import * as React from 'react';
import React__default, { createContext, useContext, useEffect, useState, Component, forwardRef, useRef, useImperativeHandle, createElement, PureComponent, useMemo } from 'react';
import 'antd/lib/progress/style';
import _Progress from 'antd/lib/progress';
import { BaseButton as BaseButton$1, Header as Header$2, Selector as Selector$1, Icons, AutoSuggest as AutoSuggest$1, MenuItem, ActionMenu as ActionMenu$1, ToolTip, Tag, RightPanel as RightPanel$1, MultiSelectInput as MultiSelectInput$1, Tabs, BUTTON_TYPE, SIZE, FilterChips as FilterChips$1, TableControls as TableControls$1, SEARCH_TAG_TYPES, ViewSwitch, Alert, TextInput as TextInput$1, Radio, StatusIcon, STATUS_ICON_COLORS, STATUS_ICON_TYPES, Checkbox, BreadCrumb, FilterSection as FilterSection$1, FILTER_TAG_TYPES } from 'prefab';
export { BreadCrumb, Collapse, CopyToClipboard, InputRadio, PopupDialog, Tabs, Tag, Wizard } from 'prefab';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'antd/lib/time-picker/style';
import _TimePicker from 'antd/lib/time-picker';
import 'antd/lib/date-picker/style';
import _DatePicker from 'antd/lib/date-picker';
import classNames$1 from 'classnames';
import { createInstance as createInstance$1 } from 'i18next';
import 'antd/lib/checkbox/style';
import _Checkbox from 'antd/lib/checkbox';
import 'antd/lib/select/style';
import _Select from 'antd/lib/select';
import 'antd/lib/input/style';
import _Input from 'antd/lib/input';
import 'antd/lib/message/style';
import _message from 'antd/lib/message';
import { TablePagination as TablePagination$1, Table } from 'workbench';
import forEach$1 from 'lodash/forEach';
import _$1, { isNumber as isNumber$1, isEmpty as isEmpty$1, sum, every, find, map as map$1, groupBy, forEach as forEach$2, keys, lowerCase, isArray as isArray$3 } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import 'antd/lib/modal/style';
import _Modal from 'antd/lib/modal';
import ReactTooltip from 'react-tooltip';
import 'antd/lib/button/style';
import _Button from 'antd/lib/button';
import 'antd/lib/table/style';
import _Table from 'antd/lib/table';
import { Trans } from 'react-i18next';
import 'antd/lib/dropdown/style';
import _Dropdown from 'antd/lib/dropdown';
import 'antd/lib/menu/style';
import _Menu from 'antd/lib/menu';
import 'antd/lib/spin/style';
import _Spin from 'antd/lib/spin';
import momentTZ from 'moment-timezone';
import 'antd/lib/row/style';
import _Row from 'antd/lib/row';
import 'antd/lib/col/style';
import _Col from 'antd/lib/col';
import 'antd/lib/popover/style';
import _Popover from 'antd/lib/popover';
import 'antd/lib/breadcrumb/style';
import _Breadcrumb from 'antd/lib/breadcrumb';
import ReactDOM, { createPortal, findDOMNode } from 'react-dom';
import { create as create$8, addDependencies, divideDependencies, bignumberDependencies, multiplyDependencies } from 'mathjs';
import Cookies from 'universal-cookie';
import { ReactSortable } from 'react-sortablejs';
import 'antd/lib/card/style';
import _Card from 'antd/lib/card';
import validator from 'validator';
import 'antd/lib/tag/style';
import _Tag from 'antd/lib/tag';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactPlaceholder from 'react-placeholder';
import uniqBy from 'lodash/uniqBy';
import concat from 'lodash/concat';
import sumBy from 'lodash/sumBy';
import cloneDeep from 'lodash/cloneDeep';
import 'lodash/isEqual';
import 'lodash/sortBy';
import isString$1 from 'lodash/isString';
import capitalize$1 from 'lodash/capitalize';
import Dropzone from 'react-dropzone';
import uniq from 'lodash/uniq';
import map$2 from 'lodash/map';
import sum$1 from 'lodash/sum';
import { useTable, useFlexLayout, useSortBy, usePagination } from 'react-table7';
export { useColumnOrder, useFilters, useFlexLayout, usePagination, useSortBy, useTable } from 'react-table7';

var PrimaryButton = function PrimaryButton(props) {
  return /*#__PURE__*/React__default.createElement("button", {
    className: props.disabled ? 'btn-default primary-btn disabled' : 'btn-default primary-btn',
    onClick: !props.disabled && props.callbackAction,
    style: props.style
  }, props.btnName);
};

PrimaryButton.defaultProps = {
  disabled: false,
  callbackAction: function callbackAction() {}
};

function SecondaryButton(props) {
  var style = props.style,
      callbackAction = props.callbackAction,
      btnName = props.btnName;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "btn-default secondary-btn",
    onClick: callbackAction,
    style: style || {}
  }, btnName);
}

SecondaryButton.defaultProps = {
  style: {}
};

var IconButton = function IconButton(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-button",
    onClick: props.callbackAction
  }, props.icon);
};

IconButton.defaultProps = {
  icon: 'close',
  callbackAction: function callbackAction() {}
};

var DeleteButton = function DeleteButton(props) {
  return /*#__PURE__*/React__default.createElement("button", {
    className: props.disabled ? 'btn-default delete-btn disabled' : 'btn-default delete-btn',
    onClick: !props.disabled && props.clickEvent
  }, props.text);
};

DeleteButton.defaultProps = {
  disabled: false,
  clickEvent: function clickEvent() {}
};

var SVG$x = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M4.5596,18.7675 C5.38847443,18.7675 6.0596,19.4390894 6.0596,20.2675 L6.0596,21.5175 C6.0596,21.7936424 5.83574237,22.0175 5.5596,22.0175 L2.5596,22.0175 C2.28345763,22.0175 2.0596,21.7936424 2.0596,21.5175 L2.0596,20.2685 C2.0596,19.4393576 2.73145763,18.7675 3.5606,18.7675 L4.5596,18.7675 Z M9.7617,18.7675 C10.5905744,18.7675 11.2617,19.4390894 11.2617,20.2675 L11.2617,21.5175 C11.2617,21.7936424 11.0378424,22.0175 10.7617,22.0175 L7.7617,22.0175 C7.48555763,22.0175 7.2617,21.7936424 7.2617,21.5175 L7.2617,20.2685 C7.2617,19.4393576 7.93355763,18.7675 8.7627,18.7675 L9.7617,18.7675 Z M15.2383,18.7675 C16.0664424,18.7675 16.7383,19.4393576 16.7383,20.2675 L16.7383,21.5175 C16.7383,21.7936424 16.5144424,22.0175 16.2383,22.0175 L13.2383,22.0175 C12.9621576,22.0175 12.7383,21.7936424 12.7383,21.5175 L12.7383,20.2685 C12.7383,19.4393576 13.4101576,18.7675 14.2393,18.7675 L15.2383,18.7675 Z M20.4404,18.7675 C21.2692744,18.7675 21.9404,19.4390894 21.9404,20.2675 L21.9404,21.5175 C21.9404,21.7936424 21.7165424,22.0175 21.4404,22.0175 L18.4404,22.0175 C18.1642576,22.0175 17.9404,21.7936424 17.9404,21.5175 L17.9404,20.2685 C17.9404,19.4393576 18.6122576,18.7675 19.4414,18.7675 L20.4404,18.7675 Z M4.5596,19.7675 L3.5606,19.7675 C3.28374237,19.7675 3.0596,19.9916424 3.0596,20.2685 L3.0596,21.0175 L5.0596,21.0175 L5.0596,20.2675 C5.0596,19.9912195 4.83603497,19.7675 4.5596,19.7675 Z M9.7617,19.7675 L8.7627,19.7675 C8.48584237,19.7675 8.2617,19.9916424 8.2617,20.2685 L8.2617,21.0175 L10.2617,21.0175 L10.2617,20.2675 C10.2617,19.9912195 10.038135,19.7675 9.7617,19.7675 Z M15.2383,19.7675 L14.2393,19.7675 C13.9624424,19.7675 13.7383,19.9916424 13.7383,20.2685 L13.7383,21.0175 L15.7383,21.0175 L15.7383,20.2675 C15.7383,19.9916424 15.5141576,19.7675 15.2383,19.7675 Z M20.4404,19.7675 L19.4414,19.7675 C19.1645424,19.7675 18.9404,19.9916424 18.9404,20.2685 L18.9404,21.0175 L20.9404,21.0175 L20.9404,20.2675 C20.9404,19.9912195 20.716835,19.7675 20.4404,19.7675 Z M7.4111,13.994 C8.23951062,13.994 8.9111,14.6651256 8.9111,15.494 L8.9111,16.744 C8.9111,17.0201424 8.68724237,17.244 8.4111,17.244 L5.4111,17.244 C5.13495763,17.244 4.9111,17.0201424 4.9111,16.744 L4.9111,15.495 C4.9111,14.665821 5.58199373,13.994 6.4111,13.994 L7.4111,13.994 Z M12.5,13.994 C13.3291424,13.994 14,14.6648576 14,15.494 L14,16.744 C14,17.0201424 13.7761424,17.244 13.5,17.244 L10.5,17.244 C10.2238576,17.244 10,17.0201424 10,16.744 L10,15.495 C10,14.6658576 10.6718576,13.994 11.501,13.994 L12.5,13.994 Z M17.5889,13.994 C18.4180424,13.994 19.0889,14.6648576 19.0889,15.494 L19.0889,16.744 C19.0889,17.0201424 18.8650424,17.244 18.5889,17.244 L15.5889,17.244 C15.3127576,17.244 15.0889,17.0201424 15.0889,16.744 L15.0889,15.495 C15.0889,14.6658576 15.7607576,13.994 16.5899,13.994 L17.5889,13.994 Z M7.4111,14.994 L6.4111,14.994 C6.13458791,14.994 5.9111,15.2177968 5.9111,15.495 L5.9111,16.244 L7.9111,16.244 L7.9111,15.494 C7.9111,15.217565 7.68738046,14.994 7.4111,14.994 Z M12.5,14.994 L11.501,14.994 C11.2241424,14.994 11,15.2181424 11,15.495 L11,16.244 L13,16.244 L13,15.494 C13,15.2171424 12.7768576,14.994 12.5,14.994 Z M17.5889,14.994 L16.5899,14.994 C16.3130424,14.994 16.0889,15.2181424 16.0889,15.495 L16.0889,16.244 L18.0889,16.244 L18.0889,15.494 C18.0889,15.2171424 17.8657576,14.994 17.5889,14.994 Z M20.5,2 C21.3291424,2 22,2.67085763 22,3.5 L22,11.452 C22,12.2811424 21.3291424,12.952 20.5,12.952 L3.5,12.952 C2.67085763,12.952 2,12.2811424 2,11.452 L2,3.5 C2,2.67085763 2.67085763,2 3.5,2 L20.5,2 Z M20.5,3 L3.5,3 C3.22314237,3 3,3.22314237 3,3.5 L3,11.452 C3,11.7288576 3.22314237,11.952 3.5,11.952 L20.5,11.952 C20.7768576,11.952 21,11.7288576 21,11.452 L21,3.5 C21,3.22314237 20.7768576,3 20.5,3 Z"
  })));
};

var SVG$w = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M19,5 C20.1045695,5 21,5.8954305 21,7 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,7 C3,5.8954305 3.8954305,5 5,5 L19,5 Z M19,6 L5,6 C4.44771525,6 4,6.44771525 4,7 L4,17 C4,17.5522847 4.44771525,18 5,18 L19,18 C19.5522847,18 20,17.5522847 20,17 L20,7 C20,6.44771525 19.5522847,6 19,6 Z M10.7649995,9.07680032 L14.7649995,11.5768003 C15.0783335,11.7726341 15.0783335,12.2289649 14.7649995,12.4247986 L10.7649995,14.9247986 C10.4319755,15.1329386 10,14.8935172 10,14.5007995 L10,9.50079947 C10,9.1080817 10.4319755,8.86866032 10.7649995,9.07680032 Z M11,10.4029233 L11,13.5986757 L13.5566019,12.0007995 L11,10.4029233 Z"
  })));
};

var SVG$v = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 18 18' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "QW-Distributor-Redesign",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Add-to-New-List",
    transform: "translate(-314.000000, -96.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "label-input-copy",
    transform: "translate(21.000000, 69.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "label-input"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "input",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "input/text-icon/large"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon",
    transform: "translate(290.000000, 4.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/gray/date-range"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4,7 C4,6.28991961 4.28991961,6 5,6 L6,6 C6.23669346,6 6.42857143,5.52240775 6.42857143,5.28571429 C6.42857143,5.04902082 6.23669346,5 6,5 L5,5 C3.81653268,5 3,5.81653268 3,7 L3,19 C3,20.1834673 3.81653268,21 5,21 L19,21 C20.1834673,21 21,20.1834673 21,19 L21,7 C21,5.81653268 20.1834673,5 19,5 L17.5714286,5 C17.3347351,5 17.1428571,5.04902082 17.1428571,5.28571429 C17.1428571,5.52240775 17.3347351,6 17.5714286,6 L19,6 C19.7100804,6 20,6.28991961 20,7 L20,9 L4,9 L4,7 Z M20,10 L20,19 C20,19.7100804 19.7100804,20 19,20 L5,20.0528571 C4.28991961,20.0528571 4,19.7100804 4,19 L4,10 L20,10 Z",
    id: "Shape",
    fill: "#8794A3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18,6 C18.2366935,6 18,5.66526489 18,5.42857143 C18,5.19187796 17.808122,5 17.5714286,5 L5.42857143,5 C5.19187796,5 5,5.19187796 5,5.42857143 C5,5.66526489 5.19187796,6 5.42857143,6 L18,6 Z",
    id: "Shape",
    fill: "#8794A3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8,6.56756757 L8,3.43243243 C8,3.19360659 7.77614237,3 7.5,3 C7.22385763,3 7,3.19360659 7,3.43243243 L7,6.56756757 C7,6.80639341 7.22385763,7 7.5,7 C7.77614237,7 8,6.80639341 8,6.56756757 Z",
    id: "Shape",
    fill: "#8794A3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17,6.56756757 L17,3.43243243 C17,3.19360659 16.7761424,3 16.5,3 C16.2238576,3 16,3.19360659 16,3.43243243 L16,6.56756757 C16,6.80639341 16.2238576,7 16.5,7 C16.7761424,7 17,6.80639341 17,6.56756757 Z",
    id: "Shape",
    fill: "#8794A3"
  }))))))))));
};

var SVG$u = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#69788C' : _ref$fill,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: fill
  }, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_15981_49497)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V10H20ZM8 16H6V18H8V16ZM13 16H11V18H13V16ZM18 16H16V18H18V16ZM8 12H6V14H8V12ZM13 12H11V14H13V12ZM18 12H16V14H18V12ZM9.5 4C9.77614 4 10 4.22386 10 4.5V6H14V4.5C14 4.22386 14.2239 4 14.5 4H16.5C16.7761 4 17 4.22386 17 4.5V6H19C19.5523 6 20 6.44772 20 7V9H4V7C4 6.44772 4.44772 6 5 6H7V4.5C7 4.22386 7.22386 4 7.5 4H9.5Z"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_15981_49497"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var SVG$t = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#69788C' : _ref$fill,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: fill
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12ZM11 13.5V8H12.5V12H16V13.5H11Z"
  }));
};

var SVG$s = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/selected-circle-copy",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/selected-circle"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("circle", {
    id: "Oval-3",
    fill: "#17304D",
    cx: "12",
    cy: "12",
    r: "6"
  }))));
};

var SVG$r = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/partial-circle-copy",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/partial-circle"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12,6 C15.3137085,6 18,8.6862915 18,12 C18,15.2383969 15.4344251,17.8775718 12.2249383,17.9958615 L12,18 L11.7750617,17.9958615 C8.56557489,17.8775718 6,15.2383969 6,12 C6,8.6862915 8.6862915,6 12,6 L12,6 Z M12,7.2 L12,16.8 L12,16.8 C14.6509668,16.8 16.8,14.6509668 16.8,12 C16.8,9.3490332 14.6509668,7.2 12,7.2 Z",
    id: "Combined-Shape",
    fill: "#17304D"
  }))));
};

var SVG$q = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/unselected-circle-copy",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/unselected-circle"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12,16.8 C14.6509668,16.8 16.8,14.6509668 16.8,12 C16.8,9.3490332 14.6509668,7.2 12,7.2 C9.3490332,7.2 7.2,9.3490332 7.2,12 C7.2,14.6509668 9.3490332,16.8 12,16.8 Z M12,18 C8.6862915,18 6,15.3137085 6,12 C6,8.6862915 8.6862915,6 12,6 C15.3137085,6 18,8.6862915 18,12 C18,15.3137085 15.3137085,18 12,18 Z",
    id: "Oval-3",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$p = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/error",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.9820144,13.971223 L13.3705036,6 L10.6079137,6 L11.0179856,13.971223 L12.9820144,13.971223 Z M12.0107914,18.611223 C12.8309353,18.611223 13.5,17.9205755 13.5,17.1004317 C13.5,16.3018705 12.8309353,15.611223 12.0107914,15.611223 C11.1906475,15.611223 10.5,16.3018705 10.5,17.1004317 C10.5,17.9205755 11.1906475,18.611223 12.0107914,18.611223 Z",
    id: "!",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$o = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/primary/edit",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-53",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.0519038,4.15 C15.6794629,4.15 15.3302168,4.29486575 15.0657511,4.55868669 L5.05197798,14.5727364 C4.98324829,14.6414632 4.93769074,14.7294185 4.9215385,14.824474 L4.15664822,19.3030058 C4.13116097,19.4527371 4.17985388,19.6056523 4.2875827,19.713112 C4.37507815,19.8008665 4.49433719,19.85 4.61824813,19.85 C4.6448076,19.85 4.6712854,19.8477992 4.69699264,19.8433851 L9.17551637,19.0793221 C9.27177766,19.062477 9.36016341,19.0168405 9.42822572,18.9487811 L19.442376,8.93505434 C19.9858849,8.39188437 19.9858849,7.50635631 19.4423297,6.96250806 L17.0388879,4.55846759 C16.7747968,4.29502103 16.4245629,4.15 16.0519038,4.15 Z M9.27908803,17.5615114 L6.43896529,14.7211587 L13.8674633,7.29332487 L16.7079361,10.1333275 L9.27908803,17.5615114 Z M5.84419535,15.8742425 L8.12665563,18.1566062 L5.37440061,18.6267311 L5.84419535,15.8742425 Z M18.6742827,8.16741418 L17.5820624,9.25958825 L14.7415896,6.41923557 L15.8338098,5.32671144 C15.9125757,5.24794889 16.0046443,5.23639705 16.0519038,5.23639705 C16.1002136,5.23639705 16.1922821,5.24829895 16.270698,5.32671144 L18.6742827,7.72984444 C18.7947069,7.85026364 18.7947069,8.04664493 18.6742827,8.16741418 Z",
    id: "Shape",
    fill: "#084782"
  }))));
};

var SVG$n = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    d: "M16.0519038,4.15 C15.6794629,4.15 15.3302168,4.29486575 15.0657511,4.55868669 L5.05197798,14.5727364 C4.98324829,14.6414632 4.93769074,14.7294185 4.9215385,14.824474 L4.15664822,19.3030058 C4.13116097,19.4527371 4.17985388,19.6056523 4.2875827,19.713112 C4.37507815,19.8008665 4.49433719,19.85 4.61824813,19.85 C4.6448076,19.85 4.6712854,19.8477992 4.69699264,19.8433851 L9.17551637,19.0793221 C9.27177766,19.062477 9.36016341,19.0168405 9.42822572,18.9487811 L19.442376,8.93505434 C19.9858849,8.39188437 19.9858849,7.50635631 19.4423297,6.96250806 L17.0388879,4.55846759 C16.7747968,4.29502103 16.4245629,4.15 16.0519038,4.15 Z M9.27908803,17.5615114 L6.43896529,14.7211587 L13.8674633,7.29332487 L16.7079361,10.1333275 L9.27908803,17.5615114 Z M5.84419535,15.8742425 L8.12665563,18.1566062 L5.37440061,18.6267311 L5.84419535,15.8742425 Z M18.6742827,8.16741418 L17.5820624,9.25958825 L14.7415896,6.41923557 L15.8338098,5.32671144 C15.9125757,5.24794889 16.0046443,5.23639705 16.0519038,5.23639705 C16.1002136,5.23639705 16.1922821,5.24829895 16.270698,5.32671144 L18.6742827,7.72984444 C18.7947069,7.85026364 18.7947069,8.04664493 18.6742827,8.16741418 Z"
  })));
};

var SVG$m = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '', " ").concat(className || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "#084782"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M4.79289322 10.5L2 10.5C1.72385763 10.5 1.5 10.2761424 1.5 10L1.5 6C1.5 5.72385763 1.72385763 5.5 2 5.5L4.79289322 5.5 7.64644661 2.64644661C7.96142904 2.33146418 8.5 2.55454757 8.5 3L8.5 13C8.5 13.4454524 7.96142904 13.6685358 7.64644661 13.3535534L4.79289322 10.5zM2.5 9.5L5 9.5C5.13260824 9.5 5.2597852 9.55267842 5.35355339 9.64644661L7.5 11.7928932 7.5 4.20710678 5.35355339 6.35355339C5.2597852 6.44732158 5.13260824 6.5 5 6.5L2.5 6.5 2.5 9.5zM11.6464466 4.35355339C14.1178511 6.82495791 14.1178511 9.17504209 11.6464466 11.6464466 11.4511845 11.8417088 11.4511845 12.1582912 11.6464466 12.3535534 11.8417088 12.5488155 12.1582912 12.5488155 12.3535534 12.3535534 15.2154822 9.49162458 15.2154822 6.50837542 12.3535534 3.64644661 12.1582912 3.45118446 11.8417088 3.45118446 11.6464466 3.64644661 11.4511845 3.84170876 11.4511845 4.15829124 11.6464466 4.35355339z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.64644661,6.35355339 C10.7845178,7.49162458 10.7845178,8.50837542 9.64644661,9.64644661 C9.45118446,9.84170876 9.45118446,10.1582912 9.64644661,10.3535534 C9.84170876,10.5488155 10.1582912,10.5488155 10.3535534,10.3535534 C11.8821489,8.82495791 11.8821489,7.17504209 10.3535534,5.64644661 C10.1582912,5.45118446 9.84170876,5.45118446 9.64644661,5.64644661 C9.45118446,5.84170876 9.45118446,6.15829124 9.64644661,6.35355339 Z"
  })));
};

var SVG$l = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '', " ").concat(className || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "evenodd",
    d: "M1.3298479,10.2257209 C1.7553261,10.5502381 2.3106112,10.75216 3.0245492,10.75216 C4.32261829,10.75216 4.88511489,10.067068 4.88511489,9.26659205 C4.88511489,8.22092528 3.94040906,7.97573446 3.14714462,7.7738126 C2.57743652,7.6295827 2.08705486,7.50698729 2.08705486,7.13198955 C2.08705486,6.7714148 2.40436064,6.53343547 2.97406874,6.53343547 C3.34185498,6.53343547 3.74569869,6.6416079 4.09185045,6.87237573 C4.14954241,6.9156447 4.22886885,6.94449068 4.31540679,6.94449068 C4.53175164,6.94449068 4.71203901,6.76420331 4.71203901,6.54785846 C4.71203901,6.41084006 4.63992406,6.28824464 4.53175164,6.22334119 C4.06300447,5.9276699 3.60868029,5.78344 3.04618369,5.78344 C1.92119048,5.78344 1.22167547,6.39641707 1.22167547,7.18968151 C1.22167547,8.20650229 2.14474682,8.43727013 2.93079977,8.63198049 C3.51493086,8.78342189 4.026947,8.9132288 4.026947,9.34591849 C4.026947,9.66322427 3.75291019,10.0021645 3.06060668,10.0021645 C2.55580203,10.0021645 2.14474682,9.82908865 1.81301806,9.58389782 C1.7481146,9.53341736 1.66157666,9.50457138 1.56782723,9.50457138 C1.35148238,9.50457138 1.17119501,9.68485875 1.17119501,9.90841509 C1.17119501,10.038222 1.23609846,10.1536059 1.3298479,10.2257209 Z M5.66395634,8.7689989 C5.66395634,9.95168406 6.34904836,10.75216 7.74807837,10.75216 C9.13989689,10.75216 9.82498891,9.95889556 9.82498891,8.7617874 L9.82498891,6.23776418 C9.82498891,6.00699634 9.63749004,5.81228598 9.39951071,5.81228598 C9.16153138,5.81228598 8.97403251,6.00699634 8.97403251,6.23776418 L8.97403251,8.74015292 C8.97403251,9.50457138 8.54855431,10.0021645 7.74807837,10.0021645 C6.94039094,10.0021645 6.51491274,9.50457138 6.51491274,8.74015292 L6.51491274,6.23776418 C6.51491274,6.00699634 6.32741388,5.81228598 6.08943454,5.81228598 C5.85145521,5.81228598 5.66395634,6.00699634 5.66395634,6.23776418 L5.66395634,8.7689989 Z M11.2961339,10.6656221 C11.0076741,10.6656221 10.8490212,10.5069692 10.8490212,10.2185094 L10.8490212,6.30266763 C10.8490212,6.01420784 11.0076741,5.85555495 11.2961339,5.85555495 L13.2143915,5.85555495 C14.0941939,5.85555495 14.5845756,6.40362856 14.5845756,7.08150909 C14.5845756,7.68727466 14.1951548,8.09111837 13.7480421,8.18486781 C14.2600583,8.26419425 14.678325,8.77621039 14.678325,9.36755298 C14.678325,10.110337 14.1807318,10.6656221 13.279295,10.6656221 L11.2961339,10.6656221 Z M11.6927661,7.84592755 L13.0413156,7.84592755 C13.4740053,7.84592755 13.7191962,7.58631373 13.7191962,7.22573898 C13.7191962,6.86516424 13.4740053,6.59833893 13.0413156,6.59833893 L11.6927661,6.59833893 L11.6927661,7.84592755 Z M11.6927661,9.92283808 L13.0773731,9.92283808 C13.5389088,9.92283808 13.8129456,9.67043576 13.8129456,9.25216906 C13.8129456,8.89159431 13.5605433,8.58871152 13.0773731,8.58871152 L11.6927661,8.58871152 L11.6927661,9.92283808 Z"
  }));
};

var SVG$k = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '', " ").concat(className || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "evenodd",
    d: "M5.58132927,10.79035 C6.42028579,10.79035 6.98735825,10.4718572 7.3990684,10.0213065 C7.46898144,9.95139348 7.50782202,9.84263986 7.50782202,9.73388623 C7.50782202,9.50084275 7.31361912,9.30663986 7.08057564,9.30663986 C6.94851767,9.30663986 6.83976405,9.36878478 6.76208289,9.45423406 C6.4746626,9.78049493 6.06295246,9.98246594 5.58132927,9.98246594 C4.59477854,9.98246594 3.83350318,9.19788623 3.83350318,8.11035 C3.83350318,7.02281377 4.59477854,6.23823406 5.58132927,6.23823406 C6.06295246,6.23823406 6.4746626,6.44797319 6.75431477,6.76646594 C6.83199593,6.85968333 6.94851767,6.91406014 7.08057564,6.91406014 C7.31361912,6.91406014 7.50782202,6.71985725 7.50782202,6.48681377 C7.50782202,6.37806014 7.46898144,6.26930652 7.3990684,6.19939348 C6.98735825,5.74884275 6.41251767,5.43035 5.58132927,5.43035 C4.08985101,5.43035 2.90132927,6.51788623 2.90132927,8.11035 C2.90132927,9.70281377 4.08985101,10.79035 5.58132927,10.79035 Z M10.974128,10.79035 C11.8130845,10.79035 12.380157,10.4718572 12.7918671,10.0213065 C12.8617802,9.95139348 12.9006207,9.84263986 12.9006207,9.73388623 C12.9006207,9.50084275 12.7064178,9.30663986 12.4733744,9.30663986 C12.3413164,9.30663986 12.2325628,9.36878478 12.1548816,9.45423406 C11.8674613,9.78049493 11.4557512,9.98246594 10.974128,9.98246594 C9.98757726,9.98246594 9.22630189,9.19788623 9.22630189,8.11035 C9.22630189,7.02281377 9.98757726,6.23823406 10.974128,6.23823406 C11.4557512,6.23823406 11.8674613,6.44797319 12.1471135,6.76646594 C12.2247946,6.85968333 12.3413164,6.91406014 12.4733744,6.91406014 C12.7064178,6.91406014 12.9006207,6.71985725 12.9006207,6.48681377 C12.9006207,6.37806014 12.8617802,6.26930652 12.7918671,6.19939348 C12.380157,5.74884275 11.8053164,5.43035 10.974128,5.43035 C9.48264972,5.43035 8.29412798,6.51788623 8.29412798,8.11035 C8.29412798,9.70281377 9.48264972,10.79035 10.974128,10.79035 Z"
  }));
};

var SVG$j = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '', " ").concat(className || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "8.04",
    cy: "5.695",
    r: "4.02",
    stroke: "#084782",
    strokeLinecap: "square"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M3.18966074,11.2701443 L4.67152697,11.0088513 C4.94347413,10.9608997 5.20280332,11.1424839 5.25075494,11.4144311 L5.50415279,12.8515217 L7.32906953,10.2008919 L4.9059371,8.71673068 L3.18966074,11.2701443 Z M2.20589031,12.4590362 C1.77171993,12.5355921 1.45815737,12.0536048 1.70409421,11.6877089 L4.34337905,7.76107686 C4.67152697,7.76107686 8.61437233,10.0974553 8.45183185,10.3335398 L5.63555984,14.4240796 C5.38187026,14.7925551 4.80900788,14.6679295 4.73132431,14.2273641 L4.35277128,12.0804831 L2.20589031,12.4590362 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M8.71643142,10.0040524 L10.5204501,12.6243285 L10.7738479,11.1872379 C10.8217996,10.9152907 11.0811288,10.7337065 11.3530759,10.7816581 L12.8262565,11.0414196 L11.2271077,8.6896535 L8.71643142,10.0040524 Z M11.2932786,14.0001709 C11.215595,14.4407363 10.6427326,14.5653619 10.3890431,14.1968864 L7.57277104,10.1063467 C7.40264196,9.85923993 11.2932786,8 11.8034678,7.75885146 L14.3190042,11.4582904 C14.5676276,11.8239249 14.2541515,12.3086226 13.8187126,12.231843 L11.6718316,11.8532899 L11.2932786,14.0001709 Z"
  })));
};

var SVG$i = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Booking-History---Internal",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1138.000000, -81.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "page-header/booking-history",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/primary/search",
    transform: "translate(1135.000000, 18.000000)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.5839466,14.2910534 L19.5839466,20.2910534 C19.7792088,20.4863155 20.0957912,20.4863155 20.2910534,20.2910534 C20.4863155,20.0957912 20.4863155,19.7792088 20.2910534,19.5839466 L14.2910534,13.5839466 C14.0957912,13.3886845 13.7792088,13.3886845 13.5839466,13.5839466 C13.3886845,13.7792088 13.3886845,14.0957912 13.5839466,14.2910534 Z",
    id: "Stroke-55",
    fill: "#084782",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16,9.5 C16,13.0891424 13.0891424,16 9.5,16 C5.91085763,16 3,13.0891424 3,9.5 C3,5.91085763 5.91085763,3 9.5,3 C13.0891424,3 16,5.91085763 16,9.5 Z M15,9.5 C15,6.46314237 12.5368576,4 9.5,4 C6.46314237,4 4,6.46314237 4,9.5 C4,12.5368576 6.46314237,15 9.5,15 C12.5368576,15 15,12.5368576 15,9.5 Z",
    id: "Stroke-56",
    fill: "#084782",
    fillRule: "nonzero"
  }))))));
};

var SVG$h = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("g", {
    fill: "#084782",
    fillRule: "nonzero",
    transform: "translate(8 4)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M3.64644661,9.14644661 L6.64644661,6.14644661 C6.84170876,5.95118446 7.15829124,5.95118446 7.35355339,6.14644661 C7.54881554,6.34170876 7.54881554,6.65829124 7.35355339,6.85355339 L4.35355339,9.85355339 C4.15829124,10.0488155 3.84170876,10.0488155 3.64644661,9.85355339 C3.45118446,9.65829124 3.45118446,9.34170876 3.64644661,9.14644661 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.64644661,9.85355339 L0.646446609,6.85355339 C0.451184464,6.65829124 0.451184464,6.34170876 0.646446609,6.14644661 C0.841708755,5.95118446 1.15829124,5.95118446 1.35355339,6.14644661 L4.35355339,9.14644661 C4.54881554,9.34170876 4.54881554,9.65829124 4.35355339,9.85355339 C4.15829124,10.0488155 3.84170876,10.0488155 3.64644661,9.85355339 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.5,8.41666667 L3.5,0.583333333 C3.5,0.261167229 3.72385763,0 4,0 C4.27614237,0 4.5,0.261167229 4.5,0.583333333 L4.5,8.41666667 C4.5,8.73883277 4.27614237,9 4,9 C3.72385763,9 3.5,8.73883277 3.5,8.41666667 Z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M21,12.5 C21,17.7352012 21.1953793,17.4942922 17.0338715,17.4999598 L12.4953045,17.5 C12.4249533,17.5 12.3548402,17.4981793 12.2850072,17.4945512 C12.1598862,17.4981569 12.0850248,17.5 12.0099226,17.5 L7.49007744,17.5 C2.27658101,17.5 2.50417517,17.7199366 2.5041397,12.6986005 C2.50346009,12.625917 2.50346009,12.625917 2.50179258,12.57656 C2.50035572,12.5327327 2.50035572,12.5327327 2.5,12.5 C2.5,12.2238576 2.27614237,12 2,12 C1.72385763,12 1.5,12.2238576 1.5,12.5 C1.50067918,12.5604825 1.50067918,12.5604825 1.50234703,12.6098554 C1.50378387,12.6536783 1.50378387,12.6536783 1.50413961,12.6863798 C1.50417913,18.2800272 1.73181074,18.5 7.49007744,18.5 L12.0099226,18.5 C12.1014337,18.5 12.1926995,18.497753 12.2836644,18.4932723 C12.3202335,18.4977301 12.4076472,18.5 12.4953045,18.5 L17.0046955,18.5 C21.7996831,18.4934702 22,18.246473 22,12.5 C22,12.2238576 21.7761424,12 21.5,12 C21.2238576,12 21,12.2238576 21,12.5 Z"
  })));
};

var SVG$g = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 16' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M11.6464466,15.1464466 L13.6464466,13.1464466 C13.8417088,12.9511845 14.1582912,12.9511845 14.3535534,13.1464466 C14.5488155,13.3417088 14.5488155,13.6582912 14.3535534,13.8535534 L12.3535534,15.8535534 C12.1582912,16.0488155 11.8417088,16.0488155 11.6464466,15.8535534 C11.4511845,15.6582912 11.4511845,15.3417088 11.6464466,15.1464466 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M11.6464466,15.8535534 L9.64644661,13.8535534 C9.45118446,13.6582912 9.45118446,13.3417088 9.64644661,13.1464466 C9.84170876,12.9511845 10.1582912,12.9511845 10.3535534,13.1464466 L12.3535534,15.1464466 C12.5488155,15.3417088 12.5488155,15.6582912 12.3535534,15.8535534 C12.1582912,16.0488155 11.8417088,16.0488155 11.6464466,15.8535534 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M11.5,14.4166667 L11.5,8.58333333 C11.5,8.26116723 11.7238576,8 12,8 C12.2761424,8 12.5,8.26116723 12.5,8.58333333 L12.5,14.4166667 C12.5,14.7388328 12.2761424,15 12,15 C11.7238576,15 11.5,14.7388328 11.5,14.4166667 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M16.5,10.5 L16.5,10 C16.5,7.51471863 14.4852814,5.5 12,5.5 C9.84509136,5.5 8.0040679,7.02630885 7.58725613,9.11321582 L7.51313799,9.48431301 L7.13585964,9.5137694 C4.80942974,9.6954078 3,11.6464603 3,14 C3,16.4819118 5.01252108,18.5 7.49007744,18.5 L12.0099226,18.5 C12.0850248,18.5 12.1598862,18.4981569 12.2850072,18.4945512 C12.3548402,18.4981793 12.4249533,18.5 12.4953045,18.5 L17.0046955,18.5 C19.2057252,18.5 21,16.7061857 21,14.5 C21,12.293968 19.2092939,10.5 17.0046955,10.5 L16.5,10.5 Z M22,14.5 C22,17.2585279 19.7579526,19.5 17.0046955,19.5 L12.4953045,19.5 C12.4076472,19.5 12.3202335,19.4977301 12.2836644,19.4932723 C12.1926995,19.497753 12.1014337,19.5 12.0099226,19.5 L7.49007744,19.5 C4.459617,19.5 2,17.0335791 2,14 C2,11.2486453 4.02380416,8.9470046 6.69105946,8.55783289 C7.33133281,6.19183181 9.49137222,4.5 12,4.5 C14.8766426,4.5 17.2374772,6.70843649 17.4795471,9.52235265 C20.0144115,9.76218851 22,11.9022741 22,14.5 Z"
  })));
};

var SVG$f = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M18.8915881,16.3479549 L18.8506309,16.1865482 L17.2921397,6.83560101 C17.2117751,6.35341304 16.794585,6 16.3057458,6 L7.69425418,6 C7.20541502,6 6.78822491,6.35341304 6.70786025,6.83560101 L5.14936906,16.1865482 L5.10841188,16.3479549 C5.03694558,16.5553388 5,16.7744737 5,17 C5,18.1045695 5.8954305,19 7,19 L17,19 C18.1045695,19 19,18.1045695 19,17 C19,16.7744737 18.9630544,16.5553388 18.8915881,16.3479549 Z M20,17 C20,18.6568542 18.6568542,20 17,20 L7,20 C5.34314575,20 4,18.6568542 4,17 C4,16.6576265 4.05735284,16.3286484 4.16297514,16.0221492 L5.72146633,6.67120203 C5.88219565,5.70682609 6.71657587,5 7.69425418,5 L16.3057458,5 C17.2834241,5 18.1178043,5.70682609 18.2785337,6.67120203 L19.8370249,16.0221492 C19.9426472,16.3286484 20,16.6576265 20,17 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M7,15 C5.8954305,15 5,15.8954305 5,17 C5,18.1045695 5.8954305,19 7,19 L17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 L7,15 Z M7,14 L17,14 C18.6568542,14 20,15.3431458 20,17 C20,18.6568542 18.6568542,20 17,20 L7,20 C5.34314575,20 4,18.6568542 4,17 C4,15.3431458 5.34314575,14 7,14 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M17,16 C17.5522847,16 18,16.4477153 18,17 C18,17.5522847 17.5522847,18 17,18 C16.4477153,18 16,17.5522847 16,17 C16,16.4477153 16.4477153,16 17,16 Z"
  })));
};

var SVG$e = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("polyline", {
    stroke: "#084782",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3 7 12 13 21 7"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "19",
    height: "12",
    x: "2.5",
    y: "6",
    stroke: "#084782",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    rx: "1"
  })));
};

var SVG$d = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 100 100' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    ngattrstroke: "{{config.color}}",
    ngattrstrokewidth: "{{config.width}}",
    ngattrr: "{{config.radius}}",
    ngattrstrokedasharray: "{{config.dasharray}}",
    stroke: "#084782",
    strokeWidth: "2",
    r: "24",
    strokeDasharray: "70.68583470577033 25.561944901923447",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React__default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite"
  })));
};

var SVG$c = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/square-empty",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.2857143,6 C17.2324881,6 18,6.76751186 18,7.71428571 L18,16.2857143 C18,17.2324881 17.2324881,18 16.2857143,18 L7.71428571,18 C6.76751186,18 6,17.2324881 6,16.2857143 L6,7.71428571 C6,6.76751186 6.76751186,6 7.71428571,6 L16.2857143,6 Z M16.2857143,7.28571429 L7.71428571,7.28571429 C7.50389152,7.28571429 7.32890711,7.43732157 7.29261915,7.63724946 L7.28571429,7.71428571 L7.28571429,16.2857143 C7.28571429,16.4961085 7.43732157,16.6710929 7.63724946,16.7073809 L7.71428571,16.7142857 L16.2857143,16.7142857 C16.4961085,16.7142857 16.6710929,16.5626784 16.7073809,16.3627505 L16.7142857,16.2857143 L16.7142857,7.71428571 C16.7142857,7.50389152 16.5626784,7.32890711 16.3627505,7.29261915 L16.2857143,7.28571429 Z",
    id: "Combined-Shape",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$b = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/square-half-filled",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.71428571,18 C6.76751186,18 6,17.2324881 6,16.2857143 L6,7.71428571 C6,6.76751186 6.76751186,6 7.71428571,6 L16.2857143,6 C17.2324881,6 18,6.76751186 18,7.71428571 L18,16.2857143 C18,17.2324881 17.2324881,18 16.2857143,18 L7.71428571,18 Z M16.2857143,7.28571429 L12,7.285 L12,16.714 L16.2857143,16.7142857 C16.4961085,16.7142857 16.6710929,16.5626784 16.7073809,16.3627505 L16.7142857,16.2857143 L16.7142857,7.71428571 C16.7142857,7.50389152 16.5626784,7.32890711 16.3627505,7.29261915 L16.2857143,7.28571429 Z",
    id: "Combined-Shape",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$a = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/square-filled",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle",
    fill: "#17304D",
    fillRule: "nonzero",
    x: "6",
    y: "6",
    width: "12",
    height: "12",
    rx: "1.71428571"
  }))));
};

var SVG$9 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("title", null, "satellite"), /*#__PURE__*/React__default.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React__default.createElement("g", {
    id: "satellite",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 3.000000)",
    fill: "#084782",
    fillRule: "nonzero"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M9.06850973,9.05275233 L8.7175976,9.40889479 L8.36143884,9.0579992 C7.91726827,8.62039241 7.80587991,8.51044591 7.65077539,8.35620393 L7.6457454,8.35120147 C7.49064597,8.19693729 7.38008922,8.08615333 6.94003339,7.64437264 L6.58717653,7.29013271 L6.94141216,6.93727152 C7.22040691,6.65935928 7.59822617,6.5 8,6.5 C8.82842712,6.5 9.5,7.17157288 9.5,8 C9.5,8.39889853 9.34291794,8.77425408 9.06850973,9.05275233 Z",
    id: "Oval"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.39029249,3.41735897 C3.58498217,3.22152604 3.90156331,3.22059925 4.09739624,3.41528894 C4.29322917,3.60997862 4.29415596,3.92655976 4.09946628,4.12239269 C3.0812931,5.14654474 2.5,6.52666032 2.5,8 C2.5,11.0375661 4.96243388,13.5 8,13.5 C9.46545594,13.5 10.8387899,12.9249536 11.8615435,11.9164387 C12.0581696,11.72255 12.3747443,11.7247691 12.5686329,11.9213952 C12.7625216,12.1180212 12.7603025,12.4345959 12.5636764,12.6284846 C11.3556504,13.8196926 9.73093055,14.5 8,14.5 C4.41014913,14.5 1.5,11.5898509 1.5,8 C1.5,6.25974862 2.18769032,4.62702301 3.39029249,3.41735897 Z M16.0003833,6.5 C16.0003833,6.77614237 15.7765257,7 15.5003833,7 C15.2242409,7 15.0003833,6.77614237 15.0003833,6.5 C15.0003833,3.46243388 12.5379494,1 9.50038332,1 C9.22424094,1 9.00038332,0.776142375 9.00038332,0.5 C9.00038332,0.223857625 9.22424094,-1.13686838e-13 9.50038332,-1.13686838e-13 C13.0902342,-1.13686838e-13 16.0003833,2.91014913 16.0003833,6.5 Z M13,6.5 C13,6.77614237 12.7761424,7 12.5,7 C12.2238576,7 12,6.77614237 12,6.5 C12,5.17549951 10.7819941,3.99999999 9.49999998,3.99999995 C9.22385761,3.99999994 8.99999999,3.77614231 9,3.49999994 C9.00000001,3.22385756 9.22385764,2.99999994 9.50000002,2.99999995 C11.3264868,3.00000001 13,4.61511037 13,6.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.52565835,14.4876454 C7.43833446,14.2256738 7.57991446,13.9425138 7.84188612,13.8551899 C8.10385778,13.767866 8.38701776,13.909446 8.47434165,14.1714177 L9.47434165,17.3318141 C9.5822635,17.6555797 9.34127886,17.989928 9,17.989928 L3,17.989928 C2.62830899,17.989928 2.38656113,17.5987717 2.5527864,17.2663212 L4.46749742,13.2765027 C4.59099204,13.0295135 4.89132856,12.9294013 5.13831781,13.0528959 C5.38530706,13.1763906 5.48541923,13.4767271 5.36192461,13.7237163 L3.80901699,16.989928 L8.30628705,16.989928 L7.52565835,14.4876454 Z",
    id: "Path"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0.545454545,18 C0.244208318,18 0,17.7761424 0,17.5 C0,17.2238576 0.244208318,17 0.545454545,17 L11.4545455,17 C11.7557917,17 12,17.2238576 12,17.5 C12,17.7761424 11.7557917,18 11.4545455,18 L0.545454545,18 Z",
    id: "Line-6"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.01686348,8.49547958 C1.74072111,8.49547958 1.51686348,8.27162196 1.51686348,7.99547958 C1.51686348,7.71933721 1.74072111,7.49547958 2.01686348,7.49547958 L13.9740957,7.49547958 C14.2502381,7.49547958 14.4740957,7.71933721 14.4740957,7.99547958 C14.4740957,8.27162196 14.2502381,8.49547958 13.9740957,8.49547958 L2.01686348,8.49547958 Z",
    id: "Line-6-Copy",
    transform: "translate(7.995480, 7.995480) rotate(45.000000) translate(-7.995480, -7.995480) "
  })))));
};

var SVG$8 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/chevron-down",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.56568542,9.43431458 L12.5656854,14.4343146 C13.3199327,15.1885618 12.1885618,16.3199327 11.4343146,15.5656854 L6.43431458,10.5656854 C5.68006734,9.81143819 6.81143819,8.68006734 7.56568542,9.43431458 Z",
    id: "Line-2-Copy",
    fill: "#17304D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.4343146,9.43431458 L11.4343146,14.4343146 C10.6800673,15.1885618 11.8114382,16.3199327 12.5656854,15.5656854 L17.5656854,10.5656854 C18.3199327,9.81143819 17.1885618,8.68006734 16.4343146,9.43431458 Z",
    id: "Line-2-Copy-2",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$7 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/chevron-right",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.56568542,9.43431458 L12.5656854,14.4343146 C13.3199327,15.1885618 12.1885618,16.3199327 11.4343146,15.5656854 L6.43431458,10.5656854 C5.68006734,9.81143819 6.81143819,8.68006734 7.56568542,9.43431458 Z",
    id: "Line-2-Copy",
    fill: "#17304D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.4343146,9.43431458 L11.4343146,14.4343146 C10.6800673,15.1885618 11.8114382,16.3199327 12.5656854,15.5656854 L17.5656854,10.5656854 C18.3199327,9.81143819 17.1885618,8.68006734 16.4343146,9.43431458 Z",
    id: "Line-2-Copy-2",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$6 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.3801 7.5637L10.3801 12.5637C9.62586 13.3179 8.49449 12.1866 9.24874 11.4323L14.2487 6.43233C15.003 5.67808 16.1344 6.80945 15.3801 7.5637Z",
    fill: "#17304D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.3801 16.4323L10.3801 11.4323C9.62586 10.6781 8.49449 11.8095 9.24874 12.5637L14.2487 17.5637C15.003 18.3179 16.1344 17.1866 15.3801 16.4323Z",
    fill: "#17304D"
  }));
};

var SVG$5 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM12.6359 10.5018H11.3V15.562H12.6359V10.5018ZM11.9753 7.8C11.7598 7.8 11.5939 7.85725 11.4777 7.97176C11.3615 8.08627 11.3034 8.2496 11.3034 8.46178C11.3034 8.66385 11.3615 8.82298 11.4777 8.93917C11.5939 9.05536 11.7598 9.11345 11.9753 9.11345C12.1841 9.11345 12.3466 9.05536 12.4628 8.93917C12.579 8.82298 12.6371 8.66385 12.6371 8.46178C12.6371 8.2496 12.579 8.08627 12.4628 7.97176C12.3466 7.85725 12.1841 7.8 11.9753 7.8Z",
    className: "fill-color"
  }));
};

var SVG$4 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M9.94899505,11.8610422 L9.94899505,17.3002481 C9.94899505,17.4193548 10.0289088,17.5781638 10.1487794,17.617866 L13.465199,19.9205955 C13.5451127,19.9602978 13.5850696,20 13.6649833,20 C13.744897,20 13.7848539,20 13.8647676,19.9602978 C13.9846382,19.8808933 14.0645519,19.7617866 14.0645519,19.6029777 L14.0645519,11.8610422 L19.8582971,5.34987593 C20.0181245,5.0719603 20.0580814,4.7146402 19.8982539,4.43672457 C19.7384265,4.15880893 19.4587284,4 19.0991167,4 L4.91443032,4 C4.59477541,4 4.27512051,4.15880893 4.11529306,4.43672457 C3.95546561,4.7146402 3.95546561,5.0719603 4.15524992,5.34987593 L9.94899505,11.8610422 Z M4.83451659,4.8337469 C4.83451659,4.79404467 4.87447346,4.79404467 4.91443032,4.79404467 L19.1390735,4.79404467 C19.1790304,4.79404467 19.2189873,4.8337469 19.2189873,4.8337469 C19.2189873,4.87344913 19.2589441,4.87344913 19.2189873,4.91315136 L13.3852853,11.5037221 C13.3453284,11.5831266 13.3053715,11.662531 13.3053715,11.7419355 L13.3053715,18.8486352 L10.7880892,17.101737 L10.7880892,11.7419355 C10.7880892,11.662531 10.7481323,11.5831266 10.7081754,11.5037221 L4.83451659,4.9528536 C4.83451659,4.91315136 4.83451659,4.87344913 4.83451659,4.8337469 Z"
  })));
};

var SVG$3 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color;
      _ref.viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M129.325047,200.918899 L168.394797,363.987712 L168.77614,365.431247 C173.311105,381.115626 189.078389,390.799754 205.114474,387.758172 L206.618309,387.435536 L208.287851,386.987166 C216.547663,384.525928 223.453543,378.803306 227.406318,371.14447 L228.157024,369.587279 L251.352823,317.922665 L277.174715,372.579552 L277.863996,373.953029 C285.524579,388.349786 302.923557,394.584178 317.984177,388.32887 L319.388891,387.705712 L320.948141,386.915891 C327.591249,383.317617 332.733164,377.46226 335.442953,370.409919 L336.024691,368.76169 L372.513904,255.51361 L459.724336,255.51361 L435.822495,395.953598 C430.057929,429.81959 400.711755,454.592647 366.358653,454.592647 L102.462973,454.592647 C63.5473474,454.592647 32,423.045299 32,384.129674 C32,380.167284 32.3342284,376.211955 32.9991307,372.30575 L62.1651986,200.925945 L129.325047,200.918899 Z M409.537027,60 C448.452653,60 480,91.5473474 480,130.462973 C480,134.425362 479.665772,138.380692 479.000869,142.286897 L468.116477,206.189529 L369.954758,206.191366 L368.153761,206.226517 C349.613421,206.951041 333.324214,218.815679 326.947593,236.240026 L326.361703,237.943421 L302.741469,311.221636 L279.617157,262.275462 L278.831334,260.72365 C275.801417,255.126602 271.155666,250.569781 265.501108,247.648597 L263.9344,246.89291 L262.517906,246.297015 C247.339211,240.33393 230.063966,246.903402 222.683038,261.445516 L222.02043,262.832057 L204.318789,302.244654 L176.646381,186.731466 L176.204077,185.028921 C170.847388,165.913398 153.74901,152.414803 133.916233,151.637304 L132.105971,151.601864 L70.5643849,151.601864 L76.1775053,118.639049 C81.9420715,84.7730569 111.288245,60 145.641347,60 L409.537027,60 Z",
    id: "Combined-Shape",
    fill: "#084782",
    fillRule: "nonzero"
  })));
};

var SVG$2 = function SVG(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    height: size,
    style: style,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.9968 2.96136C11.5155 2.96136 11.1862 3.29702 11.1862 3.79734V10.2134L11.2432 11.5877L9.79291 9.94743L9.35529 9.51615C9.20329 9.36415 9.0133 9.26282 8.77264 9.26282C8.32933 9.26282 8 9.59214 8 10.0545C8 10.2635 8.0823 10.4661 8.2533 10.6371L11.3951 13.7853C11.5535 13.95 11.7752 14.0386 11.9968 14.0386C12.2185 14.0386 12.4465 13.95 12.5984 13.7853L15.7466 10.6371C15.9176 10.4661 16 10.2635 16 10.0545C16 9.59214 15.6707 9.26282 15.2274 9.26282C14.9867 9.26282 14.7904 9.36415 14.6447 9.51615L14.2007 9.94743L12.7568 11.5877L12.8074 10.2134V3.79734C12.8074 3.29702 12.4781 2.96136 11.9968 2.96136Z",
    fill: "black"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4185 20.2101H6.58149C5.05606 20.2101 4 19.1521 4 17.6276C4 16.1032 5.05606 15.0386 6.58149 15.0386H17.4185C18.9439 15.0386 20 16.1032 20 17.6276C20 19.1521 18.9439 20.2101 17.4185 20.2101ZM17.3272 16.7865C16.8644 16.7865 16.4798 17.1742 16.4798 17.6276C16.4798 18.1008 16.8644 18.4753 17.3272 18.4687C17.7705 18.4687 18.1617 18.0942 18.1617 17.6276C18.1617 17.1742 17.7705 16.7865 17.3272 16.7865ZM13.6525 17.6276C13.6525 17.1742 14.0372 16.7865 14.5 16.7865C14.9433 16.7865 15.3344 17.1742 15.3344 17.6276C15.3344 18.0942 14.9433 18.4687 14.5 18.4687C14.0372 18.4753 13.6525 18.1008 13.6525 17.6276Z",
    fill: "black"
  }));
};

var SVG$1 = function SVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
      filledColor = _ref$filledColor === void 0 ? '#084782' : _ref$filledColor;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "400",
    height: "300",
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "400",
    height: "300",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("g", {
    "clip-path": "url(#clip0_2191_22378)"
  }, /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.1",
    d: "M384.171 163.633C377.488 177.418 363.92 186.636 349.858 192.715C330.928 200.901 310.081 204.148 289.52 202.775C285.917 202.535 282.325 202.152 278.743 201.625C266.305 199.811 254.179 196.28 242.711 191.133C239.401 189.642 236.158 188.015 232.982 186.251C227.678 183.311 222.596 179.987 217.777 176.307C216.564 175.381 215.369 174.432 214.19 173.46C213.373 172.786 212.563 172.096 211.741 171.427C210.005 170.016 208.22 168.676 206.228 167.672C205.627 167.369 205.01 167.098 204.382 166.858C198.074 164.458 190.8 165.364 184.234 167.235C179.239 168.658 174.37 170.608 169.38 171.998C167.16 172.636 164.899 173.117 162.612 173.437C157.506 174.083 152.321 173.628 147.406 172.101L146.986 171.971C146.282 171.749 145.584 171.507 144.891 171.244L144.471 171.083C143.8 170.825 143.144 170.547 142.502 170.25L142.082 170.059C141.411 169.747 140.755 169.418 140.113 169.071C139.881 168.95 139.652 168.819 139.426 168.696C135.772 166.655 132.451 164.07 129.577 161.028C129.494 160.945 129.416 160.859 129.326 160.776C128.926 160.344 128.533 159.904 128.154 159.453C128.013 159.287 127.872 159.121 127.734 158.95C127.283 158.4 126.847 157.838 126.428 157.263C126.365 157.18 126.305 157.094 126.245 157.011C124.527 154.635 123.104 152.061 122.004 149.343C121.969 149.26 121.936 149.174 121.906 149.091C121.571 148.228 121.265 147.35 120.988 146.458C120.875 146.086 120.767 145.704 120.671 145.331C120.639 145.221 120.609 145.108 120.581 144.997C119.193 139.532 119.034 133.85 119.034 128.202C119.034 127.543 119.034 126.885 119.034 126.227C119.074 117.09 119.215 107.797 120.563 98.7859C120.563 98.723 120.581 98.6601 120.591 98.5997C121.042 95.5661 121.656 92.5588 122.429 89.5909C123.239 86.4768 124.274 83.4256 125.525 80.4614C128.626 73.1678 133.136 66.5306 138.143 60.3789C150.756 44.8989 167.297 31.9037 186.658 27.0397C207.52 21.8009 230.706 26.8208 247.534 40.2184C252.665 44.3028 257.275 49.1392 263.037 52.2704C268.067 54.9967 273.955 56.126 279.342 53.9806C283.794 52.2075 286.691 51.3273 291.691 51.5964C302.042 52.182 312.246 54.3193 321.962 57.9368C322.354 58.0801 322.746 58.2285 323.136 58.3769C348.465 68.0673 370.238 87.3198 381.555 112.06C381.855 112.714 382.146 113.373 382.428 114.037C389.176 129.799 391.615 148.272 384.171 163.633Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M365.698 52.0994H132.97C131.235 52.0994 129.829 53.5058 129.829 55.2406V184.35C129.829 186.084 131.235 187.491 132.97 187.491H365.698C367.433 187.491 368.839 186.084 368.839 184.35V55.2406C368.839 53.5058 367.433 52.0994 365.698 52.0994Z",
    fill: "url(#paint0_linear_2191_22378)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M365.346 54.0032H133.35C131.615 54.0032 130.208 55.4096 130.208 57.1444V183.899C130.208 185.634 131.615 187.041 133.35 187.041H365.346C367.081 187.041 368.487 185.634 368.487 183.899V57.1444C368.487 55.4096 367.081 54.0032 365.346 54.0032Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M365.346 54.0032H133.35C131.615 54.0032 130.208 55.4096 130.208 57.1444V183.899C130.208 185.634 131.615 187.041 133.35 187.041H365.346C367.081 187.041 368.487 185.634 368.487 183.899V57.1444C368.487 55.4096 367.081 54.0032 365.346 54.0032Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.04",
    d: "M365.346 54.0032H133.35C131.615 54.0032 130.208 55.4096 130.208 57.1444V183.899C130.208 185.634 131.615 187.041 133.35 187.041H365.346C367.081 187.041 368.487 185.634 368.487 183.899V57.1444C368.487 55.4096 367.081 54.0032 365.346 54.0032Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M367.277 52.4766H131.418C131.097 52.4766 130.79 52.604 130.563 52.8309C130.336 53.0578 130.208 53.3655 130.208 53.6863V58.7993H368.477V53.6863C368.477 53.3672 368.351 53.061 368.126 52.8344C367.902 52.6078 367.596 52.4792 367.277 52.4766Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M134.967 57.2734C135.87 57.2734 136.602 56.5415 136.602 55.6387C136.602 54.7358 135.87 54.0039 134.967 54.0039C134.064 54.0039 133.332 54.7358 133.332 55.6387C133.332 56.5415 134.064 57.2734 134.967 57.2734Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M139.368 57.2726C140.271 57.2726 141.003 56.5407 141.003 55.6378C141.003 54.735 140.271 54.0031 139.368 54.0031C138.465 54.0031 137.733 54.735 137.733 55.6378C137.733 56.5407 138.465 57.2726 139.368 57.2726Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M143.769 57.2726C144.672 57.2726 145.404 56.5407 145.404 55.6378C145.404 54.735 144.672 54.0031 143.769 54.0031C142.867 54.0031 142.135 54.735 142.135 55.6378C142.135 56.5407 142.867 57.2726 143.769 57.2726Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.2",
    d: "M213.778 70.6904H149.833V76.1179H213.778V70.6904Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.1",
    d: "M348.862 92.453H149.833V175.942H348.862V92.453Z",
    fill: "#5A5773"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.1",
    d: "M348.862 84.4175H328.717V89.1734H348.862V84.4175Z",
    fill: "#5A5773"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.1",
    d: "M358.877 224.655C371.139 224.655 381.08 223.059 381.08 221.089C381.08 219.119 371.139 217.523 358.877 217.523C346.615 217.523 336.675 219.119 336.675 221.089C336.675 223.059 346.615 224.655 358.877 224.655Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M359.592 152.776H358.163V184.943H359.592V152.776Z",
    fill: "#535461"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M368.57 184.845L368.48 186.294L368.354 188.339L368.301 189.191L368.175 191.238L368.12 192.091L367.994 194.136L366.553 217.392C366.492 218.393 366.051 219.333 365.32 220.02C364.59 220.707 363.625 221.089 362.622 221.089H355.132C354.13 221.089 353.165 220.707 352.435 220.02C351.705 219.332 351.265 218.393 351.204 217.392L349.755 194.136L349.63 192.091L349.577 191.238L349.453 189.186L349.401 188.333L349.275 186.289L349.184 184.84C349.167 184.562 349.207 184.283 349.302 184.021C349.396 183.759 349.544 183.52 349.735 183.317C349.925 183.114 350.156 182.952 350.412 182.842C350.667 182.731 350.943 182.674 351.222 182.675H366.536C366.814 182.674 367.09 182.731 367.346 182.842C367.602 182.953 367.833 183.115 368.024 183.319C368.214 183.522 368.361 183.763 368.455 184.025C368.549 184.288 368.588 184.567 368.57 184.845Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M368.48 186.294L368.354 188.338H349.398L349.272 186.294H368.48Z",
    fill: "#9D9CB5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M368.301 189.191L368.175 191.238H349.579L349.451 189.191H368.301Z",
    fill: "#9D9CB5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M368.12 192.091L367.994 194.136H349.76L349.632 192.091H368.12Z",
    fill: "#9D9CB5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M347.092 164.833C355.412 170.851 358.877 180.268 358.877 180.268C358.877 180.268 348.85 179.923 340.518 173.905C332.185 167.886 328.732 158.47 328.732 158.47C328.732 158.47 338.77 158.815 347.092 164.833Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M328.745 158.47C328.745 158.47 339.152 164.255 342.489 169.033C345.827 173.812 358.877 180.27 358.877 180.27",
    stroke: "#535461",
    strokeWidth: "0.552707",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M352.461 152.718C356.988 155.988 358.877 161.118 358.877 161.118C358.877 161.118 353.42 160.932 348.89 157.655C344.361 154.378 342.477 149.255 342.477 149.255C342.477 149.255 347.934 149.429 352.461 152.718Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M342.477 149.242C342.477 149.242 348.141 152.386 349.956 154.989C351.772 157.592 358.877 161.106 358.877 161.106",
    stroke: "#535461",
    strokeWidth: "0.552707",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M365.459 160.847C360.256 166.563 359.156 174.033 359.156 174.033C359.156 174.033 366.49 172.235 371.691 166.518C376.892 160.801 377.994 153.329 377.994 153.329C377.994 153.329 370.66 155.127 365.459 160.847Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M377.994 153.329C377.994 153.329 371.219 159.189 369.496 163.228C367.773 167.267 359.156 174.043 359.156 174.043",
    stroke: "#535461",
    strokeWidth: "0.552707",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("g", {
    "clip-path": "url(#clip1_2191_22378)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M251.787 157.65C281.415 157.65 305.433 156.06 305.433 154.098C305.433 152.137 281.415 150.547 251.787 150.547C222.159 150.547 198.14 152.137 198.14 154.098C198.14 156.06 222.159 157.65 251.787 157.65Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M249.731 115.219C240.99 115.219 234.715 120.826 234.715 133.911C234.715 148.74 240.99 152.665 249.731 152.665C258.471 152.665 265.121 148.366 265.121 133.911C265.121 118.458 258.471 115.219 249.731 115.219ZM249.788 147.743C243.734 147.743 240.572 144.191 240.572 133.92C240.572 124.858 243.864 120.078 249.918 120.078C255.972 120.078 259.264 123.218 259.264 133.92C259.264 143.932 255.842 147.743 249.788 147.743Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M229.481 142.322H225.867V131.68C225.867 131.115 225.643 130.573 225.243 130.174C224.843 129.774 224.301 129.549 223.736 129.549H222.889C222.609 129.549 222.332 129.604 222.074 129.712C221.815 129.819 221.58 129.976 221.382 130.174C221.184 130.371 221.027 130.606 220.92 130.865C220.813 131.123 220.758 131.401 220.758 131.68V142.322H210.565C210.355 142.322 210.149 142.268 209.966 142.165C209.784 142.062 209.631 141.913 209.522 141.734C209.414 141.554 209.354 141.349 209.348 141.14C209.342 140.93 209.391 140.723 209.489 140.537L220.277 120.118C220.412 119.863 220.493 119.584 220.517 119.297C220.541 119.01 220.506 118.722 220.415 118.448C220.324 118.175 220.178 117.923 219.987 117.708C219.796 117.493 219.563 117.318 219.303 117.195L218.666 116.894C218.172 116.661 217.606 116.626 217.087 116.798C216.568 116.97 216.134 117.335 215.877 117.817L202.719 142.432C202.494 142.851 202.377 143.319 202.377 143.794C202.377 144.173 202.452 144.549 202.597 144.9C202.742 145.25 202.955 145.569 203.224 145.837C203.492 146.106 203.811 146.319 204.161 146.464C204.512 146.609 204.888 146.684 205.267 146.684H220.758V153.413C220.758 153.748 220.824 154.081 220.952 154.391C221.081 154.7 221.269 154.982 221.506 155.219C221.743 155.457 222.025 155.645 222.335 155.773C222.645 155.901 222.977 155.968 223.312 155.968H223.312C223.648 155.968 223.98 155.901 224.29 155.773C224.6 155.645 224.882 155.457 225.119 155.219C225.356 154.982 225.544 154.7 225.673 154.391C225.801 154.081 225.867 153.748 225.867 153.413V146.684H229.481C230.059 146.684 230.614 146.454 231.023 146.045C231.432 145.636 231.662 145.081 231.662 144.503C231.662 143.925 231.432 143.37 231.023 142.961C230.614 142.552 230.059 142.322 229.481 142.322Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M296.399 142.322H292.785V131.68C292.785 131.115 292.561 130.573 292.161 130.174C291.761 129.774 291.219 129.549 290.654 129.549H289.807C289.527 129.549 289.25 129.604 288.992 129.712C288.733 129.819 288.498 129.976 288.3 130.174C288.102 130.371 287.945 130.606 287.838 130.865C287.731 131.123 287.676 131.401 287.676 131.68V142.322H277.483C277.273 142.322 277.067 142.268 276.884 142.165C276.702 142.062 276.549 141.913 276.44 141.734C276.332 141.554 276.272 141.349 276.266 141.14C276.26 140.93 276.309 140.723 276.407 140.537L287.195 120.118C287.33 119.863 287.411 119.584 287.435 119.297C287.459 119.01 287.424 118.722 287.333 118.448C287.242 118.175 287.096 117.923 286.905 117.708C286.714 117.493 286.481 117.318 286.221 117.195L285.584 116.894C285.09 116.661 284.524 116.626 284.005 116.798C283.486 116.97 283.052 117.335 282.795 117.817L269.637 142.432C269.412 142.851 269.295 143.319 269.295 143.794C269.295 144.56 269.6 145.295 270.142 145.837C270.684 146.379 271.419 146.684 272.185 146.684H287.676V153.413C287.676 154.09 287.945 154.74 288.424 155.219C288.903 155.698 289.553 155.968 290.23 155.968C290.908 155.968 291.558 155.698 292.037 155.219C292.516 154.74 292.785 154.09 292.785 153.413V146.684H296.399C296.977 146.684 297.532 146.454 297.941 146.045C298.35 145.636 298.58 145.081 298.58 144.503C298.58 143.925 298.35 143.37 297.941 142.961C297.532 142.552 296.977 142.322 296.399 142.322Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M230.478 141.076H226.864V130.434C226.864 130.154 226.809 129.877 226.702 129.619C226.595 129.36 226.438 129.125 226.24 128.927C226.042 128.729 225.807 128.572 225.548 128.465C225.29 128.358 225.013 128.303 224.733 128.303H223.886C223.321 128.303 222.779 128.527 222.379 128.927C221.979 129.327 221.755 129.869 221.755 130.434V141.076H211.561C211.352 141.076 211.146 141.022 210.963 140.919C210.78 140.815 210.628 140.667 210.519 140.487C210.411 140.308 210.351 140.103 210.345 139.894C210.339 139.684 210.388 139.476 210.486 139.291L221.274 118.872C221.409 118.617 221.49 118.338 221.514 118.051C221.538 117.764 221.503 117.475 221.412 117.202C221.321 116.929 221.175 116.677 220.984 116.462C220.793 116.246 220.56 116.072 220.3 115.949L219.663 115.648C219.169 115.415 218.603 115.38 218.084 115.552C217.565 115.724 217.131 116.088 216.874 116.571L203.715 141.185C203.491 141.604 203.374 142.072 203.374 142.548V142.548C203.374 143.314 203.679 144.049 204.221 144.591C204.763 145.133 205.498 145.437 206.264 145.437H221.755V152.167C221.755 152.502 221.821 152.834 221.949 153.144C222.078 153.454 222.266 153.736 222.503 153.973C222.74 154.21 223.022 154.398 223.332 154.527C223.642 154.655 223.974 154.721 224.309 154.721H224.309C224.987 154.721 225.637 154.452 226.116 153.973C226.595 153.494 226.864 152.844 226.864 152.167V145.437H230.478C230.764 145.437 231.048 145.381 231.312 145.271C231.577 145.162 231.817 145.001 232.02 144.799C232.222 144.596 232.383 144.356 232.493 144.091C232.602 143.827 232.659 143.543 232.659 143.257V143.257C232.659 142.97 232.602 142.687 232.493 142.422C232.383 142.158 232.222 141.917 232.02 141.715C231.817 141.512 231.577 141.352 231.312 141.242C231.048 141.132 230.764 141.076 230.478 141.076V141.076Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M298.268 141.076H294.654V130.434C294.654 129.869 294.43 129.327 294.03 128.927C293.63 128.527 293.088 128.303 292.523 128.303H291.676C291.396 128.303 291.119 128.358 290.861 128.465C290.602 128.572 290.367 128.729 290.169 128.927C289.971 129.125 289.814 129.36 289.707 129.619C289.6 129.877 289.545 130.154 289.545 130.434V141.076H279.352C279.142 141.076 278.936 141.022 278.753 140.919C278.571 140.815 278.418 140.667 278.31 140.487C278.201 140.308 278.141 140.103 278.136 139.894C278.13 139.684 278.178 139.476 278.276 139.291L289.064 118.872C289.199 118.617 289.281 118.338 289.304 118.051C289.328 117.764 289.293 117.475 289.202 117.202C289.111 116.929 288.965 116.677 288.774 116.462C288.583 116.246 288.351 116.072 288.09 115.949L287.453 115.648C286.959 115.415 286.393 115.38 285.874 115.552C285.355 115.724 284.922 116.088 284.664 116.571L271.506 141.185C271.282 141.604 271.164 142.072 271.164 142.548C271.164 143.314 271.469 144.049 272.011 144.591C272.553 145.133 273.288 145.437 274.054 145.437H289.545V152.167C289.545 152.844 289.814 153.494 290.293 153.973C290.772 154.452 291.422 154.721 292.1 154.721V154.721C292.777 154.721 293.427 154.452 293.906 153.973C294.385 153.494 294.654 152.844 294.654 152.167V145.437H298.268C298.554 145.437 298.838 145.381 299.103 145.271C299.367 145.162 299.608 145.001 299.81 144.799C300.013 144.596 300.173 144.356 300.283 144.091C300.392 143.827 300.449 143.543 300.449 143.257V143.257C300.449 142.678 300.219 142.124 299.81 141.715C299.401 141.306 298.846 141.076 298.268 141.076V141.076Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M251.725 114.097C242.984 114.097 236.709 119.705 236.709 132.789C236.709 147.618 242.984 151.544 251.725 151.544C260.465 151.544 267.114 147.244 267.114 132.789C267.114 117.337 260.465 114.097 251.725 114.097ZM251.782 146.621C245.728 146.621 242.565 143.07 242.565 132.799C242.565 123.736 245.858 118.957 251.912 118.957C257.965 118.957 261.258 122.096 261.258 132.799C261.258 142.811 257.836 146.621 251.782 146.621V146.621Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M299.201 140.902C299.509 141.014 299.839 141.053 300.165 141.015C300.491 140.978 300.803 140.866 301.078 140.687C301.353 140.509 301.582 140.268 301.749 139.986C301.915 139.703 302.013 139.386 302.036 139.059C302.059 138.732 302.005 138.404 301.88 138.102C301.754 137.799 301.56 137.529 301.312 137.314C301.065 137.099 300.771 136.945 300.453 136.863C300.136 136.781 299.804 136.774 299.483 136.842L299.536 137.932L299.021 136.998C298.515 137.236 298.124 137.665 297.934 138.19C297.867 138.375 297.826 138.567 297.812 138.763C297.78 139.222 297.898 139.679 298.148 140.065C298.399 140.451 298.769 140.745 299.201 140.902Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.752 153.537C301.57 152.611 302.358 151.789 303.137 151.256C303.916 150.722 304.826 150.197 305.091 149.291C305.473 147.989 304.336 146.796 303.45 145.768C302.793 145.005 302.229 144.166 301.77 143.27C301.586 142.911 301.416 142.536 301.368 142.135C301.298 141.558 301.484 140.983 301.67 140.433C302.293 138.599 302.958 136.78 303.667 134.977",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M299.288 140.621C299.597 140.733 299.926 140.772 300.252 140.735C300.578 140.698 300.89 140.585 301.165 140.407C301.44 140.228 301.67 139.988 301.836 139.705C302.002 139.423 302.101 139.106 302.123 138.779C302.146 138.451 302.092 138.124 301.967 137.821C301.841 137.518 301.647 137.249 301.399 137.034C301.152 136.819 300.858 136.664 300.54 136.582C300.223 136.5 299.891 136.493 299.57 136.562L299.623 137.651L299.108 136.718C298.602 136.955 298.211 137.384 298.021 137.91C297.954 138.094 297.913 138.287 297.9 138.482C297.867 138.941 297.985 139.398 298.236 139.784C298.486 140.17 298.856 140.464 299.288 140.621V140.621Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.493 134.6C301.614 134.267 301.817 133.969 302.083 133.734C302.349 133.5 302.67 133.336 303.016 133.258L303.191 134.294L303.514 133.206C303.962 133.213 304.397 133.362 304.756 133.632C305.114 133.901 305.377 134.278 305.508 134.708C305.638 135.137 305.628 135.597 305.48 136.02C305.332 136.444 305.054 136.809 304.684 137.064C304.315 137.319 303.874 137.45 303.426 137.438C302.977 137.426 302.544 137.271 302.189 136.997C301.834 136.723 301.575 136.343 301.45 135.912C301.325 135.481 301.34 135.022 301.493 134.6H301.493Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.609 134.226C301.73 133.893 301.933 133.595 302.199 133.36C302.465 133.126 302.786 132.962 303.133 132.884L303.307 133.92L303.63 132.832C304.079 132.839 304.513 132.988 304.872 133.258C305.23 133.528 305.494 133.904 305.624 134.334C305.754 134.763 305.744 135.223 305.597 135.646C305.449 136.07 305.17 136.435 304.8 136.69C304.431 136.945 303.99 137.076 303.542 137.064C303.093 137.052 302.66 136.898 302.305 136.623C301.95 136.349 301.691 135.969 301.566 135.538C301.441 135.108 301.456 134.648 301.609 134.226H301.609Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M303.079 145.789C303.567 145.966 304.104 145.957 304.587 145.764C305.069 145.571 305.464 145.207 305.695 144.742C305.927 144.277 305.979 143.742 305.842 143.241C305.705 142.74 305.388 142.306 304.952 142.024L304.704 142.859L304.528 141.812C304.526 141.811 304.524 141.81 304.522 141.81C304.261 141.715 303.983 141.672 303.706 141.684C303.428 141.697 303.155 141.764 302.903 141.881C302.651 141.999 302.425 142.165 302.238 142.37C302.05 142.575 301.905 142.816 301.81 143.077C301.715 143.338 301.673 143.616 301.685 143.894C301.697 144.171 301.765 144.444 301.882 144.696C302 144.948 302.167 145.174 302.372 145.361C302.577 145.549 302.817 145.694 303.079 145.789H303.079Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M303.18 145.41C303.668 145.587 304.205 145.578 304.687 145.385C305.17 145.192 305.565 144.828 305.796 144.363C306.028 143.898 306.08 143.364 305.943 142.862C305.806 142.361 305.489 141.928 305.053 141.645L304.804 142.481L304.628 141.433C304.627 141.432 304.625 141.431 304.623 141.431C304.362 141.336 304.084 141.293 303.806 141.306C303.529 141.318 303.256 141.385 303.004 141.502C302.752 141.62 302.526 141.786 302.338 141.992C302.151 142.197 302.005 142.437 301.91 142.698C301.816 142.96 301.773 143.237 301.786 143.515C301.798 143.793 301.865 144.065 301.983 144.317C302.101 144.569 302.267 144.795 302.473 144.983C302.678 145.17 302.918 145.315 303.18 145.41H303.18Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M300.875 149.304C300.959 149.782 301.205 150.216 301.571 150.535C301.938 150.853 302.403 151.036 302.888 151.052C303.373 151.068 303.849 150.917 304.236 150.624C304.623 150.331 304.897 149.914 305.013 149.443C305.129 148.972 305.079 148.475 304.873 148.036C304.666 147.597 304.314 147.242 303.877 147.032C303.44 146.821 302.943 146.767 302.471 146.879C301.999 146.991 301.579 147.262 301.283 147.646L302.226 149.066L300.938 148.312C300.838 148.633 300.816 148.973 300.875 149.304Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M300.962 149.023C301.046 149.501 301.292 149.936 301.659 150.254C302.025 150.573 302.49 150.755 302.975 150.772C303.46 150.788 303.936 150.637 304.323 150.344C304.71 150.051 304.984 149.634 305.1 149.163C305.216 148.691 305.167 148.195 304.96 147.756C304.753 147.317 304.401 146.962 303.964 146.751C303.527 146.541 303.03 146.487 302.558 146.599C302.086 146.711 301.667 146.982 301.37 147.366L302.313 148.785L301.025 148.032C300.925 148.353 300.904 148.693 300.962 149.023V149.023Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M197.72 146.058C197.922 146.131 198.139 146.157 198.353 146.133C198.567 146.108 198.772 146.034 198.953 145.917C199.133 145.799 199.284 145.642 199.393 145.456C199.503 145.271 199.567 145.062 199.582 144.847C199.597 144.632 199.562 144.417 199.479 144.218C199.397 144.019 199.269 143.842 199.107 143.701C198.944 143.56 198.751 143.458 198.542 143.404C198.334 143.351 198.116 143.346 197.905 143.391L197.94 144.107L197.601 143.493C197.269 143.649 197.012 143.931 196.887 144.276C196.843 144.397 196.816 144.524 196.807 144.653C196.786 144.954 196.863 145.255 197.028 145.508C197.193 145.762 197.436 145.955 197.72 146.058Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M199.395 154.36C199.276 153.751 199.794 153.211 200.306 152.86C200.817 152.51 201.415 152.165 201.59 151.57C201.841 150.714 201.093 149.931 200.511 149.255C200.08 148.754 199.709 148.203 199.407 147.614C199.276 147.383 199.187 147.13 199.143 146.868C199.097 146.489 199.219 146.111 199.342 145.75C199.751 144.545 200.188 143.35 200.654 142.165",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M197.777 145.874C197.979 145.947 198.196 145.973 198.41 145.948C198.624 145.924 198.829 145.85 199.01 145.733C199.191 145.615 199.341 145.457 199.451 145.272C199.56 145.086 199.625 144.878 199.639 144.663C199.654 144.448 199.619 144.233 199.537 144.034C199.454 143.835 199.327 143.658 199.164 143.517C199.001 143.375 198.808 143.274 198.6 143.22C198.391 143.166 198.173 143.162 197.962 143.206L197.997 143.922L197.658 143.309C197.326 143.465 197.069 143.747 196.945 144.092C196.9 144.213 196.873 144.34 196.865 144.468C196.843 144.77 196.921 145.07 197.085 145.324C197.25 145.577 197.493 145.77 197.777 145.874V145.874Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M199.225 141.918C199.305 141.698 199.438 141.503 199.613 141.349C199.788 141.195 199.999 141.087 200.226 141.036L200.341 141.716L200.553 141.002C200.848 141.006 201.134 141.104 201.369 141.281C201.605 141.459 201.778 141.706 201.863 141.988C201.949 142.27 201.942 142.572 201.845 142.851C201.748 143.129 201.565 143.369 201.322 143.536C201.08 143.704 200.79 143.79 200.495 143.782C200.201 143.774 199.916 143.673 199.683 143.493C199.449 143.312 199.279 143.063 199.197 142.78C199.115 142.497 199.125 142.195 199.225 141.918Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M199.302 141.672C199.381 141.453 199.514 141.257 199.689 141.103C199.864 140.949 200.075 140.841 200.303 140.79L200.417 141.471L200.629 140.756C200.924 140.76 201.21 140.858 201.445 141.036C201.681 141.213 201.854 141.46 201.939 141.743C202.025 142.025 202.019 142.327 201.922 142.605C201.824 142.883 201.641 143.123 201.398 143.291C201.156 143.458 200.866 143.544 200.572 143.536C200.277 143.528 199.992 143.427 199.759 143.247C199.526 143.067 199.356 142.817 199.274 142.534C199.191 142.251 199.201 141.949 199.302 141.672V141.672Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M200.267 149.269C200.588 149.385 200.941 149.379 201.258 149.253C201.575 149.126 201.834 148.887 201.986 148.581C202.139 148.275 202.173 147.924 202.083 147.595C201.993 147.265 201.785 146.981 201.498 146.795L201.335 147.344L201.219 146.656C201.218 146.655 201.217 146.655 201.216 146.654C201.044 146.592 200.862 146.564 200.679 146.572C200.497 146.58 200.318 146.624 200.152 146.701C199.986 146.779 199.838 146.888 199.714 147.023C199.591 147.157 199.496 147.315 199.433 147.487C199.371 147.659 199.343 147.841 199.351 148.024C199.36 148.206 199.404 148.385 199.481 148.551C199.559 148.716 199.668 148.865 199.803 148.988C199.938 149.111 200.096 149.207 200.267 149.269Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M200.333 149.02C200.654 149.136 201.007 149.131 201.324 149.004C201.641 148.877 201.9 148.638 202.053 148.332C202.205 148.026 202.239 147.675 202.149 147.346C202.059 147.017 201.851 146.732 201.564 146.546L201.401 147.095L201.285 146.407C201.284 146.406 201.283 146.406 201.282 146.405C201.11 146.343 200.928 146.315 200.746 146.324C200.563 146.332 200.384 146.376 200.219 146.453C199.885 146.609 199.626 146.892 199.5 147.239C199.375 147.585 199.392 147.968 199.548 148.302C199.704 148.636 199.987 148.894 200.333 149.02V149.02Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M198.82 151.578C198.875 151.892 199.036 152.178 199.277 152.387C199.518 152.596 199.823 152.716 200.142 152.727C200.46 152.738 200.773 152.638 201.027 152.446C201.282 152.253 201.462 151.979 201.538 151.67C201.614 151.36 201.582 151.034 201.446 150.745C201.31 150.457 201.079 150.224 200.792 150.085C200.504 149.947 200.178 149.912 199.868 149.985C199.558 150.059 199.282 150.237 199.088 150.489L199.707 151.422L198.861 150.927C198.795 151.138 198.781 151.361 198.82 151.578Z",
    fill: "#57B894"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M198.877 151.394C198.932 151.708 199.094 151.993 199.334 152.203C199.575 152.412 199.88 152.532 200.199 152.542C200.518 152.553 200.83 152.454 201.085 152.261C201.339 152.069 201.519 151.795 201.595 151.485C201.672 151.176 201.639 150.849 201.503 150.561C201.367 150.272 201.136 150.039 200.849 149.901C200.562 149.763 200.236 149.727 199.925 149.801C199.615 149.874 199.339 150.052 199.145 150.305L199.764 151.237L198.918 150.742C198.852 150.953 198.838 151.177 198.877 151.394V151.394Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M245.716 132.925C246.67 132.925 247.445 131.923 247.445 130.688C247.445 129.452 246.67 128.45 245.716 128.45C244.761 128.45 243.987 129.452 243.987 130.688C243.987 131.923 244.761 132.925 245.716 132.925Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M255.123 132.976C256.078 132.976 256.852 131.974 256.852 130.739C256.852 129.503 256.078 128.501 255.123 128.501C254.168 128.501 253.394 129.503 253.394 130.739C253.394 131.974 254.168 132.976 255.123 132.976Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M253.801 137.349C253.801 138.36 252.389 139.18 250.648 139.18C248.907 139.18 247.495 138.36 247.495 137.349C247.495 136.473 248.554 135.741 249.969 135.562C250.194 135.532 250.421 135.518 250.648 135.518C251.029 135.517 251.408 135.558 251.78 135.641C252.962 135.904 253.801 136.57 253.801 137.349Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M246.122 132.417C247.077 132.417 247.851 131.415 247.851 130.179C247.851 128.943 247.077 127.942 246.122 127.942C245.168 127.942 244.394 128.943 244.394 130.179C244.394 131.415 245.168 132.417 246.122 132.417Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M255.53 132.467C256.485 132.467 257.259 131.466 257.259 130.23C257.259 128.994 256.485 127.993 255.53 127.993C254.575 127.993 253.801 128.994 253.801 130.23C253.801 131.466 254.575 132.467 255.53 132.467Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M251.055 138.671C252.796 138.671 254.208 137.852 254.208 136.841C254.208 135.83 252.796 135.01 251.055 135.01C249.314 135.01 247.902 135.83 247.902 136.841C247.902 137.852 249.314 138.671 251.055 138.671Z",
    stroke: filledColor,
    strokeWidth: "0.276354",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M251.818 135.793C251.819 135.921 251.77 136.044 251.683 136.138C251.642 136.183 251.592 136.219 251.537 136.243C251.481 136.268 251.421 136.281 251.36 136.281H250.343C250.218 136.277 250.099 136.223 250.013 136.132C249.928 136.04 249.882 135.918 249.885 135.793C249.885 135.694 249.914 135.597 249.969 135.514C250.194 135.483 250.421 135.467 250.648 135.468C251.029 135.466 251.409 135.51 251.78 135.598C251.805 135.66 251.818 135.726 251.818 135.793Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M246.122 130.078C246.403 130.078 246.631 129.85 246.631 129.569C246.631 129.288 246.403 129.061 246.122 129.061C245.842 129.061 245.614 129.288 245.614 129.569C245.614 129.85 245.842 130.078 246.122 130.078Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M255.581 130.078C255.861 130.078 256.089 129.85 256.089 129.569C256.089 129.288 255.861 129.061 255.581 129.061C255.3 129.061 255.072 129.288 255.072 129.569C255.072 129.85 255.3 130.078 255.581 130.078Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.3",
    d: "M256.089 134.857C256.37 134.857 256.598 134.63 256.598 134.349C256.598 134.068 256.37 133.84 256.089 133.84C255.808 133.84 255.581 134.068 255.581 134.349C255.581 134.63 255.808 134.857 256.089 134.857Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.3",
    d: "M243.682 134.857C243.963 134.857 244.19 134.63 244.19 134.349C244.19 134.068 243.963 133.84 243.682 133.84C243.401 133.84 243.173 134.068 243.173 134.349C243.173 134.63 243.401 134.857 243.682 134.857Z",
    fill: filledColor
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M75.8011 213.477C99.9797 213.477 119.58 193.876 119.58 169.697C119.58 145.519 99.9797 125.918 75.8011 125.918C51.6225 125.918 32.0219 145.519 32.0219 169.697C32.0219 193.876 51.6225 213.477 75.8011 213.477Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 119.199C12 138.69 24.2276 154.462 39.3385 154.462L12 119.199Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M39.3385 154.462C39.3385 134.752 52.9838 118.803 69.8467 118.803L39.3385 154.462Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.9053 120.966C21.9053 139.48 29.7026 154.462 39.3385 154.462L21.9053 120.966Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M39.3385 154.462C39.3385 129.277 55.1103 108.898 74.6012 108.898L39.3385 154.462Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33.5872 154.71C33.5872 154.71 37.4642 154.591 38.6327 153.759C39.8011 152.927 44.5965 151.933 44.8864 153.268C45.1763 154.602 50.7129 159.904 46.3357 159.94C41.9586 159.975 36.1651 159.258 34.9989 158.548C33.8327 157.837 33.5872 154.71 33.5872 154.71Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.2",
    d: "M46.4138 159.475C42.0367 159.511 36.2432 158.793 35.077 158.083C34.1889 157.542 33.835 155.601 33.7166 154.705C33.6346 154.709 33.5872 154.71 33.5872 154.71C33.5872 154.71 33.8327 157.837 34.9989 158.548C36.1651 159.258 41.9586 159.975 46.3357 159.94C47.5992 159.93 48.0357 159.48 48.0117 158.814C47.8362 159.217 47.3543 159.468 46.4138 159.475Z",
    fill: "black"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M61.9508 219.498C87.9253 219.498 108.982 216.633 108.982 213.1C108.982 209.566 87.9253 206.701 61.9508 206.701C35.9763 206.701 14.9198 209.566 14.9198 213.1C14.9198 216.633 35.9763 219.498 61.9508 219.498Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.1",
    d: "M61.9508 218.471C83.7583 218.471 101.437 216.066 101.437 213.099C101.437 210.133 83.7583 207.728 61.9508 207.728C40.1433 207.728 22.4649 210.133 22.4649 213.099C22.4649 216.066 40.1433 218.471 61.9508 218.471Z",
    fill: "black"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M90.119 274.498C113.732 274.498 132.874 271.894 132.874 268.682C132.874 265.469 113.732 262.865 90.119 262.865C66.5058 262.865 47.3635 265.469 47.3635 268.682C47.3635 271.894 66.5058 274.498 90.119 274.498Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M133.446 236.667C165.392 250.782 226.8 218.256 233.544 181.435",
    stroke: "#2F2E41",
    strokeWidth: "0.552707",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M89.8675 171.476C89.8675 171.476 122.563 162.422 124.575 191.596C126.587 220.77 97.6641 229.07 120.299 234.855",
    stroke: "#2F2E41",
    strokeWidth: "0.552707",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M58.2794 241.465C58.2794 241.465 68.1062 238.744 68.7109 247.512C69.3156 256.281 60.6227 258.775 67.4259 260.514",
    stroke: "#2F2E41",
    strokeWidth: "0.552707",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M91.6281 146.326H39.3156V207.189H91.6281V146.326Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M96.9096 140.289H34.0339V161.919H96.9096V140.289Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M96.9096 165.943H34.0339V187.572H96.9096V165.943Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M96.9096 191.596H34.0339V213.225H96.9096V191.596Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.4",
    d: "M84.3345 144.062H80.3105V148.086H84.3345V144.062Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.8",
    d: "M90.1191 144.062H86.095V148.086H90.1191V144.062Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M95.9036 144.062H91.8795V148.086H95.9036V144.062Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.4",
    d: "M84.3345 169.464H80.3105V173.488H84.3345V169.464Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.8",
    d: "M90.1191 169.464H86.095V173.488H90.1191V169.464Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M95.9036 169.464H91.8795V173.488H95.9036V169.464Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.4",
    d: "M84.3345 194.865H80.3105V198.89H84.3345V194.865Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.8",
    d: "M90.1191 194.865H86.095V198.89H90.1191V194.865Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M95.9036 194.865H91.8795V198.89H95.9036V194.865Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M91.628 261.514C102.601 261.514 111.497 252.618 111.497 241.645C111.497 230.672 102.601 221.776 91.628 221.776C80.6548 221.776 71.7593 230.672 71.7593 241.645C71.7593 252.618 80.6548 261.514 91.628 261.514Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M88.61 257.238H82.5739V268.053H88.61V257.238Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M100.682 257.238H94.6461V268.053H100.682V257.238Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M87.604 270.065C90.382 270.065 92.6341 269.22 92.6341 268.179C92.6341 267.137 90.382 266.292 87.604 266.292C84.826 266.292 82.5739 267.137 82.5739 268.179C82.5739 269.22 84.826 270.065 87.604 270.065Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M99.6761 269.813C102.454 269.813 104.706 268.969 104.706 267.927C104.706 266.885 102.454 266.041 99.6761 266.041C96.8981 266.041 94.6461 266.885 94.6461 267.927C94.6461 268.969 96.8981 269.813 99.6761 269.813Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M92.131 243.405C95.8813 243.405 98.9216 240.365 98.9216 236.615C98.9216 232.865 95.8813 229.824 92.131 229.824C88.3807 229.824 85.3404 232.865 85.3404 236.615C85.3404 240.365 88.3807 243.405 92.131 243.405Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M92.131 238.878C93.3811 238.878 94.3945 237.865 94.3945 236.615C94.3945 235.365 93.3811 234.351 92.131 234.351C90.8809 234.351 89.8675 235.365 89.8675 236.615C89.8675 237.865 90.8809 238.878 92.131 238.878Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M72.3548 223.168C70.7505 215.983 75.8788 208.723 83.8092 206.952C91.7396 205.181 99.4691 209.57 101.073 216.755C102.678 223.94 97.4219 226.59 89.4915 228.361C81.5611 230.131 73.9591 230.353 72.3548 223.168Z",
    fill: filledColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M110.263 237.682C115.307 235.523 118.847 232.49 118.169 230.906C117.491 229.323 112.853 229.789 107.809 231.948C102.765 234.107 99.2251 237.141 99.9029 238.724C100.581 240.308 105.219 239.841 110.263 237.682Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M73.0406 251.012C78.0846 248.853 81.6241 245.819 80.9464 244.236C80.2687 242.652 75.6303 243.119 70.5863 245.278C65.5423 247.436 62.0027 250.47 62.6804 252.054C63.3582 253.637 67.9965 253.171 73.0406 251.012Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M103.197 247.43C103.197 249.374 98.1902 253.214 92.6341 253.214C87.0781 253.214 81.8195 249.626 81.8195 247.681C81.8195 245.737 87.0781 246.172 92.6341 246.172C98.1902 246.172 103.197 245.485 103.197 247.43Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint0_linear_2191_22378",
    x1: "249.333",
    y1: "187.491",
    x2: "249.333",
    y2: "52.0994",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    "stop-color": "#808080",
    "stop-opacity": "0.25"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "0.54",
    "stop-color": "#808080",
    "stop-opacity": "0.12"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    "stop-color": "#808080",
    "stop-opacity": "0.1"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_2191_22378"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "288.114",
    height: "206.21",
    fill: "white",
    transform: "translate(100.619 25)"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip1_2191_22378"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "109.265",
    height: "59.416",
    fill: "white",
    transform: "translate(196.804 98.2336)"
  }))));
};

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

var SVG = function SVG(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/React__default.createElement("svg", {
    width: "400",
    height: "300",
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "400",
    height: "300",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.1",
    d: "M357.001 212.492C348.638 229.743 331.658 241.278 314.061 248.886C290.37 259.131 264.281 263.194 238.551 261.475C234.042 261.175 229.546 260.696 225.064 260.037C209.498 257.766 194.323 253.347 179.971 246.906C175.829 245.041 171.771 243.004 167.797 240.797C161.159 237.118 154.799 232.958 148.768 228.352C147.251 227.194 145.754 226.006 144.279 224.789C143.256 223.946 142.243 223.083 141.214 222.246C139.042 220.48 136.807 218.803 134.315 217.547C133.563 217.168 132.791 216.827 132.004 216.527C124.111 213.524 115.008 214.658 106.79 216.999C100.54 218.781 94.4463 221.22 88.2018 222.96C85.4242 223.758 82.594 224.36 79.7321 224.761C73.3425 225.57 66.8537 225 60.7028 223.089L60.1772 222.926C59.2959 222.649 58.422 222.346 57.5554 222.016L57.0298 221.815C56.1905 221.492 55.369 221.144 54.5653 220.773L54.0397 220.534C53.2004 220.143 52.3789 219.731 51.5753 219.297C51.2857 219.146 50.9993 218.982 50.7161 218.828C46.1437 216.274 41.9875 213.038 38.3908 209.231C38.2869 209.128 38.1893 209.02 38.076 208.917C37.5756 208.375 37.0846 207.824 36.6093 207.261C36.4331 207.053 36.2568 206.846 36.0837 206.632C35.5193 205.943 34.9748 205.239 34.4502 204.52C34.3715 204.416 34.296 204.309 34.2204 204.205C32.0712 201.232 30.2895 198.009 28.9139 194.608C28.8698 194.505 28.8289 194.398 28.7911 194.294C28.3715 193.213 27.9885 192.115 27.6423 190.998C27.5007 190.533 27.3653 190.054 27.2457 189.588C27.2048 189.45 27.1671 189.308 27.1324 189.17C25.3951 182.33 25.1968 175.22 25.1968 168.151C25.1968 167.327 25.1968 166.503 25.1968 165.681C25.2471 154.246 25.4234 142.616 27.1104 131.339C27.1104 131.26 27.1324 131.182 27.145 131.106C27.7097 127.31 28.4777 123.546 29.4458 119.832C30.459 115.935 31.7539 112.116 33.3203 108.407C37.201 99.2794 42.8444 90.9734 49.1109 83.2748C64.8952 63.9024 85.5958 47.6397 109.825 41.5526C135.932 34.9965 164.949 41.2788 186.008 58.0451C192.429 63.1565 198.198 69.209 205.409 73.1275C211.703 76.5393 219.072 77.9525 225.813 75.2677C231.384 73.0488 235.01 71.9472 241.267 72.284C254.221 73.0168 266.991 75.6915 279.149 80.2186C279.64 80.398 280.131 80.5837 280.619 80.7694C312.317 92.8964 339.564 116.99 353.728 147.951C354.103 148.769 354.467 149.594 354.82 150.425C363.264 170.15 366.317 193.268 357.001 212.492Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M81.5109 229.956C82.9108 230.448 84.4138 230.571 85.8752 230.314C87.3366 230.056 88.7071 229.427 89.8546 228.486C92.777 226.033 93.6935 221.993 94.4388 218.251L96.6439 207.183L92.0273 210.362C88.7071 212.648 85.3123 215.008 83.0136 218.319C80.7149 221.63 79.7121 226.15 81.5585 229.733",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M82.2237 244.126C81.6426 239.892 81.0447 235.604 81.4533 231.325C81.8154 227.525 82.9748 223.814 85.3351 220.77C86.5879 219.158 88.1124 217.777 89.84 216.688C90.2904 216.404 90.705 217.118 90.2565 217.401C87.2673 219.29 84.9551 222.079 83.6535 225.367C82.216 229.023 81.9851 233.009 82.2327 236.893C82.3824 239.242 82.7005 241.575 83.0199 243.906C83.0451 244.011 83.0294 244.122 82.9758 244.216C82.9223 244.311 82.835 244.381 82.7316 244.413C82.626 244.442 82.5135 244.427 82.4185 244.374C82.3235 244.32 82.2536 244.23 82.2239 244.125L82.2237 244.126Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M86.4062 237.333C87.0065 238.246 87.8318 238.988 88.8025 239.489C89.7732 239.991 90.8566 240.233 91.9484 240.194C94.7546 240.061 97.0932 238.103 99.1982 236.244L105.426 230.745L101.304 230.548C98.3404 230.406 95.2999 230.273 92.4769 231.188C89.6538 232.103 87.0503 234.302 86.5341 237.224",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M80.5812 246.559C83.3787 241.61 86.6233 236.108 92.4213 234.35C94.0333 233.863 95.7235 233.688 97.4011 233.836C97.9299 233.882 97.7978 234.696 97.2701 234.651C94.4581 234.418 91.6515 235.16 89.3228 236.754C87.0819 238.279 85.337 240.4 83.8604 242.648C82.9558 244.026 82.1456 245.462 81.3353 246.896C81.0764 247.354 80.3193 247.023 80.5812 246.559Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M361.795 235.849C360.981 236.578 359.994 237.085 358.927 237.321C357.861 237.558 356.751 237.515 355.706 237.199C353.027 236.353 351.266 233.862 349.706 231.527L345.091 224.619L349.126 225.482C352.028 226.102 355.001 226.75 357.497 228.357C359.992 229.963 361.947 232.754 361.699 235.711",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M365.069 246.257C363.629 240.757 361.898 234.609 356.742 231.427C355.308 230.544 353.719 229.944 352.059 229.658C351.536 229.567 351.456 230.388 351.977 230.479C354.756 230.972 357.279 232.407 359.123 234.543C360.9 236.59 362.045 239.087 362.898 241.638C363.42 243.201 363.837 244.796 364.254 246.39C364.387 246.899 365.203 246.772 365.069 246.257Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M308.378 165.71H214.057C213.304 165.709 212.582 165.409 212.049 164.876C211.517 164.344 211.217 163.622 211.216 162.869V131.05C211.217 130.297 211.517 129.574 212.049 129.042C212.582 128.509 213.304 128.21 214.057 128.209H308.378C309.131 128.21 309.853 128.509 310.385 129.042C310.918 129.574 311.218 130.297 311.218 131.05V162.869C311.218 163.622 310.918 164.344 310.385 164.876C309.853 165.409 309.131 165.709 308.378 165.71Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M250.99 136.732H225.989V139.573H250.99V136.732Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M283.945 140.141C284.887 140.141 285.65 139.378 285.65 138.436C285.65 137.495 284.887 136.732 283.945 136.732C283.004 136.732 282.241 137.495 282.241 138.436C282.241 139.378 283.004 140.141 283.945 140.141Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M289.627 140.141C290.569 140.141 291.332 139.378 291.332 138.436C291.332 137.495 290.569 136.732 289.627 136.732C288.686 136.732 287.923 137.495 287.923 138.436C287.923 139.378 288.686 140.141 289.627 140.141Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M295.309 140.141C296.251 140.141 297.014 139.378 297.014 138.436C297.014 137.495 296.251 136.732 295.309 136.732C294.368 136.732 293.605 137.495 293.605 138.436C293.605 139.378 294.368 140.141 295.309 140.141Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M308.378 206.051H214.057C213.304 206.051 212.582 205.751 212.049 205.218C211.517 204.686 211.217 203.964 211.216 203.21V171.392C211.217 170.638 211.517 169.916 212.049 169.384C212.582 168.851 213.304 168.552 214.057 168.551H308.378C309.131 168.552 309.853 168.851 310.385 169.384C310.918 169.916 311.218 170.638 311.218 171.392V203.21C311.218 203.964 310.918 204.686 310.385 205.218C309.853 205.751 309.131 206.051 308.378 206.051Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M250.99 177.073H225.989V179.914H250.99V177.073Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M283.945 180.483C284.887 180.483 285.65 179.719 285.65 178.778C285.65 177.837 284.887 177.073 283.945 177.073C283.004 177.073 282.241 177.837 282.241 178.778C282.241 179.719 283.004 180.483 283.945 180.483Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M289.627 180.483C290.569 180.483 291.332 179.719 291.332 178.778C291.332 177.837 290.569 177.073 289.627 177.073C288.686 177.073 287.923 177.837 287.923 178.778C287.923 179.719 288.686 180.483 289.627 180.483Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M295.309 180.483C296.251 180.483 297.014 179.719 297.014 178.778C297.014 177.837 296.251 177.073 295.309 177.073C294.368 177.073 293.605 177.837 293.605 178.778C293.605 179.719 294.368 180.483 295.309 180.483Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M308.378 246.393H214.057C213.304 246.392 212.582 246.093 212.049 245.56C211.517 245.028 211.217 244.305 211.216 243.552V211.733C211.217 210.98 211.517 210.258 212.049 209.726C212.582 209.193 213.304 208.893 214.057 208.892H308.378C309.131 208.893 309.853 209.193 310.385 209.726C310.918 210.258 311.218 210.98 311.218 211.733V243.552C311.218 244.306 310.918 245.028 310.385 245.56C309.853 246.093 309.131 246.392 308.378 246.393Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M250.99 217.415H225.989V220.256H250.99V217.415Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M283.945 220.825C284.887 220.825 285.65 220.061 285.65 219.12C285.65 218.179 284.887 217.415 283.945 217.415C283.004 217.415 282.241 218.179 282.241 219.12C282.241 220.061 283.004 220.825 283.945 220.825Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M289.627 220.825C290.569 220.825 291.332 220.061 291.332 219.12C291.332 218.179 290.569 217.415 289.627 217.415C288.686 217.415 287.923 218.179 287.923 219.12C287.923 220.061 288.686 220.825 289.627 220.825Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M295.309 220.825C296.251 220.825 297.014 220.061 297.014 219.12C297.014 218.179 296.251 217.415 295.309 217.415C294.368 217.415 293.605 218.179 293.605 219.12C293.605 220.061 294.368 220.825 295.309 220.825Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M272.82 97.138L272.716 97.0609L272.713 97.059C272.579 96.9591 272.426 96.8866 272.263 96.8458C272.101 96.805 271.932 96.7966 271.766 96.8211C271.6 96.8455 271.441 96.9025 271.297 96.9885C271.153 97.0746 271.028 97.1881 270.928 97.3227L249.697 125.907H247.362V125.358C247.362 125.223 247.308 125.093 247.212 124.998C247.117 124.902 246.987 124.848 246.851 124.848H245.458C245.322 124.848 245.193 124.902 245.097 124.998C245.001 125.093 244.947 125.223 244.947 125.358V125.907H244.141V125.358C244.141 125.223 244.087 125.093 243.991 124.998C243.895 124.902 243.766 124.848 243.63 124.848H242.237C242.101 124.848 241.971 124.902 241.876 124.998C241.78 125.093 241.726 125.223 241.726 125.358V125.907H240.922V125.358C240.922 125.223 240.868 125.093 240.773 124.998C240.677 124.902 240.547 124.848 240.412 124.848H239.018C238.883 124.848 238.753 124.902 238.657 124.998C238.562 125.093 238.508 125.223 238.508 125.358V125.907H237.701V125.358C237.701 125.223 237.647 125.093 237.552 124.998C237.456 124.902 237.326 124.848 237.191 124.848H235.797C235.662 124.848 235.532 124.902 235.436 124.998C235.341 125.093 235.287 125.223 235.287 125.358V125.907H234.483V125.358C234.483 125.223 234.429 125.093 234.333 124.998C234.238 124.902 234.108 124.848 233.972 124.848H232.579C232.512 124.848 232.445 124.861 232.383 124.887C232.322 124.913 232.265 124.95 232.218 124.998C232.17 125.045 232.133 125.101 232.107 125.163C232.082 125.225 232.068 125.291 232.068 125.358V125.907H231.262V125.358C231.262 125.223 231.208 125.093 231.112 124.998C231.017 124.902 230.887 124.848 230.751 124.848H229.358C229.222 124.848 229.093 124.902 228.997 124.998C228.901 125.093 228.847 125.223 228.847 125.358V125.907H228.041V125.358C228.041 125.223 227.987 125.093 227.891 124.998C227.795 124.902 227.666 124.848 227.53 124.848H226.137C226.001 124.848 225.872 124.902 225.776 124.998C225.68 125.093 225.626 125.223 225.626 125.358V125.907H224.822V125.358C224.822 125.223 224.769 125.093 224.673 124.998C224.577 124.902 224.447 124.848 224.312 124.848H222.918C222.783 124.848 222.653 124.902 222.557 124.998C222.462 125.093 222.408 125.223 222.408 125.358V125.907H221.601V125.358C221.601 125.223 221.547 125.093 221.452 124.998C221.356 124.902 221.226 124.848 221.091 124.848H219.697C219.562 124.848 219.432 124.902 219.336 124.998C219.241 125.093 219.187 125.223 219.187 125.358V125.907H218.383V125.358C218.383 125.223 218.329 125.093 218.233 124.998C218.138 124.902 218.008 124.848 217.872 124.848H216.479C216.343 124.848 216.214 124.902 216.118 124.998C216.022 125.093 215.968 125.223 215.968 125.358V125.907H214.958C214.79 125.907 214.624 125.94 214.469 126.004C214.314 126.068 214.174 126.163 214.055 126.281C213.937 126.4 213.843 126.54 213.779 126.695C213.715 126.85 213.682 127.016 213.682 127.183V128.401C213.682 128.568 213.715 128.734 213.779 128.889C213.843 129.044 213.937 129.185 214.055 129.303C214.174 129.422 214.314 129.516 214.469 129.58C214.624 129.644 214.79 129.677 214.958 129.677H249.486C249.923 129.677 250.347 129.526 250.686 129.25C251.025 128.974 251.259 128.59 251.347 128.161L251.361 128.171L273.082 98.9259L273.084 98.9234C273.285 98.6516 273.371 98.3109 273.321 97.9761C273.272 97.6412 273.092 97.3398 272.82 97.138Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M138.647 235.554L142.936 237.749L153.442 222.251L147.113 219.011L138.647 235.554Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M138.27 233.594L146.716 237.916L146.716 237.916C148.144 238.647 149.222 239.915 149.715 241.441C150.208 242.967 150.074 244.626 149.344 246.054L149.254 246.228L135.425 239.151L138.27 233.594Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M188.18 241.558H192.998L195.29 222.975H188.18L188.18 241.558Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M186.952 239.985L196.44 239.985H196.44C198.043 239.985 199.581 240.622 200.715 241.756C201.849 242.89 202.486 244.428 202.486 246.031V246.228L186.952 246.229L186.952 239.985Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M165.645 89.982C165.645 89.982 162.419 87.5103 162.419 93.5478L161.909 113.499L167.597 132.347L170.909 126.235L169.55 112.99L165.645 89.982Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M200.156 144.553C200.156 144.553 203.897 162.773 199.158 177.725L196.54 235.213L186.937 234.465L183.57 191.816L180.328 170.616L173.594 189.946L151.397 230.849L141.171 222.867C141.171 222.867 152.503 191.948 160.874 185.456L165.073 137.636L200.156 144.553Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M198.381 59.926C201.281 54.6202 199.331 47.9678 194.025 45.0674C188.72 42.1671 182.067 44.117 179.167 49.4228C176.267 54.7285 178.217 61.3809 183.522 64.2813C188.828 67.1816 195.48 65.2317 198.381 59.926Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M384.327 247.035H47.831C47.7363 247.035 47.6456 246.997 47.5786 246.931C47.5117 246.864 47.4741 246.773 47.4741 246.678C47.4741 246.584 47.5117 246.493 47.5786 246.426C47.6456 246.359 47.7363 246.321 47.831 246.321H384.327C384.421 246.321 384.512 246.359 384.579 246.426C384.646 246.493 384.684 246.584 384.684 246.678C384.684 246.773 384.646 246.864 384.579 246.931C384.512 246.997 384.421 247.035 384.327 247.035Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M53.725 249.83C69.0705 249.83 81.5104 247.832 81.5104 245.367C81.5104 242.902 69.0705 240.904 53.725 240.904C38.3795 240.904 25.9396 242.902 25.9396 245.367C25.9396 247.832 38.3795 249.83 53.725 249.83Z",
    fill: "#E6EDF3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M54.6189 159.877H52.8311V200.132H54.6189V159.877Z",
    fill: "#535461"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M65.8551 200.01L65.7418 201.822L65.5845 204.381L65.5184 205.448L65.361 208.01L65.2917 209.077L65.1344 211.636L63.3309 240.74C63.254 241.993 62.7022 243.169 61.7881 244.029C60.874 244.888 59.6664 245.367 58.4115 245.367H49.0385C47.7839 245.367 46.5767 244.888 45.6631 244.028C44.7495 243.169 44.1984 241.993 44.1222 240.74L42.3093 211.636L42.1519 209.077L42.0858 208.01L41.9316 205.442L41.8655 204.375L41.7081 201.816L41.5948 200.003C41.5733 199.655 41.6233 199.307 41.7418 198.979C41.8602 198.651 42.0445 198.351 42.2834 198.097C42.5222 197.843 42.8106 197.641 43.1306 197.502C43.4507 197.364 43.7956 197.293 44.1442 197.293H63.3089C63.6579 197.293 64.0033 197.364 64.3236 197.503C64.644 197.642 64.9324 197.845 65.1711 198.099C65.4099 198.354 65.5937 198.655 65.7114 198.983C65.829 199.312 65.878 199.661 65.8551 200.01Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M65.7418 201.822L65.5844 204.381H41.8623L41.705 201.822H65.7418Z",
    fill: "#9D9CB5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M65.5183 205.448L65.3609 208.01H42.0889L41.9284 205.448H65.5183Z",
    fill: "#9D9CB5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M65.2918 209.077L65.1344 211.636H42.3156L42.1551 209.077H65.2918Z",
    fill: "#9D9CB5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M38.9762 174.965C49.3878 182.497 53.725 194.281 53.725 194.281C53.725 194.281 41.1762 193.85 30.7488 186.318C20.3214 178.786 16 167.002 16 167.002C16 167.002 28.5614 167.434 38.9762 174.965Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.0157 167.002C16.0157 167.002 29.0397 174.242 33.2163 180.222C37.393 186.202 53.7249 194.284 53.7249 194.284",
    stroke: "#535461",
    strokeWidth: "0.629484",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M45.6959 159.804C51.3612 163.896 53.7249 170.317 53.7249 170.317C53.7249 170.317 46.895 170.084 41.2265 165.983C35.558 161.882 33.2006 155.47 33.2006 155.47C33.2006 155.47 40.0305 155.688 45.6959 159.804Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33.2006 155.454C33.2006 155.454 40.2886 159.389 42.5611 162.646C44.8335 165.904 53.7249 170.301 53.7249 170.301",
    stroke: "#535461",
    strokeWidth: "0.629484",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M61.9618 169.977C55.4498 177.131 54.0744 186.479 54.0744 186.479C54.0744 186.479 63.2523 184.228 69.7611 177.074C76.27 169.92 77.6486 160.569 77.6486 160.569C77.6486 160.569 68.4707 162.819 61.9618 169.977Z",
    fill: "#084782"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M77.6486 160.569C77.6486 160.569 69.1694 167.902 67.0134 172.957C64.8575 178.012 54.0744 186.491 54.0744 186.491",
    stroke: "#535461",
    strokeWidth: "0.629484",
    "stroke-miterlimit": "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M187.999 56.9965C189.312 57.1673 190.302 55.8244 190.761 54.5831C191.22 53.3418 191.57 51.8967 192.711 51.2261C194.27 50.31 196.265 51.4118 198.047 51.1096C200.061 50.7683 201.37 48.6346 201.472 46.5951C201.575 44.5557 200.763 42.5941 199.967 40.7138L199.689 43.0506C199.726 42.2586 199.559 41.4703 199.205 40.7611C198.85 40.0519 198.32 39.4455 197.664 39L198.022 42.429C197.946 41.9559 197.777 41.5025 197.525 41.0949C197.273 40.6873 196.943 40.3334 196.554 40.0536C196.165 39.7738 195.725 39.5736 195.258 39.4644C194.791 39.3553 194.308 39.3394 193.835 39.4176L193.892 41.4607C191.566 41.1842 189.221 40.9073 186.888 41.1179C184.556 41.3286 182.208 42.0665 180.44 43.6024C177.796 45.9 176.83 49.6832 177.154 53.1711C177.478 56.6589 178.918 59.9355 180.419 63.1007C180.796 63.8971 181.319 64.7958 182.194 64.8972C182.981 64.9884 183.7 64.3308 183.945 63.5776C184.133 62.8048 184.126 61.9972 183.924 61.228C183.702 60.0523 183.424 58.8507 183.632 57.6727C183.84 56.4946 184.687 55.3305 185.875 55.1861C187.062 55.0418 188.277 56.3991 187.706 57.4504L187.999 56.9965Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M200.833 149.425L164.287 147.068L167.038 135.671L200.44 143.138L200.833 149.425Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M178.295 69.606L180.587 66.4235C180.587 66.4235 183.149 67.2942 190.011 70.7097L190.496 73.6915L202.407 146.95L180.757 146.016L174.861 145.891L172.932 141.566L170.553 145.799L164.796 145.677L158.938 142.281L164.711 124.622L166.579 108.49L163.692 93.2933C163.692 93.2933 160.06 79.338 174.05 71.8134L178.295 69.606Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M227.092 125.063C226.562 125.198 226.008 125.215 225.471 125.113C224.934 125.01 224.425 124.792 223.981 124.472C223.538 124.152 223.17 123.738 222.903 123.261C222.636 122.783 222.478 122.253 222.438 121.707L209.594 118.267L214.761 113.679L226.166 117.649C227.087 117.644 227.978 117.976 228.67 118.583C229.362 119.191 229.808 120.031 229.922 120.945C230.036 121.859 229.811 122.783 229.289 123.542C228.768 124.301 227.986 124.842 227.092 125.063V125.063Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M221.339 123.121C221.069 123.268 220.771 123.357 220.464 123.381C220.158 123.406 219.849 123.365 219.56 123.262L198.43 115.243C193.275 113.416 188.96 109.778 186.286 105.007L177.475 89.2892C176.856 88.5985 176.38 87.7926 176.073 86.9176C175.766 86.0426 175.635 85.1156 175.686 84.1898C175.738 83.264 175.972 82.3574 176.374 81.5221C176.777 80.6867 177.34 79.9389 178.032 79.3214C178.724 78.7039 179.53 78.2289 180.406 77.9236C181.281 77.6183 182.209 77.4886 183.134 77.542C184.06 77.5954 184.966 77.8308 185.801 78.2347C186.635 78.6387 187.382 79.2033 187.998 79.8962L203.249 104.069L222.443 115.321C222.819 115.568 223.11 115.925 223.277 116.342C223.444 116.76 223.479 117.219 223.377 117.657L222.422 121.702C222.32 122.135 222.087 122.528 221.756 122.826C221.629 122.94 221.489 123.04 221.339 123.121Z",
    fill: "#2F2E41"
  }));
};

var Icon$5 = function Icon() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    name: '',
    size: size,
    style: style,
    viewBox: viewBox
  };

  switch (props.name) {
    case 'theatre':
      return /*#__PURE__*/React__default.createElement(SVG$x, props);

    case 'movie':
      return /*#__PURE__*/React__default.createElement(SVG$w, props);

    case 'search':
      return /*#__PURE__*/React__default.createElement(SVG$i, props);

    case 'calendar':
      return /*#__PURE__*/React__default.createElement(SVG$v, props);

    case 'calendarNew':
      return /*#__PURE__*/React__default.createElement(SVG$u, props);

    case 'clock':
      return /*#__PURE__*/React__default.createElement(SVG$t, props);

    case 'SelectedFull':
      return /*#__PURE__*/React__default.createElement(SVG$s, props);

    case 'SelectedEmpty':
      return /*#__PURE__*/React__default.createElement(SVG$q, props);

    case 'AssestError':
      return /*#__PURE__*/React__default.createElement(SVG$p, props);

    case 'SelectedPartial':
      return /*#__PURE__*/React__default.createElement(SVG$r, props);

    case 'ListEdit':
      return /*#__PURE__*/React__default.createElement(SVG$o, props);

    case 'edit':
      return /*#__PURE__*/React__default.createElement(SVG$n, props);

    case 'audio':
      return /*#__PURE__*/React__default.createElement(SVG$m, props);

    case 'subtitle':
      return /*#__PURE__*/React__default.createElement(SVG$l, props);

    case 'captions':
      return /*#__PURE__*/React__default.createElement(SVG$k, props);

    case 'certifications':
      return /*#__PURE__*/React__default.createElement(SVG$j, props);

    case 'search':
      return /*#__PURE__*/React__default.createElement(SVG$i, props);

    case 'downloadProgress':
      return /*#__PURE__*/React__default.createElement(SVG$g, props);

    case 'download':
      return /*#__PURE__*/React__default.createElement(SVG$h, props);

    case 'drive':
      return /*#__PURE__*/React__default.createElement(SVG$f, props);

    case 'email':
      return /*#__PURE__*/React__default.createElement(SVG$e, props);

    case 'loading':
      return /*#__PURE__*/React__default.createElement(SVG$d, props);

    case 'SquareEmpty':
      return /*#__PURE__*/React__default.createElement(SVG$c, props);

    case 'SquareHalfFilled':
      return /*#__PURE__*/React__default.createElement(SVG$b, props);

    case 'SquareFilled':
      return /*#__PURE__*/React__default.createElement(SVG$a, props);

    case 'satellite':
      return /*#__PURE__*/React__default.createElement(SVG$9, props);

    case 'ChevronDown':
      return /*#__PURE__*/React__default.createElement(SVG$8, props);

    case 'ChevronRight':
      return /*#__PURE__*/React__default.createElement(SVG$7, props);

    case 'ChevronLeft':
      return /*#__PURE__*/React__default.createElement(SVG$6, props);

    case 'InfoCircle':
      return /*#__PURE__*/React__default.createElement(SVG$5, props);

    case 'Filter':
      return /*#__PURE__*/React__default.createElement(SVG$4, props);

    case 'WireTap':
      return /*#__PURE__*/React__default.createElement(SVG$3, props);

    case 'PageNotFound':
      return /*#__PURE__*/React__default.createElement(SVG$1, props);

    case 'Maintenance':
      return /*#__PURE__*/React__default.createElement(SVG, props);

    case 'ApplianceDownload':
      return /*#__PURE__*/React__default.createElement(SVG$2, props);

    default:
      return /*#__PURE__*/React__default.createElement("div", null);
  }
};

var AppIcon = function AppIcon(_ref) {
  var color = _ref.color,
      name = _ref.name,
      size = _ref.size,
      style = _ref.style,
      filledColor = _ref.filledColor;
  return /*#__PURE__*/React__default.createElement(Icon$5, {
    name: name,
    size: size,
    color: color,
    style: style,
    filledColor: filledColor
  });
};

AppIcon.defaultProps = {
  name: 'theatre',
  size: 24,
  color: '',
  style: {}
};

var SelectButton = function SelectButton(_ref) {
  var clickEvent = _ref.clickEvent,
      text = _ref.text,
      type = _ref.type;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "button-primary select-button",
    onClick: clickEvent && clickEvent
  }, type && /*#__PURE__*/React__default.createElement("span", {
    className: "icon-style"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: type,
    color: "white",
    size: 18
  })), text && /*#__PURE__*/React__default.createElement("span", {
    className: "button-text-style"
  }, text));
};

SelectButton.defaultProps = {
  clickEvent: function clickEvent() {},
  type: 'theatre',
  text: ''
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _extends$2 = /*@__PURE__*/getDefaultExportFromCjs(_extends_1);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _objectWithoutProperties$2 = /*@__PURE__*/getDefaultExportFromCjs(objectWithoutProperties);

var _excluded$9 = ["percent", "showInfo"];

var ProgressBar = function ProgressBar(props) {
  var percent = props.percent,
      showInfo = props.showInfo,
      otherProps = _objectWithoutProperties$2(props, _excluded$9);

  return /*#__PURE__*/React__default.createElement(_Progress, _extends$2({
    percent: percent,
    status: "active",
    showInfo: showInfo
  }, otherProps));
};

ProgressBar.defaultProps = {
  percent: 0,
  showInfo: false
};

var BaseButton = function BaseButton(props) {
  return /*#__PURE__*/React__default.createElement(BaseButton$1, props);
};

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _classCallCheck$2 = /*@__PURE__*/getDefaultExportFromCjs(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _createClass$2 = /*@__PURE__*/getDefaultExportFromCjs(createClass);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var inherits = createCommonjsModule(function (module) {
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _inherits$2 = /*@__PURE__*/getDefaultExportFromCjs(inherits);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _possibleConstructorReturn$2 = /*@__PURE__*/getDefaultExportFromCjs(possibleConstructorReturn);

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _getPrototypeOf$1 = /*@__PURE__*/getDefaultExportFromCjs(getPrototypeOf);

function _createSuper$Z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$Z(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _isNativeReflectConstruct$Z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MultiEmailInput = /*#__PURE__*/function (_React$Component) {
  _inherits$2(MultiEmailInput, _React$Component);

  var _super = _createSuper$Z(MultiEmailInput);

  function MultiEmailInput() {
    _classCallCheck$2(this, MultiEmailInput);

    return _super.apply(this, arguments);
  }

  _createClass$2(MultiEmailInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(ReactMultiEmail, {
        onChange: this.props.onChange,
        emails: this.props.emails,
        placeholder: this.props.placeholder,
        validateEmail: function validateEmail(email) {
          return isEmail(email);
        },
        getLabel: function getLabel(email, index, removeEmail) {
          return /*#__PURE__*/React__default.createElement("div", {
            "data-tag": true,
            key: index
          }, email, /*#__PURE__*/React__default.createElement("span", {
            "data-tag-handle": true,
            onClick: function onClick() {
              return removeEmail(index);
            }
          }, "\xD7"));
        }
      });
    }
  }]);

  return MultiEmailInput;
}(React__default.Component);

var PageHeading = function PageHeading(props) {
  return /*#__PURE__*/React__default.createElement("h2", {
    className: "page-heading ".concat(props.noCapitalize ? "" : "capitalize")
  }, props.content);
};

var SectionHeading = function SectionHeading(props) {
  return /*#__PURE__*/React__default.createElement("h4", {
    className: props.size ? "section-heading ".concat(props.size) : 'section-heading'
  }, props.content);
};

SectionHeading.defaultProps = {
  size: 'default'
};

var WarnHeading = function WarnHeading(props) {
  return /*#__PURE__*/React__default.createElement("h5", {
    className: "warn-heading"
  }, props.content);
};

var TheatreName = function TheatreName(props) {
  return /*#__PURE__*/React__default.createElement("h2", {
    className: "theatre-name ".concat(props.capitalize ? "capitalize" : "")
  }, props.name);
};

var Header$1 = function Header(props) {
  return /*#__PURE__*/React__default.createElement(Header$2, props);
};

var Selector = function Selector(props) {
  return /*#__PURE__*/React__default.createElement(Selector$1, props);
};

var InputLabel = function InputLabel(props) {
  return /*#__PURE__*/React__default.createElement("label", {
    className: "input-label"
  }, props.content);
};

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray$1 = /*@__PURE__*/getDefaultExportFromCjs(slicedToArray);

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && ('object' !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            commonjsRequire('./locale/' + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));
});

var _excluded$8 = ["type", "error", "className", "value", "format", "preset", "startDate", "endDate", "withTime", "placeholder", "onChange"];
var presetRangeValueMap = {
  'Past 1 week': [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
  'Past 2 weeks': [moment().subtract(14, 'days').startOf('day'), moment().endOf('day')],
  'This month': [moment().startOf('month').startOf('day'), moment().endOf('day')],
  'Past 1 month': [moment().subtract(1, 'months').startOf('day'), moment().endOf('day')],
  'Past 3 months': [moment().subtract(3, 'months').startOf('day'), moment().endOf('day')],
  'Past 6 months': [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')],
  'Past 1 year': [moment().subtract(1, 'years').startOf('day'), moment().endOf('day')],
  'Past 5 years': [moment().subtract(5, 'years').startOf('day'), moment().endOf('day')],
  Max: [moment('1 Jan 1970'), moment().endOf('day')]
};
/**
 *
 * @typedef {DateTimeInputProps} props
 * @param {RangePresetValues} props.preset - (Optional) Provide a array of predefined date range values as string.
 * @param {DateTimeInputProps.type} props.type - Type of date/time picker to render
 * @param {boolean} props.error - (Optional) If true, will render with error styles
 * @param {string} props.format - (Optional) Native Date/Time string format to display. Default DD MMM YYYY hh:mm:ss A
 * @returns
 */

var DateTimeInput = function DateTimeInput(_ref) {
  var type = _ref.type,
      error = _ref.error,
      className = _ref.className,
      value = _ref.value,
      _ref$format = _ref.format,
      _format = _ref$format === void 0 ? 'DD MMM YYYY hh:mm:ss A' : _ref$format,
      preset = _ref.preset,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      withTime = _ref.withTime;
      _ref.placeholder;
      var onChange = _ref.onChange,
      rest = _objectWithoutProperties$2(_ref, _excluded$8);

  var pickerValue = value ? moment(value) : null;
  var classes = classNames$1({
    'lib-date-time-input': true,
    'has-error': error
  }, className);

  switch (type) {
    case 'date':
      return /*#__PURE__*/React__default.createElement(_DatePicker, _extends$2({
        suffixIcon: /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "calendarNew"
        }),
        className: classes,
        value: pickerValue,
        format: _format,
        onChange: onChange
      }, rest));

    case 'time':
      return /*#__PURE__*/React__default.createElement(_TimePicker, _extends$2({
        suffixIcon: /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "clock"
        }),
        className: classes,
        value: pickerValue,
        format: _format,
        onChange: onChange
      }, rest));

    case 'date-time':
      return /*#__PURE__*/React__default.createElement(_DatePicker, _extends$2({
        showTime: true,
        suffixIcon: /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "calendarNew"
        }),
        className: classes,
        value: pickerValue,
        format: _format,
        onChange: onChange
      }, rest));

    case 'range':
      return /*#__PURE__*/React__default.createElement(_DatePicker.RangePicker, _extends$2({
        suffixIcon: /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "calendarNew"
        }),
        className: classes,
        dropdownClassName: "lib-date-time-picker".concat(withTime ? ' time-picker-enabled' : '').concat(preset ? ' preset-enabled' : ''),
        format: function format(m) {
          return m <= moment('1 Jan 1970') ? 'Maximum' : m.format(_format);
        } // format
        ,
        showTime: withTime,
        value: [startDate, endDate],
        separator: "-",
        ranges: preset === null || preset === void 0 ? void 0 : preset.reduce(function (acc, value) {
          if (typeof value === 'string') {
            acc[value] = presetRangeValueMap[value];
          } else {
            Object.entries(value).forEach(function (_ref2) {
              var _ref3 = _slicedToArray$1(_ref2, 2),
                  k = _ref3[0],
                  val = _ref3[1];

              acc[k] = val;
            });
          }

          return acc;
        }, {}),
        renderExtraFooter: withTime ? function () {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "time-picker-footer"
          });
        } : undefined,
        onChange: onChange
      }, rest));
  }
};

var HelpText = function HelpText(props) {
  return /*#__PURE__*/React__default.createElement("p", {
    className: props.isErrorMessage ? 'help-txt error-txt' : 'help-txt'
  }, props.content, ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "bold-txt"
  }, props.boldcontent));
};

var TheatreAddress = function TheatreAddress(props) {
  return /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-address"
  }, props.address);
};

var TheatrePrice = function TheatrePrice(props) {
  return /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-price"
  }, " ", props.price ? "USD ".concat(props.price) : '');
};

var Title = function Title(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-title-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var Description = function Description(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-description-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var Label = function Label(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-label-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var SelectText = function SelectText(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: props.clickEvent && props.clickEvent,
    className: "qw-select-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var HeaderText = function HeaderText(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-header-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var TheatreId = function TheatreId(props) {
  return props.domain && props.id ? /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-id"
  }, props.domain.toUpperCase(), ": ", props.id) : props.id ? /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-id"
  }, "Theatre ID: ", props.id) : null;
};

var DefaultDatePicker = function DefaultDatePicker(_ref) {
  var size = _ref.size,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      disabledDate = _ref.disabledDate,
      format = _ref.format,
      value = _ref.value;
  return /*#__PURE__*/React__default.createElement(_DatePicker, {
    className: 'date-picker',
    size: size,
    onChange: onChange,
    disabledDate: disabledDate,
    format: format,
    value: value,
    placeholder: placeholder
  });
};

DefaultDatePicker.defaultProps = {
  size: 'default',
  disabledDate: function disabledDate() {
    return false;
  }
};

var add$6="Add";var addAccess$6="Add Access";var addAnotherRole$6="Add another role";var addToList$6="Add to List";var addToNewList$6="Add to New List";var address$6="Address";var advertisement$6="Advertisement";var alternateNames$6="Alternate Names";var applianceBusyInDuplicating$6="This appliance is busy in duplicating work order ";var aspectRatio$6="Aspect Ratio";var audio$6="Audio";var audioFormat$6="Audio Format";var available="Available";var back$6="Back";var bandwidth$6="Bandwidth";var booking$6="Booking";var cancel$8="Cancel";var cancelled$6="Cancelled";var cancelledCount$6="{{itemCount}} Cancelled";var chain$6="Chain";var clear$6="Clear";var clearAll$6="Clear All";var clearTheatreSelection$6="Clear theatre selection";var clearTheatreSelectionConfirmation$6="Are you sure you want to clear the selection?";var closedCaptions$6="Closed Captions";var closedSubtitles$6="Closed Subtitles";var comments$6="Comments";var companyTheatreLocation$6="Company/Theatre/Location";var composition$6="Composition";var compositionDetails$6="Composition Details";var compositionTags$6="Composition Tags";var compositions$6="Compositions";var contentIsLessThan8GBWarning$6="This content is less than 8GB and could be sent via smaller, more cost effective media (ie. USB stick/thumb drive)";var contentIsLessThan8GBWarningContent$6="If this work order will be fulfilled using alternative media, please remember to update your drive inventory accordingly.";var contentSize$6="Content Size";var conventionLink$6="Data from Composition name based on the <1>Digital Cinema Naming Convention</1>";var copiedCount$6="{{itemCount}} Copied";var copyCompleted$6="Copy Completed";var copyFailed$6="Copy Failed";var copyPending$6="Copy Pending";var copyQueued$6="Copy Queued";var copyStatus$6="Copy Status";var courierType$6="Courier Type";var cplAvailability="CPL Availability";var cplFormat$6="CPL Format";var cplId$6="CPL ID";var cplMarkers$6="CPL Markers";var cplMetadata$6="CPL Metadata";var create$7="Create";var createModal$6="Create Modal";var createTag$6="Create Tag";var createdBy$6="Created By";var createdOn$6="Created On";var creditOffset$6="Credit Offset";var creditsOffset$6="Credits Offset";var creditsValue$6="Credits: {{value}}";var csvColumnsForTheatreSelect$6="CSV Columns: Screen ID, Theatre ID, Name, City, State, Country, Area, Chain Name";var dcp$6="DCP";var dcpSize="DCP Size";var dcpStatus$6="DCP Status";var dcpTransferCompleted$6="DCP transfer completed";var dcpTransferNotStarted$6="DCP transfer not started";var dcpTransferStarted$6="DCP transfer started";var deactivatedUser$6="Deactivated User";var deleteList$6="Delete List";var deleteListConfirmation$6="Are you sure you want to delete this list?";var deliverBefore$6="Deliver before";var deliverBy$6="Deliver By";var deliveries$6="Deliveries";var delivery$6="Delivery";var deliveryInstructions$6="Delivery Instructions";var download$6="Download";var downloadCompleted$6="Download Completed";var downloadDetails$6="Download Details";var downloadFailed$6="Download Failed";var downloadKdms$6="Download KDMs";var downloadNotStarted$6="Download not started";var downloadPending$6="Download Pending";var downloadQueued$6="Download Queued";var downloadScheduled$6="Download Scheduled";var downloadShipmentInformation$6="Download Shipment Information";var downloadStatus$6="Download Status";var downloadYetToStart$6="Download Yet to Start";var downloaded$6="Downloaded";var downloadedOn="Downloaded On";var downloading$6="Downloading";var downloadingArchived$6="Downloading - Archived";var downloadingPercentage$6="Downloading {{percentage}} %";var downloadingStalled$6="Downloading - Stalled";var downloadingUnarchiving$6="Downloading - Unarchiving";var driveCopy$6="Drive Copy";var driveNotHaveContent$6="Drive does not have any content";var drivesCount_one$6="{{count}} drive";var drivesCount_other$6="{{count}} drives";var duplicateRowWasIgnored_one$6="{{count}} Duplicate row was ignored";var duplicateRowWasIgnored_other$6="{{count}} Duplicate rows were ignored";var duplicatingWoInBay$6="Duplicating {{workOrderNo}} in Bay";var duplicationStatus$6="Duplication Status";var duration$6="Duration";var editTag$6="Edit Tag";var editTheatreList$6="Edit Theatre List";var email$6="Email";var emailKDMS$6="Email KDMs";var enterNameOfList$6="Enter Name of List";var enterNameOfNewList$6="Enter Name of New List";var enterTagName$6="Enter Tag Name";var enterTrackingNumber$6="Enter tracking number";var errorFetchingDownloadStatus$6="Error Fetching Download Status";var errorGettingTheatre$6="Error in Getting Theatre";var errorWhileAddingGroup$6="Error while adding group";var errorWhileUpdatingGroup$6="Error while updating group";var festivals$6="Festivals";var fetchingDetailsPleaseWait$6="Fetching details. Please wait";var ffec$6="FFEC";var ffmc$6="FFMC";var filterBy$6="Filter By";var filterByComposition="Filter By Composition";var firstFrameEndCredits$6="First Frame End Credits";var firstFrameMovingCredits$6="First Frame Moving Credits";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one$6="Following duplicate row that matched the screen is ignored";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other$6="Following {{count}} duplicate rows that matched the screen are ignored";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$6="Following duplicate row that matched the theatre is ignored";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$6="Following {{count}} duplicate rows that matched the theatre are ignored";var format$6="Format";var frameRate$6="Frame Rate";var from$6="From";var fromTimeOfBooking$6="from the time of booking";var group$6="Group";var groupAddedToUser$6="Group added to the user";var groupUpdatedForUser$6="Group has been updated for the user";var hasAccessTo$6="Has Access To";var hourCount_one$6="{{count}} Hour";var hourCount_other$6="{{count}} Hours";var id_one$6="ID";var id_other$6="IDs";var inProgressCount$6="{{itemCount}} In Progress";var inactiveScreen$6="Inactive Screen";var ingestStatus="Ingest Status";var ingestedOn="Ingested On";var insertedDrivesCount$6="{{itemCount}} drive(s) inserted.";var invalidFileNoTheatreNameOrId$6="Invalid File. There is no Theatre name or ID";var invitedUser$6="Invited User";var kdm$6="KDM";var kdmDetails$6="KDM Details";var languages$6="Languages";var lastUpdatedBy$6="Last Updated By";var lastUpdatedOn$6="Last Updated On";var listName$6="List Name";var listUpdated$6="List Updated";var lists$6="Lists";var location$6="Location";var mainCaptions$6="Main Captions";var maintenance$6="Maintenance";var maintenanceDescription$6="Qube Wire is currently under maintenance. We will be back shortly.";var manage$6="Manage";var markAsDelivered$6="Mark as Delivered";var markAsPending$6="Mark as Pending";var markAsShipped$6="Mark as Shipped";var minuteCount_one$6="{{count}} Minute";var minuteCount_other$6="{{count}} Minutes";var name$6="Name";var no$6="No";var noAccess$6="No Access";var noActiveDeviceInScreen$6="Screen does not have an active device";var noAppliancesFound$6="No appliances found";var noCompositions$6="No Compositions";var noItemTypeInWorkOrderFound$6="No {{type}} work orders found";var noKeepList$6="No, Keep the list";var noKeepSelection$6="No, Keep the selection";var noListsFound$6="No lists found";var noPlyDeviceInScreen$6="Screen does not have a playback device";var noRecordsfound$6="No records found";var noResultsFound$6="No results found";var noTagsFoundClickHereToCreateOne$6="No Tags Found. Click <1>here</1> to create one";var noTheatresAreSelected$6="No theatres are selected";var noTheatresFound$6="No theatres found";var none$6="None";var notAvailable="Not Available";var notFound$6="Not Found";var notes$6="Notes";var oops$6="Oops!";var osVersion$6="OS Version";var partner$6="Partner";var pendingCancellation$6="Pending Cancellation";var pendingCancellationCount$6="{{itemCount}} Pending Cancellation";var pendingCount$6="{{itemCount}} Pending";var picture$6="Picture";var preciseMatchForTheatresNotFound$6="A precise match for these theatres could not be found.";var preparingToCopy$6="Preparing to copy";var publicIp$6="Public IP";var ratings$6="Ratings";var rejected$6="Rejected";var rejectedCount$6="{{itemCount}} Rejected";var resolution$6="Resolution";var resultsFor$6="Results for";var role$6="Role";var roles$6="Roles";var rowMatchedCount_one$6="{{count}} row matched";var rowMatchedCount_other$6="{{count}} rows matched";var rowWithoutNameAndIdIgnored_one$6="{{count}} row without name and ID was ignored";var rowWithoutNameAndIdIgnored_other$6="{{count}} rows without name and ID were ignored";var save$6="Save";var screen$6="Screen";var screenCount_one$6="{{count}} Screen";var screenCount_other$6="{{count}} Screens";var screenNonDciComplaints$6="Screen does not have a dci complaints";var screenNotHaveCertificate$6="Screen does not have a device certificate";var screens$6="Screens";var search$6="Search";var searchAndAddTags$6="Search & Add Tags";var searchAndSelectTheatres$6="Search and Select Theatres";var searchByComposition="Search by Composition";var searchForTheatreList$6="Search for theatre list";var searchForTheatres$6="Search for theatres";var selectCourierType$6="Select courier type";var selectDcpTransferStatus$6="Select DCP Transfer Status";var selectOption$6="Select Option";var selectTheatreCount_one$6="Select {{count}} Theatre";var selectTheatreCount_other$6="Select {{count}} Theatres";var selectTheatres$6="Select Theatres";var selectUsingCsv$6="Select using CSV";var selectedTheatres$6="Selected Theatres";var serialNumber$6="Serial No";var shipBy$6="Ship By";var shipmentNo$6="Shipment Number";var shipmentStatus$6="Shipment Status";var shipped$6="Shipped";var shipping$6="Shipping";var shippingInformation$6="Shipping Information";var someErrorInGettingDownloadStatus$6="Some error in getting download status";var someScreensHaveMissingDeviceInformation$6="Some screens have missing device information";var somethingWentWrong="Something went wrong!";var spokenLanguage$6="Spoken Language";var stageCopyingContentToDrives$6="Step 2 of 3: Copying content to drives";var stageFormattingDrives$6="Step 1 of 3: Formatting drives";var stageVerifying$6="Step 3 of 3: Verifying";var startCopying$6="Start Copying";var status$6="Status";var submit$6="Submit";var subtitleLanguage$6="Subtitle Language";var tagName$6="Tag Name";var tagNameLessThan50Char$6="Tag name should be less than 50 characters";var tags$6="Tags";var theatre$6="Theatre";var theatreAlreadySelectedInList$6="This theatre is already selected in the list.";var theatreCountMatched_one$6="{{count}} Theatre matched";var theatreCountMatched_other$6="{{count}} Theatres matched";var theatreCount_one$6="{{count}} Theatre";var theatreCount_other$6="{{count}} Theatres";var theatreDetails$6="Theatre Details";var theatreListNameAlreadyExists$6="Theatre list name already exists";var theatreName$6="Theatre Name";var theatres$6="Theatres";var theatresListCreated$6="Theatres list created";var theatresListDeleted$6="Theatres list deleted";var theatresListUpdated$6="Theatres list updated";var thisPageDoesNotExist$6="This page does not exist.";var to$6="To";var totalDriveCount_one$6="{{count}} Drive";var totalDriveCount_other$6="{{count}} Drives";var trackingNumber$6="Tracking Number";var transitional$6="Transitional";var type$6="Type";var unarchivalMayTake$6="Unarchival may take";var unknown$6="Unknown";var update$6="Update";var updateAccess$6="Update Access";var updateDelivery$6="Update Delivery";var uploadShipmentInformation$6="Upload Shipment Information";var uploadingCsv$6="Uploading CSV";var users$6="Users";var view$6="View";var viewDetails$6="View Details";var viewMore$6="View More";var workorder$6="Work Order";var yes$6="Yes";var yesClear$6="Yes, Clear";var yesDelete$6="Yes, Delete";var onTheCloud="On the Cloud";var archived="Archived";var uploading="Uploading";var missingAssets="Missing Assets";var filmFestivals="Film Festivals";var searchFilmFestival="Search Film Festival";var en = {add:add$6,addAccess:addAccess$6,addAnotherRole:addAnotherRole$6,addToList:addToList$6,addToNewList:addToNewList$6,address:address$6,advertisement:advertisement$6,alternateNames:alternateNames$6,applianceBusyInDuplicating:applianceBusyInDuplicating$6,aspectRatio:aspectRatio$6,audio:audio$6,audioFormat:audioFormat$6,available:available,back:back$6,bandwidth:bandwidth$6,booking:booking$6,cancel:cancel$8,cancelled:cancelled$6,cancelledCount:cancelledCount$6,chain:chain$6,clear:clear$6,clearAll:clearAll$6,clearTheatreSelection:clearTheatreSelection$6,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation$6,closedCaptions:closedCaptions$6,closedSubtitles:closedSubtitles$6,comments:comments$6,companyTheatreLocation:companyTheatreLocation$6,composition:composition$6,compositionDetails:compositionDetails$6,compositionTags:compositionTags$6,compositions:compositions$6,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning$6,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent$6,contentSize:contentSize$6,conventionLink:conventionLink$6,copiedCount:copiedCount$6,copyCompleted:copyCompleted$6,copyFailed:copyFailed$6,copyPending:copyPending$6,copyQueued:copyQueued$6,copyStatus:copyStatus$6,courierType:courierType$6,cplAvailability:cplAvailability,cplFormat:cplFormat$6,cplId:cplId$6,cplMarkers:cplMarkers$6,cplMetadata:cplMetadata$6,create:create$7,createModal:createModal$6,createTag:createTag$6,createdBy:createdBy$6,createdOn:createdOn$6,creditOffset:creditOffset$6,creditsOffset:creditsOffset$6,creditsValue:creditsValue$6,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect$6,dcp:dcp$6,dcpSize:dcpSize,dcpStatus:dcpStatus$6,dcpTransferCompleted:dcpTransferCompleted$6,dcpTransferNotStarted:dcpTransferNotStarted$6,dcpTransferStarted:dcpTransferStarted$6,deactivatedUser:deactivatedUser$6,"delete":"Delete",deleteList:deleteList$6,deleteListConfirmation:deleteListConfirmation$6,deliverBefore:deliverBefore$6,deliverBy:deliverBy$6,deliveries:deliveries$6,delivery:delivery$6,deliveryInstructions:deliveryInstructions$6,download:download$6,downloadCompleted:downloadCompleted$6,downloadDetails:downloadDetails$6,downloadFailed:downloadFailed$6,downloadKdms:downloadKdms$6,downloadNotStarted:downloadNotStarted$6,downloadPending:downloadPending$6,downloadQueued:downloadQueued$6,downloadScheduled:downloadScheduled$6,downloadShipmentInformation:downloadShipmentInformation$6,downloadStatus:downloadStatus$6,downloadYetToStart:downloadYetToStart$6,downloaded:downloaded$6,downloadedOn:downloadedOn,downloading:downloading$6,downloadingArchived:downloadingArchived$6,downloadingPercentage:downloadingPercentage$6,downloadingStalled:downloadingStalled$6,downloadingUnarchiving:downloadingUnarchiving$6,driveCopy:driveCopy$6,driveNotHaveContent:driveNotHaveContent$6,drivesCount_one:drivesCount_one$6,drivesCount_other:drivesCount_other$6,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one$6,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other$6,duplicatingWoInBay:duplicatingWoInBay$6,duplicationStatus:duplicationStatus$6,duration:duration$6,editTag:editTag$6,editTheatreList:editTheatreList$6,email:email$6,emailKDMS:emailKDMS$6,enterNameOfList:enterNameOfList$6,enterNameOfNewList:enterNameOfNewList$6,enterTagName:enterTagName$6,enterTrackingNumber:enterTrackingNumber$6,errorFetchingDownloadStatus:errorFetchingDownloadStatus$6,errorGettingTheatre:errorGettingTheatre$6,errorWhileAddingGroup:errorWhileAddingGroup$6,errorWhileUpdatingGroup:errorWhileUpdatingGroup$6,festivals:festivals$6,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait$6,ffec:ffec$6,ffmc:ffmc$6,filterBy:filterBy$6,filterByComposition:filterByComposition,firstFrameEndCredits:firstFrameEndCredits$6,firstFrameMovingCredits:firstFrameMovingCredits$6,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one$6,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other$6,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$6,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$6,format:format$6,frameRate:frameRate$6,from:from$6,fromTimeOfBooking:fromTimeOfBooking$6,group:group$6,groupAddedToUser:groupAddedToUser$6,groupUpdatedForUser:groupUpdatedForUser$6,hasAccessTo:hasAccessTo$6,hourCount_one:hourCount_one$6,hourCount_other:hourCount_other$6,id_one:id_one$6,id_other:id_other$6,inProgressCount:inProgressCount$6,inactiveScreen:inactiveScreen$6,ingestStatus:ingestStatus,ingestedOn:ingestedOn,insertedDrivesCount:insertedDrivesCount$6,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId$6,invitedUser:invitedUser$6,kdm:kdm$6,kdmDetails:kdmDetails$6,languages:languages$6,lastUpdatedBy:lastUpdatedBy$6,lastUpdatedOn:lastUpdatedOn$6,listName:listName$6,listUpdated:listUpdated$6,lists:lists$6,location:location$6,mainCaptions:mainCaptions$6,maintenance:maintenance$6,maintenanceDescription:maintenanceDescription$6,manage:manage$6,markAsDelivered:markAsDelivered$6,markAsPending:markAsPending$6,markAsShipped:markAsShipped$6,minuteCount_one:minuteCount_one$6,minuteCount_other:minuteCount_other$6,name:name$6,no:no$6,noAccess:noAccess$6,noActiveDeviceInScreen:noActiveDeviceInScreen$6,noAppliancesFound:noAppliancesFound$6,noCompositions:noCompositions$6,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound$6,noKeepList:noKeepList$6,noKeepSelection:noKeepSelection$6,noListsFound:noListsFound$6,noPlyDeviceInScreen:noPlyDeviceInScreen$6,noRecordsfound:noRecordsfound$6,noResultsFound:noResultsFound$6,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne$6,noTheatresAreSelected:noTheatresAreSelected$6,noTheatresFound:noTheatresFound$6,none:none$6,notAvailable:notAvailable,notFound:notFound$6,notes:notes$6,oops:oops$6,osVersion:osVersion$6,partner:partner$6,pendingCancellation:pendingCancellation$6,pendingCancellationCount:pendingCancellationCount$6,pendingCount:pendingCount$6,picture:picture$6,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound$6,preparingToCopy:preparingToCopy$6,publicIp:publicIp$6,ratings:ratings$6,rejected:rejected$6,rejectedCount:rejectedCount$6,resolution:resolution$6,resultsFor:resultsFor$6,"return":"Return",role:role$6,roles:roles$6,rowMatchedCount_one:rowMatchedCount_one$6,rowMatchedCount_other:rowMatchedCount_other$6,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one$6,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other$6,save:save$6,screen:screen$6,screenCount_one:screenCount_one$6,screenCount_other:screenCount_other$6,screenNonDciComplaints:screenNonDciComplaints$6,screenNotHaveCertificate:screenNotHaveCertificate$6,screens:screens$6,search:search$6,searchAndAddTags:searchAndAddTags$6,searchAndSelectTheatres:searchAndSelectTheatres$6,searchByComposition:searchByComposition,searchForTheatreList:searchForTheatreList$6,searchForTheatres:searchForTheatres$6,selectCourierType:selectCourierType$6,selectDcpTransferStatus:selectDcpTransferStatus$6,selectOption:selectOption$6,selectTheatreCount_one:selectTheatreCount_one$6,selectTheatreCount_other:selectTheatreCount_other$6,selectTheatres:selectTheatres$6,selectUsingCsv:selectUsingCsv$6,selectedTheatres:selectedTheatres$6,serialNumber:serialNumber$6,shipBy:shipBy$6,shipmentNo:shipmentNo$6,shipmentStatus:shipmentStatus$6,shipped:shipped$6,shipping:shipping$6,shippingInformation:shippingInformation$6,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus$6,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation$6,somethingWentWrong:somethingWentWrong,spokenLanguage:spokenLanguage$6,stageCopyingContentToDrives:stageCopyingContentToDrives$6,stageFormattingDrives:stageFormattingDrives$6,stageVerifying:stageVerifying$6,startCopying:startCopying$6,status:status$6,submit:submit$6,subtitleLanguage:subtitleLanguage$6,tagName:tagName$6,tagNameLessThan50Char:tagNameLessThan50Char$6,tags:tags$6,theatre:theatre$6,theatreAlreadySelectedInList:theatreAlreadySelectedInList$6,theatreCountMatched_one:theatreCountMatched_one$6,theatreCountMatched_other:theatreCountMatched_other$6,theatreCount_one:theatreCount_one$6,theatreCount_other:theatreCount_other$6,theatreDetails:theatreDetails$6,theatreListNameAlreadyExists:theatreListNameAlreadyExists$6,theatreName:theatreName$6,theatres:theatres$6,theatresListCreated:theatresListCreated$6,theatresListDeleted:theatresListDeleted$6,theatresListUpdated:theatresListUpdated$6,thisPageDoesNotExist:thisPageDoesNotExist$6,to:to$6,totalDriveCount_one:totalDriveCount_one$6,totalDriveCount_other:totalDriveCount_other$6,trackingNumber:trackingNumber$6,transitional:transitional$6,type:type$6,unarchivalMayTake:unarchivalMayTake$6,unknown:unknown$6,update:update$6,updateAccess:updateAccess$6,updateDelivery:updateDelivery$6,uploadShipmentInformation:uploadShipmentInformation$6,uploadingCsv:uploadingCsv$6,users:users$6,view:view$6,viewDetails:viewDetails$6,viewMore:viewMore$6,workorder:workorder$6,yes:yes$6,yesClear:yesClear$6,yesDelete:yesDelete$6,onTheCloud:onTheCloud,archived:archived,uploading:uploading,missingAssets:missingAssets,filmFestivals:filmFestivals,searchFilmFestival:searchFilmFestival};

var add$5="Ajouter";var addAccess$5="Ajouter l'accès";var addAnotherRole$5="Ajouter un autre rôle";var addToList$5="Ajouter à la liste";var addToNewList$5="Ajouter à une nouvelle liste";var address$5="Adresse";var advertisement$5="Publicité";var alternateNames$5="Noms alternatifs";var applianceBusyInDuplicating$5="Cet appareil est occupé à dupliquer l'ordre de travail ";var aspectRatio$5="Ratio d'aspect";var audio$5="Audio";var audioFormat$5="Format audio";var back$5="Retour";var bandwidth$5="Bande passante";var booking$5="Réservation";var cancel$7="Annuler";var cancelled$5="Annulé";var cancelledCount$5="{{itemCount}} Annulé(s)";var chain$5="Chaîne";var clear$5="Effacer";var clearAll$5="Tout effacer";var clearTheatreSelection$5="Effacer la sélection du cinéma";var clearTheatreSelectionConfirmation$5="Êtes-vous sûr de vouloir effacer la sélection ?";var closedCaptions$5="Sous-titres codés";var closedSubtitles$5="Sous-titres codés";var comments$5="Commentaires";var companyTheatreLocation$5="Entreprise/Cinéma/Emplacement";var composition$5="Composition";var compositionDetails$5="Détails de la composition";var compositionTags$5="Étiquettes de composition";var compositions$5="Compositions";var contentIsLessThan8GBWarning$5="Ce contenu est inférieur à 8 Go et pourrait être envoyé via un support plus petit et plus économique (par exemple, une clé USB)";var contentIsLessThan8GBWarningContent$5="Si cette commande est traitée avec un support alternatif, n'oubliez pas de mettre à jour votre inventaire de supports en conséquence.";var contentSize$5="Taille du contenu";var conventionLink$5="Données issues du nom de composition basé sur la <1>Digital Cinema Naming Convention</1>";var copiedCount$5="{{itemCount}} Copié(s)";var copyCompleted$5="Copie terminée";var copyFailed$5="Échec de la copie";var copyPending$5="Copie en attente";var copyQueued$5="Copie en attente";var copyStatus$5="Statut de la copie";var courierType$5="Type de coursier";var cplFormat$5="Format CPL";var cplId$5="ID CPL";var cplMarkers$5="Marqueurs CPL";var cplMetadata$5="Métadonnées CPL";var create$6="Créer";var createModal$5="Créer une fenêtre modale";var createTag$5="Créer une étiquette";var createdBy$5="Créé par";var createdOn$5="Créé le";var creditOffset$5="Décalage de crédit";var creditsOffset$5="Décalage des crédits";var creditsValue$5="Crédits : {{value}}";var csvColumnsForTheatreSelect$5="Colonnes CSV : ID de l'écran, ID du théâtre, Nom, Ville, État, Pays, Zone, Nom de la chaîne";var dcp$5="DCP";var dcpStatus$5="Statut DCP";var dcpTransferCompleted$5="Transfert DCP terminé";var dcpTransferNotStarted$5="Transfert DCP non démarré";var dcpTransferStarted$5="Transfert DCP démarré";var deactivatedUser$5="Utilisateur désactivé";var deleteList$5="Supprimer la liste";var deleteListConfirmation$5="Êtes-vous sûr de vouloir supprimer cette liste ?";var deliverBefore$5="Livrer avant";var deliverBy$5="Livrer avant";var deliveries$5="Livraisons";var delivery$5="Livraison";var deliveryInstructions$5="Instructions de livraison";var download$5="Télécharger";var downloadCompleted$5="Téléchargement terminé";var downloadDetails$5="Détails du téléchargement";var downloadFailed$5="Échec du téléchargement";var downloadKdms$5="Télécharger les KDM";var downloadNotStarted$5="Téléchargement non démarré";var downloadPending$5="Téléchargement en attente";var downloadQueued$5="Téléchargement en attente";var downloadScheduled$5="Téléchargement planifié";var downloadShipmentInformation$5="Télécharger les informations d'expédition";var downloadStatus$5="Statut du téléchargement";var downloadYetToStart$5="Téléchargement non encore commencé";var downloaded$5="Téléchargé";var downloading$5="Téléchargement en cours";var downloadingArchived$5="Téléchargement - Archivé";var downloadingPercentage$5="Téléchargement {{percentage}} %";var downloadingStalled$5="Téléchargement - En attente";var downloadingUnarchiving$5="Téléchargement - Désarchivage";var driveCopy$5="Copie du disque";var driveNotHaveContent$5="Le disque ne contient aucun contenu";var drivesCount_one$5="{{count}} lecteur";var drivesCount_other$5="{{count}} lecteurs";var duplicateRowWasIgnored_one$5="{{count}} ligne dupliquée a été ignorée";var duplicateRowWasIgnored_other$5="{{count}} lignes dupliquées ont été ignorées";var duplicatingWoInBay$5="Duplication de la commande {{workOrderNo}} en cours dans la baie";var duplicationStatus$5="État de duplication";var duration$5="Durée";var editTag$5="Éditer l'étiquette";var editTheatreList$5="Modifier la liste de théâtre";var email$5="Email";var emailKDMS$5="Envoyer les KDM par email";var enterNameOfList$5="Entrez le nom de la liste";var enterNameOfNewList$5="Entrez le nom de la nouvelle liste";var enterTagName$5="Entrez le nom de l'étiquette";var enterTrackingNumber$5="Entrez le numéro de suivi";var errorFetchingDownloadStatus$5="Erreur lors de la récupération du statut de téléchargement";var errorGettingTheatre$5="Erreur lors de la récupération du théâtre";var errorWhileAddingGroup$5="Erreur lors de l'ajout du groupe";var errorWhileUpdatingGroup$5="Erreur lors de la mise à jour du groupe";var festivals$5="Festivals";var fetchingDetailsPleaseWait$5="Récupération des détails. Veuillez patienter";var ffec$5="FFEC";var ffmc$5="FFMC";var filterBy$5="Filtrer par";var firstFrameEndCredits$5="Première image - Générique de fin";var firstFrameMovingCredits$5="Première image - Générique en mouvement";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one$5="La ligne dupliquée suivante qui correspondait à l'écran a été ignorée";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other$5="{{count}} lignes dupliquées suivantes qui correspondaient à l'écran ont été ignorées";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$5="La ligne dupliquée suivante qui correspondait au théâtre a été ignorée";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$5="{{count}} lignes dupliquées suivantes qui correspondaient au théâtre ont été ignorées";var format$5="Format";var frameRate$5="Fréquence d'images";var from$5="De";var fromTimeOfBooking$5="à partir du moment de la réservation";var group$5="Groupe";var groupAddedToUser$5="Groupe ajouté à l'utilisateur";var groupUpdatedForUser$5="Groupe mis à jour pour l'utilisateur";var hasAccessTo$5="A accès à";var hourCount_one$5="{{count}} heure";var hourCount_other$5="{{count}} heures";var id_one$5="ID";var id_other$5="IDs";var inProgressCount$5="{{itemCount}} en cours";var inactiveScreen$5="Écran inactif";var insertedDrivesCount$5="{{itemCount}} lecteur(s) inséré(s)";var invalidFileNoTheatreNameOrId$5="Fichier invalide. Aucun nom ou ID de théâtre";var invitedUser$5="Utilisateur invité";var kdm$5="KDM";var kdmDetails$5="Détails KDM";var languages$5="Langues";var lastUpdatedBy$5="Dernière mise à jour par";var lastUpdatedOn$5="Dernière mise à jour le";var listName$5="Nom de la liste";var listUpdated$5="Liste mise à jour";var lists$5="Listes";var location$5="Emplacement";var mainCaptions$5="Légendes principales";var maintenance$5="Maintenance";var maintenanceDescription$5="Qube Wire est actuellement en maintenance. Nous serons de retour bientôt.";var manage$5="Gérer";var markAsDelivered$5="Marquer comme livré";var markAsPending$5="Marquer comme en attente";var markAsShipped$5="Marquer comme expédié";var minuteCount_one$5="{{count}} minute";var minuteCount_other$5="{{count}} minutes";var name$5="Nom";var no$5="Non";var noAccess$5="Pas d'accès";var noActiveDeviceInScreen$5="Aucun appareil actif sur l'écran";var noAppliancesFound$5="Aucun appareil trouvé";var noCompositions$5="Aucune composition";var noItemTypeInWorkOrderFound$5="Aucun {{type}} trouvé dans l'ordre de travail";var noKeepList$5="Non, conserver la liste";var noKeepSelection$5="Non, conserver la sélection";var noListsFound$5="Aucune liste trouvée";var noPlyDeviceInScreen$5="Aucun appareil de lecture sur l'écran";var noRecordsfound$5="Aucun enregistrement trouvé";var noResultsFound$5="Aucun résultat trouvé";var noTagsFoundClickHereToCreateOne$5="Aucune étiquette trouvée. Cliquez <1>ici</1> pour en créer une";var noTheatresAreSelected$5="Aucun théâtre sélectionné";var noTheatresFound$5="Aucun théâtre trouvé";var none$5="Aucun";var notFound$5="Non trouvé";var notes$5="Notes";var oops$5="Oups !";var osVersion$5="Version du système d'exploitation";var partner$5="Partenaire";var pendingCancellation$5="Annulation en attente";var pendingCancellationCount$5="{{itemCount}} Annulation en attente";var pendingCount$5="{{itemCount}} En attente";var picture$5="Image";var preciseMatchForTheatresNotFound$5="Aucune correspondance précise pour ces théâtres n'a été trouvée.";var preparingToCopy$5="Préparation de la copie";var publicIp$5="Adresse IP publique";var ratings$5="Évaluations";var rejected$5="Rejeté";var rejectedCount$5="{{itemCount}} Rejeté";var resolution$5="Résolution";var resultsFor$5="Résultats pour";var role$5="Rôle";var roles$5="Rôles";var rowMatchedCount_one$5="{{count}} ligne correspondante";var rowMatchedCount_other$5="{{count}} lignes correspondantes";var rowWithoutNameAndIdIgnored_one$5="{{count}} ligne sans nom et ID a été ignorée";var rowWithoutNameAndIdIgnored_other$5="{{count}} lignes sans nom et ID ont été ignorées";var save$5="Enregistrer";var screen$5="Écran";var screenCount_one$5="{{count}} Écran";var screenCount_other$5="{{count}} Écrans";var screenNonDciComplaints$5="L'écran n'a pas de plainte DCI";var screenNotHaveCertificate$5="L'écran n'a pas de certificat de dispositif";var screens$5="Écrans";var search$5="Recherche";var searchAndAddTags$5="Recherche et ajout de tags";var searchAndSelectTheatres$5="Rechercher et sélectionner des théâtres";var searchForTheatreList$5="Rechercher une liste de théâtre";var searchForTheatres$5="Rechercher des théâtres";var selectCourierType$5="Sélectionner le type de messagerie";var selectDcpTransferStatus$5="Sélectionner le statut de transfert DCP";var selectOption$5="Sélectionner une option";var selectTheatreCount_one$5="Sélectionnez {{count}} théâtre";var selectTheatreCount_other$5="Sélectionnez {{count}} théâtres";var selectTheatres$5="Sélectionner des théâtres";var selectUsingCsv$5="Sélectionner à l'aide de CSV";var selectedTheatres$5="Théâtres sélectionnés";var serialNumber$5="Numéro de série";var shipBy$5="Expédié par";var shipmentNo$5="Numéro d'expédition";var shipmentStatus$5="Statut de l'expédition";var shipped$5="Expédié";var shipping$5="Expédition";var shippingInformation$5="Informations d'expédition";var someErrorInGettingDownloadStatus$5="Erreur lors de la récupération du statut de téléchargement";var someScreensHaveMissingDeviceInformation$5="Certains écrans ont des informations manquantes sur le dispositif";var spokenLanguage$5="Langue parlée";var stageCopyingContentToDrives$5="Étape 2 sur 3 : Copie du contenu sur les lecteurs";var stageFormattingDrives$5="Étape 1 sur 3 : Formatage des lecteurs";var stageVerifying$5="Étape 3 sur 3 : Vérification";var startCopying$5="Démarrer la copie";var status$5="Statut";var submit$5="Soumettre";var subtitleLanguage$5="Langue des sous-titres";var tagName$5="Nom du tag";var tagNameLessThan50Char$5="Le nom du tag doit contenir moins de 50 caractères";var tags$5="Tags";var theatre$5="Théâtre";var theatreAlreadySelectedInList$5="Ce théâtre est déjà sélectionné dans la liste.";var theatreCountMatched_one$5="{{count}} théâtre correspondant";var theatreCountMatched_other$5="{{count}} théâtres correspondants";var theatreCount_one$5="{{count}} théâtre";var theatreCount_other$5="{{count}} théâtres";var theatreDetails$5="Détails du théâtre";var theatreListNameAlreadyExists$5="Le nom de la liste de théâtre existe déjà";var theatreName$5="Nom du théâtre";var theatres$5="Théâtres";var theatresListCreated$5="Liste de théâtres créée";var theatresListDeleted$5="Liste de théâtres supprimée";var theatresListUpdated$5="Liste de théâtres mise à jour";var thisPageDoesNotExist$5="Cette page n'existe pas.";var to$5="À";var totalDriveCount_one$5="{{count}} lecteur";var totalDriveCount_other$5="{{count}} lecteurs";var trackingNumber$5="Numéro de suivi";var transitional$5="Transitoire";var type$5="Type";var unarchivalMayTake$5="La désarchivation peut prendre";var unknown$5="Inconnu";var update$5="Mettre à jour";var updateAccess$5="Mettre à jour l'accès";var updateDelivery$5="Mettre à jour la livraison";var uploadShipmentInformation$5="Télécharger les informations d'expédition";var uploadingCsv$5="Chargement du CSV";var users$5="Utilisateurs";var view$5="Voir";var viewDetails$5="Voir les détails";var viewMore$5="Voir plus";var workorder$5="Ordre de travail";var yes$5="Oui";var yesClear$5="Oui, effacer";var yesDelete$5="Oui, supprimer";var fr = {add:add$5,addAccess:addAccess$5,addAnotherRole:addAnotherRole$5,addToList:addToList$5,addToNewList:addToNewList$5,address:address$5,advertisement:advertisement$5,alternateNames:alternateNames$5,applianceBusyInDuplicating:applianceBusyInDuplicating$5,aspectRatio:aspectRatio$5,audio:audio$5,audioFormat:audioFormat$5,back:back$5,bandwidth:bandwidth$5,booking:booking$5,cancel:cancel$7,cancelled:cancelled$5,cancelledCount:cancelledCount$5,chain:chain$5,clear:clear$5,clearAll:clearAll$5,clearTheatreSelection:clearTheatreSelection$5,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation$5,closedCaptions:closedCaptions$5,closedSubtitles:closedSubtitles$5,comments:comments$5,companyTheatreLocation:companyTheatreLocation$5,composition:composition$5,compositionDetails:compositionDetails$5,compositionTags:compositionTags$5,compositions:compositions$5,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning$5,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent$5,contentSize:contentSize$5,conventionLink:conventionLink$5,copiedCount:copiedCount$5,copyCompleted:copyCompleted$5,copyFailed:copyFailed$5,copyPending:copyPending$5,copyQueued:copyQueued$5,copyStatus:copyStatus$5,courierType:courierType$5,cplFormat:cplFormat$5,cplId:cplId$5,cplMarkers:cplMarkers$5,cplMetadata:cplMetadata$5,create:create$6,createModal:createModal$5,createTag:createTag$5,createdBy:createdBy$5,createdOn:createdOn$5,creditOffset:creditOffset$5,creditsOffset:creditsOffset$5,creditsValue:creditsValue$5,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect$5,dcp:dcp$5,dcpStatus:dcpStatus$5,dcpTransferCompleted:dcpTransferCompleted$5,dcpTransferNotStarted:dcpTransferNotStarted$5,dcpTransferStarted:dcpTransferStarted$5,deactivatedUser:deactivatedUser$5,"delete":"Supprimer",deleteList:deleteList$5,deleteListConfirmation:deleteListConfirmation$5,deliverBefore:deliverBefore$5,deliverBy:deliverBy$5,deliveries:deliveries$5,delivery:delivery$5,deliveryInstructions:deliveryInstructions$5,download:download$5,downloadCompleted:downloadCompleted$5,downloadDetails:downloadDetails$5,downloadFailed:downloadFailed$5,downloadKdms:downloadKdms$5,downloadNotStarted:downloadNotStarted$5,downloadPending:downloadPending$5,downloadQueued:downloadQueued$5,downloadScheduled:downloadScheduled$5,downloadShipmentInformation:downloadShipmentInformation$5,downloadStatus:downloadStatus$5,downloadYetToStart:downloadYetToStart$5,downloaded:downloaded$5,downloading:downloading$5,downloadingArchived:downloadingArchived$5,downloadingPercentage:downloadingPercentage$5,downloadingStalled:downloadingStalled$5,downloadingUnarchiving:downloadingUnarchiving$5,driveCopy:driveCopy$5,driveNotHaveContent:driveNotHaveContent$5,drivesCount_one:drivesCount_one$5,drivesCount_other:drivesCount_other$5,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one$5,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other$5,duplicatingWoInBay:duplicatingWoInBay$5,duplicationStatus:duplicationStatus$5,duration:duration$5,editTag:editTag$5,editTheatreList:editTheatreList$5,email:email$5,emailKDMS:emailKDMS$5,enterNameOfList:enterNameOfList$5,enterNameOfNewList:enterNameOfNewList$5,enterTagName:enterTagName$5,enterTrackingNumber:enterTrackingNumber$5,errorFetchingDownloadStatus:errorFetchingDownloadStatus$5,errorGettingTheatre:errorGettingTheatre$5,errorWhileAddingGroup:errorWhileAddingGroup$5,errorWhileUpdatingGroup:errorWhileUpdatingGroup$5,festivals:festivals$5,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait$5,ffec:ffec$5,ffmc:ffmc$5,filterBy:filterBy$5,firstFrameEndCredits:firstFrameEndCredits$5,firstFrameMovingCredits:firstFrameMovingCredits$5,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one$5,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other$5,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$5,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$5,format:format$5,frameRate:frameRate$5,from:from$5,fromTimeOfBooking:fromTimeOfBooking$5,group:group$5,groupAddedToUser:groupAddedToUser$5,groupUpdatedForUser:groupUpdatedForUser$5,hasAccessTo:hasAccessTo$5,hourCount_one:hourCount_one$5,hourCount_other:hourCount_other$5,id_one:id_one$5,id_other:id_other$5,inProgressCount:inProgressCount$5,inactiveScreen:inactiveScreen$5,insertedDrivesCount:insertedDrivesCount$5,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId$5,invitedUser:invitedUser$5,kdm:kdm$5,kdmDetails:kdmDetails$5,languages:languages$5,lastUpdatedBy:lastUpdatedBy$5,lastUpdatedOn:lastUpdatedOn$5,listName:listName$5,listUpdated:listUpdated$5,lists:lists$5,location:location$5,mainCaptions:mainCaptions$5,maintenance:maintenance$5,maintenanceDescription:maintenanceDescription$5,manage:manage$5,markAsDelivered:markAsDelivered$5,markAsPending:markAsPending$5,markAsShipped:markAsShipped$5,minuteCount_one:minuteCount_one$5,minuteCount_other:minuteCount_other$5,name:name$5,no:no$5,noAccess:noAccess$5,noActiveDeviceInScreen:noActiveDeviceInScreen$5,noAppliancesFound:noAppliancesFound$5,noCompositions:noCompositions$5,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound$5,noKeepList:noKeepList$5,noKeepSelection:noKeepSelection$5,noListsFound:noListsFound$5,noPlyDeviceInScreen:noPlyDeviceInScreen$5,noRecordsfound:noRecordsfound$5,noResultsFound:noResultsFound$5,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne$5,noTheatresAreSelected:noTheatresAreSelected$5,noTheatresFound:noTheatresFound$5,none:none$5,notFound:notFound$5,notes:notes$5,oops:oops$5,osVersion:osVersion$5,partner:partner$5,pendingCancellation:pendingCancellation$5,pendingCancellationCount:pendingCancellationCount$5,pendingCount:pendingCount$5,picture:picture$5,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound$5,preparingToCopy:preparingToCopy$5,publicIp:publicIp$5,ratings:ratings$5,rejected:rejected$5,rejectedCount:rejectedCount$5,resolution:resolution$5,resultsFor:resultsFor$5,"return":"Retour",role:role$5,roles:roles$5,rowMatchedCount_one:rowMatchedCount_one$5,rowMatchedCount_other:rowMatchedCount_other$5,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one$5,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other$5,save:save$5,screen:screen$5,screenCount_one:screenCount_one$5,screenCount_other:screenCount_other$5,screenNonDciComplaints:screenNonDciComplaints$5,screenNotHaveCertificate:screenNotHaveCertificate$5,screens:screens$5,search:search$5,searchAndAddTags:searchAndAddTags$5,searchAndSelectTheatres:searchAndSelectTheatres$5,searchForTheatreList:searchForTheatreList$5,searchForTheatres:searchForTheatres$5,selectCourierType:selectCourierType$5,selectDcpTransferStatus:selectDcpTransferStatus$5,selectOption:selectOption$5,selectTheatreCount_one:selectTheatreCount_one$5,selectTheatreCount_other:selectTheatreCount_other$5,selectTheatres:selectTheatres$5,selectUsingCsv:selectUsingCsv$5,selectedTheatres:selectedTheatres$5,serialNumber:serialNumber$5,shipBy:shipBy$5,shipmentNo:shipmentNo$5,shipmentStatus:shipmentStatus$5,shipped:shipped$5,shipping:shipping$5,shippingInformation:shippingInformation$5,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus$5,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation$5,spokenLanguage:spokenLanguage$5,stageCopyingContentToDrives:stageCopyingContentToDrives$5,stageFormattingDrives:stageFormattingDrives$5,stageVerifying:stageVerifying$5,startCopying:startCopying$5,status:status$5,submit:submit$5,subtitleLanguage:subtitleLanguage$5,tagName:tagName$5,tagNameLessThan50Char:tagNameLessThan50Char$5,tags:tags$5,theatre:theatre$5,theatreAlreadySelectedInList:theatreAlreadySelectedInList$5,theatreCountMatched_one:theatreCountMatched_one$5,theatreCountMatched_other:theatreCountMatched_other$5,theatreCount_one:theatreCount_one$5,theatreCount_other:theatreCount_other$5,theatreDetails:theatreDetails$5,theatreListNameAlreadyExists:theatreListNameAlreadyExists$5,theatreName:theatreName$5,theatres:theatres$5,theatresListCreated:theatresListCreated$5,theatresListDeleted:theatresListDeleted$5,theatresListUpdated:theatresListUpdated$5,thisPageDoesNotExist:thisPageDoesNotExist$5,to:to$5,totalDriveCount_one:totalDriveCount_one$5,totalDriveCount_other:totalDriveCount_other$5,trackingNumber:trackingNumber$5,transitional:transitional$5,type:type$5,unarchivalMayTake:unarchivalMayTake$5,unknown:unknown$5,update:update$5,updateAccess:updateAccess$5,updateDelivery:updateDelivery$5,uploadShipmentInformation:uploadShipmentInformation$5,uploadingCsv:uploadingCsv$5,users:users$5,view:view$5,viewDetails:viewDetails$5,viewMore:viewMore$5,workorder:workorder$5,yes:yes$5,yesClear:yesClear$5,yesDelete:yesDelete$5};

var add$4="Hozzáadás";var addAccess$4="Hozzáférés hozzáadása";var addAnotherRole$4="Másik szerep hozzáadása";var addToList$4="Hozzáadás a listához";var addToNewList$4="Hozzáadás az új listához";var address$4="Cím";var advertisement$4="Hirdetés";var alternateNames$4="Alternatív nevek";var applianceBusyInDuplicating$4="Ez a készülék foglalt, mert dolgozat másolásra vár";var aspectRatio$4="Képarány";var audio$4="Hang";var audioFormat$4="Hangformátum";var back$4="Vissza";var bandwidth$4="Sávszélesség";var booking$4="Foglalás";var cancel$6="Mégse";var cancelled$4="Törölve";var cancelledCount$4="{{itemCount}} Törölve";var chain$4="Lánc";var clear$4="Törlés";var clearAll$4="Minden törlése";var clearTheatreSelection$4="Mozi kiválasztásának törlése";var clearTheatreSelectionConfirmation$4="Biztosan törölni szeretné a kiválasztást?";var closedCaptions$4="Zárt feliratok";var closedSubtitles$4="Zárt feliratok";var comments$4="Megjegyzések";var companyTheatreLocation$4="Cég/Mozi/Helyszín";var composition$4="Tartalmak";var compositionDetails$4="Tartalom Részletei";var compositionTags$4="Tartalom Címkék";var compositions$4="Tartalmak";var contentIsLessThan8GBWarning$4="Ez a tartalom kevesebb, mint 8GB, és kisebb, költséghatékonyabb médiumon (például USB pendrive) küldhető";var contentIsLessThan8GBWarningContent$4="Ha ezt a munkalapot alternatív médiával teljesítik, ne felejtsd el frissíteni az adathordozókészletedet.";var contentSize$4="Tartalom mérete";var conventionLink$4="Adatok a Tartalom névből, a <1>Digital Cinema Naming Convention</1> alapján";var copiedCount$4="{{itemCount}} Másolva";var copyCompleted$4="Másolás befejezve";var copyFailed$4="Másolás sikertelen";var copyPending$4="Másolat függőben";var copyQueued$4="Másolás sorban";var copyStatus$4="Másolási állapot";var courierType$4="Kurir típus";var cplFormat$4="CPL formátum";var cplId$4="CPL azonosító";var cplMarkers$4="CPL jelölők";var cplMetadata$4="CPL metaadat";var create$5="Létrehoz";var createModal$4="Létrehozás módja";var createTag$4="Címke létrehozása";var createdBy$4="készítette";var createdOn$4="Létrehozás dátuma";var creditOffset$4="Hitel eltolás";var creditsOffset$4="Kreditek eltolása";var creditsValue$4="Kreditek: {{value}}";var csvColumnsForTheatreSelect$4="CSV oszlopok: Képernyő azonosító, Mozi azonosító, Név, Város, Állam, Ország, Terület, Lánc neve";var dcp$4="DCP";var dcpStatus$4="DCP állapot";var dcpTransferCompleted$4="DCP átvitel befejeződött";var dcpTransferNotStarted$4="DCP átvitel még nem kezdődött el";var dcpTransferStarted$4="DCP átvitel elkezdődött";var deactivatedUser$4="Deaktivált felhasználó";var deleteList$4="Lista törlése";var deleteListConfirmation$4="Biztosan törölni szeretné ezt a listát?";var deliverBefore$4="Kézbesítés eddig";var deliverBy$4="Kiszállítás időpontja";var deliveries$4="Kiszállítások";var delivery$4="Kiszállítás";var deliveryInstructions$4="Kiszállítási utasítások";var download$4="Letöltés";var downloadCompleted$4="Letöltés Befejezve";var downloadDetails$4="Letöltés Részletei";var downloadFailed$4="Letöltés Sikertelen";var downloadKdms$4="KDM-ek Letöltése";var downloadNotStarted$4="Letöltés nem kezdődött el";var downloadPending$4="Letöltés Függőben";var downloadQueued$4="Letöltés Várakozik";var downloadScheduled$4="Letöltés Tervezve";var downloadShipmentInformation$4="Szállítmányinformációk Letöltése";var downloadStatus$4="Letöltés Állapota";var downloadYetToStart$4="Letöltés Még Nem Kezdődött El";var downloaded$4="Letöltve";var downloading$4="Letöltés";var downloadingArchived$4="Letöltés - Archiválás alatt";var downloadingPercentage$4="{{percentage}} % Letöltve";var downloadingStalled$4="Letöltés - Megállt";var downloadingUnarchiving$4="Letöltés - Kibontás alatt";var driveCopy$4="Meghajtó másolása";var driveNotHaveContent$4="A meghajtón nincs tartalom";var drivesCount_one$4="{{count}} meghajtó";var drivesCount_other$4="{{count}} meghajtó";var duplicateRowWasIgnored_one$4="{{count}} duplikált sor figyelmen kívül hagyva";var duplicateRowWasIgnored_other$4="{{count}} duplikált sor figyelmen kívül hagyva";var duplicatingWoInBay$4="{{workOrderNo}} másolása a Bay-ben";var duplicationStatus$4="Duplikációs állapot";var duration$4="Időtartam";var editTag$4="Címke szerkesztése";var editTheatreList$4="Mozi lista szerkesztése";var email$4="Email";var emailKDMS$4="KDM-ek küldése emailben";var enterNameOfList$4="Lista nevének megadása";var enterNameOfNewList$4="Új lista nevének megadása";var enterTagName$4="Címke megadása";var enterTrackingNumber$4="Nyomkövetési szám megadása";var errorFetchingDownloadStatus$4="Hiba a Letöltés Állapotának Lekérésekor";var errorGettingTheatre$4="Hiba történt a mozi lekérésekor";var errorWhileAddingGroup$4="Hiba a csoport hozzáadása közben";var errorWhileUpdatingGroup$4="Hiba a csoport frissítése közben";var festivals$4="Fesztiválok";var fetchingDetailsPleaseWait$4="Adatok lekérése. Kérem, várjon";var ffec$4="FFEC";var ffmc$4="FFMC";var filterBy$4="Szűrés";var firstFrameEndCredits$4="Első képkocka - Végjegyzék";var firstFrameMovingCredits$4="Első képkocka - Mozgó feliratok";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one$4="A következő, a képernyővel megegyező duplikált sor figyelmen kívül hagyva";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other$4="A következő {{count}} a képernyővel megegyező duplikált sor figyelmen kívül hagyva";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$4="A mozihoz illeszkedő következő duplikált sor figyelmen kívül lesz hagyva";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$4="{{count}} mozihoz illeszkedő duplikált sor figyelmen kívül lesz hagyva";var format$4="Formátum";var frameRate$4="Képkockasebesség";var from$4="Tól";var fromTimeOfBooking$4="a foglalás időpontjától";var group$4="Csoport";var groupAddedToUser$4="Csoport hozzáadva a felhasználóhoz";var groupUpdatedForUser$4="Csoport frissítve a felhasználó számára";var hasAccessTo$4="Hozzáférése van";var hourCount_one$4="{{count}} óra";var hourCount_other$4="{{count}} óra";var id_one$4="Azonosító";var id_other$4="Azonosítók";var inProgressCount$4="{{itemCount}} folyamatban";var inactiveScreen$4="Inaktív képernyő";var insertedDrivesCount$4="{{itemCount}} meghajtó beszúrva.";var invalidFileNoTheatreNameOrId$4="Érvénytelen fájl. Nincs mozi név vagy azonosító";var invitedUser$4="Meghívott felhasználó";var kdm$4="KDM";var kdmDetails$4="KDM részletei";var languages$4="Nyelvek";var lastUpdatedBy$4="Utoljára frissítette";var lastUpdatedOn$4="Utoljára frissítve";var listName$4="Lista neve";var listUpdated$4="A lista frissítve lett";var lists$4="Listák";var location$4="Hely";var mainCaptions$4="Fő feliratok";var maintenance$4="Karbantartás";var maintenanceDescription$4="A Qube Wire jelenleg karbantartás alatt áll. Hamarosan visszatérünk.";var manage$4="Kezelés";var markAsDelivered$4="Jelölje meg kézbesítettként";var markAsPending$4="Jelölje meg függőben lévőként";var markAsShipped$4="Jelölje meg elküldöttként";var minuteCount_one$4="{{count}} perc";var minuteCount_other$4="{{count}} perc";var name$4="Név";var no$4="Nem";var noAccess$4="Nincs hozzáférés";var noActiveDeviceInScreen$4="A képernyőn nincs aktív eszköz";var noAppliancesFound$4="Nem találhatók eszközök";var noCompositions$4="Nincsenek Tartalmak";var noItemTypeInWorkOrderFound$4="Nincs {{type}} munkarend";var noKeepList$4="Nem, tartsa meg a listát";var noKeepSelection$4="Nem, tartsa meg a kiválasztást";var noListsFound$4="Nincs találat a listákra";var noPlyDeviceInScreen$4="A képernyőn nincs lejátszó eszköz";var noRecordsfound$4="Nem találhatók rekordok";var noResultsFound$4="Nincs találat";var noTagsFoundClickHereToCreateOne$4="Nincs találat a címkékre. Kattintson <1>ide</1> a létrehozáshoz";var noTheatresAreSelected$4="Nincs kiválasztott mozi";var noTheatresFound$4="Nincsenek mozik találhatók";var none$4="Nincs";var notFound$4="Nem található";var notes$4="Megjegyzések";var oops$4="Hoppá!";var osVersion$4="OS verzió";var partner$4="Partner";var pendingCancellation$4="Függőben lévő törlés";var pendingCancellationCount$4="{{itemCount}} Függőben lévő törlés";var pendingCount$4="{{itemCount}} Függőben lévő";var picture$4="Kép";var preciseMatchForTheatresNotFound$4="Ezekhez a mozikhoz nem található pontos illeszkedés.";var preparingToCopy$4="Másolás előkészítése";var publicIp$4="Nyilvános IP";var ratings$4="Értékelések";var rejected$4="Elutasítva";var rejectedCount$4="{{itemCount}} Elutasítva";var resolution$4="Felbontás";var resultsFor$4="Eredmények a következőre";var role$4="Szerep";var roles$4="Szerepek";var rowMatchedCount_one$4="{{count}} sor egyezik";var rowMatchedCount_other$4="{{count}} sorok egyeznek";var rowWithoutNameAndIdIgnored_one$4="{{count}} név és azonosító nélküli sor figyelmen kívül hagyva";var rowWithoutNameAndIdIgnored_other$4="{{count}} név és azonosító nélküli sorok figyelmen kívül hagyva";var save$4="Mentés";var screen$4="Képernyő";var screenCount_one$4="{{count}} Képernyő";var screenCount_other$4="{{count}} Képernyők";var screenNonDciComplaints$4="A képernyőn nincs DCI panasz";var screenNotHaveCertificate$4="A képernyőn nincs eszköz tanúsítvány";var screens$4="Képernyők";var search$4="Keresés";var searchAndAddTags$4="Keresés és címkék hozzáadása";var searchAndSelectTheatres$4="Mozik keresése és kiválasztása";var searchForTheatreList$4="Mozi lista keresése";var searchForTheatres$4="Mozik keresése";var selectCourierType$4="Válasszon futártípust";var selectDcpTransferStatus$4="Válassza ki a DCP átviteli állapotát";var selectOption$4="Válasszon egy lehetőséget";var selectTheatreCount_one$4="{{count}} mozi kiválasztása";var selectTheatreCount_other$4="{{count}} mozi kiválasztása";var selectTheatres$4="Mozik kiválasztása";var selectUsingCsv$4="Válassza ki a CSV használatával";var selectedTheatres$4="Kiválasztott mozik";var serialNumber$4="Sorozatszám";var shipBy$4="Szállítás:";var shipmentNo$4="Szállítmány azonosító";var shipmentStatus$4="Szállítmány állapota";var shipped$4="Szállítva";var shipping$4="Szállítás";var shippingInformation$4="Szállítási információk";var someErrorInGettingDownloadStatus$4="Hiba történt a letöltés állapotának lekérésekor";var someScreensHaveMissingDeviceInformation$4="Néhány képernyőn hiányzik az eszköz információ";var spokenLanguage$4="Beszélt nyelv";var stageCopyingContentToDrives$4="2. lépés: Tartalom másolása meghajtókra";var stageFormattingDrives$4="1. lépés: Meghajtók formázása";var stageVerifying$4="3. lépés: Ellenőrzés";var startCopying$4="Másolás indítása";var status$4="Állapot";var submit$4="Beküldés";var subtitleLanguage$4="Felirat nyelve";var tagName$4="Címke neve";var tagNameLessThan50Char$4="A címke neve legfeljebb 50 karakter lehet";var tags$4="Címkék";var theatre$4="Mozi";var theatreAlreadySelectedInList$4="Ez a mozi már szerepel a listában.";var theatreCountMatched_one$4="{{count}} mozi illeszkedik";var theatreCountMatched_other$4="{{count}} mozi illeszkedik";var theatreCount_one$4="{{count}} mozi";var theatreCount_other$4="{{count}} mozik";var theatreDetails$4="Mozi részletei";var theatreListNameAlreadyExists$4="A mozi lista neve már létezik";var theatreName$4="Mozik neve";var theatres$4="Mozik";var theatresListCreated$4="Mozik listája létrehozva";var theatresListDeleted$4="Mozik listája törölve";var theatresListUpdated$4="Mozik listája frissítve";var thisPageDoesNotExist$4="Ez az oldal nem létezik";var to$4="Ig";var totalDriveCount_one$4="{{count}} meghajtó";var totalDriveCount_other$4="{{count}} meghajtók";var trackingNumber$4="Követési szám";var transitional$4="Átmeneti";var type$4="Típus";var unarchivalMayTake$4="Az archiválás feloldása időbe telhet";var unknown$4="Ismeretlen";var update$4="Frissítés";var updateAccess$4="Hozzáférés frissítése";var updateDelivery$4="Kiszállítás frissítése";var uploadShipmentInformation$4="Szállítmányinformációk Feltöltése";var uploadingCsv$4="CSV Feltöltése";var users$4="Felhasználók";var view$4="Megtekintés";var viewDetails$4="Részletek Megtekintése";var viewMore$4="Továbbiak Megtekintése";var workorder$4="Munka rend";var yes$4="Igen";var yesClear$4="Igen, törölje";var yesDelete$4="Igen, törölje";var hu = {add:add$4,addAccess:addAccess$4,addAnotherRole:addAnotherRole$4,addToList:addToList$4,addToNewList:addToNewList$4,address:address$4,advertisement:advertisement$4,alternateNames:alternateNames$4,applianceBusyInDuplicating:applianceBusyInDuplicating$4,aspectRatio:aspectRatio$4,audio:audio$4,audioFormat:audioFormat$4,back:back$4,bandwidth:bandwidth$4,booking:booking$4,cancel:cancel$6,cancelled:cancelled$4,cancelledCount:cancelledCount$4,chain:chain$4,clear:clear$4,clearAll:clearAll$4,clearTheatreSelection:clearTheatreSelection$4,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation$4,closedCaptions:closedCaptions$4,closedSubtitles:closedSubtitles$4,comments:comments$4,companyTheatreLocation:companyTheatreLocation$4,composition:composition$4,compositionDetails:compositionDetails$4,compositionTags:compositionTags$4,compositions:compositions$4,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning$4,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent$4,contentSize:contentSize$4,conventionLink:conventionLink$4,copiedCount:copiedCount$4,copyCompleted:copyCompleted$4,copyFailed:copyFailed$4,copyPending:copyPending$4,copyQueued:copyQueued$4,copyStatus:copyStatus$4,courierType:courierType$4,cplFormat:cplFormat$4,cplId:cplId$4,cplMarkers:cplMarkers$4,cplMetadata:cplMetadata$4,create:create$5,createModal:createModal$4,createTag:createTag$4,createdBy:createdBy$4,createdOn:createdOn$4,creditOffset:creditOffset$4,creditsOffset:creditsOffset$4,creditsValue:creditsValue$4,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect$4,dcp:dcp$4,dcpStatus:dcpStatus$4,dcpTransferCompleted:dcpTransferCompleted$4,dcpTransferNotStarted:dcpTransferNotStarted$4,dcpTransferStarted:dcpTransferStarted$4,deactivatedUser:deactivatedUser$4,"delete":"Törlés",deleteList:deleteList$4,deleteListConfirmation:deleteListConfirmation$4,deliverBefore:deliverBefore$4,deliverBy:deliverBy$4,deliveries:deliveries$4,delivery:delivery$4,deliveryInstructions:deliveryInstructions$4,download:download$4,downloadCompleted:downloadCompleted$4,downloadDetails:downloadDetails$4,downloadFailed:downloadFailed$4,downloadKdms:downloadKdms$4,downloadNotStarted:downloadNotStarted$4,downloadPending:downloadPending$4,downloadQueued:downloadQueued$4,downloadScheduled:downloadScheduled$4,downloadShipmentInformation:downloadShipmentInformation$4,downloadStatus:downloadStatus$4,downloadYetToStart:downloadYetToStart$4,downloaded:downloaded$4,downloading:downloading$4,downloadingArchived:downloadingArchived$4,downloadingPercentage:downloadingPercentage$4,downloadingStalled:downloadingStalled$4,downloadingUnarchiving:downloadingUnarchiving$4,driveCopy:driveCopy$4,driveNotHaveContent:driveNotHaveContent$4,drivesCount_one:drivesCount_one$4,drivesCount_other:drivesCount_other$4,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one$4,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other$4,duplicatingWoInBay:duplicatingWoInBay$4,duplicationStatus:duplicationStatus$4,duration:duration$4,editTag:editTag$4,editTheatreList:editTheatreList$4,email:email$4,emailKDMS:emailKDMS$4,enterNameOfList:enterNameOfList$4,enterNameOfNewList:enterNameOfNewList$4,enterTagName:enterTagName$4,enterTrackingNumber:enterTrackingNumber$4,errorFetchingDownloadStatus:errorFetchingDownloadStatus$4,errorGettingTheatre:errorGettingTheatre$4,errorWhileAddingGroup:errorWhileAddingGroup$4,errorWhileUpdatingGroup:errorWhileUpdatingGroup$4,festivals:festivals$4,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait$4,ffec:ffec$4,ffmc:ffmc$4,filterBy:filterBy$4,firstFrameEndCredits:firstFrameEndCredits$4,firstFrameMovingCredits:firstFrameMovingCredits$4,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one$4,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other$4,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$4,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$4,format:format$4,frameRate:frameRate$4,from:from$4,fromTimeOfBooking:fromTimeOfBooking$4,group:group$4,groupAddedToUser:groupAddedToUser$4,groupUpdatedForUser:groupUpdatedForUser$4,hasAccessTo:hasAccessTo$4,hourCount_one:hourCount_one$4,hourCount_other:hourCount_other$4,id_one:id_one$4,id_other:id_other$4,inProgressCount:inProgressCount$4,inactiveScreen:inactiveScreen$4,insertedDrivesCount:insertedDrivesCount$4,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId$4,invitedUser:invitedUser$4,kdm:kdm$4,kdmDetails:kdmDetails$4,languages:languages$4,lastUpdatedBy:lastUpdatedBy$4,lastUpdatedOn:lastUpdatedOn$4,listName:listName$4,listUpdated:listUpdated$4,lists:lists$4,location:location$4,mainCaptions:mainCaptions$4,maintenance:maintenance$4,maintenanceDescription:maintenanceDescription$4,manage:manage$4,markAsDelivered:markAsDelivered$4,markAsPending:markAsPending$4,markAsShipped:markAsShipped$4,minuteCount_one:minuteCount_one$4,minuteCount_other:minuteCount_other$4,name:name$4,no:no$4,noAccess:noAccess$4,noActiveDeviceInScreen:noActiveDeviceInScreen$4,noAppliancesFound:noAppliancesFound$4,noCompositions:noCompositions$4,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound$4,noKeepList:noKeepList$4,noKeepSelection:noKeepSelection$4,noListsFound:noListsFound$4,noPlyDeviceInScreen:noPlyDeviceInScreen$4,noRecordsfound:noRecordsfound$4,noResultsFound:noResultsFound$4,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne$4,noTheatresAreSelected:noTheatresAreSelected$4,noTheatresFound:noTheatresFound$4,none:none$4,notFound:notFound$4,notes:notes$4,oops:oops$4,osVersion:osVersion$4,partner:partner$4,pendingCancellation:pendingCancellation$4,pendingCancellationCount:pendingCancellationCount$4,pendingCount:pendingCount$4,picture:picture$4,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound$4,preparingToCopy:preparingToCopy$4,publicIp:publicIp$4,ratings:ratings$4,rejected:rejected$4,rejectedCount:rejectedCount$4,resolution:resolution$4,resultsFor:resultsFor$4,"return":"Vissza",role:role$4,roles:roles$4,rowMatchedCount_one:rowMatchedCount_one$4,rowMatchedCount_other:rowMatchedCount_other$4,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one$4,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other$4,save:save$4,screen:screen$4,screenCount_one:screenCount_one$4,screenCount_other:screenCount_other$4,screenNonDciComplaints:screenNonDciComplaints$4,screenNotHaveCertificate:screenNotHaveCertificate$4,screens:screens$4,search:search$4,searchAndAddTags:searchAndAddTags$4,searchAndSelectTheatres:searchAndSelectTheatres$4,searchForTheatreList:searchForTheatreList$4,searchForTheatres:searchForTheatres$4,selectCourierType:selectCourierType$4,selectDcpTransferStatus:selectDcpTransferStatus$4,selectOption:selectOption$4,selectTheatreCount_one:selectTheatreCount_one$4,selectTheatreCount_other:selectTheatreCount_other$4,selectTheatres:selectTheatres$4,selectUsingCsv:selectUsingCsv$4,selectedTheatres:selectedTheatres$4,serialNumber:serialNumber$4,shipBy:shipBy$4,shipmentNo:shipmentNo$4,shipmentStatus:shipmentStatus$4,shipped:shipped$4,shipping:shipping$4,shippingInformation:shippingInformation$4,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus$4,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation$4,spokenLanguage:spokenLanguage$4,stageCopyingContentToDrives:stageCopyingContentToDrives$4,stageFormattingDrives:stageFormattingDrives$4,stageVerifying:stageVerifying$4,startCopying:startCopying$4,status:status$4,submit:submit$4,subtitleLanguage:subtitleLanguage$4,tagName:tagName$4,tagNameLessThan50Char:tagNameLessThan50Char$4,tags:tags$4,theatre:theatre$4,theatreAlreadySelectedInList:theatreAlreadySelectedInList$4,theatreCountMatched_one:theatreCountMatched_one$4,theatreCountMatched_other:theatreCountMatched_other$4,theatreCount_one:theatreCount_one$4,theatreCount_other:theatreCount_other$4,theatreDetails:theatreDetails$4,theatreListNameAlreadyExists:theatreListNameAlreadyExists$4,theatreName:theatreName$4,theatres:theatres$4,theatresListCreated:theatresListCreated$4,theatresListDeleted:theatresListDeleted$4,theatresListUpdated:theatresListUpdated$4,thisPageDoesNotExist:thisPageDoesNotExist$4,to:to$4,totalDriveCount_one:totalDriveCount_one$4,totalDriveCount_other:totalDriveCount_other$4,trackingNumber:trackingNumber$4,transitional:transitional$4,type:type$4,unarchivalMayTake:unarchivalMayTake$4,unknown:unknown$4,update:update$4,updateAccess:updateAccess$4,updateDelivery:updateDelivery$4,uploadShipmentInformation:uploadShipmentInformation$4,uploadingCsv:uploadingCsv$4,users:users$4,view:view$4,viewDetails:viewDetails$4,viewMore:viewMore$4,workorder:workorder$4,yes:yes$4,yesClear:yesClear$4,yesDelete:yesDelete$4};

var add$3="เพิ่ม";var addAccess$3="เพิ่มสิทธิ์การเข้าถึง";var addAnotherRole$3="เพิ่มบทบาทอื่น";var addToList$3="เพิ่มลงในรายการ";var addToNewList$3="เพิ่มลงในรายการใหม่";var address$3="ที่อยู่";var advertisement$3="โฆษณา";var alternateNames$3="ชื่อทางเลือก";var applianceBusyInDuplicating$3="เครื่องใช้งานนี้กำลังยุติงงานการทำคำสั่งงาน ";var aspectRatio$3="อัตราส่วนภาพ";var audio$3="เสียง";var audioFormat$3="รูปแบบเสียง";var back$3="กลับ";var bandwidth$3="แบนด์วิดธ์";var booking$3="จอง";var cancel$5="ยกเลิก";var cancelled$3="ถูกยกเลิก";var cancelledCount$3="{{itemCount}} ถูกยกเลิก";var chain$3="สาย";var clear$3="ล้าง";var clearAll$3="ล้างทั้งหมด";var clearTheatreSelection$3="ล้างการเลือกรายการ";var clearTheatreSelectionConfirmation$3="คุณแน่ใจหรือไม่ที่ต้องการล้างการเลือก?";var closedCaptions$3="คำบรรยายปิด";var closedSubtitles$3="คำบรรยายปิด";var comments$3="ความคิดเห็น";var companyTheatreLocation$3="บริษัท/โรงหนัง/สถานที่";var composition$3="สร้าง";var compositionDetails$3="รายละเอียดการสร้าง";var compositionTags$3="แท็กสร้าง";var compositions$3="การสร้าง";var contentIsLessThan8GBWarning$3="เนื้อหานี้น้อยกว่า 8GB และสามารถส่งผ่านสื่อที่เล็กกว่าที่มีความมีประสิทธิภาพมากขึ้น (เช่น USB สติก/ทัมบ์ดรายการ)";var contentIsLessThan8GBWarningContent$3="หากคำสั่งงานนี้จะประสบการณ์ให้บริการโดยใช้สื่อทางเลือก โปรดอัปเดตสต็อกไดรฟ์ของคุณตามที่เหมาะสม";var contentSize$3="ขนาดเนื้อหา";var conventionLink$3="ข้อมูลจากชื่อสร้างขึ้นขึ้นบน <1>Digital Cinema Naming Convention</1>";var copiedCount$3="{{itemCount}} คัดลอกแล้ว";var copyCompleted$3="การคัดลอกเสร็จสิ้น";var copyFailed$3="การคัดลอกล้มเหลว";var copyPending$3="การคัดลอกรอดำเนินการ";var copyQueued$3="รอคิวการคัดลอก";var copyStatus$3="สถานะการคัดลอก";var courierType$3="ประเภท Courier";var cplFormat$3="รูปแบบ CPL";var cplId$3="รหัส CPL";var cplMarkers$3="เครื่องหมาย CPL";var cplMetadata$3="ข้อมูล CPL";var create$4="สร้าง";var createModal$3="สร้างโหมด";var createTag$3="สร้างแท็ก";var createdBy$3="สร้างโดย";var createdOn$3="สร้างเมื่อ";var creditOffset$3="การเบิกเครดิต";var creditsOffset$3="การเบิกเครดิต";var creditsValue$3="เครดิต: {{value}}";var csvColumnsForTheatreSelect$3="คอลัมน์ CSV: รหัสหน้าจอ, รหัสโรงหนัง, ชื่อ, เมือง, รัฐ, ประเทศ, พื้นที่, ชื่อเครือ";var dcp$3="DCP";var dcpStatus$3="สถานะ DCP";var dcpTransferCompleted$3="การถ่ายโอน DCP เสร็จสิ้น";var dcpTransferNotStarted$3="ยังไม่เริ่มการถ่ายโอน DCP";var dcpTransferStarted$3="เริ่มการถ่ายโอน DCP";var deactivatedUser$3="ผู้ใช้ถูกปิดใช้งาน";var deleteList$3="ลบรายการ";var deleteListConfirmation$3="คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?";var deliverBefore$3="ส่งถึงก่อน";var deliverBy$3="ส่งถึงโดย";var deliveries$3="การส่ง";var delivery$3="การส่ง";var deliveryInstructions$3="คำแนะนำการส่ง";var download$3="ดาวน์โหลด";var downloadCompleted$3="ดาวน์โหลดเสร็จสิ้น";var downloadDetails$3="รายละเอียดการดาวน์โหลด";var downloadFailed$3="ดาวน์โหลดล้มเหลว";var downloadKdms$3="ดาวน์โหลด KDMs";var downloadNotStarted$3="ยังไม่เริ่มดาวน์โหลด";var downloadPending$3="รอดาวน์โหลด";var downloadQueued$3="รอคิวการดาวน์โหลด";var downloadScheduled$3="กำหนดการดาวน์โหลด";var downloadShipmentInformation$3="ดาวน์โหลดข้อมูลการส่งสินค้า";var downloadStatus$3="สถานะการดาวน์โหลด";var downloadYetToStart$3="ยังไม่เริ่มดาวน์โหลด";var downloaded$3="ดาวน์โหลดแล้ว";var downloading$3="กำลังดาวน์โหลด";var downloadingArchived$3="กำลังดาวน์โหลด - ถูกเก็บถาวร";var downloadingPercentage$3="กำลังดาวน์โหลด {{percentage}} %";var downloadingStalled$3="กำลังดาวน์โหลด - หยุดชะงัก";var downloadingUnarchiving$3="กำลังดาวน์โหลด - ไม่ได้ทำการถอด";var driveCopy$3="คัดลอกไดรฟ์";var driveNotHaveContent$3="ไดรฟ์ไม่มีเนื้อหา";var drivesCount_one$3="{{count}} ไดรฟ์";var drivesCount_other$3="{{count}} ไดรฟ์";var duplicateRowWasIgnored_one$3="{{count}} แถวที่ซ้ำถูกละเว้น";var duplicateRowWasIgnored_other$3="{{count}} แถวที่ซ้ำถูกละเว้น";var duplicatingWoInBay$3="กำลังทำซ้ำ {{workOrderNo}} ใน Bay";var duplicationStatus$3="สถานะการทำซ้ำ";var duration$3="ระยะเวลา";var editTag$3="แก้ไขแท็ก";var editTheatreList$3="แก้ไขรายการโรงหนัง";var email$3="อีเมล";var emailKDMS$3="Email KDMs";var enterNameOfList$3="ป้อนชื่อรายการ";var enterNameOfNewList$3="ป้อนชื่อรายการใหม่";var enterTagName$3="ป้อนชื่อแท็ก";var enterTrackingNumber$3="ป้อนหมายเลขติดตาม";var errorFetchingDownloadStatus$3="ข้อผิดพลาดในการดึงสถานะการดาวน์โหลด";var errorGettingTheatre$3="ข้อผิดพลาดในการรับข้อมูลโรงหนัง";var errorWhileAddingGroup$3="ข้อผิดพลาดในขณะเพิ่มกลุ่ม";var errorWhileUpdatingGroup$3="ข้อผิดพลาดในขณะอัปเดตกลุ่ม";var festivals$3="เทศกาลหนัง";var fetchingDetailsPleaseWait$3="กำลังดึงรายละเอียด กรุณารอ";var ffec$3="FFEC";var ffmc$3="FFMC";var filterBy$3="กรองโดย";var firstFrameEndCredits$3="เฟรมแรก - เครดิตสิ้นสุด";var firstFrameMovingCredits$3="เฟรมแรก - เครดิตเคลื่อนไหว";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one$3="แถวที่ซ้ำต่อไปนี้ที่ตรงกับหน้าจอถูกละเว้น";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other$3="แถวที่ซ้ำต่อไปนี้ ({{count}} แถว) ที่ตรงกับหน้าจอถูกละเว้น";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$3="แถวที่ซ้ำต่อไปนี้ที่ตรงกับโรงหนังถูกละเว้น";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$3="แถวที่ซ้ำต่อไปนี้ ({{count}} แถว) ที่ตรงกับโรงหนังถูกละเว้น";var format$3="รูปแบบ";var frameRate$3="อัตราเฟรม";var from$3="จาก";var fromTimeOfBooking$3="ตั้งแต่เวลาจอง";var group$3="กลุ่ม";var groupAddedToUser$3="เพิ่มกลุ่มให้กับผู้ใช้";var groupUpdatedForUser$3="กลุ่มได้รับการอัปเดตสำหรับผู้ใช้";var hasAccessTo$3="มีการเข้าถึง";var hourCount_one$3="{{count}} ชั่วโมง";var hourCount_other$3="{{count}} ชั่วโมง";var id_one$3="ID";var id_other$3="ID";var inProgressCount$3="{{itemCount}} กำลังดำเนินการ";var inactiveScreen$3="หน้าจอไม่ได้ใช้งาน";var insertedDrivesCount$3="{{itemCount}} ไดรฟ์ถูกแทรก";var invalidFileNoTheatreNameOrId$3="ไฟล์ไม่ถูกต้อง ไม่มีชื่อหรือ ID ของโรงหนัง";var invitedUser$3="ผู้ใช้ที่ได้รับเชิญ";var kdm$3="KDM";var kdmDetails$3="รายละเอียด KDM";var languages$3="ภาษา";var lastUpdatedBy$3="อัปเดตล่าสุดโดย";var lastUpdatedOn$3="อัปเดตล่าสุดเมื่อ";var listName$3="ชื่อรายการ";var listUpdated$3="รายการได้รับการอัปเดต";var lists$3="รายการที่บันทึกไว้";var location$3="ตำแหน่ง";var mainCaptions$3="คำบรรยายหลัก";var maintenance$3="การบำรุงรักษา";var maintenanceDescription$3="Qube Wire กำลังอยู่ในขั้นตอนการบำรุงรักษา กรุณารอสักครู่";var manage$3="จัดการ";var markAsDelivered$3="ทำเครื่องหมายว่าได้ส่งมอบแล้ว";var markAsPending$3="ทำเครื่องหมายว่ารอดำเนินการ";var markAsShipped$3="ทำเครื่องหมายว่าได้จัดส่งแล้ว";var minuteCount_one$3="{{count}} นาที";var minuteCount_other$3="{{count}} นาที";var name$3="ชื่อ";var no$3="ไม่";var noAccess$3="ไม่มีการเข้าถึง";var noActiveDeviceInScreen$3="ไม่มีอุปกรณ์ที่ใช้งานในหน้าจอ";var noAppliancesFound$3="ไม่พบอุปกรณ์";var noCompositions$3="ไม่มีการประกอบ";var noItemTypeInWorkOrderFound$3="ไม่พบ {{type}} ในคำสั่งงาน";var noKeepList$3="ไม่ รักษารายการ";var noKeepSelection$3="ไม่ รักษาการเลือก";var noListsFound$3="ไม่พบรายการ";var noPlyDeviceInScreen$3="ไม่มีอุปกรณ์เล่นในหน้าจอ";var noRecordsfound$3="ไม่พบบันทึก";var noResultsFound$3="ไม่พบผลลัพธ์";var noTagsFoundClickHereToCreateOne$3="ไม่พบแท็ก คลิก <1>ที่นี่</1> เพื่อสร้างหนึ่ง";var noTheatresAreSelected$3="ไม่ได้เลือกโรงภายนตร์";var noTheatresFound$3="ไม่พบโรงหนัง";var none$3="ไม่มี";var notFound$3="ไม่พบ";var notes$3="หมายเหตุ";var oops$3="อุ๊ปส์!";var osVersion$3="เวอร์ชันของระบบปฏิบัติการ";var partner$3="พันธมิตร";var pendingCancellation$3="รอยกเลิก";var pendingCancellationCount$3="{{itemCount}} รอยกเลิก";var pendingCount$3="{{itemCount}} รอดำเนินการ";var picture$3="รูปภาพ";var preciseMatchForTheatresNotFound$3="ไม่พบการจับคู่ที่แม่นยำสำหรับโรงหนังเหล่านี้";var preparingToCopy$3="กำลังเตรียมคัดลอก";var publicIp$3="IP สาธารณะ";var ratings$3="คะแนน";var rejected$3="ปฏิเสธ";var rejectedCount$3="{{itemCount}} ปฏิเสธ";var resolution$3="ความละเอียด";var resultsFor$3="ผลลัพธ์สำหรับ";var role$3="บทบาท";var roles$3="บทบาท";var rowMatchedCount_one$3="{{count}} แถวที่ตรง";var rowMatchedCount_other$3="{{count}} แถวที่ตรง";var rowWithoutNameAndIdIgnored_one$3="{{count}} แถวที่ไม่มีชื่อและรหัสไอดีถูกละเว้น";var rowWithoutNameAndIdIgnored_other$3="{{count}} แถวที่ไม่มีชื่อและรหัสไอดีถูกละเว้น";var save$3="บันทึก";var screen$3="หน้าจอ";var screenCount_one$3="{{count}} หน้าจอ";var screenCount_other$3="{{count}} หน้าจอ";var screenNonDciComplaints$3="หน้าจอไม่มีการร้องเรียน DCI";var screenNotHaveCertificate$3="หน้าจอไม่มีใบรับรองอุปกรณ์";var screens$3="หน้าจอ";var search$3="ค้นหา";var searchAndAddTags$3="ค้นหาและเพิ่มแท็ก";var searchAndSelectTheatres$3="ค้นหาและเลือกโรงภายนตร์";var searchForTheatreList$3="ค้นหาลิสรายชื่อโรงภาพยนตร์ที่บันทึกไว้";var searchForTheatres$3="ค้นหาโรงภาพยนตร์";var selectCourierType$3="เลือกประเภทผู้ส่งสินค้า";var selectDcpTransferStatus$3="เลือกสถานะการถ่ายโอน DCP";var selectOption$3="เลือกตัวเลือก";var selectTheatreCount_one$3="เลือก {{count}} โรงหนัง";var selectTheatreCount_other$3="เลือก {{count}} โรงหนัง";var selectTheatres$3="เลือกโรงหนัง";var selectUsingCsv$3="เลือกโดยใช้ CSV";var selectedTheatres$3="โรงภายนตร์ที่เลือก";var serialNumber$3="หมายเลขซีเรียล";var shipBy$3="ส่งโดย";var shipmentNo$3="หมายเลขการส่งของ";var shipmentStatus$3="สถานะการส่งของ";var shipped$3="ได้ทำการส่ง";var shipping$3="กำลังจัดส่ง";var shippingInformation$3="ข้อมูลการจัดส่ง";var someErrorInGettingDownloadStatus$3="เกิดข้อผิดพลาดในการดึงสถานะการดาวน์โหลด";var someScreensHaveMissingDeviceInformation$3="บางหน้าจอขาดข้อมูลอุปกรณ์";var spokenLanguage$3="ภาษาพูด";var stageCopyingContentToDrives$3="ขั้นตอนที่ 2/3: กำลังคัดลอกเนื้อหาลงในไดรฟ์";var stageFormattingDrives$3="ขั้นตอนที่ 1/3: กำลังจัดรูปแบบไดรฟ์";var stageVerifying$3="ขั้นตอนที่ 3/3: กำลังตรวจสอบ";var startCopying$3="เริ่มการคัดลอก";var status$3="สถานะ";var submit$3="ส่ง";var subtitleLanguage$3="ภาษาซับไตเติล";var tagName$3="ชื่อแท็ก";var tagNameLessThan50Char$3="ชื่อแท็กต้องน้อยกว่า 50 ตัวอักษร";var tags$3="แท็ก";var theatre$3="โรงภายนตร์";var theatreAlreadySelectedInList$3="โรงหนังนี้ได้รับการเลือกไว้ในรายการแล้ว";var theatreCountMatched_one$3="{{count}} โรงหนังที่ตรง";var theatreCountMatched_other$3="{{count}} โรงหนังที่ตรง";var theatreCount_one$3="{{count}} โรง";var theatreCount_other$3="{{count}} โรง";var theatreDetails$3="รายละเอียดโรงหนัง";var theatreListNameAlreadyExists$3="ชื่อรายการโรงหนังมีอยู่แล้ว";var theatreName$3="ชื่อโรงหนัง";var theatres$3="โรงภายนตร์";var theatresListCreated$3="สร้างรายการโรงหนังแล้ว";var theatresListDeleted$3="ลบรายการโรงหนังแล้ว";var theatresListUpdated$3="อัปเดตรายการโรงหนังแล้ว";var thisPageDoesNotExist$3="หน้านี้ไม่มีอยู่";var to$3="ถึง";var totalDriveCount_one$3="{{count}} ไดรฟ์";var totalDriveCount_other$3="{{count}} ไดรฟ์";var trackingNumber$3="หมายเลขการติดตาม";var transitional$3="ช่วงเวลาที่เปลี่ยน";var type$3="ประเภท";var unarchivalMayTake$3="การยกเลิกการเก็บถาวรอาจใช้เวลา";var unknown$3="ไม่ทราบ";var update$3="อัปเดต";var updateAccess$3="อัปเดตสิทธิ์การเข้าถึง";var updateDelivery$3="อัปเดตการจัดส่ง";var uploadShipmentInformation$3="อัปโหลดข้อมูลการส่งของ";var uploadingCsv$3="กำลังอัปโหลด CSV";var users$3="ผู้ใช้";var view$3="ดู";var viewDetails$3="ดูรายละเอียด";var viewMore$3="ดูเพิ่มเติม";var workorder$3="คำสั่งงาน";var yes$3="ใช่";var yesClear$3="ใช่, ล้าง";var yesDelete$3="ใช่, ลบ";var th = {add:add$3,addAccess:addAccess$3,addAnotherRole:addAnotherRole$3,addToList:addToList$3,addToNewList:addToNewList$3,address:address$3,advertisement:advertisement$3,alternateNames:alternateNames$3,applianceBusyInDuplicating:applianceBusyInDuplicating$3,aspectRatio:aspectRatio$3,audio:audio$3,audioFormat:audioFormat$3,back:back$3,bandwidth:bandwidth$3,booking:booking$3,cancel:cancel$5,cancelled:cancelled$3,cancelledCount:cancelledCount$3,chain:chain$3,clear:clear$3,clearAll:clearAll$3,clearTheatreSelection:clearTheatreSelection$3,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation$3,closedCaptions:closedCaptions$3,closedSubtitles:closedSubtitles$3,comments:comments$3,companyTheatreLocation:companyTheatreLocation$3,composition:composition$3,compositionDetails:compositionDetails$3,compositionTags:compositionTags$3,compositions:compositions$3,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning$3,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent$3,contentSize:contentSize$3,conventionLink:conventionLink$3,copiedCount:copiedCount$3,copyCompleted:copyCompleted$3,copyFailed:copyFailed$3,copyPending:copyPending$3,copyQueued:copyQueued$3,copyStatus:copyStatus$3,courierType:courierType$3,cplFormat:cplFormat$3,cplId:cplId$3,cplMarkers:cplMarkers$3,cplMetadata:cplMetadata$3,create:create$4,createModal:createModal$3,createTag:createTag$3,createdBy:createdBy$3,createdOn:createdOn$3,creditOffset:creditOffset$3,creditsOffset:creditsOffset$3,creditsValue:creditsValue$3,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect$3,dcp:dcp$3,dcpStatus:dcpStatus$3,dcpTransferCompleted:dcpTransferCompleted$3,dcpTransferNotStarted:dcpTransferNotStarted$3,dcpTransferStarted:dcpTransferStarted$3,deactivatedUser:deactivatedUser$3,"delete":"ลบ",deleteList:deleteList$3,deleteListConfirmation:deleteListConfirmation$3,deliverBefore:deliverBefore$3,deliverBy:deliverBy$3,deliveries:deliveries$3,delivery:delivery$3,deliveryInstructions:deliveryInstructions$3,download:download$3,downloadCompleted:downloadCompleted$3,downloadDetails:downloadDetails$3,downloadFailed:downloadFailed$3,downloadKdms:downloadKdms$3,downloadNotStarted:downloadNotStarted$3,downloadPending:downloadPending$3,downloadQueued:downloadQueued$3,downloadScheduled:downloadScheduled$3,downloadShipmentInformation:downloadShipmentInformation$3,downloadStatus:downloadStatus$3,downloadYetToStart:downloadYetToStart$3,downloaded:downloaded$3,downloading:downloading$3,downloadingArchived:downloadingArchived$3,downloadingPercentage:downloadingPercentage$3,downloadingStalled:downloadingStalled$3,downloadingUnarchiving:downloadingUnarchiving$3,driveCopy:driveCopy$3,driveNotHaveContent:driveNotHaveContent$3,drivesCount_one:drivesCount_one$3,drivesCount_other:drivesCount_other$3,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one$3,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other$3,duplicatingWoInBay:duplicatingWoInBay$3,duplicationStatus:duplicationStatus$3,duration:duration$3,editTag:editTag$3,editTheatreList:editTheatreList$3,email:email$3,emailKDMS:emailKDMS$3,enterNameOfList:enterNameOfList$3,enterNameOfNewList:enterNameOfNewList$3,enterTagName:enterTagName$3,enterTrackingNumber:enterTrackingNumber$3,errorFetchingDownloadStatus:errorFetchingDownloadStatus$3,errorGettingTheatre:errorGettingTheatre$3,errorWhileAddingGroup:errorWhileAddingGroup$3,errorWhileUpdatingGroup:errorWhileUpdatingGroup$3,festivals:festivals$3,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait$3,ffec:ffec$3,ffmc:ffmc$3,filterBy:filterBy$3,firstFrameEndCredits:firstFrameEndCredits$3,firstFrameMovingCredits:firstFrameMovingCredits$3,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one$3,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other$3,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$3,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$3,format:format$3,frameRate:frameRate$3,from:from$3,fromTimeOfBooking:fromTimeOfBooking$3,group:group$3,groupAddedToUser:groupAddedToUser$3,groupUpdatedForUser:groupUpdatedForUser$3,hasAccessTo:hasAccessTo$3,hourCount_one:hourCount_one$3,hourCount_other:hourCount_other$3,id_one:id_one$3,id_other:id_other$3,inProgressCount:inProgressCount$3,inactiveScreen:inactiveScreen$3,insertedDrivesCount:insertedDrivesCount$3,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId$3,invitedUser:invitedUser$3,kdm:kdm$3,kdmDetails:kdmDetails$3,languages:languages$3,lastUpdatedBy:lastUpdatedBy$3,lastUpdatedOn:lastUpdatedOn$3,listName:listName$3,listUpdated:listUpdated$3,lists:lists$3,location:location$3,mainCaptions:mainCaptions$3,maintenance:maintenance$3,maintenanceDescription:maintenanceDescription$3,manage:manage$3,markAsDelivered:markAsDelivered$3,markAsPending:markAsPending$3,markAsShipped:markAsShipped$3,minuteCount_one:minuteCount_one$3,minuteCount_other:minuteCount_other$3,name:name$3,no:no$3,noAccess:noAccess$3,noActiveDeviceInScreen:noActiveDeviceInScreen$3,noAppliancesFound:noAppliancesFound$3,noCompositions:noCompositions$3,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound$3,noKeepList:noKeepList$3,noKeepSelection:noKeepSelection$3,noListsFound:noListsFound$3,noPlyDeviceInScreen:noPlyDeviceInScreen$3,noRecordsfound:noRecordsfound$3,noResultsFound:noResultsFound$3,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne$3,noTheatresAreSelected:noTheatresAreSelected$3,noTheatresFound:noTheatresFound$3,none:none$3,notFound:notFound$3,notes:notes$3,oops:oops$3,osVersion:osVersion$3,partner:partner$3,pendingCancellation:pendingCancellation$3,pendingCancellationCount:pendingCancellationCount$3,pendingCount:pendingCount$3,picture:picture$3,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound$3,preparingToCopy:preparingToCopy$3,publicIp:publicIp$3,ratings:ratings$3,rejected:rejected$3,rejectedCount:rejectedCount$3,resolution:resolution$3,resultsFor:resultsFor$3,"return":"กลับ",role:role$3,roles:roles$3,rowMatchedCount_one:rowMatchedCount_one$3,rowMatchedCount_other:rowMatchedCount_other$3,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one$3,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other$3,save:save$3,screen:screen$3,screenCount_one:screenCount_one$3,screenCount_other:screenCount_other$3,screenNonDciComplaints:screenNonDciComplaints$3,screenNotHaveCertificate:screenNotHaveCertificate$3,screens:screens$3,search:search$3,searchAndAddTags:searchAndAddTags$3,searchAndSelectTheatres:searchAndSelectTheatres$3,searchForTheatreList:searchForTheatreList$3,searchForTheatres:searchForTheatres$3,selectCourierType:selectCourierType$3,selectDcpTransferStatus:selectDcpTransferStatus$3,selectOption:selectOption$3,selectTheatreCount_one:selectTheatreCount_one$3,selectTheatreCount_other:selectTheatreCount_other$3,selectTheatres:selectTheatres$3,selectUsingCsv:selectUsingCsv$3,selectedTheatres:selectedTheatres$3,serialNumber:serialNumber$3,shipBy:shipBy$3,shipmentNo:shipmentNo$3,shipmentStatus:shipmentStatus$3,shipped:shipped$3,shipping:shipping$3,shippingInformation:shippingInformation$3,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus$3,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation$3,spokenLanguage:spokenLanguage$3,stageCopyingContentToDrives:stageCopyingContentToDrives$3,stageFormattingDrives:stageFormattingDrives$3,stageVerifying:stageVerifying$3,startCopying:startCopying$3,status:status$3,submit:submit$3,subtitleLanguage:subtitleLanguage$3,tagName:tagName$3,tagNameLessThan50Char:tagNameLessThan50Char$3,tags:tags$3,theatre:theatre$3,theatreAlreadySelectedInList:theatreAlreadySelectedInList$3,theatreCountMatched_one:theatreCountMatched_one$3,theatreCountMatched_other:theatreCountMatched_other$3,theatreCount_one:theatreCount_one$3,theatreCount_other:theatreCount_other$3,theatreDetails:theatreDetails$3,theatreListNameAlreadyExists:theatreListNameAlreadyExists$3,theatreName:theatreName$3,theatres:theatres$3,theatresListCreated:theatresListCreated$3,theatresListDeleted:theatresListDeleted$3,theatresListUpdated:theatresListUpdated$3,thisPageDoesNotExist:thisPageDoesNotExist$3,to:to$3,totalDriveCount_one:totalDriveCount_one$3,totalDriveCount_other:totalDriveCount_other$3,trackingNumber:trackingNumber$3,transitional:transitional$3,type:type$3,unarchivalMayTake:unarchivalMayTake$3,unknown:unknown$3,update:update$3,updateAccess:updateAccess$3,updateDelivery:updateDelivery$3,uploadShipmentInformation:uploadShipmentInformation$3,uploadingCsv:uploadingCsv$3,users:users$3,view:view$3,viewDetails:viewDetails$3,viewMore:viewMore$3,workorder:workorder$3,yes:yes$3,yesClear:yesClear$3,yesDelete:yesDelete$3};

var add$2="Thêm";var addAccess$2="Thêm quyền truy cập";var addAnotherRole$2="Thêm vai trò khác";var addToList$2="Thêm vào danh sách";var addToNewList$2="Thêm vào Danh sách mới";var address$2="Địa chỉ";var advertisement$2="Quảng cáo";var alternateNames$2="Tên thay thế";var applianceBusyInDuplicating$2="Thiết bị này đang bận trong quá trình sao chép đơn hàng";var aspectRatio$2="Tỉ lệ khung hình";var audio$2="Âm thanh";var audioFormat$2="Định dạng âm thanh";var back$2="Quay lại";var bandwidth$2="Băng thông";var booking$2="Đặt Phim";var cancel$4="Hủy";var cancelled$2="Đã hủy";var cancelledCount$2="{{itemCount}} Đã hủy";var chain$2="Chuỗi";var clear$2="Xóa";var clearAll$2="Xóa tất cả";var clearTheatreSelection$2="Xóa lựa chọn Rạp chiếu phim";var clearTheatreSelectionConfirmation$2="Bạn chắc chắn muốn xóa lựa chọn?";var closedCaptions$2="Phụ đề đóng";var closedSubtitles$2="Phụ đề đóng";var comments$2="Bình luận";var companyTheatreLocation$2="Công ty/Rạp chiếu phim/Địa điểm";var composition$2="Phim";var compositionDetails$2="Chi tiết Phim";var compositionTags$2="Tags Phim";var compositions$2="Danh sách Phim";var contentIsLessThan8GBWarning$2="Nội dung này ít hơn 8GB và có thể được gửi qua phương tiện nhỏ, chi phí hiệu quả hơn (ví dụ: USB)";var contentIsLessThan8GBWarningContent$2="Nếu đơn hàng này sẽ được thực hiện bằng phương tiện thay thế, hãy nhớ cập nhật danh sách đĩa của bạn tương ứng.";var contentSize$2="Kích thước nội dung";var conventionLink$2="Dữ liệu từ tên Phim dựa trên <1>Digital Cinema Naming Convention</1>";var copiedCount$2="{{itemCount}} Đã sao chép";var copyCompleted$2="Hoàn thành sao chép";var copyFailed$2="Sao chép thất bại";var copyPending$2="Sao chép đang chờ";var copyQueued$2="Sao chép đang chờ";var copyStatus$2="Trạng thái sao chép";var courierType$2="Loại courier";var cplFormat$2="Định dạng CPL";var cplId$2="ID CPL";var cplMarkers$2="Điểm đánh dấu CPL";var cplMetadata$2="Dữ liệu CPL";var create$3="Tạo";var createModal$2="Tạo Modal";var createTag$2="Tạo Tag";var createdBy$2="Được tạo bởi";var createdOn$2="Được tạo vào";var creditOffset$2="Lệch tín dụng";var creditsOffset$2="Lệch tín dụng";var creditsValue$2="Tín dụng: {{value}}";var csvColumnsForTheatreSelect$2="Cột CSV: ID Màn hình, ID Rạp chiếu phim, Tên, Thành phố, Tỉnh/Thành phố, Quốc gia, Khu vực, Tên chuỗi";var dcp$2="DCP";var dcpStatus$2="Trạng thái DCP";var dcpTransferCompleted$2="Hoàn thành việc chuyển DCP";var dcpTransferNotStarted$2="Chưa bắt đầu chuyển DCP";var dcpTransferStarted$2="Bắt đầu chuyển DCP";var deactivatedUser$2="Người dùng đã bị vô hiệu hóa";var deleteList$2="Xóa danh sách";var deleteListConfirmation$2="Bạn có chắc chắn muốn xóa danh sách này không?";var deliverBefore$2="Giao trước";var deliverBy$2="Giao bởi";var deliveries$2="Giao hàng";var delivery$2="Giao hàng";var deliveryInstructions$2="Hướng dẫn giao hàng";var download$2="Tải về";var downloadCompleted$2="Tải về đã hoàn thành";var downloadDetails$2="Chi tiết tải về";var downloadFailed$2="Tải về thất bại";var downloadKdms$2="Tải về KDM";var downloadNotStarted$2="Chưa bắt đầu tải về";var downloadPending$2="Tải về đang chờ";var downloadQueued$2="Tải về đang chờ";var downloadScheduled$2="Tải về được lên lịch";var downloadShipmentInformation$2="Tải về thông tin vận chuyển";var downloadStatus$2="Trạng thái tải về";var downloadYetToStart$2="Chưa bắt đầu tải về";var downloaded$2="Đã tải về";var downloading$2="Đang tải về";var downloadingArchived$2="Đang tải về - Lưu trữ";var downloadingPercentage$2="Đang tải về {{percentage}} %";var downloadingStalled$2="Đang tải về - Tạm dừng";var downloadingUnarchiving$2="Đang tải về - Giải nén";var driveCopy$2="Sao chép ổ đĩa";var driveNotHaveContent$2="Ổ đĩa không có nội dung";var drivesCount_one$2="{{count}} ổ đĩa";var drivesCount_other$2="{{count}} ổ đĩa";var duplicateRowWasIgnored_one$2="{{count}} hàng trùng bị bỏ qua";var duplicateRowWasIgnored_other$2="{{count}} hàng trùng bị bỏ qua";var duplicatingWoInBay$2="Đang nhân bản {{workOrderNo}} tại Bay";var duplicationStatus$2="Trạng thái nhân bản";var duration$2="Thời lượng";var editTag$2="Chỉnh sửa thẻ";var editTheatreList$2="Chỉnh sửa Danh sách Rạp chiếu phim";var email$2="Email";var emailKDMS$2="Email KDMs";var enterNameOfList$2="Nhập tên danh sách";var enterNameOfNewList$2="Nhập tên danh sách mới";var enterTagName$2="Nhập tên thẻ";var enterTrackingNumber$2="Nhập số theo dõi";var errorFetchingDownloadStatus$2="Lỗi khi lấy trạng thái tải về";var errorGettingTheatre$2="Lỗi khi lấy thông tin Rạp chiếu phim";var errorWhileAddingGroup$2="Lỗi khi thêm nhóm";var errorWhileUpdatingGroup$2="Lỗi khi cập nhật nhóm";var festivals$2="Lễ hội";var fetchingDetailsPleaseWait$2="Đang lấy chi tiết. Vui lòng đợi";var ffec$2="FFEC";var ffmc$2="FFMC";var filterBy$2="Lọc theo";var firstFrameEndCredits$2="Khung đầu tiên - Điểm đến";var firstFrameMovingCredits$2="Khung đầu tiên - Điểm động";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one$2="Dòng trùng lặp sau đây phù hợp với Màn hình và sẽ bị bỏ qua";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other$2="Có {{count}} dòng trùng lặp sau đây phù hợp với Màn hình và sẽ bị bỏ qua";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$2="Dòng trùng lặp sau đây phù hợp với Rạp chiếu phim và sẽ bị bỏ qua";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$2="Có {{count}} dòng trùng lặp sau đây phù hợp với Rạp chiếu phim và sẽ bị bỏ qua";var format$2="Định dạng";var frameRate$2="Tốc độ khung hình";var from$2="Từ";var fromTimeOfBooking$2="từ thời điểm đặt chỗ";var group$2="Nhóm";var groupAddedToUser$2="Nhóm đã được thêm cho người dùng";var groupUpdatedForUser$2="Nhóm đã được cập nhật cho người dùng";var hasAccessTo$2="Có quyền truy cập";var hourCount_one$2="{{count}} giờ";var hourCount_other$2="{{count}} giờ";var id_one$2="ID";var id_other$2="IDs";var inProgressCount$2="{{itemCount}} Đang tiến hành";var inactiveScreen$2="Màn hình không hoạt động";var insertedDrivesCount$2="{{itemCount}} ổ đĩa đã được chèn.";var invalidFileNoTheatreNameOrId$2="File không hợp lệ. Không có tên hoặc ID Rạp chiếu phim";var invitedUser$2="Người dùng đã được mời";var kdm$2="KDM";var kdmDetails$2="Chi tiết KDM";var languages$2="Ngôn ngữ";var lastUpdatedBy$2="Cập nhật lần cuối bởi";var lastUpdatedOn$2="Cập nhật lần cuối vào";var listName$2="Tên danh sách";var listUpdated$2="Danh sách đã được cập nhật";var lists$2="Danh sách";var location$2="Vị trí";var mainCaptions$2="Chú thích chính";var maintenance$2="Bảo trì";var maintenanceDescription$2="Qube Wire hiện đang trong quá trình bảo trì. Chúng tôi sẽ quay lại sớm.";var manage$2="Quản lý";var markAsDelivered$2="Đánh dấu đã giao";var markAsPending$2="Đánh dấu chờ xử lý";var markAsShipped$2="Đánh dấu đã chuyển";var minuteCount_one$2="{{count}} phút";var minuteCount_other$2="{{count}} phút";var name$2="Tên";var no$2="Không";var noAccess$2="Không có quyền truy cập";var noActiveDeviceInScreen$2="Màn hình không có thiết bị hoạt động";var noAppliancesFound$2="Không tìm thấy thiết bị";var noCompositions$2="Không có Phim";var noItemTypeInWorkOrderFound$2="Không tìm thấy {{type}} trong đơn hàng";var noKeepList$2="Không, giữ danh sách";var noKeepSelection$2="Không, giữ lựa chọn";var noListsFound$2="Không tìm thấy danh sách";var noPlyDeviceInScreen$2="Màn hình không có thiết bị phát lại";var noRecordsfound$2="Không tìm thấy bản ghi";var noResultsFound$2="Không tìm thấy kết quả";var noTagsFoundClickHereToCreateOne$2="Không tìm thấy thẻ. Nhấp vào <1>đây</1> để tạo một cái";var noTheatresAreSelected$2="Không có Rạp chiếu phim nào được chọn";var noTheatresFound$2="Không tìm thấy Rạp chiếu phim";var none$2="Không có";var notFound$2="Không tìm thấy";var notes$2="Ghi chú";var oops$2="Ôi!";var osVersion$2="Phiên bản hệ điều hành";var partner$2="Đối tác";var pendingCancellation$2="Đang chờ hủy";var pendingCancellationCount$2="{{itemCount}} Đang chờ hủy";var pendingCount$2="{{itemCount}} Đang chờ";var picture$2="Hình ảnh";var preciseMatchForTheatresNotFound$2="Không tìm thấy sự phù hợp chính xác cho những Rạp chiếu phim này.";var preparingToCopy$2="Đang chuẩn bị sao chép";var publicIp$2="Địa chỉ IP công cộng";var ratings$2="Đánh giá";var rejected$2="Từ chối";var rejectedCount$2="{{itemCount}} Từ chối";var resolution$2="Độ phân giải";var resultsFor$2="Kết quả cho";var role$2="Vai trò";var roles$2="Vai trò";var rowMatchedCount_one$2="{{count}} dòng khớp";var rowMatchedCount_other$2="{{count}} dòng khớp";var rowWithoutNameAndIdIgnored_one$2="{{count}} dòng không có tên và ID đã bị bỏ qua";var rowWithoutNameAndIdIgnored_other$2="{{count}} dòng không có tên và ID đã bị bỏ qua";var save$2="Lưu";var screen$2="Màn hình";var screenCount_one$2="{{count}} Màn hình";var screenCount_other$2="{{count}} Màn hình";var screenNonDciComplaints$2="Màn hình không có khiếu nại DCI";var screenNotHaveCertificate$2="Màn hình không có chứng chỉ thiết bị";var screens$2="Màn hình";var search$2="Tìm kiếm";var searchAndAddTags$2="Tìm kiếm và thêm thẻ";var searchAndSelectTheatres$2="Tìm kiếm và Chọn Rạp chiếu phim";var searchForTheatreList$2="Tìm kiếm danh sách Rạp chiếu phim";var searchForTheatres$2="Tìm kiếm Rạp chiếu phim";var selectCourierType$2="Chọn loại dịch vụ chuyển phát";var selectDcpTransferStatus$2="Chọn Trạng thái Chuyển DCP";var selectOption$2="Chọn tùy chọn";var selectTheatreCount_one$2="Chọn {{count}} Rạp chiếu phim";var selectTheatreCount_other$2="Chọn {{count}} Rạp chiếu phim";var selectTheatres$2="Chọn Rạp chiếu phim";var selectUsingCsv$2="Chọn bằng CSV";var selectedTheatres$2="Rạp chiếu phim đã chọn";var serialNumber$2="Số sê-ri";var shipBy$2="Gửi bởi";var shipmentNo$2="Số lô hàng";var shipmentStatus$2="Trạng thái lô hàng";var shipped$2="Đã gửi";var shipping$2="Đang gửi";var shippingInformation$2="Thông tin vận chuyển";var someErrorInGettingDownloadStatus$2="Có lỗi khi lấy trạng thái tải về";var someScreensHaveMissingDeviceInformation$2="Một số màn hình có thông tin thiết bị bị thiếu";var spokenLanguage$2="Ngôn ngữ nói";var stageCopyingContentToDrives$2="Bước 2/3: Sao chép nội dung vào ổ đĩa";var stageFormattingDrives$2="Bước 1/3: Định dạng ổ đĩa";var stageVerifying$2="Bước 3/3: Xác minh";var startCopying$2="Bắt đầu sao chép";var status$2="Trạng thái";var submit$2="Gửi";var subtitleLanguage$2="Ngôn ngữ phụ đề";var tagName$2="Tên thẻ";var tagNameLessThan50Char$2="Tên thẻ phải ít hơn 50 ký tự";var tags$2="Thẻ";var theatre$2="Rạp chiếu phim";var theatreAlreadySelectedInList$2="Rạp chiếu phim này đã được chọn trong danh sách.";var theatreCountMatched_one$2="{{count}} Rạp chiếu phim phù hợp";var theatreCountMatched_other$2="{{count}} Rạp chiếu phim phù hợp";var theatreCount_one$2="{{count}} Rạp chiếu phim";var theatreCount_other$2="{{count}} Rạp chiếu phim";var theatreDetails$2="Chi tiết Rạp chiếu phim";var theatreListNameAlreadyExists$2="Tên danh sách Rạp chiếu phim đã tồn tại";var theatreName$2="Tên Rạp chiếu phim";var theatres$2="Rạp chiếu phim";var theatresListCreated$2="Danh sách Rạp chiếu phim đã được tạo";var theatresListDeleted$2="Danh sách Rạp chiếu phim đã bị xóa";var theatresListUpdated$2="Danh sách Rạp chiếu phim đã được cập nhật";var thisPageDoesNotExist$2="Trang này không tồn tại.";var to$2="Đến";var totalDriveCount_one$2="{{count}} ổ đĩa";var totalDriveCount_other$2="{{count}} ổ đĩa";var trackingNumber$2="Số theo dõi";var transitional$2="Chuyển giao";var type$2="Loại";var unarchivalMayTake$2="Quá trình mở lưu trữ có thể mất";var unknown$2="Không xác định";var update$2="Cập nhật";var updateAccess$2="Cập nhật quyền truy cập";var updateDelivery$2="Cập nhật giao hàng";var uploadShipmentInformation$2="Tải lên thông tin vận chuyển";var uploadingCsv$2="Đang tải lên CSV";var users$2="Người dùng";var view$2="Xem";var viewDetails$2="Xem chi tiết";var viewMore$2="Xem thêm";var workorder$2="Đơn đặt hàng";var yes$2="Có";var yesClear$2="Có, Xóa";var yesDelete$2="Có, Xóa";var vi = {add:add$2,addAccess:addAccess$2,addAnotherRole:addAnotherRole$2,addToList:addToList$2,addToNewList:addToNewList$2,address:address$2,advertisement:advertisement$2,alternateNames:alternateNames$2,applianceBusyInDuplicating:applianceBusyInDuplicating$2,aspectRatio:aspectRatio$2,audio:audio$2,audioFormat:audioFormat$2,back:back$2,bandwidth:bandwidth$2,booking:booking$2,cancel:cancel$4,cancelled:cancelled$2,cancelledCount:cancelledCount$2,chain:chain$2,clear:clear$2,clearAll:clearAll$2,clearTheatreSelection:clearTheatreSelection$2,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation$2,closedCaptions:closedCaptions$2,closedSubtitles:closedSubtitles$2,comments:comments$2,companyTheatreLocation:companyTheatreLocation$2,composition:composition$2,compositionDetails:compositionDetails$2,compositionTags:compositionTags$2,compositions:compositions$2,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning$2,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent$2,contentSize:contentSize$2,conventionLink:conventionLink$2,copiedCount:copiedCount$2,copyCompleted:copyCompleted$2,copyFailed:copyFailed$2,copyPending:copyPending$2,copyQueued:copyQueued$2,copyStatus:copyStatus$2,courierType:courierType$2,cplFormat:cplFormat$2,cplId:cplId$2,cplMarkers:cplMarkers$2,cplMetadata:cplMetadata$2,create:create$3,createModal:createModal$2,createTag:createTag$2,createdBy:createdBy$2,createdOn:createdOn$2,creditOffset:creditOffset$2,creditsOffset:creditsOffset$2,creditsValue:creditsValue$2,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect$2,dcp:dcp$2,dcpStatus:dcpStatus$2,dcpTransferCompleted:dcpTransferCompleted$2,dcpTransferNotStarted:dcpTransferNotStarted$2,dcpTransferStarted:dcpTransferStarted$2,deactivatedUser:deactivatedUser$2,"delete":"Xóa",deleteList:deleteList$2,deleteListConfirmation:deleteListConfirmation$2,deliverBefore:deliverBefore$2,deliverBy:deliverBy$2,deliveries:deliveries$2,delivery:delivery$2,deliveryInstructions:deliveryInstructions$2,download:download$2,downloadCompleted:downloadCompleted$2,downloadDetails:downloadDetails$2,downloadFailed:downloadFailed$2,downloadKdms:downloadKdms$2,downloadNotStarted:downloadNotStarted$2,downloadPending:downloadPending$2,downloadQueued:downloadQueued$2,downloadScheduled:downloadScheduled$2,downloadShipmentInformation:downloadShipmentInformation$2,downloadStatus:downloadStatus$2,downloadYetToStart:downloadYetToStart$2,downloaded:downloaded$2,downloading:downloading$2,downloadingArchived:downloadingArchived$2,downloadingPercentage:downloadingPercentage$2,downloadingStalled:downloadingStalled$2,downloadingUnarchiving:downloadingUnarchiving$2,driveCopy:driveCopy$2,driveNotHaveContent:driveNotHaveContent$2,drivesCount_one:drivesCount_one$2,drivesCount_other:drivesCount_other$2,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one$2,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other$2,duplicatingWoInBay:duplicatingWoInBay$2,duplicationStatus:duplicationStatus$2,duration:duration$2,editTag:editTag$2,editTheatreList:editTheatreList$2,email:email$2,emailKDMS:emailKDMS$2,enterNameOfList:enterNameOfList$2,enterNameOfNewList:enterNameOfNewList$2,enterTagName:enterTagName$2,enterTrackingNumber:enterTrackingNumber$2,errorFetchingDownloadStatus:errorFetchingDownloadStatus$2,errorGettingTheatre:errorGettingTheatre$2,errorWhileAddingGroup:errorWhileAddingGroup$2,errorWhileUpdatingGroup:errorWhileUpdatingGroup$2,festivals:festivals$2,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait$2,ffec:ffec$2,ffmc:ffmc$2,filterBy:filterBy$2,firstFrameEndCredits:firstFrameEndCredits$2,firstFrameMovingCredits:firstFrameMovingCredits$2,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one$2,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other$2,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$2,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$2,format:format$2,frameRate:frameRate$2,from:from$2,fromTimeOfBooking:fromTimeOfBooking$2,group:group$2,groupAddedToUser:groupAddedToUser$2,groupUpdatedForUser:groupUpdatedForUser$2,hasAccessTo:hasAccessTo$2,hourCount_one:hourCount_one$2,hourCount_other:hourCount_other$2,id_one:id_one$2,id_other:id_other$2,inProgressCount:inProgressCount$2,inactiveScreen:inactiveScreen$2,insertedDrivesCount:insertedDrivesCount$2,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId$2,invitedUser:invitedUser$2,kdm:kdm$2,kdmDetails:kdmDetails$2,languages:languages$2,lastUpdatedBy:lastUpdatedBy$2,lastUpdatedOn:lastUpdatedOn$2,listName:listName$2,listUpdated:listUpdated$2,lists:lists$2,location:location$2,mainCaptions:mainCaptions$2,maintenance:maintenance$2,maintenanceDescription:maintenanceDescription$2,manage:manage$2,markAsDelivered:markAsDelivered$2,markAsPending:markAsPending$2,markAsShipped:markAsShipped$2,minuteCount_one:minuteCount_one$2,minuteCount_other:minuteCount_other$2,name:name$2,no:no$2,noAccess:noAccess$2,noActiveDeviceInScreen:noActiveDeviceInScreen$2,noAppliancesFound:noAppliancesFound$2,noCompositions:noCompositions$2,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound$2,noKeepList:noKeepList$2,noKeepSelection:noKeepSelection$2,noListsFound:noListsFound$2,noPlyDeviceInScreen:noPlyDeviceInScreen$2,noRecordsfound:noRecordsfound$2,noResultsFound:noResultsFound$2,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne$2,noTheatresAreSelected:noTheatresAreSelected$2,noTheatresFound:noTheatresFound$2,none:none$2,notFound:notFound$2,notes:notes$2,oops:oops$2,osVersion:osVersion$2,partner:partner$2,pendingCancellation:pendingCancellation$2,pendingCancellationCount:pendingCancellationCount$2,pendingCount:pendingCount$2,picture:picture$2,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound$2,preparingToCopy:preparingToCopy$2,publicIp:publicIp$2,ratings:ratings$2,rejected:rejected$2,rejectedCount:rejectedCount$2,resolution:resolution$2,resultsFor:resultsFor$2,"return":"Trở lại",role:role$2,roles:roles$2,rowMatchedCount_one:rowMatchedCount_one$2,rowMatchedCount_other:rowMatchedCount_other$2,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one$2,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other$2,save:save$2,screen:screen$2,screenCount_one:screenCount_one$2,screenCount_other:screenCount_other$2,screenNonDciComplaints:screenNonDciComplaints$2,screenNotHaveCertificate:screenNotHaveCertificate$2,screens:screens$2,search:search$2,searchAndAddTags:searchAndAddTags$2,searchAndSelectTheatres:searchAndSelectTheatres$2,searchForTheatreList:searchForTheatreList$2,searchForTheatres:searchForTheatres$2,selectCourierType:selectCourierType$2,selectDcpTransferStatus:selectDcpTransferStatus$2,selectOption:selectOption$2,selectTheatreCount_one:selectTheatreCount_one$2,selectTheatreCount_other:selectTheatreCount_other$2,selectTheatres:selectTheatres$2,selectUsingCsv:selectUsingCsv$2,selectedTheatres:selectedTheatres$2,serialNumber:serialNumber$2,shipBy:shipBy$2,shipmentNo:shipmentNo$2,shipmentStatus:shipmentStatus$2,shipped:shipped$2,shipping:shipping$2,shippingInformation:shippingInformation$2,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus$2,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation$2,spokenLanguage:spokenLanguage$2,stageCopyingContentToDrives:stageCopyingContentToDrives$2,stageFormattingDrives:stageFormattingDrives$2,stageVerifying:stageVerifying$2,startCopying:startCopying$2,status:status$2,submit:submit$2,subtitleLanguage:subtitleLanguage$2,tagName:tagName$2,tagNameLessThan50Char:tagNameLessThan50Char$2,tags:tags$2,theatre:theatre$2,theatreAlreadySelectedInList:theatreAlreadySelectedInList$2,theatreCountMatched_one:theatreCountMatched_one$2,theatreCountMatched_other:theatreCountMatched_other$2,theatreCount_one:theatreCount_one$2,theatreCount_other:theatreCount_other$2,theatreDetails:theatreDetails$2,theatreListNameAlreadyExists:theatreListNameAlreadyExists$2,theatreName:theatreName$2,theatres:theatres$2,theatresListCreated:theatresListCreated$2,theatresListDeleted:theatresListDeleted$2,theatresListUpdated:theatresListUpdated$2,thisPageDoesNotExist:thisPageDoesNotExist$2,to:to$2,totalDriveCount_one:totalDriveCount_one$2,totalDriveCount_other:totalDriveCount_other$2,trackingNumber:trackingNumber$2,transitional:transitional$2,type:type$2,unarchivalMayTake:unarchivalMayTake$2,unknown:unknown$2,update:update$2,updateAccess:updateAccess$2,updateDelivery:updateDelivery$2,uploadShipmentInformation:uploadShipmentInformation$2,uploadingCsv:uploadingCsv$2,users:users$2,view:view$2,viewDetails:viewDetails$2,viewMore:viewMore$2,workorder:workorder$2,yes:yes$2,yesClear:yesClear$2,yesDelete:yesDelete$2};

var add$1="Adicionar";var addAccess$1="Adicionar acesso";var addAnotherRole$1="Adicionar outro papel";var addToList$1="Adicionar à lista";var addToNewList$1="Adicionar a uma nova lista";var address$1="Endereço";var advertisement$1="Anúncio";var alternateNames$1="Nomes alternativos";var applianceBusyInDuplicating$1="Este aparelho está ocupado duplicando a ordem de trabalho ";var aspectRatio$1="Proporção de aspecto";var audio$1="Áudio";var audioFormat$1="Formato de áudio";var back$1="Voltar";var bandwidth$1="Largura de banda";var booking$1="Booking";var cancel$3="Cancelar";var cancelled$1="Cancelado";var cancelledCount$1="{{itemCount}} Cancelado(s)";var chain$1="Cadeia";var clear$1="Limpar";var clearAll$1="Limpar tudo";var clearTheatreSelection$1="Limpar seleção do cinema";var clearTheatreSelectionConfirmation$1="Tem certeza de que deseja limpar a seleção?";var closedCaptions$1="Legendas ocultas";var closedSubtitles$1="Legendas ocultas";var comments$1="Comentários";var companyTheatreLocation$1="Empresa/Cinema/Localização";var composition$1="Composição";var compositionDetails$1="Detalhes da composição";var compositionTags$1="Etiquetas de composição";var compositions$1="Composições";var contentIsLessThan8GBWarning$1="Este conteúdo tem menos de 8GB e pode ser enviado por meio de mídia menor e mais econômica (por exemplo, pen drive USB)";var contentIsLessThan8GBWarningContent$1="Se este pedido for atendido usando mídia alternativa, lembre-se de atualizar seu inventário de unidades de armazenamento de acordo.";var contentSize$1="Tamanho do conteúdo";var conventionLink$1="Dados do nome da composição com base na <1>Digital Cinema Naming Convention</1>";var copiedCount$1="{{itemCount}} Copiado(s)";var copyCompleted$1="Cópia concluída";var copyFailed$1="Falha na cópia";var copyPending$1="Cópia pendente";var copyQueued$1="Cópia agendada";var copyStatus$1="Estado de Cópia";var courierType$1="Tipo de correio";var cplFormat$1="Formato CPL";var cplId$1="ID CPL";var cplMarkers$1="Marcadores CPL";var cplMetadata$1="Metadados CPL";var create$2="Criar";var createModal$1="Criar Modal";var createTag$1="Criar Tag";var createdBy$1="Criado por";var createdOn$1="Criado em";var creditOffset$1="Deslocamento de crédito";var creditsOffset$1="Deslocamento de créditos";var creditsValue$1="Créditos: {{value}}";var csvColumnsForTheatreSelect$1="Colunas CSV: ID da Tela, ID do Cinema, Nome, Cidade, Estado, País, Área, Nome da Rede";var dcp$1="DCP";var dcpStatus$1="Estado do DCP";var dcpTransferCompleted$1="Transferência de DCP concluída";var dcpTransferNotStarted$1="Transferência de DCP não iniciada";var dcpTransferStarted$1="Transferência de DCP iniciada";var deactivatedUser$1="Utilizador Desativado";var deleteList$1="Excluir Lista";var deleteListConfirmation$1="Tem certeza de que deseja excluir esta lista?";var deliverBefore$1="Entregar antes de";var deliverBy$1="Entregar até";var deliveries$1="Entregas";var delivery$1="Entrega";var deliveryInstructions$1="Instruções de entrega";var download$1="Baixar";var downloadCompleted$1="Download concluído";var downloadDetails$1="Detalhes do download";var downloadFailed$1="Falha no download";var downloadKdms$1="Baixar KDMs";var downloadNotStarted$1="Download não iniciado";var downloadPending$1="Download pendente";var downloadQueued$1="Download agendado";var downloadScheduled$1="Download agendado";var downloadShipmentInformation$1="Baixar informações de remessa";var downloadStatus$1="Estado de Download";var downloadYetToStart$1="Download ainda não iniciado";var downloaded$1="Baixado";var downloading$1="Baixando";var downloadingArchived$1="Baixando - Arquivado";var downloadingPercentage$1="Baixando {{percentage}} %";var downloadingStalled$1="Baixando - Estagnado";var downloadingUnarchiving$1="Baixando - Desarquivando";var driveCopy$1="Cópia do drive";var driveNotHaveContent$1="O drive não tem conteúdo";var drivesCount_one$1="{{count}} unidade";var drivesCount_other$1="{{count}} unidades";var duplicateRowWasIgnored_one$1="{{count}} linha duplicada foi ignorada";var duplicateRowWasIgnored_other$1="{{count}} linhas duplicadas foram ignoradas";var duplicatingWoInBay$1="Duplicando a ordem de serviço {{workOrderNo}} na baia";var duplicationStatus$1="Estado de Duplicação";var duration$1="Duração";var editTag$1="Editar etiqueta";var editTheatreList$1="Editar Lista de Cinemas";var email$1="E-mail";var emailKDMS$1="Enviar KDMs por e-mail";var enterNameOfList$1="Digite o nome da lista";var enterNameOfNewList$1="Digite o nome da nova lista";var enterTagName$1="Digite o nome da tag";var enterTrackingNumber$1="Digite o número de rastreamento";var errorFetchingDownloadStatus$1="Erro ao Obter Estado de Download";var errorGettingTheatre$1="Erro ao Obter Cinema";var errorWhileAddingGroup$1="Erro ao adicionar grupo";var errorWhileUpdatingGroup$1="Erro ao atualizar grupo";var festivals$1="Festivais";var fetchingDetailsPleaseWait$1="Buscando detalhes. Aguarde, por favor";var ffec$1="FFEC";var ffmc$1="FFMC";var filterBy$1="Filtrar por";var firstFrameEndCredits$1="Primeiro quadro - Créditos finais";var firstFrameMovingCredits$1="Primeiro quadro - Créditos em movimento";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one$1="A seguinte linha duplicada que coincidiu com a tela foi ignorada";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other$1="As seguintes {{count}} linhas duplicadas que coincidiram com a tela foram ignoradas";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$1="A seguinte linha duplicada que corresponde ao cinema é ignorada";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$1="As seguintes {{count}} linhas duplicadas que correspondem ao cinema são ignoradas";var format$1="Formato";var frameRate$1="Taxa de quadros";var from$1="De";var fromTimeOfBooking$1="a partir do momento da booking";var group$1="Grupo";var groupAddedToUser$1="Grupo adicionado ao utilizador";var groupUpdatedForUser$1="Grupo atualizado para o utilizador";var hasAccessTo$1="Tem acesso a";var hourCount_one$1="{{count}} hora";var hourCount_other$1="{{count}} horas";var id_one$1="ID";var id_other$1="IDs";var inProgressCount$1="{{itemCount}} em andamento";var inactiveScreen$1="Tela inativa";var insertedDrivesCount$1="{{itemCount}} unidades inseridas";var invalidFileNoTheatreNameOrId$1="Arquivo inválido. Não há nome ou ID do cinema";var invitedUser$1="Utilizador Convidado";var kdm$1="KDM";var kdmDetails$1="Detalhes do KDM";var languages$1="Idiomas";var lastUpdatedBy$1="Última atualização por";var lastUpdatedOn$1="Última atualização em";var listName$1="Nome da lista";var listUpdated$1="Lista atualizada";var lists$1="Listas";var location$1="Localização";var mainCaptions$1="Legendas principais";var maintenance$1="Manutenção";var maintenanceDescription$1="O Qube Wire está atualmente em manutenção. Estaremos de volta em breve.";var manage$1="Gerenciar";var markAsDelivered$1="Marcar como entregue";var markAsPending$1="Marcar como pendente";var markAsShipped$1="Marcar como enviado";var minuteCount_one$1="{{count}} minuto";var minuteCount_other$1="{{count}} minutos";var name$1="Nome";var no$1="Não";var noAccess$1="Sem acesso";var noActiveDeviceInScreen$1="Nenhum dispositivo ativo na tela";var noAppliancesFound$1="Nenhum dispositivo encontrado";var noCompositions$1="Sem composições";var noItemTypeInWorkOrderFound$1="Nenhum {{type}} encontrado na ordem de serviço";var noKeepList$1="Não, manter a lista";var noKeepSelection$1="Não, manter a seleção";var noListsFound$1="Nenhuma lista encontrada";var noPlyDeviceInScreen$1="Nenhum dispositivo de reprodução na tela";var noRecordsfound$1="Nenhum registro encontrado";var noResultsFound$1="Nenhum resultado encontrado";var noTagsFoundClickHereToCreateOne$1="Nenhuma tag encontrada. Clique <1>aqui</1> para criar uma";var noTheatresAreSelected$1="Nenhum cinema selecionado";var noTheatresFound$1="Nenhum cinema encontrado";var none$1="Nenhum";var notFound$1="Não encontrado";var notes$1="Notas";var oops$1="Ops!";var osVersion$1="Versão do sistema operacional";var partner$1="Parceiro";var pendingCancellation$1="Cancelamento pendente";var pendingCancellationCount$1="{{itemCount}} Cancelamento pendente";var pendingCount$1="{{itemCount}} Pendente";var picture$1="Foto";var preciseMatchForTheatresNotFound$1="Não foi possível encontrar uma correspondência precisa para estes cinemas.";var preparingToCopy$1="Preparando para copiar";var publicIp$1="IP público";var ratings$1="Avaliações";var rejected$1="Rejeitado";var rejectedCount$1="{{itemCount}} Rejeitado";var resolution$1="Resolução";var resultsFor$1="Resultados para";var role$1="Função";var roles$1="Funções";var rowMatchedCount_one$1="{{count}} linha correspondente";var rowMatchedCount_other$1="{{count}} linhas correspondentes";var rowWithoutNameAndIdIgnored_one$1="{{count}} linha sem nome e ID foi ignorada";var rowWithoutNameAndIdIgnored_other$1="{{count}} linhas sem nome e ID foram ignoradas";var save$1="Salvar";var screen$1="Tela";var screenCount_one$1="{{count}} Tela";var screenCount_other$1="{{count}} Telas";var screenNonDciComplaints$1="A tela não tem reclamações DCI";var screenNotHaveCertificate$1="A tela não tem certificado de dispositivo";var screens$1="Telas";var search$1="Procurar";var searchAndAddTags$1="Procurar e Adicionar Etiquetas";var searchAndSelectTheatres$1="Procurar e Selecionar Cinemas";var searchForTheatreList$1="Procurar lista de cinemas";var searchForTheatres$1="Procurar cinemas";var selectCourierType$1="Selecionar tipo de mensageiro";var selectDcpTransferStatus$1="Selecionar Estado de Transferência do DCP";var selectOption$1="Selecionar opção";var selectTheatreCount_one$1="Selecionar {{count}} Cinema";var selectTheatreCount_other$1="Selecionar {{count}} Cinemas";var selectTheatres$1="Selecionar Cinemas";var selectUsingCsv$1="Selecionar usando CSV";var selectedTheatres$1="Cinemas Selecionados";var serialNumber$1="Número de série";var shipBy$1="Enviar por";var shipmentNo$1="Número de envio";var shipmentStatus$1="Estado de Envio";var shipped$1="Enviado";var shipping$1="Envio";var shippingInformation$1="Informações de envio";var someErrorInGettingDownloadStatus$1="Erro ao Obter Estado de Download";var someScreensHaveMissingDeviceInformation$1="Algumas telas têm informações de dispositivo ausentes";var spokenLanguage$1="Idioma falado";var stageCopyingContentToDrives$1="Etapa 2 de 3: Copiando conteúdo para os drives";var stageFormattingDrives$1="Etapa 1 de 3: Formatando os drives";var stageVerifying$1="Etapa 3 de 3: Verificando";var startCopying$1="Iniciar a cópia";var status$1="Estado";var submit$1="Enviar";var subtitleLanguage$1="Idioma da legenda";var tagName$1="Nome da tag";var tagNameLessThan50Char$1="O nome da tag deve ter menos de 50 caracteres";var tags$1="Tags";var theatre$1="Cinema";var theatreAlreadySelectedInList$1="Este cinema já está selecionado na lista.";var theatreCountMatched_one$1="{{count}} Cinema correspondido";var theatreCountMatched_other$1="{{count}} Cinemas correspondidos";var theatreCount_one$1="{{count}} Cinema";var theatreCount_other$1="{{count}} Cinemas";var theatreDetails$1="Detalhes do Cinema";var theatreListNameAlreadyExists$1="O nome da lista de cinemas já existe";var theatreName$1="Nome do Cinema";var theatres$1="Cinemas";var theatresListCreated$1="Lista de Cinemas criada";var theatresListDeleted$1="Lista de Cinemas excluída";var theatresListUpdated$1="Lista de Cinemas atualizada";var thisPageDoesNotExist$1="Esta página não existe.";var to$1="Para";var totalDriveCount_one$1="{{count}} Drive";var totalDriveCount_other$1="{{count}} Drives";var trackingNumber$1="Número de rastreamento";var transitional$1="Transicional";var type$1="Tipo";var unarchivalMayTake$1="A desarquivamento pode levar";var unknown$1="Desconhecido";var update$1="Atualizar";var updateAccess$1="Atualizar acesso";var updateDelivery$1="Atualizar entrega";var uploadShipmentInformation$1="Enviar informações de envio";var uploadingCsv$1="Enviando CSV";var users$1="Utilizadores";var view$1="Visualizar";var viewDetails$1="Visualizar detalhes";var viewMore$1="Ver mais";var workorder$1="Ordem de serviço";var yes$1="Sim";var yesClear$1="Sim, limpar";var yesDelete$1="Sim, excluir";var pt = {add:add$1,addAccess:addAccess$1,addAnotherRole:addAnotherRole$1,addToList:addToList$1,addToNewList:addToNewList$1,address:address$1,advertisement:advertisement$1,alternateNames:alternateNames$1,applianceBusyInDuplicating:applianceBusyInDuplicating$1,aspectRatio:aspectRatio$1,audio:audio$1,audioFormat:audioFormat$1,back:back$1,bandwidth:bandwidth$1,booking:booking$1,cancel:cancel$3,cancelled:cancelled$1,cancelledCount:cancelledCount$1,chain:chain$1,clear:clear$1,clearAll:clearAll$1,clearTheatreSelection:clearTheatreSelection$1,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation$1,closedCaptions:closedCaptions$1,closedSubtitles:closedSubtitles$1,comments:comments$1,companyTheatreLocation:companyTheatreLocation$1,composition:composition$1,compositionDetails:compositionDetails$1,compositionTags:compositionTags$1,compositions:compositions$1,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning$1,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent$1,contentSize:contentSize$1,conventionLink:conventionLink$1,copiedCount:copiedCount$1,copyCompleted:copyCompleted$1,copyFailed:copyFailed$1,copyPending:copyPending$1,copyQueued:copyQueued$1,copyStatus:copyStatus$1,courierType:courierType$1,cplFormat:cplFormat$1,cplId:cplId$1,cplMarkers:cplMarkers$1,cplMetadata:cplMetadata$1,create:create$2,createModal:createModal$1,createTag:createTag$1,createdBy:createdBy$1,createdOn:createdOn$1,creditOffset:creditOffset$1,creditsOffset:creditsOffset$1,creditsValue:creditsValue$1,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect$1,dcp:dcp$1,dcpStatus:dcpStatus$1,dcpTransferCompleted:dcpTransferCompleted$1,dcpTransferNotStarted:dcpTransferNotStarted$1,dcpTransferStarted:dcpTransferStarted$1,deactivatedUser:deactivatedUser$1,"delete":"Excluir",deleteList:deleteList$1,deleteListConfirmation:deleteListConfirmation$1,deliverBefore:deliverBefore$1,deliverBy:deliverBy$1,deliveries:deliveries$1,delivery:delivery$1,deliveryInstructions:deliveryInstructions$1,download:download$1,downloadCompleted:downloadCompleted$1,downloadDetails:downloadDetails$1,downloadFailed:downloadFailed$1,downloadKdms:downloadKdms$1,downloadNotStarted:downloadNotStarted$1,downloadPending:downloadPending$1,downloadQueued:downloadQueued$1,downloadScheduled:downloadScheduled$1,downloadShipmentInformation:downloadShipmentInformation$1,downloadStatus:downloadStatus$1,downloadYetToStart:downloadYetToStart$1,downloaded:downloaded$1,downloading:downloading$1,downloadingArchived:downloadingArchived$1,downloadingPercentage:downloadingPercentage$1,downloadingStalled:downloadingStalled$1,downloadingUnarchiving:downloadingUnarchiving$1,driveCopy:driveCopy$1,driveNotHaveContent:driveNotHaveContent$1,drivesCount_one:drivesCount_one$1,drivesCount_other:drivesCount_other$1,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one$1,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other$1,duplicatingWoInBay:duplicatingWoInBay$1,duplicationStatus:duplicationStatus$1,duration:duration$1,editTag:editTag$1,editTheatreList:editTheatreList$1,email:email$1,emailKDMS:emailKDMS$1,enterNameOfList:enterNameOfList$1,enterNameOfNewList:enterNameOfNewList$1,enterTagName:enterTagName$1,enterTrackingNumber:enterTrackingNumber$1,errorFetchingDownloadStatus:errorFetchingDownloadStatus$1,errorGettingTheatre:errorGettingTheatre$1,errorWhileAddingGroup:errorWhileAddingGroup$1,errorWhileUpdatingGroup:errorWhileUpdatingGroup$1,festivals:festivals$1,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait$1,ffec:ffec$1,ffmc:ffmc$1,filterBy:filterBy$1,firstFrameEndCredits:firstFrameEndCredits$1,firstFrameMovingCredits:firstFrameMovingCredits$1,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one$1,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other$1,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one$1,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other$1,format:format$1,frameRate:frameRate$1,from:from$1,fromTimeOfBooking:fromTimeOfBooking$1,group:group$1,groupAddedToUser:groupAddedToUser$1,groupUpdatedForUser:groupUpdatedForUser$1,hasAccessTo:hasAccessTo$1,hourCount_one:hourCount_one$1,hourCount_other:hourCount_other$1,id_one:id_one$1,id_other:id_other$1,inProgressCount:inProgressCount$1,inactiveScreen:inactiveScreen$1,insertedDrivesCount:insertedDrivesCount$1,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId$1,invitedUser:invitedUser$1,kdm:kdm$1,kdmDetails:kdmDetails$1,languages:languages$1,lastUpdatedBy:lastUpdatedBy$1,lastUpdatedOn:lastUpdatedOn$1,listName:listName$1,listUpdated:listUpdated$1,lists:lists$1,location:location$1,mainCaptions:mainCaptions$1,maintenance:maintenance$1,maintenanceDescription:maintenanceDescription$1,manage:manage$1,markAsDelivered:markAsDelivered$1,markAsPending:markAsPending$1,markAsShipped:markAsShipped$1,minuteCount_one:minuteCount_one$1,minuteCount_other:minuteCount_other$1,name:name$1,no:no$1,noAccess:noAccess$1,noActiveDeviceInScreen:noActiveDeviceInScreen$1,noAppliancesFound:noAppliancesFound$1,noCompositions:noCompositions$1,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound$1,noKeepList:noKeepList$1,noKeepSelection:noKeepSelection$1,noListsFound:noListsFound$1,noPlyDeviceInScreen:noPlyDeviceInScreen$1,noRecordsfound:noRecordsfound$1,noResultsFound:noResultsFound$1,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne$1,noTheatresAreSelected:noTheatresAreSelected$1,noTheatresFound:noTheatresFound$1,none:none$1,notFound:notFound$1,notes:notes$1,oops:oops$1,osVersion:osVersion$1,partner:partner$1,pendingCancellation:pendingCancellation$1,pendingCancellationCount:pendingCancellationCount$1,pendingCount:pendingCount$1,picture:picture$1,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound$1,preparingToCopy:preparingToCopy$1,publicIp:publicIp$1,ratings:ratings$1,rejected:rejected$1,rejectedCount:rejectedCount$1,resolution:resolution$1,resultsFor:resultsFor$1,"return":"Retorno",role:role$1,roles:roles$1,rowMatchedCount_one:rowMatchedCount_one$1,rowMatchedCount_other:rowMatchedCount_other$1,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one$1,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other$1,save:save$1,screen:screen$1,screenCount_one:screenCount_one$1,screenCount_other:screenCount_other$1,screenNonDciComplaints:screenNonDciComplaints$1,screenNotHaveCertificate:screenNotHaveCertificate$1,screens:screens$1,search:search$1,searchAndAddTags:searchAndAddTags$1,searchAndSelectTheatres:searchAndSelectTheatres$1,searchForTheatreList:searchForTheatreList$1,searchForTheatres:searchForTheatres$1,selectCourierType:selectCourierType$1,selectDcpTransferStatus:selectDcpTransferStatus$1,selectOption:selectOption$1,selectTheatreCount_one:selectTheatreCount_one$1,selectTheatreCount_other:selectTheatreCount_other$1,selectTheatres:selectTheatres$1,selectUsingCsv:selectUsingCsv$1,selectedTheatres:selectedTheatres$1,serialNumber:serialNumber$1,shipBy:shipBy$1,shipmentNo:shipmentNo$1,shipmentStatus:shipmentStatus$1,shipped:shipped$1,shipping:shipping$1,shippingInformation:shippingInformation$1,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus$1,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation$1,spokenLanguage:spokenLanguage$1,stageCopyingContentToDrives:stageCopyingContentToDrives$1,stageFormattingDrives:stageFormattingDrives$1,stageVerifying:stageVerifying$1,startCopying:startCopying$1,status:status$1,submit:submit$1,subtitleLanguage:subtitleLanguage$1,tagName:tagName$1,tagNameLessThan50Char:tagNameLessThan50Char$1,tags:tags$1,theatre:theatre$1,theatreAlreadySelectedInList:theatreAlreadySelectedInList$1,theatreCountMatched_one:theatreCountMatched_one$1,theatreCountMatched_other:theatreCountMatched_other$1,theatreCount_one:theatreCount_one$1,theatreCount_other:theatreCount_other$1,theatreDetails:theatreDetails$1,theatreListNameAlreadyExists:theatreListNameAlreadyExists$1,theatreName:theatreName$1,theatres:theatres$1,theatresListCreated:theatresListCreated$1,theatresListDeleted:theatresListDeleted$1,theatresListUpdated:theatresListUpdated$1,thisPageDoesNotExist:thisPageDoesNotExist$1,to:to$1,totalDriveCount_one:totalDriveCount_one$1,totalDriveCount_other:totalDriveCount_other$1,trackingNumber:trackingNumber$1,transitional:transitional$1,type:type$1,unarchivalMayTake:unarchivalMayTake$1,unknown:unknown$1,update:update$1,updateAccess:updateAccess$1,updateDelivery:updateDelivery$1,uploadShipmentInformation:uploadShipmentInformation$1,uploadingCsv:uploadingCsv$1,users:users$1,view:view$1,viewDetails:viewDetails$1,viewMore:viewMore$1,workorder:workorder$1,yes:yes$1,yesClear:yesClear$1,yesDelete:yesDelete$1};

var add="新增";var addAccess="新增存取權";var addAnotherRole="新增另一個角色";var addToList="新增至清單";var addToNewList="新增至新清單";var address="地址";var advertisement="廣告";var alternateNames="替代名稱";var applianceBusyInDuplicating="該設備正在複製工單中";var aspectRatio="寬高比";var audio="音頻";var audioFormat="音頻格式";var back="返回";var bandwidth="頻寬";var booking="預訂";var cancel$2="取消";var cancelled="已取消";var cancelledCount="{{itemCount}} 已取消";var chain="鏈";var clear="清除";var clearAll="全部清除";var clearTheatreSelection="清除劇院選擇";var clearTheatreSelectionConfirmation="確定要清除選擇嗎？";var closedCaptions="封閉字幕";var closedSubtitles="封閉字幕";var comments="評論";var companyTheatreLocation="公司/劇院/地點";var composition="組合";var compositionDetails="組合詳情";var compositionTags="組合標籤";var compositions="組合";var contentIsLessThan8GBWarning="此內容小於8GB，可使用更小、更具成本效益的媒體（即USB隨身碟）傳送";var contentIsLessThan8GBWarningContent="如果此工單將使用替代媒體履行，請記得相應更新您的儲存設備清單。";var contentSize="內容大小";var conventionLink="根據<1>Digital Cinema Naming Convention</1>基於組合名的數據";var copiedCount="{{itemCount}} 已複製";var copyCompleted="複製完成";var copyFailed="複製失敗";var copyPending="複製待定";var copyQueued="複製排隊中";var copyStatus="複製狀態";var courierType="快遞類型";var cplFormat="CPL格式";var cplId="CPL ID";var cplMarkers="CPL標記";var cplMetadata="CPL元數據";var create$1="創建";var createModal="創建模式";var createTag="創建標籤";var createdBy="創建者";var createdOn="創建時間";var creditOffset="信用偏移";var creditsOffset="學分偏移";var creditsValue="學分：{{value}}";var csvColumnsForTheatreSelect="CSV列：屏幕ID、劇院ID、名稱、城市、州、國家、區域、鏈名";var dcp="DCP";var dcpStatus="DCP狀態";var dcpTransferCompleted="DCP傳輸已完成";var dcpTransferNotStarted="DCP傳輸尚未開始";var dcpTransferStarted="DCP傳輸已啟動";var deactivatedUser="停用用戶";var deleteList="刪除列表";var deleteListConfirmation="您確定要刪除此列表嗎？";var deliverBefore="交付截止日期";var deliverBy="交付截止日期";var deliveries="交付";var delivery="交付";var deliveryInstructions="交付說明";var download="下載";var downloadCompleted="下載完成";var downloadDetails="下載詳情";var downloadFailed="下載失敗";var downloadKdms="下載KDM";var downloadNotStarted="尚未開始下載";var downloadPending="下載待處理";var downloadQueued="下載排隊中";var downloadScheduled="預定下載";var downloadShipmentInformation="下載運輸信息";var downloadStatus="下載狀態";var downloadYetToStart="尚未開始下載";var downloaded="已下載";var downloading="下載中";var downloadingArchived="下載中 - 存檔中";var downloadingPercentage="下載 {{percentage}} %";var downloadingStalled="下載中 - 停滯中";var downloadingUnarchiving="下載中 - 解壓縮中";var driveCopy="驅動器複製";var driveNotHaveContent="驅動器沒有任何內容";var drivesCount_one="{{count}} 隻驅動器";var drivesCount_other="{{count}} 隻驅動器";var duplicateRowWasIgnored_one="{{count}} 重複的行被忽略";var duplicateRowWasIgnored_other="{{count}} 重複的行被忽略";var duplicatingWoInBay="在 Bay 中複製 {{workOrderNo}}";var duplicationStatus="複製狀態";var duration="持續時間";var editTag="編輯標籤";var editTheatreList="编辑剧场列表";var email="電子郵件";var emailKDMS="郵件 KDMs";var enterNameOfList="輸入清單名稱";var enterNameOfNewList="輸入新清單名稱";var enterTagName="輸入標籤名稱";var enterTrackingNumber="輸入追踪號碼";var errorFetchingDownloadStatus="獲取下載狀態錯誤";var errorGettingTheatre="獲取劇院錯誤";var errorWhileAddingGroup="添加群組時出錯";var errorWhileUpdatingGroup="更新群組時出錯";var festivals="節慶";var fetchingDetailsPleaseWait="正在獲取詳細信息，請稍候";var ffec="FFEC";var ffmc="FFMC";var filterBy="篩選";var firstFrameEndCredits="第一幀結尾字幕";var firstFrameMovingCredits="第一幀移動字幕";var followingDuplicateRowThatMatchedTheScreenAreIgnored_one="以下匹配屏幕的重複行被忽略";var followingDuplicateRowThatMatchedTheScreenAreIgnored_other="以下匹配屏幕的 {{count}} 個重複行被忽略";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_one="以下匹配劇院的重複行被忽略";var followingDuplicateRowThatMatchedTheTheatreAreIgnored_other="以下匹配劇院的 {{count}} 個重複行被忽略";var format="格式";var frameRate="幀速率";var from="从";var fromTimeOfBooking="從預訂時間開始";var group="群組";var groupAddedToUser="群組已添加到用戶";var groupUpdatedForUser="用戶的群組已更新";var hasAccessTo="有訪問權限";var hourCount_one="{{count}} 小時";var hourCount_other="{{count}} 小時";var id_one="ID";var id_other="ID";var inProgressCount="{{itemCount}} 進行中";var inactiveScreen="非活動屏幕";var insertedDrivesCount="{{itemCount}} 插入的驅動器。";var invalidFileNoTheatreNameOrId="無效文件。沒有劇院名稱或 ID";var invitedUser="被邀請的用戶";var kdm="KDM";var kdmDetails="KDM 詳細信息";var languages="語言";var lastUpdatedBy="最後更新者";var lastUpdatedOn="最後更新時間";var listName="清單名稱";var listUpdated="清單已更新";var lists="列表";var location="地點";var mainCaptions="主要字幕";var maintenance="維護";var maintenanceDescription="Qube Wire 目前正在維護中。我們將很快回來。";var manage="管理";var markAsDelivered="標記為已交付";var markAsPending="標記為待處理";var markAsShipped="標記為已發貨";var minuteCount_one="{{count}} 分鐘";var minuteCount_other="{{count}} 分鐘";var name="名稱";var no="否";var noAccess="無訪問權限";var noActiveDeviceInScreen="屏幕上沒有活動裝置";var noAppliancesFound="找不到設備";var noCompositions="沒有組合";var noItemTypeInWorkOrderFound="找不到 {{type}} 的工作訂單";var noKeepList="不，保留清單";var noKeepSelection="不，保留選擇";var noListsFound="未找到列表";var noPlyDeviceInScreen="屏幕上沒有播放裝置";var noRecordsfound="找不到記錄";var noResultsFound="找不到結果";var noTagsFoundClickHereToCreateOne="找不到標籤。點擊 <1>這裡</1> 創建一個";var noTheatresAreSelected="未選擇劇院";var noTheatresFound="找不到劇院";var none="無";var notFound="未找到";var notes="注釋";var oops="哎呀！";var osVersion="操作系统版本";var partner="合作伙伴";var pendingCancellation="待取消";var pendingCancellationCount="{{itemCount}} 待取消";var pendingCount="{{itemCount}} 待处理";var picture="图片";var preciseMatchForTheatresNotFound="未找到这些影院的精确匹配。";var preparingToCopy="准备复制";var publicIp="公共IP";var ratings="评级";var rejected="已拒绝";var rejectedCount="{{itemCount}} 已拒绝";var resolution="分辨率";var resultsFor="搜索结果";var role="角色";var roles="角色";var rowMatchedCount_one="{{count}} 行匹配";var rowMatchedCount_other="{{count}} 行匹配";var rowWithoutNameAndIdIgnored_one="{{count}} 行无名称和ID已忽略";var rowWithoutNameAndIdIgnored_other="{{count}} 行无名称和ID已忽略";var save="保存";var screen="屏幕";var screenCount_one="{{count}} 屏幕";var screenCount_other="{{count}} 屏幕";var screenNonDciComplaints="屏幕没有DCI投诉";var screenNotHaveCertificate="屏幕没有设备证书";var screens="屏幕";var search="搜索";var searchAndAddTags="搜索并添加标签";var searchAndSelectTheatres="搜索并选择影院";var searchForTheatreList="搜索影院列表";var searchForTheatres="搜索影院";var selectCourierType="选择快递类型";var selectDcpTransferStatus="选择DCP传输状态";var selectOption="选择选项";var selectTheatreCount_one="选择{{count}}家影院";var selectTheatreCount_other="选择{{count}}家影院";var selectTheatres="选择影院";var selectUsingCsv="使用CSV选择";var selectedTheatres="已选择的影院";var serialNumber="序列号";var shipBy="发货方式";var shipmentNo="发货编号";var shipmentStatus="发货状态";var shipped="已发货";var shipping="发货";var shippingInformation="发货信息";var someErrorInGettingDownloadStatus="获取下载状态时发生错误";var someScreensHaveMissingDeviceInformation="一些屏幕缺少设备信息";var spokenLanguage="口头语言";var stageCopyingContentToDrives="步骤2/3：将内容复制到驱动器";var stageFormattingDrives="步骤1/3：格式化驱动器";var stageVerifying="步骤3/3：正在验证";var startCopying="开始复制";var status="状态";var submit="提交";var subtitleLanguage="字幕语言";var tagName="标签名称";var tagNameLessThan50Char="标签名称应少于50个字符";var tags="标签";var theatre="影院";var theatreAlreadySelectedInList="此影院已在列表中选择。";var theatreCountMatched_one="{{count}} 家影院匹配";var theatreCountMatched_other="{{count}} 家影院匹配";var theatreCount_one="{{count}} 家影院";var theatreCount_other="{{count}} 家影院";var theatreDetails="影院详情";var theatreListNameAlreadyExists="影院列表名称已存在";var theatreName="影院名称";var theatres="影院";var theatresListCreated="影院列表已创建";var theatresListDeleted="影院列表已删除";var theatresListUpdated="影院列表已更新";var thisPageDoesNotExist="此页面不存在。";var to="到";var totalDriveCount_one="{{count}} 驱动器";var totalDriveCount_other="{{count}} 驱动器";var trackingNumber="跟踪编号";var transitional="过渡性的";var type="类型";var unarchivalMayTake="解档可能需要";var unknown="未知";var update="更新";var updateAccess="更新访问权限";var updateDelivery="更新交付";var uploadShipmentInformation="上传发货信息";var uploadingCsv="正在上传CSV";var users="用户";var view="查看";var viewDetails="查看详细信息";var viewMore="查看更多";var workorder="工作订单";var yes="是";var yesClear="是，清除";var yesDelete="是，删除";var zh = {add:add,addAccess:addAccess,addAnotherRole:addAnotherRole,addToList:addToList,addToNewList:addToNewList,address:address,advertisement:advertisement,alternateNames:alternateNames,applianceBusyInDuplicating:applianceBusyInDuplicating,aspectRatio:aspectRatio,audio:audio,audioFormat:audioFormat,back:back,bandwidth:bandwidth,booking:booking,cancel:cancel$2,cancelled:cancelled,cancelledCount:cancelledCount,chain:chain,clear:clear,clearAll:clearAll,clearTheatreSelection:clearTheatreSelection,clearTheatreSelectionConfirmation:clearTheatreSelectionConfirmation,closedCaptions:closedCaptions,closedSubtitles:closedSubtitles,comments:comments,companyTheatreLocation:companyTheatreLocation,composition:composition,compositionDetails:compositionDetails,compositionTags:compositionTags,compositions:compositions,contentIsLessThan8GBWarning:contentIsLessThan8GBWarning,contentIsLessThan8GBWarningContent:contentIsLessThan8GBWarningContent,contentSize:contentSize,conventionLink:conventionLink,copiedCount:copiedCount,copyCompleted:copyCompleted,copyFailed:copyFailed,copyPending:copyPending,copyQueued:copyQueued,copyStatus:copyStatus,courierType:courierType,cplFormat:cplFormat,cplId:cplId,cplMarkers:cplMarkers,cplMetadata:cplMetadata,create:create$1,createModal:createModal,createTag:createTag,createdBy:createdBy,createdOn:createdOn,creditOffset:creditOffset,creditsOffset:creditsOffset,creditsValue:creditsValue,csvColumnsForTheatreSelect:csvColumnsForTheatreSelect,dcp:dcp,dcpStatus:dcpStatus,dcpTransferCompleted:dcpTransferCompleted,dcpTransferNotStarted:dcpTransferNotStarted,dcpTransferStarted:dcpTransferStarted,deactivatedUser:deactivatedUser,"delete":"刪除",deleteList:deleteList,deleteListConfirmation:deleteListConfirmation,deliverBefore:deliverBefore,deliverBy:deliverBy,deliveries:deliveries,delivery:delivery,deliveryInstructions:deliveryInstructions,download:download,downloadCompleted:downloadCompleted,downloadDetails:downloadDetails,downloadFailed:downloadFailed,downloadKdms:downloadKdms,downloadNotStarted:downloadNotStarted,downloadPending:downloadPending,downloadQueued:downloadQueued,downloadScheduled:downloadScheduled,downloadShipmentInformation:downloadShipmentInformation,downloadStatus:downloadStatus,downloadYetToStart:downloadYetToStart,downloaded:downloaded,downloading:downloading,downloadingArchived:downloadingArchived,downloadingPercentage:downloadingPercentage,downloadingStalled:downloadingStalled,downloadingUnarchiving:downloadingUnarchiving,driveCopy:driveCopy,driveNotHaveContent:driveNotHaveContent,drivesCount_one:drivesCount_one,drivesCount_other:drivesCount_other,duplicateRowWasIgnored_one:duplicateRowWasIgnored_one,duplicateRowWasIgnored_other:duplicateRowWasIgnored_other,duplicatingWoInBay:duplicatingWoInBay,duplicationStatus:duplicationStatus,duration:duration,editTag:editTag,editTheatreList:editTheatreList,email:email,emailKDMS:emailKDMS,enterNameOfList:enterNameOfList,enterNameOfNewList:enterNameOfNewList,enterTagName:enterTagName,enterTrackingNumber:enterTrackingNumber,errorFetchingDownloadStatus:errorFetchingDownloadStatus,errorGettingTheatre:errorGettingTheatre,errorWhileAddingGroup:errorWhileAddingGroup,errorWhileUpdatingGroup:errorWhileUpdatingGroup,festivals:festivals,fetchingDetailsPleaseWait:fetchingDetailsPleaseWait,ffec:ffec,ffmc:ffmc,filterBy:filterBy,firstFrameEndCredits:firstFrameEndCredits,firstFrameMovingCredits:firstFrameMovingCredits,followingDuplicateRowThatMatchedTheScreenAreIgnored_one:followingDuplicateRowThatMatchedTheScreenAreIgnored_one,followingDuplicateRowThatMatchedTheScreenAreIgnored_other:followingDuplicateRowThatMatchedTheScreenAreIgnored_other,followingDuplicateRowThatMatchedTheTheatreAreIgnored_one:followingDuplicateRowThatMatchedTheTheatreAreIgnored_one,followingDuplicateRowThatMatchedTheTheatreAreIgnored_other:followingDuplicateRowThatMatchedTheTheatreAreIgnored_other,format:format,frameRate:frameRate,from:from,fromTimeOfBooking:fromTimeOfBooking,group:group,groupAddedToUser:groupAddedToUser,groupUpdatedForUser:groupUpdatedForUser,hasAccessTo:hasAccessTo,hourCount_one:hourCount_one,hourCount_other:hourCount_other,id_one:id_one,id_other:id_other,inProgressCount:inProgressCount,inactiveScreen:inactiveScreen,insertedDrivesCount:insertedDrivesCount,invalidFileNoTheatreNameOrId:invalidFileNoTheatreNameOrId,invitedUser:invitedUser,kdm:kdm,kdmDetails:kdmDetails,languages:languages,lastUpdatedBy:lastUpdatedBy,lastUpdatedOn:lastUpdatedOn,listName:listName,listUpdated:listUpdated,lists:lists,location:location,mainCaptions:mainCaptions,maintenance:maintenance,maintenanceDescription:maintenanceDescription,manage:manage,markAsDelivered:markAsDelivered,markAsPending:markAsPending,markAsShipped:markAsShipped,minuteCount_one:minuteCount_one,minuteCount_other:minuteCount_other,name:name,no:no,noAccess:noAccess,noActiveDeviceInScreen:noActiveDeviceInScreen,noAppliancesFound:noAppliancesFound,noCompositions:noCompositions,noItemTypeInWorkOrderFound:noItemTypeInWorkOrderFound,noKeepList:noKeepList,noKeepSelection:noKeepSelection,noListsFound:noListsFound,noPlyDeviceInScreen:noPlyDeviceInScreen,noRecordsfound:noRecordsfound,noResultsFound:noResultsFound,noTagsFoundClickHereToCreateOne:noTagsFoundClickHereToCreateOne,noTheatresAreSelected:noTheatresAreSelected,noTheatresFound:noTheatresFound,none:none,notFound:notFound,notes:notes,oops:oops,osVersion:osVersion,partner:partner,pendingCancellation:pendingCancellation,pendingCancellationCount:pendingCancellationCount,pendingCount:pendingCount,picture:picture,preciseMatchForTheatresNotFound:preciseMatchForTheatresNotFound,preparingToCopy:preparingToCopy,publicIp:publicIp,ratings:ratings,rejected:rejected,rejectedCount:rejectedCount,resolution:resolution,resultsFor:resultsFor,"return":"返回",role:role,roles:roles,rowMatchedCount_one:rowMatchedCount_one,rowMatchedCount_other:rowMatchedCount_other,rowWithoutNameAndIdIgnored_one:rowWithoutNameAndIdIgnored_one,rowWithoutNameAndIdIgnored_other:rowWithoutNameAndIdIgnored_other,save:save,screen:screen,screenCount_one:screenCount_one,screenCount_other:screenCount_other,screenNonDciComplaints:screenNonDciComplaints,screenNotHaveCertificate:screenNotHaveCertificate,screens:screens,search:search,searchAndAddTags:searchAndAddTags,searchAndSelectTheatres:searchAndSelectTheatres,searchForTheatreList:searchForTheatreList,searchForTheatres:searchForTheatres,selectCourierType:selectCourierType,selectDcpTransferStatus:selectDcpTransferStatus,selectOption:selectOption,selectTheatreCount_one:selectTheatreCount_one,selectTheatreCount_other:selectTheatreCount_other,selectTheatres:selectTheatres,selectUsingCsv:selectUsingCsv,selectedTheatres:selectedTheatres,serialNumber:serialNumber,shipBy:shipBy,shipmentNo:shipmentNo,shipmentStatus:shipmentStatus,shipped:shipped,shipping:shipping,shippingInformation:shippingInformation,someErrorInGettingDownloadStatus:someErrorInGettingDownloadStatus,someScreensHaveMissingDeviceInformation:someScreensHaveMissingDeviceInformation,spokenLanguage:spokenLanguage,stageCopyingContentToDrives:stageCopyingContentToDrives,stageFormattingDrives:stageFormattingDrives,stageVerifying:stageVerifying,startCopying:startCopying,status:status,submit:submit,subtitleLanguage:subtitleLanguage,tagName:tagName,tagNameLessThan50Char:tagNameLessThan50Char,tags:tags,theatre:theatre,theatreAlreadySelectedInList:theatreAlreadySelectedInList,theatreCountMatched_one:theatreCountMatched_one,theatreCountMatched_other:theatreCountMatched_other,theatreCount_one:theatreCount_one,theatreCount_other:theatreCount_other,theatreDetails:theatreDetails,theatreListNameAlreadyExists:theatreListNameAlreadyExists,theatreName:theatreName,theatres:theatres,theatresListCreated:theatresListCreated,theatresListDeleted:theatresListDeleted,theatresListUpdated:theatresListUpdated,thisPageDoesNotExist:thisPageDoesNotExist,to:to,totalDriveCount_one:totalDriveCount_one,totalDriveCount_other:totalDriveCount_other,trackingNumber:trackingNumber,transitional:transitional,type:type,unarchivalMayTake:unarchivalMayTake,unknown:unknown,update:update,updateAccess:updateAccess,updateDelivery:updateDelivery,uploadShipmentInformation:uploadShipmentInformation,uploadingCsv:uploadingCsv,users:users,view:view,viewDetails:viewDetails,viewMore:viewMore,workorder:workorder,yes:yes,yesClear:yesClear,yesDelete:yesDelete};

var i18n = createInstance$1({
  lng: 'en',
  fallbackLng: 'en',
  lowerCaseLng: true,
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: en
    },
    fr: {
      translation: fr
    },
    hu: {
      translation: hu
    },
    th: {
      translation: th
    },
    vi: {
      translation: vi
    },
    'pt-br': {
      translation: pt
    },
    'zh-tw': {
      translation: zh
    }
  }
});
i18n.init();

var DefaultRangePicker = function DefaultRangePicker(_ref) {
  var size = _ref.size,
      placeholder = _ref.placeholder,
      disabledDate = _ref.disabledDate,
      format = _ref.format,
      value = _ref.value,
      onChange = _ref.onChange,
      showTime = _ref.showTime,
      disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'range-picker'
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'label'
  }, i18n.t('from')), /*#__PURE__*/React__default.createElement(_DatePicker, {
    showTime: showTime && showTime[0],
    size: size,
    onChange: onChange && onChange[0],
    disabled: disabled,
    disabledDate: disabledDate,
    format: format,
    value: value && value[0],
    placeholder: placeholder && placeholder[0]
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'label'
  }, i18n.t('to')), /*#__PURE__*/React__default.createElement(_DatePicker, {
    showTime: showTime && showTime[1],
    size: size,
    onChange: onChange && onChange[1],
    disabled: disabled,
    disabledDate: disabledDate,
    format: format,
    value: value && value[1],
    placeholder: placeholder && placeholder[1]
  })));
};

DefaultRangePicker.defaultProps = {
  size: 'default',
  disabledDate: function disabledDate() {
    return false;
  }
};

var TabItem = function TabItem(props) {
  var name = props.name,
      item = props.item,
      onChange = props.onChange,
      selectedTab = props.selectedTab;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tab-bar-chip".concat(item && selectedTab == item.type ? ' tab-border-bottom' : ''),
    onClick: function onClick() {
      return onChange && onChange(item);
    }
  }, name);
};

var DefaultCheckbox = function DefaultCheckbox(_ref) {
  var disabled = _ref.disabled,
      defaultChecked = _ref.defaultChecked,
      checked = _ref.checked,
      onChange = _ref.onChange,
      label = _ref.label,
      indeterminate = _ref.indeterminate;
  return /*#__PURE__*/React__default.createElement(_Checkbox, {
    onChange: onChange,
    defaultChecked: defaultChecked,
    disabled: disabled,
    checked: checked,
    indeterminate: indeterminate
  }, label);
};

DefaultCheckbox.defaultProps = {
  disabled: false,
  label: '',
  checked: false,
  indeterminate: false
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var _excluded$7 = ["list", "placeholder", "onSelectDropDown", "optionType", "width", "value", "defaultValue", "size"];

function _createSuper$Y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$Y(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$Y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option$3 = _Select.Option;

var DropDown = /*#__PURE__*/function (_React$Component) {
  _inherits$1(DropDown, _React$Component);

  var _super = _createSuper$Y(DropDown);

  function DropDown() {
    _classCallCheck$1(this, DropDown);

    return _super.apply(this, arguments);
  }

  _createClass$1(DropDown, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          list = _this$props.list,
          placeholder = _this$props.placeholder,
          onSelectDropDown = _this$props.onSelectDropDown;
          _this$props.optionType;
          var width = _this$props.width,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          size = _this$props.size,
          otherProps = _objectWithoutProperties$1(_this$props, _excluded$7);

      function onselect(i) {
        if (onSelectDropDown) {
          onSelectDropDown(i);
        }
      }

      return /*#__PURE__*/React__default.createElement(_Select, _extends$1({
        defaultValue: defaultValue,
        value: value === '' ? undefined : value,
        placeholder: placeholder && placeholder,
        style: {
          width: width || '100%'
        },
        onSelect: function onSelect(i) {
          return onselect(i);
        },
        size: size
      }, otherProps), list && list.map(function (item) {
        return /*#__PURE__*/React__default.createElement(Option$3, {
          value: item.type,
          onChange: function onChange() {
            return _this.props.onChange && _this.props.onChange();
          }
        }, item.name);
      }));
    }
  }]);

  return DropDown;
}(React__default.Component);
DropDown.defaultProps = {
  onCheck: function onCheck() {},
  width: '20%',
  size: 'default'
};

var IconContext = /*#__PURE__*/createContext({});

// This icon file is generated automatically.
var AccountBookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] }, "name": "account-book", "theme": "filled" };

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$a(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$a(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */
function bound01(n, max) {
    if (isOnePointZero(n)) {
        n = '100%';
    }
    var isPercent = isPercentage(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) {
        n = parseInt(String(n * max), 10) / 100;
    }
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
        return 1;
    }
    // Convert into [0, 1] range if it isn't already
    if (max === 360) {
        // If n is a hue given in degrees,
        // wrap around out-of-range values into [0, 360] range
        // then convert into [0, 1].
        n = (n < 0 ? (n % max) + max : n % max) / parseFloat(String(max));
    }
    else {
        // If n not a hue given in degrees
        // Convert into [0, 1] range if it isn't already.
        n = (n % max) / parseFloat(String(max));
    }
    return n;
}
/**
 * Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
 * <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
 * @hidden
 */
function isOnePointZero(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
/**
 * Check to see if string passed in is a percentage
 * @hidden
 */
function isPercentage(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
/**
 * Return a valid alpha value [0,1] with all invalid values being set to 1
 * @hidden
 */
function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }
    return a;
}
/**
 * Replace a decimal with it's percentage value
 * @hidden
 */
function convertToPercentage(n) {
    if (n <= 1) {
        return Number(n) * 100 + "%";
    }
    return n;
}
/**
 * Force a hex value to have 2 characters
 * @hidden
 */
function pad2(c) {
    return c.length === 1 ? '0' + c : String(c);
}

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
/**
 * Handle bounds / percentage checking to conform to CSS color spec
 * <http://www.w3.org/TR/css3-color/>
 * *Assumes:* r, g, b in [0, 255] or [0, 1]
 * *Returns:* { r, g, b } in [0, 255]
 */
function rgbToRgb(r, g, b) {
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255,
    };
}
function hue2rgb(p, q, t) {
    if (t < 0) {
        t += 1;
    }
    if (t > 1) {
        t -= 1;
    }
    if (t < 1 / 6) {
        return p + (q - p) * (6 * t);
    }
    if (t < 1 / 2) {
        return q;
    }
    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
}
/**
 * Converts an HSL color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hslToRgb(h, s, l) {
    var r;
    var g;
    var b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color value to HSV
 *
 * *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
 * *Returns:* { h, s, v } in [0,1]
 */
function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
/**
 * Converts an HSV color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [v, q, p, p, t, v][mod];
    var g = [t, v, v, q, p, p][mod];
    var b = [p, p, t, v, v, q][mod];
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color to hex
 *
 * Assumes r, g, and b are contained in the set [0, 255]
 * Returns a 3 or 6 character hex
 */
function rgbToHex(r, g, b, allow3Char) {
    var hex = [
        pad2(Math.round(r).toString(16)),
        pad2(Math.round(g).toString(16)),
        pad2(Math.round(b).toString(16)),
    ];
    // Return a 3 character hex if possible
    if (allow3Char &&
        hex[0].startsWith(hex[0].charAt(1)) &&
        hex[1].startsWith(hex[1].charAt(1)) &&
        hex[2].startsWith(hex[2].charAt(1))) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join('');
}
/** Converts a hex value to a decimal */
function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
}
/** Parse a base-16 hex value into a base-10 integer */
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */
var names = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
};

/**
 * Given a string or object, convert that input to RGB
 *
 * Possible string inputs:
 * ```
 * "red"
 * "#f00" or "f00"
 * "#ff0000" or "ff0000"
 * "#ff000000" or "ff000000"
 * "rgb 255 0 0" or "rgb (255, 0, 0)"
 * "rgb 1.0 0 0" or "rgb (1, 0, 0)"
 * "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
 * "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
 * "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
 * "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
 * "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
 * ```
 */
function inputToRGB(color) {
    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') {
        color = stringInputToObject(color);
    }
    if (typeof color === 'object') {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = 'hsv';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) {
            a = color.a;
        }
    }
    a = boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a,
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var matchers = {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp('rgb' + PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
};
/**
 * Permissive string parsing.  Take in a number of formats, and output an object
 * based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
 */
function stringInputToObject(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) {
        return false;
    }
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color === 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: 'name' };
    }
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = matchers.rgb.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    match = matchers.rgba.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    match = matchers.hsl.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    match = matchers.hsla.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    match = matchers.hsv.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    match = matchers.hsva.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    match = matchers.hex8.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex6.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    match = matchers.hex4.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1] + match[1]),
            g: parseIntFromHex(match[2] + match[2]),
            b: parseIntFromHex(match[3] + match[3]),
            a: convertHexToDecimal(match[4] + match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex3.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1] + match[1]),
            g: parseIntFromHex(match[2] + match[2]),
            b: parseIntFromHex(match[3] + match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    return false;
}
/**
 * Check to see if it looks like a CSS unit
 * (see `matchers` above for definition).
 */
function isValidCSSUnit(color) {
    return Boolean(matchers.CSS_UNIT.exec(String(color)));
}

var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`

function toHsv(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var hsv = rgbToHsv(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`


function toHex(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;
  return "#".concat(rgbToHex(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.


function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate$1(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }));
    patterns.push(colorString);
  }

  patterns.push(toHex(pColor));

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);

    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }));

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref3) {
      var index = _ref3.index,
          opacity = _ref3.opacity;
      var darkColorString = toHex(mix(inputToRGB(opts.backgroundColor || '#141414'), inputToRGB(patterns[index]), opacity * 100));
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate$1(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate$1(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
presetPalettes.red;
presetPalettes.volcano;
presetPalettes.gold;
presetPalettes.orange;
presetPalettes.yellow;
presetPalettes.lime;
presetPalettes.green;
presetPalettes.cyan;
presetPalettes.blue;
presetPalettes.geekblue;
presetPalettes.purple;
presetPalettes.magenta;
presetPalettes.grey;

/* eslint-disable no-console */
var warned$1 = {};
function warning$3(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call$1(method, valid, message) {
  if (!valid && !warned$1[message]) {
    method(false, message);
    warned$1[message] = true;
  }
}
function warningOnce$1(valid, message) {
  call$1(warning$3, valid, message);
}
/* eslint-enable */

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

var MARK_KEY = "rc-util-key";

function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }

  var head = document.querySelector('head');
  return head || document.body;
}

function injectCSS(css) {
  var _option$csp;

  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canUseDom()) {
    return null;
  }

  var styleNode = document.createElement('style');

  if ((_option$csp = option.csp) === null || _option$csp === void 0 ? void 0 : _option$csp.nonce) {
    var _option$csp2;

    styleNode.nonce = (_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce;
  }

  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;

  if (option.prepend && container.prepend) {
    // Use `prepend` first
    container.prepend(styleNode);
  } else if (option.prepend && firstChild) {
    // Fallback to `insertBefore` like IE not support `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }

  return styleNode;
}
var containerCache = new Map();
function updateCSS(css, key) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(option); // Get real parent

  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }

  var existNode = Array.from(containerCache.get(container).children).find(function (node) {
    return node.tagName === 'STYLE' && node[MARK_KEY] === key;
  });

  if (existNode) {
    var _option$csp3, _option$csp4;

    if (((_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce) && existNode.nonce !== ((_option$csp4 = option.csp) === null || _option$csp4 === void 0 ? void 0 : _option$csp4.nonce)) {
      var _option$csp5;

      existNode.nonce = (_option$csp5 = option.csp) === null || _option$csp5 === void 0 ? void 0 : _option$csp5.nonce;
    }

    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }

    return existNode;
  }

  var newNode = injectCSS(css, option);
  newNode[MARK_KEY] = key;
  return newNode;
}

function warning$2(valid, message) {
  warningOnce$1(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2(_objectSpread2({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return generate$1(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4

var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;

  var _useContext = useContext(IconContext),
      csp = _useContext.csp;

  useEffect(function () {
    updateCSS(styleStr, '@ant-design-icons', {
      prepend: true,
      csp: csp
    });
  }, []);
};

var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}

var IconBase = function IconBase(props) {
  var icon = props.icon,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      restProps = _objectWithoutProperties$1(props, ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"]);

  var colors = twoToneColorPalette;

  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }

  useInsertStyles();
  warning$2(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));

  if (!isIconDefinition(icon)) {
    return null;
  }

  var target = icon;

  if (target && typeof target.icon === 'function') {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }

  return generate(target.icon, "svg-".concat(target.name), _objectSpread2({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};

IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;

function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return IconBase.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = IconBase.getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}

// should move it to antd main repo?

setTwoToneColor('#1890ff');
var Icon$4 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var className = props.className,
      icon = props.icon,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      twoToneColor = props.twoToneColor,
      restProps = _objectWithoutProperties$1(props, ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]);

  var _React$useContext = React.useContext(IconContext),
      _React$useContext$pre = _React$useContext.prefixCls,
      prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre;

  var classString = classNames$1(prefixCls, (_classNames = {}, _defineProperty$1(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty$1(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), _classNames), className);
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return /*#__PURE__*/React.createElement("span", Object.assign({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/React.createElement(IconBase, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon$4.displayName = 'AntdIcon';
Icon$4.getTwoToneColor = getTwoToneColor;
Icon$4.setTwoToneColor = setTwoToneColor;

// GENERATE BY ./scripts/generate.ts

var AccountBookFilled = function AccountBookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookFilled$2
  }));
};

AccountBookFilled.displayName = 'AccountBookFilled';
var AccountBookFilled$1 = /*#__PURE__*/React.forwardRef(AccountBookFilled);

// This icon file is generated automatically.
var AccountBookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z" } }] }, "name": "account-book", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookOutlined$2
  }));
};

AccountBookOutlined.displayName = 'AccountBookOutlined';
var AccountBookOutlined$1 = /*#__PURE__*/React.forwardRef(AccountBookOutlined);

// This icon file is generated automatically.
var AccountBookTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 017.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }] }; }, "name": "account-book", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AccountBookTwoTone = function AccountBookTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookTwoTone$2
  }));
};

AccountBookTwoTone.displayName = 'AccountBookTwoTone';
var AccountBookTwoTone$1 = /*#__PURE__*/React.forwardRef(AccountBookTwoTone);

// This icon file is generated automatically.
var AimOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z" } }, { "tag": "path", "attrs": { "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z" } }] }, "name": "aim", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AimOutlined = function AimOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AimOutlined$2
  }));
};

AimOutlined.displayName = 'AimOutlined';
var AimOutlined$1 = /*#__PURE__*/React.forwardRef(AimOutlined);

// This icon file is generated automatically.
var AlertFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 01-32 32H225a32 32 0 01-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 018 8v96a8 8 0 01-8 8h-56a8 8 0 01-8-8V76a8 8 0 018-8zM177.25 191.66a8 8 0 0111.32 0l67.88 67.88a8 8 0 010 11.31l-39.6 39.6a8 8 0 01-11.31 0l-67.88-67.88a8 8 0 010-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 010 11.3l-67.88 67.9a8 8 0 01-11.32 0l-39.6-39.6a8 8 0 010-11.32l67.89-67.88a8 8 0 0111.31 0zM192 892h640a32 32 0 0132 32v24a8 8 0 01-8 8H168a8 8 0 01-8-8v-24a32 32 0 0132-32zm148-317v253h64V575h-64z" } }] }, "name": "alert", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AlertFilled = function AlertFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlertFilled$2
  }));
};

AlertFilled.displayName = 'AlertFilled';
var AlertFilled$1 = /*#__PURE__*/React.forwardRef(AlertFilled);

// This icon file is generated automatically.
var AlertOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z" } }] }, "name": "alert", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlertOutlined = function AlertOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlertOutlined$2
  }));
};

AlertOutlined.displayName = 'AlertOutlined';
var AlertOutlined$1 = /*#__PURE__*/React.forwardRef(AlertOutlined);

// This icon file is generated automatically.
var AlertTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z", "fill": primaryColor } }] }; }, "name": "alert", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AlertTwoTone = function AlertTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlertTwoTone$2
  }));
};

AlertTwoTone.displayName = 'AlertTwoTone';
var AlertTwoTone$1 = /*#__PURE__*/React.forwardRef(AlertTwoTone);

// This icon file is generated automatically.
var AlibabaOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z" } }] }, "name": "alibaba", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlibabaOutlined = function AlibabaOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlibabaOutlined$2
  }));
};

AlibabaOutlined.displayName = 'AlibabaOutlined';
var AlibabaOutlined$1 = /*#__PURE__*/React.forwardRef(AlibabaOutlined);

// This icon file is generated automatically.
var AlignCenterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-center", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlignCenterOutlined$2
  }));
};

AlignCenterOutlined.displayName = 'AlignCenterOutlined';
var AlignCenterOutlined$1 = /*#__PURE__*/React.forwardRef(AlignCenterOutlined);

// This icon file is generated automatically.
var AlignLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlignLeftOutlined$2
  }));
};

AlignLeftOutlined.displayName = 'AlignLeftOutlined';
var AlignLeftOutlined$1 = /*#__PURE__*/React.forwardRef(AlignLeftOutlined);

// This icon file is generated automatically.
var AlignRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlignRightOutlined$2
  }));
};

AlignRightOutlined.displayName = 'AlignRightOutlined';
var AlignRightOutlined$1 = /*#__PURE__*/React.forwardRef(AlignRightOutlined);

// This icon file is generated automatically.
var AlipayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] }, "name": "alipay-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AlipayCircleFilled = function AlipayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleFilled$2
  }));
};

AlipayCircleFilled.displayName = 'AlipayCircleFilled';
var AlipayCircleFilled$1 = /*#__PURE__*/React.forwardRef(AlipayCircleFilled);

// This icon file is generated automatically.
var AlipayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] }, "name": "alipay-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlipayCircleOutlined = function AlipayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleOutlined$2
  }));
};

AlipayCircleOutlined.displayName = 'AlipayCircleOutlined';
var AlipayCircleOutlined$1 = /*#__PURE__*/React.forwardRef(AlipayCircleOutlined);

// This icon file is generated automatically.
var AlipayOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 01-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z" } }] }, "name": "alipay", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlipayOutlined = function AlipayOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlipayOutlined$2
  }));
};

AlipayOutlined.displayName = 'AlipayOutlined';
var AlipayOutlined$1 = /*#__PURE__*/React.forwardRef(AlipayOutlined);

// This icon file is generated automatically.
var AlipaySquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z" } }] }, "name": "alipay-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AlipaySquareFilled$2
  }));
};

AlipaySquareFilled.displayName = 'AlipaySquareFilled';
var AlipaySquareFilled$1 = /*#__PURE__*/React.forwardRef(AlipaySquareFilled);

// This icon file is generated automatically.
var AliwangwangFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z" } }] }, "name": "aliwangwang", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangFilled$2
  }));
};

AliwangwangFilled.displayName = 'AliwangwangFilled';
var AliwangwangFilled$1 = /*#__PURE__*/React.forwardRef(AliwangwangFilled);

// This icon file is generated automatically.
var AliwangwangOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 01-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 01-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 01217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z" } }] }, "name": "aliwangwang", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangOutlined$2
  }));
};

AliwangwangOutlined.displayName = 'AliwangwangOutlined';
var AliwangwangOutlined$1 = /*#__PURE__*/React.forwardRef(AliwangwangOutlined);

// This icon file is generated automatically.
var AliyunOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0132.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 01-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 01-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z" } }] }, "name": "aliyun", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AliyunOutlined = function AliyunOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AliyunOutlined$2
  }));
};

AliyunOutlined.displayName = 'AliyunOutlined';
var AliyunOutlined$1 = /*#__PURE__*/React.forwardRef(AliyunOutlined);

// This icon file is generated automatically.
var AmazonCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z" } }] }, "name": "amazon-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AmazonCircleFilled = function AmazonCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AmazonCircleFilled$2
  }));
};

AmazonCircleFilled.displayName = 'AmazonCircleFilled';
var AmazonCircleFilled$1 = /*#__PURE__*/React.forwardRef(AmazonCircleFilled);

// This icon file is generated automatically.
var AmazonOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 00-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z" } }] }, "name": "amazon", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AmazonOutlined = function AmazonOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AmazonOutlined$2
  }));
};

AmazonOutlined.displayName = 'AmazonOutlined';
var AmazonOutlined$1 = /*#__PURE__*/React.forwardRef(AmazonOutlined);

// This icon file is generated automatically.
var AmazonSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z" } }] }, "name": "amazon-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AmazonSquareFilled = function AmazonSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AmazonSquareFilled$2
  }));
};

AmazonSquareFilled.displayName = 'AmazonSquareFilled';
var AmazonSquareFilled$1 = /*#__PURE__*/React.forwardRef(AmazonSquareFilled);

// This icon file is generated automatically.
var AndroidFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z" } }] }, "name": "android", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AndroidFilled = function AndroidFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AndroidFilled$2
  }));
};

AndroidFilled.displayName = 'AndroidFilled';
var AndroidFilled$1 = /*#__PURE__*/React.forwardRef(AndroidFilled);

// This icon file is generated automatically.
var AndroidOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z" } }] }, "name": "android", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AndroidOutlined = function AndroidOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AndroidOutlined$2
  }));
};

AndroidOutlined.displayName = 'AndroidOutlined';
var AndroidOutlined$1 = /*#__PURE__*/React.forwardRef(AndroidOutlined);

// This icon file is generated automatically.
var AntCloudOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0122.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 01-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1096 0 48 48 0 10-96 0zm-65.7 61.3a24 24 0 1048 0 24 24 0 10-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z" } }] }, "name": "ant-cloud", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AntCloudOutlined = function AntCloudOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AntCloudOutlined$2
  }));
};

AntCloudOutlined.displayName = 'AntCloudOutlined';
var AntCloudOutlined$1 = /*#__PURE__*/React.forwardRef(AntCloudOutlined);

// This icon file is generated automatically.
var AntDesignOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 000 76.4L474.6 944a54.14 54.14 0 0076.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 00-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 10212.6 0 106.3 106.2 0 10-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 000 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 000 68.6 48.7 48.7 0 0068.7 0l121.8-121.7a53.93 53.93 0 00-.1-76.4z" } }] }, "name": "ant-design", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AntDesignOutlined = function AntDesignOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AntDesignOutlined$2
  }));
};

AntDesignOutlined.displayName = 'AntDesignOutlined';
var AntDesignOutlined$1 = /*#__PURE__*/React.forwardRef(AntDesignOutlined);

// This icon file is generated automatically.
var ApartmentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z" } }] }, "name": "apartment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ApartmentOutlined$2
  }));
};

ApartmentOutlined.displayName = 'ApartmentOutlined';
var ApartmentOutlined$1 = /*#__PURE__*/React.forwardRef(ApartmentOutlined);

// This icon file is generated automatically.
var ApiFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z" } }] }, "name": "api", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ApiFilled = function ApiFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ApiFilled$2
  }));
};

ApiFilled.displayName = 'ApiFilled';
var ApiFilled$1 = /*#__PURE__*/React.forwardRef(ApiFilled);

// This icon file is generated automatically.
var ApiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 01-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z" } }] }, "name": "api", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ApiOutlined = function ApiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ApiOutlined$2
  }));
};

ApiOutlined.displayName = 'ApiOutlined';
var ApiOutlined$1 = /*#__PURE__*/React.forwardRef(ApiOutlined);

// This icon file is generated automatically.
var ApiTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 00-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z", "fill": primaryColor } }] }; }, "name": "api", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ApiTwoTone = function ApiTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ApiTwoTone$2
  }));
};

ApiTwoTone.displayName = 'ApiTwoTone';
var ApiTwoTone$1 = /*#__PURE__*/React.forwardRef(ApiTwoTone);

// This icon file is generated automatically.
var AppleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] }, "name": "apple", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AppleFilled = function AppleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AppleFilled$2
  }));
};

AppleFilled.displayName = 'AppleFilled';
var AppleFilled$1 = /*#__PURE__*/React.forwardRef(AppleFilled);

// This icon file is generated automatically.
var AppleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] }, "name": "apple", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AppleOutlined = function AppleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AppleOutlined$2
  }));
};

AppleOutlined.displayName = 'AppleOutlined';
var AppleOutlined$1 = /*#__PURE__*/React.forwardRef(AppleOutlined);

// This icon file is generated automatically.
var AppstoreAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zm52 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "appstore-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreAddOutlined$2
  }));
};

AppstoreAddOutlined.displayName = 'AppstoreAddOutlined';
var AppstoreAddOutlined$1 = /*#__PURE__*/React.forwardRef(AppstoreAddOutlined);

// This icon file is generated automatically.
var AppstoreFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z" } }] }, "name": "appstore", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AppstoreFilled = function AppstoreFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreFilled$2
  }));
};

AppstoreFilled.displayName = 'AppstoreFilled';
var AppstoreFilled$1 = /*#__PURE__*/React.forwardRef(AppstoreFilled);

// This icon file is generated automatically.
var AppstoreOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z" } }] }, "name": "appstore", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreOutlined$2
  }));
};

AppstoreOutlined.displayName = 'AppstoreOutlined';
var AppstoreOutlined$1 = /*#__PURE__*/React.forwardRef(AppstoreOutlined);

// This icon file is generated automatically.
var AppstoreTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z", "fill": secondaryColor } }] }; }, "name": "appstore", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AppstoreTwoTone = function AppstoreTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreTwoTone$2
  }));
};

AppstoreTwoTone.displayName = 'AppstoreTwoTone';
var AppstoreTwoTone$1 = /*#__PURE__*/React.forwardRef(AppstoreTwoTone);

// This icon file is generated automatically.
var AreaChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 00-11.3 0l-189 189.6a7.87 7.87 0 00-2.3 5.6V720c0 4.4 3.6 8 8 8z" } }] }, "name": "area-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AreaChartOutlined = function AreaChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AreaChartOutlined$2
  }));
};

AreaChartOutlined.displayName = 'AreaChartOutlined';
var AreaChartOutlined$1 = /*#__PURE__*/React.forwardRef(AreaChartOutlined);

// This icon file is generated automatically.
var ArrowDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] }, "name": "arrow-down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ArrowDownOutlined$2
  }));
};

ArrowDownOutlined.displayName = 'ArrowDownOutlined';
var ArrowDownOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowDownOutlined);

// This icon file is generated automatically.
var ArrowLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "arrow-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ArrowLeftOutlined$2
  }));
};

ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
var ArrowLeftOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowLeftOutlined);

// This icon file is generated automatically.
var ArrowRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, "name": "arrow-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ArrowRightOutlined$2
  }));
};

ArrowRightOutlined.displayName = 'ArrowRightOutlined';
var ArrowRightOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowRightOutlined);

// This icon file is generated automatically.
var ArrowUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] }, "name": "arrow-up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ArrowUpOutlined$2
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';
var ArrowUpOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowUpOutlined);

// This icon file is generated automatically.
var ArrowsAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] }, "name": "arrows-alt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ArrowsAltOutlined$2
  }));
};

ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
var ArrowsAltOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowsAltOutlined);

// This icon file is generated automatically.
var AudioFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z" } }] }, "name": "audio", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AudioFilled = function AudioFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AudioFilled$2
  }));
};

AudioFilled.displayName = 'AudioFilled';
var AudioFilled$1 = /*#__PURE__*/React.forwardRef(AudioFilled);

// This icon file is generated automatically.
var AudioMutedOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z" } }, { "tag": "path", "attrs": { "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z" } }] }, "name": "audio-muted", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AudioMutedOutlined$2
  }));
};

AudioMutedOutlined.displayName = 'AudioMutedOutlined';
var AudioMutedOutlined$1 = /*#__PURE__*/React.forwardRef(AudioMutedOutlined);

// This icon file is generated automatically.
var AudioOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z" } }] }, "name": "audio", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AudioOutlined = function AudioOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AudioOutlined$2
  }));
};

AudioOutlined.displayName = 'AudioOutlined';
var AudioOutlined$1 = /*#__PURE__*/React.forwardRef(AudioOutlined);

// This icon file is generated automatically.
var AudioTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z", "fill": primaryColor } }] }; }, "name": "audio", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AudioTwoTone = function AudioTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AudioTwoTone$2
  }));
};

AudioTwoTone.displayName = 'AudioTwoTone';
var AudioTwoTone$1 = /*#__PURE__*/React.forwardRef(AudioTwoTone);

// This icon file is generated automatically.
var AuditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z" } }] }, "name": "audit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AuditOutlined = function AuditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: AuditOutlined$2
  }));
};

AuditOutlined.displayName = 'AuditOutlined';
var AuditOutlined$1 = /*#__PURE__*/React.forwardRef(AuditOutlined);

// This icon file is generated automatically.
var BackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] }, "name": "backward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BackwardFilled = function BackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BackwardFilled$2
  }));
};

BackwardFilled.displayName = 'BackwardFilled';
var BackwardFilled$1 = /*#__PURE__*/React.forwardRef(BackwardFilled);

// This icon file is generated automatically.
var BackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] }, "name": "backward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BackwardOutlined = function BackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BackwardOutlined$2
  }));
};

BackwardOutlined.displayName = 'BackwardOutlined';
var BackwardOutlined$1 = /*#__PURE__*/React.forwardRef(BackwardOutlined);

// This icon file is generated automatically.
var BankFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z" } }] }, "name": "bank", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BankFilled = function BankFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BankFilled$2
  }));
};

BankFilled.displayName = 'BankFilled';
var BankFilled$1 = /*#__PURE__*/React.forwardRef(BankFilled);

// This icon file is generated automatically.
var BankOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z" } }] }, "name": "bank", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BankOutlined = function BankOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BankOutlined$2
  }));
};

BankOutlined.displayName = 'BankOutlined';
var BankOutlined$1 = /*#__PURE__*/React.forwardRef(BankOutlined);

// This icon file is generated automatically.
var BankTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M240.9 393.9h542.2L512 196.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z", "fill": primaryColor } }] }; }, "name": "bank", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BankTwoTone = function BankTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BankTwoTone$2
  }));
};

BankTwoTone.displayName = 'BankTwoTone';
var BankTwoTone$1 = /*#__PURE__*/React.forwardRef(BankTwoTone);

// This icon file is generated automatically.
var BarChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z" } }] }, "name": "bar-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarChartOutlined = function BarChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BarChartOutlined$2
  }));
};

BarChartOutlined.displayName = 'BarChartOutlined';
var BarChartOutlined$1 = /*#__PURE__*/React.forwardRef(BarChartOutlined);

// This icon file is generated automatically.
var BarcodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "barcode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarcodeOutlined = function BarcodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BarcodeOutlined$2
  }));
};

BarcodeOutlined.displayName = 'BarcodeOutlined';
var BarcodeOutlined$1 = /*#__PURE__*/React.forwardRef(BarcodeOutlined);

// This icon file is generated automatically.
var BarsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BarsOutlined$2
  }));
};

BarsOutlined.displayName = 'BarsOutlined';
var BarsOutlined$1 = /*#__PURE__*/React.forwardRef(BarsOutlined);

// This icon file is generated automatically.
var BehanceCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0017.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z" } }] }, "name": "behance-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BehanceCircleFilled$2
  }));
};

BehanceCircleFilled.displayName = 'BehanceCircleFilled';
var BehanceCircleFilled$1 = /*#__PURE__*/React.forwardRef(BehanceCircleFilled);

// This icon file is generated automatically.
var BehanceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z" } }] }, "name": "behance", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BehanceOutlined = function BehanceOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BehanceOutlined$2
  }));
};

BehanceOutlined.displayName = 'BehanceOutlined';
var BehanceOutlined$1 = /*#__PURE__*/React.forwardRef(BehanceOutlined);

// This icon file is generated automatically.
var BehanceSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] }, "name": "behance-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BehanceSquareFilled = function BehanceSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareFilled$2
  }));
};

BehanceSquareFilled.displayName = 'BehanceSquareFilled';
var BehanceSquareFilled$1 = /*#__PURE__*/React.forwardRef(BehanceSquareFilled);

// This icon file is generated automatically.
var BehanceSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] }, "name": "behance-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareOutlined$2
  }));
};

BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
var BehanceSquareOutlined$1 = /*#__PURE__*/React.forwardRef(BehanceSquareOutlined);

// This icon file is generated automatically.
var BellFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z" } }] }, "name": "bell", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BellFilled = function BellFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BellFilled$2
  }));
};

BellFilled.displayName = 'BellFilled';
var BellFilled$1 = /*#__PURE__*/React.forwardRef(BellFilled);

// This icon file is generated automatically.
var BellOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z" } }] }, "name": "bell", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BellOutlined = function BellOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BellOutlined$2
  }));
};

BellOutlined.displayName = 'BellOutlined';
var BellOutlined$1 = /*#__PURE__*/React.forwardRef(BellOutlined);

// This icon file is generated automatically.
var BellTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z", "fill": primaryColor } }] }; }, "name": "bell", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BellTwoTone = function BellTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BellTwoTone$2
  }));
};

BellTwoTone.displayName = 'BellTwoTone';
var BellTwoTone$1 = /*#__PURE__*/React.forwardRef(BellTwoTone);

// This icon file is generated automatically.
var BgColorsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] }, "name": "bg-colors", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BgColorsOutlined$2
  }));
};

BgColorsOutlined.displayName = 'BgColorsOutlined';
var BgColorsOutlined$1 = /*#__PURE__*/React.forwardRef(BgColorsOutlined);

// This icon file is generated automatically.
var BlockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z" } }] }, "name": "block", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BlockOutlined = function BlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BlockOutlined$2
  }));
};

BlockOutlined.displayName = 'BlockOutlined';
var BlockOutlined$1 = /*#__PURE__*/React.forwardRef(BlockOutlined);

// This icon file is generated automatically.
var BoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z" } }] }, "name": "bold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BoldOutlined = function BoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BoldOutlined$2
  }));
};

BoldOutlined.displayName = 'BoldOutlined';
var BoldOutlined$1 = /*#__PURE__*/React.forwardRef(BoldOutlined);

// This icon file is generated automatically.
var BookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z" } }] }, "name": "book", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BookFilled = function BookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BookFilled$2
  }));
};

BookFilled.displayName = 'BookFilled';
var BookFilled$1 = /*#__PURE__*/React.forwardRef(BookFilled);

// This icon file is generated automatically.
var BookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z" } }] }, "name": "book", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BookOutlined = function BookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BookOutlined$2
  }));
};

BookOutlined.displayName = 'BookOutlined';
var BookOutlined$1 = /*#__PURE__*/React.forwardRef(BookOutlined);

// This icon file is generated automatically.
var BookTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M668 345.9V136h-96v211.4l49.5-35.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 01-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z", "fill": secondaryColor } }] }; }, "name": "book", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BookTwoTone = function BookTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BookTwoTone$2
  }));
};

BookTwoTone.displayName = 'BookTwoTone';
var BookTwoTone$1 = /*#__PURE__*/React.forwardRef(BookTwoTone);

// This icon file is generated automatically.
var BorderBottomOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "border-bottom", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderBottomOutlined = function BorderBottomOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderBottomOutlined$2
  }));
};

BorderBottomOutlined.displayName = 'BorderBottomOutlined';
var BorderBottomOutlined$1 = /*#__PURE__*/React.forwardRef(BorderBottomOutlined);

// This icon file is generated automatically.
var BorderHorizontalOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-horizontal", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderHorizontalOutlined = function BorderHorizontalOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderHorizontalOutlined$2
  }));
};

BorderHorizontalOutlined.displayName = 'BorderHorizontalOutlined';
var BorderHorizontalOutlined$1 = /*#__PURE__*/React.forwardRef(BorderHorizontalOutlined);

// This icon file is generated automatically.
var BorderInnerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-inner", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderInnerOutlined$2
  }));
};

BorderInnerOutlined.displayName = 'BorderInnerOutlined';
var BorderInnerOutlined$1 = /*#__PURE__*/React.forwardRef(BorderInnerOutlined);

// This icon file is generated automatically.
var BorderLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderLeftOutlined$2
  }));
};

BorderLeftOutlined.displayName = 'BorderLeftOutlined';
var BorderLeftOutlined$1 = /*#__PURE__*/React.forwardRef(BorderLeftOutlined);

// This icon file is generated automatically.
var BorderOuterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "border-outer", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderOuterOutlined$2
  }));
};

BorderOuterOutlined.displayName = 'BorderOuterOutlined';
var BorderOuterOutlined$1 = /*#__PURE__*/React.forwardRef(BorderOuterOutlined);

// This icon file is generated automatically.
var BorderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "border", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderOutlined = function BorderOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderOutlined$2
  }));
};

BorderOutlined.displayName = 'BorderOutlined';
var BorderOutlined$1 = /*#__PURE__*/React.forwardRef(BorderOutlined);

// This icon file is generated automatically.
var BorderRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderRightOutlined = function BorderRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderRightOutlined$2
  }));
};

BorderRightOutlined.displayName = 'BorderRightOutlined';
var BorderRightOutlined$1 = /*#__PURE__*/React.forwardRef(BorderRightOutlined);

// This icon file is generated automatically.
var BorderTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-top", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderTopOutlined$2
  }));
};

BorderTopOutlined.displayName = 'BorderTopOutlined';
var BorderTopOutlined$1 = /*#__PURE__*/React.forwardRef(BorderTopOutlined);

// This icon file is generated automatically.
var BorderVerticleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-verticle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderVerticleOutlined = function BorderVerticleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderVerticleOutlined$2
  }));
};

BorderVerticleOutlined.displayName = 'BorderVerticleOutlined';
var BorderVerticleOutlined$1 = /*#__PURE__*/React.forwardRef(BorderVerticleOutlined);

// This icon file is generated automatically.
var BorderlessTableOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M117 368h231v64H117zm559 0h241v64H676zm-264 0h200v64H412zm0 224h200v64H412zm264 0h241v64H676zm-559 0h231v64H117zm295-160V179h-64v666h64V592zm264-64V179h-64v666h64V432z" } }] }, "name": "borderless-table", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BorderlessTableOutlined$2
  }));
};

BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
var BorderlessTableOutlined$1 = /*#__PURE__*/React.forwardRef(BorderlessTableOutlined);

// This icon file is generated automatically.
var BoxPlotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z" } }] }, "name": "box-plot", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotFilled$2
  }));
};

BoxPlotFilled.displayName = 'BoxPlotFilled';
var BoxPlotFilled$1 = /*#__PURE__*/React.forwardRef(BoxPlotFilled);

// This icon file is generated automatically.
var BoxPlotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z" } }] }, "name": "box-plot", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotOutlined$2
  }));
};

BoxPlotOutlined.displayName = 'BoxPlotOutlined';
var BoxPlotOutlined$1 = /*#__PURE__*/React.forwardRef(BoxPlotOutlined);

// This icon file is generated automatically.
var BoxPlotTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 368h88v288h-88zm152 0h280v288H448z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z", "fill": primaryColor } }] }; }, "name": "box-plot", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotTwoTone$2
  }));
};

BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
var BoxPlotTwoTone$1 = /*#__PURE__*/React.forwardRef(BoxPlotTwoTone);

// This icon file is generated automatically.
var BranchesOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0034.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm408-491a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "branches", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BranchesOutlined = function BranchesOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BranchesOutlined$2
  }));
};

BranchesOutlined.displayName = 'BranchesOutlined';
var BranchesOutlined$1 = /*#__PURE__*/React.forwardRef(BranchesOutlined);

// This icon file is generated automatically.
var BugFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 00123.2-149.5A120.4 120.4 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "bug", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BugFilled = function BugFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BugFilled$2
  }));
};

BugFilled.displayName = 'BugFilled';
var BugFilled$1 = /*#__PURE__*/React.forwardRef(BugFilled);

// This icon file is generated automatically.
var BugOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 00123.2-149.5A120 120 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 01308 680V412h408v268z" } }] }, "name": "bug", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BugOutlined = function BugOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BugOutlined$2
  }));
};

BugOutlined.displayName = 'BugOutlined';
var BugOutlined$1 = /*#__PURE__*/React.forwardRef(BugOutlined);

// This icon file is generated automatically.
var BugTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 01-22.66 49.02 281.39 281.39 0 01-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 01-100.45-100.45 278.63 278.63 0 01-22.66-49.02A119.95 119.95 0 00188 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 01232 680v-96H84a8 8 0 01-8-8v-56a8 8 0 018-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 018-8h60a8 8 0 018 8 63 63 0 0063 63h560a63 63 0 0063-63 8 8 0 018-8h60a8 8 0 018 8c0 76.77-62.23 139-139 139v100h148a8 8 0 018 8v56a8 8 0 01-8 8H792zM368 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0174.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0174.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 00-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 00-45.4 45.39C373.95 218.85 368 243.67 368 272z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308z", "fill": secondaryColor } }] }; }, "name": "bug", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BugTwoTone = function BugTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BugTwoTone$2
  }));
};

BugTwoTone.displayName = 'BugTwoTone';
var BugTwoTone$1 = /*#__PURE__*/React.forwardRef(BugTwoTone);

// This icon file is generated automatically.
var BuildFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z" } }] }, "name": "build", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BuildFilled = function BuildFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BuildFilled$2
  }));
};

BuildFilled.displayName = 'BuildFilled';
var BuildFilled$1 = /*#__PURE__*/React.forwardRef(BuildFilled);

// This icon file is generated automatically.
var BuildOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z" } }] }, "name": "build", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BuildOutlined = function BuildOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BuildOutlined$2
  }));
};

BuildOutlined.displayName = 'BuildOutlined';
var BuildOutlined$1 = /*#__PURE__*/React.forwardRef(BuildOutlined);

// This icon file is generated automatically.
var BuildTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M144 546h200v200H144zm268-268h200v200H412z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z", "fill": primaryColor } }] }; }, "name": "build", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BuildTwoTone = function BuildTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BuildTwoTone$2
  }));
};

BuildTwoTone.displayName = 'BuildTwoTone';
var BuildTwoTone$1 = /*#__PURE__*/React.forwardRef(BuildTwoTone);

// This icon file is generated automatically.
var BulbFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z" } }] }, "name": "bulb", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BulbFilled = function BulbFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BulbFilled$2
  }));
};

BulbFilled.displayName = 'BulbFilled';
var BulbFilled$1 = /*#__PURE__*/React.forwardRef(BulbFilled);

// This icon file is generated automatically.
var BulbOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z" } }] }, "name": "bulb", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BulbOutlined = function BulbOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BulbOutlined$2
  }));
};

BulbOutlined.displayName = 'BulbOutlined';
var BulbOutlined$1 = /*#__PURE__*/React.forwardRef(BulbOutlined);

// This icon file is generated automatically.
var BulbTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z", "fill": primaryColor } }] }; }, "name": "bulb", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BulbTwoTone = function BulbTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: BulbTwoTone$2
  }));
};

BulbTwoTone.displayName = 'BulbTwoTone';
var BulbTwoTone$1 = /*#__PURE__*/React.forwardRef(BulbTwoTone);

// This icon file is generated automatically.
var CalculatorFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z" } }] }, "name": "calculator", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CalculatorFilled = function CalculatorFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorFilled$2
  }));
};

CalculatorFilled.displayName = 'CalculatorFilled';
var CalculatorFilled$1 = /*#__PURE__*/React.forwardRef(CalculatorFilled);

// This icon file is generated automatically.
var CalculatorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z" } }] }, "name": "calculator", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CalculatorOutlined = function CalculatorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorOutlined$2
  }));
};

CalculatorOutlined.displayName = 'CalculatorOutlined';
var CalculatorOutlined$1 = /*#__PURE__*/React.forwardRef(CalculatorOutlined);

// This icon file is generated automatically.
var CalculatorTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z", "fill": primaryColor } }] }; }, "name": "calculator", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorTwoTone$2
  }));
};

CalculatorTwoTone.displayName = 'CalculatorTwoTone';
var CalculatorTwoTone$1 = /*#__PURE__*/React.forwardRef(CalculatorTwoTone);

// This icon file is generated automatically.
var CalendarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z" } }] }, "name": "calendar", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CalendarFilled = function CalendarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CalendarFilled$2
  }));
};

CalendarFilled.displayName = 'CalendarFilled';
var CalendarFilled$1 = /*#__PURE__*/React.forwardRef(CalendarFilled);

// This icon file is generated automatically.
var CalendarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CalendarOutlined = function CalendarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CalendarOutlined$2
  }));
};

CalendarOutlined.displayName = 'CalendarOutlined';
var CalendarOutlined$1 = /*#__PURE__*/React.forwardRef(CalendarOutlined);

// This icon file is generated automatically.
var CalendarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z", "fill": primaryColor } }] }; }, "name": "calendar", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CalendarTwoTone$2
  }));
};

CalendarTwoTone.displayName = 'CalendarTwoTone';
var CalendarTwoTone$1 = /*#__PURE__*/React.forwardRef(CalendarTwoTone);

// This icon file is generated automatically.
var CameraFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 10192 0 96 96 0 10-192 0z" } }] }, "name": "camera", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CameraFilled = function CameraFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CameraFilled$2
  }));
};

CameraFilled.displayName = 'CameraFilled';
var CameraFilled$1 = /*#__PURE__*/React.forwardRef(CameraFilled);

// This icon file is generated automatically.
var CameraOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z" } }] }, "name": "camera", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CameraOutlined = function CameraOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CameraOutlined$2
  }));
};

CameraOutlined.displayName = 'CameraOutlined';
var CameraOutlined$1 = /*#__PURE__*/React.forwardRef(CameraOutlined);

// This icon file is generated automatically.
var CameraTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z", "fill": primaryColor } }] }; }, "name": "camera", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CameraTwoTone = function CameraTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CameraTwoTone$2
  }));
};

CameraTwoTone.displayName = 'CameraTwoTone';
var CameraTwoTone$1 = /*#__PURE__*/React.forwardRef(CameraTwoTone);

// This icon file is generated automatically.
var CarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z" } }] }, "name": "car", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CarFilled = function CarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CarFilled$2
  }));
};

CarFilled.displayName = 'CarFilled';
var CarFilled$1 = /*#__PURE__*/React.forwardRef(CarFilled);

// This icon file is generated automatically.
var CarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1080 0 40 40 0 10-80 0zm239-167.6L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "car", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CarOutlined = function CarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CarOutlined$2
  }));
};

CarOutlined.displayName = 'CarOutlined';
var CarOutlined$1 = /*#__PURE__*/React.forwardRef(CarOutlined);

// This icon file is generated automatically.
var CarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M720 581a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M224 581a40 40 0 1080 0 40 40 0 10-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "car", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CarTwoTone = function CarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CarTwoTone$2
  }));
};

CarTwoTone.displayName = 'CarTwoTone';
var CarTwoTone$1 = /*#__PURE__*/React.forwardRef(CarTwoTone);

// This icon file is generated automatically.
var CaretDownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretDownFilled = function CaretDownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownFilled$2
  }));
};

CaretDownFilled.displayName = 'CaretDownFilled';
var CaretDownFilled$1 = /*#__PURE__*/React.forwardRef(CaretDownFilled);

// This icon file is generated automatically.
var CaretDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownOutlined$2
  }));
};

CaretDownOutlined.displayName = 'CaretDownOutlined';
var CaretDownOutlined$1 = /*#__PURE__*/React.forwardRef(CaretDownOutlined);

// This icon file is generated automatically.
var CaretLeftFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] }, "name": "caret-left", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretLeftFilled = function CaretLeftFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftFilled$2
  }));
};

CaretLeftFilled.displayName = 'CaretLeftFilled';
var CaretLeftFilled$1 = /*#__PURE__*/React.forwardRef(CaretLeftFilled);

// This icon file is generated automatically.
var CaretLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] }, "name": "caret-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftOutlined$2
  }));
};

CaretLeftOutlined.displayName = 'CaretLeftOutlined';
var CaretLeftOutlined$1 = /*#__PURE__*/React.forwardRef(CaretLeftOutlined);

// This icon file is generated automatically.
var CaretRightFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] }, "name": "caret-right", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretRightFilled = function CaretRightFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightFilled$2
  }));
};

CaretRightFilled.displayName = 'CaretRightFilled';
var CaretRightFilled$1 = /*#__PURE__*/React.forwardRef(CaretRightFilled);

// This icon file is generated automatically.
var CaretRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] }, "name": "caret-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightOutlined$2
  }));
};

CaretRightOutlined.displayName = 'CaretRightOutlined';
var CaretRightOutlined$1 = /*#__PURE__*/React.forwardRef(CaretRightOutlined);

// This icon file is generated automatically.
var CaretUpFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretUpFilled = function CaretUpFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpFilled$2
  }));
};

CaretUpFilled.displayName = 'CaretUpFilled';
var CaretUpFilled$1 = /*#__PURE__*/React.forwardRef(CaretUpFilled);

// This icon file is generated automatically.
var CaretUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpOutlined$2
  }));
};

CaretUpOutlined.displayName = 'CaretUpOutlined';
var CaretUpOutlined$1 = /*#__PURE__*/React.forwardRef(CaretUpOutlined);

// This icon file is generated automatically.
var CarryOutFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "carry-out", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CarryOutFilled = function CarryOutFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutFilled$2
  }));
};

CarryOutFilled.displayName = 'CarryOutFilled';
var CarryOutFilled$1 = /*#__PURE__*/React.forwardRef(CarryOutFilled);

// This icon file is generated automatically.
var CarryOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z" } }] }, "name": "carry-out", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutOutlined$2
  }));
};

CarryOutOutlined.displayName = 'CarryOutOutlined';
var CarryOutOutlined$1 = /*#__PURE__*/React.forwardRef(CarryOutOutlined);

// This icon file is generated automatically.
var CarryOutTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z", "fill": primaryColor } }] }; }, "name": "carry-out", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CarryOutTwoTone = function CarryOutTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutTwoTone$2
  }));
};

CarryOutTwoTone.displayName = 'CarryOutTwoTone';
var CarryOutTwoTone$1 = /*#__PURE__*/React.forwardRef(CarryOutTwoTone);

// This icon file is generated automatically.
var CheckCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleFilled$2
  }));
};

CheckCircleFilled.displayName = 'CheckCircleFilled';
var CheckCircleFilled$1 = /*#__PURE__*/React.forwardRef(CheckCircleFilled);

// This icon file is generated automatically.
var CheckCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleOutlined$2
  }));
};

CheckCircleOutlined.displayName = 'CheckCircleOutlined';
var CheckCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CheckCircleOutlined);

// This icon file is generated automatically.
var CheckCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] }; }, "name": "check-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleTwoTone$2
  }));
};

CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
var CheckCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CheckCircleTwoTone);

// This icon file is generated automatically.
var CheckOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckOutlined$2
  }));
};

CheckOutlined.displayName = 'CheckOutlined';
var CheckOutlined$1 = /*#__PURE__*/React.forwardRef(CheckOutlined);

// This icon file is generated automatically.
var CheckSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 01-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareFilled$2
  }));
};

CheckSquareFilled.displayName = 'CheckSquareFilled';
var CheckSquareFilled$1 = /*#__PURE__*/React.forwardRef(CheckSquareFilled);

// This icon file is generated automatically.
var CheckSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.1 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "check-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckSquareOutlined = function CheckSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareOutlined$2
  }));
};

CheckSquareOutlined.displayName = 'CheckSquareOutlined';
var CheckSquareOutlined$1 = /*#__PURE__*/React.forwardRef(CheckSquareOutlined);

// This icon file is generated automatically.
var CheckSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 01-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M432.2 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z", "fill": primaryColor } }] }; }, "name": "check-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CheckSquareTwoTone = function CheckSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareTwoTone$2
  }));
};

CheckSquareTwoTone.displayName = 'CheckSquareTwoTone';
var CheckSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(CheckSquareTwoTone);

// This icon file is generated automatically.
var ChromeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0096 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z" } }] }, "name": "chrome", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ChromeFilled = function ChromeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ChromeFilled$2
  }));
};

ChromeFilled.displayName = 'ChromeFilled';
var ChromeFilled$1 = /*#__PURE__*/React.forwardRef(ChromeFilled);

// This icon file is generated automatically.
var ChromeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z" } }] }, "name": "chrome", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ChromeOutlined = function ChromeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ChromeOutlined$2
  }));
};

ChromeOutlined.displayName = 'ChromeOutlined';
var ChromeOutlined$1 = /*#__PURE__*/React.forwardRef(ChromeOutlined);

// This icon file is generated automatically.
var CiCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z" } }] }, "name": "ci-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CiCircleFilled = function CiCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleFilled$2
  }));
};

CiCircleFilled.displayName = 'CiCircleFilled';
var CiCircleFilled$1 = /*#__PURE__*/React.forwardRef(CiCircleFilled);

// This icon file is generated automatically.
var CiCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] }, "name": "ci-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CiCircleOutlined = function CiCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleOutlined$2
  }));
};

CiCircleOutlined.displayName = 'CiCircleOutlined';
var CiCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CiCircleOutlined);

// This icon file is generated automatically.
var CiCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] }; }, "name": "ci-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleTwoTone$2
  }));
};

CiCircleTwoTone.displayName = 'CiCircleTwoTone';
var CiCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CiCircleTwoTone);

// This icon file is generated automatically.
var CiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] }, "name": "ci", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CiOutlined = function CiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CiOutlined$2
  }));
};

CiOutlined.displayName = 'CiOutlined';
var CiOutlined$1 = /*#__PURE__*/React.forwardRef(CiOutlined);

// This icon file is generated automatically.
var CiTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] }; }, "name": "ci", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CiTwoTone = function CiTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CiTwoTone$2
  }));
};

CiTwoTone.displayName = 'CiTwoTone';
var CiTwoTone$1 = /*#__PURE__*/React.forwardRef(CiTwoTone);

// This icon file is generated automatically.
var ClearOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z" } }] }, "name": "clear", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClearOutlined = function ClearOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ClearOutlined$2
  }));
};

ClearOutlined.displayName = 'ClearOutlined';
var ClearOutlined$1 = /*#__PURE__*/React.forwardRef(ClearOutlined);

// This icon file is generated automatically.
var ClockCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z" } }] }, "name": "clock-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleFilled$2
  }));
};

ClockCircleFilled.displayName = 'ClockCircleFilled';
var ClockCircleFilled$1 = /*#__PURE__*/React.forwardRef(ClockCircleFilled);

// This icon file is generated automatically.
var ClockCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleOutlined$2
  }));
};

ClockCircleOutlined.displayName = 'ClockCircleOutlined';
var ClockCircleOutlined$1 = /*#__PURE__*/React.forwardRef(ClockCircleOutlined);

// This icon file is generated automatically.
var ClockCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z", "fill": primaryColor } }] }; }, "name": "clock-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleTwoTone$2
  }));
};

ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
var ClockCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(ClockCircleTwoTone);

// This icon file is generated automatically.
var CloseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleFilled$2
  }));
};

CloseCircleFilled.displayName = 'CloseCircleFilled';
var CloseCircleFilled$1 = /*#__PURE__*/React.forwardRef(CloseCircleFilled);

// This icon file is generated automatically.
var CloseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "close-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleOutlined$2
  }));
};

CloseCircleOutlined.displayName = 'CloseCircleOutlined';
var CloseCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CloseCircleOutlined);

// This icon file is generated automatically.
var CloseCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z", "fill": primaryColor } }] }; }, "name": "close-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleTwoTone$2
  }));
};

CloseCircleTwoTone.displayName = 'CloseCircleTwoTone';
var CloseCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CloseCircleTwoTone);

// This icon file is generated automatically.
var CloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, "name": "close", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseOutlined = function CloseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseOutlined$2
  }));
};

CloseOutlined.displayName = 'CloseOutlined';
var CloseOutlined$1 = /*#__PURE__*/React.forwardRef(CloseOutlined);

// This icon file is generated automatically.
var CloseSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z" } }] }, "name": "close-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CloseSquareFilled = function CloseSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareFilled$2
  }));
};

CloseSquareFilled.displayName = 'CloseSquareFilled';
var CloseSquareFilled$1 = /*#__PURE__*/React.forwardRef(CloseSquareFilled);

// This icon file is generated automatically.
var CloseSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "close-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseSquareOutlined = function CloseSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareOutlined$2
  }));
};

CloseSquareOutlined.displayName = 'CloseSquareOutlined';
var CloseSquareOutlined$1 = /*#__PURE__*/React.forwardRef(CloseSquareOutlined);

// This icon file is generated automatically.
var CloseSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z", "fill": primaryColor } }] }; }, "name": "close-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareTwoTone$2
  }));
};

CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
var CloseSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(CloseSquareTwoTone);

// This icon file is generated automatically.
var CloudDownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud-download", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudDownloadOutlined = function CloudDownloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudDownloadOutlined$2
  }));
};

CloudDownloadOutlined.displayName = 'CloudDownloadOutlined';
var CloudDownloadOutlined$1 = /*#__PURE__*/React.forwardRef(CloudDownloadOutlined);

// This icon file is generated automatically.
var CloudFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CloudFilled = function CloudFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudFilled$2
  }));
};

CloudFilled.displayName = 'CloudFilled';
var CloudFilled$1 = /*#__PURE__*/React.forwardRef(CloudFilled);

// This icon file is generated automatically.
var CloudOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z" } }] }, "name": "cloud", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudOutlined = function CloudOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudOutlined$2
  }));
};

CloudOutlined.displayName = 'CloudOutlined';
var CloudOutlined$1 = /*#__PURE__*/React.forwardRef(CloudOutlined);

// This icon file is generated automatically.
var CloudServerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z" } }, { "tag": "path", "attrs": { "d": "M424 748a32 32 0 1064 0 32 32 0 10-64 0zm0-178a32 32 0 1064 0 32 32 0 10-64 0z" } }, { "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }] }, "name": "cloud-server", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudServerOutlined = function CloudServerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudServerOutlined$2
  }));
};

CloudServerOutlined.displayName = 'CloudServerOutlined';
var CloudServerOutlined$1 = /*#__PURE__*/React.forwardRef(CloudServerOutlined);

// This icon file is generated automatically.
var CloudSyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }, { "tag": "path", "attrs": { "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 003 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 00-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z" } }] }, "name": "cloud-sync", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudSyncOutlined = function CloudSyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudSyncOutlined$2
  }));
};

CloudSyncOutlined.displayName = 'CloudSyncOutlined';
var CloudSyncOutlined$1 = /*#__PURE__*/React.forwardRef(CloudSyncOutlined);

// This icon file is generated automatically.
var CloudTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 00-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 00-52.4 49.9 240.47 240.47 0 00-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 00-66.1 43.7A123.1 123.1 0 00140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 00884 612c0-56.2-37.8-105.5-92.1-120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z", "fill": primaryColor } }] }; }, "name": "cloud", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CloudTwoTone = function CloudTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudTwoTone$2
  }));
};

CloudTwoTone.displayName = 'CloudTwoTone';
var CloudTwoTone$1 = /*#__PURE__*/React.forwardRef(CloudTwoTone);

// This icon file is generated automatically.
var CloudUploadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud-upload", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CloudUploadOutlined$2
  }));
};

CloudUploadOutlined.displayName = 'CloudUploadOutlined';
var CloudUploadOutlined$1 = /*#__PURE__*/React.forwardRef(CloudUploadOutlined);

// This icon file is generated automatically.
var ClusterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "cluster", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClusterOutlined = function ClusterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ClusterOutlined$2
  }));
};

ClusterOutlined.displayName = 'ClusterOutlined';
var ClusterOutlined$1 = /*#__PURE__*/React.forwardRef(ClusterOutlined);

// This icon file is generated automatically.
var CodeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z" } }] }, "name": "code", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodeFilled = function CodeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodeFilled$2
  }));
};

CodeFilled.displayName = 'CodeFilled';
var CodeFilled$1 = /*#__PURE__*/React.forwardRef(CodeFilled);

// This icon file is generated automatically.
var CodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "code", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodeOutlined = function CodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodeOutlined$2
  }));
};

CodeOutlined.displayName = 'CodeOutlined';
var CodeOutlined$1 = /*#__PURE__*/React.forwardRef(CodeOutlined);

// This icon file is generated automatically.
var CodeSandboxCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z" } }] }, "name": "code-sandbox-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodeSandboxCircleFilled = function CodeSandboxCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxCircleFilled$2
  }));
};

CodeSandboxCircleFilled.displayName = 'CodeSandboxCircleFilled';
var CodeSandboxCircleFilled$1 = /*#__PURE__*/React.forwardRef(CodeSandboxCircleFilled);

// This icon file is generated automatically.
var CodeSandboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z" } }] }, "name": "code-sandbox", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxOutlined$2
  }));
};

CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
var CodeSandboxOutlined$1 = /*#__PURE__*/React.forwardRef(CodeSandboxOutlined);

// This icon file is generated automatically.
var CodeSandboxSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z" } }] }, "name": "code-sandbox-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxSquareFilled$2
  }));
};

CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
var CodeSandboxSquareFilled$1 = /*#__PURE__*/React.forwardRef(CodeSandboxSquareFilled);

// This icon file is generated automatically.
var CodeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z", "fill": primaryColor } }] }; }, "name": "code", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CodeTwoTone = function CodeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodeTwoTone$2
  }));
};

CodeTwoTone.displayName = 'CodeTwoTone';
var CodeTwoTone$1 = /*#__PURE__*/React.forwardRef(CodeTwoTone);

// This icon file is generated automatically.
var CodepenCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] }, "name": "codepen-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleFilled$2
  }));
};

CodepenCircleFilled.displayName = 'CodepenCircleFilled';
var CodepenCircleFilled$1 = /*#__PURE__*/React.forwardRef(CodepenCircleFilled);

// This icon file is generated automatically.
var CodepenCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] }, "name": "codepen-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodepenCircleOutlined = function CodepenCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleOutlined$2
  }));
};

CodepenCircleOutlined.displayName = 'CodepenCircleOutlined';
var CodepenCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CodepenCircleOutlined);

// This icon file is generated automatically.
var CodepenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 00-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z" } }] }, "name": "codepen", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodepenOutlined = function CodepenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodepenOutlined$2
  }));
};

CodepenOutlined.displayName = 'CodepenOutlined';
var CodepenOutlined$1 = /*#__PURE__*/React.forwardRef(CodepenOutlined);

// This icon file is generated automatically.
var CodepenSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z" } }] }, "name": "codepen-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CodepenSquareFilled$2
  }));
};

CodepenSquareFilled.displayName = 'CodepenSquareFilled';
var CodepenSquareFilled$1 = /*#__PURE__*/React.forwardRef(CodepenSquareFilled);

// This icon file is generated automatically.
var CoffeeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z" } }] }, "name": "coffee", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CoffeeOutlined = function CoffeeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CoffeeOutlined$2
  }));
};

CoffeeOutlined.displayName = 'CoffeeOutlined';
var CoffeeOutlined$1 = /*#__PURE__*/React.forwardRef(CoffeeOutlined);

// This icon file is generated automatically.
var ColumnHeightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 00-11.3 0L403.6 366.3a7.23 7.23 0 005.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z" } }] }, "name": "column-height", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ColumnHeightOutlined$2
  }));
};

ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
var ColumnHeightOutlined$1 = /*#__PURE__*/React.forwardRef(ColumnHeightOutlined);

// This icon file is generated automatically.
var ColumnWidthOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 00-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z" } }] }, "name": "column-width", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ColumnWidthOutlined = function ColumnWidthOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ColumnWidthOutlined$2
  }));
};

ColumnWidthOutlined.displayName = 'ColumnWidthOutlined';
var ColumnWidthOutlined$1 = /*#__PURE__*/React.forwardRef(ColumnWidthOutlined);

// This icon file is generated automatically.
var CommentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zm-280 0c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }, { "tag": "path", "attrs": { "d": "M894 345a343.92 343.92 0 00-189-130v.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l.8 132.6c0 3.2.5 6.4 1.5 9.4a31.95 31.95 0 0040.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-.5.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102zm505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-.2-.1A367.31 367.31 0 00729 676c76.4-105.3 88.8-237.6 44.4-350.4l.6.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z" } }, { "tag": "path", "attrs": { "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }] }, "name": "comment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CommentOutlined = function CommentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CommentOutlined$2
  }));
};

CommentOutlined.displayName = 'CommentOutlined';
var CommentOutlined$1 = /*#__PURE__*/React.forwardRef(CommentOutlined);

// This icon file is generated automatically.
var CompassFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z" } }] }, "name": "compass", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CompassFilled = function CompassFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CompassFilled$2
  }));
};

CompassFilled.displayName = 'CompassFilled';
var CompassFilled$1 = /*#__PURE__*/React.forwardRef(CompassFilled);

// This icon file is generated automatically.
var CompassOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 00-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 00-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z" } }] }, "name": "compass", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CompassOutlined = function CompassOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CompassOutlined$2
  }));
};

CompassOutlined.displayName = 'CompassOutlined';
var CompassOutlined$1 = /*#__PURE__*/React.forwardRef(CompassOutlined);

// This icon file is generated automatically.
var CompassTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }] }; }, "name": "compass", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CompassTwoTone = function CompassTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CompassTwoTone$2
  }));
};

CompassTwoTone.displayName = 'CompassTwoTone';
var CompassTwoTone$1 = /*#__PURE__*/React.forwardRef(CompassTwoTone);

// This icon file is generated automatically.
var CompressOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zm16-576h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zm578 576H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm0-384H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z" } }] }, "name": "compress", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CompressOutlined = function CompressOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CompressOutlined$2
  }));
};

CompressOutlined.displayName = 'CompressOutlined';
var CompressOutlined$1 = /*#__PURE__*/React.forwardRef(CompressOutlined);

// This icon file is generated automatically.
var ConsoleSqlOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4.1 14.7-14.5 25.1-36 25.1z" } }, { "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }, { "tag": "path", "attrs": { "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zm-298.6 53.4c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-.1 73.7 43 118.9 111.1 118.9zm0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2.1-43.6 21.2-71.1 52.9-71.1z" } }] }, "name": "console-sql", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ConsoleSqlOutlined = function ConsoleSqlOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ConsoleSqlOutlined$2
  }));
};

ConsoleSqlOutlined.displayName = 'ConsoleSqlOutlined';
var ConsoleSqlOutlined$1 = /*#__PURE__*/React.forwardRef(ConsoleSqlOutlined);

// This icon file is generated automatically.
var ContactsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z" } }] }, "name": "contacts", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ContactsFilled = function ContactsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ContactsFilled$2
  }));
};

ContactsFilled.displayName = 'ContactsFilled';
var ContactsFilled$1 = /*#__PURE__*/React.forwardRef(ContactsFilled);

// This icon file is generated automatically.
var ContactsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z" } }] }, "name": "contacts", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ContactsOutlined$2
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
var ContactsOutlined$1 = /*#__PURE__*/React.forwardRef(ContactsOutlined);

// This icon file is generated automatically.
var ContactsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M460.3 526a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 01-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 01-8 8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }] }; }, "name": "contacts", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ContactsTwoTone = function ContactsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ContactsTwoTone$2
  }));
};

ContactsTwoTone.displayName = 'ContactsTwoTone';
var ContactsTwoTone$1 = /*#__PURE__*/React.forwardRef(ContactsTwoTone);

// This icon file is generated automatically.
var ContainerFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z" } }] }, "name": "container", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ContainerFilled = function ContainerFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ContainerFilled$2
  }));
};

ContainerFilled.displayName = 'ContainerFilled';
var ContainerFilled$1 = /*#__PURE__*/React.forwardRef(ContainerFilled);

// This icon file is generated automatically.
var ContainerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "container", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ContainerOutlined = function ContainerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ContainerOutlined$2
  }));
};

ContainerOutlined.displayName = 'ContainerOutlined';
var ContainerOutlined$1 = /*#__PURE__*/React.forwardRef(ContainerOutlined);

// This icon file is generated automatically.
var ContainerTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "container", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ContainerTwoTone$2
  }));
};

ContainerTwoTone.displayName = 'ContainerTwoTone';
var ContainerTwoTone$1 = /*#__PURE__*/React.forwardRef(ContainerTwoTone);

// This icon file is generated automatically.
var ControlFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1072 0 36 36 0 10-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z" } }] }, "name": "control", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ControlFilled = function ControlFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ControlFilled$2
  }));
};

ControlFilled.displayName = 'ControlFilled';
var ControlFilled$1 = /*#__PURE__*/React.forwardRef(ControlFilled);

// This icon file is generated automatically.
var ControlOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z" } }] }, "name": "control", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ControlOutlined = function ControlOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ControlOutlined$2
  }));
};

ControlOutlined.displayName = 'ControlOutlined';
var ControlOutlined$1 = /*#__PURE__*/React.forwardRef(ControlOutlined);

// This icon file is generated automatically.
var ControlTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M616 440a36 36 0 1072 0 36 36 0 10-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 01408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z", "fill": primaryColor } }] }; }, "name": "control", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ControlTwoTone = function ControlTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ControlTwoTone$2
  }));
};

ControlTwoTone.displayName = 'ControlTwoTone';
var ControlTwoTone$1 = /*#__PURE__*/React.forwardRef(ControlTwoTone);

// This icon file is generated automatically.
var CopyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z" } }] }, "name": "copy", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CopyFilled = function CopyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyFilled$2
  }));
};

CopyFilled.displayName = 'CopyFilled';
var CopyFilled$1 = /*#__PURE__*/React.forwardRef(CopyFilled);

// This icon file is generated automatically.
var CopyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyOutlined = function CopyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyOutlined$2
  }));
};

CopyOutlined.displayName = 'CopyOutlined';
var CopyOutlined$1 = /*#__PURE__*/React.forwardRef(CopyOutlined);

// This icon file is generated automatically.
var CopyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z", "fill": primaryColor } }] }; }, "name": "copy", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CopyTwoTone = function CopyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyTwoTone$2
  }));
};

CopyTwoTone.displayName = 'CopyTwoTone';
var CopyTwoTone$1 = /*#__PURE__*/React.forwardRef(CopyTwoTone);

// This icon file is generated automatically.
var CopyrightCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z" } }] }, "name": "copyright-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleFilled$2
  }));
};

CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
var CopyrightCircleFilled$1 = /*#__PURE__*/React.forwardRef(CopyrightCircleFilled);

// This icon file is generated automatically.
var CopyrightCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] }, "name": "copyright-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleOutlined$2
  }));
};

CopyrightCircleOutlined.displayName = 'CopyrightCircleOutlined';
var CopyrightCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CopyrightCircleOutlined);

// This icon file is generated automatically.
var CopyrightCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] }; }, "name": "copyright-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleTwoTone$2
  }));
};

CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
var CopyrightCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CopyrightCircleTwoTone);

// This icon file is generated automatically.
var CopyrightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] }, "name": "copyright", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyrightOutlined = function CopyrightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightOutlined$2
  }));
};

CopyrightOutlined.displayName = 'CopyrightOutlined';
var CopyrightOutlined$1 = /*#__PURE__*/React.forwardRef(CopyrightOutlined);

// This icon file is generated automatically.
var CopyrightTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] }; }, "name": "copyright", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightTwoTone$2
  }));
};

CopyrightTwoTone.displayName = 'CopyrightTwoTone';
var CopyrightTwoTone$1 = /*#__PURE__*/React.forwardRef(CopyrightTwoTone);

// This icon file is generated automatically.
var CreditCardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z" } }] }, "name": "credit-card", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CreditCardFilled = function CreditCardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardFilled$2
  }));
};

CreditCardFilled.displayName = 'CreditCardFilled';
var CreditCardFilled$1 = /*#__PURE__*/React.forwardRef(CreditCardFilled);

// This icon file is generated automatically.
var CreditCardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z" } }] }, "name": "credit-card", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardOutlined$2
  }));
};

CreditCardOutlined.displayName = 'CreditCardOutlined';
var CreditCardOutlined$1 = /*#__PURE__*/React.forwardRef(CreditCardOutlined);

// This icon file is generated automatically.
var CreditCardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z", "fill": primaryColor } }] }; }, "name": "credit-card", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CreditCardTwoTone = function CreditCardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardTwoTone$2
  }));
};

CreditCardTwoTone.displayName = 'CreditCardTwoTone';
var CreditCardTwoTone$1 = /*#__PURE__*/React.forwardRef(CreditCardTwoTone);

// This icon file is generated automatically.
var CrownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z" } }] }, "name": "crown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CrownFilled = function CrownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CrownFilled$2
  }));
};

CrownFilled.displayName = 'CrownFilled';
var CrownFilled$1 = /*#__PURE__*/React.forwardRef(CrownFilled);

// This icon file is generated automatically.
var CrownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z" } }] }, "name": "crown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CrownOutlined = function CrownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CrownOutlined$2
  }));
};

CrownOutlined.displayName = 'CrownOutlined';
var CrownOutlined$1 = /*#__PURE__*/React.forwardRef(CrownOutlined);

// This icon file is generated automatically.
var CrownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z", "fill": primaryColor } }] }; }, "name": "crown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CrownTwoTone = function CrownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CrownTwoTone$2
  }));
};

CrownTwoTone.displayName = 'CrownTwoTone';
var CrownTwoTone$1 = /*#__PURE__*/React.forwardRef(CrownTwoTone);

// This icon file is generated automatically.
var CustomerServiceFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z" } }] }, "name": "customer-service", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceFilled$2
  }));
};

CustomerServiceFilled.displayName = 'CustomerServiceFilled';
var CustomerServiceFilled$1 = /*#__PURE__*/React.forwardRef(CustomerServiceFilled);

// This icon file is generated automatically.
var CustomerServiceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z" } }] }, "name": "customer-service", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceOutlined$2
  }));
};

CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
var CustomerServiceOutlined$1 = /*#__PURE__*/React.forwardRef(CustomerServiceOutlined);

// This icon file is generated automatically.
var CustomerServiceTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 632h128v192H696zm-496 0h128v192H200z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z", "fill": primaryColor } }] }; }, "name": "customer-service", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CustomerServiceTwoTone = function CustomerServiceTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceTwoTone$2
  }));
};

CustomerServiceTwoTone.displayName = 'CustomerServiceTwoTone';
var CustomerServiceTwoTone$1 = /*#__PURE__*/React.forwardRef(CustomerServiceTwoTone);

// This icon file is generated automatically.
var DashOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z" } }] }, "name": "dash", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DashOutlined = function DashOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DashOutlined$2
  }));
};

DashOutlined.displayName = 'DashOutlined';
var DashOutlined$1 = /*#__PURE__*/React.forwardRef(DashOutlined);

// This icon file is generated automatically.
var DashboardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 01-11.3 0L261.7 352a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z" } }] }, "name": "dashboard", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DashboardFilled = function DashboardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DashboardFilled$2
  }));
};

DashboardFilled.displayName = 'DashboardFilled';
var DashboardFilled$1 = /*#__PURE__*/React.forwardRef(DashboardFilled);

// This icon file is generated automatically.
var DashboardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z" } }] }, "name": "dashboard", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DashboardOutlined = function DashboardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DashboardOutlined$2
  }));
};

DashboardOutlined.displayName = 'DashboardOutlined';
var DashboardOutlined$1 = /*#__PURE__*/React.forwardRef(DashboardOutlined);

// This icon file is generated automatically.
var DashboardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 00884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 01-11.3 0l-56.6-56.6a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "dashboard", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DashboardTwoTone$2
  }));
};

DashboardTwoTone.displayName = 'DashboardTwoTone';
var DashboardTwoTone$1 = /*#__PURE__*/React.forwardRef(DashboardTwoTone);

// This icon file is generated automatically.
var DatabaseFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z" } }] }, "name": "database", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DatabaseFilled = function DatabaseFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseFilled$2
  }));
};

DatabaseFilled.displayName = 'DatabaseFilled';
var DatabaseFilled$1 = /*#__PURE__*/React.forwardRef(DatabaseFilled);

// This icon file is generated automatically.
var DatabaseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "database", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseOutlined$2
  }));
};

DatabaseOutlined.displayName = 'DatabaseOutlined';
var DatabaseOutlined$1 = /*#__PURE__*/React.forwardRef(DatabaseOutlined);

// This icon file is generated automatically.
var DatabaseTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 512a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0-544a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }] }; }, "name": "database", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseTwoTone$2
  }));
};

DatabaseTwoTone.displayName = 'DatabaseTwoTone';
var DatabaseTwoTone$1 = /*#__PURE__*/React.forwardRef(DatabaseTwoTone);

// This icon file is generated automatically.
var DeleteColumnOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M651.1 641.9a7.84 7.84 0 00-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H378c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L474.2 776 371.8 898.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zm556-256h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z" } }] }, "name": "delete-column", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeleteColumnOutlined = function DeleteColumnOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeleteColumnOutlined$2
  }));
};

DeleteColumnOutlined.displayName = 'DeleteColumnOutlined';
var DeleteColumnOutlined$1 = /*#__PURE__*/React.forwardRef(DeleteColumnOutlined);

// This icon file is generated automatically.
var DeleteFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z" } }] }, "name": "delete", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DeleteFilled = function DeleteFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeleteFilled$2
  }));
};

DeleteFilled.displayName = 'DeleteFilled';
var DeleteFilled$1 = /*#__PURE__*/React.forwardRef(DeleteFilled);

// This icon file is generated automatically.
var DeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeleteOutlined = function DeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeleteOutlined$2
  }));
};

DeleteOutlined.displayName = 'DeleteOutlined';
var DeleteOutlined$1 = /*#__PURE__*/React.forwardRef(DeleteOutlined);

// This icon file is generated automatically.
var DeleteRowOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M819.8 512l102.4-122.9a8.06 8.06 0 00-6.1-13.2h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H648c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L744.2 512 641.8 634.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-84 204h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z" } }] }, "name": "delete-row", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeleteRowOutlined = function DeleteRowOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeleteRowOutlined$2
  }));
};

DeleteRowOutlined.displayName = 'DeleteRowOutlined';
var DeleteRowOutlined$1 = /*#__PURE__*/React.forwardRef(DeleteRowOutlined);

// This icon file is generated automatically.
var DeleteTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M292.7 840h438.6l24.2-512h-487z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z", "fill": primaryColor } }] }; }, "name": "delete", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DeleteTwoTone = function DeleteTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeleteTwoTone$2
  }));
};

DeleteTwoTone.displayName = 'DeleteTwoTone';
var DeleteTwoTone$1 = /*#__PURE__*/React.forwardRef(DeleteTwoTone);

// This icon file is generated automatically.
var DeliveredProcedureOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M632 698.3l141.9-112a8 8 0 000-12.6L632 461.7c-5.3-4.2-13-.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zm261.3-405L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zm264 436h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z" } }] }, "name": "delivered-procedure", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeliveredProcedureOutlined$2
  }));
};

DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
var DeliveredProcedureOutlined$1 = /*#__PURE__*/React.forwardRef(DeliveredProcedureOutlined);

// This icon file is generated automatically.
var DeploymentUnitOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 01-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0165.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z" } }] }, "name": "deployment-unit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeploymentUnitOutlined = function DeploymentUnitOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DeploymentUnitOutlined$2
  }));
};

DeploymentUnitOutlined.displayName = 'DeploymentUnitOutlined';
var DeploymentUnitOutlined$1 = /*#__PURE__*/React.forwardRef(DeploymentUnitOutlined);

// This icon file is generated automatically.
var DesktopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }] }, "name": "desktop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DesktopOutlined = function DesktopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DesktopOutlined$2
  }));
};

DesktopOutlined.displayName = 'DesktopOutlined';
var DesktopOutlined$1 = /*#__PURE__*/React.forwardRef(DesktopOutlined);

// This icon file is generated automatically.
var DiffFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z" } }] }, "name": "diff", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DiffFilled = function DiffFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DiffFilled$2
  }));
};

DiffFilled.displayName = 'DiffFilled';
var DiffFilled$1 = /*#__PURE__*/React.forwardRef(DiffFilled);

// This icon file is generated automatically.
var DiffOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z" } }] }, "name": "diff", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DiffOutlined = function DiffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DiffOutlined$2
  }));
};

DiffOutlined.displayName = 'DiffOutlined';
var DiffOutlined$1 = /*#__PURE__*/React.forwardRef(DiffOutlined);

// This icon file is generated automatically.
var DiffTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z", "fill": primaryColor } }] }; }, "name": "diff", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DiffTwoTone = function DiffTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DiffTwoTone$2
  }));
};

DiffTwoTone.displayName = 'DiffTwoTone';
var DiffTwoTone$1 = /*#__PURE__*/React.forwardRef(DiffTwoTone);

// This icon file is generated automatically.
var DingdingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] }, "name": "dingding", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DingdingOutlined = function DingdingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DingdingOutlined$2
  }));
};

DingdingOutlined.displayName = 'DingdingOutlined';
var DingdingOutlined$1 = /*#__PURE__*/React.forwardRef(DingdingOutlined);

// This icon file is generated automatically.
var DingtalkCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] }, "name": "dingtalk-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkCircleFilled$2
  }));
};

DingtalkCircleFilled.displayName = 'DingtalkCircleFilled';
var DingtalkCircleFilled$1 = /*#__PURE__*/React.forwardRef(DingtalkCircleFilled);

// This icon file is generated automatically.
var DingtalkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] }, "name": "dingtalk", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkOutlined$2
  }));
};

DingtalkOutlined.displayName = 'DingtalkOutlined';
var DingtalkOutlined$1 = /*#__PURE__*/React.forwardRef(DingtalkOutlined);

// This icon file is generated automatically.
var DingtalkSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] }, "name": "dingtalk-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkSquareFilled$2
  }));
};

DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
var DingtalkSquareFilled$1 = /*#__PURE__*/React.forwardRef(DingtalkSquareFilled);

// This icon file is generated automatically.
var DisconnectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 00-11.3 0L209.4 249a8.03 8.03 0 000 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z" } }] }, "name": "disconnect", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DisconnectOutlined$2
  }));
};

DisconnectOutlined.displayName = 'DisconnectOutlined';
var DisconnectOutlined$1 = /*#__PURE__*/React.forwardRef(DisconnectOutlined);

// This icon file is generated automatically.
var DislikeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z" } }] }, "name": "dislike", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DislikeFilled = function DislikeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DislikeFilled$2
  }));
};

DislikeFilled.displayName = 'DislikeFilled';
var DislikeFilled$1 = /*#__PURE__*/React.forwardRef(DislikeFilled);

// This icon file is generated automatically.
var DislikeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z" } }] }, "name": "dislike", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DislikeOutlined = function DislikeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DislikeOutlined$2
  }));
};

DislikeOutlined.displayName = 'DislikeOutlined';
var DislikeOutlined$1 = /*#__PURE__*/React.forwardRef(DislikeOutlined);

// This icon file is generated automatically.
var DislikeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0042.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z", "fill": primaryColor } }] }; }, "name": "dislike", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DislikeTwoTone$2
  }));
};

DislikeTwoTone.displayName = 'DislikeTwoTone';
var DislikeTwoTone$1 = /*#__PURE__*/React.forwardRef(DislikeTwoTone);

// This icon file is generated automatically.
var DollarCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z" } }] }, "name": "dollar-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleFilled$2
  }));
};

DollarCircleFilled.displayName = 'DollarCircleFilled';
var DollarCircleFilled$1 = /*#__PURE__*/React.forwardRef(DollarCircleFilled);

// This icon file is generated automatically.
var DollarCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DollarCircleOutlined = function DollarCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleOutlined$2
  }));
};

DollarCircleOutlined.displayName = 'DollarCircleOutlined';
var DollarCircleOutlined$1 = /*#__PURE__*/React.forwardRef(DollarCircleOutlined);

// This icon file is generated automatically.
var DollarCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] }; }, "name": "dollar-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DollarCircleTwoTone = function DollarCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleTwoTone$2
  }));
};

DollarCircleTwoTone.displayName = 'DollarCircleTwoTone';
var DollarCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(DollarCircleTwoTone);

// This icon file is generated automatically.
var DollarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DollarOutlined = function DollarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DollarOutlined$2
  }));
};

DollarOutlined.displayName = 'DollarOutlined';
var DollarOutlined$1 = /*#__PURE__*/React.forwardRef(DollarOutlined);

// This icon file is generated automatically.
var DollarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] }; }, "name": "dollar", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DollarTwoTone = function DollarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DollarTwoTone$2
  }));
};

DollarTwoTone.displayName = 'DollarTwoTone';
var DollarTwoTone$1 = /*#__PURE__*/React.forwardRef(DollarTwoTone);

// This icon file is generated automatically.
var DotChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "dot-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DotChartOutlined = function DotChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DotChartOutlined$2
  }));
};

DotChartOutlined.displayName = 'DotChartOutlined';
var DotChartOutlined$1 = /*#__PURE__*/React.forwardRef(DotChartOutlined);

// This icon file is generated automatically.
var DoubleLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DoubleLeftOutlined$2
  }));
};

DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
var DoubleLeftOutlined$1 = /*#__PURE__*/React.forwardRef(DoubleLeftOutlined);

// This icon file is generated automatically.
var DoubleRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DoubleRightOutlined$2
  }));
};

DoubleRightOutlined.displayName = 'DoubleRightOutlined';
var DoubleRightOutlined$1 = /*#__PURE__*/React.forwardRef(DoubleRightOutlined);

// This icon file is generated automatically.
var DownCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "down-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DownCircleFilled = function DownCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleFilled$2
  }));
};

DownCircleFilled.displayName = 'DownCircleFilled';
var DownCircleFilled$1 = /*#__PURE__*/React.forwardRef(DownCircleFilled);

// This icon file is generated automatically.
var DownCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "down-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownCircleOutlined = function DownCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleOutlined$2
  }));
};

DownCircleOutlined.displayName = 'DownCircleOutlined';
var DownCircleOutlined$1 = /*#__PURE__*/React.forwardRef(DownCircleOutlined);

// This icon file is generated automatically.
var DownCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] }; }, "name": "down-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DownCircleTwoTone = function DownCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleTwoTone$2
  }));
};

DownCircleTwoTone.displayName = 'DownCircleTwoTone';
var DownCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(DownCircleTwoTone);

// This icon file is generated automatically.
var DownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownOutlined = function DownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownOutlined$2
  }));
};

DownOutlined.displayName = 'DownOutlined';
var DownOutlined$1 = /*#__PURE__*/React.forwardRef(DownOutlined);

// This icon file is generated automatically.
var DownSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "down-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DownSquareFilled = function DownSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareFilled$2
  }));
};

DownSquareFilled.displayName = 'DownSquareFilled';
var DownSquareFilled$1 = /*#__PURE__*/React.forwardRef(DownSquareFilled);

// This icon file is generated automatically.
var DownSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "down-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownSquareOutlined = function DownSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareOutlined$2
  }));
};

DownSquareOutlined.displayName = 'DownSquareOutlined';
var DownSquareOutlined$1 = /*#__PURE__*/React.forwardRef(DownSquareOutlined);

// This icon file is generated automatically.
var DownSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z", "fill": primaryColor } }] }; }, "name": "down-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DownSquareTwoTone = function DownSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareTwoTone$2
  }));
};

DownSquareTwoTone.displayName = 'DownSquareTwoTone';
var DownSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(DownSquareTwoTone);

// This icon file is generated automatically.
var DownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownloadOutlined = function DownloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DownloadOutlined$2
  }));
};

DownloadOutlined.displayName = 'DownloadOutlined';
var DownloadOutlined$1 = /*#__PURE__*/React.forwardRef(DownloadOutlined);

// This icon file is generated automatically.
var DragOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z" } }] }, "name": "drag", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DragOutlined = function DragOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DragOutlined$2
  }));
};

DragOutlined.displayName = 'DragOutlined';
var DragOutlined$1 = /*#__PURE__*/React.forwardRef(DragOutlined);

// This icon file is generated automatically.
var DribbbleCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M675.1 328.3a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z" } }] }, "name": "dribbble-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DribbbleCircleFilled = function DribbbleCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleCircleFilled$2
  }));
};

DribbbleCircleFilled.displayName = 'DribbbleCircleFilled';
var DribbbleCircleFilled$1 = /*#__PURE__*/React.forwardRef(DribbbleCircleFilled);

// This icon file is generated automatically.
var DribbbleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 01512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z" } }] }, "name": "dribbble", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleOutlined$2
  }));
};

DribbbleOutlined.displayName = 'DribbbleOutlined';
var DribbbleOutlined$1 = /*#__PURE__*/React.forwardRef(DribbbleOutlined);

// This icon file is generated automatically.
var DribbbleSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] }, "name": "dribbble-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DribbbleSquareFilled = function DribbbleSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareFilled$2
  }));
};

DribbbleSquareFilled.displayName = 'DribbbleSquareFilled';
var DribbbleSquareFilled$1 = /*#__PURE__*/React.forwardRef(DribbbleSquareFilled);

// This icon file is generated automatically.
var DribbbleSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] }, "name": "dribbble-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DribbbleSquareOutlined = function DribbbleSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareOutlined$2
  }));
};

DribbbleSquareOutlined.displayName = 'DribbbleSquareOutlined';
var DribbbleSquareOutlined$1 = /*#__PURE__*/React.forwardRef(DribbbleSquareOutlined);

// This icon file is generated automatically.
var DropboxCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z" } }] }, "name": "dropbox-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DropboxCircleFilled$2
  }));
};

DropboxCircleFilled.displayName = 'DropboxCircleFilled';
var DropboxCircleFilled$1 = /*#__PURE__*/React.forwardRef(DropboxCircleFilled);

// This icon file is generated automatically.
var DropboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z" } }] }, "name": "dropbox", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DropboxOutlined = function DropboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DropboxOutlined$2
  }));
};

DropboxOutlined.displayName = 'DropboxOutlined';
var DropboxOutlined$1 = /*#__PURE__*/React.forwardRef(DropboxOutlined);

// This icon file is generated automatically.
var DropboxSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z" } }] }, "name": "dropbox-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: DropboxSquareFilled$2
  }));
};

DropboxSquareFilled.displayName = 'DropboxSquareFilled';
var DropboxSquareFilled$1 = /*#__PURE__*/React.forwardRef(DropboxSquareFilled);

// This icon file is generated automatically.
var EditFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z" } }] }, "name": "edit", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EditFilled = function EditFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EditFilled$2
  }));
};

EditFilled.displayName = 'EditFilled';
var EditFilled$1 = /*#__PURE__*/React.forwardRef(EditFilled);

// This icon file is generated automatically.
var EditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EditOutlined = function EditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EditOutlined$2
  }));
};

EditOutlined.displayName = 'EditOutlined';
var EditOutlined$1 = /*#__PURE__*/React.forwardRef(EditOutlined);

// This icon file is generated automatically.
var EditTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z", "fill": primaryColor } }] }; }, "name": "edit", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EditTwoTone = function EditTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EditTwoTone$2
  }));
};

EditTwoTone.displayName = 'EditTwoTone';
var EditTwoTone$1 = /*#__PURE__*/React.forwardRef(EditTwoTone);

// This icon file is generated automatically.
var EllipsisOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlined$2
  }));
};

EllipsisOutlined.displayName = 'EllipsisOutlined';
var EllipsisOutlined$1 = /*#__PURE__*/React.forwardRef(EllipsisOutlined);

// This icon file is generated automatically.
var EnterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EnterOutlined = function EnterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EnterOutlined$2
  }));
};

EnterOutlined.displayName = 'EnterOutlined';
var EnterOutlined$1 = /*#__PURE__*/React.forwardRef(EnterOutlined);

// This icon file is generated automatically.
var EnvironmentFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 00400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 00512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] }, "name": "environment", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EnvironmentFilled = function EnvironmentFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentFilled$2
  }));
};

EnvironmentFilled.displayName = 'EnvironmentFilled';
var EnvironmentFilled$1 = /*#__PURE__*/React.forwardRef(EnvironmentFilled);

// This icon file is generated automatically.
var EnvironmentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z" } }] }, "name": "environment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentOutlined$2
  }));
};

EnvironmentOutlined.displayName = 'EnvironmentOutlined';
var EnvironmentOutlined$1 = /*#__PURE__*/React.forwardRef(EnvironmentOutlined);

// This icon file is generated automatically.
var EnvironmentTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z", "fill": primaryColor } }] }; }, "name": "environment", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentTwoTone$2
  }));
};

EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
var EnvironmentTwoTone$1 = /*#__PURE__*/React.forwardRef(EnvironmentTwoTone);

// This icon file is generated automatically.
var EuroCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z" } }] }, "name": "euro-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EuroCircleFilled = function EuroCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleFilled$2
  }));
};

EuroCircleFilled.displayName = 'EuroCircleFilled';
var EuroCircleFilled$1 = /*#__PURE__*/React.forwardRef(EuroCircleFilled);

// This icon file is generated automatically.
var EuroCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] }, "name": "euro-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleOutlined$2
  }));
};

EuroCircleOutlined.displayName = 'EuroCircleOutlined';
var EuroCircleOutlined$1 = /*#__PURE__*/React.forwardRef(EuroCircleOutlined);

// This icon file is generated automatically.
var EuroCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] }; }, "name": "euro-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EuroCircleTwoTone = function EuroCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleTwoTone$2
  }));
};

EuroCircleTwoTone.displayName = 'EuroCircleTwoTone';
var EuroCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(EuroCircleTwoTone);

// This icon file is generated automatically.
var EuroOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] }, "name": "euro", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EuroOutlined = function EuroOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EuroOutlined$2
  }));
};

EuroOutlined.displayName = 'EuroOutlined';
var EuroOutlined$1 = /*#__PURE__*/React.forwardRef(EuroOutlined);

// This icon file is generated automatically.
var EuroTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] }; }, "name": "euro", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EuroTwoTone = function EuroTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EuroTwoTone$2
  }));
};

EuroTwoTone.displayName = 'EuroTwoTone';
var EuroTwoTone$1 = /*#__PURE__*/React.forwardRef(EuroTwoTone);

// This icon file is generated automatically.
var ExceptionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1064 0 32 32 0 10-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "exception", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExceptionOutlined$2
  }));
};

ExceptionOutlined.displayName = 'ExceptionOutlined';
var ExceptionOutlined$1 = /*#__PURE__*/React.forwardRef(ExceptionOutlined);

// This icon file is generated automatically.
var ExclamationCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleFilled$2
  }));
};

ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
var ExclamationCircleFilled$1 = /*#__PURE__*/React.forwardRef(ExclamationCircleFilled);

// This icon file is generated automatically.
var ExclamationCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleOutlined$2
  }));
};

ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
var ExclamationCircleOutlined$1 = /*#__PURE__*/React.forwardRef(ExclamationCircleOutlined);

// This icon file is generated automatically.
var ExclamationCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "exclamation-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleTwoTone$2
  }));
};

ExclamationCircleTwoTone.displayName = 'ExclamationCircleTwoTone';
var ExclamationCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(ExclamationCircleTwoTone);

// This icon file is generated automatically.
var ExclamationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 804a64 64 0 10128 0 64 64 0 10-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationOutlined$2
  }));
};

ExclamationOutlined.displayName = 'ExclamationOutlined';
var ExclamationOutlined$1 = /*#__PURE__*/React.forwardRef(ExclamationOutlined);

// This icon file is generated automatically.
var ExpandAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] }, "name": "expand-alt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExpandAltOutlined$2
  }));
};

ExpandAltOutlined.displayName = 'ExpandAltOutlined';
var ExpandAltOutlined$1 = /*#__PURE__*/React.forwardRef(ExpandAltOutlined);

// This icon file is generated automatically.
var ExpandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm578 576h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z" } }] }, "name": "expand", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExpandOutlined = function ExpandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExpandOutlined$2
  }));
};

ExpandOutlined.displayName = 'ExpandOutlined';
var ExpandOutlined$1 = /*#__PURE__*/React.forwardRef(ExpandOutlined);

// This icon file is generated automatically.
var ExperimentFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0094.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 01164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0036.6-82.5z" } }] }, "name": "experiment", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ExperimentFilled = function ExperimentFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentFilled$2
  }));
};

ExperimentFilled.displayName = 'ExperimentFilled';
var ExperimentFilled$1 = /*#__PURE__*/React.forwardRef(ExperimentFilled);

// This icon file is generated automatically.
var ExperimentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 472a40 40 0 1080 0 40 40 0 10-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z" } }] }, "name": "experiment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentOutlined$2
  }));
};

ExperimentOutlined.displayName = 'ExperimentOutlined';
var ExperimentOutlined$1 = /*#__PURE__*/React.forwardRef(ExperimentOutlined);

// This icon file is generated automatically.
var ExperimentTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 01552 512a40 40 0 01-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0040 39.4z", "fill": primaryColor } }] }; }, "name": "experiment", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentTwoTone$2
  }));
};

ExperimentTwoTone.displayName = 'ExperimentTwoTone';
var ExperimentTwoTone$1 = /*#__PURE__*/React.forwardRef(ExperimentTwoTone);

// This icon file is generated automatically.
var ExportOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] }, "name": "export", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExportOutlined = function ExportOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ExportOutlined$2
  }));
};

ExportOutlined.displayName = 'ExportOutlined';
var ExportOutlined$1 = /*#__PURE__*/React.forwardRef(ExportOutlined);

// This icon file is generated automatically.
var EyeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 512a112 112 0 10224 0 112 112 0 10-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] }, "name": "eye", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EyeFilled = function EyeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EyeFilled$2
  }));
};

EyeFilled.displayName = 'EyeFilled';
var EyeFilled$1 = /*#__PURE__*/React.forwardRef(EyeFilled);

// This icon file is generated automatically.
var EyeInvisibleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M508 624a112 112 0 00112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 00-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 000 11.31L155.25 889a8 8 0 0011.31 0l712.16-712.12a8 8 0 000-11.32zM332 512a176 176 0 01258.88-155.28l-48.62 48.62a112.08 112.08 0 00-140.92 140.92l-48.62 48.62A175.09 175.09 0 01332 512z" } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 01445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z" } }] }, "name": "eye-invisible", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleFilled$2
  }));
};

EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
var EyeInvisibleFilled$1 = /*#__PURE__*/React.forwardRef(EyeInvisibleFilled);

// This icon file is generated automatically.
var EyeInvisibleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleOutlined$2
  }));
};

EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
var EyeInvisibleOutlined$1 = /*#__PURE__*/React.forwardRef(EyeInvisibleOutlined);

// This icon file is generated automatically.
var EyeInvisibleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M254.89 758.85l125.57-125.57a176 176 0 01248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 01-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zM878.63 165.56L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z", "fill": primaryColor } }] }; }, "name": "eye-invisible", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleTwoTone$2
  }));
};

EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
var EyeInvisibleTwoTone$1 = /*#__PURE__*/React.forwardRef(EyeInvisibleTwoTone);

// This icon file is generated automatically.
var EyeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EyeOutlined$2
  }));
};

EyeOutlined.displayName = 'EyeOutlined';
var EyeOutlined$1 = /*#__PURE__*/React.forwardRef(EyeOutlined);

// This icon file is generated automatically.
var EyeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M81.8 537.8a60.3 60.3 0 010-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z", "fill": primaryColor } }] }; }, "name": "eye", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EyeTwoTone = function EyeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: EyeTwoTone$2
  }));
};

EyeTwoTone.displayName = 'EyeTwoTone';
var EyeTwoTone$1 = /*#__PURE__*/React.forwardRef(EyeTwoTone);

// This icon file is generated automatically.
var FacebookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z" } }] }, "name": "facebook", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FacebookFilled = function FacebookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FacebookFilled$2
  }));
};

FacebookFilled.displayName = 'FacebookFilled';
var FacebookFilled$1 = /*#__PURE__*/React.forwardRef(FacebookFilled);

// This icon file is generated automatically.
var FacebookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z" } }] }, "name": "facebook", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FacebookOutlined = function FacebookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FacebookOutlined$2
  }));
};

FacebookOutlined.displayName = 'FacebookOutlined';
var FacebookOutlined$1 = /*#__PURE__*/React.forwardRef(FacebookOutlined);

// This icon file is generated automatically.
var FallOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 00-11.3 0l-45 45.2a8.03 8.03 0 000 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 004.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z" } }] }, "name": "fall", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FallOutlined = function FallOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FallOutlined$2
  }));
};

FallOutlined.displayName = 'FallOutlined';
var FallOutlined$1 = /*#__PURE__*/React.forwardRef(FallOutlined);

// This icon file is generated automatically.
var FastBackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-backward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardFilled$2
  }));
};

FastBackwardFilled.displayName = 'FastBackwardFilled';
var FastBackwardFilled$1 = /*#__PURE__*/React.forwardRef(FastBackwardFilled);

// This icon file is generated automatically.
var FastBackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-backward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardOutlined$2
  }));
};

FastBackwardOutlined.displayName = 'FastBackwardOutlined';
var FastBackwardOutlined$1 = /*#__PURE__*/React.forwardRef(FastBackwardOutlined);

// This icon file is generated automatically.
var FastForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-forward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FastForwardFilled = function FastForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardFilled$2
  }));
};

FastForwardFilled.displayName = 'FastForwardFilled';
var FastForwardFilled$1 = /*#__PURE__*/React.forwardRef(FastForwardFilled);

// This icon file is generated automatically.
var FastForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-forward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FastForwardOutlined = function FastForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardOutlined$2
  }));
};

FastForwardOutlined.displayName = 'FastForwardOutlined';
var FastForwardOutlined$1 = /*#__PURE__*/React.forwardRef(FastForwardOutlined);

// This icon file is generated automatically.
var FieldBinaryOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9a86.14 86.14 0 01-26.3 24.4c-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1a8 8 0 00-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8zm-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8.1-19.4.4-31.8.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2a87.94 87.94 0 0127.4 28.2c6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4.2 12.4.4 23 .4 31.8.1 14.8-.4 32.5-1.4 53.3z" } }] }, "name": "field-binary", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FieldBinaryOutlined$2
  }));
};

FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
var FieldBinaryOutlined$1 = /*#__PURE__*/React.forwardRef(FieldBinaryOutlined);

// This icon file is generated automatically.
var FieldNumberOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zm378 413H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-152.2-63c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2zm-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6.1-35.8 8.2-63 24.5-83.2z" } }] }, "name": "field-number", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FieldNumberOutlined$2
  }));
};

FieldNumberOutlined.displayName = 'FieldNumberOutlined';
var FieldNumberOutlined$1 = /*#__PURE__*/React.forwardRef(FieldNumberOutlined);

// This icon file is generated automatically.
var FieldStringOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M875.6 515.9c2.1.8 4.4-.3 5.2-2.4.2-.4.2-.9.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4.1 26.6 1.8 30.7 3.4zm-537-40.5l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9zM841 729a36 36 0 1072 0 36 36 0 10-72 0zM653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-.4c-4.9.5-6.2.6-8.3.8-4.1.3-7.8.5-12.6.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z" } }] }, "name": "field-string", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FieldStringOutlined$2
  }));
};

FieldStringOutlined.displayName = 'FieldStringOutlined';
var FieldStringOutlined$1 = /*#__PURE__*/React.forwardRef(FieldStringOutlined);

// This icon file is generated automatically.
var FieldTimeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z" } }, { "tag": "path", "attrs": { "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z" } }] }, "name": "field-time", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FieldTimeOutlined$2
  }));
};

FieldTimeOutlined.displayName = 'FieldTimeOutlined';
var FieldTimeOutlined$1 = /*#__PURE__*/React.forwardRef(FieldTimeOutlined);

// This icon file is generated automatically.
var FileAddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M480 580H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V644h108a8 8 0 008-8v-48a8 8 0 00-8-8H544V472a8 8 0 00-8-8h-48a8 8 0 00-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] }, "name": "file-add", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileAddFilled = function FileAddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileAddFilled$2
  }));
};

FileAddFilled.displayName = 'FileAddFilled';
var FileAddFilled$1 = /*#__PURE__*/React.forwardRef(FileAddFilled);

// This icon file is generated automatically.
var FileAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z" } }] }, "name": "file-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileAddOutlined = function FileAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileAddOutlined$2
  }));
};

FileAddOutlined.displayName = 'FileAddOutlined';
var FileAddOutlined$1 = /*#__PURE__*/React.forwardRef(FileAddOutlined);

// This icon file is generated automatically.
var FileAddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z", "fill": primaryColor } }] }; }, "name": "file-add", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileAddTwoTone = function FileAddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileAddTwoTone$2
  }));
};

FileAddTwoTone.displayName = 'FileAddTwoTone';
var FileAddTwoTone$1 = /*#__PURE__*/React.forwardRef(FileAddTwoTone);

// This icon file is generated automatically.
var FileDoneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 00-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "file-done", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileDoneOutlined$2
  }));
};

FileDoneOutlined.displayName = 'FileDoneOutlined';
var FileDoneOutlined$1 = /*#__PURE__*/React.forwardRef(FileDoneOutlined);

// This icon file is generated automatically.
var FileExcelFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 00-10.27-5.79h-38.44a12 12 0 00-6.4 1.85 12 12 0 00-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 00-1.84 6.39 12 12 0 0012 12h34.46a12 12 0 0010.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0010.23 5.72h37.48a12 12 0 006.48-1.9 12 12 0 003.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 001.9-6.5 12 12 0 00-12-12h-35.7a12 12 0 00-10.29 5.84z" } }] }, "name": "file-excel", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileExcelFilled = function FileExcelFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelFilled$2
  }));
};

FileExcelFilled.displayName = 'FileExcelFilled';
var FileExcelFilled$1 = /*#__PURE__*/React.forwardRef(FileExcelFilled);

// This icon file is generated automatically.
var FileExcelOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z" } }] }, "name": "file-excel", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileExcelOutlined = function FileExcelOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelOutlined$2
  }));
};

FileExcelOutlined.displayName = 'FileExcelOutlined';
var FileExcelOutlined$1 = /*#__PURE__*/React.forwardRef(FileExcelOutlined);

// This icon file is generated automatically.
var FileExcelTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm51.6 120h35.7a12.04 12.04 0 0110.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 01-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z", "fill": primaryColor } }] }; }, "name": "file-excel", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileExcelTwoTone = function FileExcelTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelTwoTone$2
  }));
};

FileExcelTwoTone.displayName = 'FileExcelTwoTone';
var FileExcelTwoTone$1 = /*#__PURE__*/React.forwardRef(FileExcelTwoTone);

// This icon file is generated automatically.
var FileExclamationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 100-80 40 40 0 000 80zm32-152V448a8 8 0 00-8-8h-48a8 8 0 00-8 8v184a8 8 0 008 8h48a8 8 0 008-8z" } }] }, "name": "file-exclamation", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileExclamationFilled = function FileExclamationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationFilled$2
  }));
};

FileExclamationFilled.displayName = 'FileExclamationFilled';
var FileExclamationFilled$1 = /*#__PURE__*/React.forwardRef(FileExclamationFilled);

// This icon file is generated automatically.
var FileExclamationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM472 744a40 40 0 1080 0 40 40 0 10-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z" } }] }, "name": "file-exclamation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileExclamationOutlined = function FileExclamationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationOutlined$2
  }));
};

FileExclamationOutlined.displayName = 'FileExclamationOutlined';
var FileExclamationOutlined$1 = /*#__PURE__*/React.forwardRef(FileExclamationOutlined);

// This icon file is generated automatically.
var FileExclamationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "file-exclamation", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationTwoTone$2
  }));
};

FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
var FileExclamationTwoTone$1 = /*#__PURE__*/React.forwardRef(FileExclamationTwoTone);

// This icon file is generated automatically.
var FileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] }, "name": "file", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileFilled = function FileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileFilled$2
  }));
};

FileFilled.displayName = 'FileFilled';
var FileFilled$1 = /*#__PURE__*/React.forwardRef(FileFilled);

// This icon file is generated automatically.
var FileGifOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v.7c-.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l.9 2.8h49.2l-.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z" } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z" } }, { "tag": "path", "attrs": { "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z" } }] }, "name": "file-gif", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileGifOutlined = function FileGifOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileGifOutlined$2
  }));
};

FileGifOutlined.displayName = 'FileGifOutlined';
var FileGifOutlined$1 = /*#__PURE__*/React.forwardRef(FileGifOutlined);

// This icon file is generated automatically.
var FileImageFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8 8 0 0112.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z" } }] }, "name": "file-image", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileImageFilled = function FileImageFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileImageFilled$2
  }));
};

FileImageFilled.displayName = 'FileImageFilled';
var FileImageFilled$1 = /*#__PURE__*/React.forwardRef(FileImageFilled);

// This icon file is generated automatically.
var FileImageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-image", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileImageOutlined = function FileImageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileImageOutlined$2
  }));
};

FileImageOutlined.displayName = 'FileImageOutlined';
var FileImageOutlined$1 = /*#__PURE__*/React.forwardRef(FileImageOutlined);

// This icon file is generated automatically.
var FileImageTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0112.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "file-image", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileImageTwoTone = function FileImageTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileImageTwoTone$2
  }));
};

FileImageTwoTone.displayName = 'FileImageTwoTone';
var FileImageTwoTone$1 = /*#__PURE__*/React.forwardRef(FileImageTwoTone);

// This icon file is generated automatically.
var FileJpgOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z" } }] }, "name": "file-jpg", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileJpgOutlined$2
  }));
};

FileJpgOutlined.displayName = 'FileJpgOutlined';
var FileJpgOutlined$1 = /*#__PURE__*/React.forwardRef(FileJpgOutlined);

// This icon file is generated automatically.
var FileMarkdownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0014.62 9.5h24.06a16 16 0 0014.63-9.51l59.1-133.35V758a16 16 0 0016.01 16H641a16 16 0 0016-16V486a16 16 0 00-16-16h-34.75a16 16 0 00-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 00-14.67-9.61H383a16 16 0 00-16 16v272a16 16 0 0016 16h27.13a16 16 0 0016-16V600.93z" } }] }, "name": "file-markdown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileMarkdownFilled = function FileMarkdownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownFilled$2
  }));
};

FileMarkdownFilled.displayName = 'FileMarkdownFilled';
var FileMarkdownFilled$1 = /*#__PURE__*/React.forwardRef(FileMarkdownFilled);

// This icon file is generated automatically.
var FileMarkdownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z" } }] }, "name": "file-markdown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownOutlined$2
  }));
};

FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
var FileMarkdownOutlined$1 = /*#__PURE__*/React.forwardRef(FileMarkdownOutlined);

// This icon file is generated automatically.
var FileMarkdownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 01-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z", "fill": primaryColor } }] }; }, "name": "file-markdown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownTwoTone$2
  }));
};

FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
var FileMarkdownTwoTone$1 = /*#__PURE__*/React.forwardRef(FileMarkdownTwoTone);

// This icon file is generated automatically.
var FileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileOutlined = function FileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileOutlined$2
  }));
};

FileOutlined.displayName = 'FileOutlined';
var FileOutlined$1 = /*#__PURE__*/React.forwardRef(FileOutlined);

// This icon file is generated automatically.
var FilePdfFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 015.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 01-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 01-1.12-.15 2.07 2.07 0 01-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 01-1.36 6.31 6.7 6.7 0 01-2.17 1.28z" } }] }, "name": "file-pdf", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilePdfFilled = function FilePdfFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfFilled$2
  }));
};

FilePdfFilled.displayName = 'FilePdfFilled';
var FilePdfFilled$1 = /*#__PURE__*/React.forwardRef(FilePdfFilled);

// This icon file is generated automatically.
var FilePdfOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-pdf", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FilePdfOutlined = function FilePdfOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfOutlined$2
  }));
};

FilePdfOutlined.displayName = 'FilePdfOutlined';
var FilePdfOutlined$1 = /*#__PURE__*/React.forwardRef(FilePdfOutlined);

// This icon file is generated automatically.
var FilePdfTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z", "fill": primaryColor } }] }; }, "name": "file-pdf", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FilePdfTwoTone = function FilePdfTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfTwoTone$2
  }));
};

FilePdfTwoTone.displayName = 'FilePdfTwoTone';
var FilePdfTwoTone$1 = /*#__PURE__*/React.forwardRef(FilePdfTwoTone);

// This icon file is generated automatically.
var FilePptFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 00-12 12v276a12 12 0 0012 12h32.53a12 12 0 0012-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z" } }] }, "name": "file-ppt", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilePptFilled = function FilePptFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilePptFilled$2
  }));
};

FilePptFilled.displayName = 'FilePptFilled';
var FilePptFilled$1 = /*#__PURE__*/React.forwardRef(FilePptFilled);

// This icon file is generated automatically.
var FilePptOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-ppt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FilePptOutlined = function FilePptOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilePptOutlined$2
  }));
};

FilePptOutlined.displayName = 'FilePptOutlined';
var FilePptOutlined$1 = /*#__PURE__*/React.forwardRef(FilePptOutlined);

// This icon file is generated automatically.
var FilePptTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z", "fill": primaryColor } }] }; }, "name": "file-ppt", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FilePptTwoTone = function FilePptTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilePptTwoTone$2
  }));
};

FilePptTwoTone.displayName = 'FilePptTwoTone';
var FilePptTwoTone$1 = /*#__PURE__*/React.forwardRef(FilePptTwoTone);

// This icon file is generated automatically.
var FileProtectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M644.7 669.2a7.92 7.92 0 00-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 00-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z" } }] }, "name": "file-protect", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileProtectOutlined$2
  }));
};

FileProtectOutlined.displayName = 'FileProtectOutlined';
var FileProtectOutlined$1 = /*#__PURE__*/React.forwardRef(FileProtectOutlined);

// This icon file is generated automatically.
var FileSearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 000-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "file-search", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileSearchOutlined = function FileSearchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileSearchOutlined$2
  }));
};

FileSearchOutlined.displayName = 'FileSearchOutlined';
var FileSearchOutlined$1 = /*#__PURE__*/React.forwardRef(FileSearchOutlined);

// This icon file is generated automatically.
var FileSyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 003 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 00-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 00-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0012.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z" } }] }, "name": "file-sync", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileSyncOutlined$2
  }));
};

FileSyncOutlined.displayName = 'FileSyncOutlined';
var FileSyncOutlined$1 = /*#__PURE__*/React.forwardRef(FileSyncOutlined);

// This icon file is generated automatically.
var FileTextFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" } }] }, "name": "file-text", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileTextFilled = function FileTextFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileTextFilled$2
  }));
};

FileTextFilled.displayName = 'FileTextFilled';
var FileTextFilled$1 = /*#__PURE__*/React.forwardRef(FileTextFilled);

// This icon file is generated automatically.
var FileTextOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z" } }] }, "name": "file-text", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileTextOutlined = function FileTextOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileTextOutlined$2
  }));
};

FileTextOutlined.displayName = 'FileTextOutlined';
var FileTextOutlined$1 = /*#__PURE__*/React.forwardRef(FileTextOutlined);

// This icon file is generated automatically.
var FileTextTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "file-text", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileTextTwoTone = function FileTextTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileTextTwoTone$2
  }));
};

FileTextTwoTone.displayName = 'FileTextTwoTone';
var FileTextTwoTone$1 = /*#__PURE__*/React.forwardRef(FileTextTwoTone);

// This icon file is generated automatically.
var FileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] }; }, "name": "file", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileTwoTone = function FileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileTwoTone$2
  }));
};

FileTwoTone.displayName = 'FileTwoTone';
var FileTwoTone$1 = /*#__PURE__*/React.forwardRef(FileTwoTone);

// This icon file is generated automatically.
var FileUnknownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 100-64 32 32 0 000 64z" } }] }, "name": "file-unknown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownFilled$2
  }));
};

FileUnknownFilled.displayName = 'FileUnknownFilled';
var FileUnknownFilled$1 = /*#__PURE__*/React.forwardRef(FileUnknownFilled);

// This icon file is generated automatically.
var FileUnknownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1064 0 32 32 0 10-64 0z" } }] }, "name": "file-unknown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileUnknownOutlined = function FileUnknownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownOutlined$2
  }));
};

FileUnknownOutlined.displayName = 'FileUnknownOutlined';
var FileUnknownOutlined$1 = /*#__PURE__*/React.forwardRef(FileUnknownOutlined);

// This icon file is generated automatically.
var FileUnknownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M480 744a32 32 0 1064 0 32 32 0 10-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z", "fill": primaryColor } }] }; }, "name": "file-unknown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileUnknownTwoTone = function FileUnknownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownTwoTone$2
  }));
};

FileUnknownTwoTone.displayName = 'FileUnknownTwoTone';
var FileUnknownTwoTone$1 = /*#__PURE__*/React.forwardRef(FileUnknownTwoTone);

// This icon file is generated automatically.
var FileWordFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0011.6 8.9h31.77a12 12 0 0011.6-8.88l74.37-276a12 12 0 00.4-3.12 12 12 0 00-12-12h-35.57a12 12 0 00-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 00528.1 472h-32.2a12 12 0 00-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 00-11.68-9.29h-35.39a12 12 0 00-3.11.41 12 12 0 00-8.47 14.7l74.17 276A12 12 0 00415.6 772h31.99a12 12 0 0011.59-8.9l52.81-197z" } }] }, "name": "file-word", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileWordFilled = function FileWordFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileWordFilled$2
  }));
};

FileWordFilled.displayName = 'FileWordFilled';
var FileWordFilled$1 = /*#__PURE__*/React.forwardRef(FileWordFilled);

// This icon file is generated automatically.
var FileWordOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z" } }] }, "name": "file-word", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileWordOutlined = function FileWordOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileWordOutlined$2
  }));
};

FileWordOutlined.displayName = 'FileWordOutlined';
var FileWordOutlined$1 = /*#__PURE__*/React.forwardRef(FileWordOutlined);

// This icon file is generated automatically.
var FileWordTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0111.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0111.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z", "fill": primaryColor } }] }; }, "name": "file-word", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileWordTwoTone$2
  }));
};

FileWordTwoTone.displayName = 'FileWordTwoTone';
var FileWordTwoTone$1 = /*#__PURE__*/React.forwardRef(FileWordTwoTone);

// This icon file is generated automatically.
var FileZipFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" } }] }, "name": "file-zip", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileZipFilled = function FileZipFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileZipFilled$2
  }));
};

FileZipFilled.displayName = 'FileZipFilled';
var FileZipFilled$1 = /*#__PURE__*/React.forwardRef(FileZipFilled);

// This icon file is generated automatically.
var FileZipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-zip", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileZipOutlined = function FileZipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileZipOutlined$2
  }));
};

FileZipOutlined.displayName = 'FileZipOutlined';
var FileZipOutlined$1 = /*#__PURE__*/React.forwardRef(FileZipOutlined);

// This icon file is generated automatically.
var FileZipTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M344 630h32v2h-32z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z", "fill": primaryColor } }] }; }, "name": "file-zip", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileZipTwoTone = function FileZipTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FileZipTwoTone$2
  }));
};

FileZipTwoTone.displayName = 'FileZipTwoTone';
var FileZipTwoTone$1 = /*#__PURE__*/React.forwardRef(FileZipTwoTone);

// This icon file is generated automatically.
var FilterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilterFilled = function FilterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilled$2
  }));
};

FilterFilled.displayName = 'FilterFilled';
var FilterFilled$1 = /*#__PURE__*/React.forwardRef(FilterFilled);

// This icon file is generated automatically.
var FilterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z" } }] }, "name": "filter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FilterOutlined = function FilterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilterOutlined$2
  }));
};

FilterOutlined.displayName = 'FilterOutlined';
var FilterOutlined$1 = /*#__PURE__*/React.forwardRef(FilterOutlined);

// This icon file is generated automatically.
var FilterTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z", "fill": primaryColor } }] }; }, "name": "filter", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FilterTwoTone = function FilterTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FilterTwoTone$2
  }));
};

FilterTwoTone.displayName = 'FilterTwoTone';
var FilterTwoTone$1 = /*#__PURE__*/React.forwardRef(FilterTwoTone);

// This icon file is generated automatically.
var FireFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9z" } }] }, "name": "fire", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FireFilled = function FireFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FireFilled$2
  }));
};

FireFilled.displayName = 'FireFilled';
var FireFilled$1 = /*#__PURE__*/React.forwardRef(FireFilled);

// This icon file is generated automatically.
var FireOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z" } }] }, "name": "fire", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FireOutlined = function FireOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FireOutlined$2
  }));
};

FireOutlined.displayName = 'FireOutlined';
var FireOutlined$1 = /*#__PURE__*/React.forwardRef(FireOutlined);

// This icon file is generated automatically.
var FireTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 01-51 24.4 73.36 73.36 0 01-53.4-18.8 74.01 74.01 0 01-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 01-12.1 46.5 354.26 354.26 0 01-58.2 101 349.6 349.6 0 01-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 00-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z", "fill": primaryColor } }] }; }, "name": "fire", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FireTwoTone = function FireTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FireTwoTone$2
  }));
};

FireTwoTone.displayName = 'FireTwoTone';
var FireTwoTone$1 = /*#__PURE__*/React.forwardRef(FireTwoTone);

// This icon file is generated automatically.
var FlagFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z" } }] }, "name": "flag", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FlagFilled = function FlagFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FlagFilled$2
  }));
};

FlagFilled.displayName = 'FlagFilled';
var FlagFilled$1 = /*#__PURE__*/React.forwardRef(FlagFilled);

// This icon file is generated automatically.
var FlagOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z" } }] }, "name": "flag", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FlagOutlined = function FlagOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FlagOutlined$2
  }));
};

FlagOutlined.displayName = 'FlagOutlined';
var FlagOutlined$1 = /*#__PURE__*/React.forwardRef(FlagOutlined);

// This icon file is generated automatically.
var FlagTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 232h368v336H184z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z", "fill": primaryColor } }] }; }, "name": "flag", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FlagTwoTone = function FlagTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FlagTwoTone$2
  }));
};

FlagTwoTone.displayName = 'FlagTwoTone';
var FlagTwoTone$1 = /*#__PURE__*/React.forwardRef(FlagTwoTone);

// This icon file is generated automatically.
var FolderAddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z" } }] }, "name": "folder-add", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FolderAddFilled = function FolderAddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddFilled$2
  }));
};

FolderAddFilled.displayName = 'FolderAddFilled';
var FolderAddFilled$1 = /*#__PURE__*/React.forwardRef(FolderAddFilled);

// This icon file is generated automatically.
var FolderAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderAddOutlined = function FolderAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddOutlined$2
  }));
};

FolderAddOutlined.displayName = 'FolderAddOutlined';
var FolderAddOutlined$1 = /*#__PURE__*/React.forwardRef(FolderAddOutlined);

// This icon file is generated automatically.
var FolderAddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z", "fill": primaryColor } }] }; }, "name": "folder-add", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FolderAddTwoTone = function FolderAddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddTwoTone$2
  }));
};

FolderAddTwoTone.displayName = 'FolderAddTwoTone';
var FolderAddTwoTone$1 = /*#__PURE__*/React.forwardRef(FolderAddTwoTone);

// This icon file is generated automatically.
var FolderFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z" } }] }, "name": "folder", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FolderFilled = function FolderFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderFilled$2
  }));
};

FolderFilled.displayName = 'FolderFilled';
var FolderFilled$1 = /*#__PURE__*/React.forwardRef(FolderFilled);

// This icon file is generated automatically.
var FolderOpenFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z" } }] }, "name": "folder-open", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenFilled = function FolderOpenFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenFilled$2
  }));
};

FolderOpenFilled.displayName = 'FolderOpenFilled';
var FolderOpenFilled$1 = /*#__PURE__*/React.forwardRef(FolderOpenFilled);

// This icon file is generated automatically.
var FolderOpenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenOutlined$2
  }));
};

FolderOpenOutlined.displayName = 'FolderOpenOutlined';
var FolderOpenOutlined$1 = /*#__PURE__*/React.forwardRef(FolderOpenOutlined);

// This icon file is generated automatically.
var FolderOpenTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M159 768h612.3l103.4-256H262.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z", "fill": primaryColor } }] }; }, "name": "folder-open", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenTwoTone$2
  }));
};

FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
var FolderOpenTwoTone$1 = /*#__PURE__*/React.forwardRef(FolderOpenTwoTone);

// This icon file is generated automatically.
var FolderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderOutlined = function FolderOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderOutlined$2
  }));
};

FolderOutlined.displayName = 'FolderOutlined';
var FolderOutlined$1 = /*#__PURE__*/React.forwardRef(FolderOutlined);

// This icon file is generated automatically.
var FolderTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1z", "fill": secondaryColor } }] }; }, "name": "folder", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FolderTwoTone = function FolderTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderTwoTone$2
  }));
};

FolderTwoTone.displayName = 'FolderTwoTone';
var FolderTwoTone$1 = /*#__PURE__*/React.forwardRef(FolderTwoTone);

// This icon file is generated automatically.
var FolderViewOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M309.1 554.3a42.92 42.92 0 000 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.3l-.1-.1-.1-.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z" } }, { "tag": "path", "attrs": { "d": "M457 573a56 56 0 10112 0 56 56 0 10-112 0z" } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder-view", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderViewOutlined = function FolderViewOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FolderViewOutlined$2
  }));
};

FolderViewOutlined.displayName = 'FolderViewOutlined';
var FolderViewOutlined$1 = /*#__PURE__*/React.forwardRef(FolderViewOutlined);

// This icon file is generated automatically.
var FontColorsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 006-12.4L573.6 118.6a9.9 9.9 0 00-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z" } }] }, "name": "font-colors", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FontColorsOutlined$2
  }));
};

FontColorsOutlined.displayName = 'FontColorsOutlined';
var FontColorsOutlined$1 = /*#__PURE__*/React.forwardRef(FontColorsOutlined);

// This icon file is generated automatically.
var FontSizeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z" } }] }, "name": "font-size", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FontSizeOutlined$2
  }));
};

FontSizeOutlined.displayName = 'FontSizeOutlined';
var FontSizeOutlined$1 = /*#__PURE__*/React.forwardRef(FontSizeOutlined);

// This icon file is generated automatically.
var ForkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm336 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm192-552a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "fork", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ForkOutlined = function ForkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ForkOutlined$2
  }));
};

ForkOutlined.displayName = 'ForkOutlined';
var ForkOutlined$1 = /*#__PURE__*/React.forwardRef(ForkOutlined);

// This icon file is generated automatically.
var FormOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z" } }] }, "name": "form", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FormOutlined = function FormOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FormOutlined$2
  }));
};

FormOutlined.displayName = 'FormOutlined';
var FormOutlined$1 = /*#__PURE__*/React.forwardRef(FormOutlined);

// This icon file is generated automatically.
var FormatPainterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1.2 2.2.6 3.1-.4 1.6-.6 3.2-.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-.2-3.3-.6-4.9.4-1 .6-2 .6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z" } }] }, "name": "format-painter", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterFilled$2
  }));
};

FormatPainterFilled.displayName = 'FormatPainterFilled';
var FormatPainterFilled$1 = /*#__PURE__*/React.forwardRef(FormatPainterFilled);

// This icon file is generated automatically.
var FormatPainterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 .6.1 1.3.2 1.9A83.99 83.99 0 00457 960c46.4 0 84-37.6 84-84 0-2.1-.1-4.1-.2-6.1.1-.6.2-1.2.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z" } }] }, "name": "format-painter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FormatPainterOutlined = function FormatPainterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterOutlined$2
  }));
};

FormatPainterOutlined.displayName = 'FormatPainterOutlined';
var FormatPainterOutlined$1 = /*#__PURE__*/React.forwardRef(FormatPainterOutlined);

// This icon file is generated automatically.
var ForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] }, "name": "forward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ForwardFilled = function ForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ForwardFilled$2
  }));
};

ForwardFilled.displayName = 'ForwardFilled';
var ForwardFilled$1 = /*#__PURE__*/React.forwardRef(ForwardFilled);

// This icon file is generated automatically.
var ForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] }, "name": "forward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ForwardOutlined = function ForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ForwardOutlined$2
  }));
};

ForwardOutlined.displayName = 'ForwardOutlined';
var ForwardOutlined$1 = /*#__PURE__*/React.forwardRef(ForwardOutlined);

// This icon file is generated automatically.
var FrownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "frown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FrownFilled = function FrownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FrownFilled$2
  }));
};

FrownFilled.displayName = 'FrownFilled';
var FrownFilled$1 = /*#__PURE__*/React.forwardRef(FrownFilled);

// This icon file is generated automatically.
var FrownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533z" } }] }, "name": "frown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FrownOutlined = function FrownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FrownOutlined$2
  }));
};

FrownOutlined.displayName = 'FrownOutlined';
var FrownOutlined$1 = /*#__PURE__*/React.forwardRef(FrownOutlined);

// This icon file is generated automatically.
var FrownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "frown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FrownTwoTone = function FrownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FrownTwoTone$2
  }));
};

FrownTwoTone.displayName = 'FrownTwoTone';
var FrownTwoTone$1 = /*#__PURE__*/React.forwardRef(FrownTwoTone);

// This icon file is generated automatically.
var FullscreenExitOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 000 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 00391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 00-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z" } }] }, "name": "fullscreen-exit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FullscreenExitOutlined = function FullscreenExitOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenExitOutlined$2
  }));
};

FullscreenExitOutlined.displayName = 'FullscreenExitOutlined';
var FullscreenExitOutlined$1 = /*#__PURE__*/React.forwardRef(FullscreenExitOutlined);

// This icon file is generated automatically.
var FullscreenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z" } }] }, "name": "fullscreen", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FullscreenOutlined = function FullscreenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenOutlined$2
  }));
};

FullscreenOutlined.displayName = 'FullscreenOutlined';
var FullscreenOutlined$1 = /*#__PURE__*/React.forwardRef(FullscreenOutlined);

// This icon file is generated automatically.
var FunctionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M841 370c3-3.3 2.7-8.3-.6-11.3a8.24 8.24 0 00-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6a7.96 7.96 0 01-13.4-1.9l-63.5-141.3a7.9 7.9 0 00-7.3-4.7H380.7l.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415a8.07 8.07 0 007.8 9.7H284l-89 429.9a8.07 8.07 0 007.8 9.7H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 .9.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6a8.02 8.02 0 007.2-11.5l-95.2-198.9c-1.4-2.9-.9-6.4 1.3-8.8L841 370z" } }] }, "name": "function", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FunctionOutlined = function FunctionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FunctionOutlined$2
  }));
};

FunctionOutlined.displayName = 'FunctionOutlined';
var FunctionOutlined$1 = /*#__PURE__*/React.forwardRef(FunctionOutlined);

// This icon file is generated automatically.
var FundFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 01-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 01-11.3 0l-36.8-36.8a8.03 8.03 0 010-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z" } }] }, "name": "fund", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FundFilled = function FundFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FundFilled$2
  }));
};

FundFilled.displayName = 'FundFilled';
var FundFilled$1 = /*#__PURE__*/React.forwardRef(FundFilled);

// This icon file is generated automatically.
var FundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] }, "name": "fund", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FundOutlined$2
  }));
};

FundOutlined.displayName = 'FundOutlined';
var FundOutlined$1 = /*#__PURE__*/React.forwardRef(FundOutlined);

// This icon file is generated automatically.
var FundProjectionScreenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L517 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L275.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8z" } }, { "tag": "path", "attrs": { "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1a7.92 7.92 0 00-2.3 11l30.3 47.2v.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-.1l30.3-47.2a8 8 0 00-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 512H160V232h704v440z" } }] }, "name": "fund-projection-screen", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FundProjectionScreenOutlined$2
  }));
};

FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
var FundProjectionScreenOutlined$1 = /*#__PURE__*/React.forwardRef(FundProjectionScreenOutlined);

// This icon file is generated automatically.
var FundTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 01-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 01-11.3 0l-36.7-36.9a8.03 8.03 0 010-11.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L533 561 418.6 446.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z", "fill": primaryColor } }] }; }, "name": "fund", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FundTwoTone = function FundTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FundTwoTone$2
  }));
};

FundTwoTone.displayName = 'FundTwoTone';
var FundTwoTone$1 = /*#__PURE__*/React.forwardRef(FundTwoTone);

// This icon file is generated automatically.
var FundViewOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M956 686.5l-.1-.1-.1-.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v.1a42.92 42.92 0 000 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z" } }, { "tag": "path", "attrs": { "d": "M697 705a56 56 0 10112 0 56 56 0 10-112 0zM136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z" } }, { "tag": "path", "attrs": { "d": "M724.9 338.1l-36.8-36.8a8.03 8.03 0 00-11.3 0L493 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L251.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z" } }] }, "name": "fund-view", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FundViewOutlined = function FundViewOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FundViewOutlined$2
  }));
};

FundViewOutlined.displayName = 'FundViewOutlined';
var FundViewOutlined$1 = /*#__PURE__*/React.forwardRef(FundViewOutlined);

// This icon file is generated automatically.
var FunnelPlotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z" } }] }, "name": "funnel-plot", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FunnelPlotFilled = function FunnelPlotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotFilled$2
  }));
};

FunnelPlotFilled.displayName = 'FunnelPlotFilled';
var FunnelPlotFilled$1 = /*#__PURE__*/React.forwardRef(FunnelPlotFilled);

// This icon file is generated automatically.
var FunnelPlotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z" } }] }, "name": "funnel-plot", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FunnelPlotOutlined = function FunnelPlotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotOutlined$2
  }));
};

FunnelPlotOutlined.displayName = 'FunnelPlotOutlined';
var FunnelPlotOutlined$1 = /*#__PURE__*/React.forwardRef(FunnelPlotOutlined);

// This icon file is generated automatically.
var FunnelPlotTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z", "fill": primaryColor } }] }; }, "name": "funnel-plot", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotTwoTone$2
  }));
};

FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
var FunnelPlotTwoTone$1 = /*#__PURE__*/React.forwardRef(FunnelPlotTwoTone);

// This icon file is generated automatically.
var GatewayOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z" } }] }, "name": "gateway", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GatewayOutlined = function GatewayOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GatewayOutlined$2
  }));
};

GatewayOutlined.displayName = 'GatewayOutlined';
var GatewayOutlined$1 = /*#__PURE__*/React.forwardRef(GatewayOutlined);

// This icon file is generated automatically.
var GifOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zm-356 1h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z" } }] }, "name": "gif", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GifOutlined = function GifOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GifOutlined$2
  }));
};

GifOutlined.displayName = 'GifOutlined';
var GifOutlined$1 = /*#__PURE__*/React.forwardRef(GifOutlined);

// This icon file is generated automatically.
var GiftFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" } }] }, "name": "gift", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GiftFilled = function GiftFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GiftFilled$2
  }));
};

GiftFilled.displayName = 'GiftFilled';
var GiftFilled$1 = /*#__PURE__*/React.forwardRef(GiftFilled);

// This icon file is generated automatically.
var GiftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z" } }] }, "name": "gift", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GiftOutlined = function GiftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GiftOutlined$2
  }));
};

GiftOutlined.displayName = 'GiftOutlined';
var GiftOutlined$1 = /*#__PURE__*/React.forwardRef(GiftOutlined);

// This icon file is generated automatically.
var GiftTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z", "fill": primaryColor } }] }; }, "name": "gift", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var GiftTwoTone = function GiftTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GiftTwoTone$2
  }));
};

GiftTwoTone.displayName = 'GiftTwoTone';
var GiftTwoTone$1 = /*#__PURE__*/React.forwardRef(GiftTwoTone);

// This icon file is generated automatically.
var GithubFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GithubFilled = function GithubFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GithubFilled$2
  }));
};

GithubFilled.displayName = 'GithubFilled';
var GithubFilled$1 = /*#__PURE__*/React.forwardRef(GithubFilled);

// This icon file is generated automatically.
var GithubOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GithubOutlined = function GithubOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GithubOutlined$2
  }));
};

GithubOutlined.displayName = 'GithubOutlined';
var GithubOutlined$1 = /*#__PURE__*/React.forwardRef(GithubOutlined);

// This icon file is generated automatically.
var GitlabFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z" } }] }, "name": "gitlab", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GitlabFilled = function GitlabFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GitlabFilled$2
  }));
};

GitlabFilled.displayName = 'GitlabFilled';
var GitlabFilled$1 = /*#__PURE__*/React.forwardRef(GitlabFilled);

// This icon file is generated automatically.
var GitlabOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z" } }] }, "name": "gitlab", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GitlabOutlined = function GitlabOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GitlabOutlined$2
  }));
};

GitlabOutlined.displayName = 'GitlabOutlined';
var GitlabOutlined$1 = /*#__PURE__*/React.forwardRef(GitlabOutlined);

// This icon file is generated automatically.
var GlobalOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z" } }] }, "name": "global", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GlobalOutlined = function GlobalOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GlobalOutlined$2
  }));
};

GlobalOutlined.displayName = 'GlobalOutlined';
var GlobalOutlined$1 = /*#__PURE__*/React.forwardRef(GlobalOutlined);

// This icon file is generated automatically.
var GoldFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] }, "name": "gold", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoldFilled = function GoldFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoldFilled$2
  }));
};

GoldFilled.displayName = 'GoldFilled';
var GoldFilled$1 = /*#__PURE__*/React.forwardRef(GoldFilled);

// This icon file is generated automatically.
var GoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z" } }] }, "name": "gold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GoldOutlined = function GoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoldOutlined$2
  }));
};

GoldOutlined.displayName = 'GoldOutlined';
var GoldOutlined$1 = /*#__PURE__*/React.forwardRef(GoldOutlined);

// This icon file is generated automatically.
var GoldTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z", "fill": secondaryColor } }] }; }, "name": "gold", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var GoldTwoTone = function GoldTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoldTwoTone$2
  }));
};

GoldTwoTone.displayName = 'GoldTwoTone';
var GoldTwoTone$1 = /*#__PURE__*/React.forwardRef(GoldTwoTone);

// This icon file is generated automatically.
var GoldenFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] }, "name": "golden", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoldenFilled = function GoldenFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoldenFilled$2
  }));
};

GoldenFilled.displayName = 'GoldenFilled';
var GoldenFilled$1 = /*#__PURE__*/React.forwardRef(GoldenFilled);

// This icon file is generated automatically.
var GoogleCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] }, "name": "google-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoogleCircleFilled$2
  }));
};

GoogleCircleFilled.displayName = 'GoogleCircleFilled';
var GoogleCircleFilled$1 = /*#__PURE__*/React.forwardRef(GoogleCircleFilled);

// This icon file is generated automatically.
var GoogleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z" } }] }, "name": "google", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GoogleOutlined = function GoogleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoogleOutlined$2
  }));
};

GoogleOutlined.displayName = 'GoogleOutlined';
var GoogleOutlined$1 = /*#__PURE__*/React.forwardRef(GoogleOutlined);

// This icon file is generated automatically.
var GooglePlusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] }, "name": "google-plus-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilled$2
  }));
};

GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
var GooglePlusCircleFilled$1 = /*#__PURE__*/React.forwardRef(GooglePlusCircleFilled);

// This icon file is generated automatically.
var GooglePlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z" } }] }, "name": "google-plus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GooglePlusOutlined = function GooglePlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusOutlined$2
  }));
};

GooglePlusOutlined.displayName = 'GooglePlusOutlined';
var GooglePlusOutlined$1 = /*#__PURE__*/React.forwardRef(GooglePlusOutlined);

// This icon file is generated automatically.
var GooglePlusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] }, "name": "google-plus-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusSquareFilled$2
  }));
};

GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
var GooglePlusSquareFilled$1 = /*#__PURE__*/React.forwardRef(GooglePlusSquareFilled);

// This icon file is generated automatically.
var GoogleSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 01272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] }, "name": "google-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GoogleSquareFilled$2
  }));
};

GoogleSquareFilled.displayName = 'GoogleSquareFilled';
var GoogleSquareFilled$1 = /*#__PURE__*/React.forwardRef(GoogleSquareFilled);

// This icon file is generated automatically.
var GroupOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm704 680H184V184h656v656zm48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }, { "tag": "path", "attrs": { "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64zm-56 420h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64z" } }] }, "name": "group", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GroupOutlined = function GroupOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: GroupOutlined$2
  }));
};

GroupOutlined.displayName = 'GroupOutlined';
var GroupOutlined$1 = /*#__PURE__*/React.forwardRef(GroupOutlined);

// This icon file is generated automatically.
var HddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z" } }] }, "name": "hdd", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HddFilled = function HddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HddFilled$2
  }));
};

HddFilled.displayName = 'HddFilled';
var HddFilled$1 = /*#__PURE__*/React.forwardRef(HddFilled);

// This icon file is generated automatically.
var HddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "hdd", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HddOutlined = function HddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HddOutlined$2
  }));
};

HddOutlined.displayName = 'HddOutlined';
var HddOutlined$1 = /*#__PURE__*/React.forwardRef(HddOutlined);

// This icon file is generated automatically.
var HddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "hdd", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HddTwoTone = function HddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HddTwoTone$2
  }));
};

HddTwoTone.displayName = 'HddTwoTone';
var HddTwoTone$1 = /*#__PURE__*/React.forwardRef(HddTwoTone);

// This icon file is generated automatically.
var HeartFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" } }] }, "name": "heart", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HeartFilled = function HeartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HeartFilled$2
  }));
};

HeartFilled.displayName = 'HeartFilled';
var HeartFilled$1 = /*#__PURE__*/React.forwardRef(HeartFilled);

// This icon file is generated automatically.
var HeartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z" } }] }, "name": "heart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HeartOutlined = function HeartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HeartOutlined$2
  }));
};

HeartOutlined.displayName = 'HeartOutlined';
var HeartOutlined$1 = /*#__PURE__*/React.forwardRef(HeartOutlined);

// This icon file is generated automatically.
var HeartTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z", "fill": secondaryColor } }] }; }, "name": "heart", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HeartTwoTone = function HeartTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HeartTwoTone$2
  }));
};

HeartTwoTone.displayName = 'HeartTwoTone';
var HeartTwoTone$1 = /*#__PURE__*/React.forwardRef(HeartTwoTone);

// This icon file is generated automatically.
var HeatMapOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z" } }] }, "name": "heat-map", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HeatMapOutlined$2
  }));
};

HeatMapOutlined.displayName = 'HeatMapOutlined';
var HeatMapOutlined$1 = /*#__PURE__*/React.forwardRef(HeatMapOutlined);

// This icon file is generated automatically.
var HighlightFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z" } }] }, "name": "highlight", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HighlightFilled = function HighlightFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HighlightFilled$2
  }));
};

HighlightFilled.displayName = 'HighlightFilled';
var HighlightFilled$1 = /*#__PURE__*/React.forwardRef(HighlightFilled);

// This icon file is generated automatically.
var HighlightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z" } }] }, "name": "highlight", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HighlightOutlined = function HighlightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HighlightOutlined$2
  }));
};

HighlightOutlined.displayName = 'HighlightOutlined';
var HighlightOutlined$1 = /*#__PURE__*/React.forwardRef(HighlightOutlined);

// This icon file is generated automatically.
var HighlightTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 00-11.2 0L353.3 393.5a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z", "fill": primaryColor } }] }; }, "name": "highlight", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HighlightTwoTone = function HighlightTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HighlightTwoTone$2
  }));
};

HighlightTwoTone.displayName = 'HighlightTwoTone';
var HighlightTwoTone$1 = /*#__PURE__*/React.forwardRef(HighlightTwoTone);

// This icon file is generated automatically.
var HistoryOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 003 14.1zm167.7 301.1l-56.7-19.5a8 8 0 00-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 01-112.5 75.9 352.18 352.18 0 01-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 01-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 01171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 01112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 01775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z" } }] }, "name": "history", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HistoryOutlined = function HistoryOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HistoryOutlined$2
  }));
};

HistoryOutlined.displayName = 'HistoryOutlined';
var HistoryOutlined$1 = /*#__PURE__*/React.forwardRef(HistoryOutlined);

// This icon file is generated automatically.
var HomeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L534.6 93.4a31.93 31.93 0 00-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z" } }] }, "name": "home", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HomeFilled = function HomeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HomeFilled$2
  }));
};

HomeFilled.displayName = 'HomeFilled';
var HomeFilled$1 = /*#__PURE__*/React.forwardRef(HomeFilled);

// This icon file is generated automatically.
var HomeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" } }] }, "name": "home", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HomeOutlined = function HomeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HomeOutlined$2
  }));
};

HomeOutlined.displayName = 'HomeOutlined';
var HomeOutlined$1 = /*#__PURE__*/React.forwardRef(HomeOutlined);

// This icon file is generated automatically.
var HomeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.6 63.6 0 00-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0018.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z", "fill": primaryColor } }] }; }, "name": "home", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HomeTwoTone = function HomeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HomeTwoTone$2
  }));
};

HomeTwoTone.displayName = 'HomeTwoTone';
var HomeTwoTone$1 = /*#__PURE__*/React.forwardRef(HomeTwoTone);

// This icon file is generated automatically.
var HourglassFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z" } }] }, "name": "hourglass", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HourglassFilled = function HourglassFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HourglassFilled$2
  }));
};

HourglassFilled.displayName = 'HourglassFilled';
var HourglassFilled$1 = /*#__PURE__*/React.forwardRef(HourglassFilled);

// This icon file is generated automatically.
var HourglassOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z" } }] }, "name": "hourglass", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HourglassOutlined = function HourglassOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HourglassOutlined$2
  }));
};

HourglassOutlined.displayName = 'HourglassOutlined';
var HourglassOutlined$1 = /*#__PURE__*/React.forwardRef(HourglassOutlined);

// This icon file is generated automatically.
var HourglassTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 00354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 00512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z", "fill": primaryColor } }] }; }, "name": "hourglass", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: HourglassTwoTone$2
  }));
};

HourglassTwoTone.displayName = 'HourglassTwoTone';
var HourglassTwoTone$1 = /*#__PURE__*/React.forwardRef(HourglassTwoTone);

// This icon file is generated automatically.
var Html5Filled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z" } }] }, "name": "html5", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var Html5Filled = function Html5Filled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: Html5Filled$2
  }));
};

Html5Filled.displayName = 'Html5Filled';
var Html5Filled$1 = /*#__PURE__*/React.forwardRef(Html5Filled);

// This icon file is generated automatically.
var Html5Outlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z" } }] }, "name": "html5", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var Html5Outlined = function Html5Outlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: Html5Outlined$2
  }));
};

Html5Outlined.displayName = 'Html5Outlined';
var Html5Outlined$1 = /*#__PURE__*/React.forwardRef(Html5Outlined);

// This icon file is generated automatically.
var Html5TwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z", "fill": primaryColor } }] }; }, "name": "html5", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var Html5TwoTone = function Html5TwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: Html5TwoTone$2
  }));
};

Html5TwoTone.displayName = 'Html5TwoTone';
var Html5TwoTone$1 = /*#__PURE__*/React.forwardRef(Html5TwoTone);

// This icon file is generated automatically.
var IdcardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z" } }] }, "name": "idcard", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var IdcardFilled = function IdcardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IdcardFilled$2
  }));
};

IdcardFilled.displayName = 'IdcardFilled';
var IdcardFilled$1 = /*#__PURE__*/React.forwardRef(IdcardFilled);

// This icon file is generated automatically.
var IdcardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z" } }] }, "name": "idcard", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var IdcardOutlined = function IdcardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IdcardOutlined$2
  }));
};

IdcardOutlined.displayName = 'IdcardOutlined';
var IdcardOutlined$1 = /*#__PURE__*/React.forwardRef(IdcardOutlined);

// This icon file is generated automatically.
var IdcardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 01-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.3 463a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z", "fill": primaryColor } }] }; }, "name": "idcard", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var IdcardTwoTone = function IdcardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IdcardTwoTone$2
  }));
};

IdcardTwoTone.displayName = 'IdcardTwoTone';
var IdcardTwoTone$1 = /*#__PURE__*/React.forwardRef(IdcardTwoTone);

// This icon file is generated automatically.
var IeCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] }, "name": "ie-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var IeCircleFilled = function IeCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IeCircleFilled$2
  }));
};

IeCircleFilled.displayName = 'IeCircleFilled';
var IeCircleFilled$1 = /*#__PURE__*/React.forwardRef(IeCircleFilled);

// This icon file is generated automatically.
var IeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z" } }] }, "name": "ie", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var IeOutlined = function IeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IeOutlined$2
  }));
};

IeOutlined.displayName = 'IeOutlined';
var IeOutlined$1 = /*#__PURE__*/React.forwardRef(IeOutlined);

// This icon file is generated automatically.
var IeSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] }, "name": "ie-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var IeSquareFilled = function IeSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IeSquareFilled$2
  }));
};

IeSquareFilled.displayName = 'IeSquareFilled';
var IeSquareFilled$1 = /*#__PURE__*/React.forwardRef(IeSquareFilled);

// This icon file is generated automatically.
var ImportOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "import", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ImportOutlined = function ImportOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ImportOutlined$2
  }));
};

ImportOutlined.displayName = 'ImportOutlined';
var ImportOutlined$1 = /*#__PURE__*/React.forwardRef(ImportOutlined);

// This icon file is generated automatically.
var InboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z" } }] }, "name": "inbox", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InboxOutlined = function InboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InboxOutlined$2
  }));
};

InboxOutlined.displayName = 'InboxOutlined';
var InboxOutlined$1 = /*#__PURE__*/React.forwardRef(InboxOutlined);

// This icon file is generated automatically.
var InfoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleFilled$2
  }));
};

InfoCircleFilled.displayName = 'InfoCircleFilled';
var InfoCircleFilled$1 = /*#__PURE__*/React.forwardRef(InfoCircleFilled);

// This icon file is generated automatically.
var InfoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleOutlined$2
  }));
};

InfoCircleOutlined.displayName = 'InfoCircleOutlined';
var InfoCircleOutlined$1 = /*#__PURE__*/React.forwardRef(InfoCircleOutlined);

// This icon file is generated automatically.
var InfoCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "info-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleTwoTone$2
  }));
};

InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
var InfoCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(InfoCircleTwoTone);

// This icon file is generated automatically.
var InfoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 224a64 64 0 10128 0 64 64 0 10-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z" } }] }, "name": "info", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InfoOutlined = function InfoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InfoOutlined$2
  }));
};

InfoOutlined.displayName = 'InfoOutlined';
var InfoOutlined$1 = /*#__PURE__*/React.forwardRef(InfoOutlined);

// This icon file is generated automatically.
var InsertRowAboveOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160zm0-224H184V408h176v160zm240 224H424V632h176v160zm0-224H424V408h176v160zm240 224H664V632h176v160zm0-224H664V408h176v160zm64-408H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] }, "name": "insert-row-above", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowAboveOutlined$2
  }));
};

InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
var InsertRowAboveOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowAboveOutlined);

// This icon file is generated automatically.
var InsertRowBelowOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-25.3-608H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160zm0-224H184V232h176v160zm240 224H424V456h176v160zm0-224H424V232h176v160zm240 224H664V456h176v160zm0-224H664V232h176v160z" } }] }, "name": "insert-row-below", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowBelowOutlined = function InsertRowBelowOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowBelowOutlined$2
  }));
};

InsertRowBelowOutlined.displayName = 'InsertRowBelowOutlined';
var InsertRowBelowOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowBelowOutlined);

// This icon file is generated automatically.
var InsertRowLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm584 0H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176zm0-240H408V424h160v176zm0-240H408V184h160v176zm224 480H632V664h160v176zm0-240H632V424h160v176zm0-240H632V184h160v176z" } }] }, "name": "insert-row-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowLeftOutlined = function InsertRowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowLeftOutlined$2
  }));
};

InsertRowLeftOutlined.displayName = 'InsertRowLeftOutlined';
var InsertRowLeftOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowLeftOutlined);

// This icon file is generated automatically.
var InsertRowRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm-200 0H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176zm0-240H232V424h160v176zm0-240H232V184h160v176zm224 480H456V664h160v176zm0-240H456V424h160v176zm0-240H456V184h160v176z" } }] }, "name": "insert-row-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowRightOutlined$2
  }));
};

InsertRowRightOutlined.displayName = 'InsertRowRightOutlined';
var InsertRowRightOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowRightOutlined);

// This icon file is generated automatically.
var InstagramFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" } }] }, "name": "instagram", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InstagramFilled = function InstagramFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InstagramFilled$2
  }));
};

InstagramFilled.displayName = 'InstagramFilled';
var InstagramFilled$1 = /*#__PURE__*/React.forwardRef(InstagramFilled);

// This icon file is generated automatically.
var InstagramOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 00-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" } }] }, "name": "instagram", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InstagramOutlined = function InstagramOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InstagramOutlined$2
  }));
};

InstagramOutlined.displayName = 'InstagramOutlined';
var InstagramOutlined$1 = /*#__PURE__*/React.forwardRef(InstagramOutlined);

// This icon file is generated automatically.
var InsuranceFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 01-8.9-1.4L430 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z" } }] }, "name": "insurance", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InsuranceFilled = function InsuranceFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceFilled$2
  }));
};

InsuranceFilled.displayName = 'InsuranceFilled';
var InsuranceFilled$1 = /*#__PURE__*/React.forwardRef(InsuranceFilled);

// This icon file is generated automatically.
var InsuranceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M441.6 306.8L403 288.6a6.1 6.1 0 00-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 00-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0033.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }] }, "name": "insurance", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsuranceOutlined = function InsuranceOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceOutlined$2
  }));
};

InsuranceOutlined.displayName = 'InsuranceOutlined';
var InsuranceOutlined$1 = /*#__PURE__*/React.forwardRef(InsuranceOutlined);

// This icon file is generated automatically.
var InsuranceTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M521.9 358.8h97.9v41.6h-97.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 01-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 00-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0033.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z", "fill": primaryColor } }] }; }, "name": "insurance", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceTwoTone$2
  }));
};

InsuranceTwoTone.displayName = 'InsuranceTwoTone';
var InsuranceTwoTone$1 = /*#__PURE__*/React.forwardRef(InsuranceTwoTone);

// This icon file is generated automatically.
var InteractionFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z" } }] }, "name": "interaction", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InteractionFilled = function InteractionFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InteractionFilled$2
  }));
};

InteractionFilled.displayName = 'InteractionFilled';
var InteractionFilled$1 = /*#__PURE__*/React.forwardRef(InteractionFilled);

// This icon file is generated automatically.
var InteractionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z" } }] }, "name": "interaction", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InteractionOutlined = function InteractionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InteractionOutlined$2
  }));
};

InteractionOutlined.displayName = 'InteractionOutlined';
var InteractionOutlined$1 = /*#__PURE__*/React.forwardRef(InteractionOutlined);

// This icon file is generated automatically.
var InteractionTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z", "fill": primaryColor } }] }; }, "name": "interaction", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: InteractionTwoTone$2
  }));
};

InteractionTwoTone.displayName = 'InteractionTwoTone';
var InteractionTwoTone$1 = /*#__PURE__*/React.forwardRef(InteractionTwoTone);

// This icon file is generated automatically.
var IssuesCloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 00-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0026 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 01-49.8 62.2A355.92 355.92 0 01651.1 840a355 355 0 01-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 01-113.3-76.3A353.06 353.06 0 01184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 01138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 00892 694z" } }] }, "name": "issues-close", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var IssuesCloseOutlined = function IssuesCloseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: IssuesCloseOutlined$2
  }));
};

IssuesCloseOutlined.displayName = 'IssuesCloseOutlined';
var IssuesCloseOutlined$1 = /*#__PURE__*/React.forwardRef(IssuesCloseOutlined);

// This icon file is generated automatically.
var ItalicOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, "name": "italic", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ItalicOutlined = function ItalicOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ItalicOutlined$2
  }));
};

ItalicOutlined.displayName = 'ItalicOutlined';
var ItalicOutlined$1 = /*#__PURE__*/React.forwardRef(ItalicOutlined);

// This icon file is generated automatically.
var KeyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 00608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z" } }] }, "name": "key", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var KeyOutlined = function KeyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: KeyOutlined$2
  }));
};

KeyOutlined.displayName = 'KeyOutlined';
var KeyOutlined$1 = /*#__PURE__*/React.forwardRef(KeyOutlined);

// This icon file is generated automatically.
var LaptopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z" } }] }, "name": "laptop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LaptopOutlined = function LaptopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LaptopOutlined$2
  }));
};

LaptopOutlined.displayName = 'LaptopOutlined';
var LaptopOutlined$1 = /*#__PURE__*/React.forwardRef(LaptopOutlined);

// This icon file is generated automatically.
var LayoutFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z" } }] }, "name": "layout", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LayoutFilled = function LayoutFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LayoutFilled$2
  }));
};

LayoutFilled.displayName = 'LayoutFilled';
var LayoutFilled$1 = /*#__PURE__*/React.forwardRef(LayoutFilled);

// This icon file is generated automatically.
var LayoutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z" } }] }, "name": "layout", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LayoutOutlined = function LayoutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LayoutOutlined$2
  }));
};

LayoutOutlined.displayName = 'LayoutOutlined';
var LayoutOutlined$1 = /*#__PURE__*/React.forwardRef(LayoutOutlined);

// This icon file is generated automatically.
var LayoutTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z", "fill": primaryColor } }] }; }, "name": "layout", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LayoutTwoTone = function LayoutTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LayoutTwoTone$2
  }));
};

LayoutTwoTone.displayName = 'LayoutTwoTone';
var LayoutTwoTone$1 = /*#__PURE__*/React.forwardRef(LayoutTwoTone);

// This icon file is generated automatically.
var LeftCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178a8 8 0 0112.7 6.5v46.8z" } }] }, "name": "left-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleFilled$2
  }));
};

LeftCircleFilled.displayName = 'LeftCircleFilled';
var LeftCircleFilled$1 = /*#__PURE__*/React.forwardRef(LeftCircleFilled);

// This icon file is generated automatically.
var LeftCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "left-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleOutlined$2
  }));
};

LeftCircleOutlined.displayName = 'LeftCircleOutlined';
var LeftCircleOutlined$1 = /*#__PURE__*/React.forwardRef(LeftCircleOutlined);

// This icon file is generated automatically.
var LeftCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z", "fill": primaryColor } }] }; }, "name": "left-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LeftCircleTwoTone = function LeftCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleTwoTone$2
  }));
};

LeftCircleTwoTone.displayName = 'LeftCircleTwoTone';
var LeftCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(LeftCircleTwoTone);

// This icon file is generated automatically.
var LeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftOutlined = function LeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftOutlined$2
  }));
};

LeftOutlined.displayName = 'LeftOutlined';
var LeftOutlined$1 = /*#__PURE__*/React.forwardRef(LeftOutlined);

// This icon file is generated automatically.
var LeftSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z" } }] }, "name": "left-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LeftSquareFilled = function LeftSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareFilled$2
  }));
};

LeftSquareFilled.displayName = 'LeftSquareFilled';
var LeftSquareFilled$1 = /*#__PURE__*/React.forwardRef(LeftSquareFilled);

// This icon file is generated automatically.
var LeftSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 000 13z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "left-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftSquareOutlined = function LeftSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareOutlined$2
  }));
};

LeftSquareOutlined.displayName = 'LeftSquareOutlined';
var LeftSquareOutlined$1 = /*#__PURE__*/React.forwardRef(LeftSquareOutlined);

// This icon file is generated automatically.
var LeftSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 010-12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 000 12.9z", "fill": primaryColor } }] }; }, "name": "left-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareTwoTone$2
  }));
};

LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
var LeftSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(LeftSquareTwoTone);

// This icon file is generated automatically.
var LikeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z" } }] }, "name": "like", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LikeFilled = function LikeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LikeFilled$2
  }));
};

LikeFilled.displayName = 'LikeFilled';
var LikeFilled$1 = /*#__PURE__*/React.forwardRef(LikeFilled);

// This icon file is generated automatically.
var LikeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z" } }] }, "name": "like", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LikeOutlined = function LikeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LikeOutlined$2
  }));
};

LikeOutlined.displayName = 'LikeOutlined';
var LikeOutlined$1 = /*#__PURE__*/React.forwardRef(LikeOutlined);

// This icon file is generated automatically.
var LikeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0033.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0019.6-43c0-19.1-11-37.5-28.8-48.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 00-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 00-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0142.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z", "fill": primaryColor } }] }; }, "name": "like", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LikeTwoTone = function LikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LikeTwoTone$2
  }));
};

LikeTwoTone.displayName = 'LikeTwoTone';
var LikeTwoTone$1 = /*#__PURE__*/React.forwardRef(LikeTwoTone);

// This icon file is generated automatically.
var LineChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 00-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 00-11.3 0L266.3 586.7a8.03 8.03 0 000 11.3l39.5 39.7z" } }] }, "name": "line-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LineChartOutlined = function LineChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LineChartOutlined$2
  }));
};

LineChartOutlined.displayName = 'LineChartOutlined';
var LineChartOutlined$1 = /*#__PURE__*/React.forwardRef(LineChartOutlined);

// This icon file is generated automatically.
var LineHeightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 00-11.3 0L713.6 306.3a7.23 7.23 0 005.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 00-5.6-11.7z" } }] }, "name": "line-height", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LineHeightOutlined$2
  }));
};

LineHeightOutlined.displayName = 'LineHeightOutlined';
var LineHeightOutlined$1 = /*#__PURE__*/React.forwardRef(LineHeightOutlined);

// This icon file is generated automatically.
var LineOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "line", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LineOutlined = function LineOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LineOutlined$2
  }));
};

LineOutlined.displayName = 'LineOutlined';
var LineOutlined$1 = /*#__PURE__*/React.forwardRef(LineOutlined);

// This icon file is generated automatically.
var LinkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" } }] }, "name": "link", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LinkOutlined = function LinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LinkOutlined$2
  }));
};

LinkOutlined.displayName = 'LinkOutlined';
var LinkOutlined$1 = /*#__PURE__*/React.forwardRef(LinkOutlined);

// This icon file is generated automatically.
var LinkedinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1168.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z" } }] }, "name": "linkedin", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LinkedinFilled = function LinkedinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinFilled$2
  }));
};

LinkedinFilled.displayName = 'LinkedinFilled';
var LinkedinFilled$1 = /*#__PURE__*/React.forwardRef(LinkedinFilled);

// This icon file is generated automatically.
var LinkedinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 10-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z" } }] }, "name": "linkedin", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinOutlined$2
  }));
};

LinkedinOutlined.displayName = 'LinkedinOutlined';
var LinkedinOutlined$1 = /*#__PURE__*/React.forwardRef(LinkedinOutlined);

// This icon file is generated automatically.
var Loading3QuartersOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z" } }] }, "name": "loading-3-quarters", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: Loading3QuartersOutlined$2
  }));
};

Loading3QuartersOutlined.displayName = 'Loading3QuartersOutlined';
var Loading3QuartersOutlined$1 = /*#__PURE__*/React.forwardRef(Loading3QuartersOutlined);

// This icon file is generated automatically.
var LoadingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LoadingOutlined = function LoadingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LoadingOutlined$2
  }));
};

LoadingOutlined.displayName = 'LoadingOutlined';
var LoadingOutlined$1 = /*#__PURE__*/React.forwardRef(LoadingOutlined);

// This icon file is generated automatically.
var LockFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z" } }] }, "name": "lock", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LockFilled = function LockFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LockFilled$2
  }));
};

LockFilled.displayName = 'LockFilled';
var LockFilled$1 = /*#__PURE__*/React.forwardRef(LockFilled);

// This icon file is generated automatically.
var LockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "lock", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LockOutlined = function LockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LockOutlined$2
  }));
};

LockOutlined.displayName = 'LockOutlined';
var LockOutlined$1 = /*#__PURE__*/React.forwardRef(LockOutlined);

// This icon file is generated automatically.
var LockTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }] }; }, "name": "lock", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LockTwoTone = function LockTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LockTwoTone$2
  }));
};

LockTwoTone.displayName = 'LockTwoTone';
var LockTwoTone$1 = /*#__PURE__*/React.forwardRef(LockTwoTone);

// This icon file is generated automatically.
var LoginOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 01520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 01270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 010 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z" } }] }, "name": "login", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LoginOutlined = function LoginOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LoginOutlined$2
  }));
};

LoginOutlined.displayName = 'LoginOutlined';
var LoginOutlined$1 = /*#__PURE__*/React.forwardRef(LoginOutlined);

// This icon file is generated automatically.
var LogoutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 01-112.7 75.9A352.8 352.8 0 01512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 01-112.7-75.9 353.28 353.28 0 01-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] }, "name": "logout", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LogoutOutlined = function LogoutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: LogoutOutlined$2
  }));
};

LogoutOutlined.displayName = 'LogoutOutlined';
var LogoutOutlined$1 = /*#__PURE__*/React.forwardRef(LogoutOutlined);

// This icon file is generated automatically.
var MacCommandFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M624 672a48.01 48.01 0 0096 0c0-26.5-21.5-48-48-48h-48v48zm96-320a48.01 48.01 0 00-96 0v48h48c26.5 0 48-21.5 48-48z" } }, { "tag": "path", "attrs": { "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z" } }, { "tag": "path", "attrs": { "d": "M464 464h96v96h-96zM352 304a48.01 48.01 0 000 96h48v-48c0-26.5-21.5-48-48-48zm-48 368a48.01 48.01 0 0096 0v-48h-48c-26.5 0-48 21.5-48 48z" } }] }, "name": "mac-command", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MacCommandFilled = function MacCommandFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandFilled$2
  }));
};

MacCommandFilled.displayName = 'MacCommandFilled';
var MacCommandFilled$1 = /*#__PURE__*/React.forwardRef(MacCommandFilled);

// This icon file is generated automatically.
var MacCommandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4zm42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4zm197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4zm0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7zm-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z" } }] }, "name": "mac-command", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MacCommandOutlined = function MacCommandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandOutlined$2
  }));
};

MacCommandOutlined.displayName = 'MacCommandOutlined';
var MacCommandOutlined$1 = /*#__PURE__*/React.forwardRef(MacCommandOutlined);

// This icon file is generated automatically.
var MailFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 01194 256h648.8a7.2 7.2 0 014.4 12.9z" } }] }, "name": "mail", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MailFilled = function MailFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MailFilled$2
  }));
};

MailFilled.displayName = 'MailFilled';
var MailFilled$1 = /*#__PURE__*/React.forwardRef(MailFilled);

// This icon file is generated automatically.
var MailOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z" } }] }, "name": "mail", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MailOutlined = function MailOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MailOutlined$2
  }));
};

MailOutlined.displayName = 'MailOutlined';
var MailOutlined$1 = /*#__PURE__*/React.forwardRef(MailOutlined);

// This icon file is generated automatically.
var MailTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 01-68.7 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z", "fill": primaryColor } }] }; }, "name": "mail", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MailTwoTone = function MailTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MailTwoTone$2
  }));
};

MailTwoTone.displayName = 'MailTwoTone';
var MailTwoTone$1 = /*#__PURE__*/React.forwardRef(MailTwoTone);

// This icon file is generated automatically.
var ManOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z" } }] }, "name": "man", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ManOutlined = function ManOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ManOutlined$2
  }));
};

ManOutlined.displayName = 'ManOutlined';
var ManOutlined$1 = /*#__PURE__*/React.forwardRef(ManOutlined);

// This icon file is generated automatically.
var MedicineBoxFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z" } }] }, "name": "medicine-box", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MedicineBoxFilled = function MedicineBoxFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxFilled$2
  }));
};

MedicineBoxFilled.displayName = 'MedicineBoxFilled';
var MedicineBoxFilled$1 = /*#__PURE__*/React.forwardRef(MedicineBoxFilled);

// This icon file is generated automatically.
var MedicineBoxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "medicine-box", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxOutlined$2
  }));
};

MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
var MedicineBoxOutlined$1 = /*#__PURE__*/React.forwardRef(MedicineBoxOutlined);

// This icon file is generated automatically.
var MedicineBoxTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z", "fill": primaryColor } }] }; }, "name": "medicine-box", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MedicineBoxTwoTone = function MedicineBoxTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxTwoTone$2
  }));
};

MedicineBoxTwoTone.displayName = 'MedicineBoxTwoTone';
var MedicineBoxTwoTone$1 = /*#__PURE__*/React.forwardRef(MedicineBoxTwoTone);

// This icon file is generated automatically.
var MediumCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] }, "name": "medium-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MediumCircleFilled$2
  }));
};

MediumCircleFilled.displayName = 'MediumCircleFilled';
var MediumCircleFilled$1 = /*#__PURE__*/React.forwardRef(MediumCircleFilled);

// This icon file is generated automatically.
var MediumOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 01-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 016.8-17.2z" } }] }, "name": "medium", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MediumOutlined = function MediumOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MediumOutlined$2
  }));
};

MediumOutlined.displayName = 'MediumOutlined';
var MediumOutlined$1 = /*#__PURE__*/React.forwardRef(MediumOutlined);

// This icon file is generated automatically.
var MediumSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] }, "name": "medium-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MediumSquareFilled$2
  }));
};

MediumSquareFilled.displayName = 'MediumSquareFilled';
var MediumSquareFilled$1 = /*#__PURE__*/React.forwardRef(MediumSquareFilled);

// This icon file is generated automatically.
var MediumWorkmarkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 01-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0134.61 21.67v-56.19a6.99 6.99 0 00-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 00-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0019.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 00-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 01-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 00-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0019.35-12.2v-80.85a7.65 7.65 0 00-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 00-21.19 11.64 99.68 99.68 0 012.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 002.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 00-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0144.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 002.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 002.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 002.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 002.96-17.78V457.97A19.71 19.71 0 0024 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 00-2.72 6.8v139.37a6.5 6.5 0 002.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0040.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z" } }] }, "name": "medium-workmark", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MediumWorkmarkOutlined = function MediumWorkmarkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MediumWorkmarkOutlined$2
  }));
};

MediumWorkmarkOutlined.displayName = 'MediumWorkmarkOutlined';
var MediumWorkmarkOutlined$1 = /*#__PURE__*/React.forwardRef(MediumWorkmarkOutlined);

// This icon file is generated automatically.
var MehFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "meh", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MehFilled = function MehFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MehFilled$2
  }));
};

MehFilled.displayName = 'MehFilled';
var MehFilled$1 = /*#__PURE__*/React.forwardRef(MehFilled);

// This icon file is generated automatically.
var MehOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "meh", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MehOutlined = function MehOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MehOutlined$2
  }));
};

MehOutlined.displayName = 'MehOutlined';
var MehOutlined$1 = /*#__PURE__*/React.forwardRef(MehOutlined);

// This icon file is generated automatically.
var MehTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "meh", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MehTwoTone = function MehTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MehTwoTone$2
  }));
};

MehTwoTone.displayName = 'MehTwoTone';
var MehTwoTone$1 = /*#__PURE__*/React.forwardRef(MehTwoTone);

// This icon file is generated automatically.
var MenuFoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 000 13.8z" } }] }, "name": "menu-fold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MenuFoldOutlined = function MenuFoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MenuFoldOutlined$2
  }));
};

MenuFoldOutlined.displayName = 'MenuFoldOutlined';
var MenuFoldOutlined$1 = /*#__PURE__*/React.forwardRef(MenuFoldOutlined);

// This icon file is generated automatically.
var MenuOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, "name": "menu", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MenuOutlined = function MenuOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MenuOutlined$2
  }));
};

MenuOutlined.displayName = 'MenuOutlined';
var MenuOutlined$1 = /*#__PURE__*/React.forwardRef(MenuOutlined);

// This icon file is generated automatically.
var MenuUnfoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z" } }] }, "name": "menu-unfold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MenuUnfoldOutlined$2
  }));
};

MenuUnfoldOutlined.displayName = 'MenuUnfoldOutlined';
var MenuUnfoldOutlined$1 = /*#__PURE__*/React.forwardRef(MenuUnfoldOutlined);

// This icon file is generated automatically.
var MergeCellsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] }, "name": "merge-cells", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MergeCellsOutlined$2
  }));
};

MergeCellsOutlined.displayName = 'MergeCellsOutlined';
var MergeCellsOutlined$1 = /*#__PURE__*/React.forwardRef(MergeCellsOutlined);

// This icon file is generated automatically.
var MessageFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.3 338.4a447.57 447.57 0 00-96.1-143.3 443.09 443.09 0 00-143-96.3A443.91 443.91 0 00512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 00-141.7 96.5 445 445 0 00-95 142.8A449.89 449.89 0 0065 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 00199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 00827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z" } }] }, "name": "message", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MessageFilled = function MessageFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MessageFilled$2
  }));
};

MessageFilled.displayName = 'MessageFilled';
var MessageFilled$1 = /*#__PURE__*/React.forwardRef(MessageFilled);

// This icon file is generated automatically.
var MessageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0zm200 0a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] }, "name": "message", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MessageOutlined = function MessageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MessageOutlined$2
  }));
};

MessageOutlined.displayName = 'MessageOutlined';
var MessageOutlined$1 = /*#__PURE__*/React.forwardRef(MessageOutlined);

// This icon file is generated automatically.
var MessageTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M775.3 248.9a369.62 369.62 0 00-119-80A370.2 370.2 0 00512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 00-80-119zM312 560a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M664 512a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "message", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MessageTwoTone = function MessageTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MessageTwoTone$2
  }));
};

MessageTwoTone.displayName = 'MessageTwoTone';
var MessageTwoTone$1 = /*#__PURE__*/React.forwardRef(MessageTwoTone);

// This icon file is generated automatically.
var MinusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] }, "name": "minus-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleFilled$2
  }));
};

MinusCircleFilled.displayName = 'MinusCircleFilled';
var MinusCircleFilled$1 = /*#__PURE__*/React.forwardRef(MinusCircleFilled);

// This icon file is generated automatically.
var MinusCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "minus-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleOutlined$2
  }));
};

MinusCircleOutlined.displayName = 'MinusCircleOutlined';
var MinusCircleOutlined$1 = /*#__PURE__*/React.forwardRef(MinusCircleOutlined);

// This icon file is generated automatically.
var MinusCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "minus-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleTwoTone$2
  }));
};

MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
var MinusCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(MinusCircleTwoTone);

// This icon file is generated automatically.
var MinusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "minus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusOutlined = function MinusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusOutlined$2
  }));
};

MinusOutlined.displayName = 'MinusOutlined';
var MinusOutlined$1 = /*#__PURE__*/React.forwardRef(MinusOutlined);

// This icon file is generated automatically.
var MinusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] }, "name": "minus-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareFilled$2
  }));
};

MinusSquareFilled.displayName = 'MinusSquareFilled';
var MinusSquareFilled$1 = /*#__PURE__*/React.forwardRef(MinusSquareFilled);

// This icon file is generated automatically.
var MinusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareOutlined$2
  }));
};

MinusSquareOutlined.displayName = 'MinusSquareOutlined';
var MinusSquareOutlined$1 = /*#__PURE__*/React.forwardRef(MinusSquareOutlined);

// This icon file is generated automatically.
var MinusSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "minus-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareTwoTone$2
  }));
};

MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
var MinusSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(MinusSquareTwoTone);

// This icon file is generated automatically.
var MobileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] }, "name": "mobile", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MobileFilled = function MobileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MobileFilled$2
  }));
};

MobileFilled.displayName = 'MobileFilled';
var MobileFilled$1 = /*#__PURE__*/React.forwardRef(MobileFilled);

// This icon file is generated automatically.
var MobileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "mobile", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MobileOutlined = function MobileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MobileOutlined$2
  }));
};

MobileOutlined.displayName = 'MobileOutlined';
var MobileOutlined$1 = /*#__PURE__*/React.forwardRef(MobileOutlined);

// This icon file is generated automatically.
var MobileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 786a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "mobile", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MobileTwoTone = function MobileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MobileTwoTone$2
  }));
};

MobileTwoTone.displayName = 'MobileTwoTone';
var MobileTwoTone$1 = /*#__PURE__*/React.forwardRef(MobileTwoTone);

// This icon file is generated automatically.
var MoneyCollectFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 699.7a8 8 0 00-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z" } }] }, "name": "money-collect", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectFilled$2
  }));
};

MoneyCollectFilled.displayName = 'MoneyCollectFilled';
var MoneyCollectFilled$1 = /*#__PURE__*/React.forwardRef(MoneyCollectFilled);

// This icon file is generated automatically.
var MoneyCollectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z" } }] }, "name": "money-collect", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectOutlined$2
  }));
};

MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
var MoneyCollectOutlined$1 = /*#__PURE__*/React.forwardRef(MoneyCollectOutlined);

// This icon file is generated automatically.
var MoneyCollectTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z", "fill": primaryColor } }] }; }, "name": "money-collect", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectTwoTone$2
  }));
};

MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
var MoneyCollectTwoTone$1 = /*#__PURE__*/React.forwardRef(MoneyCollectTwoTone);

// This icon file is generated automatically.
var MonitorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 00-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 00-11.2-1.4l-37.9 29.7a7.97 7.97 0 00-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z" } }] }, "name": "monitor", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MonitorOutlined = function MonitorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MonitorOutlined$2
  }));
};

MonitorOutlined.displayName = 'MonitorOutlined';
var MonitorOutlined$1 = /*#__PURE__*/React.forwardRef(MonitorOutlined);

// This icon file is generated automatically.
var MoreOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M456 231a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "more", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MoreOutlined = function MoreOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: MoreOutlined$2
  }));
};

MoreOutlined.displayName = 'MoreOutlined';
var MoreOutlined$1 = /*#__PURE__*/React.forwardRef(MoreOutlined);

// This icon file is generated automatically.
var NodeCollapseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3a9.9 9.9 0 000 15.4z" } }] }, "name": "node-collapse", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NodeCollapseOutlined = function NodeCollapseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NodeCollapseOutlined$2
  }));
};

NodeCollapseOutlined.displayName = 'NodeCollapseOutlined';
var NodeCollapseOutlined$1 = /*#__PURE__*/React.forwardRef(NodeCollapseOutlined);

// This icon file is generated automatically.
var NodeExpandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z" } }] }, "name": "node-expand", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NodeExpandOutlined = function NodeExpandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NodeExpandOutlined$2
  }));
};

NodeExpandOutlined.displayName = 'NodeExpandOutlined';
var NodeExpandOutlined$1 = /*#__PURE__*/React.forwardRef(NodeExpandOutlined);

// This icon file is generated automatically.
var NodeIndexOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7.2 3.5.3 5.2.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-.8-6.6-1.5-7.8-1.8l-3.1-.6c-2.2-.3-5.9-.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2a83.3 83.3 0 11.01-166.61 83.3 83.3 0 01-.01 166.61zM695.6 845a83.3 83.3 0 11.01-166.61A83.3 83.3 0 01695.6 845z" } }] }, "name": "node-index", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NodeIndexOutlined$2
  }));
};

NodeIndexOutlined.displayName = 'NodeIndexOutlined';
var NodeIndexOutlined$1 = /*#__PURE__*/React.forwardRef(NodeIndexOutlined);

// This icon file is generated automatically.
var NotificationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z" } }] }, "name": "notification", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var NotificationFilled = function NotificationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NotificationFilled$2
  }));
};

NotificationFilled.displayName = 'NotificationFilled';
var NotificationFilled$1 = /*#__PURE__*/React.forwardRef(NotificationFilled);

// This icon file is generated automatically.
var NotificationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z" } }] }, "name": "notification", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NotificationOutlined = function NotificationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NotificationOutlined$2
  }));
};

NotificationOutlined.displayName = 'NotificationOutlined';
var NotificationOutlined$1 = /*#__PURE__*/React.forwardRef(NotificationOutlined);

// This icon file is generated automatically.
var NotificationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z", "fill": primaryColor } }] }; }, "name": "notification", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NotificationTwoTone$2
  }));
};

NotificationTwoTone.displayName = 'NotificationTwoTone';
var NotificationTwoTone$1 = /*#__PURE__*/React.forwardRef(NotificationTwoTone);

// This icon file is generated automatically.
var NumberOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z" } }] }, "name": "number", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NumberOutlined = function NumberOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: NumberOutlined$2
  }));
};

NumberOutlined.displayName = 'NumberOutlined';
var NumberOutlined$1 = /*#__PURE__*/React.forwardRef(NumberOutlined);

// This icon file is generated automatically.
var OneToOneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zm196-50c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zm0-140c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z" } }] }, "name": "one-to-one", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: OneToOneOutlined$2
  }));
};

OneToOneOutlined.displayName = 'OneToOneOutlined';
var OneToOneOutlined$1 = /*#__PURE__*/React.forwardRef(OneToOneOutlined);

// This icon file is generated automatically.
var OrderedListOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 00-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 002.1-5.4V432c0-2.2-1.8-4-4-4z" } }] }, "name": "ordered-list", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: OrderedListOutlined$2
  }));
};

OrderedListOutlined.displayName = 'OrderedListOutlined';
var OrderedListOutlined$1 = /*#__PURE__*/React.forwardRef(OrderedListOutlined);

// This icon file is generated automatically.
var PaperClipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PaperClipOutlined$2
  }));
};

PaperClipOutlined.displayName = 'PaperClipOutlined';
var PaperClipOutlined$1 = /*#__PURE__*/React.forwardRef(PaperClipOutlined);

// This icon file is generated automatically.
var PartitionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3zm53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150zm364.2 75.1h150v150.1h-150V662.1z" } }] }, "name": "partition", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PartitionOutlined = function PartitionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PartitionOutlined$2
  }));
};

PartitionOutlined.displayName = 'PartitionOutlined';
var PartitionOutlined$1 = /*#__PURE__*/React.forwardRef(PartitionOutlined);

// This icon file is generated automatically.
var PauseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z" } }] }, "name": "pause-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PauseCircleFilled = function PauseCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleFilled$2
  }));
};

PauseCircleFilled.displayName = 'PauseCircleFilled';
var PauseCircleFilled$1 = /*#__PURE__*/React.forwardRef(PauseCircleFilled);

// This icon file is generated automatically.
var PauseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z" } }] }, "name": "pause-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PauseCircleOutlined = function PauseCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleOutlined$2
  }));
};

PauseCircleOutlined.displayName = 'PauseCircleOutlined';
var PauseCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PauseCircleOutlined);

// This icon file is generated automatically.
var PauseCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "pause-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleTwoTone$2
  }));
};

PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
var PauseCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PauseCircleTwoTone);

// This icon file is generated automatically.
var PauseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z" } }] }, "name": "pause", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PauseOutlined = function PauseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PauseOutlined$2
  }));
};

PauseOutlined.displayName = 'PauseOutlined';
var PauseOutlined$1 = /*#__PURE__*/React.forwardRef(PauseOutlined);

// This icon file is generated automatically.
var PayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 017-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 017.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z" } }] }, "name": "pay-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PayCircleFilled = function PayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleFilled$2
  }));
};

PayCircleFilled.displayName = 'PayCircleFilled';
var PayCircleFilled$1 = /*#__PURE__*/React.forwardRef(PayCircleFilled);

// This icon file is generated automatically.
var PayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 00-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z" } }] }, "name": "pay-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleOutlined$2
  }));
};

PayCircleOutlined.displayName = 'PayCircleOutlined';
var PayCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PayCircleOutlined);

// This icon file is generated automatically.
var PercentageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 00-11.3 0L168.3 801.9a8.03 8.03 0 000 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z" } }] }, "name": "percentage", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PercentageOutlined = function PercentageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PercentageOutlined$2
  }));
};

PercentageOutlined.displayName = 'PercentageOutlined';
var PercentageOutlined$1 = /*#__PURE__*/React.forwardRef(PercentageOutlined);

// This icon file is generated automatically.
var PhoneFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 00-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 01553.1 553 395.34 395.34 0 01437 633.8L353.2 550a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 00-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z" } }] }, "name": "phone", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PhoneFilled = function PhoneFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PhoneFilled$2
  }));
};

PhoneFilled.displayName = 'PhoneFilled';
var PhoneFilled$1 = /*#__PURE__*/React.forwardRef(PhoneFilled);

// This icon file is generated automatically.
var PhoneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z" } }] }, "name": "phone", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PhoneOutlined = function PhoneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PhoneOutlined$2
  }));
};

PhoneOutlined.displayName = 'PhoneOutlined';
var PhoneOutlined$1 = /*#__PURE__*/React.forwardRef(PhoneOutlined);

// This icon file is generated automatically.
var PhoneTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 01438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z", "fill": primaryColor } }] }; }, "name": "phone", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PhoneTwoTone$2
  }));
};

PhoneTwoTone.displayName = 'PhoneTwoTone';
var PhoneTwoTone$1 = /*#__PURE__*/React.forwardRef(PhoneTwoTone);

// This icon file is generated automatically.
var PicCenterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z" } }] }, "name": "pic-center", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PicCenterOutlined$2
  }));
};

PicCenterOutlined.displayName = 'PicCenterOutlined';
var PicCenterOutlined$1 = /*#__PURE__*/React.forwardRef(PicCenterOutlined);

// This icon file is generated automatically.
var PicLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "pic-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PicLeftOutlined = function PicLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PicLeftOutlined$2
  }));
};

PicLeftOutlined.displayName = 'PicLeftOutlined';
var PicLeftOutlined$1 = /*#__PURE__*/React.forwardRef(PicLeftOutlined);

// This icon file is generated automatically.
var PicRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "pic-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PicRightOutlined = function PicRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PicRightOutlined$2
  }));
};

PicRightOutlined.displayName = 'PicRightOutlined';
var PicRightOutlined$1 = /*#__PURE__*/React.forwardRef(PicRightOutlined);

// This icon file is generated automatically.
var PictureFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 01-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z" } }] }, "name": "picture", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PictureFilled = function PictureFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PictureFilled$2
  }));
};

PictureFilled.displayName = 'PictureFilled';
var PictureFilled$1 = /*#__PURE__*/React.forwardRef(PictureFilled);

// This icon file is generated automatically.
var PictureOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, "name": "picture", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PictureOutlined = function PictureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PictureOutlined$2
  }));
};

PictureOutlined.displayName = 'PictureOutlined';
var PictureOutlined$1 = /*#__PURE__*/React.forwardRef(PictureOutlined);

// This icon file is generated automatically.
var PictureTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] }; }, "name": "picture", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PictureTwoTone = function PictureTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PictureTwoTone$2
  }));
};

PictureTwoTone.displayName = 'PictureTwoTone';
var PictureTwoTone$1 = /*#__PURE__*/React.forwardRef(PictureTwoTone);

// This icon file is generated automatically.
var PieChartFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 00-282.5 117 397.47 397.47 0 00-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 00155.6 31.5 398.57 398.57 0 00282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0031.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 00588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z" } }] }, "name": "pie-chart", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PieChartFilled = function PieChartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PieChartFilled$2
  }));
};

PieChartFilled.displayName = 'PieChartFilled';
var PieChartFilled$1 = /*#__PURE__*/React.forwardRef(PieChartFilled);

// This icon file is generated automatically.
var PieChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552a398.46 398.46 0 00117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952a398.46 398.46 0 00282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z" } }] }, "name": "pie-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PieChartOutlined$2
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
var PieChartOutlined$1 = /*#__PURE__*/React.forwardRef(PieChartOutlined);

// This icon file is generated automatically.
var PieChartTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 01-85.7-127.1A397.12 397.12 0 0172 552.2v.2a398.57 398.57 0 00117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 00471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 00-166.4-89.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 00-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 004.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z", "fill": primaryColor } }] }; }, "name": "pie-chart", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PieChartTwoTone$2
  }));
};

PieChartTwoTone.displayName = 'PieChartTwoTone';
var PieChartTwoTone$1 = /*#__PURE__*/React.forwardRef(PieChartTwoTone);

// This icon file is generated automatically.
var PlayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z" } }] }, "name": "play-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleFilled$2
  }));
};

PlayCircleFilled.displayName = 'PlayCircleFilled';
var PlayCircleFilled$1 = /*#__PURE__*/React.forwardRef(PlayCircleFilled);

// This icon file is generated automatically.
var PlayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 00398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 000-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z" } }] }, "name": "play-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleOutlined$2
  }));
};

PlayCircleOutlined.displayName = 'PlayCircleOutlined';
var PlayCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PlayCircleOutlined);

// This icon file is generated automatically.
var PlayCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 01-12.7-6.5V353a8 8 0 0112.7-6.5l218.4 158.8a7.9 7.9 0 010 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M676.1 505.3L457.7 346.5A8 8 0 00445 353v317.6a8.02 8.02 0 0012.7 6.5l218.4-158.9a7.9 7.9 0 000-12.9z", "fill": primaryColor } }] }; }, "name": "play-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlayCircleTwoTone = function PlayCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleTwoTone$2
  }));
};

PlayCircleTwoTone.displayName = 'PlayCircleTwoTone';
var PlayCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PlayCircleTwoTone);

// This icon file is generated automatically.
var PlaySquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6z" } }] }, "name": "play-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlaySquareFilled = function PlaySquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareFilled$2
  }));
};

PlaySquareFilled.displayName = 'PlaySquareFilled';
var PlaySquareFilled$1 = /*#__PURE__*/React.forwardRef(PlaySquareFilled);

// This icon file is generated automatically.
var PlaySquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 000-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "play-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlaySquareOutlined = function PlaySquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareOutlined$2
  }));
};

PlaySquareOutlined.displayName = 'PlaySquareOutlined';
var PlaySquareOutlined$1 = /*#__PURE__*/React.forwardRef(PlaySquareOutlined);

// This icon file is generated automatically.
var PlaySquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 000-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z", "fill": primaryColor } }] }; }, "name": "play-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareTwoTone$2
  }));
};

PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
var PlaySquareTwoTone$1 = /*#__PURE__*/React.forwardRef(PlaySquareTwoTone);

// This icon file is generated automatically.
var PlusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] }, "name": "plus-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlusCircleFilled = function PlusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleFilled$2
  }));
};

PlusCircleFilled.displayName = 'PlusCircleFilled';
var PlusCircleFilled$1 = /*#__PURE__*/React.forwardRef(PlusCircleFilled);

// This icon file is generated automatically.
var PlusCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "plus-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleOutlined$2
  }));
};

PlusCircleOutlined.displayName = 'PlusCircleOutlined';
var PlusCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PlusCircleOutlined);

// This icon file is generated automatically.
var PlusCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "plus-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlusCircleTwoTone = function PlusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleTwoTone$2
  }));
};

PlusCircleTwoTone.displayName = 'PlusCircleTwoTone';
var PlusCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PlusCircleTwoTone);

// This icon file is generated automatically.
var PlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusOutlined$2
  }));
};

PlusOutlined.displayName = 'PlusOutlined';
var PlusOutlined$1 = /*#__PURE__*/React.forwardRef(PlusOutlined);

// This icon file is generated automatically.
var PlusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] }, "name": "plus-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareFilled = function PlusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareFilled$2
  }));
};

PlusSquareFilled.displayName = 'PlusSquareFilled';
var PlusSquareFilled$1 = /*#__PURE__*/React.forwardRef(PlusSquareFilled);

// This icon file is generated automatically.
var PlusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareOutlined$2
  }));
};

PlusSquareOutlined.displayName = 'PlusSquareOutlined';
var PlusSquareOutlined$1 = /*#__PURE__*/React.forwardRef(PlusSquareOutlined);

// This icon file is generated automatically.
var PlusSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "plus-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareTwoTone$2
  }));
};

PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
var PlusSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(PlusSquareTwoTone);

// This icon file is generated automatically.
var PoundCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z" } }] }, "name": "pound-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleFilled$2
  }));
};

PoundCircleFilled.displayName = 'PoundCircleFilled';
var PoundCircleFilled$1 = /*#__PURE__*/React.forwardRef(PoundCircleFilled);

// This icon file is generated automatically.
var PoundCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] }, "name": "pound-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleOutlined$2
  }));
};

PoundCircleOutlined.displayName = 'PoundCircleOutlined';
var PoundCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PoundCircleOutlined);

// This icon file is generated automatically.
var PoundCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0010.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "pound-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleTwoTone$2
  }));
};

PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
var PoundCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PoundCircleTwoTone);

// This icon file is generated automatically.
var PoundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] }, "name": "pound", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PoundOutlined = function PoundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PoundOutlined$2
  }));
};

PoundOutlined.displayName = 'PoundOutlined';
var PoundOutlined$1 = /*#__PURE__*/React.forwardRef(PoundOutlined);

// This icon file is generated automatically.
var PoweroffOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M705.6 124.9a8 8 0 00-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0162.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0127.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 01-76.3 113.3 353.06 353.06 0 01-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 01-113.2-76.4A355.92 355.92 0 01184 650.4a355 355 0 01-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] }, "name": "poweroff", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PoweroffOutlined$2
  }));
};

PoweroffOutlined.displayName = 'PoweroffOutlined';
var PoweroffOutlined$1 = /*#__PURE__*/React.forwardRef(PoweroffOutlined);

// This icon file is generated automatically.
var PrinterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z" } }] }, "name": "printer", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PrinterFilled = function PrinterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PrinterFilled$2
  }));
};

PrinterFilled.displayName = 'PrinterFilled';
var PrinterFilled$1 = /*#__PURE__*/React.forwardRef(PrinterFilled);

// This icon file is generated automatically.
var PrinterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z" } }] }, "name": "printer", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PrinterOutlined = function PrinterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PrinterOutlined$2
  }));
};

PrinterOutlined.displayName = 'PrinterOutlined';
var PrinterOutlined$1 = /*#__PURE__*/React.forwardRef(PrinterOutlined);

// This icon file is generated automatically.
var PrinterTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "printer", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PrinterTwoTone$2
  }));
};

PrinterTwoTone.displayName = 'PrinterTwoTone';
var PrinterTwoTone$1 = /*#__PURE__*/React.forwardRef(PrinterTwoTone);

// This icon file is generated automatically.
var ProfileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z" } }] }, "name": "profile", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ProfileFilled = function ProfileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ProfileFilled$2
  }));
};

ProfileFilled.displayName = 'ProfileFilled';
var ProfileFilled$1 = /*#__PURE__*/React.forwardRef(ProfileFilled);

// This icon file is generated automatically.
var ProfileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "profile", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ProfileOutlined = function ProfileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ProfileOutlined$2
  }));
};

ProfileOutlined.displayName = 'ProfileOutlined';
var ProfileOutlined$1 = /*#__PURE__*/React.forwardRef(ProfileOutlined);

// This icon file is generated automatically.
var ProfileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 656a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "profile", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ProfileTwoTone = function ProfileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ProfileTwoTone$2
  }));
};

ProfileTwoTone.displayName = 'ProfileTwoTone';
var ProfileTwoTone$1 = /*#__PURE__*/React.forwardRef(ProfileTwoTone);

// This icon file is generated automatically.
var ProjectFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z" } }] }, "name": "project", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ProjectFilled = function ProjectFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ProjectFilled$2
  }));
};

ProjectFilled.displayName = 'ProjectFilled';
var ProjectFilled$1 = /*#__PURE__*/React.forwardRef(ProjectFilled);

// This icon file is generated automatically.
var ProjectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "project", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ProjectOutlined = function ProjectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ProjectOutlined$2
  }));
};

ProjectOutlined.displayName = 'ProjectOutlined';
var ProjectOutlined$1 = /*#__PURE__*/React.forwardRef(ProjectOutlined);

// This icon file is generated automatically.
var ProjectTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "project", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ProjectTwoTone$2
  }));
};

ProjectTwoTone.displayName = 'ProjectTwoTone';
var ProjectTwoTone$1 = /*#__PURE__*/React.forwardRef(ProjectTwoTone);

// This icon file is generated automatically.
var PropertySafetyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] }, "name": "property-safety", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PropertySafetyFilled = function PropertySafetyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyFilled$2
  }));
};

PropertySafetyFilled.displayName = 'PropertySafetyFilled';
var PropertySafetyFilled$1 = /*#__PURE__*/React.forwardRef(PropertySafetyFilled);

// This icon file is generated automatically.
var PropertySafetyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 00-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 00-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z" } }] }, "name": "property-safety", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyOutlined$2
  }));
};

PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
var PropertySafetyOutlined$1 = /*#__PURE__*/React.forwardRef(PropertySafetyOutlined);

// This icon file is generated automatically.
var PropertySafetyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 018.9-5.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438.9 323.5a9.88 9.88 0 00-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 00-8.9 5.5l-73.2 144.3-72.9-144.3z", "fill": primaryColor } }] }; }, "name": "property-safety", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyTwoTone$2
  }));
};

PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
var PropertySafetyTwoTone$1 = /*#__PURE__*/React.forwardRef(PropertySafetyTwoTone);

// This icon file is generated automatically.
var PullRequestOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 010-96 48.01 48.01 0 010 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0z" } }] }, "name": "pull-request", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PullRequestOutlined$2
  }));
};

PullRequestOutlined.displayName = 'PullRequestOutlined';
var PullRequestOutlined$1 = /*#__PURE__*/React.forwardRef(PullRequestOutlined);

// This icon file is generated automatically.
var PushpinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z" } }] }, "name": "pushpin", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PushpinFilled = function PushpinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PushpinFilled$2
  }));
};

PushpinFilled.displayName = 'PushpinFilled';
var PushpinFilled$1 = /*#__PURE__*/React.forwardRef(PushpinFilled);

// This icon file is generated automatically.
var PushpinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z" } }] }, "name": "pushpin", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PushpinOutlined = function PushpinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PushpinOutlined$2
  }));
};

PushpinOutlined.displayName = 'PushpinOutlined';
var PushpinOutlined$1 = /*#__PURE__*/React.forwardRef(PushpinOutlined);

// This icon file is generated automatically.
var PushpinTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0030.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z", "fill": primaryColor } }] }; }, "name": "pushpin", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: PushpinTwoTone$2
  }));
};

PushpinTwoTone.displayName = 'PushpinTwoTone';
var PushpinTwoTone$1 = /*#__PURE__*/React.forwardRef(PushpinTwoTone);

// This icon file is generated automatically.
var QqCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] }, "name": "qq-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var QqCircleFilled = function QqCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QqCircleFilled$2
  }));
};

QqCircleFilled.displayName = 'QqCircleFilled';
var QqCircleFilled$1 = /*#__PURE__*/React.forwardRef(QqCircleFilled);

// This icon file is generated automatically.
var QqOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z" } }] }, "name": "qq", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QqOutlined = function QqOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QqOutlined$2
  }));
};

QqOutlined.displayName = 'QqOutlined';
var QqOutlined$1 = /*#__PURE__*/React.forwardRef(QqOutlined);

// This icon file is generated automatically.
var QqSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] }, "name": "qq-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var QqSquareFilled = function QqSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QqSquareFilled$2
  }));
};

QqSquareFilled.displayName = 'QqSquareFilled';
var QqSquareFilled$1 = /*#__PURE__*/React.forwardRef(QqSquareFilled);

// This icon file is generated automatically.
var QrcodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "qrcode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QrcodeOutlined$2
  }));
};

QrcodeOutlined.displayName = 'QrcodeOutlined';
var QrcodeOutlined$1 = /*#__PURE__*/React.forwardRef(QrcodeOutlined);

// This icon file is generated automatically.
var QuestionCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" } }] }, "name": "question-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleFilled$2
  }));
};

QuestionCircleFilled.displayName = 'QuestionCircleFilled';
var QuestionCircleFilled$1 = /*#__PURE__*/React.forwardRef(QuestionCircleFilled);

// This icon file is generated automatically.
var QuestionCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleOutlined$2
  }));
};

QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
var QuestionCircleOutlined$1 = /*#__PURE__*/React.forwardRef(QuestionCircleOutlined);

// This icon file is generated automatically.
var QuestionCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 732a40 40 0 1080 0 40 40 0 10-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z", "fill": primaryColor } }] }; }, "name": "question-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleTwoTone = function QuestionCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleTwoTone$2
  }));
};

QuestionCircleTwoTone.displayName = 'QuestionCircleTwoTone';
var QuestionCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(QuestionCircleTwoTone);

// This icon file is generated automatically.
var QuestionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 00-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z" } }] }, "name": "question", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QuestionOutlined = function QuestionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: QuestionOutlined$2
  }));
};

QuestionOutlined.displayName = 'QuestionOutlined';
var QuestionOutlined$1 = /*#__PURE__*/React.forwardRef(QuestionOutlined);

// This icon file is generated automatically.
var RadarChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926.8 397.1l-396-288a31.81 31.81 0 00-37.6 0l-396 288a31.99 31.99 0 00-11.6 35.8l151.3 466a32 32 0 0030.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z" } }] }, "name": "radar-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RadarChartOutlined$2
  }));
};

RadarChartOutlined.displayName = 'RadarChartOutlined';
var RadarChartOutlined$1 = /*#__PURE__*/React.forwardRef(RadarChartOutlined);

// This icon file is generated automatically.
var RadiusBottomleftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-bottomleft", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomleftOutlined$2
  }));
};

RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
var RadiusBottomleftOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusBottomleftOutlined);

// This icon file is generated automatically.
var RadiusBottomrightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-bottomright", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusBottomrightOutlined = function RadiusBottomrightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomrightOutlined$2
  }));
};

RadiusBottomrightOutlined.displayName = 'RadiusBottomrightOutlined';
var RadiusBottomrightOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusBottomrightOutlined);

// This icon file is generated automatically.
var RadiusSettingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z" } }] }, "name": "radius-setting", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusSettingOutlined = function RadiusSettingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RadiusSettingOutlined$2
  }));
};

RadiusSettingOutlined.displayName = 'RadiusSettingOutlined';
var RadiusSettingOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusSettingOutlined);

// This icon file is generated automatically.
var RadiusUpleftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-upleft", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUpleftOutlined$2
  }));
};

RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
var RadiusUpleftOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusUpleftOutlined);

// This icon file is generated automatically.
var RadiusUprightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z" } }] }, "name": "radius-upright", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUprightOutlined$2
  }));
};

RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
var RadiusUprightOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusUprightOutlined);

// This icon file is generated automatically.
var ReadFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z" } }] }, "name": "read", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ReadFilled = function ReadFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ReadFilled$2
  }));
};

ReadFilled.displayName = 'ReadFilled';
var ReadFilled$1 = /*#__PURE__*/React.forwardRef(ReadFilled);

// This icon file is generated automatically.
var ReadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z" } }] }, "name": "read", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ReadOutlined = function ReadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ReadOutlined$2
  }));
};

ReadOutlined.displayName = 'ReadOutlined';
var ReadOutlined$1 = /*#__PURE__*/React.forwardRef(ReadOutlined);

// This icon file is generated automatically.
var ReconciliationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z" } }] }, "name": "reconciliation", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationFilled$2
  }));
};

ReconciliationFilled.displayName = 'ReconciliationFilled';
var ReconciliationFilled$1 = /*#__PURE__*/React.forwardRef(ReconciliationFilled);

// This icon file is generated automatically.
var ReconciliationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "reconciliation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ReconciliationOutlined = function ReconciliationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationOutlined$2
  }));
};

ReconciliationOutlined.displayName = 'ReconciliationOutlined';
var ReconciliationOutlined$1 = /*#__PURE__*/React.forwardRef(ReconciliationOutlined);

// This icon file is generated automatically.
var ReconciliationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M642 657a34 34 0 1068 0 34 34 0 10-68 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z", "fill": primaryColor } }] }; }, "name": "reconciliation", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ReconciliationTwoTone = function ReconciliationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationTwoTone$2
  }));
};

ReconciliationTwoTone.displayName = 'ReconciliationTwoTone';
var ReconciliationTwoTone$1 = /*#__PURE__*/React.forwardRef(ReconciliationTwoTone);

// This icon file is generated automatically.
var RedEnvelopeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 017.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z" } }] }, "name": "red-envelope", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeFilled$2
  }));
};

RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
var RedEnvelopeFilled$1 = /*#__PURE__*/React.forwardRef(RedEnvelopeFilled);

// This icon file is generated automatically.
var RedEnvelopeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z" } }] }, "name": "red-envelope", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedEnvelopeOutlined = function RedEnvelopeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeOutlined$2
  }));
};

RedEnvelopeOutlined.displayName = 'RedEnvelopeOutlined';
var RedEnvelopeOutlined$1 = /*#__PURE__*/React.forwardRef(RedEnvelopeOutlined);

// This icon file is generated automatically.
var RedEnvelopeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 01-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 017.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 013.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 017.5-4.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z", "fill": primaryColor } }] }; }, "name": "red-envelope", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RedEnvelopeTwoTone = function RedEnvelopeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeTwoTone$2
  }));
};

RedEnvelopeTwoTone.displayName = 'RedEnvelopeTwoTone';
var RedEnvelopeTwoTone$1 = /*#__PURE__*/React.forwardRef(RedEnvelopeTwoTone);

// This icon file is generated automatically.
var RedditCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm72 108a36 36 0 1072 0 36 36 0 10-72 0z" } }] }, "name": "reddit-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RedditCircleFilled = function RedditCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedditCircleFilled$2
  }));
};

RedditCircleFilled.displayName = 'RedditCircleFilled';
var RedditCircleFilled$1 = /*#__PURE__*/React.forwardRef(RedditCircleFilled);

// This icon file is generated automatically.
var RedditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 568a56 56 0 10112 0 56 56 0 10-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 10-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 00-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 00176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 110 63 31.5 31.5 0 010-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0150.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 01-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "reddit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedditOutlined = function RedditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedditOutlined$2
  }));
};

RedditOutlined.displayName = 'RedditOutlined';
var RedditOutlined$1 = /*#__PURE__*/React.forwardRef(RedditOutlined);

// This icon file is generated automatically.
var RedditSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM368 548a36 36 0 1072 0 36 36 0 10-72 0z" } }] }, "name": "reddit-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RedditSquareFilled = function RedditSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedditSquareFilled$2
  }));
};

RedditSquareFilled.displayName = 'RedditSquareFilled';
var RedditSquareFilled$1 = /*#__PURE__*/React.forwardRef(RedditSquareFilled);

// This icon file is generated automatically.
var RedoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedoOutlined = function RedoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RedoOutlined$2
  }));
};

RedoOutlined.displayName = 'RedoOutlined';
var RedoOutlined$1 = /*#__PURE__*/React.forwardRef(RedoOutlined);

// This icon file is generated automatically.
var ReloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z" } }] }, "name": "reload", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ReloadOutlined = function ReloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ReloadOutlined$2
  }));
};

ReloadOutlined.displayName = 'ReloadOutlined';
var ReloadOutlined$1 = /*#__PURE__*/React.forwardRef(ReloadOutlined);

// This icon file is generated automatically.
var RestFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 10160 0 80 80 0 10-160 0z" } }] }, "name": "rest", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RestFilled = function RestFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RestFilled$2
  }));
};

RestFilled.displayName = 'RestFilled';
var RestFilled$1 = /*#__PURE__*/React.forwardRef(RestFilled);

// This icon file is generated automatically.
var RestOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z" } }] }, "name": "rest", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RestOutlined = function RestOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RestOutlined$2
  }));
};

RestOutlined.displayName = 'RestOutlined';
var RestOutlined$1 = /*#__PURE__*/React.forwardRef(RestOutlined);

// This icon file is generated automatically.
var RestTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z", "fill": primaryColor } }] }; }, "name": "rest", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RestTwoTone = function RestTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RestTwoTone$2
  }));
};

RestTwoTone.displayName = 'RestTwoTone';
var RestTwoTone$1 = /*#__PURE__*/React.forwardRef(RestTwoTone);

// This icon file is generated automatically.
var RetweetOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0011.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 00-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 00-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z" } }] }, "name": "retweet", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RetweetOutlined = function RetweetOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RetweetOutlined$2
  }));
};

RetweetOutlined.displayName = 'RetweetOutlined';
var RetweetOutlined$1 = /*#__PURE__*/React.forwardRef(RetweetOutlined);

// This icon file is generated automatically.
var RightCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] }, "name": "right-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RightCircleFilled = function RightCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleFilled$2
  }));
};

RightCircleFilled.displayName = 'RightCircleFilled';
var RightCircleFilled$1 = /*#__PURE__*/React.forwardRef(RightCircleFilled);

// This icon file is generated automatically.
var RightCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178A8 8 0 00408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "right-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleOutlined$2
  }));
};

RightCircleOutlined.displayName = 'RightCircleOutlined';
var RightCircleOutlined$1 = /*#__PURE__*/React.forwardRef(RightCircleOutlined);

// This icon file is generated automatically.
var RightCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z", "fill": primaryColor } }] }; }, "name": "right-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleTwoTone$2
  }));
};

RightCircleTwoTone.displayName = 'RightCircleTwoTone';
var RightCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(RightCircleTwoTone);

// This icon file is generated automatically.
var RightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightOutlined$2
  }));
};

RightOutlined.displayName = 'RightOutlined';
var RightOutlined$1 = /*#__PURE__*/React.forwardRef(RightOutlined);

// This icon file is generated automatically.
var RightSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] }, "name": "right-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RightSquareFilled = function RightSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareFilled$2
  }));
};

RightSquareFilled.displayName = 'RightSquareFilled';
var RightSquareFilled$1 = /*#__PURE__*/React.forwardRef(RightSquareFilled);

// This icon file is generated automatically.
var RightSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "right-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareOutlined$2
  }));
};

RightSquareOutlined.displayName = 'RightSquareOutlined';
var RightSquareOutlined$1 = /*#__PURE__*/React.forwardRef(RightSquareOutlined);

// This icon file is generated automatically.
var RightSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z", "fill": primaryColor } }] }; }, "name": "right-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareTwoTone$2
  }));
};

RightSquareTwoTone.displayName = 'RightSquareTwoTone';
var RightSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(RightSquareTwoTone);

// This icon file is generated automatically.
var RiseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z" } }] }, "name": "rise", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RiseOutlined = function RiseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RiseOutlined$2
  }));
};

RiseOutlined.displayName = 'RiseOutlined';
var RiseOutlined$1 = /*#__PURE__*/React.forwardRef(RiseOutlined);

// This icon file is generated automatically.
var RobotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60zm372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60zm-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zm135 476H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c.1-17.7-11.1-32-24.9-32z" } }] }, "name": "robot", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RobotFilled = function RobotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RobotFilled$2
  }));
};

RobotFilled.displayName = 'RobotFilled';
var RobotFilled$1 = /*#__PURE__*/React.forwardRef(RobotFilled);

// This icon file is generated automatically.
var RobotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M300 328a60 60 0 10120 0 60 60 0 10-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 10120 0 60 60 0 10-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "robot", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RobotOutlined = function RobotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RobotOutlined$2
  }));
};

RobotOutlined.displayName = 'RobotOutlined';
var RobotOutlined$1 = /*#__PURE__*/React.forwardRef(RobotOutlined);

// This icon file is generated automatically.
var RocketFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 010 96 48.01 48.01 0 010-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z" } }] }, "name": "rocket", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RocketFilled = function RocketFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RocketFilled$2
  }));
};

RocketFilled.displayName = 'RocketFilled';
var RocketFilled$1 = /*#__PURE__*/React.forwardRef(RocketFilled);

// This icon file is generated automatically.
var RocketOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0162.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1096 0 48 48 0 10-96 0z" } }] }, "name": "rocket", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RocketOutlined = function RocketOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RocketOutlined$2
  }));
};

RocketOutlined.displayName = 'RocketOutlined';
var RocketOutlined$1 = /*#__PURE__*/React.forwardRef(RocketOutlined);

// This icon file is generated automatically.
var RocketTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 00-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0162.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 400a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "rocket", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RocketTwoTone = function RocketTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RocketTwoTone$2
  }));
};

RocketTwoTone.displayName = 'RocketTwoTone';
var RocketTwoTone$1 = /*#__PURE__*/React.forwardRef(RocketTwoTone);

// This icon file is generated automatically.
var RollbackOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 000 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z" } }] }, "name": "rollback", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RollbackOutlined = function RollbackOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RollbackOutlined$2
  }));
};

RollbackOutlined.displayName = 'RollbackOutlined';
var RollbackOutlined$1 = /*#__PURE__*/React.forwardRef(RollbackOutlined);

// This icon file is generated automatically.
var RotateLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RotateLeftOutlined$2
  }));
};

RotateLeftOutlined.displayName = 'RotateLeftOutlined';
var RotateLeftOutlined$1 = /*#__PURE__*/React.forwardRef(RotateLeftOutlined);

// This icon file is generated automatically.
var RotateRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: RotateRightOutlined$2
  }));
};

RotateRightOutlined.displayName = 'RotateRightOutlined';
var RotateRightOutlined$1 = /*#__PURE__*/React.forwardRef(RotateRightOutlined);

// This icon file is generated automatically.
var SafetyCertificateFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "safety-certificate", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateFilled$2
  }));
};

SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
var SafetyCertificateFilled$1 = /*#__PURE__*/React.forwardRef(SafetyCertificateFilled);

// This icon file is generated automatically.
var SafetyCertificateOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z" } }] }, "name": "safety-certificate", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SafetyCertificateOutlined = function SafetyCertificateOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateOutlined$2
  }));
};

SafetyCertificateOutlined.displayName = 'SafetyCertificateOutlined';
var SafetyCertificateOutlined$1 = /*#__PURE__*/React.forwardRef(SafetyCertificateOutlined);

// This icon file is generated automatically.
var SafetyCertificateTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z", "fill": primaryColor } }] }; }, "name": "safety-certificate", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SafetyCertificateTwoTone = function SafetyCertificateTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateTwoTone$2
  }));
};

SafetyCertificateTwoTone.displayName = 'SafetyCertificateTwoTone';
var SafetyCertificateTwoTone$1 = /*#__PURE__*/React.forwardRef(SafetyCertificateTwoTone);

// This icon file is generated automatically.
var SafetyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z" } }, { "tag": "path", "attrs": { "d": "M378.4 475.1a35.91 35.91 0 00-50.9 0 35.91 35.91 0 000 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0048.1 0L730.6 434a33.98 33.98 0 000-48.1l-2.8-2.8a33.98 33.98 0 00-48.1 0L483 579.7 378.4 475.1z" } }] }, "name": "safety", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SafetyOutlined = function SafetyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SafetyOutlined$2
  }));
};

SafetyOutlined.displayName = 'SafetyOutlined';
var SafetyOutlined$1 = /*#__PURE__*/React.forwardRef(SafetyOutlined);

// This icon file is generated automatically.
var SaveFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" } }] }, "name": "save", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SaveFilled = function SaveFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SaveFilled$2
  }));
};

SaveFilled.displayName = 'SaveFilled';
var SaveFilled$1 = /*#__PURE__*/React.forwardRef(SaveFilled);

// This icon file is generated automatically.
var SaveOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" } }] }, "name": "save", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SaveOutlined = function SaveOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SaveOutlined$2
  }));
};

SaveOutlined.displayName = 'SaveOutlined';
var SaveOutlined$1 = /*#__PURE__*/React.forwardRef(SaveOutlined);

// This icon file is generated automatically.
var SaveTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 00-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z", "fill": primaryColor } }] }; }, "name": "save", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SaveTwoTone = function SaveTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SaveTwoTone$2
  }));
};

SaveTwoTone.displayName = 'SaveTwoTone';
var SaveTwoTone$1 = /*#__PURE__*/React.forwardRef(SaveTwoTone);

// This icon file is generated automatically.
var ScanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "scan", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ScanOutlined = function ScanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ScanOutlined$2
  }));
};

ScanOutlined.displayName = 'ScanOutlined';
var ScanOutlined$1 = /*#__PURE__*/React.forwardRef(ScanOutlined);

// This icon file is generated automatically.
var ScheduleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "schedule", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ScheduleFilled = function ScheduleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleFilled$2
  }));
};

ScheduleFilled.displayName = 'ScheduleFilled';
var ScheduleFilled$1 = /*#__PURE__*/React.forwardRef(ScheduleFilled);

// This icon file is generated automatically.
var ScheduleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z" } }] }, "name": "schedule", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleOutlined$2
  }));
};

ScheduleOutlined.displayName = 'ScheduleOutlined';
var ScheduleOutlined$1 = /*#__PURE__*/React.forwardRef(ScheduleOutlined);

// This icon file is generated automatically.
var ScheduleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "schedule", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ScheduleTwoTone = function ScheduleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleTwoTone$2
  }));
};

ScheduleTwoTone.displayName = 'ScheduleTwoTone';
var ScheduleTwoTone$1 = /*#__PURE__*/React.forwardRef(ScheduleTwoTone);

// This icon file is generated automatically.
var ScissorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 00288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" } }] }, "name": "scissor", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ScissorOutlined = function ScissorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ScissorOutlined$2
  }));
};

ScissorOutlined.displayName = 'ScissorOutlined';
var ScissorOutlined$1 = /*#__PURE__*/React.forwardRef(ScissorOutlined);

// This icon file is generated automatically.
var SearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SearchOutlined$2
  }));
};

SearchOutlined.displayName = 'SearchOutlined';
var SearchOutlined$1 = /*#__PURE__*/React.forwardRef(SearchOutlined);

// This icon file is generated automatically.
var SecurityScanFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 10113.27-113.28 80.1 80.1 0 10-113.27 113.28z" } }] }, "name": "security-scan", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SecurityScanFilled = function SecurityScanFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanFilled$2
  }));
};

SecurityScanFilled.displayName = 'SecurityScanFilled';
var SecurityScanFilled$1 = /*#__PURE__*/React.forwardRef(SecurityScanFilled);

// This icon file is generated automatically.
var SecurityScanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z" } }] }, "name": "security-scan", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanOutlined$2
  }));
};

SecurityScanOutlined.displayName = 'SecurityScanOutlined';
var SecurityScanOutlined$1 = /*#__PURE__*/React.forwardRef(SecurityScanOutlined);

// This icon file is generated automatically.
var SecurityScanTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.7 451.1a80.1 80.1 0 10160.2 0 80.1 80.1 0 10-160.2 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 01113.3 0 80.1 80.1 0 010 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z", "fill": primaryColor } }] }; }, "name": "security-scan", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SecurityScanTwoTone = function SecurityScanTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanTwoTone$2
  }));
};

SecurityScanTwoTone.displayName = 'SecurityScanTwoTone';
var SecurityScanTwoTone$1 = /*#__PURE__*/React.forwardRef(SecurityScanTwoTone);

// This icon file is generated automatically.
var SelectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 00-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z" } }] }, "name": "select", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SelectOutlined = function SelectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SelectOutlined$2
  }));
};

SelectOutlined.displayName = 'SelectOutlined';
var SelectOutlined$1 = /*#__PURE__*/React.forwardRef(SelectOutlined);

// This icon file is generated automatically.
var SendOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z" } }] }, "name": "send", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SendOutlined = function SendOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SendOutlined$2
  }));
};

SendOutlined.displayName = 'SendOutlined';
var SendOutlined$1 = /*#__PURE__*/React.forwardRef(SendOutlined);

// This icon file is generated automatically.
var SettingFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 00-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 009.3-35.2l-.9-2.6a442.5 442.5 0 00-79.6-137.7l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.3a353.44 353.44 0 00-98.9 57.3l-81.8-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a445.93 445.93 0 00-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0025.8 25.7l2.7.5a448.27 448.27 0 00158.8 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z" } }] }, "name": "setting", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SettingFilled = function SettingFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SettingFilled$2
  }));
};

SettingFilled.displayName = 'SettingFilled';
var SettingFilled$1 = /*#__PURE__*/React.forwardRef(SettingFilled);

// This icon file is generated automatically.
var SettingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z" } }] }, "name": "setting", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SettingOutlined = function SettingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SettingOutlined$2
  }));
};

SettingOutlined.displayName = 'SettingOutlined';
var SettingOutlined$1 = /*#__PURE__*/React.forwardRef(SettingOutlined);

// This icon file is generated automatically.
var SettingTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 00-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 01-79.7 137.9l-1.8 2.1a32 32 0 01-35.1 9.5l-81.3-28.9a350 350 0 01-99.7 57.6l-15.7 85a32.05 32.05 0 01-25.8 25.7l-2.7.5a445.2 445.2 0 01-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M594.1 952.2a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 00-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6a32.09 32.09 0 007.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z", "fill": primaryColor } }] }; }, "name": "setting", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SettingTwoTone = function SettingTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SettingTwoTone$2
  }));
};

SettingTwoTone.displayName = 'SettingTwoTone';
var SettingTwoTone$1 = /*#__PURE__*/React.forwardRef(SettingTwoTone);

// This icon file is generated automatically.
var ShakeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M324 666a48 48 0 1096 0 48 48 0 10-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 000 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0011.2 0L373.7 164a7.9 7.9 0 000-11.2l-38.4-38.4a7.9 7.9 0 00-11.2 0L114.3 323.9a7.9 7.9 0 000 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 00-11.2 0L650.3 860.1a7.9 7.9 0 000 11.2l38.4 38.4a7.9 7.9 0 0011.2 0L909.7 700a7.9 7.9 0 000-11.2l-38.3-38.5z" } }] }, "name": "shake", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShakeOutlined = function ShakeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShakeOutlined$2
  }));
};

ShakeOutlined.displayName = 'ShakeOutlined';
var ShakeOutlined$1 = /*#__PURE__*/React.forwardRef(ShakeOutlined);

// This icon file is generated automatically.
var ShareAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 000-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z" } }] }, "name": "share-alt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShareAltOutlined = function ShareAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShareAltOutlined$2
  }));
};

ShareAltOutlined.displayName = 'ShareAltOutlined';
var ShareAltOutlined$1 = /*#__PURE__*/React.forwardRef(ShareAltOutlined);

// This icon file is generated automatically.
var ShopFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z" } }] }, "name": "shop", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ShopFilled = function ShopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShopFilled$2
  }));
};

ShopFilled.displayName = 'ShopFilled';
var ShopFilled$1 = /*#__PURE__*/React.forwardRef(ShopFilled);

// This icon file is generated automatically.
var ShopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z" } }] }, "name": "shop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShopOutlined = function ShopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShopOutlined$2
  }));
};

ShopOutlined.displayName = 'ShopOutlined';
var ShopOutlined$1 = /*#__PURE__*/React.forwardRef(ShopOutlined);

// This icon file is generated automatically.
var ShopTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z", "fill": primaryColor } }] }; }, "name": "shop", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ShopTwoTone = function ShopTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShopTwoTone$2
  }));
};

ShopTwoTone.displayName = 'ShopTwoTone';
var ShopTwoTone$1 = /*#__PURE__*/React.forwardRef(ShopTwoTone);

// This icon file is generated automatically.
var ShoppingCartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 00-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 100 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 00-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 00-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6z" } }] }, "name": "shopping-cart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShoppingCartOutlined = function ShoppingCartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingCartOutlined$2
  }));
};

ShoppingCartOutlined.displayName = 'ShoppingCartOutlined';
var ShoppingCartOutlined$1 = /*#__PURE__*/React.forwardRef(ShoppingCartOutlined);

// This icon file is generated automatically.
var ShoppingFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z" } }] }, "name": "shopping", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ShoppingFilled = function ShoppingFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingFilled$2
  }));
};

ShoppingFilled.displayName = 'ShoppingFilled';
var ShoppingFilled$1 = /*#__PURE__*/React.forwardRef(ShoppingFilled);

// This icon file is generated automatically.
var ShoppingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z" } }] }, "name": "shopping", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingOutlined$2
  }));
};

ShoppingOutlined.displayName = 'ShoppingOutlined';
var ShoppingOutlined$1 = /*#__PURE__*/React.forwardRef(ShoppingOutlined);

// This icon file is generated automatically.
var ShoppingTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z", "fill": primaryColor } }] }; }, "name": "shopping", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingTwoTone$2
  }));
};

ShoppingTwoTone.displayName = 'ShoppingTwoTone';
var ShoppingTwoTone$1 = /*#__PURE__*/React.forwardRef(ShoppingTwoTone);

// This icon file is generated automatically.
var ShrinkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 00-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L447.9 585a7.9 7.9 0 00-8.9-8.9z" } }] }, "name": "shrink", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ShrinkOutlined$2
  }));
};

ShrinkOutlined.displayName = 'ShrinkOutlined';
var ShrinkOutlined$1 = /*#__PURE__*/React.forwardRef(ShrinkOutlined);

// This icon file is generated automatically.
var SignalFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z" } }] }, "name": "signal", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SignalFilled = function SignalFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SignalFilled$2
  }));
};

SignalFilled.displayName = 'SignalFilled';
var SignalFilled$1 = /*#__PURE__*/React.forwardRef(SignalFilled);

// This icon file is generated automatically.
var SisternodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432zm128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] }, "name": "sisternode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SisternodeOutlined = function SisternodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SisternodeOutlined$2
  }));
};

SisternodeOutlined.displayName = 'SisternodeOutlined';
var SisternodeOutlined$1 = /*#__PURE__*/React.forwardRef(SisternodeOutlined);

// This icon file is generated automatically.
var SketchCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z" } }] }, "name": "sketch-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SketchCircleFilled$2
  }));
};

SketchCircleFilled.displayName = 'SketchCircleFilled';
var SketchCircleFilled$1 = /*#__PURE__*/React.forwardRef(SketchCircleFilled);

// This icon file is generated automatically.
var SketchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 00-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 00.2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 00.2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z" } }] }, "name": "sketch", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SketchOutlined = function SketchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SketchOutlined$2
  }));
};

SketchOutlined.displayName = 'SketchOutlined';
var SketchOutlined$1 = /*#__PURE__*/React.forwardRef(SketchOutlined);

// This icon file is generated automatically.
var SketchSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z" } }] }, "name": "sketch-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SketchSquareFilled$2
  }));
};

SketchSquareFilled.displayName = 'SketchSquareFilled';
var SketchSquareFilled$1 = /*#__PURE__*/React.forwardRef(SketchSquareFilled);

// This icon file is generated automatically.
var SkinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44z" } }] }, "name": "skin", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SkinFilled = function SkinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SkinFilled$2
  }));
};

SkinFilled.displayName = 'SkinFilled';
var SkinFilled$1 = /*#__PURE__*/React.forwardRef(SkinFilled);

// This icon file is generated automatically.
var SkinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z" } }] }, "name": "skin", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SkinOutlined = function SkinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SkinOutlined$2
  }));
};

SkinOutlined.displayName = 'SkinOutlined';
var SkinOutlined$1 = /*#__PURE__*/React.forwardRef(SkinOutlined);

// This icon file is generated automatically.
var SkinTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z", "fill": primaryColor } }] }; }, "name": "skin", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SkinTwoTone = function SkinTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SkinTwoTone$2
  }));
};

SkinTwoTone.displayName = 'SkinTwoTone';
var SkinTwoTone$1 = /*#__PURE__*/React.forwardRef(SkinTwoTone);

// This icon file is generated automatically.
var SkypeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z" } }] }, "name": "skype", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SkypeFilled = function SkypeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SkypeFilled$2
  }));
};

SkypeFilled.displayName = 'SkypeFilled';
var SkypeFilled$1 = /*#__PURE__*/React.forwardRef(SkypeFilled);

// This icon file is generated automatically.
var SkypeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 01-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 01-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0171.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z" } }] }, "name": "skype", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SkypeOutlined = function SkypeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SkypeOutlined$2
  }));
};

SkypeOutlined.displayName = 'SkypeOutlined';
var SkypeOutlined$1 = /*#__PURE__*/React.forwardRef(SkypeOutlined);

// This icon file is generated automatically.
var SlackCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SlackCircleFilled = function SlackCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlackCircleFilled$2
  }));
};

SlackCircleFilled.displayName = 'SlackCircleFilled';
var SlackCircleFilled$1 = /*#__PURE__*/React.forwardRef(SlackCircleFilled);

// This icon file is generated automatically.
var SlackOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 00-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z" } }] }, "name": "slack", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SlackOutlined = function SlackOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlackOutlined$2
  }));
};

SlackOutlined.displayName = 'SlackOutlined';
var SlackOutlined$1 = /*#__PURE__*/React.forwardRef(SlackOutlined);

// This icon file is generated automatically.
var SlackSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareFilled$2
  }));
};

SlackSquareFilled.displayName = 'SlackSquareFilled';
var SlackSquareFilled$1 = /*#__PURE__*/React.forwardRef(SlackSquareFilled);

// This icon file is generated automatically.
var SlackSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SlackSquareOutlined = function SlackSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareOutlined$2
  }));
};

SlackSquareOutlined.displayName = 'SlackSquareOutlined';
var SlackSquareOutlined$1 = /*#__PURE__*/React.forwardRef(SlackSquareOutlined);

// This icon file is generated automatically.
var SlidersFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z" } }] }, "name": "sliders", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SlidersFilled = function SlidersFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlidersFilled$2
  }));
};

SlidersFilled.displayName = 'SlidersFilled';
var SlidersFilled$1 = /*#__PURE__*/React.forwardRef(SlidersFilled);

// This icon file is generated automatically.
var SlidersOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z" } }] }, "name": "sliders", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SlidersOutlined = function SlidersOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlidersOutlined$2
  }));
};

SlidersOutlined.displayName = 'SlidersOutlined';
var SlidersOutlined$1 = /*#__PURE__*/React.forwardRef(SlidersOutlined);

// This icon file is generated automatically.
var SlidersTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 00-3 3v74a3 3 0 003 3h74a3 3 0 003-3v-74a3 3 0 00-3-3zm215-108h80v296h-80z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z", "fill": primaryColor } }] }; }, "name": "sliders", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SlidersTwoTone$2
  }));
};

SlidersTwoTone.displayName = 'SlidersTwoTone';
var SlidersTwoTone$1 = /*#__PURE__*/React.forwardRef(SlidersTwoTone);

// This icon file is generated automatically.
var SmallDashOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z" } }] }, "name": "small-dash", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SmallDashOutlined = function SmallDashOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SmallDashOutlined$2
  }));
};

SmallDashOutlined.displayName = 'SmallDashOutlined';
var SmallDashOutlined$1 = /*#__PURE__*/React.forwardRef(SmallDashOutlined);

// This icon file is generated automatically.
var SmileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "smile", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SmileFilled = function SmileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SmileFilled$2
  }));
};

SmileFilled.displayName = 'SmileFilled';
var SmileFilled$1 = /*#__PURE__*/React.forwardRef(SmileFilled);

// This icon file is generated automatically.
var SmileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z" } }] }, "name": "smile", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SmileOutlined = function SmileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SmileOutlined$2
  }));
};

SmileOutlined.displayName = 'SmileOutlined';
var SmileOutlined$1 = /*#__PURE__*/React.forwardRef(SmileOutlined);

// This icon file is generated automatically.
var SmileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4zm-24-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "smile", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SmileTwoTone = function SmileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SmileTwoTone$2
  }));
};

SmileTwoTone.displayName = 'SmileTwoTone';
var SmileTwoTone$1 = /*#__PURE__*/React.forwardRef(SmileTwoTone);

// This icon file is generated automatically.
var SnippetsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] }, "name": "snippets", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SnippetsFilled = function SnippetsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsFilled$2
  }));
};

SnippetsFilled.displayName = 'SnippetsFilled';
var SnippetsFilled$1 = /*#__PURE__*/React.forwardRef(SnippetsFilled);

// This icon file is generated automatically.
var SnippetsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] }, "name": "snippets", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsOutlined$2
  }));
};

SnippetsOutlined.displayName = 'SnippetsOutlined';
var SnippetsOutlined$1 = /*#__PURE__*/React.forwardRef(SnippetsOutlined);

// This icon file is generated automatically.
var SnippetsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z", "fill": primaryColor } }] }; }, "name": "snippets", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsTwoTone$2
  }));
};

SnippetsTwoTone.displayName = 'SnippetsTwoTone';
var SnippetsTwoTone$1 = /*#__PURE__*/React.forwardRef(SnippetsTwoTone);

// This icon file is generated automatically.
var SolutionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }] }, "name": "solution", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SolutionOutlined = function SolutionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SolutionOutlined$2
  }));
};

SolutionOutlined.displayName = 'SolutionOutlined';
var SolutionOutlined$1 = /*#__PURE__*/React.forwardRef(SolutionOutlined);

// This icon file is generated automatically.
var SortAscendingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0012.6 0l112-141.9c4.1-5.2.4-13-6.3-13z" } }] }, "name": "sort-ascending", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SortAscendingOutlined$2
  }));
};

SortAscendingOutlined.displayName = 'SortAscendingOutlined';
var SortAscendingOutlined$1 = /*#__PURE__*/React.forwardRef(SortAscendingOutlined);

// This icon file is generated automatically.
var SortDescendingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM310.3 167.1a8 8 0 00-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z" } }] }, "name": "sort-descending", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SortDescendingOutlined$2
  }));
};

SortDescendingOutlined.displayName = 'SortDescendingOutlined';
var SortDescendingOutlined$1 = /*#__PURE__*/React.forwardRef(SortDescendingOutlined);

// This icon file is generated automatically.
var SoundFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z" } }] }, "name": "sound", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SoundFilled = function SoundFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SoundFilled$2
  }));
};

SoundFilled.displayName = 'SoundFilled';
var SoundFilled$1 = /*#__PURE__*/React.forwardRef(SoundFilled);

// This icon file is generated automatically.
var SoundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344z" } }] }, "name": "sound", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SoundOutlined = function SoundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SoundOutlined$2
  }));
};

SoundOutlined.displayName = 'SoundOutlined';
var SoundOutlined$1 = /*#__PURE__*/React.forwardRef(SoundOutlined);

// This icon file is generated automatically.
var SoundTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z", "fill": primaryColor } }] }; }, "name": "sound", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SoundTwoTone = function SoundTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SoundTwoTone$2
  }));
};

SoundTwoTone.displayName = 'SoundTwoTone';
var SoundTwoTone$1 = /*#__PURE__*/React.forwardRef(SoundTwoTone);

// This icon file is generated automatically.
var SplitCellsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] }, "name": "split-cells", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SplitCellsOutlined = function SplitCellsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SplitCellsOutlined$2
  }));
};

SplitCellsOutlined.displayName = 'SplitCellsOutlined';
var SplitCellsOutlined$1 = /*#__PURE__*/React.forwardRef(SplitCellsOutlined);

// This icon file is generated automatically.
var StarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StarFilled = function StarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StarFilled$2
  }));
};

StarFilled.displayName = 'StarFilled';
var StarFilled$1 = /*#__PURE__*/React.forwardRef(StarFilled);

// This icon file is generated automatically.
var StarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z" } }] }, "name": "star", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StarOutlined = function StarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StarOutlined$2
  }));
};

StarOutlined.displayName = 'StarOutlined';
var StarOutlined$1 = /*#__PURE__*/React.forwardRef(StarOutlined);

// This icon file is generated automatically.
var StarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0046.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z", "fill": primaryColor } }] }; }, "name": "star", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var StarTwoTone = function StarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StarTwoTone$2
  }));
};

StarTwoTone.displayName = 'StarTwoTone';
var StarTwoTone$1 = /*#__PURE__*/React.forwardRef(StarTwoTone);

// This icon file is generated automatically.
var StepBackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] }, "name": "step-backward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StepBackwardFilled = function StepBackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardFilled$2
  }));
};

StepBackwardFilled.displayName = 'StepBackwardFilled';
var StepBackwardFilled$1 = /*#__PURE__*/React.forwardRef(StepBackwardFilled);

// This icon file is generated automatically.
var StepBackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] }, "name": "step-backward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardOutlined$2
  }));
};

StepBackwardOutlined.displayName = 'StepBackwardOutlined';
var StepBackwardOutlined$1 = /*#__PURE__*/React.forwardRef(StepBackwardOutlined);

// This icon file is generated automatically.
var StepForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] }, "name": "step-forward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StepForwardFilled = function StepForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardFilled$2
  }));
};

StepForwardFilled.displayName = 'StepForwardFilled';
var StepForwardFilled$1 = /*#__PURE__*/React.forwardRef(StepForwardFilled);

// This icon file is generated automatically.
var StepForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] }, "name": "step-forward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardOutlined$2
  }));
};

StepForwardOutlined.displayName = 'StepForwardOutlined';
var StepForwardOutlined$1 = /*#__PURE__*/React.forwardRef(StepForwardOutlined);

// This icon file is generated automatically.
var StockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0045.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 00-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 00-45.2 0L165.7 610.5a7.94 7.94 0 000 11.3z" } }] }, "name": "stock", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StockOutlined = function StockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StockOutlined$2
  }));
};

StockOutlined.displayName = 'StockOutlined';
var StockOutlined$1 = /*#__PURE__*/React.forwardRef(StockOutlined);

// This icon file is generated automatically.
var StopFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z" } }] }, "name": "stop", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StopFilled = function StopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StopFilled$2
  }));
};

StopFilled.displayName = 'StopFilled';
var StopFilled$1 = /*#__PURE__*/React.forwardRef(StopFilled);

// This icon file is generated automatically.
var StopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z" } }] }, "name": "stop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StopOutlined = function StopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StopOutlined$2
  }));
};

StopOutlined.displayName = 'StopOutlined';
var StopOutlined$1 = /*#__PURE__*/React.forwardRef(StopOutlined);

// This icon file is generated automatically.
var StopTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z", "fill": secondaryColor } }] }; }, "name": "stop", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var StopTwoTone = function StopTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StopTwoTone$2
  }));
};

StopTwoTone.displayName = 'StopTwoTone';
var StopTwoTone$1 = /*#__PURE__*/React.forwardRef(StopTwoTone);

// This icon file is generated automatically.
var StrikethroughOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 00-8-7.9z" } }] }, "name": "strikethrough", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: StrikethroughOutlined$2
  }));
};

StrikethroughOutlined.displayName = 'StrikethroughOutlined';
var StrikethroughOutlined$1 = /*#__PURE__*/React.forwardRef(StrikethroughOutlined);

// This icon file is generated automatically.
var SubnodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M688 240c-138 0-252 102.8-269.6 236H249a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240zm128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] }, "name": "subnode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SubnodeOutlined = function SubnodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SubnodeOutlined$2
  }));
};

SubnodeOutlined.displayName = 'SubnodeOutlined';
var SubnodeOutlined$1 = /*#__PURE__*/React.forwardRef(SubnodeOutlined);

// This icon file is generated automatically.
var SwapLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapLeftOutlined = function SwapLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SwapLeftOutlined$2
  }));
};

SwapLeftOutlined.displayName = 'SwapLeftOutlined';
var SwapLeftOutlined$1 = /*#__PURE__*/React.forwardRef(SwapLeftOutlined);

// This icon file is generated automatically.
var SwapOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapOutlined = function SwapOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SwapOutlined$2
  }));
};

SwapOutlined.displayName = 'SwapOutlined';
var SwapOutlined$1 = /*#__PURE__*/React.forwardRef(SwapOutlined);

// This icon file is generated automatically.
var SwapRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SwapRightOutlined$2
  }));
};

SwapRightOutlined.displayName = 'SwapRightOutlined';
var SwapRightOutlined$1 = /*#__PURE__*/React.forwardRef(SwapRightOutlined);

// This icon file is generated automatically.
var SwitcherFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z" } }] }, "name": "switcher", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SwitcherFilled = function SwitcherFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherFilled$2
  }));
};

SwitcherFilled.displayName = 'SwitcherFilled';
var SwitcherFilled$1 = /*#__PURE__*/React.forwardRef(SwitcherFilled);

// This icon file is generated automatically.
var SwitcherOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z" } }] }, "name": "switcher", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherOutlined$2
  }));
};

SwitcherOutlined.displayName = 'SwitcherOutlined';
var SwitcherOutlined$1 = /*#__PURE__*/React.forwardRef(SwitcherOutlined);

// This icon file is generated automatically.
var SwitcherTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M300 550h296v64H300z", "fill": primaryColor } }] }; }, "name": "switcher", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherTwoTone$2
  }));
};

SwitcherTwoTone.displayName = 'SwitcherTwoTone';
var SwitcherTwoTone$1 = /*#__PURE__*/React.forwardRef(SwitcherTwoTone);

// This icon file is generated automatically.
var SyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z" } }] }, "name": "sync", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SyncOutlined = function SyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: SyncOutlined$2
  }));
};

SyncOutlined.displayName = 'SyncOutlined';
var SyncOutlined$1 = /*#__PURE__*/React.forwardRef(SyncOutlined);

// This icon file is generated automatically.
var TableOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z" } }] }, "name": "table", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TableOutlined = function TableOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TableOutlined$2
  }));
};

TableOutlined.displayName = 'TableOutlined';
var TableOutlined$1 = /*#__PURE__*/React.forwardRef(TableOutlined);

// This icon file is generated automatically.
var TabletFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] }, "name": "tablet", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TabletFilled = function TabletFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TabletFilled$2
  }));
};

TabletFilled.displayName = 'TabletFilled';
var TabletFilled$1 = /*#__PURE__*/React.forwardRef(TabletFilled);

// This icon file is generated automatically.
var TabletOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "tablet", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TabletOutlined = function TabletOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TabletOutlined$2
  }));
};

TabletOutlined.displayName = 'TabletOutlined';
var TabletOutlined$1 = /*#__PURE__*/React.forwardRef(TabletOutlined);

// This icon file is generated automatically.
var TabletTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 784a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "tablet", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TabletTwoTone = function TabletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TabletTwoTone$2
  }));
};

TabletTwoTone.displayName = 'TabletTwoTone';
var TabletTwoTone$1 = /*#__PURE__*/React.forwardRef(TabletTwoTone);

// This icon file is generated automatically.
var TagFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z" } }] }, "name": "tag", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TagFilled = function TagFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TagFilled$2
  }));
};

TagFilled.displayName = 'TagFilled';
var TagFilled$1 = /*#__PURE__*/React.forwardRef(TagFilled);

// This icon file is generated automatically.
var TagOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" } }] }, "name": "tag", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TagOutlined = function TagOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TagOutlined$2
  }));
};

TagOutlined.displayName = 'TagOutlined';
var TagOutlined$1 = /*#__PURE__*/React.forwardRef(TagOutlined);

// This icon file is generated automatically.
var TagTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8a9.9 9.9 0 007.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z", "fill": primaryColor } }] }; }, "name": "tag", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TagTwoTone = function TagTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TagTwoTone$2
  }));
};

TagTwoTone.displayName = 'TagTwoTone';
var TagTwoTone$1 = /*#__PURE__*/React.forwardRef(TagTwoTone);

// This icon file is generated automatically.
var TagsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] }, "name": "tags", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TagsFilled = function TagsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TagsFilled$2
  }));
};

TagsFilled.displayName = 'TagsFilled';
var TagsFilled$1 = /*#__PURE__*/React.forwardRef(TagsFilled);

// This icon file is generated automatically.
var TagsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1067.88-67.89 48 48 0 10-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] }, "name": "tags", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TagsOutlined = function TagsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TagsOutlined$2
  }));
};

TagsOutlined.displayName = 'TagsOutlined';
var TagsOutlined$1 = /*#__PURE__*/React.forwardRef(TagsOutlined);

// This icon file is generated automatically.
var TagsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0133.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0112.4 46.4 47.81 47.81 0 01-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 01-12.4-46.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 010-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0033.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 00-46.4-12.4 47.81 47.81 0 00-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0046.4 12.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z", "fill": primaryColor } }] }; }, "name": "tags", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TagsTwoTone = function TagsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TagsTwoTone$2
  }));
};

TagsTwoTone.displayName = 'TagsTwoTone';
var TagsTwoTone$1 = /*#__PURE__*/React.forwardRef(TagsTwoTone);

// This icon file is generated automatically.
var TaobaoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TaobaoCircleFilled = function TaobaoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleFilled$2
  }));
};

TaobaoCircleFilled.displayName = 'TaobaoCircleFilled';
var TaobaoCircleFilled$1 = /*#__PURE__*/React.forwardRef(TaobaoCircleFilled);

// This icon file is generated automatically.
var TaobaoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleOutlined$2
  }));
};

TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
var TaobaoCircleOutlined$1 = /*#__PURE__*/React.forwardRef(TaobaoCircleOutlined);

// This icon file is generated automatically.
var TaobaoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168.5 273.7a68.7 68.7 0 10137.4 0 68.7 68.7 0 10-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z" } }] }, "name": "taobao", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TaobaoOutlined = function TaobaoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoOutlined$2
  }));
};

TaobaoOutlined.displayName = 'TaobaoOutlined';
var TaobaoOutlined$1 = /*#__PURE__*/React.forwardRef(TaobaoOutlined);

// This icon file is generated automatically.
var TaobaoSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoSquareFilled$2
  }));
};

TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
var TaobaoSquareFilled$1 = /*#__PURE__*/React.forwardRef(TaobaoSquareFilled);

// This icon file is generated automatically.
var TeamOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z" } }] }, "name": "team", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TeamOutlined = function TeamOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TeamOutlined$2
  }));
};

TeamOutlined.displayName = 'TeamOutlined';
var TeamOutlined$1 = /*#__PURE__*/React.forwardRef(TeamOutlined);

// This icon file is generated automatically.
var ThunderboltFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z" } }] }, "name": "thunderbolt", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ThunderboltFilled = function ThunderboltFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltFilled$2
  }));
};

ThunderboltFilled.displayName = 'ThunderboltFilled';
var ThunderboltFilled$1 = /*#__PURE__*/React.forwardRef(ThunderboltFilled);

// This icon file is generated automatically.
var ThunderboltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z" } }] }, "name": "thunderbolt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltOutlined$2
  }));
};

ThunderboltOutlined.displayName = 'ThunderboltOutlined';
var ThunderboltOutlined$1 = /*#__PURE__*/React.forwardRef(ThunderboltOutlined);

// This icon file is generated automatically.
var ThunderboltTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z", "fill": primaryColor } }] }; }, "name": "thunderbolt", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ThunderboltTwoTone = function ThunderboltTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltTwoTone$2
  }));
};

ThunderboltTwoTone.displayName = 'ThunderboltTwoTone';
var ThunderboltTwoTone$1 = /*#__PURE__*/React.forwardRef(ThunderboltTwoTone);

// This icon file is generated automatically.
var ToTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z" } }] }, "name": "to-top", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ToTopOutlined = function ToTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ToTopOutlined$2
  }));
};

ToTopOutlined.displayName = 'ToTopOutlined';
var ToTopOutlined$1 = /*#__PURE__*/React.forwardRef(ToTopOutlined);

// This icon file is generated automatically.
var ToolFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 00419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z" } }] }, "name": "tool", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ToolFilled = function ToolFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ToolFilled$2
  }));
};

ToolFilled.displayName = 'ToolFilled';
var ToolFilled$1 = /*#__PURE__*/React.forwardRef(ToolFilled);

// This icon file is generated automatically.
var ToolOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z" } }] }, "name": "tool", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ToolOutlined = function ToolOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ToolOutlined$2
  }));
};

ToolOutlined.displayName = 'ToolOutlined';
var ToolOutlined$1 = /*#__PURE__*/React.forwardRef(ToolOutlined);

// This icon file is generated automatically.
var ToolTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M706.8 488.7a32.05 32.05 0 01-45.3 0L537 364.2a32.05 32.05 0 010-45.3l132.9-132.8a184.2 184.2 0 00-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z", "fill": primaryColor } }] }; }, "name": "tool", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ToolTwoTone = function ToolTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ToolTwoTone$2
  }));
};

ToolTwoTone.displayName = 'ToolTwoTone';
var ToolTwoTone$1 = /*#__PURE__*/React.forwardRef(ToolTwoTone);

// This icon file is generated automatically.
var TrademarkCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z" } }] }, "name": "trademark-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TrademarkCircleFilled = function TrademarkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleFilled$2
  }));
};

TrademarkCircleFilled.displayName = 'TrademarkCircleFilled';
var TrademarkCircleFilled$1 = /*#__PURE__*/React.forwardRef(TrademarkCircleFilled);

// This icon file is generated automatically.
var TrademarkCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] }, "name": "trademark-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TrademarkCircleOutlined = function TrademarkCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleOutlined$2
  }));
};

TrademarkCircleOutlined.displayName = 'TrademarkCircleOutlined';
var TrademarkCircleOutlined$1 = /*#__PURE__*/React.forwardRef(TrademarkCircleOutlined);

// This icon file is generated automatically.
var TrademarkCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z", "fill": primaryColor } }] }; }, "name": "trademark-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleTwoTone$2
  }));
};

TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
var TrademarkCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(TrademarkCircleTwoTone);

// This icon file is generated automatically.
var TrademarkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] }, "name": "trademark", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkOutlined$2
  }));
};

TrademarkOutlined.displayName = 'TrademarkOutlined';
var TrademarkOutlined$1 = /*#__PURE__*/React.forwardRef(TrademarkOutlined);

// This icon file is generated automatically.
var TransactionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 01103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 003 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 008 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 01-103.5 242.4 352.57 352.57 0 01-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 01-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 00-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 00-8-8.2z" } }] }, "name": "transaction", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TransactionOutlined = function TransactionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TransactionOutlined$2
  }));
};

TransactionOutlined.displayName = 'TransactionOutlined';
var TransactionOutlined$1 = /*#__PURE__*/React.forwardRef(TransactionOutlined);

// This icon file is generated automatically.
var TranslationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z" } }, { "tag": "path", "attrs": { "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z" } }] }, "name": "translation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TranslationOutlined = function TranslationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TranslationOutlined$2
  }));
};

TranslationOutlined.displayName = 'TranslationOutlined';
var TranslationOutlined$1 = /*#__PURE__*/React.forwardRef(TranslationOutlined);

// This icon file is generated automatically.
var TrophyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z" } }] }, "name": "trophy", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TrophyFilled = function TrophyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrophyFilled$2
  }));
};

TrophyFilled.displayName = 'TrophyFilled';
var TrophyFilled$1 = /*#__PURE__*/React.forwardRef(TrophyFilled);

// This icon file is generated automatically.
var TrophyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM184 352V232h64v207.6a91.99 91.99 0 01-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z" } }] }, "name": "trophy", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TrophyOutlined = function TrophyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrophyOutlined$2
  }));
};

TrophyOutlined.displayName = 'TrophyOutlined';
var TrophyOutlined$1 = /*#__PURE__*/React.forwardRef(TrophyOutlined);

// This icon file is generated automatically.
var TrophyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6a91.99 91.99 0 01-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z", "fill": primaryColor } }] }; }, "name": "trophy", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TrophyTwoTone$2
  }));
};

TrophyTwoTone.displayName = 'TrophyTwoTone';
var TrophyTwoTone$1 = /*#__PURE__*/React.forwardRef(TrophyTwoTone);

// This icon file is generated automatically.
var TwitterCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] }, "name": "twitter-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TwitterCircleFilled$2
  }));
};

TwitterCircleFilled.displayName = 'TwitterCircleFilled';
var TwitterCircleFilled$1 = /*#__PURE__*/React.forwardRef(TwitterCircleFilled);

// This icon file is generated automatically.
var TwitterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0075-94 336.64 336.64 0 01-108.2 41.2A170.1 170.1 0 00672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 00-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 01-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 01-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" } }] }, "name": "twitter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TwitterOutlined = function TwitterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TwitterOutlined$2
  }));
};

TwitterOutlined.displayName = 'TwitterOutlined';
var TwitterOutlined$1 = /*#__PURE__*/React.forwardRef(TwitterOutlined);

// This icon file is generated automatically.
var TwitterSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] }, "name": "twitter-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: TwitterSquareFilled$2
  }));
};

TwitterSquareFilled.displayName = 'TwitterSquareFilled';
var TwitterSquareFilled$1 = /*#__PURE__*/React.forwardRef(TwitterSquareFilled);

// This icon file is generated automatically.
var UnderlineOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z" } }] }, "name": "underline", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UnderlineOutlined$2
  }));
};

UnderlineOutlined.displayName = 'UnderlineOutlined';
var UnderlineOutlined$1 = /*#__PURE__*/React.forwardRef(UnderlineOutlined);

// This icon file is generated automatically.
var UndoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z" } }] }, "name": "undo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UndoOutlined = function UndoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UndoOutlined$2
  }));
};

UndoOutlined.displayName = 'UndoOutlined';
var UndoOutlined$1 = /*#__PURE__*/React.forwardRef(UndoOutlined);

// This icon file is generated automatically.
var UngroupOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208 130c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208-194c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72zm0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0 656c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }] }, "name": "ungroup", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UngroupOutlined = function UngroupOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UngroupOutlined$2
  }));
};

UngroupOutlined.displayName = 'UngroupOutlined';
var UngroupOutlined$1 = /*#__PURE__*/React.forwardRef(UngroupOutlined);

// This icon file is generated automatically.
var UnlockFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0z" } }] }, "name": "unlock", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UnlockFilled = function UnlockFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UnlockFilled$2
  }));
};

UnlockFilled.displayName = 'UnlockFilled';
var UnlockFilled$1 = /*#__PURE__*/React.forwardRef(UnlockFilled);

// This icon file is generated automatically.
var UnlockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "unlock", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UnlockOutlined = function UnlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UnlockOutlined$2
  }));
};

UnlockOutlined.displayName = 'UnlockOutlined';
var UnlockOutlined$1 = /*#__PURE__*/React.forwardRef(UnlockOutlined);

// This icon file is generated automatically.
var UnlockTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z", "fill": primaryColor } }] }; }, "name": "unlock", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UnlockTwoTone$2
  }));
};

UnlockTwoTone.displayName = 'UnlockTwoTone';
var UnlockTwoTone$1 = /*#__PURE__*/React.forwardRef(UnlockTwoTone);

// This icon file is generated automatically.
var UnorderedListOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "unordered-list", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UnorderedListOutlined$2
  }));
};

UnorderedListOutlined.displayName = 'UnorderedListOutlined';
var UnorderedListOutlined$1 = /*#__PURE__*/React.forwardRef(UnorderedListOutlined);

// This icon file is generated automatically.
var UpCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] }, "name": "up-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UpCircleFilled = function UpCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleFilled$2
  }));
};

UpCircleFilled.displayName = 'UpCircleFilled';
var UpCircleFilled$1 = /*#__PURE__*/React.forwardRef(UpCircleFilled);

// This icon file is generated automatically.
var UpCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.5 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "up-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleOutlined$2
  }));
};

UpCircleOutlined.displayName = 'UpCircleOutlined';
var UpCircleOutlined$1 = /*#__PURE__*/React.forwardRef(UpCircleOutlined);

// This icon file is generated automatically.
var UpCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M518.4 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z", "fill": primaryColor } }] }; }, "name": "up-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleTwoTone$2
  }));
};

UpCircleTwoTone.displayName = 'UpCircleTwoTone';
var UpCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(UpCircleTwoTone);

// This icon file is generated automatically.
var UpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpOutlined$2
  }));
};

UpOutlined.displayName = 'UpOutlined';
var UpOutlined$1 = /*#__PURE__*/React.forwardRef(UpOutlined);

// This icon file is generated automatically.
var UpSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] }, "name": "up-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UpSquareFilled = function UpSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareFilled$2
  }));
};

UpSquareFilled.displayName = 'UpSquareFilled';
var UpSquareFilled$1 = /*#__PURE__*/React.forwardRef(UpSquareFilled);

// This icon file is generated automatically.
var UpSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246A7.96 7.96 0 00334 624z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "up-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareOutlined$2
  }));
};

UpSquareOutlined.displayName = 'UpSquareOutlined';
var UpSquareOutlined$1 = /*#__PURE__*/React.forwardRef(UpSquareOutlined);

// This icon file is generated automatically.
var UpSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z", "fill": primaryColor } }] }; }, "name": "up-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareTwoTone$2
  }));
};

UpSquareTwoTone.displayName = 'UpSquareTwoTone';
var UpSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(UpSquareTwoTone);

// This icon file is generated automatically.
var UploadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "upload", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UploadOutlined = function UploadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UploadOutlined$2
  }));
};

UploadOutlined.displayName = 'UploadOutlined';
var UploadOutlined$1 = /*#__PURE__*/React.forwardRef(UploadOutlined);

// This icon file is generated automatically.
var UsbFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "usb", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UsbFilled = function UsbFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UsbFilled$2
  }));
};

UsbFilled.displayName = 'UsbFilled';
var UsbFilled$1 = /*#__PURE__*/React.forwardRef(UsbFilled);

// This icon file is generated automatically.
var UsbOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "usb", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UsbOutlined = function UsbOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UsbOutlined$2
  }));
};

UsbOutlined.displayName = 'UsbOutlined';
var UsbOutlined$1 = /*#__PURE__*/React.forwardRef(UsbOutlined);

// This icon file is generated automatically.
var UsbTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z", "fill": primaryColor } }] }; }, "name": "usb", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UsbTwoTone = function UsbTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UsbTwoTone$2
  }));
};

UsbTwoTone.displayName = 'UsbTwoTone';
var UsbTwoTone$1 = /*#__PURE__*/React.forwardRef(UsbTwoTone);

// This icon file is generated automatically.
var UserAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "user-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserAddOutlined = function UserAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UserAddOutlined$2
  }));
};

UserAddOutlined.displayName = 'UserAddOutlined';
var UserAddOutlined$1 = /*#__PURE__*/React.forwardRef(UserAddOutlined);

// This icon file is generated automatically.
var UserDeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 901.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "user-delete", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserDeleteOutlined = function UserDeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UserDeleteOutlined$2
  }));
};

UserDeleteOutlined.displayName = 'UserDeleteOutlined';
var UserDeleteOutlined$1 = /*#__PURE__*/React.forwardRef(UserDeleteOutlined);

// This icon file is generated automatically.
var UserOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" } }] }, "name": "user", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserOutlined = function UserOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UserOutlined$2
  }));
};

UserOutlined.displayName = 'UserOutlined';
var UserOutlined$1 = /*#__PURE__*/React.forwardRef(UserOutlined);

// This icon file is generated automatically.
var UserSwitchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-.4.2-.7.3-.9.4-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00136 874.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zm105 221h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1a8.1 8.1 0 001.7-4.9c0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8.1 17.7 14.4 32 32.1 32zm240 64H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1a8.1 8.1 0 00-1.7 4.9c0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-.1-17.7-14.4-32-32.1-32z" } }] }, "name": "user-switch", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UserSwitchOutlined$2
  }));
};

UserSwitchOutlined.displayName = 'UserSwitchOutlined';
var UserSwitchOutlined$1 = /*#__PURE__*/React.forwardRef(UserSwitchOutlined);

// This icon file is generated automatically.
var UsergroupAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] }, "name": "usergroup-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupAddOutlined$2
  }));
};

UsergroupAddOutlined.displayName = 'UsergroupAddOutlined';
var UsergroupAddOutlined$1 = /*#__PURE__*/React.forwardRef(UsergroupAddOutlined);

// This icon file is generated automatically.
var UsergroupDeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] }, "name": "usergroup-delete", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupDeleteOutlined$2
  }));
};

UsergroupDeleteOutlined.displayName = 'UsergroupDeleteOutlined';
var UsergroupDeleteOutlined$1 = /*#__PURE__*/React.forwardRef(UsergroupDeleteOutlined);

// This icon file is generated automatically.
var VerifiedOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M447.8 588.8l-7.3-32.5c-.2-1-.6-1.9-1.1-2.7a7.94 7.94 0 00-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4a8 8 0 0012.7 6.5l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zm-56.7-216.6l.2.2c3.2 3 8.3 2.8 11.3-.5l24.1-26.2a8.1 8.1 0 00-.3-11.2l-53.7-52.1a8 8 0 00-11.2.1l-24.7 24.7c-3.1 3.1-3.1 8.2.1 11.3l54.2 53.7z" } }, { "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }, { "tag": "path", "attrs": { "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z" } }] }, "name": "verified", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VerifiedOutlined$2
  }));
};

VerifiedOutlined.displayName = 'VerifiedOutlined';
var VerifiedOutlined$1 = /*#__PURE__*/React.forwardRef(VerifiedOutlined);

// This icon file is generated automatically.
var VerticalAlignBottomOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" } }] }, "name": "vertical-align-bottom", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignBottomOutlined$2
  }));
};

VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
var VerticalAlignBottomOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalAlignBottomOutlined);

// This icon file is generated automatically.
var VerticalAlignMiddleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 00-11.3 0L405.6 752.3a7.23 7.23 0 005.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z" } }] }, "name": "vertical-align-middle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalAlignMiddleOutlined = function VerticalAlignMiddleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignMiddleOutlined$2
  }));
};

VerticalAlignMiddleOutlined.displayName = 'VerticalAlignMiddleOutlined';
var VerticalAlignMiddleOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalAlignMiddleOutlined);

// This icon file is generated automatically.
var VerticalAlignTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z" } }] }, "name": "vertical-align-top", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlined$2
  }));
};

VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
var VerticalAlignTopOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalAlignTopOutlined);

// This icon file is generated automatically.
var VerticalLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 00254 164z" } }] }, "name": "vertical-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VerticalLeftOutlined$2
  }));
};

VerticalLeftOutlined.displayName = 'VerticalLeftOutlined';
var VerticalLeftOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalLeftOutlined);

// This icon file is generated automatically.
var VerticalRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z" } }] }, "name": "vertical-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VerticalRightOutlined$2
  }));
};

VerticalRightOutlined.displayName = 'VerticalRightOutlined';
var VerticalRightOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalRightOutlined);

// This icon file is generated automatically.
var VideoCameraAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z" } }, { "tag": "path", "attrs": { "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z" } }] }, "name": "video-camera-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraAddOutlined = function VideoCameraAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraAddOutlined$2
  }));
};

VideoCameraAddOutlined.displayName = 'VideoCameraAddOutlined';
var VideoCameraAddOutlined$1 = /*#__PURE__*/React.forwardRef(VideoCameraAddOutlined);

// This icon file is generated automatically.
var VideoCameraFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z" } }] }, "name": "video-camera", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraFilled$2
  }));
};

VideoCameraFilled.displayName = 'VideoCameraFilled';
var VideoCameraFilled$1 = /*#__PURE__*/React.forwardRef(VideoCameraFilled);

// This icon file is generated automatically.
var VideoCameraOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "video-camera", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraOutlined$2
  }));
};

VideoCameraOutlined.displayName = 'VideoCameraOutlined';
var VideoCameraOutlined$1 = /*#__PURE__*/React.forwardRef(VideoCameraOutlined);

// This icon file is generated automatically.
var VideoCameraTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "video-camera", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraTwoTone = function VideoCameraTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraTwoTone$2
  }));
};

VideoCameraTwoTone.displayName = 'VideoCameraTwoTone';
var VideoCameraTwoTone$1 = /*#__PURE__*/React.forwardRef(VideoCameraTwoTone);

// This icon file is generated automatically.
var WalletFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "wallet", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WalletFilled = function WalletFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WalletFilled$2
  }));
};

WalletFilled.displayName = 'WalletFilled';
var WalletFilled$1 = /*#__PURE__*/React.forwardRef(WalletFilled);

// This icon file is generated automatically.
var WalletOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "wallet", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WalletOutlined = function WalletOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WalletOutlined$2
  }));
};

WalletOutlined.displayName = 'WalletOutlined';
var WalletOutlined$1 = /*#__PURE__*/React.forwardRef(WalletOutlined);

// This icon file is generated automatically.
var WalletTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M580 512a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z", "fill": secondaryColor } }] }; }, "name": "wallet", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var WalletTwoTone = function WalletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WalletTwoTone$2
  }));
};

WalletTwoTone.displayName = 'WalletTwoTone';
var WalletTwoTone$1 = /*#__PURE__*/React.forwardRef(WalletTwoTone);

// This icon file is generated automatically.
var WarningFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WarningFilled = function WarningFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WarningFilled$2
  }));
};

WarningFilled.displayName = 'WarningFilled';
var WarningFilled$1 = /*#__PURE__*/React.forwardRef(WarningFilled);

// This icon file is generated automatically.
var WarningOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z" } }] }, "name": "warning", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WarningOutlined = function WarningOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WarningOutlined$2
  }));
};

WarningOutlined.displayName = 'WarningOutlined';
var WarningOutlined$1 = /*#__PURE__*/React.forwardRef(WarningOutlined);

// This icon file is generated automatically.
var WarningTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }] }; }, "name": "warning", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var WarningTwoTone = function WarningTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WarningTwoTone$2
  }));
};

WarningTwoTone.displayName = 'WarningTwoTone';
var WarningTwoTone$1 = /*#__PURE__*/React.forwardRef(WarningTwoTone);

// This icon file is generated automatically.
var WechatFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] }, "name": "wechat", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WechatFilled = function WechatFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WechatFilled$2
  }));
};

WechatFilled.displayName = 'WechatFilled';
var WechatFilled$1 = /*#__PURE__*/React.forwardRef(WechatFilled);

// This icon file is generated automatically.
var WechatOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] }, "name": "wechat", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WechatOutlined = function WechatOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WechatOutlined$2
  }));
};

WechatOutlined.displayName = 'WechatOutlined';
var WechatOutlined$1 = /*#__PURE__*/React.forwardRef(WechatOutlined);

// This icon file is generated automatically.
var WeiboCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleFilled$2
  }));
};

WeiboCircleFilled.displayName = 'WeiboCircleFilled';
var WeiboCircleFilled$1 = /*#__PURE__*/React.forwardRef(WeiboCircleFilled);

// This icon file is generated automatically.
var WeiboCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleOutlined$2
  }));
};

WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
var WeiboCircleOutlined$1 = /*#__PURE__*/React.forwardRef(WeiboCircleOutlined);

// This icon file is generated automatically.
var WeiboOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 00-106-34.3 28.45 28.45 0 00-21.9 33.8 28.39 28.39 0 0033.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0111.3 53.3 28.45 28.45 0 0018.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 00-25.4 39.3 33.12 33.12 0 0039.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z" } }] }, "name": "weibo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WeiboOutlined = function WeiboOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WeiboOutlined$2
  }));
};

WeiboOutlined.displayName = 'WeiboOutlined';
var WeiboOutlined$1 = /*#__PURE__*/React.forwardRef(WeiboOutlined);

// This icon file is generated automatically.
var WeiboSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WeiboSquareFilled = function WeiboSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareFilled$2
  }));
};

WeiboSquareFilled.displayName = 'WeiboSquareFilled';
var WeiboSquareFilled$1 = /*#__PURE__*/React.forwardRef(WeiboSquareFilled);

// This icon file is generated automatically.
var WeiboSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WeiboSquareOutlined = function WeiboSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareOutlined$2
  }));
};

WeiboSquareOutlined.displayName = 'WeiboSquareOutlined';
var WeiboSquareOutlined$1 = /*#__PURE__*/React.forwardRef(WeiboSquareOutlined);

// This icon file is generated automatically.
var WhatsAppOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-.4-13.7-.4-21.1-.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z" } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] }, "name": "whats-app", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WhatsAppOutlined = function WhatsAppOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WhatsAppOutlined$2
  }));
};

WhatsAppOutlined.displayName = 'WhatsAppOutlined';
var WhatsAppOutlined$1 = /*#__PURE__*/React.forwardRef(WhatsAppOutlined);

// This icon file is generated automatically.
var WifiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 00-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 00-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 00-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 10128 0 64 64 0 10-128 0z" } }] }, "name": "wifi", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WifiOutlined = function WifiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WifiOutlined$2
  }));
};

WifiOutlined.displayName = 'WifiOutlined';
var WifiOutlined$1 = /*#__PURE__*/React.forwardRef(WifiOutlined);

// This icon file is generated automatically.
var WindowsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z" } }] }, "name": "windows", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WindowsFilled = function WindowsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WindowsFilled$2
  }));
};

WindowsFilled.displayName = 'WindowsFilled';
var WindowsFilled$1 = /*#__PURE__*/React.forwardRef(WindowsFilled);

// This icon file is generated automatically.
var WindowsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z" } }] }, "name": "windows", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WindowsOutlined = function WindowsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WindowsOutlined$2
  }));
};

WindowsOutlined.displayName = 'WindowsOutlined';
var WindowsOutlined$1 = /*#__PURE__*/React.forwardRef(WindowsOutlined);

// This icon file is generated automatically.
var WomanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z" } }] }, "name": "woman", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WomanOutlined = function WomanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: WomanOutlined$2
  }));
};

WomanOutlined.displayName = 'WomanOutlined';
var WomanOutlined$1 = /*#__PURE__*/React.forwardRef(WomanOutlined);

// This icon file is generated automatically.
var YahooFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z" } }] }, "name": "yahoo", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var YahooFilled = function YahooFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: YahooFilled$2
  }));
};

YahooFilled.displayName = 'YahooFilled';
var YahooFilled$1 = /*#__PURE__*/React.forwardRef(YahooFilled);

// This icon file is generated automatically.
var YahooOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z" } }] }, "name": "yahoo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var YahooOutlined = function YahooOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: YahooOutlined$2
  }));
};

YahooOutlined.displayName = 'YahooOutlined';
var YahooOutlined$1 = /*#__PURE__*/React.forwardRef(YahooOutlined);

// This icon file is generated automatically.
var YoutubeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M941.3 296.1a112.3 112.3 0 00-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0082.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z" } }] }, "name": "youtube", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var YoutubeFilled = function YoutubeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeFilled$2
  }));
};

YoutubeFilled.displayName = 'YoutubeFilled';
var YoutubeFilled$1 = /*#__PURE__*/React.forwardRef(YoutubeFilled);

// This icon file is generated automatically.
var YoutubeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 00-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0082.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z" } }] }, "name": "youtube", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var YoutubeOutlined = function YoutubeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeOutlined$2
  }));
};

YoutubeOutlined.displayName = 'YoutubeOutlined';
var YoutubeOutlined$1 = /*#__PURE__*/React.forwardRef(YoutubeOutlined);

// This icon file is generated automatically.
var YuqueFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z" } }] }, "name": "yuque", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var YuqueFilled = function YuqueFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: YuqueFilled$2
  }));
};

YuqueFilled.displayName = 'YuqueFilled';
var YuqueFilled$1 = /*#__PURE__*/React.forwardRef(YuqueFilled);

// This icon file is generated automatically.
var YuqueOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z" } }] }, "name": "yuque", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var YuqueOutlined = function YuqueOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: YuqueOutlined$2
  }));
};

YuqueOutlined.displayName = 'YuqueOutlined';
var YuqueOutlined$1 = /*#__PURE__*/React.forwardRef(YuqueOutlined);

// This icon file is generated automatically.
var ZhihuCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] }, "name": "zhihu-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ZhihuCircleFilled = function ZhihuCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuCircleFilled$2
  }));
};

ZhihuCircleFilled.displayName = 'ZhihuCircleFilled';
var ZhihuCircleFilled$1 = /*#__PURE__*/React.forwardRef(ZhihuCircleFilled);

// This icon file is generated automatically.
var ZhihuOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z" } }] }, "name": "zhihu", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuOutlined$2
  }));
};

ZhihuOutlined.displayName = 'ZhihuOutlined';
var ZhihuOutlined$1 = /*#__PURE__*/React.forwardRef(ZhihuOutlined);

// This icon file is generated automatically.
var ZhihuSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] }, "name": "zhihu-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuSquareFilled$2
  }));
};

ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
var ZhihuSquareFilled$1 = /*#__PURE__*/React.forwardRef(ZhihuSquareFilled);

// This icon file is generated automatically.
var ZoomInOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ZoomInOutlined$2
  }));
};

ZoomInOutlined.displayName = 'ZoomInOutlined';
var ZoomInOutlined$1 = /*#__PURE__*/React.forwardRef(ZoomInOutlined);

// This icon file is generated automatically.
var ZoomOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$4, Object.assign({}, props, {
    ref: ref,
    icon: ZoomOutOutlined$2
  }));
};

ZoomOutOutlined.displayName = 'ZoomOutOutlined';
var ZoomOutOutlined$1 = /*#__PURE__*/React.forwardRef(ZoomOutOutlined);

// GENERATE BY ./scripts/generate.ts

var allIcons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccountBookFilled: AccountBookFilled$1,
  AccountBookOutlined: AccountBookOutlined$1,
  AccountBookTwoTone: AccountBookTwoTone$1,
  AimOutlined: AimOutlined$1,
  AlertFilled: AlertFilled$1,
  AlertOutlined: AlertOutlined$1,
  AlertTwoTone: AlertTwoTone$1,
  AlibabaOutlined: AlibabaOutlined$1,
  AlignCenterOutlined: AlignCenterOutlined$1,
  AlignLeftOutlined: AlignLeftOutlined$1,
  AlignRightOutlined: AlignRightOutlined$1,
  AlipayCircleFilled: AlipayCircleFilled$1,
  AlipayCircleOutlined: AlipayCircleOutlined$1,
  AlipayOutlined: AlipayOutlined$1,
  AlipaySquareFilled: AlipaySquareFilled$1,
  AliwangwangFilled: AliwangwangFilled$1,
  AliwangwangOutlined: AliwangwangOutlined$1,
  AliyunOutlined: AliyunOutlined$1,
  AmazonCircleFilled: AmazonCircleFilled$1,
  AmazonOutlined: AmazonOutlined$1,
  AmazonSquareFilled: AmazonSquareFilled$1,
  AndroidFilled: AndroidFilled$1,
  AndroidOutlined: AndroidOutlined$1,
  AntCloudOutlined: AntCloudOutlined$1,
  AntDesignOutlined: AntDesignOutlined$1,
  ApartmentOutlined: ApartmentOutlined$1,
  ApiFilled: ApiFilled$1,
  ApiOutlined: ApiOutlined$1,
  ApiTwoTone: ApiTwoTone$1,
  AppleFilled: AppleFilled$1,
  AppleOutlined: AppleOutlined$1,
  AppstoreAddOutlined: AppstoreAddOutlined$1,
  AppstoreFilled: AppstoreFilled$1,
  AppstoreOutlined: AppstoreOutlined$1,
  AppstoreTwoTone: AppstoreTwoTone$1,
  AreaChartOutlined: AreaChartOutlined$1,
  ArrowDownOutlined: ArrowDownOutlined$1,
  ArrowLeftOutlined: ArrowLeftOutlined$1,
  ArrowRightOutlined: ArrowRightOutlined$1,
  ArrowUpOutlined: ArrowUpOutlined$1,
  ArrowsAltOutlined: ArrowsAltOutlined$1,
  AudioFilled: AudioFilled$1,
  AudioMutedOutlined: AudioMutedOutlined$1,
  AudioOutlined: AudioOutlined$1,
  AudioTwoTone: AudioTwoTone$1,
  AuditOutlined: AuditOutlined$1,
  BackwardFilled: BackwardFilled$1,
  BackwardOutlined: BackwardOutlined$1,
  BankFilled: BankFilled$1,
  BankOutlined: BankOutlined$1,
  BankTwoTone: BankTwoTone$1,
  BarChartOutlined: BarChartOutlined$1,
  BarcodeOutlined: BarcodeOutlined$1,
  BarsOutlined: BarsOutlined$1,
  BehanceCircleFilled: BehanceCircleFilled$1,
  BehanceOutlined: BehanceOutlined$1,
  BehanceSquareFilled: BehanceSquareFilled$1,
  BehanceSquareOutlined: BehanceSquareOutlined$1,
  BellFilled: BellFilled$1,
  BellOutlined: BellOutlined$1,
  BellTwoTone: BellTwoTone$1,
  BgColorsOutlined: BgColorsOutlined$1,
  BlockOutlined: BlockOutlined$1,
  BoldOutlined: BoldOutlined$1,
  BookFilled: BookFilled$1,
  BookOutlined: BookOutlined$1,
  BookTwoTone: BookTwoTone$1,
  BorderBottomOutlined: BorderBottomOutlined$1,
  BorderHorizontalOutlined: BorderHorizontalOutlined$1,
  BorderInnerOutlined: BorderInnerOutlined$1,
  BorderLeftOutlined: BorderLeftOutlined$1,
  BorderOuterOutlined: BorderOuterOutlined$1,
  BorderOutlined: BorderOutlined$1,
  BorderRightOutlined: BorderRightOutlined$1,
  BorderTopOutlined: BorderTopOutlined$1,
  BorderVerticleOutlined: BorderVerticleOutlined$1,
  BorderlessTableOutlined: BorderlessTableOutlined$1,
  BoxPlotFilled: BoxPlotFilled$1,
  BoxPlotOutlined: BoxPlotOutlined$1,
  BoxPlotTwoTone: BoxPlotTwoTone$1,
  BranchesOutlined: BranchesOutlined$1,
  BugFilled: BugFilled$1,
  BugOutlined: BugOutlined$1,
  BugTwoTone: BugTwoTone$1,
  BuildFilled: BuildFilled$1,
  BuildOutlined: BuildOutlined$1,
  BuildTwoTone: BuildTwoTone$1,
  BulbFilled: BulbFilled$1,
  BulbOutlined: BulbOutlined$1,
  BulbTwoTone: BulbTwoTone$1,
  CalculatorFilled: CalculatorFilled$1,
  CalculatorOutlined: CalculatorOutlined$1,
  CalculatorTwoTone: CalculatorTwoTone$1,
  CalendarFilled: CalendarFilled$1,
  CalendarOutlined: CalendarOutlined$1,
  CalendarTwoTone: CalendarTwoTone$1,
  CameraFilled: CameraFilled$1,
  CameraOutlined: CameraOutlined$1,
  CameraTwoTone: CameraTwoTone$1,
  CarFilled: CarFilled$1,
  CarOutlined: CarOutlined$1,
  CarTwoTone: CarTwoTone$1,
  CaretDownFilled: CaretDownFilled$1,
  CaretDownOutlined: CaretDownOutlined$1,
  CaretLeftFilled: CaretLeftFilled$1,
  CaretLeftOutlined: CaretLeftOutlined$1,
  CaretRightFilled: CaretRightFilled$1,
  CaretRightOutlined: CaretRightOutlined$1,
  CaretUpFilled: CaretUpFilled$1,
  CaretUpOutlined: CaretUpOutlined$1,
  CarryOutFilled: CarryOutFilled$1,
  CarryOutOutlined: CarryOutOutlined$1,
  CarryOutTwoTone: CarryOutTwoTone$1,
  CheckCircleFilled: CheckCircleFilled$1,
  CheckCircleOutlined: CheckCircleOutlined$1,
  CheckCircleTwoTone: CheckCircleTwoTone$1,
  CheckOutlined: CheckOutlined$1,
  CheckSquareFilled: CheckSquareFilled$1,
  CheckSquareOutlined: CheckSquareOutlined$1,
  CheckSquareTwoTone: CheckSquareTwoTone$1,
  ChromeFilled: ChromeFilled$1,
  ChromeOutlined: ChromeOutlined$1,
  CiCircleFilled: CiCircleFilled$1,
  CiCircleOutlined: CiCircleOutlined$1,
  CiCircleTwoTone: CiCircleTwoTone$1,
  CiOutlined: CiOutlined$1,
  CiTwoTone: CiTwoTone$1,
  ClearOutlined: ClearOutlined$1,
  ClockCircleFilled: ClockCircleFilled$1,
  ClockCircleOutlined: ClockCircleOutlined$1,
  ClockCircleTwoTone: ClockCircleTwoTone$1,
  CloseCircleFilled: CloseCircleFilled$1,
  CloseCircleOutlined: CloseCircleOutlined$1,
  CloseCircleTwoTone: CloseCircleTwoTone$1,
  CloseOutlined: CloseOutlined$1,
  CloseSquareFilled: CloseSquareFilled$1,
  CloseSquareOutlined: CloseSquareOutlined$1,
  CloseSquareTwoTone: CloseSquareTwoTone$1,
  CloudDownloadOutlined: CloudDownloadOutlined$1,
  CloudFilled: CloudFilled$1,
  CloudOutlined: CloudOutlined$1,
  CloudServerOutlined: CloudServerOutlined$1,
  CloudSyncOutlined: CloudSyncOutlined$1,
  CloudTwoTone: CloudTwoTone$1,
  CloudUploadOutlined: CloudUploadOutlined$1,
  ClusterOutlined: ClusterOutlined$1,
  CodeFilled: CodeFilled$1,
  CodeOutlined: CodeOutlined$1,
  CodeSandboxCircleFilled: CodeSandboxCircleFilled$1,
  CodeSandboxOutlined: CodeSandboxOutlined$1,
  CodeSandboxSquareFilled: CodeSandboxSquareFilled$1,
  CodeTwoTone: CodeTwoTone$1,
  CodepenCircleFilled: CodepenCircleFilled$1,
  CodepenCircleOutlined: CodepenCircleOutlined$1,
  CodepenOutlined: CodepenOutlined$1,
  CodepenSquareFilled: CodepenSquareFilled$1,
  CoffeeOutlined: CoffeeOutlined$1,
  ColumnHeightOutlined: ColumnHeightOutlined$1,
  ColumnWidthOutlined: ColumnWidthOutlined$1,
  CommentOutlined: CommentOutlined$1,
  CompassFilled: CompassFilled$1,
  CompassOutlined: CompassOutlined$1,
  CompassTwoTone: CompassTwoTone$1,
  CompressOutlined: CompressOutlined$1,
  ConsoleSqlOutlined: ConsoleSqlOutlined$1,
  ContactsFilled: ContactsFilled$1,
  ContactsOutlined: ContactsOutlined$1,
  ContactsTwoTone: ContactsTwoTone$1,
  ContainerFilled: ContainerFilled$1,
  ContainerOutlined: ContainerOutlined$1,
  ContainerTwoTone: ContainerTwoTone$1,
  ControlFilled: ControlFilled$1,
  ControlOutlined: ControlOutlined$1,
  ControlTwoTone: ControlTwoTone$1,
  CopyFilled: CopyFilled$1,
  CopyOutlined: CopyOutlined$1,
  CopyTwoTone: CopyTwoTone$1,
  CopyrightCircleFilled: CopyrightCircleFilled$1,
  CopyrightCircleOutlined: CopyrightCircleOutlined$1,
  CopyrightCircleTwoTone: CopyrightCircleTwoTone$1,
  CopyrightOutlined: CopyrightOutlined$1,
  CopyrightTwoTone: CopyrightTwoTone$1,
  CreditCardFilled: CreditCardFilled$1,
  CreditCardOutlined: CreditCardOutlined$1,
  CreditCardTwoTone: CreditCardTwoTone$1,
  CrownFilled: CrownFilled$1,
  CrownOutlined: CrownOutlined$1,
  CrownTwoTone: CrownTwoTone$1,
  CustomerServiceFilled: CustomerServiceFilled$1,
  CustomerServiceOutlined: CustomerServiceOutlined$1,
  CustomerServiceTwoTone: CustomerServiceTwoTone$1,
  DashOutlined: DashOutlined$1,
  DashboardFilled: DashboardFilled$1,
  DashboardOutlined: DashboardOutlined$1,
  DashboardTwoTone: DashboardTwoTone$1,
  DatabaseFilled: DatabaseFilled$1,
  DatabaseOutlined: DatabaseOutlined$1,
  DatabaseTwoTone: DatabaseTwoTone$1,
  DeleteColumnOutlined: DeleteColumnOutlined$1,
  DeleteFilled: DeleteFilled$1,
  DeleteOutlined: DeleteOutlined$1,
  DeleteRowOutlined: DeleteRowOutlined$1,
  DeleteTwoTone: DeleteTwoTone$1,
  DeliveredProcedureOutlined: DeliveredProcedureOutlined$1,
  DeploymentUnitOutlined: DeploymentUnitOutlined$1,
  DesktopOutlined: DesktopOutlined$1,
  DiffFilled: DiffFilled$1,
  DiffOutlined: DiffOutlined$1,
  DiffTwoTone: DiffTwoTone$1,
  DingdingOutlined: DingdingOutlined$1,
  DingtalkCircleFilled: DingtalkCircleFilled$1,
  DingtalkOutlined: DingtalkOutlined$1,
  DingtalkSquareFilled: DingtalkSquareFilled$1,
  DisconnectOutlined: DisconnectOutlined$1,
  DislikeFilled: DislikeFilled$1,
  DislikeOutlined: DislikeOutlined$1,
  DislikeTwoTone: DislikeTwoTone$1,
  DollarCircleFilled: DollarCircleFilled$1,
  DollarCircleOutlined: DollarCircleOutlined$1,
  DollarCircleTwoTone: DollarCircleTwoTone$1,
  DollarOutlined: DollarOutlined$1,
  DollarTwoTone: DollarTwoTone$1,
  DotChartOutlined: DotChartOutlined$1,
  DoubleLeftOutlined: DoubleLeftOutlined$1,
  DoubleRightOutlined: DoubleRightOutlined$1,
  DownCircleFilled: DownCircleFilled$1,
  DownCircleOutlined: DownCircleOutlined$1,
  DownCircleTwoTone: DownCircleTwoTone$1,
  DownOutlined: DownOutlined$1,
  DownSquareFilled: DownSquareFilled$1,
  DownSquareOutlined: DownSquareOutlined$1,
  DownSquareTwoTone: DownSquareTwoTone$1,
  DownloadOutlined: DownloadOutlined$1,
  DragOutlined: DragOutlined$1,
  DribbbleCircleFilled: DribbbleCircleFilled$1,
  DribbbleOutlined: DribbbleOutlined$1,
  DribbbleSquareFilled: DribbbleSquareFilled$1,
  DribbbleSquareOutlined: DribbbleSquareOutlined$1,
  DropboxCircleFilled: DropboxCircleFilled$1,
  DropboxOutlined: DropboxOutlined$1,
  DropboxSquareFilled: DropboxSquareFilled$1,
  EditFilled: EditFilled$1,
  EditOutlined: EditOutlined$1,
  EditTwoTone: EditTwoTone$1,
  EllipsisOutlined: EllipsisOutlined$1,
  EnterOutlined: EnterOutlined$1,
  EnvironmentFilled: EnvironmentFilled$1,
  EnvironmentOutlined: EnvironmentOutlined$1,
  EnvironmentTwoTone: EnvironmentTwoTone$1,
  EuroCircleFilled: EuroCircleFilled$1,
  EuroCircleOutlined: EuroCircleOutlined$1,
  EuroCircleTwoTone: EuroCircleTwoTone$1,
  EuroOutlined: EuroOutlined$1,
  EuroTwoTone: EuroTwoTone$1,
  ExceptionOutlined: ExceptionOutlined$1,
  ExclamationCircleFilled: ExclamationCircleFilled$1,
  ExclamationCircleOutlined: ExclamationCircleOutlined$1,
  ExclamationCircleTwoTone: ExclamationCircleTwoTone$1,
  ExclamationOutlined: ExclamationOutlined$1,
  ExpandAltOutlined: ExpandAltOutlined$1,
  ExpandOutlined: ExpandOutlined$1,
  ExperimentFilled: ExperimentFilled$1,
  ExperimentOutlined: ExperimentOutlined$1,
  ExperimentTwoTone: ExperimentTwoTone$1,
  ExportOutlined: ExportOutlined$1,
  EyeFilled: EyeFilled$1,
  EyeInvisibleFilled: EyeInvisibleFilled$1,
  EyeInvisibleOutlined: EyeInvisibleOutlined$1,
  EyeInvisibleTwoTone: EyeInvisibleTwoTone$1,
  EyeOutlined: EyeOutlined$1,
  EyeTwoTone: EyeTwoTone$1,
  FacebookFilled: FacebookFilled$1,
  FacebookOutlined: FacebookOutlined$1,
  FallOutlined: FallOutlined$1,
  FastBackwardFilled: FastBackwardFilled$1,
  FastBackwardOutlined: FastBackwardOutlined$1,
  FastForwardFilled: FastForwardFilled$1,
  FastForwardOutlined: FastForwardOutlined$1,
  FieldBinaryOutlined: FieldBinaryOutlined$1,
  FieldNumberOutlined: FieldNumberOutlined$1,
  FieldStringOutlined: FieldStringOutlined$1,
  FieldTimeOutlined: FieldTimeOutlined$1,
  FileAddFilled: FileAddFilled$1,
  FileAddOutlined: FileAddOutlined$1,
  FileAddTwoTone: FileAddTwoTone$1,
  FileDoneOutlined: FileDoneOutlined$1,
  FileExcelFilled: FileExcelFilled$1,
  FileExcelOutlined: FileExcelOutlined$1,
  FileExcelTwoTone: FileExcelTwoTone$1,
  FileExclamationFilled: FileExclamationFilled$1,
  FileExclamationOutlined: FileExclamationOutlined$1,
  FileExclamationTwoTone: FileExclamationTwoTone$1,
  FileFilled: FileFilled$1,
  FileGifOutlined: FileGifOutlined$1,
  FileImageFilled: FileImageFilled$1,
  FileImageOutlined: FileImageOutlined$1,
  FileImageTwoTone: FileImageTwoTone$1,
  FileJpgOutlined: FileJpgOutlined$1,
  FileMarkdownFilled: FileMarkdownFilled$1,
  FileMarkdownOutlined: FileMarkdownOutlined$1,
  FileMarkdownTwoTone: FileMarkdownTwoTone$1,
  FileOutlined: FileOutlined$1,
  FilePdfFilled: FilePdfFilled$1,
  FilePdfOutlined: FilePdfOutlined$1,
  FilePdfTwoTone: FilePdfTwoTone$1,
  FilePptFilled: FilePptFilled$1,
  FilePptOutlined: FilePptOutlined$1,
  FilePptTwoTone: FilePptTwoTone$1,
  FileProtectOutlined: FileProtectOutlined$1,
  FileSearchOutlined: FileSearchOutlined$1,
  FileSyncOutlined: FileSyncOutlined$1,
  FileTextFilled: FileTextFilled$1,
  FileTextOutlined: FileTextOutlined$1,
  FileTextTwoTone: FileTextTwoTone$1,
  FileTwoTone: FileTwoTone$1,
  FileUnknownFilled: FileUnknownFilled$1,
  FileUnknownOutlined: FileUnknownOutlined$1,
  FileUnknownTwoTone: FileUnknownTwoTone$1,
  FileWordFilled: FileWordFilled$1,
  FileWordOutlined: FileWordOutlined$1,
  FileWordTwoTone: FileWordTwoTone$1,
  FileZipFilled: FileZipFilled$1,
  FileZipOutlined: FileZipOutlined$1,
  FileZipTwoTone: FileZipTwoTone$1,
  FilterFilled: FilterFilled$1,
  FilterOutlined: FilterOutlined$1,
  FilterTwoTone: FilterTwoTone$1,
  FireFilled: FireFilled$1,
  FireOutlined: FireOutlined$1,
  FireTwoTone: FireTwoTone$1,
  FlagFilled: FlagFilled$1,
  FlagOutlined: FlagOutlined$1,
  FlagTwoTone: FlagTwoTone$1,
  FolderAddFilled: FolderAddFilled$1,
  FolderAddOutlined: FolderAddOutlined$1,
  FolderAddTwoTone: FolderAddTwoTone$1,
  FolderFilled: FolderFilled$1,
  FolderOpenFilled: FolderOpenFilled$1,
  FolderOpenOutlined: FolderOpenOutlined$1,
  FolderOpenTwoTone: FolderOpenTwoTone$1,
  FolderOutlined: FolderOutlined$1,
  FolderTwoTone: FolderTwoTone$1,
  FolderViewOutlined: FolderViewOutlined$1,
  FontColorsOutlined: FontColorsOutlined$1,
  FontSizeOutlined: FontSizeOutlined$1,
  ForkOutlined: ForkOutlined$1,
  FormOutlined: FormOutlined$1,
  FormatPainterFilled: FormatPainterFilled$1,
  FormatPainterOutlined: FormatPainterOutlined$1,
  ForwardFilled: ForwardFilled$1,
  ForwardOutlined: ForwardOutlined$1,
  FrownFilled: FrownFilled$1,
  FrownOutlined: FrownOutlined$1,
  FrownTwoTone: FrownTwoTone$1,
  FullscreenExitOutlined: FullscreenExitOutlined$1,
  FullscreenOutlined: FullscreenOutlined$1,
  FunctionOutlined: FunctionOutlined$1,
  FundFilled: FundFilled$1,
  FundOutlined: FundOutlined$1,
  FundProjectionScreenOutlined: FundProjectionScreenOutlined$1,
  FundTwoTone: FundTwoTone$1,
  FundViewOutlined: FundViewOutlined$1,
  FunnelPlotFilled: FunnelPlotFilled$1,
  FunnelPlotOutlined: FunnelPlotOutlined$1,
  FunnelPlotTwoTone: FunnelPlotTwoTone$1,
  GatewayOutlined: GatewayOutlined$1,
  GifOutlined: GifOutlined$1,
  GiftFilled: GiftFilled$1,
  GiftOutlined: GiftOutlined$1,
  GiftTwoTone: GiftTwoTone$1,
  GithubFilled: GithubFilled$1,
  GithubOutlined: GithubOutlined$1,
  GitlabFilled: GitlabFilled$1,
  GitlabOutlined: GitlabOutlined$1,
  GlobalOutlined: GlobalOutlined$1,
  GoldFilled: GoldFilled$1,
  GoldOutlined: GoldOutlined$1,
  GoldTwoTone: GoldTwoTone$1,
  GoldenFilled: GoldenFilled$1,
  GoogleCircleFilled: GoogleCircleFilled$1,
  GoogleOutlined: GoogleOutlined$1,
  GooglePlusCircleFilled: GooglePlusCircleFilled$1,
  GooglePlusOutlined: GooglePlusOutlined$1,
  GooglePlusSquareFilled: GooglePlusSquareFilled$1,
  GoogleSquareFilled: GoogleSquareFilled$1,
  GroupOutlined: GroupOutlined$1,
  HddFilled: HddFilled$1,
  HddOutlined: HddOutlined$1,
  HddTwoTone: HddTwoTone$1,
  HeartFilled: HeartFilled$1,
  HeartOutlined: HeartOutlined$1,
  HeartTwoTone: HeartTwoTone$1,
  HeatMapOutlined: HeatMapOutlined$1,
  HighlightFilled: HighlightFilled$1,
  HighlightOutlined: HighlightOutlined$1,
  HighlightTwoTone: HighlightTwoTone$1,
  HistoryOutlined: HistoryOutlined$1,
  HomeFilled: HomeFilled$1,
  HomeOutlined: HomeOutlined$1,
  HomeTwoTone: HomeTwoTone$1,
  HourglassFilled: HourglassFilled$1,
  HourglassOutlined: HourglassOutlined$1,
  HourglassTwoTone: HourglassTwoTone$1,
  Html5Filled: Html5Filled$1,
  Html5Outlined: Html5Outlined$1,
  Html5TwoTone: Html5TwoTone$1,
  IdcardFilled: IdcardFilled$1,
  IdcardOutlined: IdcardOutlined$1,
  IdcardTwoTone: IdcardTwoTone$1,
  IeCircleFilled: IeCircleFilled$1,
  IeOutlined: IeOutlined$1,
  IeSquareFilled: IeSquareFilled$1,
  ImportOutlined: ImportOutlined$1,
  InboxOutlined: InboxOutlined$1,
  InfoCircleFilled: InfoCircleFilled$1,
  InfoCircleOutlined: InfoCircleOutlined$1,
  InfoCircleTwoTone: InfoCircleTwoTone$1,
  InfoOutlined: InfoOutlined$1,
  InsertRowAboveOutlined: InsertRowAboveOutlined$1,
  InsertRowBelowOutlined: InsertRowBelowOutlined$1,
  InsertRowLeftOutlined: InsertRowLeftOutlined$1,
  InsertRowRightOutlined: InsertRowRightOutlined$1,
  InstagramFilled: InstagramFilled$1,
  InstagramOutlined: InstagramOutlined$1,
  InsuranceFilled: InsuranceFilled$1,
  InsuranceOutlined: InsuranceOutlined$1,
  InsuranceTwoTone: InsuranceTwoTone$1,
  InteractionFilled: InteractionFilled$1,
  InteractionOutlined: InteractionOutlined$1,
  InteractionTwoTone: InteractionTwoTone$1,
  IssuesCloseOutlined: IssuesCloseOutlined$1,
  ItalicOutlined: ItalicOutlined$1,
  KeyOutlined: KeyOutlined$1,
  LaptopOutlined: LaptopOutlined$1,
  LayoutFilled: LayoutFilled$1,
  LayoutOutlined: LayoutOutlined$1,
  LayoutTwoTone: LayoutTwoTone$1,
  LeftCircleFilled: LeftCircleFilled$1,
  LeftCircleOutlined: LeftCircleOutlined$1,
  LeftCircleTwoTone: LeftCircleTwoTone$1,
  LeftOutlined: LeftOutlined$1,
  LeftSquareFilled: LeftSquareFilled$1,
  LeftSquareOutlined: LeftSquareOutlined$1,
  LeftSquareTwoTone: LeftSquareTwoTone$1,
  LikeFilled: LikeFilled$1,
  LikeOutlined: LikeOutlined$1,
  LikeTwoTone: LikeTwoTone$1,
  LineChartOutlined: LineChartOutlined$1,
  LineHeightOutlined: LineHeightOutlined$1,
  LineOutlined: LineOutlined$1,
  LinkOutlined: LinkOutlined$1,
  LinkedinFilled: LinkedinFilled$1,
  LinkedinOutlined: LinkedinOutlined$1,
  Loading3QuartersOutlined: Loading3QuartersOutlined$1,
  LoadingOutlined: LoadingOutlined$1,
  LockFilled: LockFilled$1,
  LockOutlined: LockOutlined$1,
  LockTwoTone: LockTwoTone$1,
  LoginOutlined: LoginOutlined$1,
  LogoutOutlined: LogoutOutlined$1,
  MacCommandFilled: MacCommandFilled$1,
  MacCommandOutlined: MacCommandOutlined$1,
  MailFilled: MailFilled$1,
  MailOutlined: MailOutlined$1,
  MailTwoTone: MailTwoTone$1,
  ManOutlined: ManOutlined$1,
  MedicineBoxFilled: MedicineBoxFilled$1,
  MedicineBoxOutlined: MedicineBoxOutlined$1,
  MedicineBoxTwoTone: MedicineBoxTwoTone$1,
  MediumCircleFilled: MediumCircleFilled$1,
  MediumOutlined: MediumOutlined$1,
  MediumSquareFilled: MediumSquareFilled$1,
  MediumWorkmarkOutlined: MediumWorkmarkOutlined$1,
  MehFilled: MehFilled$1,
  MehOutlined: MehOutlined$1,
  MehTwoTone: MehTwoTone$1,
  MenuFoldOutlined: MenuFoldOutlined$1,
  MenuOutlined: MenuOutlined$1,
  MenuUnfoldOutlined: MenuUnfoldOutlined$1,
  MergeCellsOutlined: MergeCellsOutlined$1,
  MessageFilled: MessageFilled$1,
  MessageOutlined: MessageOutlined$1,
  MessageTwoTone: MessageTwoTone$1,
  MinusCircleFilled: MinusCircleFilled$1,
  MinusCircleOutlined: MinusCircleOutlined$1,
  MinusCircleTwoTone: MinusCircleTwoTone$1,
  MinusOutlined: MinusOutlined$1,
  MinusSquareFilled: MinusSquareFilled$1,
  MinusSquareOutlined: MinusSquareOutlined$1,
  MinusSquareTwoTone: MinusSquareTwoTone$1,
  MobileFilled: MobileFilled$1,
  MobileOutlined: MobileOutlined$1,
  MobileTwoTone: MobileTwoTone$1,
  MoneyCollectFilled: MoneyCollectFilled$1,
  MoneyCollectOutlined: MoneyCollectOutlined$1,
  MoneyCollectTwoTone: MoneyCollectTwoTone$1,
  MonitorOutlined: MonitorOutlined$1,
  MoreOutlined: MoreOutlined$1,
  NodeCollapseOutlined: NodeCollapseOutlined$1,
  NodeExpandOutlined: NodeExpandOutlined$1,
  NodeIndexOutlined: NodeIndexOutlined$1,
  NotificationFilled: NotificationFilled$1,
  NotificationOutlined: NotificationOutlined$1,
  NotificationTwoTone: NotificationTwoTone$1,
  NumberOutlined: NumberOutlined$1,
  OneToOneOutlined: OneToOneOutlined$1,
  OrderedListOutlined: OrderedListOutlined$1,
  PaperClipOutlined: PaperClipOutlined$1,
  PartitionOutlined: PartitionOutlined$1,
  PauseCircleFilled: PauseCircleFilled$1,
  PauseCircleOutlined: PauseCircleOutlined$1,
  PauseCircleTwoTone: PauseCircleTwoTone$1,
  PauseOutlined: PauseOutlined$1,
  PayCircleFilled: PayCircleFilled$1,
  PayCircleOutlined: PayCircleOutlined$1,
  PercentageOutlined: PercentageOutlined$1,
  PhoneFilled: PhoneFilled$1,
  PhoneOutlined: PhoneOutlined$1,
  PhoneTwoTone: PhoneTwoTone$1,
  PicCenterOutlined: PicCenterOutlined$1,
  PicLeftOutlined: PicLeftOutlined$1,
  PicRightOutlined: PicRightOutlined$1,
  PictureFilled: PictureFilled$1,
  PictureOutlined: PictureOutlined$1,
  PictureTwoTone: PictureTwoTone$1,
  PieChartFilled: PieChartFilled$1,
  PieChartOutlined: PieChartOutlined$1,
  PieChartTwoTone: PieChartTwoTone$1,
  PlayCircleFilled: PlayCircleFilled$1,
  PlayCircleOutlined: PlayCircleOutlined$1,
  PlayCircleTwoTone: PlayCircleTwoTone$1,
  PlaySquareFilled: PlaySquareFilled$1,
  PlaySquareOutlined: PlaySquareOutlined$1,
  PlaySquareTwoTone: PlaySquareTwoTone$1,
  PlusCircleFilled: PlusCircleFilled$1,
  PlusCircleOutlined: PlusCircleOutlined$1,
  PlusCircleTwoTone: PlusCircleTwoTone$1,
  PlusOutlined: PlusOutlined$1,
  PlusSquareFilled: PlusSquareFilled$1,
  PlusSquareOutlined: PlusSquareOutlined$1,
  PlusSquareTwoTone: PlusSquareTwoTone$1,
  PoundCircleFilled: PoundCircleFilled$1,
  PoundCircleOutlined: PoundCircleOutlined$1,
  PoundCircleTwoTone: PoundCircleTwoTone$1,
  PoundOutlined: PoundOutlined$1,
  PoweroffOutlined: PoweroffOutlined$1,
  PrinterFilled: PrinterFilled$1,
  PrinterOutlined: PrinterOutlined$1,
  PrinterTwoTone: PrinterTwoTone$1,
  ProfileFilled: ProfileFilled$1,
  ProfileOutlined: ProfileOutlined$1,
  ProfileTwoTone: ProfileTwoTone$1,
  ProjectFilled: ProjectFilled$1,
  ProjectOutlined: ProjectOutlined$1,
  ProjectTwoTone: ProjectTwoTone$1,
  PropertySafetyFilled: PropertySafetyFilled$1,
  PropertySafetyOutlined: PropertySafetyOutlined$1,
  PropertySafetyTwoTone: PropertySafetyTwoTone$1,
  PullRequestOutlined: PullRequestOutlined$1,
  PushpinFilled: PushpinFilled$1,
  PushpinOutlined: PushpinOutlined$1,
  PushpinTwoTone: PushpinTwoTone$1,
  QqCircleFilled: QqCircleFilled$1,
  QqOutlined: QqOutlined$1,
  QqSquareFilled: QqSquareFilled$1,
  QrcodeOutlined: QrcodeOutlined$1,
  QuestionCircleFilled: QuestionCircleFilled$1,
  QuestionCircleOutlined: QuestionCircleOutlined$1,
  QuestionCircleTwoTone: QuestionCircleTwoTone$1,
  QuestionOutlined: QuestionOutlined$1,
  RadarChartOutlined: RadarChartOutlined$1,
  RadiusBottomleftOutlined: RadiusBottomleftOutlined$1,
  RadiusBottomrightOutlined: RadiusBottomrightOutlined$1,
  RadiusSettingOutlined: RadiusSettingOutlined$1,
  RadiusUpleftOutlined: RadiusUpleftOutlined$1,
  RadiusUprightOutlined: RadiusUprightOutlined$1,
  ReadFilled: ReadFilled$1,
  ReadOutlined: ReadOutlined$1,
  ReconciliationFilled: ReconciliationFilled$1,
  ReconciliationOutlined: ReconciliationOutlined$1,
  ReconciliationTwoTone: ReconciliationTwoTone$1,
  RedEnvelopeFilled: RedEnvelopeFilled$1,
  RedEnvelopeOutlined: RedEnvelopeOutlined$1,
  RedEnvelopeTwoTone: RedEnvelopeTwoTone$1,
  RedditCircleFilled: RedditCircleFilled$1,
  RedditOutlined: RedditOutlined$1,
  RedditSquareFilled: RedditSquareFilled$1,
  RedoOutlined: RedoOutlined$1,
  ReloadOutlined: ReloadOutlined$1,
  RestFilled: RestFilled$1,
  RestOutlined: RestOutlined$1,
  RestTwoTone: RestTwoTone$1,
  RetweetOutlined: RetweetOutlined$1,
  RightCircleFilled: RightCircleFilled$1,
  RightCircleOutlined: RightCircleOutlined$1,
  RightCircleTwoTone: RightCircleTwoTone$1,
  RightOutlined: RightOutlined$1,
  RightSquareFilled: RightSquareFilled$1,
  RightSquareOutlined: RightSquareOutlined$1,
  RightSquareTwoTone: RightSquareTwoTone$1,
  RiseOutlined: RiseOutlined$1,
  RobotFilled: RobotFilled$1,
  RobotOutlined: RobotOutlined$1,
  RocketFilled: RocketFilled$1,
  RocketOutlined: RocketOutlined$1,
  RocketTwoTone: RocketTwoTone$1,
  RollbackOutlined: RollbackOutlined$1,
  RotateLeftOutlined: RotateLeftOutlined$1,
  RotateRightOutlined: RotateRightOutlined$1,
  SafetyCertificateFilled: SafetyCertificateFilled$1,
  SafetyCertificateOutlined: SafetyCertificateOutlined$1,
  SafetyCertificateTwoTone: SafetyCertificateTwoTone$1,
  SafetyOutlined: SafetyOutlined$1,
  SaveFilled: SaveFilled$1,
  SaveOutlined: SaveOutlined$1,
  SaveTwoTone: SaveTwoTone$1,
  ScanOutlined: ScanOutlined$1,
  ScheduleFilled: ScheduleFilled$1,
  ScheduleOutlined: ScheduleOutlined$1,
  ScheduleTwoTone: ScheduleTwoTone$1,
  ScissorOutlined: ScissorOutlined$1,
  SearchOutlined: SearchOutlined$1,
  SecurityScanFilled: SecurityScanFilled$1,
  SecurityScanOutlined: SecurityScanOutlined$1,
  SecurityScanTwoTone: SecurityScanTwoTone$1,
  SelectOutlined: SelectOutlined$1,
  SendOutlined: SendOutlined$1,
  SettingFilled: SettingFilled$1,
  SettingOutlined: SettingOutlined$1,
  SettingTwoTone: SettingTwoTone$1,
  ShakeOutlined: ShakeOutlined$1,
  ShareAltOutlined: ShareAltOutlined$1,
  ShopFilled: ShopFilled$1,
  ShopOutlined: ShopOutlined$1,
  ShopTwoTone: ShopTwoTone$1,
  ShoppingCartOutlined: ShoppingCartOutlined$1,
  ShoppingFilled: ShoppingFilled$1,
  ShoppingOutlined: ShoppingOutlined$1,
  ShoppingTwoTone: ShoppingTwoTone$1,
  ShrinkOutlined: ShrinkOutlined$1,
  SignalFilled: SignalFilled$1,
  SisternodeOutlined: SisternodeOutlined$1,
  SketchCircleFilled: SketchCircleFilled$1,
  SketchOutlined: SketchOutlined$1,
  SketchSquareFilled: SketchSquareFilled$1,
  SkinFilled: SkinFilled$1,
  SkinOutlined: SkinOutlined$1,
  SkinTwoTone: SkinTwoTone$1,
  SkypeFilled: SkypeFilled$1,
  SkypeOutlined: SkypeOutlined$1,
  SlackCircleFilled: SlackCircleFilled$1,
  SlackOutlined: SlackOutlined$1,
  SlackSquareFilled: SlackSquareFilled$1,
  SlackSquareOutlined: SlackSquareOutlined$1,
  SlidersFilled: SlidersFilled$1,
  SlidersOutlined: SlidersOutlined$1,
  SlidersTwoTone: SlidersTwoTone$1,
  SmallDashOutlined: SmallDashOutlined$1,
  SmileFilled: SmileFilled$1,
  SmileOutlined: SmileOutlined$1,
  SmileTwoTone: SmileTwoTone$1,
  SnippetsFilled: SnippetsFilled$1,
  SnippetsOutlined: SnippetsOutlined$1,
  SnippetsTwoTone: SnippetsTwoTone$1,
  SolutionOutlined: SolutionOutlined$1,
  SortAscendingOutlined: SortAscendingOutlined$1,
  SortDescendingOutlined: SortDescendingOutlined$1,
  SoundFilled: SoundFilled$1,
  SoundOutlined: SoundOutlined$1,
  SoundTwoTone: SoundTwoTone$1,
  SplitCellsOutlined: SplitCellsOutlined$1,
  StarFilled: StarFilled$1,
  StarOutlined: StarOutlined$1,
  StarTwoTone: StarTwoTone$1,
  StepBackwardFilled: StepBackwardFilled$1,
  StepBackwardOutlined: StepBackwardOutlined$1,
  StepForwardFilled: StepForwardFilled$1,
  StepForwardOutlined: StepForwardOutlined$1,
  StockOutlined: StockOutlined$1,
  StopFilled: StopFilled$1,
  StopOutlined: StopOutlined$1,
  StopTwoTone: StopTwoTone$1,
  StrikethroughOutlined: StrikethroughOutlined$1,
  SubnodeOutlined: SubnodeOutlined$1,
  SwapLeftOutlined: SwapLeftOutlined$1,
  SwapOutlined: SwapOutlined$1,
  SwapRightOutlined: SwapRightOutlined$1,
  SwitcherFilled: SwitcherFilled$1,
  SwitcherOutlined: SwitcherOutlined$1,
  SwitcherTwoTone: SwitcherTwoTone$1,
  SyncOutlined: SyncOutlined$1,
  TableOutlined: TableOutlined$1,
  TabletFilled: TabletFilled$1,
  TabletOutlined: TabletOutlined$1,
  TabletTwoTone: TabletTwoTone$1,
  TagFilled: TagFilled$1,
  TagOutlined: TagOutlined$1,
  TagTwoTone: TagTwoTone$1,
  TagsFilled: TagsFilled$1,
  TagsOutlined: TagsOutlined$1,
  TagsTwoTone: TagsTwoTone$1,
  TaobaoCircleFilled: TaobaoCircleFilled$1,
  TaobaoCircleOutlined: TaobaoCircleOutlined$1,
  TaobaoOutlined: TaobaoOutlined$1,
  TaobaoSquareFilled: TaobaoSquareFilled$1,
  TeamOutlined: TeamOutlined$1,
  ThunderboltFilled: ThunderboltFilled$1,
  ThunderboltOutlined: ThunderboltOutlined$1,
  ThunderboltTwoTone: ThunderboltTwoTone$1,
  ToTopOutlined: ToTopOutlined$1,
  ToolFilled: ToolFilled$1,
  ToolOutlined: ToolOutlined$1,
  ToolTwoTone: ToolTwoTone$1,
  TrademarkCircleFilled: TrademarkCircleFilled$1,
  TrademarkCircleOutlined: TrademarkCircleOutlined$1,
  TrademarkCircleTwoTone: TrademarkCircleTwoTone$1,
  TrademarkOutlined: TrademarkOutlined$1,
  TransactionOutlined: TransactionOutlined$1,
  TranslationOutlined: TranslationOutlined$1,
  TrophyFilled: TrophyFilled$1,
  TrophyOutlined: TrophyOutlined$1,
  TrophyTwoTone: TrophyTwoTone$1,
  TwitterCircleFilled: TwitterCircleFilled$1,
  TwitterOutlined: TwitterOutlined$1,
  TwitterSquareFilled: TwitterSquareFilled$1,
  UnderlineOutlined: UnderlineOutlined$1,
  UndoOutlined: UndoOutlined$1,
  UngroupOutlined: UngroupOutlined$1,
  UnlockFilled: UnlockFilled$1,
  UnlockOutlined: UnlockOutlined$1,
  UnlockTwoTone: UnlockTwoTone$1,
  UnorderedListOutlined: UnorderedListOutlined$1,
  UpCircleFilled: UpCircleFilled$1,
  UpCircleOutlined: UpCircleOutlined$1,
  UpCircleTwoTone: UpCircleTwoTone$1,
  UpOutlined: UpOutlined$1,
  UpSquareFilled: UpSquareFilled$1,
  UpSquareOutlined: UpSquareOutlined$1,
  UpSquareTwoTone: UpSquareTwoTone$1,
  UploadOutlined: UploadOutlined$1,
  UsbFilled: UsbFilled$1,
  UsbOutlined: UsbOutlined$1,
  UsbTwoTone: UsbTwoTone$1,
  UserAddOutlined: UserAddOutlined$1,
  UserDeleteOutlined: UserDeleteOutlined$1,
  UserOutlined: UserOutlined$1,
  UserSwitchOutlined: UserSwitchOutlined$1,
  UsergroupAddOutlined: UsergroupAddOutlined$1,
  UsergroupDeleteOutlined: UsergroupDeleteOutlined$1,
  VerifiedOutlined: VerifiedOutlined$1,
  VerticalAlignBottomOutlined: VerticalAlignBottomOutlined$1,
  VerticalAlignMiddleOutlined: VerticalAlignMiddleOutlined$1,
  VerticalAlignTopOutlined: VerticalAlignTopOutlined$1,
  VerticalLeftOutlined: VerticalLeftOutlined$1,
  VerticalRightOutlined: VerticalRightOutlined$1,
  VideoCameraAddOutlined: VideoCameraAddOutlined$1,
  VideoCameraFilled: VideoCameraFilled$1,
  VideoCameraOutlined: VideoCameraOutlined$1,
  VideoCameraTwoTone: VideoCameraTwoTone$1,
  WalletFilled: WalletFilled$1,
  WalletOutlined: WalletOutlined$1,
  WalletTwoTone: WalletTwoTone$1,
  WarningFilled: WarningFilled$1,
  WarningOutlined: WarningOutlined$1,
  WarningTwoTone: WarningTwoTone$1,
  WechatFilled: WechatFilled$1,
  WechatOutlined: WechatOutlined$1,
  WeiboCircleFilled: WeiboCircleFilled$1,
  WeiboCircleOutlined: WeiboCircleOutlined$1,
  WeiboOutlined: WeiboOutlined$1,
  WeiboSquareFilled: WeiboSquareFilled$1,
  WeiboSquareOutlined: WeiboSquareOutlined$1,
  WhatsAppOutlined: WhatsAppOutlined$1,
  WifiOutlined: WifiOutlined$1,
  WindowsFilled: WindowsFilled$1,
  WindowsOutlined: WindowsOutlined$1,
  WomanOutlined: WomanOutlined$1,
  YahooFilled: YahooFilled$1,
  YahooOutlined: YahooOutlined$1,
  YoutubeFilled: YoutubeFilled$1,
  YoutubeOutlined: YoutubeOutlined$1,
  YuqueFilled: YuqueFilled$1,
  YuqueOutlined: YuqueOutlined$1,
  ZhihuCircleFilled: ZhihuCircleFilled$1,
  ZhihuOutlined: ZhihuOutlined$1,
  ZhihuSquareFilled: ZhihuSquareFilled$1,
  ZoomInOutlined: ZoomInOutlined$1,
  ZoomOutOutlined: ZoomOutOutlined$1
});

var Icon$3 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      restProps = _objectWithoutProperties$1(props, ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"]);

  warning$2(Boolean(Component || children), 'Should have `component` prop or `children`.');
  useInsertStyles();
  var classString = classNames$1('anticon', className);
  var svgClassString = classNames$1({
    'anticon-spin': !!spin
  });
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = _objectSpread2(_objectSpread2({}, svgBaseProps), {}, {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  } // component > children


  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, innerSvgProps), children);
    }

    if (children) {
      warning$2(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/React.createElement("svg", Object.assign({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    return null;
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/React.createElement("span", Object.assign({
    role: "img"
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
});
Icon$3.displayName = 'AntdIcon';

var customCache = new Set();

function isValidCustomScriptUrl(scriptUrl) {
  return Boolean(typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl));
}

function createScriptUrlElements(scriptUrls) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currentScriptUrl = scriptUrls[index];

  if (isValidCustomScriptUrl(currentScriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', currentScriptUrl);
    script.setAttribute('data-namespace', currentScriptUrl);

    if (scriptUrls.length > index + 1) {
      script.onload = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };

      script.onerror = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };
    }

    customCache.add(currentScriptUrl);
    document.body.appendChild(script);
  }
}

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (scriptUrl && typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function') {
    if (Array.isArray(scriptUrl)) {
      // 因为iconfont资源会把svg插入before，所以前加载相同type会覆盖后加载，为了数组覆盖顺序，倒叙插入
      createScriptUrlElements(scriptUrl.reverse());
    } else {
      createScriptUrlElements([scriptUrl]);
    }
  }

  var Iconfont = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var type = props.type,
        children = props.children,
        restProps = _objectWithoutProperties$1(props, ["type", "children"]); // children > type


    var content = null;

    if (props.type) {
      content = /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, extraCommonProps, restProps, {
      ref: ref
    }), content);
  });
  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

var SearchButton = function SearchButton(props) {
  var searchClick = props.searchClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "search-input-bar-view"
  }, /*#__PURE__*/React__default.createElement(SearchOutlined$1, {
    className: "search-button-input-icon",
    onClick: function onClick() {
      return searchClick && searchClick();
    }
  }));
};

SearchButton.defaultProps = {
  searchClick: function searchClick() {}
};

var InputBox = function InputBox(props) {
  var placeholder = props.placeholder,
      value = props.value,
      onTextChange = props.onTextChange;
  value ? /*#__PURE__*/React__default.createElement(CloseCircleOutlined$1, {
    onClick: props.emitEmpty,
    style: {
      cursor: 'pointer'
    }
  }) : null;
  return /*#__PURE__*/React__default.createElement(_Input, {
    prefix: /*#__PURE__*/React__default.createElement(SearchButton, null),
    placeholder: placeholder && placeholder,
    value: value,
    onChange: onTextChange // allowClear={props.suffix}
    ,
    style: props.style ? props.style : {}
  });
};

InputBox.defaultProps = {
  onTextChange: function onTextChange() {},
  value: 'Text input',
  placeholder: 'placeholder'
};

var AntdTextArea = _Input.TextArea;

var TextArea = function TextArea(_ref) {
  var placeholder = _ref.placeholder,
      text = _ref.text,
      handleChange = _ref.handleChange,
      limit = _ref.limit,
      resize = _ref.resize;

  function handleType(e) {
    var value = e.target.value;
    limit ? handleChange(value.substring(0, limit)) : handleChange(value);
  }

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(AntdTextArea, {
    className: classNames$1({
      'disable-resize': !resize
    }),
    placeholder: placeholder,
    value: limit ? text.substring(0, limit) : text,
    onChange: handleType
  }), limit && /*#__PURE__*/React__default.createElement("div", {
    className: classNames$1('limit-progress', {
      error: text.length >= limit
    })
  }, text.length, "/", limit));
};

TextArea.defaultProps = {
  limit: null,
  placeholder: '',
  resize: false
};

var QubeIcons = Icons;

var _excluded$6 = ["count", "custom"];
var STATUS_ICON_MAP = {
  pending: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.ClockIcon, null),
    label: 'Pending'
  },
  completed: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.ConfirmCircleFilledIcon, null),
    label: 'Completed'
  },
  cancelled: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.CancelRoundedIcon, null),
    label: 'Cancelled'
  },
  failed: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.AlertFilledIcon, null),
    label: 'Failed'
  },
  inProgress: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.CirclePartiallyFilledV2Icon, null),
    label: 'In Progress'
  },
  linkExpired: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.DownloadLinkAlertIcon, null),
    label: 'Link Expired'
  },
  linkSent: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.DownloadLinkIcon, null),
    label: 'Link Sent'
  },
  downloading: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.DownloadIcon, null),
    label: 'Downloading'
  },
  scheduled: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.ConfirmCircleIcon, null),
    label: 'Scheduled'
  },
  notStarted: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.ClockIcon, null),
    label: 'Not Started'
  },
  verifying: {
    icon: /*#__PURE__*/React__default.createElement(QubeIcons.CirclePartiallyFilledV2Icon, null),
    label: 'Verifying'
  }
};
/**
 *
 * @param {Object} props - The component props.
 * @param {Number} [props.count=0] - The count of the status. If 0, status without count will be rendered.
 * @param {Boolean} [props.custom=false] - If true, the component will render a custom status with provided icon and label.
 * @param {DeliveryStatuses} [props.type] - The predefined status type. This will be used if custom is false.
 * @param {JSX.Element} [props.icon] - The icon to be rendered if custom is true.
 * @param {String} [props.label] - The label to be rendered if custom is true.
 * @returns {JSX.Element} - The rendered component.
 */

var DeliveryStatus = function DeliveryStatus(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count;
      _ref.custom;
      var props = _objectWithoutProperties$2(_ref, _excluded$6);

  var component = /*#__PURE__*/React__default.createElement(React__default.Fragment, null);

  if ('type' in props) {
    component = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, STATUS_ICON_MAP[props.type].icon, count > 0 && count, " ", STATUS_ICON_MAP[props.type].label);
  } else {
    component = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.icon, count > 0 && count, props.label);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "lib-status-tag ".concat('type' in props ? props.type : props.label)
  }, component);
};

var DefaultTag = function DefaultTag(props) {
  var PrefabIcon = Icons[props.tagIconName];
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.tagIconName ? "tag-container withTagIcon ".concat(props.tagType, " ").concat(props.readOnly ? 'readonly' : '') : "tag-container ".concat(props.tagType === 'type' ? props.content.toLowerCase() : props.tagType, " ").concat(props.readOnly ? 'readonly' : ''),
    onClick: function onClick() {
      return props.handleOnClick(props.content, props.tagTypeDisplayName);
    }
  }, props.tagIconName && /*#__PURE__*/React__default.createElement("span", {
    className: "tag-icon"
  }, PrefabIcon ? /*#__PURE__*/React__default.createElement(PrefabIcon, {
    height: props.content ? '16' : '20',
    width: props.content ? '16' : '20',
    viewBox: "0 0 24 24"
  }) : /*#__PURE__*/React__default.createElement(AppIcon, {
    name: props.tagIconName,
    size: "16"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "tag-content"
  }, props.content));
};

DefaultTag.defaultProps = {
  content: '',
  tagType: '',
  tagIconName: '',
  tagTypeDisplayName: '',
  readOnly: false,
  handleOnClick: function handleOnClick() {}
};

var FilterTag = function FilterTag(props) {
  var tagType = props.tagType,
      tagValue = props.tagValue,
      showFilterClose = props.showFilterClose;
  var tagTypeDetails;

  switch (tagType) {
    case 'type':
      tagTypeDetails = tagValue.toLowerCase();
      break;

    case 'resolution':
      tagTypeDetails = 'resolution';
      break;

    case 'format':
      tagTypeDetails = 'stereoType';
      break;

    case 'aspect':
      tagTypeDetails = 'aspectRatio';
      break;

    case 'language':
      tagTypeDetails = 'language';
      break;

    case 'subtitle':
      tagTypeDetails = 'subtitleLanguage';
      break;

    case 'audio':
      tagTypeDetails = 'audioFormats';
      break;

    case 'captions':
      tagTypeDetails = 'closedCaptions';
      break;

    case 'tag':
      tagTypeDetails = 'mappedTags';
      break;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "tag-container filter-container ".concat(tagTypeDetails),
    onClick: props.handleOnClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "tag-content"
  }, props.content), showFilterClose ? /*#__PURE__*/React__default.createElement("span", {
    className: "filter-close"
  }, "x") : null);
};

FilterTag.defaultProps = {
  content: '',
  tagType: '',
  tagValue: '',
  showFilterClose: true,
  handleOnClick: function handleOnClick() {}
};

var ClearTag = function ClearTag(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'tag-container filter-container clear',
    onClick: props.handleOnClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "tag-content"
  }, props.content));
};

ClearTag.defaultProps = {
  content: i18n.t('clear'),
  handleOnClick: function handleOnClick() {}
};

var FilterTags$1 = function FilterTags(_ref) {
  var filterTagList = _ref.filterTagList,
      handleClearAll = _ref.handleClearAll,
      customResultsText = _ref.customResultsText,
      _ref$showClearTag = _ref.showClearTag,
      showClearTag = _ref$showClearTag === void 0 ? true : _ref$showClearTag;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "filter-results-container"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "filter-results-label"
  }, customResultsText ? customResultsText : i18n.t('resultsFor')), filterTagList.map(function (tagListItems) {
    return tagListItems.selectedList.map(function (filter) {
      return /*#__PURE__*/React__default.createElement(FilterTag, {
        content: [/*#__PURE__*/React__default.createElement("span", {
          className: "filter-type"
        }, filter.type, "\xA0:\xA0"), /*#__PURE__*/React__default.createElement("span", {
          className: "filter-label"
        }, filter.label), /*#__PURE__*/React__default.createElement("span", {
          className: "filter-sublabel"
        }, filter.subLabel)],
        filterTagValue: filter,
        showFilterClose: filter.showFilterClose,
        handleOnClick: function handleOnClick() {
          tagListItems.handleClear(filter);
        }
      });
    });
  }), showClearTag ? /*#__PURE__*/React__default.createElement(ClearTag, {
    handleOnClick: handleClearAll
  }) : null);
};

var SuccessMessage = function SuccessMessage(msg) {
  var $timer = setTimeout(function () {
    clearTimeout($timer);
    $timer = null;

    _message.success(msg, 5);
  }, 0);
};

var ErrorMessage = function ErrorMessage(msg) {
  var $timer = setTimeout(function () {
    clearTimeout($timer);
    $timer = null;

    _message.error(msg, 5);
  }, 0);
};

var EmptyHandler = function EmptyHandler() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "empty-handler"
  }, /*#__PURE__*/React__default.createElement("span", null, "-"));
};

var CursorPagination = function CursorPagination(_ref) {
  var handlePrevious = _ref.handlePrevious,
      handleNext = _ref.handleNext,
      shoudlDisablePrevious = _ref.shoudlDisablePrevious,
      shouldDisableNext = _ref.shouldDisableNext,
      currentPage = _ref.currentPage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "cursor-pagination"
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handlePrevious,
    className: classNames$1({
      disabled: shoudlDisablePrevious
    })
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: "ChevronLeft",
    size: "24"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "current-page"
  }, currentPage), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleNext,
    className: classNames$1({
      disabled: shouldDisableNext
    })
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: "ChevronRight",
    size: "24"
  })));
};

var TablePagination = function TablePagination(props) {
  return /*#__PURE__*/React__default.createElement(TablePagination$1, props);
};

/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Alignment along the horizontal axis. */
var Alignment = {
    CENTER: "center",
    LEFT: "left",
    RIGHT: "right",
};

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// tslint:disable:object-literal-sort-keys
/**
 * The four basic intents.
 */
var Intent = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger",
};

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a, _b, _c, _d;
var NS = "bp3";
if (typeof process !== "undefined") {
    NS = (_d = (_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.BLUEPRINT_NAMESPACE) !== null && _b !== void 0 ? _b : (_c = process.env) === null || _c === void 0 ? void 0 : _c.REACT_APP_BLUEPRINT_NAMESPACE) !== null && _d !== void 0 ? _d : NS;
}
// modifiers
var ACTIVE = "".concat(NS, "-active");
var ALIGN_LEFT = "".concat(NS, "-align-left");
var ALIGN_RIGHT = "".concat(NS, "-align-right");
var DISABLED = "".concat(NS, "-disabled");
var FILL = "".concat(NS, "-fill");
var LARGE = "".concat(NS, "-large");
var LOADING = "".concat(NS, "-loading");
var MINIMAL = "".concat(NS, "-minimal");
var OUTLINED = "".concat(NS, "-outlined");
var SMALL = "".concat(NS, "-small");
intentClass(Intent.PRIMARY);
intentClass(Intent.SUCCESS);
intentClass(Intent.WARNING);
intentClass(Intent.DANGER);
var BUTTON = "".concat(NS, "-button");
var BUTTON_SPINNER = "".concat(BUTTON, "-spinner");
var BUTTON_TEXT = "".concat(BUTTON, "-text");
var SPINNER = "".concat(NS, "-spinner");
var SPINNER_ANIMATION = "".concat(SPINNER, "-animation");
var SPINNER_HEAD = "".concat(SPINNER, "-head");
var SPINNER_NO_SPIN = "".concat(NS, "-no-spin");
var SPINNER_TRACK$1 = "".concat(SPINNER, "-track");
var ICON = "".concat(NS, "-icon");
/** Return CSS class for alignment. */
function alignmentClass(alignment) {
    switch (alignment) {
        case Alignment.LEFT:
            return ALIGN_LEFT;
        case Alignment.RIGHT:
            return ALIGN_RIGHT;
        default:
            return undefined;
    }
}
function iconClass(iconName) {
    if (iconName == null) {
        return undefined;
    }
    return iconName.indexOf("".concat(NS, "-icon-")) === 0 ? iconName : "".concat(NS, "-icon-").concat(iconName);
}
function intentClass(intent) {
    if (intent == null || intent === Intent.NONE) {
        return undefined;
    }
    return "".concat(NS, "-intent-").concat(intent.toLowerCase());
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ns = "[Blueprint]";
var CLAMP_MIN_MAX = ns + " clamp: max cannot be less than min";
var SPINNER_WARN_CLASSES_SIZE = ns + " <Spinner> Classes.SMALL/LARGE are ignored if size prop is set.";

/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns whether `process.env.NODE_ENV` exists and equals `env`. */
function isNodeEnv(env) {
    return typeof process !== "undefined" && process.env && process.env.NODE_ENV === env;
}
/**
 * Clamps the given number between min and max values. Returns value if within
 * range, or closest bound.
 */
function clamp(val, min, max) {
    if (val == null) {
        return val;
    }
    if (max < min) {
        throw new Error(CLAMP_MIN_MAX);
    }
    return Math.min(Math.max(val, min), max);
}

/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns true if `node` is null/undefined, false, empty string, or an array
 * composed of those. If `node` is an array, only one level of the array is
 * checked, for performance reasons.
 */
function isReactNodeEmpty(node, skipArray) {
    if (skipArray === void 0) { skipArray = false; }
    return (node == null ||
        node === "" ||
        node === false ||
        (!skipArray &&
            Array.isArray(node) &&
            // only recurse one level through arrays, for performance
            (node.length === 0 || node.every(function (n) { return isReactNodeEmpty(n, true); }))));
}

/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isRefObject(value) {
    return value != null && typeof value !== "function";
}
function isRefCallback(value) {
    return typeof value === "function";
}
/**
 * Assign the given ref to a target, either a React ref object or a callback which takes the ref as its first argument.
 */
function setRef(refTarget, ref) {
    if (isRefObject(refTarget)) {
        refTarget.current = ref;
    }
    else if (isRefCallback(refTarget)) {
        refTarget(ref);
    }
}
/**
 * Creates a ref handler which assigns the ref returned by React for a mounted component to a field on the target object.
 * The target object is usually a component class.
 *
 * If provided, it will also update the given `refProp` with the value of the ref.
 */
function refHandler(refTargetParent, refTargetKey, refProp) {
    return function (ref) {
        refTargetParent[refTargetKey] = ref;
        setRef(refProp, ref);
    };
}

/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An abstract component that Blueprint components can extend
 * in order to add some common functionality like runtime props validation.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
var AbstractPureComponent2 = /** @class */ (function (_super) {
    __extends(AbstractPureComponent2, _super);
    function AbstractPureComponent2(props, context) {
        var _this = _super.call(this, props, context) || this;
        // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
        _this.timeoutIds = [];
        _this.requestIds = [];
        /**
         * Clear all known timeouts.
         */
        _this.clearTimeouts = function () {
            if (_this.timeoutIds.length > 0) {
                for (var _i = 0, _a = _this.timeoutIds; _i < _a.length; _i++) {
                    var timeoutId = _a[_i];
                    window.clearTimeout(timeoutId);
                }
                _this.timeoutIds = [];
            }
        };
        /**
         * Clear all known animation frame requests.
         */
        _this.cancelAnimationFrames = function () {
            if (_this.requestIds.length > 0) {
                for (var _i = 0, _a = _this.requestIds; _i < _a.length; _i++) {
                    var requestId = _a[_i];
                    window.cancelAnimationFrame(requestId);
                }
                _this.requestIds = [];
            }
        };
        if (!isNodeEnv("production")) {
            _this.validateProps(_this.props);
        }
        return _this;
    }
    AbstractPureComponent2.prototype.componentDidUpdate = function (_prevProps, _prevState, _snapshot) {
        if (!isNodeEnv("production")) {
            this.validateProps(this.props);
        }
    };
    AbstractPureComponent2.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    };
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */
    AbstractPureComponent2.prototype.requestAnimationFrame = function (callback) {
        var handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return function () { return window.cancelAnimationFrame(handle); };
    };
    /**
     * Set a timeout and remember its ID.
     * All pending timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */
    AbstractPureComponent2.prototype.setTimeout = function (callback, timeout) {
        var handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return function () { return window.clearTimeout(handle); };
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */
    AbstractPureComponent2.prototype.validateProps = function (_props) {
        // implement in subclass
    };
    return AbstractPureComponent2;
}(React.PureComponent));

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DISPLAYNAME_PREFIX = "Blueprint3";
/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */
var INVALID_PROPS = [
    "active",
    "alignText",
    "asyncControl",
    "containerRef",
    "current",
    "elementRef",
    "fill",
    "icon",
    "inputRef",
    "intent",
    "inline",
    "large",
    "loading",
    "leftElement",
    "leftIcon",
    "minimal",
    "onRemove",
    "outlined",
    "panel",
    "panelClassName",
    "popoverProps",
    "rightElement",
    "rightIcon",
    "round",
    "small",
    "text",
];
/**
 * Typically applied to HTMLElements to filter out disallowed props. When applied to a Component,
 * can filter props from being passed down to the children. Can also filter by a combined list of
 * supplied prop keys and the denylist (only appropriate for HTMLElements).
 *
 * @param props The original props object to filter down.
 * @param {string[]} invalidProps If supplied, overwrites the default denylist.
 * @param {boolean} shouldMerge If true, will merge supplied invalidProps and denylist together.
 */
function removeNonHTMLProps(props, invalidProps, shouldMerge) {
    if (invalidProps === void 0) { invalidProps = INVALID_PROPS; }
    if (shouldMerge === void 0) { shouldMerge = false; }
    if (shouldMerge) {
        invalidProps = invalidProps.concat(INVALID_PROPS);
    }
    return invalidProps.reduce(function (prev, curr) {
        // Props with hyphens (e.g. data-*) are always considered html props
        if (curr.indexOf("-") !== -1) {
            return prev;
        }
        if (prev.hasOwnProperty(curr)) {
            delete prev[curr];
        }
        return prev;
    }, __assign({}, props));
}

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ENTER = 13;
var SPACE = 32;
/** Returns whether the key code is `enter` or `space`, the two keys that can click a button. */
function isKeyboardClick(keyCode) {
    return keyCode === ENTER || keyCode === SPACE;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _reactLifecyclesCompat = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 */
var IconSvgPaths16 = {
    "add": ["M10.99 6.99h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm-3-7c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"],
    "add-clip": ["M12 0a1 1 0 00-1 1v2H9a1 1 0 000 2h2v2a1 1 0 102 0V5h2a1 1 0 100-2h-2V1a1 1 0 00-1-1zM0 4a1 1 0 011-1h3.5a1 1 0 010 2H2v2a1 1 0 01-2 0V4zm1 12a1 1 0 01-1-1v-3a1 1 0 112 0v2h2.5a1 1 0 110 2H1zm11 0a1 1 0 001-1v-3a1 1 0 10-2 0v2H9a1 1 0 100 2h3zm-5.5-4a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"],
    "add-column-left": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 14H2V2h8v12zm4 0h-3V2h3v12zM4 9h1v1c0 .55.45 1 1 1s1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1H7V6c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "add-column-right": ["M8 9h1v1c0 .55.45 1 1 1s1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V6c0-.55-.45-1-1-1s-1 .45-1 1v1H8c-.55 0-1 .45-1 1s.45 1 1 1zm7-9H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 14H2V2h3v12zm9 0H6V2h8v12z"],
    "add-location": ["M8 0a1 1 0 110 2 6 6 0 106 6 1 1 0 012 0 8 8 0 11-8-8zm0 5a3 3 0 110 6 3 3 0 010-6zm5-5a1 1 0 011 1v.999L15 2a1 1 0 010 2h-1v1a1 1 0 01-2 0V4h-1a1 1 0 010-2h1V1a1 1 0 011-1z"],
    "add-row-bottom": ["M6 11h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1H9V8c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-.55 0-1 .45-1 1s.45 1 1 1zm9-11H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V6h12v8zm0-9H2V2h12v3z"],
    "add-row-top": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2v-3h12v3zm0-4H2V2h12v8zM6 7h1v1c0 .55.45 1 1 1s1-.45 1-1V7h1c.55 0 1-.45 1-1s-.45-1-1-1H9V4c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "add-to-artifact": ["M14 4.01h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1 0-.56-.45-1-1-1zm-13 2h6c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm8 6H1c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1 0-.56-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1 0-.56-.45-1-1-1z"],
    "add-to-folder": ["M.01 7V5H16v7c0 .55-.45 1-1 1H9.005v-2.99C8.974 8.332 7.644 7 5.996 7H.01zM15 2H7.416L5.706.29a.996.996 0 00-.71-.29H1C.45 0 0 .45 0 1v3h15.99V3c.01-.55-.44-1-.99-1zM5.997 9H2c-.55 0-1 .45-1 1s.45 1 1 1h1.589L.3 14.29a1.003 1.003 0 001.42 1.42l3.287-3.29v1.59c0 .55.45 1 1 1 .549 0 .999-.45.999-1v-4A1.02 1.02 0 005.996 9z"],
    "airplane": ["M16 1.5A1.498 1.498 0 0013.44.44L9.91 3.97 2 1 1 3l5.93 3.95L3.88 10H1l-1 1 3 2 2 3 1-1v-2.88l3.05-3.05L13 15l2-1-2.97-7.91 3.53-3.53c.27-.27.44-.65.44-1.06z"],
    "align-center": ["M4 4c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H4zM1 3h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm13 10H2c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm1-6H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-5 5c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1h4z"],
    "align-justify": ["M15 12.98H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-14-10h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1 0 .56.45 1 1 1zm14 4H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-3H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0 6H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "align-left": ["M13 13H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zM1 3h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0 3h8c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 1H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM1 12h4c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "align-right": ["M15 12.98H3c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm-14-10h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1 0 .56.45 1 1 1zm14 1H7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm0 6h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm0-3H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "alignment-bottom": ["M10 12h3c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm5 2H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM3 12h3c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1z"],
    "alignment-horizontal-center": ["M15 7h-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1H7V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4H1c-.55 0-1 .45-1 1s.45 1 1 1h1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9h2v1c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9h1c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "alignment-left": ["M9 9H5c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM1 0C.45 0 0 .45 0 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm13 2H5c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "alignment-right": ["M11 9H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm4-9c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-4 2H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "alignment-top": ["M15 0H1C.45 0 0 .45 0 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM6 4H3c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm7 0h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "alignment-vertical-center": ["M13 2H9V1c0-.55-.45-1-1-1S7 .45 7 1v1H3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4v2H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1H9V7h4c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "annotation": ["M15.52 2.77c.3-.29.48-.7.48-1.15C16 .73 15.27 0 14.38 0c-.45 0-.85.18-1.15.48l-1.34 1.34 2.3 2.3 1.33-1.35zM7.4 10.9l6.21-6.21-2.3-2.3L5.1 8.6l2.3 2.3zM14 14H2V2h6.34l2-2H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5.66l-2 2V14zM3 13l3.58-1.29-2.29-2.27L3 13z"],
    "antenna": ["M2.673 10.758a1.396 1.396 0 01.093.234c.127.442.012.932-.362 1.212-.441.332-1.075.246-1.349-.233a8 8 0 1114.014-.225c-.259.488-.889.594-1.341.277-.382-.269-.513-.755-.4-1.2a1.259 1.259 0 01.085-.238 6 6 0 10-10.74.173zm2.464-1.862a1.783 1.783 0 01.076.404c.03.415-.096.831-.43 1.078-.444.328-1.08.237-1.314-.264a5.003 5.003 0 01-.24-.62l-.004-.011a5 5 0 119.574-.08l-.003.011c-.063.213-.14.422-.23.625-.226.504-.861.606-1.31.285-.338-.241-.47-.654-.448-1.07a1.737 1.737 0 01.07-.405 2.99 2.99 0 00-.216-2.233 3 3 0 00-5.525 2.28zM8 7a1 1 0 011 1v3.586l2.707 2.707a1 1 0 01-1.414 1.414L8 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L7 11.586V8a1 1 0 011-1z"],
    "app-header": ["M15 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h14zM6 4a1 1 0 00-1.993-.117L4 4v8a1 1 0 001.993.117L6 12V9h4v3a1 1 0 001.993.117L12 12V4a1 1 0 00-1.993-.117L10 4v3H6V4z"],
    "application": ["M3.5 7h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5zM15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm-1 12H2V5h12v8zM3.5 9h4c.28 0 .5-.22.5-.5S7.78 8 7.5 8h-4c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5z"],
    "applications": ["M3.5 11h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2c-.28 0-.5.22-.5.5s.22.5.5.5zm0-2h5c.28 0 .5-.22.5-.5S8.78 8 8.5 8h-5c-.28 0-.5.22-.5.5s.22.5.5.5zM11 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10H2V7h8v7zm5-14H5c-.55 0-1 .45-1 1v2h2V2h8v7h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM3.5 13h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5z"],
    "archive": ["M13.382 0a1 1 0 01.894.553L16 4v11a1 1 0 01-1 1H1a1 1 0 01-1-1V4L1.724.553A1 1 0 012.618 0h10.764zM8 6c-.55 0-1 .45-1 1v2.59l-.29-.29-.081-.076A.97.97 0 006 9a1.003 1.003 0 00-.71 1.71l2 2 .096.084c.168.13.38.206.614.206.28 0 .53-.11.71-.29l2-2 .084-.096A1.003 1.003 0 009.29 9.29l-.29.3V7l-.007-.116A1.004 1.004 0 008 6zm5-4H3L2 4h12l-1-2z"],
    "area-of-interest": ["M4 3.664C4 1.644 5.793 0 8 0s3.993 1.643 4 3.664C12 5.692 8 11 8 11S4 5.692 4 3.664zM6 4a2 2 0 104.001-.001A2 2 0 006 4zm7.504 6.269l-2.68-1.609.021-.033c.34-.538.688-1.115 1-1.687l3.67 2.202a1 1 0 01.266 1.482l-4 5A1 1 0 0111 16H5a1 1 0 01-.78-.376l-4-5a1 1 0 01.266-1.482l3.67-2.202a30.46 30.46 0 00.999 1.687l.021.033-2.68 1.609 2.985 3.73h5.038l2.985-3.73z"],
    "array": ["M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm4 7a1 1 0 110 2 1 1 0 010-2zM5 7a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z"],
    "array-boolean": ["M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm7 6a1 1 0 01.993.883L12 7v2a1 1 0 01-.883.993L11 10H5a1 1 0 01-.993-.883L4 9V7a1 1 0 01.883-.993L5 6h6zm0 1H8v2h3V7z"],
    "array-date": ["M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm6.5 4a.5.5 0 01.5.5V5a1 1 0 01.993.883L12 6v5a1 1 0 01-.883.993L11 12H5a1 1 0 01-.993-.883L4 11V6a1 1 0 01.883-.993L5 5v-.5a.5.5 0 011 0V5h4v-.5a.5.5 0 01.5-.5zm.5 3H5v4h6V7z"],
    "array-numeric": ["M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm6.904 5c.256 0 .483.037.68.112a1.343 1.343 0 01.812.788c.072.184.108.385.108.604 0 .23-.05.441-.152.636a1.314 1.314 0 01-.456.492v.016l.08.04c.055.031.111.072.168.124.085.077.163.172.232.284a1.673 1.673 0 01.24.872c0 .25-.043.477-.128.68a1.518 1.518 0 01-.896.852 1.937 1.937 0 01-.68.116c-.427 0-.792-.101-1.096-.304a1.362 1.362 0 01-.584-.864c-.01-.053.01-.088.064-.104l.696-.16.033-.002c.03.002.051.022.063.058.059.16.155.296.288.408.133.112.312.168.536.168.256 0 .453-.076.592-.228a.827.827 0 00.208-.58c0-.277-.08-.495-.24-.652-.16-.157-.376-.236-.648-.236h-.232l-.035-.005c-.03-.01-.045-.035-.045-.075v-.632l.005-.035c.01-.03.035-.045.075-.045h.216l.138-.009a.734.734 0 00.438-.207c.144-.144.216-.336.216-.576a.745.745 0 00-.192-.532c-.128-.136-.307-.204-.536-.204-.203 0-.363.05-.48.152a.815.815 0 00-.248.408c-.016.048-.048.067-.096.056l-.68-.16-.034-.012c-.028-.016-.038-.044-.03-.084a1.347 1.347 0 01.516-.828c.136-.104.296-.185.48-.244A1.98 1.98 0 0110.904 5zm-6.152.088l.035.005c.03.01.045.035.045.075v5.28l-.005.035c-.01.03-.035.045-.075.045h-.736l-.035-.005c-.03-.01-.045-.035-.045-.075V6.16H3.92l-.832.584-.032.016C3.02 6.773 3 6.751 3 6.696V5.88l.006-.04a.157.157 0 01.05-.072l.872-.632.04-.027a.236.236 0 01.104-.021h.68zM7.344 5c.256 0 .483.04.68.12.197.08.364.188.5.324s.24.296.312.48c.072.184.108.383.108.596 0 .245-.045.47-.136.676-.09.205-.216.404-.376.596l-1.584 1.92v.016h2.016l.035.005c.03.01.045.035.045.075v.64l-.005.035c-.01.03-.035.045-.075.045H5.808l-.035-.005c-.03-.01-.045-.035-.045-.075v-.6l.004-.04a.132.132 0 01.036-.064l1.92-2.392.1-.133a1.95 1.95 0 00.156-.267.985.985 0 00.096-.432.736.736 0 00-.188-.512c-.125-.139-.303-.208-.532-.208-.219 0-.39.061-.512.184a.826.826 0 00-.224.496c-.01.053-.04.075-.088.064L5.792 6.4l-.034-.012c-.028-.016-.038-.044-.03-.084a1.425 1.425 0 01.94-1.192A1.88 1.88 0 017.344 5z"],
    "array-string": ["M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm1.61 5c.514 0 .962.212 1.343.637.382.425.573.997.573 1.716 0 .838-.258 1.588-.773 2.252-.514.663-1.327 1.2-2.437 1.609v-.465l.233-.095a3.09 3.09 0 001.274-1.017c.366-.505.55-1.03.55-1.577a.478.478 0 00-.057-.26c-.018-.037-.043-.056-.074-.056s-.08.025-.149.075c-.198.142-.446.214-.744.214-.36 0-.675-.145-.944-.433A1.453 1.453 0 014 6.572c0-.422.155-.79.465-1.102.31-.313.692-.47 1.144-.47zm4.474 0c.514 0 .963.212 1.344.637.381.425.572.997.572 1.716 0 .838-.257 1.588-.772 2.252-.515.663-1.327 1.2-2.437 1.609v-.465l.233-.095a3.09 3.09 0 001.274-1.017c.366-.505.549-1.03.549-1.577a.478.478 0 00-.056-.26c-.019-.037-.044-.056-.075-.056-.03 0-.08.025-.149.075-.198.142-.446.214-.744.214-.36 0-.674-.145-.944-.433a1.453 1.453 0 01-.405-1.028c0-.422.155-.79.466-1.102.31-.313.691-.47 1.144-.47z"],
    "array-timestamp": ["M15 0a1 1 0 01.993.883L16 1v14a1 1 0 01-.883.993L15 16h-3a1 1 0 01-.117-1.993L12 14h2V2h-2a1 1 0 01-.993-.883L11 1a1 1 0 01.883-.993L12 0h3zM4 0a1 1 0 01.117 1.993L4 2H2v12h2a1 1 0 01.993.883L5 15a1 1 0 01-.883.993L4 16H1a1 1 0 01-.993-.883L0 15V1A1 1 0 01.883.007L1 0h3zm4 3a5 5 0 110 10A5 5 0 018 3zm0 1a4 4 0 100 8 4 4 0 000-8zm2.354 1.646a.5.5 0 01.057.638l-.057.07-2 2a.5.5 0 01-.638.057l-.07-.057-1-1a.5.5 0 01.638-.765l.07.057.646.647 1.646-1.647a.5.5 0 01.708 0z"],
    "arrow-bottom-left": ["M14 3a1.003 1.003 0 00-1.71-.71L4 10.59V6c0-.55-.45-1-1-1s-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1H5.41l8.29-8.29c.19-.18.3-.43.3-.71z"],
    "arrow-bottom-right": ["M13 5c-.55 0-1 .45-1 1v4.59l-8.29-8.3a1.003 1.003 0 00-1.42 1.42l8.3 8.29H6c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"],
    "arrow-down": ["M13 8c-.3 0-.5.1-.7.3L9 11.6V2c0-.5-.4-1-1-1s-1 .5-1 1v9.6L3.7 8.3C3.5 8.1 3.3 8 3 8c-.5 0-1 .5-1 1 0 .3.1.5.3.7l5 5c.2.2.4.3.7.3s.5-.1.7-.3l5-5c.2-.2.3-.4.3-.7 0-.6-.4-1-1-1z"],
    "arrow-left": ["M13.99 6.99H4.41L7.7 3.7a1.003 1.003 0 00-1.42-1.42l-5 5a1.014 1.014 0 000 1.42l5 5a1.003 1.003 0 001.42-1.42L4.41 8.99H14c.55 0 1-.45 1-1s-.46-1-1.01-1z"],
    "arrow-right": ["M14.7 7.29l-5-5a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l3.29 3.29H1.99c-.55 0-1 .45-1 1s.45 1 1 1h9.59l-3.29 3.29a1.003 1.003 0 001.42 1.42l5-5c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"],
    "arrow-top-left": ["M13.71 12.29L5.41 4H10c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1V5.41l8.29 8.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "arrow-top-right": ["M13 2H6c-.55 0-1 .45-1 1s.45 1 1 1h4.59L2.3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L12 5.41V10c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "arrow-up": ["M13.7 6.3l-5-5C8.5 1.1 8.3 1 8 1s-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L7 4.4V14c0 .6.4 1 1 1s1-.4 1-1V4.4l3.3 3.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7z"],
    "arrows-horizontal": ["M15.7 7.3l-4-4c-.2-.2-.4-.3-.7-.3-.6 0-1 .5-1 1 0 .3.1.5.3.7L12.6 7H3.4l2.3-2.3c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1-.3 0-.5.1-.7.3l-4 4c-.2.2-.3.4-.3.7s.1.5.3.7l4 4c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7L3.4 9h9.2l-2.3 2.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l4-4c.2-.2.3-.4.3-.7s-.1-.5-.3-.7z"],
    "arrows-vertical": ["M12 10c-.3 0-.5.1-.7.3L9 12.6V3.4l2.3 2.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7l-4-4C8.5.1 8.3 0 8 0s-.5.1-.7.3l-4 4c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L7 3.4v9.2l-2.3-2.3c-.2-.2-.4-.3-.7-.3-.5 0-1 .4-1 1 0 .3.1.5.3.7l4 4c.2.2.4.3.7.3s.5-.1.7-.3l4-4c.2-.2.3-.4.3-.7 0-.6-.4-1-1-1z"],
    "asterisk": ["M14.54 11.18l.01-.02L9.8 8l4.75-3.17-.01-.02c.27-.17.46-.46.46-.81 0-.55-.45-1-1-1-.21 0-.39.08-.54.18l-.01-.02L9 6.13V1c0-.55-.45-1-1-1S7 .45 7 1v5.13L2.55 3.17l-.01.01A.969.969 0 002 3c-.55 0-1 .45-1 1 0 .35.19.64.46.82l-.01.01L6.2 8l-4.75 3.17.01.02c-.27.17-.46.46-.46.81 0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02L7 9.87V15c0 .55.45 1 1 1s1-.45 1-1V9.87l4.45 2.96.01-.02c.15.11.33.19.54.19.55 0 1-.45 1-1 0-.35-.19-.64-.46-.82z"],
    "automatic-updates": ["M8 14c-3.31 0-6-2.69-6-6 0-1.77.78-3.36 2-4.46V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1s.45 1 1 1h1.74A7.95 7.95 0 000 8c0 4.42 3.58 8 8 8 .55 0 1-.45 1-1s-.45-1-1-1zM8 2a5.9 5.9 0 012.95.81l1.47-1.47A7.893 7.893 0 008 0c-.55 0-1 .45-1 1s.45 1 1 1zm2.71 6.71l5-5a1.003 1.003 0 00-1.42-1.42L10 6.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29s.53-.11.71-.29zM16 8c0-.55-.06-1.08-.16-1.6l-1.87 1.87A5.966 5.966 0 0112 12.45V11c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-1.74A7.95 7.95 0 0016 8z"],
    "backlink": ["M14 10a1 1 0 110 2h-.585l2.292 2.293a1 1 0 01-1.32 1.497l-.094-.083L12 13.415V14a1 1 0 11-2 0l.003-3.075.012-.1.012-.059.033-.108.034-.081.052-.098.067-.096.08-.09a1.01 1.01 0 01.112-.097l.11-.071.143-.065.076-.024.091-.02.116-.014L14 10zM6.036 6.136l-3.45 3.45-.117.127a2 2 0 002.818 2.818l.127-.117 3.45-3.449a4 4 0 01-.885 3.704l-.15.16-1 1A4 4 0 011.02 8.33l.15-.16 1-1a3.998 3.998 0 013.865-1.035zm4.671-1.843a1 1 0 01.083 1.32l-.083.094-5 5a1 1 0 01-1.497-1.32l.083-.094 5-5a1 1 0 011.414 0zm3.121-3.121a4 4 0 01.151 5.497l-.15.16-1 1a3.998 3.998 0 01-3.864 1.036l3.45-3.45.116-.128a2 2 0 00-2.818-2.818l-.127.117-3.45 3.45A4 4 0 017.02 2.33l.15-.16 1-1a4 4 0 015.657 0z"],
    "badge": ["M13.36 4.59c-.15-1.13.5-2.01 1.1-2.87L13.43.53c-1.72.88-4.12.65-5.63-.53-1.51 1.18-3.91 1.41-5.63.52l-1.03 1.2c.61.86 1.25 1.74 1.1 2.87-.3 2.29-2.45 4.17-1.32 6.68.45 1.14 1.44 1.9 2.72 2.2 1.56.36 3.52.72 4.16 2.53.64-1.81 2.6-2.16 4.16-2.54 1.28-.3 2.27-1.06 2.72-2.2 1.12-2.5-1.03-4.38-1.32-6.67z"],
    "ban-circle": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 9H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"],
    "bank-account": ["M15.36 6.46l-.62-.14c-.31-1.12-.98-2.15-1.87-2.99l.4-1.77a.438.438 0 00-.49-.56c-.85.09-1.6.42-2.14.98-.84-.32-1.87-.51-2.85-.51-2.49 0-4.63 1.17-5.92 2.89-.18-.04-.36-.09-.53-.09-.76 0-1.34.61-1.34 1.4 0 .56.31 1.03.76 1.26-.05.33-.09.7-.09 1.07 0 1.68.71 3.17 1.83 4.34l-.27 1.59c-.09.56.35 1.07.89 1.07h.58c.45 0 .8-.33.89-.79l.04-.37c.94.42 2 .7 3.16.7 1.11 0 2.23-.23 3.16-.7l.05.37c.09.47.45.79.89.79h.58c.53 0 .98-.51.89-1.07l-.27-1.54c.62-.61 1.07-1.35 1.38-2.15l.8-.19c.4-.09.71-.47.71-.93V7.4c.09-.47-.22-.84-.62-.94zM12 8c-.6 0-1-.7-1-1.5S11.4 5 12 5s1 .7 1 1.5S12.6 8 12 8zM6.21 4.92c-.41.2-.91.04-1.12-.36-.21-.4-.04-.88.37-1.07 1.35-.65 2.73-.65 4.08 0 .41.2.58.68.37 1.07-.21.4-.71.56-1.12.36-.87-.43-1.71-.43-2.58 0z"],
    "barcode": ["M0 14h2V2H0v12zm6 0h1V2H6v12zm2 0h1V2H8v12zm-5 0h2V2H3v12zM15 2v12h1V2h-1zm-5 12h1V2h-1v12zm2 0h2V2h-2v12z"],
    "blank": [],
    "blocked-person": ["M9.39 12.69c-1.2-.53-1.04-.85-1.08-1.29-.01-.07-.01-.13-.02-.2.41-.37.75-.87.97-1.44 0 0 .01-.03.01-.04.05-.13.09-.26.13-.39.27-.06.43-.36.5-.63.01-.03.03-.08.05-.12C8.18 7.8 6.94 6.04 6.94 4c0-.32.04-.62.09-.92-.17-.03-.35-.08-.51-.08-.65 0-1.37.2-1.88.59-.5.38-.87.92-1.05 1.51-.04.14-.07.27-.09.41-.09.48-.14 1.23-.14 1.74v.06c-.19.08-.36.27-.4.68-.03.31.1.59.16.7.06.28.23.59.51.64.04.14.08.27.13.39 0 .01.01.02.01.02v.01c.22.59.57 1.1.99 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.12 1.29-1.2.53-3.01 1.1-3.38 1.95C-.12 15.5.03 16 .03 16h12.96s.15-.5-.22-1.36c-.37-.85-2.18-1.42-3.38-1.95zM11.97 0C9.75 0 7.94 1.79 7.94 4s1.8 4 4.03 4S16 6.21 16 4s-1.8-4-4.03-4zM9.96 4c0-1.1.9-2 2.01-2 .37 0 .72.11 1.02.28l-2.75 2.73c-.17-.3-.28-.64-.28-1.01zm2.01 2c-.37 0-.72-.11-1.02-.28l2.75-2.73c.18.3.28.64.28 1.01.01 1.1-.9 2-2.01 2z"],
    "bold": ["M11.7 7c.2-.4.3-1 .3-1.5v-.4V5c0-.1 0-.2-.1-.3v-.1C11.4 3.1 10.1 2 8.5 2H4c-.5 0-1 .4-1 1v10c0 .5.4 1 1 1h5c2.2 0 4-1.8 4-4 0-1.2-.5-2.3-1.3-3zM6 5h2c.6 0 1 .4 1 1s-.4 1-1 1H6V5zm3 6H6V9h3c.6 0 1 .4 1 1s-.4 1-1 1z"],
    "book": ["M2 1v14c0 .55.45 1 1 1h1V0H3c-.55 0-1 .45-1 1zm11-1h-1v7l-2-2-2 2V0H5v16h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "bookmark": ["M11.2.01h-.15C11.03.01 11.02 0 11 0H5c-.02 0-.03.01-.05.01H4.8c-.44 0-.8.37-.8.82v14.75c0 .45.25.56.57.24l2.87-2.94c.31-.32.82-.32 1.13 0l2.87 2.94c.31.32.57.21.57-.24V.83C12 .38 11.64.01 11.2.01z"],
    "box": ["M6 10h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm9.93-4.37v-.02L13.94.63C13.78.26 13.42 0 13 0H3c-.42 0-.78.26-.93.63L.08 5.61l-.01.02C.03 5.74 0 5.87 0 6v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.13-.03-.26-.07-.37zM9 2h3.32l1.2 3H9V2zM3.68 2H7v3H2.48l1.2-3zM14 14H2V7h12v7z"],
    "briefcase": ["M15 3.98h-3v-2c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H1c-.55 0-1 .45-1 1v4h3v-1h2v1h6v-1h2v1h3v-4c0-.55-.45-1-1-1zm-5 0H6v-1h4v1zm3 7h-2v-1H5v1H3v-1H0v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-4h-3v1z"],
    "bring-data": ["M14 14a1 1 0 010 2H2a1 1 0 010-2h12zM7.995 3.005c.55 0 1 .45 1 .999v5.584l1.29-1.288a1.002 1.002 0 011.42 1.419l-3 2.996a1.015 1.015 0 01-1.42 0l-3-2.997A1.002 1.002 0 015.705 8.3l1.29 1.29V4.013c0-.55.45-1.009 1-1.009zM14 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zM8 0a1 1 0 110 2 1 1 0 010-2zM5 0a1 1 0 110 2 1 1 0 010-2zM2 0a1 1 0 110 2 1 1 0 010-2z"],
    "buggy": ["M13.928.629A1 1 0 0012.89.006l-9 1a1 1 0 00-.747.48L.431 6.005A.5.5 0 000 6.5v3a.5.5 0 00.5.5h2.798c.341 0 .672.116.938.329l1.952 1.561A.5.5 0 006.5 12H10a.5.5 0 00.4-.2l.9-1.2a1.5 1.5 0 011.2-.6h3a.5.5 0 00.5-.5v-4a.5.5 0 00-.308-.462L13.928.628zM12.36 2.094l-.006-.016-3.166.352 1.121 3.083 2.052-3.419zm.467 1.166l-1.649 2.748 2.51-.594-.861-2.154zM9.603 6.496L8.166 2.543l-3.563.396L2.766 6H3.5a.5.5 0 01.367.16L6.218 8.7h1.914l1.452-2.177a.5.5 0 01.019-.027zM2.5 16a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm11 0a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"],
    "build": ["M15.39 12.41L7.7 6l1.07-1.1c.34-.34-.12-.63.12-1.26.88-2.17 3.41-2.35 3.41-2.35s.36-.37.71-.72C9.74-.81 7.53.53 6.54 1.4L3.12 4.9l-.71.72c-.39.4-.39 1.05 0 1.45l-.7.72c-.39-.4-1.02-.4-1.41 0s-.39 1.05 0 1.45l1.41 1.45c.39.4 1.02.4 1.41 0s.39-1.05 0-1.45l.71-.72c.39.4 1.02.4 1.41 0l.8-.82 6.39 7.67c.82.82 2.14.82 2.96 0 .81-.82.81-2.15 0-2.96z"],
    "calculator": ["M13 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM6 14H4v-2h2v2zm0-3H4V9h2v2zm0-3H4V6h2v2zm3 6H7v-2h2v2zm0-3H7V9h2v2zm0-3H7V6h2v2zm3 6h-2V9h2v5zm0-6h-2V6h2v2zm0-3H4V2h8v3z"],
    "calendar": ["M11 3c.6 0 1-.5 1-1V1c0-.6-.4-1-1-1s-1 .4-1 1v1c0 .5.4 1 1 1zm3-2h-1v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H6v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h13c.6 0 1-.4 1-1V2c0-.6-.5-1-1-1zM5 13H2v-3h3v3zm0-4H2V6h3v3zm4 4H6v-3h3v3zm0-4H6V6h3v3zm4 4h-3v-3h3v3zm0-4h-3V6h3v3zM4 3c.6 0 1-.5 1-1V1c0-.6-.4-1-1-1S3 .4 3 1v1c0 .5.4 1 1 1z"],
    "camera": ["M15 3h-2.59L10.7 1.29A.956.956 0 0010 1H6c-.28 0-.53.11-.71.29L3.59 3H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h2.56c1.1 1.22 2.67 2 4.44 2s3.34-.78 4.44-2H15c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM3 6H1V5h2v1zm5 6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "caret-down": ["M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z"],
    "caret-left": ["M9.5 4c-.13 0-.24.05-.33.13l-4 3.5c-.1.09-.17.22-.17.37s.07.28.17.37l4 3.5a.495.495 0 00.83-.37v-7c0-.28-.22-.5-.5-.5z"],
    "caret-right": ["M11 8c0-.15-.07-.28-.17-.37l-4-3.5A.495.495 0 006 4.5v7a.495.495 0 00.83.37l4-3.5c.1-.09.17-.22.17-.37z"],
    "caret-up": ["M11.87 9.17s.01 0 0 0l-3.5-4C8.28 5.07 8.15 5 8 5s-.28.07-.37.17l-3.5 4a.495.495 0 00.37.83h7a.495.495 0 00.37-.83z"],
    "cargo-ship": ["M10 1h3a1 1 0 011 1v2h-4V1zM2.25 4a.25.25 0 00-.25.25V9H.883a.5.5 0 00-.429.757l1.072 1.787c.207.344.477.638.791.87A9.76 9.76 0 011 12.5a.5.5 0 000 1c2.067 0 3.414-.543 4.161-.917.55.373 1.505.917 2.839.917 1.32 0 2.27-.533 2.822-.905l.004.002c.196.105.48.24.856.374.75.268 1.857.529 3.318.529a.5.5 0 000-1c-.326 0-.63-.014-.916-.039.47-.328.848-.79 1.07-1.347l.572-1.428A.5.5 0 0015.26 9H4V4.25A.25.25 0 003.75 4h-1.5zm2.714 9.56a.5.5 0 01.527.033c.455.325 1.277.907 2.509.907s2.054-.582 2.51-.907a.5.5 0 01.579-.001l.006.004.036.023c.034.022.09.055.168.097.154.082.394.197.72.313.649.232 1.642.471 2.981.471a.5.5 0 010 1c-1.46 0-2.568-.261-3.318-.53a6.316 6.316 0 01-.856-.373l-.004-.002c-.552.372-1.502.905-2.822.905-1.334 0-2.289-.544-2.839-.917-.747.374-2.094.917-4.161.917a.5.5 0 010-1c2.129 0 3.384-.63 3.964-.94zM14 5h-4v3h3a1 1 0 001-1V5zM5 2a1 1 0 011-1h3v3H5V2zm4 3H5v2a1 1 0 001 1h3V5z"],
    "cell-tower": ["M8.97 6.76c-.01-.05-.04-.08-.06-.13-.02-.05-.03-.1-.05-.15.08-.14.14-.3.14-.48 0-.55-.45-1-1-1s-1 .45-1 1c0 .18.06.34.14.48-.03.05-.03.1-.05.15-.02.05-.05.08-.06.13l-2 8c-.13.54.19 1.08.73 1.21a.995.995 0 001.21-.73L7.53 13h.94l.56 2.24a1 1 0 001.94-.48l-2-8zM3.72 1.7C4.1 1.3 4.09.67 3.7.28S2.67-.09 2.28.3c-3.05 3.12-3.05 8.28 0 11.4a.996.996 0 101.43-1.39c-2.28-2.35-2.28-6.27.01-8.61zM11.6 3.2c-.44-.33-1.07-.24-1.4.2-.33.44-.24 1.07.2 1.4.43.32.53 1.96-.04 2.43-.42.35-.48.98-.13 1.41.35.42.98.48 1.41.13 1.59-1.33 1.39-4.5-.04-5.57z",
        "M13.72.3c-.39-.4-1.02-.4-1.41-.02s-.41 1.02-.03 1.42c2.29 2.34 2.29 6.26 0 8.6-.39.39-.38 1.03.02 1.41s1.03.38 1.41-.02c3.05-3.11 3.05-8.27.01-11.39zM5.4 7.23c-.57-.47-.47-2.11-.04-2.43.44-.33.53-.96.2-1.4s-.96-.53-1.4-.2c-1.44 1.07-1.63 4.24-.04 5.57.42.35 1.05.3 1.41-.13.35-.42.29-1.06-.13-1.41z"],
    "changes": ["M8.29 7.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L13 7.59V1c0-.55-.45-1-1-1s-1 .45-1 1v6.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42zM14.5 13h-13c-.83 0-1.5.67-1.5 1.5S.67 16 1.5 16h13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zM1 5c.28 0 .53-.11.71-.29L3 3.41V10c0 .55.45 1 1 1s1-.45 1-1V3.41L6.29 4.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3C4.53.11 4.28 0 4 0s-.53.11-.71.29l-3 3A1.003 1.003 0 001 5z"],
    "chart": ["M0 15c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V9.4L0 11v4zm6-5.5V15c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-5l-1 1-3-1.5zM13 7l-1 1v7c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V7.88c-.26.07-.58.12-1 .12-1.96 0-2-1-2-1zm2-6h-3c-.55 0-1 .45-1 1s.45 1 1 1h.59L8.8 6.78 5.45 5.11v.01C5.31 5.05 5.16 5 5 5s-.31.05-.44.11V5.1l-4 2v.01C.23 7.28 0 7.61 0 8c0 .55.45 1 1 1 .16 0 .31-.05.44-.11v.01L5 7.12 8.55 8.9v-.01c.14.06.29.11.45.11.28 0 .53-.11.71-.29L14 4.41V5c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "chat": ["M6 10c-1.1 0-2-.9-2-2V3H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1v2a1.003 1.003 0 001.71.71L5.41 13H10c.55 0 1-.45 1-1v-1.17l-.83-.83H6zm9-10H6c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "chevron-backward": ["M7.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L6 6.59V4c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V9.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L7.41 8z"],
    "chevron-down": ["M12 5c-.28 0-.53.11-.71.29L8 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 5z"],
    "chevron-forward": ["M10 3c-.55 0-1 .45-1 1v2.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L7.59 8 4.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L9 9.41V12c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "chevron-left": ["M7.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C5.11 7.47 5 7.72 5 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L7.41 8z"],
    "chevron-right": ["M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "chevron-up": ["M12.71 9.29l-4-4C8.53 5.11 8.28 5 8 5s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 7.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "circle": ["M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"],
    "circle-arrow-down": ["M11 7c-.28 0-.53.11-.71.29L9 8.59V5c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0011 7zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"],
    "circle-arrow-left": ["M11 7H7.41L8.7 5.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C4.11 7.47 4 7.72 4 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L7.41 9H11c.55 0 1-.45 1-1s-.45-1-1-1zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"],
    "circle-arrow-right": ["M8.71 4.29a1.003 1.003 0 00-1.42 1.42L8.59 7H5c-.55 0-1 .45-1 1s.45 1 1 1h3.59L7.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"],
    "circle-arrow-up": ["M8.71 4.29C8.53 4.11 8.28 4 8 4s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L7 7.41V11c0 .55.45 1 1 1s1-.45 1-1V7.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"],
    "citation": ["M15.02 5c0-1.66-1.34-3-3-3s-3 1.34-3 3a2.996 2.996 0 003.6 2.94C12.1 9.76 11.14 11 10.02 11c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5-3.13 5-7 0-.2-.02-.39-.04-.58.01-.14.04-.28.04-.42zm-11-3c-1.66 0-3 1.34-3 3a2.996 2.996 0 003.6 2.94C4.1 9.76 3.14 11 2.02 11c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5-3.13 5-7 0-.2-.02-.39-.04-.58.01-.14.04-.28.04-.42 0-1.66-1.35-3-3-3z"],
    "clean": ["M12 8l-1.2 2.796-2.8 1.2 2.8 1.197L12 16l1.2-2.807L16 12l-2.8-1.204zM5 0L3.5 3.5 0 4.995 3.5 6.5 5 10l1.5-3.5L10 5 6.5 3.5z"],
    "clip": ["M0 1a1 1 0 011-1h4a1 1 0 010 2H2v3a1 1 0 01-2 0V1zm1 15a1 1 0 01-1-1v-4a1 1 0 112 0v3h3a1 1 0 110 2H1zm14 0a1 1 0 001-1v-4a1 1 0 10-2 0v3h-3a1 1 0 100 2h4zm0-16a1 1 0 011 1v4a1 1 0 11-2 0V2h-3a1 1 0 110-2h4zM8 11a3 3 0 100-6 3 3 0 000 6z"],
    "clipboard": ["M11 2c0-.55-.45-1-1-1h.22C9.88.4 9.24 0 8.5 0S7.12.4 6.78 1H7c-.55 0-1 .45-1 1v1h5V2zm2 0h-1v2H5V2H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "cloud": ["M12 6c-.03 0-.07 0-.1.01A5 5 0 002 7c0 .11.01.22.02.33A3.51 3.51 0 000 10.5C0 12.43 1.57 14 3.5 14H12c2.21 0 4-1.79 4-4s-1.79-4-4-4z"],
    "cloud-download": ["M11 11c-.28 0-.53.11-.71.29L9 12.59V8c0-.55-.45-1-1-1s-1 .45-1 1v4.59L5.71 11.3A.965.965 0 005 11a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0011 11zm1-7c-.03 0-.07 0-.1.01A5 5 0 002 5c0 .11.01.22.02.33A3.51 3.51 0 000 8.5c0 1.41.84 2.61 2.03 3.17C2.2 10.17 3.46 9 5 9c.06 0 .13.02.19.02C5.07 8.7 5 8.36 5 8c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .36-.07.7-.19 1.02.06 0 .13-.02.19-.02 1.48 0 2.7 1.07 2.95 2.47A3.964 3.964 0 0016 8c0-2.21-1.79-4-4-4z"],
    "cloud-upload": ["M8.71 7.29C8.53 7.11 8.28 7 8 7s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L7 10.41V15c0 .55.45 1 1 1s1-.45 1-1v-4.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM12 4c-.03 0-.07 0-.1.01A5 5 0 002 5c0 .11.01.22.02.33a3.495 3.495 0 00.07 6.37c-.05-.23-.09-.46-.09-.7 0-.83.34-1.58.88-2.12l3-3a2.993 2.993 0 014.24 0l3 3c.54.54.88 1.29.88 2.12 0 .16-.02.32-.05.47C15.17 10.78 16 9.5 16 8c0-2.21-1.79-4-4-4z"],
    "code": ["M15.71 7.29l-3-3a1.003 1.003 0 00-1.42 1.42L13.59 8l-2.29 2.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM5 5a1.003 1.003 0 00-1.71-.71l-3 3C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L2.41 8 4.7 5.71c.19-.18.3-.43.3-.71zm4-3c-.48 0-.87.35-.96.81l-2 10c-.01.06-.04.12-.04.19 0 .55.45 1 1 1 .48 0 .87-.35.96-.81l2-10c.01-.06.04-.12.04-.19 0-.55-.45-1-1-1z"],
    "code-block": ["M15 3h-2V2c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H7V2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-8.29 8.29a1.003 1.003 0 01-1.42 1.42l-3-3C2.11 9.53 2 9.28 2 9s.11-.53.29-.71l3-3a1.003 1.003 0 011.42 1.42L4.41 9l2.3 2.29zm7-1.58l-3 3a1.003 1.003 0 01-1.42-1.42L11.59 9l-2.3-2.29a1.003 1.003 0 011.42-1.42l3 3c.18.18.29.43.29.71s-.11.53-.29.71z"],
    "cog": ["M15.19 6.39h-1.85c-.11-.37-.27-.71-.45-1.04l1.36-1.36c.31-.31.31-.82 0-1.13l-1.13-1.13a.803.803 0 00-1.13 0l-1.36 1.36c-.33-.17-.67-.33-1.04-.44V.79c0-.44-.36-.8-.8-.8h-1.6c-.44 0-.8.36-.8.8v1.86c-.39.12-.75.28-1.1.47l-1.3-1.3c-.3-.3-.79-.3-1.09 0L1.82 2.91c-.3.3-.3.79 0 1.09l1.3 1.3c-.2.34-.36.7-.48 1.09H.79c-.44 0-.8.36-.8.8v1.6c0 .44.36.8.8.8h1.85c.11.37.27.71.45 1.04l-1.36 1.36c-.31.31-.31.82 0 1.13l1.13 1.13c.31.31.82.31 1.13 0l1.36-1.36c.33.18.67.33 1.04.44v1.86c0 .44.36.8.8.8h1.6c.44 0 .8-.36.8-.8v-1.86c.39-.12.75-.28 1.1-.47l1.3 1.3c.3.3.79.3 1.09 0l1.09-1.09c.3-.3.3-.79 0-1.09l-1.3-1.3c.19-.35.36-.71.48-1.1h1.85c.44 0 .8-.36.8-.8v-1.6a.816.816 0 00-.81-.79zm-7.2 4.6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"],
    "collapse-all": ["M7.29 6.71c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L8 4.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4zm1.42 2.58C8.53 9.11 8.28 9 8 9s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 11.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4z"],
    "column-layout": ["M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 13H2V3h2v10zm3 0H5V3h2v10zm7 0H8V3h6v10z"],
    "comment": ["M14 1H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2v3a1.003 1.003 0 001.71.71L8.41 12H14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM3.5 8C2.67 8 2 7.33 2 6.5S2.67 5 3.5 5 5 5.67 5 6.5 4.33 8 3.5 8zm4 0C6.67 8 6 7.33 6 6.5S6.67 5 7.5 5 9 5.67 9 6.5 8.33 8 7.5 8zm4 0c-.83 0-1.5-.67-1.5-1.5S10.67 5 11.5 5s1.5.67 1.5 1.5S12.33 8 11.5 8z"],
    "comparison": ["M7.99-.01c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1v-14c0-.55-.45-1-1-1zm-3 3h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm10 0h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-4v-2h4v2zm0 3h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-4v-2h4v2zm-10-3h-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"],
    "compass": ["M12 8c0 .14-.03.27-.08.39l-3 6.99c-.15.37-.51.62-.92.62s-.77-.25-.92-.61l-3-6.99a1.006 1.006 0 010-.79l3-6.99C7.23.25 7.59 0 8 0s.77.25.92.61l3 6.99c.05.13.08.26.08.4zM8 3.54L6.09 8h3.82L8 3.54z"],
    "compressed": ["M15.93 5.63v-.02L13.94.63C13.78.26 13.42 0 13 0H3c-.42 0-.78.26-.93.63L.08 5.61l-.01.02C.03 5.74 0 5.87 0 6v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.13-.03-.26-.07-.37zM9 2h3.32l1.2 3H9V2zM3.68 2H7v3H2.48l1.2-3zM14 14H2V7h5v2.59l-1.29-1.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L9 9.59V7h5v7z"],
    "confirm": ["M8.7 4.29a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l5-5a1.003 1.003 0 00-1.42-1.42l-4.29 4.3L8.7 4.29zm5.22 3.01c.03.23.07.45.07.69 0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6c.81 0 1.59.17 2.3.46l1.5-1.5A7.998 7.998 0 00-.01 7.99c0 4.42 3.58 8 8 8s8-3.58 8-8c0-.83-.13-1.64-.36-2.39l-1.71 1.7z"],
    "console": ["M15 15H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM14 5H2v8h12V5zM4 6c.28 0 .53.11.71.29l2 2c.18.18.29.43.29.71s-.11.53-.29.71l-2 2a1.003 1.003 0 01-1.42-1.42L4.59 9l-1.3-1.29A1.003 1.003 0 014 6zm5 4h3c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1z"],
    "contrast": ["M15.2 6.4h-1.44c-.13-.47-.32-.92-.56-1.34L14.26 4c.31-.31.31-.82 0-1.13l-1.13-1.13a.803.803 0 00-1.13 0L10.94 2.8c-.42-.24-.86-.42-1.34-.56V.8c0-.44-.36-.8-.8-.8H7.2c-.44 0-.8.36-.8.8v1.44c-.5.14-.96.34-1.4.59l-1-1c-.3-.3-.79-.3-1.09 0L1.83 2.91c-.3.3-.3.79 0 1.09l1 1c-.25.44-.45.9-.59 1.4H.8c-.44 0-.8.36-.8.8v1.6c0 .44.36.8.8.8h1.44c.13.47.32.92.56 1.34L1.74 12c-.31.31-.31.82 0 1.13l1.13 1.13c.31.31.82.31 1.13 0l1.06-1.06c.42.24.86.42 1.34.56v1.44c0 .44.36.8.8.8h1.6c.44 0 .8-.36.8-.8v-1.44c.5-.14.96-.33 1.4-.59l1 1c.3.3.79.3 1.09 0l1.09-1.09c.3-.3.3-.79 0-1.09l-1-1c.25-.43.45-.9.59-1.4h1.44c.44 0 .8-.36.8-.8V7.2a.818.818 0 00-.81-.8zM8 12c-2.21 0-4-1.79-4-4s1.79-4 4-4v8z"],
    "control": ["M13 8H8v5h5V8zm0-5H8v4h5V3zm2-3H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V2h12v12zM7 3H3v10h4V3z"],
    "credit-card": ["M14.99 2.95h-14c-.55 0-1 .45-1 1v1h16v-1c0-.55-.45-1-1-1zm-15 10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-6h-16v6zm5.5-2h5c.28 0 .5.22.5.5s-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5s.23-.5.5-.5zm-3 0h1c.28 0 .5.22.5.5s-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5s.23-.5.5-.5z"],
    "cross": ["M9.41 8l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L8 6.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L6.59 8 3.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L8 9.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L9.41 8z"],
    "crown": ["M2 6l3 2 3-4 3 4 3-2-1 6H3L2 6zm6-5a1 1 0 110 2 1 1 0 010-2zM1 3a1 1 0 110 2 1 1 0 010-2zm14 0a1 1 0 110 2 1 1 0 010-2zM3 13h10v2H3v-2z"],
    "cube": ["M14.194 3.54L8 7.41 1.806 3.54 7.504.283a1 1 0 01.992 0l5.698 3.255zm.75.71a1 1 0 01.056.33v6.84a1 1 0 01-.504.868L8.5 15.714V8.277l6.444-4.027zm-13.888 0L7.5 8.277v7.437l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33z"],
    "cube-add": ["M14 2h1a1 1 0 010 2h-1v1a1 1 0 01-2 0V4h-1a1 1 0 010-2h1V1a1 1 0 012 0v1zM9.136.65a3.001 3.001 0 00.992 5.222c.018.058.038.115.059.172L8 7.41 1.806 3.54 7.504.283a1 1 0 01.992 0l.64.365zM15 7.235v4.184a1 1 0 01-.504.868L8.5 15.714V8.277l2.187-1.367A2.994 2.994 0 0013 8c.768 0 1.47-.289 2-.764zM1.056 4.25L7.5 8.277v7.437l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33z"],
    "cube-remove": ["M10.365 5.933L8 7.41 1.806 3.54 7.504.283a1 1 0 01.992 0l.64.365a3.001 3.001 0 001.228 5.283zM15 6v5.42a1 1 0 01-.504.868L8.5 15.714V8.277L12.143 6H15zM1.056 4.25L7.5 8.277v7.437l-5.996-3.426A1 1 0 011 11.42V4.58a1 1 0 01.056-.33zM11 2h4a1 1 0 010 2h-4a1 1 0 010-2z"],
    "curved-range-chart": ["M15 12H3.12l1.81-1.39c1.73 1.01 5.53-.03 9.08-2.61l-1.22-1.5C10.3 8.3 7.86 9.37 6.65 9.29L14.3 3.4l-.6-.8-7.83 6.03c-.01-1.07 1.8-3.19 4.47-5.13L9.12 2C5.38 4.7 3.34 8.1 4.25 9.87L2 11.6V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "cut": ["M13 2s.71-1.29 0-2L8.66 5.07l1.05 1.32L13 2zm.07 8c-.42 0-.82.09-1.18.26L3.31 0c-.69.71 0 2 0 2l3.68 5.02-2.77 3.24A2.996 2.996 0 000 13c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.46-.11-.89-.29-1.27L8.1 8.54l2.33 3.19c-.18.39-.29.82-.29 1.27 0 1.66 1.31 3 2.93 3S16 14.66 16 13s-1.31-3-2.93-3zM3 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10.07 0c-.54 0-.98-.45-.98-1s.44-1 .98-1 .98.45.98 1-.44 1-.98 1z"],
    "cycle": ["M13 9a3 3 0 110 6 3 3 0 010-6zM3 9a3 3 0 110 6 3 3 0 010-6zm6.169-5.27l.087.09 1.51 1.746 1.589.549a1 1 0 01.65 1.16l-.032.112a1 1 0 01-1.159.65l-.112-.032-1.843-.636a1 1 0 01-.337-.198l-.092-.093-.959-1.109L7.041 7.5l1.691 1.819a1 1 0 01.26.556L9 10v3a1 1 0 01-1.993.117L7 13l-.001-2.608-2.056-2.211a1 1 0 01-.081-1.264l.082-.1 2.825-3.026a1 1 0 011.4-.061zM13 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-10 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11 1a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"],
    "dashboard": ["M5 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM4 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-2 6c0 1.1.9 2 2 2s2-.9 2-2c0-.53-2-5-2-5s-2 4.47-2 5zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm4-9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"],
    "data-connection": ["M1 9.52c.889.641 2.308 1.133 4.003 1.354L5 11a5.994 5.994 0 002.664 4.988c-.217.008-.44.012-.664.012-3.215 0-5.846-.85-5.993-1.906L1 14V9.52zM11 6c2.762 0 5 2.238 5 5s-2.238 5-5 5-5-2.238-5-5 2.238-5 5-5zm1 1l-4 5h2.5l-.5 3 4-5h-2.5l.5-3zm1-3.48v1.822a6.002 6.002 0 00-7.9 4.556l-.248-.03c-2.168-.28-3.733-.966-3.845-1.774L1 8V3.52C2.22 4.4 4.44 5 7 5s4.78-.6 6-1.48zM7 0c3.31 0 6 .9 6 2s-2.69 2-6 2c-3.32 0-6-.9-6-2s2.68-2 6-2z"],
    "data-lineage": ["M1.067 0C.477 0 0 .478 0 1.067V3.2c0 .59.478 1.067 1.067 1.067h2.24a5.342 5.342 0 002.9 3.734 5.337 5.337 0 00-2.9 3.733h-2.24C.477 11.733 0 12.21 0 12.8v2.133C0 15.523.478 16 1.067 16H6.4c.59 0 1.067-.478 1.067-1.067V12.8c0-.59-.478-1.067-1.067-1.067H4.401a4.27 4.27 0 013.92-3.194l.212-.006V9.6c0 .59.478 1.067 1.067 1.067h5.333c.59 0 1.067-.478 1.067-1.067V6.4c0-.59-.478-1.067-1.067-1.067H9.6c-.59 0-1.067.478-1.067 1.067v1.067a4.268 4.268 0 01-4.132-3.2H6.4c.59 0 1.067-.478 1.067-1.067V1.067C7.467.477 6.989 0 6.4 0H1.067z"],
    "database": ["M8 4c3.31 0 6-.9 6-2s-2.69-2-6-2C4.68 0 2 .9 2 2s2.68 2 6 2zm-6-.48V8c0 1.1 2.69 2 6 2s6-.9 6-2V3.52C12.78 4.4 10.56 5 8 5s-4.78-.6-6-1.48zm0 6V14c0 1.1 2.69 2 6 2s6-.9 6-2V9.52C12.78 10.4 10.56 11 8 11s-4.78-.6-6-1.48z"],
    "delete": ["M11.99 4.99a1.003 1.003 0 00-1.71-.71l-2.29 2.3L5.7 4.29a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l2.29 2.29-2.29 2.29A1.003 1.003 0 005.7 11.7l2.29-2.29 2.29 2.29a1.003 1.003 0 001.42-1.42L9.41 7.99 11.7 5.7c.18-.18.29-.43.29-.71zm-4-5c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"],
    "delta": ["M8 0L0 16h16L8 0zM7 5l5 10H2L7 5z"],
    "derive-column": ["M6.08 6.67h-.84c.24-.92.56-1.6.96-2.03.24-.27.48-.4.71-.4.05 0 .08.01.11.04s.04.06.04.1c0 .04-.03.11-.1.21-.06.1-.1.2-.1.29 0 .13.05.24.15.33.1.09.23.14.39.14.17 0 .31-.06.42-.17A.58.58 0 008 4.73c0-.22-.09-.39-.26-.53-.17-.13-.44-.2-.81-.2-.59 0-1.12.16-1.59.48-.48.32-.93.85-1.36 1.59-.15.26-.29.42-.42.49s-.35.11-.64.1l-.19.65h.81l-1.19 4.37c-.2.72-.33 1.16-.4 1.33-.1.24-.26.45-.46.62-.08.07-.18.1-.3.1-.03 0-.06-.01-.08-.03l-.03-.04c0-.02.03-.06.09-.11.06-.06.09-.14.09-.26 0-.13-.05-.23-.14-.32a.6.6 0 00-.4-.13c-.21 0-.38.05-.51.16s-.21.25-.21.4c0 .16.08.3.23.42.16.12.4.18.74.18.53 0 .99-.13 1.4-.39.41-.26.76-.65 1.07-1.19.3-.54.62-1.4.94-2.59l.68-2.53h.82l.2-.63zM15 0H8c-.55 0-1 .45-1 1v2h2V2h5v12H9v-1H7v2c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM8.3 9.94c.18.52.33.89.46 1.13.13.24.28.4.44.51.17.1.37.16.62.16.24 0 .49-.08.74-.25.33-.21.66-.58 1.01-1.09l-.21-.11c-.23.31-.41.5-.52.57a.44.44 0 01-.26.07c-.12 0-.24-.07-.36-.21-.2-.24-.46-.91-.8-2 .3-.49.55-.81.75-.96.15-.11.3-.16.47-.16.06 0 .17.02.34.06.16.04.31.06.43.06.17 0 .31-.06.43-.17.1-.11.16-.25.16-.43 0-.19-.06-.33-.17-.44-.12-.11-.28-.16-.49-.16-.19 0-.37.04-.54.13-.17.09-.39.27-.65.56-.2.21-.48.58-.87 1.11-.15-.66-.41-1.26-.78-1.81l-2.05.33-.04.21c.15-.03.28-.04.39-.04.2 0 .37.08.5.25.21.26.5 1.03.88 2.33-.29.37-.49.61-.6.72-.18.18-.33.3-.44.36-.09.04-.19.07-.3.07-.09 0-.23-.04-.42-.13a.866.866 0 00-.36-.09c-.2 0-.36.06-.49.18a.59.59 0 00-.19.46c0 .17.06.32.18.43.12.11.28.16.48.16.2 0 .38-.04.55-.11.17-.08.39-.24.65-.49.24-.27.6-.66 1.06-1.21z"],
    "desktop": ["M15 0H1C.45 0 0 .45 0 1v10c0 .55.45 1 1 1h4.75l-.5 2H4c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-1.25l-.5-2H15c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 10H2V2h12v8z"],
    "diagnosis": ["M3.2 1a1 1 0 01.117 1.993L3.2 3H3v3a2 2 0 001.85 1.995L5 8a2 2 0 001.995-1.85L7 6V3h-.2a1 1 0 01-.993-.883L5.8 2a1 1 0 01.883-.993L6.8 1H8a1 1 0 01.993.883L9 2v4a4.002 4.002 0 01-3.007 3.876v.007L6 10a3 3 0 005.995.176L12 10V7.792a2.5 2.5 0 112 0V10a5 5 0 01-10 0c0-.042.003-.084.008-.125A4 4 0 011.005 6.2L1 6V2a1 1 0 01.883-.993L2 1h1.2z"],
    "diagram-tree": ["M15 8v3h-2V9H9v2H7V9H3v2H1V8a1 1 0 011-1h5V5h2v2h5a1 1 0 011 1zM1 12h2a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1zm12 0h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm-6 0h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1zM7 0h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1z"],
    "direction-left": ["M16 1.99l-16 6 16 6-4-6z"],
    "direction-right": ["M16 7.99l-16-6 4 6-4 6z"],
    "disable": ["M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm-6 8c0-3.31 2.69-6 6-6 1.3 0 2.49.42 3.47 1.12l-8.35 8.35c-.7-.98-1.12-2.17-1.12-3.47zm6 6c-1.3 0-2.49-.42-3.47-1.12l8.35-8.35c.7.98 1.12 2.17 1.12 3.47 0 3.32-2.68 6-6 6z"],
    "document": ["M9 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5L9 0zm3 14H4V2h4v4h4v8z"],
    "document-open": ["M6 12c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1h1.59L1.3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L6 10.41V12zm4-12H4c-.55 0-1 .45-1 1v4h2V2h4v4h4v8H5.24l-1.8 1.8c.16.12.35.2.56.2h10c.55 0 1-.45 1-1V5l-5-5z"],
    "document-share": ["M10 14H2V2h4v4h1c0-.83.36-1.55.91-2.09l-.03-.03.9-.9C8.3 2.45 8 1.77 8 1L7 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V8.22c-.53.48-1.23.78-2 .78v5zm5-14h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.29a1.003 1.003 0 001.42 1.42L14 3.41V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "dollar": ["M12.83 9.51c-.1-.3-.25-.58-.45-.84s-.45-.49-.75-.7c-.3-.2-.65-.36-1.05-.48-.16-.04-.43-.11-.8-.2-.35-.09-.73-.18-1.12-.28-.39-.1-.74-.19-1.06-.27-.31-.08-.49-.12-.54-.13-.43-.12-.78-.29-1.05-.52-.27-.23-.4-.55-.4-.95 0-.29.07-.53.21-.72.14-.19.32-.34.54-.46.22-.11.46-.19.72-.24.26-.05.52-.08.77-.08.74 0 1.35.15 1.83.46.48.3.75.83.81 1.56h2.14c0-.6-.13-1.13-.38-1.58-.25-.45-.59-.84-1.02-1.15-.43-.31-.93-.54-1.49-.7-.24-.06-.49-.1-.75-.14V1c0-.55-.45-1-1-1s-1 .45-1 1v1.08c-.23.03-.46.07-.68.13-.54.13-1.02.34-1.44.61-.42.28-.76.63-1.02 1.05-.26.43-.39.93-.39 1.5 0 .3.04.59.13.88.09.29.23.56.44.82.21.26.48.49.83.7.35.21.79.38 1.31.51.85.21 1.56.38 2.14.52.58.13 1.08.28 1.52.42.25.09.48.23.69.44.21.21.32.53.32.97 0 .21-.05.42-.14.63-.09.21-.24.39-.45.55-.21.16-.47.29-.81.39-.33.1-.73.15-1.2.15-.43 0-.84-.05-1.21-.14-.37-.09-.7-.24-.99-.43-.29-.2-.51-.45-.67-.76-.16-.31-.24-.68-.24-1.12H3c.01.71.15 1.32.43 1.84.27.52.64.94 1.1 1.27.46.33.99.58 1.61.74.27.07.56.12.85.16V15c0 .55.45 1 1 1s1-.45 1-1v-1.05c.3-.03.61-.08.9-.15.58-.13 1.1-.34 1.56-.63.46-.29.83-.66 1.11-1.11.28-.45.42-1 .42-1.64 0-.31-.05-.61-.15-.91z"],
    "dot": ["M8 5a3 3 0 100 6 3 3 0 100-6z"],
    "double-caret-horizontal": ["M13.71 7.29l-3-3A1.003 1.003 0 009 5v6a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM6 4c-.28 0-.53.11-.71.29l-3 3C2.11 7.47 2 7.72 2 8c0 .28.11.53.29.71l3 3A1.003 1.003 0 007 11V5c0-.55-.45-1-1-1z"],
    "double-caret-vertical": ["M5 7h6a1.003 1.003 0 00.71-1.71l-3-3C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-3 3A1.003 1.003 0 005 7zm6 2H5a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0011 9z"],
    "double-chevron-down": ["M7.29 8.71c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L8 6.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4zM12 8c-.28 0-.53.11-.71.29L8 11.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 8z"],
    "double-chevron-left": ["M4.41 8L7.7 4.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C2.11 7.47 2 7.72 2 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L4.41 8zm5 0l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C7.11 7.47 7 7.72 7 8c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L9.41 8z"],
    "double-chevron-right": ["M9 8c0-.28-.11-.53-.29-.71l-4-4a1.003 1.003 0 00-1.42 1.42L6.59 8 3.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4C8.89 8.53 9 8.28 9 8zm4.71-.71l-4-4a1.003 1.003 0 00-1.42 1.42L11.59 8 8.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "double-chevron-up": ["M4 8c.28 0 .53-.11.71-.29L8 4.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-4 4A1.003 1.003 0 004 8zm4.71-.71C8.53 7.11 8.28 7 8 7s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 9.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4z"],
    "doughnut-chart": ["M11.86 7h4.05C15.45 3.39 12.61.52 9 .07v4.07A4 4 0 0111.86 7zM12 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4V0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8h-4z"],
    "download": ["M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM11.7 9.7l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-3-3A1.003 1.003 0 015.7 8.28l1.29 1.29V3.99c0-.55.45-1 1-1s1 .45 1 1v5.59l1.29-1.29a1.003 1.003 0 011.71.71c0 .27-.11.52-.29.7z"],
    "drag-handle-horizontal": ["M2 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm8-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-4-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"],
    "drag-handle-vertical": ["M6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-6c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"],
    "draw": ["M14.9 11c-.3 0-.5.1-.7.3l-3 3c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3l3-3c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1zm-1-1v-.2l-1-5c-.1-.3-.3-.6-.6-.7l-11-4-.3.3 5.8 5.8c.2-.1.4-.2.6-.2.8 0 1.5.7 1.5 1.5S8.3 9 7.4 9s-1.5-.7-1.5-1.5c0-.2.1-.4.2-.6L.3 1.1l-.3.3 4 11c.1.3.4.6.7.6l5 1h.2c.3 0 .5-.1.7-.3l3-3c.2-.2.3-.4.3-.7z"],
    "drawer-left": ["M7 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h6zM6 2H2v12h4V2zm2 5h4.59L11.3 5.71A.965.965 0 0111 5a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42L12.59 9H8V7z"],
    "drawer-left-filled": ["M1 0h6a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm7 7h4.59L11.3 5.71A.965.965 0 0111 5a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42L12.59 9H8V7z"],
    "drawer-right": ["M15 0a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1h6zm-1 2h-4v12h4V2zM8 7H3.41L4.7 5.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 9H8V7z"],
    "drawer-right-filled": ["M9 0h6a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1zM8 7H3.41L4.7 5.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 9H8V7z"],
    "drive-time": ["M15.12 4.76h-1.05l-.76-2.12c-.19-.53-.76-1.08-1.27-1.24 0 0-1.32-.4-4.04-.4-2.72 0-4.04.4-4.04.4-.5.16-1.07.71-1.26 1.24l-.77 2.12H.88c-.48 0-.88.42-.88.94s.4.94.88.94h.38L1 7c-.03.69 0 1.44 0 2v5c0 .66.38 1 1 1s1-.34 1-1v-1h10v1c0 .66.38 1 1 1s1-.34 1-1V9c0-.56-.01-1.37 0-2l-.26-.37h.38c.48 0 .88-.42.88-.93 0-.52-.4-.94-.88-.94zM5 10H3V8h2v2zm8 0h-2V8h2v2zm0-4H3c-.18 0-.06-.82 0-1l.73-1.63C3.79 3.19 3.82 3 4 3h8c.18 0 .21.19.27.37L13 5c.06.18.18 1 0 1z"],
    "duplicate": ["M15 0H5c-.55 0-1 .45-1 1v2h2V2h8v7h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10H2V6h8v8z"],
    "edit": ["M3.25 10.26l2.47 2.47 6.69-6.69-2.46-2.48-6.7 6.7zM.99 14.99l3.86-1.39-2.46-2.44-1.4 3.83zm12.25-14c-.48 0-.92.2-1.24.51l-1.44 1.44 2.47 2.47 1.44-1.44c.32-.32.51-.75.51-1.24.01-.95-.77-1.74-1.74-1.74z"],
    "eject": ["M4 9h8a1.003 1.003 0 00.71-1.71l-4-4C8.53 3.11 8.28 3 8 3s-.53.11-.71.29l-4 4A1.003 1.003 0 004 9zm8 1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1z"],
    "emoji": ["M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zM4 8c.228 2.262 2 4 4 4 1.938 0 3.77-1.738 3.984-3.8L12 8h1c-.128 2.888-2.317 5-5 5a5 5 0 01-4.995-4.783L3 8h1zm2-3a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z"],
    "endorsed": ["M15.86 7.5l-.81-1.42V4.5c0-.36-.19-.68-.49-.87l-1.37-.8-.81-1.41c-.19-.31-.51-.49-.86-.49H9.89L8.5.14a.948.948 0 00-1 0l-1.39.8H4.52a1 1 0 00-.86.49l-.8 1.37-1.44.83c-.3.19-.49.51-.49.87v1.65l-.8 1.37c-.08.15-.13.32-.13.49s.05.34.14.49l.8 1.37v1.65c0 .36.19.68.49.87l1.42.81.8 1.37c.19.31.51.49.86.49H6.1l1.39.8c.15.09.32.14.48.14s.34-.05.49-.14l1.39-.8h1.63a1 1 0 00.86-.49l.81-1.41 1.37-.8c.3-.19.49-.51.49-.87V9.93l.81-1.42a.89.89 0 00.04-1.01zm-4.12-.82l-4.01 4.01c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-2-2c-.18-.19-.3-.44-.3-.71a1.003 1.003 0 011.71-.71l1.3 1.3 3.3-3.3a1.003 1.003 0 011.71.71.95.95 0 01-.29.7z"],
    "envelope": ["M0 3.06v9.88L4.94 8 0 3.06zM14.94 2H1.06L8 8.94 14.94 2zm-6.41 8.53c-.14.14-.32.22-.53.22s-.39-.08-.53-.22L6 9.06 1.06 14h13.88L10 9.06l-1.47 1.47zM11.06 8L16 12.94V3.06L11.06 8z"],
    "equals": ["M3 5h10a1 1 0 010 2H3a1 1 0 110-2zm0 4h10a1 1 0 010 2H3a1 1 0 010-2z"],
    "eraser": ["M8.06 13.91l7.63-7.44c.41-.4.41-1.05 0-1.45L10.86.3c-.41-.4-1.08-.4-1.49 0L.31 9.13c-.41.4-.41 1.05 0 1.45l5.58 5.44h8.12v-.01c.55 0 1-.45 1-1s-.45-1-1-1H7.96l.1-.1zm-2.17.06L1.67 9.85l4.22-4.11 4.22 4.11-4.22 4.12z"],
    "error": ["M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 13h-2v-2h2v2zm0-3h-2v-7h2v7z"],
    "euro": ["M6.52 3.18c.51-.27 1.12-.4 1.83-.4.48 0 .91.06 1.27.18.37.12.68.29.96.51.18.14.3.33.44.51l1.53-1.53c-.12-.11-.23-.22-.36-.32a5.61 5.61 0 00-1.74-.83c-.66-.2-1.36-.3-2.1-.3-.99 0-1.88.18-2.66.53-.79.35-1.45.82-2 1.41-.55.58-.96 1.27-1.26 2.06H2c-.55 0-1 .45-1 1s.45 1 1 1h.04c-.01.17-.04.33-.04.5 0 .17.03.33.04.5H2c-.55 0-1 .45-1 1s.45 1 1 1h.43c0 .01 0 .02.01.02a6.2 6.2 0 001.25 2.07 5.77 5.77 0 002 1.4c.78.34 1.67.51 2.66.51.81 0 1.54-.12 2.21-.36.67-.24 1.25-.59 1.75-1.03l.03-.03-1.55-1.33c-.01.01-.02.03-.03.04-.29.3-.63.53-1.02.69-.4.17-.85.25-1.37.25-.71 0-1.32-.13-1.83-.4s-.93-.62-1.25-1.07c-.19-.24-.34-.49-.46-.76H9c.55 0 1-.45 1-1s-.45-1-1-1H4.35c-.01-.17-.03-.33-.03-.5 0-.17.02-.34.03-.5H10c.55 0 1-.45 1-1s-.45-1-1-1H4.83c.13-.27.27-.52.44-.76.32-.44.74-.8 1.25-1.06zM14 8.98v0z"],
    "exchange": ["M1.99 5.99c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.89-2-2-2zm4.15 1.86a.495.495 0 10.7-.7L5.7 5.99h5.79c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H5.7l1.15-1.15a.495.495 0 10-.7-.7l-2 2c-.1.09-.16.21-.16.35s.06.26.15.35l2 2.01zm7.85-1.86c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.89-2-2-2zM9.85 8.14a.533.533 0 00-.36-.15.495.495 0 00-.35.85l1.15 1.15h-5.8c-.28 0-.5.22-.5.5s.22.5.5.5h5.79l-1.15 1.15a.495.495 0 10.7.7l2-2c.09-.09.15-.22.15-.35s-.06-.26-.15-.35l-1.98-2z"],
    "exclude-row": ["M0 10a1.003 1.003 0 001.71.71L3 9.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 8 5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L3 6.59l-1.29-1.3A1.003 1.003 0 00.29 6.71L1.59 8 .29 9.29C.11 9.47 0 9.72 0 10zm1-7h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 10H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-1-7H9c-1.1 0-2 .9-2 2s.9 2 2 2h5c1.1 0 2-.9 2-2s-.9-2-2-2z"],
    "expand-all": ["M4 7c.28 0 .53-.11.71-.29L8 3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-4 4A1.003 1.003 0 004 7zm8 2c-.28 0-.53.11-.71.29L8 12.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 9z"],
    "export": ["M4 6c.28 0 .53-.11.71-.29L7 3.41V11c0 .55.45 1 1 1s1-.45 1-1V3.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4C8.53.11 8.28 0 8 0s-.53.11-.71.29l-4 4A1.003 1.003 0 004 6zm11 5c-.55 0-1 .45-1 1v2H2v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1z"],
    "eye-off": ["M16 7.97v-.02-.01-.02-.02a.672.672 0 00-.17-.36c-.49-.63-1.07-1.2-1.65-1.72l-3.16 2.26a2.978 2.978 0 01-2.98 2.9c-.31 0-.6-.06-.88-.15L5.09 12.3c.44.19.9.36 1.37.47.97.23 1.94.24 2.92.05.88-.17 1.74-.54 2.53-.98 1.25-.7 2.39-1.67 3.38-2.75.18-.2.37-.41.53-.62.09-.1.15-.22.17-.36v-.02-.02-.01-.02-.03c.01-.02.01-.03.01-.04zm-.43-4.17c.25-.18.43-.46.43-.8 0-.55-.45-1-1-1-.22 0-.41.08-.57.2l-.01-.01-2.67 1.91c-.69-.38-1.41-.69-2.17-.87a6.8 6.8 0 00-2.91-.05c-.88.18-1.74.54-2.53.99-1.25.7-2.39 1.67-3.38 2.75-.18.2-.37.41-.53.62-.23.29-.23.63-.01.92.51.66 1.11 1.25 1.73 1.79.18.16.38.29.56.44l-2.09 1.5.01.01c-.25.18-.43.46-.43.8 0 .55.45 1 1 1 .22 0 .41-.08.57-.2l.01.01 14-10-.01-.01zm-10.41 5a3.03 3.03 0 01-.11-.8 2.99 2.99 0 012.99-2.98c.62 0 1.19.21 1.66.53L5.16 8.8z"],
    "eye-on": ["M10.29 6.7c.18.18.43.29.71.29s.53-.11.71-.29l4-4c.17-.18.29-.43.29-.7a1.003 1.003 0 00-1.71-.71L11 4.58 9.71 3.29A.997.997 0 009 3c-.55 0-1 .44-1 1a1 1 0 00.3.7l1.99 2zM16 7.96v-.02-.01-.02-.02a.64.64 0 00-.17-.36c-.3-.4-.65-.76-1-1.12l-1.7 1.7c-.55.55-1.3.88-2.13.88-.06 0-.11-.01-.17-.02C10.42 10.15 9.32 11 8.01 11A3.005 3.005 0 016.4 5.46c-.24-.43-.39-.93-.39-1.46 0-.26.04-.5.1-.74-.7.2-1.37.5-2.01.86-1.26.7-2.4 1.68-3.4 2.77-.18.21-.36.41-.53.63-.22.29-.22.64 0 .93.51.67 1.12 1.27 1.73 1.81 1.33 1.17 2.85 2.15 4.53 2.55.97.23 1.95.24 2.92.05.89-.18 1.74-.54 2.54-.99 1.25-.71 2.4-1.69 3.39-2.78.18-.2.37-.41.54-.63.09-.1.15-.23.17-.37v-.02-.02-.01-.02-.03c.01-.01.01-.02.01-.03zM8.01 9c.48 0 .87-.35.96-.81a.55.55 0 01-.07-.09l-.02.01L7.8 7.03c-.45.1-.79.48-.79.96 0 .56.45 1.01 1 1.01z"],
    "eye-open": ["M8.002 7.003a1.003 1.003 0 000 2.005 1.003 1.003 0 000-2.005zm7.988.972v-.02-.01-.02-.02a.675.675 0 00-.17-.36c-.509-.673-1.118-1.264-1.737-1.806-1.328-1.173-2.846-2.155-4.523-2.546a6.702 6.702 0 00-2.925-.06c-.889.18-1.738.541-2.546.992C2.84 4.837 1.692 5.81.694 6.902c-.18.211-.36.411-.53.632a.742.742 0 000 .932c.51.672 1.119 1.264 1.738 1.805 1.328 1.173 2.846 2.156 4.523 2.547.968.23 1.947.24 2.925.04.889-.18 1.738-.542 2.546-.993 1.248-.712 2.397-1.684 3.395-2.777.18-.2.37-.411.54-.632.09-.1.149-.23.169-.36v-.02-.02-.01-.02-.03c0-.01-.01-.01-.01-.02zm-7.988 3.038a2.998 2.998 0 01-2.995-3.008 2.998 2.998 0 012.995-3.008 2.998 2.998 0 012.996 3.008 2.998 2.998 0 01-2.996 3.008z"],
    "fast-backward": ["M14 3c-.24 0-.44.09-.62.23l-.01-.01L9 6.72V4c0-.55-.45-1-1-1-.24 0-.44.09-.62.23v-.01l-5 4 .01.01C2.16 7.41 2 7.68 2 8s.16.59.38.77v.01l5 4 .01-.01c.17.14.37.23.61.23.55 0 1-.45 1-1V9.28l4.38 3.5.01-.01c.17.14.37.23.61.23.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "fast-forward": ["M15 8c0-.32-.16-.59-.38-.77l.01-.01-5-4-.01.01A.987.987 0 009 3c-.55 0-1 .45-1 1v2.72l-4.38-3.5v.01A.987.987 0 003 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .24 0 .44-.09.62-.23l.01.01L8 9.28V12c0 .55.45 1 1 1 .24 0 .44-.09.62-.23l.01.01 5-4-.01-.01c.22-.18.38-.45.38-.77z"],
    "feed": ["M1.99 11.99c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.89-2-2-2zm1-4c-.55 0-1 .45-1 1s.45 1 1 1c1.66 0 3 1.34 3 3 0 .55.45 1 1 1s1-.45 1-1c0-2.76-2.24-5-5-5zm0-4c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7 3.13 7 7 0 .55.45 1 1 1s1-.45 1-1a9 9 0 00-9-9zm0-4c-.55 0-1 .45-1 1s.45 1 1 1c6.08 0 11 4.92 11 11 0 .55.45 1 1 1s1-.45 1-1c0-7.18-5.82-13-13-13z"],
    "feed-subscribed": ["M3 2c1.06 0 2.08.16 3.06.45.13-.71.52-1.32 1.05-1.76C5.82.25 4.44 0 3 0c-.55 0-1 .45-1 1s.45 1 1 1zM2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8.32-6.33a.99.99 0 001.4 0l3.98-3.98c.19-.18.3-.42.3-.7 0-.55-.45-.99-1-.99-.28 0-.52.11-.7.29l-3.28 3.28-1.29-1.29a.99.99 0 00-.7-.29 1 1 0 00-1 .99c0 .27.11.52.29.7l2 1.99zm3.73.53l-.93.93-.02-.02c-.17.17-.35.33-.56.45C13.47 9.16 14 11.02 14 13c0 .55.45 1 1 1s1-.45 1-1c0-2.5-.73-4.82-1.95-6.8zM3 8c-.55 0-1 .45-1 1s.45 1 1 1c1.66 0 3 1.34 3 3 0 .55.45 1 1 1s1-.45 1-1c0-2.76-2.24-5-5-5zm5.91-.91l-.03.03-2-2 .03-.03c-.11-.11-.23-.2-.33-.33A8.9 8.9 0 003 4c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7 3.13 7 7 0 .55.45 1 1 1s1-.45 1-1c0-1.87-.57-3.61-1.55-5.06-.61-.11-1.13-.42-1.54-.85z"],
    "film": ["M15 1h-5v2H6V1H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h5v-2h4v2h5c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 13H2v-2h2v2zm0-3H2V8h2v2zm0-3H2V5h2v2zm0-3H2V2h2v2zm6 6H6V5h4v5zm4 3h-2v-2h2v2zm0-3h-2V8h2v2zm0-3h-2V5h2v2zm0-3h-2V2h2v2z"],
    "filter": ["M13.99.99h-12a1.003 1.003 0 00-.71 1.71l4.71 4.71V14a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V7.41L14.7 2.7a1.003 1.003 0 00-.71-1.71z"],
    "filter-keep": ["M15 10c-.28 0-.53.11-.71.29L12 12.59l-1.29-1.29A.965.965 0 0010 11a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0015 10zm-3-8c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L4 6.41V12a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V6.41l3.71-3.71c.18-.17.29-.42.29-.7z"],
    "filter-list": ["M9 8c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1zm3-6c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L4 6.41V12a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V6.41l3.71-3.71c.18-.17.29-.42.29-.7zm3 8h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm0 3h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "filter-open": ["M15.707 10.293a1 1 0 010 1.414l-3 3c-.63.63-1.707.184-1.707-.707V8c0-.89 1.077-1.337 1.707-.707l3 3zM12 2c0 .28-.11.53-.29.7L8 6.41V10c0 .28-.11.53-.29.71l-2 2A1.003 1.003 0 014 12V6.41L.29 2.71A1.003 1.003 0 011 1h10c.55 0 1 .45 1 1z"],
    "filter-remove": ["M12 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L4 6.41V12a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71V6.41l3.71-3.71c.18-.17.29-.42.29-.7zm2.41 10l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L13 10.59 11.71 9.3A.965.965 0 0011 9a1.003 1.003 0 00-.71 1.71l1.3 1.29-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l1.29-1.3 1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L14.41 12z"],
    "flag": ["M2.99 2.99c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1s1-.45 1-1v-11c0-.55-.45-1-1-1zm0-3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm2 3.03v7.23c2.07-2.11 5.92 1.75 9 0V3.02c-3 2.07-6.94-2.03-9 0z"],
    "flame": ["M9.217 0c0 1.368.368 2.462 1.104 3.282C12.774 5.197 14 7.385 14 9.846c0 2.735-1.472 4.786-4.415 6.154 2.165-2.4 1.84-3.385-.368-6.4-2.342 1.2-1.967 2-1.592 3.6-.786 0-1.5 0-1.875-.4 0 .547.898 2 1.464 3.2-2.943-.82-6.092-5.744-4.988-6.154.736-.273 1.594-.137 2.575.41C3.575 5.333 5.047 1.915 9.217 0z"],
    "flash": ["M4 8c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1zm4-4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S7 .45 7 1v2c0 .55.45 1 1 1zM3.79 5.21a1.003 1.003 0 001.42-1.42l-1.5-1.5a1.003 1.003 0 00-1.42 1.42l1.5 1.5zm.71 5.29c-.28 0-.53.11-.71.29l-1.5 1.5a1.003 1.003 0 001.42 1.42l1.5-1.5a1.003 1.003 0 00-.71-1.71zm7-5c.28 0 .53-.11.71-.29l1.5-1.5a1.003 1.003 0 00-1.42-1.42l-1.5 1.5a1.003 1.003 0 00.71 1.71zm.71 5.29a1.003 1.003 0 00-1.42 1.42l1.5 1.5a1.003 1.003 0 001.42-1.42l-1.5-1.5zM15 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zM8 5C6.34 5 5 6.34 5 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0 3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1z"],
    "floppy-disk": ["M15.71 2.29l-2-2A.997.997 0 0013 0h-1v6H4V0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.28-.11-.53-.29-.71zM14 15H2V9c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v6zM11 1H9v4h2V1z"],
    "flow-branch": ["M10.643 6.595c.22.418.344.894.344 1.399 0 .439-.094.855-.263 1.231l3.265 3.462-.002-1.75a.973.973 0 01.314-.68.99.99 0 011.388.048c.186.2.316.46.3.715l-.009 4.03a.959.959 0 01-.3.68.972.972 0 01-.698.266l-4.053.002a.97.97 0 01-.679-.314 1.031 1.031 0 01.05-1.42.972.972 0 01.698-.266l1.7-.001-3.305-3.35a2.998 2.998 0 01-4.228-1.653H.999a1 1 0 010-2h4.166a2.998 2.998 0 014.06-1.735l3.449-3.268-1.745.002a.979.979 0 01-.631-1.692c.199-.186.459-.316.713-.3l4.025.009c.247.008.493.1.679.3.186.2.274.451.265.7l.002 4.046a.972.972 0 01-.313.68 1.03 1.03 0 01-1.42-.05.973.973 0 01-.266-.7V3.295l-3.34 3.301z"],
    "flow-end": ["M9.702 7.31c.176.176.293.41.293.684a.976.976 0 01-.283.695c-1.888 1.91-2.892 2.918-3.011 3.027-.179.164-.42.284-.693.284a.995.995 0 01-.997-.985c0-.274.112-.541.292-.72.12-.12.624-.551 1.514-1.293H.98c-.536 0-.975-.47-.975-1.008 0-.537.439-.996.975-.996h5.837c-.895-.752-1.4-1.187-1.514-1.304a1.03 1.03 0 01-.292-.705C5.01 4.45 5.464 4 6 4c.272 0 .52.108.695.294A535.7 535.7 0 009.702 7.31zM13 11.002c-1.657 0-3-1.347-3-3.008a3.004 3.004 0 013-3.007c1.657 0 3 1.346 3 3.007a3.004 3.004 0 01-3 3.008z"],
    "flow-linear": ["M4.16 9.002H.977C.44 9.002 0 8.532 0 7.994c0-.537.44-.99.978-.99h3.18A3.01 3.01 0 016.995 5a3.01 3.01 0 012.839 2.004h2.98c-.898-.756-1.404-1.193-1.518-1.31a1.03 1.03 0 01-.293-.705c0-.538.454-.989.992-.989.274 0 .521.108.697.294.118.124 1.122 1.13 3.014 3.016a.96.96 0 01.293.684.975.975 0 01-.284.695l-3.018 3.027a.974.974 0 01-.694.284c-.553 0-1-.447-1-.985 0-.274.117-.545.293-.72l1.518-1.293H9.833A3.01 3.01 0 016.996 11 3.01 3.01 0 014.16 9.002z"],
    "flow-review": ["M5.175 7.004a3.003 3.003 0 012.83-2.001c1.305 0 2.416.835 2.83 2.001h1.985c-.896-.756-1.401-1.193-1.515-1.31a1.03 1.03 0 01-.292-.705c0-.538.453-.989.99-.989a.95.95 0 01.696.294c.117.124 1.12 1.13 3.008 3.016.176.176.293.41.293.684a.976.976 0 01-.283.695l-3.013 3.027a.995.995 0 01-1.691-.702c0-.273.116-.544.292-.72l1.515-1.292h-1.98a3.003 3.003 0 01-2.835 2.016A3.003 3.003 0 015.17 9.002H3.18l1.515 1.292c.176.176.292.447.292.72a.995.995 0 01-1.69.702L.282 8.69A.976.976 0 010 7.994c0-.273.117-.508.293-.684A535.858 535.858 0 003.3 4.294.95.95 0 013.997 4c.537 0 .99.45.99.989 0 .273-.12.528-.292.705-.114.117-.62.554-1.515 1.31h1.995z"],
    "flow-review-branch": ["M10.392 10.647A3.002 3.002 0 016.16 8.995H3.37l1.338 1.318c.172.178.287.41.282.683-.01.536-.524.995-.99.995-.465 0-.63-.187-.747-.294L.281 8.682A.956.956 0 010 7.994a.971.971 0 01.294-.687l3.01-3.028a.973.973 0 01.697-.27c.536.01.998.485.989 1.021a.971.971 0 01-.295.687L3.37 6.997h2.79a3.002 3.002 0 014.106-1.716l2.416-2.277-1.732.004a.99.99 0 01-.679-.329.978.978 0 01.05-1.378c.199-.186.459-.315.714-.3l4.012.005c.248.009.493.1.68.3.185.2.273.45.264.699L15.99 6.05a.973.973 0 01-.314.679 1.03 1.03 0 01-1.421-.048.971.971 0 01-.265-.699V4.29L11.65 6.602c.219.416.343.89.343 1.394 0 .451-.1.88-.279 1.263L14 11.68l-.004-1.73a.982.982 0 01.323-.68.978.978 0 011.378.049c.187.2.316.46.3.714l-.004 4.011a.983.983 0 01-.3.691.972.972 0 01-.7.265l-4.046-.001a.987.987 0 01-.679-.326 1.017 1.017 0 01.048-1.41.972.972 0 01.699-.265h1.693l-2.315-2.35z"],
    "flows": ["M13.5 6a2.5 2.5 0 00-2.45 2h-1.3L5.74 4l-.75.75L8.25 8h-3.3a2.5 2.5 0 100 1h3.3l-3.26 3.25.75.75 4.01-4h1.3a2.5 2.5 0 102.45-3z"],
    "folder-close": ["M-.01 14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7h-16v7zm15-10H7.41L5.7 2.3a.965.965 0 00-.71-.3h-4c-.55 0-1 .45-1 1v3h16V5c0-.55-.45-1-1-1z"],
    "folder-new": ["M10.165 7a3.003 3.003 0 002.827 2 3.003 3.003 0 002.827-2H16v7c0 .55-.45 1-1 1H1.01c-.55 0-1-.45-1-1V7h10.155zM8.76 6H0V3c0-.55.45-1 1-1h1.998c.28 0 .53.11.71.29L5.417 4h2.578c0 .768.29 1.469.765 2zm6.23-3c.55 0 1 .45 1 1s-.45 1-1 1h-.999v1c0 .55-.45 1-1 1-.549 0-.998-.45-.998-1V5h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V2c0-.55.45-1 .999-1 .55 0 1 .45 1 1v1h.999z"],
    "folder-open": ["M2.06 6.69c.14-.4.5-.69.94-.69h11V5c0-.55-.45-1-1-1H6.41l-1.7-1.71A.997.997 0 004 2H1c-.55 0-1 .45-1 1v9.84l2.05-6.15h.01zM16 8c0-.55-.45-1-1-1H4a.99.99 0 00-.94.69l-2 6c-.04.09-.06.2-.06.31 0 .55.45 1 1 1h11c.44 0 .81-.29.94-.69l2-6c.04-.09.06-.2.06-.31z"],
    "folder-shared": ["M8.76 5.98c-.47-.53-.77-1.22-.77-1.99h-.58L5.7 2.29a.965.965 0 00-.71-.3h-4c-.55 0-1 .45-1 1v3h8.76l.01-.01zm6.23-2.99h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.3a.99.99 0 00-.29.7 1.003 1.003 0 001.71.71l3.29-3.29V8c0 .55.45 1 1 1s1-.45 1-1V4c0-.56-.45-1.01-1-1.01zm-1.98 7.23l-.9.9-.01-.01c-.54.55-1.28.89-2.11.89-1.66 0-3-1.34-3-3 0-.77.3-1.47.78-2H-.01v7c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.18c-.31.11-.65.18-1 .18-.76-.01-1.45-.31-1.98-.78z"],
    "folder-shared-open": ["M13.02 10.22l-.9.9-.01-.01c-.54.55-1.28.89-2.11.89-1.66 0-3-1.34-3-3 0-.77.3-1.47.78-2H4a.99.99 0 00-.94.69l-2 6c-.04.09-.06.2-.06.31 0 .55.45 1 1 1h11c.44 0 .81-.29.94-.69l1.11-3.32c-.01 0-.03.01-.05.01-.77 0-1.45-.3-1.98-.78zM2.06 6.69c.14-.4.5-.69.94-.69h5.76l.01-.01C8.3 5.46 8 4.77 8 4H6.41l-1.7-1.71A.997.997 0 004 2H1c-.55 0-1 .45-1 1v9.84l2.05-6.15h.01zM15 3h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.29a1.003 1.003 0 001.42 1.42L14 6.41V8c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "follower": ["M9.37 12.69c-1.2-.53-1.04-.85-1.08-1.29-.01-.06-.01-.12-.01-.19.41-.37.75-.87.97-1.44 0 0 .01-.03.01-.04.05-.13.09-.26.12-.39.28-.06.44-.36.5-.63.06-.11.19-.39.16-.7-.04-.4-.2-.59-.38-.67v-.07c0-.52-.05-1.26-.14-1.74a2.72 2.72 0 00-.09-.43 3.02 3.02 0 00-1.04-1.51C7.87 3.2 7.15 3 6.5 3c-.64 0-1.36.2-1.87.59-.5.38-.87.92-1.05 1.51-.04.13-.07.27-.09.4-.09.49-.14 1.24-.14 1.75v.06c-.19.07-.36.26-.4.68-.03.31.1.59.16.7.06.28.23.59.51.64.04.14.08.27.13.39 0 .01.01.02.01.02v.01c.22.59.57 1.1.99 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.12 1.29-1.2.53-3.01 1.1-3.38 1.95C-.13 15.5.02 16 .02 16h12.96s.15-.5-.22-1.36c-.38-.85-2.19-1.42-3.39-1.95zm6.33-10.4l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H9.99c-.55 0-1 .45-1 1s.45 1 1 1h2.58l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "following": ["M9.37 12.69c-1.2-.53-1.04-.85-1.08-1.29-.01-.06-.01-.12-.01-.19.41-.37.75-.87.97-1.44 0 0 .01-.03.01-.04.05-.13.09-.26.12-.39.28-.06.44-.36.5-.63.06-.11.19-.39.16-.7-.04-.4-.2-.59-.38-.67v-.07c0-.52-.05-1.26-.14-1.74a2.72 2.72 0 00-.09-.43 3.02 3.02 0 00-1.04-1.51C7.87 3.2 7.15 3 6.5 3c-.64 0-1.36.2-1.87.59-.5.38-.87.92-1.05 1.51-.04.13-.07.27-.09.4-.09.49-.14 1.24-.14 1.75v.06c-.19.07-.36.26-.4.68-.03.31.1.59.16.7.06.28.23.59.51.64.04.14.08.27.13.39 0 .01.01.02.01.02v.01c.22.59.57 1.1.99 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.12 1.29-1.2.53-3.01 1.1-3.38 1.95C-.13 15.5.02 16 .02 16h12.96s.15-.5-.22-1.36c-.38-.85-2.19-1.42-3.39-1.95zM14.99 2h-2.58l.29-.29A1.003 1.003 0 0011.28.29l-2 2c-.17.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L12.41 4h2.58c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "font": ["M13.93 14.67L8.94.67h-.01C8.79.28 8.43 0 8 0s-.79.28-.93.67h-.01l-5 14h.01c-.04.1-.07.21-.07.33 0 .55.45 1 1 1 .43 0 .79-.28.93-.67h.01L5.49 11h5.02l1.55 4.34h.01c.14.38.5.66.93.66.55 0 1-.45 1-1 0-.12-.03-.23-.07-.33zM6.2 9L8 3.97 9.8 9H6.2z"],
    "fork": ["M13.7 9.29a1.003 1.003 0 00-1.42 1.42l.29.29H11.4l-5-5h6.17l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.29.29H.99c-.55 0-1 .45-1 1s.45 1 1 1h2.59l6.71 6.71c.18.18.43.29.71.29h1.59l-.29.29a1.003 1.003 0 001.42 1.42l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71l-2.02-2z"],
    "form": ["M2 11v2h2v-2H2zM1 9h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1zm9-6h5c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1zM6 1a1.003 1.003 0 01.71 1.71l-3 4C3.53 6.89 3.28 7 3 7s-.53-.11-.71-.29l-2-2a1.003 1.003 0 011.42-1.42L3 4.59l2.29-3.3C5.47 1.11 5.72 1 6 1zm4 10h5c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1z"],
    "full-circle": ["M8 0a8 8 0 100 16A8 8 0 108 0z"],
    "full-stacked-chart": ["M13 12h1c.55 0 1-.45 1-1V8h-3v3c0 .55.45 1 1 1zM10 2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3h3V2zm0 4H7v3h3V6zm5-4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2h3V2zm0 3h-3v2h3V5zM5 5H2v3h3V5zm-2 7h1c.55 0 1-.45 1-1V9H2v2c0 .55.45 1 1 1zm12 1H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM5 2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h3V2zm3 10h1c.55 0 1-.45 1-1v-1H7v1c0 .55.45 1 1 1z"],
    "fullscreen": ["M3.41 2H5c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v4c0 .55.45 1 1 1s1-.45 1-1V3.41L5.29 6.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L3.41 2zM6 9c-.28 0-.53.11-.71.29L2 12.59V11c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.41l3.29-3.29c.19-.18.3-.43.3-.71 0-.55-.45-1-1-1zm9 1c-.55 0-1 .45-1 1v1.59L10.71 9.3A.965.965 0 0010 9a1.003 1.003 0 00-.71 1.71l3.3 3.29H11c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm0-10h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.29a1.003 1.003 0 001.42 1.42L14 3.41V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "function": ["M8.12 4.74H6.98c.33-1.29.75-2.24 1.28-2.84.33-.37.64-.56.95-.56.06 0 .11.02.15.05.04.04.06.09.06.15 0 .05-.04.15-.13.29-.09.14-.13.28-.13.4 0 .18.07.33.2.46.14.13.31.19.52.19.22 0 .41-.08.56-.23.15-.16.23-.37.23-.63 0-.3-.11-.55-.34-.74C10.1 1.09 9.74 1 9.24 1c-.78 0-1.49.22-2.12.67-.64.45-1.24 1.2-1.81 2.23-.2.36-.38.59-.56.69-.18.1-.46.15-.85.15l-.26.9h1.08l-1.59 6.12c-.27 1.01-.44 1.63-.54 1.86-.14.34-.34.63-.62.87-.11.1-.24.15-.4.15a.15.15 0 01-.11-.04l-.04-.05c0-.03.04-.08.12-.16.08-.08.12-.2.12-.36 0-.18-.06-.33-.19-.44-.12-.12-.3-.18-.54-.18-.28 0-.51.08-.68.23-.16.14-.25.32-.25.53 0 .22.1.42.31.59.21.17.53.25.97.25.7 0 1.32-.18 1.87-.54.54-.36 1.02-.92 1.42-1.67.41-.75.82-1.96 1.25-3.63l.91-3.54h1.1l.29-.89zm5.43 1.52c.2-.15.41-.23.62-.23.08 0 .23.03.45.09s.41.09.57.09c.23 0 .42-.08.57-.23.16-.16.24-.36.24-.61 0-.26-.08-.47-.23-.62-.15-.15-.37-.23-.66-.23-.25 0-.5.06-.72.18-.23.12-.51.38-.86.78-.26.3-.64.81-1.15 1.55-.2-.91-.55-1.75-1.05-2.51l-2.72.46-.06.29c.2-.04.37-.06.51-.06.27 0 .49.11.67.34.28.36.67 1.45 1.17 3.26-.39.52-.66.85-.8 1.01-.24.26-.44.42-.59.5-.12.06-.25.09-.41.09-.11 0-.3-.06-.56-.18-.18-.08-.34-.12-.48-.12-.27 0-.48.08-.66.25-.17.17-.26.38-.26.64 0 .25.08.44.24.6.16.15.37.23.64.23.26 0 .5-.05.73-.16.23-.11.52-.34.86-.69.35-.35.82-.9 1.43-1.67.23.73.44 1.25.61 1.58s.37.57.59.71c.22.15.5.22.83.22.32 0 .65-.11.98-.34.44-.3.88-.81 1.34-1.53l-.26-.15c-.31.43-.54.7-.69.8-.1.07-.22.1-.35.1-.16 0-.32-.1-.48-.3-.27-.34-.62-1.27-1.06-2.8.4-.68.73-1.13 1-1.34z"],
    "gantt-chart": ["M10 10c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1zM6 7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1zm9 5H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM4 5h3c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "geofence": ["M6 9c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-1.59l-3.29 3.3A1.003 1.003 0 010 15c0-.28.11-.53.3-.71L3.59 11H2c-.55 0-1-.45-1-1s.45-1 1-1zM9.088.004l.097.013.097.024.057.018.1.042.054.029.095.061.052.04 6 5 .05.046.076.08.053.07.06.095.051.11c.056.141.079.294.067.446l-.014.105-.037.143-.035.087-.043.083-4 7-.034.056-.059.08-.038.044-.096.092-.114.082-.116.062-.086.034-.109.03-.1.017-.069.006H8.83c.088-.25.144-.515.163-.79L9 13v-3a3 3 0 00-2.824-2.995L6 7H3c-.351 0-.689.06-1.002.171L2 5l.002-.07.013-.1.015-.073.025-.085.043-.104.056-.101.045-.066.079-.093.084-.078.083-.062 6-4 .07-.043.12-.056.111-.036.108-.022.083-.01h.031c.046-.002.083 0 .12.003z"],
    "geolocation": ["M-.01 6.66l7.34 2 2 7.33 6.66-16z"],
    "geosearch": ["M8.82 12.4h.66c.23 0 .36-.17.36-.4v-1.48l.19-.18c-.27.03-.55.06-.83.06-.28 0-.56-.03-.84-.07.02.04.05.08.07.13V12c0 .23.15.4.39.4zM6.4 15.1A5.51 5.51 0 01.9 9.6c0-.49.06-.98.18-1.43.03 0 .05-.01.08-.01h.08v.44c0 .19.17.34.36.34.03 0 .07-.01.1-.01l.71.7c.07.07.19.07.26 0s.07-.19 0-.26l-.7-.72c0-.02.03-.03.03-.05v-.11c0-.15.08-.2.23-.33h.42c.08 0 .15-.01.22-.04h.02c.02-.02.03-.02.04-.04.01-.01.01-.01.02-.01l.02-.01.9-.9c-.13-.26-.24-.52-.34-.8h-.5v-.43c0-.01.05.05.04-.08h.31c-.03-.13-.06-.26-.08-.39h-.57c.16-.12.34-.24.51-.36-.02-.23-.04-.46-.04-.7 0-.12.01-.23.02-.34A6.385 6.385 0 000 9.6C0 13.13 2.87 16 6.4 16c3.1 0 5.67-2.22 6.26-5.15l-.78-.88c-.21 2.85-2.58 5.13-5.48 5.13zm-1.7-2.93v-.28h.12c.23 0 .39-.19.39-.42v-.54s.01-.01 0-.01L3.77 9.45h-.62c-.23 0-.38.19-.38.42v1.6c0 .23.14.42.38.42h.26v1.61c0 .23.22.41.45.41s.45-.18.45-.41v-.97H4.3c.24 0 .4-.13.4-.36zm11.07-2.34l-2.94-2.94c.11-.17.21-.34.3-.52.01-.03.03-.06.04-.09.08-.18.16-.36.22-.55v-.01c.06-.19.1-.38.14-.58.01-.05.01-.09.02-.14.03-.2.05-.4.05-.61a4.4 4.4 0 00-4.4-4.4C6.77 0 4.8 1.97 4.8 4.4s1.97 4.4 4.4 4.4c.21 0 .41-.02.61-.05.04 0 .09-.01.14-.02.2-.03.39-.08.58-.14h.01c.19-.06.37-.14.55-.22.03-.01.06-.03.09-.04.18-.09.35-.19.52-.3l2.94 2.94a.8.8 0 00.57.23c.44 0 .8-.36.8-.8a.895.895 0 00-.24-.57zM9.2 7.6C7.43 7.6 6 6.17 6 4.4c0-1.77 1.43-3.2 3.2-3.2s3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2zm1.54 4.26v-.52c0-.09-.1-.17-.19-.17s-.19.07-.19.17v.52c0 .09.1.17.19.17s.19-.07.19-.17z"],
    "git-branch": ["M12 1c-1.66 0-3 1.34-3 3 0 1.25.76 2.32 1.85 2.77A2.02 2.02 0 019 8H7c-.73 0-1.41.2-2 .55V5.82C6.16 5.4 7 4.3 7 3c0-1.66-1.34-3-3-3S1 1.34 1 3c0 1.3.84 2.4 2 2.82v4.37c-1.16.4-2 1.51-2 2.81 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.04-.53-1.95-1.32-2.49.35-.31.81-.51 1.32-.51h2c1.92 0 3.52-1.35 3.91-3.15A2.996 2.996 0 0012 1zM4 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-commit": ["M15 7h-3.14c-.45-1.72-2-3-3.86-3S4.59 5.28 4.14 7H1c-.55 0-1 .45-1 1s.45 1 1 1h3.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H15c.55 0 1-.45 1-1s-.45-1-1-1zm-7 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"],
    "git-merge": ["M12 6c-1.3 0-2.4.84-2.82 2H9c-1.62 0-3-.96-3.63-2.34C6.33 5.16 7 4.16 7 3c0-1.66-1.34-3-3-3S1 1.34 1 3c0 1.3.84 2.4 2 2.81v4.37C1.84 10.6 1 11.7 1 13c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V8.43A5.89 5.89 0 009 10h.18A2.996 2.996 0 0015 9c0-1.66-1.34-3-3-3zm-8 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-new-branch": ["M14 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3.18 4.8C10.51 7.51 9.82 8 9 8H7c-.73 0-1.41.2-2 .55V5.82C6.16 5.4 7 4.3 7 3c0-1.66-1.34-3-3-3S1 1.34 1 3c0 1.3.84 2.4 2 2.82v4.37c-1.16.4-2 1.51-2 2.81 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.04-.53-1.95-1.32-2.49.35-.31.81-.51 1.32-.51h2c1.9 0 3.49-1.33 3.89-3.11-.29.07-.58.11-.89.11-.41 0-.8-.08-1.18-.2zM4 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-pull": ["M3 1C1.34 1 0 2.34 0 4c0 1.3.84 2.4 2 2.82v3.37C.84 10.6 0 11.7 0 13c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V6.82C5.16 6.4 6 5.3 6 4c0-1.66-1.34-3-3-3zm0 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm11 5.18V6c0-1.66-1.34-3-3-3H9.41l1.29-1.29c.19-.18.3-.43.3-.71A1.003 1.003 0 009.29.29l-3 3C6.11 3.47 6 3.72 6 4c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L9.41 5H11c.55 0 1 .45 1 1v4.18A2.996 2.996 0 0013 16c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82zM13 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-push": ["M4 6h1V5H4v1zm9 3c0-.28-.11-.53-.29-.71l-3-3C9.53 5.11 9.28 5 9 5s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L8 8.41V15c0 .55.45 1 1 1s1-.45 1-1V8.41l1.29 1.29c.18.19.43.3.71.3.55 0 1-.45 1-1zM5 3H4v1h1V3zm10-3H1C.45 0 0 .45 0 1v13c0 .55.45 1 1 1h5v-2H2v-1h4v-1H3V2h11v9h-2v1h2v1h-2v2h3c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "git-repo": ["M5 9H4v1h1V9zm10-9H1C.45 0 0 .45 0 1v13c0 .55.45 1 1 1h3v1l2-1 2 1v-1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM4 13H2v-1h2v1zm10 0H8v-1h6v1zm0-2H3V2h11v9zM5 3H4v1h1V3zm0 4H4v1h1V7zm0-2H4v1h1V5z"],
    "glass": ["M2 0v4c0 2.97 2.16 5.43 5 5.91V14H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9V9.91c2.84-.48 5-2.94 5-5.91V0H2z"],
    "globe": ["M4.45 7.83c-.26 0-.41.21-.41.46v1.75c0 .26.16.46.41.46h.29v1.77c0 .25.24.45.49.45s.49-.2.49-.45V11.2h-.01c.26 0 .44-.14.44-.4v-.3h.14c.26 0 .43-.2.43-.46v-.59s.01-.01 0-.01l-1.58-1.6h-.69zM8.51 3.9h.22c.06 0 .12-.01.12-.07 0-.06-.05-.07-.12-.07h-.22c-.06 0-.12.01-.12.07.01.06.06.07.12.07zm-2.33-.05c.07-.07.07-.19 0-.26l-.5-.5a.187.187 0 00-.26 0c-.07.07-.07.19 0 .26l.5.5c.07.07.19.07.26 0zm3.06.89c.07 0 .14-.06.14-.12v-.31c0-.07-.07-.12-.14-.12s-.14.06-.14.12v.31c0 .07.07.12.14.12zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-.55.1-1.07.23-1.57h.11v.47c0 .2.18.37.39.37.03 0 .08-.01.11-.02l.78.77c.08.08.2.08.28 0 .08-.08.08-.2 0-.28l-.75-.78c0-.02.04-.04.04-.06v-.12c0-.16.09-.22.25-.36h.46c.09 0 .17-.01.24-.05h.02c.02-.01.03-.02.05-.03.01-.01.01-.01.02-.01l.02-.02 1.59-1.58c.18-.18.18-.46 0-.64s-.47-.15-.65.03l-.3.34h-.57v-.48c0-.01.05.05.05-.09h.64c.12 0 .22-.09.22-.21s-.1-.21-.22-.21H4.1c.18-.15.34-.31.54-.44l.01-.01c.21-.14.45-.25.68-.37.15-.07.29-.15.44-.21.17-.07.35-.11.53-.17.18-.05.35-.12.53-.16a6.05 6.05 0 013.47.35c.05.02.1.05.16.08.25.11.48.24.71.39.25.16.49.34.71.55H10.6s0-.03-.01-.03c-.04 0-.09 0-.13.03l-.51.51a.17.17 0 000 .23c.06.06.17.06.23 0l.42-.44.01-.02h.25c0 .14-.07.09-.07.12v.07c0 .22-.15.37-.36.37h-.38c-.19 0-.38.21-.38.4v.17h-.1c-.12 0-.2.06-.2.18v.25h-.23c-.17 0-.3.11-.3.28 0 .17.13.26.3.26.07 0 .14.03.19-.11l.04.01.49-.46h.17l.39.37c.03.03.08.02.12-.01.03-.03.03-.12 0-.15l-.32-.35h.23l.09.12c.18.18.48.17.66-.01l.09-.1h.4c.02 0 .08.05.08.05v.24l-.05-.01h-.36c-.11 0-.21.1-.21.21 0 .11.09.21.21.21h.41v.15c-.14.21-.24.42-.45.42h-.94v-.01l-.44-.44a.47.47 0 00-.66 0l-.42.43v.01H8.6c-.26 0-.49.21-.49.46v.92c0 .26.23.45.49.45h.9c.34.14.57.35.72.69v1.68c0 .26.17.44.42.44h.72c.26 0 .4-.18.4-.44V9l.89-.86.03-.02.02-.01h.03c.07-.08.15-.19.15-.31v-.91c0-.18-.16-.32-.31-.46H13c.01.28.21.42.46.42h.42c.08.37.12.76.12 1.15 0 3.31-2.69 6-6 6zm4.54-4.27c-.1 0-.21.08-.21.18v.57c0 .1.11.18.21.18.1 0 .21-.08.21-.18v-.57c0-.1-.11-.18-.21-.18zM8.37 3.19c0-.25-.2-.42-.46-.42h-.54c-.25 0-.42.18-.42.43 0 .03-.1.04.05.08v.47c0 .15.06.27.21.27s.21-.12.21-.27v-.14h.5c.24 0 .45-.16.45-.42z"],
    "globe-network": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm5.17 5h-2.44c-.21-1.11-.51-2.03-.91-2.69 1.43.46 2.61 1.43 3.35 2.69zM10 8c0 .73-.05 1.39-.12 2H6.12C6.05 9.39 6 8.73 6 8s.05-1.39.12-2h3.76c.07.61.12 1.27.12 2zM8 2c.67 0 1.36 1.1 1.73 3H6.27C6.64 3.1 7.33 2 8 2zm-1.82.31c-.4.66-.71 1.58-.91 2.69H2.83a6.025 6.025 0 013.35-2.69zM2 8c0-.7.13-1.37.35-2h2.76C5.04 6.62 5 7.28 5 8s.04 1.38.11 2H2.35C2.13 9.37 2 8.7 2 8zm.83 3h2.44c.21 1.11.51 2.03.91 2.69A6.025 6.025 0 012.83 11zM8 14c-.67 0-1.36-1.1-1.73-3h3.46c-.37 1.9-1.06 3-1.73 3zm1.82-.31c.4-.66.7-1.58.91-2.69h2.44a6.025 6.025 0 01-3.35 2.69zM13.65 10h-2.76c.07-.62.11-1.28.11-2s-.04-1.38-.11-2h2.76c.22.63.35 1.3.35 2s-.13 1.37-.35 2z"],
    "graph": ["M14 3c-1.06 0-1.92.83-1.99 1.88l-1.93.97A2.95 2.95 0 008 5c-.56 0-1.08.16-1.52.43L3.97 3.34C3.98 3.23 4 3.12 4 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.24 0 .47-.05.68-.13l2.51 2.09C5.08 7.29 5 7.63 5 8c0 .96.46 1.81 1.16 2.35l-.56 1.69c-.91.19-1.6.99-1.6 1.96 0 1.1.9 2 2 2s2-.9 2-2c0-.51-.2-.97-.51-1.32l.56-1.69A2.99 2.99 0 0011 8c0-.12-.02-.24-.04-.36l1.94-.97c.32.21.69.33 1.1.33 1.1 0 2-.9 2-2s-.9-2-2-2z"],
    "graph-remove": ["M12.89 8.11l-.01.01-.38-.38-.38.38-.02-.02c-.54.55-1.27.9-2.1.9-1.66 0-3-1.34-3-3 0-.83.35-1.56.9-2.1l-.02-.02.38-.38-.38-.38.01-.01C7.35 2.57 7 1.83 7 1c0-.34.07-.65.17-.96A8.004 8.004 0 000 8c0 4.42 3.58 8 8 8 4.14 0 7.54-3.14 7.96-7.17-.31.1-.62.17-.96.17-.83 0-1.57-.35-2.11-.89zm1.02-4.61l1.79-1.79c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-1.79 1.8L10.71.3A.965.965 0 0010 0a1.003 1.003 0 00-.71 1.71l1.79 1.79-1.79 1.79a1.003 1.003 0 001.42 1.42l1.79-1.79 1.79 1.79a1.003 1.003 0 001.42-1.42l-1.8-1.79z"],
    "greater-than": ["M2.713 5.958a1 1 0 01.574-1.916l10 3c.95.285.95 1.63 0 1.916l-10 3a1 1 0 01-.574-1.916L9.52 8 2.713 5.958z"],
    "greater-than-or-equal-to": ["M2.713 3.958a1 1 0 01.574-1.916l10 3c.95.285.95 1.63 0 1.916l-10 3a1 1 0 01-.574-1.916L9.52 6 2.713 3.958zM3 12h10a1 1 0 010 2H3a1 1 0 010-2z"],
    "grid": ["M15 9c.55 0 1-.45 1-1s-.45-1-1-1h-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1H9V1c0-.55-.45-1-1-1S7 .45 7 1v1H4V1c0-.55-.45-1-1-1S2 .45 2 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v3H1c-.55 0-1 .45-1 1s.45 1 1 1h1v3H1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h3v1c0 .55.45 1 1 1s1-.45 1-1v-1h3v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V9h1zm-8 3H4V9h3v3zm0-5H4V4h3v3zm5 5H9V9h3v3zm0-5H9V4h3v3z"],
    "grid-view": ["M0 1v6h7V0H1C.45 0 0 .45 0 1zm0 14c0 .55.45 1 1 1h6V9H0v6zM15 0H9v7h7V1c0-.55-.45-1-1-1zM9 16h6c.55 0 1-.45 1-1V9H9v7z"],
    "group-objects": ["M5 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-3H5C2.24 3 0 5.24 0 8s2.24 5 5 5h6c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 9H5c-2.21 0-4-1.79-4-4s1.79-4 4-4h6c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "grouped-bar-chart": ["M10 12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1zm3 0c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1zm2 1H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-9-1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1zm-3 0c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1z"],
    "hand": ["M15 5c0-.55-.45-1-1-1-.41 0-.76.24-.91.59v.01s0 .01-.01.01L11.57 8h-.36l.78-4.84C12 3.11 12 3.05 12 3a1 1 0 00-1.99-.16v.01L9.18 8H9V1c0-.55-.45-1-1-1S7 .45 7 1v7h-.09l-.93-5.18A1 1 0 005 2c-.55 0-1 .45-1 1 0 .05 0 .11.01.16L5.26 11h-.04L2.83 7.44C2.65 7.18 2.35 7 2 7c-.55 0-1 .45-1 1 0 .17.04.33.12.47l3 5.69h.01v.01A5.002 5.002 0 0013 11v-.59l1.93-5.05c.05-.11.07-.23.07-.36z"],
    "hand-down": ["M14.72 7.87c-1.54-.67-2.99-2.68-3.7-3.95C10.11 1.95 9.93 0 6.14 0 4.05 0 2.71.61 1.92 2.12 1.27 3.36 1 5.21 1 7.83v.79c0 .65.6 1.18 1.35 1.18.34 0 .64-.11.88-.29.17.48.68.84 1.29.84.41 0 .78-.16 1.03-.42.23.37.67.63 1.19.63.57 0 1.05-.31 1.25-.74l.01.63v4.05c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7.9c.58.41 1.55 1.21 2.47 1.29 1.57.14 1.82-1.07 1.25-1.32z"],
    "hand-left": ["M12.08 4.97c-1.26-.71-3.27-2.15-3.95-3.7C7.88.7 6.67.96 6.81 2.52c.09.93.89 1.9 1.3 2.48H1.5C.67 5 0 5.67 0 6.5S.67 8 1.5 8h4.05l.63.01c-.44.2-.75.69-.75 1.25 0 .52.26.96.63 1.19-.26.25-.42.61-.42 1.03 0 .61.35 1.12.84 1.29-.18.24-.29.54-.29.88 0 .75.54 1.35 1.19 1.35h.79c2.62 0 4.47-.28 5.71-.92 1.51-.79 2.12-2.14 2.12-4.22 0-3.79-1.95-3.97-3.92-4.89z"],
    "hand-right": ["M14.5 5H7.89c.41-.58 1.21-1.55 1.3-2.47C9.34.97 8.12.71 7.87 1.28c-.67 1.54-2.68 2.99-3.95 3.7C1.95 5.89 0 6.07 0 9.86c0 2.09.61 3.43 2.12 4.22 1.24.65 3.09.92 5.71.92h.79c.65 0 1.18-.6 1.18-1.35 0-.34-.11-.64-.29-.88.48-.17.84-.68.84-1.29 0-.41-.16-.78-.42-1.03.37-.23.63-.67.63-1.19 0-.57-.31-1.05-.74-1.25l.63-.01h4.05c.83 0 1.5-.67 1.5-1.5S15.33 5 14.5 5z"],
    "hand-up": ["M13.65 6.19c-.34 0-.64.11-.88.29-.17-.48-.68-.84-1.29-.84-.41 0-.78.16-1.03.42-.23-.37-.67-.63-1.19-.63-.57 0-1.05.31-1.25.74L8 5.55V1.5C8 .67 7.33 0 6.5 0S5 .67 5 1.5v6.61c-.58-.41-1.55-1.21-2.48-1.3C.96 6.67.7 7.88 1.28 8.13c1.54.67 2.99 2.68 3.7 3.95C5.89 14.05 6.07 16 9.86 16c2.09 0 3.43-.61 4.22-2.12.64-1.24.92-3.09.92-5.71v-.79c0-.65-.6-1.19-1.35-1.19z"],
    "hat": ["M15 10c.495 0 .933.379.993.882L16 11v.505c0 1.461-3.524 2.45-7.707 2.493L8 14c-4.31 0-8-1-8-2.495V11c0-.561.466-1 1-1 .895 0 3 1 7 1l.381-.003C12.135 10.937 14.134 10 15 10zm-4-8c1.13 0 2.02 2.153 2.671 6.46-1.063.266-2.644.652-4.887.727l-.403.01L8 9.2c-2.664 0-4.488-.444-5.673-.74C2.98 4.153 3.87 2 5 2c2 0 1.329 2 3 2s1-2 3-2z"],
    "header": ["M13 1c-.55 0-1 .45-1 1v5H4V2c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1V9h8v5c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "header-one": ["M14.06 8c-.04.23-.12.44-.25.61-.13.17-.29.3-.48.41-.18.11-.39.18-.62.23-.23.04-.46.07-.71.07v1.03h1.74V16H15V8h-.94zM7 0c-.56 0-1 .45-1 1v4H2V1c0-.55-.45-1-1-1-.56 0-1 .45-1 1v10c0 .55.45 1 1 1 .56 0 1-.45 1-1V7h4v4c0 .55.45 1 1 1 .56 0 1-.45 1-1V1c0-.54-.45-1-1-1z"],
    "header-three": ["M1 0C.44 0 0 .45 0 1v10c0 .54.45 1 1 1 .56 0 1-.45 1-1V7h4v4c0 .54.45 1 1 1 .56 0 1-.45 1-1V1c0-.54-.45-1-1-1-.56 0-1 .45-1 1v4H2V1c0-.54-.45-1-1-1zm13.71 11.72c.41.08.72.3.95.65.23.35.34.77.34 1.27 0 .37-.07.7-.2.97-.14.29-.32.54-.55.74-.23.2-.5.36-.8.47-.3.11-.62.16-.96.16-.41 0-.77-.06-1.08-.19-.31-.12-.56-.31-.77-.54-.21-.24-.36-.52-.47-.85-.11-.33-.16-.7-.17-1.1h1.14c-.01.47.09.86.32 1.17.23.31.57.47 1.02.47.39 0 .71-.12.97-.36s.39-.58.39-1.02c0-.3-.05-.53-.16-.71-.11-.17-.25-.31-.43-.4-.17-.09-.37-.15-.59-.17-.22-.02-.44-.03-.67-.02v-.93c.19.01.38 0 .57-.04.19-.03.36-.1.51-.19.14-.09.26-.22.35-.38.09-.16.14-.36.14-.59 0-.33-.1-.59-.31-.79-.2-.2-.47-.3-.79-.3-.21 0-.38.04-.53.13-.15.09-.27.21-.37.36-.1.15-.17.32-.22.51-.05.19-.07.38-.06.58h-1.15c.01-.38.08-.72.19-1.04.11-.32.27-.6.47-.83.19-.23.44-.42.72-.55.28-.13.6-.2.96-.2.28 0 .55.04.82.13.27.08.51.21.72.38.21.17.38.38.51.64s.19.56.19.9c0 .39-.08.73-.24 1.02-.16.29-.42.5-.76.63v.02z"],
    "header-two": ["M13.17 13.93c-.17.15-.33.29-.46.44-.13.16-.22.32-.27.49h3.55V16H11c.01-.65.16-1.22.44-1.71s.67-.91 1.17-1.27c.24-.18.49-.36.75-.54.25-.18.49-.36.71-.57.21-.2.39-.42.53-.65.14-.24.21-.51.22-.82 0-.14-.02-.29-.05-.45-.03-.16-.09-.31-.18-.45a1.13 1.13 0 00-.37-.35c-.16-.09-.37-.14-.63-.14-.24 0-.43.05-.59.15-.16.1-.29.24-.38.42-.1.17-.17.38-.21.62-.05.24-.07.5-.08.77h-1.19c0-.43.05-.83.16-1.2s.27-.69.49-.96c.21-.25.48-.46.79-.62.31-.15.67-.23 1.07-.23.45 0 .82.08 1.11.23.3.16.55.36.73.6.19.24.32.5.39.79.08.28.12.54.12.79 0 .31-.04.6-.13.85s-.22.49-.37.7c-.15.21-.32.41-.52.59s-.4.35-.61.51l-.63.45c-.21.14-.39.28-.57.42zM0 1c0-.55.44-1 1-1 .55 0 1 .46 1 1v10c0 .55-.44 1-1 1-.55 0-1-.46-1-1V1zm6 0c0-.55.44-1 1-1 .55 0 1 .46 1 1v10c0 .55-.44 1-1 1-.55 0-1-.46-1-1V1zM2 5h4v2H2V5z"],
    "headset": ["M14.85 6.34C14.18 2.72 11.37 0 8 0S1.82 2.72 1.15 6.34C.47 6.9 0 8.1 0 9.5 0 11.43.9 13 2 13c0 1.1.9 2 2 2h2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1H4c-.55 0-1-.45-1-1 .55 0 1-.45 1-1V7c0-.45-.3-.81-.71-.94C3.97 3.7 5.81 2 8 2s4.03 1.7 4.71 4.06c-.41.13-.71.49-.71.94v5c0 .55.45 1 1 1h1c1.1 0 2-1.57 2-3.5 0-1.4-.47-2.6-1.15-3.16z"],
    "heart": ["M16 5.095c0-2.255-1.88-4.083-4.2-4.083-1.682 0-3.13.964-3.8 2.352a4.206 4.206 0 00-3.8-2.352C1.88 1.012 0 2.84 0 5.095c0 .066.007.13.01.194H.004c.001.047.01.096.014.143l.013.142c.07.8.321 1.663.824 2.573C2.073 10.354 4.232 12.018 8 15c3.767-2.982 5.926-4.647 7.144-6.854.501-.905.752-1.766.823-2.562.007-.055.012-.11.016-.164.003-.043.012-.088.013-.13h-.006c.003-.066.01-.13.01-.195z"],
    "heart-broken": ["M7.71 8.87L6.17 6.55l.02-.01A.906.906 0 016 6c0-.07.03-.13.04-.19h-.02l.78-3.92C6.09 1.34 5.19 1 4.2 1 1.88 1 0 2.83 0 5.09c0 .07.01.13.01.19H0c0 .05.01.1.01.14 0 .05.01.1.01.14.07.8.32 1.66.82 2.57 1.07 1.94 2.88 3.47 5.86 5.84l-.68-2.74h.02C6.03 11.16 6 11.08 6 11c0-.28.11-.53.29-.71l1.42-1.42zM16 5.09C16 2.83 14.12 1 11.8 1c-1.2 0-2.27.5-3.04 1.28l-.7 3.51 1.77 2.66-.01.01c.1.15.18.33.18.54 0 .28-.11.53-.29.71l-1.6 1.6.75 3.01c3.23-2.56 5.16-4.15 6.28-6.18.5-.91.75-1.77.82-2.56.01-.05.01-.11.02-.16 0-.04.01-.09.01-.13h-.01c.01-.07.02-.14.02-.2z"],
    "heat-grid": ["M0 10h5V7H0v3zm1-2h3v1H1V8zm14-5h-4v3h5V4c0-.55-.45-1-1-1zm0 2h-3V4h3v1zM0 4v2h5V3H1c-.55 0-1 .45-1 1zm0 9c0 .55.45 1 1 1h4v-3H0v2zm6-7h4V3H6v3zm0 8h4v-3H6v3zm1-2h2v1H7v-1zm4 2h4c.55 0 1-.45 1-1v-2h-5v3zm0-4h5V7h-5v3zm-5 0h4V7H6v3z"],
    "heatmap": ["M2 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm11-7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm3 4.5A2.5 2.5 0 0013.5 6c-.98 0-1.82.57-2.23 1.39-.6-.78-1.51-1.3-2.56-1.36.18-.49.29-.99.29-1.53C9 2.01 6.99 0 4.5 0S0 2.01 0 4.5 2.01 9 4.5 9c.19 0 .37-.03.56-.06-.03.19-.06.37-.06.56C5 11.43 6.57 13 8.5 13c1.63 0 2.98-1.11 3.37-2.62.44.38 1 .62 1.63.62A2.5 2.5 0 0016 8.5zM14.5 13c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"],
    "helicopter": ["M.5 2a.5.5 0 01.5.5V4h7V3H2.5a.5.5 0 010-1h13a.5.5 0 010 1H10v1h1c2.26 0 4 1.79 4 4 0 1.87-1.247 3.44-3 3.878V13h.382l1.894-.947a.5.5 0 11.448.894L12.618 14H4.5a.5.5 0 010-1H7v-2.306C5.749 9.736 5 8.368 5 7L1 6v1.5a.5.5 0 01-1 0v-5A.5.5 0 01.5 2zM8 11.316V13h3v-1a6.73 6.73 0 01-3-.684zM11 5v3h3a3 3 0 00-3-3z"],
    "help": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 13H7v-2h2v2zm1.93-6.52c-.14.32-.35.64-.62.97L9.25 8.83c-.12.15-.24.29-.28.42-.04.13-.09.3-.09.52V10H7.12V8.88s.05-.51.21-.71L8.4 6.73c.22-.26.35-.49.44-.68.09-.19.12-.38.12-.58 0-.3-.1-.55-.28-.75-.18-.19-.44-.28-.76-.28-.33 0-.59.1-.78.29-.19.19-.33.46-.4.81-.03.11-.1.15-.2.14l-1.7-.25c-.12-.01-.16-.08-.14-.19.12-.82.46-1.47 1.03-1.94.57-.48 1.32-.72 2.25-.72.47 0 .9.07 1.29.22s.72.34 1 .59c.28.25.49.55.65.89.15.35.22.72.22 1.12s-.07.75-.21 1.08z"],
    "helper-management": ["M13 5h-2v2h2V5zm0 6h-2v2h2v-2zm0-3h-2v2h2V8zm2-8H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H2V2h12v12zm-7-3H5v2h2v-2zm3 0H8v2h2v-2z"],
    "high-priority": ["M9 14v2H7v-2h2zm1-14L9 12H7L6 0h4z"],
    "highlight": ["M9.12 11.07l2-2.02.71.71 4-4.04L10.17 0l-4 4.04.71.71-2 2.02 4.24 4.3zM2 12.97h4c.28 0 .53-.11.71-.3l1-1.01-3.42-3.45-3 3.03c-.18.18-.29.44-.29.72 0 .55.45 1.01 1 1.01zm13 1.01H1c-.55 0-1 .45-1 1.01S.45 16 1 16h14c.55 0 1-.45 1-1.01s-.45-1.01-1-1.01z"],
    "history": ["M8 3c-.55 0-1 .45-1 1v4c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L9 7.59V4c0-.55-.45-1-1-1zm0-3a7.95 7.95 0 00-6 2.74V1c0-.55-.45-1-1-1S0 .45 0 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.54C4.64 2.78 6.23 2 8 2c3.31 0 6 2.69 6 6 0 2.61-1.67 4.81-4 5.63v-.01c-.63.23-1.29.38-2 .38-3.31 0-6-2.69-6-6 0-.55-.45-1-1-1s-1 .45-1 1c0 4.42 3.58 8 8 8 .34 0 .67-.03 1-.07.02 0 .04-.01.06-.01C12.98 15.4 16 12.06 16 8c0-4.42-3.58-8-8-8z"],
    "home": ["M2 10v5c0 .55.45 1 1 1h3v-5h4v5h3c.55 0 1-.45 1-1v-5L8 4l-6 6zm13.71-2.71L14 5.59V2c0-.55-.45-1-1-1s-1 .45-1 1v1.59L8.71.29C8.53.11 8.28 0 8 0s-.53.11-.71.29l-7 7a1.003 1.003 0 001.42 1.42L8 2.41l6.29 6.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "horizontal-bar-chart": ["M4 5h7c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zM1 1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zm14 6H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-6 5H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1z"],
    "horizontal-bar-chart-asc": ["M1 3h5c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h7c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 6H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM1 11h10c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "horizontal-bar-chart-desc": ["M15 1H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM8 9H1c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm-2 4H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm5-8H1c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "horizontal-distribution": ["M2 0c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm13 0c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-5 2H7c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "hurricane": ["M3.5 12c-.86 0-2.5-.5-3.5-1 1 3.5 4.506 4 7 4a7 7 0 007-7l-.006-.004a5.974 5.974 0 00-1.29-3.988c.896.066 2.37.53 3.296.992-1-3.5-4.506-4-7-4a6.998 6.998 0 00-6.14 3.635 5.972 5.972 0 00-.859 3.226L2 8l.006.005a5.98 5.98 0 001.771 3.99A7.469 7.469 0 013.5 12zM8 6a2 2 0 100 4 2 2 0 000-4z",
        "M0 0h16v16H0z"],
    "id-number": ["M2 5v7h12V5H2zm0-2h12c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z",
        "M7.9 10.48c-.14-.33-.84-.55-1.3-.75-.46-.2-.4-.33-.42-.5v-.07c.16-.14.29-.33.37-.56 0 0 0-.01.01-.02.02-.05.03-.1.05-.15.1-.01.16-.13.19-.23.03-.04.07-.15.06-.27-.02-.16-.08-.24-.15-.26v-.03c0-.2-.02-.48-.05-.67-.01-.05-.02-.1-.03-.16-.07-.23-.21-.44-.4-.58-.2-.15-.48-.23-.73-.23s-.53.08-.72.23c-.19.14-.33.35-.4.58-.02.05-.03.1-.03.16-.05.18-.06.47-.06.67v.03c-.07.03-.14.1-.15.26-.02.12.03.22.06.27.02.1.09.22.2.24.01.05.03.1.05.15v.01c.08.23.22.42.38.56v.07c-.02.17.03.29-.43.5-.46.2-1.16.42-1.3.75s-.09.52-.09.52H8c-.01 0 .05-.19-.1-.52zM10 6h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1zM10 9h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1z"],
    "image-rotate-left": ["M13 2h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C8.11 2.47 8 2.72 8 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H13c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.66-1.34-3-3-3zm-5.5 9c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 6.33L7 12l-1 1-2-3-2 2.67V9h7v4.33z"],
    "image-rotate-right": ["M5.71 5.71l2-2C7.89 3.53 8 3.28 8 3c0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H3C1.34 2 0 3.34 0 5v3c0 .55.45 1 1 1s1-.45 1-1V5c0-.55.45-1 1-1h1.59l-.3.29a1.003 1.003 0 001.42 1.42zM12.5 11c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM15 7H6c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 6.33L12 12l-1 1-2-3-2 2.67V9h7v4.33z"],
    "import": ["M7.29 11.71c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L9 8.59V1c0-.55-.45-1-1-1S7 .45 7 1v7.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l4 4zM15 11c-.55 0-1 .45-1 1v2H2v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1z"],
    "inbox": ["M13.91 2.6c-.16-.36-.51-.61-.92-.61h-10c-.41 0-.77.25-.92.61L-.01 7.45v5.54c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7.45L13.91 2.6zm-1.92 5.39c-.55 0-1 .45-1 1v1h-6v-1c0-.55-.45-1-1-1H1.94l1.71-4h8.68l1.71 4h-2.05z"],
    "inbox-filtered": ["M6.432 2c.094.14.202.273.324.394L8.42 4H3.66L1.95 8H4c.55 0 1 .45 1 1v1h6.557c.693 0 1.363-.262 1.837-.736l.103-.102.85-1.14a2.564 2.564 0 00.623-1.682V5.058L16 7.46V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h3.432zm9.048-2c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V3.71L8.17.98A.566.566 0 018 .57c0-.31.26-.57.57-.57h6.91z"],
    "inbox-geo": ["M6.341 2A5.99 5.99 0 006 4H3.66L1.95 8H4c.55 0 1 .45 1 1v1h7a5.978 5.978 0 004-1.528V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h3.341zm3.679 2.145c0-.125.075-.23.205-.225h.345l.79.8c.005 0 0 .005 0 .005v.295c0 .13-.085.23-.215.23h-.07v.15c0 .13-.09.2-.215.2v.535c0 .125-.12.225-.245.225s-.245-.1-.245-.225V5.25h-.145c-.125 0-.205-.1-.205-.23v-.875zm2.235-2.195c-.03 0-.055-.005-.06-.035 0-.03.03-.035.06-.035h.11c.035 0 .06.005.06.035 0 .03-.03.035-.06.035h-.11zm-1.165-.025a.094.094 0 01-.13 0l-.25-.25a.094.094 0 010-.13.094.094 0 01.13 0l.25.25a.094.094 0 010 .13zm1.53.445c-.035 0-.07-.025-.07-.06v-.155c0-.03.035-.06.07-.06s.07.025.07.06v.155c0 .03-.035.06-.07.06zM12 0c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 7c1.655 0 3-1.345 3-3 0-.195-.02-.39-.06-.575h-.21c-.125 0-.225-.07-.23-.21h-.215c.075.07.155.14.155.23V3.9c0 .06-.04.115-.075.155h-.015l-.01.005-.015.01-.445.43v.815c0 .13-.07.22-.2.22h-.36c-.125 0-.21-.09-.21-.22v-.84a.627.627 0 00-.36-.345h-.45c-.13 0-.245-.095-.245-.225v-.46c0-.125.115-.23.245-.23l.13-.005.21-.215c.09-.09.24-.09.33 0l.22.225h.47c.105 0 .155-.105.225-.21v-.075h-.205a.106.106 0 01-.105-.105.11.11 0 01.105-.105h.18l.025.005v-.12s-.03-.025-.04-.025h-.2l-.045.05a.235.235 0 01-.33.005l-.045-.06h-.115l.16.175c.015.015.015.06 0 .075-.02.015-.045.02-.06.005l-.195-.185h-.085l-.245.23-.02-.005c-.025.07-.06.055-.095.055-.085 0-.15-.045-.15-.13s.065-.14.15-.14h.115v-.125c0-.06.04-.09.1-.09h.05V2.36c0-.095.095-.2.19-.2h.19c.105 0 .18-.075.18-.185V1.94c0-.015.035.01.035-.06h-.125l-.005.01-.21.22a.085.085 0 01-.115 0 .085.085 0 010-.115l.255-.255c.02-.015.045-.015.065-.015.005 0 .005.015.005.015h.64a2.327 2.327 0 00-.355-.275 2.452 2.452 0 00-.355-.195c-.03-.015-.055-.03-.08-.04a3.025 3.025 0 00-1.735-.175c-.09.02-.175.055-.265.08-.09.03-.18.05-.265.085-.075.03-.145.07-.22.105-.115.06-.235.115-.34.185l-.005.005c-.1.065-.18.145-.27.22h.455c.06 0 .11.045.11.105s-.05.105-.11.105h-.32c0 .07-.025.04-.025.045v.24h.285l.15-.17c.09-.09.235-.105.325-.015.09.09.09.23 0 .32l-.795.79-.01.01c-.005 0-.005 0-.01.005l-.025.015h-.01a.235.235 0 01-.12.025h-.23c-.08.07-.125.1-.125.18v.06c0 .01-.02.02-.02.03l.375.39c.04.04.04.1 0 .14-.04.04-.1.04-.14 0l-.39-.385a.213.213 0 01-.055.01c-.105 0-.195-.085-.195-.185v-.235h-.055A3.1 3.1 0 009 4c0 1.655 1.345 3 3 3zm2.27-2.135c.05 0 .105.04.105.09v.285c0 .05-.055.09-.105.09-.05 0-.105-.04-.105-.09v-.285c0-.05.055-.09.105-.09zm-2.085-3.27c0 .13-.105.21-.225.21h-.25v.07c0 .075-.03.135-.105.135s-.105-.06-.105-.135V1.64c-.075-.02-.025-.025-.025-.04 0-.125.085-.215.21-.215h.27c.13 0 .23.085.23.21z"],
    "inbox-search": ["M5.639 2a5.391 5.391 0 00-.144 2H3.66L1.95 8H4c.55 0 1 .45 1 1v1h6V9c0-.088.012-.174.033-.255.12-.007.238-.019.39-.038.154-.008.252-.03.442-.077a5.34 5.34 0 00.24-.05h.05l.122-.04 1.266 1.271c.425.47 1.116.769 1.847.769.21 0 .414-.025.61-.071V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h2.639zM15.82 7.53c.1.12.17.27.18.44 0 .34-.27.61-.61.61a.57.57 0 01-.43-.18l-2.24-2.25c-.13.08-.26.16-.4.23-.02.01-.05.02-.07.03-.14.06-.27.12-.42.17h-.01c-.14.05-.29.08-.44.11-.04.01-.08.02-.11.02-.15.02-.3.04-.46.04-1.85 0-3.35-1.51-3.35-3.37S8.96.01 10.81 0c1.85 0 3.35 1.51 3.35 3.37 0 .16-.02.31-.04.47-.01.04-.01.07-.02.11-.02.15-.05.29-.1.44v.01c-.05.15-.11.28-.17.42-.01.02-.02.05-.03.07-.07.14-.14.27-.23.4l2.25 2.24zm-5.01-1.94c1.22 0 2.21-.99 2.21-2.22 0-1.23-.99-2.22-2.21-2.22S8.6 2.14 8.6 3.37c0 1.22.99 2.22 2.21 2.22z"],
    "inbox-update": ["M8.1 2a5.023 5.023 0 000 2H3.66L1.95 8H4c.55 0 1 .45 1 1v1h6V9c0-.55.45-1 1-1h2.05c.708 0 1.352-.241 1.905-.645L16 7.46V13c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V7.46l2.08-4.85C2.23 2.25 2.59 2 3 2h5.1zM13 6a3 3 0 110-6 3 3 0 010 6z"],
    "info-sign": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM7 3h2v2H7V3zm3 10H6v-1h1V7H6V6h3v6h1v1z"],
    "inheritance": ["M5 8c0 1.66 1.34 3 3 3h4.59L11.3 9.71A.965.965 0 0111 9a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42l1.3-1.29H8c-2.76 0-5-2.24-5-5H1a1 1 0 01-1-1V1a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5zM2 2v4h4V2H2z"],
    "inherited-group": ["M1 7c.51 0 .935.388.993.884L2 8v3c0 .51.388.935.884.993L3 12h1.59l-.3-.29a1.003 1.003 0 011.324-1.504l.096.084 2 2c.18.18.29.43.29.71 0 .233-.076.446-.206.614l-.084.096-2 2A1.003 1.003 0 014 15c0-.24.08-.458.224-.629l.076-.081.29-.29H3a2.996 2.996 0 01-2.995-2.823L0 11V8c0-.55.45-1 1-1zm5.388-7c.629 0 1.338.21 1.838.6.48.38.85.91 1.019 1.52.04.13.07.27.09.4.09.48.14 1.22.14 1.73v.07c.18.08.34.27.37.67.03.32-.09.59-.16.71-.06.28-.21.58-.48.63-.03.13-.07.26-.12.39 0 .01-.01.04-.01.04-.22.58-.55 1.08-.949 1.45v.18c.04.45-.12.77 1.059 1.3 1.179.53 2.947 1.09 3.307 1.95.37.86.22 1.36.22 1.36H9c0-.539-.21-1.045-.583-1.417l-2-2A1.997 1.997 0 005 9c-.149 0-.296-.015-.442-.045.099-.19.082-.37.101-.575 0-.05.01-.11.01-.17-.41-.35-.75-.86-.969-1.45v-.01s-.01-.01-.01-.02c-.04-.12-.09-.26-.12-.39-.28-.05-.44-.36-.5-.64-.06-.12-.19-.39-.16-.71.04-.41.21-.6.39-.68v-.06c0-.51.05-1.26.14-1.74.02-.13.05-.27.09-.4.17-.6.54-1.13 1.02-1.51C5.048.21 5.757 0 6.387 0zm4.625 2.04c.49 0 1.05.16 1.439.46.38.29.67.7.8 1.17.03.1.05.21.07.31.07.37.11.94.11 1.33v.05c.139.06.269.21.289.51.02.25-.07.45-.13.54-.05.21-.16.44-.38.48a1.711 1.711 0 01-.1.33c-.17.44-.43.83-.749 1.11v.14c.03.35-.09.59.83 1 .929.41 2.317.84 2.597 1.5.29.66.17 1.04.17 1.04H13.66v.01c-.05-.24-.14-.5-.25-.76-.36-.86-1.119-1.33-2.687-2-.14-.06-.59-.25-.6-.25-.21-.09-.36-.15-.5-.22.02-.1.02-.2.03-.31 0-.04.01-.08.01-.13-.07-.06-.13-.12-.19-.19.22-.32.4-.67.54-1.05.02-.06.02-.06.03-.1.29-.23.48-.57.59-.96.16-.33.25-.73.21-1.16-.03-.4-.16-.76-.37-1.03-.02-.53-.07-1.13-.15-1.54-.01-.06-.02-.12-.03-.19.23-.06.48-.09.72-.09z"],
    "inner-join": ["M6.6 3.3C5.3 4.4 4.5 6.1 4.5 8s.8 3.6 2.1 4.7c-.5.2-1 .3-1.6.3-2.8 0-5-2.2-5-5s2.2-5 5-5c.6 0 1.1.1 1.6.3zm-1.96 8.68C3.92 10.83 3.5 9.46 3.5 8s.42-2.83 1.14-3.98C2.6 4.2 1 5.91 1 8s1.6 3.8 3.64 3.98zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c2.8 0 5 2.2 5 5s-2.2 5-5 5c-.6 0-1.1-.1-1.6-.3 1.3-1.1 2.1-2.9 2.1-4.7s-.8-3.5-2.1-4.7c.5-.2 1-.3 1.6-.3zm.35 1.02c.73 1.15 1.14 2.52 1.14 3.98s-.42 2.83-1.14 3.98c2.04-.18 3.64-1.9 3.64-3.98s-1.6-3.8-3.64-3.98z"],
    "insert": ["M5 9h2v2c0 .6.4 1 1 1s1-.4 1-1V9h2c.6 0 1-.4 1-1s-.4-1-1-1H9V5c0-.6-.4-1-1-1s-1 .4-1 1v2H5c-.6 0-1 .4-1 1s.4 1 1 1zm10-9H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H2V2h12v12z"],
    "intersection": ["M10 3c-.92 0-1.76.26-2.5.69C6.76 3.26 5.92 3 5 3 2.24 3 0 5.24 0 8s2.24 5 5 5c.92 0 1.76-.26 2.5-.69.74.43 1.58.69 2.5.69 2.76 0 5-2.24 5-5s-2.24-5-5-5zm-4.1 7.85c-.29.09-.59.15-.9.15-1.66 0-3-1.34-3-3s1.34-3 3-3c.31 0 .61.06.9.15C5.33 5.96 5 6.94 5 8s.33 2.04.9 2.85zM10 11c-.31 0-.61-.06-.9-.15.57-.81.9-1.79.9-2.85s-.33-2.04-.9-2.85c.29-.09.59-.15.9-.15 1.66 0 3 1.34 3 3s-1.34 3-3 3z"],
    "ip-address": ["M5 2.66C5 4.14 8 8 8 8s3-3.86 3-5.34C10.99 1.2 9.66 0 8 0S5 1.2 5 2.66zM7 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zM10.5 10H8v5h1v-4h1v1H9v1h2v-3h-.5zM2 9h12c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1zm4 1v5h1v-5H6z"],
    "issue": ["M8 16A8 8 0 118 0a8 8 0 010 16zm0-2A6 6 0 108 2a6 6 0 000 12zm1-2H7v-2h2v2zm0-3H7V4h2v5z"],
    "issue-closed": ["M9.296.104a2.99 2.99 0 00-1.003.664 2.987 2.987 0 00-.75 1.25 6 6 0 106.28 4.527c.043-.039.085-.079.127-.12l1.456-1.456A8 8 0 119.296.105zm2.532 5.2a.997.997 0 01-.707-.294L9.707 3.596a1 1 0 011.414-1.414l.707.707 1.768-1.768a1 1 0 111.414 1.415L12.536 5.01a.997.997 0 01-.708.293zM9 12H7v-2h2v2zm0-3H7V4h2v5z"],
    "issue-new": ["M10.568.421c-.01.04-.018.08-.026.121-.837.156-1.53.73-1.85 1.497a6 6 0 105.27 5.273 2.51 2.51 0 001.496-1.854c.04-.008.081-.016.121-.026A8 8 0 1110.568.421zM9 12H7v-2h2v2zm0-3H7V4h2v5zm1-6c0-.55.45-1 1-1h1V1c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v1.005c0 .55-.45 1-1 1s-1-.45-1-1V4h-1c-.55 0-1-.45-1-1z"],
    "italic": ["M9.8 4H11c.5 0 1-.4 1-1s-.4-1-1-1H7c-.5 0-1 .4-1 1s.4 1 1 1h.8l-1.6 8H5c-.5 0-1 .4-1 1s.4 1 1 1h4c.5 0 1-.4 1-1s-.4-1-1-1h-.8l1.6-8z"],
    "join-table": ["M15 5h-3V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-5-1v2H6V4h4zm0 6H6V7h4v3zM2 4h3v2H2V4zm0 5V7h3v2H2zm4 4v-2h4v2H6zm8 0h-3v-2h3v2zm0-3h-3V8h3v2z"],
    "key": ["M11 0C8.24 0 6 2.24 6 5c0 1.02.31 1.96.83 2.75L.29 14.29a1.003 1.003 0 001.42 1.42L3 14.41l1.29 1.29c.18.19.43.3.71.3s.53-.11.71-.29l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71L6.41 11l1.83-1.83c.8.52 1.74.83 2.76.83 2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-.23 0-.45-.03-.66-.08-.01 0-.02-.01-.03-.01-.21-.05-.41-.12-.6-.21a3.014 3.014 0 01-1.62-2c0-.01-.01-.02-.01-.03C8.03 5.45 8 5.23 8 5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3z"],
    "key-backspace": ["M15 2H6c-.28 0-.53.11-.71.29l-5 5C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l5 5c.18.18.43.29.71.29h9c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-2.29 7.29a1.003 1.003 0 01-1.42 1.42L10 9.41 8.71 10.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71L8.59 8l-1.3-1.29a1.003 1.003 0 011.42-1.42L10 6.59l1.29-1.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L11.41 8l1.3 1.29z"],
    "key-command": ["M12 9h-1V7h1c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3v1H7V4c0-1.66-1.34-3-3-3S1 2.34 1 4s1.34 3 3 3h1v2H4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3v-1h2v1c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3zm0-6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5 4H7V7h2v2zm3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "key-control": ["M12.71 5.29l-4-4C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "key-delete": ["M15.71 7.29l-5-5A.997.997 0 0010 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h9c.28 0 .53-.11.71-.29l5-5c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zm-7 2a1.003 1.003 0 01-1.42 1.42L6 9.41 4.71 10.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71L4.59 8l-1.3-1.29a1.003 1.003 0 011.42-1.42L6 6.59 7.29 5.3c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L7.41 8l1.3 1.29z"],
    "key-enter": ["M14 2c-.55 0-1 .45-1 1v3c0 1.66-1.34 3-3 3H4.41L5.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L4.41 11H10c2.76 0 5-2.24 5-5V3c0-.55-.45-1-1-1z"],
    "key-escape": ["M2 7c.55 0 1-.45 1-1V4.41L7.29 8.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 3H6c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7-5.9v2A5 5 0 113.1 9h-2c.49 3.39 3.38 6 6.9 6 3.87 0 7-3.13 7-7 0-3.52-2.61-6.41-6-6.9z"],
    "key-option": ["M11 4h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm4 8h-3.43L5.86 2.49h-.02A.975.975 0 005 2H1c-.55 0-1 .45-1 1s.45 1 1 1h3.43l5.71 9.51.01-.01c.18.3.49.5.85.5h4c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "key-shift": ["M13.71 7.29l-5-5C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-5 5A1.003 1.003 0 003 9h2v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h2a1.003 1.003 0 00.71-1.71z"],
    "key-tab": ["M15 10H4.41L5.7 8.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L2 9.59V8c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1v-1.59l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 12H15c.55 0 1-.45 1-1s-.45-1-1-1zm0-9c-.55 0-1 .45-1 1v1.59L11.71 1.3A.965.965 0 0011 1a1.003 1.003 0 00-.71 1.71L11.59 4H1c-.55 0-1 .45-1 1s.45 1 1 1h10.59L10.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L14 6.41V8c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "known-vehicle": ["M15 3a.997.997 0 00-.707.293L12 5.586l-1.293-1.293a1 1 0 10-1.414 1.414l2 2a.997.997 0 001.414 0l3-3A1 1 0 0015 3zm-.879 6.121l-.007-.007c-.313.309-.69.552-1.114.702V10h-.998H12h-1v-.184c-.424-.15-.8-.395-1.112-.704l-.01.01-2-2 .012-.012A2.978 2.978 0 017.184 6H3c-.176 0-.06-.824 0-1l.73-1.63C3.79 3.192 3.823 3 4 3H7.78C8.328 2.39 9.115 2 10 2c.768 0 1.461.293 1.987.77l.844-.844c-.238-.244-.524-.442-.794-.524C12.037 1.402 10.72 1 8 1c-2.72 0-4.037.402-4.037.402-.508.155-1.078.711-1.268 1.237l-.763 2.117H.88c-.484 0-.88.423-.88.939s.396.939.88.939h.375L1 7c-.034.685 0 1.436 0 2v5c0 .657.384 1 1 1s1-.343 1-1v-1h10v1c0 .657.384 1 1 1s1-.343 1-1V9l-.003-.754-.876.875zM5.001 10H3V8h2v2z"],
    "lab-test": ["M11 1a1 1 0 010 2v3l3 7v1.25a.75.75 0 01-.75.75H2.75a.75.75 0 01-.75-.75V13l3-7V3a1 1 0 110-2h6zM9 3H7v3l-1.714 4h5.428L9 6V3z"],
    "label": ["M11 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7l-5-5zm3 10H2V4h8v2H3v1h7v1h4v4zm-3-5V4l3 3h-3zm-8 3h10V9H3v1z"],
    "layer": ["M16 8c0-.37-.21-.68-.51-.85l.01-.01-7-4-.01.01C8.34 3.06 8.18 3 8 3s-.34.06-.49.15l-.01-.02-7 4 .01.01C.21 7.32 0 7.63 0 8s.21.68.51.85l-.01.01 7 4 .01-.01c.15.09.31.15.49.15s.34-.06.49-.15l.01.01 7-4-.01-.01c.3-.17.51-.48.51-.85z"],
    "layer-outline": ["M7.504 3.132l-7 4a1 1 0 000 1.736l7 4a1 1 0 00.992 0l7-4a1 1 0 000-1.736l-7-4a1 1 0 00-.992 0zM8 5.152L12.983 8 8 10.847 3.016 8 8 5.152z"],
    "layers": ["M.55 4.89l7 3.5c.14.07.29.11.45.11s.31-.04.45-.11l7-3.5a.998.998 0 00-.06-1.81L8.4.08a1.006 1.006 0 00-.79 0l-6.99 3a.992.992 0 00-.07 1.81zM15 10c-.16 0-.31.04-.45.11L8 13.38 1.45 10.1c-.14-.06-.29-.1-.45-.1-.55 0-1 .45-1 1 0 .39.23.73.55.89l7 3.5c.14.07.29.11.45.11s.31-.04.45-.11l7-3.5c.32-.16.55-.5.55-.89 0-.55-.45-1-1-1zm0-3.5c-.16 0-.31.04-.45.11L8 9.88 1.45 6.61A.997.997 0 001 6.5c-.55 0-1 .45-1 1 0 .39.23.73.55.89l7 3.5c.14.07.29.11.45.11s.31-.04.45-.11l7-3.5c.32-.16.55-.5.55-.89 0-.55-.45-1-1-1z"],
    "layout": ["M14 4c-1.1 0-2 .9-2 2 0 .47.17.9.44 1.24l-.68.91A1.996 1.996 0 009.07 9.5H7.93C7.71 8.64 6.93 8 6 8c-.47 0-.9.17-1.24.44l-.91-.68c.1-.23.15-.49.15-.76 0-.37-.11-.71-.28-1.01l2.27-2.27c.3.17.64.28 1.01.28 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .37.11.71.28 1.01L3.01 5.28C2.71 5.11 2.37 5 2 5 .9 5 0 5.9 0 7s.9 2 2 2c.47 0 .9-.17 1.24-.44l.91.68c-.1.23-.15.49-.15.76 0 .37.11.71.28 1.01l-1.27 1.27C2.71 12.11 2.37 12 2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.37-.11-.71-.28-1.01l1.27-1.27c.3.17.64.28 1.01.28.93 0 1.71-.64 1.93-1.5h1.14c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2 0-.47-.17-.9-.44-1.24l.68-.91c.23.1.49.15.76.15 1.1 0 2-.9 2-2s-.9-2-2-2z"],
    "layout-auto": ["M14 9.5c-.56 0-1.06.23-1.42.59L8.99 8l3.59-2.09A2.002 2.002 0 0016 4.5c0-1.1-.9-2-2-2s-2 .9-2 2c0 .19.03.37.08.54L8.5 7.13v-3.2c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S6 .9 6 2c0 .93.64 1.71 1.5 1.93v3.2L3.92 5.04c.05-.17.08-.35.08-.54 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.56 0 1.06-.23 1.42-.59L7.01 8l-3.59 2.09A2.002 2.002 0 000 11.5c0 1.1.9 2 2 2s2-.9 2-2c0-.19-.03-.37-.08-.54L7.5 8.87v3.2c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-3.2l3.58 2.09c-.05.17-.08.35-.08.54 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"],
    "layout-balloon": ["M14 11c-.2 0-.38.04-.56.09L12.42 9.4c.36-.36.58-.85.58-1.4 0-.55-.22-1.04-.58-1.4l1.01-1.69c.19.05.37.09.57.09 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .55.22 1.04.58 1.4l-1.01 1.69C11.38 6.04 11.2 6 11 6c-.93 0-1.71.64-1.93 1.5H6.93C6.71 6.64 5.93 6 5 6c-.2 0-.38.04-.56.09L3.42 4.4C3.78 4.04 4 3.55 4 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.2 0 .38-.04.56-.09L3.58 6.6C3.22 6.96 3 7.45 3 8c0 .55.22 1.04.58 1.4l-1.01 1.69C2.38 11.04 2.2 11 2 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.55-.22-1.04-.58-1.4l1.01-1.69c.19.05.37.09.57.09.93 0 1.71-.64 1.93-1.5h2.14c.22.86 1 1.5 1.93 1.5.2 0 .38-.04.56-.09l1.01 1.69c-.35.36-.57.85-.57 1.4 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"],
    "layout-circle": ["M14.16 6.02c-.12-.36-.26-.7-.43-1.03.17-.29.27-.63.27-.99 0-1.1-.9-2-2-2-.36 0-.7.1-.99.27-.33-.17-.67-.31-1.03-.43A1.987 1.987 0 008 0C6.95 0 6.1.81 6.02 1.84c-.36.12-.7.26-1.03.43C4.7 2.1 4.36 2 4 2c-1.1 0-2 .9-2 2 0 .36.1.7.27.99-.17.33-.31.67-.43 1.03C.81 6.1 0 6.95 0 8c0 1.05.81 1.9 1.84 1.98.12.36.26.7.43 1.03-.17.29-.27.63-.27.99 0 1.1.9 2 2 2 .36 0 .7-.1.99-.27.33.17.67.32 1.03.43C6.1 15.19 6.95 16 8 16c1.05 0 1.9-.81 1.98-1.84.36-.12.7-.26 1.03-.43.29.17.63.27.99.27 1.1 0 2-.9 2-2 0-.36-.1-.7-.27-.99.17-.33.31-.67.43-1.03C15.19 9.9 16 9.05 16 8c0-1.05-.81-1.9-1.84-1.98zm-.99 3.79c-.05.16-.11.31-.17.46-.3-.17-.64-.27-1-.27-1.1 0-2 .9-2 2 0 .36.1.7.27 1-.15.07-.3.12-.46.17C9.5 12.48 8.81 12 8 12s-1.5.48-1.81 1.17c-.16-.06-.32-.11-.46-.17.17-.3.27-.64.27-1 0-1.1-.9-2-2-2-.36 0-.7.1-1 .27-.07-.15-.12-.3-.17-.46C3.52 9.5 4 8.81 4 8s-.48-1.5-1.17-1.81c.06-.16.11-.32.17-.46.3.17.64.27 1 .27 1.1 0 2-.9 2-2 0-.36-.1-.7-.27-1 .15-.07.3-.12.46-.17C6.5 3.52 7.19 4 8 4s1.5-.48 1.81-1.17c.16.06.32.11.46.17-.17.3-.27.64-.27 1 0 1.1.9 2 2 2 .36 0 .7-.1 1-.27.07.15.12.3.17.46C12.48 6.5 12 7.19 12 8s.48 1.5 1.17 1.81z"],
    "layout-grid": ["M2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 0C6.9 0 6 .9 6 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "layout-group-by": ["M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 1C.9 1 0 1.9 0 3s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "layout-hierarchy": ["M14.5 12.07V9.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2-.93 0-1.71.64-1.93 1.5H9.93c-.18-.7-.73-1.25-1.43-1.43V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S6 .9 6 2c0 .93.64 1.71 1.5 1.93v2.14c-.7.18-1.25.73-1.43 1.43H3.93C3.71 6.64 2.93 6 2 6 .9 6 0 6.9 0 8c0 .93.64 1.71 1.5 1.93v2.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93V9.93c.7-.18 1.25-.73 1.43-1.43h2.14c.18.7.73 1.25 1.43 1.43v2.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93V9.93c.7-.18 1.25-.73 1.43-1.43h2.14c.18.7.73 1.25 1.43 1.43v2.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93z"],
    "layout-linear": ["M14 6c-.93 0-1.71.64-1.93 1.5H9.93C9.71 6.64 8.93 6 8 6s-1.71.64-1.93 1.5H3.93C3.71 6.64 2.93 6 2 6 .9 6 0 6.9 0 8s.9 2 2 2c.93 0 1.71-.64 1.93-1.5h2.13C6.29 9.36 7.07 10 8 10s1.71-.64 1.93-1.5h2.13c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2C16 6.9 15.1 6 14 6z"],
    "layout-skew-grid": ["M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "layout-sorted-clusters": ["M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "learning": ["M8.441 1.104a.985.985 0 00-.882 0L.365 5c-.487.253-.487.747 0 1L7.56 9.896a.985.985 0 00.882 0L15.635 6c.487-.253.487-.747 0-1L8.44 1.104z",
        "M14 5.5l.016 4.514c.002.548.447.99.994.99a.99.99 0 00.99-.99V5.5h-2zM3.371 9.047l4.387 2.432a.5.5 0 00.485 0l4.39-2.432a.25.25 0 01.371.218v2.955a.25.25 0 01-.134.222l-4.635 2.436a.5.5 0 01-.466 0l-4.635-2.436A.25.25 0 013 12.22V9.265a.25.25 0 01.371-.218z"],
    "left-join": ["M6.6 3.3C6.1 3.1 5.6 3 5 3 2.2 3 0 5.2 0 8s2.2 5 5 5c.6 0 1.1-.1 1.6-.3C5.3 11.6 4.5 9.9 4.5 8s.8-3.6 2.1-4.7zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c2.8 0 5 2.2 5 5s-2.2 5-5 5c-.6 0-1.1-.1-1.6-.3 1.3-1.1 2.1-2.9 2.1-4.7s-.8-3.5-2.1-4.7c.5-.2 1-.3 1.6-.3zm.35 1.02c.73 1.15 1.14 2.52 1.14 3.98s-.42 2.83-1.14 3.98c2.04-.18 3.64-1.9 3.64-3.98s-1.6-3.8-3.64-3.98z"],
    "less-than": ["M13.287 5.958a1 1 0 00-.574-1.916l-10 3c-.95.285-.95 1.631 0 1.916l10 3a1 1 0 00.574-1.916L6.48 8l6.807-2.042z"],
    "less-than-or-equal-to": ["M13.287 3.958a1 1 0 00-.575-1.916l-10 3c-.95.285-.95 1.63 0 1.916l10 3a1 1 0 00.575-1.916L6.48 6l6.807-2.042zM13 12H3a1 1 0 000 2h10a1 1 0 000-2z"],
    "lifesaver": ["M9.405 11.746C8.968 11.91 8.495 12 8 12c-.494 0-.968-.09-1.405-.254l-.702 1.873C6.548 13.865 7.258 14 8 14c.742 0 1.452-.135 2.107-.38l-.702-1.874zm2.341-2.341l1.873.702C13.865 9.452 14 8.742 14 8c0-.742-.135-1.452-.38-2.107l-1.874.702c.164.437.254.91.254 1.405 0 .494-.09.968-.254 1.405zM9.405 4.254l.702-1.873A5.987 5.987 0 008 2c-.742 0-1.452.135-2.107.38l.702 1.874C7.032 4.09 7.505 4 8 4c.494 0 .968.09 1.405.254zM4.254 6.595L2.38 5.893A5.987 5.987 0 002 8c0 .742.135 1.452.38 2.107l1.874-.702A3.991 3.991 0 014 8c0-.494.09-.968.254-1.405zM8 16A8 8 0 118 0a8 8 0 010 16zm0-6a2 2 0 100-4 2 2 0 000 4z"],
    "lightbulb": ["M9.01 14h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.44-1-1-1zm1-3h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.44-1-1-1zm-2-11C5.26 0 3.03 1.95 3.03 4.35c0 2.37 1.63 2.64 1.94 5.22 0 .24.22.44.5.44h5.09c.28 0 .5-.19.5-.44C11.37 6.99 13 6.72 13 4.35 13 1.95 10.77 0 8.01 0z"],
    "lightning": ["M7 9H5a1 1 0 01-1-1L4.89.876A1 1 0 015.884 0h4.27a.847.847 0 01.793 1.144L9.125 6h2.05a.825.825 0 01.754 1.16L8.16 15.64A.606.606 0 017 15.394V9z"],
    "link": ["M4.99 11.99c.28 0 .53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42l-6 6a1.003 1.003 0 00.71 1.71zm3.85-2.02L6.4 12.41l-1 1-.01-.01c-.36.36-.85.6-1.4.6-1.1 0-2-.9-2-2 0-.55.24-1.04.6-1.4l-.01-.01 1-1 2.44-2.44c-.33-.1-.67-.16-1.03-.16-1.1 0-2.09.46-2.81 1.19l-.02-.02-1 1 .02.02c-.73.72-1.19 1.71-1.19 2.81 0 2.21 1.79 4 4 4 1.1 0 2.09-.46 2.81-1.19l.02.02 1-1-.02-.02c.73-.72 1.19-1.71 1.19-2.81 0-.35-.06-.69-.15-1.02zm7.15-5.98c0-2.21-1.79-4-4-4-1.1 0-2.09.46-2.81 1.19l-.02-.02-1 1 .02.02c-.72.72-1.19 1.71-1.19 2.81 0 .36.06.69.15 1.02l2.44-2.44 1-1 .01.01c.36-.36.85-.6 1.4-.6 1.1 0 2 .9 2 2 0 .55-.24 1.04-.6 1.4l.01.01-1 1-2.43 2.45c.33.09.67.15 1.02.15 1.1 0 2.09-.46 2.81-1.19l.02.02 1-1-.02-.02a3.92 3.92 0 001.19-2.81z"],
    "list": ["M1 3h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 10H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "list-columns": ["M6 1c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h5zm9-12c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5zm0 4c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5z"],
    "list-detail-view": ["M6 9H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm9-12h-5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM6 5H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "locate": ["M15 7h-.09A6.98 6.98 0 009 1.1V1c0-.55-.45-1-1-1S7 .45 7 1v.09A6.98 6.98 0 001.1 7H1c-.55 0-1 .45-1 1s.45 1 1 1h.1A6.969 6.969 0 007 14.91V15c0 .55.45 1 1 1s1-.45 1-1v-.09A6.98 6.98 0 0014.9 9h.1c.55 0 1-.45 1-1s-.45-1-1-1zm-6.02 5.9c-.05-.5-.46-.9-.98-.9s-.93.4-.98.9A5.017 5.017 0 013.1 8.98c.5-.05.9-.46.9-.98s-.4-.93-.9-.98A5.017 5.017 0 017.02 3.1c.05.5.46.9.98.9s.93-.4.98-.9c1.97.39 3.52 1.95 3.92 3.92-.5.05-.9.46-.9.98s.4.93.9.98a5.017 5.017 0 01-3.92 3.92zM8 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "lock": ["M13.96 7H12V3.95C12 1.77 10.21 0 8 0S4 1.77 4 3.95V7H1.96c-.55 0-.96.35-.96.9v6.91c0 .54.41 1.19.96 1.19h12c.55 0 1.04-.65 1.04-1.19V7.9c0-.55-.49-.9-1.04-.9zM6 7V3.95c0-1.09.9-1.97 2-1.97s2 .88 2 1.97V7H6z"],
    "log-in": ["M11 8c0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L7.59 7H1c-.55 0-1 .45-1 1s.45 1 1 1h6.59L6.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71zm4-8H9c-.55 0-1 .45-1 1s.45 1 1 1h5v12H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "log-out": ["M7 14H2V2h5c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm8.71-6.71l-3-3a1.003 1.003 0 00-1.42 1.42L12.59 7H6c-.55 0-1 .45-1 1s.45 1 1 1h6.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "manual": ["M15.99 1.13c-.02-.41-.33-.77-.78-.87C12.26-.36 9.84.13 8 1.7 6.16.13 3.74-.36.78.26.33.35.03.72.01 1.13H0v12c0 .08 0 .17.02.26.12.51.65.82 1.19.71 2.63-.55 4.59-.04 6.01 1.57.02.03.06.04.08.06.02.02.03.04.05.06.04.03.09.04.13.07.05.03.09.05.14.07.11.04.23.07.35.07h.04c.12 0 .24-.03.35-.07.05-.02.09-.05.14-.07.04-.02.09-.04.13-.07.02-.02.03-.04.05-.06.03-.02.06-.03.08-.06 1.42-1.6 3.39-2.12 6.01-1.57.54.11 1.07-.21 1.19-.71.04-.09.04-.18.04-.26l-.01-12zM7 12.99c-1.4-.83-3.07-1.14-5-.93V1.96c2.11-.28 3.75.2 5 1.46v9.57zm7-.92c-1.93-.21-3.6.1-5 .93V3.42c1.25-1.26 2.89-1.74 5-1.46v10.11z"],
    "manually-entered-data": ["M1 8h3.76l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm14.49-4.01c.31-.32.51-.76.51-1.24C16 1.78 15.22 1 14.25 1c-.48 0-.92.2-1.24.51l-1.44 1.44 2.47 2.47 1.45-1.43zM1 4h7.76l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm0 6c-.55 0-1 .45-1 1 0 .48.35.86.8.96L2.76 10H1zm9.95-6.43l-6.69 6.69 2.47 2.47 6.69-6.69-2.47-2.47zm4.25 2.47L13.24 8H15c.55 0 1-.45 1-1 0-.48-.35-.86-.8-.96zM2 15l3.86-1.39-2.46-2.44L2 15zm13-5h-3.76l-2 2H15c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "many-to-many": ["M3 3a1 1 0 100 2 1 1 0 000-2zm3 1c0 .047-.001.094-.003.14.255.081.538.209.832.41.406.28.8.676 1.171 1.225.37-.549.765-.945 1.171-1.224a3.14 3.14 0 01.832-.411 3 3 0 11.77 1.87 1.038 1.038 0 00-.47.19c-.291.2-.752.672-1.227 1.8.475 1.128.936 1.6 1.227 1.8.183.126.336.173.47.19a3 3 0 11-.77 1.87 3.141 3.141 0 01-.832-.41c-.406-.28-.8-.676-1.171-1.225-.37.549-.765.945-1.171 1.224-.294.202-.577.33-.832.411a3 3 0 11-.77-1.87c.134-.017.287-.064.47-.19.291-.2.752-.672 1.227-1.8-.475-1.128-.936-1.6-1.227-1.8a1.038 1.038 0 00-.47-.19A3 3 0 116 4zm6 0a1 1 0 112 0 1 1 0 01-2 0zm-9 7a1 1 0 100 2 1 1 0 000-2zm9 1a1 1 0 112 0 1 1 0 01-2 0z"],
    "many-to-one": ["M3 2a1 1 0 100 2 1 1 0 000-2zm0-2c1.385 0 2.551.94 2.896 2.215.168.044.34.096.51.158 1.076.394 2.237 1.242 2.575 2.93.161.809.664 1.211 1.293 1.443a3 3 0 110 2.508c-.629.232-1.132.634-1.293 1.442-.338 1.69-1.499 2.537-2.575 2.93a5.436 5.436 0 01-.51.159A3.001 3.001 0 010 13a3 3 0 015.726-1.254c.629-.232 1.132-.634 1.293-1.442.216-1.076.765-1.81 1.413-2.304-.648-.493-1.197-1.228-1.413-2.304-.161-.808-.664-1.21-1.293-1.442A3 3 0 113 0zm1 13a1 1 0 10-2 0 1 1 0 002 0zm8-5a1 1 0 102 0 1 1 0 00-2 0z"],
    "map": ["M15.55 3.17l-4.49-3A.975.975 0 009.99.15L5.53 2.82 1.56.17A1.003 1.003 0 000 1v11c0 .35.18.65.45.83l4.49 3a.975.975 0 001.07.02l4.46-2.67 3.97 2.65A1.003 1.003 0 0016 15V4c0-.35-.18-.65-.45-.83zM5 13.46l-3-2v-8.6l2.94 1.96c.02.02.04.03.06.04v8.6zm5-2.32s-.01 0-.01.01L6 13.53V4.86s.01 0 .01-.01L10 2.47v8.67zm4 1.99l-2.94-1.96c-.02-.01-.04-.02-.05-.03v-8.6l3 2v8.59z"],
    "map-create": ["M14 6.82v6.32l-2.94-1.96c-.02-.01-.04-.02-.05-.03V6.22c-.08-.07-.15-.16-.22-.24-.28-.02-.54-.08-.79-.16v5.32s-.01 0-.01.01L6 13.53V4.86s.01 0 .01-.01l2.05-1.23C8.02 3.42 8 3.21 8 3c0-.98.47-1.84 1.2-2.39l-3.67 2.2L1.56.17A1.003 1.003 0 000 1v11c0 .35.18.65.45.83l4.49 3a.975.975 0 001.07.02l4.46-2.67 3.97 2.65A1.003 1.003 0 0016 15V5.82c-.25.09-.52.14-.8.16-.33.36-.73.67-1.2.84zm-9 6.64l-3-2v-8.6l2.94 1.96c.02.02.04.03.06.04v8.6zM11 4h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "map-marker": ["M8.46 0C5.42 0 2.95 2.39 2.95 5.33 2.95 8.28 8.46 16 8.46 16s5.51-7.72 5.51-10.67C13.96 2.39 11.5 0 8.46 0zm0 8a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"],
    "maximize": ["M5.99 8.99c-.28 0-.53.11-.71.29l-3.29 3.29v-1.59c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.41L6.7 10.7a1.003 1.003 0 00-.71-1.71zm9-9h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-3.3 3.3a.99.99 0 00-.29.7 1.003 1.003 0 001.71.71l3.29-3.29V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.56-.45-1.01-1-1.01z"],
    "media": ["M11.99 6.99c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3-5h-14c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1zm-1 9l-5-3-1 2-3-4-3 5v-7h12v7z"],
    "menu": ["M1 4h14c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 8H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm0-5H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "menu-closed": ["M14.99 6.99h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm-12-2c-.28 0-.53.11-.71.29l-2 2a1.014 1.014 0 000 1.42l2 2a1.003 1.003 0 001.71-.71v-4c0-.55-.45-1-1-1zm3-1h9c.55 0 1-.45 1-1s-.45-1-1-1h-9c-.55 0-1 .45-1 1s.45 1 1 1zm9 8h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "menu-open": ["M9.99 11.99h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0-5h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0-5h-9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm5.71 5.3l-2-2a1.003 1.003 0 00-1.71.71v4a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71z"],
    "merge-columns": ["M5.71 5.29a1.003 1.003 0 00-1.42 1.42l.3.29H2V2h3v1.51c.52.06.99.29 1.34.65l.66.66V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3.82l-.66.66c-.35.35-.82.59-1.34.65V14H2V9h2.59l-.3.29a1.003 1.003 0 001.42 1.42l2-2C7.89 8.53 8 8.28 8 8c0-.28-.11-.53-.29-.71l-2-2zM15 0h-5c-.55 0-1 .45-1 1v3.82l.66-.66c.35-.35.82-.59 1.34-.65V2h3v5h-2.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C8.11 7.47 8 7.72 8 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H14v5h-3v-1.51c-.52-.06-.99-.29-1.34-.65L9 11.18V15c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "merge-links": ["M8 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 3c-.93 0-1.71.64-1.93 1.5H11V3c0-1.66-1.34-3-3-3S5 1.34 5 3v4.5H3.93C3.71 6.64 2.93 6 2 6 .9 6 0 6.9 0 8s.9 2 2 2c.93 0 1.71-.64 1.93-1.5H5V13c0 1.66 1.34 3 3 3s3-1.34 3-3V8.5h1.07c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2s-.9-2-2-2zm-4 7c0 1.1-.9 2-2 2s-2-.9-2-2V3c0-1.1.9-2 2-2s2 .9 2 2v10z"],
    "minimize": ["M15.99.99a1.003 1.003 0 00-1.71-.71l-3.29 3.29V1.99c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H12.4l3.3-3.29c.18-.18.29-.43.29-.71zm-10 8h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.29 14.28a1.003 1.003 0 001.42 1.42L5 12.41V14c0 .55.45 1 1 1s1-.45 1-1v-4a1.02 1.02 0 00-1.01-1.01z"],
    "minus": ["M13 7H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "mobile-phone": ["M12 0H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM8 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3H5V3h6v9z"],
    "mobile-video": ["M15 4c-.28 0-.53.11-.71.29L12 6.59V4c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V9.41l2.29 2.29c.18.19.43.3.71.3.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "modal": ["M15 1a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h14zm-1 4H2v8h12V5zm-3-3H9v2h2V2zm3 0h-2v2h2V2z"],
    "modal-filled": ["M15 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm1 4H0V3h16v2zm-3-2h-2V1h2v2z"],
    "moon": ["M15 11.38A7.835 7.835 0 017.85 16C3.51 16 0 12.49 0 8.15 0 4.97 1.89 2.23 4.62 1c-.45.99-.7 2.08-.7 3.23a7.85 7.85 0 007.85 7.85c1.15 0 2.24-.25 3.23-.7z"],
    "more": ["M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z"],
    "mountain": ["M16 13H3l6-9h1l2 2h1l3 7zm-2.5-3.5l-1-2.5h-1l-2-2-3 4.5L9 8l1 1 1-1 2.5 1.5zM5.94 7l-4.122 6H0l5-6h.94z"],
    "move": ["M15.71 7.29l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H9V3.41l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2C8.53.11 8.28 0 8 0s-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V7H3.41l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L3.41 9H7v3.59l-.29-.29A.965.965 0 006 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2a1.003 1.003 0 00-1.42-1.42l-.29.3V9h3.59l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "mugshot": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14h-.15c-.03-.09-.04-.16-.08-.25-.34-.79-2.01-1.31-3.12-1.8-1.11-.49-.96-.79-1-1.2-.01-.06-.01-.12-.01-.18.38-.34.69-.8.89-1.33 0 0 .01-.03.01-.04.04-.12.08-.24.11-.36.25-.05.4-.33.46-.59.06-.1.18-.36.15-.65-.04-.37-.19-.55-.35-.62v-.06c0-.48-.04-1.16-.13-1.61-.02-.12-.05-.25-.08-.37-.16-.55-.51-1.05-.96-1.39C9.26 3.19 8.6 3 8 3c-.59 0-1.26.19-1.73.55-.45.35-.8.84-.96 1.39-.04.13-.06.25-.08.38-.09.45-.13 1.13-.13 1.61v.06c-.18.06-.33.24-.37.62-.03.29.09.54.15.65.06.26.21.54.47.59.03.12.07.25.11.36 0 .01.01.02.01.02v.01c.21.54.53 1.01.92 1.35 0 .05-.01.11-.01.16-.04.41.08.7-1.03 1.2-1.11.49-2.77 1.01-3.12 1.8-.04.09-.05.16-.08.25H2V2h12v12z"],
    "multi-select": ["M12 3.98H4c-.55 0-1 .45-1 1v1h8v5h1c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm3-3H7c-.55 0-1 .45-1 1v1h8v5h1c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-6 6H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1 5H2v-3h6v3z"],
    "music": ["M15 0c-.07 0-.13.03-.19.04V.02l-10 2v.02C4.35 2.13 4 2.52 4 3v9.12c-.31-.07-.65-.12-1-.12-1.66 0-3 .9-3 2s1.34 2 3 2 3-.9 3-2V6.32l8-1.6v5.4c-.31-.07-.65-.12-1-.12-1.66 0-3 .9-3 2s1.34 2 3 2 3-.9 3-2V1c0-.55-.45-1-1-1z"],
    "nest": ["M2 2c.55 0 1 .45 1 1v3c0 1.66 1.34 3 3 3h5.59L10.3 7.71A.965.965 0 0110 7a1.003 1.003 0 011.71-.71l3 3c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-3 3a1.003 1.003 0 01-1.42-1.42l1.3-1.29H6c-2.76 0-5-2.24-5-5V3c0-.55.45-1 1-1z"],
    "new-drawing": ["M14.9 11c.6 0 1 .5 1 1 0 .257-.073.44-.22.614l-.08.086-3 3c-.2.2-.4.3-.7.3-.5 0-1-.4-1-1 0-.257.073-.44.22-.614l.08-.086 3-3c.2-.2.4-.3.7-.3zM1.3.1l6.734 2.45a3.005 3.005 0 002.095 3.322 3.005 3.005 0 003.401 2.081L13.9 9.8v.2c0 .257-.073.44-.22.614l-.08.086-3 3c-.171.171-.343.27-.577.294L9.9 14h-.2l-5-1-.1-.01c-.231-.05-.45-.26-.56-.49L4 12.4l-4-11 .3-.3 5.8 5.8c-.1.2-.2.4-.2.6 0 .8.6 1.5 1.5 1.5s1.5-.7 1.5-1.5S8.2 6 7.4 6c-.16 0-.32.064-.48.14l-.12.06L1 .4l.3-.3zM13 0c.55 0 1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .503-.376.922-.861.99l-.013.002A.999.999 0 0113 6l.097-.006-.027.004a1 1 0 01-.037.001L13 6c-.55 0-1-.45-1-1V4h-1a.993.993 0 01-.855-.482A1 1 0 0110 3c0-.55.45-1 1-1h1V1c0-.55.45-1 1-1z"],
    "new-grid-item": ["M6 0H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm5 14c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1zM6 9H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm9 4c-.55 0-1 .45-1 1-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm-4-4h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1s1-.45 1-1c.55 0 1-.45 1-1s-.45-1-1-1zm4-9h-5c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm0 9h-1c-.55 0-1 .45-1 1s.45 1 1 1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55-.45-1-1-1z"],
    "new-layer": ["M13.982 6.272l1.518.868-.01.01c.3.17.51.48.51.85s-.21.68-.51.85l.01.01-7 4-.01-.01A.94.94 0 018 13a.94.94 0 01-.49-.15l-.01.01-7-4 .01-.01A.977.977 0 010 8c0-.37.21-.68.51-.86L.5 7.13l7-4 .01.02A.94.94 0 018 3c.086 0 .168.014.246.038a2 2 0 105.736 3.234zM14 3c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .55-.45 1-1 1s-1-.45-1-1V5h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V2c0-.55.45-1 1-1s1 .45 1 1v1h1z"],
    "new-layers": ["M13 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5H9a1 1 0 110-2h2V1a1 1 0 012 0v2zm-3-1.983V2H9a2 2 0 100 4h1v1c0 .279.057.544.16.785l-1.71.855c-.14.07-.29.11-.45.11-.16 0-.31-.04-.45-.11l-7-3.5a.992.992 0 01.07-1.81l6.99-3a1.006 1.006 0 01.79 0l1.6.687zm.91 7.66a2 2 0 003.085-1.54l.555-.277c.14-.07.29-.11.45-.11.55 0 1 .45 1 1 0 .39-.23.73-.55.89l-7 3.5c-.14.07-.29.11-.45.11-.16 0-.31-.04-.45-.11l-7-3.5C.23 8.48 0 8.14 0 7.75c0-.55.45-1 1-1 .16 0 .31.04.45.11L8 10.13l2.91-1.453zM15 10.25c.55 0 1 .45 1 1 0 .39-.23.73-.55.89l-7 3.5c-.14.07-.29.11-.45.11-.16 0-.31-.04-.45-.11l-7-3.5c-.32-.16-.55-.5-.55-.89 0-.55.45-1 1-1 .16 0 .31.04.45.1L8 13.63l6.55-3.27c.14-.07.29-.11.45-.11z"],
    "new-link": ["M15 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3.5 6a2.5 2.5 0 00-2.45 2h-4.1a2.5 2.5 0 100 1h4.1a2.5 2.5 0 102.45-3z"],
    "new-object": ["M8 4c0 .6.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1V5h2c.6 0 1-.4 1-1s-.4-1-1-1h-2V1c0-.6-.4-1-1-1s-1 .4-1 1v2H9c-.6 0-1 .5-1 1zm6.5 2.5V7c0 1.4-1.1 2.5-2.5 2.5S9.5 8.4 9.5 7v-.5H9C7.6 6.5 6.5 5.4 6.5 4S7.6 1.5 9 1.5h.5V1c0-.3.1-.6.1-.8C9.1.1 8.6 0 8 0 3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8c0-.6-.1-1.3-.2-1.9-.4.3-.8.4-1.3.4z"],
    "new-person": ["M9.12 12.69c-1.17-.53-1.01-.85-1.05-1.29-.01-.06-.01-.12-.01-.19.4-.37.73-.87.94-1.44 0 0 .01-.03.01-.04.05-.14.09-.27.12-.4.27-.06.43-.36.49-.63.06-.11.19-.39.16-.7-.04-.41-.2-.6-.38-.68v-.07c0-.51-.05-1.25-.14-1.74-.02-.13-.05-.27-.09-.4-.17-.6-.53-1.14-1.01-1.52C7.66 3.2 6.96 3 6.33 3c-.62 0-1.33.2-1.82.59-.49.38-.85.92-1.02 1.52-.04.13-.07.26-.09.4-.09.49-.13 1.23-.13 1.74v.06c-.19.08-.35.27-.39.68-.03.31.1.59.16.7.06.28.22.59.5.64.03.14.07.27.11.4 0 .01.01.02.01.02v.01c.22.59.55 1.1.96 1.46 0 .06-.01.12-.01.17-.04.44.08.76-1.09 1.29-1.17.53-2.93 1.1-3.29 1.95-.35.87-.2 1.37-.2 1.37h12.6s.15-.5-.22-1.36c-.36-.85-2.12-1.42-3.29-1.95zM14.89 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "new-prescription": ["M9.82 11.66l2.48-2.87c.12-.2.13-.37.04-.53-.11-.19-.3-.26-.52-.26h-1.29c-.27 0-.49.13-.63.34L8.44 9.9 6.95 8a.482.482 0 00-.08-.1L5.82 6.55c.57-.24 1.04-.57 1.42-1.01.49-.57.74-1.27.74-2.08 0-.51-.1-.99-.32-1.42-.21-.43-.51-.8-.89-1.11A4.1 4.1 0 005.42.24C4.91.08 4.34 0 3.72 0H.61C.26 0 0 .23 0 .56v9.89c0 .33.26.55.61.55h.8c.36 0 .61-.23.61-.56V6.99H3.3l3.73 4.74-2.71 3.48c-.12.2-.13.37-.04.53.11.19.3.26.52.26h1.27c.27 0 .51-.12.64-.34l1.69-2.15 1.66 2.14c.12.21.34.35.62.35h1.43c.2 0 .39-.08.5-.25.12-.18.09-.38-.02-.55l-2.77-3.54zM4.18 5H1.99V2.02h2.19c.62 0 1.08.13 1.38.37.29.22.44.62.44 1.08 0 .45-.15.94-.44 1.17-.31.23-.76.36-1.38.36zM15 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1zM9.99 3.01c0 .02.01.04.01.06V2.95c0 .02-.01.04-.01.06z"],
    "new-text-box": ["M5 6.5c0 .28.22.5.5.5H7v3.5c0 .28.22.5.5.5s.5-.22.5-.5V7h1.5c.28 0 .5-.22.5-.5S9.78 6 9.5 6h-4c-.28 0-.5.22-.5.5zM15 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1zm-2 5c-.55 0-1 .45-1 1v5H3V4h5c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1z"],
    "ninja": ["M16 5s-2.52 2.11-4.96 1.99C11.03 4.89 10.39.23 5 0c0 0 2.11 2.54 1.96 4.99C4.86 5.01.23 5.65 0 11c0 0 2.56-2.12 5.02-1.95.02 2.11.67 6.72 5.98 6.95 0 0-2.09-2.54-1.94-4.99 2.11-.02 6.71-.68 6.94-6.01zM8 9.5c-.83 0-1.5-.67-1.5-1.5S7.17 6.5 8 6.5s1.5.67 1.5 1.5S8.83 9.5 8 9.5z"],
    "not-equal-to": ["M7.58 5l.44-2.196a1 1 0 011.96.392L9.62 5H13a1 1 0 010 2H9.22l-.4 2H13a1 1 0 010 2H8.42l-.44 2.196a1 1 0 01-1.96-.392L6.38 11H3a1 1 0 010-2h3.78l.4-2H3a1 1 0 110-2h4.58z"],
    "notifications": ["M8 16c1.1 0 2-.9 2-2H6c0 1.1.9 2 2 2zm6-5c-.55 0-1-.45-1-1V6c0-2.43-1.73-4.45-4.02-4.9 0-.04.02-.06.02-.1 0-.55-.45-1-1-1S7 .45 7 1c0 .04.02.06.02.1A4.992 4.992 0 003 6v4c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "notifications-snooze": ["M9 14c0 1.1-.9 2-2 2s-2-.9-2-2zM7 0c.404 0 .755.243.912.59L7.9.6c-.7.6-.9 1.36-.9 1.9 0 .8.267 1.433.8 1.9-.533.6-.795 1.222-.784 1.867l.004.358A2.8 2.8 0 009.82 9.4L12 9.399V10c0 .51.388.935.884.993L13 11c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V6c0-2.43 1.73-4.45 4.02-4.9L6 1c0-.55.45-1 1-1z",
        "M13 6.702a.632.632 0 00-.632-.632h-1.743l2.208-2.734A.75.75 0 0013 2.864v-.3A.565.565 0 0012.435 2H9.561a.561.561 0 100 1.123h1.814L9.221 5.795A1 1 0 009 6.423v.279c0 .349.283.631.632.631h2.736A.632.632 0 0013 6.702z"],
    "notifications-updated": ["M8 16c1.1 0 2-.9 2-2H6c0 1.1.9 2 2 2zm3.399-13.667l-.413.412A2.99 2.99 0 009 1.99a3 3 0 00-3 2.99c0 .8.32 1.558.876 2.114l2.002 1.992A2.99 2.99 0 0013 9.184V10c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1H2c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V6c0-2.43 1.73-4.45 4.02-4.9 0-.04-.02-.06-.02-.1 0-.55.45-1 1-1s1 .45 1 1c0 .04-.02.06-.02.1a4.97 4.97 0 012.419 1.233zM10.29 7.67l-2-1.99a.99.99 0 01-.29-.7 1 1 0 011-.99c.27 0 .52.11.7.29l1.29 1.29 3.28-3.28c.18-.18.42-.29.7-.29.55 0 1 .44 1 .99 0 .28-.11.52-.3.7l-3.98 3.98a.99.99 0 01-1.4 0z"],
    "numbered-list": ["M2.76 7h1.26V0h-.94c-.04.21-.12.39-.25.54-.13.15-.29.27-.48.36-.18.09-.39.16-.62.2-.23.04-.46.06-.71.06v.9h1.74V7zm-.59 7.17c.18-.12.37-.25.58-.37a10.763 10.763 0 001.24-.83c.2-.16.37-.33.52-.51.15-.19.28-.39.37-.61.09-.22.14-.47.14-.74 0-.22-.04-.45-.12-.7-.08-.26-.21-.49-.4-.69-.18-.21-.43-.39-.72-.52-.3-.14-.68-.21-1.12-.21-.41 0-.77.07-1.08.2-.32.14-.58.32-.8.56-.22.23-.38.51-.49.84-.11.32-.16.67-.16 1.05h1.19c.01-.24.03-.47.08-.67.05-.21.11-.39.21-.54.09-.15.22-.27.38-.36.16-.09.35-.13.59-.13.26 0 .47.04.63.12.16.08.29.18.38.3.09.12.15.25.18.39s.05.27.05.4c-.01.27-.08.5-.22.71-.14.21-.32.4-.53.57-.22.18-.45.34-.71.49-.26.15-.51.31-.74.47-.5.31-.89.68-1.17 1.11-.3.41-.44.91-.45 1.48h5v-1H1.43c.05-.15.14-.29.27-.43.14-.13.29-.26.47-.38zM15.01 1.99h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.44-1-1-1zm0 9h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.44-1-1-1z"],
    "numerical": ["M2.79 4.61c-.13.17-.29.3-.48.41-.18.11-.39.18-.62.23-.23.04-.46.07-.71.07v1.03h1.74V12h1.26V4h-.94c-.04.23-.12.44-.25.61zm4.37 5.31c.18-.14.37-.28.58-.42l.63-.45c.21-.16.41-.33.61-.51s.37-.38.52-.59c.15-.21.28-.45.37-.7.09-.25.13-.54.13-.85 0-.25-.04-.52-.12-.8-.07-.29-.2-.55-.39-.79a2.18 2.18 0 00-.73-.6c-.29-.15-.66-.23-1.11-.23-.41 0-.77.08-1.08.23-.31.16-.58.37-.79.64-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.2h1.19c.01-.27.03-.53.08-.77.04-.24.11-.45.21-.62.09-.18.22-.32.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.15.09.28.21.37.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.82-.14.23-.32.45-.53.65-.22.21-.46.39-.71.57-.26.18-.51.36-.75.54-.5.36-.89.78-1.17 1.27-.28.49-.43 1.06-.44 1.71h5v-1.15H6.43c.05-.17.14-.33.27-.49.13-.15.29-.29.46-.44zm8.5-1.56c-.23-.35-.54-.57-.95-.65v-.02c.34-.13.6-.34.76-.63.16-.29.24-.63.24-1.02 0-.34-.06-.64-.19-.9s-.3-.47-.51-.64c-.21-.17-.45-.3-.72-.38-.27-.09-.54-.13-.82-.13-.36 0-.68.07-.96.2-.28.13-.53.32-.72.55-.2.23-.36.51-.47.83-.11.32-.18.66-.19 1.04h1.15c-.01-.2.01-.39.06-.58.05-.19.12-.36.22-.51.1-.15.22-.27.37-.36.15-.09.32-.13.53-.13.32 0 .59.1.79.3.21.2.31.46.31.79 0 .23-.05.43-.14.59-.09.16-.21.29-.35.38-.15.09-.32.16-.51.19-.19.04-.38.05-.57.04v.93c.23-.01.45 0 .67.02.22.02.42.08.59.17.18.09.32.23.43.4.11.18.16.41.16.71 0 .44-.13.78-.39 1.02s-.58.36-.97.36c-.45 0-.79-.16-1.02-.47-.23-.31-.33-.7-.32-1.17H11c.01.4.06.77.17 1.1.11.33.26.61.47.85.21.23.46.42.77.54.31.13.67.19 1.08.19.34 0 .66-.05.96-.16.3-.11.57-.27.8-.47.23-.2.41-.45.55-.74.13-.27.2-.6.2-.97 0-.5-.11-.92-.34-1.27z"],
    "office": ["M15 5h-3V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h3v-4h4v4h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM5 10H2V7h3v3zm0-5H2V2h3v3zm5 5H7V7h3v3zm0-5H7V2h3v3zm4 9h-2v-2h2v2zm0-4h-2V7h2v3z"],
    "offline": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM6 14l1-5H4l6-7-1 5h3l-6 7z"],
    "oil-field": ["M15 14h-1.35l-3.34-7.51 2.46-.95 1.45 3.21c.09.2.36.3.6.23.1-.03.18-.08.24-.15.05-.08 1.23-1.56.87-4.2-.11-.79-.52-4.62-3.26-4.62-.93 0-1.68.62-1.67 1.37 0 .14.03.28.09.42l.87 1.92L.64 8.07v.01A.98.98 0 000 9c0 .55.45 1 1 1 .13 0 .25-.03.36-.07v.01l1.04-.4L3.67 14H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM4.27 8.81L7.14 7.7 5.2 12.08l-.93-3.27zM6.54 14L9 8.46 11.46 14H6.54z"],
    "one-column": ["M11.99-.01h-3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm-6 5c-.28 0-.53.11-.71.29l-2 2a1.014 1.014 0 000 1.42l2 2a1.003 1.003 0 001.71-.71v-4c0-.55-.45-1-1-1z"],
    "one-to-many": ["M14 3a1 1 0 11-2 0 1 1 0 012 0zm-3.726 1.254a3 3 0 10-.17-2.039 5.467 5.467 0 00-.51.158c-1.076.394-2.237 1.242-2.575 2.93-.161.809-.664 1.211-1.293 1.443a3 3 0 100 2.508c.629.232 1.132.634 1.293 1.442.338 1.69 1.499 2.537 2.575 2.93.17.063.342.115.51.159a3.001 3.001 0 10.17-2.04c-.629-.231-1.132-.633-1.293-1.441C8.765 9.228 8.216 8.494 7.568 8c.648-.493 1.197-1.228 1.413-2.304.161-.808.664-1.21 1.293-1.442zM13 14a1 1 0 110-2 1 1 0 010 2zM4 8a1 1 0 10-2 0 1 1 0 002 0z"],
    "one-to-one": ["M2 8a1 1 0 112 0 1 1 0 01-2 0zm3.83-1a3.001 3.001 0 100 2h4.34a3.001 3.001 0 100-2H5.83zM13 7a1 1 0 100 2 1 1 0 000-2z"],
    "outdated": ["M8 0c4.42 0 8 3.58 8 8 0 4.06-3.02 7.4-6.94 7.92-.02 0-.04.01-.06.01-.33.04-.66.07-1 .07-4.42 0-8-3.58-8-8 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6 .71 0 1.37-.15 2-.38v.01c2.33-.82 4-3.02 4-5.63 0-3.31-2.69-6-6-6-1.78 0-3.36.78-4.46 2H5c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v1.74A7.95 7.95 0 018 0zm1 12H7v-2h2v2zm0-3H7V4h2v5z"],
    "page-layout": ["M15 .95H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm-9 12H2v-6h4v6zm8 0H7v-6h7v6zm0-7H2v-3h12v3z"],
    "panel-stats": ["M10 4h3v1h-3zM10 6h3v1h-3zM10 8h3v1h-3zM10 10h3v1h-3z",
        "M15 1H1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM8 12H2V3h6v9zm6 0H9V3h5v9z"],
    "panel-table": ["M15 1H1c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM8 9H6V7h2v2zm0-3H6V4h2v2zm-6 6V3h3v9H2zm4 0v-2h2v2H6zm8 0H9v-2h5v2zm0-3H9V7h5v2zm0-3H9V4h5v2z"],
    "paperclip": ["M14.68 2.31A4.54 4.54 0 0011.46.99c-1.15 0-2.31.44-3.19 1.32L.95 9.63c-.63.63-.95 1.46-.95 2.28a3.21 3.21 0 003.23 3.22c.83 0 1.66-.31 2.3-.95l7.31-7.32c.76-.77.76-1.98.01-2.73s-1.99-.76-2.75 0l-6.07 6.08c-.24.25-.24.65.01.9s.65.25.91.01l6.07-6.08c.25-.25.67-.25.91-.01.25.25.25.67 0 .92l-7.31 7.32c-.75.75-2.04.74-2.76.01-.75-.75-.73-2.02.01-2.76L9.2 3.21c1.24-1.24 3.35-1.26 4.58-.03 1.24 1.24 1.24 3.36 0 4.6l-7.12 7.13c-.24.25-.24.64.01.88.24.24.63.24.88.01v.01l7.13-7.13A4.41 4.41 0 0016 5.51c0-1.16-.44-2.32-1.32-3.2z"],
    "paragraph": ["M13 1H6C3.8 1 2 2.8 2 5s1.8 4 4 4v5c0 .6.4 1 1 1s1-.5 1-1V3h2v11c0 .6.4 1 1 1s1-.5 1-1V3h1c.5 0 1-.4 1-1s-.4-1-1-1z"],
    "path": ["M14.5 0h-13C.67 0 0 .67 0 1.5S.67 3 1.5 3H7v3H3.5C2.67 6 2 6.67 2 7.5S2.67 9 3.5 9H7v3H5.5c-.83 0-1.5.67-1.5 1.5S4.67 15 5.5 15h5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H9V9h3.5c.83 0 1.5-.67 1.5-1.5S13.33 6 12.5 6H9V3h5.5c.83 0 1.5-.67 1.5-1.5S15.33 0 14.5 0z"],
    "path-search": ["M15 14.62l-4-2.4V9.77c-.32.09-.66.15-1 .18v2.27l-4 2.4V8.71c-.38-.31-.72-.66-1-1.06v6.97l-4-2.4V8c.55 0 1-.45 1-1s-.45-1-1-1V1.38l3.15 1.89c.08-.34.18-.66.32-.97L.76.07v.01A.496.496 0 00.5 0C.22 0 0 .22 0 .5v12c0 .18.1.33.25.42v.01l5 3v-.01c.07.05.16.08.25.08s.18-.03.25-.08v.01l4.74-2.85 4.74 2.85v-.01c.09.05.18.08.27.08.28 0 .5-.22.5-.5v-3.78c-.3.17-.63.28-1 .28v2.62zM2 5c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm6-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm7.75-.92l-1.19-.72c.18.43.29.9.36 1.38l.08.04v3.39l1 1V3.5c0-.18-.1-.33-.25-.42zM10 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3.3 4.89c.44-.7.7-1.51.7-2.39C14 2.01 11.99 0 9.5 0S5 2.01 5 4.5 7.01 9 9.5 9c.88 0 1.69-.26 2.39-.7l2.41 2.41c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71l-2.41-2.4zM9.5 8C7.57 8 6 6.43 6 4.5S7.57 1 9.5 1 13 2.57 13 4.5 11.43 8 9.5 8z"],
    "pause": ["M6 3H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm6 0h-2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "people": ["M13.69 13.98c-.05-.24-.14-.5-.25-.76-.36-.86-1.12-1.33-2.69-2-.14-.06-.59-.25-.6-.25-.21-.09-.36-.15-.5-.22.02-.1.02-.2.03-.31 0-.04.01-.08.01-.13-.07-.06-.13-.12-.19-.19.22-.32.4-.67.54-1.05.02-.06.02-.06.03-.1.29-.23.48-.57.59-.96.16-.33.25-.73.21-1.16-.03-.4-.16-.76-.37-1.03-.02-.53-.07-1.13-.15-1.54-.01-.06-.02-.12-.03-.19.23-.06.48-.09.72-.09.49 0 1.05.16 1.44.46.38.29.67.7.8 1.17.03.1.05.21.07.31.07.37.11.94.11 1.33v.05c.14.06.27.21.29.51.02.25-.07.45-.13.54-.05.21-.16.44-.38.48-.02.1-.05.2-.09.3 0 .01-.01.03-.01.03-.17.44-.43.83-.75 1.11v.14c.03.35-.09.59.83 1 .93.41 2.32.84 2.6 1.5.29.66.17 1.04.17 1.04h-2.3zm-1.17-.38c.37.86.22 1.36.22 1.36H.06s-.14-.5.22-1.36 2.13-1.43 3.31-1.96c1.17-.54 1.05-.86 1.09-1.3 0-.05.01-.11.01-.17-.41-.35-.75-.86-.97-1.45v-.01s-.01-.01-.01-.02c-.04-.12-.09-.26-.12-.39-.28-.05-.44-.36-.5-.64-.06-.12-.19-.39-.16-.71.04-.41.21-.6.39-.68v-.06c0-.51.05-1.26.14-1.74.02-.13.05-.27.09-.4.17-.6.54-1.13 1.02-1.51.5-.39 1.21-.6 1.84-.6s1.34.21 1.84.6c.48.38.85.91 1.02 1.52.04.13.07.27.09.4.09.48.14 1.22.14 1.73v.07c.18.08.34.27.37.67.03.32-.09.59-.16.71-.06.28-.21.58-.48.63-.03.13-.07.26-.12.39 0 .01-.01.04-.01.04-.22.58-.55 1.08-.95 1.45v.18c.04.45-.12.77 1.06 1.3 1.18.53 2.95 1.09 3.31 1.95z"],
    "percentage": ["M6 6V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2zM3.5 6c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5s.5.22.5.5v1c0 .28-.22.5-.5.5zM13 8h-1c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm0 3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5s.5.22.5.5v1zM12 3a1.003 1.003 0 00-1.87-.5l-5.99 9.98c-.09.15-.14.33-.14.52a1.003 1.003 0 001.87.5l5.99-9.98c.09-.15.14-.33.14-.52z"],
    "person": ["M15.68 14.32c-.46-1.05-2.68-1.75-4.16-2.4-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15A3.671 3.671 0 0010.32.72C9.68.25 8.79-.01 8-.01c-.79 0-1.68.25-2.31.73-.61.47-1.06 1.13-1.28 1.86-.05.17-.09.33-.11.5-.12.6-.17 1.51-.17 2.15v.08c-.24.09-.45.32-.5.83-.03.38.13.72.2.86.08.35.28.72.63.78.04.17.09.33.15.49 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.37 1.59-1.48.65-3.7 1.35-4.16 2.4-.46 1.05-.27 1.67-.27 1.67h15.92c-.01.01.18-.61-.28-1.66z"],
    "phone": ["M15.9 12.41c-.06-.06-3.37-2-3.48-2.05a.794.794 0 00-.32-.08c-.15 0-.34.11-.57.32-.23.22-.94 1.19-1.15 1.4-.21.22-.38.32-.52.32-.07 0-.15-.02-.25-.06-.1-.04-1.16-.58-3.36-2.52-2.2-1.93-2.49-3.2-2.5-3.55 0-.14.11-.31.32-.52.22-.21.45-.41.7-.6.25-.19.49-.4.7-.62.22-.23.32-.42.32-.57 0-.11-.03-.21-.08-.32C5.66 3.46 3.66.15 3.59.08 3.44-.07 2.85 0 2.55.16.16 1.46-.03 3.2 0 3.89c.04.71.49 4.46 4.16 7.95C8.72 16.17 11.89 16 12.1 16c.69 0 2.82-.38 3.72-2.55.13-.32.25-.87.08-1.04z"],
    "pie-chart": ["M7 1.08c-3.37.5-5.97 3.4-5.97 6.92 0 3.87 3.13 7 6.98 7 3.52 0 6.42-2.61 6.91-6H7V1.08z",
        "M8 0v8h8c0-4.42-3.58-8-8-8z"],
    "pin": ["M9.41.92c-.51.51-.41 1.5.15 2.56L4.34 7.54C2.8 6.48 1.45 6.05.92 6.58l3.54 3.54-3.54 4.95 4.95-3.54 3.54 3.54c.53-.53.1-1.88-.96-3.42l4.06-5.22c1.06.56 2.04.66 2.55.15L9.41.92z"],
    "pivot": ["M4.57 7.02L.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4.27-4.27c-.58-.35-1.07-.84-1.41-1.42zM15 8c-.55 0-1 .45-1 1v.59l-2.57-2.57c-.34.58-.83 1.07-1.41 1.41L12.59 11H12c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-4-3c0-1.66-1.34-3-3-3S5 3.34 5 5s1.34 3 3 3 3-1.34 3-3zM8 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "pivot-table": ["M2 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0-4H1C.45 0 0 .45 0 1v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm11.71 4.29C13.53 4.11 13.28 4 13 4s-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V9c0 1.66-1.34 3-3 3H7.41l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H9c2.76 0 5-2.24 5-5V7.41l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2zM15 0H5c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "play": ["M12 8c0-.35-.19-.64-.46-.82l.01-.02-6-4-.01.02A.969.969 0 005 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02 6-4-.01-.02c.27-.18.46-.47.46-.82z"],
    "plus": ["M13 7H9V3c0-.55-.45-1-1-1s-1 .45-1 1v4H3c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1V9h4c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "polygon-filter": ["M14 5c-.24 0-.47.05-.68.13L9.97 2.34c.01-.11.03-.22.03-.34 0-1.1-.9-2-2-2S6 .9 6 2c0 .04.01.08.01.12L2.88 4.21C2.61 4.08 2.32 4 2 4 .9 4 0 4.9 0 6c0 .74.4 1.38 1 1.72v4.55c-.6.35-1 .99-1 1.73 0 1.1.9 2 2 2 .74 0 1.38-.4 1.72-1h4.55c.35.6.98 1 1.72 1 1.1 0 2-.9 2-2 0-.37-.11-.7-.28-1L14 9c1.11-.01 2-.9 2-2s-.9-2-2-2zm-4.01 7c-.73 0-1.37.41-1.71 1H3.73c-.18-.3-.43-.55-.73-.72V7.72c.6-.34 1-.98 1-1.72 0-.04-.01-.08-.01-.12l3.13-2.09c.27.13.56.21.88.21.24 0 .47-.05.68-.13l3.35 2.79c-.01.11-.03.22-.03.34 0 .37.11.7.28 1l-2.29 4z"],
    "power": ["M8 8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S7 .45 7 1v6c0 .55.45 1 1 1zm3-5.32v2.34c1.21.91 2 2.35 2 3.98 0 2.76-2.24 5-5 5s-5-2.24-5-5c0-1.63.79-3.06 2-3.98V2.68C2.64 3.81 1 6.21 1 9c0 3.87 3.13 7 7 7s7-3.13 7-7c0-2.79-1.64-5.19-4-6.32z"],
    "predictive-analysis": ["M16 6.41c0-1.01-.49-1.94-1.29-2.49-.43-1.92-2.07-3.28-4-3.28-.46 0-.92.08-1.35.24C8.83.31 8.11 0 7.34 0c-.9 0-1.74.44-2.28 1.16-.12-.01-.24-.02-.36-.02-1.31 0-2.42.89-2.77 2.17C.78 3.72 0 4.84 0 6.13c0 .38.07.76.21 1.12C.07 7.6 0 7.98 0 8.36c0 1.11.58 2.11 1.51 2.63.54.56 1.27.87 2.03.87.49 0 .95-.12 1.37-.36a2.85 2.85 0 002.18 1.04c.52 0 1.03-.14 1.47-.42.49.39 1.07.65 1.69.73 1.04 1.15 1.84 2.63 1.84 2.64 0 0 .28.49.26.49.77 0 1.41-.16 1.32-1.04 0 .02-.73-2.31-.73-2.31.41-.21.75-.55.97-.98.9-.52 1.47-1.53 1.47-2.61 0-.24-.03-.48-.08-.71.45-.52.7-1.21.7-1.92zm-1.23 1.02l-.15-.16-.61-.67c-.27-.29-.54-.94-.58-1.39l-.1-1.01c-.05-.59-.94-.58-.91.11 0 .02.1 1.01.1 1.01.03.29.12.62.24.93-.06-.01-.12-.02-.18-.02 0 0-2.06-.1-2.05-.11-.58-.02-.71.97-.04 1l2.05.11c.42.02 1.04.3 1.29.58l.49.54.02.05c.08.21.12.44.12.66 0 .74-.41 1.41-1.07 1.75l-.16.08-.07.18c-.15.38-.48.66-.88.74l-.54.11.7 2.2c-.38-.61-.95-1.43-1.62-2.14l-.12-.13-.17-.01c-.41-.03-.8-.17-1.14-.38l1.36-1.18c.35-.31.83-.44.99-.39 0 0 .63.17.62.18.63.16.83-.74.23-.97l-.62-.18c-.55-.16-1.33.18-1.79.58l-1.53 1.33-.31.26c-.35.29-.75.44-1.2.44-.64 0-1.23-.33-1.58-.86V9.15c0-.4.17-.79.27-.85 0 0 .52-.34.51-.35.71-.53.18-1.23-.49-.89 0-.01-.52.35-.52.35-.26.15-.45.44-.58.77-.11-.11-.22-.2-.34-.28 0 0-1.53-1.01-1.53-1.02-.65-.45-1.2.51-.49.89 0-.01 1.51 1.02 1.51 1.02.37.24.62.78.62 1.09v.67c-.34.19-.63.29-.99.29-.54 0-1.05-.23-1.41-.63l-.05-.06-.07-.04c-.65-.34-1.05-1-1.05-1.73 0-.3.07-.6.2-.87l.12-.25L1.15 7c-.13-.27-.2-.56-.2-.87 0-.9.61-1.68 1.48-1.89l.31-.08.05-.34a1.926 1.926 0 012.38-1.58l.32.08.18-.31c.35-.6.99-.97 1.67-.97.44 0 .86.15 1.2.42l-.36.36v-.01l-.25.26c-.33.27-.74.42-.89.4 0 0-.67-.1-.67-.11-.67-.13-.87.86-.14 1.02.01 0 .67.11.67.11.02 0 .05 0 .07.01-.11.37-.15.77-.1 1.12 0 0 .17.99.15.99.11.52 1.06.36.93-.18 0-.01-.15-.99-.15-.99-.05-.37.12-.94.36-1.19l.39-.4c.05-.05.1-.09.15-.14l.74-.76c.4-.18.83-.27 1.27-.27 1.55 0 2.86 1.12 3.11 2.67l.04.25.21.12c.61.35.98 1 .98 1.7 0 .36-.1.7-.28 1.01z"],
    "prescription": ["M10.91 8.34c.14-.21.36-.34.63-.34h1.29c.22 0 .41.07.52.26.09.16.08.33-.04.53l-2.49 2.87 2.77 3.54c.12.17.14.37.02.55-.11.17-.3.25-.5.25h-1.44a.69.69 0 01-.61-.35L9.4 13.51l-1.69 2.15c-.13.21-.36.34-.63.34H5.8c-.22 0-.41-.07-.52-.26-.09-.16-.08-.33.04-.53l2.71-3.48L4.3 6.99H3.03v3.47c0 .33-.26.56-.62.56h-.8c-.35-.01-.61-.23-.61-.56V.56c0-.33.26-.56.62-.56h3.11c.62 0 1.19.08 1.7.24.51.16.96.39 1.34.69a3.194 3.194 0 011.21 2.53c0 .81-.25 1.5-.74 2.08-.37.44-.84.77-1.42 1.01L7.88 7.9c.04.04.07.08.08.1l1.49 1.9 1.46-1.56zM5.18 5c.62 0 1.08-.13 1.39-.37.29-.23.44-.71.44-1.16s-.15-.87-.44-1.1C6.26 2.12 5.8 2 5.18 2H2.99v3h2.19z"],
    "presentation": ["M15 1H9c0-.55-.45-1-1-1S7 .45 7 1H1c-.55 0-1 .45-1 1s.45 1 1 1v8c0 .55.45 1 1 1h3.59L3.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 13.41V15c0 .55.45 1 1 1s1-.45 1-1v-1.59l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L10.41 12H14c.55 0 1-.45 1-1V3c.55 0 1-.45 1-1s-.45-1-1-1zm-2 9H3V3h10v7z"],
    "print": ["M12 2.02c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1h8v-1zm3 2H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h1v-3h12v3h1c.55 0 1-.45 1-1v-6c0-.56-.45-1-1-1zm-1 3h-2v-1h2v1zm-3 6H5v-3H3v4c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-4h-2v3z"],
    "projects": ["M14 3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v1h12V3zm-2-3H4c-.55 0-1 .45-1 1h10c0-.55-.45-1-1-1zm3 5H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-3 6c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V9h1v2h6V9h1v2z"],
    "properties": ["M2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-3h9c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm-4 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm13-5H6c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0 6H6c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "property": ["M3 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.5-6.5a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM7 3h8c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zm8 10H7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zM3 0C1.9 0 1 .9 1 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 6H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"],
    "publish-function": ["M12.16 3.76c.15-.11.3-.16.47-.16.06 0 .17.02.34.06.16.04.31.06.43.06a.58.58 0 00.6-.6c0-.19-.06-.33-.17-.44-.11-.11-.28-.16-.49-.16-.19 0-.37.04-.54.13-.17.09-.39.27-.65.55-.2.21-.48.58-.87 1.11a5.22 5.22 0 00-.78-1.79l-2.05.32-.04.21c.15-.03.28-.04.39-.04.2 0 .37.08.5.25.21.26.5 1.03.88 2.33-.29.36-.49.6-.6.71-.18.19-.33.31-.45.36-.09.04-.19.07-.3.07-.09 0-.23-.04-.42-.13a.904.904 0 00-.36-.09c-.2 0-.36.06-.49.18a.59.59 0 00-.19.46c0 .18.06.32.18.43.12.11.28.16.48.16.2 0 .38-.04.55-.12.17-.08.39-.24.65-.49s.62-.65 1.07-1.19c.18.52.33.89.46 1.13.13.24.28.4.44.51.17.1.37.16.62.16.24 0 .49-.08.74-.25.33-.21.66-.58 1.01-1.09l-.21-.11c-.23.31-.41.5-.52.57a.44.44 0 01-.26.07c-.12 0-.24-.07-.36-.21-.2-.24-.46-.91-.8-2 .29-.49.54-.81.74-.96zM6.37 5.83l.68-2.53h.83l.2-.64h-.84c.24-.91.56-1.59.96-2.01.24-.27.48-.4.71-.4.05 0 .08.01.11.04s.04.06.04.1c0 .04-.03.11-.1.21-.06.1-.1.2-.1.29 0 .13.05.24.15.33.1.09.23.14.39.14.17 0 .31-.06.42-.17.12-.12.18-.27.18-.46 0-.21-.08-.39-.25-.52C9.57.07 9.3 0 8.93 0c-.59 0-1.12.16-1.59.48-.48.32-.93.85-1.36 1.59-.15.26-.29.42-.42.49s-.35.11-.64.1l-.19.65h.81L4.35 7.68c-.2.72-.33 1.16-.4 1.33-.1.24-.26.45-.46.62a.48.48 0 01-.31.1c-.03 0-.06-.01-.08-.03l-.03-.03c0-.02.03-.06.09-.11.06-.06.09-.15.09-.26 0-.13-.05-.23-.14-.32-.1-.09-.23-.13-.41-.13-.21 0-.38.05-.51.16A.52.52 0 002 9.4c0 .16.08.3.23.42.16.12.4.18.74.18.53 0 .99-.13 1.4-.39.41-.26.76-.65 1.07-1.19.3-.53.61-1.39.93-2.59zm2.34 3.46A.997.997 0 008 9c-.28 0-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l.29-.3V15c0 .55.45 1 1 1s1-.45 1-1v-2.59l.29.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2z"],
    "pulse": ["M15 8h-1.46l-1.7-2.55-.02.01A.984.984 0 0011 5c-.43 0-.79.27-.93.65h-.01l-1.69 4.51-1.38-8.32h-.02A.989.989 0 006 1c-.41 0-.77.25-.92.61L2.34 8H1c-.55 0-1 .45-1 1s.45 1 1 1h2c.41 0 .77-.25.92-.61l1.65-3.86 1.44 8.63h.02c.08.47.47.84.97.84.43 0 .79-.27.93-.65h.01l2.31-6.17.92 1.38.02-.01c.17.26.46.45.81.45h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "rain": ["M3.5 8a2.5 2.5 0 11.608-4.926 4.002 4.002 0 017.381-1.03A3 3 0 1112 8H3.501zM3 10a1 1 0 012 0v4a1 1 0 11-2 0v-4zm7-1a1 1 0 00-1 1v5a1 1 0 102 0v-5a1 1 0 00-1-1zm2 1a1 1 0 112 0v2a1 1 0 11-2 0v-2zM7 9a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1z"],
    "random": ["M11.48 4h1.11l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H11c-.32 0-.59.16-.77.38l-.01-.01L8.28 4.8l1.28 1.6L11.48 4zm2.23 6.29a1.003 1.003 0 00-1.42 1.42l.3.29h-1.11l-7.7-9.62h-.01A.996.996 0 003 2H1c-.55 0-1 .45-1 1s.45 1 1 1h1.52l7.7 9.62.01-.01c.18.23.45.39.77.39h1.59l-.29.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2zM2.52 12H1c-.55 0-1 .45-1 1s.45 1 1 1h2c.32 0 .59-.16.77-.38l.01.01 1.94-2.42L4.44 9.6 2.52 12z"],
    "record": ["M8 3a5 5 0 100 10A5 5 0 108 3z"],
    "rectangle": ["M1 3h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zm1 2v6h12V5H2z"],
    "redo": ["M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3.71-6.71l-3-3a1.003 1.003 0 00-1.42 1.42L12.59 4H5C2.24 4 0 6.24 0 9s2.24 5 5 5h4v-2H5c-1.66 0-3-1.34-3-3s1.34-3 3-3h7.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "refresh": ["M14.99 6.99c-.55 0-1 .45-1 1 0 3.31-2.69 6-6 6-1.77 0-3.36-.78-4.46-2h1.46c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-1.74a7.95 7.95 0 006 2.74c4.42 0 8-3.58 8-8 0-.55-.45-1-1-1zm0-7c-.55 0-1 .45-1 1v1.74a7.95 7.95 0 00-6-2.74c-4.42 0-8 3.58-8 8 0 .55.45 1 1 1s1-.45 1-1c0-3.31 2.69-6 6-6 1.77 0 3.36.78 4.46 2h-1.46c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"],
    "regression-chart": ["M13 6.5c0 .83.67 1.5 1.5 1.5S16 7.33 16 6.5 15.33 5 14.5 5 13 5.67 13 6.5zM8.5 5c.83 0 1.5-.67 1.5-1.5S9.33 2 8.5 2 7 2.67 7 3.5 7.67 5 8.5 5zM9 9.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S11.33 8 10.5 8 9 8.67 9 9.5zM4.5 8C5.33 8 6 7.33 6 6.5S5.33 5 4.5 5 3 5.67 3 6.5 3.67 8 4.5 8zM15 12H3.26l12.03-8.59-.58-.81L2 11.67V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "remove": ["M10.99 6.99h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm-3-7c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.68 6-6 6z"],
    "remove-column": ["M14 0H4c-.55 0-1 .45-1 1v3h2V2h3v12H5v-2H3v3c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14h-3V2h3v12zm-8.71-3.29a1.003 1.003 0 001.42-1.42L4.41 8 5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L3 6.59l-1.29-1.3A1.003 1.003 0 00.29 6.71L1.59 8 .29 9.29a1.003 1.003 0 001.42 1.42L3 9.41l1.29 1.3z"],
    "remove-column-left": ["M4 9h4c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm11-9H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 14H2V2h8v12zm4 0h-3V2h3v12z"],
    "remove-column-right": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 14H2V2h3v12zm9 0H6V2h8v12zM8 9h4c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "remove-row-bottom": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V6h12v8zm0-9H2V2h12v3zm-8 6h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "remove-row-top": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2v-3h12v3zm0-4H2V2h12v8zM6 7h4c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "repeat": ["M10 5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1.74A7.95 7.95 0 008 0C3.58 0 0 3.58 0 8c0 4.06 3.02 7.4 6.94 7.92.02 0 .04.01.06.01.33.04.66.07 1 .07 4.42 0 8-3.58 8-8 0-.55-.45-1-1-1s-1 .45-1 1c0 3.31-2.69 6-6 6-.71 0-1.37-.15-2-.38v.01C3.67 12.81 2 10.61 2 8c0-3.31 2.69-6 6-6 1.77 0 3.36.78 4.46 2H11c-.55 0-1 .45-1 1z"],
    "reset": ["M6 5c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v1.74A7.95 7.95 0 018 0c4.42 0 8 3.58 8 8 0 4.06-3.02 7.4-6.94 7.92-.02 0-.04.01-.06.01-.33.04-.66.07-1 .07-4.42 0-8-3.58-8-8 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6 .71 0 1.37-.15 2-.38v.01c2.33-.82 4-3.02 4-5.63 0-3.31-2.69-6-6-6-1.77 0-3.36.78-4.46 2H5c.55 0 1 .45 1 1z"],
    "resolve": ["M6.6 3.3C6.1 3.1 5.6 3 5 3 2.2 3 0 5.2 0 8s2.2 5 5 5c.6 0 1.1-.1 1.6-.3C5.3 11.6 4.5 9.9 4.5 8s.8-3.6 2.1-4.7zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c-.6 0-1.1.1-1.6.3 1.3 1.2 2.1 2.9 2.1 4.7s-.8 3.6-2.1 4.7c.5.2 1 .3 1.6.3 2.8 0 5-2.2 5-5s-2.2-5-5-5z"],
    "rig": ["M5.71 3c0 1.1.96 2 2.14 2C9.04 5 10 3.96 10 3c0-1.96-1.47-3-2.14-3H5c0 1.96 2.68 1.4.71 3zm2.5 3l.01.01s0-.01-.01-.01zm6.5 8.29L10 9.59V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v2.58l-4.71 4.7c-.18.19-.29.44-.29.72a1.003 1.003 0 001.71.71L6 12.42V15c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.58l3.29 3.29a1.003 1.003 0 001.42-1.42z"],
    "right-join": ["M6.6 3.3C5.3 4.4 4.5 6.1 4.5 8s.8 3.6 2.1 4.7c-.5.2-1 .3-1.6.3-2.8 0-5-2.2-5-5s2.2-5 5-5c.6 0 1.1.1 1.6.3zm-1.96 8.68C3.92 10.83 3.5 9.46 3.5 8s.42-2.83 1.14-3.98C2.6 4.2 1 5.91 1 8s1.6 3.8 3.64 3.98zM8 4c-1.2.9-2 2.4-2 4s.8 3.1 2 4c1.2-.9 2-2.3 2-4s-.8-3.1-2-4zm3-1c2.8 0 5 2.2 5 5s-2.2 5-5 5c-.6 0-1.1-.1-1.6-.3 1.3-1.1 2.1-2.9 2.1-4.7s-.8-3.5-2.1-4.7c.5-.2 1-.3 1.6-.3z"],
    "ring": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"],
    "rocket": ["M6 12C4.397 7.46 4.415 4.465 8 0c3.585 4.485 3.602 7.48 2 12H6zm3-7a1 1 0 11-2 0 1 1 0 012 0zm-7 8.022l3-1-.054-.158C4.636 10.954 4.076 9.317 4 8L3 9l-1 4.022zm9-1l3 1L13 9l-1-1c-.076 1.317-.635 2.954-.946 3.864l-.054.158zM7 13h2c0 1.5-.5 2.5-1 3-.5-.5-1-1.5-1-3z"],
    "rocket-slant": ["M3.992 10c2-5 5-9 11-9 0 6-4 9-9 11l-2-2zm7.714-4.285a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414zm-6.555-.218L2.992 6l-3 2L3.24 9.195c.542-1.301 1.166-2.556 1.911-3.698zM7.992 16l-1.236-3.232c1.3-.539 2.552-1.158 3.694-1.898L9.992 13l-2 3zm-4.931-4.94L5 13c-.992.991-2.186 1.154-3.001 1-.154-.815.07-1.948 1.06-2.94z"],
    "rotate-document": ["M12 2h-1.59l.29-.29c.19-.18.3-.43.3-.71A1.003 1.003 0 009.29.29l-2 2C7.11 2.47 7 2.72 7 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H12c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.66-1.34-3-3-3zM5.71 5.29A.997.997 0 005 5H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V9c0-.28-.11-.53-.29-.71l-3-3zM7 14H2V7h2v2c0 .55.45 1 1 1h2v4z"],
    "rotate-page": ["M8 6H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm-1 8H3V8h4v6zm5-12h-1.59l.29-.29c.19-.18.3-.43.3-.71A1.003 1.003 0 009.29.29l-2 2C7.11 2.47 7 2.72 7 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H12c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.66-1.34-3-3-3z"],
    "route": ["M11.669 5.066l.099.189c.113.213.236.434.367.661.226.39.468.78.709 1.151l-.198-.004-.48-.004c-1.745.003-2.369.233-2.369.688 0 .053.226.19 1.038.436l.84.24C13.9 9.064 15 9.83 15 11.63c0 2.123-1.607 3.122-4.027 3.366-.651.065-1.266.075-2.043.05l-.958-.035H5.196l.268-.406c.336-.517.672-1.052.998-1.593h1.636l.572.023c.857.036 1.475.034 2.103-.03 1.526-.153 2.227-.59 2.227-1.375 0-.531-.402-.84-1.66-1.22l-.691-.198c-1.04-.293-1.764-.562-2.222-.946C8.8 8.366 9 7.612 9 6.997a5.03 5.03 0 00-.184-1.334c.645-.395 1.598-.562 2.853-.597zM4 3a4.007 4.007 0 014 3.997C8 9.21 4 15 4 15l-.416-.62C2.56 12.827 0 8.767 0 6.997A4.002 4.002 0 014 3zm0 2a2 2 0 10.001 4.001A2 2 0 004 5zm10-4c1.103 0 1.996.896 2 1.999C16 4.105 14 7 14 7l-.293-.44C13.15 5.707 12 3.838 12 2.999 12 1.896 12.897 1 14 1z"],
    "satellite": ["M3 9c0-.6.4-1 1-1s1 .4 1 1c0 1.1.9 2 2 2 .6 0 1 .4 1 1s-.4 1-1 1c-2.2 0-4-1.8-4-4zM0 9c0-.6.4-1 1-1s1 .4 1 1c0 2.8 2.2 5 5 5 .6 0 1 .4 1 1s-.4 1-1 1c-3.9 0-7-3.1-7-7zm7 1c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1.3-2.8c-.4-.4-.4-1 0-1.4l4.5-4.5c.4-.4 1-.4 1.4 0l.5.5c.4.4.4 1 0 1.4l-4.5 4.5c-.4.4-1 .4-1.4 0l-.5-.5zM5.2.3c.4-.4 1-.4 1.4 0l2.1 2.1c.4.4.4 1 0 1.4l-.9.9c-.4.4-1 .4-1.4 0L4.3 2.6c-.4-.4-.4-1 0-1.4l.9-.9zm7 7c.4-.4 1-.4 1.4 0l2.1 2.1c.4.4.4 1 0 1.4l-.9.9c-.4.4-1 .4-1.4 0l-2.1-2.1c-.4-.4-.4-1 0-1.4l.9-.9z"],
    "saved": ["M6.71 9.29a1.003 1.003 0 00-1.42 1.42l2 2a.997.997 0 001.6-.27h.01l2-4h-.01c.06-.13.11-.28.11-.44 0-.55-.45-1-1-1-.39 0-.72.23-.89.56H9.1l-1.38 2.76-1.01-1.03zM9 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5L9 0zm3 14H4V2h4v4h4v8z"],
    "scatter-plot": ["M15 12H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm-.5-7c.83 0 1.5-.67 1.5-1.5S15.33 2 14.5 2 13 2.67 13 3.5 13.67 5 14.5 5zm-3 4c.83 0 1.5-.67 1.5-1.5S12.33 6 11.5 6 10 6.67 10 7.5 10.67 9 11.5 9zm-4-2C8.33 7 9 6.33 9 5.5S8.33 4 7.5 4 6 4.67 6 5.5 6.67 7 7.5 7zm-3 4c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"],
    "search": ["M15.55 13.43l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"],
    "search-around": ["M13.5 11c-.51 0-.98.15-1.38.42l-2.4-2.41c.17-.3.28-.64.28-1.01s-.11-.71-.28-1.01l2.41-2.41c.39.27.86.42 1.37.42a2.5 2.5 0 000-5A2.5 2.5 0 0011 2.5c0 .51.15.98.42 1.38l-2.41 2.4C8.71 6.11 8.37 6 8 6s-.71.11-1.01.28l-2.41-2.4c.27-.4.42-.87.42-1.38a2.5 2.5 0 00-5 0A2.5 2.5 0 002.5 5c.51 0 .98-.15 1.38-.42l2.41 2.41C6.11 7.29 6 7.63 6 8s.11.71.28 1.01l-2.41 2.41c-.39-.27-.86-.42-1.37-.42a2.5 2.5 0 000 5A2.5 2.5 0 005 13.5c0-.51-.15-.98-.42-1.38l2.41-2.41c.3.18.64.29 1.01.29s.71-.11 1.01-.28l2.41 2.41c-.27.39-.42.86-.42 1.37a2.5 2.5 0 005 0 2.5 2.5 0 00-2.5-2.5zm0-10c.83 0 1.5.67 1.5 1.5S14.33 4 13.5 4 12 3.33 12 2.5 12.67 1 13.5 1zm-11 3C1.67 4 1 3.33 1 2.5S1.67 1 2.5 1 4 1.67 4 2.5 3.33 4 2.5 4zm0 11c-.83 0-1.5-.67-1.5-1.5S1.67 12 2.5 12s1.5.67 1.5 1.5S3.33 15 2.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"],
    "search-template": ["M15.55 13.43l-2.67-2.67c.7-1.09 1.11-2.38 1.11-3.77 0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.41 3.77-1.11l2.67 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm2.5-6h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm0-2h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm0 4h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"],
    "search-text": ["M9 4H5c-.55 0-1 .45-1 1s.45 1 1 1h1v3c0 .55.45 1 1 1s1-.45 1-1V6h1c.55 0 1-.45 1-1s-.45-1-1-1zm6.56 9.44l-2.67-2.67C13.59 9.68 14 8.39 14 7c0-3.87-3.13-7-7-7S0 3.13 0 7s3.13 7 7 7c1.39 0 2.68-.41 3.77-1.11l2.67 2.67a1.498 1.498 0 102.12-2.12zM7 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"],
    "segmented-control": ["M15 4H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 6H8V6h6v4z"],
    "select": ["M16 15c0-.28-.12-.52-.31-.69l.02-.02-3.12-3.12 3.41-.84-8.05-2.86c.03-.09.05-.17.05-.27V2c0-.55-.45-1-1-1H3c0-.55-.45-1-1-1S1 .45 1 1c-.55 0-1 .45-1 1s.45 1 1 1v4c0 .55.45 1 1 1h5.2c.1 0 .18-.02.27-.05L10.33 16l.85-3.41 3.12 3.12.02-.02c.16.19.4.31.68.31.04 0 .07-.02.1-.02s.06.02.1.02c.44 0 .8-.36.8-.8 0-.04-.02-.07-.02-.1s.02-.06.02-.1zM6 6H3V3h3v3z"],
    "selection": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-9C6.34 5 5 6.34 5 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"],
    "send-message": ["M15.399 9.01L1.527 15.875c-.535.267-1.175.081-1.421-.427A.953.953 0 010 15V10l8-2-8-2V1c0-.528.407-1 1.004-1 .169 0 .416.04.567.116L15.403 7.07a1.084 1.084 0 01-.005 1.939z"],
    "send-to": ["M15 7.5c-.8 0-1.5-.4-2-1l-1.2 1.2c-.4.5-1.1.7-1.8.7-1.4.1-2.5-1-2.5-2.4 0-.7.3-1.3.7-1.8L9.5 3c-.6-.5-1-1.2-1-2 0-.3.1-.7.2-1H8C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8v-.7c-.3.1-.6.2-1 .2zM15 0h-4c-.6 0-1 .5-1 1s.4 1 1 1h1.6L9.3 5.3c-.2.2-.3.4-.3.7 0 .5.4 1 1 1 .3 0 .5-.1.7-.3L14 3.4V5c0 .6.4 1 1 1 .5 0 1-.4 1-1V1c0-.5-.4-1-1-1z"],
    "send-to-graph": ["M6 9H2c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L5 12.41V14c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm8 .5c-.56 0-1.06.23-1.42.59l-2.13-1.24L8.99 8l3.59-2.09A2.002 2.002 0 0016 4.5c0-1.1-.9-2-2-2s-2 .9-2 2c0 .19.03.37.08.54L8.5 7.13v-3.2c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S6 .9 6 2c0 .93.64 1.71 1.5 1.93v3.2l-.88-.52-2.7-1.57c.05-.17.08-.35.08-.54 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.56 0 1.06-.23 1.42-.59l2.13 1.24 3.84 2.24 2.7 1.57c-.06.17-.09.35-.09.54 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"],
    "send-to-map": ["M6 9H2c-.55 0-1 .45-1 1s.45 1 1 1h1.59L.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L5 12.41V14c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm9.55-5.83l-4.49-3A.975.975 0 009.99.15L5.53 2.82 1.56.17A1.003 1.003 0 000 1v6h2V2.87l2.94 1.96.06.03V7h1V4.86s.01 0 .01-.01L10 2.47v8.67s-.01 0-.01.01l-.99.58v2.33l1.47-.88 3.97 2.65A1.003 1.003 0 0016 15V4c0-.35-.18-.65-.45-.83zM14 13.13l-2.94-1.96c-.02-.01-.04-.02-.05-.03v-8.6l3 2v8.59z"],
    "series-add": ["M10.68 7.9c.44.54 1.07.92 1.79 1.05l-2.76 2.76c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L5 8.41l-3 3V13h13c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 6.11 4.72 6 5 6s.53.11.71.29L9 9.59l1.68-1.69zM15 3c.55 0 1 .45 1 1s-.45 1-1 1h-1v1c0 .55-.45 1-1 1s-1-.45-1-1V5h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V2c0-.55.45-1 1-1s1 .45 1 1v1h1z"],
    "series-configuration": ["M9.94 9.64c.65.23 1.34.36 2.06.36.14 0 .29-.01.43-.01L9.7 12.71c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.3L5 9.41l-3 3V14h12.99c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 7.11 4.72 7 5 7c.28 0 .53.11.71.29L9 10.59l.94-.95zm4.73-6.44h.92c.22 0 .4.18.4.4v.8c0 .22-.18.4-.4.4h-.93c-.06.2-.14.38-.24.55l.66.65c.15.15.15.4 0 .55l-.54.55c-.15.15-.4.15-.55 0l-.65-.65c-.17.1-.36.18-.55.24v.91c0 .22-.18.4-.4.4h-.8c-.22 0-.4-.18-.4-.4v-.93c-.18-.06-.36-.13-.52-.22l-.68.68c-.15.16-.41.16-.57 0l-.56-.56a.417.417 0 010-.57l.68-.68c-.08-.16-.16-.33-.22-.52h-.93c-.22 0-.4-.18-.4-.4v-.8c0-.22.18-.4.4-.4h.93c.06-.2.14-.38.24-.55l-.65-.64a.392.392 0 010-.55l.54-.55a.38.38 0 01.54 0l.65.65c.18-.1.36-.18.55-.24V.4c0-.22.18-.4.4-.4h.8c.22 0 .4.18.4.4v.93c.18.06.35.14.52.22l.68-.68c.15-.16.41-.16.57 0l.57.57c.15.16.15.41 0 .57l-.68.68c.09.16.16.33.22.51zm-4.18.8c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5c-.82 0-1.5.67-1.5 1.5z"],
    "series-derived": ["M10.66 7.92c.44.54 1.07.91 1.8 1.03L9.71 11.7c-.18.19-.43.3-.71.3s-.53-.11-.71-.3L5 8.41l-3 3V13h13c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 6.11 4.72 6 5 6s.53.11.71.29L9 9.59l1.66-1.67zM12.3 5.3l.3-.3H8c-.6 0-1-.4-1-1s.4-1 1-1h4.6l-.3-.3c-.2-.2-.3-.4-.3-.7 0-.6.5-1 1-1 .3 0 .5.1.7.3l2 2c.2.2.3.4.3.7s-.1.5-.3.7l-2 2c-.2.2-.4.3-.7.3-.6 0-1-.4-1-1 0-.3.1-.5.3-.7z"],
    "series-filtered": ["M9.29 9.3c.3.62.8 1.12 1.42 1.41l-1 1c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L5 8.41l-3 3V13h13c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v4.59l2.29-2.3C4.47 6.11 4.72 6 5 6s.53.11.71.29L9 9.59l.29-.29zM15.48 1c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V4.71L8.17 1.98A.566.566 0 018 1.57c0-.31.26-.57.57-.57h6.91z"],
    "series-search": ["M9.6 8.94a4.937 4.937 0 001.82.01c.1-.01.22-.04.39-.08l.23-.07c.04-.01.08-.02.11-.04l.22.22-2.7 2.72c-.18.19-.43.3-.71.3s-.53-.11-.71-.3L4.98 8.41l-2.99 3V13h12.94c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V3.99c0-.55.45-1 1-1s1 .45 1 1v4.59l2.28-2.3c.17-.18.42-.29.7-.29s.53.11.7.29l3.28 3.3.64-.64zm6.22-.41c.1.12.17.27.18.44 0 .34-.27.61-.61.61a.57.57 0 01-.43-.18l-2.24-2.25c-.13.08-.26.16-.4.23-.02.01-.05.02-.07.03-.14.06-.27.12-.42.17h-.01c-.14.05-.29.08-.44.11-.04.01-.08.02-.11.02-.15.02-.3.04-.46.04-1.85 0-3.35-1.51-3.35-3.37S8.96 1.01 10.81 1c1.85 0 3.35 1.51 3.35 3.37 0 .16-.02.31-.04.47-.01.04-.01.07-.02.11-.02.15-.05.29-.1.44v.01c-.05.15-.11.28-.17.42-.01.02-.02.05-.03.07-.07.14-.14.27-.23.4l2.25 2.24zm-5.01-1.94c1.22 0 2.21-.99 2.21-2.22 0-1.23-.99-2.22-2.21-2.22S8.6 3.14 8.6 4.37c0 1.22.99 2.22 2.21 2.22z"],
    "settings": ["M3 1c0-.55-.45-1-1-1S1 .45 1 1v3h2V1zm0 4H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm12-4c0-.55-.45-1-1-1s-1 .45-1 1v2h2V1zM9 1c0-.55-.45-1-1-1S7 .45 7 1v6h2V1zM1 15c0 .55.45 1 1 1s1-.45 1-1v-5H1v5zM15 4h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-2 11c0 .55.45 1 1 1s1-.45 1-1V9h-2v6zM9 8H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-2 7c0 .55.45 1 1 1s1-.45 1-1v-2H7v2z"],
    "shapes": ["M5.92 8.139c.44-.282 1.006-.121 1.264.358l2.689 4.988c.083.155.127.33.127.51C10 14.55 9.587 15 9.077 15H3.924a.864.864 0 01-.438-.12c-.449-.263-.617-.873-.376-1.362l2.465-4.989c.08-.162.2-.297.346-.39zM12 4a3 3 0 110 6 3 3 0 010-6zM6 1a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h4z"],
    "share": ["M10.99 13.99h-9v-9h4.76l2-2H.99c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V7.24l-2 2v4.75zm4-14h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L7.29 7.28a1 1 0 00-.3.71 1.003 1.003 0 001.71.71l5.29-5.29V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.56-.45-1.01-1-1.01z"],
    "shared-filter": ["M13.843 15.163c.232.53.138.837.138.837H6.017s-.088-.308.138-.837c.226-.53 1.338-.88 2.079-1.206.735-.332.66-.53.685-.8 0-.03.006-.068.006-.105a2.171 2.171 0 01-.61-.892v-.006s-.006-.006-.006-.012c-.025-.074-.056-.16-.075-.24-.176-.031-.276-.222-.314-.394a.8.8 0 01-.1-.437c.025-.253.131-.37.244-.419v-.037c0-.313.032-.775.088-1.07A1.835 1.835 0 018.85 8.37c.315-.24.76-.37 1.156-.37.396 0 .842.13 1.156.37.301.233.534.56.64.935.026.08.045.166.057.246.057.295.088.75.088 1.064v.043c.113.05.214.167.232.413a.75.75 0 01-.1.437c-.038.172-.132.357-.301.387a1.77 1.77 0 01-.076.24.136.136 0 01-.006.025 2.346 2.346 0 01-.597.892v.111c.025.277-.075.474.666.8.741.326 1.853.67 2.079 1.2z",
        "M14.852 15h1.131s.083-.27-.12-.732c-.16-.373-.82-.641-1.411-.88a15.328 15.328 0 01-.409-.17c-.565-.25-.57-.412-.577-.61-.001-.03-.002-.06-.005-.09v-.097c.22-.2.401-.469.522-.781 0 0 .005-.016.005-.022.028-.07.05-.14.066-.21.149-.026.231-.188.264-.339a.655.655 0 00.088-.382c-.016-.215-.104-.318-.203-.36v-.039c0-.274-.028-.673-.077-.931a1.598 1.598 0 00-.61-1.034 1.736 1.736 0 00-1.285-.3c.236.285.42.622.529.996.038.124.065.248.083.36.048.257.079.578.093.867a1.736 1.736 0 01.08 1.624 1.65 1.65 0 01-.217.453 1.42 1.42 0 01-.176.209c-.08.204-.178.4-.292.585l.202.083c.285.117.64.261.9.387.226.11.475.245.698.414.213.161.476.408.63.764.034.08.065.159.091.235zM12.14 14.12l.09.037zM11 1c.55 0 1 .45 1 1 0 .28-.11.53-.29.7L8 6.41v1.374a2.813 2.813 0 00-.833 1.589 6.925 6.925 0 00-.092.86 1.64 1.64 0 00-.25.739l-.001.004c-.02.217.006.413.046.573L5.71 12.71A1.003 1.003 0 014 12V6.41L.29 2.71A1.003 1.003 0 011 1h10z"],
    "shield": ["M8 16c4.667-3.048 7-7.238 7-12.571-1.556 0-3.889-1.143-7-3.429-3.111 2.286-5.444 3.429-7 3.429C1 8.762 3.333 12.952 8 16zM8 2.121c2.005 1.388 3.715 2.304 5.186 2.735-.342 3.702-2.05 6.683-5.186 9.038V2.121z"],
    "ship": ["M5.44.804L5.2 2H3a1 1 0 00-1 1v3.714l-1.08.309a.988.988 0 00-.69 1.192c.366 1.432.897 3.324 1.309 4.26a.644.644 0 00.005.01c-.175.01-.356.015-.544.015a.5.5 0 000 1c2.067 0 3.414-.543 4.161-.917.55.373 1.505.917 2.839.917 1.32 0 2.27-.533 2.822-.905l.004.002c.196.105.48.24.856.374.75.268 1.857.529 3.318.529a.5.5 0 000-1c-.295 0-.572-.012-.834-.032a.995.995 0 00.308-.458l1.208-3.74a1 1 0 00-.677-1.269L14 6.714V3a1 1 0 00-1-1h-2.2L10.56.804A1 1 0 009.58 0H6.42a1 1 0 00-.98.804zM4 6.143l3-.857V4H4v2.143zm5-.857l3 .857V4H9v1.286zm-4.036 8.273a.5.5 0 01.527.034c.455.325 1.277.907 2.509.907s2.054-.582 2.51-.907a.5.5 0 01.579-.001l.006.004.036.023c.034.022.09.055.168.097.154.082.394.197.72.313.649.232 1.642.471 2.981.471a.5.5 0 010 1c-1.46 0-2.568-.261-3.318-.53a6.316 6.316 0 01-.856-.373l-.004-.002c-.552.372-1.502.905-2.822.905-1.334 0-2.289-.544-2.839-.917-.747.374-2.094.917-4.161.917a.5.5 0 010-1c2.129 0 3.384-.63 3.964-.94z"],
    "shop": ["M3 2h10c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm9 11H4v-3H2v5c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-5h-2v3zm4-6l-1.01-3.17C14.9 3.36 14.49 3 14 3H2c-.49 0-.9.36-.98.83L.01 7H0c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2z"],
    "shopping-cart": ["M14 10H7.72l-.33-1H13c.39 0 .72-.23.89-.56h.01l2-4h-.01c.06-.13.11-.28.11-.44 0-.55-.45-1-1-1H5.39l-.44-1.32h-.01C4.8 1.29 4.44 1 4 1H1c-.55 0-1 .45-1 1s.45 1 1 1h2.28l2.33 7H4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2h6c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zM6.05 5h7.33l-1 2H6.72l-.67-2z"],
    "signal-search": ["M5.474 7.971A5.31 5.31 0 006.66 8.9l.007.019.018.056c.015.038.038.06.045.098l1.5 5.999a.75.75 0 01-1.455.36l-.42-1.68h-.704l-.42 1.68a.746.746 0 01-.907.547.746.746 0 01-.547-.907l1.5-6c.007-.037.03-.06.044-.097.015-.037.015-.075.038-.112a.722.722 0 01-.105-.36c0-.207.084-.394.22-.53zM2.795 5.277a.763.763 0 00-.015-1.065.756.756 0 00-1.065.015c-2.286 2.34-2.286 6.21 0 8.549a.747.747 0 101.072-1.042c-1.709-1.763-1.709-4.702.008-6.457zM7.808 9.388a5.318 5.318 0 001.58.211 2.236 2.236 0 01-.656.98.756.756 0 01-1.057-.098.756.756 0 01.097-1.057l.036-.036zM11.544 9.105l.378.378a6.02 6.02 0 01-1.638 3.285c-.285.3-.757.3-1.057.015a.74.74 0 01-.015-1.057 4.52 4.52 0 001.185-2.24c.4-.083.785-.212 1.147-.381z",
        "M4.054 9.424c-.427-.352-.352-1.582-.03-1.822a.752.752 0 00.15-1.05.752.752 0 00-1.05-.15c-1.079.802-1.221 3.18-.03 4.177a.75.75 0 10.96-1.155zM9.318 0a4.318 4.318 0 014.317 4.318c0 .206-.02.402-.049.598-.01.05-.01.088-.02.138-.039.196-.078.382-.137.569v.01c-.059.186-.137.363-.216.54l-.039.087a5.285 5.285 0 01-.294.51l2.884 2.886a.878.878 0 01.236.559.787.787 0 01-.785.785.785.785 0 01-.56-.226L11.772 7.89a5.285 5.285 0 01-.51.295l-.089.039c-.176.079-.353.157-.54.216h-.01a3.701 3.701 0 01-.568.137c-.05.01-.099.02-.138.02-.196.03-.392.049-.598.049A4.318 4.318 0 015 4.327 4.332 4.332 0 019.318 0zm-.02 1.1A3.195 3.195 0 006.1 4.298a3.195 3.195 0 003.198 3.198 3.195 3.195 0 003.198-3.198A3.195 3.195 0 009.298 1.1z"],
    "sim-card": ["M13.71 4.29l-4-4A.997.997 0 009 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.28-.11-.53-.29-.71zM7 6h2v2H7V6zM4 6h2v2H4V6zm2 8H4v-2h2v2zm3 0H7v-2h2v2zm3 0h-2v-2h2v2zm0-3H4V9h8v2zm0-3h-2V6h2v2z"],
    "slash": ["M10 2a.99.99 0 00-.96.73l-2.99 9.96A1.003 1.003 0 007 14c.46 0 .85-.31.96-.73l2.99-9.96A1.003 1.003 0 0010 2z"],
    "small-cross": ["M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L9.41 8z"],
    "small-minus": ["M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "small-plus": ["M11 7H9V5c0-.55-.45-1-1-1s-1 .45-1 1v2H5c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V9h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "small-square": ["M5 5v6h6V5H5zM4 3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H4z"],
    "small-tick": ["M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z"],
    "snowflake": ["M13.364 9l.879.879a1 1 0 11-1.415 1.414l-2.12-2.121A1.003 1.003 0 0110.568 9H9v1.604c.042.03.083.065.121.103l2.122 2.121a1 1 0 01-1.415 1.415L9 13.414V15a1 1 0 01-2 0v-1.636l-.879.879a1 1 0 11-1.414-1.415l2.121-2.12c.054-.054.111-.1.172-.139V9H5.38c-.038.06-.084.118-.137.172l-2.122 2.12A1 1 0 111.707 9.88L2.586 9H1a1 1 0 110-2h1.536l-.829-.828a1 1 0 011.414-1.415L5.243 6.88c.038.038.072.079.103.121H7V5.38a1.003 1.003 0 01-.172-.137L4.708 3.12A1 1 0 016.12 1.707L7 2.586V1a1 1 0 112 0v1.536l.828-.829a1 1 0 011.415 1.414L9.12 5.243A1.007 1.007 0 019 5.346V7h1.604c.03-.042.065-.083.103-.121l2.121-2.122a1 1 0 011.415 1.415L13.414 7H15a1 1 0 010 2h-1.636z"],
    "social-media": ["M9.5 4c.4 0 .8-.1 1.1-.3C12 4.5 12.9 6 13 7.6c0 .5.5.9 1 .9.6 0 1-.4 1-1v-.2c-.2-2.4-1.5-4.4-3.5-5.5-.1-1-.9-1.8-2-1.8s-2 .9-2 2 .9 2 2 2zM4 8.5c0-.7-.4-1.3-.9-1.7.3-1.4 1.2-2.6 2.5-3.3.3-.1.6-.4.6-.9s-.4-1-1-1c-.2 0-.3 0-.5.1-1.9 1-3.2 2.8-3.6 5C.4 7.1 0 7.8 0 8.5c0 1.1.9 2 2 2s2-.9 2-2zm8.8 1.2c-1.1 0-2 .9-2 2v.3c-.8.6-1.8.9-2.8.9-1.2 0-2.3-.4-3.2-1.1-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.6.3.8C4.6 14.4 6.2 15 8 15c1.5 0 3-.5 4.1-1.3.2.1.5.1.7.1 1.1 0 2-.9 2-2s-.9-2.1-2-2.1z"],
    "sort": ["M5 12c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 001 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 005 12zm3-9h7c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm7 2H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm0 8H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "sort-alphabetical": ["M6 12c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 002 12a1.003 1.003 0 00-.71 1.71l2 2c.19.18.44.29.71.29.28 0 .53-.11.71-.29l2-2c.18-.18.29-.43.29-.71a.99.99 0 00-1-1zm7.93-.95v-1.04H9.25v1.11h2.94L9 14.96V16h5.02v-1.11h-3.27l3.18-3.84zm-1.42-4.84l.62 1.78H15L11.94.01H10.1L7 7.99h1.81l.64-1.78h3.06zm-1.52-4.24h.02l1.03 2.93H9.92l1.07-2.93z"],
    "sort-alphabetical-desc": ["M5.99 11.99c-.28 0-.53.11-.71.29l-.29.29V8.99c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2c.18-.18.29-.43.29-.71 0-.56-.45-1.01-1-1.01zM12.7 10h-1.38L9 15.99h1.36l.48-1.33h2.3l.46 1.33H15L12.7 10zm-1.51 3.67l.8-2.2h.02l.77 2.2h-1.59zm3.8-7.17h-4.57l4.45-5.12V0H8.34v1.48h4.1L7.99 6.59v1.39h7V6.5z"],
    "sort-asc": ["M8 7h3c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h1c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 8h5c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm-3 1c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 001 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 005 12zm10 1H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "sort-desc": ["M5 12c-.28 0-.53.11-.71.29l-.29.3V9c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29A.965.965 0 001 12a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 005 12zm4 1H8c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1zm4-8H8c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm-2 4H8c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm4-8H8c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "sort-numerical": ["M6 11.99c-.28 0-.53.11-.71.29l-.29.3V8.99c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l2-2A1.003 1.003 0 006 11.99zm7.91-.08c-.06-.36-.17-.68-.33-.96-.16-.28-.37-.51-.64-.69-.27-.17-.61-.26-1.03-.26-.28 0-.54.06-.78.17-.23.11-.43.26-.6.45-.17.19-.3.41-.39.67a2.492 2.492 0 00-.04 1.52 1.623 1.623 0 00.89 1.03c.22.11.45.16.68.16.26 0 .5-.05.7-.15s.38-.26.53-.5l.02.02c-.01.16-.03.34-.07.54-.03.2-.09.4-.17.57-.08.18-.18.33-.31.45s-.29.19-.5.19a.63.63 0 01-.48-.21c-.13-.14-.21-.31-.25-.5H10.1c.03.25.1.48.19.68.1.2.22.37.38.5.16.14.33.24.54.31s.42.1.65.1c.39 0 .72-.09.99-.27.27-.18.49-.41.66-.7.17-.29.29-.61.37-.97.08-.36.12-.72.12-1.07 0-.36-.03-.72-.09-1.08zm-1.14.54c-.04.13-.09.24-.16.34a.78.78 0 01-.27.24c-.11.06-.24.09-.39.09a.75.75 0 01-.37-.09.777.777 0 01-.26-.25c-.07-.1-.12-.22-.15-.35-.03-.13-.05-.26-.05-.4 0-.13.02-.26.05-.39.04-.13.09-.24.16-.34.07-.1.16-.18.26-.24s.22-.09.35-.09c.14 0 .26.03.37.09.11.06.2.14.28.24a1.32 1.32 0 01.23.74c0 .15-.02.28-.05.41zm-1.56-4.47H13V0h-1.42c-.05.3-.16.56-.31.76-.16.21-.35.37-.58.5-.23.13-.49.21-.78.26-.3.05-.6.07-.91.06V2.8h2.21v5.18z"],
    "sort-numerical-desc": ["M6 11.99c-.28 0-.53.11-.71.29l-.29.3V8.99c0-.55-.45-1-1-1s-1 .45-1 1v3.59l-.29-.29a.982.982 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 006 11.99zm7.86-9.45c-.09-.48-.26-.9-.5-1.28S12.8.58 12.4.35C12 .12 11.49 0 10.86 0c-.43 0-.82.07-1.17.22s-.65.35-.9.6-.44.55-.58.89c-.14.34-.2.71-.2 1.11 0 .31.05.61.15.91.1.3.26.57.48.8.23.24.52.43.85.58.33.14.68.21 1.03.21.4 0 .75-.07 1.05-.2.3-.13.57-.35.79-.66l.02.02c-.02.21-.05.45-.1.73-.05.27-.13.53-.25.76-.12.24-.27.44-.47.6-.19.16-.44.25-.75.25a.98.98 0 01-.72-.29c-.19-.18-.31-.4-.37-.66H8.15c.05.34.14.64.29.9.15.26.34.49.57.67.23.18.5.32.8.41.31.1.63.15.98.15.58 0 1.08-.12 1.48-.36.4-.24.73-.55.99-.93.26-.39.44-.82.56-1.29.12-.48.18-.96.18-1.44s-.05-.96-.14-1.44zm-1.71.72c-.05.17-.14.32-.24.46-.11.13-.24.24-.41.31-.16.08-.36.12-.58.12-.21 0-.39-.04-.55-.13-.16-.08-.29-.19-.39-.33-.12-.14-.19-.29-.24-.46-.05-.17-.08-.35-.08-.54 0-.18.03-.35.08-.52.06-.16.14-.31.25-.44.11-.13.24-.24.4-.32.16-.08.33-.12.52-.12.21 0 .4.04.56.12.16.08.3.19.41.32.11.14.2.29.26.46.06.17.09.35.09.52 0 .2-.03.38-.08.55zm-.46 7.31c-.12.15-.26.28-.44.37-.17.09-.37.16-.58.2-.22.04-.44.05-.67.05v.92h1.65v3.88h1.33V10h-1.06c-.03.23-.11.42-.23.57z"],
    "split-columns": ["M12 10a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H9V2h3v1.71c.31-.13.64-.21 1-.21s.69.08 1 .21V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2.71c.31-.13.64-.21 1-.21s.69.08 1 .21V2h3v5H3.41l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C.11 7.47 0 7.72 0 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L3.41 9H7v5H4v-1.71c-.31.13-.64.21-1 .21s-.69-.08-1-.21V15c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-2.71c-.31.13-.64.21-1 .21s-.69-.08-1-.21V14H9V9h3.59l-.29.29c-.19.18-.3.43-.3.71z"],
    "square": ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V2h12v12z"],
    "stacked-chart": ["M10 2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3h3V2zm3 10h1c.55 0 1-.45 1-1V8h-3v3c0 .55.45 1 1 1zm2-7c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2h3V5zm-5 1H7v3h3V6zM5 7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v1h3V7zm3 5h1c.55 0 1-.45 1-1v-1H7v1c0 .55.45 1 1 1zm7 1H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM3 12h1c.55 0 1-.45 1-1V9H2v2c0 .55.45 1 1 1z"],
    "stadium-geometry": ["M12 6H4a2 2 0 100 4h8a2 2 0 100-4zM4 4a4 4 0 100 8h8a4 4 0 000-8H4z"],
    "star": ["M8 0l2.5 5.3 5.5.8-4 4.1.9 5.8L8 13.3 3.1 16l.9-5.8-4-4.1 5.5-.8z"],
    "star-empty": ["M16 6.11l-5.53-.84L8 0 5.53 5.27 0 6.11l4 4.1L3.06 16 8 13.27 12.94 16 12 10.21l4-4.1zM4.91 13.2l.59-3.62L3 7.02l3.45-.53L8 3.2l1.55 3.29 3.45.53-2.5 2.56.59 3.62L8 11.49 4.91 13.2z"],
    "step-backward": ["M12 3c-.24 0-.44.09-.62.23l-.01-.01L7 6.72V4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V9.28l4.38 3.5.01-.01c.17.14.37.23.61.23.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "step-chart": ["M15 12H2v-2h3c.55 0 1-.45 1-1V7h2v1c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1v3h-2V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "step-forward": ["M12 3h-1c-.55 0-1 .45-1 1v2.72l-4.38-3.5v.01A.987.987 0 005 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .24 0 .44-.09.62-.23l.01.01L10 9.28V12c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "stop": ["M12 3H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "stopwatch": ["M9 2v1.083A6.002 6.002 0 018 15 6 6 0 017 3.083V2H6a1 1 0 110-2h4a1 1 0 010 2H9zM8 5a4 4 0 104 4H8V5z"],
    "strikethrough": ["M14 7H8.65c-.38-.09-.73-.18-1.04-.26-.31-.08-.49-.13-.54-.14-.43-.11-.79-.29-1.05-.52-.27-.23-.4-.55-.4-.95 0-.29.07-.53.21-.72s.32-.34.54-.46c.22-.11.46-.19.72-.24.26-.05.52-.07.77-.07.74 0 1.36.15 1.84.46.32.2.55.5.68.9h2.22c-.06-.33-.17-.64-.32-.92-.25-.45-.59-.84-1.02-1.15-.43-.31-.93-.54-1.49-.7S8.59 2 7.95 2c-.55 0-1.1.07-1.63.2-.54.13-1.02.34-1.45.62-.42.28-.76.63-1.02 1.05-.26.42-.39.92-.39 1.5 0 .3.04.59.13.88.08.26.21.51.39.75H2c-.55 0-1 .45-1 1s.45 1 1 1h7.13c.25.07.49.14.71.22.25.09.48.23.7.44.21.21.32.53.32.97 0 .21-.05.43-.14.63-.09.21-.24.39-.45.55-.21.16-.48.29-.81.39-.33.1-.73.15-1.2.15-.44 0-.84-.05-1.21-.14-.37-.09-.7-.24-.99-.43-.29-.2-.51-.45-.67-.76-.01 0-.01-.01-.02-.02H3.14a3.68 3.68 0 001.39 2.03c.46.34 1 .58 1.62.74.61.15 1.27.23 1.97.23.61 0 1.2-.07 1.79-.2.58-.13 1.11-.34 1.56-.63.46-.29.83-.66 1.11-1.11.28-.45.42-1 .42-1.64 0-.3-.05-.6-.15-.9-.05-.19-.13-.36-.22-.52H14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "style": ["M14 14H2V2h8.76l2-2H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6.24l-2 2V14zm1.4-14L9.7 5.7l2.1 2.1L16 3.6V0h-.6zM4 11.92c2.33.15 4.42.15 6.15-1.5.82-.83.82-2.25 0-3.08-.45-.38-.98-.6-1.5-.6-.53 0-1.05.22-1.43.6-.82.91-1.27 3.38-3.22 4.58z"],
    "swap-horizontal": ["M0 7.02L.05 7H0v.02zm2-2.03h9.57l-1.29 1.29A1.003 1.003 0 0011.7 7.7l2.99-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2.99-3a1.07 1.07 0 00-.71-.28 1.003 1.003 0 00-.71 1.71L11.57 3H2c-.55 0-1 .45-1 1a1 1 0 001 .99zM15.96 9H16v-.02l-.04.02zM14 11.01H4.43l1.29-1.29A1.003 1.003 0 004.3 8.3l-2.99 3a.99.99 0 00-.29.7c0 .28.11.53.29.71l2.99 3a1.003 1.003 0 001.42-1.42L4.43 13H14c.55 0 1-.45 1-1s-.45-.99-1-.99z"],
    "swap-vertical": ["M9 0h-.02L9 .04V0zM7 16h.02L7 15.95V16zM4.7 1.31c-.18-.18-.43-.29-.7-.29s-.53.11-.71.29l-3 2.99a1.003 1.003 0 001.42 1.42L3 4.43V14c0 .55.45 1 1 1s1-.45 1-1V4.43l1.29 1.29c.18.18.43.29.7.29A1.003 1.003 0 007.7 4.3l-3-2.99zM15 9.99c-.28 0-.53.11-.71.29L13 11.57V2c0-.55-.45-1-1-1s-1 .45-1 1v9.57l-1.29-1.29a.99.99 0 00-.7-.29 1.003 1.003 0 00-.71 1.71l3 2.99c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-2.99c.18-.18.29-.43.29-.71-.01-.55-.46-1-1.01-1z"],
    "switch": ["M9.293 2.293l1.414 1.414-4.999 5a3 3 0 11-1.415-1.415l5-5zM13 7a3 3 0 110 6 3 3 0 010-6zM3 9a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2z"],
    "symbol-circle": ["M8 3.01a5 5 0 100 10 5 5 0 100-10z"],
    "symbol-cross": ["M12 6.01h-2v-2c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v2H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1v-2c0-.56-.45-1-1-1z"],
    "symbol-diamond": ["M12 8.01c0-.19-.07-.36-.16-.51l.01-.01-3-5-.01.01c-.17-.29-.48-.49-.84-.49s-.67.2-.84.49l-.02-.01-3 5 .02.01c-.09.15-.16.32-.16.51s.07.36.16.51h-.02l3 5 .01-.01c.18.29.49.5.85.5s.67-.2.84-.49l.01.01 3-5-.01-.01c.09-.16.16-.32.16-.51z"],
    "symbol-rectangle": ["M13 4H3c-.5 0-1 .5-1 1v6c0 .5.5 1 1 1h10c.5 0 1-.5 1-1V5c0-.5-.5-1-1-1z"],
    "symbol-square": ["M12 3.01H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-8c0-.56-.45-1-1-1z"],
    "symbol-triangle-down": ["M13 4.01c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 .16.05.31.11.44H3.1l4 8h.01c.16.33.49.56.89.56s.72-.23.89-.56h.01l4-8h-.01c.06-.14.11-.28.11-.44z"],
    "symbol-triangle-up": ["M12.89 11.56l-3.99-8h-.01c-.17-.32-.5-.55-.89-.55s-.72.23-.89.55H7.1l-4 8h.01c-.06.14-.11.29-.11.45 0 .55.45 1 1 1h8c.55 0 1-.45 1-1 0-.16-.05-.31-.11-.45z"],
    "syringe": ["M11.146.146a.5.5 0 000 .708l.647.646L10.5 2.793 8.854 1.146a.5.5 0 10-.708.708l.647.646-1.146 1.146-5.5 5.5a.5.5 0 000 .708l.646.646-1.647 1.646a.5.5 0 000 .708l.647.646-1.647 1.646a.5.5 0 00.708.708L2.5 14.207l.646.647a.5.5 0 00.708 0L5.5 13.207l.646.647a.5.5 0 00.708 0l5.5-5.5L13.5 7.207l.646.647a.5.5 0 00.708-.708L13.207 5.5 14.5 4.207l.646.647a.5.5 0 00.708-.708l-4-4a.5.5 0 00-.708 0zM11.293 8l-.793.793-1.646-1.647a.5.5 0 10-.708.708L9.793 9.5 8.5 10.793 6.854 9.146a.5.5 0 10-.708.708L7.793 11.5 6.5 12.793 3.207 9.5 8 4.707 11.293 8zM8.707 4L12 7.293l.793-.793L9.5 3.207 8.707 4zm-6.5 8.5L3.5 13.793 4.793 12.5 3.5 11.207 2.207 12.5zm11.586-9L12.5 2.207 11.207 3.5 12.5 4.793 13.793 3.5z"],
    "tag": ["M1 3a2 2 0 012-2h4.584a2 2 0 011.414.586l5.413 5.412a2 2 0 010 2.829L9.827 14.41a2 2 0 01-2.829 0L1.586 8.998A2 2 0 011 7.584V3zm3.487-.007a1.494 1.494 0 100 2.988 1.494 1.494 0 000-2.988z"],
    "take-action": ["M9 11a1.003 1.003 0 001.71.71l4-4a1.003 1.003 0 00-1.42-1.42l-4 4c-.18.18-.29.43-.29.71zM4 6c.28 0 .53-.11.71-.29l4-4A1.003 1.003 0 007.29.29l-4 4A1.003 1.003 0 004 6zm4 4l5-5-.79-.79.5-.5a1.003 1.003 0 00-1.42-1.42l-.5.5L10 2 5 7l.79.79-5.5 5.5a1.003 1.003 0 001.42 1.42l5.5-5.5L8 10zm7 4H7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "tank": ["M3.7 3.4a1 1 0 01.8-.4h5.086a1 1 0 01.707.293L11 4h3a1 1 0 110 2h-3v1h2.5a2.5 2.5 0 010 5h-11a2.5 2.5 0 010-5H3V4.667a1 1 0 01.2-.6l.5-.667zM2.5 9h11a.5.5 0 010 1h-11a.5.5 0 110-1z"],
    "target": ["M7 4a1 1 0 012 0v2a1 1 0 01-2 0V4zM10 7a1 1 0 000 2h2a1 1 0 000-2h-2zM3 8a1 1 0 011-1h2a1 1 0 010 2H4a1 1 0 01-1-1zM8 9a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z",
        "M8 16A8 8 0 108 0a8 8 0 000 16zm0-2A6 6 0 108 2a6 6 0 000 12z"],
    "taxi": ["M15.12 6.63h-.38L15 7c-.01.3-.01.64 0 .98V8c0 .07-.03.13-.04.19h.02L14 13.1v.9c0 .55-.45 1-1 1s-1-.45-1-1v-1H4v1c0 .55-.45 1-1 1s-1-.45-1-1v-.9l-.98-4.9h.02C1.03 8.13 1 8.07 1 8H.99c0-.33 0-.67.01-1l.26-.37H.88C.4 6.63 0 6.21 0 5.69s.4-.94.88-.94h1.05l.77-2.11c.19-.53.76-1.08 1.26-1.24 0 0 .68-.2 2.05-.32C6.01 1.05 6 1.03 6 1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1 0 .03-.01.05-.02.08 1.37.12 2.05.32 2.05.32.51.15 1.08.71 1.27 1.24l.76 2.12h1.05c.49 0 .89.42.89.93 0 .52-.4.94-.88.94zM11 10h2V8h-2v2zm-8 0h2V8H3v2zm10-5l-.73-1.63C12.21 3.19 12.18 3 12 3H4c-.18 0-.21.19-.27.37L3 5c-.06.18-.18 1 0 1h10c.18 0 .06-.82 0-1z"],
    "temperature": ["M8.5 0A1.5 1.5 0 007 1.5v7.837a3.5 3.5 0 103 0V1.5A1.5 1.5 0 008.5 0zM2 5.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM2.5 1a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4 3.5a.5.5 0 01.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM4.5 7a.5.5 0 000 1h1a.5.5 0 000-1h-1z"],
    "text-highlight": ["M9 10H2V6h7V4H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h8v-2zm4 3h-1V3h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.37 0-.7.11-1 .28-.3-.17-.63-.28-1-.28H9c-.55 0-1 .45-1 1s.45 1 1 1h1v10H9c-.55 0-1 .45-1 1s.45 1 1 1h1c.37 0 .7-.11 1-.28.3.17.63.28 1 .28h1c.55 0 1-.45 1-1s-.45-1-1-1zm2-9h-2v2h1v4h-1v2h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "th": ["M15 1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1zM6 13H2v-2h4v2zm0-3H2V8h4v2zm0-3H2V5h4v2zm8 6H7v-2h7v2zm0-3H7V8h7v2zm0-3H7V5h7v2z"],
    "th-derived": ["M5.6 10l-.3.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l2-2c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-2-2C6.5 6.1 6.3 6 6 6c-.5 0-1 .4-1 1 0 .3.1.5.3.7l.3.3H1c-.6 0-1 .4-1 1s.4 1 1 1h4.6zM15 1H2c-.5 0-1 .5-1 1v5h2V5h11v2H8.8l.6.6c.1.1.2.3.3.4H14v2H9.7c-.1.1-.2.3-.3.4l-.6.6H14v2H3v-2H1v3c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V2c0-.5-.4-1-1-1z"],
    "th-disconnect": ["M12 1h3c.6 0 1 .5 1 1v12c0 .6-.4 1-1 1h-4.97l.286-2H14v-2h-3.398l.143-1H14V8h-2.97l.143-1H14V5h-2.541l.51-3.576C11.99 1.282 12 1.14 12 1zM5.97 1l-.572 4H2v2h3.112L4.97 8H2v2h2.684l-.143 1H2v2h2.255l-.225 1.576c-.02.142-.03.284-.03.424H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h4.97zM8.01.859a1 1 0 111.98.282l-2 14a1 1 0 11-1.98-.282l2-14z"],
    "th-filtered": ["M10 10h3l1.78-2.226a1 1 0 00.22-.625V4.3l1-.9V14c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V2c0-.5.4-1 1-1h4.333L9 4.3V5H7v2h2v1H7v2h3zm-4 3v-2H2v2h4zm0-3V8H2v2h4zm0-3V5H2v2h4zm8 6v-2H7v2h7z",
        "M15.48 0c.31 0 .52.26.52.57 0 .16-.06.3-.17.41l-2.86 2.73v2.63c0 .16-.06.3-.17.41l-.82 1.1c-.1.1-.25.17-.41.17-.31 0-.57-.26-.57-.57V3.71L8.17.98A.566.566 0 018 .57c0-.31.26-.57.57-.57h6.91z"],
    "th-list": ["M15 1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1zm-1 12H2v-2h12v2zm0-3H2V8h12v2zm0-3H2V5h12v2z"],
    "third-party": ["M4.448 9h.573c.025-.044.051-.088.079-.13A9.43 9.43 0 015.183 8h-.995A10.424 10.424 0 014 6c0-.717.068-1.391.188-2h3.624c.065.33.114.678.146 1.042A3.42 3.42 0 018.46 5c.168 0 .336.013.502.037A11.089 11.089 0 008.829 4h1.755c.148.338.26.696.33 1.068l.176-.028a2.74 2.74 0 01.5 0c.113 0 .225.006.336.018A6.001 6.001 0 000 6a6 6 0 005.672 5.991 4 4 0 01-.202-.441 1.842 1.842 0 01-.24-.26 1.82 1.82 0 01-.26-.55 2 2 0 01-.185-.92l-.012-.025A6.036 6.036 0 014.448 9zM3.171 8H1.416A4.983 4.983 0 011 6c0-.711.148-1.388.416-2h1.755C3.06 4.626 3 5.299 3 6c0 .701.06 1.374.17 2zM2 9H3.4c.18.618.412 1.167.685 1.62A5.015 5.015 0 012 9zm2.448-6h3.104a6.036 6.036 0 00-.325-.795C6.737 1.225 6.246 1 6 1c-.246 0-.737.225-1.227 1.205-.119.238-.228.504-.325.795zm4.15 0H10a5.016 5.016 0 00-2.086-1.62c.273.453.506 1.002.685 1.62zM4.087 1.38A6.834 6.834 0 003.401 3H2a5.015 5.015 0 012.086-1.62zM13.476 16s.118-.385-.172-1.046c-.228-.533-1.172-.915-2.015-1.257a22.113 22.113 0 01-.584-.243c-.808-.356-.816-.588-.825-.872-.002-.041-.003-.084-.007-.128v-.139c.314-.284.573-.669.745-1.115 0 0 .008-.023.008-.03.04-.1.071-.2.095-.3.212-.04.33-.27.377-.485.054-.093.149-.3.125-.547-.024-.307-.15-.453-.29-.515v-.054c0-.392-.04-.961-.11-1.33a2.16 2.16 0 00-.071-.308 2.283 2.283 0 00-.8-1.17C9.558 6.162 9.001 6 8.506 6c-.495 0-1.052.162-1.445.462A2.294 2.294 0 006.19 7.93c-.07.369-.11.946-.11 1.338v.046c-.14.062-.274.208-.306.523a1 1 0 00.126.547c.047.215.173.453.393.492.02.083.05.172.078.253l.016.047c0 .008.008.015.008.015v.008c.172.454.44.846.761 1.115a.804.804 0 01-.004.072c-.002.02-.004.04-.004.06l-.007.105c-.016.287-.028.523-.848.894-.176.078-.37.156-.568.237-.847.345-1.802.735-2.031 1.27C3.41 15.616 3.52 16 3.52 16h9.955zm2.503-1.25h-1.413a4.05 4.05 0 00-.116-.294c-.192-.445-.52-.753-.787-.955-.278-.21-.59-.38-.873-.517a21.373 21.373 0 00-1.122-.483l-.02-.008-.235-.097c.144-.23.266-.476.366-.731.089-.087.162-.177.22-.26.132-.192.217-.391.271-.568.117-.251.24-.64.199-1.105a2.025 2.025 0 00-.299-.925 8.626 8.626 0 00-.116-1.083 3.426 3.426 0 00-.104-.45 3.476 3.476 0 00-.661-1.246A2.18 2.18 0 0111.63 6c.432 0 .92.141 1.264.404.33.256.584.612.7 1.023.028.087.049.182.062.27.062.322.097.82.097 1.163v.048c.123.053.233.181.254.45a.82.82 0 01-.11.478c-.041.189-.144.391-.33.425a1.92 1.92 0 01-.082.262c0 .007-.007.027-.007.027-.151.39-.378.727-.653.976v.121c.004.038.005.075.006.111v.002c.008.247.015.451.722.762.158.07.332.14.51.213.739.299 1.565.634 1.764 1.1.254.579.151.915.151.915z"],
    "thumbs-down": ["M2 2H0v7h2c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm13.99 4.38c.08-.58-.44-1.02-1.15-1.05-.25-.01-.52-.03-.81-.05.02 0 .05-.01.07-.01.7-.1 1.34-.49 1.41-1.07.06-.58-.46-.97-1.17-1.04-.25-.02-.52-.04-.79-.06.47-.15.84-.42.87-.93.04-.58-.79-1.03-1.5-1.09-.27-.02-.51-.04-.73-.05h-.09c-.23-.02-.43-.02-.62-.03C8.35.95 5.66 1.47 4 2.51v6c2.14 1.29 4.76 3.59 4.21 5.51-.18.59.31 1.05.98.98.81-.09 1.37-.91 1.4-1.78.04-1-.15-2.01-.5-2.91-.04-.25.01-.5.37-.53.49-.03 1.11-.06 1.59-.08.26 0 .51-.01.75-.02h.01c.41-.02.8-.05 1.13-.09.7-.09 1.35-.47 1.43-1.05.08-.58-.44-.97-1.15-1.05-.05-.01-.11-.01-.16-.02.17-.01.33-.03.49-.05.72-.08 1.37-.46 1.44-1.04z"],
    "thumbs-up": ["M15.99 9.62c-.08-.58-.73-.96-1.43-1.05-.15-.02-.32-.04-.49-.05.06-.01.11-.01.16-.02.71-.08 1.23-.47 1.15-1.05-.08-.58-.73-.96-1.43-1.05-.34-.04-.72-.07-1.13-.09h-.01c-.24-.01-.49-.02-.75-.02-.48-.02-1.11-.04-1.59-.08-.36-.03-.41-.28-.37-.53.35-.9.54-1.91.5-2.91-.04-.85-.6-1.68-1.41-1.77-.67-.07-1.16.39-.99.98C8.76 3.91 6.13 6.2 4 7.49v6c1.66 1.03 4.35 1.56 7.48 1.5.19 0 .39-.01.62-.02h.09c.22-.01.46-.03.73-.05.71-.06 1.54-.51 1.5-1.09-.03-.51-.4-.79-.87-.93.27-.02.54-.04.79-.06.71-.06 1.24-.45 1.17-1.04-.06-.58-.7-.97-1.41-1.07-.02 0-.05-.01-.07-.01.29-.02.57-.03.81-.05.71-.03 1.23-.47 1.15-1.05zM2 7H0v7h2c.55 0 1-.45 1-1V8c0-.56-.45-1-1-1z"],
    "tick": ["M14 3c-.28 0-.53.11-.71.29L6 10.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l8-8A1.003 1.003 0 0014 3z"],
    "tick-circle": ["M8 16c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4-11c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z"],
    "time": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm1-6.41V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L9 7.59z"],
    "timeline-area-chart": ["M15 2.59L9.91 7.68 6.6 5.2l-.01.01C6.42 5.09 6.23 5 6 5c-.24 0-.44.09-.62.23v-.01L3 7.12V11h12V2.59zM15 12H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "timeline-bar-chart": ["M8 12h1c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1zm5 0h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm2 1H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM3 12h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"],
    "timeline-events": ["M8 11H7v1h1v-1zm-4 0H3v1h1v-1zm7-8c.6 0 1-.5 1-1V1c0-.5-.4-1-1-1s-1 .5-1 1v1c0 .5.5 1 1 1zM4 3c.5 0 1-.5 1-1V1c0-.5-.5-1-1-1S3 .5 3 1v1c0 .5.5 1 1 1zm10-2h-1v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H6v1c0 1.1-.9 2-2 2s-2-.9-2-2V1H1c-.5 0-1 .5-1 1v12c0 .5.5 1 1 1h13c.6 0 1-.5 1-1V2c0-.5-.4-1-1-1zM5 13H2v-3h3v3zm0-4H2V6h3v3zm4 4H6v-3h3v3zm0-4H6V6h3v3zm4 4h-3v-3h3v3zm0-4h-3V6h3v3zm-1-2h-1v1h1V7z"],
    "timeline-line-chart": ["M15 12H2V9.41l3-3L8.29 9.7c.18.19.43.3.71.3s.53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42L9 7.59l-3.29-3.3C5.53 4.11 5.28 4 5 4s-.53.11-.71.29L2 6.59V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "tint": ["M7.88 1s-4.9 6.28-4.9 8.9c.01 2.82 2.34 5.1 4.99 5.1 2.65-.01 5.03-2.3 5.03-5.13C12.99 7.17 7.88 1 7.88 1z"],
    "torch": ["M5 15c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H5v1zm7-15H4c-.55 0-1 .45-1 1v1h10V1c0-.55-.45-1-1-1zM5 7v6h6V7l2-4H3l2 4zm2 0c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V7z"],
    "tractor": ["M3.5 9a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm9.5 1a3 3 0 110 6 3 3 0 010-6zm-9.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9.5 1a1 1 0 100 2 1 1 0 000-2zM5 0c1.46 0 2.527.668 3 2l.815 3.255a78.9 78.9 0 012.186.195L11 2h2l.001 3.688c.698.095 1.37.198 2.013.312.623.11.986.479.986 1v3.354a4.001 4.001 0 00-6.873 1.645H7.999l-.026-.002A4.5 4.5 0 00.659 9.01l-.654.001v-.829C.003 7.386.002 6.423 0 6.022 0 5.5.376 4.99 1 4.99V1a1 1 0 011-1h3zm1 2H3v2.99c1.29.024 2.554.069 3.781.135L6 2z"],
    "train": ["M13 14h-1l1 2H3l1-2H3c-1.1 0-2-.9-2-2V2C1 .9 4.13 0 8 0s7 .9 7 2v10c0 1.1-.9 2-2 2zm-2-2h2v-2h-2v2zM9 7h4V3H9v4zm-6 5h2v-2H3v2zm0-5h4V3H3v4z"],
    "translate": ["M15.89 14.56l-3.99-8h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56h-.01L9 8.76 7.17 7.38l.23-.18C8.37 6.47 9 5.31 9 4V3h1c.55 0 1-.45 1-1s-.45-1-1-1H7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1H1c-.55 0-1 .45-1 1s.45 1 1 1h6v1c0 .66-.32 1.25-.82 1.61l-.68.51-.68-.5C4.32 5.25 4 4.66 4 4H2c0 1.31.63 2.47 1.6 3.2l.23.17L1.4 9.2l.01.01C1.17 9.4 1 9.67 1 10c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01 2.9-2.17 2.6 1.95-1.99 3.98h.01c-.07.13-.12.28-.12.44 0 .55.45 1 1 1 .39 0 .72-.23.89-.56h.01L8.62 14h4.76l.72 1.45h.01c.17.32.5.55.89.55.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44zM9.62 12L11 9.24 12.38 12H9.62z"],
    "trash": ["M14.49 3.99h-13c-.28 0-.5.22-.5.5s.22.5.5.5h.5v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-8.5 9c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm3 0c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm3 0c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm2-12h-4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1h-4c-.55 0-1 .45-1 1v1h14v-1c0-.55-.45-1-1-1z"],
    "tree": ["M9 11.857V16H7v-4.143L1 13l3.885-4.44L3 9l3.07-4.297L5 5l3-5 3 5-1.07-.297L13 9l-1.885-.44L15 13l-6-1.143z"],
    "trending-down": ["M15 7c-.55 0-1 .45-1 1v.59l-4.29-4.3A.997.997 0 009 4c-.16 0-.31.05-.44.11V4.1L5 5.88 1.45 4.11v.01C1.31 4.05 1.16 4 1 4c-.55 0-1 .45-1 1 0 .39.23.72.56.89v.01l4 2v-.01c.13.06.28.11.44.11s.31-.05.44-.11v.01L8.8 6.22 12.59 10H12c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1z"],
    "trending-up": ["M15 4h-3c-.55 0-1 .45-1 1s.45 1 1 1h.59L8.8 9.78 5.45 8.11v.01C5.31 8.05 5.16 8 5 8s-.31.05-.44.11V8.1l-4 2v.01c-.33.17-.56.5-.56.89 0 .55.45 1 1 1 .16 0 .31-.05.44-.11v.01L5 10.12l3.55 1.78v-.01c.14.06.29.11.45.11.28 0 .53-.11.71-.29L14 7.41V8c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "truck": ["M12.5 0a.5.5 0 01.5.5V9a1 1 0 011 1v2h.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13v1a1 1 0 01-2 0v-1H5v1a1 1 0 01-2 0v-1H1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H2v-2a1 1 0 011-1V.5a.5.5 0 011 0V3a2 2 0 012-2h4a2 2 0 012 2V.5a.5.5 0 01.5-.5zM9 8H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V9a1 1 0 00-1-1zm3.5 3h-1a.5.5 0 100 1h1a.5.5 0 100-1zm-8 0h-1a.5.5 0 100 1h1a.5.5 0 100-1zM9 9a.5.5 0 01.5.5v1l-.008.09A.5.5 0 019 11H7l-.09-.008a.5.5 0 01-.41-.492v-1l.008-.09A.5.5 0 017 9zm2-5H5v2h6V4z"],
    "two-columns": ["M3.99-.01h-3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm11.71 7.3l-2-2a1.003 1.003 0 00-1.71.71v4a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71s-.11-.53-.29-.71zM9.99-.01h-3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1z"],
    "unarchive": ["M13.382 0a1 1 0 01.894.553L16 4v11a1 1 0 01-1 1H1a1 1 0 01-1-1V4L1.724.553A1 1 0 012.618 0h10.764zM8 6c-.28 0-.53.11-.71.29l-2 2-.084.096A1.003 1.003 0 006.71 9.71l.29-.3V12l.007.116c.058.496.482.884.993.884.55 0 1-.45 1-1V9.41l.29.29.081.076A.97.97 0 0010 10a1.003 1.003 0 00.71-1.71l-2-2-.096-.084A1.002 1.002 0 008 6zm5-4H3L2 4h12l-1-2z"],
    "underline": ["M8 14c2.8 0 5-2.2 5-5V3c0-.6-.4-1-1-1s-1 .4-1 1v6c0 1.7-1.3 3-3 3s-3-1.3-3-3V3c0-.6-.4-1-1-1s-1 .4-1 1v6c0 2.8 2.2 5 5 5zM13.5 15h-11c-.3 0-.5.2-.5.5s.2.5.5.5h11c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"],
    "undo": ["M4 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H3.41L4.7 2.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 4.47 0 4.72 0 5c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 6H11c1.66 0 3 1.34 3 3s-1.34 3-3 3H7v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"],
    "ungroup-objects": ["M3.5 5C1.57 5 0 6.57 0 8.5S1.57 12 3.5 12 7 10.43 7 8.5 5.43 5 3.5 5zm9 0C10.57 5 9 6.57 9 8.5s1.57 3.5 3.5 3.5S16 10.43 16 8.5 14.43 5 12.5 5z"],
    "unknown-vehicle": ["M10.507 9.75v-3.5c0-.089.023-.171.051-.25h-7.55c-.176 0-.061-.824 0-1l.729-1.63c.06-.177.095-.37.27-.37h4.5V1.01c-.166-.003-.32-.01-.5-.01-2.72 0-4.036.402-4.036.402-.508.155-1.079.711-1.268 1.237L1.94 4.756H.887c-.483 0-.88.423-.88.939s.397.939.88.939h.376L1.008 7c-.034.685 0 1.436 0 2v5c0 .657.384 1 1 1s1-.343 1-1v-1h10v1c0 .657.383 1 1 1s1-.343 1-1v-3.5h-3.75a.75.75 0 01-.75-.75zm-5.5.25h-2V8h2v2zm11-4.305zM15.34.826a2.807 2.807 0 00-.932-.598c-.386-.16-.868-.241-1.445-.241-.447 0-.851.076-1.213.228-.362.153-.67.364-.926.636s-.456.592-.598.963a3.535 3.535 0 00-.218 1.144V3h1.789c.003-.208.023-.405.069-.588.049-.193.124-.362.225-.506.102-.144.232-.259.39-.345.159-.087.348-.13.567-.13.325 0 .58.09.762.272.183.18.275.46.275.839.008.222-.031.407-.116.555a1.654 1.654 0 01-.335.408 7.4 7.4 0 01-.452.37c-.162.123-.316.27-.463.438a2.556 2.556 0 00-.384.611c-.11.239-.177.535-.2.889V6h1.645v-.1c.032-.248.111-.453.237-.618.126-.164.27-.31.433-.438.163-.128.335-.255.518-.383a2.413 2.413 0 00.878-1.117c.102-.255.152-.58.152-.975A2.241 2.241 0 0015.34.826zM12.007 7v2h2V7h-2z"],
    "unlock": ["M11.99-.01c-2.21 0-4 1.79-4 4v3h-7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1h-3v-3c0-1.1.9-2 2-2s2 .9 2 2v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-2.21-1.79-4-4-4z"],
    "unpin": ["M9.39 1c-.5.5-.4 1.48.15 2.53L4.38 7.54C2.85 6.5 1.52 6.07 1 6.59l3.5 3.5c-.02.02-1.4 2.8-1.4 2.8l2.8-1.4 3.5 3.5c.53-.53.1-1.86-.95-3.38l4.02-5.16c1.04.55 2.01.65 2.51.14L9.39 1z"],
    "unresolve": ["M11 3c-.55 0-1.07.09-1.57.26a6.46 6.46 0 010 9.48c.5.17 1.02.26 1.57.26 2.76 0 5-2.24 5-5s-2.24-5-5-5zM9.78 9.38l.09-.27c.08-.36.13-.73.13-1.11s-.05-.75-.13-1.11l-.09-.27a5.32 5.32 0 00-.29-.79l-.12-.21c-.14-.27-.31-.52-.51-.76a.7.7 0 00-.08-.1c-.24-.27-.49-.52-.78-.74-.43-.32-.92-.58-1.45-.75l.01-.01c-.1-.03-.2-.05-.3-.08-.12-.03-.23-.07-.36-.09A5.28 5.28 0 005 3C2.24 3 0 5.24 0 8s2.24 5 5 5c.31 0 .61-.04.9-.09.12-.02.24-.06.36-.09.1-.03.21-.04.3-.08l-.01-.01c.88-.29 1.64-.8 2.22-1.49.03-.03.06-.07.09-.1.19-.24.36-.49.51-.76.04-.07.08-.14.11-.21.13-.25.23-.52.3-.79z"],
    "updated": ["M8 0a7.95 7.95 0 00-6 2.74V1c0-.55-.45-1-1-1S0 .45 0 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.54C4.64 2.78 6.22 2 8 2c3.31 0 6 2.69 6 6 0 2.61-1.67 4.81-4 5.63-.63.22-1.29.37-2 .37-3.31 0-6-2.69-6-6 0-.55-.45-1-1-1s-1 .45-1 1c0 4.42 3.58 8 8 8 .34 0 .67-.03 1-.07.02 0 .04-.01.06-.01C12.98 15.4 16 12.06 16 8c0-4.42-3.58-8-8-8zm3 5c-.28 0-.53.11-.71.29L7 8.58 5.71 7.29a1.003 1.003 0 00-1.42 1.42l2 2c.18.18.43.29.71.29.28 0 .53-.11.71-.29l4-4A1.003 1.003 0 0011 5z"],
    "upload": ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 8c-.28 0-.53-.11-.71-.29L9 6.41V12c0 .55-.45 1-1 1s-1-.45-1-1V6.41l-1.29 1.3a1.003 1.003 0 01-1.42-1.42l3-3C7.47 3.11 7.72 3 8 3s.53.11.71.29l3 3A1.003 1.003 0 0111 8z"],
    "user": ["M7.99-.01A7.998 7.998 0 00.03 8.77c.01.09.03.18.04.28.02.15.04.31.07.47.02.11.05.22.08.34.03.13.06.26.1.38.04.12.08.25.12.37.04.11.08.21.12.32a6.583 6.583 0 00.3.65c.07.14.14.27.22.4.04.07.08.13.12.2l.27.42.1.13a7.973 7.973 0 003.83 2.82c.03.01.05.02.07.03.37.12.75.22 1.14.29l.2.03c.39.06.79.1 1.2.1s.81-.04 1.2-.1l.2-.03c.39-.07.77-.16 1.14-.29.03-.01.05-.02.07-.03a8.037 8.037 0 003.83-2.82c.03-.04.06-.08.09-.13.1-.14.19-.28.28-.42.04-.07.08-.13.12-.2.08-.13.15-.27.22-.41.04-.08.08-.17.12-.26.06-.13.11-.26.17-.39.04-.1.08-.21.12-.32.04-.12.08-.24.12-.37.04-.13.07-.25.1-.38.03-.11.06-.22.08-.34.03-.16.05-.31.07-.47.01-.09.03-.18.04-.28.02-.26.04-.51.04-.78-.03-4.41-3.61-7.99-8.03-7.99zm0 14.4c-1.98 0-3.75-.9-4.92-2.31.67-.36 1.49-.66 2.14-.95 1.16-.52 1.04-.84 1.08-1.27.01-.06.01-.11.01-.17-.41-.36-.74-.86-.96-1.44v-.01c0-.01-.01-.02-.01-.02-.05-.13-.09-.26-.12-.39-.28-.05-.44-.35-.5-.63-.06-.11-.18-.38-.15-.69.04-.41.2-.59.38-.67v-.06c0-.51.05-1.24.14-1.72.02-.13.05-.26.09-.39.17-.59.53-1.12 1.01-1.49.49-.38 1.19-.59 1.82-.59.62 0 1.32.2 1.82.59.48.37.84.9 1.01 1.49.04.13.07.26.09.4.09.48.14 1.21.14 1.72v.07c.18.08.33.26.37.66.03.31-.1.58-.16.69-.06.27-.21.57-.48.62-.03.13-.07.26-.12.38 0 .01-.01.04-.01.04-.21.57-.54 1.06-.94 1.42 0 .06.01.13.01.19.04.43-.12.75 1.05 1.27.65.29 1.47.6 2.14.95a6.415 6.415 0 01-4.93 2.31z"],
    "variable": ["M3.94 3.15c.47-.66 1.05-1.24 1.76-1.73l.13-.4c-1.11.45-2.05 1.01-2.84 1.7-1.02.88-1.8 1.9-2.32 3.05C.22 6.76 0 7.75 0 8.75c0 1.75.66 3.5 1.99 5.25l.13-.42c-.39-.94-.59-1.82-.59-2.63 0-1.28.22-2.64.67-4.1.45-1.45 1.03-2.69 1.74-3.7zm7.51 6.41l-.27-.15c-.3.41-.52.66-.66.77-.09.06-.21.1-.33.1-.15 0-.3-.1-.45-.28-.25-.33-.59-1.22-1.01-2.69.38-.65.69-1.08.95-1.28.19-.15.39-.22.59-.22.08 0 .22.03.43.08.2.06.39.08.54.08.22 0 .4-.07.54-.22.15-.15.22-.34.22-.57 0-.25-.07-.45-.22-.59-.15-.15-.35-.22-.63-.22-.24 0-.47.06-.69.17-.21.11-.49.36-.82.74-.25.28-.61.78-1.1 1.48a6.72 6.72 0 00-.97-2.38l-2.59.44-.05.27c.19-.04.36-.06.49-.06.26 0 .47.11.64.33.26.34.63 1.38 1.11 3.12-.37.49-.63.81-.77.96-.23.24-.41.4-.56.47-.11.06-.24.09-.39.09-.11 0-.29-.06-.53-.18-.17-.07-.32-.11-.45-.11-.25 0-.46.08-.62.24-.16.16-.24.37-.24.61 0 .23.08.42.23.57.15.15.35.22.61.22.25 0 .48-.05.7-.15.22-.1.49-.32.82-.65.33-.33.78-.86 1.36-1.59.22.69.42 1.19.58 1.51.16.31.35.54.56.68.21.14.47.21.79.21.31 0 .62-.11.93-.33.4-.29.82-.77 1.26-1.47zm2.56-8.54l-.12.42c.39.95.59 1.82.59 2.64 0 1.09-.17 2.26-.5 3.51-.26.96-.6 1.87-1.02 2.71-.42.85-.82 1.51-1.21 1.98-.39.48-.87.92-1.44 1.32l-.14.4c1.11-.45 2.05-1.02 2.84-1.7 1.03-.89 1.81-1.91 2.33-3.05.44-.99.66-1.99.66-3 0-1.73-.66-3.48-1.99-5.23z"],
    "vertical-bar-chart-asc": ["M6 7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zM2 9c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zm8-5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm4-4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "vertical-bar-chart-desc": ["M6 4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zM2 0c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm8 7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zm4 2c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1z"],
    "vertical-distribution": ["M1 2h14c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1s.45 1 1 1zm14 11H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM3 5c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H3z"],
    "video": ["M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM5 11V5l6 3-6 3z"],
    "virus": ["M11.918 11.107l.737.737.052-.051A1 1 0 0114.2 13.12l-.078.087-1.414 1.414a1 1 0 01-1.492-1.327l.029-.033-.863-.863c-.426.231-.89.402-1.38.502L9 14l.117.007A1 1 0 019 16H7l-.117-.007A1 1 0 017 14v-1.1a4.967 4.967 0 01-1.447-.539l-.846.846.078.087a1 1 0 01-1.492 1.327l-1.414-1.414-.078-.087a1 1 0 011.492-1.327l.744-.744A4.986 4.986 0 013.23 9.5H2a1 1 0 01-1.993.117L0 9.5v-2a1 1 0 011.993-.117L2 7.5h1.025a4.973 4.973 0 01.905-2.405l-.512-.513-.125.125A1 1 0 011.8 3.38l.078-.087 1.414-1.414a1 1 0 011.529 1.277l.573.575a4.969 4.969 0 011.604-.63V2l-.116-.007a1 1 0 010-1.986L7 0h2a1 1 0 01.117 1.993L9 2l.001 1.1c.639.13 1.233.381 1.757.73l.535-.537-.078-.087a1 1 0 011.492-1.327l1.414 1.414.078.087a1 1 0 01-1.492 1.327l-.535.536a4.97 4.97 0 01.803 2.257H14l.007-.117A1 1 0 0116 7.5v2l-.007.117A1 1 0 0114 9.5h-1.229a4.987 4.987 0 01-.853 1.607zM10 9a1 1 0 100 2 1 1 0 000-2zM6.5 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"],
    "volume-down": ["M9 2c-.28 0-.53.11-.71.29L5.59 5H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm3.57 1.44l-1.59 1.22C11.62 5.61 12 6.76 12 8s-.38 2.39-1.02 3.34l1.59 1.22C13.47 11.27 14 9.7 14 8c0-1.7-.53-3.27-1.43-4.56z"],
    "volume-off": ["M11 2c-.28 0-.53.11-.71.29L7.59 5H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "volume-up": ["M7 1.86c-.28 0-.53.11-.71.29l-2.7 2.71H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2.59l2.71 2.71a1.003 1.003 0 001.71-.71v-10c-.01-.55-.46-1-1.01-1zm6.74-.99l-1.58 1.22A9.985 9.985 0 0114 7.86c0 2.16-.69 4.15-1.85 5.78l1.58 1.22c1.42-1.97 2.26-4.38 2.26-7 .01-2.61-.84-5.02-2.25-6.99zM8.98 4.52C9.62 5.48 10 6.63 10 7.86s-.38 2.39-1.02 3.34l1.59 1.22c.9-1.29 1.43-2.86 1.43-4.56 0-1.7-.53-3.27-1.43-4.56L8.98 4.52z"],
    "walk": ["M13 8h-2c-.16 0-.31-.05-.44-.11v.01l-1.02-.51-.37 1.86 1.38.92-.01.02c.27.17.46.46.46.81v4c0 .55-.45 1-1 1s-1-.45-1-1v-3.46l-1.27-.85-1.8 4.67h-.01A.98.98 0 015 16c-.55 0-1-.45-1-1 0-.13.03-.25.07-.36h-.01L7.39 6H5.62l-.73 1.45h-.01C4.72 7.77 4.39 8 4 8c-.55 0-1-.45-1-1 0-.16.05-.31.11-.44H3.1l1-2h.01c.17-.33.5-.56.89-.56h3.16l.29-.75C8.17 2.9 8 2.47 8 2c0-1.1.9-2 2-2s2 .9 2 2c0 1-.73 1.82-1.69 1.97l-.5 1.32 1.43.71H13c.55 0 1 .45 1 1s-.45 1-1 1z"],
    "warning-sign": ["M15.84 13.5l.01-.01-7-12-.01.01c-.17-.3-.48-.5-.85-.5s-.67.2-.85.5l-.01-.01-7 12 .01.01c-.09.15-.15.31-.15.5 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 0-.19-.06-.35-.15-.5zm-6.85-.51h-2v-2h2v2zm0-3h-2v-5h2v5z"],
    "waterfall-chart": ["M8 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 4h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm7-6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1zm4-3h-1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 10H2V3c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "waves": ["M3 1a1 1 0 01.894.553c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.173.344.38.75.637 1.072.277.347.437.375.469.375a1 1 0 110 2c-.968 0-1.642-.64-2.03-1.125a4.755 4.755 0 01-.076-.097 6.093 6.093 0 01-.221.212C12.175 4.442 11.393 5 10.5 5c-.892 0-1.675-.558-2.173-1.01A6.243 6.243 0 018 3.67c-.105.11-.214.217-.327.32C7.175 4.442 6.393 5 5.5 5c-.892 0-1.675-.558-2.173-1.01a6.119 6.119 0 01-.221-.212l-.075.097C2.64 4.36 1.968 5 1 5a1 1 0 010-2c.032 0 .191-.028.47-.375.256-.321.463-.728.636-1.072A1 1 0 013 1zm0 5a1 1 0 01.894.553c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.102.202.393.607.779.957.419.381.72.49.827.49.108 0 .408-.109.827-.49.386-.35.677-.755.779-.957a1 1 0 011.788 0c.173.344.38.75.637 1.072.277.347.437.375.469.375a1 1 0 110 2c-.968 0-1.642-.639-2.03-1.125a4.726 4.726 0 01-.076-.097 6.093 6.093 0 01-.221.212c-.498.452-1.28 1.01-2.173 1.01-.892 0-1.675-.558-2.173-1.01A6.243 6.243 0 018 8.67c-.105.11-.214.217-.327.32C7.175 9.442 6.393 10 5.5 10c-.892 0-1.675-.558-2.173-1.01a6.119 6.119 0 01-.221-.212l-.075.097C2.64 9.36 1.968 10 1 10a1 1 0 010-2c.032 0 .191-.028.47-.375.256-.321.463-.728.636-1.072A1 1 0 013 6zm.894 5.553a1 1 0 00-1.788 0c-.173.344-.38.75-.637 1.072-.278.347-.437.375-.469.375a1 1 0 100 2c.968 0 1.642-.639 2.03-1.125a4.9 4.9 0 00.076-.097c.072.073.146.143.221.212.498.452 1.28 1.01 2.173 1.01.892 0 1.675-.558 2.173-1.01.113-.103.222-.21.327-.32.105.11.214.217.327.32.498.452 1.28 1.01 2.173 1.01.892 0 1.675-.558 2.173-1.01.075-.069.149-.14.221-.212a4.9 4.9 0 00.075.097C13.36 14.36 14.032 15 15 15a1 1 0 100-2c-.032 0-.191-.028-.47-.375-.256-.321-.463-.728-.636-1.072a1 1 0 00-1.788 0c-.102.202-.393.607-.779.957-.419.381-.72.49-.827.49-.108 0-.408-.109-.827-.49-.386-.35-.677-.755-.779-.957a1 1 0 00-1.788 0c-.102.202-.393.607-.779.957-.419.381-.72.49-.827.49-.108 0-.408-.109-.827-.49-.386-.35-.677-.755-.779-.957z"],
    "widget": ["M13 11h2V5h-2v6zM3 5H1v6h2V5zm11-1c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 3h6V1H5v2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3 15h6v-2H5v2z"],
    "widget-button": ["M1 3h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zm1 2v6h12V5H2zm3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "widget-footer": ["M14 0H2c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H3v-3h10v3zm0-4H3V2h10v8z"],
    "widget-header": ["M14 0H2c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H3V6h10v8zm0-9H3V2h10v3z"],
    "wind": ["M10 4a2 2 0 112 2H4a1 1 0 000 2h8a4 4 0 10-4-4 1 1 0 002 0zM1 9a1 1 0 100 2h7.5a1.5 1.5 0 010 3c-.749 0-1.386-.538-1.52-1.199a1 1 0 10-1.96.398C5.35 14.82 6.83 16 8.5 16a3.5 3.5 0 100-7H1z"],
    "wrench": ["M15.83 3.7l-3.06 3.05-2.84-.7-.7-2.83L12.29.17a5.004 5.004 0 00-4.83 1.29 4.967 4.967 0 00-1.12 5.36L.58 12.58c-.36.36-.58.86-.58 1.41 0 1.1.9 2 2 2 .55 0 1.05-.22 1.41-.59l5.77-5.77c1.79.69 3.91.33 5.35-1.12 1.32-1.3 1.74-3.15 1.3-4.81z"],
    "zoom-in": ["M7.99 5.99v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2zm7.56 7.44l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"],
    "zoom-out": ["M3.99 5.99c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-6zm11.56 7.44l-2.67-2.68a6.94 6.94 0 001.11-3.76c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7c1.39 0 2.68-.42 3.76-1.11l2.68 2.67a1.498 1.498 0 102.12-2.12zm-8.56-1.44c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"],
    "zoom-to-fit": ["M11 10a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42L12.59 8 11.3 9.29c-.19.18-.3.43-.3.71zM1 5c.55 0 1-.45 1-1V2h2c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v3c0 .55.45 1 1 1zm4 1a1.003 1.003 0 00-1.71-.71l-2 2C1.11 7.47 1 7.72 1 8c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L3.41 8 4.7 6.71c.19-.18.3-.43.3-.71zm1-1c.28 0 .53-.11.71-.29L8 3.41 9.29 4.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-2 2A1.003 1.003 0 006 5zm9 6c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0-11h-3c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zM4 14H2v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm6-3c-.28 0-.53.11-.71.29L8 12.59 6.71 11.3A.965.965 0 006 11a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 0010 11z"],
};
var IconSvgPaths20 = {
    "add": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm5-9h-4V5c0-.55-.45-1-1-1s-1 .45-1 1v4H5c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1v-4h4c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "add-clip": ["M15 0a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0V6h-3a1 1 0 110-2h3V1a1 1 0 011-1zM1 4a1 1 0 00-1 1v4a1 1 0 002 0V6h3a1 1 0 000-2H1zM0 19a1 1 0 001 1h4a1 1 0 100-2H2v-3a1 1 0 10-2 0v4zm15 1h-4a1 1 0 110-2h3v-3a1 1 0 112 0v4a1 1 0 01-1 1zm-7-5a3 3 0 100-6 3 3 0 000 6z"],
    "add-column-left": ["M4 11h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H8V7c0-.55-.45-1-1-1s-1 .45-1 1v2H4c-.55 0-1 .45-1 1s.45 1 1 1zM19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-7 18H2V2h10v16zm6 0h-5V2h5v16z"],
    "add-column-right": ["M10 11h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V7c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1zm9-11H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 18H2V2h5v16zm11 0H8V2h10v16z"],
    "add-location": ["M10 0a1 1 0 010 2 8 8 0 108 8 1 1 0 012 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 6a4 4 0 110 8 4 4 0 010-8zm6-6c.6 0 1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1V5h-2c-.6 0-1-.4-1-1 0-.5.4-1 1-1h2V1c0-.6.4-1 1-1z"],
    "add-row-bottom": ["M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V8h16v10zm0-11H2V2h16v5zM7 14h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H7c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "add-row-top": ["M7 8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V4c0-.55-.45-1-1-1s-1 .45-1 1v2H7c-.55 0-1 .45-1 1s.45 1 1 1zm12-8H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2v-5h16v5zm0-6H2V2h16v10z"],
    "add-to-artifact": ["M13 12H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zM1 6h9c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm12 2H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm6-4h-2V2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "add-to-folder": ["M.01 10V6H20v10c0 .55-.45 1-1 1H9.995v-3.99C9.965 11.332 8.635 10 6.987 10H.01zM19 3c.55 0 1 .45.99 1v1H0V2c0-.55.45-1 1-1h5.997c.28 0 .53.11.71.29L9.414 3H19zM6.987 12c.55 0 .999.45 1.009 1.01v5c0 .55-.45 1-1 1s-.999-.45-.999-1v-2.59l-4.288 4.29a1.003 1.003 0 01-1.42-1.42L4.579 14H1.989c-.55 0-1-.45-1-1s.45-1 1-1h4.998z"],
    "airplane": ["M20 2c0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.59l-4.84 4.84L2 1 1 3l7.53 5.64L4.17 13H1l-1 1 4 2 2 4 1-1v-3.17l4.36-4.36L17 19l2-1-4.43-9.74 4.84-4.84c.37-.37.59-.87.59-1.42z"],
    "align-center": ["M5 5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1H5zM1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm12 12c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h6zm4 2H3c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm2-8H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "align-justify": ["M1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 14H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0-12H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "align-left": ["M1 7h10c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm14 14H1c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zm4-8H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM1 15h6c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "align-right": ["M19 17H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 10h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H9c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "alignment-bottom": ["M12 16h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm7 2H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM4 16h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1z"],
    "alignment-horizontal-center": ["M19 9h-2V7c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2H9V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6H1c-.55 0-1 .45-1 1s.45 1 1 1h2v6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-6h2v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "alignment-left": ["M1 0C.45 0 0 .45 0 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm11 11H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm7-8H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "alignment-right": ["M19 0c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-4 11H8c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm0-8H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "alignment-top": ["M8 4H4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm11-4H1C.45 0 0 .45 0 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-3 4h-4c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "alignment-vertical-center": ["M17 3h-6V1c0-.55-.45-1-1-1S9 .45 9 1v2H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h6v2H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-2V9h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "annotation": ["M9.41 13.41l7.65-7.65-2.83-2.83-7.65 7.65 2.83 2.83zm10-10c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.59l-1.65 1.65 2.83 2.83 1.64-1.66zM18 18H2V2h8.93l2-2H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7.07l-2 2V18zM4 16l4.41-1.59-2.81-2.79L4 16z"],
    "antenna": ["M2.01 10.758a8.025 8.025 0 001.01 3.204l.02.035c.034.058.061.117.084.178.163.44.054.951-.33 1.239-.435.328-1.059.242-1.342-.224a9.797 9.797 0 01-.221-.383 10 10 0 1117.48.106c-.269.474-.89.58-1.335.267-.392-.275-.518-.783-.37-1.228a1.19 1.19 0 01.078-.18l.019-.036A8.026 8.026 0 102.01 10.758zm4.272.772a1.464 1.464 0 01.091.32c.07.425-.052.87-.402 1.128-.44.325-1.068.235-1.316-.252a6 6 0 1110.734-.09c-.24.492-.867.593-1.312.275-.354-.253-.483-.695-.42-1.122a1.462 1.462 0 01.085-.321 4.021 4.021 0 00-5.87-4.878 4.02 4.02 0 00-1.59 4.94zm4.712 2.583A.999.999 0 0011 14v-4a1 1 0 10-2 0v4c0 .038.002.076.006.113l-3.753 4.223a1 1 0 001.494 1.328L10 16.005l3.252 3.66a1 1 0 101.495-1.33l-3.753-4.222z"],
    "app-header": ["M19 0a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h18zM8 6a1 1 0 00-1.993-.117L6 6v8a1 1 0 001.993.117L8 14v-3h4v3a1 1 0 001.993.117L14 14V6a1 1 0 00-1.993-.117L12 6v3H8V6z"],
    "application": ["M3.5 9h9c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-9c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5zM19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm-1 16H2V6h16v11zM3.5 13h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5z"],
    "applications": ["M15 5H1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 13H2V8h12v10zM3.5 10h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5zm0 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5zM19 0H5c-.55 0-1 .45-1 1v3h2V3h12v10h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "archive": ["M16.434 0a1 1 0 01.857.486L20 5v14a1 1 0 01-1 1H1a1 1 0 01-1-1V5L2.709.486A1 1 0 013.566 0h12.868zM10 8c-.55 0-1 .45-1 1v4.58l-1.29-1.29-.081-.073A.996.996 0 007 11.99a1.003 1.003 0 00-.71 1.71l3 3 .096.084c.168.13.38.206.614.206.28 0 .53-.11.71-.29l3-3 .084-.096a1.003 1.003 0 00-1.504-1.324L11 13.58V9l-.007-.116A1.004 1.004 0 0010 8zm6-6H4L2 5.002h16L16 2z"],
    "area-of-interest": ["M5 4.664C5 2.09 7.241 0 10 0s4.99 2.091 5 4.664C15 7.245 10 14 10 14S5 7.245 5 4.664zM8 5a2 2 0 104.001-.001A2 2 0 008 5zM.504 12.132l4.302-2.458c.322.576.662 1.145.995 1.681l.025.04-3.294 1.881L6.468 18h7.064l3.936-4.724-3.293-1.882.024-.039c.333-.536.673-1.105.995-1.681l4.302 2.458a1 1 0 01.272 1.508l-5 6A1 1 0 0114 20H6a1 1 0 01-.768-.36l-5-6a1 1 0 01.272-1.508z"],
    "array": ["M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm5 9a1 1 0 110 2 1 1 0 010-2zM6 9a1 1 0 110 2 1 1 0 010-2zm8 0a1 1 0 110 2 1 1 0 010-2z"],
    "array-boolean": ["M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm10 7a1 1 0 01.993.883L16 8v4a1 1 0 01-.883.993L15 13H5a1 1 0 01-.993-.883L4 12V8a1 1 0 01.883-.993L5 7h10zm0 1h-5v4h5V8z"],
    "array-date": ["M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm2.5 5a.5.5 0 01.5.5V6h4v-.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V6h1a1 1 0 01.993.883L16 7v7a1 1 0 01-.883.993L15 15H5a1 1 0 01-.993-.883L4 14V7a1 1 0 01.883-.993L5 6h1v-.5a.5.5 0 01.5-.5h1zM15 9H5v5h10V9z"],
    "array-numeric": ["M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm8.995 6.09c.32 0 .603.047.85.14a1.679 1.679 0 011.015.985c.09.23.135.482.135.755 0 .287-.063.552-.19.795a1.642 1.642 0 01-.57.615v.02l.101.05c.068.039.138.09.209.155.107.097.203.215.29.355a2.09 2.09 0 01.3 1.09c0 .313-.053.597-.16.85a1.898 1.898 0 01-1.12 1.065 2.42 2.42 0 01-.85.145c-.533 0-.99-.127-1.37-.38a1.702 1.702 0 01-.73-1.08c-.013-.067.013-.11.08-.13l.87-.2.041-.003c.038.004.064.028.079.073.073.2.193.37.36.51.167.14.39.21.67.21.32 0 .567-.095.74-.285.173-.19.26-.432.26-.725 0-.347-.1-.618-.3-.815-.2-.197-.47-.295-.81-.295h-.29l-.044-.006c-.037-.013-.056-.044-.056-.094V9.1l.006-.044c.013-.037.044-.056.094-.056h.27l.145-.008a.925.925 0 00.575-.262c.18-.18.27-.42.27-.72 0-.273-.08-.495-.24-.665-.16-.17-.383-.255-.67-.255-.253 0-.453.063-.6.19-.147.127-.25.297-.31.51-.02.06-.06.083-.12.07l-.85-.2-.042-.015c-.035-.02-.048-.055-.038-.105a1.684 1.684 0 01.645-1.035c.17-.13.37-.232.6-.305.23-.073.482-.11.755-.11zm-7.99.11l.044.006c.037.013.056.044.056.094v6.6l-.006.044c-.013.037-.044.056-.094.056h-.92l-.044-.006c-.037-.013-.056-.044-.056-.094V7.54h-.02l-1.04.73-.04.02c-.047.016-.07-.01-.07-.08V7.19l.008-.051a.196.196 0 01.062-.089l1.09-.79.051-.033a.295.295 0 01.129-.027h.85zm3.34-.11c.32 0 .603.05.85.15.247.1.455.235.625.405.17.17.3.37.39.6.09.23.135.478.135.745 0 .307-.057.588-.17.845a3.16 3.16 0 01-.47.745l-1.98 2.4V12h2.52l.044.006c.037.013.056.044.056.094v.8l-.006.044c-.013.037-.044.056-.094.056h-3.82l-.044-.006c-.037-.013-.056-.044-.056-.094v-.75l.006-.05a.165.165 0 01.044-.08l2.4-2.99.124-.167c.077-.11.143-.222.196-.333.08-.167.12-.347.12-.54a.92.92 0 00-.235-.64c-.157-.173-.378-.26-.665-.26-.273 0-.487.077-.64.23-.153.153-.247.36-.28.62-.013.067-.05.093-.11.08l-.88-.18-.043-.015c-.035-.02-.047-.055-.037-.105a1.78 1.78 0 01.56-1.115c.167-.157.372-.282.615-.375a2.35 2.35 0 01.845-.14z"],
    "array-string": ["M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm2.012 6c.643 0 1.203.266 1.68.797.477.53.715 1.246.715 2.145a4.472 4.472 0 01-.965 2.814c-.644.83-1.66 1.5-3.047 2.011v-.581l.26-.104a3.87 3.87 0 001.624-1.285c.457-.632.686-1.29.686-1.971 0-.148-.023-.256-.07-.326-.023-.047-.054-.07-.093-.07-.038 0-.1.031-.186.093-.248.179-.558.268-.93.268-.45 0-.843-.18-1.18-.541A1.817 1.817 0 015 7.965c0-.527.194-.986.581-1.378A1.934 1.934 0 017.011 6zm5.593 0c.643 0 1.203.266 1.68.797.477.53.715 1.246.715 2.145a4.472 4.472 0 01-.965 2.814c-.644.83-1.659 1.5-3.047 2.011v-.581l.26-.104a3.87 3.87 0 001.624-1.285c.457-.632.686-1.29.686-1.971 0-.148-.023-.256-.07-.326-.023-.047-.054-.07-.093-.07-.038 0-.1.031-.186.093-.248.179-.558.268-.93.268-.45 0-.843-.18-1.18-.541a1.817 1.817 0 01-.506-1.285c0-.527.194-.986.581-1.378A1.934 1.934 0 0112.604 6z"],
    "array-timestamp": ["M19 0a1 1 0 01.993.883L20 1v18a1 1 0 01-.883.993L19 20h-4a1 1 0 01-.117-1.993L15 18h3V2h-3a1 1 0 01-.993-.883L14 1a1 1 0 01.883-.993L15 0h4zM5 0a1 1 0 01.117 1.993L5 2H2v16h3a1 1 0 01.993.883L6 19a1 1 0 01-.883.993L5 20H1a1 1 0 01-.993-.883L0 19V1A1 1 0 01.883.007L1 0h4zm5 4a6 6 0 110 12 6 6 0 010-12zm0 1a5 5 0 100 10 5 5 0 000-10zm2.854 2.146a.5.5 0 01.057.638l-.057.07-2.5 2.5a.5.5 0 01-.638.057l-.07-.057-1.5-1.5a.5.5 0 01.638-.765l.07.057L10 9.293l2.146-2.147a.5.5 0 01.708 0z"],
    "arrow-bottom-left": ["M18 3a1.003 1.003 0 00-1.71-.71L4 14.59V7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1H5.41l12.3-12.29c.18-.18.29-.43.29-.71z"],
    "arrow-bottom-right": ["M17 6c-.55 0-1 .45-1 1v7.59L3.71 2.29a1.003 1.003 0 00-1.42 1.42L14.59 16H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"],
    "arrow-down": ["M16 11c-.3 0-.5.1-.7.3L11 15.6V2c0-.5-.4-1-1-1s-1 .5-1 1v13.6l-4.3-4.3c-.2-.2-.4-.3-.7-.3-.5 0-1 .4-1 1 0 .3.1.5.3.7l6 6c.2.2.4.3.7.3s.5-.1.7-.3l6-6c.2-.2.3-.4.3-.7 0-.6-.5-1-1-1z"],
    "arrow-left": ["M18 9H4.41L8.7 4.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L4.41 11H18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "arrow-right": ["M18.71 9.29l-6-6a1.003 1.003 0 00-1.42 1.42L15.59 9H2c-.55 0-1 .45-1 1s.45 1 1 1h13.59l-4.29 4.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "arrow-top-left": ["M17.71 16.29L5.41 4H13c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V5.41L16.29 17.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "arrow-top-right": ["M17 2H7c-.55 0-1 .45-1 1s.45 1 1 1h7.59L2.29 16.29a1.003 1.003 0 001.42 1.42L16 5.41V13c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "arrow-up": ["M16.7 7.3l-6-6c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-6 6c-.2.2-.3.4-.3.7 0 .6.5 1 1 1 .3 0 .5-.1.7-.3L9 4.4V18c0 .5.4 1 1 1s1-.5 1-1V4.4l4.3 4.3c.2.2.4.3.7.3.5 0 1-.4 1-1 0-.3-.1-.5-.3-.7z"],
    "arrows-horizontal": ["M19.7 9.3l-5-5c-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.5.3.7L16.6 9H3.4l3.3-3.3c.2-.2.3-.4.3-.7 0-.6-.4-1-1-1-.3 0-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7s.1.5.3.7l5 5c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7L3.4 11h13.2l-3.3 3.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l5-5c.2-.2.3-.4.3-.7s-.1-.5-.3-.7z"],
    "arrows-vertical": ["M15 13c-.3 0-.5.1-.7.3L11 16.6V3.4l3.3 3.3c.2.2.4.3.7.3.6 0 1-.4 1-1 0-.3-.1-.5-.3-.7l-5-5c-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-5 5c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3L9 3.4v13.2l-3.3-3.3c-.2-.2-.4-.3-.7-.3-.6 0-1 .4-1 1 0 .3.1.5.3.7l5 5c.2.2.4.3.7.3s.5-.1.7-.3l5-5c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1z"],
    "asterisk": ["M18.52 14.17l.01-.02L11.89 10l6.64-4.15-.01-.02A.97.97 0 0019 5c0-.55-.45-1-1-1-.2 0-.37.07-.52.17l-.01-.02L11 8.2V1c0-.55-.45-1-1-1S9 .45 9 1v7.2L2.53 4.15l-.01.02A.922.922 0 002 4c-.55 0-1 .45-1 1 0 .36.2.66.48.83l-.01.02L8.11 10l-6.64 4.15.01.02A.97.97 0 001 15c0 .55.45 1 1 1 .2 0 .37-.07.52-.17l.01.02L9 11.8V19c0 .55.45 1 1 1s1-.45 1-1v-7.2l6.47 4.04.01-.02c.15.11.32.18.52.18.55 0 1-.45 1-1 0-.36-.2-.66-.48-.83z"],
    "automatic-updates": ["M10 18c-4.42 0-8-3.58-8-8 0-2.52 1.18-4.76 3-6.22V5c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1h2.06C1.61 3.82 0 6.71 0 10c0 5.52 4.48 10 10 10 .55 0 1-.45 1-1s-.45-1-1-1zm0-16c1.64 0 3.15.49 4.42 1.34l1.43-1.43A9.869 9.869 0 0010 0c-.55 0-1 .45-1 1s.45 1 1 1zm10 8c0-1.13-.2-2.21-.54-3.22L17.84 8.4A7.962 7.962 0 0115 16.22V15c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-2.06c2.45-1.82 4.06-4.71 4.06-8zm0-7a1.003 1.003 0 00-1.71-.71L12 8.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7c.18-.18.29-.43.29-.71z"],
    "backlink": ["M18.387 19.79l-.094-.083L14 15.415V18a1 1 0 01-2 0l.003-5.075.017-.126.03-.111.044-.111.052-.098.067-.096.08-.09a1.01 1.01 0 01.112-.097l.11-.071.114-.054.105-.035.15-.03L13 12h5a1 1 0 110 2h-2.585l4.292 4.293a1 1 0 01-1.32 1.497zM7.036 9.136l-4.45 4.45-.117.127a2 2 0 002.818 2.818l.127-.117 4.45-4.449a4 4 0 01-.885 3.704l-.15.16-2 2A4 4 0 011.02 12.33l.15-.16 2-2a3.998 3.998 0 013.865-1.035zm6.671-3.843a1 1 0 01.083 1.32l-.083.094-7 7a1 1 0 01-1.497-1.32l.083-.094 7-7a1 1 0 011.414 0zm4.121-4.121a4 4 0 01.151 5.497l-.15.16-2 2a3.998 3.998 0 01-3.864 1.036l4.45-4.45.116-.128a2 2 0 00-2.818-2.818l-.127.117-4.45 4.45a4 4 0 01.885-3.705l.15-.16 2-2a4 4 0 015.657 0z"],
    "badge": ["M16.94 5.73c-.19-1.41.62-2.52 1.38-3.59L17.03.65C14.89 1.76 11.88 1.48 10 0 8.12 1.48 5.11 1.76 2.97.65L1.68 2.14c.76 1.07 1.57 2.18 1.38 3.59C2.68 8.59 0 10.94 1.4 14.08c.56 1.43 1.81 2.37 3.4 2.75 1.95.46 4.4.91 5.2 3.17.8-2.26 3.25-2.71 5.2-3.17 1.6-.38 2.84-1.32 3.4-2.75 1.4-3.14-1.28-5.49-1.66-8.35z"],
    "ban-circle": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm5 11H5c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"],
    "bank-account": ["M19.2 8.02l-.78-.18C18.03 6.4 17.2 5.08 16.08 4l.5-2.28c.11-.42-.22-.78-.61-.72-1.06.12-2 .54-2.67 1.26-1.06-.42-2.34-.66-3.56-.66-3.12 0-5.79 1.5-7.4 3.72-.23-.05-.45-.11-.67-.11C.72 5.21 0 5.98 0 7c0 .72.39 1.32.95 1.62-.06.42-.12.9-.12 1.38 0 2.16.89 4.08 2.28 5.58l-.33 2.04c-.11.72.45 1.38 1.12 1.38h.72c.56 0 1-.42 1.11-1.02l.06-.48c1.17.54 2.5.9 3.95.9 1.39 0 2.78-.3 3.95-.9l.06.48c.11.6.56 1.02 1.11 1.02h.72c.67 0 1.22-.66 1.11-1.38l-.33-1.98c.78-.78 1.34-1.74 1.73-2.76l1-.24c.5-.12.89-.6.89-1.2V9.22c.11-.6-.28-1.08-.78-1.2zM15 10c-.6 0-1-.7-1-1.5S14.4 7 15 7s1 .7 1 1.5-.4 1.5-1 1.5zM7.55 5.83a.99.99 0 01-1.38-.28.99.99 0 01.28-1.38c2.34-1.56 4.77-1.56 7.11 0 .46.31.58.93.28 1.39-.31.46-.93.58-1.39.28-1.67-1.12-3.23-1.12-4.9-.01z"],
    "barcode": ["M6 16.98h2v-14H6v14zm3 0h1v-14H9v14zm-6 0h2v-14H3v14zm-3 0h2v-14H0v14zm16 0h2v-14h-2v14zm-4 0h1v-14h-1v14zm7-14v14h1v-14h-1zm-5 14h1v-14h-1v14z"],
    "blank": [],
    "blocked-person": ["M11.55 15.92c-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.06-.11.14-.35.17-.62C10.33 9.42 8.92 7.38 8.92 5c0-.3.05-.58.09-.87-.33-.08-.67-.13-.99-.13-.79 0-1.68.25-2.31.73-.61.47-1.07 1.13-1.29 1.86-.05.16-.09.33-.11.5-.12.6-.17 1.51-.17 2.14v.08c-.24.09-.45.32-.49.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59C3 16.56.77 17.26.32 18.31-.15 19.38.04 20 .04 20h15.95s.18-.62-.27-1.67c-.46-1.06-2.69-1.75-4.17-2.41zM14.97 0c-2.78 0-5.03 2.24-5.03 5s2.25 5 5.03 5S20 7.76 20 5s-2.25-5-5.03-5zm-3.03 5c0-1.66 1.35-3 3.02-3 .47 0 .9.11 1.29.3l-4.01 3.99c-.18-.4-.3-.83-.3-1.29zm3.03 3c-.47 0-.9-.11-1.29-.3l4.01-3.99c.19.39.3.82.3 1.29 0 1.66-1.36 3-3.02 3z"],
    "bold": ["M14.3 9c.4-.8.7-1.6.7-2.5C15 4 13 2 10.5 2H5c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h6.5c2.5 0 4.5-2 4.5-4.5 0-1.4-.7-2.7-1.7-3.5zM7 5h3.5c.8 0 1.5.7 1.5 1.5S11.3 8 10.5 8H7V5zm4.5 9H7v-3h4.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"],
    "book": ["M3 1v18c0 .55.45 1 1 1h2V0H4c-.55 0-1 .45-1 1zm14-1h-2v8l-2-2-2 2V0H7v20h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "bookmark": ["M6 0c-.55 0-1 .45-1 1v18c0 .55.32.68.71.29L9.3 15.7a.996.996 0 011.41 0l3.59 3.59c.38.39.7.26.7-.29v-8-4.5V1c0-.55-.45-1-1-1H6z"],
    "box": ["M19.89 6.56l-2.99-6h-.01C16.72.23 16.39 0 16 0H4c-.39 0-.72.23-.89.56H3.1l-3 6h.01C.05 6.69 0 6.84 0 7v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7c0-.16-.05-.31-.11-.44zM11 2h4.38l2 4H11V2zM4.62 2H9v4H2.62l2-4zM18 18H2V8h16v10zM8 12h4c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "briefcase": ["M19 5h-4V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v3H1c-.55 0-1 .45-1 1v5h4v-1h2v1h8v-1h2v1h4V6c0-.55-.45-1-1-1zm-6 0H7V3h6v2zm3 8h-2v-1H6v1H4v-1H0v6c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-6h-4v1z"],
    "bring-data": ["M18 18a1 1 0 010 2H2a1 1 0 010-2h16zM9.995 3.005c.55 0 1 .45 1 .999v9.584l1.29-1.288a1.002 1.002 0 011.42 1.419l-3 2.996a1.015 1.015 0 01-1.42 0l-3-2.997a1.002 1.002 0 011.42-1.419l1.29 1.29V4.013c0-.55.45-1.009 1-1.009zM16 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zM7 0a1 1 0 110 2 1 1 0 010-2zM4 0a1 1 0 110 2 1 1 0 010-2z"],
    "buggy": ["M15.836 1.014a1 1 0 011.058.539l2.482 4.962.02-.004a.5.5 0 01.604.49v4.5a.5.5 0 01-.5.5h-3.93a1.5 1.5 0 00-1.248.667l-1.406 2.11A.5.5 0 0112.5 15H8a.5.5 0 01-.354-.146l-2.414-2.415A1.5 1.5 0 004.172 12H.5a.5.5 0 01-.5-.5v-3A.5.5 0 01.5 8h.823L3.072 3.63a1 1 0 01.764-.615l12-2zm.289 3.472l1.231 2.462-2.758.591 1.527-3.053zM14.5 3.264l-1.56 3.12-.252-.638-.825-2.043 2.637-.44zm-9.78 1.63l5.122-.854.988 2.445.899 2.27L10.232 11H7.707L4.854 8.147A.5.5 0 004.5 8H3.477l1.242-3.106zM3 19a3 3 0 100-6 3 3 0 000 6zm14 0a3 3 0 100-6 3 3 0 000 6z"],
    "build": ["M19.43 16.67L9.31 7.81l1.47-1.56c.41-.44-.15-.8.15-1.6 1.08-2.76 4.19-2.99 4.19-2.99s.45-.47.87-.92C11.98-1 9.26.7 8.04 1.8L3.83 6.25l-.86.92c-.48.51-.48 1.33 0 1.84l-.87.92c-.48-.51-1.26-.51-1.74 0s-.48 1.33 0 1.84l1.74 1.84c.48.51 1.26.51 1.74 0s.48-1.33 0-1.84l.87-.92c.48.51 1.26.51 1.74 0l1.41-1.49 8.81 10.07c.76.76 2 .76 2.76 0 .76-.76.76-2 0-2.76z"],
    "calculator": ["M16 0H4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 18H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V8h2v2zm4 8H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V8h2v2zm4 8h-2v-6h2v6zm0-8h-2V8h2v2zm0-4H5V2h10v4z"],
    "calendar": ["M15 5c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zM5 5c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zm13-2h-1v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H7v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H2c-.5 0-1 .5-1 1v14c0 .5.5 1 1 1h16c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1zM7 17H3v-4h4v4zm0-5H3V8h4v4zm5 5H8v-4h4v4zm0-5H8V8h4v4zm5 5h-4v-4h4v4zm0-5h-4V8h4v4z"],
    "camera": ["M10 8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm9-4h-3.59L13.7 2.29A.956.956 0 0013 2H7c-.28 0-.53.11-.71.29L4.59 4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h4.11c1.26 1.24 2.99 2 4.89 2s3.63-.76 4.89-2H19c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM4 8H2V6h2v2zm6 8c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"],
    "caret-down": ["M16 7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1 0 .24.1.46.24.63l-.01.01 5 6 .01-.01c.19.22.45.37.76.37s.57-.15.76-.37l.01.01 5-6-.01-.01c.14-.17.24-.39.24-.63z"],
    "caret-left": ["M13 4c-.24 0-.46.1-.63.24l-.01-.01-6 5 .01.01c-.22.19-.37.45-.37.76s.15.57.37.76l-.01.01 6 5 .01-.01c.17.14.39.24.63.24.55 0 1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "caret-right": ["M14 10c0-.31-.15-.57-.37-.76l.01-.01-6-5-.01.01C7.46 4.1 7.24 4 7 4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1 .24 0 .46-.1.63-.24l.01.01 6-5-.01-.01c.22-.19.37-.45.37-.76z"],
    "caret-up": ["M15.76 12.37l.01-.01-5-6-.01.01C10.57 6.15 10.31 6 10 6s-.57.15-.76.37l-.01-.01-5 6 .01.01c-.14.17-.24.39-.24.63 0 .55.45 1 1 1h10c.55 0 1-.45 1-1 0-.24-.1-.46-.24-.63z"],
    "cargo-ship": ["M12.5 1.25h4a1 1 0 011 1V5h-5V1.25zM2.75 5a.25.25 0 00-.25.25v6H.883a.5.5 0 00-.429.757l1.672 2.787c.17.284.384.533.63.741-.458.057-.959.09-1.506.09a.625.625 0 100 1.25c2.583 0 4.268-.68 5.202-1.146.687.466 1.88 1.146 3.548 1.146 1.65 0 2.837-.666 3.528-1.132l.005.003c.244.131.6.3 1.07.468.938.335 2.321.661 4.147.661a.625.625 0 100-1.25c-.319 0-.622-.01-.91-.03.398-.318.717-.738.914-1.23l.972-2.43a.5.5 0 00-.464-.685H5v-6A.25.25 0 004.75 5h-2zm3.455 11.95a.625.625 0 01.658.041c.569.407 1.597 1.134 3.137 1.134s2.568-.727 3.137-1.134a.625.625 0 01.724-.001l.007.005.045.029c.044.027.114.069.21.12.194.104.493.247.9.392.812.29 2.053.589 3.727.589a.625.625 0 110 1.25c-1.826 0-3.21-.326-4.148-.661a7.894 7.894 0 01-1.069-.468l-.005-.003c-.691.466-1.878 1.132-3.528 1.132-1.667 0-2.861-.68-3.548-1.146-.934.467-2.619 1.146-5.202 1.146a.625.625 0 110-1.25c2.66 0 4.23-.787 4.955-1.176zM17.5 6.25h-5V10h4a1 1 0 001-1V6.25zm-11.25-4a1 1 0 011-1h4V5h-5V2.25zm5 4h-5V9a1 1 0 001 1h4V6.25z"],
    "cell-tower": ["M11.5 8.32c.31-.35.51-.81.51-1.32 0-1.1-.9-2-2-2s-2 .9-2 2c0 .51.2.97.51 1.32L5.06 18.69c-.17.52.11 1.09.63 1.26s1.09-.11 1.26-.63L8.39 15h3.23l1.44 4.32c.17.52.74.81 1.26.63s.81-.74.63-1.26L11.5 8.32zM10.95 13H9.06l.95-2.84.94 2.84zM5.31 10.73a.996.996 0 101.37-1.45c-1.4-1.33-1.28-3.35-.01-4.54.4-.38.43-1.01.05-1.41-.36-.41-1-.43-1.4-.06-2.09 1.95-2.28 5.3-.01 7.46z",
        "M4.6 12.2C3 11.1 2 9 2 7c0-2.1.9-3.9 2.6-5.2.5-.3.5-1 .2-1.4-.3-.5-1-.5-1.4-.2C1.2 1.9-.1 4.2 0 7c.1 2.7 1.4 5.3 3.4 6.8.2.1.4.2.6.2.3 0 .6-.1.8-.4.4-.5.3-1.1-.2-1.4zM13.27 10.69c.38.4 1.01.42 1.41.04 2.27-2.16 2.08-5.51-.01-7.46a.996.996 0 10-1.36 1.46c1.28 1.19 1.39 3.21-.01 4.54-.39.39-.41 1.02-.03 1.42z",
        "M16.6.2c-.4-.3-1.1-.3-1.4.2-.3.4-.3 1.1.2 1.4C17.1 3.1 18 4.9 18 7c0 2-1 4.1-2.6 5.2-.5.3-.6.9-.2 1.4.2.3.5.4.8.4.2 0 .4-.1.6-.2C18.7 12.3 20 9.7 20 7c.09-2.8-1.2-5.1-3.4-6.8z"],
    "changes": ["M18 16H2c-1.1 0-2 .9-2 2s.9 2 2 2h16c1.1 0 2-.9 2-2s-.9-2-2-2zM3 5c.28 0 .53-.11.71-.29L5 3.41V13c0 .55.45 1 1 1s1-.45 1-1V3.41L8.29 4.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3C6.53.11 6.28 0 6 0s-.53.11-.71.29l-3 3A1.003 1.003 0 003 5zm7.29 5.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L15 10.59V1c0-.55-.45-1-1-1s-1 .45-1 1v9.59L11.71 9.3A.965.965 0 0011 9a1.003 1.003 0 00-.71 1.71z"],
    "chart": ["M7 11v8c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8l-2 2-4-2zm-7 8c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8l-6 3v5zM17 7l-3 3v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8.74c-.26.15-.58.26-1 .26-1.92 0-2-2-2-2zm2-6h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.59L10.8 8.78 7.45 7.11v.01C7.31 7.05 7.16 7 7 7s-.31.05-.44.11V7.1l-6 3v.01c-.33.17-.56.5-.56.89 0 .55.45 1 1 1 .16 0 .31-.05.44-.11v.01L7 9.12l3.55 1.78v-.01c.14.06.29.11.45.11.28 0 .53-.11.71-.29L18 4.41V6c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "chat": ["M19 0H7c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h5.59l3.71 3.71c.17.18.42.29.7.29.55 0 1-.45 1-1v-3h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 13c-1.1 0-2-.9-2-2V4H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h1v3a1.003 1.003 0 001.71.71L7.41 16H13c.55 0 1-.45 1-1v-.17L12.17 13H7z"],
    "chevron-backward": ["M8.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L7 8.59V4c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1v-4.59l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L8.41 10z"],
    "chevron-down": ["M16 6c-.28 0-.53.11-.71.29L10 11.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 6z"],
    "chevron-forward": ["M13 3c-.55 0-1 .45-1 1v4.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l5.29-5.3V16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "chevron-left": ["M8.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L8.41 10z"],
    "chevron-right": ["M13.71 9.29l-6-6a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "chevron-up": ["M16.71 12.29l-6-6C10.53 6.11 10.28 6 10 6s-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42L10 8.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "circle": ["M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"],
    "circle-arrow-down": ["M14 10c-.28 0-.53.11-.71.29L11 12.59V5c0-.55-.45-1-1-1s-1 .45-1 1v7.59L6.71 10.3A.965.965 0 006 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0014 10zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"],
    "circle-arrow-left": ["M15 9H7.41L9.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L7.41 11H15c.55 0 1-.45 1-1s-.45-1-1-1zm-5-9C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"],
    "circle-arrow-right": ["M15.71 9.29l-4-4a1.003 1.003 0 00-1.42 1.42L12.59 9H5c-.55 0-1 .45-1 1s.45 1 1 1h7.59l-2.29 2.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"],
    "circle-arrow-up": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.71-13.71C10.53 4.11 10.28 4 10 4s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L9 7.41V15c0 .55.45 1 1 1s1-.45 1-1V7.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-4-4z"],
    "citation": ["M4 1C1.79 1 0 2.79 0 5s1.79 4 4 4c.1 0 .2-.01.3-.02C3.82 11.32 2.53 13 1 13c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7-4.48 7-10 0-2.21-1.79-4-4-4zM16 1c-2.21 0-4 1.79-4 4s1.79 4 4 4c.1 0 .2-.01.3-.02C15.82 11.32 14.53 13 13 13c-.55 0-1 .45-1 1s.45 1 1 1c3.87 0 7-4.48 7-10 0-2.21-1.79-4-4-4z"],
    "clean": ["M7 0L5 5 0 6.998 5 9l2 5 2-5 5-1.995L9 5zM15 10l-1.5 3.496-3.5 1.499 3.5 1.498L15 20l1.5-3.507L20 15l-3.5-1.504z"],
    "clip": ["M0 1a1 1 0 011-1h5a1 1 0 010 2H2v4a1 1 0 01-2 0V1zm1 19a1 1 0 01-1-1v-5a1 1 0 112 0v4h4a1 1 0 110 2H1zm18 0a1 1 0 001-1v-5a1 1 0 10-2 0v4h-4a1 1 0 100 2h5zm0-20a1 1 0 011 1v5a1 1 0 11-2 0V2h-4a1 1 0 110-2h5zm-9 14a4 4 0 100-8 4 4 0 000 8z"],
    "clipboard": ["M13 2c0-.55-.45-1-1-1h-.78a1.98 1.98 0 00-3.44 0H7c-.55 0-1 .45-1 1v2h7V2z",
        "M16 2h-2v3H5V2H3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z"],
    "cloud": ["M15 7c-.12 0-.24.03-.36.04C13.83 4.69 11.62 3 9 3 5.69 3 3 5.69 3 9c0 .05.01.09.01.14A3.98 3.98 0 000 13c0 2.21 1.79 4 4 4h11c2.76 0 5-2.24 5-5s-2.24-5-5-5z"],
    "cloud-download": ["M15 4c-.12 0-.24.03-.36.04C13.83 1.69 11.62 0 9 0 5.69 0 3 2.69 3 6c0 .05.01.09.01.14A3.98 3.98 0 000 10c0 2.21 1.79 4 4 4h.78c.55-.61 1.34-1 2.22-1v-2c0-1.66 1.34-3 3-3s3 1.34 3 3v2c.88 0 1.66.38 2.2.98C17.87 13.87 20 11.69 20 9c0-2.76-2.24-5-5-5zm-2 11c-.28 0-.53.11-.71.29L11 16.59V11c0-.55-.45-1-1-1s-1 .45-1 1v5.59L7.71 15.3A.965.965 0 007 15a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 0013 15z"],
    "cloud-upload": ["M10.71 10.29c-.18-.18-.43-.29-.71-.29s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L9 13.41V19c0 .55.45 1 1 1s1-.45 1-1v-5.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM15 4c-.12 0-.24.03-.36.04C13.83 1.69 11.62 0 9 0 5.69 0 3 2.69 3 6c0 .05.01.09.01.14A3.98 3.98 0 000 10c0 2.21 1.79 4 4 4 0-.83.34-1.58.88-2.12l3-3a2.993 2.993 0 014.24 0l3 3-.01.01c.52.52.85 1.23.87 2.02C18.28 13.44 20 11.42 20 9c0-2.76-2.24-5-5-5z"],
    "code": ["M6 6a1.003 1.003 0 00-1.71-.71l-4 4C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L2.41 10 5.7 6.71c.19-.18.3-.43.3-.71zm6-4c-.46 0-.83.31-.95.73l-4 14c-.02.09-.05.17-.05.27 0 .55.45 1 1 1 .46 0 .83-.31.95-.73l4-14c.02-.09.05-.17.05-.27 0-.55-.45-1-1-1zm7.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42l3.3 3.29-3.29 3.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "code-block": ["M19 5h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2H9V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8.71 15.29a1.003 1.003 0 01-1.42 1.42l-4-4C3.11 12.53 3 12.28 3 12s.11-.53.29-.71l4-4a1.003 1.003 0 011.42 1.42L5.41 12l3.3 3.29zm8-2.58l-4 4a1.003 1.003 0 01-1.42-1.42l3.3-3.29-3.29-3.29A.965.965 0 0111 8a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71s-.11.53-.29.71z"],
    "cog": ["M19 8h-2.31c-.14-.46-.33-.89-.56-1.3l1.7-1.7a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0l-1.7 1.7c-.41-.22-.84-.41-1.3-.55V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v2.33c-.48.14-.94.34-1.37.58L5 2.28a.972.972 0 00-1.36 0L2.28 3.64c-.37.38-.37.99 0 1.36L3.9 6.62c-.24.44-.44.89-.59 1.38H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h2.31c.14.46.33.89.56 1.3L2.17 15a.996.996 0 000 1.41l1.41 1.41c.39.39 1.02.39 1.41 0l1.7-1.7c.41.22.84.41 1.3.55V19c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.33c.48-.14.94-.35 1.37-.59L15 17.72c.37.37.98.37 1.36 0l1.36-1.36c.37-.37.37-.98 0-1.36l-1.62-1.62c.24-.43.45-.89.6-1.38H19c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-9 6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"],
    "collapse-all": ["M9.29 8.71c.18.18.43.29.71.29s.53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42L10 6.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6zm1.42 2.58c-.18-.18-.43-.29-.71-.29s-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42l5.29-5.3 5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6z"],
    "column-layout": ["M19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM5 17H2V3h3v14zm4 0H6V3h3v14zm9 0h-8V3h8v14z"],
    "comment": ["M19 1H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3v4a1.003 1.003 0 001.71.71l4.7-4.71H19c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM4 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"],
    "comparison": ["M6 8H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm13-6h-5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 3h-5V3h5v2zM6 14H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zM6 2H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm4-2c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm9 14h-5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm0 3h-5v-2h5v2zm0-9h-5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm0 3h-5V9h5v2z"],
    "compass": ["M15 10c0 .14-.03.28-.09.4l-3.99 8.98-.01.02a.991.991 0 01-1.82 0l-.01-.02-3.99-8.98c-.06-.12-.09-.26-.09-.4s.03-.28.09-.4L9.08.62 9.09.6a.991.991 0 011.82 0l.01.02 3.99 8.98c.06.12.09.26.09.4zm-5-6.54L7.09 10h5.81L10 3.46z"],
    "compressed": ["M19.89 6.56l-2.99-6h-.01C16.72.23 16.39 0 16 0H4c-.39 0-.72.23-.89.56H3.1l-3 6h.01C.05 6.69 0 6.84 0 7v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7c0-.16-.05-.31-.11-.44zM11 2h4.38l2 4H11V2zM4.62 2H9v4H2.62l2-4zM18 18H2V8h7v4.59L6.71 10.3A.965.965 0 006 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4a1.003 1.003 0 00-1.42-1.42L11 12.59V8h7v10z"],
    "confirm": ["M9.71 5.29a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7a1.003 1.003 0 00-1.42-1.42L12 7.59l-2.29-2.3zm7.93 2.32c.23.75.36 1.56.36 2.39 0 4.42-3.58 8-8 8s-8-3.58-8-8a7.998 7.998 0 0111.8-7.04l1.46-1.46C13.73.56 11.93 0 10 0 4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10c0-1.4-.29-2.73-.81-3.95l-1.55 1.56z"],
    "console": ["M19 19H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1zM18 6H2v11h16V6zM4 8c.28 0 .53.11.71.29l2 2c.18.18.29.43.29.71s-.11.53-.29.71l-2 2a1.003 1.003 0 01-1.42-1.42L4.59 11l-1.3-1.29A1.003 1.003 0 014 8zm5 4h3c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1z"],
    "contrast": ["M19 8h-1.26c-.19-.73-.48-1.42-.85-2.06l.94-.94a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0l-.94.94c-.65-.38-1.34-.67-2.07-.86V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1.26c-.76.2-1.47.5-2.13.89L5 2.28a.972.972 0 00-1.36 0L2.28 3.64c-.37.38-.37.98 0 1.36l.87.87c-.39.66-.69 1.37-.89 2.13H1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1.26c.19.73.48 1.42.85 2.06l-.94.94a.996.996 0 000 1.41l1.41 1.41c.39.39 1.02.39 1.41 0l.94-.94c.64.38 1.33.66 2.06.85V19c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1.26c.76-.2 1.47-.5 2.13-.89l.88.87c.37.37.98.37 1.36 0l1.36-1.36c.37-.38.37-.98 0-1.36l-.87-.87c.4-.65.7-1.37.89-2.13H19c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-9 7c-2.76 0-5-2.24-5-5s2.24-5 5-5v10z"],
    "control": ["M17 10h-7v7h7v-7zm0-7h-7v6h7V3zM9 3H3v14h6V3zm10-3H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V2h16v16z"],
    "credit-card": ["M19 3H1c-.55 0-1 .45-1 1v2h20V4c0-.55-.45-1-1-1zM0 16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V8H0v8zm6.5-2h7c.28 0 .5.22.5.5s-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zm-4 0h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"],
    "cross": ["M11.41 10l4.29-4.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L10 8.59l-4.29-4.3a1.003 1.003 0 00-1.42 1.42L8.59 10 4.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4.29-4.3 4.29 4.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L11.41 10z"],
    "crown": ["M2 8l4 2 4-5 4 5 4-2-1 7H3L2 8zm8-6a1 1 0 110 2 1 1 0 010-2zM1 5a1 1 0 110 2 1 1 0 010-2zm18 0a1 1 0 110 2 1 1 0 010-2zM3 16h14v2H3v-2z"],
    "cube": ["M1.953 4.481l7.41-4.02c.394-.215.88-.215 1.275 0l7.409 4.02L10 9.22 1.953 4.48zm-.817.68L9.5 10.085v9.281a1.316 1.316 0 01-.138-.064l-7.714-4.186A1.211 1.211 0 011 14.057v-8.35c0-.193.048-.38.136-.547zm17.728 0c.088.166.136.353.136.546v8.35c0 .438-.247.842-.648 1.06l-7.714 4.186c-.045.024-.091.046-.138.064v-9.281l8.364-4.926z"],
    "cube-add": ["M17 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1a1 1 0 012 0v2zm-3.969 4.435L10 9.22 1.953 4.48l7.41-4.02c.394-.215.88-.215 1.275 0l1.33.721A3.001 3.001 0 0013 7c0 .148.01.293.031.435zm.319.972A3 3 0 0019 7v7.057c0 .438-.247.842-.648 1.06l-7.714 4.186c-.045.024-.091.046-.138.064v-9.281l2.85-1.679zM1.136 5.16L9.5 10.086v9.281a1.316 1.316 0 01-.138-.064l-7.714-4.186A1.211 1.211 0 011 14.057v-8.35c0-.193.048-.38.136-.547z"],
    "cube-remove": ["M11.968 1.182A3.001 3.001 0 0013 7h.77L10 9.22 1.953 4.48l7.41-4.02c.394-.215.88-.215 1.275 0l1.33.721zM19 7v7.057c0 .438-.247.842-.648 1.06l-7.714 4.186c-.045.024-.091.046-.138.064v-9.281L15.74 7H19zM1.136 5.16L9.5 10.086v9.281a1.316 1.316 0 01-.138-.064l-7.714-4.186A1.211 1.211 0 011 14.057v-8.35c0-.193.048-.38.136-.547zM13 3h6a1 1 0 010 2h-6a1 1 0 010-2z"],
    "curved-range-chart": ["M19 16H3.02l2.14-1.74c2.25 1.7 7.33.46 11.83-2.99l-1.29-1.5c-3.56 2.74-7.31 4.03-8.93 3.19l10.55-8.57-.63-.78-10.59 8.6c-.64-1.64 1.46-4.91 5.09-7.7L9.9 3.01c-4.6 3.54-6.91 8.12-5.41 10.51L2 15.54V3c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "cut": ["M16 2s.72-1.28 0-2l-5.29 6.25 1.28 1.54L16 2zm.08 10c-.55 0-1.07.12-1.54.32L4.31 0c-.7.72 0 2 0 2l4.45 6.56-3.19 3.77C5.09 12.12 4.56 12 4 12c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.65-.17-1.26-.45-1.8l2.54-3.67 2.49 3.67c-.27.54-.44 1.15-.44 1.8 0 2.21 1.76 4 3.92 4 2.17 0 3.92-1.79 3.92-4 .02-2.21-1.74-4-3.9-4zM4 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm12.08 0c-1.08 0-1.96-.9-1.96-2s.88-2 1.96-2 1.96.9 1.96 2-.88 2-1.96 2z"],
    "cycle": ["M16 10a4 4 0 110 8 4 4 0 010-8zM4 10a4 4 0 110 8 4 4 0 010-8zm7.299-5.543l.087.089 1.93 2.232 2.048.708a1 1 0 01.65 1.16l-.031.112a1 1 0 01-1.16.65l-.112-.031-2.302-.796a1 1 0 01-.337-.197l-.092-.094-1.387-1.603-1.891 1.982 2.046 2.274a1 1 0 01.25.547l.007.122v4.24a1 1 0 01-1.993.117l-.007-.117-.001-3.857-2.408-2.676a1 1 0 01-.063-1.26l.082-.099 3.29-3.45a1 1 0 011.394-.053zM16 12a2 2 0 100 4 2 2 0 000-4zM4 12a2 2 0 100 4 2 2 0 000-4zm9.5-10a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"],
    "dashboard": ["M6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM4 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-5C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm6-9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-8 5c0 1.1.9 2 2 2s2-.9 2-2c0-.33-2-8-2-8s-2 7.67-2 8zm6-9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"],
    "data-connection": ["M2 11.9c.935.674 2.339 1.217 4.023 1.536A6.996 6.996 0 009.393 20c-3.988-.019-7.231-1.083-7.387-2.4L2 17.5v-5.6zM13 8c3.315 0 6 2.685 6 6s-2.685 6-6 6-6-2.685-6-6 2.685-6 6-6zm1 1l-4 6h2.5l-.5 4 4-6h-2.5l.5-4zm3-4.6v3.855a7.003 7.003 0 00-10.779 3.992c-2.408-.391-4.097-1.202-4.214-2.142L2 10V4.4c1.525 1.1 4.3 1.85 7.5 1.85S15.475 5.5 17 4.4zM9.5 0C13.637 0 17 1.125 17 2.5S13.637 5 9.5 5C5.35 5 2 3.875 2 2.5S5.35 0 9.5 0z"],
    "data-lineage": ["M1.053 0C.47 0 0 .471 0 1.053V4.21c0 .58.471 1.052 1.053 1.052h3.275a6.332 6.332 0 003.728 4.738 6.33 6.33 0 00-3.728 4.737l-3.275-.001C.47 14.737 0 15.208 0 15.789v3.158C0 19.53.471 20 1.053 20h7.435c.581 0 1.053-.471 1.053-1.053V15.79c0-.58-.472-1.052-1.053-1.052H5.406a5.293 5.293 0 015.195-4.21v2.105c0 .58.471 1.052 1.052 1.052h7.294c.582 0 1.053-.471 1.053-1.052V7.368c0-.58-.471-1.052-1.053-1.052h-7.294c-.581 0-1.052.471-1.052 1.052v2.106a5.293 5.293 0 01-5.194-4.21h3.081c.581 0 1.053-.472 1.053-1.053V1.053C9.54.47 9.069 0 8.488 0H1.053z"],
    "database": ["M2.01 5.1v5.4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5V5.1c-1.49 1.13-4.51 1.9-8 1.9-3.48 0-6.5-.77-8-1.9zm8 .9c4.42 0 8-1.12 8-2.5s-3.58-2.5-8-2.5-8 1.12-8 2.5S5.6 6 10.01 6zm-8 6.1v5.4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5v-5.4c-1.49 1.13-4.51 1.9-8 1.9-3.48 0-6.5-.77-8-1.9z"],
    "delete": ["M15 6a1.003 1.003 0 00-1.71-.71L10 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L8.59 10 5.3 13.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3.29-3.3 3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L11.41 10l3.29-3.29c.19-.18.3-.43.3-.71zm-5-6C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"],
    "delta": ["M10 0L0 20h20L10 0zM9 6l6 12H3L9 6z"],
    "derive-column": ["M7.1 8.2h-.99c.28-1.11.66-1.92 1.12-2.43.28-.32.56-.48.83-.48.05 0 .1.02.13.05.03.03.05.07.05.12 0 .04-.04.13-.11.25a.64.64 0 00-.12.35c0 .15.06.28.18.39.12.11.27.16.45.16.2 0 .36-.07.49-.2s.2-.31.2-.54c0-.26-.1-.47-.3-.63-.19-.16-.51-.24-.95-.24-.68 0-1.3.19-1.85.58-.56.38-1.09 1.02-1.59 1.91-.17.3-.34.5-.49.59-.15.08-.4.13-.74.12l-.23.77h.95l-1.39 5.24c-.23.86-.39 1.39-.47 1.59-.12.29-.3.54-.54.75-.1.08-.21.12-.35.12-.04 0-.07-.01-.1-.03l-.03-.04c0-.02.03-.07.1-.13.07-.07.1-.17.1-.31 0-.15-.05-.28-.16-.38-.11-.1-.27-.15-.47-.15-.25 0-.44.07-.59.2-.15.12-.23.28-.23.46 0 .19.09.36.27.5.19.14.47.21.86.21.61 0 1.16-.15 1.63-.46.48-.31.89-.78 1.25-1.43.35-.64.72-1.68 1.09-3.11l.8-3.03h.96l.24-.77zM19 0h-9c-.55 0-1 .45-1 1v3h2V2h7v16h-7v-2H9v3c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-8.79 13.49c.15.28.32.49.52.61.19.12.44.19.73.19.28 0 .57-.1.86-.3.38-.25.77-.69 1.17-1.31l-.25-.14c-.27.37-.48.6-.61.69-.09.06-.19.09-.31.09-.14 0-.28-.09-.42-.26-.23-.29-.54-1.09-.93-2.4.35-.59.64-.97.87-1.15.17-.13.35-.2.55-.2.07 0 .2.03.39.08s.36.08.5.08c.2 0 .37-.07.5-.2.15-.14.22-.31.22-.52 0-.22-.07-.4-.2-.53s-.33-.2-.58-.2c-.22 0-.43.05-.63.15-.2.1-.45.32-.75.67-.23.25-.56.7-1.01 1.33a6.52 6.52 0 00-.91-2.15l-2.39.39-.05.25c.18-.03.33-.05.45-.05.24 0 .43.1.59.3.25.31.59 1.24 1.02 2.8-.34.44-.58.73-.7.87-.21.22-.38.36-.52.43-.1.05-.22.08-.35.08-.1 0-.26-.05-.49-.16a1.01 1.01 0 00-.42-.11c-.23 0-.42.07-.57.22-.15.14-.23.33-.23.55 0 .21.07.38.21.51.14.13.33.2.56.2.23 0 .44-.05.64-.14.2-.09.45-.29.75-.59s.72-.78 1.25-1.43c.21.61.39 1.06.54 1.35z"],
    "desktop": ["M19 0H1C.45 0 0 .45 0 1v13c0 .55.45 1 1 1h5.67l-.5 3H5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1h-1.17l-.5-3H19c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 13H2V2h16v11z"],
    "diagnosis": ["M4 2a1 1 0 01.117 1.993L4 4v5a2 2 0 001.85 1.995L6 11a2 2 0 001.995-1.85L8 9V4a1 1 0 01-.117-1.993L8 2h1a1 1 0 01.993.883L10 3v6a4.002 4.002 0 01-3 3.874V13a3 3 0 003 3 4 4 0 003.995-3.8L14 12V8.792a2.5 2.5 0 112 0V12a6 6 0 01-6 6 5 5 0 01-4.995-4.783L5 13v-.126A4.002 4.002 0 012.005 9.2L2 9V3a1 1 0 01.883-.993L3 2h1z"],
    "diagram-tree": ["M19 10v5h-2v-4h-6v4H9v-4H3v4H1v-5a1 1 0 011-1h7V5h2v4h7a1 1 0 011 1zM1 16h2a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1zm16 0h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm-8 0h2a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2a1 1 0 011-1zM9 0h2a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1V1a1 1 0 011-1z"],
    "direction-left": ["M20 3.02l-20 7 20 7-5-7z"],
    "direction-right": ["M20 10.02l-20-7 5 7-5 7z"],
    "disable": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM2 10c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L3.69 14.9A7.902 7.902 0 012 10zm8 8c-1.85 0-3.55-.63-4.9-1.69L16.31 5.1A7.902 7.902 0 0118 10c0 4.42-3.58 8-8 8z"],
    "document": ["M11.98 0h-8c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V6l-6-6zm4 18h-11V2h6v5h5v11z"],
    "document-open": ["M8 15c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h2.59L1.3 16.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L8 12.41V15zm5-15H5c-.55 0-1 .45-1 1v6h2V2h6v5h5v11H6v-.76L4.04 19.2c.1.45.48.8.96.8h13c.55 0 1-.45 1-1V6l-6-6z"],
    "document-share": ["M14.09 10.09c-.31.31-.67.57-1.09.72V18H2V2h6v5h1.18c.15-.42.39-.8.7-1.11v-.01l2.45-2.45c-.42-.29-.78-.65-1.01-1.11L9 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V9.24l-.88.88-.03-.03zM19 0h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 3.41V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "dollar": ["M15.57 11.19c-.27-.51-.63-.93-1.07-1.26-.44-.33-.95-.6-1.51-.79-.56-.2-1.14-.36-1.72-.5-.6-.14-1.19-.26-1.75-.38-.57-.13-1.07-.27-1.51-.44-.44-.17-.8-.38-1.07-.63s-.41-.59-.41-1c0-.33.09-.6.28-.81.19-.21.42-.36.69-.47.27-.11.57-.18.88-.22.31-.04.58-.06.8-.06.71 0 1.35.14 1.9.41.55.27.91.81 1.06 1.62h3.36c-.09-.84-.32-1.56-.69-2.16-.37-.6-.83-1.08-1.38-1.45-.56-.37-1.18-.64-1.86-.81-.19-.05-.38-.07-.57-.1V1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1.1c-.22.03-.43.05-.66.1-.73.13-1.39.37-1.98.71-.6.34-1.09.8-1.47 1.35-.39.56-.58 1.25-.58 2.08 0 .76.13 1.41.4 1.93.26.52.62.95 1.06 1.28.44.33.94.6 1.5.79.55.2 1.13.36 1.74.5.58.14 1.16.26 1.72.38s1.07.26 1.51.43c.44.17.8.39 1.09.66.28.27.43.63.45 1.06.02.43-.08.78-.3 1.04-.22.26-.49.47-.83.6-.34.14-.7.23-1.09.28-.39.05-.73.07-1.03.07-.87 0-1.61-.2-2.23-.59-.62-.39-.98-1.08-1.07-2.06H3c.02.9.19 1.68.52 2.34.33.66.78 1.21 1.35 1.65.57.44 1.25.77 2.03.98.35.1.71.16 1.08.21V19c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.13c.25-.04.5-.07.76-.13.77-.18 1.47-.46 2.1-.85.63-.39 1.14-.9 1.54-1.53.4-.63.59-1.39.59-2.29.01-.75-.13-1.37-.4-1.88z"],
    "dot": ["M10 6a4 4 0 100 8 4 4 0 100-8z"],
    "double-caret-horizontal": ["M8 4c-.24 0-.46.1-.63.24l-.01-.01-6 5 .01.01c-.22.19-.37.45-.37.76s.15.57.37.76l-.01.01 6 5 .01-.01c.17.14.39.24.63.24.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm11 6c0-.31-.15-.57-.37-.76l.01-.01-6-5-.01.01C12.46 4.1 12.24 4 12 4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1 .24 0 .46-.1.63-.24l.01.01 6-5-.01-.01c.22-.19.37-.45.37-.76z"],
    "double-caret-vertical": ["M5 9h10c.55 0 1-.45 1-1 0-.24-.1-.46-.24-.63l.01-.01-5-6-.01.01C10.57 1.15 10.31 1 10 1s-.57.15-.76.37l-.01-.01-5 6 .01.01C4.1 7.54 4 7.76 4 8c0 .55.45 1 1 1zm10 2H5c-.55 0-1 .45-1 1 0 .24.1.46.24.63l-.01.01 5 6 .01-.01c.19.22.45.37.76.37s.57-.15.76-.37l.01.01 5-6-.01-.01c.14-.17.24-.39.24-.63 0-.55-.45-1-1-1z"],
    "double-chevron-down": ["M9.29 10.71c.18.18.43.29.71.29s.53-.11.71-.29l6-6a1.003 1.003 0 00-1.42-1.42L10 8.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6zM16 9c-.28 0-.53.11-.71.29L10 14.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 9z"],
    "double-chevron-left": ["M5.41 10l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L5.41 10zm6 0l5.29-5.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-6 6c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l6 6a1.003 1.003 0 001.42-1.42L11.41 10z"],
    "double-chevron-right": ["M11 10c0-.28-.11-.53-.29-.71l-6-6a1.003 1.003 0 00-1.42 1.42L8.59 10 3.3 15.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71zm5.71-.71l-6-6a1.003 1.003 0 00-1.42 1.42l5.3 5.29-5.29 5.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "double-chevron-up": ["M4 11c.28 0 .53-.11.71-.29L10 5.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6A.997.997 0 0010 3c-.28 0-.53.11-.71.29l-6 6A1.003 1.003 0 004 11zm6.71-1.71A.997.997 0 0010 9c-.28 0-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42l5.29-5.3 5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6z"],
    "doughnut-chart": ["M16 10c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6V0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10h-4zm-.09-1h4.04C19.48 4.28 15.72.52 11 .05V4.1A5.98 5.98 0 0115.91 9z"],
    "download": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm4.71 11.71l-4 4c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-4-4a1.003 1.003 0 011.42-1.42L9 12.59V5c0-.55.45-1 1-1s1 .45 1 1v7.59l2.29-2.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71z"],
    "drag-handle-horizontal": ["M7.5 11c-.83 0-1.5.67-1.5 1.5S6.67 14 7.5 14 9 13.33 9 12.5 8.33 11 7.5 11zm-5-5C1.67 6 1 6.67 1 7.5S1.67 9 2.5 9 4 8.33 4 7.5 3.33 6 2.5 6zm0 5c-.83 0-1.5.67-1.5 1.5S1.67 14 2.5 14 4 13.33 4 12.5 3.33 11 2.5 11zm15-2c.83 0 1.5-.67 1.5-1.5S18.33 6 17.5 6 16 6.67 16 7.5 16.67 9 17.5 9zm-5 2c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-10-5C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9 9 8.33 9 7.5 8.33 6 7.5 6zm5 0c-.83 0-1.5.67-1.5 1.5S11.67 9 12.5 9 14 8.33 14 7.5 13.33 6 12.5 6z"],
    "drag-handle-vertical": ["M7.5 6C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9 9 8.33 9 7.5 8.33 6 7.5 6zm0 5c-.83 0-1.5.67-1.5 1.5S6.67 14 7.5 14 9 13.33 9 12.5 8.33 11 7.5 11zm0 5c-.83 0-1.5.67-1.5 1.5S6.67 19 7.5 19 9 18.33 9 17.5 8.33 16 7.5 16zm5-12c.83 0 1.5-.67 1.5-1.5S13.33 1 12.5 1 11 1.67 11 2.5 11.67 4 12.5 4zm-5-3C6.67 1 6 1.67 6 2.5S6.67 4 7.5 4 9 3.33 9 2.5 8.33 1 7.5 1zm5 10c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-10c-.83 0-1.5.67-1.5 1.5S11.67 9 12.5 9 14 8.33 14 7.5 13.33 6 12.5 6z"],
    "draw": ["M17.7 12.7c0-.1 0-.2-.1-.3l-2-7c-.1-.3-.3-.6-.6-.7L1.8 0l-.6.5L7.7 7c.3-.2.6-.3 1-.3 1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2c0-.4.1-.7.3-1L.5 1.2l-.5.6L4.7 15c.1.3.4.5.7.6l7 2c.1 0 .2.1.3.1.3 0 .5-.1.7-.3l4-4c.2-.2.3-.5.3-.7zm1 1c-.3 0-.5.1-.7.3l-4 4c-.2.2-.3.4-.3.7 0 .5.4 1 1 1 .3 0 .5-.1.7-.3l4-4c.2-.2.3-.4.3-.7 0-.6-.5-1-1-1z"],
    "drawer-left": ["M9 0a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h8zM8 2H2v16h6V2zm2 7h6.59L14.3 6.71A.965.965 0 0114 6a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H10V9z"],
    "drawer-left-filled": ["M1 0h8a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm9 9h6.59L14.3 6.71A.965.965 0 0114 6a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H10V9z"],
    "drawer-right": ["M19 0a1 1 0 011 1v18a1 1 0 01-1 1h-8a1 1 0 01-1-1V1a1 1 0 011-1h8zm-1 2h-6v16h6V2zm-8 7H3.41L5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L3.41 11H10V9z"],
    "drawer-right-filled": ["M11 0h8a1 1 0 011 1v18a1 1 0 01-1 1h-8a1 1 0 01-1-1V1a1 1 0 011-1zm-1 9H3.41L5.7 6.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L3.41 11H10V9z"],
    "drive-time": ["M20.01 7.7c0-.63-.5-1.14-1.1-1.14h-1.32l-.95-2.57c-.24-.64-.95-1.31-1.59-1.5 0 0-1.65-.49-5.05-.49s-5.04.49-5.04.49c-.63.19-1.35.86-1.59 1.5l-.95 2.57H1.1C.5 6.56 0 7.07 0 7.7c0 .63.5 1.14 1.1 1.14h.47l-.34.91c-.24.64-.43 1.72-.43 2.4v5.39c0 .8.63 1.45 1.4 1.45.77 0 1.4-.65 1.4-1.45v-.83h12.8v.83c0 .8.63 1.45 1.4 1.45s1.4-.65 1.4-1.45v-5.39c0-.68-.19-1.77-.43-2.4l-.34-.91h.47c.61 0 1.11-.51 1.11-1.14zm-16.47.34l1.12-3.16c.08-.22.32-.39.54-.39h9.6c.22 0 .46.17.54.39l1.12 3.16c.08.21-.04.39-.26.39H3.8c-.22-.01-.34-.18-.26-.39zm.96 4.94c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.68 1.5 1.5c0 .83-.67 1.5-1.5 1.5zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"],
    "duplicate": ["M15 4H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 14H2V6h12v12zm5-18H5c-.55 0-1 .45-1 1v2h2V2h12v12h-1v2h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "edit": ["M4.59 12.59l2.83 2.83 7.65-7.65-2.83-2.83-7.65 7.65zM2 18l4.41-1.59-2.81-2.79L2 18zM16 2c-.55 0-1.05.22-1.41.59l-1.65 1.65 2.83 2.83 1.65-1.65A2.006 2.006 0 0016 2z"],
    "eject": ["M4 12h12c.55 0 1-.45 1-1 0-.25-.1-.47-.25-.64l.01-.01-6-7-.01.01C10.57 3.14 10.3 3 10 3s-.57.14-.75.36l-.01-.01-6 7 .01.01c-.15.17-.25.39-.25.64 0 .55.45 1 1 1zm12 1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"],
    "emoji": ["M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 2a8 8 0 100 16 8 8 0 000-16zm-4 8l.015.215C6.219 12.42 7.925 14 10 14a4 4 0 003.995-3.8L14 10h2l-.013.238C15.754 13.552 13.163 16 10 16a6 6 0 01-5.996-5.775L4 10h2zm1.5-4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"],
    "endorsed": ["M19.83 9.38L18.81 7.6V5.62c0-.45-.23-.85-.61-1.08l-1.71-1-1.02-1.76a1.25 1.25 0 00-1.08-.61h-2.03l-1.74-1c-.38-.23-.87-.23-1.25 0l-1.74 1H5.65c-.44 0-.85.23-1.08.61L3.58 3.5l-1.8 1.04c-.38.24-.62.64-.62 1.08v2.06L.17 9.4c-.11.19-.17.4-.17.61s.06.42.17.61l.99 1.72v2.06c0 .45.23.85.61 1.08l1.78 1.02.99 1.72c.23.38.63.61 1.08.61h1.99l1.74 1c.19.11.41.17.62.17.21 0 .42-.06.61-.17l1.74-1h2.03c.44 0 .85-.23 1.08-.61l1.02-1.76 1.71-1c.38-.23.61-.64.61-1.08v-1.97l1.02-1.78c.27-.38.27-.85.04-1.25zm-5.08-.71l-5.01 5.01c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.29l-3.01-3.01a1.003 1.003 0 011.42-1.42l2.3 2.3 4.31-4.3a1.003 1.003 0 011.71.71c0 .28-.12.53-.3.71z"],
    "envelope": ["M0 4.01v11.91l6.27-6.27L0 4.01zm18.91-1.03H1.09L10 10.97l8.91-7.99zm-5.18 6.66L20 15.92V4.01l-6.27 5.63zm-3.23 2.9c-.13.12-.31.19-.5.19s-.37-.07-.5-.19l-2.11-1.89-6.33 6.33h17.88l-6.33-6.33-2.11 1.89z"],
    "equals": ["M4 7h12a1 1 0 010 2H4a1 1 0 110-2zm0 4h12a1 1 0 010 2H4a1 1 0 010-2z"],
    "eraser": ["M18.71 8.43c.39-.4.39-1.05 0-1.45l-5.53-5.72a.967.967 0 00-1.4 0L1.29 12.1c-.39.4-.39 1.05 0 1.45l4.25 4.39 2.13 2.05h9.27c.02 0 .03.01.05.01.55 0 1-.45 1-1s-.45-1-1-1H9.46l.05-.05h.01l.81-.84 8.38-8.68zM7.52 17.94l-4.95-5.12 4.46-4.61 4.95 5.12-4.46 4.61z"],
    "error": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 16H9v-2h2v2zm0-3H9V4h2v9z"],
    "euro": ["M8.89 4.47c.56-.31 1.23-.47 2.03-.47.44 0 .85.07 1.25.22.4.14.76.35 1.07.6.17.14.33.3.47.47l2.32-2.32c-.16-.15-.3-.32-.47-.46-.62-.49-1.33-.87-2.12-1.13-.8-.25-1.64-.38-2.52-.38-1.24 0-2.35.22-3.33.66-.99.44-1.82 1.05-2.49 1.82-.68.78-1.2 1.68-1.56 2.72-.09.26-.13.54-.2.8H2c-.55 0-1 .45-1 1s.45 1 1 1h1.04c-.01.2-.04.38-.04.58 0 .15.03.28.03.42H2c-.55 0-1 .45-1 1s.45 1 1 1h1.31c.07.3.13.6.23.89.36 1.02.88 1.92 1.56 2.67.68.76 1.51 1.35 2.49 1.79.98.43 2.09.65 3.33.65.99 0 1.9-.15 2.73-.46.83-.3 1.55-.74 2.17-1.32.03-.03.05-.06.08-.09l-2.41-2.15c-.01.01-.02.02-.02.03-.61.67-1.46 1-2.54 1-.8 0-1.47-.16-2.03-.47-.56-.31-1.01-.72-1.35-1.24-.28-.38-.47-.83-.63-1.3H12c.55 0 1-.45 1-1s-.45-1-1-1H6.56c0-.14-.02-.28-.02-.42 0-.2.02-.39.03-.58H13c.55 0 1-.45 1-1s-.45-1-1-1H6.94c.15-.46.34-.9.59-1.28.35-.52.8-.94 1.36-1.25zM18 11.38v0z"],
    "exchange": ["M2.5 8a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm10.35 3.15a.495.495 0 10-.7.7L13.3 13H5.5c-.28 0-.5.22-.5.5s.22.5.5.5h7.79l-1.15 1.15c-.08.09-.14.21-.14.35a.495.495 0 00.85.35l2-2c.09-.09.15-.21.15-.35s-.06-.26-.15-.35l-2-2zM17.5 8a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM7.15 9.85a.495.495 0 10.7-.7L6.71 8h7.79c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H6.71l1.15-1.15c.08-.09.14-.21.14-.35a.495.495 0 00-.85-.35l-2 2c-.09.09-.15.21-.15.35s.06.26.15.35l2 2z"],
    "exclude-row": ["M1 3h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zM0 13a1.003 1.003 0 001.71.71L4 11.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L5.41 10 7.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L4 8.59l-2.29-2.3A1.003 1.003 0 00.29 7.71L2.59 10 .3 12.29c-.19.18-.3.43-.3.71zm18-5h-7c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2-.9 2-2s-.9-2-2-2zm1 9H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "expand-all": ["M4 9c.28 0 .53-.11.71-.29L10 3.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-6-6C10.53 1.11 10.28 1 10 1s-.53.11-.71.29l-6 6A1.003 1.003 0 004 9zm12 2c-.28 0-.53.11-.71.29L10 16.59 4.71 11.3A.965.965 0 004 11a1.003 1.003 0 00-.71 1.71l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 11z"],
    "export": ["M5 7c.28 0 .53-.11.71-.29L9 3.41V15c0 .55.45 1 1 1s1-.45 1-1V3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-5-5C10.53.11 10.28 0 10 0s-.53.11-.71.29l-5 5A1.003 1.003 0 005 7zm14 7c-.55 0-1 .45-1 1v3H2v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"],
    "eye-off": ["M20 9.96v-.03-.01-.02-.02a.794.794 0 00-.21-.43c-.55-.69-1.19-1.3-1.85-1.87l-3.93 2.62a3.966 3.966 0 01-3.96 3.77c-.47 0-.91-.1-1.33-.24l-2.24 1.49c.52.21 1.05.39 1.6.51 1.21.27 2.43.28 3.64.05 1.11-.21 2.17-.64 3.17-1.18 1.56-.84 2.99-2 4.23-3.3.23-.24.46-.49.67-.75a.87.87 0 00.21-.43v-.02-.02-.01-.03V10v-.04zm-.46-5.14c.27-.18.46-.47.46-.82 0-.55-.45-1-1-1-.21 0-.39.08-.54.18l-.01-.02L15 5.46c-.95-.53-1.95-.96-3.01-1.2a9.158 9.158 0 00-3.65-.04c-1.11.21-2.17.64-3.17 1.18-1.56.84-2.99 2-4.23 3.3-.23.24-.46.48-.67.75-.27.34-.27.76 0 1.1.64.79 1.39 1.5 2.16 2.15.26.21.52.41.79.61L.44 15.16l.01.02A1 1 0 000 16c0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02 18-12-.01-.02zm-8.67 3.4c-.25-.12-.53-.2-.83-.2-1.1 0-1.99.89-1.99 1.99 0 .03.02.06.02.09l-1.78 1.19c-.14-.4-.22-.83-.22-1.28 0-2.19 1.78-3.97 3.98-3.97 1.01 0 1.91.38 2.61 1l-1.79 1.18z"],
    "eye-on": ["M13.3 8.71c.18.18.43.29.71.29s.53-.11.71-.29l4.99-5a1.003 1.003 0 00-1.42-1.42L14 6.58l-2.29-2.29a.956.956 0 00-.7-.29 1.003 1.003 0 00-.71 1.71l3 3zM20 9.96v-.03-.01-.02-.02a.823.823 0 00-.21-.44c-.44-.55-.94-1.05-1.46-1.52l-2.2 2.2c-.55.54-1.3.88-2.12.88-.05 0-.09-.01-.14-.01a3.978 3.978 0 01-3.86 3.02 4.007 4.007 0 01-1.66-7.65A2.97 2.97 0 018.02 5c0-.28.05-.54.12-.8-1.05.22-2.07.64-3.02 1.15-1.57.85-3 2.02-4.24 3.33-.23.25-.46.5-.67.76-.28.35-.28.77 0 1.12.64.8 1.4 1.52 2.17 2.17 1.66 1.41 3.56 2.58 5.66 3.06 1.21.27 2.43.29 3.65.05 1.11-.21 2.18-.65 3.18-1.19 1.57-.85 3-2.02 4.24-3.33.23-.24.46-.49.67-.76.11-.12.18-.27.21-.44v-.02-.02-.01-.03V10c.01-.01.01-.03.01-.04zm-9.99 2.05c1.03 0 1.87-.79 1.98-1.8l-.09-.09-.01.01-2.1-2.11c-1 .11-1.77.95-1.77 1.98-.01 1.11.89 2.01 1.99 2.01z"],
    "eye-open": ["M10.01 7.984A2.008 2.008 0 008.012 9.99c0 1.103.9 2.006 1.998 2.006a2.008 2.008 0 001.998-2.006c0-1.103-.9-2.006-1.998-2.006zM20 9.96v-.03-.01-.02-.02a.827.827 0 00-.21-.442c-.64-.802-1.398-1.514-2.168-2.166-1.658-1.404-3.566-2.587-5.664-3.058a8.982 8.982 0 00-3.656-.05c-1.11.2-2.178.641-3.177 1.183-1.569.852-2.997 2.016-4.246 3.33-.23.25-.46.49-.67.761-.279.351-.279.773 0 1.124.64.802 1.4 1.514 2.169 2.166 1.658 1.404 3.566 2.577 5.664 3.058 1.209.271 2.438.281 3.656.05 1.11-.21 2.178-.651 3.177-1.193 1.569-.852 2.997-2.016 4.246-3.33.23-.24.46-.49.67-.751.11-.12.179-.271.209-.442v-.02-.02-.01-.03V10v-.04zM10.01 14A4.003 4.003 0 016.014 9.99a4.003 4.003 0 013.996-4.011 4.003 4.003 0 013.996 4.011 4.003 4.003 0 01-3.996 4.011z"],
    "fast-backward": ["M18 3c-.23 0-.42.09-.59.21l-.01-.01L11 8V4c0-.55-.45-1-1-1-.23 0-.42.09-.59.21L9.4 3.2l-8 6 .01.01C1.17 9.4 1 9.67 1 10s.17.6.41.79l-.01.01 8 6 .01-.01c.17.12.36.21.59.21.55 0 1-.45 1-1v-4l6.4 4.8.01-.01c.17.12.36.21.59.21.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "fast-forward": ["M19 10c0-.33-.17-.6-.41-.79l.01-.01-8-6-.01.01C10.42 3.09 10.23 3 10 3c-.55 0-1 .45-1 1v4L2.6 3.2l-.01.01C2.42 3.09 2.23 3 2 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01L9 12v4c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01 8-6-.01-.01c.24-.19.41-.46.41-.79z"],
    "feed": ["M2.5 15a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm.5-5c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5 2.24 5 5 0 .55.45 1 1 1s1-.45 1-1c0-3.87-3.13-7-7-7zM3 0c-.55 0-1 .45-1 1s.45 1 1 1c8.28 0 15 6.72 15 15 0 .55.45 1 1 1s1-.45 1-1C20 7.61 12.39 0 3 0zm0 5c-.55 0-1 .45-1 1s.45 1 1 1c5.52 0 10 4.48 10 10 0 .55.45 1 1 1s1-.45 1-1C15 10.37 9.63 5 3 5z"],
    "feed-subscribed": ["M2.5 15a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM3 2c1.76 0 3.44.31 5.01.87.03-.71.31-1.35.75-1.85C6.96.37 5.03 0 3 0c-.55 0-1 .45-1 1s.45 1 1 1zm10.32 4.67a.99.99 0 001.4 0l4.98-4.98c.19-.17.3-.42.3-.7 0-.55-.45-1-1-1a.99.99 0 00-.7.29l-4.27 4.27-2.28-2.28a.99.99 0 00-.7-.29c-.55 0-.99.45-.99 1 0 .28.11.52.29.7l2.97 2.99zM3 10c-.55 0-1 .45-1 1s.45 1 1 1c2.76 0 5 2.24 5 5 0 .55.45 1 1 1s1-.45 1-1c0-3.87-3.13-7-7-7zm13.94-2.69l-.82.82-.02-.02c-.2.2-.42.37-.67.51A14.8 14.8 0 0118 17c0 .55.45 1 1 1s1-.45 1-1c0-3.61-1.14-6.94-3.06-9.69zM3 5c-.55 0-1 .45-1 1s.45 1 1 1c5.52 0 10 4.48 10 10 0 .55.45 1 1 1s1-.45 1-1C15 10.37 9.63 5 3 5z"],
    "film": ["M19 2h-5v3H6V2H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h5v-3h8v3h5c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM4 17H2v-2h2v2zm0-3H2v-2h2v2zm0-3H2V9h2v2zm0-3H2V6h2v2zm0-3H2V3h2v2zm10 8H6V7h8v6zm4 4h-2v-2h2v2zm0-3h-2v-2h2v2zm0-3h-2V9h2v2zm0-3h-2V6h2v2zm0-3h-2V3h2v2z"],
    "filter": ["M18 1H2a1.003 1.003 0 00-.71 1.71L7 8.41V18a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71V8.41l5.71-5.71c.18-.17.29-.42.29-.7 0-.55-.45-1-1-1z"],
    "filter-keep": ["M15 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L5 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zm4 11c-.28 0-.53.11-.71.29L15 16.59l-1.29-1.29A.965.965 0 0013 15a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0019 13z"],
    "filter-list": ["M15 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L5 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zm-4 8c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7c-.55 0-1 .45-1 1zm8 7h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zm0-4h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "filter-open": ["M15 2c0 .28-.11.53-.29.7L10 7.41V13c0 .28-.11.53-.29.71l-3 3A1.003 1.003 0 015 16V7.41L.29 2.71A1.003 1.003 0 011 1h13c.55 0 1 .45 1 1zm4.707 11.293a1 1 0 010 1.414l-4 4c-.63.63-1.707.184-1.707-.707v-8c0-.89 1.077-1.337 1.707-.707l4 4z"],
    "filter-remove": ["M15 2c0-.55-.45-1-1-1H1a1.003 1.003 0 00-.71 1.71L5 7.41V16a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71V7.41l4.71-4.71c.18-.17.29-.42.29-.7zm2.91 13.5l1.79-1.79c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-1.79 1.79-1.79-1.79a1.003 1.003 0 00-1.42 1.42l1.79 1.79-1.79 1.79a1.003 1.003 0 001.42 1.42l1.79-1.79 1.79 1.79a1.003 1.003 0 001.42-1.42l-1.8-1.79z"],
    "flag": ["M3 3c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm0-3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm2 4.08v8.28c3.01-2.41 8.67 2.64 13 0V4.08C13.61 7.14 8.01 1 5 4.08z"],
    "flame": ["M11.622 0c0 1.71.49 3.077 1.472 4.103C16.364 6.496 18 9.23 18 12.308c0 3.418-1.962 5.983-5.887 7.692 2.887-3 2.453-4.23-.49-8C8.5 13.5 9 14.5 9.5 16.5c-1.048 0-2 0-2.5-.5 0 .684 1.197 2.5 1.952 4-3.924-1.026-8.123-7.18-6.651-7.692.981-.342 2.126-.171 3.434.513C4.1 6.667 6.062 2.393 11.622 0z"],
    "flash": ["M4.96 6.37a1.003 1.003 0 001.42-1.42l-2-2a1.07 1.07 0 00-.71-.28 1.003 1.003 0 00-.71 1.71l2 1.99zm9.37.3c.28 0 .53-.11.71-.29l2-2a1.003 1.003 0 00-1.42-1.42l-2 2a1.003 1.003 0 00.71 1.71zM10 5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S9 .45 9 1v3c0 .55.45 1 1 1zm-5 5c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1zm14-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm-9-3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5.04 1.63a1.003 1.003 0 00-1.42 1.42l2 2a1.003 1.003 0 001.42-1.42l-2-2zM10 15c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1zm-4.33-1.67c-.28 0-.53.11-.71.29l-2 2a1.003 1.003 0 001.42 1.42l2-2a1.003 1.003 0 00-.71-1.71z"],
    "floppy-disk": ["M14 1h-3v5h3V1zm5.71 2.29l-3-3A.997.997 0 0016 0h-1v7H5V0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V4c0-.28-.11-.53-.29-.71zM17 19H3v-8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v8z"],
    "flow-branch": ["M14.425 7.953a3.98 3.98 0 01.562 2.045 3.98 3.98 0 01-.583 2.08L18 15.671V12.98c0-.248.097-.496.29-.689.379-.379 1.047-.38 1.426 0a.94.94 0 01.283.696l-.001 5.049a.957.957 0 01-.276.69.955.955 0 01-.69.273h-5.059a.971.971 0 01-.689-.289 1.026 1.026 0 010-1.417.972.972 0 01.69-.29h2.702l-3.634-3.573a3.998 3.998 0 01-5.924-2.431H1a1 1 0 010-2h6.12a3.998 3.998 0 015.96-2.409L16.665 3l-2.694-.001a.972.972 0 01-.689-.29 1.035 1.035 0 010-1.425.94.94 0 01.696-.283l5.05.001c.248 0 .497.083.69.276a.954.954 0 01.272.69l.001 5.052a.971.971 0 01-.29.689 1.028 1.028 0 01-1.419 0 .972.972 0 01-.29-.69V4.323l-3.567 3.63z"],
    "flow-end": ["M12 9.919a3.998 3.998 0 014-3.92c2.21 0 4 1.79 4 3.997a3.998 3.998 0 01-4 3.996 3.998 3.998 0 01-4-3.916.967.967 0 01-.28.612L7.685 14.71a.958.958 0 01-.686.285c-.536 0-.994-.461-.994-.997 0-.273.107-.528.283-.704l2.379-2.302H.98c-.537 0-.976-.46-.976-.996s.44-.992.976-.992h7.676L6.287 6.687a.957.957 0 01-.283-.686c0-.536.458-.996.994-.996.274 0 .51.1.686.285l4.027 4.024c.159.158.27.365.29.605z"],
    "flow-linear": ["M5.125 10.997H.976C.439 10.997 0 10.537 0 10c0-.536.44-.993.976-.993h4.148a4.002 4.002 0 017.752 0h3.776L14.293 6.69a.962.962 0 01-.285-.687c0-.537.46-1.001.996-1.001a.96.96 0 01.698.3l4.005 4.015c.176.176.293.41.293.683a.972.972 0 01-.283.693L15.702 14.7a.997.997 0 01-.698.297c-.537 0-.996-.453-.996-.99 0-.273.107-.517.283-.692l2.371-2.318h-3.787a4.002 4.002 0 01-7.75 0z"],
    "flow-review": ["M6.13 9.004A4.005 4.005 0 0110.012 6c1.87 0 3.44 1.278 3.881 3.005h2.768l-2.354-2.317a.97.97 0 01-.283-.691c0-.536.462-.995 1-.995.273 0 .517.107.693.283l4 4.041a.97.97 0 01.284.692.956.956 0 01-.293.682l-3.991 3.997a.944.944 0 01-.694.292c-.537 0-1-.46-1-.997a.97.97 0 01.284-.692l2.345-2.29h-2.765a4.005 4.005 0 01-3.875 2.981 4.005 4.005 0 01-3.874-2.981H3.349l2.376 2.308a.97.97 0 01.283.691 1 1 0 01-.994.983.989.989 0 01-.713-.291L.293 10.699A.956.956 0 010 10.017a.97.97 0 01.283-.692l4.03-4.037a.996.996 0 01.701-.283c.537 0 .994.464.994 1a.97.97 0 01-.283.691L3.34 9.004h2.79z"],
    "flow-review-branch": ["M13.04 13.424c-.6.36-1.302.568-2.052.568a4 4 0 01-3.868-2.999H3.342l2.372 2.31c.176.176.283.42.283.694 0 .537-.452.998-.988.998a.935.935 0 01-.691-.289L.292 10.683A.96.96 0 010 9.999c0-.274.107-.518.283-.694l4.035-4.04a.973.973 0 01.691-.288c.536 0 .988.47.988 1.007a.975.975 0 01-.283.694L3.332 8.984h3.786a4 4 0 013.87-3.006c.771 0 1.492.22 2.102.599l3.565-3.57-2.538-.003a.974.974 0 01-.69-.29c-.38-.38-.38-1.052-.002-1.431A.94.94 0 0114.122 1l4.896.005a.96.96 0 01.69.277c.193.193.27.442.27.69l.005 4.9a.971.971 0 01-.289.69 1.023 1.023 0 01-1.416 0 .975.975 0 01-.29-.691l-.003-2.54-3.554 3.62c.351.596.553 1.291.553 2.034 0 .763-.213 1.477-.583 2.084l3.595 3.595.003-2.54c0-.249.097-.497.29-.69.38-.38 1.05-.381 1.429-.002a.94.94 0 01.282.697l-.005 4.9a.927.927 0 01-.277.675.974.974 0 01-.69.291L13.974 19a.97.97 0 01-.69-.29 1.03 1.03 0 01.002-1.42.974.974 0 01.69-.29l2.696-.003-3.632-3.573z"],
    "flows": ["M17.5 7.93a2.5 2.5 0 00-2.45 2h-2.3l-4.01-4-.75.75 3.26 3.25h-6.3a2.5 2.5 0 100 1h6.3l-3.26 3.25.75.75 4.01-4h2.3a2.5 2.5 0 102.45-3z"],
    "folder-close": ["M0 17c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7H0v10zM19 4H9.41l-1.7-1.71A.997.997 0 007 2H1c-.55 0-1 .45-1 1v3h20V5c0-.55-.45-1-1-1z"],
    "folder-new": ["M12.994 7c0 1.655 1.344 3 2.998 3a3.002 3.002 0 002.999-3H20v10c0 .55-.45 1-1 1H1.01c-.55 0-1-.45-1-1V7h12.984zM10.76 6H0V3c0-.55.45-1 1-1h3.998c.28 0 .53.11.71.29L7.415 4h2.579c0 .768.29 1.469.765 2zm8.23-3c.55 0 1 .45 1 1s-.45 1-1 1h-1.998v2c0 .55-.45 1-1 1s-1-.45-1-1V5h-1.998c-.55 0-1-.45-1-1s.45-1 1-1h1.999V1c0-.55.45-1 .999-1 .55 0 1 .45 1 1v2h1.999z"],
    "folder-open": ["M20 9c0-.55-.45-1-1-1H5c-.43 0-.79.27-.93.65h-.01l-3 8h.01c-.04.11-.07.23-.07.35 0 .55.45 1 1 1h14c.43 0 .79-.27.93-.65h.01l3-8h-.01c.04-.11.07-.23.07-.35zM3.07 7.63C3.22 7.26 3.58 7 4 7h14V5c0-.55-.45-1-1-1H8.41l-1.7-1.71A.997.997 0 006 2H1c-.55 0-1 .45-1 1v12.31l3.07-7.68z"],
    "folder-shared": ["M11 4H9.41l-1.7-1.71A.997.997 0 007 2H1c-.55 0-1 .45-1 1v3h11.78C11.3 5.47 11 4.77 11 4zm8-1h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L12.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm-2.46 7.7l-1.42 1.42a2.996 2.996 0 11-4.24-4.24l.88-.88H0v10c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-5.18c-.31.11-.65.18-1 .18-1.02 0-1.92-.52-2.46-1.3z"],
    "folder-shared-open": ["M3.07 7.63C3.22 7.26 3.58 7 4 7h7.76l.54-.54A2.97 2.97 0 0111 4H8.41l-1.7-1.71A.997.997 0 006 2H1c-.55 0-1 .45-1 1v12.31l3.07-7.68zm13.47 3.07l-1.42 1.42A2.996 2.996 0 0110 10c0-.77.3-1.47.78-2H5c-.43 0-.79.27-.93.65h-.01l-3 8h.01c-.04.11-.07.23-.07.35 0 .55.45 1 1 1h14c.43 0 .79-.27.93-.65h.01l2.01-5.36c-1-.01-1.88-.52-2.41-1.29zM19 3h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L12.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "follower": ["M11.54 15.92c-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5a3.69 3.69 0 00-1.29-1.86C9.69 4.25 8.8 4 8.01 4c-.8 0-1.69.25-2.32.73-.61.47-1.06 1.13-1.28 1.86-.05.17-.09.33-.11.5-.12.6-.18 1.51-.18 2.14v.08c-.23.09-.44.32-.49.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59-1.48.65-3.71 1.35-4.16 2.4C-.16 19.38.02 20 .02 20h15.95s.18-.62-.27-1.67c-.46-1.06-2.68-1.75-4.16-2.41zm8.15-12.63l-3-3a.956.956 0 00-.7-.29 1.003 1.003 0 00-.71 1.71L16.58 3H13c-.55 0-1 .45-1 1s.45 1 1 1h3.58l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.3-.71z"],
    "following": ["M11.55 15.92c-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5a3.69 3.69 0 00-1.29-1.86C9.7 4.25 8.81 4 8.02 4c-.79 0-1.68.25-2.31.73-.61.47-1.07 1.13-1.29 1.86-.05.16-.09.33-.11.5-.12.6-.18 1.51-.18 2.14v.08c-.23.09-.44.32-.48.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59C3 16.56.77 17.26.32 18.31-.15 19.38.04 20 .04 20h15.95s.18-.62-.27-1.67c-.46-1.06-2.69-1.75-4.17-2.41zM19 3h-3.58l1.29-1.29A1.003 1.003 0 0015.29.29l-3 3c-.17.18-.28.43-.28.71 0 .28.11.53.29.71l3 3c.18.18.43.29.7.29a1.003 1.003 0 00.71-1.71L15.42 5H19c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "font": ["M17.93 18.64l-7-18C10.78.27 10.42 0 10 0s-.78.27-.93.64l-7 18c-.04.11-.07.23-.07.36 0 .55.45 1 1 1 .42 0 .78-.27.93-.64L6.41 13h7.19l2.47 6.36c.15.37.51.64.93.64.55 0 1-.45 1-1 0-.13-.03-.25-.07-.36zM7.18 11L10 3.76 12.82 11H7.18z"],
    "fork": ["M16.71 11.29a1.003 1.003 0 00-1.42 1.42l1.3 1.29h-2.17l-8-8h10.17L15.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 4H1c-.55 0-1 .45-1 1s.45 1 1 1h2.59l9.71 9.71c.17.18.42.29.7.29h2.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3z"],
    "form": ["M2 13v4h4v-4H2zm-1-2h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1zm11-7h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1zM8 1a1.003 1.003 0 01.71 1.71l-5 6C3.53 8.89 3.28 9 3 9s-.53-.11-.71-.29l-2-2a1.003 1.003 0 011.42-1.42L3 6.59l4.29-5.3C7.47 1.11 7.72 1 8 1zm4 13h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1z"],
    "full-circle": ["M9.96 0a10 10 0 100 20 10 10 0 100-20z"],
    "full-stacked-chart": ["M15 16h2c.55 0 1-.45 1-1v-5h-4v5c0 .55.45 1 1 1zM12 2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4h4V2zm6 4h-4v3h4V6zm0-4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v3h4V2zm-6 5H8v5h4V7zm-9 9h2c.55 0 1-.45 1-1v-3H2v3c0 .55.45 1 1 1zm6 0h2c.55 0 1-.45 1-1v-2H8v2c0 .55.45 1 1 1zm10 1H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM6 2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v3h4V2zm0 4H2v5h4V6z"],
    "fullscreen": ["M3.41 2H6c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1s1-.45 1-1V3.41L7.29 8.7c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L3.41 2zM8 11c-.28 0-.53.11-.71.29L2 16.59V14c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H3.41l5.29-5.29c.19-.18.3-.43.3-.71 0-.55-.45-1-1-1zM19 0h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 3.41V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm0 13c-.55 0-1 .45-1 1v2.59l-5.29-5.29A.965.965 0 0012 11a1.003 1.003 0 00-.71 1.71l5.3 5.29H14c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1z"],
    "function": ["M10.14 5.82H8.73c.4-1.66.94-2.87 1.6-3.64.4-.48.8-.72 1.18-.72.08 0 .14.02.19.07.05.05.07.1.07.18 0 .07-.05.19-.16.37s-.16.36-.16.52c0 .23.08.43.25.59a.9.9 0 00.64.25c.28 0 .51-.1.7-.3.19-.2.28-.47.28-.81 0-.39-.14-.7-.42-.94-.28-.24-.74-.36-1.36-.36-.97 0-1.86.29-2.65.87-.79.56-1.54 1.52-2.26 2.85-.24.46-.48.75-.7.88-.22.13-.57.19-1.06.19l-.32 1.15H5.9l-1.99 7.85c-.33 1.29-.56 2.09-.67 2.39-.17.44-.43.81-.77 1.12a.74.74 0 01-.5.19c-.05 0-.1-.02-.14-.05l-.04-.07c0-.03.05-.1.15-.2.1-.1.15-.26.15-.47 0-.23-.08-.42-.23-.57-.16-.15-.38-.23-.67-.23-.35 0-.63.1-.85.29-.21.2-.32.43-.32.7 0 .29.13.54.39.75.25.22.65.33 1.2.33.88 0 1.66-.23 2.33-.69.68-.46 1.27-1.17 1.78-2.14.51-.96 1.03-2.52 1.56-4.66l1.14-4.54H9.8l.34-1.15zm6.8 1.95c.25-.2.51-.29.78-.29.1 0 .29.04.56.11.27.08.51.11.72.11.29 0 .52-.1.72-.3.18-.19.28-.45.28-.77 0-.33-.1-.6-.29-.8-.19-.2-.47-.29-.82-.29-.32 0-.62.08-.9.23-.28.15-.64.49-1.08 1-.33.38-.81 1.05-1.44 2a9.712 9.712 0 00-1.31-3.22l-3.4.59-.07.37c.25-.05.47-.08.64-.08.34 0 .62.15.84.44.35.46.84 1.85 1.46 4.19-.49.66-.82 1.09-1 1.3-.3.33-.55.54-.74.64-.15.08-.32.12-.51.12-.14 0-.38-.08-.7-.24-.22-.1-.42-.16-.59-.16-.33 0-.6.11-.82.32-.21.22-.32.49-.32.83 0 .31.1.57.3.77.2.2.47.29.8.29.32 0 .63-.07.92-.21.29-.14.64-.43 1.08-.88.43-.45 1.03-1.16 1.79-2.14.29.93.55 1.61.76 2.03.21.42.46.73.74.91.28.19.62.28 1.04.28.4 0 .81-.15 1.23-.44.55-.38 1.1-1.04 1.68-1.97l-.35-.21c-.39.55-.68.89-.87 1.03-.12.09-.27.13-.44.13-.2 0-.4-.13-.59-.38-.33-.43-.77-1.63-1.33-3.6.47-.86.89-1.44 1.23-1.71z"],
    "gantt-chart": ["M4 7h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm3 2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1zm12 3h-6c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0 4H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "geofence": ["M8 11l.075.003.126.017.111.03.111.044.098.052.096.067.09.08c.036.035.068.073.097.112l.071.11.054.114.035.105.03.148L9 12V18a1 1 0 01-1.993.117L7 18v-3.586l-5.293 5.293a1 1 0 01-1.497-1.32l.083-.094L5.584 13h-3.58a1 1 0 01-.117-1.993L2.004 11H8zm3.018-11a1.003 1.003 0 01.39.087l.12.063.031.02.1.078 8.027 7.026.062.064.068.086.044.068.064.128.04.117.024.113.011.108v.1l-.007.073-.019.103-.037.121-.039.09-.05.087-4.996 7.994c-.06.097-.137.183-.226.254l-.093.067-.095.053-.087.037-.125.037a1.018 1.018 0 01-.218.026H11v-5a3 3 0 00-2.824-2.995L8 9H3V6a1 1 0 01.321-.734l.098-.08 7-5a1.01 1.01 0 01.45-.178L11.018 0z"],
    "geolocation": ["M0 8.33l9.17 2.5 2.5 9.17L20 0z"],
    "geosearch": ["M8 18.88c-3.79 0-6.88-3.09-6.88-6.88 0-.61.08-1.22.23-1.79.03.01.06-.01.1-.01h.09v.55c0 .23.21.42.44.42.04 0 .09-.01.12-.02l.9.88c.09.09.23.09.32 0s.09-.23 0-.32l-.86-.9c0-.02.05-.04.05-.07v-.13c0-.18.1-.25.29-.41h.53c.1 0 .19-.01.27-.05.01-.01.02 0 .03-.01.02-.01.03-.02.05-.04.01-.01.02-.01.02-.02l.02-.02 1.13-1.13c-.16-.32-.3-.65-.42-.99h-.64v-.53c0-.01.06.06.06-.1h.38c-.04-.16-.08-.32-.1-.48h-.71c.2-.16.42-.31.64-.45C4.02 6.09 4 5.8 4 5.5c0-.14.01-.28.02-.43C1.62 6.46 0 9.04 0 12c0 4.41 3.59 8 8 8 3.87 0 7.09-2.77 7.82-6.44l-.97-1.1c-.26 3.57-3.23 6.42-6.85 6.42zm-2.12-3.67v-.35h.15c.29 0 .49-.23.49-.53v-.68c0-.01.01-.01 0-.02L4.71 11.8h-.77c-.29 0-.47.24-.47.53v2c0 .29.18.53.47.53h.33v2.02c0 .28.28.51.56.51s.56-.23.56-.51v-1.22h-.01c.29 0 .5-.16.5-.45zm13.83-2.92l-3.68-3.68c.14-.21.27-.42.38-.65.02-.04.04-.07.05-.11.11-.22.2-.45.28-.69v-.01c.07-.24.13-.48.17-.73l.03-.17c.04-.24.06-.49.06-.75C17 2.46 14.54 0 11.5 0S6 2.46 6 5.5 8.46 11 11.5 11c.26 0 .51-.02.76-.06l.17-.03c.25-.04.49-.1.73-.17h.01c.24-.08.47-.17.69-.28.04-.02.07-.04.11-.05.23-.11.44-.24.65-.38l3.68 3.68c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71zM11.5 9.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm1.93 5.33v-.65c0-.11-.13-.21-.24-.21-.11 0-.24.09-.24.21v.65c0 .11.13.21.24.21.11 0 .24-.1.24-.21zm-2.41.67h.83c.29 0 .46-.21.46-.5v-1.86l.23-.22c-.34.05-.69.08-1.04.08-.36 0-.7-.03-1.05-.08.03.05.06.1.08.16V15c.01.29.2.5.49.5z"],
    "git-branch": ["M15 2c-1.66 0-3 1.34-3 3 0 1.3.84 2.4 2 2.82V9c0 1.1-.9 2-2 2H8c-.73 0-1.41.21-2 .55V5.82C7.16 5.4 8 4.3 8 3c0-1.66-1.34-3-3-3S2 1.34 2 3c0 1.3.84 2.4 2 2.82v8.37C2.84 14.6 2 15.7 2 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.25-.77-2.3-1.85-2.75C6.45 13.52 7.16 13 8 13h4c2.21 0 4-1.79 4-4V7.82C17.16 7.4 18 6.3 18 5c0-1.66-1.34-3-3-3zM5 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM15 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-commit": ["M19 9h-4.1a5 5 0 00-9.8 0H1c-.55 0-1 .45-1 1s.45 1 1 1h4.1a5 5 0 009.8 0H19c.55 0 1-.45 1-1s-.45-1-1-1zm-9 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"],
    "git-merge": ["M15 8c-1.3 0-2.4.84-2.82 2H11c-2.49 0-4.54-1.83-4.92-4.21A2.995 2.995 0 005 0C3.34 0 2 1.34 2 3c0 1.3.84 2.4 2 2.81v8.37C2.84 14.6 2 15.7 2 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V9.86C7.27 11.17 9.03 12 11 12h1.18A2.996 2.996 0 0018 11c0-1.66-1.34-3-3-3zM5 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM5 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-new-branch": ["M17 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3 4.86V9c0 1.1-.9 2-2 2H8c-.73 0-1.41.21-2 .55V5.82C7.16 5.4 8 4.3 8 3c0-1.66-1.34-3-3-3S2 1.34 2 3c0 1.3.84 2.4 2 2.82v8.37C2.84 14.6 2 15.7 2 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.25-.77-2.3-1.85-2.75C6.45 13.52 7.16 13 8 13h4c2.21 0 4-1.79 4-4V7.86c-.32.08-.65.14-1 .14s-.68-.06-1-.14zM5 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-pull": ["M17 14.18V7c0-2.21-1.79-4-4-4h-2.59l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C7.11 3.47 7 3.72 7 4c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L10.41 5H13c1.1 0 2 .9 2 2v7.18A2.996 2.996 0 0016 20c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82zM16 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 1C2.34 1 1 2.34 1 4c0 1.3.84 2.4 2 2.82v7.37C1.84 14.6 1 15.7 1 17c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V6.82C6.16 6.4 7 5.3 7 4c0-1.66-1.34-3-3-3zm0 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "git-push": ["M15 11c0-.28-.11-.53-.29-.71l-3-3C11.53 7.11 11.28 7 11 7s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42l1.29-1.3V19c0 .55.45 1 1 1s1-.45 1-1v-8.59l1.29 1.29c.18.19.43.3.71.3.55 0 1-.45 1-1zm4-11H1C.45 0 0 .45 0 1v16c0 .55.45 1 1 1h7v-2H2v-2h6v-1H4V2h14v11h-4v1h4v2h-4v2h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM5 8h2V6H5v2zm2-5H5v2h2V3z"],
    "git-repo": ["M7 3H5v2h2V3zm0 6H5v2h2V9zm0-3H5v2h2V6zm12-6H1C.45 0 0 .45 0 1v16c0 .55.45 1 1 1h4v2l2-1 2 1v-2h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 16H9v-1H5v1H2v-2h16v2zm0-3H4V2h14v11z"],
    "glass": ["M17 6V0H3v6c0 3.53 2.61 6.43 6 6.92V18H6c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-5.08c3.39-.49 6-3.39 6-6.92z"],
    "globe": ["M7.53 4.37c.1-.1.1-.26 0-.35l-.68-.68c-.1-.1-.25-.1-.35 0-.1.1-.1.26 0 .35l.68.68c.1.1.25.1.35 0zm3.17.06h.3c.09 0 .16-.01.16-.1 0-.09-.07-.1-.16-.1h-.3c-.09 0-.16.01-.16.1s.07.1.16.1zm.98 1.15c.09 0 .19-.08.19-.17v-.42c0-.09-.1-.17-.19-.17s-.19.08-.19.17v.42c0 .09.1.17.19.17zm-6.5 4.19c-.35 0-.56.28-.56.63v2.37c0 .35.21.62.56.62h.39v2.4c0 .34.33.61.67.61s.67-.27.67-.61v-1.44h-.02c.35 0 .6-.19.6-.54v-.41h.18c.35 0 .58-.28.58-.62v-.81c0-.01.01-.01 0-.02L6.1 9.77h-.92zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8 0-.74.11-1.46.3-2.14h.03v.65c0 .28.25.5.53.5.05 0 .1-.01.15-.02l1.05 1.05c.1.11.28.11.38 0 .1-.1.11-.27 0-.38L3.42 8.59c0-.03.05-.05.05-.08v-.16c0-.22.12-.3.34-.49h.63c.12 0 .23-.01.32-.07.01-.01.02 0 .03-.01.02-.02.04-.03.06-.04.01-.01.02-.01.03-.02l.02-.02 2.15-2.15c.24-.24.24-.63 0-.86-.23-.24-.62-.19-.86.04l-.41.46H5v-.64c0-.01.07.07.07-.12h.87c.17 0 .3-.12.3-.29 0-.17-.13-.29-.3-.29H4.88C6.27 2.7 8.05 2 10 2s3.73.7 5.12 1.86h-1.58l-.01-.04c-.06 0-.12 0-.17.04l-.71.7c-.09.09-.09.23 0 .31.09.09.23.09.32 0l.56-.6.01-.03h.34c0 .19-.1.13-.1.16v.1c0 .29-.2.5-.49.5h-.51c-.25 0-.52.28-.52.54v.23h-.12c-.16 0-.27.08-.27.24v.33h-.32c-.23 0-.41.15-.41.38 0 .22.18.35.41.35.1 0 .19.04.26-.16l.06.01.66-.59h.23l.53.5c.04.04.11.03.16-.01.04-.04.04-.16 0-.2L13 6.15h.32l.12.16c.25.25.65.23.89-.02l.12-.14H15c.02 0 .11.07.11.07v.33s-.06-.01-.07-.01h-.49c-.16 0-.28.13-.28.29 0 .16.13.29.28.29h.49c.01 0 .07-.01.07-.01v.2c-.19.28-.33.57-.62.57h-1.28s0-.01-.01-.01l-.58-.58a.622.622 0 00-.89 0l-.58.58s0 .01-.01.01h-.34c-.35 0-.67.28-.67.63v1.25c0 .35.32.61.67.61h1.22c.46.19.78.48.97.94v2.28c0 .35.23.6.58.6h.98c.35 0 .54-.25.54-.6v-2.2l1.21-1.17.04-.02.02-.01h.04c.1-.11.2-.26.2-.42V8.49c0-.25-.22-.44-.42-.63h.58c.02.38.29.57.63.57h.43c.13.51.18 1.03.18 1.57 0 4.42-3.58 8-8 8zm6.16-5.65c-.14 0-.29.11-.29.25v.77c0 .14.15.25.29.25.14 0 .29-.11.29-.25v-.77c0-.14-.15-.25-.29-.25zM10.5 3.48c0-.34-.28-.57-.62-.57h-.74c-.34 0-.57.25-.57.59 0 .05-.13.06.06.1v.64c0 .2.09.36.29.36.2 0 .29-.16.29-.36v-.19h.68c.33 0 .61-.23.61-.57z"],
    "globe-network": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm7.39 7h-3.63c-.31-1.99-.92-3.66-1.72-4.73 2.45.65 4.41 2.42 5.35 4.73zM13 10c0 .69-.04 1.36-.11 2H7.11a18.419 18.419 0 010-4h5.77c.08.64.12 1.31.12 2zm-3-8c1.07 0 2.25 2.05 2.75 5h-5.5c.5-2.95 1.68-5 2.75-5zm-2.04.27C7.16 3.34 6.55 5.01 6.24 7H2.61c.94-2.31 2.9-4.08 5.35-4.73zM2 10c0-.69.11-1.36.28-2h3.83a18.419 18.419 0 000 4H2.28c-.17-.64-.28-1.31-.28-2zm.61 3h3.63c.31 1.99.92 3.66 1.72 4.73A7.996 7.996 0 012.61 13zM10 18c-1.07 0-2.25-2.05-2.75-5h5.5c-.5 2.95-1.68 5-2.75 5zm2.04-.27c.79-1.07 1.4-2.74 1.72-4.73h3.63a7.996 7.996 0 01-5.35 4.73zM13.89 12a18.419 18.419 0 000-4h3.83c.17.64.28 1.31.28 2s-.11 1.36-.28 2h-3.83z"],
    "graph": ["M17.5 4A2.5 2.5 0 0015 6.5c0 .06.01.12.02.18l-1.9.84C12.38 6.6 11.27 6 10 6c-.83 0-1.59.25-2.23.68L4.91 4.14c.05-.21.09-.42.09-.64a2.5 2.5 0 00-5 0A2.5 2.5 0 002.5 6c.42 0 .81-.11 1.16-.3l2.79 2.48C6.17 8.73 6 9.34 6 10c0 1.41.73 2.64 1.83 3.35l-.56 1.67A2.498 2.498 0 005 17.5a2.5 2.5 0 005 0c0-.74-.32-1.39-.83-1.85l.56-1.68c.09.01.18.03.27.03 2.21 0 4-1.79 4-4 0-.22-.03-.44-.07-.65l2.02-.9c.43.34.96.55 1.55.55a2.5 2.5 0 000-5z"],
    "graph-remove": ["M17.41 4l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L16 2.59 13.71.3A.965.965 0 0013 0a1.003 1.003 0 00-.71 1.71L14.59 4 12.3 6.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L16 5.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L17.41 4zM19 10c-.83 0-1.55-.36-2.09-.91l-.03.03-.88-.88-.88.88a2.996 2.996 0 11-4.24-4.24l.88-.88-.88-.88.03-.03C10.36 2.55 10 1.83 10 1c0-.35.07-.68.18-.99-.06 0-.12-.01-.18-.01C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10c0-.06-.01-.12-.01-.18-.31.11-.64.18-.99.18z"],
    "greater-than": ["M12.838 10l-9.154 3.051a1 1 0 00.632 1.898l12-4c.912-.304.912-1.594 0-1.898l-12-4a1 1 0 00-.632 1.898L12.838 10z"],
    "greater-than-or-equal-to": ["M3.684 11.051a1 1 0 00.632 1.898l12-4c.912-.304.912-1.594 0-1.898l-12-4a1 1 0 00-.632 1.898L12.838 8l-9.154 3.051zM4 15h12a1 1 0 110 2H4a1 1 0 010-2z"],
    "grid": ["M19 11c.55 0 1-.45 1-1s-.45-1-1-1h-2V5h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-4V1c0-.55-.45-1-1-1S9 .45 9 1v2H5V1c0-.55-.45-1-1-1S3 .45 3 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2v4H1c-.55 0-1 .45-1 1s.45 1 1 1h2v4H1c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h4v2c0 .55.45 1 1 1s1-.45 1-1v-2h4v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2v-4h2zM9 15H5v-4h4v4zm0-6H5V5h4v4zm6 6h-4v-4h4v4zm0-6h-4V5h4v4z"],
    "grid-view": ["M0 19c0 .55.45 1 1 1h8v-9H0v8zM0 1v8h9V0H1C.45 0 0 .45 0 1zm19-1h-8v9h9V1c0-.55-.45-1-1-1zm-8 20h8c.55 0 1-.45 1-1v-8h-9v9z"],
    "group-objects": ["M6 7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm8-3H6c-3.31 0-6 2.69-6 6s2.69 6 6 6h8c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 11H6c-2.76 0-5-2.24-5-5s2.24-5 5-5h8c2.76 0 5 2.24 5 5s-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"],
    "grouped-bar-chart": ["M12 16h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1zm7 1H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-3-1h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm-9 0h1c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1zm-4 0h1c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1z"],
    "hand": ["M17 5c-.42 0-.79.27-.93.64L14.38 10h-.77l1.34-6.67c.03-.1.05-.21.05-.33a.998.998 0 00-1.98-.19h-.01L11.57 10H11V1c0-.55-.45-1-1-1S9 .45 9 1v9h-.2L6.97 2.76a.997.997 0 00-1.73-.41l-.03.03c-.01.02-.02.03-.03.04-.01.02-.01.03-.02.04v.01c-.01.01-.02.02-.02.03v.01c-.02.01-.02.02-.03.03 0 0 0 .01-.01.01 0 .01 0 .02-.01.03 0 0 0 .01-.01.01 0 .01-.01.02-.01.03 0 0 0 .01-.01.01 0 .01-.01.02-.01.03 0 .01 0 .01-.01.02 0 .01-.01.02-.01.03 0 .01 0 .01-.01.02 0 .01-.01.02-.01.03v.02c0 .01 0 .02-.01.03V3c0 .05 0 .09.01.14l1.45 10.25L6 12.7v.01L3.84 9.45h-.01A.98.98 0 003 9c-.55 0-1 .45-1 1 0 .2.06.39.17.55L6 18.44C7.06 19.4 8.46 20 10 20c3.31 0 6-2.69 6-6v-1.84l.01-.03v-.06l1.94-5.75A1.003 1.003 0 0017 5z"],
    "hand-down": ["M17.68 9.84C15.91 9 14.27 6.49 13.45 4.9 12.41 2.43 12.21 0 7.87 0 5.49 0 3.95.76 3.05 2.65 2.31 4.2 2 5.48 2 9.79v.99c0 .82.69 1.48 1.54 1.48.38 0 .73-.14 1-.36.19.6.78 1.05 1.47 1.05.47 0 .89-.2 1.17-.52.26.47.77.79 1.36.79.65 0 1.2-.39 1.43-.93l.03.77v5.44c0 .48.23.91.59 1.18.21.19.5.32.85.32h.06c.83 0 1.5-.67 1.5-1.5v-8.24l.01-.67c.85.98 1.92 1.76 3.24 1.89 1.79.19 2.09-1.33 1.43-1.64z"],
    "hand-left": ["M15.1 6.54c-1.58-.81-4.09-2.46-4.94-4.23-.31-.65-1.82-.35-1.64 1.43.13 1.33.91 2.4 1.89 3.24L9.74 7H1.5C.67 7 0 7.67 0 8.5v.06c0 .36.13.64.32.85.27.36.7.59 1.18.59h5.44l.78.01c-.54.23-.93.78-.93 1.43 0 .59.32 1.1.79 1.36-.32.28-.52.7-.52 1.17 0 .69.44 1.28 1.05 1.47-.22.27-.36.62-.36 1 0 .85.66 1.54 1.48 1.54h.99c4.31 0 5.59-.31 7.14-1.05 1.89-.9 2.65-2.44 2.65-4.82-.01-4.32-2.44-4.52-4.91-5.57z"],
    "hand-right": ["M20 8.5c0-.83-.67-1.5-1.5-1.5h-8.24l-.67-.01c.98-.85 1.76-1.92 1.89-3.24.18-1.79-1.33-2.08-1.65-1.43-.84 1.76-3.35 3.41-4.93 4.23C2.43 7.59 0 7.79 0 12.13c0 2.38.76 3.92 2.65 4.82C4.2 17.69 5.48 18 9.79 18h.99c.82 0 1.48-.69 1.48-1.54 0-.38-.14-.73-.36-1 .6-.19 1.05-.78 1.05-1.47 0-.47-.2-.89-.52-1.17.47-.26.79-.77.79-1.36 0-.65-.39-1.2-.93-1.43l.77-.03h5.44c.48 0 .91-.23 1.18-.59.19-.21.32-.49.32-.85v-.03-.03z"],
    "hand-up": ["M16.46 7.74c-.38 0-.73.14-1 .36-.19-.6-.78-1.05-1.47-1.05-.47 0-.89.2-1.17.52-.26-.47-.77-.79-1.36-.79-.65 0-1.2.39-1.43.93L10 6.94V1.5c0-.48-.23-.91-.59-1.18C9.2.13 8.92 0 8.56 0H8.5C7.67 0 7 .67 7 1.5v8.24l-.01.67c-.84-.98-1.92-1.76-3.24-1.89-1.79-.18-2.08 1.33-1.43 1.65 1.77.84 3.41 3.35 4.23 4.94 1.05 2.47 1.25 4.9 5.58 4.9 2.38 0 3.92-.76 4.82-2.65.74-1.56 1.05-2.84 1.05-7.15v-.99c0-.81-.69-1.48-1.54-1.48z"],
    "hat": ["M18.5 13c1.118 0 1.466.534 1.498 1.366L20 14.5v.5c0 1.945-5.69 3-10 3S0 16.945 0 15v-.5c0-.908.323-1.5 1.5-1.5.895 0 3.5 1.2 8.5 1.2l.411-.003C15.143 14.134 17.631 13 18.5 13zm-5-10c1.725 0 2.954 2.729 3.688 8.186-1.455.263-3.805.72-6.392.801l-.434.01L10 12c-2.896 0-5.585-.524-7.189-.814C3.546 5.73 4.775 3 6.5 3 8.6 3 8.329 5.5 10 5.5S11.5 3 13.5 3z"],
    "header": ["M16 1c-.55 0-1 .45-1 1v7H5V2c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1v-7h10v7c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "header-one": ["M10 0c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V9H2v6c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v6h7V1c0-.55.45-1 1-1zm7.4 10.77c.17-.2.29-.46.34-.77H19v10h-1.5v-7.11H15v-1.24c.32 0 .63-.03.93-.08.31-.06.58-.16.83-.29.26-.12.47-.3.64-.51z"],
    "header-three": ["M10.989 1c0-.55-.45-1-.999-1-.55 0-.999.45-.999 1v6H1.998V1c0-.55-.45-1-.999-1C.449 0 0 .45 0 1v14c0 .55.45 1 .999 1 .55 0 .999-.45.999-1V9h6.993v6c0 .55.45 1 .999 1 .55 0 .999-.45.999-1V1zm7.461 13.645c.49.11.87.38 1.14.82.27.44.41.97.41 1.61a3 3 0 01-.24 1.23c-.16.36-.38.67-.66.92-.27.25-.59.44-.96.58-.37.14-.75.21-1.16.21-.5 0-.93-.08-1.3-.24a2.55 2.55 0 01-.93-.68c-.25-.29-.44-.65-.57-1.06-.13-.42-.2-.88-.21-1.38h1.39c-.02.58.11 1.07.38 1.46.28.39.68.58 1.23.58.47 0 .86-.15 1.17-.45.31-.3.47-.72.47-1.27 0-.37-.07-.67-.2-.89-.13-.22-.3-.39-.51-.5-.21-.11-.45-.18-.71-.21-.26-.03-.53-.04-.81-.03v-1.17c.22.01.45 0 .68-.05.23-.05.43-.13.61-.24.18-.11.32-.27.43-.47.11-.2.16-.45.16-.74 0-.41-.12-.74-.37-.99s-.57-.37-.96-.37c-.24 0-.45.06-.63.17-.18.11-.33.26-.45.45s-.2.4-.26.63c-.05.23-.08.47-.07.72h-1.39c.01-.47.09-.9.23-1.3s.33-.75.57-1.04c.24-.3.53-.53.87-.69.34-.17.73-.25 1.16-.25.33 0 .66.05.98.16.32.11.61.27.87.48.26.21.47.47.62.8.15.32.23.7.23 1.12 0 .48-.09.91-.29 1.27-.2.36-.5.63-.92.79v.02z"],
    "header-two": ["M16.6 17.41c-.22.17-.4.36-.56.55-.16.19-.27.4-.33.61h4.28V20H14c.01-.81.18-1.52.53-2.13.35-.6.81-1.13 1.41-1.58.28-.23.58-.46.89-.68.31-.22.59-.46.85-.71.26-.26.48-.53.63-.83.16-.3.25-.64.26-1.02 0-.18-.02-.37-.06-.57-.04-.2-.11-.39-.22-.56s-.26-.31-.45-.43-.44-.18-.75-.18c-.28 0-.52.06-.71.19s-.34.3-.45.52c-.11.22-.2.48-.25.78-.05.3-.08.62-.09.97h-1.43c0-.54.07-1.04.2-1.5.13-.47.32-.87.58-1.2.26-.34.58-.6.95-.78.37-.19.81-.29 1.3-.29.54 0 .99.09 1.35.29.36.19.65.44.87.74.22.29.38.62.47.97.09.35.14.68.14 1 0 .4-.05.75-.16 1.07-.11.32-.26.61-.44.88-.19.27-.4.52-.63.74-.24.22-.48.43-.73.63s-.5.38-.75.56c-.26.17-.5.35-.71.53zM10 0c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V9H2v6c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v6h7V1c0-.55.45-1 1-1z"],
    "headset": ["M18.97 9H19A9 9 0 001 9h.03C.41 9.73 0 10.8 0 12c0 1.74.84 3.2 2 3.76V16c0 1.66 1.34 3 3 3h3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1H5c-.55 0-1-.45-1-1 .55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-.92C3.57 4.61 6.47 2 10 2s6.43 2.61 6.92 6H16c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h1c1.66 0 3-1.79 3-4 0-1.2-.41-2.27-1.03-3z"],
    "heart": ["M20 6.25C20 3.35 17.65 1 14.75 1c-1.02 0-1.95.31-2.75.82v-.04c-.09.06-.17.12-.26.19-.04.03-.09.06-.14.1-.68.51-1.24 1.18-1.6 1.96-.4-.86-1.04-1.57-1.8-2.1-.04-.02-.07-.05-.1-.08a7 7 0 00-.6-.33c-.13-.04-.23-.1-.35-.15-.05-.02-.1-.05-.15-.07v.02C6.45 1.13 5.87 1 5.25 1A5.25 5.25 0 000 6.25c0 .09.01.17.01.25H0c0 .06.01.12.02.18s.01.12.02.18C.13 7.89.44 9 1.07 10.17 2.23 12.33 4.1 14.11 7 16.53v.01c.9.75 1.89 1.55 3 2.46.71-.58 1.38-1.12 2-1.63 3.48-2.86 5.64-4.78 6.93-7.18.63-1.17.94-2.27 1.03-3.3.01-.07.01-.14.02-.21 0-.06.01-.11.02-.17h-.01c0-.09.01-.17.01-.26z"],
    "heart-broken": ["M8.11 7.45C8.05 7.31 8 7.16 8 7c0-.07.03-.13.04-.19h-.02l.86-4.32A5.159 5.159 0 005.25 1 5.25 5.25 0 000 6.25c0 .09.01.17.01.25H0c0 .06.01.12.02.18s.01.12.02.18C.13 7.89.44 9 1.07 10.17c1.38 2.58 3.76 4.6 7.71 7.83l-.76-3.8h.02c-.01-.07-.04-.13-.04-.2 0-.21.08-.39.18-.54l-.02-.01 1.68-2.52-1.73-3.48zM20 6.25C20 3.35 17.65 1 14.75 1c-1.54 0-2.92.67-3.88 1.73l-.83 4.13 1.85 3.69h-.01c.07.14.12.29.12.45 0 .21-.08.39-.18.54l.02.01-1.77 2.66.81 4.07c4.16-3.39 6.63-5.45 8.05-8.1.63-1.17.94-2.27 1.03-3.3.01-.07.01-.14.02-.21 0-.06.01-.11.02-.17h-.01c0-.08.01-.16.01-.25z"],
    "heat-grid": ["M14 12h6V8h-6v4zM0 12h6V8H0v4zm1-3h4v2H1V9zm-1 7c0 .55.45 1 1 1h5v-4H0v3zM19 3h-5v4h6V4c0-.55-.45-1-1-1zm0 3h-4V4h4v2zM0 4v3h6V3H1c-.55 0-1 .45-1 1zm7 3h6V3H7v4zm7 10h5c.55 0 1-.45 1-1v-3h-6v4zm-7 0h6v-4H7v4zm1-3h4v2H8v-2zm-1-2h6V8H7v4z"],
    "heatmap": ["M6 0a6 6 0 100 12A6 6 0 106 0z",
        "M10.5 8a4.5 4.5 0 100 9 4.5 4.5 0 100-9z",
        "M16.5 7a3.5 3.5 0 100 7 3.5 3.5 0 100-7zM18 16a2 2 0 100 4 2 2 0 100-4zM2.5 14a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM16.5 0a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"],
    "helicopter": ["M10 3v2H1V3.5a.5.5 0 00-1 0v5a.5.5 0 001 0V7l5 2c0 1.54.824 3.575 3 4.835V16H5.5a.5.5 0 100 1H16.5a.5.5 0 00.224-.053l2-1a.5.5 0 10-.448-.894L16.382 16H15v-1.1A5.002 5.002 0 0014 5h-1V3h6.5a.5.5 0 000-1h-16a.5.5 0 000 1H10zm4 13v-1c-1.608 0-2.928-.258-4-.683V16h4zm0-6V6a4 4 0 014 4h-4z"],
    "help": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM7.41 4.62c.65-.54 1.51-.82 2.56-.82.54 0 1.03.08 1.48.25.44.17.83.39 1.14.68.32.29.56.63.74 1.02.17.39.26.82.26 1.27s-.08.87-.24 1.23c-.16.37-.4.73-.71 1.11l-1.21 1.58c-.14.17-.28.33-.32.48-.05.15-.11.35-.11.6v.97H9v-2s.06-.58.24-.81l1.21-1.64c.25-.3.41-.56.51-.77s.14-.44.14-.67c0-.35-.11-.63-.32-.85s-.5-.33-.88-.33c-.37 0-.67.11-.89.33-.22.23-.37.54-.46.94-.03.12-.11.17-.23.16l-1.95-.29c-.12-.01-.16-.08-.14-.22.13-.93.52-1.67 1.18-2.22zM9 14h2.02L11 16H9v-2z"],
    "helper-management": ["M17 10h-3v3h3v-3zm0 4h-3v3h3v-3zm0-8h-3v3h3V6zm2-6H1C.4 0 0 .4 0 1v18c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V1c0-.6-.5-1-1-1zm-1 18H2V2h16v16zm-9-4H6v3h3v-3zm4 0h-3v3h3v-3z"],
    "high-priority": ["M12 16v4H8v-4h4zm1-16l-1 14H8L7 0h6z"],
    "highlight": ["M11.22 14.09l3.03-3.03.71.71L20 6.73l-5.71-5.71-5.04 5.04.71.71-3.02 3.04 4.28 4.28zm6.8 3.91h-16c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm-15-1h4.04c.28 0 .53-.11.71-.3l2.02-2.02-3.44-3.45-4.04 4.04c-.18.18-.3.44-.3.71.01.57.46 1.02 1.01 1.02z"],
    "history": ["M10 0C6.71 0 3.82 1.6 2 4.05V2c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.76C5.23 3.17 7.47 2 10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8c0-.55-.45-1-1-1s-1 .45-1 1c0 5.52 4.48 10 10 10s10-4.48 10-10S15.52 0 10 0zm0 3c-.55 0-1 .45-1 1v6c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L11 9.59V4c0-.55-.45-1-1-1z"],
    "home": ["M2 12v7c0 .55.45 1 1 1h5v-7h4v7h5c.55 0 1-.45 1-1v-7l-8-8-8 8zm17.71-2.71L17 6.59V3c0-.55-.45-1-1-1s-1 .45-1 1v1.59L10.71.3C10.53.11 10.28 0 10 0s-.53.11-.71.29l-9 9a1.003 1.003 0 001.42 1.42L10 2.41l8.29 8.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "horizontal-bar-chart": ["M1 1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zm3 5h11c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm8 8H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zm7-6H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h15c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"],
    "horizontal-bar-chart-asc": ["M1 9h11c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0-5h9c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm18 12H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM1 14h14c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1z"],
    "horizontal-bar-chart-desc": ["M10 16H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm2-5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm3-5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm4-5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "horizontal-distribution": ["M12 2H8c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM1 0C.45 0 0 .45 0 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm18 0c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "hurricane": ["M0 14c1.648.775 3 1 4 1-1-1-2-3.112-2-5a5.098 5.098 0 000-.045C2 5.17 6.201 1 11.172 1c3.206 0 6.9.667 8.828 5-1.648-.775-3-1-4-1 1 1 2 3.112 2 5v.045C18 14.83 13.799 19 8.828 19c-3.206 0-6.9-.667-8.828-5zm10-7a3 3 0 100 6 3 3 0 000-6z"],
    "id-number": ["M2 5v10h16V5H2zm0-2h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z",
        "M8.88 12.38c-.17-.39-1.01-.66-1.56-.9-.56-.24-.48-.39-.5-.6v-.09c.19-.17.35-.4.45-.67 0 0 0-.02.01-.02l.06-.18c.13-.03.2-.17.23-.29.03-.05.09-.18.08-.33-.04-.18-.11-.27-.2-.3v-.03c0-.24-.02-.58-.06-.81-.01-.06-.02-.12-.04-.19-.08-.27-.25-.52-.48-.7C6.63 7.09 6.3 7 6 7s-.63.09-.87.27c-.23.17-.4.42-.48.7-.02.06-.03.13-.04.19-.04.22-.06.57-.06.81V9c-.09.03-.17.12-.19.31-.01.14.05.27.08.32.03.14.1.27.23.3.02.06.03.12.06.18v.01c.11.27.27.51.47.68v.08c-.02.2.04.35-.51.6-.56.24-1.39.51-1.56.9-.19.39-.12.62-.12.62h5.98c-.01 0 .06-.23-.11-.62zM12 7h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1zM12 11h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1z"],
    "image-rotate-left": ["M10.5 13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM14 7H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 10l-5-3-1 2-2-4-3 4.5V9h11v8zm3-15h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H16c1.1 0 2 .9 2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-2.21-1.79-4-4-4z"],
    "image-rotate-right": ["M5.29 4.29a1.003 1.003 0 001.42 1.42l2-2C8.89 3.53 9 3.28 9 3c0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l.3.29H4C1.79 2 0 3.79 0 6v3c0 .55.45 1 1 1s1-.45 1-1V6c0-1.1.9-2 2-2h1.59l-.3.29zM15.5 13c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM19 7H6c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 10l-5-3-1 2-2-4-3 4.5V9h11v8z"],
    "import": ["M9.29 15.71c.18.18.43.29.71.29s.53-.11.71-.29l5-5a1.003 1.003 0 00-1.42-1.42L11 12.59V1c0-.55-.45-1-1-1S9 .45 9 1v11.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l5 5zM19 14c-.55 0-1 .45-1 1v3H2v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"],
    "inbox": ["M16.92 3.56l-.01-.02c-.16-.35-.5-.6-.91-.6H4c-.41 0-.76.25-.91.6l-.01.02L0 10.49v6.46c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-6.46l-3.08-6.93zM15 10.95c-.55 0-1 .45-1 1v1H6v-1c0-.55-.45-1-1-1H1.98l2.67-6h10.7l2.67 6H15z"],
    "inbox-filtered": ["M10.262 3l1.958 1.958v.05H4.65l-2.67 5.997H5c.55 0 1 .45 1 .999v1h8v-1c0-.55.45-1 1-1h3.02l-.635-1.426.625-.63c.354-.353.598-.8.707-1.289L20 10.545v6.456c0 .55-.45.999-1 .999H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h6.262zm9.088-3a.642.642 0 01.46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V4.13L11.19 1.1a.642.642 0 01.45-1.1h7.71z"],
    "inbox-geo": ["M7.427 3a7.467 7.467 0 00-.411 2.009H4.65l-2.67 5.996H5c.55 0 1 .45 1 .999v1h8V13c.165.01.332 0 .5 0a7.48 7.48 0 005.5-2.4V17c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h3.427zm5.715-.596a.133.133 0 01-.193 0l-.374-.374a.133.133 0 010-.193.133.133 0 01.193 0l.373.374a.133.133 0 010 .193zm1.743.033c-.05 0-.088-.006-.088-.055 0-.05.038-.056.088-.056h.165c.05 0 .088.006.088.055 0 .05-.038.056-.088.056h-.165zm.539.632c-.05 0-.104-.044-.104-.094v-.23c0-.05.054-.094.104-.094.05 0 .104.044.104.094v.23c0 .05-.055.094-.104.094zm-3.575 2.304h.506l1.182 1.2c.006.005 0 .005 0 .01v.446c0 .187-.126.341-.319.341h-.098v.226c0 .192-.138.296-.33.296h.01v.792c0 .188-.181.336-.368.336s-.369-.149-.369-.335v-1.32h-.214c-.193 0-.308-.149-.308-.341V5.72c0-.192.115-.346.308-.346zM14.5 0C17.536 0 20 2.464 20 5.5S17.536 11 14.5 11A5.502 5.502 0 019 5.5C9 2.464 11.464 0 14.5 0zm0 9.9c2.431 0 4.4-1.969 4.4-4.4 0-.297-.027-.583-.099-.864h-.236c-.188 0-.336-.104-.347-.313h-.319c.11.104.231.209.231.346v.705c0 .088-.055.17-.11.23h-.022l-.011.006-.022.011-.666.643v1.21c0 .193-.104.33-.296.33h-.54c-.192 0-.319-.137-.319-.33V6.221a.915.915 0 00-.533-.518h-.671c-.192 0-.368-.143-.368-.335V4.68c0-.192.176-.346.368-.346l.193-.005.319-.32a.342.342 0 01.489 0l.319.32c.005 0 .005.005.005.005h.704c.16 0 .237-.16.341-.313v-.11l-.038.005h-.27a.159.159 0 01-.153-.16c0-.087.066-.159.154-.159h.269l.039.006V3.42s-.05-.038-.061-.038h-.302l-.067.076a.342.342 0 01-.489.011l-.066-.088h-.176l.248.259c.021.022.021.088 0 .11-.028.022-.067.028-.088.006l-.292-.276h-.127l-.363.325-.033-.006c-.038.11-.087.089-.143.089-.126 0-.225-.072-.225-.193 0-.127.099-.209.225-.209h.176v-.182c0-.088.061-.131.149-.131h.066v-.127c0-.143.149-.297.286-.297h.28c.16 0 .27-.115.27-.275V2.42c0-.016.055.017.055-.088h-.187l-.005.017-.308.33a.123.123 0 01-.177 0c-.049-.044-.049-.121 0-.171l.391-.385c.027-.022.06-.022.094-.022l.005.022h.869A4.376 4.376 0 0014.5 1.1a4.402 4.402 0 00-2.816 1.018h.583c.094 0 .165.066.165.159s-.072.16-.165.16h-.478c0 .104-.039.06-.039.066v.351h.429l.226-.252c.132-.127.346-.155.473-.022a.332.332 0 010 .473l-1.183 1.182-.011.011c-.005.005-.011.005-.016.011a.115.115 0 00-.034.022c-.005.006-.01 0-.016.006a.309.309 0 01-.176.038h-.347c-.12.104-.187.148-.187.27v.088c0 .016-.027.027-.027.043l.561.589c.06.06.055.154 0 .209a.143.143 0 01-.209 0l-.578-.578a.425.425 0 01-.082.011c-.154 0-.292-.12-.292-.274v-.358h-.016c-.104.374-.165.77-.165 1.177 0 2.431 1.969 4.4 4.4 4.4zm3.388-3.107c.077 0 .16.06.16.137v.424c0 .077-.083.137-.16.137s-.16-.06-.16-.137V6.93c0-.077.083-.137.16-.137zm-3.113-4.879c0 .187-.154.314-.335.314h-.374v.104c0 .11-.05.198-.16.198s-.16-.088-.16-.198V1.98c-.104-.022-.033-.028-.033-.055 0-.187.127-.325.314-.325h.407c.187 0 .341.127.341.314z"],
    "inbox-search": ["M7.136 3a6.327 6.327 0 00-.098 2.009H4.65l-2.67 5.996H5c.55 0 1 .45 1 .999v1h8v-1c0-.55.45-1 1-1h1.076l1.14 1.14a2.767 2.767 0 001.974.806c.282 0 .554-.042.81-.12V17c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h3.136zm3.244 1.33c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93-1.31-2.93-2.93-2.93-2.93 1.31-2.93 2.93zm6.47 2.43l2.89 2.85c.13.15.22.35.23.56 0 .43-.35.78-.78.78-.23 0-.42-.08-.56-.22l-2.87-2.87c-.17.1-.33.2-.51.29-.03.01-.06.03-.09.04-.18.07-.35.15-.55.21-.19.06-.37.11-.57.14-.05.01-.1.02-.14.02-.2.03-.39.05-.6.05A4.3 4.3 0 019 4.31C9 1.93 10.93.01 13.3 0c2.37 0 4.3 1.93 4.3 4.3 0 .21-.02.4-.05.6-.01.05-.01.09-.02.14-.04.2-.08.38-.14.58-.05.19-.13.36-.21.54-.01.03-.03.06-.04.09-.08.18-.18.34-.29.51z"],
    "inbox-update": ["M10.083 3a6.04 6.04 0 00.001 2.009H4.65l-2.67 5.996H5c.55 0 1 .45 1 .999v1h8v-1c0-.55.45-1 1-1h3.02l-.53-1.19a5.97 5.97 0 001.824-.811L20 10.545v6.456c0 .55-.45.999-1 .999H1c-.55 0-1-.45-1-1v-6.455L3.08 3.62l.01-.02c.15-.35.5-.6.91-.6h6.083zM16 8a4 4 0 110-8 4 4 0 010 8z"],
    "info-sign": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 4h2v2H9V4zm4 12H7v-1h2V8H8V7h3v8h2v1z"],
    "inheritance": ["M6 10c0 2.21 1.79 4 4 4h6.59l-2.29-2.29A.965.965 0 0114 11a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H10c-3.31 0-6-2.69-6-6H1a1 1 0 01-1-1V1a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H6zM2 2v6h6V2H2z"],
    "inherited-group": ["M1 9c.55 0 1 .45 1 1v4c0 1.1.9 2 2 2h2.59l-.3-.29a1.003 1.003 0 011.42-1.42l2 2c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2 2A1.003 1.003 0 016 19c0-.28.11-.53.3-.71l.29-.29H4c-2.21 0-4-1.79-4-4v-4c0-.55.45-1 1-1zm6.996-9c.79 0 1.68.25 2.309.73a3.63 3.63 0 011.4 2.36c.11.6.17 1.52.17 2.15v.09c.22.09.42.32.47.82.03.39-.12.73-.2.87-.07.34-.27.71-.61.78-.04.16-.09.33-.15.48-.01.01-.02.05-.02.05-.27.71-.68 1.33-1.19 1.78 0 .08 0 .16.01.23.05.55-.15.95 1.33 1.6 1.469.66 3.698 1.35 4.178 2.39.45 1.05.27 1.67.27 1.67h-5.227a1.982 1.982 0 00-.319-.417l-2-2A2.003 2.003 0 005 15H4c-.548 0-1-.452-1-1v-1.462c.511-.213 1.023-.413 1.468-.608 1.479-.65 1.329-1.05 1.379-1.59l.01-.21c-.52-.45-.95-1.08-1.22-1.8l-.01-.01-.01-.03c-.07-.15-.12-.32-.16-.49-.34-.06-.54-.43-.62-.78-.08-.14-.24-.48-.2-.87.05-.51.26-.74.49-.83v-.08c0-.64.05-1.55.17-2.15a3.648 3.648 0 011.4-2.36C6.317.25 7.207 0 7.996 0zm5.997 3c.59 0 1.26.19 1.73.55.46.35.8.85.97 1.4.04.13.07.25.08.38.08.45.13 1.14.13 1.61v.07c.16.07.31.24.35.62.02.29-.09.55-.15.65-.05.26-.2.53-.46.59-.03.12-.07.25-.11.36-.01.01-.01.04-.01.04-.2.53-.51 1-.89 1.34 0 .06 0 .12.01.17.04.41-.11.71 1 1.19 1.099.5 2.768 1.01 3.128 1.79.34.79.2 1.25.2 1.25h-3.039V15c-.06-.33-.17-.69-.33-1.06-.45-.97-1.37-1.52-3.238-2.3-.17-.07-.76-.31-.77-.32-.1-.04-.2-.08-.28-.12.05-.14.04-.29.06-.45l.01-.16c-.25-.21-.47-.48-.65-.79.22-.34.41-.71.56-1.12l.028-.078-.002.013-.006.035.06-.15c.36-.26.6-.67.72-1.13.18-.37.29-.82.25-1.3-.05-.5-.21-.92-.47-1.22-.02-.53-.06-1.11-.12-1.59.38-.17.83-.26 1.24-.26z"],
    "inner-join": ["M8.7 4.7C7.4 6 6.5 7.9 6.5 10s.8 4 2.2 5.3c-.8.5-1.7.7-2.7.7-3.3 0-6-2.7-6-6s2.7-6 6-6c1 0 1.9.2 2.7.7zm-3.34 9.25c-.55-1.2-.86-2.54-.86-3.95s.31-2.75.86-3.95a4.001 4.001 0 000 7.9zM14 4c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1 0-1.9-.2-2.7-.7 1.3-1.3 2.2-3.2 2.2-5.3s-.8-3.9-2.2-5.3C12.1 4.2 13 4 14 4zm.6 2.05c.55 1.2.86 2.54.86 3.95s-.31 2.75-.86 3.95c1.9-.31 3.36-1.96 3.36-3.95S16.5 6.36 14.6 6.05zM10 5.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"],
    "insert": ["M19 0H1C.4 0 0 .4 0 1v18c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V1c0-.6-.5-1-1-1zm-1 18H2V2h16v16zM5 11h4v4c0 .6.4 1 1 1s1-.4 1-1v-4h4c.6 0 1-.4 1-1s-.4-1-1-1h-4V5c0-.6-.4-1-1-1s-1 .4-1 1v4H5c-.6 0-1 .4-1 1s.4 1 1 1z"],
    "intersection": ["M13 4c-1.31 0-2.51.43-3.5 1.14A5.977 5.977 0 006 4c-3.31 0-6 2.69-6 6s2.69 6 6 6c1.31 0 2.51-.43 3.5-1.14.99.71 2.19 1.14 3.5 1.14 3.31 0 6-2.69 6-6s-2.69-6-6-6zm-4.93 9.41c-.61.37-1.31.59-2.07.59-2.21 0-4-1.79-4-4s1.79-4 4-4c.76 0 1.46.22 2.07.59C7.4 7.56 7 8.73 7 10s.4 2.44 1.07 3.41zM13 14c-.76 0-1.46-.22-2.07-.59C11.6 12.44 12 11.27 12 10s-.4-2.44-1.07-3.41C11.54 6.22 12.24 6 13 6c2.21 0 4 1.79 4 4s-1.79 4-4 4z"],
    "ip-address": ["M6 3.66C6 5.69 10 11 10 11s4-5.31 4-7.34C13.99 1.64 12.21 0 10 0S6 1.64 6 3.66zM8 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM14 13.5V13h-4v1h3v2h-2v1h3v-3.5zM3 12h14c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1zm4 1v6h1v-6H7zm3 1v5h1v-5h-1z"],
    "issue": ["M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-2H9v-2h2v2zm0-3H9V4h2v9z"],
    "issue-closed": ["M15.364 5.9a.997.997 0 01-.707-.293l-2.121-2.122a1 1 0 111.414-1.414l1.414 1.414L18.192.657a1 1 0 011.414 1.414l-3.535 3.536a.997.997 0 01-.707.292zM11.78.157a3.002 3.002 0 00-1.437 1.85 8 8 0 107.1 5.055l.042-.042 1.472-1.472A9.959 9.959 0 0120 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0c.608 0 1.202.054 1.78.158zM11 16H9v-2h2v2zm0-3H9V4h2v9z"],
    "issue-new": ["M13.167.512a2.98 2.98 0 00-.131.524c-.74.115-1.39.5-1.848 1.052a8 8 0 106.724 6.724 2.997 2.997 0 001.052-1.848 2.98 2.98 0 00.524-.13A9.99 9.99 0 0120 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0a9.99 9.99 0 013.167.512zM11 16H9v-2h2v2zm0-3H9V4h2v9zm6-10h1.5a1 1 0 010 2H17v1.5a1 1 0 01-2 0V5h-1.5a1 1 0 010-2H15V1.5a1 1 0 012 0V3z"],
    "italic": ["M11.7 4H14c.6 0 1-.4 1-1s-.4-1-1-1H7c-.6 0-1 .4-1 1s.4 1 1 1h2.2L7.3 15H5c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1H9.8l1.9-11z"],
    "join-table": ["M19 6h-4V2c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h4v4c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zM6 12H2V9h4v3zm0-4H2V5h4v3zm7 9H7v-3h6v3zm0-4H7V9h6v4zm0-5H7V5h6v3zm5 9h-4v-3h4v3zm0-4h-4v-3h4v3z"],
    "key": ["M14 0c-3.31 0-6 2.69-6 6 0 1.11.32 2.14.85 3.03L.44 17.44a1.498 1.498 0 102.12 2.12l.79-.79.94.94c.18.18.43.29.71.29s.53-.11.71-.29l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-.94-.94 3.2-3.2A5.9 5.9 0 0014 12c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"],
    "key-backspace": ["M19 3H7c-.28 0-.53.11-.71.29l-6 6C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l6 6c.18.18.43.29.71.29h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-2.29 9.29a1.003 1.003 0 01-1.42 1.42L13 11.41l-2.29 2.29c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71l2.3-2.29-2.3-2.29a1.003 1.003 0 011.42-1.42L13 8.59l2.29-2.29c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L14.41 10l2.3 2.29z"],
    "key-command": ["M15.5 12H14V8h1.5C17.43 8 19 6.43 19 4.5S17.43 1 15.5 1 12 2.57 12 4.5V6H8V4.5C8 2.57 6.43 1 4.5 1S1 2.57 1 4.5 2.57 8 4.5 8H6v4H4.5C2.57 12 1 13.57 1 15.5S2.57 19 4.5 19 8 17.43 8 15.5V14h4v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0-9c.83 0 1.5.67 1.5 1.5S16.33 6 15.5 6 14 5.33 14 4.5 14.67 3 15.5 3zm-11 14c-.83 0-1.5-.67-1.5-1.5S3.67 14 4.5 14s1.5.67 1.5 1.5S5.33 17 4.5 17zm0-11C3.67 6 3 5.33 3 4.5S3.67 3 4.5 3 6 3.67 6 4.5 5.33 6 4.5 6zm7.5 6H8V8h4v4zm3.5 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"],
    "key-control": ["M16.71 7.29l-6-6C10.53 1.11 10.28 1 10 1s-.53.11-.71.29l-6 6a1.003 1.003 0 001.42 1.42L10 3.41l5.29 5.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z"],
    "key-delete": ["M19.71 9.29l-6-6A.997.997 0 0013 3H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.28 0 .53-.11.71-.29l6-6c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zm-9 3a1.003 1.003 0 01-1.42 1.42L7 11.41 4.71 13.7c-.18.19-.43.3-.71.3a1.003 1.003 0 01-.71-1.71L5.59 10l-2.3-2.29a1.003 1.003 0 011.42-1.42L7 8.59 9.29 6.3c.18-.19.43-.3.71-.3a1.003 1.003 0 01.71 1.71L8.41 10l2.3 2.29z"],
    "key-enter": ["M18 2c-.55 0-1 .45-1 1v5c0 2.21-1.79 4-4 4H4.41L6.7 9.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L4.41 14H13c3.31 0 6-2.69 6-6V3c0-.55-.45-1-1-1z"],
    "key-escape": ["M2 8c.55 0 1-.45 1-1V4.41l6.29 6.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 3H7c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1zm9-6.94V3.1c3.39.49 6 3.38 6 6.9 0 3.87-3.13 7-7 7-3.52 0-6.41-2.61-6.9-6H1.06c.5 4.5 4.31 8 8.94 8a9 9 0 009-9c0-4.63-3.5-8.44-8-8.94z"],
    "key-option": ["M13 4h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1zm6 12h-4.42L6.87 2.5l-.02.01A.977.977 0 006 2H1c-.55 0-1 .45-1 1s.45 1 1 1h4.42l7.71 13.5.01-.01c.18.3.49.51.86.51h5c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "key-shift": ["M17.74 10.35l-6.99-8.01-.01.01C10.56 2.14 10.3 2 10 2s-.56.14-.74.35l-.01-.01-7 8 .01.01A.95.95 0 002 11c0 .55.45 1 1 1h3v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5h3c.55 0 1-.45 1-1 0-.25-.1-.48-.26-.65z"],
    "key-tab": ["M19 13H4.41l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L2 12.59V10c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1v-2.59l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L4.41 15H19c.55 0 1-.45 1-1s-.45-1-1-1zm0-12c-.55 0-1 .45-1 1v2.59L14.71 1.3A.965.965 0 0014 1a1.003 1.003 0 00-.71 1.71L15.59 5H1c-.55 0-1 .45-1 1s.45 1 1 1h14.59L13.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 7.41V10c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "known-vehicle": ["M19 4a.997.997 0 00-.707.293L14 8.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a.997.997 0 001.414 0l5-5A1 1 0 0019 4zm-2.048 7.291c.011.072.048.134.048.209a1.5 1.5 0 01-1.5 1.5c-.225 0-.433-.057-.624-.145-.279.085-.57.145-.876.145a2.99 2.99 0 01-2.121-.879l-3-3 .007-.007A3.027 3.027 0 018.184 8H4V7l1-3h10l.19.568 1.307-1.308c-.336-.356-.758-.658-1.165-.772 0 0-1.74-.488-5.332-.488s-5.332.488-5.332.488c-.67.188-1.424.864-1.674 1.502L2.99 4H3L2 7H1a1 1 0 000 2h.333l-.28.84L1 10v7.5a1.5 1.5 0 103 0V17h12v.5a1.5 1.5 0 003 0V10l-.19-.568-1.858 1.86zM4.5 13a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"],
    "lab-test": ["M13 2a1 1 0 010 2v4l4 8v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1l4-8V4a1 1 0 110-2h6zm-2 2H9v4l-2 4h6l-2-4V4z"],
    "label": ["M3 12h14v-1H3v1zm11-9H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V9l-6-6zm4 12H2V5h11v3H3v1h10v1h5v5zm-4-6V5l4 4h-4z"],
    "layer": ["M19.5 9.1l-9-5c-.2-.1-.3-.1-.5-.1s-.3 0-.5.1l-9 5c-.3.2-.5.5-.5.9s.2.7.5.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9s-.2-.7-.5-.9z"],
    "layer-outline": ["M9.514 4.126l-9 5a1 1 0 000 1.748l9 5a1 1 0 00.972 0l9-5a1 1 0 000-1.748l-9-5a1 1 0 00-.972 0zM10 6.144l6.94 3.855L10 13.855 3.059 9.999 10 6.144z"],
    "layers": ["M.5 6.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9s-.2-.7-.5-.9l-9-5c-.2-.1-.3-.1-.5-.1s-.3 0-.5.1l-9 5c-.3.2-.5.5-.5.9s.2.7.5.9z",
        "M19 9c-.2 0-.3 0-.5.1L10 13.9 1.5 9.1C1.3 9 1.2 9 1 9c-.6 0-1 .4-1 1 0 .4.2.7.5.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9 0-.6-.4-1-1-1z",
        "M19 13c-.2 0-.3 0-.5.1L10 17.9l-8.5-4.7c-.2-.2-.3-.2-.5-.2-.6 0-1 .4-1 1 0 .4.2.7.5.9l9 5c.2.1.3.1.5.1s.3 0 .5-.1l9-5c.3-.2.5-.5.5-.9 0-.6-.4-1-1-1z"],
    "layout": ["M18 6c-1.1 0-2 .9-2 2 0 .37.11.71.28 1.01l-2.27 2.27c-.3-.17-.64-.28-1.01-.28-.93 0-1.71.64-1.93 1.5H8.93c-.22-.86-1-1.5-1.93-1.5-.37 0-.71.11-1.01.28L3.72 9.01C3.89 8.71 4 8.37 4 8c0-.34-.09-.66-.24-.94l3.66-3.38c.31.2.68.32 1.08.32 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .34.09.66.24.94L3.08 6.32C2.77 6.12 2.4 6 2 6 .9 6 0 6.9 0 8s.9 2 2 2c.37 0 .71-.11 1.01-.28l2.27 2.27c-.17.3-.28.64-.28 1.01s.11.71.28 1.01l-2.27 2.27C2.71 16.11 2.37 16 2 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.37-.11-.71-.28-1.01l2.27-2.27c.3.17.64.28 1.01.28.93 0 1.71-.64 1.93-1.5h2.14c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2 0-.37-.11-.71-.28-1.01l2.27-2.27c.3.17.64.28 1.01.28 1.1 0 2-.9 2-2s-.9-2-2-2z"],
    "layout-auto": ["M18 13c-.53 0-1.01.21-1.37.55L11.9 10.6c.06-.19.1-.39.1-.6s-.04-.41-.1-.6l4.72-2.95c.37.34.85.55 1.38.55 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .21.04.41.1.6l-4.73 2.96c-.24-.23-.54-.4-.87-.48V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S8 .9 8 2c0 .93.64 1.71 1.5 1.93v4.14c-.33.09-.63.26-.87.48L3.9 5.6c.06-.19.1-.39.1-.6 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.53 0 1.01-.21 1.37-.55L8.1 9.4c-.06.19-.1.39-.1.6s.04.41.1.6l-4.72 2.95C3.01 13.21 2.53 13 2 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.21-.04-.41-.1-.6l4.73-2.96c.24.23.54.4.87.48v4.14C8.64 16.29 8 17.07 8 18c0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-4.14c.33-.09.63-.26.87-.48l4.73 2.96c-.06.18-.1.38-.1.59 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"],
    "layout-balloon": ["M18 16c-.14 0-.28.02-.42.05l-1.73-3.45c.69-.45 1.14-1.22 1.14-2.1s-.46-1.65-1.14-2.1l1.73-3.45c.14.03.28.05.42.05 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .6.27 1.13.69 1.5l-1.77 3.54c-.14-.02-.28-.04-.42-.04a2.5 2.5 0 00-2.45 2h-4.1A2.5 2.5 0 005.5 8c-.14 0-.28.02-.42.04L3.31 4.5C3.73 4.13 4 3.6 4 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.14 0 .28-.02.42-.05L4.14 8.4C3.46 8.85 3 9.62 3 10.5s.46 1.65 1.14 2.1l-1.73 3.45A1.84 1.84 0 002 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.6-.27-1.13-.69-1.5l1.77-3.54c.14.02.28.04.42.04a2.5 2.5 0 002.45-2h4.1a2.5 2.5 0 002.45 2c.14 0 .28-.02.42-.04l1.77 3.54c-.42.37-.69.9-.69 1.5 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2z"],
    "layout-circle": ["M18.3 8c-.2-.9-.6-1.7-1.1-2.5.2-.3.3-.7.3-1 0-1.1-.9-2-2-2-.4 0-.7.1-1 .3-.8-.5-1.6-.8-2.5-1.1-.1-1-1-1.7-2-1.7S8.2.8 8 1.7c-.9.3-1.7.6-2.5 1.1-.3-.2-.7-.3-1-.3-1.1 0-2 .9-2 2 0 .4.1.7.3 1-.5.8-.8 1.6-1.1 2.5C.8 8.2 0 9 0 10s.8 1.8 1.7 2c.2.9.6 1.7 1.1 2.5-.2.3-.3.7-.3 1 0 1.1.9 2 2 2 .4 0 .7-.1 1-.3.8.5 1.6.8 2.5 1.1.1 1 1 1.7 2 1.7s1.8-.8 2-1.7c.9-.2 1.7-.6 2.5-1.1.3.2.7.3 1 .3 1.1 0 2-.9 2-2 0-.4-.1-.7-.3-1 .5-.8.8-1.6 1.1-2.5 1-.1 1.7-1 1.7-2s-.8-1.8-1.7-2zm-1.8 5.8c-.3-.2-.6-.3-1-.3-1.1 0-2 .9-2 2 0 .4.1.7.3 1-.6.3-1.2.6-1.9.8-.3-.7-1-1.3-1.9-1.3-.8 0-1.6.5-1.9 1.3-.7-.2-1.3-.4-1.9-.8.2-.3.3-.6.3-1 0-1.1-.9-2-2-2-.4 0-.7.1-1 .3-.3-.6-.6-1.2-.8-1.9.8-.3 1.3-1.1 1.3-1.9s-.5-1.6-1.2-1.8c.2-.7.4-1.3.8-1.9.3.2.6.3 1 .3 1.1 0 2-.9 2-2 0-.4-.1-.7-.3-1 .6-.3 1.2-.6 1.9-.8.2.7 1 1.2 1.8 1.2s1.6-.5 1.9-1.3c.7.2 1.3.4 1.9.8-.2.3-.3.6-.3 1 0 1.1.9 2 2 2 .4 0 .7-.1 1-.3.3.6.6 1.2.8 1.9-.8.3-1.3 1.1-1.3 1.9s.5 1.6 1.2 1.8c-.1.7-.4 1.4-.7 2z"],
    "layout-grid": ["M2 0a2 2 0 100 4 2 2 0 100-4zM10 0a2 2 0 100 4 2 2 0 100-4zM18 0a2 2 0 100 4 2 2 0 100-4zM18 8a2 2 0 100 4 2 2 0 100-4zM18 16a2 2 0 100 4 2 2 0 100-4zM10 16a2 2 0 100 4 2 2 0 100-4zM2 16a2 2 0 100 4 2 2 0 100-4zM2 8a2 2 0 100 4 2 2 0 100-4zM10 8a2 2 0 100 4 2 2 0 100-4z"],
    "layout-group-by": ["M2 2a2 2 0 100 4 2 2 0 100-4zM18 0a2 2 0 100 4 2 2 0 100-4zM18 8a2 2 0 100 4 2 2 0 100-4zM18 16a2 2 0 100 4 2 2 0 100-4zM2 14a2 2 0 100 4 2 2 0 100-4zM2 8a2 2 0 100 4 2 2 0 100-4zM13 12a2 2 0 100 4 2 2 0 100-4zM13 4a2 2 0 100 4 2 2 0 100-4z"],
    "layout-hierarchy": ["M18.5 16.07v-4.14c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2-.93 0-1.71.64-1.93 1.5h-4.14c-.18-.7-.73-1.25-1.43-1.43V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S8 .9 8 2c0 .93.64 1.71 1.5 1.93v4.14c-.7.18-1.25.73-1.43 1.43H3.93C3.71 8.64 2.93 8 2 8c-1.1 0-2 .9-2 2 0 .93.64 1.71 1.5 1.93v4.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-4.14c.7-.18 1.25-.73 1.43-1.43h4.14c.18.7.73 1.25 1.43 1.43v4.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93v-4.14c.7-.18 1.25-.73 1.43-1.43h4.14c.18.7.73 1.25 1.43 1.43v4.14c-.86.22-1.5 1-1.5 1.93 0 1.1.9 2 2 2s2-.9 2-2c0-.93-.64-1.71-1.5-1.93z"],
    "layout-linear": ["M16.5 7a2.5 2.5 0 00-2.45 2h-2.1a2.5 2.5 0 00-4.9 0h-2.1a2.5 2.5 0 100 1h2.1a2.5 2.5 0 004.9 0h2.1a2.5 2.5 0 102.45-3z"],
    "layout-skew-grid": ["M2 0a2 2 0 100 4 2 2 0 100-4zM18 0a2 2 0 100 4 2 2 0 100-4zM18 8a2 2 0 100 4 2 2 0 100-4zM18 16a2 2 0 100 4 2 2 0 100-4zM2 16a2 2 0 100 4 2 2 0 100-4zM2 8a2 2 0 100 4 2 2 0 100-4zM10 12a2 2 0 100 4 2 2 0 100-4zM10 4a2 2 0 100 4 2 2 0 100-4z"],
    "layout-sorted-clusters": ["M2 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm16 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-8 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "learning": ["M10.551 1.127a1.256 1.256 0 00-1.102 0L.456 5.89c-.608.309-.608.913 0 1.222l8.993 4.762c.334.17.767.17 1.102 0l8.992-4.762c.61-.309.61-.913 0-1.222l-8.992-4.762z",
        "M18 6.5l.016 4.514c.002.548.447.99.994.99a.99.99 0 00.99-.99V6.5h-2zM3.366 10.033l6.401 3.358a.5.5 0 00.465 0l6.406-3.358a.25.25 0 01.366.221v5.109a.25.25 0 01-.139.224l-6.64 3.302a.5.5 0 01-.446 0l-6.64-3.302A.25.25 0 013 15.363v-5.108a.25.25 0 01.366-.222z"],
    "left-join": ["M8.7 4.7C7.4 6 6.5 7.9 6.5 10s.8 4 2.2 5.3c-.8.5-1.7.7-2.7.7-3.3 0-6-2.7-6-6s2.7-6 6-6c1 0 1.9.2 2.7.7zM14 4c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1 0-1.9-.2-2.7-.7 1.3-1.3 2.2-3.2 2.2-5.3s-.8-3.9-2.2-5.3C12.1 4.2 13 4 14 4zm.6 2.05c.55 1.2.86 2.54.86 3.95s-.31 2.75-.86 3.95c1.9-.31 3.36-1.96 3.36-3.95S16.5 6.36 14.6 6.05zM10 5.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"],
    "less-than": ["M7.162 10l9.154 3.052a1 1 0 01-.632 1.897l-12-4c-.912-.304-.912-1.594 0-1.897l12-4a1 1 0 01.632 1.897L7.162 10z"],
    "less-than-or-equal-to": ["M16.316 11.051L7.162 8l9.154-3.051a1 1 0 10-.632-1.898l-12 4c-.912.304-.912 1.594 0 1.898l12 4a1 1 0 10.632-1.898zM16 15H4a1 1 0 100 2h12a1 1 0 100-2z"],
    "lifesaver": ["M8.143 14.644L7.028 17.43c.919.368 1.922.57 2.972.57s2.053-.202 2.972-.57l-1.115-2.786A4.986 4.986 0 0110 15a4.986 4.986 0 01-1.857-.356zm-2.787-2.787A4.986 4.986 0 015 10c0-.656.126-1.283.356-1.857L2.57 7.028A7.978 7.978 0 002 10c0 1.05.202 2.053.57 2.972l2.786-1.115zm2.787-6.5A4.986 4.986 0 0110 5c.656 0 1.283.126 1.857.356l1.115-2.786A7.978 7.978 0 0010 2c-1.05 0-2.053.202-2.972.57l1.115 2.786zm6.5 2.786c.23.574.357 1.2.357 1.857 0 .656-.126 1.283-.356 1.857l2.786 1.115c.368-.919.57-1.922.57-2.972s-.202-2.053-.57-2.972l-2.786 1.115zM10 13a3 3 0 100-6 3 3 0 000 6zm0 7C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"],
    "lightbulb": ["M6.33 13.39c0 .34.27.61.6.61h6.13c.33 0 .6-.27.6-.61C14.03 9.78 16 9.4 16 6.09 16 2.72 13.31 0 10 0S4 2.72 4 6.09c0 3.31 1.97 3.69 2.33 7.3zM13 15H7c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm-1 3H8c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "lightning": ["M9 11H6a1 1 0 01-1-1L5.91.9a1 1 0 01.995-.9h6.256a.839.839 0 01.779 1.15L11.2 8h2.978a.822.822 0 01.748 1.162l-4.764 10.481A.608.608 0 019 19.392V11z"],
    "link": ["M10.85 11.98l-4.44 4.44-1 1c-.36.36-.86.58-1.41.58-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41l5.44-5.44C7.69 9.06 7.36 9 7 9c-1.11 0-2.09.46-2.82 1.18l-.01-.01-3 3 .01.01C.46 13.91 0 14.89 0 16c0 2.21 1.79 4 4 4 1.11 0 2.09-.46 2.82-1.18l.01.01 3-3-.01-.01C10.54 15.09 11 14.11 11 13c0-.36-.06-.69-.15-1.02zM20 4c0-2.21-1.79-4-4-4-1.11 0-2.09.46-2.82 1.18l-.01-.01-3 3 .01.01C9.46 4.91 9 5.89 9 7c0 .36.06.69.15 1.02l4.44-4.44 1-1c.36-.36.86-.58 1.41-.58 1.1 0 2 .9 2 2 0 .55-.22 1.05-.59 1.41l-5.44 5.44c.34.09.67.15 1.03.15 1.11 0 2.09-.46 2.82-1.18l.01.01 3-3-.01-.01C19.54 6.09 20 5.11 20 4zM5 14a1.003 1.003 0 001.71.71l8-8a1.003 1.003 0 00-1.42-1.42l-2 2-2 2-2 2-2 2c-.18.18-.29.43-.29.71z"],
    "list": ["M1.03 1C.46 1 0 1.46 0 2.03v.95C0 3.54.46 4 1.03 4h17.95C19.54 4 20 3.54 20 2.97v-.94C20 1.46 19.54 1 18.97 1H1.03zM0 17.97C0 18.54.46 19 1.03 19h17.95c.56 0 1.03-.46 1.03-1.03v-.95c0-.56-.46-1.03-1.03-1.03H1.03C.46 16 0 16.46 0 17.03v.94zM0 12.97C0 13.54.46 14 1.03 14h17.95c.56 0 1.03-.46 1.03-1.03v-.95c0-.56-.46-1.03-1.03-1.03H1.03C.46 11 0 11.46 0 12.03v.94zM0 7.97C0 8.54.46 9 1.03 9h17.95C19.54 9 20 8.54 20 7.97v-.94C20 6.46 19.54 6 18.97 6H1.03C.46 6 0 6.46 0 7.03v.94z"],
    "list-columns": ["M0 2.973v-.936C0 1.468.46 1.01 1.029 1H7.97C8.541 1 9 1.468 9 2.027v.946C9 3.542 8.53 4 7.971 4H1.03C.459 4 0 3.542 0 2.973zm0 5v-.936C0 6.468.46 6.01 1.029 6H7.97C8.541 6 9 6.468 9 7.027v.946C9 8.542 8.53 9 7.971 9H1.03C.459 9 0 8.542 0 7.973zm0 5v-.936C0 11.468.46 11.01 1.029 11H7.97C8.541 11 9 11.468 9 12.027v.946C9 13.542 8.53 14 7.971 14H1.03C.459 14 0 13.542 0 12.973zm0 5v-.936C0 16.468.46 16.01 1.029 16H7.97C8.541 16 9 16.468 9 17.027v.946C9 18.542 8.53 19 7.971 19H1.03C.459 19 0 18.542 0 17.973zm11-15v-.936c0-.569.46-1.027 1.029-1.037h6.942C19.541 1 20 1.468 20 2.027v.946C20 3.542 19.53 4 18.971 4H12.03C11.459 4 11 3.542 11 2.973zm0 5v-.936c0-.569.46-1.027 1.029-1.037h6.942C19.541 6 20 6.468 20 7.027v.946C20 8.542 19.53 9 18.971 9H12.03C11.459 9 11 8.542 11 7.973zm0 5v-.936c0-.569.46-1.027 1.029-1.037h6.942c.57 0 1.029.468 1.029 1.027v.946c0 .569-.47 1.027-1.029 1.027H12.03c-.57 0-1.029-.458-1.029-1.027zm0 5v-.936c0-.569.46-1.027 1.029-1.037h6.942c.57 0 1.029.468 1.029 1.027v.946c0 .569-.47 1.027-1.029 1.027H12.03c-.57 0-1.029-.458-1.029-1.027z"],
    "list-detail-view": ["M8 6H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM8 1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm11 0h-7c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z"],
    "locate": ["M10 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9 1h-1.07c-.45-3.61-3.32-6.45-6.93-6.91V1c0-.55-.45-1-1-1S9 .45 9 1v1.09C5.39 2.55 2.52 5.39 2.07 9H1c-.55 0-1 .45-1 1s.45 1 1 1h1.07c.45 3.61 3.32 6.45 6.93 6.91V19c0 .55.45 1 1 1s1-.45 1-1v-1.09c3.61-.46 6.48-3.29 6.93-6.91H19c.55 0 1-.45 1-1s-.45-1-1-1zm-4 2h.9a5.98 5.98 0 01-4.9 4.91V15c0-.55-.45-1-1-1s-1 .45-1 1v.91A5.98 5.98 0 014.1 11H5c.55 0 1-.45 1-1s-.45-1-1-1h-.9A5.98 5.98 0 019 4.09V5c0 .55.45 1 1 1s1-.45 1-1v-.91A5.98 5.98 0 0115.9 9H15c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "lock": ["M15.93 9H14V4.99c0-2.21-1.79-4-4-4s-4 1.79-4 4V9H3.93c-.55 0-.93.44-.93.99v8c0 .55.38 1.01.93 1.01h12c.55 0 1.07-.46 1.07-1.01v-8c0-.55-.52-.99-1.07-.99zM8 9V4.99c0-1.1.9-2 2-2s2 .9 2 2V9H8z"],
    "log-in": ["M19 0h-8c-.55 0-1 .45-1 1s.45 1 1 1h7v16h-7c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 10c0-.28-.11-.53-.29-.71l-5-5a1.003 1.003 0 00-1.42 1.42L11.59 9H1c-.55 0-1 .45-1 1s.45 1 1 1h10.59L8.3 14.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l5-5c.18-.18.29-.43.29-.71z"],
    "log-out": ["M19.71 9.29l-5-5a1.003 1.003 0 00-1.42 1.42L16.59 9H6c-.55 0-1 .45-1 1s.45 1 1 1h10.59l-3.29 3.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l5-5c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM9 18H2V2h7c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "manual": ["M20 1.1a.976.976 0 00-.83-.88C15.15-.43 12.07.34 10 2.5 7.93.34 4.85-.43.84.22.37.3.03.67 0 1.1v15.01c0 .07 0 .14.01.21.09.52.61.88 1.15.79 3.85-.62 6.4.16 8 2.46.02.02.03.04.05.07.02.02.04.04.06.07l.01.01a1.07 1.07 0 00.28.19c.01 0 .01.01.02.01.03.01.07.03.1.04.01 0 .02.01.04.01.03.01.07.02.1.02.01 0 .02 0 .04.01H10c.04 0 .09 0 .13-.01.01 0 .03 0 .04-.01.03-.01.06-.01.1-.02.01 0 .03-.01.04-.01.03-.01.07-.02.1-.04.01 0 .02-.01.03-.01.07-.03.13-.07.19-.11.01 0 .01-.01.02-.01.02-.02.04-.03.06-.05.01-.01.02-.02.03-.02l.05-.05c.01-.01.02-.02.02-.03.01-.02.02-.03.04-.05 1.61-2.3 4.15-3.09 8-2.46.54.09 1.06-.26 1.15-.79-.01-.05 0-.09 0-.13V1.1zM9 16.63c-1.78-1.31-4.12-1.83-7-1.55V2c3.26-.37 5.51.39 7 2.35v12.28zm9-1.56c-2.88-.28-5.22.24-7 1.55V4.34c1.49-1.96 3.74-2.71 7-2.35v13.08z"],
    "manually-entered-data": ["M1 12h4.34l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm16.77-3.94l1.65-1.65c.36-.36.58-.86.58-1.41 0-1.1-.9-2-2-2-.55 0-1.05.22-1.41.59l-1.65 1.65 2.83 2.82zM1 4h12.34l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zM0 15c0 .55.45 1 1 1h.34l2-2H1c-.55 0-1 .45-1 1zm1-7h8.34l2-2H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 2h-.34l-2 2H19c.55 0 1-.45 1-1s-.45-1-1-1zm0 4h-4.34l-2 2H19c.55 0 1-.45 1-1s-.45-1-1-1zM4 19l4.41-1.59-2.81-2.79L4 19zM14.23 5.94l-7.65 7.65 2.83 2.83 7.65-7.65-2.83-2.83z"],
    "many-to-many": ["M17 6a1 1 0 100-2 1 1 0 000 2zm0 2a3 3 0 01-2.73-1.754c-.2.068-.408.154-.617.264-.884.465-1.92 1.418-2.605 3.49.685 2.072 1.721 3.025 2.605 3.49.21.11.416.196.617.264a3 3 0 11-.165 2.034 6.262 6.262 0 01-1.383-.528c-.983-.518-1.948-1.364-2.722-2.705-.774 1.34-1.739 2.187-2.722 2.705-.48.252-.95.419-1.383.528A3.001 3.001 0 010 15a3 3 0 015.73-1.246c.2-.068.408-.154.617-.264.884-.465 1.92-1.418 2.605-3.49-.685-2.072-1.721-3.025-2.605-3.49a4.21 4.21 0 00-.617-.264 3 3 0 11.165-2.034c.433.11.904.276 1.383.528.983.518 1.948 1.364 2.722 2.705.774-1.34 1.739-2.187 2.722-2.705.48-.252.95-.419 1.383-.528A3.001 3.001 0 0120 5a3 3 0 01-3 3zM4 5a1 1 0 10-2 0 1 1 0 002 0zm12 10a1 1 0 102 0 1 1 0 00-2 0zM3 14a1 1 0 110 2 1 1 0 010-2z"],
    "many-to-one": ["M3 2a1 1 0 100 2 1 1 0 000-2zm0 4c1.296 0 2.4-.821 2.82-1.972.487.039 1.086.13 1.667.347.947.352 1.773 1 2.032 2.318.323 1.644 1.234 2.675 2.264 3.307-1.03.632-1.941 1.663-2.264 3.307-.259 1.318-1.085 1.966-2.032 2.318a6.244 6.244 0 01-1.668.347 3.001 3.001 0 10.019 2.004c.633-.042 1.491-.158 2.347-.476 1.402-.523 2.867-1.625 3.296-3.807.259-1.318 1.085-1.966 2.032-2.318.24-.09.484-.158.722-.21a3 3 0 100-2.33 5.329 5.329 0 01-.722-.21c-.947-.352-1.773-1-2.032-2.318-.428-2.182-1.894-3.284-3.296-3.807-.856-.318-1.714-.434-2.347-.476A3.001 3.001 0 000 3a3 3 0 003 3zm13 4a1 1 0 102 0 1 1 0 00-2 0zM2 17a1 1 0 112 0 1 1 0 01-2 0z"],
    "map": ["M19.54 4.18l.01-.02-6-4-.01.02C13.39.08 13.21 0 13 0s-.39.08-.54.18l-.01-.02L7 3.8 1.55.17l-.01.01A.969.969 0 001 0C.45 0 0 .45 0 1v14c0 .35.19.64.46.82l-.01.02 6 4 .01-.02c.15.1.33.18.54.18s.39-.08.54-.18l.01.02L13 16.2l5.45 3.63.01-.02c.15.11.33.19.54.19.55 0 1-.45 1-1V5c0-.35-.19-.64-.46-.82zM6 17.13l-4-2.67V2.87l4 2.67v11.59zm6-2.67l-4 2.67V5.54l4-2.67v11.59zm6 2.67l-4-2.67V2.87l4 2.67v11.59z"],
    "map-create": ["M18 9.22v7.91l-4-2.67V9.22c-.61-.55-1-1.33-1-2.22-.35 0-.69-.07-1-.18v7.65l-4 2.67V5.54l2.02-1.35c0-.06-.02-.13-.02-.19 0-1.66 1.34-3 3-3 0-.34.07-.66.17-.97C13.12.02 13.06 0 13 0c-.21 0-.39.08-.54.18l-.01-.02L7 3.8 1.55.17l-.01.01A.969.969 0 001 0C.45 0 0 .45 0 1v14c0 .35.19.64.46.82l-.01.02 6 4 .01-.02c.15.1.33.18.54.18s.39-.08.54-.18l.01.02L13 16.2l5.45 3.63.01-.02c.15.11.33.19.54.19.55 0 1-.45 1-1V6.82c-.31.11-.65.18-1 .18 0 .89-.39 1.67-1 2.22zM6 17.13l-4-2.67V2.87l4 2.67v11.59zM12 4c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1z"],
    "map-marker": ["M9.98 0c-3.87 0-7 2.98-7 6.67 0 3.68 7 13.33 7 13.33s7-9.65 7-13.33c0-3.68-3.14-6.67-7-6.67zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"],
    "maximize": ["M19 0h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L11.3 7.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L18 3.41V6c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zM8 11c-.28 0-.53.11-.71.29L2 16.59V14c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H3.41l5.29-5.29c.19-.18.3-.43.3-.71 0-.55-.45-1-1-1z"],
    "media": ["M15 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-7H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 13l-6-5-2 2-4-5-4 8V4h16v11z"],
    "menu": ["M1 6h18c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm18 3H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "menu-closed": ["M8 6h11c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM4 6c-.28 0-.53.11-.71.29l-3 3C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l3 3A1.003 1.003 0 005 13V7c0-.55-.45-1-1-1zm15 8H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm0-5H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "menu-open": ["M12 9H1c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm0 5H1c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm0-10H1c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm7.71 5.29l-3-3A1.003 1.003 0 0015 7v6a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "merge-columns": ["M6.71 6.29a1.003 1.003 0 00-1.42 1.42L6.59 9H2V2h5v2.18c.42.15.8.39 1.11.7l.01-.01.88.89V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-4.76l-.88.88-.01-.01c-.31.31-.69.56-1.11.71V18H2v-7h4.59L5.3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3zM19 0h-7c-.55 0-1 .45-1 1v4.76l.88-.88.01.01c.31-.31.69-.55 1.11-.7V2h5v7h-4.59l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L13.41 11H18v7h-5v-2.18c-.42-.15-.8-.39-1.11-.7l-.01.01-.88-.89V19c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "merge-links": ["M10 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8-5c-.93 0-1.71.64-1.93 1.5H14V4c0-2.21-1.79-4-4-4S6 1.79 6 4v5.5H3.93C3.71 8.64 2.93 8 2 8c-1.1 0-2 .9-2 2s.9 2 2 2c.93 0 1.71-.64 1.93-1.5H6V16c0 2.21 1.79 4 4 4s4-1.79 4-4v-5.5h2.07c.22.86 1 1.5 1.93 1.5 1.1 0 2-.9 2-2s-.9-2-2-2zm-5 8c0 1.66-1.34 3-3 3s-3-1.34-3-3V4c0-1.66 1.34-3 3-3s3 1.34 3 3v12zM10 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "minimize": ["M8 11H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zM20 1a1.003 1.003 0 00-1.71-.71L13 5.59V3c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-2.59l5.29-5.29c.19-.18.3-.43.3-.71z"],
    "minus": ["M16 9H4c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "mobile-phone": ["M15 0H5c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4-3H6V3h8v13z"],
    "mobile-video": ["M19 5c-.28 0-.53.11-.71.29L15 8.59V5c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-3.59l3.29 3.29c.18.19.43.3.71.3.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"],
    "modal": ["M19 1a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h18zm-1 4H2v12h16V5zm-3-3h-2v2h2V2zm3 0h-2v2h2V2z"],
    "modal-filled": ["M20 5v13a1 1 0 01-1 1H1a1 1 0 01-1-1V5h20zm-3-4h2a1 1 0 011 1v1h-3V1zm-2 2H0V2a1 1 0 011-1h14v2z"],
    "moon": ["M19 14.15A9.94 9.94 0 019.94 20C4.45 20 0 15.55 0 10.06 0 6.03 2.4 2.56 5.85 1a9.811 9.811 0 00-.88 4.09c0 5.49 4.45 9.94 9.94 9.94 1.46 0 2.84-.31 4.09-.88z"],
    "more": ["M3.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM17.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5zM10.5 8a2.5 2.5 0 100 5 2.5 2.5 0 100-5z"],
    "mountain": ["M20 16H4l7-11h1l2 2h1l5 9zm-4-5l-1.5-3h-1l-1-1-1-1L8 11.5l3-1.5 1 1 1-1 3 1zM8.055 8L2.79 16H0l7-8h1.055z"],
    "move": ["M19.71 9.29l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 9H11V3.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3C10.53.11 10.28 0 10 0s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L9 3.41V9H3.41L4.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 11H9v5.59L7.71 15.3A.965.965 0 007 15a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3a1.003 1.003 0 00-1.42-1.42L11 16.59V11h5.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"],
    "mugshot": ["M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18h-.07c-.05-.2-.12-.42-.22-.67-.46-1.05-2.68-1.75-4.16-2.4-1.48-.65-1.28-1.05-1.33-1.59-.01-.07-.01-.15-.01-.23.51-.45.92-1.07 1.19-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.34-.07.54-.44.61-.78.08-.14.23-.48.2-.87-.05-.5-.25-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5a3.67 3.67 0 00-1.29-1.86C11.7 3.25 10.81 3 10.02 3s-1.68.25-2.31.73c-.61.47-1.07 1.13-1.29 1.86-.05.16-.09.33-.11.5-.12.6-.17 1.51-.17 2.14v.08c-.24.09-.44.32-.49.83-.04.39.12.73.2.87.08.35.28.72.63.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.7 1.35 1.22 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.38 1.59-1.48.65-3.7 1.35-4.16 2.4-.12.27-.18.49-.23.69H2V2h16v16z"],
    "multi-select": ["M19 3H7c-.55 0-1 .45-1 1v1h12v6h1c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-6 6H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H2v-4h10v4zm4-9H4c-.55 0-1 .45-1 1v1h12v6h1c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"],
    "music": ["M19 0c-.08 0-.16.03-.24.05V.03l-12 3v.02C6.33 3.16 6 3.53 6 4v11.35c-.59-.22-1.27-.35-2-.35-2.21 0-4 1.12-4 2.5S1.79 20 4 20c1.94 0 3.55-.86 3.92-2H8V7.78l10-2.5v7.07c-.59-.22-1.27-.35-2-.35-2.21 0-4 1.12-4 2.5s1.79 2.5 4 2.5c1.94 0 3.55-.86 3.92-2H20V1c0-.55-.45-1-1-1z"],
    "nest": ["M2 2c.55 0 1 .45 1 1v5c0 2.21 1.79 4 4 4h8.59L13.3 9.71A.965.965 0 0113 9a1.003 1.003 0 011.71-.71l4 4c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-4 4a1.003 1.003 0 01-1.42-1.42l2.3-2.29H7c-3.31 0-6-2.69-6-6V3c0-.55.45-1 1-1z"],
    "new-drawing": ["M18.7 13.7c.5 0 1 .4 1 1 0 .257-.073.44-.22.614l-.08.086-4 4c-.2.2-.4.3-.7.3-.6 0-1-.5-1-1 0-.257.073-.44.22-.614L14 18l4-4c.2-.2.4-.3.7-.3zM1.8 0l8.378 2.982A3.003 3.003 0 0013 7a3.003 3.003 0 003.877 2.87l.723 2.53.049.06a.41.41 0 01.051.24c0 .167-.07.403-.208.593l-.092.107-4 4c-.2.2-.4.3-.7.3-.075 0-.15-.056-.225-.084L12.4 17.6l-7-2-.112-.042c-.223-.094-.431-.244-.542-.45L4.7 15 0 1.8l.5-.6L7 7.7c-.2.3-.3.6-.3 1 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2a1.68 1.68 0 00-.871.22L7.7 7 1.2.5l.6-.5zM16 0c.55 0 1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .432-.278.803-.664.941l-.01.004A.989.989 0 0116 8c-.55 0-1-.45-1-1V5h-2c-.55 0-1-.45-1-1l.007-.116C12.065 3.388 12.489 3 13 3h2V1c0-.55.45-1 1-1z"],
    "new-grid-item": ["M8 0H1C.45 0 0 .45 0 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm0 11H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1zm6 7h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm5-7h-2c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zm0-11h-7c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-5 11h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1zm5 5c-.55 0-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"],
    "new-layer": ["M11.513 2.663A2 2 0 0013 6h1v1a2 2 0 104 0v-.733l1.5.833c.3.2.5.5.5.9s-.2.7-.5.9l-9 5c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5C.2 8.7 0 8.4 0 8s.2-.7.5-.9l9-5c.2-.1.3-.1.5-.1s.3 0 .5.1l1.013.563zM17 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1a1 1 0 012 0v2z"],
    "new-layers": ["M17 3h2a1 1 0 010 2h-2v2a1 1 0 01-2 0V5h-2a1 1 0 010-2h2V1a1 1 0 012 0v2zm-1.252 5.984L10.5 11.9c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5C.2 6.7 0 6.4 0 6s.2-.7.5-.9l9-5c.2-.1.3-.1.5-.1s.3 0 .5.1L13.92 2H13a2 2 0 100 4h1v1a2 2 0 001.748 1.984zm2.07-1.15C17.935 7.58 18 7.298 18 7V6h1c.353 0 .684-.091.972-.251.018.078.028.162.028.251 0 .4-.2.7-.5.9l-1.682.934zM19 9c.6 0 1 .4 1 1 0 .4-.2.7-.5.9l-9 5c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5c-.3-.2-.5-.5-.5-.9 0-.6.4-1 1-1 .2 0 .3 0 .5.1l8.5 4.8 8.5-4.8c.2-.1.3-.1.5-.1zm0 4c.6 0 1 .4 1 1 0 .4-.2.7-.5.9l-9 5c-.2.1-.3.1-.5.1s-.3 0-.5-.1l-9-5c-.3-.2-.5-.5-.5-.9 0-.6.4-1 1-1 .2 0 .3 0 .5.2l8.5 4.7 8.5-4.8c.2-.1.3-.1.5-.1z"],
    "new-link": ["M14.5 12a2.5 2.5 0 00-2.45 2h-7.1a2.5 2.5 0 100 1h7.1a2.5 2.5 0 102.45-3zM19 5h-2V3c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "new-object": ["M12 4c0 .6.4 1 1 1h2v2c0 .6.4 1 1 1 .5 0 1-.4 1-1V5h2c.5 0 1-.4 1-1s-.5-1-1-1h-2V1c0-.6-.5-1-1-1-.6 0-1 .4-1 1v2h-2c-.6 0-1 .5-1 1zm7 3c0 1.7-1.3 3-3 3s-3-1.3-3-3c-1.7 0-3-1.3-3-3s1.3-3 3-3c0-.2 0-.4.1-.5-1-.3-2-.5-3.1-.5C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10c0-1.1-.2-2.1-.5-3H19z"],
    "new-person": ["M11.41 15.92c-1.46-.65-1.26-1.05-1.31-1.59-.01-.07-.01-.15-.01-.23.5-.45.91-1.07 1.18-1.78 0 0 .01-.04.02-.05.06-.15.11-.32.15-.48.33-.07.53-.44.6-.78.08-.14.23-.48.2-.87-.05-.5-.24-.73-.47-.82v-.09c0-.63-.06-1.55-.17-2.15-.02-.17-.06-.33-.11-.5-.22-.73-.67-1.4-1.27-1.86C9.58 4.25 8.7 4 7.92 4c-.78 0-1.66.25-2.28.73-.61.47-1.06 1.13-1.27 1.86-.05.16-.08.33-.11.5-.12.6-.18 1.51-.18 2.14v.08c-.23.09-.43.32-.48.83-.04.39.12.73.2.87.08.35.28.72.62.78.04.17.09.33.15.48 0 .01.01.02.01.03l.01.01c.27.72.69 1.35 1.21 1.8 0 .07-.01.14-.01.21-.05.54.1.94-1.36 1.59-1.46.65-3.66 1.35-4.11 2.4C-.14 19.38.04 20 .04 20h15.75s.18-.62-.27-1.67c-.45-1.06-2.65-1.75-4.11-2.41zM18.87 3h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "new-prescription": ["M11.95 10.23c.16-.18.22-.22.46-.22h1.48c.25 0 .47.08.59.33.1.2.09.41-.05.66l-2.71 3.58L14.88 19c.13.21.16.46.03.69-.12.21-.34.31-.57.31H12.7c-.31 0-.56-.17-.7-.44l-1.9-2.67-1.93 2.68c-.15.27-.42.43-.73.43H5.98c-.25 0-.47-.08-.59-.33-.1-.2-.09-.41.05-.66l3.09-4.35L4.26 9H3v4.32c0 .41-.3.69-.7.69H.7c-.41 0-.7-.28-.7-.69V.69C0 .28.3 0 .7 0h4.42c.71 0 1.36.1 1.94.3.59.2 1.11.49 1.54.87.44.38.78.84 1.02 1.39.25.54.37 1.13.37 1.77 0 1.01-.28 1.88-.84 2.6-.43.54-1.35 1.29-2 1.59l3.09 3.94 1.71-2.23zM4.71 6.04c.71 0 1.45-.16 1.81-.46.33-.28.5-.69.5-1.25s-.17-.97-.5-1.25c-.35-.3-1.1-.46-1.81-.46h-1.7v3.42h1.7zM19 3c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1V5h-2c-.55 0-1-.45-1-1s.45-1 1-1h2V1c0-.55.45-1 1-1s1 .45 1 1v2h2z"],
    "new-text-box": ["M19 3h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1zM5 7.5v1c0 .28.22.5.5.5s.5-.22.5-.5V8h2v7h-.5c-.28 0-.5.22-.5.5s.22.5.5.5h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H9V8h2v.5c0 .28.22.5.5.5s.5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-6c-.28 0-.5.22-.5.5zM16 9c-.55 0-1 .45-1 1v8H2V5h8c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z"],
    "ninja": ["M20 6s-2.98 2.43-6.12 2.19C13.52 5.31 12.05 0 6 0c0 0 2.41 2.99 2.16 6.12C5.27 6.49 0 7.97 0 14c0 0 2.98-2.43 6.11-2.19C6.47 14.69 7.94 20 14 20c0 0-2.42-2.99-2.16-6.13C14.73 13.51 20 12.02 20 6zm-10 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"],
    "not-equal-to": ["M9.487 7l.532-3.196a1 1 0 011.962.392L11.513 7H16a1 1 0 010 2h-4.82l-.333 2H16a1 1 0 010 2h-5.487l-.532 3.196a1 1 0 01-1.962-.392L8.487 13H4a1 1 0 010-2h4.82l.333-2H4a1 1 0 110-2h5.487z"],
    "notifications": ["M10 20c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2zm7-5c-.55 0-1-.45-1-1V8c0-2.61-1.67-4.81-4-5.63V2c0-1.1-.9-2-2-2S8 .9 8 2v.37C5.67 3.19 4 5.39 4 8v6c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "notifications-snooze": ["M10 18c0 1.1-.9 2-2 2s-2-.9-2-2zM8 0c.476 0 .914.168 1.258.448C8.508.878 8.09 1.562 8 2.5c-.133 1.4.4 2.367 1.6 2.9C8.533 6.6 8 7.467 8 8v1.2a2.8 2.8 0 002.8 2.8H14v2c0 .51.388.935.884.993L15 15c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V8c0-2.61 1.67-4.81 4-5.63V2c0-1.1.9-2 2-2z",
        "M16 9.25v-.395a.75.75 0 00-.75-.75h-2.813L15.834 3.9A.75.75 0 0016 3.43v-.68a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75v.184c0 .414.336.75.75.75h2.813L10.22 7.831a1 1 0 00-.221.627v.792c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75z"],
    "notifications-updated": ["M10 20c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2zm2-17.834A2.994 2.994 0 008 4.99c0 .808.319 1.557.876 2.114l2.97 2.99a2.99 2.99 0 004.154.072V14c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V8c0-2.61 1.67-4.81 4-5.63V2c0-1.1.9-2 2-2s2 .9 2 2v.166zm1.26 6.514l-2.97-2.99a.973.973 0 01-.29-.7c0-.55.44-1 .99-1 .27 0 .52.11.7.29l2.28 2.28 4.27-4.27a.99.99 0 01.7-.29c.55 0 1 .45 1 1 0 .28-.11.53-.3.7l-4.98 4.98a.99.99 0 01-1.4 0z"],
    "numbered-list": ["M1.74 9.01h1.27V1h-.95c-.04.24-.12.45-.26.62-.13.17-.29.3-.47.41-.19.11-.4.18-.63.23-.23.04-.46.07-.71.07v1.03h1.75v5.65zm.43 7.93c.18-.14.37-.28.58-.43.21-.14.42-.29.63-.45.21-.16.41-.33.61-.5.2-.18.37-.38.52-.59.15-.21.28-.45.37-.7.09-.25.14-.54.14-.85 0-.25-.04-.52-.12-.8-.08-.28-.21-.54-.39-.78-.19-.24-.43-.44-.73-.59-.3-.17-.68-.25-1.12-.25-.41 0-.77.08-1.08.23-.32.16-.58.37-.8.64-.22.27-.38.59-.49.96-.11.37-.16.77-.16 1.21h1.19c.01-.28.03-.53.08-.77s.12-.45.21-.62c.09-.18.22-.31.38-.42.16-.1.35-.15.59-.15.26 0 .47.05.63.14.16.09.29.21.38.35.09.14.15.29.18.45.03.16.05.31.05.45-.01.31-.08.58-.22.81-.14.24-.32.45-.53.66-.22.2-.45.39-.71.57-.26.18-.51.36-.74.54-.5.36-.89.78-1.17 1.27-.3.47-.45 1.04-.46 1.69H5v-1.14H1.43c.05-.17.14-.33.27-.49.13-.15.29-.3.47-.44zM18 4.02H8c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-.56-.45-1-1-1zm0 9H8c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-.56-.45-1-1-1z"],
    "numerical": ["M2.39 5.75c-.17.21-.38.39-.63.52s-.52.23-.83.29c-.3.05-.61.08-.93.08v1.24h2.49V15h1.49V4.98H2.73c-.05.31-.17.57-.34.77zm17.2 4.71c-.27-.44-.65-.71-1.14-.82v-.02c.42-.16.72-.43.92-.79.2-.36.29-.79.29-1.27 0-.42-.08-.8-.23-1.12-.15-.33-.36-.59-.62-.8-.26-.21-.55-.37-.87-.48-.32-.11-.65-.16-.98-.16-.43 0-.82.08-1.16.25-.34.16-.63.39-.87.69-.24.29-.43.64-.57 1.04-.14.4-.22.83-.23 1.3h1.39c-.01-.25.02-.49.07-.72.06-.23.14-.44.26-.63s.27-.34.45-.45c.18-.11.39-.17.63-.17.39 0 .71.12.96.37s.37.58.37.99c0 .29-.05.54-.16.74-.11.2-.25.36-.43.47-.18.11-.38.19-.61.24-.23.05-.46.06-.68.05v1.17c.28-.01.55 0 .81.03s.5.1.71.21c.21.11.38.28.51.5.13.22.2.52.2.89 0 .55-.16.97-.47 1.27-.31.3-.7.45-1.17.45-.55 0-.95-.19-1.23-.58-.27-.39-.4-.88-.38-1.46h-1.39c.01.5.08.96.21 1.38.13.41.32.77.57 1.06.25.29.56.52.93.68.37.16.8.24 1.3.24.41 0 .79-.07 1.16-.21.37-.14.69-.33.96-.58.28-.25.5-.56.66-.92a3 3 0 00.24-1.23c0-.64-.14-1.17-.41-1.61zM8.58 12.41c.21-.18.45-.36.7-.53.25-.18.5-.36.75-.56.25-.2.49-.41.73-.63.23-.22.44-.47.63-.74.18-.27.33-.56.44-.88.11-.32.16-.67.16-1.07 0-.32-.05-.65-.14-1-.09-.35-.25-.68-.47-.97-.22-.3-.51-.55-.87-.74-.36-.2-.81-.29-1.35-.29-.49 0-.93.1-1.3.29-.37.18-.69.44-.95.78-.26.33-.45.73-.58 1.2-.13.46-.2.96-.2 1.5h1.43c.01-.35.04-.67.09-.97.05-.3.14-.56.25-.78.11-.22.26-.39.45-.52s.43-.19.71-.19c.31 0 .56.06.75.18.19.12.34.26.45.43.11.17.18.36.22.56.04.2.06.39.06.57-.01.38-.1.72-.26 1.02-.15.3-.37.57-.63.83-.26.25-.54.49-.85.71-.31.22-.61.45-.89.68-.6.45-1.06.98-1.41 1.58-.35.61-.52 1.32-.53 2.13h6.01v-1.43H7.69c.06-.21.17-.42.33-.61s.34-.38.56-.55z"],
    "office": ["M19 6h-5V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h4v-6h4v6h10c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zM6 12H2V8h4v4zm0-6H2V2h4v4zm6 6H8V8h4v4zm0-6H8V2h4v4zm6 11h-4v-3h4v3zm0-5h-4V8h4v4z"],
    "offline": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM7 18l2-7H5l8-9-2 7h4l-8 9z"],
    "oil-field": ["M19 17.99h-1.36l-4.35-9.57 2.91-.86 1.66 4.1c.11.27.43.4.72.31.12-.04.22-.11.28-.2.06-.11 1.47-2.08 1.05-5.6C19.79 5.12 19.3 0 16.01 0 14.89.01 13.99.83 14 1.84c0 .19.04.38.1.56l1.34 3.31L.72 10.03v.02c-.41.12-.72.49-.72.94 0 .55.45 1 1 1 .1 0 .19-.03.28-.06v.02l2-.59 1.47 6.63H3c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM5.2 10.8l3.95-1.16-2.83 6.22L5.2 10.8zm2.35 7.19l3.95-8.68 3.95 8.68h-7.9z"],
    "one-column": ["M14.94 0h-4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-8 6c-.28 0-.53.11-.71.29l-3 3c-.18.18-.29.43-.29.71s.11.53.29.71l3 3A1.003 1.003 0 007.94 13V7c0-.55-.45-1-1-1z"],
    "one-to-many": ["M18 3a1 1 0 11-2 0 1 1 0 012 0zm-3.82 1.028a6.243 6.243 0 00-1.667.347c-.947.352-1.773 1-2.032 2.318C10.158 8.337 9.247 9.368 8.217 10c1.03.632 1.941 1.663 2.264 3.307.259 1.318 1.085 1.966 2.032 2.318.581.217 1.18.308 1.668.347a3.001 3.001 0 11-.019 2.004c-.633-.042-1.491-.158-2.347-.476-1.402-.523-2.868-1.625-3.296-3.807-.259-1.318-1.085-1.966-2.032-2.318a5.314 5.314 0 00-.722-.21 3 3 0 110-2.33c.238-.052.481-.12.722-.21.947-.352 1.773-1 2.032-2.318.428-2.182 1.894-3.284 3.296-3.807.856-.318 1.714-.434 2.347-.476A3.001 3.001 0 0120 3a3 3 0 01-5.82 1.028zM4 10a1 1 0 100 .002v-.002zM17 18a1 1 0 100-2 1 1 0 000 2z"],
    "one-to-one": ["M2 10a1 1 0 112 0 1 1 0 01-2 0zm3.83-1a3.001 3.001 0 100 2h8.34a3.001 3.001 0 100-2H5.83zM17 9a1 1 0 100 2 1 1 0 000-2z"],
    "outdated": ["M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10c0-.55.45-1 1-1s1 .45 1 1c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8C7.47 2 5.22 3.17 3.76 5H5c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v2.05C3.82 1.6 6.71 0 10 0zm1 16H9v-2h2v2zm0-3H9V4h2v9z"],
    "page-layout": ["M19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM7 17H2V8h5v9zm11 0H8V8h10v9zm0-10H2V3h16v4z"],
    "panel-stats": ["M1 1h18a1 1 0 011 1v15a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1zm1 2v13h16V3H2zm9 0h1v13h-1V3zm2 7h3.952v1H13v-1zm0 2h3.952v1H13v-1zm0 2h3.952v1H13v-1zm0-6h3.952v1H13V8zm0-2h3.952v1H13V6zm0-2h3.952v1H13V4z"],
    "panel-table": ["M19 1H1c-.6 0-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-9 11H7V9h3v3zm0-4H7V5h3v3zm-8 8V3h4v13H2zm5 0v-3h3v3H7zm11 0h-7v-3h7v3zm0-4h-7V9h7v3zm0-4h-7V5h7v3z"],
    "paperclip": ["M18.35 2.67A5.664 5.664 0 0014.33 1c-1.44 0-2.89.56-3.99 1.67l-9.16 9.27C.4 12.73 0 13.78 0 14.83s.39 2.1 1.18 2.9c.78.79 1.82 1.18 2.85 1.18 1.04 0 2.07-.39 2.87-1.2l9.14-9.27c.96-.96.96-2.5.02-3.45-.94-.95-2.49-.96-3.44 0l-7.59 7.69c-.31.32-.3.83.01 1.14.31.31.81.31 1.13.02l7.59-7.69c.31-.31.84-.31 1.13-.02.31.31.31.85 0 1.16l-9.14 9.27c-.93.95-2.54.93-3.45.02-.94-.95-.92-2.55.02-3.49l9.16-9.25c1.55-1.56 4.18-1.59 5.72-.03 1.56 1.57 1.55 4.26 0 5.82l-8.89 9.02c-.3.31-.3.81.01 1.11.3.3.79.31 1.1.01v.01l8.91-9.02A5.645 5.645 0 0020 6.73c0-1.48-.55-2.94-1.65-4.06z"],
    "paragraph": ["M16.5 1H7C4.2 1 2 3.2 2 6s2.2 5 5 5v6.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V4h2v13.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V4h1.5c.8 0 1.5-.7 1.5-1.5S17.3 1 16.5 1z"],
    "path": ["M18 0H2C.9 0 0 .9 0 2s.9 2 2 2h7v4H4c-1.1 0-2 .9-2 2s.9 2 2 2h5v4H6c-1.1 0-2 .9-2 2s.9 2 2 2h8c1.1 0 2-.9 2-2s-.9-2-2-2h-3v-4h5c1.1 0 2-.9 2-2s-.9-2-2-2h-5V4h7c1.1 0 2-.9 2-2s-.9-2-2-2z"],
    "path-search": ["M4 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 11.69l-5-2.5v-3.63c-.32.11-.66.22-1 .29v3.32l-6 2.57v-7.25c-.36-.27-.69-.57-1-.9v8.1l-5-2.5V10c.55 0 1-.45 1-1s-.45-1-1-1V1.31l3.43 1.71c.11-.31.24-.62.39-.92L.72.05A.545.545 0 00.5 0C.22 0 0 .22 0 .5v16c0 .2.12.36.28.44l6 3c.07.04.14.06.22.06.07 0 .14-.01.2-.04l6.79-2.91 5.79 2.9c.07.03.14.05.22.05.28 0 .5-.22.5-.5v-4.21c-.31.13-.64.21-1 .21v3.19zM10 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6.72-.94l-1.43-.72c.2.43.36.89.48 1.36l.23.11V5.5c-.55 0-1 .45-1 1s.45 1 1 1v1.96l1 1V3.5c0-.2-.12-.36-.28-.44zm-3.69 5.56c.14-.21.27-.42.38-.65.02-.04.04-.07.05-.11.11-.22.2-.45.28-.69v-.01c.07-.24.13-.48.17-.73l.03-.17c.04-.25.06-.5.06-.76C17 2.46 14.54 0 11.5 0S6 2.46 6 5.5 8.46 11 11.5 11c.26 0 .51-.02.76-.06l.17-.03c.25-.04.49-.1.73-.17h.01c.24-.08.47-.17.69-.28.04-.02.07-.03.11-.05.23-.11.44-.24.65-.38l.18.18 3.5 3.5c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71l-3.68-3.67zm-4.53.88c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"],
    "pause": ["M7 3H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm9 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "people": ["M16.94 17a4.92 4.92 0 00-.33-1.06c-.45-.97-1.37-1.52-3.24-2.3-.17-.07-.76-.31-.77-.32-.1-.04-.2-.08-.28-.12.05-.14.04-.29.06-.45 0-.05.01-.11.01-.16-.25-.21-.47-.48-.65-.79.22-.34.41-.71.56-1.12l.04-.11c-.01.02-.01.02-.02.08l.06-.15c.36-.26.6-.67.72-1.13.18-.37.29-.82.25-1.3-.05-.5-.21-.92-.47-1.22-.02-.53-.06-1.11-.12-1.59.38-.17.83-.26 1.24-.26.59 0 1.26.19 1.73.55.46.35.8.85.97 1.4.04.13.07.25.08.38.08.45.13 1.14.13 1.61v.07c.16.07.31.24.35.62.02.29-.09.55-.15.65-.05.26-.2.53-.46.59-.03.12-.07.25-.11.36-.01.01-.01.04-.01.04-.2.53-.51 1-.89 1.34 0 .06 0 .12.01.17.04.41-.11.71 1 1.19 1.1.5 2.77 1.01 3.13 1.79.34.79.2 1.25.2 1.25h-3.04zm-5.42-3.06c1.47.66 3.7 1.35 4.18 2.39.45 1.05.27 1.67.27 1.67H.04s-.19-.62.27-1.67c.46-1.05 2.68-1.75 4.16-2.4 1.48-.65 1.33-1.05 1.38-1.59 0-.07.01-.14.01-.21-.52-.45-.95-1.08-1.22-1.8l-.01-.01c0-.01-.01-.02-.01-.03-.07-.15-.12-.32-.16-.49-.34-.06-.54-.43-.62-.78-.08-.14-.24-.48-.2-.87.05-.51.26-.74.49-.83v-.08c0-.64.05-1.55.17-2.15a3.648 3.648 0 011.4-2.36C6.32 2.25 7.21 2 8 2s1.68.25 2.31.73a3.63 3.63 0 011.4 2.36c.11.6.17 1.52.17 2.15v.09c.22.09.42.32.47.82.03.39-.12.73-.2.87-.07.34-.27.71-.61.78-.04.16-.09.33-.15.48-.01.01-.02.05-.02.05-.27.71-.68 1.33-1.19 1.78 0 .08 0 .16.01.23.05.55-.15.95 1.33 1.6z"],
    "percentage": ["M15 10c-1.66 0-3 1.34-3 3v2c0 1.66 1.34 3 3 3s3-1.34 3-3v-2c0-1.66-1.34-3-3-3zm1 5c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2zM8 7V5c0-1.66-1.34-3-3-3S2 3.34 2 5v2c0 1.66 1.34 3 3 3s3-1.34 3-3zM4 7V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm11-4a1.003 1.003 0 00-1.88-.48L5.14 16.49a1.003 1.003 0 101.74.99l7.99-13.97c.08-.15.13-.32.13-.51z"],
    "person": ["M19.61 17.91c-.57-1.32-3.35-2.19-5.19-3.01-1.85-.82-1.59-1.31-1.66-1.99-.01-.09-.01-.19-.02-.29.63-.56 1.15-1.33 1.49-2.22 0 0 .02-.05.02-.06.07-.19.13-.39.19-.6.42-.09.67-.55.76-.98.1-.17.29-.6.25-1.08-.06-.62-.31-.91-.59-1.03v-.11c0-.79-.07-1.93-.22-2.68A4.55 4.55 0 0012.9.92C12.11.32 11 0 10.01 0s-2.1.32-2.89.92a4.55 4.55 0 00-1.74 2.94c-.14.75-.22 1.89-.22 2.68v.1c-.29.11-.55.4-.61 1.04-.04.48.15.91.25 1.08.1.44.35.91.79.98.05.21.12.41.19.6 0 .01.01.03.01.04l.01.02c.34.91.87 1.69 1.52 2.25 0 .09-.01.18-.02.26-.07.68.13 1.17-1.72 1.99S.96 16.59.39 17.91C-.18 19.23.05 20 .05 20h19.9s.23-.77-.34-2.09z"],
    "phone": ["M19.91 15.51c-.08-.08-4.21-2.5-4.35-2.57a.876.876 0 00-.4-.1c-.19 0-.42.13-.71.4-.28.27-1.17 1.49-1.43 1.76s-.48.4-.65.4c-.08 0-.19-.02-.32-.07s-1.45-.73-4.2-3.15-3.11-4-3.13-4.44c0-.17.13-.39.4-.65.28-.25.57-.51.89-.74.32-.24.61-.5.88-.78s.4-.52.4-.71c0-.13-.03-.27-.1-.4C7.12 4.32 4.62.19 4.53.1c-.19-.18-.92-.1-1.29.1C.25 1.82 0 4 .05 4.86c.05.89.61 5.58 5.2 9.93 5.7 5.41 9.66 5.2 9.92 5.2.87 0 3.52-.48 4.65-3.19.16-.38.31-1.07.09-1.29z"],
    "pie-chart": ["M9 .98c-4.5.5-8 4.31-8 8.94 0 4.97 4.03 9.04 9 9.04 4.63 0 8.44-3.96 8.94-7.96H9V.98z",
        "M10-.08V10h10C20 4 15.52-.08 10-.08z"],
    "pin": ["M11.77 1.16c-.81.81-.74 2.28.02 3.76L6.1 8.71c-2.17-1.46-4.12-2-4.94-1.18l4.95 4.95-4.95 6.36 6.36-4.95 4.95 4.95c.82-.82.27-2.77-1.19-4.94l3.8-5.69c1.47.76 2.94.84 3.76.02l-7.07-7.07z"],
    "pivot": ["M5.83 9.75L.29 15.29a1.003 1.003 0 001.42 1.42l5.54-5.54c-.57-.37-1.05-.85-1.42-1.42zM19 11c-.55 0-1 .45-1 1v1.59l-3.83-3.83c-.37.56-.85 1.04-1.41 1.41L16.59 15H15c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-5-4c0-2.21-1.79-4-4-4S6 4.79 6 7s1.79 4 4 4 4-1.79 4-4zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"],
    "pivot-table": ["M3 5H1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm0-5H1C.45 0 0 .45 0 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm13.71 5.29C16.53 5.11 16.28 5 16 5s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L15 8.41V11c0 2.21-1.79 4-4 4H8.41l1.29-1.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L8.41 17H11c3.31 0 6-2.69 6-6V8.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zM19 0H6c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "play": ["M16 10c0-.36-.2-.67-.49-.84l.01-.01-10-6-.01.01A.991.991 0 005 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .19 0 .36-.07.51-.16l.01.01 10-6-.01-.01c.29-.17.49-.48.49-.84z"],
    "plus": ["M16 9h-5V4c0-.55-.45-1-1-1s-1 .45-1 1v5H4c-.55 0-1 .45-1 1s.45 1 1 1h5v5c0 .55.45 1 1 1s1-.45 1-1v-5h5c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "polygon-filter": ["M18 7c-.27 0-.52.05-.75.15l-6.28-4.88c.01-.09.03-.18.03-.27 0-1.1-.9-2-2-2S7 .9 7 2c0 .06.01.12.02.19l-4.19 3C2.57 5.07 2.29 5 2 5 .9 5 0 5.9 0 7c0 .74.4 1.38 1 1.72v7.55c-.6.35-1 .99-1 1.73 0 1.1.9 2 2 2 .74 0 1.38-.4 1.72-1h7.55c.35.6.98 1 1.72 1 1.1 0 2-.9 2-2 0-.37-.11-.72-.29-1.02L18.03 11A2 2 0 0018 7zm-5.03 9c-.72.01-1.35.41-1.69 1H3.72c-.17-.3-.42-.55-.72-.72V8.72c.6-.34 1-.98 1-1.72 0-.06-.01-.12-.02-.19l4.19-3c.26.12.54.19.83.19.27 0 .52-.05.75-.15l6.28 4.88c-.01.09-.03.18-.03.27 0 .37.11.72.29 1.02L12.97 16z"],
    "power": ["M10 10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S9 .45 9 1v8c0 .55.45 1 1 1zm3-7.45v2.16c2.36 1.12 4 3.5 4 6.29 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.79 1.64-5.17 4-6.29V2.55C3.51 3.79 1 7.09 1 11a9 9 0 0018 0c0-3.91-2.51-7.21-6-8.45z"],
    "predictive-analysis": ["M20 8.01c0-1.26-.61-2.43-1.61-3.12C17.86 2.5 15.8.79 13.4.79c-.58 0-1.14.1-1.69.29A3.533 3.533 0 009.17 0C8.05 0 7 .55 6.32 1.45c-.15-.02-.3-.03-.45-.03-1.63 0-3.03 1.12-3.46 2.71C.97 4.65 0 6.05 0 7.66c0 .48.09.95.26 1.4-.17.44-.26.91-.26 1.39 0 1.38.72 2.64 1.89 3.29.67.7 1.59 1.09 2.54 1.09.61 0 1.19-.15 1.71-.45.68.82 1.68 1.3 2.73 1.3.66 0 1.28-.18 1.83-.52.61.49 1.34.81 2.11.91 1.3 1.43 2.3 3.28 2.31 3.3 0 0 .35.61.33.61.96-.01 1.77-.2 1.64-1.3.01.02-.92-2.89-.92-2.89.52-.26.94-.69 1.21-1.23 1.12-.66 1.84-1.91 1.84-3.26 0-.3-.03-.6-.1-.89.57-.64.88-1.51.88-2.4zm-1.54 1.28l-.18-.2-.77-.84c-.33-.37-.67-1.17-.73-1.73 0 0-.13-1.25-.13-1.26-.06-.74-1.17-.73-1.13.14 0 .02.13 1.26.13 1.26.04.36.15.77.3 1.17-.08-.01-.15-.02-.22-.02 0 0-2.57-.12-2.57-.13-.73-.03-.89 1.22-.05 1.25l2.57.13c.53.03 1.29.37 1.61.72l.61.67.02.06c.1.27.14.55.14.83 0 .93-.51 1.77-1.34 2.18l-.2.1-.09.23c-.19.48-.6.82-1.1.93l-.67.14.87 2.75c-.48-.76-1.19-1.79-2.02-2.67l-.15-.16-.21-.02c-.51-.04-.99-.21-1.42-.48l1.7-1.48c.44-.39 1.04-.55 1.24-.49 0 0 .78.22.78.23.78.2 1.03-.92.29-1.21l-.78-.23c-.69-.2-1.67.22-2.24.72l-1.91 1.66-.39.32c-.44.36-.93.55-1.5.55-.8 0-1.54-.41-1.97-1.07v-1.88c0-.5.21-.98.34-1.07 0 0 .65-.43.64-.43.87-.69.21-1.57-.64-1.14 0-.01-.65.43-.65.43-.31.2-.54.56-.7.97-.13-.13-.28-.25-.43-.35 0 0-1.91-1.26-1.91-1.28-.81-.56-1.5.63-.61 1.11 0-.02 1.89 1.28 1.89 1.28.46.31.77.97.77 1.36v.84c-.43.24-.78.36-1.24.36-.67 0-1.31-.29-1.77-.79l-.07-.08-.09-.05a2.425 2.425 0 01-1.31-2.16c0-.38.09-.74.25-1.08l.15-.31-.14-.33c-.17-.34-.25-.7-.25-1.08 0-1.13.76-2.1 1.85-2.37l.39-.09.07-.43a2.41 2.41 0 012.39-2.05c.19 0 .39.02.58.07l.4.1.22-.38A2.41 2.41 0 019.17 1.3c.55 0 1.08.19 1.5.53l-.44.45-.01-.01-.31.31c-.41.35-.92.53-1.11.5 0 0-.84-.13-.84-.14-.83-.15-1.09 1.08-.18 1.29.01 0 .84.14.84.14.03 0 .06 0 .09.01-.14.46-.18.96-.12 1.4 0 0 .21 1.24.19 1.23.13.65 1.32.44 1.16-.22 0-.01-.19-1.23-.19-1.23-.07-.48.15-1.19.45-1.5l.48-.5c.07-.06.13-.12.19-.18l.93-.95c.5-.23 1.04-.34 1.59-.34 1.93 0 3.57 1.4 3.89 3.34l.05.31.26.15a2.445 2.445 0 01.87 3.4z"],
    "prescription": ["M13.95 10.23c.16-.18.22-.22.46-.22h1.48c.25 0 .47.08.59.33.1.2.09.41-.05.66l-2.71 3.58L16.88 19c.13.21.16.46.03.69-.12.21-.34.31-.57.31H14.7c-.31 0-.56-.17-.7-.44l-1.9-2.67-1.93 2.68c-.15.27-.42.43-.73.43H7.98c-.25 0-.47-.08-.59-.33-.1-.2-.09-.41.05-.66l3.09-4.35L6.26 9H5v4.32c0 .41-.3.69-.7.69H2.7c-.41 0-.7-.28-.7-.69V.69c0-.41.3-.69.7-.69h4.42c.71 0 1.36.1 1.94.3.59.2 1.11.49 1.54.87.44.38.78.84 1.02 1.39.24.54.36 1.14.36 1.78 0 1.01-.28 1.88-.84 2.6-.43.54-1.35 1.29-2 1.59l3.09 3.94 1.72-2.24zM6.71 6.04c.71 0 1.45-.16 1.81-.46.33-.28.5-.69.5-1.25s-.17-.97-.5-1.25c-.35-.3-1.1-.46-1.81-.46h-1.7v3.42h1.7z"],
    "presentation": ["M19 1h-8c0-.55-.45-1-1-1S9 .45 9 1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 .55.45 1 1 1h4.59L4.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L9 16.41V19c0 .55.45 1 1 1s1-.45 1-1v-2.59l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L12.41 15H17c.55 0 1-.45 1-1V3h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3 12H4V3h12v10z"],
    "print": ["M14 16H6v-4H4v5c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-5h-2v4zm2-13c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1h12V3zm3 2H1c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h2v-3h14v3h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 4h-2V7h2v2z"],
    "projects": ["M18 4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h16V4zm-2-3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v1h12V1zm3 6H1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-5 7c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-2h1v2h6v-2h1v2z"],
    "properties": ["M2 15c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5-4h12c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zM2 1C.9 1 0 1.9 0 3s.9 2 2 2 2-.9 2-2-.9-2-2-2zm17 8H7c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0 7H7c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "property": ["M3 5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm5-1h11c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM3 15c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm16 1H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm-1-8H9c-1.1 0-2 .9-2 2s.9 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2zM3 7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"],
    "publish-function": ["M7.01 10.11c.35-.64.72-1.68 1.09-3.11l.8-3.03h.96l.24-.77h-.99c.28-1.11.66-1.92 1.12-2.43.28-.32.56-.48.83-.48.05 0 .1.02.13.05.03.03.05.07.05.12 0 .04-.04.13-.11.25-.08.12-.11.24-.11.35 0 .15.06.28.18.39.12.11.27.16.45.16.2 0 .36-.07.49-.2s.2-.31.2-.54c0-.26-.1-.47-.3-.63-.2-.16-.52-.24-.96-.24-.68 0-1.3.19-1.86.58-.55.38-1.08 1.02-1.58 1.91-.17.3-.34.5-.49.59-.15.08-.4.13-.74.12l-.23.77h.95L5.74 9.21c-.23.86-.39 1.39-.47 1.59-.12.29-.3.54-.54.75-.1.08-.21.12-.35.12-.04 0-.07-.01-.1-.03l-.03-.04c0-.02.03-.07.1-.13.07-.07.1-.17.1-.31 0-.15-.05-.28-.16-.38-.11-.1-.27-.15-.47-.15-.25 0-.44.07-.59.2-.15.12-.23.28-.23.46 0 .19.09.36.27.5.19.14.47.21.86.21.61 0 1.16-.15 1.63-.46.48-.31.89-.79 1.25-1.43zm3.7 1.18c-.18-.18-.43-.29-.71-.29s-.53.11-.71.29l-3 3a1.003 1.003 0 001.42 1.42L9 14.41V19c0 .55.45 1 1 1s1-.45 1-1v-4.59l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3zm4.15-6.78c.17-.13.36-.2.55-.2.07 0 .2.03.39.08s.36.08.5.08c.2 0 .37-.07.5-.2.13-.14.2-.31.2-.52 0-.22-.07-.4-.2-.53s-.33-.2-.58-.2c-.22 0-.43.05-.63.15-.2.1-.45.32-.75.67-.23.25-.56.7-1.01 1.33a6.52 6.52 0 00-.91-2.15l-2.38.39-.05.25c.18-.03.33-.05.45-.05.24 0 .43.1.59.3.25.31.59 1.24 1.02 2.79-.34.44-.58.73-.7.87-.21.22-.38.36-.52.43-.1.05-.22.08-.35.08-.1 0-.26-.05-.49-.16a1.01 1.01 0 00-.42-.11c-.23 0-.42.07-.57.22-.17.14-.24.32-.24.55 0 .21.07.38.21.51.14.13.33.2.56.2.23 0 .44-.05.64-.14.2-.09.45-.29.75-.59s.72-.78 1.25-1.43c.2.62.38 1.07.53 1.35.15.28.32.49.52.61.19.12.44.19.73.19.28 0 .57-.1.86-.3.38-.25.77-.69 1.17-1.31l-.25-.14c-.27.37-.48.6-.61.69-.09.06-.19.09-.31.09-.14 0-.28-.09-.42-.26-.23-.29-.54-1.09-.93-2.4.37-.58.66-.96.9-1.14z"],
    "pulse": ["M19 10h-2.38L14.9 6.55h-.01c-.17-.32-.5-.55-.89-.55-.43 0-.79.28-.93.66h-.01l-2.75 7.57L7.98 1.82h-.02A.978.978 0 007 1c-.44 0-.8.29-.94.69h-.01L3.28 10H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.44 0 .8-.29.94-.69h.01l1.78-5.34 2.29 12.21h.02c.08.46.47.82.96.82.43 0 .79-.28.93-.66h.01l3.21-8.82.96 1.92h.01c.16.33.49.56.88.56h3c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "rain": ["M4 10a3 3 0 111.065-5.806A5.001 5.001 0 0114.63 3.11 3.5 3.5 0 1115.5 10H4zm0 2a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm9 1a1 1 0 10-2 0v6a1 1 0 102 0v-6zm3-1a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-7 1a1 1 0 10-2 0v3a1 1 0 102 0v-3z"],
    "random": ["M14.47 5h2.12L15.3 6.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 3H14c-.31 0-.57.15-.76.37l-.01-.01-2.93 3.52 1.3 1.56L14.47 5zm2.24 7.29a1.003 1.003 0 00-1.42 1.42l1.3 1.29h-2.12L4.77 3.36l-.01.01A.998.998 0 004 3H1c-.55 0-1 .45-1 1s.45 1 1 1h2.53l9.7 11.64.01-.01c.19.22.45.37.76.37h2.59l-1.29 1.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3zM3.53 15H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.31 0 .57-.15.76-.37l.01.01 2.93-3.52-1.3-1.56L3.53 15z"],
    "record": ["M10 3a7 7 0 100 14 7 7 0 100-14z"],
    "rectangle": ["M1 4h18c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1zm1 2v8h16V6H2z"],
    "redo": ["M19.71 5.29l-4-4a1.003 1.003 0 00-1.42 1.42L16.59 5H6c-3.31 0-6 2.69-6 6s2.69 6 6 6h5v-2H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h10.59L14.3 9.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM15 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"],
    "refresh": ["M19 1c-.55 0-1 .45-1 1v2.06C16.18 1.61 13.29 0 10 0 4.48 0 0 4.48 0 10c0 .55.45 1 1 1s1-.45 1-1c0-4.42 3.58-8 8-8 2.52 0 4.76 1.18 6.22 3H15c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 8c-.55 0-1 .45-1 1 0 4.42-3.58 8-8 8-2.52 0-4.76-1.18-6.22-3H5c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-2.06C3.82 18.39 6.71 20 10 20c5.52 0 10-4.48 10-10 0-.55-.45-1-1-1z"],
    "regression-chart": ["M19 16H3.1L19.31 3.39l-.61-.79L2 15.59V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-9-9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-5 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm10-2c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm-5 4c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"],
    "remove": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm5-9H5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "remove-column": ["M19 0H5c-.55 0-1 .45-1 1v4h2V2h5v16H6v-3H4v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18h-5V2h5v16zM6.29 13.71a1.003 1.003 0 001.42-1.42L5.41 10 7.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L4 8.59l-2.29-2.3A1.003 1.003 0 00.29 7.71L2.59 10 .3 12.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L4 11.41l2.29 2.3z"],
    "remove-column-left": ["M4 11h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-7 18H2V2h10v16zm6 0h-5V2h5v16z"],
    "remove-column-right": ["M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7 18H2V2h5v16zm11 0H8V2h10v16zm-8-7h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1z"],
    "remove-row-bottom": ["M7 14h6c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zM19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V8h16v10zm0-11H2V2h16v5z"],
    "remove-row-top": ["M7 8h6c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1zm12-8H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2v-5h16v5zm0-6H2V2h16v10z"],
    "repeat": ["M14 6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v2.05C16.18 1.6 13.29 0 10 0 4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10c0-.55-.45-1-1-1s-1 .45-1 1c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c2.53 0 4.77 1.17 6.24 3H15c-.55 0-1 .45-1 1z"],
    "reset": ["M6 6c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v2.05C3.82 1.6 6.71 0 10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10c0-.55.45-1 1-1s1 .45 1 1c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8C7.47 2 5.23 3.17 3.76 5H5c.55 0 1 .45 1 1z"],
    "resolve": ["M8.7 4.7C7.9 4.2 7 4 6 4c-3.3 0-6 2.7-6 6s2.7 6 6 6c1 0 1.9-.2 2.7-.7C7.3 14 6.5 12.1 6.5 10s.9-4 2.2-5.3zM14 4c-1 0-1.9.2-2.7.7 1.4 1.4 2.2 3.2 2.2 5.3s-.9 4-2.2 5.3c.8.5 1.7.7 2.7.7 3.3 0 6-2.7 6-6s-2.7-6-6-6zm-4 1.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"],
    "rig": ["M7 4.2C7 5.75 8.34 7 10 7s3-1.46 3-2.8C13 1.45 10.94 0 10 0H6c0 2.74 3.76 1.96 1 4.2zm11.71 14.09L13 12.59V9.01c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v3.58l-5.71 5.7a1.003 1.003 0 001.42 1.42L7 15.42V19c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3.58l4.29 4.29a1.003 1.003 0 001.42-1.42zM10.21 8c.01 0 .01.01 0 0 .01.01.01 0 0 0z"],
    "right-join": ["M8.7 4.7C7.4 6 6.5 7.9 6.5 10s.8 4 2.2 5.3c-.8.5-1.7.7-2.7.7-3.3 0-6-2.7-6-6s2.7-6 6-6c1 0 1.9.2 2.7.7zm-3.34 9.25c-.55-1.2-.86-2.54-.86-3.95s.31-2.75.86-3.95a4.001 4.001 0 000 7.9zM14 4c3.3 0 6 2.7 6 6s-2.7 6-6 6c-1 0-1.9-.2-2.7-.7 1.3-1.3 2.2-3.2 2.2-5.3s-.8-3.9-2.2-5.3C12.1 4.2 13 4 14 4zm-4 1.5C8.8 6.7 8 8.2 8 10s.8 3.3 2 4.4c1.2-1.1 2-2.7 2-4.5s-.8-3.3-2-4.4z"],
    "ring": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"],
    "rocket": ["M7 7.5c0-3 1.857-6.25 3-7.5 1.143 1.25 3 4.5 3 7.5s-.714 6.25-1 7.5H8c-.286-1.25-1-4.5-1-7.5zm6.84 2.5c-.139 1.62-.47 3.405-.84 5.01l4 .99-1-4-2.16-2zm-4.832 6C9 16.139 9 16.284 9 16.429 9 17.143 9 17.5 10 20c1-2.5 1-2.857 1-3.571 0-.145 0-.29-.008-.429H9.008zM7 15.011c-.37-1.605-.701-3.39-.84-5.011L4 12l-1 4 4-.989zM10 5a1 1 0 100 2 1 1 0 000-2z"],
    "rocket-slant": ["M10 5c2.121-2.121 6.308-2.924 8-3-.076 1.692-.879 5.879-3 8-1.192 1.192-2.543 1.823-3.748 2.384-.442.207-.865.404-1.252.616-.203.111-.597.302-.986.49-.444.215-.88.426-1.014.51l-2-2c.158-.252 1-2 1-2s1.37-3.37 3-5zm5 1a1 1 0 11-2 0 1 1 0 012 0zM3 17s0-2 2-4l2 2c-2 2-4 2-4 2zm11-2l-4 4-1.298-4.233c1.033-.56 1.881-.962 2.643-1.322 1.275-.604 2.307-1.092 3.554-2.015L14 15zM1 10l4-4 3.557-.899c-.923 1.247-1.412 2.28-2.015 3.554-.36.762-.762 1.61-1.322 2.643L1 10z"],
    "rotate-document": ["M8.71 6.29A.997.997 0 008 6H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-8c0-.28-.11-.53-.29-.71l-4-4zM11 18H4V8h3v3c0 .55.45 1 1 1h3v6zm3-16h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C9.11 2.47 9 2.72 9 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H14c1.1 0 2 .9 2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-2.21-1.79-4-4-4z"],
    "rotate-page": ["M14 2h-1.59l.29-.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-2 2C9.11 2.47 9 2.72 9 3c0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42l-.3-.29H14c1.1 0 2 .9 2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-2.21-1.79-4-4-4zm-2 5H3c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 11H4V9h7v9z"],
    "route": ["M14.028 6.016c.146.275.31.57.485.872.304.524.628 1.047.952 1.545l.118.178-.208-.006-.577-.005c-2.093.004-2.841.303-2.841.895 0 .069.271.248 1.245.567l1.008.313c2.671.831 3.99 1.827 3.99 4.167 0 2.76-1.928 4.059-4.832 4.376-.782.085-1.52.098-2.452.066l-1.15-.046H6.221l.535-.811a67.46 67.46 0 001.122-1.787h2.04l.686.03c1.028.046 1.77.043 2.523-.039 1.832-.2 2.673-.767 2.673-1.789 0-.69-.483-1.09-1.992-1.585l-.83-.257c-1.192-.364-2.037-.7-2.59-1.165.399-1 .612-1.844.612-2.538a6.018 6.018 0 00-.382-2.098c.745-.573 1.884-.822 3.41-.883zM5 4.2c2.648 0 4.791 2.151 4.8 4.797C9.8 11.652 5 18.6 5 18.6l-.5-.744C3.273 15.993.2 11.121.2 8.997A4.802 4.802 0 015 4.2zm0 2.4a2.4 2.4 0 10.002 4.802A2.4 2.4 0 005 6.6zM17 .333a2.671 2.671 0 012.667 2.665C19.667 4.473 17 8.333 17 8.333l-.391-.587c-.741-1.137-2.276-3.629-2.276-4.748A2.668 2.668 0 0117 .333z"],
    "satellite": ["M9 18c.6 0 1 .4 1 1s-.4 1-1 1c-5 0-9-4-9-9 0-.6.4-1 1-1s1 .4 1 1c0 3.9 3.1 7 7 7zm0-4c.6 0 1 .4 1 1s-.4 1-1 1c-2.8 0-5-2.2-5-5 0-.6.4-1 1-1s1 .4 1 1c0 1.7 1.3 3 3 3zm5.7-3.7c.4-.4 1-.4 1.4 0l3.6 3.6c.4.4.4 1 0 1.4l-1.4 1.4c-.4.4-1 .4-1.4 0l-3.6-3.6c-.4-.4-.4-1 0-1.4l1.4-1.4zM4.7.3c.4-.4 1-.4 1.4 0l3.6 3.6c.4.4.4 1 0 1.4L8.3 6.7c-.4.4-1 .4-1.4 0L3.3 3.1c-.4-.4-.4-1 0-1.4L4.7.3zm11.1 1c.4-.4 1-.4 1.4 0l1.6 1.6c.4.4.4 1 0 1.4l-6.5 6.5c-.4.4-1 .4-1.4 0L9.3 9.2c-.4-.4-.4-1 0-1.4l6.5-6.5zM9 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"],
    "saved": ["M12 0H4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h13c.55 0 1-.45 1-1V6l-6-6zm4 18H5V2h6v5h5v11zm-8.29-6.71a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.32 0 .59-.16.77-.38l.01.01 4-5-.01-.01c.14-.18.23-.38.23-.62 0-.55-.45-1-1-1-.32 0-.59.16-.77.38l-.01-.01-3.3 4.13-2.21-2.21z"],
    "scatter-plot": ["M9 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm5 2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1 10H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM5 15c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"],
    "search": ["M19.56 17.44l-4.94-4.94A8.004 8.004 0 0016 8c0-4.42-3.58-8-8-8S0 3.58 0 8s3.58 8 8 8c1.67 0 3.21-.51 4.5-1.38l4.94 4.94a1.498 1.498 0 102.12-2.12zM8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"],
    "search-around": ["M9.9 6.9a3 3 0 100 6 3 3 0 100-6zM3 14c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM3 0C1.3 0 0 1.3 0 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM17 14c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM17 0c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM10 10L5 5",
        "M5.379 4.671l5.02 5.02-.707.708-5.02-5.02zM10 10l5-5",
        "M14.621 4.671l.707.708-5.02 5.02-.707-.707z",
        "M10 10l5 5M10.379 9.671l5.02 5.02-.707.708-5.02-5.02z",
        "M10 10l-5 5M9.621 9.671l.707.708-5.02 5.02-.707-.707z"],
    "search-template": ["M13 8H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm0 3H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm6.56 12.44l-3.23-3.23A8.939 8.939 0 0018 9a9 9 0 10-9 9c1.94 0 3.74-.62 5.21-1.67l3.23 3.23a1.498 1.498 0 102.12-2.12zM9 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"],
    "search-text": ["M19.56 17.44l-3.23-3.23A8.939 8.939 0 0018 9a9 9 0 10-9 9c1.94 0 3.74-.62 5.21-1.67l3.23 3.23a1.498 1.498 0 102.12-2.12zM9 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm3.5-11h-7c-.28 0-.5.22-.5.5v2c0 .28.22.5.5.5s.5-.22.5-.5V7h2v6h-.5c-.28 0-.5.22-.5.5s.22.5.5.5h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H10V7h2v.5c0 .28.22.5.5.5s.5-.22.5-.5v-2c0-.28-.22-.5-.5-.5z"],
    "segmented-control": ["M19 5H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 8h-8V7h8v6z"],
    "select": ["M19.71 18.29l-4.25-4.25L20 12.91 9.93 9.33c.04-.1.07-.21.07-.33V3c0-.55-.45-1-1-1H4V1c0-.55-.45-1-1-1S2 .45 2 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 .55.45 1 1 1h6c.12 0 .23-.03.34-.07L12.91 20l1.14-4.54 4.25 4.25c.17.18.42.29.7.29a1.003 1.003 0 00.71-1.71zM8 8H4V4h4v4z"],
    "selection": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
        "M10 6a4 4 0 100 8 4 4 0 100-8z"],
    "send-message": ["M1.754.135L19.393 9.06c.57.288.775.943.458 1.462-.107.176-.266.32-.458.418l-17.64 8.925c-.57.288-1.288.1-1.604-.418C.05 19.287 0 19.183 0 19v-7l11-2L0 8V1.075C0 .481.529 0 1.18 0c.201 0 .399.047.574.135z"],
    "send-to": ["M19 0h-5c-.6 0-1 .4-1 1s.4 1 1 1h2.6l-4.3 4.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3L18 3.4V6c0 .5.5 1 1 1s1-.5 1-1V1c0-.6-.5-1-1-1zm0 9c-1 0-1.9-.5-2.5-1.3l-1.4 1.4c-.5.6-1.3.9-2.1.9-1.7 0-3-1.3-3-3 0-.8.3-1.6.9-2.1l1.4-1.4C11.5 2.9 11 2 11 1c0-.3.1-.6.2-.9-.4-.1-.8-.1-1.2-.1C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10c0-.4 0-.8-.1-1.2-.3.1-.6.2-.9.2z"],
    "send-to-graph": ["M8 11H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zm10 2c-.53 0-1.01.21-1.37.55L11.9 10.6c.06-.19.1-.39.1-.6 0-.21-.04-.41-.1-.6l4.72-2.95c.37.34.85.55 1.38.55 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .21.04.41.1.6l-4.73 2.96c-.24-.23-.54-.4-.87-.48V3.93c.86-.22 1.5-1 1.5-1.93 0-1.1-.9-2-2-2S8 .9 8 2c0 .93.64 1.71 1.5 1.93v4.14c-.33.09-.63.26-.87.48L7.6 7.91 5.42 6.55 3.9 5.6c.06-.19.1-.39.1-.6 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.53 0 1.01-.21 1.37-.55L9 9.96V10h.06L12 11.84l.4.25 1.51.94 2.19 1.37c-.06.19-.1.39-.1.6 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zm-7-2.96l-.06-.04H11v.04z"],
    "send-to-map": ["M8 11H3c-.55 0-1 .45-1 1s.45 1 1 1h2.59L.3 18.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71L7 14.41V17c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1zm11.54-6.82l.01-.02-6-4-.01.02C13.39.08 13.21 0 13 0s-.39.08-.54.18l-.01-.02L7 3.8 1.55.17l-.01.01A.969.969 0 001 0C.45 0 0 .45 0 1v9c0-.55.45-1 1-1h1V2.87l4 2.67V9h2V5.54l4-2.67v11.6l-1 .67v2.4l2-1.33 5.45 3.63.01-.02c.15.1.33.18.54.18.55 0 1-.45 1-1V5c0-.35-.19-.64-.46-.82zM18 17.13l-4-2.67V2.87l4 2.67v11.59z"],
    "series-add": ["M13.29 9.29c.3.62.8 1.12 1.42 1.42l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L7 10.41l-5 5V17h17c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8s.53.11.71.29l3.29 3.3 2.29-2.3zM12 5c0-.5.4-1 1-1h2V2c0-.6.4-1 1-1 .5 0 1 .4 1 1v2h2c.5 0 1 .4 1 1s-.5 1-1 1h-2v2c0 .6-.5 1-1 1-.6 0-1-.4-1-1V6h-2c-.6 0-1-.4-1-1z"],
    "series-configuration": ["M11.91 10.67c.52.45 1.13.8 1.8 1.03l-2.01 2.01c-.18.18-.43.29-.71.29-.28 0-.53-.11-.71-.3L7 10.41l-5 5V17h16.99c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8c.28 0 .53.11.71.29l3.29 3.3.91-.92zM18.5 4.6h1.04c.25 0 .45.2.46.44v.9c0 .25-.2.45-.45.45h-1.04c-.07.22-.16.42-.27.62l.73.73c.17.17.17.44 0 .61l-.61.61c-.17.17-.44.17-.61 0l-.73-.73c-.2.11-.4.2-.62.26v1.05c0 .25-.2.45-.45.45h-.9c-.25 0-.45-.2-.45-.45V8.51c-.21-.06-.4-.15-.58-.25l-.76.77c-.17.17-.46.17-.64 0l-.64-.64a.465.465 0 010-.64l.76-.77c-.1-.19-.19-.38-.25-.59h-1.04c-.25 0-.45-.2-.45-.45v-.9c0-.25.2-.45.45-.45h1.04c.07-.22.16-.42.27-.61l-.73-.73a.429.429 0 010-.61l.61-.61c.17-.17.44-.17.61 0l.73.73c.2-.11.4-.2.62-.26V1.45a.44.44 0 01.44-.45h.9c.25 0 .45.2.45.45V2.5c.21.06.4.15.58.25l.76-.77c.17-.17.46-.17.64 0l.64.64c.17.17.17.46 0 .64l-.76.77c.1.17.19.36.25.57zm-4.69.9c0 .93.75 1.69 1.69 1.69.93 0 1.69-.75 1.69-1.69s-.75-1.69-1.69-1.69-1.69.76-1.69 1.69z"],
    "series-derived": ["M18.82 6.58c-.03.05-.07.09-.11.13 0 0 0-.01-.01-.01l-2 2c-.2.2-.4.3-.7.3-.6 0-1-.4-1-1 0-.3.1-.5.3-.7L16.6 6H11c-.6 0-1-.4-1-1s.4-1 1-1h5.6l-1.3-1.3c-.2-.2-.3-.4-.3-.7 0-.6.4-1 1-1 .3 0 .5.1.7.3l3 3c.2.2.3.4.3.7s-.1.5-.3.7l-.88.88zm-5.53 2.71c.3.62.8 1.12 1.42 1.42l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L7 10.41l-5 5V17h17c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8s.53.11.71.29l3.29 3.3 2.29-2.3z"],
    "series-filtered": ["M12.14 10.45c.21.67.65 1.23 1.22 1.61l-1.65 1.65c-.18.18-.43.29-.71.29s-.53-.11-.71-.3L7 10.41l-5 5V17h17c.55 0 1 .45 1 1s-.45 1-1 1H1a.998.998 0 01-1-1V4c0-.55.45-1 1-1s1 .45 1 1v8.59l4.29-4.3C6.47 8.11 6.72 8 7 8s.53.11.71.29l3.29 3.3 1.14-1.14zM19.35 1a.642.642 0 01.46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V5.13L11.19 2.1a.642.642 0 01.45-1.1h7.71z"],
    "series-search": ["M11.28 11.31l-.28.28-3.29-3.3C7.53 8.11 7.28 8 7 8s-.53.11-.71.29L2 12.59V4c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1H2v-1.59l5-5 3.29 3.29c.18.19.43.3.71.3s.53-.11.71-.29l2.09-2.09c-.17.02-.34.02-.51.02-.7 0-1.38-.12-2.01-.33zm-.93-6c0-1.62 1.31-2.93 2.93-2.93s2.93 1.31 2.93 2.93-1.31 2.93-2.93 2.93-2.93-1.31-2.93-2.93zm6.47 2.43c.11-.17.21-.33.29-.51.01-.03.03-.06.04-.09.08-.18.16-.35.21-.54.06-.2.1-.38.14-.58.01-.05.01-.09.02-.14.03-.2.05-.39.05-.6 0-2.37-1.93-4.3-4.3-4.3-2.37.01-4.3 1.93-4.3 4.31s1.93 4.3 4.3 4.3c.21 0 .4-.02.6-.05.04 0 .09-.01.14-.02.2-.03.38-.08.57-.14.2-.06.37-.14.55-.21.03-.01.06-.03.09-.04.18-.09.34-.19.51-.29l2.87 2.87c.14.14.33.22.56.22.43 0 .78-.35.78-.78a.938.938 0 00-.23-.56l-2.89-2.85z"],
    "settings": ["M4 1c0-.55-.45-1-1-1S2 .45 2 1v5h2V1zM2 19c0 .55.45 1 1 1s1-.45 1-1v-6H2v6zm9-18c0-.55-.45-1-1-1S9 .45 9 1v8h2V1zm7 0c0-.55-.45-1-1-1s-1 .45-1 1v3h2V1zM9 19c0 .55.45 1 1 1s1-.45 1-1v-3H9v3zm9-14h-2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-2 14c0 .55.45 1 1 1s1-.45 1-1v-8h-2v8zM4 7H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm7 3H9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1z"],
    "shapes": ["M7.88 11.12a.958.958 0 011.277.33l3.719 6.207c.081.136.124.29.124.447 0 .495-.419.896-.936.896H4.936a.969.969 0 01-.436-.103.878.878 0 01-.392-1.21l3.409-6.208a.915.915 0 01.362-.36zM15 5a4 4 0 110 8 4 4 0 010-8zM8 1a1 1 0 011 1v6a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h6z"],
    "share": ["M15 18H2V5h8.76l2-2H1c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1h15c.55 0 1-.45 1-1V7.24l-2 2V18zm4-18h-7c-.55 0-1 .45-1 1s.45 1 1 1h4.59l-7.3 7.29a1.003 1.003 0 001.42 1.42L18 3.41V8c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "shared-filter": ["M13.917 17.209c1.01.454 2.543.928 2.873 1.643.31.722.186 1.148.186 1.148H6.026s-.13-.426.186-1.148 1.842-1.203 2.86-1.65c1.017-.447.914-.722.948-1.093 0-.048.007-.097.007-.145a3.067 3.067 0 01-.839-1.237l-.007-.007c0-.007-.006-.014-.006-.02a1.757 1.757 0 01-.11-.337c-.234-.042-.372-.296-.426-.537a1.045 1.045 0 01-.138-.598c.034-.35.179-.509.337-.57v-.056c0-.44.034-1.065.117-1.478a2.508 2.508 0 01.962-1.623c.426-.33 1.038-.501 1.58-.501.544 0 1.155.172 1.588.502a2.496 2.496 0 01.963 1.622c.075.413.117 1.045.117 1.478v.062c.15.062.288.22.323.564.02.268-.083.502-.138.598-.048.234-.185.488-.42.537a2.635 2.635 0 01-.116.364 3.094 3.094 0 01-.818 1.224c0 .055 0 .11.007.158.034.378-.103.653.914 1.1z",
        "M14.976 16.57c-.24-.099-.455-.186-.65-.273l-.007-.004a3.801 3.801 0 01-.194-.091c.224-.288.41-.609.554-.946l.001-.002.013-.033c.018-.043.036-.087.052-.13l.011-.027.016-.04c.105-.092.19-.19.256-.284.129-.184.213-.38.265-.563.105-.226.225-.592.192-1.026l-.001-.011-.002-.011a1.854 1.854 0 00-.325-.91 9.924 9.924 0 00-.12-1.246 3.09 3.09 0 00-.106-.475l-.001-.006a3.543 3.543 0 00-.763-1.353c.27-.092.56-.139.83-.139.495 0 1.05.156 1.444.456a2.269 2.269 0 01.875 1.475c.069.375.106.95.106 1.344v.056c.138.056.263.2.294.513.019.244-.075.456-.125.543-.044.213-.169.444-.381.488-.025.1-.056.206-.094.3a2.815 2.815 0 01-.756 1.144c0 .05 0 .1.006.144.004.043.006.086.007.127.01.283.018.518.824.872.192.087.404.173.623.263.83.34 1.752.717 1.99 1.231.28.657.168 1.044.168 1.044h-2.081a3.864 3.864 0 00-.188-.542l-.005-.013-.006-.012c-.183-.397-.491-.681-.76-.88a5.614 5.614 0 00-.896-.522 17.36 17.36 0 00-.916-.4l-.15-.061zM14 1c.55 0 1 .45 1 1 0 .28-.11.53-.29.7L10 7.41v.897a3.182 3.182 0 00-.69.4 3.508 3.508 0 00-1.343 2.259c-.07.37-.107.836-.122 1.237a1.836 1.836 0 00-.339.926c-.046.458.09.84.195 1.06.053.178.138.376.27.56.055.08.125.162.21.242v.143l.053.052L6.71 16.71A1.003 1.003 0 015 16V7.41L.29 2.71A1.003 1.003 0 011 1h13z",
        "M9.059 14.361c-.23-.044-.366-.296-.42-.535a1.045 1.045 0 01-.138-.598c.034-.35.179-.509.337-.57v-.056c0-.44.034-1.065.117-1.478A2.508 2.508 0 0110 9.441V13c0 .28-.11.53-.29.71l-.651.651z"],
    "shield": ["M10 20c6-3.81 9-9.048 9-15.714-2 0-5-1.429-9-4.286-4 2.857-7 4.286-9 4.286C1 10.952 4 16.19 10 20zm0-17.348c2.577 1.734 4.776 2.88 6.667 3.419-.44 4.627-2.636 8.353-6.667 11.297V2.652z"],
    "ship": ["M6.84.804L6.5 2.5h-3a1 1 0 00-1 1v4.893l-1.58.451a.99.99 0 00-.691 1.192c.46 1.82 1.163 4.356 1.701 5.571-.218.012-.445.018-.68.018a.625.625 0 100 1.25c2.583 0 4.268-.68 5.202-1.146.687.466 1.88 1.146 3.548 1.146 1.65 0 2.837-.666 3.528-1.132l.005.003c.244.131.6.3 1.07.468.938.335 2.321.661 4.147.661a.625.625 0 100-1.25c-.323 0-.63-.011-.922-.031a.996.996 0 00.184-.334l1.67-5.168a1 1 0 00-.677-1.27l-1.505-.43V3.5a1 1 0 00-1-1h-3L13.16.804A1 1 0 0012.18 0H7.82a1 1 0 00-.98.804zM5 7.679l3.75-1.072V5H5v2.679zm6.25-1.072L15 7.68V5h-3.75v1.607zM6.205 16.95a.625.625 0 01.658.042c.569.407 1.597 1.134 3.137 1.134s2.568-.727 3.137-1.134a.625.625 0 01.724-.001l.007.005.045.029c.044.027.114.069.21.12.194.104.493.247.9.392.811.29 2.053.589 3.727.589a.625.625 0 110 1.25c-1.826 0-3.21-.326-4.148-.661a7.894 7.894 0 01-1.069-.468l-.005-.003c-.691.466-1.878 1.132-3.528 1.132-1.667 0-2.861-.68-3.548-1.146-.934.467-2.619 1.146-5.202 1.146a.625.625 0 110-1.25c2.66 0 4.23-.787 4.955-1.176z"],
    "shop": ["M17.94 3.63c-.01-.02-.01-.03-.02-.04l-.03-.09h-.01c-.18-.3-.49-.5-.86-.5h-14c-.42 0-.77.25-.92.61L0 8.5h.02a2.5 2.5 0 005 0 2.5 2.5 0 005 0 2.5 2.5 0 005 0 2.5 2.5 0 005 0l-2.08-4.87zM3.02 2h14c.55 0 1-.45 1-1s-.45-1-1-1h-14c-.55 0-1 .45-1 1s.44 1 1 1zm13 14h-12v-4h-2v7c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-7h-2v4z"],
    "shopping-cart": ["M18 14H8.72l-.67-2H17c.44 0 .8-.29.94-.69h.01l2-6h-.01c.03-.1.06-.2.06-.31 0-.55-.45-1-1-1H5.39l-.44-1.32h-.01C4.8 2.29 4.44 2 4 2H1c-.55 0-1 .45-1 1s.45 1 1 1h2.28l3.33 10H5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2h9c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zM6.05 6h11.56l-1.33 4H7.39L6.05 6z"],
    "signal-search": ["M7.15 10.33c.888.8 1.999 1.36 3.228 1.574l2.326 6.98a.846.846 0 01-.535 1.07.844.844 0 01-1.072-.535l-1.225-3.671H7.125L5.9 19.419a.85.85 0 01-1.072.536.85.85 0 01-.536-1.071l2.857-8.555zm1.353 1.305l-.808 2.413h1.607l-.8-2.413zM5 5.5c0 .76.13 1.49.37 2.17-.496 1.056-.313 2.356.704 3.29.385.353.404.94.038 1.311a.982.982 0 01-1.356.038c-2.183-2.01-2-5.125.01-6.94a.95.95 0 01.24-.156A6.421 6.421 0 005 5.5z",
        "M3.874 13.185c-1.346-.918-2.187-2.67-2.187-4.34 0-1.752.757-3.254 2.187-4.339.42-.25.42-.834.168-1.168-.252-.418-.84-.418-1.177-.167C1.014 4.59-.08 6.509.005 8.846c.084 2.253 1.177 4.423 2.86 5.675.168.083.336.166.504.166.253 0 .505-.083.673-.333.337-.418.253-.918-.168-1.169zM12.246 12.309a.98.98 0 01-1.354-.037.917.917 0 01-.206-.324 6.54 6.54 0 001.959-.049 5.125 5.125 0 01-.399.41zM14.631 11.476l1.228 1.229a6.6 6.6 0 01-1.723 1.816c-.169.083-.337.166-.505.166-.253 0-.505-.083-.673-.333-.337-.418-.253-.918.168-1.169.62-.422 1.133-1.022 1.505-1.709z",
        "M11.5 0C14.54 0 17 2.46 17 5.5c0 .26-.02.51-.06.75l-.03.17c-.04.25-.1.49-.17.73v.01c-.08.24-.17.47-.28.69-.01.04-.03.07-.05.11-.11.23-.24.44-.38.65l3.68 3.68A1.003 1.003 0 0119 14c-.28 0-.53-.11-.7-.29l-3.68-3.68c-.21.14-.42.27-.65.38-.04.01-.07.03-.11.05-.22.11-.45.2-.69.28h-.01c-.24.07-.48.13-.73.17l-.17.03c-.25.04-.5.06-.76.06C8.46 11 6 8.54 6 5.5S8.46 0 11.5 0zm0 1.5c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"],
    "sim-card": ["M16.71 5.29l-5-5A.997.997 0 0011 0H4c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.28-.11-.53-.29-.71zM9 7h2v3H9V7zM6 7h2v3H6V7zm2 11H6v-3h2v3zm3 0H9v-3h2v3zm3 0h-2v-3h2v3zm0-4H6v-3h8v3zm0-4h-2V7h2v3z"],
    "slash": ["M12 2c-.46 0-.85.32-.97.74L7.04 16.7c-.02.1-.04.2-.04.3 0 .55.45 1 1 1 .46 0 .85-.32.97-.74L12.96 3.3c.02-.1.04-.2.04-.3 0-.55-.45-1-1-1z"],
    "small-cross": ["M11.41 10l3.29-3.29c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71L10 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42L8.59 10 5.3 13.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l3.29-3.3 3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71L11.41 10z"],
    "small-minus": ["M14 9H6c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "small-plus": ["M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "small-square": ["M5 5v10h10V5H5zM4 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H4z"],
    "small-tick": ["M15 5c-.28 0-.53.11-.71.29L8 11.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7A1.003 1.003 0 0015 5z"],
    "snowflake": ["M11 11.776v2.81l2.31 2.242a.987.987 0 010 1.415c-.399.39-1.044.39-1.442 0L11 17.414V19a.99.99 0 01-.996 1A.996.996 0 019 19v-1.636l-.912.879c-.398.39-1.043.39-1.441 0a.987.987 0 010-1.415L9 14.536v-2.79l-2.548 1.435-.837 3.063c-.146.534-.705.85-1.248.707a.998.998 0 01-.721-1.224l.309-1.132-1.4.793a1.03 1.03 0 01-1.393-.366.99.99 0 01.373-1.366l1.445-.818-1.224-.322a.998.998 0 01-.72-1.225c.145-.533.704-.85 1.248-.707l3.193.84 2.462-1.395-2.532-1.434-3.123.82a1.022 1.022 0 01-1.249-.706.998.998 0 01.721-1.225L2.91 7.18l-1.4-.793a.99.99 0 01-.373-1.366 1.03 1.03 0 011.392-.366l1.445.818-.328-1.2a.998.998 0 01.72-1.225 1.022 1.022 0 011.25.707l.855 3.132L9 8.311V5.414L6.647 3.121a.987.987 0 010-1.414 1.033 1.033 0 011.441 0L9 2.586V1c0-.552.44-1 1.004-1A.99.99 0 0111 1l-.007 1.536.875-.829a1.033 1.033 0 011.441 0 .987.987 0 010 1.414L11 5.364v2.918l2.53-1.42.855-3.131c.146-.534.705-.85 1.249-.707a.998.998 0 01.72 1.224l-.327 1.2 1.4-.792a1.03 1.03 0 011.392.366.99.99 0 01-.373 1.366l-1.355.768 1.153.303a.998.998 0 01.721 1.225c-.146.533-.705.85-1.249.707l-3.123-.821-2.576 1.459 2.506 1.42 3.193-.84a1.022 1.022 0 011.249.707.998.998 0 01-.72 1.225l-1.224.322 1.4.793a.99.99 0 01.373 1.366 1.03 1.03 0 01-1.393.366l-1.356-.768.31 1.132a.998.998 0 01-.721 1.224 1.022 1.022 0 01-1.249-.707l-.837-3.063L11 11.776z"],
    "social-media": ["M11.5 5c.8 0 1.6-.4 2-1 2 1.2 3.3 3.3 3.5 5.7 0 .5.5.9 1 .9.6 0 1-.5 1-1v-.1c-.2-3.3-2.2-6.2-5.1-7.6C13.7.8 12.7 0 11.5 0 10.1 0 9 1.1 9 2.5S10.1 5 11.5 5zm5 7c-1.4 0-2.5 1.1-2.5 2.5 0 .4.1.7.2 1.1-1.1.9-2.6 1.4-4.2 1.4-1.9 0-3.6-.8-4.9-2-.2-.2-.5-.4-.8-.4-.5 0-1 .5-1 1 0 .3.1.5.3.7C5.3 18 7.5 19 10 19c2.2 0 4.2-.8 5.8-2.1.2.1.5.1.7.1 1.4 0 2.5-1.1 2.5-2.5S17.9 12 16.5 12zM5 10.5c0-1.1-.7-2.1-1.7-2.4.5-1.9 1.9-3.5 3.6-4.4.3-.2.6-.5.6-.9 0-.5-.4-1-1-1-.2 0-.4.1-.6.2-2.4 1.2-4.2 3.6-4.7 6.4C.5 8.9 0 9.6 0 10.5 0 11.9 1.1 13 2.5 13S5 11.9 5 10.5z"],
    "sort": ["M19 16h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0-5h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM7 15c-.28 0-.53.11-.71.29L5 16.59V11c0-.55-.45-1-1-1s-1 .45-1 1v5.59L1.71 15.3A.965.965 0 001 15a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 007 15zM19 1h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zm0 5h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"],
    "sort-alphabetical": ["M8 15c-.28 0-.53.11-.71.29L6 16.59v-5.58c0-.55-.45-1-1-1s-1 .45-1 1v5.58L2.71 15.3c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 008 15zm8.89-.79v-1.22H11.3v1.3h3.51L11 18.78V20h5.99v-1.3h-3.91l3.81-4.49zM14.97 0h-1.95L9.01 11.01h1.89l.98-2.92h4.17l.98 2.92h1.96L14.97 0zm-2.59 6.63l1.58-4.74H14l1.57 4.74h-3.19z"],
    "sort-alphabetical-desc": ["M8.01 15c-.28 0-.53.11-.71.29L6 16.59v-5.58c0-.55-.45-1-1-1s-1 .45-1 1v5.58L2.71 15.3c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l3 3a1.014 1.014 0 001.42 0l3-3c.18-.18.29-.43.29-.71.01-.55-.44-1-.99-1zm4.44-5.65l6.4-7.88V0H10.5v1.67h5.91L10 9.44v1.57h9V9.35h-6.55zm1.27 3.64L11 20h1.59l.56-1.56h2.68l.55 1.56h1.64l-2.68-7.01h-1.62zm-.16 4.3l.93-2.57h.02l.9 2.57h-1.85z"],
    "sort-asc": ["M10 8h5c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0 5h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0-10h3c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm9 12h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zM7 14c-.28 0-.53.11-.71.29L5 15.59V10c0-.55-.45-1-1-1s-1 .45-1 1v5.59L1.71 14.3A.965.965 0 001 14a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 007 14z"],
    "sort-desc": ["M13 15h-3c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm-6-1c-.28 0-.53.11-.71.29L5 15.59V10c0-.55-.45-1-1-1s-1 .45-1 1v5.59L1.71 14.3A.965.965 0 001 14a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29s.53-.11.71-.29l3-3A1.003 1.003 0 007 14zM19 0h-9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-4 10h-5c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm2-5h-7c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"],
    "sort-numerical": ["M9 14.99c-.28 0-.53.11-.71.29L7 16.58v-5.59c0-.55-.45-1-1-1s-1 .45-1 1v5.59l-1.29-1.29a.965.965 0 00-.71-.3 1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-3c.18-.18.29-.43.29-.71a.99.99 0 00-1-1zm8.88.23c-.08-.42-.22-.79-.42-1.12-.2-.33-.47-.6-.8-.8-.33-.2-.76-.3-1.28-.3a2.333 2.333 0 00-1.72.71c-.21.22-.37.48-.49.78-.11.3-.17.62-.17.97 0 .27.04.54.13.8.08.26.22.5.4.7.19.21.43.38.71.5a2.142 2.142 0 001.72.02c.25-.12.47-.31.66-.58l.02.02c-.01.19-.04.4-.08.63-.04.24-.11.46-.21.67-.1.21-.23.38-.39.53a.92.92 0 01-.62.22c-.24 0-.44-.08-.6-.25-.16-.17-.27-.36-.31-.59h-1.31c.04.29.12.56.24.79.12.23.28.43.48.59.19.16.42.28.67.36.25.08.52.12.82.12.49 0 .9-.1 1.23-.31.34-.21.61-.48.82-.82.21-.34.37-.71.47-1.13.1-.42.15-.83.15-1.25 0-.43-.04-.85-.12-1.26zm-1.42.63c-.05.15-.11.28-.2.4-.09.12-.2.21-.34.27s-.3.1-.49.1c-.17 0-.33-.04-.46-.11s-.24-.17-.33-.29c-.08-.12-.15-.25-.19-.4-.04-.15-.06-.31-.06-.47 0-.15.02-.3.07-.45.05-.15.11-.28.2-.39.09-.12.2-.21.33-.28.13-.07.27-.11.44-.11.17 0 .33.04.47.11.14.07.25.17.34.28a1.387 1.387 0 01.28.86c.01.17-.02.33-.06.48zM15.32 11H17V0h-1.25c-.05.34-.17.62-.34.85-.17.23-.39.42-.63.57-.25.15-.52.25-.83.31-.3.06-.62.09-.94.09v1.41h2.31V11z"],
    "sort-numerical-desc": ["M9 15c-.28 0-.53.11-.71.29L7 16.59v-5.58c0-.55-.45-1-1-1s-1 .45-1 1v5.58L3.71 15.3c-.18-.18-.43-.3-.71-.3a1.003 1.003 0 00-.71 1.71l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l3-3A1.003 1.003 0 009 15zm6.7-1.33a1.5 1.5 0 01-.44.43c-.17.11-.37.19-.58.23-.22.04-.44.06-.67.05v1.07h1.66V20H17v-6.99h-1.06c-.04.26-.12.48-.24.66zm3.15-10.3c-.11-.68-.29-1.26-.55-1.76-.26-.5-.62-.89-1.08-1.18C16.75.14 16.17 0 15.46 0c-.54 0-1.03.09-1.46.27-.43.18-.79.44-1.09.76-.3.33-.52.71-.67 1.15-.16.44-.24.92-.24 1.43 0 .54.08 1.04.23 1.47.15.44.37.81.65 1.12.28.31.61.55 1 .72.39.17.82.26 1.3.26.46 0 .88-.11 1.26-.33.38-.22.68-.53.9-.94l.03.03c-.03.35-.07.74-.12 1.16-.05.42-.15.81-.29 1.18-.14.37-.35.68-.61.92-.26.25-.62.37-1.06.37-.43 0-.77-.13-1.03-.4-.25-.27-.4-.62-.44-1.05h-1.64c.02.43.11.83.29 1.18.17.35.39.66.67.91a3.027 3.027 0 002.07.8c.71 0 1.3-.17 1.79-.5.48-.33.87-.76 1.17-1.29.3-.53.51-1.12.64-1.76.13-.64.19-1.28.19-1.92.01-.77-.05-1.49-.15-2.17zM17.1 4.44c-.08.27-.19.5-.34.71-.15.21-.34.37-.57.49-.23.12-.5.18-.8.18-.3 0-.56-.06-.78-.19-.22-.13-.4-.29-.55-.49-.14-.2-.25-.44-.32-.7-.07-.27-.11-.55-.11-.84 0-.28.04-.55.11-.82.07-.26.18-.49.32-.7.14-.2.33-.36.55-.48.22-.12.48-.17.78-.17.31 0 .57.06.8.18.23.12.42.28.57.48.15.2.26.43.34.69.08.26.11.53.11.82 0 .29-.04.57-.11.84z"],
    "split-columns": ["M15 13a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-3-3a1.003 1.003 0 00-1.42 1.42L16.59 9H11V2h5v2c.77 0 1.47.3 2 .78V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v3.78C2.53 4.3 3.23 4 4 4V2h5v7H3.41L4.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3C.11 9.47 0 9.72 0 10c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L3.41 11H9v7H4v-2c-.77 0-1.47-.3-2-.78V19c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.78c-.53.48-1.23.78-2 .78v2h-5v-7h5.59l-1.29 1.29c-.19.18-.3.43-.3.71z"],
    "square": ["M19 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H2V2h16v16z"],
    "stacked-chart": ["M12 2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4h4V2zm3 14h2c.55 0 1-.45 1-1v-5h-4v5c0 .55.45 1 1 1zm3-10c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v3h4V6zm-6 1H8v5h4V7zm-9 9h2c.55 0 1-.45 1-1v-3H2v3c0 .55.45 1 1 1zm16 1H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM6 9c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h4V9zm3 7h2c.55 0 1-.45 1-1v-2H8v2c0 .55.45 1 1 1z"],
    "stadium-geometry": ["M15 7H5a3 3 0 000 6h10a3 3 0 100-6zM5 5a5 5 0 000 10h10a5 5 0 000-10H5z"],
    "star": ["M10 0l3.1 6.6 6.9 1-5 5.1 1.2 7.3-6.2-3.4L3.8 20 5 12.7 0 7.6l6.9-1z"],
    "star-empty": ["M20 7.6l-6.9-1.1L10 0 6.9 6.6 0 7.6l5 5.1L3.8 20l6.2-3.4 6.2 3.4-1.2-7.2 5-5.2zM10 15l-4.5 2.4.9-5.2-3.6-3.6 5-.8L10 3.1l2.2 4.7 5 .8-3.6 3.7.9 5.2L10 15z"],
    "step-backward": ["M15 3c-.23 0-.42.09-.59.21l-.01-.01L8 8V4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-4l6.4 4.8.01-.01c.17.12.36.21.59.21.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "step-chart": ["M19 16H2v-3h4c.55 0 1-.45 1-1V8h3v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v4h-3V7c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v4H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "step-forward": ["M15 3h-2c-.55 0-1 .45-1 1v4L5.6 3.2l-.01.01C5.42 3.09 5.23 3 5 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .23 0 .42-.09.59-.21l.01.01L12 12v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "stop": ["M16 3H4c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "stopwatch": ["M10 6a6 6 0 106 6h-6V6zm-.998-1.938A1.015 1.015 0 019 4V2H7a1 1 0 110-2h6a1 1 0 010 2h-2v2c0 .02 0 .041-.002.062A8.001 8.001 0 0110 20a8 8 0 01-.998-15.938z"],
    "strikethrough": ["M18 9h-4.46a4.7 4.7 0 00-.4-.14c-.19-.05-.51-.14-.96-.25-.45-.11-.9-.23-1.37-.35-.47-.12-.89-.23-1.27-.33s-.6-.16-.65-.17c-.53-.15-.95-.37-1.27-.66-.32-.28-.49-.68-.49-1.19 0-.36.09-.66.26-.9s.39-.43.65-.57c.26-.14.55-.24.87-.3s.63-.09.93-.09c.89 0 1.63.19 2.21.57.45.3.75.76.89 1.38h2.63c-.06-.52-.2-.98-.42-1.4-.3-.57-.71-1.05-1.23-1.43a5.33 5.33 0 00-1.79-.87c-.7-.2-1.42-.3-2.19-.3-.66 0-1.31.08-1.96.25s-1.22.43-1.73.77-.92.79-1.23 1.32c-.31.52-.46 1.15-.46 1.87 0 .37.05.74.15 1.1.1.36.28.7.53 1.02.18.24.41.47.69.67H2c-.55 0-1 .45-1 1s.45 1 1 1h10.14c.02.01.05.02.07.02.3.11.58.29.84.55.25.26.38.67.38 1.21 0 .27-.06.53-.17.79-.11.26-.29.49-.54.69-.25.2-.57.36-.97.49s-.88.19-1.44.19c-.52 0-1.01-.06-1.45-.17-.45-.11-.84-.29-1.19-.54s-.61-.56-.8-.95c-.05-.08-.09-.18-.12-.28H4.11c.09.43.22.82.4 1.18.33.65.77 1.18 1.32 1.59.55.41 1.2.72 1.94.92.74.2 1.53.3 2.37.3.73 0 1.44-.08 2.14-.25.7-.17 1.33-.43 1.88-.79.55-.36.99-.83 1.33-1.39.34-.56.51-1.25.51-2.05 0-.37-.06-.75-.18-1.12a3.12 3.12 0 00-.15-.39H18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "style": ["M18 18H2V2h12.3l2-2H1C.4 0 0 .4 0 1v18c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V7.7l-2 2V18zm1.2-18l-7.6 7.6 2.8 2.8L20 4.8V0h-.8zM4 15.9c3.1.2 5.9.2 8.2-2 1.1-1.1 1.1-3 0-4.1-.6-.5-1.3-.8-2-.8s-1.4.3-1.9.8C7.2 11 6.6 14.3 4 15.9z"],
    "swap-horizontal": ["M16.02 10c-.01 0-.01 0 0 0H16h.02zM2 6h13.58l-2.29 2.29a1 1 0 00-.3.71 1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-4-4a1.003 1.003 0 00-1.42 1.42L15.58 4H2c-.55 0-1 .45-1 1s.45 1 1 1zm2 4h-.02H4zm14 4H4.42l2.29-2.29a1 1 0 00.3-.71 1.003 1.003 0 00-1.71-.71l-4 4c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L4.42 16H18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "swap-vertical": ["M9.71 5.3l-4-4A.997.997 0 005 1.01c-.28 0-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L4 4.42V18c0 .55.45 1 1 1s1-.45 1-1V4.42l2.29 2.29a1 1 0 00.71.3 1.003 1.003 0 00.71-1.71zM10 3.98c0 .01 0 .01 0 0V4v-.02zm0 12.04c0-.01 0-.01 0 0V16v.02zm9-3.03c-.28 0-.53.11-.71.29L16 15.58V2c0-.55-.45-1-1-1s-1 .45-1 1v13.58l-2.29-2.29a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29.28 0 .53-.11.71-.29l4-4c.18-.18.29-.43.29-.71 0-.56-.45-1.01-1-1.01z"],
    "switch": ["M12.293 2.293l1.414 1.414-7.127 7.129a3.5 3.5 0 11-1.415-1.415l7.128-7.128zM16.5 9a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm-13 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm13 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"],
    "symbol-circle": ["M10 4.01a6 6 0 100 12 6 6 0 100-12z"],
    "symbol-cross": ["M15 8.01h-3v-3c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v3H5c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-3h3c.55 0 1-.45 1-1v-2c0-.56-.45-1-1-1z"],
    "symbol-diamond": ["M15 10.01c0-.21-.08-.39-.18-.54l.02-.01-4-6-.02.01c-.18-.28-.47-.46-.82-.46s-.64.18-.82.45l-.01-.01-4 6 .02.01c-.11.16-.19.34-.19.55s.08.39.18.54l-.02.01 4 6 .02-.01c.18.27.47.46.82.46s.64-.19.82-.46l.02.01 4-6-.02-.01c.1-.16.18-.34.18-.54z"],
    "symbol-rectangle": ["M16 5H4c-.5 0-1 .5-1 1v8c0 .5.5 1 1 1h12c.5 0 1-.5 1-1V6c0-.5-.5-1-1-1z"],
    "symbol-square": ["M15 4.01H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10c0-.56-.45-1-1-1z"],
    "symbol-triangle-down": ["M16 5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1 0 .16.05.31.11.44H4.1l5 10h.01c.17.33.5.56.89.56s.72-.23.89-.56h.01l5-10h-.01c.06-.13.11-.28.11-.44z"],
    "symbol-triangle-up": ["M15.89 14.56l-4.99-10h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56H9.1l-5 10h.01c-.06.13-.11.28-.11.44 0 .55.45 1 1 1h10c.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44z"],
    "syringe": ["M15.146.854a.5.5 0 01.708-.708l4 4a.5.5 0 01-.708.708l-.646-.647L17.207 5.5l1.647 1.646a.5.5 0 01-.708.708l-.646-.647-1.146 1.146-7.5 7.5a.5.5 0 01-.708 0l-.646-.646-2.646 2.647a.5.5 0 01-.708 0l-.646-.647-2.646 2.647a.5.5 0 01-.708-.708L2.793 16.5l-.647-.646a.5.5 0 010-.708L4.793 12.5l-.647-.646a.5.5 0 010-.708l7.5-7.5L12.794 2.5l-.647-.646a.5.5 0 01.708-.708L14.5 2.793 15.793 1.5l-.647-.646zM12.707 4l.793-.793L16.793 6.5 16 7.293 12.707 4zm2.586 4l-.793.793-1.646-1.647a.5.5 0 00-.708.708L13.793 9.5 12.5 10.793l-1.646-1.647a.5.5 0 00-.708.708l1.647 1.646-1.293 1.293-1.646-1.647a.5.5 0 00-.708.708L9.793 13.5 8.5 14.793 5.207 11.5 12 4.707 15.293 8zM3.207 15.5L5.5 13.207 6.793 14.5 4.5 16.793 3.207 15.5zM16.5 2.207L17.793 3.5 16.5 4.793 15.207 3.5 16.5 2.207z"],
    "tag": ["M2 4a2 2 0 012-2h4.588a2 2 0 011.414.586l7.41 7.41a2 2 0 010 2.828l-4.588 4.588a2 2 0 01-2.829 0l-7.41-7.41A2 2 0 012 8.588V4zm3.489-.006a1.495 1.495 0 100 2.99 1.495 1.495 0 000-2.99z"],
    "take-action": ["M5 7c.28 0 .53-.11.71-.29l5-5A1.003 1.003 0 009.29.29l-5 5A1.003 1.003 0 005 7zm6 6a1.003 1.003 0 001.71.71l5-5a1.003 1.003 0 00-1.42-1.42l-5 5c-.18.18-.29.43-.29.71zm8 5h-1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1H8c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm-9-6l6-6-1.29-1.29a1.003 1.003 0 00-1.42-1.42L12 2 6 8l1.29 1.29-7 7a1.003 1.003 0 001.42 1.42l7-7L10 12z"],
    "tank": ["M3.956 4.47A1 1 0 014.804 4h6.392a1 1 0 01.848.47L13 6h5a1 1 0 010 2h-5v1h4a3 3 0 110 6H3a3 3 0 010-6V6.287a1 1 0 01.152-.53l.804-1.287zM3 11h14a1 1 0 110 2H3a1 1 0 110-2z"],
    "target": ["M9 5a1 1 0 012 0v3a1 1 0 01-2 0V5zM12 9a1 1 0 000 2h3a1 1 0 000-2h-3zM4 10a1 1 0 011-1h3a1 1 0 010 2H5a1 1 0 01-1-1zM10 11a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z",
        "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"],
    "taxi": ["M19 9h-.33l.33 1v.5c0 .15-.03.3-.07.44h.01L17 17.23v.27c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5V17H6v.5c0 .83-.67 1.5-1.5 1.5S3 18.33 3 17.5v-.27l-1.93-6.28h.01c-.05-.15-.08-.3-.08-.45V10s.02-.06.05-.16c.06-.17.16-.47.28-.84H1c-.55 0-1-.45-1-1s.45-1 1-1h1l1-3h-.01v-.01c.25-.64 1-1.31 1.67-1.5 0 0 .78-.21 2.33-.36V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1.13c1.55.14 2.33.36 2.33.36.67.19 1.42.86 1.67 1.5V4H17l1 3h1c.55 0 1 .45 1 1s-.45 1-1 1zM3 11.5c0 .83.67 1.5 1.5 1.5S6 12.33 6 11.5 5.33 10 4.5 10 3 10.67 3 11.5zM16 7l-1-3H5L4 7v1h12V7zm-.5 3c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"],
    "temperature": ["M11 0a2 2 0 00-2 2v10.535a4 4 0 104 0V2a2 2 0 00-2-2zM3 2.5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM3.5 8a.5.5 0 000 1h4a.5.5 0 000-1h-4zM5 5.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm.5 5.5a.5.5 0 000 1h2a.5.5 0 000-1h-2z"],
    "text-highlight": ["M16 17c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1-.45 1-1-.45-1-1-1c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78-.55 0-1 .45-1 1s.45 1 1 1 1 .45 1 1v12c0 .55-.45 1-1 1s-1 .45-1 1 .45 1 1 1c.77 0 1.47-.3 2-.78.53.48 1.23.78 2 .78.55 0 1-.45 1-1s-.45-1-1-1zm-4-4H2V7h10V5H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h11v-2zm7-8h-3v2h2v6h-2v2h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"],
    "th": ["M19 1H1c-.6 0-1 .5-1 1v16c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V2c0-.5-.5-1-1-1zM7 17H2v-3h5v3zm0-4H2v-3h5v3zm0-4H2V6h5v3zm11 8H8v-3h10v3zm0-4H8v-3h10v3zm0-4H8V6h10v3z"],
    "th-derived": ["M5.3 13.3c-.2.2-.3.4-.3.7 0 .6.4 1 1 1 .3 0 .5-.1.7-.3l3-3c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-3-3C6.5 7.1 6.3 7 6 7c-.6 0-1 .4-1 1 0 .3.1.5.3.7L6.6 10H1c-.6 0-1 .4-1 1s.4 1 1 1h5.6l-1.3 1.3zM19 1H3c-.5 0-1 .5-1 1v6h1c0-1.7 1.3-3 3-3 .8 0 1.6.3 2.1.9l.1.1H9v.8l1 1V6h8v3h-6.8c.3.3.5.6.6 1H18v3h-6.8l-.1.1-.9.9H18v3h-8v-2.8l-1 1V17H4v-.8c-.6-.5-1-1.3-1-2.2H2v4c0 .5.5 1 1 1h16c.6 0 1-.5 1-1V2c0-.5-.5-1-1-1z"],
    "th-disconnect": ["M14.25 1H19c.5 0 1 .5 1 1v16c0 .5-.5 1-1 1h-7.221l.278-2H18v-3h-5.527l.14-1H18v-3h-4.971l.139-1H18V6h-4.416l.637-4.587c.02-.139.03-.277.03-.413zM8.221 1l-.694 5H2v3h5.11l-.139 1H2v3h4.555l-.14 1H2v3h3.999l-.22 1.587c-.02.139-.03.277-.03.413H1c-.6 0-1-.5-1-1V2c0-.5.4-1 1-1h7.221zM10.26.862a1 1 0 011.98.276l-2.5 18a1 1 0 01-1.98-.276l2.5-18z"],
    "th-filtered": ["M17.333 10l1.435-1.722a1 1 0 00.232-.64V4.85l1-.9V18c0 .5-.5 1-1 1H1c-.6 0-1-.5-1-1V2c0-.5.4-1 1-1h6.722L12 4.85V6H8v3h4v1H8v3h10v-3h-.667zM7 17v-3H2v3h5zm0-4v-3H2v3h5zm0-4V6H2v3h5zm11 8v-3H8v3h10z",
        "M19.35 0a.642.642 0 01.46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V4.13L11.19 1.1a.642.642 0 01.45-1.1h7.71z"],
    "th-list": ["M19 1H1c-.6 0-1 .5-1 1v16c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V2c0-.5-.5-1-1-1zm-1 16H2v-3h16v3zm0-4H2v-3h16v3zm0-4H2V6h16v3z"],
    "third-party": ["M8 0C3.58 0 0 3.58 0 8a8 8 0 005.856 7.71c.064-.057.129-.109.19-.156.278-.209.595-.383.896-.53.358-.174.81-.358 1.193-.515.206-.084.393-.16.534-.223a3.93 3.93 0 00.203-.095 4.1 4.1 0 01-.305-.45C8.382 13.911 8.19 14 8 14c-.67 0-1.36-1.1-1.73-3h1.252c.047-.296.153-.571.323-.797l.01-.203H6.12C6.05 9.39 6 8.73 6 8s.05-1.39.12-2h3.76l.037.344c.315-.145.65-.242.979-.295L10.89 6h2.76c.027.077.052.155.076.233l.118-.04A3.62 3.62 0 0114.998 6c.247 0 .51.028.772.086A8 8 0 008 0zm5.17 5h-2.44c-.21-1.11-.51-2.03-.91-2.69 1.43.46 2.61 1.43 3.35 2.69zM8 2c.67 0 1.36 1.1 1.73 3H6.27C6.64 3.1 7.33 2 8 2zm-1.82.31c-.4.66-.71 1.58-.91 2.69H2.83a6.025 6.025 0 013.35-2.69zM2 8c0-.7.13-1.37.35-2h2.76C5.04 6.62 5 7.28 5 8s.04 1.38.11 2H2.35C2.13 9.37 2 8.7 2 8zm.83 3h2.44c.21 1.11.51 2.03.91 2.69A6.025 6.025 0 012.83 11z",
        "M13.917 15.209c.21.094.444.19.685.288.912.374 1.927.789 2.188 1.355.31.722.186 1.148.186 1.148H6.026s-.13-.426.186-1.148c.256-.584 1.305-1.011 2.234-1.39.22-.088.432-.175.626-.26.909-.4.923-.662.94-.978.002-.037.004-.076.008-.115l.003-.072c.002-.025.004-.049.004-.073a3.067 3.067 0 01-.839-1.237l-.007-.007a.024.024 0 00-.003-.01 1.757 1.757 0 01-.113-.347c-.234-.042-.372-.296-.427-.537a1.045 1.045 0 01-.137-.598c.034-.35.179-.509.337-.57v-.056c0-.44.034-1.065.117-1.478a2.508 2.508 0 01.962-1.623c.426-.33 1.038-.501 1.58-.501.544 0 1.155.172 1.588.502a2.496 2.496 0 01.963 1.622c.075.413.117 1.045.117 1.478v.062c.15.062.288.22.323.564.02.268-.083.502-.138.598-.048.234-.185.488-.42.537a2.635 2.635 0 01-.116.364 3.094 3.094 0 01-.818 1.224c0 .055 0 .11.007.158.004.048.006.095.007.14.011.311.02.57.907.96z",
        "M14.976 14.57c-.24-.098-.455-.186-.65-.274l-.007-.003a3.801 3.801 0 01-.194-.091c.224-.288.41-.609.554-.946l.001-.002.013-.033c.018-.043.036-.087.052-.13l.011-.027.016-.04c.105-.092.19-.19.256-.284.129-.184.213-.38.265-.563.105-.226.225-.592.192-1.026l-.001-.011-.002-.011a1.855 1.855 0 00-.325-.91 9.924 9.924 0 00-.12-1.246 3.088 3.088 0 00-.106-.474l-.001-.007a3.543 3.543 0 00-.763-1.353c.27-.092.56-.139.83-.139.495 0 1.05.156 1.444.456a2.269 2.269 0 01.875 1.475c.069.375.106.95.106 1.344v.056c.138.056.263.2.294.513.019.244-.075.456-.125.543-.044.213-.169.444-.381.488-.025.1-.056.206-.094.3a2.815 2.815 0 01-.756 1.144c0 .05 0 .1.006.144.004.043.006.086.007.127.01.283.018.518.824.873.192.086.404.172.623.262.83.34 1.752.717 1.99 1.231.28.657.168 1.044.168 1.044h-2.081a3.864 3.864 0 00-.188-.542l-.005-.013-.006-.012c-.183-.397-.491-.681-.76-.88a5.614 5.614 0 00-.896-.522 17.36 17.36 0 00-.916-.4l-.15-.061z"],
    "thumbs-down": ["M18.55 6.56c-.31-.01-.65-.03-1.02-.06.03 0 .06-.01.09-.01.88-.12 1.68-.63 1.76-1.37.08-.75-.58-1.25-1.46-1.33-.32-.03-.65-.05-.99-.08.59-.19 1.05-.54 1.09-1.2.05-.75-.99-1.32-1.87-1.41-.34-.03-.64-.05-.91-.07h-.11c-.28-.02-.54-.02-.77-.02-3.92-.08-7.29.6-9.36 1.93v7.72c2.67 1.66 5.95 4.61 5.26 7.08-.21.76.39 1.35 1.23 1.26 1.01-.11 1.71-1.18 1.75-2.28.05-1.29-.19-2.59-.62-3.74-.05-.32.01-.65.47-.68.61-.04 1.39-.08 1.99-.1.32 0 .64-.01.94-.03h.01c.52-.03 1-.07 1.42-.12.88-.11 1.69-.6 1.79-1.35.1-.75-.55-1.25-1.44-1.35-.07-.01-.13-.02-.2-.02.21-.02.42-.04.61-.06.88-.11 1.69-.6 1.79-1.35.09-.75-.56-1.31-1.45-1.36zM3 3H0v8h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "thumbs-up": ["M3 9H0v8h3c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm16.99 3.09c-.1-.75-.91-1.24-1.79-1.35-.19-.02-.4-.05-.61-.06.07-.01.14-.01.2-.02.88-.1 1.53-.61 1.44-1.35-.1-.74-.91-1.24-1.79-1.35-.42-.05-.9-.09-1.42-.12h-.01l-.94-.03c-.6-.02-1.39-.05-1.99-.1-.45-.03-.51-.36-.47-.68.43-1.15.67-2.45.62-3.74-.04-1.11-.74-2.17-1.75-2.28-.84-.09-1.45.5-1.23 1.26.7 2.47-2.58 5.43-5.25 7.08v7.72c2.08 1.33 5.44 2.01 9.35 1.93.24 0 .49-.01.77-.02h.11c.27-.02.57-.04.91-.07.88-.08 1.92-.66 1.87-1.41-.04-.65-.5-1.01-1.09-1.2.34-.03.67-.05.99-.08.89-.08 1.55-.58 1.46-1.33-.08-.75-.88-1.25-1.76-1.37-.03 0-.06-.01-.09-.01.37-.02.71-.04 1.02-.06.91-.05 1.55-.61 1.45-1.36z"],
    "tick": ["M17 4c-.28 0-.53.11-.71.29L7 13.59 3.71 10.3A.965.965 0 003 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l10-10A1.003 1.003 0 0017 4z"],
    "tick-circle": ["M10 20C4.48 20 0 15.52 0 10S4.48 0 10 0s10 4.48 10 10-4.48 10-10 10zm5-14c-.28 0-.53.11-.71.29L8 12.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l7-7A1.003 1.003 0 0015 6z"],
    "time": ["M11 9.59V4c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L11 9.59zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"],
    "timeline-area-chart": ["M19 16H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm0-13.41l-7.07 7.07-4.3-3.44-.01.01A.987.987 0 007 6c-.24 0-.46.1-.63.24l-.01-.01L3 9.03V15h16V2.59z"],
    "timeline-bar-chart": ["M19 17H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zM9 16h2c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1zm6 0h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1zM3 16h2c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"],
    "timeline-events": ["M5 5c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zm10 0c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1s-1 .5-1 1v2c0 .6.4 1 1 1zm-9 9H4v2h2v-2zM17 3v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H7v1c0 1.1-.9 2-2 2s-2-.9-2-2V3H2c-.5 0-1 .5-1 1v14c0 .5.5 1 1 1h16c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1h-1zM7 17H3v-4h4v4zm0-5H3V8h4v4zm5 5H8v-4h4v4zm0-5H8V8h4v4zm5 5h-4v-4h4v4zm0-5h-4V8h4v4zm-6 2H9v2h2v-2zm5-5h-2v2h2V9z"],
    "timeline-line-chart": ["M19 16H2v-1.59l5-5 3.29 3.29c.18.19.43.3.71.3s.53-.11.71-.29l7-7a1.003 1.003 0 00-1.42-1.42L11 10.59l-3.29-3.3C7.53 7.11 7.28 7 7 7s-.53.11-.71.29L2 11.59V3c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "tint": ["M9.86 2S3.98 9.18 3.98 12.17C3.99 15.4 6.78 18 9.96 18c3.18-.01 6.04-2.63 6.03-5.86C15.99 9.05 9.86 2 9.86 2z"],
    "torch": ["M6.97 19c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-2h-6v2zm-3-15l3 4v8h6V8l3-4h-12zm5 5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V9zm6-9h-10c-.55 0-1 .45-1 1v2h12V1c0-.55-.45-1-1-1z"],
    "tractor": ["M4.5 11a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm11.499 1a4 4 0 110 8 4 4 0 010-8zm-11.5 1.571a1.928 1.928 0 100 3.857 1.928 1.928 0 000-3.857zM16 14.667a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666zM5.999 0C7.46 0 8.527.668 9 2l.851 4.256c1.433.096 2.82.217 4.147.362V2h2L16 6.862c.962.13 1.886.275 2.767.435.779.141 1.232.614 1.232 1.284L20 13a4.995 4.995 0 00-4-1.997A5.001 5.001 0 0011.099 15h-1.12a5.499 5.499 0 00-5.478-4.994 5.482 5.482 0 00-3.377 1.157H.004v-1.18L0 7.327c-.002-.597.37-1.18.999-1.302V1a1 1 0 011-1h4zm1 2H3v4h.75c1.386.027 2.749.073 4.079.139L6.999 2z"],
    "train": ["M16 18h-2l2 2H4l.12-.12L6 18H4c-1.1 0-2-.9-2-2V2c0-1.1 3.58-2 8-2s8 .9 8 2v14c0 1.1-.9 2-2 2zM5.5 15c.83 0 1.5-.67 1.5-1.5S6.33 12 5.5 12 4 12.67 4 13.5 4.67 15 5.5 15zM9 3H4v6h5V3zm7 0h-5v6h5V3zm-1.5 9c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"],
    "translate": ["M19.89 18.56l-4.99-10h-.01c-.17-.33-.5-.56-.89-.56s-.72.23-.89.56h-.01l-1.73 3.46-2.8-2.3 1.99-1.64C11.44 7.34 12 6.23 12 5V4h1c.55 0 1-.45 1-1s-.45-1-1-1H8V1c0-.55-.45-1-1-1S6 .45 6 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h9v1c0 .62-.28 1.18-.73 1.54L7 8.42 4.73 6.54C4.28 6.18 4 5.62 4 5H2c0 1.23.56 2.34 1.44 3.07l1.99 1.64-3.06 2.52.01.01c-.23.18-.38.45-.38.76 0 .55.45 1 1 1 .24 0 .45-.1.63-.24l.01.01L7 11l3.36 2.77.01-.01c.02.02.05.03.08.05.01 0 .01.01.02.02l-2.36 4.73h.01c-.07.13-.12.28-.12.44 0 .55.45 1 1 1 .39 0 .72-.23.89-.56h.01L11.12 17h5.76l1.22 2.45h.01c.17.32.5.55.89.55.55 0 1-.45 1-1 0-.16-.05-.31-.11-.44zM12.12 15L14 11.24 15.88 15h-3.76z"],
    "trash": ["M17 1h-5c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1H3c-.55 0-1 .45-1 1v1h16V2c0-.55-.45-1-1-1zm.5 3h-15c-.28 0-.5.22-.5.5s.22.5.5.5H3v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V5h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM7 16c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8zm4 0c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8zm4 0c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8z"],
    "tree": ["M11 15.542V20H9v-4.458L2 17l4.5-5.625L4 12l3.655-5.483L6 7l4-7 4 7-1.655-.483L16 12l-2.5-.625L18 17l-7-1.458z"],
    "trending-down": ["M19 10c-.55 0-1 .45-1 1v1.37l-6.25-7.03-.01.01A.971.971 0 0011 5c-.23 0-.42.09-.59.21l-.01-.01-3.43 2.58-5.42-3.61-.01.01A.969.969 0 001 4c-.55 0-1 .45-1 1 0 .35.19.64.46.82l-.01.01 6 4 .01-.02c.15.11.33.19.54.19.23 0 .42-.09.59-.21l.01.01 3.26-2.45L16.77 14H15c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1z"],
    "trending-up": ["M19 4h-4c-.55 0-1 .45-1 1s.45 1 1 1h1.77l-5.91 6.65L7.6 10.2l-.01.01C7.42 10.09 7.23 10 7 10c-.21 0-.39.08-.54.18l-.01-.02-6 4 .01.02c-.27.18-.46.47-.46.82 0 .55.45 1 1 1 .21 0 .39-.08.54-.18l.01.02 5.41-3.61 3.43 2.58.01-.01c.18.11.37.2.6.2.3 0 .56-.14.74-.34l.01.01L18 7.63V9c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"],
    "truck": ["M16 0a1 1 0 011 1v11a1 1 0 011 1v3h.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H17v1a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H6v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1H1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H2v-3a1 1 0 011-1V1a1 1 0 112 0v3a2 2 0 012-2h6a2 2 0 012 2V1a1 1 0 011-1zm-4 10H8a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1zm-7 4H4a1 1 0 000 2h1a1 1 0 000-2zm11 0h-1a1 1 0 000 2h1a1 1 0 000-2zm-4.5 0a.5.5 0 110 1h-3l-.09-.008A.5.5 0 018.5 14zm0-1.5a.5.5 0 110 1h-3l-.09-.008a.5.5 0 01.09-.992zm0-1.5a.5.5 0 110 1h-3l-.09-.008A.5.5 0 018.5 11zM14 5H6v3h8V5z"],
    "two-columns": ["M5 0H1C.45 0 0 .45 0 1v18c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm14.71 9.29l-3-3A1.003 1.003 0 0015 7v6a1.003 1.003 0 001.71.71l3-3c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71zM12 0H8c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "unarchive": ["M16.434 0a1 1 0 01.857.486L20 5v14a1 1 0 01-1 1H1a1 1 0 01-1-1V5L2.709.486A1 1 0 013.566 0h12.868zM10 8c-.28 0-.53.11-.71.29l-3 3-.084.096A1.003 1.003 0 007.71 12.71L9 11.41v4.58l.007.116c.058.496.482.884.993.884.55 0 1-.45 1-1v-4.58l1.29 1.29.081.073c.171.139.389.227.629.227a1.003 1.003 0 00.71-1.71l-3-3-.096-.084A1.002 1.002 0 0010 8zm6-6H4L2 5.002h16L16 2z"],
    "underline": ["M10 17c3.3 0 6-2.7 6-6V3.5c0-.8-.7-1.5-1.5-1.5S13 2.7 13 3.5V11c0 1.7-1.3 3-3 3s-3-1.3-3-3V3.5C7 2.7 6.3 2 5.5 2S4 2.7 4 3.5V11c0 3.3 2.7 6 6 6zM16.5 19h-13c-.3 0-.5.2-.5.5s.2.5.5.5h13c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"],
    "undo": ["M5 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9-9H3.41L5.7 2.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-4 4C.11 5.47 0 5.72 0 6c0 .28.11.53.29.71l4 4a1.003 1.003 0 001.42-1.42L3.41 7H14c2.21 0 4 1.79 4 4s-1.79 4-4 4H9v2h5c3.31 0 6-2.69 6-6s-2.69-6-6-6z"],
    "ungroup-objects": ["M4.5 6C2.01 6 0 8.01 0 10.5S2.01 15 4.5 15 9 12.99 9 10.5 6.99 6 4.5 6zm11 0C13.01 6 11 8.01 11 10.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5S17.99 6 15.5 6z"],
    "unknown-vehicle": ["M13 11.988v-4H4v-1l1-3h6V2.003a35.867 35.867 0 00-1-.015c-3.593 0-5.332.488-5.332.488-.67.188-1.424.864-1.674 1.503l-.004.009H3l-1 3H1a1 1 0 100 2h.333l-.28.84-.053.16v7.5a1.5 1.5 0 103 0v-.5h12v.5a1.5 1.5 0 103 0v-4.5h-5a1 1 0 01-1-1zm-8.5 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM19.83 2.782a2.392 2.392 0 00-.592-.853c-.276-.264-.64-.485-1.09-.663C17.695 1.09 17.132 1 16.457 1c-.523 0-.996.084-1.418.253a3.157 3.157 0 00-1.084.703c-.299.3-.532.656-.698 1.065-.166.41-.254.861-.264 1.353h2.096c0-.246.028-.476.085-.69.057-.214.145-.4.264-.56.119-.16.27-.287.456-.383.185-.095.406-.143.663-.143.38 0 .677.1.89.3.215.2.321.51.321.93.01.245-.035.45-.135.614-.1.164-.23.314-.392.45a8.598 8.598 0 01-.527.41 3.53 3.53 0 00-.542.485c-.171.187-.32.412-.45.676-.127.265-.206.592-.234.984v.614h1.924v-.519c.038-.273.13-.5.278-.683.147-.182.316-.343.506-.484a13.5 13.5 0 01.606-.424c.214-.14.408-.312.584-.512s.323-.442.442-.724.178-.642.178-1.079c0-.264-.059-.548-.178-.854zm-4.54 6.099v2.103h2.237V8.881H15.29z"],
    "unlock": ["M14 1c-2.21 0-4 1.79-4 4v4H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-2V5c0-1.1.9-2 2-2s2 .9 2 2v2c0 .55.45 1 1 1s1-.45 1-1V5c0-2.21-1.79-4-4-4z"],
    "unpin": ["M11.77 1.16c-.81.81-.74 2.28.02 3.76L6.1 8.71c-2.17-1.46-4.12-2-4.94-1.18l4.95 4.95-2.12 3.54 3.54-2.12 4.95 4.95c.82-.82.27-2.77-1.19-4.94l3.8-5.69c1.47.76 2.94.84 3.76.02l-7.08-7.08z"],
    "unresolve": ["M11.47 12.46c.16-.36.29-.74.38-1.14 0-.02.01-.04.01-.06.09-.4.14-.82.14-1.26 0-.44-.05-.86-.14-1.27 0-.02-.01-.04-.01-.06-.09-.4-.22-.78-.38-1.14-.01-.02-.02-.03-.02-.05a5.94 5.94 0 00-.61-1.03c0-.01-.01-.01-.01-.02a6.308 6.308 0 00-2.1-1.77c-.19-.1-.39-.18-.59-.26-.03-.01-.06-.02-.1-.03-.17-.07-.34-.12-.52-.17-.05-.01-.1-.03-.15-.04a4.34 4.34 0 00-.52-.09c-.05-.01-.11-.02-.17-.03C6.46 4.02 6.23 4 6 4c-3.31 0-6 2.69-6 6s2.69 6 6 6c.23 0 .46-.02.68-.04l.17-.03c.17-.02.34-.06.51-.09.05-.01.1-.03.15-.04.18-.05.36-.1.53-.17l.09-.03a5.973 5.973 0 002.68-2.04c0-.01.01-.01.01-.02.24-.32.44-.66.61-1.03.02-.01.03-.03.04-.05zM14 4c-.99 0-1.91.24-2.73.66a7.51 7.51 0 010 10.68c.82.42 1.74.66 2.73.66 3.31 0 6-2.69 6-6s-2.69-6-6-6z"],
    "updated": ["M10 0C6.71 0 3.82 1.6 2 4.05V2c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3.76C5.22 3.17 7.47 2 10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8c0-.55-.45-1-1-1s-1 .45-1 1c0 5.52 4.48 10 10 10s10-4.48 10-10S15.52 0 10 0zm4 7c-.28 0-.53.11-.71.29L9 11.58 6.71 9.29a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29.28 0 .53-.11.71-.29l5-5A1.003 1.003 0 0014 7z"],
    "upload": ["M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm4 10c-.28 0-.53-.11-.71-.29L11 7.41V15c0 .55-.45 1-1 1s-1-.45-1-1V7.41l-2.29 2.3a1.003 1.003 0 01-1.42-1.42l4-4c.18-.18.43-.29.71-.29s.53.11.71.29l4 4A1.003 1.003 0 0114 10z"],
    "user": ["M10 0C4.48 0 0 4.48 0 10c0 .33.02.65.05.97.01.12.03.23.05.35.03.2.05.4.09.59.03.14.06.28.1.42l.12.48c.05.16.1.31.15.46.05.13.09.27.15.4.06.16.13.32.21.48.05.11.1.22.16.33.09.17.17.34.27.5.05.09.1.17.15.25.11.18.22.35.34.52.04.06.08.11.12.17 1.19 1.62 2.85 2.86 4.78 3.53l.09.03c.46.15.93.27 1.42.36.08.01.17.03.25.04.49.07.99.12 1.5.12s1.01-.05 1.5-.12c.08-.01.17-.02.25-.04.49-.09.96-.21 1.42-.36l.09-.03c1.93-.67 3.59-1.91 4.78-3.53.04-.05.08-.1.12-.16.12-.17.23-.35.34-.53.05-.08.1-.16.15-.25.1-.17.19-.34.27-.51.05-.11.1-.21.15-.32.07-.16.14-.32.21-.49.05-.13.1-.26.14-.39.05-.15.11-.31.15-.46.05-.16.08-.32.12-.48.03-.14.07-.28.1-.42.04-.19.06-.39.09-.59.02-.12.04-.23.05-.35.05-.32.07-.64.07-.97 0-5.52-4.48-10-10-10zm0 18a7.94 7.94 0 01-6.15-2.89c.84-.44 1.86-.82 2.67-1.19 1.45-.65 1.3-1.05 1.35-1.59.01-.07.01-.14.01-.21-.51-.45-.93-1.08-1.2-1.8l-.01-.01c0-.01-.01-.02-.01-.03a4.42 4.42 0 01-.15-.48c-.33-.07-.53-.44-.61-.79-.08-.14-.23-.48-.2-.87.05-.51.26-.74.49-.83v-.08c0-.63.06-1.55.17-2.15.02-.17.06-.33.11-.5.21-.73.66-1.4 1.26-1.86.62-.47 1.5-.72 2.28-.72.78 0 1.65.25 2.27.73.6.46 1.05 1.12 1.26 1.86.05.16.08.33.11.5.11.6.17 1.51.17 2.15v.09c.22.1.42.33.46.82.04.39-.12.73-.2.87-.07.34-.27.71-.6.78-.04.16-.09.33-.15.48 0 .01-.02.05-.02.05-.26.71-.67 1.33-1.17 1.78 0 .08.01.16.01.23.05.54-.15.94 1.31 1.59.81.36 1.84.74 2.68 1.19A7.958 7.958 0 0110 18z"],
    "variable": ["M4.93 3.79a9.1 9.1 0 012.2-2.27L7.29 1c-1.38.59-2.57 1.33-3.55 2.22C2.46 4.39 1.49 5.72.83 7.23.28 8.51 0 9.81 0 11.12c0 2.28.83 4.57 2.49 6.86l.16-.55c-.49-1.23-.73-2.38-.73-3.44 0-1.67.28-3.46.84-5.36.55-1.9 1.28-3.51 2.17-4.84zm9.38 8.39l-.33-.2c-.37.54-.65.87-.82 1a.74.74 0 01-.42.12c-.19 0-.38-.12-.57-.37-.31-.42-.73-1.59-1.26-3.5.47-.85.86-1.41 1.19-1.67.23-.19.48-.29.74-.29.1 0 .28.04.53.11.26.07.48.11.68.11.27 0 .5-.1.68-.29.18-.19.27-.44.27-.75 0-.33-.09-.58-.27-.77-.18-.19-.44-.29-.78-.29-.3 0-.59.07-.86.22s-.61.47-1.02.97c-.31.37-.77 1.02-1.37 1.94a9.683 9.683 0 00-1.24-3.14l-3.24.59-.06.36c.24-.05.44-.07.61-.07.32 0 .59.14.8.43.33.45.8 1.8 1.39 4.07-.47.64-.78 1.06-.96 1.26-.28.32-.52.53-.7.62-.14.08-.3.11-.48.11-.14 0-.36-.08-.67-.23-.21-.1-.4-.15-.57-.15-.31 0-.57.11-.78.32s-.31.48-.31.8c0 .31.09.55.28.75.19.19.44.29.76.29.31 0 .6-.07.87-.2s.61-.42 1.02-.86c.41-.44.98-1.13 1.7-2.08.28.9.52 1.56.72 1.97.2.41.44.71.7.89.26.18.59.27.99.27.38 0 .77-.14 1.17-.43.54-.36 1.07-1 1.61-1.91zM17.51 1l-.15.54c.49 1.24.73 2.39.73 3.45 0 1.43-.21 2.96-.63 4.6-.33 1.26-.75 2.45-1.27 3.55-.52 1.11-1.02 1.97-1.51 2.6-.49.62-1.09 1.2-1.8 1.72l-.17.53c1.38-.59 2.57-1.34 3.55-2.23 1.29-1.17 2.26-2.5 2.91-4 .55-1.28.83-2.59.83-3.91 0-2.27-.83-4.56-2.49-6.85z"],
    "vertical-bar-chart-asc": ["M8 7H7c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM3 9H2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1zm10-5h-1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm5-4h-1c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1z"],
    "vertical-bar-chart-desc": ["M3 0H2c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm5 4H7c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm5 3h-1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm5 2h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z"],
    "vertical-distribution": ["M1 2h18c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1s.45 1 1 1zm2 5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1H3zm16 11H1c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "video": ["M19 2H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM7 14V6l6 4-6 4z"],
    "virus": ["M15.249 13.835l1.251 1.251.354-.354.087-.077a1 1 0 011.327 1.491l-2.122 2.122-.087.077a1 1 0 01-1.327-1.491l.354-.354-1.251-1.251A6.466 6.466 0 0111 16.424L10.999 18h.501a1 1 0 01.117 1.993L11.5 20h-3a1 1 0 01-.117-1.993L8.5 18h.499v-1.577a6.46 6.46 0 01-2.538-.97L5.414 16.5l.354.354a1 1 0 01-1.327 1.491l-.087-.077-2.122-2.122a1 1 0 011.327-1.491l.087.077.354.354.97-.97a6.472 6.472 0 01-1.384-3.057l-.025.002L2 11.06v.44a1 1 0 01-1.993.117L0 11.5v-3a1 1 0 011.993-.117L2 8.5v.56h1.567A6.471 6.471 0 014.97 5.883l-.971-.969-.353.354-.087.077a1 1 0 01-1.327-1.491l2.122-2.122.087-.077a1 1 0 011.327 1.491l-.354.353 1.047 1.048A6.46 6.46 0 019 3.577L9 2h-.5A1 1 0 018.383.007L8.5 0h3a1 1 0 01.117 1.993L11.5 2H11v1.577a6.466 6.466 0 012.838 1.176l.04-.046L15.086 3.5l-.353-.353a1 1 0 011.327-1.491l.087.077 2.122 2.122a1 1 0 01-1.327 1.491l-.087-.077-.354-.354-1.207 1.207-.046.041a6.467 6.467 0 011.16 2.733H18V8.5a1 1 0 011.993-.117L20 8.5v3a1 1 0 01-1.993.117L18 11.5v-.605h-1.561a6.466 6.466 0 01-1.19 2.94zM12.5 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM8 6a2 2 0 100 4 2 2 0 000-4z"],
    "volume-down": ["M15.92 3.93l-1.6 1.18A7.948 7.948 0 0116 10c0 1.84-.63 3.54-1.68 4.89l1.6 1.18A9.878 9.878 0 0018 10c0-2.29-.78-4.39-2.08-6.07zM11 3c-.28 0-.53.11-.71.29L7.59 6H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "volume-off": ["M14 3c-.28 0-.53.11-.71.29L10.59 6H6c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"],
    "volume-up": ["M9 3.43c-.28 0-.53.11-.71.29l-2.7 2.71H1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71a1.003 1.003 0 001.71-.71v-12c-.01-.55-.46-1-1.01-1zm8.31-1.56l-1.62 1.2C17.14 5.16 18 7.69 18 10.43s-.86 5.27-2.31 7.37l1.62 1.2C19 16.57 20 13.62 20 10.43c0-3.18-1-6.13-2.69-8.56zm-3.39 2.49l-1.6 1.18A7.948 7.948 0 0114 10.43c0 1.84-.63 3.54-1.68 4.89l1.6 1.18A9.94 9.94 0 0016 10.43c0-2.28-.78-4.38-2.08-6.07z"],
    "walk": ["M16 10h-2c-.23 0-.42-.09-.59-.21l-.01.01-1.69-1.27-.63 3.14 2.62 2.62c.19.18.3.43.3.71v4c0 .55-.45 1-1 1s-1-.45-1-1v-3.59L9.39 12.8l-2.45 6.55h-.01c-.14.38-.5.65-.93.65-.55 0-1-.45-1-1 0-.12.03-.24.07-.35h-.01L9.43 7h-2.9l-1.7 2.55-.01-.01c-.18.27-.47.46-.82.46-.55 0-1-.45-1-1 0-.21.08-.39.18-.54l-.01-.01 2-3 .02.01C5.36 5.19 5.65 5 6 5h4.18l.36-.96c-.33-.43-.54-.96-.54-1.54a2.5 2.5 0 015 0A2.5 2.5 0 0112.5 5c-.06 0-.12-.01-.18-.02l-.44 1.18L14.33 8H16c.55 0 1 .45 1 1s-.45 1-1 1z"],
    "warning-sign": ["M19.86 17.52l.01-.01-9-16-.01.01C10.69 1.21 10.37 1 10 1s-.69.21-.86.52l-.01-.01-9 16 .01.01c-.08.14-.14.3-.14.48 0 .55.45 1 1 1h18c.55 0 1-.45 1-1 0-.18-.06-.34-.14-.48zM11 17H9v-2h2v2zm0-3H9V6h2v8z"],
    "waterfall-chart": ["M13 7h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm-9 8h1c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm4-6h2c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm11-5h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm0 12H2V3c0-.55-.45-1-1-1s-1 .45-1 1v14a.998.998 0 001 1h18c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "waves": ["M4.948 2.682a1 1 0 00-1.897.001l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172C1.958 4.635 1.468 5 .999 5a1 1 0 000 2c1.457 0 2.442-1.027 3-1.825C4.558 5.973 5.543 7 7 7s2.442-1.027 3-1.825C10.558 5.973 11.543 7 13 7s2.442-1.027 3-1.825C16.558 5.973 17.544 7 19 7a1 1 0 100-2c-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.896 0l-.006.016a5.868 5.868 0 01-.147.364c-.11.246-.272.568-.481.882C13.958 4.635 13.469 5 13 5c-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.897 0l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172C7.958 4.635 7.468 5 6.999 5c-.47 0-.958-.365-1.418-1.055A6.05 6.05 0 014.954 2.7l-.006-.016v-.001zm0 6a1 1 0 00-1.897.001l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172c-.46.69-.95 1.055-1.419 1.055a1 1 0 100 2c1.457 0 2.442-1.027 3-1.825C4.558 11.973 5.543 13 7 13s2.442-1.027 3-1.825c.558.798 1.543 1.825 3 1.825s2.442-1.027 3-1.825c.558.798 1.544 1.825 3 1.825a1 1 0 100-2c-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.896 0l-.006.016a5.868 5.868 0 01-.147.364c-.11.246-.272.568-.481.882-.46.69-.949 1.055-1.418 1.055-.47 0-.958-.365-1.418-1.055a6.048 6.048 0 01-.628-1.246l-.006-.016a1 1 0 00-1.897 0l-.005.016-.027.074a6.05 6.05 0 01-.6 1.172c-.46.69-.95 1.055-1.419 1.055-.47 0-.958-.365-1.418-1.055A6.05 6.05 0 014.954 8.7l-.006-.016zm-1.896-6zm1.896 12l.006.017.027.074a6.053 6.053 0 00.6 1.172c.46.69.95 1.055 1.419 1.055.47 0 .958-.365 1.418-1.055a6.053 6.053 0 00.628-1.246l.005-.016a1 1 0 011.897 0l.006.016.027.074a6.051 6.051 0 00.6 1.172c.46.69.95 1.055 1.419 1.055.47 0 .958-.365 1.418-1.055a6.051 6.051 0 00.628-1.246l.006-.016a1 1 0 011.896 0l.006.016.027.074a6.051 6.051 0 00.6 1.172c.46.69.95 1.055 1.419 1.055a1 1 0 110 2c-1.456 0-2.442-1.027-3-1.825-.558.798-1.543 1.825-3 1.825s-2.442-1.027-3-1.825C9.442 17.973 8.457 19 7 19s-2.442-1.027-3-1.825C3.442 17.973 2.457 19 1 19a1 1 0 110-2c.47 0 .958-.365 1.418-1.055a6.053 6.053 0 00.628-1.246l.005-.016a1 1 0 011.897-.001z"],
    "widget": ["M18 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm15-1h2V5h-2v10zM3 5H1v10h2V5zM2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3 3h10V1H5v2zm13 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 19h10v-2H5v2z"],
    "widget-button": ["M1 4h18c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1zm1 2v8h16V6H2zm4 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"],
    "widget-footer": ["M17 0H3c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H4v-4h12v4zm0-5H4V2h12v11z"],
    "widget-header": ["M17 0H3c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 18H4V7h12v11zm0-12H4V2h12v4z"],
    "wind": ["M12 6a3 3 0 113 3H4a1 1 0 000 2h11a5 5 0 10-5-5 1 1 0 102 0zM1 12a1 1 0 100 2h10a2 2 0 110 4c-.934 0-1.803-.614-2.057-1.333a1 1 0 10-1.886.666C7.627 18.944 9.321 20 11 20a4 4 0 000-8H1z"],
    "wrench": ["M19.8 4.44L16.13 8.1l-3.55-.71-.71-3.53L15.54.21c-2.01-.53-4.23-.03-5.8 1.53-1.86 1.85-2.23 4.6-1.14 6.83L.59 16.59C.22 16.95 0 17.45 0 18a2 2 0 002 2c.55 0 1.05-.22 1.41-.59l8.03-8.04c2.23 1.05 4.97.67 6.82-1.16 1.57-1.56 2.07-3.77 1.54-5.77z"],
    "zoom-in": ["M19.56 17.44l-4.94-4.94A8.004 8.004 0 0016 8c0-4.42-3.58-8-8-8S0 3.58 0 8s3.58 8 8 8c1.67 0 3.21-.51 4.5-1.38l4.94 4.94a1.498 1.498 0 102.12-2.12zM8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm3-7H9V5c0-.55-.45-1-1-1s-1 .45-1 1v2H5c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V9h2c.55 0 1-.45 1-1s-.45-1-1-1z"],
    "zoom-out": ["M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm8.56 10.44l-4.94-4.94A8.004 8.004 0 0016 8c0-4.42-3.58-8-8-8S0 3.58 0 8s3.58 8 8 8c1.67 0 3.21-.51 4.5-1.38l4.94 4.94a1.498 1.498 0 102.12-2.12zM8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"],
    "zoom-to-fit": ["M1 7c.55 0 1-.45 1-1V2h4c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v5c0 .55.45 1 1 1zm5 1a1.003 1.003 0 00-1.71-.71l-2 2c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2 2a1.003 1.003 0 001.42-1.42L4.41 10 5.7 8.71c.19-.18.3-.43.3-.71zm2-2c.28 0 .53-.11.71-.29L10 4.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-2-2C10.53 2.11 10.28 2 10 2s-.53.11-.71.29l-2 2A1.003 1.003 0 008 6zM6 18H2v-4c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zm8-6a1.003 1.003 0 001.71.71l2-2c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71l-2-2a1.003 1.003 0 00-1.42 1.42l1.3 1.29-1.29 1.29c-.19.18-.3.43-.3.71zm5-12h-5c-.55 0-1 .45-1 1s.45 1 1 1h4v4c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1zm-7 14c-.28 0-.53.11-.71.29L10 15.59 8.71 14.3A.965.965 0 008 14a1.003 1.003 0 00-.71 1.71l2 2c.18.18.43.29.71.29s.53-.11.71-.29l2-2A1.003 1.003 0 0012 14zm7-1c-.55 0-1 .45-1 1v4h-4c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1z"],
};

/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IconSize;
(function (IconSize) {
    IconSize[IconSize["STANDARD"] = 16] = "STANDARD";
    IconSize[IconSize["LARGE"] = 20] = "LARGE";
})(IconSize || (IconSize = {}));
var Icon$2 = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var icon = this.props.icon;
        if (icon == null || typeof icon === "boolean") {
            return null;
        }
        else if (typeof icon !== "string") {
            return icon;
        }
        var _a = this.props, className = _a.className, color = _a.color, htmlTitle = _a.htmlTitle, 
        // eslint-disable-next-line deprecation/deprecation
        iconSize = _a.iconSize, intent = _a.intent, _b = _a.size, size = _b === void 0 ? iconSize !== null && iconSize !== void 0 ? iconSize : IconSize.STANDARD : _b, title = _a.title, _c = _a.tagName, tagName = _c === void 0 ? "span" : _c, htmlprops = __rest(_a, ["className", "color", "htmlTitle", "iconSize", "intent", "size", "title", "tagName"]);
        // choose which pixel grid is most appropriate for given icon size
        var pixelGridSize = size >= IconSize.LARGE ? IconSize.LARGE : IconSize.STANDARD;
        // render path elements, or nothing if icon name is unknown.
        var paths = this.renderSvgPaths(pixelGridSize, icon);
        // eslint-disable-next-line deprecation/deprecation
        var classes = classNames$1(ICON, iconClass(icon), intentClass(intent), className);
        var viewBox = "0 0 ".concat(pixelGridSize, " ").concat(pixelGridSize);
        return React.createElement(tagName, __assign(__assign({}, htmlprops), { "aria-hidden": title ? undefined : true, className: classes, title: htmlTitle }), React.createElement("svg", { fill: color, "data-icon": icon, width: size, height: size, viewBox: viewBox },
            title && React.createElement("desc", null, title),
            paths));
    };
    /** Render `<path>` elements for the given icon name. Returns `null` if name is unknown. */
    Icon.prototype.renderSvgPaths = function (pathsSize, iconName) {
        var svgPathsRecord = pathsSize === IconSize.STANDARD ? IconSvgPaths16 : IconSvgPaths20;
        var pathStrings = svgPathsRecord[iconName];
        if (pathStrings == null) {
            return null;
        }
        return pathStrings.map(function (d, i) { return React.createElement("path", { key: i, d: d, fillRule: "evenodd" }); });
    };
    Icon.displayName = "".concat(DISPLAYNAME_PREFIX, ".Icon");
    /** @deprecated use IconSize.STANDARD */
    Icon.SIZE_STANDARD = IconSize.STANDARD;
    /** @deprecated use IconSize.LARGE */
    Icon.SIZE_LARGE = IconSize.LARGE;
    Icon = __decorate([
        polyfill
    ], Icon);
    return Icon;
}(AbstractPureComponent2));

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize[SpinnerSize["SMALL"] = 20] = "SMALL";
    SpinnerSize[SpinnerSize["STANDARD"] = 50] = "STANDARD";
    SpinnerSize[SpinnerSize["LARGE"] = 100] = "LARGE";
})(SpinnerSize || (SpinnerSize = {}));
// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
var R = 45;
var SPINNER_TRACK = "M 50,50 m 0,-".concat(R, " a ").concat(R, ",").concat(R, " 0 1 1 0,").concat(R * 2, " a ").concat(R, ",").concat(R, " 0 1 1 0,-").concat(R * 2);
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
var PATH_LENGTH = 280;
var MIN_SIZE = 10;
var STROKE_WIDTH = 4;
var MIN_STROKE_WIDTH = 16;
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value) {
            // IE/Edge: re-render after changing value to force SVG update
            this.forceUpdate();
        }
    };
    Spinner.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, intent = _b.intent, value = _b.value, _c = _b.tagName, tagName = _c === void 0 ? "div" : _c;
        var size = this.getSize();
        var classes = classNames$1(SPINNER, intentClass(intent), (_a = {}, _a[SPINNER_NO_SPIN] = value != null, _a), className);
        // keep spinner track width consistent at all sizes (down to about 10px).
        var strokeWidth = Math.min(MIN_STROKE_WIDTH, (STROKE_WIDTH * SpinnerSize.LARGE) / size);
        var strokeOffset = PATH_LENGTH - PATH_LENGTH * (value == null ? 0.25 : clamp(value, 0, 1));
        // multiple DOM elements around SVG are necessary to properly isolate animation:
        // - SVG elements in IE do not support anim/trans so they must be set on a parent HTML element.
        // - SPINNER_ANIMATION isolates svg from parent display and is always centered inside root element.
        return React.createElement(tagName, {
            className: classes,
            role: "progressbar",
        }, React.createElement(tagName, { className: SPINNER_ANIMATION }, React.createElement("svg", { width: size, height: size, strokeWidth: strokeWidth.toFixed(2), viewBox: this.getViewBox(strokeWidth) },
            React.createElement("path", { className: SPINNER_TRACK$1, d: SPINNER_TRACK }),
            React.createElement("path", { className: SPINNER_HEAD, d: SPINNER_TRACK, pathLength: PATH_LENGTH, strokeDasharray: "".concat(PATH_LENGTH, " ").concat(PATH_LENGTH), strokeDashoffset: strokeOffset }))));
    };
    Spinner.prototype.validateProps = function (_a) {
        var _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size != null && (className.indexOf(SMALL) >= 0 || className.indexOf(LARGE) >= 0)) {
            console.warn(SPINNER_WARN_CLASSES_SIZE);
        }
    };
    /**
     * Resolve size to a pixel value.
     * Size can be set by className, props, default, or minimum constant.
     */
    Spinner.prototype.getSize = function () {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? "" : _b, size = _a.size;
        if (size == null) {
            // allow Classes constants to determine default size.
            if (className.indexOf(SMALL) >= 0) {
                return SpinnerSize.SMALL;
            }
            else if (className.indexOf(LARGE) >= 0) {
                return SpinnerSize.LARGE;
            }
            return SpinnerSize.STANDARD;
        }
        return Math.max(MIN_SIZE, size);
    };
    /** Compute viewbox such that stroked track sits exactly at edge of image frame. */
    Spinner.prototype.getViewBox = function (strokeWidth) {
        var radius = R + strokeWidth / 2;
        var viewBoxX = (50 - radius).toFixed(2);
        var viewBoxWidth = (radius * 2).toFixed(2);
        return "".concat(viewBoxX, " ").concat(viewBoxX, " ").concat(viewBoxWidth, " ").concat(viewBoxWidth);
    };
    Spinner.displayName = "".concat(DISPLAYNAME_PREFIX, ".Spinner");
    /** @deprecated use SpinnerSize.SMALL */
    Spinner.SIZE_SMALL = SpinnerSize.SMALL;
    /** @deprecated use SpinnerSize.STANDARD */
    Spinner.SIZE_STANDARD = SpinnerSize.STANDARD;
    /** @deprecated use SpinnerSize.LARGE */
    Spinner.SIZE_LARGE = SpinnerSize.LARGE;
    Spinner = __decorate([
        polyfill
    ], Spinner);
    return Spinner;
}(AbstractPureComponent2));

/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AbstractButton = /** @class */ (function (_super) {
    __extends(AbstractButton, _super);
    function AbstractButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false,
        };
        // we're casting as `any` to get around a somewhat opaque safeInvoke error
        // that "Type argument candidate 'KeyboardEvent<T>' is not a valid type
        // argument because it is not a supertype of candidate
        // 'KeyboardEvent<HTMLElement>'."
        _this.handleKeyDown = function (e) {
            var _a, _b;
            // HACKHACK: https://github.com/palantir/blueprint/issues/4165
            /* eslint-disable deprecation/deprecation */
            if (isKeyboardClick(e.which)) {
                e.preventDefault();
                if (e.which !== _this.currentKeyDown) {
                    _this.setState({ isActive: true });
                }
            }
            _this.currentKeyDown = e.which;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleKeyUp = function (e) {
            var _a, _b, _c;
            // HACKHACK: https://github.com/palantir/blueprint/issues/4165
            /* eslint-disable deprecation/deprecation */
            if (isKeyboardClick(e.which)) {
                _this.setState({ isActive: false });
                (_a = _this.buttonRef) === null || _a === void 0 ? void 0 : _a.click();
            }
            _this.currentKeyDown = undefined;
            (_c = (_b = _this.props).onKeyUp) === null || _c === void 0 ? void 0 : _c.call(_b, e);
        };
        _this.handleBlur = function (e) {
            var _a, _b;
            if (_this.state.isActive) {
                _this.setState({ isActive: false });
            }
            (_b = (_a = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        return _this;
    }
    AbstractButton.prototype.getCommonButtonProps = function () {
        var _a;
        var _b = this.props, active = _b.active, alignText = _b.alignText, fill = _b.fill, large = _b.large, loading = _b.loading, outlined = _b.outlined, minimal = _b.minimal, small = _b.small, tabIndex = _b.tabIndex;
        var disabled = this.props.disabled || loading;
        var className = classNames$1(BUTTON, (_a = {},
            _a[ACTIVE] = !disabled && (active || this.state.isActive),
            _a[DISABLED] = disabled,
            _a[FILL] = fill,
            _a[LARGE] = large,
            _a[LOADING] = loading,
            _a[MINIMAL] = minimal,
            _a[OUTLINED] = outlined,
            _a[SMALL] = small,
            _a), alignmentClass(alignText), intentClass(this.props.intent), this.props.className);
        return {
            className: className,
            disabled: disabled,
            onBlur: this.handleBlur,
            onClick: disabled ? undefined : this.props.onClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            tabIndex: disabled ? -1 : tabIndex,
        };
    };
    AbstractButton.prototype.renderChildren = function () {
        var _a = this.props, children = _a.children, icon = _a.icon, loading = _a.loading, rightIcon = _a.rightIcon, text = _a.text;
        var maybeHasText = !isReactNodeEmpty(text) || !isReactNodeEmpty(children);
        return [
            loading && React.createElement(Spinner, { key: "loading", className: BUTTON_SPINNER, size: IconSize.LARGE }),
            // The icon is purely decorative if text is provided
            React.createElement(Icon$2, { key: "leftIcon", icon: icon, "aria-hidden": maybeHasText, tabIndex: maybeHasText ? -1 : 0 }),
            maybeHasText && (React.createElement("span", { key: "text", className: BUTTON_TEXT },
                text,
                children)),
            React.createElement(Icon$2, { key: "rightIcon", icon: rightIcon }),
        ];
    };
    return AbstractButton;
}(AbstractPureComponent2));

/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // need to keep this ref so that we can access it in AbstractButton#handleKeyUp
        _this.buttonRef = null;
        _this.handleRef = refHandler(_this, "buttonRef", _this.props.elementRef);
        return _this;
    }
    Button.prototype.render = function () {
        return (React.createElement("button", __assign({ type: "button", ref: this.handleRef }, removeNonHTMLProps(this.props), this.getCommonButtonProps()), this.renderChildren()));
    };
    Button.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.elementRef !== this.props.elementRef) {
            setRef(prevProps.elementRef, null);
            this.handleRef = refHandler(this, "buttonRef", this.props.elementRef);
            setRef(this.props.elementRef, this.buttonRef);
        }
    };
    Button.displayName = "".concat(DISPLAYNAME_PREFIX, ".Button");
    return Button;
}(AbstractButton));
/** @class */ ((function (_super) {
    __extends(AnchorButton, _super);
    function AnchorButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // need to keep this ref so that we can access it in AbstractButton#handleKeyUp
        _this.buttonRef = null;
        _this.handleRef = refHandler(_this, "buttonRef", _this.props.elementRef);
        return _this;
    }
    AnchorButton.prototype.render = function () {
        var _a = this.props, href = _a.href, _b = _a.tabIndex, tabIndex = _b === void 0 ? 0 : _b;
        var commonProps = this.getCommonButtonProps();
        return (React.createElement("a", __assign({ role: "button", ref: this.handleRef }, removeNonHTMLProps(this.props), commonProps, { href: commonProps.disabled ? undefined : href, tabIndex: commonProps.disabled ? -1 : tabIndex }), this.renderChildren()));
    };
    AnchorButton.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.elementRef !== this.props.elementRef) {
            setRef(prevProps.elementRef, null);
            this.handleRef = refHandler(this, "buttonRef", this.props.elementRef);
            setRef(this.props.elementRef, this.buttonRef);
        }
    };
    AnchorButton.displayName = "".concat(DISPLAYNAME_PREFIX, ".AnchorButton");
    return AnchorButton;
})(AbstractButton));

var _excluded$5 = ["query", "onQueryChange", "className", "placeholder", "isLoading", "showSubText", "customMenuTextName", "customSubTextName", "noResultsText", "showIcon", "onItemSelect", "inputValueRenderer", "selectedItem"];

var AutoSuggest = function AutoSuggest(_ref) {
  var query = _ref.query,
      onQueryChange = _ref.onQueryChange,
      className = _ref.className,
      placeholder = _ref.placeholder,
      isLoading = _ref.isLoading,
      showSubText = _ref.showSubText,
      customMenuTextName = _ref.customMenuTextName,
      customSubTextName = _ref.customSubTextName,
      noResultsText = _ref.noResultsText,
      showIcon = _ref.showIcon,
      onItemSelect = _ref.onItemSelect,
      inputValueRenderer = _ref.inputValueRenderer,
      selectedItem = _ref.selectedItem,
      props = _objectWithoutProperties$2(_ref, _excluded$5);

  var _useState = useState(query !== null && query !== void 0 ? query : ''),
      _useState2 = _slicedToArray$1(_useState, 2),
      queryTerm = _useState2[0],
      setQueryTerm = _useState2[1];

  var handleSelected = function handleSelected(item, e) {
    onItemSelect === null || onItemSelect === void 0 ? void 0 : onItemSelect(item, e);
  };

  var handleQuery = function handleQuery(value, e) {
    onQueryChange === null || onQueryChange === void 0 ? void 0 : onQueryChange(value, e);
    setQueryTerm(value);
  };

  var handleClear = function handleClear() {
    handleSelected(null);
    handleQuery('');
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames$1('AutoSuggestComponent', className)
  }, /*#__PURE__*/React__default.createElement(AutoSuggest$1, _extends$2({
    query: queryTerm,
    onQueryChange: handleQuery,
    onItemSelect: handleSelected,
    selectedItem: selectedItem,
    itemRenderer: function itemRenderer(item, itemProps) {
      return /*#__PURE__*/React__default.createElement(MenuItem, {
        className: classNames$1('autosuggest__item', itemProps.modifiers.active && 'active'),
        onClick: itemProps.handleClick,
        key: item.id,
        text: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, customMenuTextName ? customMenuTextName(item) : item.name, showSubText && /*#__PURE__*/React__default.createElement("div", {
          className: "autosuggest__sub_text"
        }, customSubTextName ? customSubTextName(item) : item.type))
      });
    },
    inputValueRenderer: inputValueRenderer !== null && inputValueRenderer !== void 0 ? inputValueRenderer : function (item) {
      return item.name;
    },
    noResults: queryTerm && !isLoading ? /*#__PURE__*/React__default.createElement(MenuItem, {
      disabled: true,
      text: noResultsText !== null && noResultsText !== void 0 ? noResultsText : i18n.t('noResultsFound')
    }) : null,
    inputProps: {
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : i18n.t('search'),
      rightElement: showIcon ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (queryTerm || selectedItem) && !isLoading ? /*#__PURE__*/React__default.createElement(BaseButton$1, {
        iconName: "CancelIcon",
        buttonType: "secondary",
        className: "rightElementClear",
        onClick: handleClear
      }) : isLoading ? /*#__PURE__*/React__default.createElement(Button, {
        icon: "refresh",
        loading: true,
        minimal: true
      }) : /*#__PURE__*/React__default.createElement(BaseButton$1, {
        iconName: "SearchIcon",
        buttonType: "secondary",
        className: "rightElementSearch"
      })) : null
    }
  }, props)));
};

var ActionMenu = function ActionMenu(props) {
  return /*#__PURE__*/React__default.createElement(ActionMenu$1, props);
};

var MARKERS = ['FFEC', 'FFMC'];
var KDMStatuses = {
  success: 'success',
  emailed: 'emailed',
  inprogress: 'inprogress',
  action_required: 'action_required',
  failed: 'failed',
  generated: 'generated',
  unavailable: 'unavailable',
  inProgress: 'inProgress',
  expired: 'expired',
  expiring: 'expiring'
};
var IngestStatuses = {
  pendingingest: 'PendingIngest',
  ingestinprogress: 'IngestInProgress',
  ingestfailed: 'IngestFailed',
  ingestcancelled: 'IngestCancelled',
  ingested: 'Ingested'
};
var IngestStatusValues = {
  pendingingest: 'Pending Ingest',
  ingestinprogress: 'Ingest in Progress',
  ingestfailed: 'Ingest Failed',
  ingestcancelled: 'Ingest Cancelled',
  ingested: 'Ingested'
};
var ShipmentStatusValues = {
  Pending: 'Pending',
  InfoReceived: 'In Transit',
  InTransit: 'In Transit',
  OutForDelivery: 'Out For Delivery',
  AttemptFail: 'Delivery Attempt Failed',
  Delivered: 'Delivered',
  Exception: 'Delivery Exception',
  Expired: 'Expired'
};
var ShipmentStatuses = {
  Pending: 'Pending',
  InfoReceived: 'InfoReceived',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  AttemptFail: 'AttemptFail',
  Delivered: 'Delivered',
  Exception: 'Exception',
  Expired: 'Expired'
};
var DCPStatuses = {
  dispatched: 'dispatched',
  executing: 'executing',
  queued: 'queued',
  failed: 'failed',
  error: 'error',
  succeeded: 'succeeded',
  cancelled: 'cancelled',
  scheduled: 'scheduled',
  downloading: 'downloading',
  downloaded: 'downloaded',
  expired: 'expired',
  pending: 'pending',
  delivered: 'delivered',
  pending_cancellation: 'pending_cancellation',
  unarchiving: 'unarchiving',
  downloading_unarchiving: 'downloading_unarchiving',
  pending_fulfilment_unarchiving: 'pending_fulfilment_unarchiving',
  archived: 'archived',
  downloading_archived: 'downloading_archived',
  pending_fulfilment_archived: 'pending_fulfilment_archived',
  stalled: 'stalled',
  downloading_stalled: 'downloading_stalled',
  pending_fulfilment_stalled: 'pending_fulfilment_stalled'
};
var DCPStatusValues = {
  downloaded: 'Downloaded',
  pending: 'Pending',
  cancelled: 'Cancelled',
  dispatched: 'Shipped',
  pending_cancellation: 'Pending Cancellation',
  queued: 'Queued',
  failed: 'Failed',
  error: 'Failed',
  succeeded: 'Succeeded',
  executing: 'Downloading...',
  scheduled: 'Scheduled for Download',
  downloading: 'Downloading...',
  expired: 'Failed',
  intransit: 'In Transit',
  outfordelivery: 'Out For Delivery',
  attemptfail: 'Delivery AttemptFail',
  delivered: 'Delivered',
  exception: 'Delivery Exception',
  unarchiving: 'Unarchiving',
  archived: 'Archived',
  stalled: 'Stalled'
};
var ApplianceColumn = {
  serialNo: 'Serial No',
  theatres: 'Theatres',
  chain: 'Chain',
  bandwidth: 'Bandwidth',
  publicIP: 'Public IP',
  osVersion: 'OS Version',
  downloadStatus: 'Download Status',
  status: 'Status'
};
var MatchedBy = {
  screenId: 'Screen ID',
  theatreDetails: 'Theatre Details',
  theatreId: 'Theatre ID'
};
var WorkOrderStatuses = {
  ASSIGNED: 'assigned',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled'
};
var WorkOrderStatusLabel = {
  assigned: 'Assigned',
  approved: 'Approved',
  rejected: 'Rejected',
  cancelled: 'Cancelled'
};
var DcpUploadStatuses = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  NOT_STARTED: 'not_started'
};
var DcpTransferStatuses = {
  STARTED: 'started',
  COMPLETED: 'completed'
};
var WorkOrderItemsFilterValues = {
  ARCHIVE: 'archive',
  ACTIVE: 'active',
  CURRENT: 'current',
  PAST: 'past'
};
var WorkOrderItemsFilterTagKeys = {
  BOOKING: 'booking',
  PARTNER: 'partner',
  WORK_ORDER: 'workorder',
  COMPOSITION: 'composition'
};
var DcpTransferStatusOptions = [{
  name: 'Started',
  type: DcpTransferStatuses.STARTED
}, {
  name: 'Completed',
  type: DcpTransferStatuses.COMPLETED
}];
var PartnerTypeKeys = {
  MANUAL: 'Manual',
  OFFLINE: 'Offline'
};
var DcpDownloadStatuses = {
  NOT_STARTED: 'not_started',
  QUEUED: 'queued',
  IN_PROGRESS: 'in_progress',
  DOWNLOADING: 'downloading',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DOWNLOADED: 'downloaded',
  EXPIRED: 'expired',
  SCHEDULED: 'scheduled',
  PENDING: 'pending',
  ERROR: 'error',
  UNARCHIVING: 'unarchiving',
  ARCHIVED: 'archived',
  STALLED: 'stalled'
};
var BayStatuses = {
  EMPTY: 'empty',
  INSERTED: 'inserted',
  COPYING: 'copying',
  COPY_COMPLETE: 'copy_complete',
  ERROR: 'error',
  AVAILABLE: 'available',
  BUSY: 'busy',
  QUEUED: 'queued'
};
var DuplicationProgress = {
  QUEUED: 'queued',
  SUCCEEDED: 'succeeded',
  EXECUTING: 'executing',
  FAILED: 'failed',
  PREPARING: 'preparing',
  FORMATTING: 'formatting',
  DUPLICATING: 'duplicating',
  VERIFYING: 'verifying'
};
var DuplicationProgressStatuses = [DuplicationProgress.PREPARING, DuplicationProgress.FORMATTING, DuplicationProgress.VERIFYING, DuplicationProgress.DUPLICATING, DuplicationProgress.EXECUTING];
var ShippingTabColumns = {
  ADDRESS: 'address',
  DELIVERY_INSTRUCTIONS: 'deliveryInstructions',
  DELIVER_BY: 'deliverBy',
  SHIP_BY: 'shipBy',
  SHIPPING_INFO: 'shippingInfo',
  SHIPPED: 'shipped',
  ORDINAL: 'ordinal',
  STATUS: 'status'
};
var SHIPMENT_STATUS_DISPATCHED = 'dispatched';
var DeliveryMode = {
  PARTNERS: 'PARTNERS',
  ELECTRONIC: 'ELECTRONIC'
};
var DeliveryTypes = {
  HARD_DRIVE: 'HARD_DRIVE',
  SATELLITE: 'SATELLITE',
  INTERNET: 'INTERNET'
};
var WorkOrderTabs = {
  DUPLICATION: 'duplication',
  DELIVERY: 'delivery'
};
var PartnerTypes = {
  MANUAL: 'Manual',
  OFFLINE: 'Offline',
  ONLINE: 'Online'
};
var ShippingStatus = {
  PENDING: 'pending',
  DISPATCHED: 'dispatched',
  CANCELLED: 'cancelled',
  PENDING_CANCELLATION: 'pending_cancellation',
  REJECTED: 'rejected',
  DELIVERED: 'delivered'
};
var FilterLabels = {
  chain: 'Chain',
  ipAddress: 'IP Address',
  theatre: 'Theatre',
  city: 'City',
  province: 'Province',
  country: 'Country',
  serialNumber: 'Serial Number',
  osVersion: 'OS Version',
  status: 'Appliance Status',
  partner: 'Partner'
};
var FilterTypes = {
  chain: 'chain',
  ipAddress: 'ipAddress',
  theatre: 'theatre',
  city: 'city',
  province: 'province',
  country: 'country',
  serialNumber: 'serialNumber',
  osVersion: 'osVersion',
  status: 'status',
  partner: 'partner'
};
var ComponentTypes = {
  list: 'List',
  multiselect: 'MultiSelect'
};
var WorkOrderTagList = {
  BOOKING: 'booking',
  PARTNER: 'partner',
  WORK_ORDER: 'workorder',
  COMPOSITION: 'composition'
};
var WorkOrderDeliveryType = {
  HARD_DRIVE: 'HARD_DRIVE',
  SATELLITE: 'SATELLITE',
  INTERNET: 'INTERNET'
};
var WorkOrderDeliveryLabel = {
  HARD_DRIVE: 'Hard Drive',
  SATELLITE: 'Satellite',
  INTERNET: 'Internet'
};
var WorkOrderTypes = {
  CURRENT: 'current',
  PAST: 'past'
};
var ApplianceTypes = {
  PARTNER: 'partner',
  THEATRE: 'theatre',
  FESTIVAL: 'festival'
};
var DCPDeliveryType = {
  // Imported from qw-ui-lib Old only used for CompositionList (Organism)
  THEATRE_APPLIANCE: 'THEATRE_APPLIANCE',
  PARTNERS: 'partners',
  ELECTRONIC: 'ELECTRONIC'
};
var DeliveryType = {
  THEATRE_APPLIANCE: 'theatre_appliance',
  PARTNER: 'partners',
  ELECTRONIC: 'electronic'
};
var DCPDeliveryEventOrder = {
  booked: 1,
  planned: 2
};
var CPLAttributes = {
  type: 1,
  resolution: 2,
  stereoType: 3,
  aspectRatio: 4,
  audioFormats: 5,
  language: 6,
  subtitleLanguage: 7,
  closedCaptions: 8,
  ratings: 9
};

var enums = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MARKERS: MARKERS,
  KDMStatuses: KDMStatuses,
  IngestStatuses: IngestStatuses,
  IngestStatusValues: IngestStatusValues,
  ShipmentStatusValues: ShipmentStatusValues,
  ShipmentStatuses: ShipmentStatuses,
  DCPStatuses: DCPStatuses,
  DCPStatusValues: DCPStatusValues,
  ApplianceColumn: ApplianceColumn,
  MatchedBy: MatchedBy,
  WorkOrderStatuses: WorkOrderStatuses,
  WorkOrderStatusLabel: WorkOrderStatusLabel,
  DcpUploadStatuses: DcpUploadStatuses,
  DcpTransferStatuses: DcpTransferStatuses,
  WorkOrderItemsFilterValues: WorkOrderItemsFilterValues,
  WorkOrderItemsFilterTagKeys: WorkOrderItemsFilterTagKeys,
  DcpTransferStatusOptions: DcpTransferStatusOptions,
  PartnerTypeKeys: PartnerTypeKeys,
  DcpDownloadStatuses: DcpDownloadStatuses,
  BayStatuses: BayStatuses,
  DuplicationProgress: DuplicationProgress,
  DuplicationProgressStatuses: DuplicationProgressStatuses,
  ShippingTabColumns: ShippingTabColumns,
  SHIPMENT_STATUS_DISPATCHED: SHIPMENT_STATUS_DISPATCHED,
  DeliveryMode: DeliveryMode,
  DeliveryTypes: DeliveryTypes,
  WorkOrderTabs: WorkOrderTabs,
  PartnerTypes: PartnerTypes,
  ShippingStatus: ShippingStatus,
  FilterLabels: FilterLabels,
  FilterTypes: FilterTypes,
  ComponentTypes: ComponentTypes,
  WorkOrderTagList: WorkOrderTagList,
  WorkOrderDeliveryType: WorkOrderDeliveryType,
  WorkOrderDeliveryLabel: WorkOrderDeliveryLabel,
  WorkOrderTypes: WorkOrderTypes,
  ApplianceTypes: ApplianceTypes,
  DCPDeliveryType: DCPDeliveryType,
  DeliveryType: DeliveryType,
  DCPDeliveryEventOrder: DCPDeliveryEventOrder,
  CPLAttributes: CPLAttributes
});

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var camelize = function(obj) {
    if (typeof obj === 'string') return camelCase$1(obj);
    return walk(obj);
};

function walk (obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (isDate$1(obj) || isRegex(obj)) return obj;
    if (isArray$2(obj)) return map(obj, walk);
    return reduce(objectKeys(obj), function (acc, key) {
        var camel = camelCase$1(key);
        acc[camel] = walk(obj[key]);
        return acc;
    }, {});
}

function camelCase$1(str) {
    return str.replace(/[_.-](\w|$)/g, function (_,x) {
        return x.toUpperCase();
    });
}

var isArray$2 = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
};

var isDate$1 = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Date]';
};

var isRegex = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var has = Object.prototype.hasOwnProperty;
var objectKeys = Object.keys || function (obj) {
    var keys = [];
    for (var key in obj) {
        if (has.call(obj, key)) keys.push(key);
    }
    return keys;
};

function map (xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        res.push(f(xs[i], i));
    }
    return res;
}

function reduce (xs, f, acc) {
    if (xs.reduce) return xs.reduce(f, acc);
    for (var i = 0; i < xs.length; i++) {
        acc = f(acc, xs[i], i);
    }
    return acc;
}

/*! Moment Duration Format v1.3.0
 *  https://github.com/jsmreese/moment-duration-format 
 *  Date: 2014-07-15
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2014 John Madhavan-Reese
 *  Released under the MIT license
 */

(function (root, undefined$1) {

	// repeatZero(qty)
	// returns "0" repeated qty times
	function repeatZero(qty) {
		var result = "";
		
		// exit early
		// if qty is 0 or a negative number
		// or doesn't coerce to an integer
		qty = parseInt(qty, 10);
		if (!qty || qty < 1) { return result; }
		
		while (qty) {
			result += "0";
			qty -= 1;
		}
		
		return result;
	}
	
	// padZero(str, len [, isRight])
	// pads a string with zeros up to a specified length
	// will not pad a string if its length is aready
	// greater than or equal to the specified length
	// default output pads with zeros on the left
	// set isRight to `true` to pad with zeros on the right
	function padZero(str, len, isRight) {
		if (str == null) { str = ""; }
		str = "" + str;
		
		return (isRight ? str : "") + repeatZero(len - str.length) + (isRight ? "" : str);
	}
	
	// isArray
	function isArray(array) {
		return Object.prototype.toString.call(array) === "[object Array]";
	}
	
	// isObject
	function isObject(obj) {
		return Object.prototype.toString.call(obj) === "[object Object]";
	}
	
	// findLast
	function findLast(array, callback) {
		var index = array.length;

		while (index -= 1) {
			if (callback(array[index])) { return array[index]; }
		}
	}

	// find
	function find(array, callback) {
		var index = 0,
			max = array.length,
			match;
			
		if (typeof callback !== "function") {
			match = callback;
			callback = function (item) {
				return item === match;
			};
		}

		while (index < max) {
			if (callback(array[index])) { return array[index]; }
			index += 1;
		}
	}
	
	// each
	function each(array, callback) {
		var index = 0,
			max = array.length;
			
		if (!array || !max) { return; }

		while (index < max) {
			if (callback(array[index], index) === false) { return; }
			index += 1;
		}
	}
	
	// map
	function map(array, callback) {
		var index = 0,
			max = array.length,
			ret = [];

		if (!array || !max) { return ret; }
				
		while (index < max) {
			ret[index] = callback(array[index], index);
			index += 1;
		}
		
		return ret;
	}
	
	// pluck
	function pluck(array, prop) {
		return map(array, function (item) {
			return item[prop];
		});
	}
	
	// compact
	function compact(array) {
		var ret = [];
		
		each(array, function (item) {
			if (item) { ret.push(item); }
		});
		
		return ret;
	}
	
	// unique
	function unique(array) {
		var ret = [];
		
		each(array, function (_a) {
			if (!find(ret, _a)) { ret.push(_a); }
		});
		
		return ret;
	}
	
	// intersection
	function intersection(a, b) {
		var ret = [];
		
		each(a, function (_a) {
			each(b, function (_b) {
				if (_a === _b) { ret.push(_a); }
			});
		});
		
		return unique(ret);
	}
	
	// rest
	function rest(array, callback) {
		var ret = [];
		
		each(array, function (item, index) {
			if (!callback(item)) {
				ret = array.slice(index);
				return false;
			}
		});
		
		return ret;
	}

	// initial
	function initial(array, callback) {
		var reversed = array.slice().reverse();
		
		return rest(reversed, callback).reverse();
	}
	
	// extend
	function extend(a, b) {
		for (var key in b) {
			if (b.hasOwnProperty(key)) { a[key] = b[key]; }
		}
		
		return a;
	}
			
	// define internal moment reference
	var moment$1;

	if (typeof commonjsRequire === "function") {
		try { moment$1 = moment; } 
		catch (e) {}
	} 
	
	if (!moment$1 && root.moment) {
		moment$1 = root.moment;
	}
	
	if (!moment$1) {
		throw "Moment Duration Format cannot find Moment.js";
	}
	
	// moment.duration.format([template] [, precision] [, settings])
	moment$1.duration.fn.format = function () {

		var tokenizer, tokens, types, typeMap, momentTypes, foundFirst, args = [].slice.call(arguments),
			settings = extend({}, this.format.defaults),
			// keep a shadow copy of this moment for calculating remainders
			remainder = moment$1.duration(this);

		// add a reference to this duration object to the settings for use
		// in a template function
		settings.duration = this;

		// parse arguments
		each(args, function (arg) {
			if (typeof arg === "string" || typeof arg === "function") {
				settings.template = arg;
				return;
			}

			if (typeof arg === "number") {
				settings.precision = arg;
				return;
			}

			if (isObject(arg)) {
				extend(settings, arg);
			}
		});

		// types
		types = settings.types = (isArray(settings.types) ? settings.types : settings.types.split(" "));

		// template
		if (typeof settings.template === "function") {
			settings.template = settings.template.apply(settings);
		}

		// tokenizer regexp
		tokenizer = new RegExp(map(types, function (type) {
			return settings[type].source;
		}).join("|"), "g");

		// token type map function
		typeMap = function (token) {
			return find(types, function (type) {
				return settings[type].test(token);
			});
		};

		// tokens array
		tokens = map(settings.template.match(tokenizer), function (token, index) {
			var type = typeMap(token),
				length = token.length;

			return {
				index: index,
				length: length,

				// replace escaped tokens with the non-escaped token text
				token: (type === "escape" ? token.replace(settings.escape, "$1") : token),

				// ignore type on non-moment tokens
				type: ((type === "escape" || type === "general") ? null : type)

				// calculate base value for all moment tokens
				//baseValue: ((type === "escape" || type === "general") ? null : this.as(type))
			};
		});

		// unique moment token types in the template (in order of descending magnitude)
		momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));

		// exit early if there are no momentTypes
		if (!momentTypes.length) {
			return pluck(tokens, "token").join("");
		}

		// calculate values for each token type in the template
		each(momentTypes, function (momentType, index) {
			var value, wholeValue, decimalValue, isLeast, isMost;

			// calculate integer and decimal value portions
			value = remainder.as(momentType);
			wholeValue = (value > 0 ? Math.floor(value) : Math.ceil(value));
			decimalValue = value - wholeValue;

			// is this the least-significant moment token found?
			isLeast = ((index + 1) === momentTypes.length);

			// is this the most-significant moment token found?
			isMost = (!index);

			// update tokens array
			// using this algorithm to not assume anything about
			// the order or frequency of any tokens
			each(tokens, function (token) {
				if (token.type === momentType) {
					extend(token, {
						value: value,
						wholeValue: wholeValue,
						decimalValue: decimalValue,
						isLeast: isLeast,
						isMost: isMost
					});

					if (isMost) {
						// note the length of the most-significant moment token:
						// if it is greater than one and forceLength is not set, default forceLength to `true`
						if (settings.forceLength == null && token.length > 1) {
							settings.forceLength = true;
						}

						// rationale is this:
						// if the template is "h:mm:ss" and the moment value is 5 minutes, the user-friendly output is "5:00", not "05:00"
						// shouldn't pad the `minutes` token even though it has length of two
						// if the template is "hh:mm:ss", the user clearly wanted everything padded so we should output "05:00"
						// if the user wanted the full padded output, they can set `{ trim: false }` to get "00:05:00"
					}
				}
			});

			// update remainder
			remainder.subtract(wholeValue, momentType);
		});
	
		// trim tokens array
		if (settings.trim) {
			tokens = (settings.trim === "left" ? rest : initial)(tokens, function (token) {
				// return `true` if:
				// the token is not the least moment token (don't trim the least moment token)
				// the token is a moment token that does not have a value (don't trim moment tokens that have a whole value)
				return !(token.isLeast || (token.type != null && token.wholeValue));
			});
		}
		
		
		// build output

		// the first moment token can have special handling
		foundFirst = false;

		// run the map in reverse order if trimming from the right
		if (settings.trim === "right") {
			tokens.reverse();
		}

		tokens = map(tokens, function (token) {
			var val,
				decVal;

			if (!token.type) {
				// if it is not a moment token, use the token as its own value
				return token.token;
			}

			// apply negative precision formatting to the least-significant moment token
			if (token.isLeast && (settings.precision < 0)) {
				val = (Math.floor(token.wholeValue * Math.pow(10, settings.precision)) * Math.pow(10, -settings.precision)).toString();
			} else {
				val = token.wholeValue.toString();
			}
			
			// remove negative sign from the beginning
			val = val.replace(/^\-/, "");

			// apply token length formatting
			// special handling for the first moment token that is not the most significant in a trimmed template
			if (token.length > 1 && (foundFirst || token.isMost || settings.forceLength)) {
				val = padZero(val, token.length);
			}

			// add decimal value if precision > 0
			if (token.isLeast && (settings.precision > 0)) {
				decVal = token.decimalValue.toString().replace(/^\-/, "").split(/\.|e\-/);
				switch (decVal.length) {
					case 1:
						val += "." + padZero(decVal[0], settings.precision, true).slice(0, settings.precision);
						break;
						
					case 2:
						val += "." + padZero(decVal[1], settings.precision, true).slice(0, settings.precision);		
						break;
						
					case 3:
						val += "." + padZero(repeatZero((+decVal[2]) - 1) + (decVal[0] || "0") + decVal[1], settings.precision, true).slice(0, settings.precision);		
						break;
					
					default:
						throw "Moment Duration Format: unable to parse token decimal value.";
				}
			}
			
			// add a negative sign if the value is negative and token is most significant
			if (token.isMost && token.value < 0) {
				val = "-" + val;
			}

			foundFirst = true;

			return val;
		});

		// undo the reverse if trimming from the right
		if (settings.trim === "right") {
			tokens.reverse();
		}

		return tokens.join("");
	};

	moment$1.duration.fn.format.defaults = {
		// token definitions
		escape: /\[(.+?)\]/,
		years: /[Yy]+/,
		months: /M+/,
		weeks: /[Ww]+/,
		days: /[Dd]+/,
		hours: /[Hh]+/,
		minutes: /m+/,
		seconds: /s+/,
		milliseconds: /S+/,
		general: /.+?/,

		// token type names
		// in order of descending magnitude
		// can be a space-separated token name list or an array of token names
		types: "escape years months weeks days hours minutes seconds milliseconds general",

		// format options

		// trim
		// "left" - template tokens are trimmed from the left until the first moment token that has a value >= 1
		// "right" - template tokens are trimmed from the right until the first moment token that has a value >= 1
		// (the final moment token is not trimmed, regardless of value)
		// `false` - template tokens are not trimmed
		trim: "left",

		// precision
		// number of decimal digits to include after (to the right of) the decimal point (positive integer)
		// or the number of digits to truncate to 0 before (to the left of) the decimal point (negative integer)
		precision: 0,

		// force first moment token with a value to render at full length even when template is trimmed and first moment token has length of 1
		forceLength: null,

		// template used to format duration
		// may be a function or a string
		// template functions are executed with the `this` binding of the settings object
		// so that template strings may be dynamically generated based on the duration object
		// (accessible via `this.duration`)
		// or any of the other settings
		template: function () {
			var types = this.types,
				dur = this.duration,
				lastType = findLast(types, function (type) {
					return dur._data[type];
				});

			// default template strings for each duration dimension type
			switch (lastType) {
				case "seconds":
					return "h:mm:ss";
				case "minutes":
					return "d[d] h:mm";
				case "hours":
					return "d[d] h[h]";
				case "days":
					return "M[m] d[d]";
				case "weeks":
					return "y[y] w[w]";
				case "months":
					return "y[y] M[m]";
				case "years":
					return "y[y]";
				default:
					return "y[y] M[m] d[d] h:mm:ss";
			}
		}
	};

})(commonjsGlobal);

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function frameTheatreAddress(theatre) {
  var address = [];

  if (!_$1.isEmpty(theatre.city)) {
    address.push(theatre.city.name);
  }

  if (!_$1.isEmpty(theatre.province)) {
    address.push(theatre.province.name);
  } else if (!_$1.isEmpty(theatre.state)) {
    address.push(theatre.state.name);
  }

  if (!_$1.isEmpty(theatre.country)) {
    address.push(theatre.country.name);
  }

  return address.join(', ');
}
function calculateKdmPrice(theatre, pricingModel) {
  if (!theatre || !pricingModel || theatre.isPublic === undefined) {
    return 0.0.toFixed(2);
  }

  var theatreAmount = 0;
  pricingModel.items.forEach(function (_ref) {
    var theatreId = _ref.theatreId,
        netAmount = _ref.netAmount;

    if (theatreId === theatre.id) {
      theatreAmount += netAmount;
    }
  });
  return (theatreAmount / 100).toFixed(2);
}
function downloadKdm(ZIPPO_URL, fileName, data) {
  var form = document.createElement('form');
  var node = document.createElement('input');
  node.type = 'hidden';
  form.action = "".concat(ZIPPO_URL, "/?filename=").concat(fileName, ".zip");
  form.method = 'POST';
  data.forEach(function (item) {
    node.name = item.filename;
    node.value = item.url;
    form.appendChild(node.cloneNode());
  });
  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
function formatMinutesToHours(totalminutes) {
  var hours = Math.floor(totalminutes / 60);
  var minutes = totalminutes % 60;
  return {
    hours: hours,
    minutes: minutes
  };
}
function getDuration(duration) {
  try {
    var formatted = moment.duration(parseInt(duration, 10), 'seconds').format('hh:mm:ss');

    if (formatted.length === 5) {
      formatted = '00:' + formatted;
    }

    if (formatted.length === 2) {
      formatted = '00:00:' + formatted;
    }

    return formatted;
  } catch (e) {
    console.log('UiLib2 moment:', e);
    return duration;
  }
}
function getKdmDcpPrice(theatre, pricingModel) {
  var dcpDeliveryPrice = theatre.dcpPrice ? theatre.dcpPrice / 100 : 0;
  var kdmPriceForTheatre = parseFloat(calculateKdmPrice(theatre, pricingModel));
  var totalPriceForTheatre = dcpDeliveryPrice + kdmPriceForTheatre;
  return Number(totalPriceForTheatre).toFixed(2);
}
function processTheatre(theatre) {
  var theatreConflict = false;
  var screens = [];

  _$1.each(theatre.auditoriums, function (auditorium) {
    var deviceErrors = [];

    var validDevices = _$1.filter(auditorium.devices, function (device) {
      return device.code == 'PLY';
    });

    if (validDevices.length) {
      validDevices.map(function (device) {
        return deviceErrors = deviceErrors.concat(checkDeviceErrors(camelize(device)));
      });
    } else {
      deviceErrors.push('NOT_PLY_DEVICE');
    }

    var player = _$1.find(auditorium.devices, function (device) {
      return isValidPlaybackDevice_(camelize(device));
    });

    var conflict = _$1.find(auditorium.devices, function (device) {
      return device.code == 'PLY' && device.conflict == true;
    });

    if (conflict) {
      theatreConflict = true;
    }

    screens.push({
      id: auditorium.uuid,
      number: auditorium.number,
      name: auditorium.name,
      hasMediaBlock: !!(!auditorium.devices.length || player),
      conflict: !!conflict,
      deviceErrors: _$1.uniq(deviceErrors),
      isActive: auditorium.is_active,
      selected: auditorium.selected ? auditorium.selected : false
    });
  });

  var address = theatre.address;
  var processedTheatre = {
    id: theatre.uuid,
    name: theatre.name,
    timezone: theatre.timezone,
    address: camelize(address),
    conflict: theatreConflict,
    isPublic: !theatre.is_private,
    screens: screens,
    alternate_names: theatre.alternate_names,
    wiretaps: theatre.wiretaps,
    matched_on: theatre.matched_on
  };
  return processedTheatre;
}

function isValidPlaybackDevice_(device) {
  return true;
}

function checkDeviceErrors(device) {
  var deviceErrors = [];
  device.isActive == false ? deviceErrors.push('IS_NOT_ACTIVE') : null;
  device.hasCertificate == false ? deviceErrors.push('HAS_NO_CERTIFICATE') : null;
  return deviceErrors;
}

function processTheatreRequestData(request) {
  var formattedRequest = {
    name: request.name ? [request.name] : [],
    address: {
      city: request.city,
      state: request.state,
      country: request.country
    },
    id: request.id ? [request.id] : [],
    screen_id: request.screen_id ? [request.screen_id] : []
  };
  return formattedRequest;
}
function processTheatres(theatres) {
  var processedTheatres = [];

  _$1.each(theatres, function (theatre) {
    if (theatre.request) {
      theatre.request = processTheatreRequestData(theatre.request);
      theatre.record = processTheatre(theatre.record);
    }

    processedTheatres.push(theatre);
  });

  return processedTheatres;
}
var extractYear = function extractYear(dateString) {
  var year = new Date(dateString).getFullYear();
  return year;
};
function formatAddress(address) {
  var formattedAddress = [];

  if (address.city) {
    formattedAddress.push(address.city);
  }

  if (address.state) {
    formattedAddress.push(address.state);
  }

  if (address.country) {
    formattedAddress.push(address.country);
  }

  return formattedAddress.join(', ');
}
function combineTheatreRows(theatres) {
  var combinedRows = [];
  var index;

  for (index = 0; index < theatres.length; index++) {
    var theatreIndex = _$1.findIndex(combinedRows, function (theatre) {
      return theatre.record.id === theatres[index].record.id;
    });

    if (theatreIndex >= 0) {
      var processedTheatre = _$1.cloneDeep(combinedRows[theatreIndex]);

      if (theatres[index].record.matched_on === MatchedBy.screenId) {
        if (processedTheatre.record.matched_on === MatchedBy.screenId) {
          var duplicateScreenId = processedTheatre.matchedColumn.screen_id.includes(theatres[index].request.screen_id[0]);

          if (!duplicateScreenId) {
            for (var iteration = 0; iteration < processedTheatre.record.screens.length; iteration++) {
              if (processedTheatre.record.screens[iteration].selected && theatres[index].record.screens[iteration].selected) {
                duplicateScreenId = true;
                break;
              }

              processedTheatre.record.screens[iteration].selected = processedTheatre.record.screens[iteration].selected || theatres[index].record.screens[iteration].selected;
            }

            if (duplicateScreenId) {
              processedTheatre.duplicate = _objectSpread$9(_objectSpread$9({}, processedTheatre.duplicate), {}, {
                screen_id: processedTheatre.duplicate.screen_id ? processedTheatre.duplicate.screen_id.concat(theatres[index].request.screen_id) : [theatres[index].request.screen_id]
              });
              processedTheatre.duplicateRows += 1;
            } else {
              processedTheatre.matchedColumn.screen_id = processedTheatre.matchedColumn.screen_id.concat(theatres[index].request.screen_id);
            }

            processedTheatre.matchedRows += 1;
          } else {
            processedTheatre.duplicate = _objectSpread$9(_objectSpread$9({}, processedTheatre.duplicate), {}, {
              screen_id: processedTheatre.duplicate.screen_id ? processedTheatre.duplicate.screen_id.concat(theatres[index].request.screen_id) : [theatres[index].request.screen_id]
            });
            processedTheatre.duplicateRows += 1;
            processedTheatre.matchedRows += 1;
          }
        } else {
          if (processedTheatre.record.matched_on === MatchedBy.theatreId) {
            processedTheatre.duplicate = _objectSpread$9(_objectSpread$9({}, processedTheatre.duplicate), {}, {
              id: processedTheatre.duplicate.id ? processedTheatre.matchedColumn.id.concat(processedTheatre.duplicate.id) : processedTheatre.matchedColumn.id
            });
          } else {
            processedTheatre.duplicate = _objectSpread$9(_objectSpread$9({}, processedTheatre.duplicate), {}, {
              name: processedTheatre.duplicate.name ? processedTheatre.matchedColumn.name.concat(processedTheatre.duplicate.name) : processedTheatre.matchedColumn.name
            });
          }

          processedTheatre.matchedColumn = {
            name: theatres[index].request.name,
            screen_id: theatres[index].request.screen_id
          };
          processedTheatre.record.screens = _toConsumableArray$1(theatres[index].record.screens);
          processedTheatre.record.matched_on = MatchedBy.screenId;
          processedTheatre.duplicateRows += 1;
          processedTheatre.matchedRows += 1;
        }
      } else {
        if (theatres[index].record.matched_on === MatchedBy.theatreId) {
          processedTheatre.duplicate = _objectSpread$9(_objectSpread$9({}, processedTheatre.duplicate), {}, {
            id: processedTheatre.duplicate.id ? processedTheatre.duplicate.id.concat(theatres[index].request.id) : [theatres[index].request.id]
          });
        } else if (theatres[index].record.matched_on === MatchedBy.theatreDetails) {
          processedTheatre.duplicate = _objectSpread$9(_objectSpread$9({}, processedTheatre.duplicate), {}, {
            name: processedTheatre.duplicate.name ? processedTheatre.duplicate.name.concat(theatres[index].request.name) : [theatres[index].request.name]
          });
        }

        processedTheatre.matchedRows += 1;
        processedTheatre.duplicateRows += 1;
      }

      combinedRows[theatreIndex] = _$1.cloneDeep(processedTheatre);
    } else {
      var theatre = {
        matchedColumn: {},
        duplicate: {},
        record: _$1.cloneDeep(theatres[index].record),
        matchedRows: 1,
        duplicateRows: 0
      };

      if (theatre.record.matched_on !== MatchedBy.screenId) {
        theatre.record.screens = theatre.record.screens.map(function (screen) {
          screen.selected = true;
          return screen;
        });
      }

      if (theatre.record.matched_on === MatchedBy.screenId) {
        theatre.matchedColumn = {
          name: theatres[index].request.name,
          screen_id: theatres[index].request.screen_id
        };
      } else if (theatre.record.matched_on === MatchedBy.theatreDetails) {
        theatre.matchedColumn = {
          name: theatres[index].request.name,
          address: theatres[index].request.address
        };
      } else if (theatre.record.matched_on === MatchedBy.theatreId) {
        theatre.matchedColumn = {
          name: theatres[index].request.name,
          id: theatres[index].request.id
        };
      }

      combinedRows.push(theatre);
    }
  }

  return combinedRows;
}
function bytesToSize(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return "".concat((bytes / Math.pow(1024, i)).toFixed(2), " ").concat(sizes[i]);
} //Drive manufacturers consider 1000GB as 1TB

function bytesToSizeBase1000(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
  return "".concat((bytes / Math.pow(1000, i)).toFixed(0), " ").concat(sizes[i]);
}

function _createSuper$X(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$X(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$X() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CommonModal = /*#__PURE__*/function (_React$Component) {
  _inherits$1(CommonModal, _React$Component);

  var _super = _createSuper$X(CommonModal);

  function CommonModal() {
    _classCallCheck$1(this, CommonModal);

    return _super.apply(this, arguments);
  }

  _createClass$1(CommonModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(_Modal, _extends$1({}, this.props, {
        width: this.props.width,
        visible: this.props.visible,
        wrapClassName: this.props.wrapClassName,
        title: this.props.title,
        onCancel: this.props.onCancel,
        afterClose: this.props.afterClose,
        footer: this.props.footer,
        closable: this.props.closable,
        style: this.props.style,
        bodyStyle: this.props.bodyStyle
      }), this.props.children);
    }
  }]);

  return CommonModal;
}(React__default.Component);

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function reactSelectTheme() {
  return function (theme) {
    return _objectSpread$8(_objectSpread$8({}, theme), {}, {
      borderRadius: 0,
      colors: _objectSpread$8(_objectSpread$8({}, theme.colors), {}, {
        primary25: theme.colors.primary50,
        primary: '#084782'
      })
    });
  };
}

function _createSuper$W(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$W(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$W() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BayCompositionsViewModal = /*#__PURE__*/function (_React$Component) {
  _inherits$1(BayCompositionsViewModal, _React$Component);

  var _super = _createSuper$W(BayCompositionsViewModal);

  function BayCompositionsViewModal(props) {
    _classCallCheck$1(this, BayCompositionsViewModal);

    return _super.call(this, props);
  }

  _createClass$1(BayCompositionsViewModal, [{
    key: "renderCompositions",
    value: function renderCompositions() {
      var compositions = this.props.compositions;

      if (isEmpty(compositions)) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "px2 mt1"
        }, i18n.t('driveNotHaveContent'));
      }

      return /*#__PURE__*/React__default.createElement("div", null, compositions.map(function (composition) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "px2 mt1"
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "h5-alt"
        }, composition.name));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "bay-composition-modal"
      }, /*#__PURE__*/React__default.createElement(CommonModal, {
        visible: this.props.viewModal,
        bodyStyle: {
          margin: 'auto',
          maxWidth: '100%',
          minHeight: '100%',
          width: '100%%',
          height: '40%'
        },
        title: i18n.t('compositions'),
        onCancel: null,
        closable: true,
        footer: [],
        width: '60%'
      }, this.renderCompositions()));
    }
  }]);

  return BayCompositionsViewModal;
}(React__default.Component);

function _createSuper$V(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$V(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$V() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Bay = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Bay, _React$Component);

  var _super = _createSuper$V(Bay);

  function Bay(props) {
    var _this;

    _classCallCheck$1(this, Bay);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "toggleModal", function () {
      console.log(_this.state.viewModal);

      _this.setState(function (prevState) {
        return {
          viewModal: !prevState.viewModal
        };
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderViewDcpButton", function () {
      var bay = _this.props.bay;
      if (_this.isBayBusy() || isEmpty(bay.path)) return;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "h6 right cursor-pointer view-details-link",
        onClick: _this.toggleModal
      }, i18n.t('viewDetails'), _this.renderBayCompositionsViewModal(bay.dcps));
    });

    _this.state = {
      viewModal: false
    };
    return _this;
  }

  _createClass$1(Bay, [{
    key: "getBayStatus",
    value: function getBayStatus() {
      var _this$props = this.props,
          bay = _this$props.bay,
          workOrder = _this$props.workOrder,
          ignoreWorkOrder = _this$props.ignoreWorkOrder;

      if (isEmpty(bay.path)) {
        return BayStatuses.EMPTY;
      }

      if (isEmpty(bay.duplicationStatus)) {
        return BayStatuses.INSERTED;
      }

      if (isEmpty(bay.duplicationStatus.status)) {
        return BayStatuses.INSERTED;
      }

      var _bay$duplicationStatu = bay.duplicationStatus,
          status = _bay$duplicationStatu.status,
          userData = _bay$duplicationStatu.userData;

      if (userData && userData.workOrderNo === (workOrder === null || workOrder === void 0 ? void 0 : workOrder.workOrderNo) || ignoreWorkOrder) {
        return status;
      } else {
        return BayStatuses.INSERTED;
      }
    }
  }, {
    key: "getBayStatusText",
    value: function getBayStatusText() {
      var _this$props2 = this.props,
          bay = _this$props2.bay;
          _this$props2.appliance;
          var workOrder = _this$props2.workOrder,
          ignoreWorkOrder = _this$props2.ignoreWorkOrder;
      var status = {
        available: 'Drive Inserted',
        queued: 'Copy Queued',
        busy: 'Drive Inserted',
        empty: 'Insert Drive',
        inserted: 'Drive Inserted',
        copying: 'Copying...',
        copy_complete: 'Copy Complete. Eject Drive',
        error: 'Drive Error',
        eject: 'Eject drive',
        executing: 'Copy started',
        failed: 'Copy failed'
      };
      var bayStatusText = {
        executing: 'Copy started',
        formatting: 'Formatting drive...',
        preparing: 'Preparing to copy...',
        duplicating: 'Copying content...',
        verifying: 'Verifying...',
        succeeded: 'Copy Complete. Eject Drive',
        failed: 'Drive Error. Copy Failed',
        duplication_failed: 'Copy Failed',
        verification_failed: 'Verification Failed',
        format_failed: 'Formatting Failed',
        mount_points_preparation_failed: 'Drive not found',
        partitioning_failed: 'Formatting Failed.',
        duplication_interrupted: 'Duplication Interrupted',
        drive_in_use: 'Drive is in use',
        slow_drive: 'Copying Content; Slow Drive Detected.'
      };

      if (isEmpty(bay.path)) {
        return status.empty;
      }

      if (isEmpty(bay.duplicationStatus) && !isEmpty(bay.path)) {
        return "".concat(bytesToSizeBase1000(bay.size), " ").concat(status.inserted);
      }

      if (isEmpty(bay.duplicationStatus.status)) {
        return "".concat(bytesToSizeBase1000(bay.size), " ").concat(status.inserted);
      }

      var bayStatus = bay.duplicationStatus.status;
      var userData = bay.duplicationStatus.userData;
      var statusText = '';

      if (userData && userData.workOrderNo === (workOrder === null || workOrder === void 0 ? void 0 : workOrder.workOrderNo) || ignoreWorkOrder) {
        if (bayStatus === DuplicationProgress.FAILED) {
          if (bay.duplicationStatus.error) {
            var errorCode = bay.duplicationStatus.error.code;
            statusText = bayStatusText[errorCode] + (ignoreWorkOrder ? " WorkOrder : ".concat(userData.workOrderNo) : '');
            return statusText;
          }

          statusText = bayStatusText.failed + (ignoreWorkOrder ? " WorkOrder : ".concat(userData.workOrderNo) : '');
          return statusText;
        }

        if (bay.duplicationStatus.isSlowDrive) {
          statusText = bayStatusText.slow_drive + (ignoreWorkOrder ? " WorkOrder : ".concat(userData.workOrderNo) : '');
          return statusText;
        }

        if (!DuplicationProgressStatuses.includes(bayStatus) && bayStatus !== DuplicationProgress.SUCCEEDED && bayStatus !== DuplicationProgress.FAILED) {
          statusText = "".concat(bytesToSizeBase1000(bay.size), " ").concat(status[bayStatus]) + (ignoreWorkOrder ? " WorkOrder : ".concat(userData.workOrderNo) : '');
          return statusText;
        }

        statusText = bayStatusText[bayStatus] + (ignoreWorkOrder ? " WorkOrder : ".concat(userData.workOrderNo) : '');
        return statusText;
      } else {
        return "".concat(bytesToSizeBase1000(bay.size), " ").concat(status.inserted);
      }
    }
  }, {
    key: "renderBayCompositionsViewModal",
    value: function renderBayCompositionsViewModal(compositions) {
      var viewModal = this.state.viewModal;
      return /*#__PURE__*/React__default.createElement(BayCompositionsViewModal, {
        viewModal: viewModal,
        onCancel: this.toggleModal,
        compositions: compositions
      });
    }
  }, {
    key: "isBayBusy",
    value: function isBayBusy() {
      var _this$props3 = this.props,
          bay = _this$props3.bay,
          isCurrentWorkOrderDuplicatingInThisAppliance = _this$props3.isCurrentWorkOrderDuplicatingInThisAppliance;
      return isCurrentWorkOrderDuplicatingInThisAppliance && !isEmpty(bay.duplicationStatus) && DuplicationProgressStatuses.includes(bay.duplicationStatus.status);
    }
  }, {
    key: "render",
    value: function render() {
      var bay = this.props.bay;
      var bayStatus = this.getBayStatus();
      var bayStatusText = this.getBayStatusText();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "bay bay-item clearfix"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col bay-number"
      }, "Bay ", bay.bay), /*#__PURE__*/React__default.createElement("div", {
        className: "col bay-status h5 bay-".concat(bayStatus)
      }, /*#__PURE__*/React__default.createElement("span", null, bayStatusText), this.renderViewDcpButton()));
    }
  }]);

  return Bay;
}(React__default.Component);

function bandwidthCalculator(bytes) {
  var bytesData = bytes;

  if (bytesData >= 1024 * 1024 * 1024) {
    bytesData = "".concat((bytesData / (1024 * 1024 * 1024)).toFixed(2), " Gbps");
  } else if (bytesData >= 1024 * 1024) {
    bytesData = "".concat((bytesData / (1024 * 1024)).toFixed(2), " Mbps");
  } else if (bytesData >= 1024) {
    bytesData = "".concat((bytesData / 1024).toFixed(2), " Kbps");
  } else {
    bytesData = "".concat(bytesData.toFixed(2), " bps");
  }

  return bytesData;
}

function _createSuper$U(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$U(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _isNativeReflectConstruct$U() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultBays = [{
  bay: 1
}, {
  bay: 2
}, {
  bay: 3
}, {
  bay: 4
}, {
  bay: 5
}, {
  bay: 6
}, {
  bay: 7
}, {
  bay: 8
}];
var infoIconSize = 20;

var ApplianceRack = /*#__PURE__*/function (_React$Component) {
  _inherits$2(ApplianceRack, _React$Component);

  var _super = _createSuper$U(ApplianceRack);

  function ApplianceRack(props) {
    var _this;

    _classCallCheck$2(this, ApplianceRack);

    _this = _super.call(this, props);
    _this.state = {
      modalFlag: false
    };
    return _this;
  }

  _createClass$2(ApplianceRack, [{
    key: "hasDriveFailed",
    value: function hasDriveFailed(slot, failedTargetDrive) {
      // Going forward failure message will have 'bay' key to indicate the actual bay that was failed,
      // so use that check for failed drive
      if (failedTargetDrive.bay && failedTargetDrive.bay > 0) {
        return failedTargetDrive.bay === slot.slotNo;
      } // This is a fallback check just in case the appliance firmware was not updated, hence 'bay' key in the
      // failure message would not be available


      return failedTargetDrive.drive === slot.path;
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this2 = this;

      var appliance = this.props.appliance;
      var modalFlag = this.state.modalFlag;
      return /*#__PURE__*/React__default.createElement(CommonModal, {
        visible: modalFlag,
        title: "Appliance Details",
        className: "appliance-modal",
        footer: null,
        onCancel: function onCancel() {
          _this2.setState({
            modalFlag: false
          });
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-box"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-head-text"
      }, "Serial No."), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-text"
      }, appliance.serialNo || '-')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-box"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-head-text"
      }, "Bandwidth"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-text"
      }, appliance.bandwidth || '-')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-box"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-head-text"
      }, "OS Version"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-text"
      }, appliance.softwareVersion || '-'))));
    }
  }, {
    key: "renderBay",
    value: function renderBay(bay) {
      var _this$props = this.props,
          appliance = _this$props.appliance,
          workOrder = _this$props.workOrder,
          isCurrentWorkOrderDuplicatingInThisAppliance = _this$props.isCurrentWorkOrderDuplicatingInThisAppliance,
          ignoreWorkOrder = _this$props.ignoreWorkOrder;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col col-12 bay-container"
      }, /*#__PURE__*/React__default.createElement(Bay, {
        key: Date.now(),
        bay: bay,
        appliance: appliance,
        workOrder: workOrder,
        isCurrentWorkOrderDuplicatingInThisAppliance: isCurrentWorkOrderDuplicatingInThisAppliance,
        ignoreWorkOrder: ignoreWorkOrder
      }));
    }
  }, {
    key: "renderAppliance",
    value: function renderAppliance(appliance) {
      var _this3 = this;

      var bays = appliance && appliance.drives || defaultBays;
      var applianceBays = [];
      if (!bays) return null;
      forEach$1(bays, function (bay) {
        return applianceBays.push(_this3.renderBay(bay));
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, appliance.isOnline != null ? /*#__PURE__*/React__default.createElement("div", {
        className: appliance.isOnline ? 'appliance-online' : 'appliance-offline'
      }) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "appliance-name"
      }, appliance.serialNo), /*#__PURE__*/React__default.createElement("div", {
        className: "appliance-info",
        onClick: function onClick() {
          _this3.setState({
            modalFlag: true
          });
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: 'InfoCircle',
        color: 'appliance-info-color',
        size: infoIconSize
      })), appliance.downloadRate != 0 && appliance.downloadRate != null ? /*#__PURE__*/React__default.createElement("div", {
        className: "appliance-download"
      }, "Downloading at ", bandwidthCalculator(appliance.downloadRate * 8)) : null), /*#__PURE__*/React__default.createElement("div", {
        className: "appliance-rack"
      }, applianceBays));
    }
  }, {
    key: "render",
    value: function render() {
      var appliance = this.props.appliance;
      if (!appliance) return null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "appliance-rack-container"
      }, this.renderAppliance(appliance), this.renderModal());
    }
  }]);

  return ApplianceRack;
}(React__default.Component);
ApplianceRack.defaultProps = {
  ignoreWorkOrder: false
};

var TheatreDefaultInfo = function TheatreDefaultInfo(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      viewMatchedRows = _useState2[0],
      setView = _useState2[1];

  var renderScreenId = function renderScreenId(screenId) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "id-text"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-heading"
    }, "".concat(i18n.t('screen'), " ").concat(i18n.t('id', {
      count: screenId.length
    }))), screenId.map(function (screen, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, screen);
    }));
  };

  var renderDuplicateRows = function renderDuplicateRows(duplicate) {
    var duplicateTheatres = 0;
    var duplicateTheatreNames = duplicate.name ? duplicate.name.length : 0;
    var duplicateTheatreId = duplicate.id ? duplicate.id.length : 0;
    duplicateTheatres = duplicateTheatreNames + duplicateTheatreId;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, duplicate.screen_id ? /*#__PURE__*/React__default.createElement("div", {
      className: "id-text"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-heading"
    }, i18n.t('followingDuplicateRowThatMatchedTheScreenAreIgnored', {
      count: duplicate.screen_id.length
    })), duplicate.screen_id.map(function (screen, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, screen);
    })) : null, duplicateTheatres ? /*#__PURE__*/React__default.createElement("div", {
      className: "id-text"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-heading"
    }, i18n.t('followingDuplicateRowThatMatchedTheTheatreAreIgnored', {
      count: duplicateTheatres
    })), duplicate.name && duplicate.name.map(function (name, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, name);
    }), duplicate.id && duplicate.id.map(function (id, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, id);
    })) : null);
  };

  var renderTheatreSelectInfo = function renderTheatreSelectInfo(props) {
    var id = props.id,
        screen_id = props.screen_id,
        name = props.name,
        duplicate = props.duplicate,
        matchedRows = props.matchedRows,
        unMatched = props.unMatched,
        duplicateRows = props.duplicateRows;
    var theatreName;
    var theatreId = null;
    var screenId = null;
    var rowsMatched = null;

    if (matchedRows == 1 || unMatched) {
      if (name && name.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: name[0]
        });

        if (screen_id && screen_id.length) {
          screenId = renderScreenId(screen_id);

          if (id && id.length) {
            theatreId = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
              className: "id-text sub-heading"
            }, "".concat(i18n.t('theatre'), " ").concat(i18n.t('id', {
              count: id.length
            }))), id.map(function (id, index) {
              return /*#__PURE__*/React__default.createElement("div", {
                className: "id-text",
                key: index
              }, id);
            }));
          }
        }
      } else if (screen_id && screen_id.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(i18n.t('screen'), " ").concat(i18n.t('id', {
            count: screen_id.length
          }), ": ").concat(screen_id[0])
        });

        if (id && id.length) {
          theatreId = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "id-text sub-heading"
          }, "".concat(i18n.t('theatre'), " ").concat(i18n.t('id', {
            count: id.length
          }))), id.map(function (id, index) {
            return /*#__PURE__*/React__default.createElement("div", {
              className: "id-text",
              key: index
            }, id);
          }));
        }
      } else {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(i18n.t('theatre'), " ").concat(i18n.t('id', {
            count: id.length
          }), ": ").concat(id[0])
        });
      }
    } else {
      if (name && name.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: name[0]
        });
      } else if (screen_id && screen_id.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(i18n.t('screen'), " ").concat(i18n.t('id_one'), ": ").concat(screen_id[0])
        });
      } else {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(i18n.t('theatre'), " ").concat(i18n.t('id_one'), ": ").concat(id[0])
        });
      }

      rowsMatched = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-details margin-chevron",
        onClick: function onClick() {
          return setView(!viewMatchedRows);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: viewMatchedRows ? 'ChevronDown' : 'ChevronRight',
        color: "blue",
        size: "16"
      }), /*#__PURE__*/React__default.createElement("div", null, i18n.t('rowMatchedCount', {
        count: matchedRows
      }))), viewMatchedRows ? screen_id ? renderScreenId(screen_id) : id ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "id-text sub-heading"
      }, "".concat(i18n.t('theatre'), " ").concat(i18n.t('id', {
        count: id.length
      }), ":")), id.map(function (id, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "id-text",
          key: index
        }, id);
      })) : null : null, viewMatchedRows ? duplicateRows ? renderDuplicateRows(duplicate) : null : null);
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, theatreName, props.address ? /*#__PURE__*/React__default.createElement(TheatreAddress, {
      address: props.address
    }) : null, screenId, theatreId, rowsMatched);
  };

  var renderTheatreinfo = function renderTheatreinfo(props) {
    var hasWireTap = props.hasWireTap,
        genericWireTapIcon = props.genericWireTapIcon;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "theatrename-wiretapicon-wrapper"
    }, /*#__PURE__*/React__default.createElement(TheatreName, {
      name: props.name,
      capitalize: true
    }), hasWireTap ? /*#__PURE__*/React__default.createElement(ToolTip, {
      toolTip: genericWireTapIcon ? 'Electronic Delivery' : 'Powered by WireTAP',
      usePortal: true,
      portalContainer: document.querySelector('.container')
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "wire-tap-icon"
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-tip": true,
      "data-for": "wiretapicon"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: genericWireTapIcon ? 'ApplianceDownload' : 'WireTap',
      color: "primary",
      size: 16
    })))) : null), /*#__PURE__*/React__default.createElement(TheatreAddress, {
      address: props.address
    }));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "theatre-info__default"
  }, props.theatreSelect ? renderTheatreSelectInfo(props) : renderTheatreinfo(props));
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$1 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral$1 = '[' + rsAstralRange$1 + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboMarksRange$1 + rsComboSymbolsRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$1 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1,
    rsSymbol$1 = '(?:' + [rsNonAstral$1 + rsCombo$1 + '?', rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral$1].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$1, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol$1 + rsSeq$1, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode$1 = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboMarksRange$1 + rsComboSymbolsRange$1 + rsVarRange$1 + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray$1(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$1(string) {
  return reHasUnicode$1.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray$1(string)
    : asciiToArray$1(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode$1) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var Symbol$2 = root$1.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice$1(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode$1(string)
      ? stringToArray$1(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice$1(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst$1(toString$2(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString$2(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst$1('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var lodash_camelcase = camelCase;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString$1(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

var lodash_upperfirst = upperFirst;

/* eslint-disable no-console */
var warned = {};
function warning$1(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning$1, valid, message);
}
/* eslint-enable */

var warning = (function (valid, component, message) {
  warningOnce(valid, "[antd-compatible: ".concat(component, "] ").concat(message));
});

var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;
function getThemeFromTypeName(type) {
  var result = null;

  if (fillTester.test(type)) {
    result = 'filled';
  } else if (outlineTester.test(type)) {
    result = 'outlined';
  } else if (twoToneTester.test(type)) {
    result = 'twoTone';
  }

  return result;
}
function removeTypeTheme(type) {
  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
}
var themeMap = {
  filled: 'filled',
  outlined: 'outlined',
  twoTone: 'twoTone'
};
function withThemeSuffix(type, theme) {
  var result = lodash_upperfirst(lodash_camelcase(type));
  var realTheme = lodash_upperfirst(themeMap[theme]);

  if (theme !== 'outlined' && !realTheme) {
    warning(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
  }

  return result + realTheme;
} // For alias or compatibility

function alias(type) {
  var newType = type;

  switch (type) {
    case 'cross':
      newType = 'close';
      break;
    // https://github.com/ant-design/ant-design/issues/13007

    case 'interation':
      newType = 'interaction';
      break;
    // https://github.com/ant-design/ant-design/issues/16810

    case 'canlendar':
      newType = 'calendar';
      break;
    // https://github.com/ant-design/ant-design/issues/17448

    case 'colum-height':
      newType = 'column-height';
      break;
  }

  warning(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
  return newType;
}

var upgradeMessage = (function (component) {
  return warning(false, component, "The legacy component has been deprecated, and ant design 4.0 now released! Please follow https://ant.design/components/".concat(component.toLowerCase()).concat(component === 'Mention' ? 's' : '', " to upgrade."));
});

var iconsMap = allIcons;

var LegacyTypeIcon = function LegacyTypeIcon(props) {
  var type = props.type,
      theme = props.theme;

  if (theme) {
    var themeInName = getThemeFromTypeName(type);
    warning(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
  }

  var computedType = withThemeSuffix(removeTypeTheme(alias(type)), theme || 'outlined');
  var targetIconComponent = iconsMap[computedType];
  warning(targetIconComponent, 'Icon', "The icon name '".concat(type, "'").concat(theme ? "with ".concat(theme) : '', " doesn't exist, please check it at https://ant.design/components/icon"));
  return targetIconComponent ? React__default.createElement(targetIconComponent, props) : null;
};

var Icon$1 = function Icon(props) {
  var type = props.type,
      component = props.component,
      children = props.children;
  upgradeMessage('Icon');
  warning(Boolean(type || component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');

  if (component || children) {
    return React__default.createElement(Icon$3, Object.assign({}, props));
  }

  if (typeof type === 'string') {
    return React__default.createElement(LegacyTypeIcon, Object.assign({}, props, {
      type: type
    }));
  }

  return React__default.createElement(Icon$3, null);
};

Icon$1.createFromIconfontCN = create;
Icon$1.getTwoToneColor = getTwoToneColor;
Icon$1.setTwoToneColor = setTwoToneColor;

var Icon = function Icon(props) {
  return /*#__PURE__*/React__default.createElement("button", {
    className: "icon-btn",
    onClick: props.callbackAction
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    type: props.iconName
  }));
};

Icon.defaultProps = {
  iconName: 'close',
  callbackAction: function callbackAction() {}
};

var TheatreDefaultMeta = function TheatreDefaultMeta(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "theatre-meta__default"
  }, props.price && /*#__PURE__*/React__default.createElement(TheatrePrice, {
    price: props.price
  }), props.containsDeleteButton && /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "close",
    callbackAction: props.deleteAction
  }));
};

var TextLinks = function TextLinks(props) {
  return /*#__PURE__*/React__default.createElement("span", {
    className: props.size ? "text-with-icon__link ".concat(props.size) : 'text-with-icon__link'
  }, props.content);
};

TextLinks.defaultProps = {
  size: 'large'
};

var TextWithIconLinks = function TextWithIconLinks(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.size ? "text-with-icon ".concat(props.size) : 'text-with-icon'
  }, props.iconName && /*#__PURE__*/React__default.createElement("div", {
    className: "text-with-icon__icon"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: props.iconName,
    color: "blue"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: props.size ? "text-with-icon__link ".concat(props.size) : 'text-with-icon__link'
  }, props.content));
};

TextWithIconLinks.defaultProps = {
  size: 'large'
};

var SearchBox = function SearchBox(props) {
  var value = props.value,
      _onTextChange = props.onTextChange,
      placeholder = props.placeholder,
      suffix = props.suffix,
      _emitEmpty = props.emitEmpty;
      props.searchClick;
      props.searchButton;
      var error = props.error,
      style = props.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "qw-search"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "qw-search-input-box"
  }, /*#__PURE__*/React__default.createElement(InputBox, {
    value: value,
    onTextChange: function onTextChange(e) {
      return _onTextChange && _onTextChange(e);
    },
    placeholder: placeholder,
    suffix: suffix,
    style: style || {},
    emitEmpty: function emitEmpty() {
      return _emitEmpty && _emitEmpty();
    }
  })), error && /*#__PURE__*/React__default.createElement("div", {
    className: "search-input-error"
  }, error));
};

SearchBox.defaultProps = {
  value: 'input',
  error: 'error',
  suffix: true,
  placeholder: 'placeholder',
  searchButton: true
};

var TabBar = function TabBar(props) {
  var list = props.list,
      _onChange = props.onChange,
      selectedTab = props.selectedTab;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tab-bar-chip-list"
  }, list.map(function (item) {
    return /*#__PURE__*/React__default.createElement(TabItem, {
      name: item.name,
      id: item.id,
      key: item.id,
      item: item,
      selectedTab: selectedTab,
      onChange: function onChange(item) {
        return _onChange && _onChange(item);
      }
    });
  }));
};

TabBar.defaultProps = {
  list: [{
    id: "tab".concat(1),
    name: 'Theatres',
    type: 'theatres'
  }, {
    id: "tab".concat(2),
    name: 'Lists',
    type: 'lists'
  }, {
    id: "tab".concat(3),
    name: 'Festivals',
    type: 'festivals'
  }],
  selectedTab: 'theatres'
};

var errorValues = {
  screen_errors: {
    not_ply_device: i18n.t('noPlyDeviceInScreen'),
    is_not_active: i18n.t('noActiveDeviceInScreen'),
    has_no_certificate: i18n.t('screenNotHaveCertificate'),
    non_dci: i18n.t('screenNonDciComplaints'),
    screen_inactive: i18n.t('inactiveScreen')
  }
};

var ScreensList = function ScreensList(props) {
  var list = props.list,
      handleAddScreen = props.handleAddScreen,
      theatreIndex = props.theatreIndex,
      theatre = props.theatre,
      theatresInBooking = props.theatresInBooking,
      editListView = props.editListView,
      listType = props.listType;
      props.pricingModel;
      props.dcpPrice;
      var shouldShowPrice = props.shouldShowPrice;

  function getDeviceErrorMessages(deviceErrors) {
    if (deviceErrors) {
      return deviceErrors.map(function (error) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "block"
        }, errorValues.screen_errors[error.toLowerCase()]);
      });
    }
  }

  function getScreenList(screen, screenInBooking, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "theatre-card-list-view",
      key: "".concat(screen.id + index, "screen-list"),
      onClick: function onClick() {
        return handleAddScreen && handleAddScreen(index, theatreIndex, screen, theatre, screenInBooking >= 0);
      }
    }, /*#__PURE__*/React__default.createElement(Label, {
      text: screen.name
    }), (screen && screen.deviceErrors && screen.deviceErrors.length || !screen.isActive) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ToolTip, {
      toolTip: !screen.isActive ? /*#__PURE__*/React__default.createElement("span", null, i18n.t('inactiveScreen')) : getDeviceErrorMessages(screen.deviceErrors)
    }, /*#__PURE__*/React__default.createElement("span", {
      "data-tip": true,
      "data-for": screen.id,
      className: "screen-error-icon"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "AssestError"
    })))), /*#__PURE__*/React__default.createElement("div", {
      className: "theatre-card-list-view-options"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: 'theatre-card-list-view-checkbox'
    }, listType == 'lists' && !screen.isInList && /*#__PURE__*/React__default.createElement("div", null, screenInBooking >= 0 ? /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SquareFilled"
    }) : /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SquareEmpty"
    })), shouldShowPrice ? '' : (listType != 'lists' || listType == 'lists' && screen.isInList) && ( // <Checkbox value={screenInBooking >= 0} />
    screenInBooking >= 0 ? /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SelectedFull",
      size: 20
    }) : /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SelectedEmpty",
      size: 20
    })))));
  }

  return /*#__PURE__*/React__default.createElement("div", null, list && list.map(function (screen, index) {
    var theatreInBooking = _.findIndex(theatresInBooking, function (th) {
      return th.id === theatre.id;
    });

    var screenInBooking = -1;

    if (theatreInBooking >= 0) {
      screenInBooking = _.findIndex(theatresInBooking[theatreInBooking].screens, function (sc) {
        if (editListView) {
          return sc.id === screen.id && sc.isInList;
        }

        return sc.id === screen.id && sc.selected;
      });
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, shouldShowPrice ? screen.selected ? getScreenList(screen, screenInBooking, index) : '' : getScreenList(screen, screenInBooking, index));
  }));
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$1(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge$1(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$1 = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge$1,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$1.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$1.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$1.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$1.forEach(val, function parseValue(v) {
        if (utils$1.isDate(v)) {
          v = v.toISOString();
        } else if (utils$1.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils$1.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils$1.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$1.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$1.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$1.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$1.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$1.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$1.trim(line.substr(0, i)).toLowerCase();
    val = utils$1.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils$1.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$1.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$1.isUndefined(headers) && utils$1.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils$1.isFormData(data) ||
      utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$1.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$1.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils$1.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$1.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$1.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge(target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$1.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$1.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$1.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$1.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$1.forEach(otherKeys, mergeDeepProperties);

  return config;
};

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken$2(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken$2.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken$2.source = function source() {
  var cancel;
  var token = new CancelToken$2(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken$2;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios_1;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

var axios_1 = axios$1;

// Allow use of default import syntax in TypeScript
var _default$1 = axios$1;
axios_1.default = _default$1;

var axios = axios_1;

function _createSuper$T(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$T(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$T() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// const cancelAllPendingRequest = async (cb) => {
//     await source.cancel()
//     source = CancelToken.source()
//     cb()
// }

var SearchMenu = /*#__PURE__*/function (_React$Component) {
  _inherits$1(SearchMenu, _React$Component);

  var _super = _createSuper$T(SearchMenu);

  function SearchMenu(props) {
    var _this;

    _classCallCheck$1(this, SearchMenu);

    _this = _super.call(this, props);
    _this.state = {
      searchInput: '',
      lists: null,
      loading: true
    };
    _this.hostUrl = _this.props.hostUrl;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.clickList = _this.clickList.bind(_assertThisInitialized(_this));
    _this.getTheatresList = _.debounce(_this.getTheatresList, 800);
    return _this;
  }

  _createClass$1(SearchMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hostUrl = this.hostUrl;

      if (hostUrl) {
        this.getTheatresList();
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "getTheatresList",
    value: function getTheatresList() {
      var _this2 = this;

      var hostUrl = this.hostUrl;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(this.props.accessToken)
        }
      };
      var searchInput = this.state.searchInput;
      axios.get("".concat(hostUrl, "/v1/theatres/lists?q=").concat(searchInput.trim(), "&offset=0&ps=5&sortBy=accessed_on|desc"), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          _this2.setState({
            list: response.data.theatreLists,
            loading: false
          });
        }
      }).catch(function (error) {
        console.log(error);

        _this2.setState({
          error: true
        });
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _this3 = this;

      this.setState({
        searchInput: e.target.value,
        loading: true
      }, function () {
        return _this3.getTheatresList();
      });
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this4 = this;

      var _this$state = this.state,
          list = _this$state.list,
          loading = _this$state.loading;

      if (list && list.length > 0) {
        return list.map(function (list) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: list.id,
            disabled: _this4.state.loading,
            onClick: function onClick() {
              return !loading ? _this4.clickList(list) : '';
            },
            className: "theatre-list-view-item"
          }, list.name);
        });
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-view-empty"
      }, "No results found");
    }
  }, {
    key: "clickList",
    value: function clickList(list) {
      this.props.handleAddNewItem(list);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          searchInput = _this$state2.searchInput,
          loading = _this$state2.loading;
          _this$state2.list;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-selection-view"
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "input-search-container"
      }, /*#__PURE__*/React__default.createElement(InputBox, {
        placeholder: "Search for list",
        onTextChange: this.handleChange,
        value: searchInput,
        style: {
          height: 35
        }
      })), loading ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-render-view-loader"
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-render-view"
      }, this.renderList()), /*#__PURE__*/React__default.createElement("div", {
        className: "add-new-list-select-modal",
        onClick: this.props.addNewList
      }, "+ Create List")));
    }
  }]);

  return SearchMenu;
}(React__default.Component);

var DeleteModal = function DeleteModal(props) {
  var heading = props.heading,
      content = props.content,
      deleteText = props.deleteText,
      cancelText = props.cancelText,
      cancelFunction = props.cancelFunction,
      deleteFunction = props.deleteFunction,
      listPosting = props.listPosting;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'delete-modal-overlay'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-header"
  }, heading), /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-content"
  }, content), /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-footer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cancel-button-view",
    onClick: function onClick() {
      return cancelFunction();
    }
  }, /*#__PURE__*/React__default.createElement(_Button, {
    type: "link"
  }, cancelText)), /*#__PURE__*/React__default.createElement("div", {
    className: "submit-button-view"
  }, /*#__PURE__*/React__default.createElement(_Button, {
    className: 'submit-button-confirm-text',
    loading: listPosting,
    onClick: function onClick() {
      return deleteFunction();
    }
  }, deleteText)))));
};

function _createSuper$S(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$S(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$S() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectedHeader = /*#__PURE__*/function (_React$Component) {
  _inherits$1(SelectedHeader, _React$Component);

  var _super = _createSuper$S(SelectedHeader);

  function SelectedHeader(props) {
    var _this;

    _classCallCheck$1(this, SelectedHeader);

    _this = _super.call(this, props);
    _this.state = {
      showList: false,
      showOptions: false,
      isOpenDeleteModal: false
    };
    _this.openList = _this.openList.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.addToItem = _this.addToItem.bind(_assertThisInitialized(_this));
    _this.confirmClearList = _this.confirmClearList.bind(_assertThisInitialized(_this));
    _this.handleModalClose = _this.handleModalClose.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(SelectedHeader, [{
    key: "openList",
    value: function openList() {
      this.setState({
        showList: !this.state.showList,
        showOptions: false
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      var _this2 = this;

      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({
          showList: false
        }, function () {
          return _this2.forceUpdate();
        });
      }

      if (this.wrapperOptionRef && !this.wrapperOptionRef.contains(event.target)) {
        if (!event.target.closest('.theatre-selection-dropdown')) {
          this.setState({
            showOptions: false
          }, function () {
            return _this2.forceUpdate();
          });
        }
      }

      if (this.modalWrapperRef && !this.modalWrapperRef.contains(event.target)) {
        this.setState({
          isOpenDeleteModal: false
        });
      }
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      if (node) {
        this.wrapperRef = node;
      }
    }
  }, {
    key: "setWrapperOptionRef",
    value: function setWrapperOptionRef(node) {
      if (node) {
        this.wrapperOptionRef = node;
      }
    }
  }, {
    key: "setModalWrapperRef",
    value: function setModalWrapperRef(node) {
      if (node) {
        this.modalWrapperRef = node;
      }
    }
  }, {
    key: "handleAddToNewItem",
    value: function handleAddToNewItem() {
      this.setState({
        showList: false
      });
      this.props.handleAddToNewItem();
    }
  }, {
    key: "addToItem",
    value: function addToItem(list) {
      this.props.addToItem(list);
      this.setState({
        showList: !this.state.showList
      });
    }
  }, {
    key: "addNewList",
    value: function addNewList() {
      var _this3 = this;

      this.setState({
        showList: !this.state.showList
      }, function () {
        return _this3.props.handleAddToNewItem();
      });
    }
  }, {
    key: "confirmClearList",
    value: function confirmClearList() {
      this.setState({
        showOptions: false,
        isOpenDeleteModal: true
      });
    }
  }, {
    key: "openOptions",
    value: function openOptions() {
      this.setState({
        showOptions: !this.state.showOptions
      });
    }
  }, {
    key: "changeView",
    value: function changeView() {
      this.props.onChangeView();
    }
  }, {
    key: "handleModalClose",
    value: function handleModalClose() {
      this.setState({
        isOpenDeleteModal: false
      });
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      this.props.clearTheatreList();
      this.setState({
        isOpenDeleteModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          title = _this$props.title,
          areTheatresSelected = _this$props.areTheatresSelected;
          _this$props.addToList;
          var hasList = _this$props.hasList;
      var _this$state = this.state,
          showList = _this$state.showList,
          showOptions = _this$state.showOptions,
          isOpenDeleteModal = _this$state.isOpenDeleteModal;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selected-view-header"
      }, /*#__PURE__*/React__default.createElement(HeaderText, {
        text: title
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-options"
      }, areTheatresSelected && /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-add-to-list"
      }, hasList && /*#__PURE__*/React__default.createElement("div", {
        className: "option-button-view"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        type: "link",
        onClick: this.openList
      }, i18n.t('addToList'))), /*#__PURE__*/React__default.createElement("div", {
        className: "option-button-view"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        type: "link",
        onClick: this.confirmClearList
      }, i18n.t('clear'))), showList && /*#__PURE__*/React__default.createElement("div", {
        className: "add-to-list-search-menu",
        ref: function ref(node) {
          return _this4.setWrapperRef(node);
        }
      }, /*#__PURE__*/React__default.createElement(SearchMenu, {
        hostUrl: this.props.hostUrl,
        accessToken: this.props.accessToken,
        handleAddNewItem: this.addToItem,
        addNewList: function addNewList() {
          return _this4.addNewList();
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button"
      }, /*#__PURE__*/React__default.createElement(SelectButton, {
        clickEvent: function clickEvent() {
          return _this4.changeView();
        },
        text: i18n.t('back')
      }), areTheatresSelected && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selection-dropdown",
        onClick: function onClick() {
          return _this4.openOptions();
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button-bullet"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button-bullet"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button-bullet"
      })), showOptions && /*#__PURE__*/React__default.createElement("div", {
        id: "more-selection-options",
        className: "selected-view-options",
        ref: function ref(node) {
          return _this4.setWrapperOptionRef(node);
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this4.openList();
        }
      }, i18n.t('addToList')), /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this4.confirmClearList();
        }
      }, i18n.t('clear'))))), isOpenDeleteModal && /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(node) {
          return _this4.setModalWrapperRef(node);
        }
      }, /*#__PURE__*/React__default.createElement(DeleteModal, {
        deleteFunction: this.handleClear,
        cancelFunction: this.handleModalClose,
        heading: i18n.t('clearTheatreSelection'),
        content: i18n.t('clearTheatreSelectionConfirmation'),
        cancelText: i18n.t('noKeepSelection'),
        deleteText: i18n.t('yesClear')
      })));
    }
  }]);

  return SelectedHeader;
}(React__default.Component);

function _createSuper$R(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$R(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$R() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultTabs = /*#__PURE__*/function (_Component) {
  _inherits$1(DefaultTabs, _Component);

  var _super = _createSuper$R(DefaultTabs);

  function DefaultTabs(props) {
    var _this;

    _classCallCheck$1(this, DefaultTabs);

    _this = _super.call(this, props);
    _this.state = {
      selectedTab: _this.props.selectedTab
    };
    return _this;
  }

  _createClass$1(DefaultTabs, [{
    key: "handleTabChange",
    value: function handleTabChange(tab) {
      this.setState({
        selectedTab: tab
      });
      this.props.onTabChange(tab);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedTab = this.state.selectedTab;
      var tabsDetail = this.props.tabsDetail;
      return /*#__PURE__*/React__default.createElement("ul", {
        className: "tabs-list"
      }, tabsDetail.map(function (tab, index) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: selectedTab === tab.tabId ? 'tab-item active' : 'tab-item',
          onClick: function onClick() {
            return _this2.handleTabChange(tab.tabId);
          },
          key: tab.tabId
        }, /*#__PURE__*/React__default.createElement("span", {
          title: tab.tabName
        }, tab.tabName));
      }));
    }
  }]);

  return DefaultTabs;
}(Component);

function _createSuper$Q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$Q(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$Q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultTable = /*#__PURE__*/function (_Component) {
  _inherits$1(DefaultTable, _Component);

  var _super = _createSuper$Q(DefaultTable);

  function DefaultTable() {
    _classCallCheck$1(this, DefaultTable);

    return _super.apply(this, arguments);
  }

  _createClass$1(DefaultTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          rows = _this$props.rows,
          fetchingData = _this$props.fetchingData;
      return /*#__PURE__*/React__default.createElement(_Table, {
        columns: columns,
        dataSource: rows,
        size: "middle",
        bordered: true,
        pagination: false,
        locale: {
          emptyText: fetchingData ? '' : 'No Data Found'
        },
        loading: fetchingData,
        scroll: {
          x: 1024
        }
      });
    }
  }]);

  return DefaultTable;
}(Component);

function _createSuper$P(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$P(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$P() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SaveTagModal = /*#__PURE__*/function (_Component) {
  _inherits$1(SaveTagModal, _Component);

  var _super = _createSuper$P(SaveTagModal);

  function SaveTagModal(props) {
    var _this;

    _classCallCheck$1(this, SaveTagModal);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleInputChange", function (event) {
      _this.setState(_defineProperty$1({}, event.target.name, event.target.value));
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleSave", function () {
      _this.props.handleSubmit(_this.state.tagName);
    });

    _this.state = {
      tagName: _this.props.tagName
    };
    return _this;
  }

  _createClass$1(SaveTagModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.input.focus();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          title = _this$props.title,
          visible = _this$props.visible,
          loading = _this$props.loading,
          submitBtnName = _this$props.submitBtnName,
          hasErrorMessage = _this$props.hasErrorMessage;
      var tagName = this.state.tagName;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: title,
        wrapClassName: "vertical-center-modal modal-medium",
        visible: visible,
        onCancel: this.props.handleCancel,
        footer: [/*#__PURE__*/React__default.createElement(_Button, {
          key: "back",
          size: "large",
          onClick: this.props.handleCancel,
          disabled: loading,
          className: "cancel-btn"
        }, i18n.t('cancel')), /*#__PURE__*/React__default.createElement(_Button, {
          key: "submit",
          type: "primary",
          size: "large",
          loading: loading,
          onClick: this.handleSave,
          disabled: tagName.length > 50 || tagName.length < 1
        }, submitBtnName)]
      }, /*#__PURE__*/React__default.createElement(InputLabel, {
        content: i18n.t('tagName')
      }), /*#__PURE__*/React__default.createElement(_Input, {
        size: "large",
        placeholder: i18n.t('enterTagName'),
        value: tagName,
        name: "tagName",
        onChange: this.handleInputChange,
        autoComplete: "off",
        ref: function ref(node) {
          return _this3.input = node;
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "input-meta__data"
      }, hasErrorMessage && /*#__PURE__*/React__default.createElement(HelpText, {
        isErrorMessage: true,
        content: hasErrorMessage
      }), tagName.length > 50 && /*#__PURE__*/React__default.createElement(HelpText, {
        isErrorMessage: true,
        content: i18n.t('tagNameLessThan50Char')
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "character-count"
      }, tagName.length, "/50")));
    }
  }]);

  return SaveTagModal;
}(Component);

SaveTagModal.defaultProps = {
  title: i18n.t('createModal'),
  tagName: '',
  loading: false,
  submitBtnName: i18n.t('submit'),
  visible: false,
  hasErrorMessage: '',
  handleSubmit: function handleSubmit() {},
  handleCancel: function handleCancel() {}
};

function _createSuper$O(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$O(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$O() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option$2 = _Select.Option;

var TagsDropdownMenu = /*#__PURE__*/function (_Component) {
  _inherits$1(TagsDropdownMenu, _Component);

  var _super = _createSuper$O(TagsDropdownMenu);

  function TagsDropdownMenu(props) {
    var _this;

    _classCallCheck$1(this, TagsDropdownMenu);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleChange", function (value) {
      _this.setState({
        value: value
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleSaveTags", function () {
      var tagsListData = _this.props.tagsListData;
      var tagsTobeSaved = [];

      if (tagsListData.companyTags) {
        tagsTobeSaved = _this.state.value.map(function (tagname) {
          return tagsListData.companyTags.find(function (tag) {
            return tag.name === tagname;
          }).id;
        });
      }

      _this.props.saveMappedTags(tagsTobeSaved);
    });

    _this.state = {
      value: _this.props.cplTags.map(function (tag) {
        return tag.name;
      }),
      menuItems: []
    };
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(TagsDropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.tagsListData.fetchingData && this.props.tagsListData.companyTags) {
        var tagsList = this.props.tagsListData.companyTags.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        var menuItems = tagsList.map(function (tag) {
          return {
            text: "".concat(tag.name),
            value: tag.name
          };
        });
        this.setState({
          menuItems: menuItems
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isEdit = _this$props.isEdit,
          tagsListData = _this$props.tagsListData,
          mappingTagsStatus = _this$props.mappingTagsStatus;
      var _this$state = this.state,
          value = _this$state.value,
          menuItems = _this$state.menuItems;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-menu__tags"
      }, value.length < 1 && /*#__PURE__*/React__default.createElement("div", {
        className: "search-icon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "search",
        size: "20"
      })), /*#__PURE__*/React__default.createElement(_Select, {
        autoFocus: true,
        mode: "multiple",
        className: "tags-select",
        placeholder: i18n.t('searchAndAddTags'),
        value: value,
        showAction: ['focus', 'click'],
        onChange: this.handleChange,
        getPopupContainer: function getPopupContainer() {
          return document.getElementById('tags-dropdown');
        },
        filterOption: function filterOption(inputValue, option) {
          return option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
        },
        notFoundContent: tagsListData.fetchingData ? /*#__PURE__*/React__default.createElement(_Spin, {
          size: "small"
        }) : /*#__PURE__*/React__default.createElement("div", {
          className: "empty-tags__message"
        }, /*#__PURE__*/React__default.createElement(Trans, {
          i18nKey: "noTagsFoundClickHereToCreateOne",
          i18n: i18n
        }, 'No Tags Found. Click ', /*#__PURE__*/React__default.createElement("span", {
          className: "empty-tag__click",
          onClick: this.props.manageTags
        }, "here"), ' to create one'))
      }, menuItems.map(function (item) {
        return /*#__PURE__*/React__default.createElement(Option$2, {
          key: item.text,
          value: item.value
        }, item.text);
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-menu__tagslist",
        id: "tags-dropdown",
        ref: this.setWrapperRef
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-menu__tagsfooter"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "btn-container"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        key: "manage",
        size: "small",
        disabled: mappingTagsStatus,
        className: "link-btn",
        onClick: this.props.manageTags
      }, i18n.t('manage'))), /*#__PURE__*/React__default.createElement("div", {
        className: "btn-container"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        key: "manage",
        size: "small",
        disabled: mappingTagsStatus,
        className: "cancel-btn",
        onClick: this.props.closeDropdownMenu
      }, i18n.t('cancel')), /*#__PURE__*/React__default.createElement(_Button, {
        key: "update",
        type: "primary",
        size: "small",
        disabled: !isEdit && value.length < 1,
        loading: mappingTagsStatus,
        onClick: this.handleSaveTags
      }, isEdit ? i18n.t('update') : i18n.t('add')))));
    }
  }]);

  return TagsDropdownMenu;
}(Component);

TagsDropdownMenu.defaultProps = {
  isEdit: false,
  tagsListData: {},
  cplTags: [],
  saveMappedTags: function saveMappedTags() {},
  manageTags: function manageTags() {}
};

function _createSuper$N(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$N(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$N() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MapTagsDropdown = /*#__PURE__*/function (_Component) {
  _inherits$1(MapTagsDropdown, _Component);

  var _super = _createSuper$N(MapTagsDropdown);

  function MapTagsDropdown() {
    var _this;

    _classCallCheck$1(this, MapTagsDropdown);

    _this = _super.call(this);

    _defineProperty$1(_assertThisInitialized(_this), "handleVisibleChange", function (flag) {
      _this.setState({
        visible: flag
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "closeDropdownMenu", function () {
      _this.setState({
        visible: false
      });
    });

    _this.state = {
      visible: false
    };
    return _this;
  }

  _createClass$1(MapTagsDropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.mappingTagsStatus === true && nextProps.mappingTagsStatus === false && this.state.visible === true) {
        this.setState({
          visible: false
        });
      }
    }
  }, {
    key: "renderDropdownOptions",
    value: function renderDropdownOptions() {
      if (this.state.visible) {
        return /*#__PURE__*/React__default.createElement(TagsDropdownMenu, {
          isEdit: this.props.isEdit,
          closeDropdownMenu: this.closeDropdownMenu,
          tagsListData: this.props.tagsListData,
          cplTags: this.props.cplTags,
          saveMappedTags: this.props.saveMappedTags,
          manageTags: this.props.manageTags,
          mappingTagsStatus: this.props.mappingTagsStatus
        });
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "empty-menu"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isEdit = _this$props.isEdit,
          inlineDropdown = _this$props.inlineDropdown,
          compositionType = _this$props.compositionType;
      return /*#__PURE__*/React__default.createElement(_Dropdown, {
        overlay: this.renderDropdownOptions(),
        trigger: ["click"],
        onVisibleChange: this.handleVisibleChange,
        visible: this.state.visible
      }, /*#__PURE__*/React__default.createElement("div", {
        className: inlineDropdown ? "map-tags__dropdown__layout inline-dropdown" : "map-tags__dropdown__layout"
      }, isEdit ? /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "edit",
        size: "16"
      }) : /*#__PURE__*/React__default.createElement("i", {
        className: "add-tag"
      }, "+ ", !compositionType && /*#__PURE__*/React__default.createElement("span", {
        className: "add-text"
      }, "Add Tags"))));
    }
  }]);

  return MapTagsDropdown;
}(Component);

MapTagsDropdown.defaultProps = {
  isEdit: false,
  tagsListData: {},
  cplTags: [],
  saveMappedTags: function saveMappedTags() {},
  manageTags: function manageTags() {},
  compositionType: ''
};

function _createSuper$M(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$M(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$M() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CompositionCardTags = /*#__PURE__*/function (_Component) {
  _inherits$1(CompositionCardTags, _Component);

  var _super = _createSuper$M(CompositionCardTags);

  function CompositionCardTags() {
    var _this;

    _classCallCheck$1(this, CompositionCardTags);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "handleOnClick", function (value, type) {
      if (type !== 'ratings' && !_this.props.readOnly) {
        if (_this.props.removeFilterTag) {
          _this.props.removeFilterTag(_this.props.filterPosition);
        } else {
          var tag = type.trim() + ': ' + value.trim();

          _this.props.filterBytags(tag);
        }
      }
    });

    return _this;
  }

  _createClass$1(CompositionCardTags, [{
    key: "renderTag",
    value: function renderTag(tagName, tagValue, id) {
      var _this2 = this;

      var _this$props = this.props;
          _this$props.readOnly;
          var canMapTags = _this$props.canMapTags,
          tagsListData = _this$props.tagsListData,
          mappingTagsStatus = _this$props.mappingTagsStatus;

      switch (tagName) {
        case 'type':
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(Tag, {
              color: 'orange',
              onClick: function onClick() {
                return _this2.handleOnClick(tagValue, tagName);
              },
              key: "".concat(tagName, "_").concat(tagValue),
              className: tagValue.toLowerCase()
            }, tagValue);
          }

          break;

        case 'resolution':
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(Tag, {
              color: 'secondary',
              onClick: function onClick() {
                return _this2.handleOnClick(tagValue, tagName);
              },
              key: "".concat(tagName, "_").concat(tagValue)
            }, tagValue);
          }

          break;

        case 'stereoType':
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(Tag, {
              color: 'secondary',
              onClick: function onClick() {
                return _this2.handleOnClick(tagValue, 'format');
              },
              key: "".concat(tagName, "_").concat(tagValue)
            }, tagValue);
          }

          break;

        case 'aspectRatio':
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(Tag, {
              color: 'secondary',
              onClick: function onClick() {
                return _this2.handleOnClick(tagValue, 'aspect');
              },
              key: "".concat(tagName, "_").concat(tagValue)
            }, tagValue);
          }

          break;

        case 'language':
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(Tag, {
              color: 'secondary',
              onClick: function onClick() {
                return _this2.handleOnClick(tagValue, tagName);
              },
              prefixIcon: /*#__PURE__*/React__default.createElement(Icons.AudioIcon, {
                height: '16',
                width: '16',
                viewBox: "0 0 24 24"
              }),
              key: "".concat(tagName, "_").concat(tagValue)
            }, tagValue);
          }

          break;

        case 'subtitleLanguage':
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(Tag, {
              color: 'secondary',
              onClick: function onClick() {
                return _this2.handleOnClick(tagValue, 'subtitle');
              },
              prefixIcon: /*#__PURE__*/React__default.createElement(Icons.SubtitlesIcon, {
                height: '16',
                width: '16',
                viewBox: "0 0 24 24"
              }),
              key: "".concat(tagName, "_").concat(tagValue)
            }, tagValue);
          }

          break;

        case 'audioFormats':
          if (tagValue && tagValue.length > 0) {
            var _listOfTags = tagValue.map(function (item, index) {
              return /*#__PURE__*/React__default.createElement(Tag, {
                color: 'secondary',
                onClick: function onClick() {
                  return _this2.handleOnClick(item, 'audio');
                },
                key: "".concat(tagName, "_").concat(item)
              }, item);
            });

            return _listOfTags;
          }

          break;

        case 'closedCaptions':
          if (tagValue && tagValue.length > 0) {
            var _listOfTags2 = tagValue.map(function (item, index) {
              return /*#__PURE__*/React__default.createElement(Tag, {
                color: 'secondary',
                onClick: function onClick() {
                  return _this2.handleOnClick(item, 'captions');
                },
                prefixIcon: /*#__PURE__*/React__default.createElement(Icons.ClosedCaptionsIcon, {
                  height: '16',
                  width: '16',
                  viewBox: "0 0 24 24"
                }),
                key: "".concat(tagName, "_").concat(item)
              }, item);
            });

            return _listOfTags2;
          }

          break;

        case 'mappedTags':
          var listOfTags = [];

          if (tagValue && tagValue.length > 0) {
            var cplTags = tagValue.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            listOfTags = cplTags.map(function (item, index) {
              return /*#__PURE__*/React__default.createElement(Tag, {
                color: 'secondary',
                onClick: function onClick() {
                  return _this2.handleOnClick(item.name, 'tag');
                },
                key: "".concat(tagName, "_").concat(item)
              }, item.name);
            });

            if (canMapTags) {
              listOfTags.push( /*#__PURE__*/React__default.createElement(MapTagsDropdown, {
                isEdit: true,
                tagsListData: tagsListData,
                saveMappedTags: this.props.saveMappedTags,
                manageTags: this.props.manageTags,
                key: "".concat(tagName, "mapTags"),
                cplTags: cplTags,
                mappingTagsStatus: mappingTagsStatus,
                compositionType: this.props.composition.type
              }));
            }

            return listOfTags;
          } else if (canMapTags) {
            listOfTags.push( /*#__PURE__*/React__default.createElement(MapTagsDropdown, {
              isEdit: false,
              tagsListData: tagsListData,
              saveMappedTags: this.props.saveMappedTags,
              manageTags: this.props.manageTags,
              key: "".concat(tagName, "maptags"),
              mappingTagsStatus: mappingTagsStatus,
              compositionType: this.props.composition.type
            }));
            return listOfTags;
          }

          break;

        case 'ratings':
          var ratings = tagValue;

          if (ratings && ratings.length > 0) {
            if (ratings.length === 1) {
              return /*#__PURE__*/React__default.createElement(Tag, {
                color: "secondary" // prefixIcon={<AppIcon name="certifications" size="16" />}

              }, this._renderRating(ratings[0].name));
            } else {
              return this.renderRatingsMenu(_toConsumableArray$1(ratings).sort());
            }
          }

          break;
      }
    }
  }, {
    key: "_renderRating",
    value: function _renderRating(name) {
      return name ? name : 'None';
    }
  }, {
    key: "renderAgencyAndRating",
    value: function renderAgencyAndRating(rating) {
      var value;

      if (rating.agency && rating.agency.name) {
        value = "".concat(rating.agency.name, ", ").concat(this._renderRating(rating.name));
      } else {
        value = 'Unknown agency'.concat(", ", this._renderRating(rating.name));
      }

      return value;
    }
  }, {
    key: "renderRatingsSubmenu",
    value: function renderRatingsSubmenu(ratings) {
      var _this3 = this;

      return /*#__PURE__*/React__default.createElement(_Menu, {
        className: "ratings-dropdown"
      }, ratings.map(function (rating, index) {
        return /*#__PURE__*/React__default.createElement(_Menu.Item, {
          key: index
        }, _this3.renderAgencyAndRating(rating));
      }));
    }
  }, {
    key: "renderRatingsMenu",
    value: function renderRatingsMenu(ratings) {
      return /*#__PURE__*/React__default.createElement(_Dropdown, {
        overlay: this.renderRatingsSubmenu(ratings),
        trigger: ['click']
      }, /*#__PURE__*/React__default.createElement(Tag, {
        color: "secondary" // prefixIcon={<AppIcon name="certifications" size="16" />}

      }, this._renderRating(ratings[0].name) + ' ...'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var composition = this.props.composition;
      var tagsDetails = {
        type: composition.type,
        resolution: composition.resolution,
        stereoType: composition.stereoType,
        aspectRatio: composition.aspectRatio,
        audioFormats: composition.audioFormats,
        language: composition.language,
        subtitleLanguage: composition.subtitleLanguage,
        closedCaptions: composition.closedCaptions,
        ratings: composition.ratings,
        mappedTags: composition.tags
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tags-container"
      }, Object.keys(tagsDetails).map(function (tag, id) {
        return _this4.renderTag(tag, tagsDetails[tag], id);
      }));
    }
  }]);

  return CompositionCardTags;
}(Component);

CompositionCardTags.defaultProps = {
  filterBytags: function filterBytags() {},
  canMapTags: false,
  tagsListData: {},
  saveMappedTags: function saveMappedTags() {},
  manageTags: function manageTags() {},
  mappingTagsStatus: false
};

function formatDuration(duration) {
  var formatted = moment.utc(moment.duration(parseFloat(duration), 's').asMilliseconds()).format('HH:mm:ss');

  if (formatted.length === 5) {
    formatted = "00:".concat(formatted);
  }

  if (formatted.length === 2) {
    formatted = "00:00:".concat(formatted);
  }

  return formatted;
}
function formatDateTime(momentObj) {
  return momentObj.format('DD MMM YYYY hh:mm A');
}

function _createSuper$L(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$L(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$L() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var cplTypes = {
  "tran'l": i18n.t('transitional'),
  advert: i18n.t('advertisement')
};

var CompositionInfoModal = /*#__PURE__*/function (_Component) {
  _inherits$1(CompositionInfoModal, _Component);

  var _super = _createSuper$L(CompositionInfoModal);

  function CompositionInfoModal(props) {
    _classCallCheck$1(this, CompositionInfoModal);

    return _super.call(this, props);
  }

  _createClass$1(CompositionInfoModal, [{
    key: "renderRatings",
    value: function renderRatings() {
      var composition = this.props.composition;
      var nodes = composition.ratings.map(function (rating) {
        if (rating.agency && rating.agency.name) {
          return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
            title: rating.agency.uri
          }, rating.agency.name), ' ', rating.country.code, " ,", rating.name);
        }

        if (rating.agency && rating.agency.uri) {
          return /*#__PURE__*/React__default.createElement("div", {
            title: rating.agency.uri
          }, "Unknown agency,", rating.name);
        }
      });
      return nodes;
    }
  }, {
    key: "renderAudioFormat",
    value: function renderAudioFormat() {
      var composition = this.props.composition;
      var format = '';

      if (composition.audioFormats.indexOf('Atmos') !== -1) {
        format = 'Atmos';
      } else {
        format = composition.audioFormats.join(', ');
      }

      format = composition.hearingImpaired ? format.concat(', HI') : format;
      format = composition.visuallyImpaired ? format.concat(', VI') : format;
      return /*#__PURE__*/React__default.createElement("span", null, format);
    }
  }, {
    key: "renderMarkers",
    value: function renderMarkers() {
      var _this$props$compositi = this.props.composition,
          _this$props$compositi2 = _this$props$compositi.markers,
          markers = _this$props$compositi2 === void 0 ? [] : _this$props$compositi2,
          duration = _this$props$compositi.duration;
      var nodes = [];
      var markerNodes = [];
      var processedMarkers = [];

      if (markers) {
        MARKERS.map(function (marker) {
          var data = markers.filter(function (markerItem) {
            return markerItem.label == marker;
          })[0];

          if (data) {
            markerNodes.push( /*#__PURE__*/React__default.createElement("div", {
              className: "modal-block__description",
              key: marker
            }, marker, " -", formatDuration(data.value), " (-", formatDuration(parseFloat(duration) - parseInt(data.value)), ")"));
            processedMarkers.push(marker);
          }
        });
        nodes.push(markerNodes);
      }

      if (!markerNodes.length) {
        nodes.push( /*#__PURE__*/React__default.createElement("div", {
          className: "modal-block__description no-mg",
          key: "none"
        }, i18n.t('none')));
      }

      if ((!nodes.length || MARKERS.length != processedMarkers.length) && this.props.showAddMarker && this.props.addMarkerRender) {
        nodes.push( /*#__PURE__*/React__default.createElement("div", {
          className: "composition-modal-info-overview"
        }, this.props.addMarkerRender));
      }

      return nodes;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          visible = _this$props.visible,
          composition = _this$props.composition,
          modalClassName = _this$props.modalClassName;
      var nullDefault;
      var compositionTags;

      if (composition) {
        nullDefault = composition.type ? i18n.t('none') : i18n.t('unknown');
        compositionTags = {
          tags: composition.tags
        };
      }

      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: i18n.t('compositionDetails'),
        wrapClassName: classNames$1('vertical-center-modal modal-large', modalClassName),
        visible: visible,
        onCancel: this.props.handleCancel,
        footer: null
      }, composition && /*#__PURE__*/React__default.createElement("div", {
        className: "compositoinDetails"
      }, composition.name && /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__header"
      }, composition.name), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, composition.id))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('duration')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.duration ? formatDuration(composition.duration) : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('type')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.type ? cplTypes[composition.type.toLowerCase()] || composition.type : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('format')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.stereoType ? composition.stereoType : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('aspectRatio')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.aspectRatio ? composition.aspectRatio : nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('frameRate')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.frameRate ? composition.frameRate : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('cplFormat')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.cplFormat ? composition.cplFormat === 'smpte' ? composition.cplFormat.toUpperCase() : composition.cplFormat : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('spokenLanguage')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.language ? composition.language : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('subtitleLanguage')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.subtitleLanguage ? composition.subtitleLanguage : nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('closedCaptions')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.closedCaptions && composition.closedCaptions.length > 0 ? composition.closedCaptions.join(', ') : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('mainCaptions')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.mainCaption ? composition.mainCaption : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('closedSubtitles')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.closedSubtitles && composition.closedSubtitles.length > 0 ? composition.closedSubtitles.join(', ') : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('cplMetadata')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.hasMetadata ? i18n.t('yes') : i18n.t('no')))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('ratings')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.ratings && composition.ratings.length > 0 ? this.renderRatings() : nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('cplMarkers')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__markers"
      }, this.renderMarkers()))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth sm-pd__b"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title sm-mg__b"
      }, i18n.t('tags')), compositionTags.tags && compositionTags.tags.length > 0 ? /*#__PURE__*/React__default.createElement(CompositionCardTags, {
        composition: compositionTags,
        readOnly: true
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__link"
      }, /*#__PURE__*/React__default.createElement(Trans, {
        i18nKey: "conventionLink",
        i18n: i18n
      }, 'Data from Composition name based on the ', /*#__PURE__*/React__default.createElement("a", {
        href: "http://isdcf.com/dcnc/",
        target: "_blank",
        rel: "noreferrer"
      }, "Digital Cinema Naming Convention"))))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('resolution')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.resolution ? composition.resolution : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('audioFormat')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.audioFormats && composition.audioFormats.length > 0 ? this.renderAudioFormat() : nullDefault)))));
    }
  }]);

  return CompositionInfoModal;
}(Component);

CompositionInfoModal.defaultProps = {
  visible: false,
  handleCancel: function handleCancel() {},
  showAddMarker: false
};

function showKdmValidity(kdmSummary) {
  if (kdmSummary) {
    var statuses = Object.keys(kdmSummary.statuses);

    if (statuses.find(function (k) {
      return k.toLowerCase() === KDMStatuses.inprogress;
    })) {
      return statuses.length > 1;
    }

    return true;
  }

  return false;
}

function getTheatreKdmSummaryStatus(theatre, kdmStatus, kdmIngestStatus) {
  var kdmGenerationCompleted = true;
  var kdmIssuedScreenCount = 0;
  var kdmSummaryStatus = theatre.kdmSummary ? theatre.kdmSummary.statuses : [];
  var kdmIngestSummaryStatus = theatre.kdmSummary ? theatre.kdmSummary.ingest : {};
  [KDMStatuses.success, KDMStatuses.generated, KDMStatuses.emailed].forEach(function (key) {
    if (kdmSummaryStatus[key]) {
      kdmIssuedScreenCount += kdmSummaryStatus[key];
    }
  });

  switch (true) {
    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.action_required) && kdmSummaryStatus[KDMStatuses.action_required] > 0:
      if (kdmStatus[KDMStatuses.action_required]) {
        kdmStatus[KDMStatuses.action_required] += 1;
      } else {
        kdmStatus[KDMStatuses.action_required] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.failed) && kdmSummaryStatus[KDMStatuses.failed] > 0:
      if (kdmStatus[KDMStatuses.failed]) {
        kdmStatus[KDMStatuses.failed] += 1;
      } else {
        kdmStatus[KDMStatuses.failed] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.unavailable) && kdmSummaryStatus[KDMStatuses.unavailable] > 0:
      if (kdmStatus[KDMStatuses.unavailable]) {
        kdmStatus[KDMStatuses.unavailable] += 1;
      } else {
        kdmStatus[KDMStatuses.unavailable] = 1;
      }

      break;

    case _.isEmpty(kdmSummaryStatus):
      if (kdmStatus[KDMStatuses.unavailable]) {
        kdmStatus[KDMStatuses.unavailable] += 1;
      } else {
        kdmStatus[KDMStatuses.unavailable] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.expiring) && kdmSummaryStatus[KDMStatuses.expiring] > 0:
      if (kdmStatus[KDMStatuses.expiring]) {
        kdmStatus[KDMStatuses.expiring] += 1;
      } else {
        kdmStatus[KDMStatuses.expiring] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.emailed) && kdmSummaryStatus[KDMStatuses.emailed] > 0:
      if (kdmStatus[KDMStatuses.emailed]) {
        kdmStatus[KDMStatuses.emailed] += 1;
      } else {
        kdmStatus[KDMStatuses.emailed] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.success) && kdmSummaryStatus[KDMStatuses.success] > 0 || kdmSummaryStatus.hasOwnProperty(KDMStatuses.generated) && kdmSummaryStatus[KDMStatuses.generated] > 0 || kdmSummaryStatus.hasOwnProperty('GENERATED') && kdmSummaryStatus.GENERATED > 0:
      if (kdmStatus[KDMStatuses.success]) {
        kdmStatus[KDMStatuses.success] += 1;
      } else {
        kdmStatus[KDMStatuses.success] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.inProgress) && kdmSummaryStatus[KDMStatuses.inProgress] > 0:
      if (kdmStatus[KDMStatuses.inProgress]) {
        kdmStatus[KDMStatuses.inProgress] += 1;
      } else {
        kdmStatus[KDMStatuses.inProgress] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.expired) && kdmSummaryStatus[KDMStatuses.expired] > 0:
      if (kdmStatus[KDMStatuses.expired]) {
        kdmStatus[KDMStatuses.expired] += 1;
      } else {
        kdmStatus[KDMStatuses.expired] = 1;
      }

      break;

    default:
      kdmStatus[KDMStatuses.unavailable] = 1;
  }

  if (kdmIngestSummaryStatus) {
    if (kdmIngestSummaryStatus.Ingested) {
      if (kdmIngestStatus[IngestStatuses.ingested]) {
        kdmIngestStatus[IngestStatuses.ingested] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingested] = 1;
      }
    } else if (kdmIngestSummaryStatus.IngestCancelled) {
      if (kdmIngestStatus[IngestStatuses.ingestcancelled]) {
        kdmIngestStatus[IngestStatuses.ingestcancelled] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingestcancelled] = 1;
      }
    } else if (kdmIngestSummaryStatus.IngestFailed) {
      if (kdmIngestStatus[IngestStatuses.ingestfailed]) {
        kdmIngestStatus[IngestStatuses.ingestfailed] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingestfailed] = 1;
      }
    } else if (kdmIngestSummaryStatus.IngestInProgress) {
      if (kdmIngestStatus[IngestStatuses.ingestinprogress]) {
        kdmIngestStatus[IngestStatuses.ingestinprogress] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingestinprogress] = 1;
      }
    } else if (kdmIngestSummaryStatus.PendingIngest) {
      if (kdmIngestStatus[IngestStatuses.pendingingest]) {
        kdmIngestStatus[IngestStatuses.pendingingest] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.pendingingest] = 1;
      }
    }
  }

  if (kdmIssuedScreenCount && !!kdmStatus[KDMStatuses.inprogress]) {
    kdmGenerationCompleted = false;
  }

  return kdmGenerationCompleted;
}

function getKDMSummaryData(props) {
  var theatres = props.composition.theatres;
  var kdmStatus = {};
  var kdmIngestStatus = {};
  var kdmGenerationCompleted = true;
  var kdmValidity = {
    validFrom: '',
    validTill: '',
    timezone: '',
    isMultiple: false
  };
  theatres.forEach(function (theatre) {
    var kdmSummary = theatre.kdmSummary,
        timezone = theatre.timezone;

    var _ref = kdmSummary || {},
        validFrom = _ref.validFrom,
        validTill = _ref.validTill;

    var showValidity = showKdmValidity(kdmSummary);

    if (showValidity && validFrom && validTill && !kdmValidity.isMultiple) {
      if (!kdmValidity.validFrom && !kdmValidity.validTill) {
        kdmValidity = {
          validFrom: validFrom,
          validTill: validTill,
          timezone: timezone,
          isMultiple: false
        };
      } else {
        var curValidFrom = momentTZ.tz(validFrom, timezone);
        var curValidTill = momentTZ.tz(validTill, timezone);
        var kdmValidFrom = momentTZ.tz(kdmValidity.validFrom, kdmValidity.timezone);
        var kdmValidTill = momentTZ.tz(kdmValidity.validTill, kdmValidity.timezone);

        if (!_.isEqual(curValidFrom, kdmValidFrom) || !_.isEqual(curValidTill, kdmValidTill)) {
          kdmValidity = {
            validFrom: '',
            validTill: '',
            timezone: '',
            isMultiple: true
          };
        }
      }
    } else if (showValidity && !kdmValidity.isMultiple) {
      kdmValidity = {
        validFrom: '',
        validTill: '',
        timezone: '',
        isMultiple: true
      };
    }

    var theatreKdmGenerationComplete = getTheatreKdmSummaryStatus(theatre, kdmStatus, kdmIngestStatus);

    if (kdmGenerationCompleted && !theatreKdmGenerationComplete) {
      kdmGenerationCompleted = theatreKdmGenerationComplete;
    }
  });
  return {
    kdmStatus: kdmStatus,
    kdmIngestStatus: kdmIngestStatus,
    kdmGenerationCompleted: kdmGenerationCompleted,
    showKdmDownloadOption: theatres.length === 1 ? kdmGenerationCompleted : false,
    kdmValidity: kdmValidity
  };
}

function ingestStatusSummary$1(kdmIngestStatus) {
  var ingestSummary = [];
  var ingestCount = 100;

  for (var ingetStatus in kdmIngestStatus) {
    ingestSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: ingestCount,
      className: "kdm-summary__status kdm-ingest__status ".concat(ingetStatus.toLowerCase())
    }, ingestCount > 100 && /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__txt"
    }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__count"
    }, kdmIngestStatus[ingetStatus]), IngestStatusValues[ingetStatus.toLowerCase()]));
    ingestCount += 1;
  }

  return ingestSummary;
}

function renderKDMStatusSummary(kdmStatus, kdmValidity, kdmIngestStatus) {
  var statusSummary = [];
  var kdmStatusSummary = {
    emailed: 'Emailed',
    generated: 'Available',
    failed: 'Failed',
    inprogress: 'In Progress',
    action_required: 'Action Required',
    success: 'Available',
    unavailable: 'Unavailable',
    expired: 'Expired',
    expiring: 'Expiring'
  };
  var current = 1;

  if (kdmStatus[KDMStatuses.inprogress]) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: current,
      className: "kdm-summary__status inprogress"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__count"
    }, kdmStatus[KDMStatuses.inprogress]), kdmStatusSummary.inprogress));
    current += 1;
  }

  for (var status in kdmStatus) {
    if (status !== KDMStatuses.inprogress) {
      statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
        key: current,
        className: "kdm-summary__status ".concat(status.toLowerCase())
      }, current > 1 && /*#__PURE__*/React__default.createElement("span", {
        className: "status-meta__txt"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
        className: "status-meta__count"
      }, kdmStatus[status]), kdmStatusSummary[status.toLowerCase()]));
      current += 1;
    }
  }

  if (kdmIngestStatus) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      className: "ingest__status",
      key: current
    }, ingestStatusSummary$1(kdmIngestStatus)));
    current += 1;
  }

  var timezone = kdmValidity.timezone,
      validFrom = kdmValidity.validFrom,
      validTill = kdmValidity.validTill,
      isMultiple = kdmValidity.isMultiple;

  if (validFrom && validTill) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: current,
      className: "validity__status"
    }, formatDateTime(momentTZ.tz(validFrom, timezone)), /*#__PURE__*/React__default.createElement("span", {
      className: "to-division"
    }, "to"), formatDateTime(momentTZ.tz(validTill, timezone))));
  } else if (isMultiple) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: current,
      className: "validity__status"
    }, "Multiple Validities"));
  }

  return statusSummary;
}

function getDcpStatus(_ref) {
  var subDetail = _ref.subDetail,
      type = _ref.type;
  var status = subDetail || (type ? type.toLowerCase() : DCPStatuses.pending);

  switch (status) {
    case DCPStatuses.error:
    case DCPStatuses.expired:
      status = DCPStatuses.failed;
      break;

    case DCPStatuses.pending_cancellation:
      status = DCPStatuses.pending;
      break;
  }

  return status;
}

function getDcpShipmentStatus(dcpInfo) {
  var _dcpInfo$shippingDeta = dcpInfo.shippingDetails;
  _dcpInfo$shippingDeta = _dcpInfo$shippingDeta === void 0 ? {} : _dcpInfo$shippingDeta;
  var _dcpInfo$shippingDeta2 = _dcpInfo$shippingDeta.trackingInfo;
  _dcpInfo$shippingDeta2 = _dcpInfo$shippingDeta2 === void 0 ? {} : _dcpInfo$shippingDeta2;
  var status = _dcpInfo$shippingDeta2.status;

  switch (status) {
    case ShipmentStatuses.InfoReceived:
      return ShipmentStatuses.InTransit;

    case ShipmentStatuses.Pending:
      return DCPStatuses.dispatched;

    default:
      return status || DCPStatuses.dispatched;
  }
}

function getCplInfo(theatres) {
  var theatreCount = 0;
  var isDcpBooking = false;
  var isKdmBooking = false;
  var dcpStatus = {};
  var dcpIngestStatus = {};
  theatres.forEach(function (t) {
    theatreCount += 1;

    if (!_.isEmpty(t.kdmSummary)) {
      isKdmBooking = true;
    }

    if (t.dcp && !_.isEmpty(t.dcp)) {
      isDcpBooking = true;
      var status = getDcpStatus(t.dcp.status);

      if (status === DCPStatuses.dispatched) {
        status = getDcpShipmentStatus(t.dcp.details).toLowerCase();
      }

      if (dcpStatus[status]) {
        dcpStatus[status] += 1;
      } else {
        dcpStatus[status] = 1;
      }
    }

    if (t.dcpIngestSummary && t.dcpIngestSummary.statuses && !_.isEmpty(t.dcpIngestSummary.statuses)) {
      var dcpIngestSummaryStatus = t.dcpIngestSummary.statuses;

      if (dcpIngestSummaryStatus) {
        if (dcpIngestSummaryStatus.IngestFailed) {
          if (dcpIngestStatus[IngestStatuses.ingestfailed]) {
            dcpIngestStatus[IngestStatuses.ingestfailed] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingestfailed] = 1;
          }
        } else if (dcpIngestSummaryStatus.IngestInProgress) {
          if (dcpIngestStatus[IngestStatuses.ingestinprogress]) {
            dcpIngestStatus[IngestStatuses.ingestinprogress] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingestinprogress] = 1;
          }
        } else if (dcpIngestSummaryStatus.PendingIngest) {
          if (dcpIngestStatus[IngestStatuses.pendingingest]) {
            dcpIngestStatus[IngestStatuses.pendingingest] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.pendingingest] = 1;
          }
        } else if (dcpIngestSummaryStatus.Ingested) {
          if (dcpIngestStatus[IngestStatuses.ingested]) {
            dcpIngestStatus[IngestStatuses.ingested] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingested] = 1;
          }
        } else if (dcpIngestSummaryStatus.IngestCancelled) {
          if (dcpIngestStatus[IngestStatuses.ingestcancelled]) {
            dcpIngestStatus[IngestStatuses.ingestcancelled] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingestcancelled] = 1;
          }
        }
      }
    }
  });
  return {
    isDcpBooking: isDcpBooking,
    isKdmBooking: isKdmBooking,
    theatreCount: theatreCount,
    dcpStatus: dcpStatus,
    dcpIngestStatus: dcpIngestStatus
  };
}

function ingestStatusSummary(dcpIngestStatus) {
  var ingestSummary = [];
  var ingestCount = 100;

  for (var ingestStatus in dcpIngestStatus) {
    ingestSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: ingestCount,
      className: "dcp-summary__status dcp-ingest__status ".concat(ingestStatus.toLowerCase())
    }, ingestCount > 100 && /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__txt"
    }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__count"
    }, dcpIngestStatus[ingestStatus]), IngestStatusValues[ingestStatus.toLowerCase()]));
    ingestCount += 1;
  }

  return ingestSummary;
}

function renderDCPStatusSummary(DCPStatus, dcpIngestStatus) {
  var statusSummary = [];
  var current = 1;

  for (var status in DCPStatus) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("span", {
      key: current,
      className: "dcp-summary__status ".concat(status.toLowerCase())
    }, current > 1 && /*#__PURE__*/React__default.createElement("span", null, "\xA0\u2022\xA0"), DCPStatus[status], "\xA0", DCPStatusValues[status]));
    current += 1;
  }

  if (dcpIngestStatus) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      className: "ingest__status",
      key: current
    }, ingestStatusSummary(dcpIngestStatus)));
    current += 1;
  }

  return statusSummary;
}
function renderIngestStatusSummary(dcpIngestStatus) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ingest__status dcp_ingest__status"
  }, ingestStatusSummary(dcpIngestStatus));
}

var Status = function Status(props) {
  return /*#__PURE__*/React__default.createElement("div", null, props.status ? /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("span", {
    className: "qw-online-status qw-status"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "online-status qw-online"
  }, "Online")) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("span", {
    className: "qw-offline-status qw-status"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "online-status qw-offline"
  }, "Offline")));
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$K(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$K(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$K() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option$1 = _Select.Option;

var SearchFilter = /*#__PURE__*/function (_Component) {
  _inherits$1(SearchFilter, _Component);

  var _super = _createSuper$K(SearchFilter);

  function SearchFilter(props) {
    var _this;

    _classCallCheck$1(this, SearchFilter);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "getUniqueSelectedList", function () {
      var _this$state = _this.state,
          _this$state$selectedL = _this$state.selectedList,
          selectedList = _this$state$selectedL === void 0 ? [] : _this$state$selectedL,
          _this$state$selectedL2 = _this$state.selectedListFromSearch,
          selectedListFromSearch = _this$state$selectedL2 === void 0 ? [] : _this$state$selectedL2;

      var uniqueSelection = _$1.uniqBy(selectedListFromSearch.concat(selectedList), 'key');

      return _$1.isEmpty(uniqueSelection) ? null : uniqueSelection;
    });

    _this.state = {
      searchValue: false,
      selectedListFromSearch: [],
      selectedList: [],
      showContent: true,
      searchList: [],
      isFreshSearch: true
    };
    _this.timer = null;
    _this.onSearch = _$1.debounce(_this.onSearch.bind(_assertThisInitialized(_this)), 400);
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    _this.clearSearch = _this.clearSearch.bind(_assertThisInitialized(_this));
    _this.handleListSelect = _this.handleListSelect.bind(_assertThisInitialized(_this));
    _this.handleListDeselect = _this.handleListDeselect.bind(_assertThisInitialized(_this));
    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(SearchFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clearAll !== this.props.clearAll) {
        this.handleClear();
      }

      if (prevProps.selectedList !== this.props.selectedList) {
        if (this.props.selectedList !== this.state.selectedList) {
          this.setState({
            selectedList: this.props.selectedList,
            selectedListFromSearch: this.props.selectedList
          });
        }
      }

      if (prevProps.searchList !== this.props.searchList) {
        this.setState({
          searchList: this.props.searchList
        });
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(e) {
      var _this2 = this;

      e && e.stopPropagation();
      this.setState({
        selectedListFromSearch: [],
        selectedList: []
      }, function () {
        return _this2.props.onSelectDeselect && _this2.props.onSelectDeselect(true, 0, {
          type: _this2.props.type,
          clear: true
        });
      });
    }
  }, {
    key: "handleListSelect",
    value: function handleListSelect(value) {
      var _this3 = this;

      var _this$state2 = this.state,
          selectedListFromSearch = _this$state2.selectedListFromSearch,
          selectedList = _this$state2.selectedList;

      var selectedValue = _$1.cloneDeep(value);

      if (Array.isArray(value.label)) {
        selectedValue.label = value.label[0].props.children;
        selectedValue.subLabel = value.label[1].props.children;
      }

      this.setState({
        selectedListFromSearch: [].concat(_toConsumableArray$1(selectedListFromSearch), [Object.assign({}, _objectSpread$7(_objectSpread$7({}, selectedValue), {}, {
          type: this.props.type
        }))]),
        selectedList: [].concat(_toConsumableArray$1(selectedList), [_objectSpread$7(_objectSpread$7({}, selectedValue), {}, {
          type: this.props.type
        })])
      }, function () {
        return _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, _this3.getUniqueSelectedList());
      });
    }
  }, {
    key: "handleListDeselect",
    value: function handleListDeselect(value) {
      var _this4 = this;

      var _this$state3 = this.state,
          selectedListFromSearch = _this$state3.selectedListFromSearch,
          selectedList = _this$state3.selectedList;
      this.setState({
        selectedListFromSearch: selectedListFromSearch.filter(function (s) {
          return s.key !== value.key;
        }),
        selectedList: selectedList.filter(function (s) {
          return s.key !== value.key;
        })
      }, function () {
        return _this4.props.onSelectDeselect && _this4.props.onSelectDeselect(true, 0, _this4.getUniqueSelectedList());
      });
    }
  }, {
    key: "handleCheckboxClick",
    value: function handleCheckboxClick(value, e) {
      var _this5 = this;

      if (e.target.checked) {
        this.setState({
          selectedListFromSearch: [].concat(_toConsumableArray$1(this.state.selectedListFromSearch), [value]),
          selectedList: [].concat(_toConsumableArray$1(this.state.selectedList), [value])
        }, function () {
          return _this5.props.onSelectDeselect && _this5.props.onSelectDeselect(true, 0, _this5.getUniqueSelectedList());
        });
      } else {
        this.setState({
          selectedListFromSearch: this.state.selectedListFromSearch.filter(function (s) {
            return s.key !== value.key;
          }),
          selectedList: this.state.selectedList.filter(function (s) {
            return s.key !== value.key;
          })
        }, function () {
          if (_$1.isEmpty(_this5.state.selectedList)) {
            _this5.props.onSelectDeselect && _this5.props.onSelectDeselect(true, 0, {
              type: _this5.props.type,
              clear: true
            });
          } else {
            _this5.props.onSelectDeselect && _this5.props.onSelectDeselect(true, 0, _this5.getUniqueSelectedList());
          }
        });
      }
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      this.setState({
        showContent: !this.state.showContent
      });
    }
  }, {
    key: "onSearch",
    value: function onSearch(value) {
      if (value) {
        this.props.onSearch(value);
        this.setState({
          searchValue: true,
          isFreshSearch: false
        });
      } else {
        this.setState({
          searchValue: false,
          isFreshSearch: false
        });
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      this.setState({
        searchValue: false
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        searchValue: false,
        searchList: [],
        isFreshSearch: true
      });
    }
  }, {
    key: "getSelectedListCurrentType",
    value: function getSelectedListCurrentType(selectedList) {
      var _this6 = this;

      return selectedList.filter(function (item) {
        return item.type === _this6.props.type;
      });
    }
  }, {
    key: "renderSearchList",
    value: function renderSearchList() {
      var _this7 = this;

      var _this$state4 = this.state,
          _this$state4$selected = _this$state4.selectedList,
          selectedList = _this$state4$selected === void 0 ? [] : _this$state4$selected,
          _this$state4$selected2 = _this$state4.selectedListFromSearch,
          selectedListFromSearch = _this$state4$selected2 === void 0 ? [] : _this$state4$selected2;
      var _this$props = this.props,
          _this$props$recentLis = _this$props.recentList,
          recentList = _this$props$recentLis === void 0 ? [] : _this$props$recentLis,
          isFetching = _this$props.isFetching;

      var listData = _$1.uniqBy(this.getSelectedListCurrentType(selectedListFromSearch).concat(recentList.concat(this.getSelectedListCurrentType(selectedList))), 'key');

      if (isFetching) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "loader"
        }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
          spin: true
        }));
      }

      return listData.map(function (data, idx) {
        var isChecked = !!_this7.getSelectedListCurrentType(selectedList).find(function (s) {
          return s.key === data.key;
        });
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: classNames$1('checkbox', {
            checked: isChecked
          })
        }, /*#__PURE__*/React__default.createElement(_Checkbox, {
          checked: isChecked,
          onChange: _this7.handleCheckboxClick.bind(_this7, data)
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, data.label), data.subLabel && /*#__PURE__*/React__default.createElement("div", {
          className: "secondary-label"
        }, data.subLabel))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props2 = this.props,
          title = _this$props2.title,
          placeholder = _this$props2.placeholder,
          isSearching = _this$props2.isSearching,
          setShowClearAll = _this$props2.setShowClearAll,
          showClearAll = _this$props2.showClearAll,
          dropDownPlaceholder = _this$props2.dropDownPlaceholder;
      var _this$state5 = this.state,
          searchValue = _this$state5.searchValue,
          _this$state5$selected = _this$state5.selectedList,
          selectedList = _this$state5$selected === void 0 ? [] : _this$state5$selected,
          _this$state5$selected2 = _this$state5.selectedListFromSearch,
          selectedListFromSearch = _this$state5$selected2 === void 0 ? [] : _this$state5$selected2,
          _this$state5$searchLi = _this$state5.searchList,
          searchList = _this$state5$searchLi === void 0 ? [] : _this$state5$searchLi,
          showContent = _this$state5.showContent,
          isFreshSearch = _this$state5.isFreshSearch;

      if (selectedList.length !== 0 || selectedListFromSearch.length !== 0) {
        if (!showClearAll) {
          setShowClearAll(true);
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter",
        ref: "searchFilter"
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "search-filter-header",
        onClick: this.handleCollapse
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 16,
        className: "heading"
      }, title, !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && "(".concat(this.getSelectedListCurrentType(selectedList).length, ")"), !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && /*#__PURE__*/React__default.createElement("span", {
        className: "clear",
        onClick: this.handleClear
      }, i18n.t('clear'))), /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "arrow"
      }, showContent ? /*#__PURE__*/React__default.createElement(UpOutlined$1, null) : /*#__PURE__*/React__default.createElement(DownOutlined$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('search-filter-content', {
          visible: showContent
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter-field"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-icon"
      }, searchValue ? /*#__PURE__*/React__default.createElement(CloseOutlined$1, {
        onClick: this.clearSearch
      }) : /*#__PURE__*/React__default.createElement(SearchOutlined$1, null)), /*#__PURE__*/React__default.createElement(_Select, {
        ref: "searchFilter",
        mode: "multiple",
        value: this.getSelectedListCurrentType(selectedList),
        placeholder: placeholder,
        filterOption: false,
        labelInValue: true,
        onSearch: this.onSearch,
        onSelect: this.handleListSelect,
        onDeselect: this.handleListDeselect,
        onBlur: this.onBlur,
        style: {
          width: '100%'
        },
        getPopupContainer: function getPopupContainer() {
          return _this8.refs.searchFilter;
        },
        notFoundContent: isSearching ? /*#__PURE__*/React__default.createElement("div", {
          className: "spinner"
        }, /*#__PURE__*/React__default.createElement(_Spin, null)) : _$1.isEmpty(searchList) && isFreshSearch ? dropDownPlaceholder : i18n.t('noRecordsfound')
      }, searchList.map(function (data) {
        return /*#__PURE__*/React__default.createElement(Option$1, {
          key: data.key
        }, /*#__PURE__*/React__default.createElement("div", null, data.label), data.subLabel && /*#__PURE__*/React__default.createElement("div", {
          className: "secondary-label"
        }, data.subLabel));
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter-list"
      }, this.renderSearchList())));
    }
  }]);

  return SearchFilter;
}(Component);

function _createSuper$J(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$J(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$J() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CheckboxFilter = /*#__PURE__*/function (_Component) {
  _inherits$1(CheckboxFilter, _Component);

  var _super = _createSuper$J(CheckboxFilter);

  function CheckboxFilter(props) {
    var _this;

    _classCallCheck$1(this, CheckboxFilter);

    _this = _super.call(this, props);
    _this.state = {
      selectedList: [],
      showContent: true
    };
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(CheckboxFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clearAll !== this.props.clearAll) {
        this.handleClear();
      }

      if (prevProps.selectedList !== this.props.selectedList) {
        if (this.props.selectedList !== this.state.selectedList) {
          this.setState({
            selectedList: this.props.selectedList
          });
        }
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(e) {
      var _this2 = this;

      e && e.stopPropagation();
      this.setState({
        selectedList: []
      }, function () {
        return _this2.props.onSelectDeselect && _this2.props.onSelectDeselect(true, 0, {
          type: _this2.props.type,
          clear: true
        });
      });
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      this.setState({
        showContent: !this.state.showContent
      });
    }
  }, {
    key: "handleCheckboxClick",
    value: function handleCheckboxClick(value, e) {
      var _this3 = this;

      if (e.target.checked) {
        this.setState({
          selectedList: [].concat(_toConsumableArray$1(this.state.selectedList), [value])
        }, function () {
          return _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, _this3.state.selectedList);
        });
      } else {
        this.setState({
          selectedList: this.state.selectedList.filter(function (s) {
            return s.key !== value.key;
          })
        }, function () {
          if (_$1.isEmpty(_this3.state.selectedList)) {
            _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, {
              type: _this3.props.type,
              clear: true
            });
          } else {
            _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, _this3.state.selectedList);
          }
        });
      }
    }
  }, {
    key: "getSelectedListCurrentType",
    value: function getSelectedListCurrentType(selectedList) {
      var _this4 = this;

      return selectedList.filter(function (item) {
        return item.type === _this4.props.type;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          title = _this$props.title,
          _this$props$filterLis = _this$props.filterList,
          filterList = _this$props$filterLis === void 0 ? [] : _this$props$filterLis,
          showClearAll = _this$props.showClearAll,
          setShowClearAll = _this$props.setShowClearAll,
          isFetching = _this$props.isFetching;
      var _this$state = this.state,
          showContent = _this$state.showContent,
          selectedList = _this$state.selectedList;

      if (selectedList.length !== 0) {
        if (!showClearAll) {
          setShowClearAll(true);
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter",
        ref: "searchFilter"
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "search-filter-header",
        onClick: this.handleCollapse
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 16,
        className: "heading"
      }, title, !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && "(".concat(this.getSelectedListCurrentType(selectedList).length, ")"), !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && /*#__PURE__*/React__default.createElement("span", {
        className: "clear",
        onClick: this.handleClear
      }, i18n.t('clear'))), /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "arrow"
      }, showContent ? /*#__PURE__*/React__default.createElement(UpOutlined$1, null) : /*#__PURE__*/React__default.createElement(DownOutlined$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('search-filter-content', {
          visible: showContent
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter-list"
      }, isFetching ? /*#__PURE__*/React__default.createElement("div", {
        className: "loader"
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        spin: true
      })) : filterList.map(function (filter, idx) {
        var isChecked = !!selectedList.find(function (s) {
          return s.key === filter.key;
        });
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: classNames$1('checkbox', {
            checked: isChecked
          })
        }, /*#__PURE__*/React__default.createElement(_Checkbox, {
          checked: isChecked,
          onChange: _this5.handleCheckboxClick.bind(_this5, filter)
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, filter.label), filter.subLabel && /*#__PURE__*/React__default.createElement("div", {
          className: "secondary-label"
        }, filter.subLabel))));
      }))));
    }
  }]);

  return CheckboxFilter;
}(Component);

var formatPictureData = function formatPictureData(cpl) {
  var picture = [];

  if (cpl.resolution) {
    picture.push(cpl.resolution);
  }

  if (cpl.stereoType) {
    picture.push(cpl.stereoType);
  }

  if (cpl.aspectRatio) {
    picture.push(cpl.aspectRatio);
  }

  return picture;
};

var formatLanguage = function formatLanguage(cpl) {
  var language = {};

  if (cpl.language) {
    language[cpl.language] = ['Audio'];
  }

  if (cpl.mainCaption) {
    if (language[cpl.mainCaption]) {
      language[cpl.mainCaption].push('Main Caption');
    } else {
      language[cpl.mainCaption] = ['Main Caption'];
    }
  }

  if (cpl.subtitleLanguage) {
    if (language[cpl.subtitleLanguage]) {
      language[cpl.subtitleLanguage].push('Main Subtitle');
    } else {
      language[cpl.subtitleLanguage] = ['Main Subtitle'];
    }
  }

  if (cpl.closedCaptions) {
    cpl.closedCaptions.forEach(function (lang) {
      if (language[lang]) {
        language[lang].push('Closed Caption');
      } else {
        language[lang] = ['Closed Caption'];
      }
    });
  }

  if (cpl.closedSubtitles) {
    cpl.closedSubtitles.forEach(function (lang) {
      if (language[lang]) {
        language[lang].push('Closed Subtitle');
      } else {
        language[lang] = ['Closed Subtitle'];
      }
    });
  }

  return language;
};

var CPLRightPanelContent = function CPLRightPanelContent(_ref) {
  var _cpl$markers$find, _cpl$markers$find2, _cpl$markers;

  var cpl = _ref.cpl;
  var picture = formatPictureData(cpl);
  var language = formatLanguage(cpl);
  var duration = formatDuration(cpl.durationInSec);
  var ffec = cpl.markers ? (_cpl$markers$find = cpl.markers.find(function (marker) {
    return marker.label === 'FFEC';
  })) === null || _cpl$markers$find === void 0 ? void 0 : _cpl$markers$find.value : null;
  var ffmc = cpl.markers ? (_cpl$markers$find2 = cpl.markers.find(function (marker) {
    return marker.label === 'FFMC';
  })) === null || _cpl$markers$find2 === void 0 ? void 0 : _cpl$markers$find2.value : null;
  var LockIcon = cpl.isEncrypted ? Icons.LockedIcon : Icons.LockOpenIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__name"
  }, cpl.name), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__highlights"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "encrypt-status composition-tag"
  }, /*#__PURE__*/React__default.createElement(LockIcon, {
    height: "20",
    width: "20",
    viewBox: "0 0 24 24"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "composition_type composition-tag"
  }, cpl.type)), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_header"
  }, i18n.t('cplId')), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_value"
  }, cpl.id)), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_header"
  }, i18n.t('duration')), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_value"
  }, duration)), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_header"
  }, i18n.t('picture')), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_value"
  }, picture.join(' • '))), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_header"
  }, i18n.t('audio')), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_value"
  }, cpl.audioFormats.join('-'))), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_header"
  }, i18n.t('languages')), /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper__sub-wrapper"
  }, Object.entries(language).map(function (value) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-wrapper__header"
    }, value[0]), /*#__PURE__*/React__default.createElement("div", {
      className: "sub-wrapper__value"
    }, value[1].join(', ')));
  }))), (_cpl$markers = cpl.markers) !== null && _cpl$markers !== void 0 && _cpl$markers.length ? /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_header"
  }, i18n.t('cplMarkers')), ffec >= 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_value"
  }, i18n.t('firstFrameEndCredits'), ":", ' ', new Date(ffec * 1000).toISOString().slice(11, 19)) : null, ffmc >= 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "cpl-right-panel__wrapper_value"
  }, i18n.t('firstFrameMovingCredits'), ":", ' ', new Date(ffmc * 1000).toISOString().slice(11, 19)) : null) : null);
};

var InfoFilledIcon$1 = Icons.InfoFilledIcon;

var CompositionCard = function CompositionCard(_ref) {
  var useFetchCplQuery = _ref.useFetchCplQuery,
      cplId = _ref.cplId,
      _ref$withCplInfo = _ref.withCplInfo,
      withCplInfo = _ref$withCplInfo === void 0 ? true : _ref$withCplInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useFetchCplQuery = useFetchCplQuery(cplId),
      cpl = _useFetchCplQuery.data;

  if (!cpl) return /*#__PURE__*/React__default.createElement("div", null, "-");
  return /*#__PURE__*/React__default.createElement("div", {
    className: "composition-card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "composition-name-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "composition-name"
  }, cpl.name), withCplInfo && /*#__PURE__*/React__default.createElement("div", {
    className: "composition-info-icon",
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, /*#__PURE__*/React__default.createElement(InfoFilledIcon$1, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "tag_group"
  }, /*#__PURE__*/React__default.createElement(CompositionCardTags, {
    composition: cpl
  })), withCplInfo && /*#__PURE__*/React__default.createElement(RightPanel$1, {
    isOpen: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    header: i18n.t('compositionDetails')
  }, /*#__PURE__*/React__default.createElement(CPLRightPanelContent, {
    cpl: cpl
  })));
};

var CompositionCardList = function CompositionCardList(_ref) {
  var cplIds = _ref.cplIds,
      useFetchCplQuery = _ref.useFetchCplQuery;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "composition-list"
  }, cplIds.length > 0 ? cplIds.map(function (cplId, i) {
    return /*#__PURE__*/React__default.createElement(CompositionCard, {
      cplId: cplId,
      useFetchCplQuery: useFetchCplQuery,
      key: "".concat(i).concat(cplId)
    });
  }) : null);
};

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _toConsumableArray = /*@__PURE__*/getDefaultExportFromCjs(toConsumableArray);

var _excluded$4 = ["query", "onQueryChange", "selectedItems", "onSelectedItemsChange", "onMenuItemSelect", "customMenuName", "onRemove", "customUniqueId", "onSearchClear", "clearAllText", "showClearAllButton", "onClearAll"];

var MultiSelectTagInput = function MultiSelectTagInput(_ref) {
  var query = _ref.query,
      onQueryChange = _ref.onQueryChange,
      selectedItems = _ref.selectedItems,
      onSelectedItemsChange = _ref.onSelectedItemsChange,
      onMenuItemSelect = _ref.onMenuItemSelect,
      customMenuName = _ref.customMenuName,
      onRemove = _ref.onRemove,
      customUniqueId = _ref.customUniqueId,
      onSearchClear = _ref.onSearchClear,
      clearAllText = _ref.clearAllText,
      showClearAllButton = _ref.showClearAllButton,
      onClearAll = _ref.onClearAll,
      props = _objectWithoutProperties$2(_ref, _excluded$4);

  var _useState = useState(query !== null && query !== void 0 ? query : ''),
      _useState2 = _slicedToArray$1(_useState, 2),
      inputQuery = _useState2[0],
      setInputQuery = _useState2[1];

  var updateSelectedItemList = function updateSelectedItemList(item) {
    var uniqueId = function uniqueId(x) {
      return customUniqueId ? customUniqueId(x) : x.id;
    };

    var itemIndex = selectedItems.findIndex(function (i) {
      return uniqueId(i) === uniqueId(item);
    });

    if (itemIndex < 0) {
      onSelectedItemsChange === null || onSelectedItemsChange === void 0 ? void 0 : onSelectedItemsChange([].concat(_toConsumableArray(selectedItems), [item]));
    } else {
      var newList = _toConsumableArray(selectedItems);

      newList.splice(itemIndex, 1);
      onSelectedItemsChange === null || onSelectedItemsChange === void 0 ? void 0 : onSelectedItemsChange(newList);
    }
  };

  var handleQueryChange = function handleQueryChange(value, e) {
    onQueryChange === null || onQueryChange === void 0 ? void 0 : onQueryChange(value, e);
    setInputQuery(value);
  };

  var handleQueryClear = function handleQueryClear(e) {
    onSearchClear === null || onSearchClear === void 0 ? void 0 : onSearchClear(e);
    setInputQuery('');
  };

  var handleAddItem = function handleAddItem(item) {
    onMenuItemSelect === null || onMenuItemSelect === void 0 ? void 0 : onMenuItemSelect(item);
    updateSelectedItemList(item);
  };

  var handleRemoveItem = function handleRemoveItem(item) {
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(item);
    updateSelectedItemList(item);
  };

  var handleClearAllSelectedTags = function handleClearAllSelectedTags(e) {
    onClearAll === null || onClearAll === void 0 ? void 0 : onClearAll(e);
    onSelectedItemsChange === null || onSelectedItemsChange === void 0 ? void 0 : onSelectedItemsChange([]);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "MultiSelectTagInput"
  }, /*#__PURE__*/React__default.createElement(MultiSelectInput$1, _extends$2({
    query: inputQuery,
    onQueryChange: handleQueryChange,
    customMenuName: customMenuName,
    selectedItems: selectedItems,
    onMenuItemSelect: handleAddItem,
    onRemove: handleRemoveItem,
    onSearchClear: handleQueryClear
  }, props)), selectedItems && selectedItems.length !== 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "selected-items"
  }, selectedItems.map(function (item) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "selected-items__chip",
      key: customUniqueId ? customUniqueId(item) : item.id
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "selected-items__chip__text"
    }, customMenuName ? customMenuName(item) : item.name), /*#__PURE__*/React__default.createElement(BaseButton$1, {
      className: "selected-items__chip__icon",
      iconName: "CancelRoundedIcon",
      buttonType: "secondary",
      onClick: function onClick() {
        return handleRemoveItem(item);
      }
    }));
  }), showClearAllButton && selectedItems.length !== 0 && /*#__PURE__*/React__default.createElement(BaseButton$1, {
    className: "selected-items__clear-all",
    buttonType: "secondary",
    buttonText: clearAllText ? clearAllText : i18n.t('clearAll'),
    onClick: handleClearAllSelectedTags
  })));
};

var _excluded$3 = ["visible", "title", "bodyText", "overlayClassName", "onVisibleChange", "cancelButtonProps", "confirmButtonProps", "children"];

var PopConfirm = function PopConfirm(_ref) {
  var _cancelButtonProps$bu, _confirmButtonProps$b;

  var visible = _ref.visible,
      title = _ref.title,
      bodyText = _ref.bodyText,
      overlayClassName = _ref.overlayClassName,
      onVisibleChange = _ref.onVisibleChange,
      cancelButtonProps = _ref.cancelButtonProps,
      confirmButtonProps = _ref.confirmButtonProps,
      children = _ref.children,
      props = _objectWithoutProperties$2(_ref, _excluded$3);

  var _useState = useState(visible !== null && visible !== void 0 ? visible : false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleIsOpen = function handleIsOpen(value, e) {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(value, e);
    setIsOpen(value);
  };

  return /*#__PURE__*/React__default.createElement(_Popover, _extends$2({
    visible: isOpen,
    onVisibleChange: handleIsOpen,
    overlayClassName: classNames$1('popconfirm', overlayClassName),
    trigger: "click",
    title: /*#__PURE__*/React__default.createElement("div", {
      className: "flex justify-between items-center"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "popconfirm__title"
    }, title), /*#__PURE__*/React__default.createElement(BaseButton$1, {
      buttonType: "secondary",
      iconName: "CancelIcon",
      onClick: function onClick() {
        return handleIsOpen(false);
      }
    })),
    content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", {
      className: "popconfirm__body"
    }, bodyText), /*#__PURE__*/React__default.createElement("div", {
      className: "flex action_buttons justify-end"
    }, /*#__PURE__*/React__default.createElement(BaseButton$1, _extends$2({
      buttonText: (_cancelButtonProps$bu = cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.buttonText) !== null && _cancelButtonProps$bu !== void 0 ? _cancelButtonProps$bu : "Cancel",
      onClick: function onClick() {
        return handleIsOpen(!isOpen);
      }
    }, cancelButtonProps)), /*#__PURE__*/React__default.createElement(BaseButton$1, _extends$2({
      className: "ml2",
      buttonText: (_confirmButtonProps$b = confirmButtonProps === null || confirmButtonProps === void 0 ? void 0 : confirmButtonProps.buttonText) !== null && _confirmButtonProps$b !== void 0 ? _confirmButtonProps$b : "Confirm"
    }, confirmButtonProps))))
  }, props), children);
};

var SelectableCompositionCard = function SelectableCompositionCard(_ref) {
  var _composition$assets2;

  var composition = _ref.composition,
      onSelectionChange = _ref.onSelectionChange,
      selected = _ref.selected,
      _ref$withCheckbox = _ref.withCheckbox,
      withCheckbox = _ref$withCheckbox === void 0 ? true : _ref$withCheckbox,
      showStatus = _ref.showStatus;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      openRightPanel = _useState2[0],
      toggleRightPanel = _useState2[1];

  var duration = formatDuration(composition.durationInSec);

  function checkHandler(e) {
    var checked = e.target.checked;
    onSelectionChange(checked, composition);
  }

  function getTotalSize() {
    var _composition$assets;

    var bytes = (_composition$assets = composition.assets) === null || _composition$assets === void 0 ? void 0 : _composition$assets.reduce(function (s, asset) {
      return s + Number(asset.size);
    }, 0);
    return bytesToSize(bytes);
  }

  var EncIcon = Icons["".concat(composition.isEncrypted ? 'LockedIcon' : 'LockOpenIcon')];
  var hasAssets = ((_composition$assets2 = composition.assets) === null || _composition$assets2 === void 0 ? void 0 : _composition$assets2.length) > 0 && composition.assets.reduce(function (sum, asset) {
    return asset.type !== 'assetmap' && asset.type !== 'pkl' ? sum + Number(asset.size) : sum;
  }, 0);
  var dcpStatus = 'missingAssets';

  if (composition.storagestatus === 'archived') {
    dcpStatus = 'archived';
  } else if (hasAssets) {
    var isUploading = composition.assets.some(function (asset) {
      return asset.type !== 'assetmap' && asset.type !== 'pkl' && (asset.status === 'uploading' || asset.status === 'uploaded');
    });
    dcpStatus = isUploading ? 'uploading' : 'onTheCloud';
  }

  var STATUS = {
    onTheCloud: {
      title: i18n.t('onTheCloud'),
      icon: /*#__PURE__*/React__default.createElement(Icons.CloudAvailableIcon, null),
      color: '#1D81E3'
    },
    uploading: {
      title: i18n.t('uploading'),
      icon: /*#__PURE__*/React__default.createElement(Icons.UploadIcon, null),
      color: '#F0A203'
    },
    archived: {
      title: i18n.t('archived'),
      icon: /*#__PURE__*/React__default.createElement(Icons.ArchiveIcon, null),
      color: '#F0A203'
    },
    missingAssets: {
      title: i18n.t('missingAssets'),
      icon: /*#__PURE__*/React__default.createElement(Icons.AlertFilledIcon, null),
      color: '#F0A203'
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "selectable-composition-card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "selectable-composition-card__container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "selectable-composition-card__name-info"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "left-column"
  }, withCheckbox ? /*#__PURE__*/React__default.createElement(DefaultCheckbox, {
    label: composition.name,
    checked: selected,
    onChange: checkHandler
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "composition-name"
  }, composition.name)), /*#__PURE__*/React__default.createElement("div", {
    className: "right-column"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "duration"
  }, duration), /*#__PURE__*/React__default.createElement(BaseButton$1, {
    iconName: 'InfoFilledIcon',
    onClick: function onClick() {
      return toggleRightPanel(true);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "selectable-composition-card__tags"
  }, /*#__PURE__*/React__default.createElement(Tag, {
    color: "constructive",
    className: "custom-tag",
    prefixIcon: /*#__PURE__*/React__default.createElement(EncIcon, {
      height: '16',
      width: '16',
      viewBox: "0 0 24 24"
    }),
    readOnly: true
  }), /*#__PURE__*/React__default.createElement(CompositionCardTags, {
    composition: composition
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "selectable-composition-card__details"
  }, showStatus && /*#__PURE__*/React__default.createElement("div", {
    className: "status",
    style: {
      '--status-color': STATUS[dcpStatus].color
    }
  }, STATUS[dcpStatus].icon, STATUS[dcpStatus].title), /*#__PURE__*/React__default.createElement("div", {
    className: "size"
  }, getTotalSize()))), /*#__PURE__*/React__default.createElement(RightPanel$1, {
    isOpen: openRightPanel,
    onClose: function onClose() {
      return toggleRightPanel(false);
    },
    header: i18n.t('compositionDetails')
  }, /*#__PURE__*/React__default.createElement(CPLRightPanelContent, {
    cpl: composition
  })));
};

var DateTimeView = function DateTimeView(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "datetime-view"
  }, /*#__PURE__*/React__default.createElement("time", {
    dateTime: value
  }, momentTZ(value).format('DD MMM YYYY')), /*#__PURE__*/React__default.createElement("time", {
    dateTime: value,
    className: "datetime-view__subtext"
  }, momentTZ(value).format('hh:mm A'), " (".concat(momentTZ.tz(momentTZ.tz.guess()).zoneAbbr(), ")")));
};

/**
 * Renders a component that displays the status count.
 *
 * @param {Object} props - The component props.
 * @param {StatusCountObject[]} props.statusCountList - An array of status count objects. The order of the array determines the order of the rendered statuses.
 * @returns {JSX.Element}
 */

var StatusHeader = function StatusHeader(_ref) {
  var statusCountList = _ref.statusCountList;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, statusCountList.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "status-count-header"
  }, statusCountList.map(function (object, index) {
    return object.count > 0 ? /*#__PURE__*/React__default.createElement(DeliveryStatus, {
      type: object.type,
      count: object.count,
      custom: false,
      key: index
    }) : null;
  })));
};

var BreadCrumbs = function BreadCrumbs(props) {
  var breadCrumbItems = props.breadCrumbItems;
  return /*#__PURE__*/React__default.createElement(_Breadcrumb, {
    className: "breadcrumb",
    separator: ">"
  }, breadCrumbItems && breadCrumbItems.map(function (breadCrumbItem) {
    return breadCrumbItem;
  }));
};

var PageDefaultHeader = function PageDefaultHeader(_ref) {
  var content = _ref.content,
      type = _ref.type,
      buttons = _ref.buttons,
      tabsDetail = _ref.tabsDetail,
      selectedTab = _ref.selectedTab,
      onTabChange = _ref.onTabChange,
      breadCrumbItems = _ref.breadCrumbItems,
      noCapitalize = _ref.noCapitalize;

  switch (type) {
    case 'buttons':
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "page-header__buttons"
        }, breadCrumbItems ? /*#__PURE__*/React__default.createElement("div", {
          className: "breadcrumbs_outer",
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/React__default.createElement(BreadCrumbs, {
          breadCrumbItems: breadCrumbItems
        })) : null, /*#__PURE__*/React__default.createElement(PageHeading, {
          content: content,
          noCapitalize: noCapitalize
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "buttons-wrapper"
        }, buttons && buttons.map(function (button) {
          if (button.type === 'primary') {
            return /*#__PURE__*/React__default.createElement(PrimaryButton, _extends$1({
              key: button.btnName
            }, button));
          }

          if (button.type === 'secondary') {
            return /*#__PURE__*/React__default.createElement(SecondaryButton, _extends$1({
              key: button.btnName
            }, button));
          }
        })));
      }

    case 'tabs':
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "page-header__tabs"
        }, /*#__PURE__*/React__default.createElement(PageHeading, {
          content: content
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "tabs-list-layout"
        }, /*#__PURE__*/React__default.createElement(DefaultTabs, {
          tabsDetail: tabsDetail,
          selectedTab: selectedTab,
          onTabChange: onTabChange
        })));
      }

    default:
      return /*#__PURE__*/React__default.createElement("div", {
        className: "page-header__default"
      }, /*#__PURE__*/React__default.createElement(PageHeading, {
        content: content
      }));
  }
};

var HeaderWithTabs = function HeaderWithTabs(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "page-header__tabs"
  }, /*#__PURE__*/React__default.createElement(PageHeading, {
    content: props.content
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "tabs-list-layout"
  }, /*#__PURE__*/React__default.createElement(DefaultTabs, {
    tabsDetail: props.tabsDetail,
    selectedTab: props.selectedTab,
    onTabChange: props.onTabChange
  })));
};

var TheatreDefaultCard = function TheatreDefaultCard(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "theaterContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: props.isUnServiced ? 'theatre-card__default unserviced' : props.isDuplicate ? 'theatre-card__default duplicate' : 'theatre-card__default'
  }, /*#__PURE__*/React__default.createElement(TheatreDefaultInfo, {
    name: props.name,
    address: props.address,
    id: props.id,
    screen_id: props.screen_id,
    theatreSelect: props.theatreSelect,
    unMatched: props.unMatched,
    duplicate: props.duplicate,
    matchedRows: props.matchedRows,
    duplicateRows: props.duplicateRows,
    hasWireTap: props.hasWireTap,
    genericWireTapIcon: props.genericWireTapIcon
  }), props.isUnServiced ? /*#__PURE__*/React__default.createElement(TheatreDefaultMeta, {
    containsDeleteButton: props.isUnServiced,
    deleteAction: props.deleteAction
  }) : /*#__PURE__*/React__default.createElement(TheatreDefaultMeta, {
    price: props.price
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "deleteButtonConatiner"
  }, props.isDuplicate ? /*#__PURE__*/React__default.createElement(TheatreDefaultMeta, {
    containsDeleteButton: props.isDuplicate,
    deleteAction: props.deleteAction
  }) : ''));
};

function _createSuper$I(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$I(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$I() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListCard = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ListCard, _React$Component);

  var _super = _createSuper$I(ListCard);

  function ListCard(props) {
    var _this;

    _classCallCheck$1(this, ListCard);

    _this = _super.call(this);
    _this.state = {
      expand: false,
      checked: false,
      selected: false,
      notSelected: true,
      partialSelected: false
    };
    return _this;
  }

  _createClass$1(ListCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.hasScreenNotInList(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps, newState) {
      this.hasScreenNotInList(newProps);
    }
  }, {
    key: "hasScreenNotInList",
    value: function hasScreenNotInList(props) {
      var theatreList = props.theatreList;
          props.selected;
          var theatresInBooking = props.theatresInBooking;
      var fullySelected = 0;
      var totalTheatreCount = theatreList && theatreList.theatres && theatreList.theatres.length;

      if (theatreList && theatreList.theatres) {
        theatreList.theatres.forEach(function (item) {
          theatresInBooking && theatresInBooking.forEach(function (child) {
            if (item.id == child.id) {
              fullySelected += 1;
            }
          });
        });
      }

      if (fullySelected === totalTheatreCount) {
        this.setState({
          selected: true,
          notSelected: false,
          partialSelected: false
        });
      } else if (!fullySelected) {
        this.setState({
          selected: false,
          notSelected: true,
          partialSelected: false
        });
      } else {
        this.setState({
          selected: false,
          notSelected: false,
          partialSelected: true
        });
      }
    }
  }, {
    key: "expandCard",
    value: function expandCard(e) {
      e.stopPropagation();
      this.setState({
        expand: !this.state.expand
      });

      if (this.props.onToggle) {
        this.props.onToggle();
      }
    }
  }, {
    key: "onCheck",
    value: function onCheck(e) {
      e.stopPropagation();

      if (this.props.handleAddListToBooking) {
        this.setState({
          checked: !this.state.checked
        });
        this.props.handleAddListToBooking();
      }
    }
  }, {
    key: "renderIconsForTheatreInList",
    value: function renderIconsForTheatreInList() {
      var _this$state = this.state,
          selected = _this$state.selected,
          notSelected = _this$state.notSelected;
          _this$state.partialSelected;

      if (selected) {
        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedFull",
          size: 20
        });
      }

      if (notSelected) {
        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedEmpty",
          size: 20
        });
      }

      return /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "SelectedPartial",
        size: 20
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          name = _this$props.name,
          theatreCount = _this$props.theatreCount,
          renderEditView = _this$props.renderEditView,
          expandInfo = _this$props.expandInfo;
      var _this$state2 = this.state;
          _this$state2.expand;
          _this$state2.checked;
          _this$state2.partialSelected;
          _this$state2.fullySelected;
          _this$state2.notSelected;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-overview"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-description",
        onClick: function onClick(e) {
          return _this2.onCheck(e);
        }
      }, expandInfo ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '24px'
        },
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronDown",
        size: 20
      })) : /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '24px'
        },
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronRight",
        size: 20
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-details-view"
      }, /*#__PURE__*/React__default.createElement(Title, {
        text: name
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "list-card-mobile-description"
      }, /*#__PURE__*/React__default.createElement(Description, {
        text: theatreCount
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-select-view"
      }, theatreCount && /*#__PURE__*/React__default.createElement("div", {
        className: "list-card-count-theatre-count"
      }, /*#__PURE__*/React__default.createElement(Description, {
        text: theatreCount
      })), renderEditView && /*#__PURE__*/React__default.createElement("div", null, renderEditView), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-click-icon"
      }, this.renderIconsForTheatreInList()))), children && /*#__PURE__*/React__default.createElement("div", null, this.props.children));
    }
  }]);

  return ListCard;
}(React__default.Component);
ListCard.defaultProps = {
  theatreCount: '5 theatres',
  name: 'List name'
};

function _createSuper$H(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$H(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$H() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreInfoModal = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatreInfoModal, _React$Component);

  var _super = _createSuper$H(TheatreInfoModal);

  function TheatreInfoModal(props) {
    var _this;

    _classCallCheck$1(this, TheatreInfoModal);

    _this = _super.call(this, props);
    _this.state = {
      expand: false
    };
    _this.handleExpand = _this.handleExpand.bind(_assertThisInitialized(_this));
    _this.closeExpand = _this.closeExpand.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(TheatreInfoModal, [{
    key: "handleExpand",
    value: function handleExpand() {
      this.setState({
        expand: true
      });
    }
  }, {
    key: "closeExpand",
    value: function closeExpand() {
      this.setState({
        expand: false
      });
    }
  }, {
    key: "renderAllAlternateNames",
    value: function renderAllAlternateNames() {
      var alternate_names = this.props.theatre.alternate_names;
      return alternate_names && alternate_names.map(function (name, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "alternate_names",
          key: index
        }, name);
      });
    }
  }, {
    key: "renderPartialAlternateNames",
    value: function renderPartialAlternateNames() {
      var sliceValue = 3;
      var alternate_names = this.props.theatre.alternate_names;
      return /*#__PURE__*/React__default.createElement("div", null, alternate_names && alternate_names.slice(0, sliceValue).map(function (name, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "alternate_names",
          key: index
        }, name);
      }), alternate_names.length > 3 ? /*#__PURE__*/React__default.createElement("div", {
        className: "light-blue cursor-pointer view_more",
        onClick: this.handleExpand
      }, i18n.t('viewMore')) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theatre = _this$props.theatre,
          handleCancel = _this$props.handleCancel,
          open = _this$props.open,
          showWireTapIcon = _this$props.showWireTapIcon,
          genericWireTapIcon = _this$props.genericWireTapIcon;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        visible: open,
        wrapClassName: "vertical-center-modal",
        title: i18n.t('theatreDetails'),
        onCancel: handleCancel,
        afterClose: this.closeExpand,
        footer: null
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block halfwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('theatreName'), " "), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block_description"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "mg-btm-small"
      }, theatre.name, showWireTapIcon && theatre && theatre.wiretaps && theatre.wiretaps.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "wiretap-badge"
      }, /*#__PURE__*/React__default.createElement(ToolTip, {
        toolTip: genericWireTapIcon ? 'Electronic Delivery' : 'Powered By WireTAP'
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: genericWireTapIcon ? 'ApplianceDownload' : 'WireTap',
        color: "primary",
        size: 16
      }))))), /*#__PURE__*/React__default.createElement(Description, {
        text: theatre && theatre.address && (theatre.address.area ? "".concat(theatre.address.area, ", ") : "") + (theatre.address.city ? "".concat(theatre.address.city, ", ") : "") + (theatre.address.state ? "".concat(theatre.address.state, ", ") : "") + (theatre.address.country ? "".concat(theatre.address.country) : "")
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block halfwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('address')), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, theatre && theatre.address && (theatre.address.street ? "".concat(theatre.address.street, ",") : ""), /*#__PURE__*/React__default.createElement("br", null), ' ', theatre && theatre.address && (theatre.address.city ? "".concat(theatre.address.city, " ") : "") + (theatre.address.postalCode ? "".concat(theatre.address.postalCode) : "")))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, i18n.t('alternateNames'), ' '), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, theatre && theatre.alternate_names && (theatre.alternate_names.length > 0 ? this.state.expand ? this.renderAllAlternateNames() : this.renderPartialAlternateNames() : "-")))));
    }
  }]);

  return TheatreInfoModal;
}(React__default.Component);

function _createSuper$G(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$G(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreCard = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatreCard, _React$Component);

  var _super = _createSuper$G(TheatreCard);

  function TheatreCard(props) {
    var _this;

    _classCallCheck$1(this, TheatreCard);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleCancel", function () {
      _this.setState({
        modalvisible: false
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "overRideElementPosition", function (_ref, currentEvent, currentTarget, node, place, desiredPlace, effect, offset) {
      var left = _ref.left,
          top = _ref.top;

      if (_this.props.listItemStyle) {
        top = _this.props.listItemStyle.top;
      }

      return {
        left: left,
        top: top
      };
    });

    _this.state = {
      expand: false,
      modalvisible: false
    };
    _this.expandCard = _this.expandCard.bind(_assertThisInitialized(_this));
    _this.checkBox = _this.checkBox.bind(_assertThisInitialized(_this));
    _this.openTheatreInfo = _this.openTheatreInfo.bind(_assertThisInitialized(_this));
    _this.handleCancel = _this.handleCancel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(TheatreCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var expandedTheatre = this.props.expandedTheatre;
      var expanded = expandedTheatre ? expandedTheatre : false;
      this.setState({
        expand: expanded
      });
    }
  }, {
    key: "expandCard",
    value: function expandCard(e) {
      var _this$props = this.props,
          theatre = _this$props.theatre,
          UpdateExpandedTheatre = _this$props.UpdateExpandedTheatre;
      e.stopPropagation();
      this.setState({
        expand: !this.state.expand
      });
      UpdateExpandedTheatre && UpdateExpandedTheatre(theatre);
    }
  }, {
    key: "checkBox",
    value: function checkBox(e) {
      e.stopPropagation();
      var _this$props2 = this.props;
          _this$props2.selected;
          _this$props2.index;
          var theatre = _this$props2.theatre,
          handleAddTheatre = _this$props2.handleAddTheatre;
          _this$props2.type;
          _this$props2.edit;
      handleAddTheatre && handleAddTheatre(theatre);
    }
  }, {
    key: "openTheatreInfo",
    value: function openTheatreInfo(e) {
      e.stopPropagation();
      this.setState({
        modalvisible: true
      });
    }
  }, {
    key: "renderIconsForTheatreInList",
    value: function renderIconsForTheatreInList() {
      var _this$props3 = this.props,
          theatre = _this$props3.theatre,
          selected = _this$props3.selected;
          _this$props3.listView;
          _this$props3.type;
          var mode = _this$props3.mode,
          nettCustomer = _this$props3.nettCustomer;

      if (nettCustomer) {
        return null;
      }

      if (mode === 'exhibitor') {
        if (selected) {
          return /*#__PURE__*/React__default.createElement(AppIcon, {
            name: "SelectedFull",
            size: 20
          });
        }

        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedEmpty",
          size: 20
        });
      }

      if (selected) {
        if (this.props.getSelectedScreenCount(selected, theatre) < (theatre.screens && theatre.screens.length)) {
          _.findIndex(theatre.screens, function (screen) {
            return screen.isInList === true;
          });

          return /*#__PURE__*/React__default.createElement(AppIcon, {
            name: "SelectedPartial",
            size: 20
          });
        }

        _.findIndex(theatre.screens, function (screen) {
          return screen.isInList === true;
        });

        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedFull",
          size: 20
        });
      }

      return /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "SelectedEmpty",
        size: 20
      });
    }
  }, {
    key: "isSelectedTheatreScreenNotInList",
    value: function isSelectedTheatreScreenNotInList() {
      //not used function?
      var _this$props4 = this.props,
          theatre = _this$props4.theatre,
          selected = _this$props4.selected,
          theatresInBooking = _this$props4.theatresInBooking;
      var screenNotInList = false;

      var theatreIndex = _.findIndex(theatresInBooking, function (th) {
        return th.id === theatre.id;
      });

      if (selected) {
        _.forEach(theatresInBooking[theatreIndex].screens, function (sc) {
          if (sc.selected && sc.hasOwnProperty('isInList') && !sc.isInList) {
            screenNotInList = true;
          }
        });
      }

      return screenNotInList;
    }
  }, {
    key: "renderErrorIcon",
    value: function renderErrorIcon() {
      var theatre = this.props.theatre;
      var totaldeviceErrors = 0;

      if (theatre) {
        _.forEach(theatre.screens, function (screen) {
          screen.deviceErrors.length ? totaldeviceErrors++ : null;
        });
      }

      if (totaldeviceErrors > 0 || !this.isTheatreAddressValid(theatre && theatre.address)) {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ToolTip, {
          toolTip: i18n.t('someScreensHaveMissingDeviceInformation'),
          usePortal: true,
          portalContainer: document.querySelector('.container')
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-card-error-icon"
        }, /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "AssestError"
        }))));
      }
    }
  }, {
    key: "isTheatreAddressValid",
    value: function isTheatreAddressValid(theatreAddress) {
      if (theatreAddress) {
        return theatreAddress && !_.isEmpty(theatreAddress.country);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var expand = this.state.expand;
      var _this$props5 = this.props,
          theatre = _this$props5.theatre,
          getSelectedScreenCount = _this$props5.getSelectedScreenCount,
          selected = _this$props5.selected,
          handleAddScreen = _this$props5.handleAddScreen,
          index = _this$props5.index,
          theatresInBooking = _this$props5.theatresInBooking;
          _this$props5.removeTheatresFromBooking;
          var listView = _this$props5.listView,
          editListView = _this$props5.editListView,
          type = _this$props5.type,
          edit = _this$props5.edit,
          pricingModel = _this$props5.pricingModel,
          shouldShowPrice = _this$props5.shouldShowPrice,
          nettCustomer = _this$props5.nettCustomer,
          theatreMatchedId = _this$props5.theatreMatchedId,
          removeTheatre = _this$props5.removeTheatre,
          handleRemoveTheatre = _this$props5.handleRemoveTheatre,
          showTheatreInfo = _this$props5.showTheatreInfo,
          showWireTapIcon = _this$props5.showWireTapIcon,
          genericWireTapIcon = _this$props5.genericWireTapIcon,
          expandedTheatre = _this$props5.expandedTheatre;
      var shouldShowExpand = this.props.shouldShowExpand;
      var totalCount;
      var selectView = ['theatre-card-select-view'];
      var theatreInfoIcon = ['theatre-info'];

      if (theatre) {
        totalCount = theatre.screens && theatre.screens.length;
      }

      if (!removeTheatre && !showTheatreInfo) {
        selectView.push('mg-left');
      } else if (!removeTheatre) {
        theatreInfoIcon.push('mg-left');
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-item-card-overview ".concat(this.props.selected ? 'theatre-item-selected' : '')
      }, this.props.showTheatreInfo ? /*#__PURE__*/React__default.createElement(TheatreInfoModal, {
        open: this.state.modalvisible,
        handleCancel: this.handleCancel,
        theatre: theatre,
        showWireTapIcon: showWireTapIcon,
        genericWireTapIcon: genericWireTapIcon
      }) : null, theatre && theatre.name && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-item-card-description",
        onClick: this.checkBox
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-header"
      }, shouldShowExpand && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, expand || expandedTheatre ? /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronDown"
      })) : /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronRight"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-details-view"
      }, /*#__PURE__*/React__default.createElement(TheatreName, {
        name: theatre && theatre.name ? theatre.name : ''
      })), showWireTapIcon ? theatre && theatre.wiretaps && theatre.wiretaps.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "wire-tap-icon"
      }, /*#__PURE__*/React__default.createElement(ToolTip, {
        toolTip: genericWireTapIcon ? 'Electronic Delivery' : 'Powered by WireTAP',
        usePortal: true,
        portalContainer: document.querySelector('.container')
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-tip": true,
        "data-for": "wiretapicon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: genericWireTapIcon ? 'ApplianceDownload' : 'WireTap',
        color: 'primary',
        size: 16
      })))) : null, this.renderErrorIcon(), removeTheatre ? /*#__PURE__*/React__default.createElement(CloseOutlined$1, {
        onClick: function onClick(e) {
          return handleRemoveTheatre(e);
        }
      }) : null, this.props.showTheatreInfo ? /*#__PURE__*/React__default.createElement("div", {
        className: theatreInfoIcon.join(' '),
        onClick: function onClick(e) {
          return _this2.openTheatreInfo(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "InfoCircle",
        color: "grey060",
        size: "20px"
      })) : null, shouldShowPrice && !nettCustomer ? /*#__PURE__*/React__default.createElement("div", {
        className: selectView.join(' ')
      }, theatre.dcpPrice !== null ? /*#__PURE__*/React__default.createElement("span", {
        className: pricingModel ? 'theatre-dcp-price' : 'theatre-dcp-kdm-dcp'
      }, /*#__PURE__*/React__default.createElement("div", null, (theatre.dcpPrice / 100).toFixed(2))) : '', pricingModel ? /*#__PURE__*/React__default.createElement("span", {
        className: "theatre-kdm-price"
      }, /*#__PURE__*/React__default.createElement("div", null, calculateKdmPrice(theatre, pricingModel))) : '', /*#__PURE__*/React__default.createElement("span", null, (pricingModel || theatre.dcpPrice !== null || theatre.dcpPrice !== undefined) && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-select-view-cursor theatre-total-price"
      }, getKdmDcpPrice(theatre, pricingModel)))) : /*#__PURE__*/React__default.createElement("div", {
        className: selectView.join(' ')
      }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-select-view-cursor"
      }, this.renderIconsForTheatreInList())))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-footer",
        style: !shouldShowExpand ? {
          paddingLeft: '8px'
        } : {}
      }, theatre && theatre.address && /*#__PURE__*/React__default.createElement(TheatreAddress, {
        address: "".concat(theatre.address.city && "".concat(theatre.address.city, ","), "\n                                 ").concat(theatre.address.state && "".concat(theatre.address.state, ","), "\n                                 ").concat(theatre.address.country && theatre.address.country)
      }), isNumber$1(totalCount) && getSelectedScreenCount && shouldShowExpand && /*#__PURE__*/React__default.createElement("div", {
        className: "screens-count"
      }, /*#__PURE__*/React__default.createElement(Description, {
        text: "".concat(getSelectedScreenCount(selected, theatre), "/").concat(totalCount)
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "screen-txt"
      }, i18n.t('screens'))), theatreMatchedId && theatreMatchedId.id && /*#__PURE__*/React__default.createElement(TheatreId, {
        domain: theatreMatchedId.domain,
        id: theatreMatchedId.id
      }))), (expand || expandedTheatre) && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-item-card-list"
      }, shouldShowPrice && !nettCustomer && (pricingModel || theatre.dcpPrice !== null || theatre.dcpPrice !== undefined) ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-list-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "qw-label-text"
      }, "DCP Price: USD", ' ', theatre.dcpPrice ? (theatre.dcpPrice / 100).toFixed(2) : '0.00')), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-list-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "qw-label-text"
      }, "KDM Price: USD ", calculateKdmPrice(theatre, pricingModel)))) : '', shouldShowExpand && /*#__PURE__*/React__default.createElement(ScreensList, {
        list: theatre && theatre.screens,
        handleAddScreen: handleAddScreen,
        pricingModel: pricingModel,
        dcpPrice: theatre.dcpPrice,
        listType: type,
        theatre: theatre,
        theatreIndex: index,
        theatresInBooking: theatresInBooking,
        listView: listView,
        editListView: editListView,
        edit: edit,
        shouldShowPrice: shouldShowPrice
      })));
    }
  }]);

  return TheatreCard;
}(React__default.Component);
TheatreCard.defaultProps = {
  nettCustomer: false,
  shouldShowExpand: true
};

var interopRequireWildcard = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty);

var detectElementResize = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createDetectElementResize;

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = commonjsGlobal;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
});

var AutoSizer_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);

var _getPrototypeOf3 = interopRequireDefault(getPrototypeOf);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inherits2 = interopRequireDefault(inherits);

var _defineProperty2 = interopRequireDefault(defineProperty);

var React = interopRequireWildcard(React__default);

var _detectElementResize = interopRequireDefault(detectElementResize);

var _propTypes = interopRequireDefault(propTypes);

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AutoSizer = (_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parentNode", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_autoSizer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_window", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_detectElementResize", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });
    return _this;
  }

  (0, _createClass2["default"])(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = (0, _detectElementResize["default"])(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return React.createElement("div", {
        className: className,
        ref: this._setRef,
        style: _objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);
  return AutoSizer;
}(React.Component), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  /** Function responsible for rendering children.*/
  "children": _propTypes["default"].func.isRequired,

  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  "className": _propTypes["default"].string,

  /** Default height to use for initial render; useful for SSR */
  "defaultHeight": _propTypes["default"].number,

  /** Default width to use for initial render; useful for SSR */
  "defaultWidth": _propTypes["default"].number,

  /** Disable dynamic :height property */
  "disableHeight": _propTypes["default"].bool.isRequired,

  /** Disable dynamic :width property */
  "disableWidth": _propTypes["default"].bool.isRequired,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  "nonce": _propTypes["default"].string,

  /** Callback to be invoked on-resize */
  "onResize": _propTypes["default"].func.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object
}), _temp);
exports["default"] = AutoSizer;
(0, _defineProperty2["default"])(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});
});

var AutoSizer = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});
Object.defineProperty(exports, "AutoSizer", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});

var _AutoSizer = interopRequireDefault(AutoSizer_1);
});

var AutoSizer$1 = /*@__PURE__*/getDefaultExportFromCjs(AutoSizer);

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx_m () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var clsx_m$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': clsx_m
});

var calculateSizeAndPositionDataAndUpdateScrollOffset_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateSizeAndPositionDataAndUpdateScrollOffset;

/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
});

var types$2 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_VisibleCellRange = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_OverscanIndices = exports.bpfrpt_proptype_OverscanIndicesGetterParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_ScrollbarPresenceChange = exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_NoContentRenderer = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellSizeGetter = exports.bpfrpt_proptype_CellRangeRenderer = exports.bpfrpt_proptype_CellRangeRendererParams = exports.bpfrpt_proptype_StyleCache = exports.bpfrpt_proptype_CellCache = exports.bpfrpt_proptype_CellRenderer = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellPosition = void 0;

interopRequireWildcard(React__default);

var _ScalingCellSizeAndPositionManager = interopRequireDefault(ScalingCellSizeAndPositionManager_1);

var _propTypes = interopRequireDefault(propTypes);

var bpfrpt_proptype_CellPosition = process.env.NODE_ENV === 'production' ? null : {
  "columnIndex": _propTypes["default"].number.isRequired,
  "rowIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
var bpfrpt_proptype_CellRendererParams = process.env.NODE_ENV === 'production' ? null : {
  "columnIndex": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "rowIndex": _propTypes["default"].number.isRequired,
  "style": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
var bpfrpt_proptype_CellRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
var bpfrpt_proptype_CellCache = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].objectOf(_propTypes["default"].node.isRequired);
exports.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
var bpfrpt_proptype_StyleCache = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].objectOf(_propTypes["default"].object.isRequired);
exports.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
var bpfrpt_proptype_CellRangeRendererParams = process.env.NODE_ENV === 'production' ? null : {
  "cellCache": _propTypes["default"].objectOf(_propTypes["default"].node.isRequired).isRequired,
  "cellRenderer": _propTypes["default"].func.isRequired,
  "columnSizeAndPositionManager": function columnSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  },
  "columnStartIndex": _propTypes["default"].number.isRequired,
  "columnStopIndex": _propTypes["default"].number.isRequired,
  "deferredMeasurementCache": _propTypes["default"].object,
  "horizontalOffsetAdjustment": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "rowSizeAndPositionManager": function rowSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  },
  "rowStartIndex": _propTypes["default"].number.isRequired,
  "rowStopIndex": _propTypes["default"].number.isRequired,
  "scrollLeft": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired,
  "styleCache": _propTypes["default"].objectOf(_propTypes["default"].object.isRequired).isRequired,
  "verticalOffsetAdjustment": _propTypes["default"].number.isRequired,
  "visibleColumnIndices": _propTypes["default"].object.isRequired,
  "visibleRowIndices": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
var bpfrpt_proptype_CellRangeRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
var bpfrpt_proptype_CellSizeGetter = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
var bpfrpt_proptype_CellSize = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].number]);
exports.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
var bpfrpt_proptype_NoContentRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
var bpfrpt_proptype_Scroll = process.env.NODE_ENV === 'production' ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "clientWidth": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollLeft": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired,
  "scrollWidth": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
var bpfrpt_proptype_ScrollbarPresenceChange = process.env.NODE_ENV === 'production' ? null : {
  "horizontal": _propTypes["default"].bool.isRequired,
  "vertical": _propTypes["default"].bool.isRequired,
  "size": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
var bpfrpt_proptype_RenderedSection = process.env.NODE_ENV === 'production' ? null : {
  "columnOverscanStartIndex": _propTypes["default"].number.isRequired,
  "columnOverscanStopIndex": _propTypes["default"].number.isRequired,
  "columnStartIndex": _propTypes["default"].number.isRequired,
  "columnStopIndex": _propTypes["default"].number.isRequired,
  "rowOverscanStartIndex": _propTypes["default"].number.isRequired,
  "rowOverscanStopIndex": _propTypes["default"].number.isRequired,
  "rowStartIndex": _propTypes["default"].number.isRequired,
  "rowStopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
var bpfrpt_proptype_OverscanIndicesGetterParams = process.env.NODE_ENV === 'production' ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  "direction": _propTypes["default"].oneOf(["horizontal", "vertical"]).isRequired,
  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  "scrollDirection": _propTypes["default"].oneOf([-1, 1]).isRequired,
  // Number of rows or columns in the current axis
  "cellCount": _propTypes["default"].number.isRequired,
  // Maximum number of cells to over-render in either direction
  "overscanCellsCount": _propTypes["default"].number.isRequired,
  // Begin of range of visible cells
  "startIndex": _propTypes["default"].number.isRequired,
  // End of range of visible cells
  "stopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
var bpfrpt_proptype_OverscanIndices = process.env.NODE_ENV === 'production' ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
var bpfrpt_proptype_OverscanIndicesGetter = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
var bpfrpt_proptype_Alignment = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].oneOf(["auto", "end", "start", "center"]);
exports.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
var bpfrpt_proptype_VisibleCellRange = process.env.NODE_ENV === 'production' ? null : {
  "start": _propTypes["default"].number,
  "stop": _propTypes["default"].number
};
exports.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;
});

var CellSizeAndPositionManager_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _defineProperty2 = interopRequireDefault(defineProperty);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;
    (0, _classCallCheck2["default"])(this, CellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
    (0, _defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
    (0, _defineProperty2["default"])(this, "_lastBatchedIndex", -1);
    (0, _defineProperty2["default"])(this, "_cellCount", void 0);
    (0, _defineProperty2["default"])(this, "_cellSizeGetter", void 0);
    (0, _defineProperty2["default"])(this, "_estimatedCellSize", void 0);
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  (0, _createClass2["default"])(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);
  return CellSizeAndPositionManager;
}();

exports["default"] = CellSizeAndPositionManager;
});

var maxElementSize = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxElementSize = void 0;
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};

exports.getMaxElementSize = getMaxElementSize;
});

var ScalingCellSizeAndPositionManager_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _defineProperty2 = interopRequireDefault(defineProperty);

var _CellSizeAndPositionManager = interopRequireDefault(CellSizeAndPositionManager_1);





/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? (0, maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
        params = (0, _objectWithoutProperties2["default"])(_ref, ["maxScrollSize"]);
    (0, _classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
    (0, _defineProperty2["default"])(this, "_maxScrollSize", void 0);
    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager["default"](params);
    this._maxScrollSize = maxScrollSize;
  }

  (0, _createClass2["default"])(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
  return ScalingCellSizeAndPositionManager;
}();

exports["default"] = ScalingCellSizeAndPositionManager;
});

var createCallbackMemoizer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCallbackMemoizer;

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
});

var defaultOverscanIndicesGetter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;



var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}
});

var updateScrollIndexHelper_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateScrollIndexHelper;

interopRequireDefault(ScalingCellSizeAndPositionManager_1);



function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}
});

var defaultCellRangeRenderer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultCellRangeRenderer;



/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (process.env.NODE_ENV !== 'production') {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (process.env.NODE_ENV !== 'production') {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}
});

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var size$1;
function scrollbarSize(recalc) {
  if (!size$1 && size$1 !== 0 || recalc) {
    if (canUseDOM$1) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size$1 = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size$1;
}

var scrollbarSize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': scrollbarSize
});

var animationFrame = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caf = exports.raf = void 0;
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
exports.raf = raf;
var caf = cancel;
exports.caf = caf;
});

var requestAnimationTimeout_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_AnimationTimeoutId = exports.requestAnimationTimeout = exports.cancelAnimationTimeout = void 0;



var _propTypes = interopRequireDefault(propTypes);

var bpfrpt_proptype_AnimationTimeoutId = process.env.NODE_ENV === 'production' ? null : {
  "id": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;

var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return (0, animationFrame.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */


exports.cancelAnimationTimeout = cancelAnimationTimeout;

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = (0, animationFrame.raf)(timeout);
    }
  };

  var frame = {
    id: (0, animationFrame.raf)(timeout)
  };
  return frame;
};

exports.requestAnimationTimeout = requestAnimationTimeout;
});

var require$$10 = /*@__PURE__*/getAugmentedNamespace(clsx_m$1);

var require$$16 = /*@__PURE__*/getAugmentedNamespace(scrollbarSize$1);

var Grid_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);

var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inherits2 = interopRequireDefault(inherits);

var _defineProperty2 = interopRequireDefault(defineProperty);

var React = interopRequireWildcard(React__default);

var _clsx = interopRequireDefault(require$$10);

var _calculateSizeAndPositionDataAndUpdateScrollOffset = interopRequireDefault(calculateSizeAndPositionDataAndUpdateScrollOffset_1);

var _ScalingCellSizeAndPositionManager = interopRequireDefault(ScalingCellSizeAndPositionManager_1);

var _createCallbackMemoizer = interopRequireDefault(createCallbackMemoizer_1);

var _defaultOverscanIndicesGetter = interopRequireWildcard(defaultOverscanIndicesGetter_1);

var _updateScrollIndexHelper = interopRequireDefault(updateScrollIndexHelper_1);

var _defaultCellRangeRenderer = interopRequireDefault(defaultCellRangeRenderer_1);

var _scrollbarSize = interopRequireDefault(require$$16);







var _propTypes = interopRequireDefault(propTypes);

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = DEFAULT_SCROLLING_RESET_TIME_INTERVAL;
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Grid);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onGridRenderedMemoizer", (0, _createCallbackMemoizer["default"])());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScrollMemoizer", (0, _createCallbackMemoizer["default"])(false));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateColumnIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateRowIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollLeftFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollTopFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_horizontalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollbarPresenceChanged", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollingContainer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_childrenToDisplay", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollTop", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollLeft", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_disablePointerEventsTimeoutId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_styleCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });
    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  (0, _createClass2["default"])(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        (0, requestAnimationTimeout_1.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return React.createElement("div", (0, _extends2["default"])({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: (0, _clsx["default"])('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && React.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        (0, requestAnimationTimeout_1.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = (0, requestAnimationTimeout_1.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);
  return Grid;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  "aria-label": _propTypes["default"].string.isRequired,
  "aria-readonly": _propTypes["default"].bool,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  "autoContainerWidth": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoWidth": _propTypes["default"].bool.isRequired,

  /** Responsible for rendering a cell given an row and column index.  */
  "cellRenderer": function cellRenderer() {
    return (typeof types$2.bpfrpt_proptype_CellRenderer === "function" ? types$2.bpfrpt_proptype_CellRenderer.isRequired ? types$2.bpfrpt_proptype_CellRenderer.isRequired : types$2.bpfrpt_proptype_CellRenderer : _propTypes["default"].shape(types$2.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a group of cells given their index ranges.  */
  "cellRangeRenderer": function cellRangeRenderer() {
    return (typeof types$2.bpfrpt_proptype_CellRangeRenderer === "function" ? types$2.bpfrpt_proptype_CellRangeRenderer.isRequired ? types$2.bpfrpt_proptype_CellRangeRenderer.isRequired : types$2.bpfrpt_proptype_CellRangeRenderer : _propTypes["default"].shape(types$2.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },

  /** Optional custom CSS class name to attach to root Grid element.  */
  "className": _propTypes["default"].string,

  /** Number of columns in grid.  */
  "columnCount": _propTypes["default"].number.isRequired,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  "columnWidth": function columnWidth() {
    return (typeof types$2.bpfrpt_proptype_CellSize === "function" ? types$2.bpfrpt_proptype_CellSize.isRequired ? types$2.bpfrpt_proptype_CellSize.isRequired : types$2.bpfrpt_proptype_CellSize : _propTypes["default"].shape(types$2.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Unfiltered props for the Grid container. */
  "containerProps": _propTypes["default"].object,

  /** ARIA role for the cell-container.  */
  "containerRole": _propTypes["default"].string.isRequired,

  /** Optional inline style applied to inner cell-container */
  "containerStyle": _propTypes["default"].object.isRequired,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  "deferredMeasurementCache": _propTypes["default"].object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  "estimatedColumnSize": _propTypes["default"].number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Exposed for testing purposes only.  */
  "getScrollbarSize": _propTypes["default"].func.isRequired,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  "height": _propTypes["default"].number.isRequired,

  /** Optional custom id to attach to root Grid element.  */
  "id": _propTypes["default"].string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  "isScrolling": _propTypes["default"].bool,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  "noContentRenderer": function noContentRenderer() {
    return (typeof types$2.bpfrpt_proptype_NoContentRenderer === "function" ? types$2.bpfrpt_proptype_NoContentRenderer.isRequired ? types$2.bpfrpt_proptype_NoContentRenderer.isRequired : types$2.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(types$2.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  "onScrollbarPresenceChange": _propTypes["default"].func.isRequired,

  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  "onSectionRendered": _propTypes["default"].func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanColumnCount": _propTypes["default"].number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof types$2.bpfrpt_proptype_OverscanIndicesGetter === "function" ? types$2.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? types$2.bpfrpt_proptype_OverscanIndicesGetter.isRequired : types$2.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(types$2.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** ARIA role for the grid element.  */
  "role": _propTypes["default"].string.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  "rowHeight": function rowHeight() {
    return (typeof types$2.bpfrpt_proptype_CellSize === "function" ? types$2.bpfrpt_proptype_CellSize.isRequired ? types$2.bpfrpt_proptype_CellSize.isRequired : types$2.bpfrpt_proptype_CellSize : _propTypes["default"].shape(types$2.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Number of rows in grid.  */
  "rowCount": _propTypes["default"].number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  "scrollingResetTimeInterval": _propTypes["default"].number.isRequired,

  /** Horizontal offset. */
  "scrollLeft": _propTypes["default"].number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof types$2.bpfrpt_proptype_Alignment === "function" ? types$2.bpfrpt_proptype_Alignment.isRequired ? types$2.bpfrpt_proptype_Alignment.isRequired : types$2.bpfrpt_proptype_Alignment : _propTypes["default"].shape(types$2.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToColumn": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToRow": _propTypes["default"].number.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  "width": _propTypes["default"].number.isRequired
}), _temp);
(0, _defineProperty2["default"])(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: _defaultCellRangeRenderer["default"],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize["default"],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter["default"],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});
(0, _reactLifecyclesCompat.polyfill)(Grid);
var _default = Grid;
exports["default"] = _default;
});

var accessibilityOverscanIndicesGetter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;



var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}
});

var Grid = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "accessibilityOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _accessibilityOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "defaultCellRangeRenderer", {
  enumerable: true,
  get: function get() {
    return _defaultCellRangeRenderer["default"];
  }
});
Object.defineProperty(exports, "defaultOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _defaultOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_NoContentRenderer", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_NoContentRenderer;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Alignment", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_Alignment;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellPosition", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_CellPosition;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellSize", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_CellSize;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_OverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_OverscanIndicesGetter;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RenderedSection", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_RenderedSection;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellRendererParams", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_CellRendererParams;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Scroll", {
  enumerable: true,
  get: function get() {
    return types$2.bpfrpt_proptype_Scroll;
  }
});

var _Grid = interopRequireDefault(Grid_1);

var _accessibilityOverscanIndicesGetter = interopRequireDefault(accessibilityOverscanIndicesGetter);

var _defaultCellRangeRenderer = interopRequireDefault(defaultCellRangeRenderer_1);

var _defaultOverscanIndicesGetter = interopRequireDefault(defaultOverscanIndicesGetter_1);
});

var types$1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_RenderedRows = exports.bpfrpt_proptype_RowRenderer = exports.bpfrpt_proptype_RowRendererParams = void 0;

interopRequireWildcard(React__default);

var _propTypes = interopRequireDefault(propTypes);

var bpfrpt_proptype_RowRendererParams = process.env.NODE_ENV === 'production' ? null : {
  "index": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "style": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
var bpfrpt_proptype_RowRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
var bpfrpt_proptype_RenderedRows = process.env.NODE_ENV === 'production' ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired,
  "startIndex": _propTypes["default"].number.isRequired,
  "stopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
var bpfrpt_proptype_Scroll = process.env.NODE_ENV === 'production' ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
});

var List_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);

var _getPrototypeOf3 = interopRequireDefault(getPrototypeOf);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inherits2 = interopRequireDefault(inherits);

var _defineProperty2 = interopRequireDefault(defineProperty);

var _Grid = interopRequireWildcard(Grid);

var React = interopRequireWildcard(React__default);

var _clsx = interopRequireDefault(require$$10);



var _propTypes = interopRequireDefault(propTypes);

var _class, _temp;

var List = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(List)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "Grid", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = (0, _clsx["default"])('ReactVirtualized__List', className);
      return React.createElement(_Grid["default"], (0, _extends2["default"])({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
  return List;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  "aria-label": _propTypes["default"].string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /** Optional CSS class name */
  "className": _propTypes["default"].string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  "height": _propTypes["default"].number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  "noRowsRenderer": function noRowsRenderer() {
    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === "function" ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /** Callback invoked with information about the slice of rows that were just rendered.  */
  "onRowsRendered": _propTypes["default"].func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /** See Grid#overscanIndicesGetter */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  "rowHeight": function rowHeight() {
    return (typeof _Grid.bpfrpt_proptype_CellSize === "function" ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  "rowRenderer": function rowRenderer() {
    return (typeof types$1.bpfrpt_proptype_RowRenderer === "function" ? types$1.bpfrpt_proptype_RowRenderer.isRequired ? types$1.bpfrpt_proptype_RowRenderer.isRequired : types$1.bpfrpt_proptype_RowRenderer : _propTypes["default"].shape(types$1.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },

  /** Number of rows in list. */
  "rowCount": _propTypes["default"].number.isRequired,

  /** See Grid#scrollToAlignment */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _Grid.bpfrpt_proptype_Alignment === "function" ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToIndex": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of list */
  "width": _propTypes["default"].number.isRequired
}), _temp);
exports["default"] = List;
(0, _defineProperty2["default"])(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});
});

var List = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RowRendererParams", {
  enumerable: true,
  get: function get() {
    return types$1.bpfrpt_proptype_RowRendererParams;
  }
});

var _List = interopRequireDefault(List_1);
});

var List$1 = /*@__PURE__*/getDefaultExportFromCjs(List);

var types = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_CellMeasureCache = void 0;

var _propTypes = interopRequireDefault(propTypes);

var bpfrpt_proptype_CellMeasureCache = process.env.NODE_ENV === 'production' ? null : {
  "hasFixedWidth": _propTypes["default"].func.isRequired,
  "hasFixedHeight": _propTypes["default"].func.isRequired,
  "has": _propTypes["default"].func.isRequired,
  "set": _propTypes["default"].func.isRequired,
  "getHeight": _propTypes["default"].func.isRequired,
  "getWidth": _propTypes["default"].func.isRequired
};
exports.bpfrpt_proptype_CellMeasureCache = bpfrpt_proptype_CellMeasureCache;
});

var CellMeasurer_1 = createCommonjsModule(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);

var _getPrototypeOf3 = interopRequireDefault(getPrototypeOf);

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inherits2 = interopRequireDefault(inherits);

var _defineProperty2 = interopRequireDefault(defineProperty);

var React = interopRequireWildcard(React__default);





var _propTypes = interopRequireDefault(propTypes);

var _class, _temp;

/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, CellMeasurer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(CellMeasurer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_child", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_measure", function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }

      _this._child = element;

      if (element) {
        _this._maybeMeasureCell();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child || (0, ReactDOM.findDOMNode)(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.

        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }

        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660

        if (styleWidth) {
          node.style.width = styleWidth;
        }

        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
          cache = _this$props2.cache,
          _this$props2$columnIn = _this$props2.columnIndex,
          columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
          parent = _this$props2.parent,
          _this$props2$rowIndex = _this$props2.rowIndex,
          rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;

      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
            height = _this$_getCellMeasure2.height,
            width = _this$_getCellMeasure2.width;

        cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.

        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);
  return CellMeasurer;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  "cache": function cache() {
    return (typeof types.bpfrpt_proptype_CellMeasureCache === "function" ? types.bpfrpt_proptype_CellMeasureCache.isRequired ? types.bpfrpt_proptype_CellMeasureCache.isRequired : types.bpfrpt_proptype_CellMeasureCache : _propTypes["default"].shape(types.bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  "children": _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired,
  "columnIndex": _propTypes["default"].number,
  "index": _propTypes["default"].number,
  "parent": _propTypes["default"].shape({
    invalidateCellSizeAfterRender: _propTypes["default"].func,
    recomputeGridSize: _propTypes["default"].func
  }).isRequired,
  "rowIndex": _propTypes["default"].number
}), _temp); // Used for DEV mode warning check

exports["default"] = CellMeasurer;
(0, _defineProperty2["default"])(CellMeasurer, "__internalCellMeasurerFlag", false);

if (process.env.NODE_ENV !== 'production') {
  CellMeasurer.__internalCellMeasurerFlag = true;
}
});

var CellMeasurerCache_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_WIDTH = exports.DEFAULT_HEIGHT = void 0;

var _classCallCheck2 = interopRequireDefault(classCallCheck);

var _createClass2 = interopRequireDefault(createClass);

var _defineProperty2 = interopRequireDefault(defineProperty);



var DEFAULT_HEIGHT = 30;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
var DEFAULT_WIDTH = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

exports.DEFAULT_WIDTH = DEFAULT_WIDTH;

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache =
/*#__PURE__*/
function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, CellMeasurerCache);
    (0, _defineProperty2["default"])(this, "_cellHeightCache", {});
    (0, _defineProperty2["default"])(this, "_cellWidthCache", {});
    (0, _defineProperty2["default"])(this, "_columnWidthCache", {});
    (0, _defineProperty2["default"])(this, "_rowHeightCache", {});
    (0, _defineProperty2["default"])(this, "_defaultHeight", void 0);
    (0, _defineProperty2["default"])(this, "_defaultWidth", void 0);
    (0, _defineProperty2["default"])(this, "_minHeight", void 0);
    (0, _defineProperty2["default"])(this, "_minWidth", void 0);
    (0, _defineProperty2["default"])(this, "_keyMapper", void 0);
    (0, _defineProperty2["default"])(this, "_hasFixedHeight", void 0);
    (0, _defineProperty2["default"])(this, "_hasFixedWidth", void 0);
    (0, _defineProperty2["default"])(this, "_columnCount", 0);
    (0, _defineProperty2["default"])(this, "_rowCount", 0);
    (0, _defineProperty2["default"])(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
    });
    (0, _defineProperty2["default"])(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
    });
    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (process.env.NODE_ENV !== 'production') {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  (0, _createClass2["default"])(CellMeasurerCache, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }

      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      } // Size is cached per cell so we don't have to re-measure if cells are re-ordered.


      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;

        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }

        var columnKey = this._keyMapper(0, columnIndex);

        this._columnWidthCache[columnKey] = columnWidth;
      }

      if (!this._hasFixedHeight) {
        var rowHeight = 0;

        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }

        var rowKey = this._keyMapper(rowIndex, 0);

        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._defaultWidth;
    }
  }]);
  return CellMeasurerCache;
}();

exports["default"] = CellMeasurerCache;

function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}
});

var CellMeasurer = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CellMeasurer", {
  enumerable: true,
  get: function get() {
    return _CellMeasurer["default"];
  }
});
Object.defineProperty(exports, "CellMeasurerCache", {
  enumerable: true,
  get: function get() {
    return _CellMeasurerCache["default"];
  }
});
exports["default"] = void 0;

var _CellMeasurer = interopRequireDefault(CellMeasurer_1);

var _CellMeasurerCache = interopRequireDefault(CellMeasurerCache_1);

var _default = _CellMeasurer["default"];
exports["default"] = _default;
});

function _createSuper$F(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$F(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MODE$1 = 'selected';
var HEIGHT_OFFSET_FROM_VIEW_BOTTOM$2 = 270; // In pixels

var Theatres = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Theatres, _React$Component);

  var _super = _createSuper$F(Theatres);

  function Theatres(props) {
    var _this;

    _classCallCheck$1(this, Theatres);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "reRenderList", function () {
      _this.cache.clearAll();

      if (_this.ListRef.current) _this.ListRef.current.recomputeRowHeights();
    });

    _defineProperty$1(_assertThisInitialized(_this), "UpdateExpandedTheatre", function (theatre) {
      if (theatre) {
        var expandedTheatres = _this.state.expandedTheatres;
        var newExpandedTheatreList = expandedTheatres.slice();
        var index = newExpandedTheatreList.findIndex(function (id) {
          return id === theatre.id;
        });

        if (index > -1) {
          newExpandedTheatreList.splice(index, 1);
        } else {
          newExpandedTheatreList.push(theatre.id);
        }

        _this.setState({
          expandedTheatres: newExpandedTheatreList
        });
      }

      _this.reRenderList();
    });

    _defineProperty$1(_assertThisInitialized(_this), "rowRenderer", function (_ref) {
      var index = _ref.index;
          _ref.isScrolling;
          _ref.isVisible;
          var key = _ref.key,
          parent = _ref.parent,
          style = _ref.style;
      var expandedTheatres = _this.state.expandedTheatres;
      var _this$props = _this.props,
          theatres = _this$props.theatres,
          theatresInBooking = _this$props.theatresInBooking,
          listView = _this$props.listView,
          editListView = _this$props.editListView,
          tabType = _this$props.tabType,
          edit = _this$props.edit,
          mode = _this$props.mode;
      var theatre = theatres[index];
      var expandedTheatre = false;
      var selected = false;
      expandedTheatre = expandedTheatres.includes(theatre.id);

      if (mode === 'exhibitor') {
        selected = _$1.findIndex(theatresInBooking, function (th) {
          return th.uuid === theatre.uuid;
        }) >= 0;
      } else if (!edit) {
        selected = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        }) >= 0;
      } else {
        var screenInTheatreListCount = 0;
        theatre && theatre.screens && theatre.screens.forEach(function (item) {
          if (item.isInList) {
            screenInTheatreListCount += 1;
          }
        });

        if (screenInTheatreListCount) {
          selected = true;
        }
      }

      return /*#__PURE__*/React__default.createElement(CellMeasurer.CellMeasurer, {
        cache: _this.cache,
        columnIndex: 0,
        key: key,
        parent: parent,
        rowIndex: index
      }, /*#__PURE__*/React__default.createElement("div", {
        style: style,
        className: "theatre-card-list-item-wrapper"
      }, /*#__PURE__*/React__default.createElement(TheatreCard, {
        expandedTheatre: expandedTheatre,
        UpdateExpandedTheatre: _this.UpdateExpandedTheatre,
        showTheatreInfo: _this.props.showTheatreInfo,
        showWireTapIcon: _this.props.showWireTapIcon,
        genericWireTapIcon: _this.props.genericWireTapIcon,
        listItemStyle: style,
        index: index,
        listRef: _this.ListRef.current,
        theatre: theatre,
        key: mode === 'exhibitor' ? theatre.uuid + index : theatre.id + index,
        selected: selected,
        editListView: editListView,
        theatresInBooking: theatresInBooking,
        getSelectedScreenCount: _this.getSelectedScreenCount.bind(_assertThisInitialized(_this)),
        handleAddTheatre: _this.handleAddTheatre.bind(_assertThisInitialized(_this)),
        handleAddScreen: _this.handleAddScreen.bind(_assertThisInitialized(_this)),
        toggleExpand: _this.toggleTheatreExpand,
        expand: _this.getExpandTheatreToggleStatus(index),
        listView: listView,
        type: tabType,
        edit: edit,
        shouldShowPrice: false,
        mode: mode,
        shouldShowExpand: mode !== 'exhibitor' && _this.props.withScreenInfo
      })));
    });

    _this.ListRef = /*#__PURE__*/React__default.createRef();
    _this.cache = new CellMeasurer.CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 72
    });
    _this.state = {
      expandInfo: {
        index: 0,
        status: false
      },
      expandedTheatres: [],
      cachedSearchedName: props.searchedTheatreName,
      updatedOn: null
    };
    _this.handleRemoveTheatresFromBooking = _this.handleRemoveTheatresFromBooking.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(Theatres, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var searchedTheatreName = nextProps.searchedTheatreName;
          nextProps.editListView;

      if (searchedTheatreName && this.state.cachedSearchedName !== searchedTheatreName) {
        this.setState({
          expandInfo: {
            index: 0,
            status: false
          },
          cachedSearchedName: searchedTheatreName
        });
      }

      this.cache.clearAll(); //Clear the cache if row heights are recompute to be sure there are no "blank spaces" (some row are erased)

      this.listRef && this.listRef.recomputeRowHeights(); //We need to recompute the heights

      this.setState({
        updatedOn: Date.now()
      });
    }
  }, {
    key: "toggleTheatreExpand",
    value: function toggleTheatreExpand(index) {
      var expandInfo = {};

      if (index === this.state.expandInfo.index) {
        expandInfo = {
          index: index,
          status: !this.state.expandInfo.status
        };
      } else {
        expandInfo = {
          index: index,
          status: true
        };
      }

      this.setState({
        expandInfo: expandInfo
      });
    }
  }, {
    key: "getExpandTheatreToggleStatus",
    value: function getExpandTheatreToggleStatus(index) {
      if (index === this.state.expandInfo.index) {
        return this.state.expandInfo.status;
      }

      return false;
    }
  }, {
    key: "handleRemoveTheatresFromBooking",
    value: function handleRemoveTheatresFromBooking(position, theatres) {
      var expandInfo = this.state.expandInfo;

      var totalScreensWithConflict = _$1.reduce(theatres[0].screens, function (sum, screen) {
        if (!screen.hasMediaBlock) {
          sum += 1;
        }

        return sum;
      }, 0);

      var shouldRemoveAllScreens = theatres[0].screens.length === totalScreensWithConflict + theatres[0].screensToProcess.length;

      if (shouldRemoveAllScreens && this.props.selectMode === MODE$1) {
        if (position === this.state.expandInfo.index) {
          expandInfo.index = -1;
        } else if (position < this.state.expandInfo.index) {
          expandInfo.index--;
        }
      }

      this.setState({
        expandInfo: expandInfo
      });
      this.props.addTheatreForBooking(theatres);
    }
  }, {
    key: "getSelectedScreenCount",
    value: function getSelectedScreenCount(selected, theatre) {
      var _this$props2 = this.props,
          theatresInBooking = _this$props2.theatresInBooking,
          editListView = _this$props2.editListView;
      var selectedScreensCount = 0;
      var theatreIndex;

      if (theatresInBooking) {
        theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        });
      }

      if (selected) {
        selectedScreensCount = _$1.filter(theatresInBooking[theatreIndex].screens, function (sc) {
          return sc.selected;
        }).length;
      }

      if (editListView) {
        selectedScreensCount = theatresInBooking[theatreIndex] ? _$1.filter(theatresInBooking[theatreIndex].screens, function (sc) {
          return sc.isInList;
        }).length : 0;
      }

      return selectedScreensCount;
    }
  }, {
    key: "handleAddTheatre",
    value: function handleAddTheatre(theatre, selected, index) {
      var _this$props3 = this.props,
          listView = _this$props3.listView,
          mode = _this$props3.mode;

      if (mode === 'exhibitor') {
        this.props.addTheatreForBooking([theatre]);
      } else {
        var theatreToProcess = _$1.cloneDeep(theatre);

        if (listView) {
          theatreToProcess.screensToProcess = _$1.filter(theatreToProcess.screens, function (screen) {
            return screen.isInList;
          });
          theatreToProcess.screensToProcess = _$1.map(theatreToProcess.screensToProcess, function (screen) {
            return screen.id;
          });
        } else {
          theatreToProcess.screensToProcess = _$1.filter(theatreToProcess.screens, function (screen) {
            return screen.hasMediaBlock;
          });
          theatreToProcess.screensToProcess = _$1.map(theatreToProcess.screensToProcess, 'id');
        }

        this.props.addTheatreForBooking([theatreToProcess]);
      }
    }
  }, {
    key: "handleAddScreen",
    value: function handleAddScreen(index, theatreIndex, screen, theatre, selected) {
      this.props.handleScreenBooking(theatreIndex, index, selected, theatre, screen);
      this.reRenderList();
    }
  }, {
    key: "_renderTheatresList",
    value: function _renderTheatresList() {
      var _this2 = this;

      var _this$props4 = this.props,
          theatres = _this$props4.theatres;
          _this$props4.addTheatreForBooking;
          var theatresInBooking = _this$props4.theatresInBooking,
          listView = _this$props4.listView,
          editListView = _this$props4.editListView,
          tabType = _this$props4.tabType,
          edit = _this$props4.edit,
          mode = _this$props4.mode;

      if ((listView || editListView) && theatres.length < 10 || mode === 'exhibitor') {
        return (theatres || []).map(function (theatre, index) {
          var selected = false;

          if (mode === 'exhibitor') {
            selected = _$1.findIndex(theatresInBooking, function (th) {
              return th.uuid === theatre.uuid;
            }) >= 0;
          } else if (!edit) {
            selected = _$1.findIndex(theatresInBooking, function (th) {
              return th.id === theatre.id;
            }) >= 0;
          } else {
            var screenInTheatreListCount = 0;
            theatre && theatre.screens && theatre.screens.forEach(function (item) {
              if (item.isInList) {
                screenInTheatreListCount += 1;
              }
            });

            if (screenInTheatreListCount) {
              selected = true;
            }
          }

          return /*#__PURE__*/React__default.createElement(TheatreCard, {
            showTheatreInfo: _this2.props.showTheatreInfo,
            showWireTapIcon: _this2.props.showWireTapIcon,
            genericWireTapIcon: _this2.props.genericWireTapIcon,
            index: index,
            updatedOn: _this2.state.updatedOn,
            theatre: theatre,
            key: mode === 'exhibitor' ? theatre.uuid + index : theatre.id + index,
            selected: selected,
            editListView: editListView,
            theatresInBooking: theatresInBooking,
            getSelectedScreenCount: _this2.getSelectedScreenCount.bind(_this2),
            handleAddTheatre: _this2.handleAddTheatre.bind(_this2),
            handleAddScreen: _this2.handleAddScreen.bind(_this2),
            toggleExpand: _this2.toggleTheatreExpand,
            expand: _this2.getExpandTheatreToggleStatus(index),
            listView: listView,
            type: tabType,
            edit: edit,
            shouldShowPrice: false,
            mode: mode,
            shouldShowExpand: mode !== 'exhibitor' && _this2.props.withScreenInfo
          });
        });
      } else if (listView || editListView) {
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            height: 560
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-search-list"
        }, /*#__PURE__*/React__default.createElement(AutoSizer$1, null, function (_ref2) {
          var height = _ref2.height,
              width = _ref2.width;
          return /*#__PURE__*/React__default.createElement(List$1, {
            ref: _this2.ListRef,
            data: theatresInBooking,
            deferredMeasurementCache: _this2.cache,
            height: height ? height : 560,
            rowCount: theatres.length,
            rowRenderer: _this2.rowRenderer,
            width: width,
            rowHeight: _this2.cache.rowHeight,
            className: "theatre-auto-list"
          });
        })));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-list"
      }, /*#__PURE__*/React__default.createElement(AutoSizer$1, null, function (_ref3) {
        var height = _ref3.height,
            width = _ref3.width;
        return /*#__PURE__*/React__default.createElement(List$1, {
          ref: _this2.ListRef,
          data: theatresInBooking,
          deferredMeasurementCache: _this2.cache,
          height: height ? height : 560,
          rowCount: theatres.length,
          rowRenderer: _this2.rowRenderer,
          width: width,
          rowHeight: _this2.cache.rowHeight,
          className: "theatre-auto-list"
        });
      }));
    }
  }, {
    key: "renderNoTheatresFoundMessage",
    value: function renderNoTheatresFoundMessage() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center'
        },
        className: "no-theatres"
      }, i18n.t('noTheatresFound'));
    }
  }, {
    key: "renderSearchInProgress",
    value: function renderSearchInProgress() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-loader",
        style: {
          height: "".concat(window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM$2, "px")
        }
      }, /*#__PURE__*/React__default.createElement("div", null, this.props.isLoading && /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      }));
    }
  }, {
    key: "renderInfiniteTheatresList",
    value: function renderInfiniteTheatresList() {
      var hasMoreLoading = this.props.hasMoreLoading;
      return /*#__PURE__*/React__default.createElement("div", null, this._renderTheatresList(), hasMoreLoading && this.renderLoading());
    }
  }, {
    key: "renderTheatresList",
    value: function renderTheatresList() {
      var _this$props5 = this.props;
          _this$props5.isLoading;
          var hasMoreLoading = _this$props5.hasMoreLoading;

      if (this.props.forSearchResults) {
        return /*#__PURE__*/React__default.createElement("div", null, this.renderInfiniteTheatresList());
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-wrapper"
      }, this._renderTheatresList(), hasMoreLoading && /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'absolute'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          theatres = _this$props6.theatres,
          searchedTheatreName = _this$props6.searchedTheatreName,
          isLoading = _this$props6.isLoading;

      if (!theatres || theatres.length === 0) {
        if (!isLoading && !searchedTheatreName) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "theatres-empty-state"
          }, i18n.t('searchAndSelectTheatres'));
        }

        if (!isLoading && searchedTheatreName && searchedTheatreName.length > 2) {
          return this.renderNoTheatresFoundMessage();
        }

        if (searchedTheatreName && searchedTheatreName.length > 2) {
          return this.renderSearchInProgress();
        }

        return /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-empty-state"
        }, i18n.t('searchAndSelectTheatres'));
      }

      return this.renderTheatresList();
    }
  }]);

  return Theatres;
}(React__default.Component);
Theatres.defaultProps = {
  withScreenInfo: true
};

function TertiaryButton(props) {
  var style = props.style,
      clickEvent = props.clickEvent,
      btnName = props.btnName;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "tertiary-btn",
    onClick: clickEvent,
    style: style || {}
  }, btnName);
}

TertiaryButton.defaultProps = {
  style: {}
};

var antIcon = /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
  style: {
    fontSize: 24
  },
  spin: true
});

var SearchBar = function SearchBar(props) {
  var value = props.value,
      placeholder = props.placeholder,
      size = props.size,
      style = props.style,
      onSearch = props.onSearch,
      onChange = props.onChange,
      getPopupContainer = props.getPopupContainer,
      notFoundContent = props.notFoundContent,
      notFoundMessage = props.notFoundMessage;
  return /*#__PURE__*/React__default.createElement(_Select, {
    showSearch: true,
    allowClear: true,
    value: value,
    placeholder: placeholder,
    style: style,
    size: size,
    defaultActiveFirstOption: false,
    suffixIcon: /*#__PURE__*/React__default.createElement(SearchOutlined$1, null),
    filterOption: false,
    onSearch: onSearch,
    onChange: onChange,
    getPopupContainer: getPopupContainer,
    notFoundContent: notFoundContent ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, notFoundMessage ? notFoundMessage : /*#__PURE__*/React__default.createElement(_Spin, {
      indicator: antIcon,
      size: "small"
    })) : null
  }, props.children);
};

SearchBar.defaultProps = {
  value: undefined,
  placeholder: '',
  notFoundContent: false,
  onSearch: function onSearch() {},
  onChange: function onChange() {},
  getPopupContainer: function getPopupContainer() {},
  size: 'default'
};

function _createSuper$E(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$E(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CancelToken$1 = axios.CancelToken;
var cancel$1;

var TheatreSearch = /*#__PURE__*/function (_Component) {
  _inherits$1(TheatreSearch, _Component);

  var _super = _createSuper$E(TheatreSearch);

  function TheatreSearch(props) {
    var _this;

    _classCallCheck$1(this, TheatreSearch);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleRemoveTheatre", function (e) {
      var selectedTheatre = _this.state.selectedTheatre;
      var removeSearchedTheatre = _this.props.removeSearchedTheatre;
      e.stopPropagation();
      removeSearchedTheatre(selectedTheatre);

      _this.setState({
        theatreSelected: false,
        selectedTheatre: {},
        duplicateTheatre: false,
        options: [],
        searchValue: undefined
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "onChange", function (value) {
      if (value) {
        var _this$props = _this.props,
            theatresInBooking = _this$props.theatresInBooking,
            handleAddTheatre = _this$props.handleAddTheatre,
            id = _this$props.id,
            updateUnMatchedTheatresList = _this$props.updateUnMatchedTheatresList;
        var searchedTheatres = _this.state.searchedTheatres;

        var selectedTheatre = _$1.find(searchedTheatres, function (theatre) {
          return theatre.id === value;
        });

        var itemIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === selectedTheatre.id;
        }) >= 0;

        if (itemIndex) {
          _this.setState({
            duplicateTheatre: true,
            searchValue: selectedTheatre.name
          });
        } else {
          selectedTheatre.screens = selectedTheatre.screens.map(function (screen) {
            if (screen.hasMediaBlock) {
              screen.selected = true;
            }

            return screen;
          });
          updateUnMatchedTheatresList && updateUnMatchedTheatresList(selectedTheatre, id);
          handleAddTheatre(selectedTheatre, true);

          _this.setState({
            selectedTheatre: selectedTheatre,
            theatreSelected: true
          });
        }
      } else {
        _this.setState({
          duplicateTheatre: false,
          options: [],
          searchValue: value
        });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "onSearch", function (value) {
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          account = _this$props2.account,
          accessToken = _this$props2.accessToken;
      var _this$state = _this.state,
          offset = _this$state.offset,
          ps = _this$state.ps;

      _this.setState({
        duplicateTheatre: false,
        notFoundMessage: null
      });

      if (value.length >= 3) {
        if (cancel$1 !== undefined) {
          cancel$1();
        }

        var config = {
          headers: {
            Authorization: "Bearer ".concat(accessToken)
          },
          cancelToken: new CancelToken$1(function executor(c) {
            cancel$1 = c;
          })
        };
        var spec = 'spec=dci&';

        if (account.user.enableNonDCITheatreSearch) {
          spec = '';
        }

        _this.setState({
          options: [],
          notFoundContent: true
        });

        axios.get("".concat(hostUrl, "/v1/theatres/search?").concat(spec, "offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(value), config).then(function (response) {
          var Option = _Select.Option;

          if (response.data.theatres.length) {
            var options = response.data.theatres.map(function (theatre, index) {
              return /*#__PURE__*/React__default.createElement(Option, {
                key: index,
                value: theatre.id
              }, /*#__PURE__*/React__default.createElement(TheatreName, {
                name: theatre.name
              }), /*#__PURE__*/React__default.createElement(TheatreAddress, {
                address: formatAddress(theatre.address)
              }));
            });

            _this.setState({
              options: options,
              notFoundContent: false,
              searchedTheatres: response.data.theatres
            });
          } else {
            _this.setState({
              notFoundMessage: i18n.t('noTheatresFound')
            });
          }
        }).catch(function (error) {
          if (!axios.isCancel(error)) {
            handleAppError(error, i18n.t('errorGettingTheatre'));
          }
        });
      } else {
        _this.setState({
          options: []
        });
      }
    });

    _this.state = {
      offset: 0,
      ps: 5,
      options: [],
      notFoundContent: false,
      theatreSelected: _this.props.theatre ? true : false,
      selectedTheatre: _this.props.theatre ? _this.props.theatre : {},
      searchedTheatres: [],
      duplicateTheatre: false,
      searchValue: undefined,
      notFoundMessage: null
    };
    return _this;
  }

  _createClass$1(TheatreSearch, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          selectedTheatre = _this$state2.selectedTheatre,
          notFoundContent = _this$state2.notFoundContent,
          options = _this$state2.options,
          duplicateTheatre = _this$state2.duplicateTheatre,
          searchValue = _this$state2.searchValue,
          notFoundMessage = _this$state2.notFoundMessage,
          theatreSelected = _this$state2.theatreSelected;
      var _this$props3 = this.props,
          getSelectedScreenCount = _this$props3.getSelectedScreenCount,
          theatresInBooking = _this$props3.theatresInBooking,
          handleAddScreen = _this$props3.handleAddScreen,
          handleAddTheatre = _this$props3.handleAddTheatre,
          id = _this$props3.id,
          UpdateExpandedTheatre = _this$props3.UpdateExpandedTheatre,
          expandedTheatre = _this$props3.expandedTheatre,
          genericWireTapIcon = _this$props3.genericWireTapIcon,
          shouldShowExpand = _this$props3.shouldShowExpand;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, theatreSelected ? /*#__PURE__*/React__default.createElement(TheatreCard, {
        theatre: selectedTheatre,
        showTheatreInfo: true,
        showWireTapIcon: true,
        removeTheatre: true,
        UpdateExpandedTheatre: UpdateExpandedTheatre,
        expandedTheatre: expandedTheatre,
        handleRemoveTheatre: this.handleRemoveTheatre,
        index: selectedTheatre.id,
        selected: _$1.findIndex(theatresInBooking, function (th) {
          return th.id === selectedTheatre.id;
        }) >= 0,
        getSelectedScreenCount: getSelectedScreenCount,
        theatresInBooking: theatresInBooking,
        handleAddTheatre: handleAddTheatre,
        handleAddScreen: handleAddScreen,
        genericWireTapIcon: genericWireTapIcon,
        shouldShowExpand: shouldShowExpand
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        id: 'theatre-search' + id,
        className: "theatre-search-outer"
      }, /*#__PURE__*/React__default.createElement(SearchBar, {
        value: searchValue,
        placeholder: i18n.t('searchAndSelectTheatres'),
        style: {
          width: '365px'
        },
        onSearch: this.onSearch,
        onChange: this.onChange,
        size: 'small',
        getPopupContainer: function getPopupContainer() {
          return document.getElementById('theatre-search' + id);
        },
        notFoundContent: notFoundContent,
        notFoundMessage: notFoundMessage
      }, options)), duplicateTheatre ? /*#__PURE__*/React__default.createElement("div", {
        className: "duplicate-theatre-warning"
      }, i18n.t('theatreAlreadySelectedInList')) : null));
    }
  }]);

  return TheatreSearch;
}(Component);

function _createSuper$D(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$D(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreSelectModal = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatreSelectModal, _React$Component);

  var _super = _createSuper$D(TheatreSelectModal);

  function TheatreSelectModal(props) {
    var _this;

    _classCallCheck$1(this, TheatreSelectModal);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "updateUnMatchedTheatresList", function (theatre, index) {
      var selectedUnMatchedTheatres = _this.state.selectedUnMatchedTheatres;

      var theatres = _toConsumableArray$1(selectedUnMatchedTheatres);

      theatres[index] = theatre;

      _this.setState({
        selectedUnMatchedTheatres: theatres
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "UpdateExpandedTheatre", function (theatre) {
      if (theatre) {
        var expandedTheatres = _this.state.expandedTheatres;
        var newExpandedTheatreList = expandedTheatres.slice();
        var index = newExpandedTheatreList.findIndex(function (id) {
          return id === theatre.id;
        });

        if (index > -1) {
          newExpandedTheatreList.splice(index, 1);
        } else {
          newExpandedTheatreList.push(theatre.id);
        }

        _this.setState({
          expandedTheatres: newExpandedTheatreList
        });
      }

      _this.reRenderMatchedList();

      _this.reRenderUnMatchedList();
    });

    _defineProperty$1(_assertThisInitialized(_this), "reRenderMatchedList", function () {
      _this.matchedTheatreCache.clearAll();

      if (_this.matchedTheatreListRef.current) _this.matchedTheatreListRef.current.recomputeRowHeights();
    });

    _defineProperty$1(_assertThisInitialized(_this), "reRenderUnMatchedList", function () {
      _this.unMatchedTheatreCache.clearAll();

      if (_this.unMatchedTheatreListRef.current) _this.unMatchedTheatreListRef.current.recomputeRowHeights();
    });

    _defineProperty$1(_assertThisInitialized(_this), "removeSearchedTheatre", function (theatre) {
      var _this$state = _this.state,
          theatresInBooking = _this$state.theatresInBooking,
          selectedUnMatchedTheatres = _this$state.selectedUnMatchedTheatres;

      var tempSelectedTheartes = _toConsumableArray$1(selectedUnMatchedTheatres);

      var index = _$1.findIndex(selectedUnMatchedTheatres, function (th) {
        return th ? th.id === theatre.id : false;
      });

      var tempList = theatresInBooking;

      var theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
        return th.id === theatre.id;
      });

      if (theatreIndex > -1) {
        tempList.splice(theatreIndex, 1);
      }

      if (index > -1) {
        tempSelectedTheartes[index] = null;
      }

      _this.setState({
        theatresInBooking: tempList,
        selectedUnMatchedTheatres: tempSelectedTheartes
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "getSelectedScreenCount", function (selected, theatre) {
      var theatresInBooking = _this.state.theatresInBooking;
      var selectedScreensCount = 0;
      var theatreIndex;

      if (theatresInBooking) {
        theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        });
      }

      if (selected) {
        selectedScreensCount = _$1.filter(theatresInBooking[theatreIndex].screens, function (sc) {
          return sc.selected;
        }).length;
      }

      return selectedScreensCount;
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleAddTheatre", function (theatre) {
      var oldTheatre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var theatreToProcess = _$1.cloneDeep(theatre);

      theatreToProcess.screensToProcess = _$1.filter(theatreToProcess.screens, function (screen) {
        return screen.hasMediaBlock;
      });
      theatreToProcess.screensToProcess = _$1.map(theatreToProcess.screensToProcess, 'id');

      _this.addTheatreToBooking([theatreToProcess], oldTheatre);
    });

    _defineProperty$1(_assertThisInitialized(_this), "addTheatreToBooking", function (list) {
      var oldTheatre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var tempList = _$1.cloneDeep(_this.state.theatresInBooking);

      var theatreList = list[0];
      var itemIndex = tempList.findIndex(function (item) {
        return item.id === theatreList.id;
      });
      theatreList.screens.map(function (item) {
        item['selected'] = true;
      });

      if (itemIndex > -1 && !oldTheatre) {
        tempList.splice(itemIndex, 1);
      } else if (!(itemIndex > -1) && oldTheatre || !oldTheatre) {
        tempList.push(theatreList);
      }

      _this.setState({
        theatresInBooking: tempList
      });

      if (_this.props.handleCSVToList) {
        _this.props.handleCSVToList(tempList);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleAddScreen", function (index, theatreIndex, screen, theatre, selected) {
      _this.handleScreenBooking(theatreIndex, index, selected, theatre, screen);
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleScreenBooking", function (selectionIndex, screenIndex, selected, theatre, screen) {
      var tempList = _$1.cloneDeep(_this.state.theatresInBooking);

      var theatreIndex = _$1.findIndex(tempList, function (th) {
        return th.id == theatre.id;
      });

      if (!_$1.isEmpty(tempList) && theatreIndex >= 0 && tempList[theatreIndex]) {
        tempList[theatreIndex].screens[screenIndex].selected = !selected;
        var hasSelected;
        tempList[theatreIndex].screens.forEach(function (item) {
          if (item.selected) {
            hasSelected = true;
          }
        });

        if (hasSelected) {
          _this.setState({
            theatresInBooking: tempList
          });
        } else {
          tempList.splice(theatreIndex, 1);

          _this.setState({
            theatresInBooking: tempList
          });
        }
      } else {
        var _tempList = _this.state.theatresInBooking;
        var tempScreen = theatre;
        tempScreen && tempScreen.screens.map(function (item) {
          if (item.id == screen.id) {
            item['selected'] = true;
          } else {
            item['selected'] = false;
          }
        });

        _tempList.push(tempScreen);

        _this.setState({
          theatresInBooking: _tempList
        });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleTabChange", function (key) {
      _this.setState({
        currentTab: key
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "getPageTabs", function () {
      var _this$props = _this.props,
          unmatchedTheatres = _this$props.unmatchedTheatres,
          matchedTheatres = _this$props.matchedTheatres;
      var uniqueUnmatchedTheatres = unmatchedTheatres.filter(function (theatre) {
        if (theatre.request.name.length || theatre.request.id.length || theatre.request.screen_id.length) {
          return theatre;
        }
      });
      return [{
        id: 'not_found',
        title: "Not Found (".concat(uniqueUnmatchedTheatres.length, ")"),
        isHidden: uniqueUnmatchedTheatres.length === 0
      }, {
        id: 'matched',
        title: "Matched Theatres (".concat(matchedTheatres.length, ")"),
        isHidden: matchedTheatres.length === 0
      }];
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderTabs", function () {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tabs-container"
      }, /*#__PURE__*/React__default.createElement(Tabs, {
        selectedTabId: _this.props.currentTab //no prop is passed? empty props?
        ,
        tabs: _this.getPageTabs(),
        onChange: _this.handleTabChange
      }));
    });

    _defineProperty$1(_assertThisInitialized(_this), "unMatchedRowRenderer", function (_ref, theatre) {
      var index = _ref.index;
          _ref.isScrolling;
          _ref.isVisible;
          var key = _ref.key,
          parent = _ref.parent,
          style = _ref.style;
      var _this$props2 = _this.props;
          _this$props2.unmatchedTheatres;
          var hostUrl = _this$props2.hostUrl,
          account = _this$props2.account,
          accessToken = _this$props2.accessToken,
          shouldShowExpand = _this$props2.shouldShowExpand;
      var _this$state2 = _this.state,
          theatresInBooking = _this$state2.theatresInBooking,
          selectedUnMatchedTheatres = _this$state2.selectedUnMatchedTheatres,
          expandedTheatres = _this$state2.expandedTheatres;
      var Selectedtheatre = selectedUnMatchedTheatres[index];
      return /*#__PURE__*/React__default.createElement(CellMeasurer.CellMeasurer, {
        cache: _this.unMatchedTheatreCache,
        columnIndex: 0,
        key: key,
        parent: parent,
        rowIndex: index
      }, /*#__PURE__*/React__default.createElement("div", {
        style: style
      }, /*#__PURE__*/React__default.createElement(_Row, {
        key: index
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React__default.createElement(TheatreDefaultCard, {
        key: index,
        name: theatre.request.name,
        address: formatAddress(theatre.request.address),
        id: theatre.request.id,
        screen_id: theatre.request.screen_id,
        theatreSelect: true,
        unMatched: true
      })), /*#__PURE__*/React__default.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React__default.createElement(TheatreSearch, {
        id: index,
        hostUrl: hostUrl,
        account: account,
        UpdateExpandedTheatre: _this.UpdateExpandedTheatre,
        expandedTheatre: Selectedtheatre ? expandedTheatres.includes(Selectedtheatre.id) : false,
        theatre: Selectedtheatre,
        accessToken: accessToken,
        updateUnMatchedTheatresList: _this.updateUnMatchedTheatresList,
        getSelectedScreenCount: _this.getSelectedScreenCount,
        theatresInBooking: theatresInBooking,
        handleAddTheatre: _this.handleAddTheatre,
        handleAddScreen: _this.handleAddScreen,
        removeSearchedTheatre: _this.removeSearchedTheatre,
        shouldShowExpand: shouldShowExpand
      })))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "matchedRowRenderer", function (_ref2, theatre) {
      var index = _ref2.index;
          _ref2.isScrolling;
          _ref2.isVisible;
          var key = _ref2.key,
          parent = _ref2.parent,
          style = _ref2.style;
      var expandedTheatres = _this.state.expandedTheatres;
      var shouldShowExpand = _this.props.shouldShowExpand;
      return /*#__PURE__*/React__default.createElement(CellMeasurer.CellMeasurer, {
        cache: _this.matchedTheatreCache,
        columnIndex: 0,
        key: key,
        parent: parent,
        rowIndex: index
      }, /*#__PURE__*/React__default.createElement("div", {
        style: style
      }, /*#__PURE__*/React__default.createElement(_Row, {
        key: index
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React__default.createElement(TheatreDefaultCard, {
        key: index,
        name: theatre.matchedColumn.name,
        address: formatAddress(theatre.matchedColumn.address ? theatre.matchedColumn.address : {}),
        id: theatre.matchedColumn.id,
        screen_id: theatre.matchedColumn.screen_id,
        theatreSelect: true,
        duplicate: theatre.duplicate,
        matchedRows: theatre.matchedRows,
        duplicateRows: theatre.duplicateRows
      })), /*#__PURE__*/React__default.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React__default.createElement(TheatreCard, {
        theatre: theatre.record,
        showTheatreInfo: true,
        showWireTapIcon: true,
        genericWireTapIcon: _this.props.genericWireTapIcon,
        index: index,
        key: theatre.record.id + index,
        theatreMatchedId: theatre.matched_id,
        expandedTheatre: expandedTheatres.includes(theatre.id),
        selected: _$1.findIndex(_this.state.theatresInBooking, function (th) {
          return th.id === theatre.record.id;
        }) >= 0,
        UpdateExpandedTheatre: _this.UpdateExpandedTheatre,
        getSelectedScreenCount: _this.getSelectedScreenCount,
        theatresInBooking: _this.state.theatresInBooking,
        handleAddTheatre: _this.handleAddTheatre,
        handleAddScreen: _this.handleAddScreen,
        shouldShowExpand: shouldShowExpand
      })))));
    });

    _this.state = {
      matchedTheatres: [],
      selectedUnMatchedTheatres: [],
      theatresInBooking: _this.props.theatresBookingByFile ? _this.props.theatresBookingByFile : [],
      currentTab: 'matched',
      expandedTheatres: []
    };
    _this.matchedTheatreListRef = /*#__PURE__*/React__default.createRef();
    _this.matchedTheatreCache = new CellMeasurer.CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 72
    });
    _this.unMatchedTheatreListRef = /*#__PURE__*/React__default.createRef();
    _this.unMatchedTheatreCache = new CellMeasurer.CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 72
    });
    _this.addTheatreToBooking = _this.addTheatreToBooking.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(TheatreSelectModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {// this.reRenderMatchedList();
      // this.reRenderUnMatchedList();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var uniqueUnmatchedTheatres = this.props.unmatchedTheatres.filter(function (theatre) {
        if (theatre.request.name.length || theatre.request.id.length || theatre.request.screen_id.length) {
          return theatre;
        }
      });

      if (uniqueUnmatchedTheatres.length > 0) {
        this.setState({
          currentTab: 'not_found'
        });
      } else {
        this.setState({
          currentTab: 'matched'
        });
      }
    }
  }, {
    key: "renderUnMatchedThetares",
    value: function renderUnMatchedThetares() {
      var _this2 = this;

      var _this$props3 = this.props,
          unmatchedTheatres = _this$props3.unmatchedTheatres,
          hostUrl = _this$props3.hostUrl,
          account = _this$props3.account,
          accessToken = _this$props3.accessToken,
          shouldShowExpand = _this$props3.shouldShowExpand;
      var theatresInBooking = this.state.theatresInBooking;
      var ignoredTheatres = 0;
      var uniqueUnmatchedTheatres = unmatchedTheatres.filter(function (theatre) {
        if (theatre.request.name.length || theatre.request.id.length || theatre.request.screen_id.length) {
          return theatre;
        }
      });
      ignoredTheatres = unmatchedTheatres.length - uniqueUnmatchedTheatres.length;
      return uniqueUnmatchedTheatres.length !== 0 || ignoredTheatres !== 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-found-heading "
      }, /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(_Col, {
        span: 24
      }, uniqueUnmatchedTheatres.length !== 0 ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-count text-capitalize"
      }, i18n.t('theatreCount', {
        count: uniqueUnmatchedTheatres.length
      }), i18n.t('notFound')) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "warning-text"
      }, uniqueUnmatchedTheatres.length !== 0 && "".concat(i18n.t('preciseMatchForTheatresNotFound'), " "), ignoredTheatres !== 0 && i18n.t('rowWithoutNameAndIdIgnored', {
        count: ignoredTheatres
      }))))), /*#__PURE__*/React__default.createElement("div", {
        className: "unmatched-theatres-scroll"
      }, uniqueUnmatchedTheatres.length > 10 ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-virtual-list-container"
      }, /*#__PURE__*/React__default.createElement(AutoSizer$1, null, function (_ref3) {
        var height = _ref3.height,
            width = _ref3.width;
        return /*#__PURE__*/React__default.createElement(List$1, {
          ref: _this2.unMatchedTheatreListRef,
          deferredMeasurementCache: _this2.unMatchedTheatreCache,
          height: height ? height : 500,
          rowCount: uniqueUnmatchedTheatres.length,
          rowRenderer: function rowRenderer(props) {
            return _this2.unMatchedRowRenderer(props, uniqueUnmatchedTheatres[props.index]);
          },
          width: width,
          rowHeight: _this2.unMatchedTheatreCache.rowHeight,
          className: "theatre-auto-list"
        });
      })) : uniqueUnmatchedTheatres.map(function (theatre, index) {
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: index
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreDefaultCard, {
          key: index,
          name: theatre.request.name,
          address: formatAddress(theatre.request.address),
          id: theatre.request.id,
          screen_id: theatre.request.screen_id,
          theatreSelect: true,
          unMatched: true
        })), /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreSearch, {
          id: index,
          hostUrl: hostUrl,
          account: account,
          accessToken: accessToken,
          getSelectedScreenCount: _this2.getSelectedScreenCount,
          theatresInBooking: theatresInBooking,
          handleAddTheatre: _this2.handleAddTheatre,
          handleAddScreen: _this2.handleAddScreen,
          removeSearchedTheatre: _this2.removeSearchedTheatre,
          shouldShowExpand: shouldShowExpand
        })));
      }))) : null;
    }
  }, {
    key: "renderMatchedTheatres",
    value: function renderMatchedTheatres() {
      var _this3 = this;

      var _this$props4 = this.props,
          matchedTheatres = _this$props4.matchedTheatres,
          shouldShowExpand = _this$props4.shouldShowExpand;
      var duplicateCount = 0;
      matchedTheatres.forEach(function (theatre) {
        duplicateCount = duplicateCount + theatre.duplicateRows;
      });
      return matchedTheatres.length != 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-found-heading"
      }, /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(_Col, {
        span: 24
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-count text-capitalize"
      }, i18n.t('theatreCountMatched', {
        count: matchedTheatres.length
      })), duplicateCount != 0 ? /*#__PURE__*/React__default.createElement("div", {
        className: "warning-text"
      }, i18n.t('duplicateRowWasIgnored', {
        count: duplicateCount
      })) : null))), /*#__PURE__*/React__default.createElement("div", {
        className: "matched-theatres-scroll"
      }, matchedTheatres.length > 10 ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-virtual-list-container"
      }, /*#__PURE__*/React__default.createElement(AutoSizer$1, null, function (_ref4) {
        var height = _ref4.height,
            width = _ref4.width;
        return /*#__PURE__*/React__default.createElement(List$1, {
          ref: _this3.matchedTheatreListRef,
          deferredMeasurementCache: _this3.matchedTheatreCache,
          height: height ? height : 500,
          rowCount: matchedTheatres.length,
          rowRenderer: function rowRenderer(props) {
            return _this3.matchedRowRenderer(props, matchedTheatres[props.index]);
          },
          width: width,
          rowHeight: _this3.matchedTheatreCache.rowHeight,
          className: "theatre-auto-list"
        });
      })) : matchedTheatres.map(function (theatre, index) {
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: index
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreDefaultCard, {
          key: index,
          name: theatre.matchedColumn.name,
          address: formatAddress(theatre.matchedColumn.address ? theatre.matchedColumn.address : {}),
          id: theatre.matchedColumn.id,
          screen_id: theatre.matchedColumn.screen_id,
          theatreSelect: true,
          duplicate: theatre.duplicate,
          matchedRows: theatre.matchedRows,
          duplicateRows: theatre.duplicateRows
        })), /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreCard, {
          theatre: theatre.record,
          showTheatreInfo: true,
          showWireTapIcon: true,
          genericWireTapIcon: _this3.props.genericWireTapIcon,
          index: index,
          key: theatre.record.id + index,
          theatreMatchedId: theatre.matched_id,
          selected: _$1.findIndex(_this3.state.theatresInBooking, function (th) {
            return th.id === theatre.record.id;
          }) >= 0,
          getSelectedScreenCount: _this3.getSelectedScreenCount,
          theatresInBooking: _this3.state.theatresInBooking,
          handleAddTheatre: _this3.handleAddTheatre,
          handleAddScreen: _this3.handleAddScreen,
          shouldShowExpand: shouldShowExpand
        })));
      }))) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state3 = this.state,
          theatresInBooking = _this$state3.theatresInBooking,
          currentTab = _this$state3.currentTab;
      var _this$props5 = this.props,
          visible = _this$props5.visible,
          onCancel = _this$props5.onCancel,
          addTheatresToBooking = _this$props5.addTheatresToBooking;

      var triggerFunction = function triggerFunction() {
        (_this4.props.addCSVToList || addTheatresToBooking)(theatresInBooking);
      };

      return /*#__PURE__*/React__default.createElement(_Modal, {
        visible: visible,
        wrapClassName: 'theatre-upload-modal',
        title: i18n.t('selectTheatres'),
        onCancel: onCancel,
        afterClose: null,
        footer: [/*#__PURE__*/React__default.createElement("div", {
          key: "canel-button",
          className: "theatre-modal-cancel",
          onClick: onCancel
        }, i18n.t('cancel')), /*#__PURE__*/React__default.createElement(PrimaryButton, {
          key: "select_button",
          disabled: theatresInBooking.length === 0,
          btnName: i18n.t('selectTheatreCount', {
            count: theatresInBooking.length
          }),
          callbackAction: triggerFunction
        })]
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-select-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-select-modal-tab-menu"
      }, this.renderTabs()), currentTab === 'not_found' ? this.renderUnMatchedThetares() : null, currentTab === 'matched' ? this.renderMatchedTheatres() : null));
    }
  }]);

  return TheatreSelectModal;
}(React__default.Component);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * A component that allows users to upload CSV files and send them to theatre match service for processing/displaying csv data in a modal.
 *
 * @component
 * @example
 * (*) Denotes component will not work properly without these props.
 * <CSVUpload
 *   shouldShowUploadCSV={'boolean value, toggles the upload csv button visibilty'}
 *   hostUrl="https://example.com"*
 *   accessToken="abc123"*
 *   account={myaccount}*
 *   genericWireTapIcon="boolean value"
 *   styles={'inline css passing for styling of button'}
 *   theatreUrl={theatreUrl}*
 *   showAppBusy={'function here for handling busy state'}*
 *   handleAppError="error handling function here"*
 *   shouldShowExpand={boolean value, true by default}
 * />
 */

var CancelToken = axios.CancelToken;
var cancel;
var CSVUpload = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      percent = _useState4[0],
      setPercent = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      matchedTheatres = _useState6[0],
      setMatchedTheatres = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      theatresBookingByFile = _useState8[0],
      setTheatresBookingByFile = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      unmatchedTheatres = _useState10[0],
      setUnmatchedTheatres = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      theatreSelectModalVisible = _useState12[0],
      setTheatreSelectModalVisible = _useState12[1];

  var uploadCsvModal = function uploadCsvModal() {
    var _props$id = props.id,
        id = _props$id === void 0 ? 'csvupload' : _props$id;
    document.getElementById(id).click();
  };

  var cancelCsvUpload = function cancelCsvUpload() {
    setVisible(false);
  };

  var closeTheatreSelectModal = function closeTheatreSelectModal() {
    setTheatreSelectModalVisible(false);
  };

  var addTheatresToBookings = function addTheatresToBookings(list) {
    props.addTheatresToBooking(list);
    closeTheatreSelectModal();
  };

  var cancelFileUpload = function cancelFileUpload() {
    cancel();
    setPercent(0);
    setVisible(false);
  };

  var uploadFile = function uploadFile(e) {
    setVisible(true);
    var accessToken = props.accessToken,
        theatreUrl = props.theatreUrl,
        showAppBusy = props.showAppBusy,
        handleAppError = props.handleAppError,
        _props$id2 = props.id,
        id = _props$id2 === void 0 ? 'csvupload' : _props$id2;
    var form = new FormData();
    form.append('file', new Blob([e.target.files[0]], {
      type: 'text/csv'
    }));
    var config = {
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      },
      onUploadProgress: function onUploadProgress(progressEvent) {
        var loaded = progressEvent.loaded,
            total = progressEvent.total;
        var percent = Math.floor(loaded * 100 / total);
        setPercent(percent);

        if (percent === 100) {
          cancelCsvUpload();
          showAppBusy(true);
        }
      },
      cancelToken: new CancelToken(function (c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    };
    axios.post("".concat(theatreUrl, "/v1/facility/search"), form, config).then(function (response) {
      var theatres = _$1.sortBy(response.data, ['order']);

      setPercent(0);

      var unmatchedTheatres = theatres.filter(function (theatre) {
        return theatre.matched === false;
      });
      var matchedTheatres = theatres.filter(function (theatre) {
        return theatre.matched === true;
      });
      matchedTheatres = processTheatres(matchedTheatres);
      matchedTheatres = combineTheatreRows(matchedTheatres);
      var theatresForBooking = matchedTheatres.map(function (theatre) {
        return theatre.record;
      });
      theatresForBooking = _$1.uniqBy(theatresForBooking, function (theatre) {
        return theatre.id;
      });
      unmatchedTheatres = unmatchedTheatres.map(function (theatre) {
        theatre.request = processTheatreRequestData(theatre.request);
        return theatre;
      });
      var uniqueUnmatchedTheatres = unmatchedTheatres.filter(function (theatre) {
        if (theatre.request.name.length || theatre.request.id.length || theatre.request.screen_id.length) {
          return theatre;
        }
      });
      showAppBusy(false);

      if (matchedTheatres.length !== 0 || uniqueUnmatchedTheatres.length !== 0) {
        setUnmatchedTheatres(unmatchedTheatres);
        setMatchedTheatres(matchedTheatres);
        setTheatresBookingByFile(theatresForBooking);
        setTheatreSelectModalVisible(true);
      } else {
        ErrorMessage(i18n.t('invalidFileNoTheatreNameOrId'));
      }
    }).catch(function (error) {
      showAppBusy(false);

      if (!axios.isCancel(error)) {
        handleAppError(error, 'File', error.response.data.message);
      }
    });
    document.getElementById(id).value = '';
  };

  var CSVModal = function CSVModal() {
    var hostUrl = props.hostUrl,
        accessToken = props.accessToken,
        account = props.account,
        genericWireTapIcon = props.genericWireTapIcon,
        shouldShowExpand = props.shouldShowExpand;

    var conditionalProps = function conditionalProps() {
      var propsToPass = {};

      if (props.handleCSVToList && props.addCSVToList) {
        propsToPass.handleCSVToList = props.handleCSVToList;
        propsToPass.addCSVToList = props.addCSVToList;
      } else {
        propsToPass.addTheatresToBooking = addTheatresToBookings;
      }

      return propsToPass;
    };

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CommonModal, {
      visible: visible,
      wrapClassName: "vertical-center-modal modal-medium ",
      title: null,
      onCancel: null,
      afterClose: null,
      closable: false,
      footer: null
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "uploading-csv"
    }, i18n.t('uploadingCsv')), /*#__PURE__*/React__default.createElement(ProgressBar, {
      percent: percent,
      showInfo: false
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "cancel-upload",
      onClick: cancelFileUpload,
      role: "Cancel"
    }, i18n.t('cancel'))), theatreSelectModalVisible ? /*#__PURE__*/React__default.createElement(TheatreSelectModal, _extends$1({
      visible: theatreSelectModalVisible,
      onCancel: closeTheatreSelectModal,
      unmatchedTheatres: unmatchedTheatres,
      matchedTheatres: matchedTheatres,
      theatresBookingByFile: theatresBookingByFile,
      hostUrl: hostUrl,
      accessToken: accessToken,
      account: account,
      genericWireTapIcon: genericWireTapIcon,
      shouldShowExpand: shouldShowExpand
    }, conditionalProps())) : null);
  };

  var csvFunctionsRef = useRef({
    uploadCsvModal: uploadCsvModal,
    cancelCsvUpload: cancelCsvUpload,
    closeTheatreSelectModal: closeTheatreSelectModal,
    addTheatresToBookings: addTheatresToBookings,
    cancelFileUpload: cancelFileUpload,
    uploadFile: uploadFile,
    CSVModal: CSVModal
  });
  useImperativeHandle(ref, function () {
    return csvFunctionsRef.current;
  });
  var shouldShowUploadCSV = props.shouldShowUploadCSV,
      styles = props.styles,
      _props$id3 = props.id,
      id = _props$id3 === void 0 ? 'csvupload' : _props$id3;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, shouldShowUploadCSV && /*#__PURE__*/React__default.createElement("div", {
    className: "csvupload-button"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    id: id,
    accept: ".csv",
    hidden: true,
    onChange: uploadFile
  }), /*#__PURE__*/React__default.createElement(TertiaryButton, {
    btnName: i18n.t('selectUsingCsv'),
    clickEvent: uploadCsvModal,
    style: _objectSpread$6({
      margin: '0px 12px',
      display: 'inline',
      color: '#2D3540',
      backgroundColor: '#E6ECF0',
      padding: '0px 16px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer'
    }, styles)
  }), /*#__PURE__*/React__default.createElement("div", {
    "data-tip": true,
    "data-for": "csv"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    icon: /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "InfoCircle",
      color: "grey060"
    })
  })), /*#__PURE__*/React__default.createElement(ReactTooltip, {
    className: "react-tooltip-custom",
    id: "csv",
    place: "top",
    type: "dark",
    effect: "solid"
  }, i18n.t('csvColumnsForTheatreSelect'))), CSVModal());
});
CSVUpload.defaultProps = {
  shouldShowUploadCSV: true,
  styles: '',
  shouldShowExpand: true
};

function _createSuper$C(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$C(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MIN_SEARCH_TEXT_LEN = 2;

var TheatresViewPage = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatresViewPage, _React$Component);

  var _super = _createSuper$C(TheatresViewPage);

  function TheatresViewPage(props) {
    var _this;

    _classCallCheck$1(this, TheatresViewPage);

    _this = _super.call(this, props);
    _this.state = {
      searchText: '',
      offset: 0,
      ps: 10,
      // error: false,
      isLoading: false,
      hasMoreTheatres: false,
      hasMoreLoading: false
    };
    _this.emitEmpty = _this.emitEmpty.bind(_assertThisInitialized(_this));
    _this.searchInput = _this.searchInput.bind(_assertThisInitialized(_this));
    _this.theatreListScroll = _this.theatreListScroll.bind(_assertThisInitialized(_this));
    _this.getTheatres = _this.getTheatres.bind(_assertThisInitialized(_this));
    _this.getTheatres = _$1.debounce(_this.getTheatres, 1000);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(TheatresViewPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // var elmnt = document.getElementById("layout-content-scroll");
      // if(elmnt){
      //   elmnt.scrollTop = 0
      // }
      if (document.getElementById('theatres-list-overview-scroll')) {
        document.getElementById('theatres-list-overview-scroll').addEventListener('scroll', this.theatreListScroll, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.getElementById('theatres-list-overview-scroll').removeEventListener('scroll', this.theatreListScroll);
    }
  }, {
    key: "theatreListScroll",
    value: function theatreListScroll() {
      var _this2 = this;

      var hasMoreLoading = this.state.hasMoreLoading;
      var scrollElem = document.getElementById('theatres-list-overview-scroll');

      if (Math.ceil(scrollElem.scrollHeight - scrollElem.scrollTop) == scrollElem.clientHeight) {
        if (this.state.hasMoreTheatres && !hasMoreLoading) {
          this.setState({
            offset: this.state.offset + 10,
            hasMoreLoading: true
          }, function () {
            return _this2.loadMoreTheatres();
          });
        }
      }
    }
  }, {
    key: "searchTheatreResults",
    value: function searchTheatreResults() {
      var _this3 = this;

      var searchText = this.state.searchText;

      if (searchText.length > 2) {
        this.setState({
          isLoading: true,
          offset: 0
        }, function () {
          return _this3.getTheatres();
        }); // cancelAllPendingRequest(() => {
        //   this.setState({isLoading: true}, () => this.getTheatres())
        // })
      } else {
        this.setState({
          theatresList: [],
          isLoading: false
        }); // source.cancel('Operation canceled by the user.');
      }
    }
  }, {
    key: "shouldTheatresSectionBeVisible",
    value: function shouldTheatresSectionBeVisible() {
      var searchText = this.state.searchText;
      return searchText && searchText.length > MIN_SEARCH_TEXT_LEN;
    }
  }, {
    key: "shouldAddTheatreSectionBeHidden",
    value: function shouldAddTheatreSectionBeHidden() {
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          theatresList = _this$state.theatresList;
      return isLoading && theatresList && theatresList.length === 0;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _this4 = this;

      this.setState({
        searchText: e.target.value,
        theatresList: []
      }, function () {
        return _this4.searchTheatres();
      });
    }
  }, {
    key: "searchTheatres",
    value: function searchTheatres() {
      var searchText = this.state.searchText;

      if (searchText.length > 2) {
        this.searchTheatreResults();
      }
    }
  }, {
    key: "emitEmpty",
    value: function emitEmpty() {
      var _this5 = this;

      this.setState({
        offset: 0,
        searchText: ''
      }, function () {
        return _this5.searchTheatreResults();
      });
    }
  }, {
    key: "searchInput",
    value: function searchInput() {
      this.searchTheatreResults();
    }
  }, {
    key: "getTheatres",
    value: function getTheatres() {
      var _this6 = this;

      var _this$props = this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken,
          account = _this$props.account,
          theatreSearchUrl = _this$props.theatreSearchUrl,
          mode = _this$props.mode,
          handleAppError = _this$props.handleAppError;
      var _this$state2 = this.state,
          searchText = _this$state2.searchText,
          offset = _this$state2.offset,
          ps = _this$state2.ps;
          _this$state2.isLoading;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };

      if (mode === 'exhibitor') {
        axios.get("".concat(hostUrl, "/").concat(theatreSearchUrl, "?offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(searchText), config).then(function (response) {
          if (response.status >= 200 && response.status <= 300) {
            if (searchText.length) {
              _this6.setState({
                theatresList: response.data.facilities,
                isLoading: false,
                hasMoreTheatres: response.data.hasMoreTheatres
              });
            }
          }
        }).catch(function (error) {});
      } else {
        var spec = 'spec=dci&';

        if (account && account.user.enableNonDCITheatreSearch) {
          spec = '';
        }

        axios.get("".concat(hostUrl, "/").concat(theatreSearchUrl, "?").concat(spec, "offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(searchText), config).then(function (response) {
          if (response.status >= 200 && response.status <= 300) {
            if (searchText.length) {
              _this6.setState({
                theatresList: response.data.theatres,
                isLoading: false,
                hasMoreTheatres: response.data.hasMoreTheatres
              });
            }
          }
        }).catch(function (error) {
          _this6.setState({
            isLoading: false
          });

          handleAppError(error, i18n.t('oops'));
        });
      }
    }
  }, {
    key: "loadMoreTheatres",
    value: function loadMoreTheatres() {
      var _this7 = this;

      var _this$props2 = this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken,
          account = _this$props2.account;
      var _this$state3 = this.state,
          searchText = _this$state3.searchText,
          offset = _this$state3.offset,
          ps = _this$state3.ps;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };
      var spec = 'spec=dci&';

      if (account.user.enableNonDCITheatreSearch) {
        spec = '';
      }

      axios.get("".concat(hostUrl, "/v1/theatres/search?").concat(spec, "offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(searchText), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          _this7.setState({
            theatresList: [].concat(_toConsumableArray$1(_this7.state.theatresList), _toConsumableArray$1(response.data.theatres)),
            hasMoreTheatres: response.data.hasMoreTheatres,
            hasMoreLoading: false
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props3 = this.props,
          addTheatresToBooking = _this$props3.addTheatresToBooking,
          theatresInBooking = _this$props3.theatresInBooking,
          tabType = _this$props3.tabType,
          hostUrl = _this$props3.hostUrl,
          account = _this$props3.account,
          accessToken = _this$props3.accessToken,
          shouldShowUploadCSV = _this$props3.shouldShowUploadCSV,
          mode = _this$props3.mode,
          genericWireTapIcon = _this$props3.genericWireTapIcon;
      var _this$props4 = this.props,
          theatreUrl = _this$props4.theatreUrl,
          showAppBusy = _this$props4.showAppBusy,
          handleAppError = _this$props4.handleAppError;
      var _this$state4 = this.state,
          searchText = _this$state4.searchText,
          isLoading = _this$state4.isLoading,
          theatresList = _this$state4.theatresList,
          hasMoreLoading = _this$state4.hasMoreLoading;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-header"
      }, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: searchText,
        emitEmpty: this.emitEmpty,
        suffix: true,
        error: false,
        searchButton: true,
        placeholder: i18n.t('searchForTheatres'),
        searchClick: this.searchInput,
        onTextChange: this.handleChange
      }), /*#__PURE__*/React__default.createElement(CSVUpload, {
        shouldShowUploadCSV: shouldShowUploadCSV,
        hostUrl: hostUrl,
        accessToken: accessToken,
        account: account,
        genericWireTapIcon: genericWireTapIcon,
        theatreUrl: theatreUrl,
        showAppBusy: showAppBusy,
        handleAppError: handleAppError,
        addTheatresToBooking: addTheatresToBooking
      })), /*#__PURE__*/React__default.createElement("div", {
        id: "theatres-list-overview-scroll",
        className: classNames$1('theatre-selection-card-scroll-view', {
          hiddens: !this.shouldTheatresSectionBeVisible()
        })
      }, /*#__PURE__*/React__default.createElement(Theatres, {
        showTheatreInfo: true,
        showWireTapIcon: mode != 'exhibitor',
        theatres: theatresList,
        isLoading: isLoading,
        addTheatreForBooking: function addTheatreForBooking(list) {
          return _this8.props.addTheatreToBooking(list);
        },
        handleScreenBooking: function handleScreenBooking(theatreIndex, screenIndex, selected, theatre, screen) {
          return _this8.props.handleScreenBooking(theatreIndex, screenIndex, selected, theatre, screen);
        },
        hasMoreLoading: hasMoreLoading,
        tabType: tabType,
        searchedTheatreName: searchText,
        forSearchResults: true,
        theatresInBooking: theatresInBooking,
        mode: mode,
        genericWireTapIcon: genericWireTapIcon,
        withScreenInfo: this.props.withScreenInfo
      })));
    }
  }]);

  return TheatresViewPage;
}(React__default.Component);
TheatresViewPage.defaultProps = {
  shouldShowUploadCSV: true
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime_1 = createCommonjsModule(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

// History related constants

var PENDING_APPROVAL = 'pending approval';
var QUEUED = 'queued';
var SUCCESS = 'success';
var FAILED = 'failed'; // List type

var FESTIVALS = 'festivals';
var THEATRE_LISTS = 'theatreLists'; // CPL/DKDM file identifier
var COMPLETELY_SELECTED = 2;
var PARTIALLY_SELECTED = 1;
var NOT_SELECTED = 0; // Assign Rights DKDM TREX States
var FILE_TYPE_XLSX = '.xlsx';

function _createSuper$B(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$B(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreList = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatreList, _React$Component);

  var _super = _createSuper$B(TheatreList);

  function TheatreList(props) {
    var _this;

    _classCallCheck$1(this, TheatreList);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "getListArray", function (type) {
      var _this$props = _this.props;
          _this$props.listType;
          var handleAppError = _this$props.handleAppError;
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken,
          theatreList = _this$props2.theatreList;
      var config = {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatrelists/").concat(theatreList.id), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            theatreListValue: response.data.theatres,
            theatreLoading: false
          });

          if (type) {
            this.proceedToBooking();
            this.props.fetchingFunction(false);
          }
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        _this.setState({
          theatreLoading: false
        });

        _this.props.fetchingFunction(false);

        handleAppError(error, i18n.t('oops'));
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleAddListToBooking", function () {
      var _this$props3 = _this.props;
          _this$props3.theatreList;
          _this$props3.selected;
          var listViewFetching = _this$props3.listViewFetching;
      var theatreListValue = _this.state.theatreListValue;

      if (!theatreListValue.length) {
        if (!listViewFetching) {
          _this.props.fetchingFunction(true);

          _this.getListArray('select');
        }
      } else {
        _this.proceedToBooking();
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "proceedToBooking", function () {
      var _this$props4 = _this.props;
          _this$props4.theatreList;
          _this$props4.selected;

      var theatresToProcess = _this.getTheatresToProcess();

      _this.props.addTheatreForBooking(theatresToProcess);
    });

    _this.state = {
      hasScreenNotInList: false,
      deleteConfirmation: false,
      hover: false,
      theatreListValue: [],
      theatreLoading: false
    };
    return _this;
  }

  _createClass$1(TheatreList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps, newState) {
      this.setState({
        hasScreenNotInList: this.hasScreenNotInList(newProps)
      });
    }
  }, {
    key: "hasScreenNotInList",
    value: function hasScreenNotInList(props) {
      var theatreList = props.theatreList,
          selected = props.selected,
          theatresInBooking = props.theatresInBooking;
      var screenNotInList = false;
      selected != NOT_SELECTED && theatreList.theatres.forEach(function (theatre) {
        var theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        });

        theatreIndex >= 0 && theatresInBooking[theatreIndex].screens.forEach(function (sc) {
          if (sc.selected && sc.hasOwnProperty('isInList') && !sc.isInList) {
            screenNotInList = true;
          }
        });
      });
      return screenNotInList;
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var theatreListValue = this.state.theatreListValue;
      this.props.toggleExpand(this.props.index);

      if (!theatreListValue.length) {
        this.setState({
          theatreLoading: true
        });
        this.getListArray();
      }
    }
  }, {
    key: "handleEditList",
    value: function handleEditList(e) {
      var theatreList = this.props.theatreList;
      e.stopPropagation();
      this.props.handleEditList(theatreList.id);
    }
  }, {
    key: "getTheatresToProcess",
    value: function getTheatresToProcess() {
      var theatreList = this.props.theatreList;
      var theatreListValue = this.state.theatreListValue;

      var theatresToProcess = _$1.filter(theatreListValue, function (theatre) {
        var mediaBlockCount = 0;

        _$1.forEach(theatre.screens, function (screen) {
          !screen.hasMediaBlock ? mediaBlockCount++ : null;
        });

        return mediaBlockCount !== theatre.screens.length;
      });

      theatresToProcess = theatresToProcess.map(function (th) {
        th.list = theatreList.id;
        th.screensToProcess = _$1.filter(th.screens, function (screen) {
          return screen.isInList;
        });
        th.screensToProcess = _$1.map(th.screensToProcess, function (screen) {
          if (screen.hasMediaBlock) {
            return screen.id;
          } else {
            return null;
          }
        });
        th.screensToProcess = _$1.compact(th.screensToProcess);
        return th;
      });
      return theatresToProcess;
    }
  }, {
    key: "getTheatreCount",
    value: function getTheatreCount() {
      var theatreList = this.props.theatreList;
      return theatreList.theatres.length;
    }
  }, {
    key: "renderEditList",
    value: function renderEditList() {
      var theatreList = this.props.theatreList;
      this.state && theatreList.id === this.state.deleteConfirmation;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          cursor: 'pointer',
          paddingLeft: 8,
          display: 'flex'
        },
        onClick: this.handleEditList.bind(this)
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: 'ListEdit',
        size: 20
      }));
    }
  }, {
    key: "renderTheatres",
    value: function renderTheatres() {
      var _this$props5 = this.props,
          tabType = _this$props5.tabType,
          handleScreenBooking = _this$props5.handleScreenBooking;
      var _this$state = this.state,
          theatreListValue = _this$state.theatreListValue,
          theatreLoading = _this$state.theatreLoading;

      if (this.props.expand) {
        if (!theatreLoading) {
          return /*#__PURE__*/React__default.createElement(Theatres, {
            showTheatreInfo: true,
            theatres: theatreListValue,
            addTheatreForBooking: this.props.addTheatreForBooking,
            removeTheatresFromBooking: this.props.removeTheatresFromBooking,
            theatresInBooking: this.props.theatresInBooking,
            listView: true,
            tabType: tabType,
            handleScreenBooking: handleScreenBooking
          });
        } else {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "theatre-list-view-loader"
          }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
            style: {
              fontSize: 24,
              color: '#084782'
            },
            spin: true
          }));
        }
      } else {
        return /*#__PURE__*/React__default.createElement("div", null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          type = _this$props6.type,
          theatreList = _this$props6.theatreList;
      return /*#__PURE__*/React__default.createElement(ListCard, {
        name: theatreList && theatreList.name,
        theatreCount: i18n.t('theatreCount', {
          count: this.getTheatreCount()
        }),
        selected: this.props.selected,
        expandInfo: this.props.expand,
        theatreList: this.props.theatreList,
        theatresInBooking: this.props.theatresInBooking,
        partiallySelected: this.props.partiallySelected,
        handleAddListToBooking: this.handleAddListToBooking.bind(this),
        renderEditView: type === THEATRE_LISTS && this.renderEditList(),
        onToggle: function onToggle() {
          return _this2.toggleExpand();
        }
      }, this.renderTheatres());
    }
  }]);

  return TheatreList;
}(React__default.Component);

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HEIGHT_OFFSET_FROM_VIEW_BOTTOM$1 = 120; // In pixels

var TheatreLists = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatreLists, _React$Component);

  var _super = _createSuper$A(TheatreLists);

  function TheatreLists(props) {
    var _this;

    _classCallCheck$1(this, TheatreLists);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "toggleListExpand", function (index, addListToBooking, operation) {
      _this.props.type;
      var expandInfo = {};

      if (!addListToBooking) {
        if (index === _this.state.expandInfo.index) {
          expandInfo = {
            index: index,
            status: !_this.state.expandInfo.status
          };
        } else {
          expandInfo = {
            index: index,
            status: !addListToBooking
          };
        }

        _this.setState({
          expandInfo: expandInfo
        });
      }
    });

    _this.state = {
      expandInfo: {
        index: 0,
        status: false
      }
    };
    return _this;
  }

  _createClass$1(TheatreLists, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextState) {
      if (_$1.isEmpty(nextProps.theatreLists)) {
        this.setState({
          expandInfo: {
            index: 0,
            status: false
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadTheatreLists ? this.props.loadTheatreLists() : null;
    }
  }, {
    key: "getExpandListToggleStatus",
    value: function getExpandListToggleStatus(index) {
      if (this.props.appError) {
        this.state.expandInfo.status = false;
      }

      if (index === this.state.expandInfo.index) {
        return this.state.expandInfo.status;
      } else {
        return false;
      }
    }
  }, {
    key: "_renderTheatreLists",
    value: function _renderTheatreLists() {
      var _this2 = this;

      var _this$props = this.props,
          theatreLists = _this$props.theatreLists,
          theatresInBooking = _this$props.theatresInBooking,
          addTheatreForBooking = _this$props.addTheatreForBooking,
          removeTheatresFromBooking = _this$props.removeTheatresFromBooking,
          handleEditList = _this$props.handleEditList,
          deleteList = _this$props.deleteList,
          tabType = _this$props.tabType,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken,
          fetchingFunction = _this$props.fetchingFunction,
          listViewFetching = _this$props.listViewFetching,
          handleScreenBooking = _this$props.handleScreenBooking,
          handleAppError = _this$props.handleAppError;
      return (theatreLists || []).map(function (theatreList, index) {
        var theatreIds = _$1.map(theatreList.theatres, 'id');

        var selected = NOT_SELECTED;
        var partiallySelectedCount = 0; // Proceed to check whether this theatre list is in the booking list only if this theatre has screens info
        // i.e it should have been expanded to get the screens list

        if (theatreList.hasInfo) {
          var selectedTheatresInList = _$1.filter(theatresInBooking, function (th) {
            var thisTheatre = _$1.find(theatreList.theatres, function (theatre) {
              return theatre.id === th.id;
            });

            var screensToProcess = null;

            if (thisTheatre) {
              screensToProcess = _$1.filter(thisTheatre.screens, function (screen) {
                return screen.isInList;
              });
            } //Iterate through the booking state to add the isInList property
            //if the screen does not have the key


            if (screensToProcess && screensToProcess.length > 0) {
              th.screens = th.screens.map(function (sc) {
                var isInList = _$1.findIndex(screensToProcess, function (scToProcess) {
                  return scToProcess.id === sc.id;
                });

                sc['isInList'] = isInList > -1;
                return sc;
              });
            }

            var screensInBooking = th.screens.filter(function (screen) {
              return screen.selected;
            });

            if (thisTheatre && !_$1.isEmpty(_$1.difference(_$1.map(screensToProcess, 'id'), _$1.map(screensInBooking, 'id')))) {
              partiallySelectedCount += 1;
            }

            return thisTheatre;
          });

          if (selectedTheatresInList.length === theatreIds.length && selectedTheatresInList.length > 0 && partiallySelectedCount === 0) {
            selected = COMPLETELY_SELECTED;
          } else if (selectedTheatresInList.length > 0 && selectedTheatresInList.length < theatreIds.length || partiallySelectedCount > 0) {
            selected = PARTIALLY_SELECTED;
          }
        }

        return /*#__PURE__*/React__default.createElement(TheatreList, {
          key: theatreList.id + 'theatre-list',
          index: index,
          listViewFetching: listViewFetching,
          selected: selected,
          partiallySelected: partiallySelectedCount,
          theatreList: theatreList,
          type: _this2.props.type,
          listType: _this2.props.listType,
          handleAppError: handleAppError,
          theatresInBooking: theatresInBooking,
          toggleExpand: _this2.toggleListExpand,
          expand: _this2.getExpandListToggleStatus(index),
          addTheatreForBooking: addTheatreForBooking,
          handleEditList: handleEditList,
          deleteList: deleteList,
          tabType: tabType,
          removeTheatresFromBooking: removeTheatresFromBooking,
          hostUrl: hostUrl,
          accessToken: accessToken,
          fetchingFunction: fetchingFunction,
          handleScreenBooking: handleScreenBooking
        });
      });
    }
  }, {
    key: "renderNoListsFoundMessage",
    value: function renderNoListsFoundMessage() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "empty-list-text"
      }, i18n.t('noListsFound'));
    }
  }, {
    key: "renderSearchInProgress",
    value: function renderSearchInProgress(isLoading) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-loader",
        style: {
          height: window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM$1 + 'px'
        }
      }, /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 24
        },
        spin: true
      }));
    }
  }, {
    key: "renderTheatreLists",
    value: function renderTheatreLists() {
      var _this$props2 = this.props,
          isLoading = _this$props2.isLoading,
          type = _this$props2.type,
          fetchMoreLoading = _this$props2.fetchMoreLoading;

      if (type === 'festivals') {
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            height: window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM$1,
            overflowY: 'scroll'
          }
        }, this._renderTheatreLists(), isLoading && this.renderLoading());
      } else {
        return /*#__PURE__*/React__default.createElement("div", null, this._renderTheatreLists(), fetchMoreLoading && this.renderLoading());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          theatreLists = _this$props3.theatreLists,
          isLoading = _this$props3.isLoading;

      if (!theatreLists || theatreLists.length === 0) {
        if (!isLoading) {
          return this.renderNoListsFoundMessage();
        } else {
          return this.renderSearchInProgress(isLoading);
        }
      } else {
        return this.renderTheatreLists();
      }
    }
  }]);

  return TheatreLists;
}(React__default.Component);

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var initialState = {
  listName: '',
  theatreList: [],
  listObject: null,
  theatresInBooking: []
};

var EditTheatreList = /*#__PURE__*/function (_React$Component) {
  _inherits$1(EditTheatreList, _React$Component);

  var _super = _createSuper$z(EditTheatreList);

  function EditTheatreList(props) {
    var _this;

    _classCallCheck$1(this, EditTheatreList);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "addTheatreToList", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(item) {
        var tempTheatre, screenInTheatreListCount, theatreList, theatresInBooking, theatreIndex;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tempTheatre = item[0];
                screenInTheatreListCount = 0;
                tempTheatre.screens.forEach(function (item) {
                  if (item.isInList) {
                    screenInTheatreListCount += 1;
                  }
                });

                if (screenInTheatreListCount) {
                  tempTheatre.screens.forEach(function (item) {
                    return item['isInList'] = false;
                  });
                } else {
                  tempTheatre.screens.forEach(function (item) {
                    return item['isInList'] = true;
                  });
                }

                theatreList = _this.state.theatreList.map(function (theatre) {
                  if (theatre.id === tempTheatre.id) {
                    return tempTheatre;
                  } else {
                    return theatre;
                  }
                });
                theatresInBooking = _this.state.theatresInBooking.map(function (theatre) {
                  if (theatre.id === tempTheatre.id) {
                    return tempTheatre;
                  } else {
                    return theatre;
                  }
                });
                theatreIndex = _this.state.theatresInBooking.findIndex(function (item) {
                  return item.id === tempTheatre.id;
                });

                if (theatreIndex > -1) {
                  theatresInBooking.splice(theatreIndex, 1);
                } else {
                  theatresInBooking.push(tempTheatre);
                }

                _this.setState({
                  theatreList: theatreList,
                  theatresInBooking: theatresInBooking
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty$1(_assertThisInitialized(_this), "updateTheatreScreenToList", function (theatreIndex, screenIndex, isInList, theatre, screen) {
      var theatreList = _$1.cloneDeep(_this.state.theatreList);

      var theatresInBooking = _$1.cloneDeep(_this.state.theatresInBooking);

      if (_$1.isEmpty(theatresInBooking)) {
        theatresInBooking.push(theatreList[theatreIndex]);
      }

      if (theatreList && theatreList[theatreIndex]) {
        theatreList[theatreIndex].screens[screenIndex].isInList = !isInList;
      }

      if (theatresInBooking && theatresInBooking[theatreIndex]) {
        theatresInBooking[theatreIndex].screens[screenIndex].isInList = !isInList;
      }

      var isScreenInTheatreList = 0;
      theatresInBooking && theatresInBooking[theatreIndex] && theatresInBooking[theatreIndex].screens.forEach(function (item) {
        if (item.isInList) {
          isScreenInTheatreList += 1;
        }
      });

      if (!isScreenInTheatreList) {
        theatresInBooking.splice(theatreIndex, 1);
      }

      _this.setState({
        theatreList: theatreList,
        theatresInBooking: theatresInBooking
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "editList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.editTheatreList(_this.state);

            case 2:
              _this.setState(initialState);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    var list = _this.props.list;
    _this.state = {
      listName: list && list.name,
      theatreList: list && list.theatres,
      listObject: list,
      theatresInBooking: list && list.theatres
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.addTheatreToList = _this.addTheatreToList.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(EditTheatreList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!_$1.isEqual(this.props.list, prevProps.list)) {
        var list = this.props.list;
        this.setState({
          listName: list && list.name,
          theatreList: list && list.theatres,
          listObject: list,
          theatresInBooking: list && list.theatres
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        listName: e.target.value
      });
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 24
        },
        spin: true
      }));
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this$props = this.props,
          list = _this$props.list;
          _this$props.handleScreenBooking;

      _$1.compact(list.theatres.map(function (theatre) {
        var screensInList = theatre.screens && theatre.screens.filter(function (screen) {
          return screen.isInList;
        });
        return screensInList && screensInList.length > 0 ? theatre : null;
      }));

      var _this$state = this.state,
          listName = _this$state.listName,
          theatreList = _this$state.theatreList;
          _this$state.theatresInBooking;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: listName,
        suffix: false,
        searchButton: false,
        error: false,
        style: {
          height: 35
        },
        placeholder: i18n.t('enterNameOfList'),
        onTextChange: this.handleChange
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          maxHeight: 300,
          overflow: 'auto'
        }
      }, /*#__PURE__*/React__default.createElement(Theatres, {
        editListView: true,
        edit: true,
        theatres: theatreList,
        theatresInBooking: theatreList,
        addTheatreForBooking: this.addTheatreToList,
        handleScreenBooking: this.updateTheatreScreenToList
      })));
    }
  }, {
    key: "renderActionButtons",
    value: function renderActionButtons() {
      var _this2 = this;

      var _this$props2 = this.props,
          list = _this$props2.list,
          cancel = _this$props2.cancel,
          deleteList = _this$props2.deleteList;
      var _this$state2 = this.state,
          theatreList = _this$state2.theatreList,
          listName = _this$state2.listName; // let disabled = (list && list.errors && list.errors.name.self) ? true : false

      var isAtleastOneScreenInList = false;
      theatreList && theatreList.every(function (theatre) {
        return theatre.screens.every(function (screen) {
          if (screen.isInList) {
            isAtleastOneScreenInList = true;
            return false;
          }

          return true;
        });
      });
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '8px 0px 0px'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: 'delete-text',
        onClick: function onClick() {
          return deleteList(list);
        }
      }, i18n.t('delete')), /*#__PURE__*/React__default.createElement(SecondaryButton, {
        btnName: i18n.t('cancel'),
        callbackAction: function callbackAction() {
          return cancel();
        },
        style: {
          margin: '0px 8px'
        }
      }), /*#__PURE__*/React__default.createElement(PrimaryButton, {
        disabled: listName && !listName.length || !isAtleastOneScreenInList,
        btnName: i18n.t('save'),
        callbackAction: function callbackAction() {
          return _this2.editList();
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var list = this.props.list;
      return /*#__PURE__*/React__default.createElement("div", null, !list ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: 75,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, this.renderLoader()) : /*#__PURE__*/React__default.createElement("div", null, list && this.renderList(), this.renderActionButtons()));
    }
  }]);

  return EditTheatreList;
}(React__default.Component);

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditTheatreListModal = /*#__PURE__*/function (_React$Component) {
  _inherits$1(EditTheatreListModal, _React$Component);

  var _super = _createSuper$y(EditTheatreListModal);

  function EditTheatreListModal(props) {
    var _this;

    _classCallCheck$1(this, EditTheatreListModal);

    _this = _super.call(this, props);
    _this.state = {
      open: _this.props.open
    };
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(EditTheatreListModal, [{
    key: "handleOpen",
    value: function handleOpen() {
      this.props.handleEditOpen();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.resetTheatreList();
    }
  }, {
    key: "showEditTheatreListModal",
    value: function showEditTheatreListModal(theatreList) {
      this.setState({
        theatreList: theatreList
      });
      this.handleOpen();
    }
  }, {
    key: "handleSaveList",
    value: function handleSaveList() {
      this.props.handleEditOpen();
      this.props.saveList();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.theatreList;
          var theatreLists = _this$props.theatreLists;
          _this$props.saveList;
          var updateTheatreListName = _this$props.updateTheatreListName,
          addTheatreToList = _this$props.addTheatreToList,
          editTheatreList = _this$props.editTheatreList,
          handleScreenBooking = _this$props.handleScreenBooking;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: i18n.t('editTheatreList'),
        wrapClassName: "vertical-center-modal",
        visible: this.props.open,
        footer: null,
        onCancel: this.props.handleEditOpen,
        width: 600
      }, /*#__PURE__*/React__default.createElement(EditTheatreList, {
        list: theatreLists,
        saveList: this.handleSaveList.bind(this),
        cancel: this.props.handleEditOpen,
        updateListName: updateTheatreListName,
        addTheatreToList: addTheatreToList,
        deleteList: this.props.deleteList,
        editTheatreList: editTheatreList,
        handleScreenBooking: handleScreenBooking
      }));
    }
  }]);

  return EditTheatreListModal;
}(React__default.Component);

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// let source = CancelToken.source()

var ListsViewPage = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ListsViewPage, _React$Component);

  var _super = _createSuper$x(ListsViewPage);

  function ListsViewPage(props) {
    var _this;

    _classCallCheck$1(this, ListsViewPage);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "getLists", function () {
      var _this$state = _this.state,
          offset = _this$state.offset,
          ps = _this$state.ps,
          searchText = _this$state.searchText;
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken;
      var config = {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatres/lists?offset=").concat(offset, "&ps=").concat(ps, "&sortBy=accessed_on|desc&q=").concat(searchText), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            listArray: response.data.theatreLists,
            totalList: response.data.totalCount,
            loading: false
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty$1(_assertThisInitialized(_this), "fetchMoreList", function () {
      var _this$state2 = _this.state,
          offset = _this$state2.offset,
          ps = _this$state2.ps,
          searchText = _this$state2.searchText;
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken;
      var config = {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatres/lists?offset=").concat(offset, "&ps=").concat(ps, "&sortBy=accessed_on|desc&q=").concat(searchText), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          var tempArray = [].concat(_toConsumableArray$1(this.state.listArray), _toConsumableArray$1(response.data.theatreLists));
          this.setState({
            listArray: tempArray,
            totalList: response.data.totalCount,
            fetchMoreLoading: false
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleEditOpen", function () {
      _this.setState({
        editOpen: false,
        editListTheatres: null
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleEditList", function (theatreList) {
      _this.setState({
        editOpen: true
      }, function () {
        return _this.fetchListTheatres(theatreList);
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "fetchListTheatres", function (theatreList) {
      var _this$props3 = _this.props,
          hostUrl = _this$props3.hostUrl,
          accessToken = _this$props3.accessToken,
          handleAppError = _this$props3.handleAppError;
      var config = {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      };

      _this.setState({
        editListTheatres: null
      });

      axios.get("".concat(hostUrl, "/v1/theatrelists/").concat(theatreList), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            editListTheatres: response.data
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        this.setState({
          editOpen: false
        });
        handleAppError(error, i18n.t('oops'));
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty$1(_assertThisInitialized(_this), "editTheatreList", function (state) {
      var listName = state.listName;
          state.listObject;
          var theatresInBooking = state.theatresInBooking;
      var data = state.listObject;
      var selectedTheatres = theatresInBooking && theatresInBooking.map(function (item) {
        var screens = item.screens.filter(function (screen) {
          return screen.isInList;
        });
        return {
          id: item.id,
          screens: screens.map(function (screen) {
            return screen.id;
          })
        };
      });
      data['name'] = listName;
      data['theatres'] = selectedTheatres;

      _this.setState({
        editOpen: false,
        loading: true,
        listArray: [],
        offset: 0
      }, function () {
        return _this.updateTheatreList(data);
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "updateTheatreList", function (data) {
      var _this$props4 = _this.props,
          hostUrl = _this$props4.hostUrl,
          accessToken = _this$props4.accessToken;
      var config = {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      };
      axios.put("".concat(hostUrl, "/v1/theatrelists/").concat(data.id), data, config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          SuccessMessage(i18n.t('theatresListUpdated'));
          this.getLists();
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        if (error.status == 400) {
          ErrorMessage(error.data.message);
        }

        this.getLists();
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty$1(_assertThisInitialized(_this), "deleteListItem", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var deleteID;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              deleteID = _this.state.deleteID;
              _context.next = 3;
              return _this.props.deteteTheatreList(deleteID, _this.handleDeleteClose);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      searchText: '',
      deleteModal: false,
      editModal: false,
      disableView: false,
      offset: 0,
      ps: 10,
      loading: true,
      totalList: null,
      listArray: [],
      fetchMoreLoading: false,
      editListTheatres: null,
      editingLoader: false
    }; // this.emitEmpty = this.emitEmpty.bind(this);
    // this.searchInput = this.searchInput.bind(this);

    _this.getLists = _this.getLists.bind(_assertThisInitialized(_this));
    _this.getLists = _.debounce(_this.getLists, 1000);
    _this.theatreListScroll = _this.theatreListScroll.bind(_assertThisInitialized(_this));
    _this.handleDeleteClose = _this.handleDeleteClose.bind(_assertThisInitialized(_this));
    _this.deleteListItem = _this.deleteListItem.bind(_assertThisInitialized(_this));
    _this.editTheatreList = _this.editTheatreList.bind(_assertThisInitialized(_this));
    _this.clickedOutside = _this.clickedOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(ListsViewPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.clickedOutside);

      if (document.getElementById('theatres-screen-lists-overview-scroll')) {
        document.getElementById('theatres-screen-lists-overview-scroll').addEventListener('scroll', this.theatreListScroll, true);
      }

      this.getLists();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // source.cancel('Operation canceled by the user.');
      document.getElementById('theatres-screen-lists-overview-scroll').removeEventListener('scroll', this.theatreListScroll);
      document.removeEventListener('mousedown', this.clickedOutside, true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps, newState) {
      var _this2 = this;

      var refetchListView = newProps.refetchListView,
          listRefetching = newProps.listRefetching;

      if (refetchListView) {
        listRefetching(false);
        this.setState({
          listArray: [],
          offset: 0,
          loading: true
        }, function () {
          return _this2.getLists();
        });
      }
    }
  }, {
    key: "clickedOutside",
    value: function clickedOutside(event) {
      if (this.wrapperModalRef && !this.wrapperModalRef.contains(event.target)) {
        this.setState({
          deleteModal: false
        });
      }
    }
  }, {
    key: "setWrapperModalRef",
    value: function setWrapperModalRef(node) {
      if (node) {
        this.wrapperModalRef = node;
      }
    }
  }, {
    key: "theatreListScroll",
    value: function theatreListScroll() {
      var _this3 = this;

      var _this$state3 = this.state,
          loading = _this$state3.loading,
          totalList = _this$state3.totalList,
          listArray = _this$state3.listArray,
          fetchMoreLoading = _this$state3.fetchMoreLoading;

      if (!loading) {
        var scrollElem = document.getElementById('theatres-screen-lists-overview-scroll');

        if (scrollElem) {
          if (Math.ceil(scrollElem.scrollHeight - scrollElem.scrollTop) == scrollElem.clientHeight) {
            if (listArray.length < totalList && !fetchMoreLoading) {
              this.setState({
                offset: this.state.offset + 10,
                fetchMoreLoading: true
              }, function () {
                return _this3.fetchMoreList();
              });
            }
          }
        }
      }
    }
  }, {
    key: "deleteList",
    value: function deleteList(list) {
      this.setState({
        deleteID: list.id,
        deleteModal: true,
        editOpen: false
      });
    }
  }, {
    key: "handleDeleteClose",
    value: function handleDeleteClose() {
      this.setState({
        deleteModal: false
      });
    }
  }, {
    key: "renderEditTheatreListModal",
    value: function renderEditTheatreListModal() {
      var _this4 = this;

      var _this$props5 = this.props,
          updateTheatreListName = _this$props5.updateTheatreListName,
          theatreList = _this$props5.theatreList,
          resetTheatreList = _this$props5.resetTheatreList,
          saveList = _this$props5.saveList,
          addTheatreToList = _this$props5.addTheatreToList,
          removeTheatreFromList = _this$props5.removeTheatreFromList,
          editModal = _this$props5.editModal,
          handleScreenBooking = _this$props5.handleScreenBooking;
      var editListTheatres = this.state.editListTheatres;
      return /*#__PURE__*/React__default.createElement(EditTheatreListModal, {
        theatreList: theatreList,
        theatreLists: editListTheatres,
        open: this.state.editOpen,
        saveList: saveList,
        editModal: editModal,
        addTheatreToList: addTheatreToList,
        editTheatreList: this.editTheatreList,
        removeTheatreFromList: removeTheatreFromList,
        resetTheatreList: resetTheatreList,
        deleteList: this.deleteList.bind(this),
        handleEditOpen: function handleEditOpen() {
          return _this4.handleEditOpen();
        },
        updateTheatreListName: updateTheatreListName,
        handleScreenBooking: handleScreenBooking
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        searchText: e.target.value,
        theatresList: []
      });

      if (e.target.value.length > 2) {
        this.setState({
          loading: true,
          offset: 0
        });
        this.getLists();
      } else if (e.target.value.length == 0) {
        this.setState({
          loading: true,
          offset: 0
        });
        this.getLists();
      } else {
        this.setState({
          listArray: [],
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props6 = this.props;
          _this$props6.theatreLists;
          var theatresInBooking = _this$props6.theatresInBooking,
          addTheatreForBooking = _this$props6.addTheatreForBooking,
          removeTheatresFromBooking = _this$props6.removeTheatresFromBooking,
          deleteList = _this$props6.deleteList,
          tabType = _this$props6.tabType,
          hostUrl = _this$props6.hostUrl,
          accessToken = _this$props6.accessToken,
          fetchingFunction = _this$props6.fetchingFunction,
          listViewFetching = _this$props6.listViewFetching,
          handleScreenBooking = _this$props6.handleScreenBooking,
          listPosting = _this$props6.listPosting,
          handleAppError = _this$props6.handleAppError;
      var _this$state4 = this.state,
          deleteModal = _this$state4.deleteModal,
          loading = _this$state4.loading,
          listArray = _this$state4.listArray,
          fetchMoreLoading = _this$state4.fetchMoreLoading,
          searchText = _this$state4.searchText;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "list-theatre-searchBox"
      }, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: searchText,
        suffix: true,
        error: false,
        placeholder: i18n.t('searchForTheatreList'),
        onTextChange: this.handleChange.bind(this)
      })), /*#__PURE__*/React__default.createElement("div", {
        id: "theatres-screen-lists-overview-scroll",
        className: 'theatre-selection-card-list-scroll-view'
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-list-container"
      }, /*#__PURE__*/React__default.createElement(TheatreLists, {
        theatreLists: listArray,
        isLoading: loading,
        fetchMoreLoading: fetchMoreLoading,
        listType: 'theatre_lists',
        type: THEATRE_LISTS,
        hostUrl: hostUrl,
        fetchingFunction: fetchingFunction,
        handleAppError: handleAppError,
        accessToken: accessToken,
        loadTheatreLists: this.props.loadTheatreLists,
        expandList: this.props.expandList,
        theatresInBooking: theatresInBooking,
        addTheatreForBooking: addTheatreForBooking,
        handleEditList: this.handleEditList.bind(this),
        deleteList: deleteList,
        tabType: tabType,
        listViewFetching: listViewFetching,
        removeTheatresFromBooking: removeTheatresFromBooking,
        appError: this.props.appError,
        handleScreenBooking: handleScreenBooking
      })), this.renderEditTheatreListModal(), deleteModal && /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(node) {
          return _this5.setWrapperModalRef(node);
        }
      }, /*#__PURE__*/React__default.createElement(DeleteModal, {
        deleteFunction: this.deleteListItem,
        cancelFunction: this.handleDeleteClose,
        heading: i18n.t('deleteList'),
        content: i18n.t('deleteListConfirmation'),
        cancelText: i18n.t('noKeepList'),
        deleteText: i18n.t('yesDelete'),
        listPosting: listPosting
      }))));
    }
  }]);

  return ListsViewPage;
}(React__default.Component);

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FestivalsView = /*#__PURE__*/function (_React$Component) {
  _inherits$1(FestivalsView, _React$Component);

  var _super = _createSuper$w(FestivalsView);

  function FestivalsView(props) {
    var _this;

    _classCallCheck$1(this, FestivalsView);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "fetchFestivals", function () {
      var _this$state = _this.state;
          _this$state.offset;
          _this$state.ps;
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken;
      var config = {
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/festivals?includeOwnerList=true"), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          var festivals = response.data.festivals || [];
          var sortedFestivals = festivals.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          });
          this.setState({
            festivalArray: sortedFestivals,
            loading: false
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _this.state = {
      loading: true,
      festivalArray: [],
      searchText: ''
    };
    return _this;
  }

  _createClass$1(FestivalsView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchFestivals();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.festivals;
          _this$props2.loadingFestivals;
          var theatresInBooking = _this$props2.theatresInBooking;
          _this$props2.expandFestivals;
          var addTheatreForBooking = _this$props2.addTheatreForBooking;
          _this$props2.removeTheatresFromBooking;
          var tabType = _this$props2.tabType,
          accessToken = _this$props2.accessToken,
          hostUrl = _this$props2.hostUrl,
          fetchingFunction = _this$props2.fetchingFunction,
          handleScreenBooking = _this$props2.handleScreenBooking,
          handleAppError = _this$props2.handleAppError;
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          festivalArray = _this$state2.festivalArray,
          searchText = _this$state2.searchText;
      var filteredFestivals = festivalArray.filter(function (item) {
        return item.name.toLowerCase().includes(searchText.toLowerCase());
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "list-theatre-searchBox"
      }, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: searchText,
        suffix: true,
        error: false,
        placeholder: i18n.t('searchFilmFestival'),
        onTextChange: function onTextChange(e) {
          return _this2.setState({
            searchText: e.target.value
          });
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {
          padding: '0px 16px'
        },
        className: "festival-list-container"
      }, /*#__PURE__*/React__default.createElement(TheatreLists, {
        isLoading: loading,
        theatreLists: filteredFestivals,
        type: FESTIVALS,
        expandList: this.props.expandList,
        tabType: tabType,
        listType: 'festivals_lists',
        accessToken: accessToken,
        hostUrl: hostUrl,
        handleAppError: handleAppError,
        theatresInBooking: theatresInBooking,
        fetchingFunction: fetchingFunction,
        addTheatreForBooking: addTheatreForBooking,
        handleScreenBooking: handleScreenBooking
      })));
    }
  }]);

  return FestivalsView;
}(React__default.Component);

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CreateList = /*#__PURE__*/function (_React$Component) {
  _inherits$1(CreateList, _React$Component);

  var _super = _createSuper$v(CreateList);

  function CreateList(props) {
    var _this;

    _classCallCheck$1(this, CreateList);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleSave", function () {
      _this.props.createNewList(_this.state.listName);
    });

    _this.state = {
      listName: _this.props.listName
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(CreateList, [{
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        listName: e.target.value
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2._input.focus();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          visible = _this$props.visible,
          loading = _this$props.loading,
          errors = _this$props.errors;
      var listName = this.state.listName;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: i18n.t('addToNewList'),
        wrapClassName: "vertical-center-modal modal-medium",
        visible: visible,
        onCancel: this.props.handleClose,
        footer: [/*#__PURE__*/React__default.createElement(_Button, {
          key: "back",
          size: "large",
          onClick: this.props.handleClose,
          disabled: loading,
          className: "cancel-btn"
        }, i18n.t('cancel')), /*#__PURE__*/React__default.createElement(_Button, {
          key: "submit",
          type: "primary",
          size: "large",
          loading: loading,
          onClick: this.handleSave,
          disabled: listName.length < 1
        }, i18n.t('create'))]
      }, /*#__PURE__*/React__default.createElement(InputLabel, {
        content: i18n.t('listName')
      }), /*#__PURE__*/React__default.createElement(_Input, {
        ref: function ref(c) {
          return _this3._input = c;
        },
        size: "large",
        placeholder: i18n.t('enterNameOfNewList'),
        value: listName,
        onChange: this.handleChange,
        autoComplete: "off",
        onPressEnter: this.handleSave
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "input-meta__data"
      }, errors && /*#__PURE__*/React__default.createElement(HelpText, {
        isErrorMessage: true,
        content: errors
      })));
    }
  }]);

  return CreateList;
}(React__default.Component);

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// import 'antd/dist/antd.less';
var CreateListModal = /*#__PURE__*/function (_React$Component) {
  _inherits$1(CreateListModal, _React$Component);

  var _super = _createSuper$u(CreateListModal);

  function CreateListModal(props) {
    var _this;

    _classCallCheck$1(this, CreateListModal);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleClose", function () {
      var listPosting = _this.props.listPosting;

      if (!listPosting) {
        _this.props.closeAddToNewList();
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "createNewList", function (name) {
      _this.props.createTheatreList(name);
    });

    return _this;
  }

  _createClass$1(CreateListModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          listError = _this$props.listError,
          open = _this$props.open,
          listPosting = _this$props.listPosting;
      return /*#__PURE__*/React__default.createElement(CreateList, {
        listName: "",
        visible: open,
        loading: listPosting,
        errors: listError,
        handleClose: this.handleClose,
        createNewList: this.createNewList
      });
    }
  }]);

  return CreateListModal;
}(React__default.Component);

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HEIGHT_OFFSET_FROM_VIEW_BOTTOM = 170; // In pixels

var MODE = 'selected';

var SelectedTheatres = /*#__PURE__*/function (_React$Component) {
  _inherits$1(SelectedTheatres, _React$Component);

  var _super = _createSuper$t(SelectedTheatres);

  function SelectedTheatres(props) {
    var _this;

    _classCallCheck$1(this, SelectedTheatres);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleAddToNewList", function () {
      _this.props.createListModalOpen(true);
    });

    _defineProperty$1(_assertThisInitialized(_this), "closeAddToNewList", function () {
      _this.props.createListModalOpen(false);
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleAddToTheatreList", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(list) {
        var _this$props, theatres, selectedTheatres;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, theatres = _this$props.theatres;
                selectedTheatres = theatres;
                _context.next = 4;
                return selectedTheatres.forEach(function (selectedTheatre) {
                  var theatreIndex = _$1.findIndex(list.theatres, function (th) {
                    return th.id == selectedTheatre.id;
                  });

                  if (theatreIndex != -1 && list.theatres[theatreIndex].screens) {
                    selectedTheatre.screens.forEach(function (screen) {
                      if (screen.selected && !_$1.find(list.theatres[theatreIndex].screens, function (sc) {
                        return sc === screen.id;
                      })) {
                        list.theatres[theatreIndex].screens.push(screen.id);
                      }
                    });
                  } else if (theatreIndex == -1) {
                    var object = {
                      id: selectedTheatre.id
                    };

                    var screens = _$1.filter(selectedTheatre.screens, 'selected');

                    screens = screens.map(function (screen) {
                      return screen.id;
                    });

                    if (screens.length != selectedTheatre.screens.length) {
                      object.screens = screens;
                    }

                    list.theatres.push(object);
                  }
                });

              case 4:
                _this.updateTheatreLists(list);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty$1(_assertThisInitialized(_this), "updateTheatreLists", function (list) {
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl;
          _this$props2.accessToken;
          var listRefetching = _this$props2.listRefetching;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(_this.props.accessToken)
        }
      };

      _this.setState({
        loading: true
      });

      axios.put("".concat(hostUrl, "/v1/theatrelists/").concat(list.id), list, config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          _this.setState({
            loading: false
          });

          listRefetching(true);
          SuccessMessage(i18n.t('listUpdated'));
        }
      }).catch(function (error) {
        this.setState({
          loading: false
        });
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _this.state = {
      searchText: '',
      createModal: false,
      loading: false
    };
    return _this;
  }

  _createClass$1(SelectedTheatres, [{
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      this.setState({
        searchText: value
      });
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-loader",
        style: {
          height: "".concat(window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM, "px")
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      }));
    }
  }, {
    key: "renderCreateListModal",
    value: function renderCreateListModal() {
      this.props.createListModal;
      return /*#__PURE__*/React__default.createElement(CreateListModal, {
        open: this.props.createListModal,
        newListName: this.props.newListName,
        closeAddToNewList: this.closeAddToNewList,
        errors: this.props.errors,
        createNewList: this.props.createNewList,
        updateListName: this.props.updateListName,
        resetValidation: this.props.resetValidation,
        createTheatreList: this.props.createTheatreList,
        listPosting: this.props.listPosting,
        listError: this.props.listError
      });
    }
  }, {
    key: "areTheatresSelected",
    value: function areTheatresSelected() {
      if (this.props.theatres) {
        return this.props.theatres.length > 0;
      }
    }
  }, {
    key: "renderTitleSection",
    value: function renderTitleSection() {
      var _this2 = this;

      var _this$props3 = this.props,
          hostUrl = _this$props3.hostUrl,
          accessToken = _this$props3.accessToken,
          mode = _this$props3.mode;
      return /*#__PURE__*/React__default.createElement(SelectedHeader, {
        title: i18n.t('selectedTheatres'),
        areTheatresSelected: this.areTheatresSelected(),
        addToItem: function addToItem(list) {
          return _this2.handleAddToTheatreList(list);
        },
        onChangeView: this.props.onChangeView,
        handleAddToNewItem: this.handleAddToNewList,
        hostUrl: hostUrl,
        accessToken: accessToken,
        clearTheatreList: this.props.clearTheatreList,
        hasList: mode !== 'exhibitor'
      });
    }
  }, {
    key: "renderNoTheatresSelectedSection",
    value: function renderNoTheatresSelectedSection() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selected-center-view"
      }, i18n.t('noTheatresAreSelected'));
    }
  }, {
    key: "renderSelectedTheatresSection",
    value: function renderSelectedTheatresSection() {
      var listViewFetching = this.props.listViewFetching;

      if (listViewFetching || this.state.loading) {
        return this.renderLoader();
      }

      if (this.areTheatresSelected()) {
        return this._renderSelectedTheatresSection();
      }

      return this.renderNoTheatresSelectedSection();
    }
  }, {
    key: "_renderSelectedTheatresSection",
    value: function _renderSelectedTheatresSection() {
      var _this3 = this;

      var _this$props4 = this.props;
          _this$props4.theatres;
          var addTheatreForBooking = _this$props4.addTheatreForBooking;
          _this$props4.removeTheatresFromBooking;
          var handleScreenBooking = _this$props4.handleScreenBooking,
          mode = _this$props4.mode,
          genericWireTapIcon = _this$props4.genericWireTapIcon;
      var filteredData = this.props.theatres.filter(function (theatre) {
        return theatre.name.toLowerCase().includes(_this3.state.searchText.toLowerCase());
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-list",
        style: {
          height: "".concat(window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM, "px"),
          // overflow: 'scroll',
          padding: '0px 12px'
        }
      }, /*#__PURE__*/React__default.createElement(Theatres, {
        showTheatreInfo: true,
        selectMode: MODE,
        showWireTapIcon: mode != 'exhibitor',
        theatres: filteredData,
        addTheatreForBooking: addTheatreForBooking,
        handleScreenBooking: handleScreenBooking,
        theatresInBooking: filteredData,
        tabType: "selected",
        mode: mode,
        genericWireTapIcon: genericWireTapIcon,
        withScreenInfo: this.props.withScreenInfo
      }));
    }
  }, {
    key: "renderSearchBox",
    value: function renderSearchBox() {
      var searchText = this.state.searchText;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "selected-theatre-searchBox"
      }, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: searchText // emitEmpty={this.emitEmpty}
        ,
        suffix: true,
        error: false // searchButton
        ,
        placeholder: i18n.t('searchForTheatres') // searchClick={this.searchInput.bind(this)}
        ,
        onTextChange: this.handleChange.bind(this)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "selected-theatre-container"
      }, this.renderTitleSection(), this.props.showSearch && this.renderSearchBox(), this.renderSelectedTheatresSection(), this.props.createListModal && this.renderCreateListModal());
    }
  }]);

  return SelectedTheatres;
}(React__default.Component);
SelectedTheatres.defaultProps = {
  showSearch: true,
  withScreenInfo: true
};

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditTagModal = /*#__PURE__*/function (_Component) {
  _inherits$1(EditTagModal, _Component);

  var _super = _createSuper$s(EditTagModal);

  function EditTagModal() {
    var _this;

    _classCallCheck$1(this, EditTagModal);

    _this = _super.call(this);

    _defineProperty$1(_assertThisInitialized(_this), "showModal", function () {
      _this.setState({
        visible: true
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleCreate", function (tagName) {
      var tagDetails = {
        name: tagName,
        id: _this.props.rowData.id
      };

      _this.setState({
        loading: true
      });

      _this.props.saveTagDetails(tagDetails, 'edit');
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleCancel", function () {
      _this.setState({
        visible: false,
        loading: false,
        errorMessage: ''
      });
    });

    _this.state = {
      visible: false,
      loading: false,
      errorMessage: ''
    };
    return _this;
  }

  _createClass$1(EditTagModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.tagDetailsSavingStatus === true && nextProps.tagDetailsSavingStatus === false && this.state.loading === true) {
        if (!nextProps.errorWhileSavingTags) {
          this.setState({
            visible: false,
            errorMessage: ''
          });
        } else if (this.state.visible) {
          this.setState({
            errorMessage: this.props.errorWhileSavingTags
          });
        }

        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var rowData = this.props.rowData;
      var _this$state = this.state,
          visible = _this$state.visible,
          loading = _this$state.loading,
          errorMessage = _this$state.errorMessage;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tag-creation__layout"
      }, /*#__PURE__*/React__default.createElement("span", {
        onClick: this.showModal
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "edit",
        size: "24"
      })), visible && /*#__PURE__*/React__default.createElement(SaveTagModal, {
        title: i18n.t('editTag'),
        tagName: rowData.name,
        submitBtnName: "Save",
        visible: visible,
        handleSubmit: this.handleCreate,
        handleCancel: this.handleCancel,
        loading: loading,
        hasErrorMessage: errorMessage
      }));
    }
  }]);

  return EditTagModal;
}(Component);

EditTagModal.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: '',
  saveTagDetails: function saveTagDetails() {},
  rowData: {}
};

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TagsTable = /*#__PURE__*/function (_Component) {
  _inherits$1(TagsTable, _Component);

  var _super = _createSuper$r(TagsTable);

  function TagsTable(props) {
    var _this;

    _classCallCheck$1(this, TagsTable);

    _this = _super.call(this, props);
    _this.state = {
      columns: [{
        title: i18n.t('tagName'),
        dataIndex: 'name',
        key: 'name',
        width: '40%'
      }, {
        title: i18n.t('lastUpdatedOn'),
        dataIndex: 'updatedOn',
        key: 'updatedOn',
        render: function render(updated) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__txt"
          }, /*#__PURE__*/React__default.createElement("div", null, momentTZ(updated).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__hlpTxt"
          }, momentTZ(updated).format('h:mm A')));
        }
      }, {
        title: i18n.t('lastUpdatedBy'),
        dataIndex: 'updatedBy',
        key: 'updatedBy',
        render: function render(updatedby) {
          return /*#__PURE__*/React__default.createElement("div", null, updatedby || 'Qube Wire');
        }
      }, {
        title: i18n.t('createdOn'),
        dataIndex: 'createdOn',
        key: 'createdOn',
        render: function render(created) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__txt"
          }, /*#__PURE__*/React__default.createElement("div", null, momentTZ(created).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__hlpTxt"
          }, momentTZ(created).format('h:mm A')));
        }
      }, {
        title: i18n.t('createdBy'),
        dataIndex: 'createdBy',
        key: 'createdBy',
        render: function render(createdby) {
          return /*#__PURE__*/React__default.createElement("div", null, createdby || 'Qube Wire');
        }
      }].concat(_toConsumableArray$1(_this.props.canEdit ? [{
        title: '',
        dataIndex: 'edit',
        key: 'edit',
        render: function render(text, record) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "icon-centered"
          }, /*#__PURE__*/React__default.createElement(EditTagModal, {
            rowData: record,
            tagDetailsSavingStatus: _this.props.tagDetailsSavingStatus,
            errorWhileSavingTags: _this.props.errorWhileSavingTags,
            saveTagDetails: _this.props.saveTagDetails
          }));
        }
      }] : []))
    };
    return _this;
  }

  _createClass$1(TagsTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rows = _this$props.rows,
          fetchingData = _this$props.fetchingData;
      var columns = this.state.columns;
      return /*#__PURE__*/React__default.createElement(DefaultTable, {
        columns: columns,
        rows: rows,
        fetchingData: fetchingData
      });
    }
  }]);

  return TagsTable;
}(Component);

TagsTable.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: '',
  saveTagDetails: function saveTagDetails() {}
};

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CreateTagModal = /*#__PURE__*/function (_Component) {
  _inherits$1(CreateTagModal, _Component);

  var _super = _createSuper$q(CreateTagModal);

  function CreateTagModal() {
    var _this;

    _classCallCheck$1(this, CreateTagModal);

    _this = _super.call(this);

    _defineProperty$1(_assertThisInitialized(_this), "showModal", function () {
      _this.setState({
        visible: true
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleCreate", function (tagName) {
      _this.setState({
        loading: true
      });

      _this.props.saveTagDetails(tagName, 'create');
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleCancel", function () {
      _this.setState({
        visible: false,
        loading: false,
        errorMessage: ''
      });
    });

    _this.state = {
      visible: false,
      loading: false,
      errorMessage: ''
    };
    return _this;
  }

  _createClass$1(CreateTagModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.tagDetailsSavingStatus === true && nextProps.tagDetailsSavingStatus === false && this.state.loading === true) {
        if (!nextProps.errorWhileSavingTags) {
          this.setState({
            visible: false,
            errorMessage: ''
          });
        } else if (this.state.visible) {
          this.setState({
            errorMessage: this.props.errorWhileSavingTags
          });
        }

        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          visible = _this$state.visible,
          loading = _this$state.loading,
          errorMessage = _this$state.errorMessage;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tag-creation__layout"
      }, /*#__PURE__*/React__default.createElement(PrimaryButton, {
        btnName: i18n.t('createTag'),
        callbackAction: this.showModal
      }), visible && /*#__PURE__*/React__default.createElement(SaveTagModal, {
        title: i18n.t('createTag'),
        tagName: "",
        submitBtnName: i18n.t('create'),
        visible: visible,
        handleSubmit: this.handleCreate,
        handleCancel: this.handleCancel,
        loading: loading,
        hasErrorMessage: errorMessage
      }));
    }
  }]);

  return CreateTagModal;
}(Component);

CreateTagModal.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: '',
  saveTagDetails: function saveTagDetails() {}
};

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TableLoading = /*#__PURE__*/function (_Component) {
  _inherits$1(TableLoading, _Component);

  var _super = _createSuper$p(TableLoading);

  function TableLoading() {
    _classCallCheck$1(this, TableLoading);

    return _super.apply(this, arguments);
  }

  _createClass$1(TableLoading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          rowsCount = _this$props.rowsCount;
      var modifiedColumns = columns.map(function (column) {
        if (!column.id && !column.accessor) {
          throw new Error("Either id or accessor should be provided at Column ".concat(column.Header));
        }

        return {
          id: column.id || column.accessor,
          Header: column.Header,
          accessor: function accessor() {
            return /*#__PURE__*/React__default.createElement("span", {
              className: "cell"
            });
          },
          width: column.width,
          sortable: column.sortable,
          resizable: column.resizable
        };
      });
      var data = Array(rowsCount).fill({});
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-loading"
      }, /*#__PURE__*/React__default.createElement(Table, {
        columns: modifiedColumns,
        data: data,
        headerClassName: ""
      }));
    }
  }]);

  return TableLoading;
}(Component);
TableLoading.defaultProps = {
  rowsCount: 10
};

var _excluded$2 = ["appliances", "loading", "columns", "emptyDataMessage", "viewAppliancePage"];
var duplicationProgressStatuses = [DuplicationProgress.QUEUED, DuplicationProgress.PREPARING, DuplicationProgress.FORMATTING, DuplicationProgress.VERIFYING, DuplicationProgress.DUPLICATING, DuplicationProgress.EXECUTING];

var ApplianceTable = function ApplianceTable(_ref) {
  var appliances = _ref.appliances,
      loading = _ref.loading,
      columns = _ref.columns,
      emptyDataMessage = _ref.emptyDataMessage,
      viewAppliancePage = _ref.viewAppliancePage;
      _objectWithoutProperties$1(_ref, _excluded$2);

  var isPartnerAppliance = function isPartnerAppliance(type) {
    return type === ApplianceTypes.PARTNER;
  };

  var isTheatreAppliance = function isTheatreAppliance(type) {
    return type === ApplianceTypes.THEATRE;
  };

  var isDuplicationInProgress = function isDuplicationInProgress(duplication) {
    return duplication && duplicationProgressStatuses.includes(duplication.status);
  };

  var formatTheatreAddress = function formatTheatreAddress(details) {
    var formattedAddress = [];
    var city = details.city,
        province = details.province,
        country = details.country;

    if (city) {
      formattedAddress.push(city.displayName ? city.displayName : city.name);
    }

    if (province) {
      formattedAddress.push(province.displayName ? province.displayName : province.name);
    }

    if (country) {
      formattedAddress.push(country.displayName ? country.displayName : country.name);
    }

    return formattedAddress.join(', ');
  };

  var defaultColumns = [{
    Header: i18n.t('serialNumber'),
    accessor: 'serial',
    key: 'serial',
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
          _ref2.original;

      if (value) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "serial-number white-space-break"
        }, value);
      } else return /*#__PURE__*/React__default.createElement("div", {
        className: "serial-number white-space-break"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: i18n.t('theatres'),
    accessor: 'mappedTo',
    key: 'theatres',
    minWidth: 200,
    Cell: function Cell(_ref3) {
      var value = _ref3.value;
      return /*#__PURE__*/React__default.createElement("div", null, value.map(function (facility) {
        return !_$1.isEmpty(facility) && !_$1.isEmpty(facility.name) ? /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-info white-space-break"
        }, /*#__PURE__*/React__default.createElement(TheatreName, {
          name: facility.displayName || facility.name,
          rowKey: function rowKey(facility) {
            return facility.id;
          }
        }), _$1.isEmpty(facility.details) || _$1.isEmpty(facility.details.city) || _$1.isEmpty(facility.details.province) || _$1.isEmpty(facility.details.country) ? /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-info white-space-break"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null)) : /*#__PURE__*/React__default.createElement(TheatreAddress, {
          address: formatTheatreAddress(facility.details)
        })) : /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-info white-space-break"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
      }));
    }
  }, {
    Header: i18n.t('companyTheatreLocation'),
    accessor: 'mappedTo',
    key: 'theatre_partner_company_name',
    minWidth: 200,
    Cell: function Cell(_ref4) {
      var value = _ref4.value;

      if (value) {
        return /*#__PURE__*/React__default.createElement("div", null, value.map(function (facility) {
          return !_$1.isEmpty(facility) && !_$1.isEmpty(facility.name) ? /*#__PURE__*/React__default.createElement("div", {
            className: "theatres-info white-space-break"
          }, /*#__PURE__*/React__default.createElement(TheatreName, {
            name: facility.displayName || facility.name,
            rowKey: function rowKey(facility) {
              return facility.id;
            }
          }), _$1.isEmpty(facility.details) || _$1.isEmpty(facility.details.city) || _$1.isEmpty(facility.details.province) || _$1.isEmpty(facility.details.country) ? /*#__PURE__*/React__default.createElement("div", {
            className: "theatres-info white-space-break"
          }, /*#__PURE__*/React__default.createElement(EmptyHandler, null)) : /*#__PURE__*/React__default.createElement(TheatreAddress, {
            address: formatTheatreAddress(facility.details)
          })) : /*#__PURE__*/React__default.createElement("div", {
            className: "theatres-info white-space-break"
          }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
        }));
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "white-space-break"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
      }
    }
  }, {
    Header: i18n.t('type'),
    accessor: 'mappedTo',
    key: 'type',
    Cell: function Cell(_ref5) {
      var value = _ref5.value;

      if (value) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "appliance-type white-space-break"
        }, isPartnerAppliance(value[0].type) ? ApplianceTypes.PARTNER : isTheatreAppliance(value[0].type) ? ApplianceTypes.THEATRE : '-');
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "appliance-type white-space-break"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
      }
    }
  }, {
    Header: i18n.t('chain'),
    accessor: 'mappedTo',
    key: 'chain',
    Cell: function Cell(_ref6) {
      var value = _ref6.value;

      if (value) {
        return /*#__PURE__*/React__default.createElement("div", null, value.map(function (facilities) {
          return !_$1.isEmpty(facilities) && !_$1.isEmpty(facilities.details) && !_$1.isEmpty(facilities.details.chain) ? /*#__PURE__*/React__default.createElement("div", {
            className: "chain-info white-space-break"
          }, /*#__PURE__*/React__default.createElement(TheatreName, {
            name: facilities.details.chain.displayName ? facilities.details.chain.displayName : facilities.details.chain.name,
            rowKey: function rowKey(facilities) {
              return facilities.id;
            }
          })) : /*#__PURE__*/React__default.createElement("div", {
            className: "chain-info white-space-break"
          }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
        }));
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "chain-info white-space-break"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
      }
    }
  }, {
    Header: i18n.t('bandwidth'),
    accessor: 'bandwidthInMbps',
    key: 'bandwidthInMbps',
    Cell: function Cell(_ref7) {
      var value = _ref7.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "bandwidth white-space-break"
      }, bandwidthCalculator(value * 1024 * 1024));else return /*#__PURE__*/React__default.createElement("div", {
        className: "bandwidth white-space-break"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: i18n.t('publicIp'),
    accessor: 'publicIp',
    key: 'publicIp',
    Cell: function Cell(_ref8) {
      var value = _ref8.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "public-ip white-space-break"
      }, value);else return /*#__PURE__*/React__default.createElement("div", {
        className: "public-ip white-space-break"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: i18n.t('osVersion'),
    accessor: 'softwareVersion',
    key: 'softwareVersion',
    Cell: function Cell(_ref9) {
      var value = _ref9.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "os-version white-space-break"
      }, value);else return /*#__PURE__*/React__default.createElement("div", {
        className: "os-version white-space-break"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: i18n.t('downloadStatus'),
    accessor: 'downloadRate',
    key: 'downloadRate',
    Cell: function Cell(_ref10) {
      var value = _ref10.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "download-speed white-space-break"
      }, /*#__PURE__*/React__default.createElement("div", null, "Downloading at ", bandwidthCalculator(value * 8)));else return /*#__PURE__*/React__default.createElement("div", {
        className: "download-speed white-space-break"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: i18n.t('duplicationStatus'),
    accessor: 'drives',
    key: 'duplicationStatus',
    Cell: function Cell(_ref11) {
      var drives = _ref11.drives;
      var duplicatingDrives = drives && drives.filter(function (d) {
        return isDuplicationInProgress(d.duplicationStatus);
      });

      if (_$1.isEmpty(drives) || _$1.isEmpty(duplicatingDrives)) {
        return '-';
      }

      var consolidatedDrives = [];
      duplicatingDrives.forEach(function (drive) {
        var bay = drive.bay,
            duplicationStatus = drive.duplicationStatus;
        var workOrderNo = duplicationStatus && duplicationStatus.userData && duplicationStatus.userData.workOrderNo;
        var existingDriveIndex = consolidatedDrives.findIndex(function (d) {
          return d.workOrderNo === workOrderNo;
        });

        if (existingDriveIndex > -1) {
          consolidatedDrives[existingDriveIndex].bays.push(bay);
        } else {
          consolidatedDrives.push({
            bays: [bay],
            workOrderNo: workOrderNo
          });
        }
      });
      return consolidatedDrives.map(function (drive) {
        var workOrderNo = drive.workOrderNo,
            bays = drive.bays;
        return /*#__PURE__*/React__default.createElement("div", null, "".concat(i18n.t('duplicatingWoInBay', {
          workOrderNo: workOrderNo
        }), " ").concat(_$1.sortBy(bays).join(', ')));
      });
    }
  }, {
    Header: i18n.t('status'),
    accessor: 'isOnline',
    key: 'isOnline',
    Cell: function Cell(_ref12) {
      var value = _ref12.value;

      if (typeof value === 'boolean') {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "online white-space-break"
        }, /*#__PURE__*/React__default.createElement(Status, {
          status: value
        }));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "online white-space-break"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    accessor: 'id',
    key: 'viewAppliance',
    Cell: function Cell(_ref13) {
      var value = _ref13.value;
      return /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonType: BUTTON_TYPE.DEFAULT,
        buttonSize: SIZE.REGULAR,
        onClick: function onClick() {
          return viewAppliancePage(value);
        },
        className: "view-button",
        buttonText: i18n.t('view')
      });
    }
  }];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "applianceTable"
  }, /*#__PURE__*/React__default.createElement(Table, {
    sortable: false,
    loading: loading,
    data: appliances,
    columns: columns ? defaultColumns.filter(function (column) {
      return columns.includes(column.key);
    }) : defaultColumns,
    emptyDataMessage: emptyDataMessage,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns ? defaultColumns.filter(function (column) {
        return columns.includes(column.key);
      }) : defaultColumns
    })
  }));
};
ApplianceTable.defaultProps = {
  emptyDataMessage: {
    heading: 'No WireTAPs Available',
    body: ''
  }
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Searchbar = function Searchbar(_ref) {
  var searchValue = _ref.searchValue,
      clearSearch = _ref.clearSearch,
      placeholder = _ref.placeholder,
      isSearching = _ref.isSearching,
      searchList = _ref.searchList,
      isFreshSearch = _ref.isFreshSearch,
      dropDownPlaceholder = _ref.dropDownPlaceholder,
      showArrow = _ref.showArrow,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "search-field"
  }, !showArrow && /*#__PURE__*/React__default.createElement("div", {
    className: "search-icon"
  }, searchValue ? /*#__PURE__*/React__default.createElement(CloseOutlined$1, {
    onClick: clearSearch
  }) : /*#__PURE__*/React__default.createElement(SearchOutlined$1, null)), /*#__PURE__*/React__default.createElement(_Select, {
    mode: "multiple",
    defaultValue: defaultValue,
    placeholder: placeholder,
    labelInValue: true,
    showArrow: showArrow,
    onChange: onChange,
    style: {
      width: '100%'
    },
    options: searchList,
    notFoundContent: isSearching ? /*#__PURE__*/React__default.createElement("div", {
      className: "spinner"
    }, /*#__PURE__*/React__default.createElement(_Spin, null)) : _.isEmpty(searchList) && isFreshSearch ? dropDownPlaceholder : i18n.t('noRecordsfound')
  }));
};

var AddUsersToGroupModal = function AddUsersToGroupModal(_ref2) {
  var visible = _ref2.visible,
      handleClose = _ref2.handleClose,
      user = _ref2.user,
      groupPlaceholder = _ref2.groupPlaceholder,
      rolePlaceholder = _ref2.rolePlaceholder,
      accessToken = _ref2.accessToken,
      theatreAclUrl = _ref2.theatreAclUrl,
      defaultGroupValues = _ref2.defaultGroupValues,
      defaultRoleValues = _ref2.defaultRoleValues,
      fetchUsers = _ref2.fetchUsers,
      currentOffset = _ref2.currentOffset,
      setIsOpen = _ref2.setIsOpen;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      selectFieldsCount = _useState2[0],
      setSelectFieldsCount = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectData = _useState4[0],
      setSelectData = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      allGroups = _useState6[0],
      setAllGroups = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedGroups = _useState8[0],
      setSelectedGroups = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isSaving = _useState10[0],
      setIsSaving = _useState10[1];

  var handleAddAnotherSelectField = function handleAddAnotherSelectField() {
    setSelectFieldsCount(selectFieldsCount + 1);
  };

  var isEdit = function isEdit(user) {
    var _user$roles;

    var edit = false;
    user === null || user === void 0 ? void 0 : (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.forEach(function (role) {
      var _role$groups;

      if (role !== null && role !== void 0 && (_role$groups = role.groups) !== null && _role$groups !== void 0 && _role$groups.length) {
        edit = true;
      }
    });
    return edit;
  };

  useEffect(function () {
    var data = {};
    var groupData = {};

    if (isEdit(user)) {
      defaultRoleValues.forEach(function (role, index) {
        data = _objectSpread$5(_objectSpread$5({}, data), {}, _defineProperty$1({}, index, _objectSpread$5(_objectSpread$5({}, data && data[index]), {}, {
          role: role
        })));
      });
      defaultGroupValues.forEach(function (group, index) {
        data = _objectSpread$5(_objectSpread$5({}, data), {}, _defineProperty$1({}, index, _objectSpread$5(_objectSpread$5({}, data && data[index]), {}, {
          group: group
        })));
      });
    }

    defaultGroupValues.forEach(function (group, index) {
      groupData = _objectSpread$5(_objectSpread$5({}, groupData), {}, _defineProperty$1({}, index, _objectSpread$5(_objectSpread$5({}, groupData && groupData[index]), {}, {
        group: group === null || group === void 0 ? void 0 : group.map(function (o) {
          return o.value;
        })
      })));
    });
    setSelectData(data);
    setSelectedGroups(groupData);
  }, [defaultGroupValues, defaultRoleValues]);

  var onSelectChange = function onSelectChange(index, name, option) {
    // Filtering options based on matching labels in allGroups  and updating value
    var updatedOptions = option === null || option === void 0 ? void 0 : option.map(function (option) {
      var matchedData = allGroups === null || allGroups === void 0 ? void 0 : allGroups.find(function (item) {
        return item.label === option.label;
      });
      return matchedData ? _objectSpread$5(_objectSpread$5({}, option), {}, {
        value: matchedData.id
      }) : option;
    });

    if (name === 'group') {
      var _data = _objectSpread$5(_objectSpread$5({}, selectedGroups), {}, _defineProperty$1({}, index, _objectSpread$5(_objectSpread$5({}, selectedGroups && selectedGroups[index]), {}, {
        group: updatedOptions.map(function (o) {
          return o.value;
        })
      })));

      setSelectedGroups(_data);
    }

    var data = _objectSpread$5(_objectSpread$5({}, selectData), {}, _defineProperty$1({}, index, _objectSpread$5(_objectSpread$5({}, selectData && selectData[index]), {}, _defineProperty$1({}, name, updatedOptions))));

    setSelectData(data);
  };

  useEffect(function () {
    if (visible) {
      setSelectFieldsCount(1);
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };
      axios.get("".concat(theatreAclUrl, "/v1/groups?ps=50&offset=0"), config).then(function (response) {
        setAllGroups(response.data.groups.map(function (group) {
          return {
            label: group.name,
            value: group.name,
            id: group.id
          };
        }));
      });
    }
  }, [visible]);

  var handleAdd = function handleAdd() {
    var data = Object.keys(selectData).map(function (key) {
      return {
        groups: selectData[key].group.map(function (group) {
          return {
            id: group.value,
            roles: selectData[key].role.map(function (role) {
              return role.value;
            })
          };
        })
      };
    });
    setIsSaving(true);

    if (isEdit(user)) {
      var _data$map;

      axios.create({
        baseURL: theatreAclUrl,
        headers: {
          Authorization: "Bearer ".concat(accessToken),
          'If-Match': user.version
        }
      }).put("".concat(theatreAclUrl, "/v1/groups/user"), {
        userId: user.Id,
        groups: (_data$map = data.map(function (d) {
          return d.groups;
        })) === null || _data$map === void 0 ? void 0 : _data$map.flat()
      }).then(function () {
        SuccessMessage(i18n.t('groupUpdatedForUser'));
        fetchUsers(currentOffset);
        setIsOpen(false);
        setIsSaving(false);
      }).catch(function () {
        ErrorMessage(i18n.t('errorWhileUpdatingGroup'));
        setIsSaving(false);
      });
    } else {
      var _data$map2;

      axios.create({
        baseURL: theatreAclUrl,
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      }).post("".concat(theatreAclUrl, "/v1/groups/user"), {
        userId: user.Id,
        groups: (_data$map2 = data.map(function (d) {
          return d.groups;
        })) === null || _data$map2 === void 0 ? void 0 : _data$map2.flat()
      }).then(function () {
        SuccessMessage(i18n.t('groupAddedToUser'));
        fetchUsers(currentOffset);
        setIsOpen(false);
        setIsSaving(false);
      }).catch(function () {
        ErrorMessage(i18n.t('errorWhileAddingGroup'));
        setIsSaving(false);
      });
    }
  };

  var filteredGroupsList = function filteredGroupsList(index) {
    return allGroups === null || allGroups === void 0 ? void 0 : allGroups.filter(function (group) {
      var groupIds = [];
      Object.keys(selectedGroups).forEach(function (key) {
        if (parseInt(key) !== index) {
          groupIds.push(selectedGroups[key].group);
        }
      });
      return !(groupIds !== null && groupIds !== void 0 && groupIds.flat().includes(group.value));
    });
  };

  var rolesList = function rolesList() {
    var _user$roles2;

    return user === null || user === void 0 ? void 0 : (_user$roles2 = user.roles) === null || _user$roles2 === void 0 ? void 0 : _user$roles2.map(function (role) {
      return {
        label: role === null || role === void 0 ? void 0 : role.name,
        value: role === null || role === void 0 ? void 0 : role.code
      };
    });
  };

  var isDisabled = function isDisabled() {
    var disabled = true;

    var data = _.cloneDeep(selectData);

    if (isEdit(user)) {
      if (data) {
        for (var key in data) {
          if (!_.isEmpty(data[key].group) && !_.isEmpty(data[key].role) || _.isEmpty(data[key].group) && _.isEmpty(data[key].role)) {
            disabled = false;
          } else {
            disabled = true;
            return disabled;
          }
        }
      }
    } else {
      var emptyRows = 0;

      if (data) {
        for (var _key in data) {
          if (!_.isEmpty(data[_key].group) && !_.isEmpty(data[_key].role)) {
            disabled = false;
          } else if (_.isEmpty(data[_key].group) && _.isEmpty(data[_key].role)) {
            emptyRows++;
          } else {
            disabled = true;
            return disabled;
          }
        }

        if (emptyRows === data.length) {
          disabled = true;
        }
      }
    }

    return disabled;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "add-users-to-groups-modal-container"
  }, /*#__PURE__*/React__default.createElement(_Modal, {
    destroyOnClose: true,
    visible: visible,
    wrapClassName: "vertical-center-modal",
    title: isEdit(user) ? i18n.t('updateAccess') : i18n.t('addAccess'),
    onCancel: handleClose,
    afterClose: null,
    closable: true,
    footer: [/*#__PURE__*/React__default.createElement(_Button, {
      key: "back",
      onClick: handleClose,
      disabled: isSaving,
      className: "cancel-btn"
    }, i18n.t('cancel')), /*#__PURE__*/React__default.createElement(_Button, {
      key: "submit",
      type: "primary",
      loading: isSaving,
      onClick: handleAdd,
      disabled: isDisabled()
    }, isEdit(user) ? i18n.t('update') : i18n.t('add'))],
    width: 500
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "add-users-to-groups-modal"
  }, /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, i18n.t('name')), /*#__PURE__*/React__default.createElement("div", null, user === null || user === void 0 ? void 0 : user.name)), /*#__PURE__*/React__default.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, i18n.t('email')), /*#__PURE__*/React__default.createElement("div", null, user === null || user === void 0 ? void 0 : user.email))), !isEdit(user) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array(selectFieldsCount).fill(null).map(function (_, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "select",
      key: index
    }, /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [16, 16]
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, i18n.t('group')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(index, 'group', option);
      },
      searchList: filteredGroupsList(index),
      placeholder: groupPlaceholder
    })), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, i18n.t('role')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(index, 'role', option);
      },
      placeholder: rolePlaceholder,
      searchList: rolesList(),
      showArrow: true
    }))));
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, defaultRoleValues.map(function (role, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "select",
      key: index
    }, /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [16, 16]
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, i18n.t('group')), /*#__PURE__*/React__default.createElement(Searchbar, {
      key: JSON.stringify(defaultGroupValues[index]),
      onChange: function onChange(option) {
        return onSelectChange(index, 'group', option);
      },
      defaultValue: defaultGroupValues[index],
      searchList: filteredGroupsList(index),
      placeholder: groupPlaceholder
    })), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, i18n.t('role')), /*#__PURE__*/React__default.createElement(Searchbar, {
      key: JSON.stringify(defaultRoleValues[index]),
      onChange: function onChange(option) {
        return onSelectChange(index, 'role', option);
      },
      defaultValue: defaultRoleValues[index],
      placeholder: rolePlaceholder,
      searchList: rolesList(),
      showArrow: true
    }))));
  }), Array(selectFieldsCount - 1).fill(null).map(function (_, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "select",
      key: index
    }, /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [16, 16]
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, i18n.t('group')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(defaultRoleValues.length + index, 'group', option);
      },
      searchList: filteredGroupsList(defaultRoleValues.length + index),
      placeholder: groupPlaceholder
    })), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, i18n.t('role')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(defaultRoleValues.length + index, 'role', option);
      },
      placeholder: rolePlaceholder,
      searchList: rolesList(),
      showArrow: true
    }))));
  })), /*#__PURE__*/React__default.createElement("a", {
    className: "add-role-button",
    onClick: handleAddAnotherSelectField
  }, "+ ", i18n.t('addAnotherRole')))));
};

var MultipleData = function MultipleData(props) {
  var data = props.data,
      limit = props.limit,
      renderFunction = props.renderFunction;
  var hiddenContent = data.length - limit;

  var handleOnClick = function handleOnClick() {
    props.callback();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.viewMore ? data.map(function (content) {
    return renderFunction(content);
  }) : data.slice(0, limit).map(function (content) {
    return renderFunction(content);
  }), hiddenContent > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "view_more_link",
    onClick: handleOnClick
  }, props.viewMore ? "Collapse" : "".concat(hiddenContent, " More")) : null);
};

var UsersTable = function UsersTable(_ref) {
  var users = _ref.users,
      loading = _ref.loading,
      offset = _ref.offset,
      ps = _ref.ps,
      hasMore = _ref.hasMore,
      fetchUsers = _ref.fetchUsers,
      accessToken = _ref.accessToken,
      theatreAclUrl = _ref.theatreAclUrl,
      isCinemasAdmin = _ref.isCinemasAdmin;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      user = _useState4[0],
      setUser = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      expand = _useState6[0],
      setExpand = _useState6[1];

  useEffect(function () {
    var expandData = [];

    if (users) {
      expandData = users === null || users === void 0 ? void 0 : users.map(function (userData) {
        var _userData$roles;

        return {
          userid: userData.Id,
          roles: (_userData$roles = userData.roles) === null || _userData$roles === void 0 ? void 0 : _userData$roles.map(function (role) {
            return {
              id: role.id,
              expanded: false
            };
          })
        };
      });
    }

    setExpand(expandData);
  }, [users]);

  var isAdmin = function isAdmin(user) {
    var _user$roles;

    return user === null || user === void 0 ? void 0 : (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.filter(function (role) {
      return role.code.toLowerCase() === 'admin';
    }).length;
  };

  var renderGroupsData = function renderGroupsData(group) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "table-data__txt",
      key: group.id
    }, /*#__PURE__*/React__default.createElement("span", null, group.name), /*#__PURE__*/React__default.createElement("span", {
      className: "table-data__hlpTxt"
    }, "".concat(group.theatreCount, " Theatres")));
  };

  var ifGroupExapnded = function ifGroupExapnded(original, roleid) {
    var _expand$index, _expand$index$roles, _expand$index2, _expand$index2$roles$;

    var index = expand.findIndex(function (data) {
      return data.userid === original.Id;
    });
    var roleIndex = (_expand$index = expand[index]) === null || _expand$index === void 0 ? void 0 : (_expand$index$roles = _expand$index.roles) === null || _expand$index$roles === void 0 ? void 0 : _expand$index$roles.findIndex(function (data) {
      return data.id === roleid;
    });
    return (_expand$index2 = expand[index]) === null || _expand$index2 === void 0 ? void 0 : (_expand$index2$roles$ = _expand$index2.roles[roleIndex]) === null || _expand$index2$roles$ === void 0 ? void 0 : _expand$index2$roles$.expanded;
  };

  var setExpandData = function setExpandData(original, roleid) {
    var _expand$index3, _expand$index3$roles, _newExpandData$index;

    var index = expand.findIndex(function (data) {
      return data.userid === original.Id;
    });
    var roleIndex = (_expand$index3 = expand[index]) === null || _expand$index3 === void 0 ? void 0 : (_expand$index3$roles = _expand$index3.roles) === null || _expand$index3$roles === void 0 ? void 0 : _expand$index3$roles.findIndex(function (data) {
      return data.id === roleid;
    });

    var newExpandData = _toConsumableArray$1(expand);

    if ((_newExpandData$index = newExpandData[index]) !== null && _newExpandData$index !== void 0 && _newExpandData$index.roles[roleIndex]) {
      var _newExpandData$index2, _newExpandData$index3;

      newExpandData[index].roles[roleIndex].expanded = !((_newExpandData$index2 = newExpandData[index]) !== null && _newExpandData$index2 !== void 0 && (_newExpandData$index3 = _newExpandData$index2.roles[roleIndex]) !== null && _newExpandData$index3 !== void 0 && _newExpandData$index3.expanded);
    }

    setExpand(_toConsumableArray$1(newExpandData));
  };

  var status = {
    inactive: i18n.t('deactivatedUser'),
    invited: i18n.t('invitedUser')
  };
  var columns = [{
    Header: i18n.t('name'),
    accessor: 'name',
    Cell: function Cell(_ref2) {
      var value = _ref2.value,
          original = _ref2.original;

      if (original.status !== 'active') {
        var renderStatus = original.status !== '' ? "(".concat(status[original.status], ")") : '';
        return /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(original.status)
        }, value ? "".concat(value, " ").concat(original.lastName ? original.lastName : '', " ").concat(renderStatus) : "- ".concat(renderStatus));
      }

      return /*#__PURE__*/React__default.createElement("div", null, value, " ", original.lastName);
    }
  }, {
    Header: i18n.t('email'),
    accessor: 'email'
  }, {
    id: 'roles',
    Header: i18n.t('roles'),
    accessor: function accessor(d) {
      var _d$roles;

      return d === null || d === void 0 ? void 0 : (_d$roles = d.roles) === null || _d$roles === void 0 ? void 0 : _d$roles.map(function (role) {
        return role.name;
      });
    },
    Cell: function Cell(_ref3) {
      var value = _ref3.value,
          original = _ref3.original;

      if (!value || !value.length) {
        return /*#__PURE__*/React__default.createElement("div", null, i18n.t('noAccess'));
      }

      if (isAdmin(original)) {
        return /*#__PURE__*/React__default.createElement("div", null, "Admin");
      }

      return original.roles.map(function (role) {
        var _role$groups, _role$groups2, _role$groups3;

        return /*#__PURE__*/React__default.createElement("div", {
          key: role.id,
          className: "role"
        }, /*#__PURE__*/React__default.createElement("span", null, role.name), ifGroupExapnded(original, role.id) ? role === null || role === void 0 ? void 0 : (_role$groups = role.groups) === null || _role$groups === void 0 ? void 0 : _role$groups.map(function () {
          return /*#__PURE__*/React__default.createElement("br", null);
        }) : role === null || role === void 0 ? void 0 : (_role$groups2 = role.groups) === null || _role$groups2 === void 0 ? void 0 : _role$groups2.slice(0, 3).map(function () {
          return /*#__PURE__*/React__default.createElement("br", null);
        }), (role === null || role === void 0 ? void 0 : (_role$groups3 = role.groups) === null || _role$groups3 === void 0 ? void 0 : _role$groups3.length) > 3 ? /*#__PURE__*/React__default.createElement("br", null) : null);
      });
    }
  }, {
    id: 'hasAccessTo',
    Header: i18n.t('hasAccessTo'),
    Cell: function Cell(_ref4) {
      var _original$roles;

      var original = _ref4.original;

      if (!(original !== null && original !== void 0 && original.roles)) {
        return /*#__PURE__*/React__default.createElement("div", null, "-");
      }

      if (isAdmin(original)) {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("i", null, "All Theatres"));
      }

      var count = 0;
      return original === null || original === void 0 ? void 0 : (_original$roles = original.roles) === null || _original$roles === void 0 ? void 0 : _original$roles.map(function (role) {
        if (!role.groups || !role.groups.length) {
          if (isCinemasAdmin || count) {
            return null;
          }

          count += 1;
          return /*#__PURE__*/React__default.createElement("div", {
            className: "role",
            onClick: function onClick() {
              return handleMapUserClick(original);
            }
          }, /*#__PURE__*/React__default.createElement("a", null, "Add Group"));
        }

        return /*#__PURE__*/React__default.createElement("div", {
          key: role.id,
          className: "role"
        }, /*#__PURE__*/React__default.createElement(MultipleData, {
          data: role.groups,
          limit: 3,
          renderFunction: renderGroupsData,
          callback: function callback() {
            return setExpandData(original, role.id);
          },
          viewMore: ifGroupExapnded(original, role.id)
        }));
      });
    }
  }, {
    Header: i18n.t('lastUpdatedOn'),
    accessor: 'updatedOn',
    defaultSortMethod: function defaultSortMethod(a, b) {
      return moment(a).unix() - moment(b).unix();
    },
    Cell: function Cell(_ref5) {
      var value = _ref5.value;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-data__txt"
      }, /*#__PURE__*/React__default.createElement("span", null, value && moment(value).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("span", {
        className: "table-data__hlpTxt"
      }, value && moment(value).format('h:mm A')));
    }
  }, _defineProperty$1({
    id: 'updatedBy',
    Header: i18n.t('lastUpdatedBy'),
    accessor: 'updatedBy'
  }, "accessor", function accessor(d) {
    return d.updatedBy.name;
  }), {
    id: 'edit',
    Header: '',
    Cell: function Cell(_ref7) {
      var original = _ref7.original;
      return /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return handleMapUserClick(original);
        },
        className: classNames$1({
          edit: true,
          disabled: isAdmin(original) || !(original !== null && original !== void 0 && original.roles)
        })
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "edit"
      }));
    },
    minWidth: 40
  }];
  var shoudlDisablePrevious = offset === 0;
  var shouldDisableNext = !hasMore;

  var handleClickNext = function handleClickNext() {
    if (!shouldDisableNext) {
      fetchUsers(offset + ps);
    }
  };

  var handleClickPrevious = function handleClickPrevious() {
    if (!shoudlDisablePrevious) {
      fetchUsers(offset - ps);
    }
  };

  var handleMapUserClick = function handleMapUserClick(user) {
    if (isAdmin(user) || !(user !== null && user !== void 0 && user.roles)) {
      return;
    }

    setUser(user);
    setIsOpen(true);
  };

  var currentPage = offset / ps + 1;

  var getDefaultValues = function getDefaultValues() {
    var _user$roles2;

    var defaultGroupValues = [];
    var defaultRoleValues = [];
    var groupsWithRoles = [];
    user === null || user === void 0 ? void 0 : (_user$roles2 = user.roles) === null || _user$roles2 === void 0 ? void 0 : _user$roles2.forEach(function (role) {
      var _role$groups4;

      role === null || role === void 0 ? void 0 : (_role$groups4 = role.groups) === null || _role$groups4 === void 0 ? void 0 : _role$groups4.forEach(function (group) {
        var groupWithRole = {
          groups: [{
            label: group.name,
            value: group.id,
            id: group.id
          }],
          roles: [{
            label: role.name,
            value: role.code
          }]
        };
        groupsWithRoles.push(groupWithRole);
      });
    });
    groupsWithRoles.forEach(function (groupWithRole, index) {
      if (groupWithRole !== null) {
        for (var i = index + 1; i < groupsWithRoles.length; i++) {
          if (groupsWithRoles[i] !== null && groupWithRole.groups[0].id === groupsWithRoles[i].groups[0].id) {
            groupWithRole.roles = [].concat(_toConsumableArray$1(groupWithRole.roles), _toConsumableArray$1(groupsWithRoles[i].roles));
            groupsWithRoles[i] = null;
          }
        }
      }
    });
    groupsWithRoles = groupsWithRoles.filter(function (groupWithRole) {
      return groupWithRole !== null;
    });
    groupsWithRoles.forEach(function (groupWithRole, index) {
      if (groupWithRole !== null) {
        for (var i = index + 1; i < groupsWithRoles.length; i++) {
          if (groupsWithRoles[i] !== null && JSON.stringify(groupWithRole.roles) === JSON.stringify(groupsWithRoles[i].roles)) {
            groupWithRole.groups = [].concat(_toConsumableArray$1(groupWithRole.groups), _toConsumableArray$1(groupsWithRoles[i].groups));
            groupsWithRoles[i] = null;
          }
        }
      }
    });
    groupsWithRoles = groupsWithRoles.filter(function (groupWithRole) {
      return groupWithRole !== null;
    });
    groupsWithRoles.forEach(function (groupWithRole) {
      defaultGroupValues.push(groupWithRole.groups);
      defaultRoleValues.push(groupWithRole.roles);
    });
    return {
      groups: defaultGroupValues,
      roles: defaultRoleValues
    };
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "usersTable"
  }, /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Table, {
    manual: false,
    striped: true,
    data: users,
    columns: isCinemasAdmin ? columns.filter(function (column) {
      return column.id !== 'edit';
    }) : columns,
    loading: loading,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns
    })
  })), /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }), /*#__PURE__*/React__default.createElement(AddUsersToGroupModal, {
    visible: isOpen,
    handleClose: function handleClose() {
      return setIsOpen(false);
    },
    user: user,
    theatreAclUrl: theatreAclUrl,
    accessToken: accessToken,
    defaultGroupValues: getDefaultValues().groups,
    defaultRoleValues: getDefaultValues().roles,
    fetchUsers: fetchUsers,
    setIsOpen: setIsOpen,
    currentOffset: offset
  }));
};

var GroupsTable = function GroupsTable(_ref) {
  var groups = _ref.groups,
      loading = _ref.loading,
      offset = _ref.offset,
      ps = _ref.ps,
      hasMore = _ref.hasMore,
      fetchGroups = _ref.fetchGroups,
      handleGroupClick = _ref.handleGroupClick;
  var columns = [{
    Header: i18n.t('group'),
    accessor: 'name'
  }, {
    Header: i18n.t('theatres'),
    accessor: 'theatreCount'
  }, {
    Header: i18n.t('users'),
    accessor: 'userCount'
  }, {
    Header: i18n.t('lastUpdatedOn'),
    accessor: 'updatedAt',
    defaultSortMethod: function defaultSortMethod(a, b) {
      return moment(a).unix() - moment(b).unix();
    },
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-data__txt"
      }, /*#__PURE__*/React__default.createElement("div", null, value && moment(value).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("div", {
        className: "table-data__hlpTxt"
      }, value && moment(value).format('h:mm A')));
    }
  }, {
    id: 'updatedBy',
    Header: i18n.t('lastUpdatedBy'),
    accessor: function accessor(d) {
      return "".concat(d.updatedBy.name, " ").concat(d.updatedBy.lastName);
    }
  }, {
    id: 'action',
    Header: '',
    Cell: function Cell(_ref3) {
      var original = _ref3.original;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center',
          cursor: 'pointer'
        },
        onClick: handleGroupClick === null || handleGroupClick === void 0 ? void 0 : handleGroupClick.bind(null, original.id)
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "InfoCircle"
      }));
    },
    minWidth: 30
  }];
  var shoudlDisablePrevious = offset === 0;
  var shouldDisableNext = !hasMore;

  var handleClickNext = function handleClickNext() {
    if (!shouldDisableNext) {
      fetchGroups(offset + ps);
    }
  };

  var handleClickPrevious = function handleClickPrevious() {
    if (!shoudlDisablePrevious) {
      fetchGroups(offset - ps);
    }
  };

  var currentPage = Math.ceil(offset / ps) + 1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "usersTable"
  }, /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Table, {
    manual: false,
    striped: true,
    data: groups,
    columns: columns,
    loading: loading,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns
    })
  })), /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }));
};

var GroupsDetailTheatreTable = function GroupsDetailTheatreTable(_ref) {
  var theatres = _ref.theatres,
      loading = _ref.loading;
  var columns = [{
    Header: i18n.t('theatre'),
    accessor: 'name'
  }, {
    Header: i18n.t('chain'),
    id: 'chain',
    accessor: function accessor(d) {
      var _d$chain;

      return d === null || d === void 0 ? void 0 : (_d$chain = d.chain) === null || _d$chain === void 0 ? void 0 : _d$chain.display_name;
    }
  }, {
    Header: i18n.t('location'),
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.address;
    },
    id: 'address',
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/React__default.createElement("div", null, formatAddress(value));
    }
  }, {
    Header: i18n.t('screens'),
    accessor: 'screen_count'
  }];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "usersTable"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Table, {
    manual: false,
    striped: true,
    data: theatres,
    columns: columns,
    loading: loading,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns
    })
  })));
};

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FilterPanel = /*#__PURE__*/function (_Component) {
  _inherits$1(FilterPanel, _Component);

  var _super = _createSuper$o(FilterPanel);

  function FilterPanel(props) {
    var _this;

    _classCallCheck$1(this, FilterPanel);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "clearAllFilters", function (e) {
      e.stopPropagation();

      _this.toggleClearAll();
    });

    _defineProperty$1(_assertThisInitialized(_this), "toggleClearAll", function () {
      _this.setState({
        clearAll: !_this.state.clearAll
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "setShowClearAll", function (value) {
      _this.setState({
        showClearAll: value
      });
    });

    _this.state = {
      showFiltersList: props.filters.map(function (f) {
        return f.type;
      }),
      showClearAll: false,
      clearAll: false
    };
    return _this;
  }

  _createClass$1(FilterPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clearAll !== this.props.clearAll) {
        if (this.props.clearAll !== this.state.clearAll) {
          this.setState({
            clearAll: this.props.clearAll
          });
        }
      }

      var previousSelectedFilters = prevProps.filters.map(function (filter) {
        return filter.selectedList;
      });
      var currentSelectedFilters = this.props.filters.map(function (filter) {
        return filter.selectedList;
      });

      if (!_$1.isEqual(previousSelectedFilters.flat(), currentSelectedFilters.flat())) {
        if (currentSelectedFilters.flat().length === 0) {
          this.setShowClearAll(false);
        }
      }
    }
  }, {
    key: "isShowingAllFilters",
    value: function isShowingAllFilters() {
      return this.props.filters.length === this.state.showFiltersList.length;
    }
  }, {
    key: "onShowHideFilter",
    value: function onShowHideFilter(type, bShow) {
      var showFiltersList = _$1.cloneDeep(this.state.showFiltersList);

      if (bShow) {
        showFiltersList.push(type);
      } else {
        showFiltersList = showFiltersList.filter(function (s) {
          return s !== type;
        });
      }

      this.setState({
        showFiltersList: showFiltersList
      });
    }
  }, {
    key: "handleShowHideFilters",
    value: function handleShowHideFilters(e) {
      e.stopPropagation();
      var showFiltersList = this.isShowingAllFilters() ? [] : this.props.filters.map(function (f) {
        return f.type;
      });
      this.setState({
        showFiltersList: showFiltersList
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.closeFilter(false);
    }
  }, {
    key: "renderFilterByType",
    value: function renderFilterByType(filter) {
      var filterItem = null;
      var _this$state = this.state,
          clearAll = _this$state.clearAll,
          showClearAll = _this$state.showClearAll;

      if (filter.isSearchable) {
        filterItem = /*#__PURE__*/React__default.createElement(SearchFilter, {
          title: filter.title,
          placeholder: filter.placeholder,
          dropDownPlaceholder: filter.dropDownPlaceholder,
          type: filter.type,
          recentList: filter.recentList,
          onSearch: filter.onSearch,
          searchList: filter.searchList,
          selectedList: filter.selectedList,
          clearAll: clearAll,
          showClearAll: showClearAll,
          setShowClearAll: this.setShowClearAll,
          onSelectDeselect: filter.onSelectDeselect,
          isSearching: filter.isSearching,
          isFetching: filter.isFetching
        });
      } else {
        filterItem = /*#__PURE__*/React__default.createElement(CheckboxFilter, {
          title: filter.title,
          type: filter.type,
          filterList: filter.filterList,
          selectedList: filter.selectedList,
          clearAll: clearAll,
          showClearAll: showClearAll,
          setShowClearAll: this.setShowClearAll,
          onSelectDeselect: filter.onSelectDeselect,
          isFetching: filter.isFetching
        });
      }

      return filterItem;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          filters = _this$props.filters,
          toggleShowFilter = _this$props.toggleShowFilter,
          showCloseIcon = _this$props.showCloseIcon;
      var showClearAll = this.state.showClearAll;
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'filter-panel'
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "filter-panel-header"
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 22
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "heading"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "Filter"
      }), /*#__PURE__*/React__default.createElement("span", null, i18n.t('filterBy')), showClearAll && /*#__PURE__*/React__default.createElement("span", {
        className: "clear",
        onClick: this.clearAllFilters
      }, i18n.t('clearAll')))), showCloseIcon && /*#__PURE__*/React__default.createElement(_Col, {
        span: 2,
        className: "close",
        onClick: toggleShowFilter
      }, /*#__PURE__*/React__default.createElement(CloseOutlined$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter-panel-content"
      }, filters && filters.map(function (filter, idx) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: "filter-panel-item"
        }, _this2.renderFilterByType(filter));
      })));
    }
  }]);

  return FilterPanel;
}(Component);

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = /*#__PURE__*/createContext({});
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (process.env.NODE_ENV !== 'production') {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var keyframes = function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(React__default.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

var _default = AutosizeInput;

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty$1(_ref3, alignToControl(placement), '100%'), _defineProperty$1(_ref3, "backgroundColor", colors.neutral0), _defineProperty$1(_ref3, "borderRadius", borderRadius), _defineProperty$1(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty$1(_ref3, "marginBottom", spacing.menuGutter), _defineProperty$1(_ref3, "marginTop", spacing.menuGutter), _defineProperty$1(_ref3, "position", 'absolute'), _defineProperty$1(_ref3, "width", '100%'), _defineProperty$1(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/createContext({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  _inherits$1(MenuPlacer, _Component);

  var _super = _createSuper$n(MenuPlacer);

  function MenuPlacer() {
    var _this;

    _classCallCheck$1(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread$4(_objectSpread$4({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  _createClass$1(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  _inherits$1(MenuPortal, _Component2);

  var _super2 = _createSuper$n(MenuPortal);

  function MenuPortal() {
    var _this2;

    _classCallCheck$1(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  _createClass$1(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(Component);

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", _extends$1({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return jsx("div", {
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return jsx("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties$1(_ref, ["size"]);

  return jsx("svg", _extends$1({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("span", _extends$1({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0xJIiwiZmlsZSI6ImluZGljYXRvcnMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyB0eXBlIE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3gsIGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5pbXBvcnQgdHlwZSB7IENvbW1vblByb3BzLCBUaGVtZSB9IGZyb20gJy4uL3R5cGVzJztcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBEcm9wZG93biAmIENsZWFyIEljb25zXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgU3ZnID0gKHsgc2l6ZSwgLi4ucHJvcHMgfTogeyBzaXplOiBudW1iZXIgfSkgPT4gKFxuICA8c3ZnXG4gICAgaGVpZ2h0PXtzaXplfVxuICAgIHdpZHRoPXtzaXplfVxuICAgIHZpZXdCb3g9XCIwIDAgMjAgMjBcIlxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgIGNzcz17e1xuICAgICAgZGlzcGxheTogJ2lubGluZS1ibG9jaycsXG4gICAgICBmaWxsOiAnY3VycmVudENvbG9yJyxcbiAgICAgIGxpbmVIZWlnaHQ6IDEsXG4gICAgICBzdHJva2U6ICdjdXJyZW50Q29sb3InLFxuICAgICAgc3Ryb2tlV2lkdGg6IDAsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgY29uc3QgQ3Jvc3NJY29uID0gKHByb3BzOiBhbnkpID0+IChcbiAgPFN2ZyBzaXplPXsyMH0gey4uLnByb3BzfT5cbiAgICA8cGF0aCBkPVwiTTE0LjM0OCAxNC44NDljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDBsLTIuNjUxLTMuMDMwLTIuNjUxIDMuMDI5Yy0wLjQ2OSAwLjQ2OS0xLjIyOSAwLjQ2OS0xLjY5NyAwLTAuNDY5LTAuNDY5LTAuNDY5LTEuMjI5IDAtMS42OTdsMi43NTgtMy4xNS0yLjc1OS0zLjE1MmMtMC40NjktMC40NjktMC40NjktMS4yMjggMC0xLjY5N3MxLjIyOC0wLjQ2OSAxLjY5NyAwbDIuNjUyIDMuMDMxIDIuNjUxLTMuMDMxYzAuNDY5LTAuNDY5IDEuMjI4LTAuNDY5IDEuNjk3IDBzMC40NjkgMS4yMjkgMCAxLjY5N2wtMi43NTggMy4xNTIgMi43NTggMy4xNWMwLjQ2OSAwLjQ2OSAwLjQ2OSAxLjIyOSAwIDEuNjk4elwiIC8+XG4gIDwvU3ZnPlxuKTtcbmV4cG9ydCBjb25zdCBEb3duQ2hldnJvbiA9IChwcm9wczogYW55KSA9PiAoXG4gIDxTdmcgc2l6ZT17MjB9IHsuLi5wcm9wc30+XG4gICAgPHBhdGggZD1cIk00LjUxNiA3LjU0OGMwLjQzNi0wLjQ0NiAxLjA0My0wLjQ4MSAxLjU3NiAwbDMuOTA4IDMuNzQ3IDMuOTA4LTMuNzQ3YzAuNTMzLTAuNDgxIDEuMTQxLTAuNDQ2IDEuNTc0IDAgMC40MzYgMC40NDUgMC40MDggMS4xOTcgMCAxLjYxNS0wLjQwNiAwLjQxOC00LjY5NSA0LjUwMi00LjY5NSA0LjUwMi0wLjIxNyAwLjIyMy0wLjUwMiAwLjMzNS0wLjc4NyAwLjMzNXMtMC41Ny0wLjExMi0wLjc4OS0wLjMzNWMwIDAtNC4yODctNC4wODQtNC42OTUtNC41MDJzLTAuNDM2LTEuMTcgMC0xLjYxNXpcIiAvPlxuICA8L1N2Zz5cbik7XG5cbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gRHJvcGRvd24gJiBDbGVhciBCdXR0b25zXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuZXhwb3J0IHR5cGUgSW5kaWNhdG9yUHJvcHMgPSBDb21tb25Qcm9wcyAmIHtcbiAgLyoqIFRoZSBjaGlsZHJlbiB0byBiZSByZW5kZXJlZCBpbnNpZGUgdGhlIGluZGljYXRvci4gKi9cbiAgY2hpbGRyZW46IE5vZGUsXG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogYW55LFxuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuLFxuICAvKiogV2hldGhlciB0aGUgdGV4dCBpcyByaWdodCB0byBsZWZ0ICovXG4gIGlzUnRsOiBib29sZWFuLFxufTtcblxuY29uc3QgYmFzZUNTUyA9ICh7XG4gIGlzRm9jdXNlZCxcbiAgdGhlbWU6IHtcbiAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gICAgY29sb3JzLFxuICB9LFxufTogSW5kaWNhdG9yUHJvcHMpID0+ICh7XG4gIGxhYmVsOiAnaW5kaWNhdG9yQ29udGFpbmVyJyxcbiAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHBhZGRpbmc6IGJhc2VVbml0ICogMixcbiAgdHJhbnNpdGlvbjogJ2NvbG9yIDE1MG1zJyxcblxuICAnOmhvdmVyJzoge1xuICAgIGNvbG9yOiBpc0ZvY3VzZWQgPyBjb2xvcnMubmV1dHJhbDgwIDogY29sb3JzLm5ldXRyYWw0MCxcbiAgfSxcbn0pO1xuXG5leHBvcnQgY29uc3QgZHJvcGRvd25JbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IERyb3Bkb3duSW5kaWNhdG9yID0gKHByb3BzOiBJbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGN4LCBnZXRTdHlsZXMsIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2Ryb3Bkb3duSW5kaWNhdG9yJywgcHJvcHMpfVxuICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAge1xuICAgICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgICAnZHJvcGRvd24taW5kaWNhdG9yJzogdHJ1ZSxcbiAgICAgICAgfSxcbiAgICAgICAgY2xhc3NOYW1lXG4gICAgICApfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8RG93bkNoZXZyb24gLz59XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgY29uc3QgY2xlYXJJbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IENsZWFySW5kaWNhdG9yID0gKHByb3BzOiBJbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGN4LCBnZXRTdHlsZXMsIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2NsZWFySW5kaWNhdG9yJywgcHJvcHMpfVxuICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAge1xuICAgICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgICAnY2xlYXItaW5kaWNhdG9yJzogdHJ1ZSxcbiAgICAgICAgfSxcbiAgICAgICAgY2xhc3NOYW1lXG4gICAgICApfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8Q3Jvc3NJY29uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBTZXBhcmF0b3Jcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG50eXBlIFNlcGFyYXRvclN0YXRlID0geyBpc0Rpc2FibGVkOiBib29sZWFuIH07XG5cbmV4cG9ydCBjb25zdCBpbmRpY2F0b3JTZXBhcmF0b3JDU1MgPSAoe1xuICBpc0Rpc2FibGVkLFxuICB0aGVtZToge1xuICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICBjb2xvcnMsXG4gIH0sXG59OiBDb21tb25Qcm9wcyAmIFNlcGFyYXRvclN0YXRlKSA9PiAoe1xuICBsYWJlbDogJ2luZGljYXRvclNlcGFyYXRvcicsXG4gIGFsaWduU2VsZjogJ3N0cmV0Y2gnLFxuICBiYWNrZ3JvdW5kQ29sb3I6IGlzRGlzYWJsZWQgPyBjb2xvcnMubmV1dHJhbDEwIDogY29sb3JzLm5ldXRyYWwyMCxcbiAgbWFyZ2luQm90dG9tOiBiYXNlVW5pdCAqIDIsXG4gIG1hcmdpblRvcDogYmFzZVVuaXQgKiAyLFxuICB3aWR0aDogMSxcbn0pO1xuXG5leHBvcnQgY29uc3QgSW5kaWNhdG9yU2VwYXJhdG9yID0gKHByb3BzOiBJbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY3gsIGdldFN0eWxlcywgaW5uZXJQcm9wcyB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPHNwYW5cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2luZGljYXRvclNlcGFyYXRvcicsIHByb3BzKX1cbiAgICAgIGNsYXNzTmFtZT17Y3goeyAnaW5kaWNhdG9yLXNlcGFyYXRvcic6IHRydWUgfSwgY2xhc3NOYW1lKX1cbiAgICAvPlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBMb2FkaW5nXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgbG9hZGluZ0RvdEFuaW1hdGlvbnMgPSBrZXlmcmFtZXNgXG4gIDAlLCA4MCUsIDEwMCUgeyBvcGFjaXR5OiAwOyB9XG4gIDQwJSB7IG9wYWNpdHk6IDE7IH1cbmA7XG5cbmV4cG9ydCBjb25zdCBsb2FkaW5nSW5kaWNhdG9yQ1NTID0gKHtcbiAgaXNGb2N1c2VkLFxuICBzaXplLFxuICB0aGVtZToge1xuICAgIGNvbG9ycyxcbiAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gIH0sXG59OiB7XG4gIGlzRm9jdXNlZDogYm9vbGVhbixcbiAgc2l6ZTogbnVtYmVyLFxuICB0aGVtZTogVGhlbWUsXG59KSA9PiAoe1xuICBsYWJlbDogJ2xvYWRpbmdJbmRpY2F0b3InLFxuICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw2MCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgcGFkZGluZzogYmFzZVVuaXQgKiAyLFxuICB0cmFuc2l0aW9uOiAnY29sb3IgMTUwbXMnLFxuICBhbGlnblNlbGY6ICdjZW50ZXInLFxuICBmb250U2l6ZTogc2l6ZSxcbiAgbGluZUhlaWdodDogMSxcbiAgbWFyZ2luUmlnaHQ6IHNpemUsXG4gIHRleHRBbGlnbjogJ2NlbnRlcicsXG4gIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnLFxufSk7XG5cbnR5cGUgRG90UHJvcHMgPSB7IGRlbGF5OiBudW1iZXIsIG9mZnNldDogYm9vbGVhbiB9O1xuY29uc3QgTG9hZGluZ0RvdCA9ICh7IGRlbGF5LCBvZmZzZXQgfTogRG90UHJvcHMpID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGFuaW1hdGlvbjogYCR7bG9hZGluZ0RvdEFuaW1hdGlvbnN9IDFzIGVhc2UtaW4tb3V0ICR7ZGVsYXl9bXMgaW5maW5pdGU7YCxcbiAgICAgIGJhY2tncm91bmRDb2xvcjogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBib3JkZXJSYWRpdXM6ICcxZW0nLFxuICAgICAgZGlzcGxheTogJ2lubGluZS1ibG9jaycsXG4gICAgICBtYXJnaW5MZWZ0OiBvZmZzZXQgPyAnMWVtJyA6IG51bGwsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgfX1cbiAgLz5cbik7XG5cbmV4cG9ydCB0eXBlIExvYWRpbmdJY29uUHJvcHMgPSB7XG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogYW55LFxuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuLFxuICAvKiogV2hldGhlciB0aGUgdGV4dCBpcyByaWdodCB0byBsZWZ0ICovXG4gIGlzUnRsOiBib29sZWFuLFxufSAmIENvbW1vblByb3BzICYge1xuICAgIC8qKiBTZXQgc2l6ZSBvZiB0aGUgY29udGFpbmVyLiAqL1xuICAgIHNpemU6IG51bWJlcixcbiAgfTtcbmV4cG9ydCBjb25zdCBMb2FkaW5nSW5kaWNhdG9yID0gKHByb3BzOiBMb2FkaW5nSWNvblByb3BzKSA9PiB7XG4gIGNvbnN0IHsgY2xhc3NOYW1lLCBjeCwgZ2V0U3R5bGVzLCBpbm5lclByb3BzLCBpc1J0bCB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICAgIGNzcz17Z2V0U3R5bGVzKCdsb2FkaW5nSW5kaWNhdG9yJywgcHJvcHMpfVxuICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAge1xuICAgICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgICAnbG9hZGluZy1pbmRpY2F0b3InOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICBjbGFzc05hbWVcbiAgICAgICl9XG4gICAgPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezB9IG9mZnNldD17aXNSdGx9IC8+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MTYwfSBvZmZzZXQgLz5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXszMjB9IG9mZnNldD17IWlzUnRsfSAvPlxuICAgIDwvZGl2PlxuICApO1xufTtcbkxvYWRpbmdJbmRpY2F0b3IuZGVmYXVsdFByb3BzID0geyBzaXplOiA0IH07XG4iXX0= */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return jsx("div", _extends$1({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$1({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, jsx(Heading, _extends$1({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme;
      props.selectProps;
      var cleanProps = _objectWithoutProperties$1(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return jsx("div", _extends$1({
    css: getStyles('groupHeading', _objectSpread$1$1({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

function ownKeys$2$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$2(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme;
      _ref2.selectProps;
      var props = _objectWithoutProperties$1(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return jsx("div", {
    css: getStyles('input', _objectSpread$2$2({
      theme: theme
    }, props))
  }, jsx(_default, _extends$1({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

function ownKeys$3$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", innerProps, children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _objectSpread$3$1(_objectSpread$3$1({}, innerProps), {}, {
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _objectSpread$3$1({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className))
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

function ownKeys$4$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread$4$1(_objectSpread$4$1({}, components), props.components);
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread$3({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFJIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICB6SW5kZXg6IDk5OTksXG4gICAgICBib3JkZXI6IDAsXG4gICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgIGhlaWdodDogMSxcbiAgICAgIHdpZHRoOiAxLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICBwYWRkaW5nOiAwLFxuICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var A11yText = function A11yText(props) {
  return jsx("span", _extends$1({
    css: _ref
  }, props));
};

function DummyInput(_ref) {
  _ref.in;
      _ref.out;
      _ref.onExited;
      _ref.appear;
      _ref.enter;
      _ref.exit;
      var innerRef = _ref.innerRef;
      _ref.emotion;
      var props = _objectWithoutProperties$1(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

  return jsx("input", _extends$1({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/css$2({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      fontSize: 'inherit',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(0)'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NodeResolver = /*#__PURE__*/function (_Component) {
  _inherits$1(NodeResolver, _Component);

  var _super = _createSuper$m(NodeResolver);

  function NodeResolver() {
    _classCallCheck$1(this, NodeResolver);

    return _super.apply(this, arguments);
  }

  _createClass$1(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(findDOMNode(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(Component);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function _createSuper$1$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$1$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var canUseDOM = !!( window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock = /*#__PURE__*/function (_Component) {
  _inherits$1(ScrollLock, _Component);

  var _super = _createSuper$1$1(ScrollLock);

  function ScrollLock() {
    var _this;

    _classCallCheck$1(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.originalStyles = {};
    _this.listenerOptions = {
      capture: false,
      passive: false
    };
    return _this;
  }

  _createClass$1(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(Component);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function _createSuper$2$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$2$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock = /*#__PURE__*/function (_PureComponent) {
  _inherits$1(ScrollBlock, _PureComponent);

  var _super = _createSuper$2$1(ScrollBlock);

  function ScrollBlock() {
    var _this;

    _classCallCheck$1(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      touchScrollTarget: null
    };

    _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    };

    _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    };

    return _this;
  }

  _createClass$1(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return jsx("div", null, jsx("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), jsx(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? jsx(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(PureComponent);

function _createSuper$3$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$3$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ScrollCaptor = /*#__PURE__*/function (_Component) {
  _inherits$1(ScrollCaptor, _Component);

  var _super = _createSuper$3$1(ScrollCaptor);

  function ScrollCaptor() {
    var _this;

    _classCallCheck$1(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.isBottom = false;
    _this.isTop = false;
    _this.scrollTarget = void 0;
    _this.touchStart = void 0;

    _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };

    _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    };

    _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    };

    _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    };

    _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    };

    _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    };

    return _this;
  }

  _createClass$1(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no element is available to attach to
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(Component);

function ScrollCaptorSwitch(_ref) {
  var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      props = _objectWithoutProperties$1(_ref, ["isEnabled"]);

  return isEnabled ? /*#__PURE__*/React__default.createElement(ScrollCaptor, props) : props.children;
}

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled,
      tabSelectsValue = context.tabSelectsValue;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$1,
  valueContainer: valueContainerCSS
}; // Merge Utility

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$4$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$4$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$1 = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select = /*#__PURE__*/function (_Component) {
  _inherits$1(Select, _Component);

  var _super = _createSuper$4$1(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck$1(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.clearFocusValueOnUpdate = false;
    _this.commonProps = void 0;
    _this.components = void 0;
    _this.hasGroups = false;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.inputIsHiddenAfterUpdate = void 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.cacheComponents = function (components) {
      _this.components = defaultComponents({
        components: components
      });
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread$2$1(_objectSpread$2$1({}, actionMeta), {}, {
        name: name
      }));
    };

    _this.setValue = function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(_toConsumableArray$1(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      _this.onChange(null, {
        action: 'clear'
      });
    };

    _this.popValue = function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return _this.props.getOptionLabel(data);
    };

    _this.getOptionValue = function (data) {
      return _this.props.getOptionValue(data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getActiveDescendentId = function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    };

    _this.announceAriaLiveSelection = function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    };

    _this.announceAriaLiveContext = function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread$2$1(_objectSpread$2$1({}, context), {}, {
          label: _this.props['aria-label']
        }))
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if ( // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if ( // $FlowFixMe
      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    };

    _this.onKeyDown = function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.buildMenuOptions = function (props, selectValue) {
      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this.isOptionDisabled(option, selectValue);

        var isSelected = _this.isOptionSelected(option, selectValue);

        var label = _this.getOptionLabel(option);

        var value = _this.getOptionValue(option);

        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this.selectOption(option);
        };
        var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this.hasGroups) _this.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    };

    var _value = _props.value;
    _this.cacheComponents = memoizeOne(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_this));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(_value);

    _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function (newArgs, lastArgs) {
      var _ref6 = newArgs,
          _ref7 = _slicedToArray(_ref6, 2),
          newProps = _ref7[0],
          newSelectValue = _ref7[1];

      var _ref8 = lastArgs,
          _ref9 = _slicedToArray(_ref8, 2),
          lastProps = _ref9[0],
          lastSelectValue = _ref9[1];

      return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
    }).bind(_assertThisInitialized(_this));

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  _createClass$1(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var menuOptions = this.buildMenuOptions(this.props, selectValue);
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          tabSelectsValue = _this$props11.tabSelectsValue;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.setState({
        menuOptions: menuOptions,
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      }, function () {
        _this2.onMenuOpen();

        _this2.announceAriaLiveContext({
          event: 'menu',
          context: {
            tabSelectsValue: tabSelectsValue
          }
        });
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props12 = this.props,
          isMulti = _this$props12.isMulti,
          isSearchable = _this$props12.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var _this$props13 = this.props,
          pageSize = _this$props13.pageSize,
          tabSelectsValue = _this$props13.tabSelectsValue;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu',
          context: {
            tabSelectsValue: tabSelectsValue
          }
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus]),
          tabSelectsValue: tabSelectsValue
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread$2$1(_objectSpread$2$1({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props14 = this.props,
          isClearable = _this$props14.isClearable,
          isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this3 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this3.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "constructAriaLiveMessage",
    // ==============================
    // Renderers
    // ==============================
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props15 = this.props,
          options = _this$props15.options,
          menuIsOpen = _this$props15.menuIsOpen,
          inputValue = _this$props15.inputValue,
          screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isSearchable = _this$props16.isSearchable,
          inputId = _this$props16.inputId,
          inputValue = _this$props16.inputValue,
          tabIndex = _this$props16.tabIndex,
          form = _this$props16.form;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React__default.createElement(DummyInput, _extends$1({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          form: form,
          value: ""
        }, ariaAttributes));
      }

      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return /*#__PURE__*/React__default.createElement(Input, _extends$1({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          controlShouldRenderValue = _this$props17.controlShouldRenderValue,
          isDisabled = _this$props17.isDisabled,
          isMulti = _this$props17.isMulti,
          inputValue = _this$props17.inputValue,
          placeholder = _this$props17.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React__default.createElement(Placeholder, _extends$1({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return /*#__PURE__*/React__default.createElement(MultiValue, _extends$1({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: "".concat(_this4.getOptionValue(opt)).concat(index),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/React__default.createElement(SingleValue, _extends$1({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props18 = this.props,
          isDisabled = _this$props18.isDisabled,
          isLoading = _this$props18.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__default.createElement(ClearIndicator, _extends$1({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props19 = this.props,
          isDisabled = _this$props19.isDisabled,
          isLoading = _this$props19.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__default.createElement(LoadingIndicator, _extends$1({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React__default.createElement(IndicatorSeparator, _extends$1({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__default.createElement(DropdownIndicator, _extends$1({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props20 = this.props,
          captureMenuScroll = _this$props20.captureMenuScroll,
          inputValue = _this$props20.inputValue,
          isLoading = _this$props20.isLoading,
          loadingMessage = _this$props20.loadingMessage,
          minMenuHeight = _this$props20.minMenuHeight,
          maxMenuHeight = _this$props20.maxMenuHeight,
          menuIsOpen = _this$props20.menuIsOpen,
          menuPlacement = _this$props20.menuPlacement,
          menuPosition = _this$props20.menuPosition,
          menuPortalTarget = _this$props20.menuPortalTarget,
          menuShouldBlockScroll = _this$props20.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView,
          noOptionsMessage = _this$props20.noOptionsMessage,
          onMenuScrollToTop = _this$props20.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return /*#__PURE__*/React__default.createElement(Option, _extends$1({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            item.type;
                var group = _objectWithoutProperties$1(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return /*#__PURE__*/React__default.createElement(Group, _extends$1({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React__default.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/React__default.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React__default.createElement(MenuPlacer, _extends$1({}, commonProps, menuPlacementProps), function (_ref10) {
        var ref = _ref10.ref,
            _ref10$placerProps = _ref10.placerProps,
            placement = _ref10$placerProps.placement,
            maxHeight = _ref10$placerProps.maxHeight;
        return /*#__PURE__*/React__default.createElement(Menu, _extends$1({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React__default.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, /*#__PURE__*/React__default.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, /*#__PURE__*/React__default.createElement(MenuList, _extends$1({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React__default.createElement(MenuPortal, _extends$1({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props21 = this.props,
          delimiter = _this$props21.delimiter,
          isDisabled = _this$props21.isDisabled,
          isMulti = _this$props21.isMulti,
          name = _this$props21.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React__default.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React__default.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React__default.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/React__default.createElement("div", null, input);
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/React__default.createElement("input", {
          name: name,
          type: "hidden",
          value: _value2
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return /*#__PURE__*/React__default.createElement(A11yText, {
        "aria-live": "polite"
      }, /*#__PURE__*/React__default.createElement("span", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), /*#__PURE__*/React__default.createElement("span", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props22 = this.props,
          className = _this$props22.className,
          id = _this$props22.id,
          isDisabled = _this$props22.isDisabled,
          menuIsOpen = _this$props22.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React__default.createElement(SelectContainer, _extends$1({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React__default.createElement(Control, _extends$1({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React__default.createElement(ValueContainer, _extends$1({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React__default.createElement(IndicatorsContainer, _extends$1({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(Component);

Select.defaultProps = defaultProps$1;

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits$1(StateManager, _Component);

    var _super = _createSuper$l(StateManager);

    function StateManager() {
      var _this;

      _classCallCheck$1(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.select = void 0;
      _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      };

      _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      };

      _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      };

      _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      };

      _this.onMenuClose = function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      };

      return _this;
    }

    _createClass$1(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props;
            _this$props2.defaultInputValue;
            _this$props2.defaultMenuIsOpen;
            _this$props2.defaultValue;
            var props = _objectWithoutProperties$1(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return /*#__PURE__*/React__default.createElement(SelectComponent, _extends$1({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(Component), _class.defaultProps = defaultProps, _temp;
};

var index$1 = manageState(Select);

var config = {
  // Default type of number
  // Available options: 'number' (default), 'BigNumber', or 'Fraction'
  number: 'BigNumber',
  // Number of significant digits for BigNumbers
  precision: 20
};

var _create = create$8({
  addDependencies: addDependencies,
  divideDependencies: divideDependencies,
  bignumberDependencies: bignumberDependencies,
  multiplyDependencies: multiplyDependencies
}, config);
    _create.add;
    var divide = _create.divide,
    bignumber = _create.bignumber;
    _create.multiply;

//@ts-nocheck
var bytesInGb = bignumber('1073741824'); // 1GB in bytes (1024 x 1024 x 1024)

var bytesInKb = bignumber('1024');
var formatDataBytes = function formatDataBytes(totalSize) {
  if (!isNumber$1(totalSize)) return null;
  if (totalSize === 0) return '0 bytes';
  var assetTotalSizeInGb = divide(bignumber(totalSize), bytesInGb);
  var totalSizeUnit;

  if (assetTotalSizeInGb >= bignumber(1)) {
    totalSizeUnit = 'GB';
  } else if (assetTotalSizeInGb * bytesInKb >= bignumber(1)) {
    assetTotalSizeInGb *= 1024;
    totalSizeUnit = 'MB';
  } else {
    assetTotalSizeInGb = assetTotalSizeInGb * 1024 * 1024;
    totalSizeUnit = 'KB';
  }

  assetTotalSizeInGb = assetTotalSizeInGb.toFixed(2);
  return "".concat(+assetTotalSizeInGb.toString(), " ").concat(totalSizeUnit);
};

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Icons.ConfirmIcon;

var Composition$1 = /*#__PURE__*/function (_Component) {
  _inherits$1(Composition, _Component);

  var _super = _createSuper$k(Composition);

  function Composition(props) {
    var _this;

    _classCallCheck$1(this, Composition);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "onChangeDcpTransferStatus", function (newValue) {
      var _this$props = _this.props,
          workOrderNo = _this$props.workOrderNo,
          composition = _this$props.composition;

      _this.setState({
        dcpTransferStatus: newValue
      });

      _this.props.onChangeDcpTransferStatus(workOrderNo, composition.composition, newValue);
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleDcpTransferStatusUpdate", function () {
      var _this$props2 = _this.props,
          workOrderNo = _this$props2.workOrderNo,
          composition = _this$props2.composition;

      if (composition.dcpTransferStatus) {
        _this.props.updateDcpTransferStatusInServer(workOrderNo, composition.composition);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleFilterByComposition", function (filterKey, value) {
      if (_this.props.onFilterSelect && _this.props.enableFilters) _this.props.onFilterSelect(filterKey, value);
    });

    _defineProperty$1(_assertThisInitialized(_this), "onDcpDownloadsStatusClick", function () {
      var _this$props3 = _this.props,
          dcpDownloadsDetails = _this$props3.composition.dcpDownloadsDetails,
          onDcpDownloadsStatusClick = _this$props3.onDcpDownloadsStatusClick;
      onDcpDownloadsStatusClick(dcpDownloadsDetails);
    });

    _defineProperty$1(_assertThisInitialized(_this), "showDcpDownloadsStatusMessage", function () {
      var _this$props4 = _this.props,
          dcpDownloadsDetails = _this$props4.composition.dcpDownloadsDetails,
          appliances = _this$props4.appliances;
      var queued = 0,
          inProgress = 0,
          downloaded = 0,
          failed = 0,
          pending = 0,
          error = 0,
          unarchiving = 0,
          archived = 0,
          stalled = 0;
      (dcpDownloadsDetails || []).forEach(function (dcpDownloadDetails) {
        switch (dcpDownloadDetails.status) {
          case DcpDownloadStatuses.QUEUED:
            queued++;
            break;

          case DcpDownloadStatuses.IN_PROGRESS:
          case DcpDownloadStatuses.DOWNLOADING:
            inProgress++;
            break;

          case DcpDownloadStatuses.COMPLETED:
          case DcpDownloadStatuses.DOWNLOADED:
            downloaded++;
            break;

          case DcpDownloadStatuses.FAILED:
          case DcpDownloadStatuses.EXPIRED:
            failed++;
            break;

          case DcpDownloadStatuses.SCHEDULED:
            pending++;
            break;

          case DcpDownloadStatuses.ERROR:
            error++;
            break;

          case DcpDownloadStatuses.UNARCHIVING:
            unarchiving++;
            break;

          case DcpDownloadStatuses.ARCHIVED:
            archived++;
            break;

          case DcpDownloadStatuses.STALLED:
            stalled++;
            break;
        }
      });
      var doesPartnerHaveMultipleAppliances = appliances.length > 1;
      var statusMessages = [{
        message: doesPartnerHaveMultipleAppliances ? "".concat(queued, " Queued") : 'Queued',
        count: queued
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(inProgress, " Downloading") : 'Downloading',
        count: inProgress
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(downloaded, " Downloaded") : 'Downloaded',
        count: downloaded
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(failed, " Failed") : 'Failed',
        count: failed
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(pending, " Pending") : 'Pending',
        count: pending
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(error, " Errors") : 'Error in getting download status',
        count: error
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(unarchiving, " Unarchiving") : 'Unarchiving',
        count: unarchiving
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(archived, " Archived") : 'Archived',
        count: archived
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(stalled, " Stalled") : 'Stalled',
        count: stalled
      }];
      statusMessages = statusMessages.filter(function (statusMessage) {
        return statusMessage.count;
      });
      var consolidatedStatusMessage = i18n.t('downloadYetToStart');

      if (!isEmpty$1(statusMessages)) {
        consolidatedStatusMessage = statusMessages.map(function (statusMessage) {
          return statusMessage.message;
        }).join(', ');
      }

      return consolidatedStatusMessage;
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDcpDownloadsStatus", function () {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col dcp-download-status"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "cursor-pointer",
        onClick: function onClick() {
          return _this.onDcpDownloadsStatusClick();
        }
      }, _this.showDcpDownloadsStatusMessage()));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDcpTransferDownloadStatus", function () {
      var _this$props5 = _this.props,
          isAdminPortal = _this$props5.isAdminPortal,
          appliances = _this$props5.appliances;
      if (!isEmpty$1(appliances)) return _this.renderDcpDownloadsStatus();
      if (!isAdminPortal) return _this.renderDcpTransferStatusSelection();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col dcp-transfer-status"
      }, _this.getDcpTransferStatus());
    });

    _defineProperty$1(_assertThisInitialized(_this), "getDcpTransferStatus", function () {
      var composition = _this.props.composition;

      switch (composition.dcpTransferStatus) {
        case DcpTransferStatuses.STARTED:
          return i18n.t('dcpTransferStarted');

        case DcpTransferStatuses.COMPLETED:
          return i18n.t('dcpTransferCompleted');

        default:
          return i18n.t('dcpTransferNotStarted');
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDcpTransferStatusSelection", function () {
      var _this$props6 = _this.props,
          composition = _this$props6.composition;
          _this$props6.dcpTransferStatuses;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 dcp-transfer-selection"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-9 mr1 blue"
      }, /*#__PURE__*/React__default.createElement(DropDown, {
        showSearch: false,
        width: '100%',
        value: composition.dcpTransferStatus ? composition.dcpTransferStatus : '',
        onSelectDropDown: _this.onChangeDcpTransferStatus,
        placeholder: i18n.t('selectDcpTransferStatus'),
        list: DcpTransferStatusOptions
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "col col-2"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        className: "cursor-pointer right",
        onClick: _this.handleDcpTransferStatusUpdate,
        iconName: "ConfirmIcon"
      })));
    });

    _this.state = {
      dcpTransferStatus: props.composition.dcpTransferStatus
    };
    return _this;
  }

  _createClass$1(Composition, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dcpTransferStatus: nextProps.composition.dcpTransferStatus
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props7 = this.props,
          containerClassName = _this$props7.containerClassName,
          composition = _this$props7.composition;
          _this$props7.onFilterSelect;
          var enableFilters = _this$props7.enableFilters;
      var sizeList = composition.assets.filter(function (asset) {
        return asset.type !== 'assetmap' && asset.type !== 'pkl';
      }).map(function (asset) {
        return parseInt(asset.size);
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('clearfix', 'composition-item-container', containerClassName)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-7 text-ellipsis composition-name', {
          'filter clickable': enableFilters
        }),
        title: composition.cplName,
        onClick: function onClick() {
          return _this2.handleFilterByComposition(WorkOrderItemsFilterTagKeys.COMPOSITION, composition.cplName);
        }
      }, composition.cplName), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-3 composition-size')
      }, formatDataBytes(sum(sizeList))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-2 composition-download')
      }, this.renderDcpTransferDownloadStatus()));
    }
  }]);

  return Composition;
}(Component);

var cookie = new Cookies();
var get$1 = function get(key) {
  return cookie.get(key);
};

var getCookieKey = function getCookieKey(workOrderNo) {
  return "".concat(workOrderNo, "_DUPLICATION_STATE_INFO");
};

var get = function get(workOrderNo) {
  return get$1(getCookieKey(workOrderNo));
};

var workOrderStatuses = {
  assigned: 'Assigned',
  ready_to_process: 'Ready to process',
  in_process: 'In Process',
  fulfilled: 'Fulfilled',
  cancelled: 'Cancelled',
  download_in_progress: 'Download In Progress',
  download_failed: 'Download Failed',
  duplication_in_progress: 'Copy In Progress',
  shipment_pending: 'Pending shipment',
  shipment_completed: 'Completed',
  update_shipping_details: 'Delivery date has passed. Please update shipping details.',
  shipments_pending_cancellation: 'Shipments Pending Cancellation'
};
var defaultWorkOrderStatusState = {
  displayStatus: workOrderStatuses.assigned,
  actualStatus: WorkOrderStatuses.APPROVED,
  overallCplsDcpUploadStatus: DcpUploadStatuses.NOT_STARTED,
  overallCplsDcpDownloadStatus: DcpDownloadStatuses.NOT_STARTED,
  overallCplsDcpTransferStatus: null,
  enableDcpTransferStatusComponent: false
};
var APPROVED = WorkOrderStatuses.APPROVED;
var _enums$DcpDownloadSta = DcpDownloadStatuses,
    COMPLETED = _enums$DcpDownloadSta.COMPLETED,
    IN_PROGRESS = _enums$DcpDownloadSta.IN_PROGRESS;

var getStatusLabel = function getStatusLabel(status) {
  return workOrderStatuses[status];
};

var getWorkOrderStatus = function getWorkOrderStatus(label, value, dcpDownloadStatus, dcpTransferStatus, enableDcpTransferStatusComponent) {
  return {
    displayStatus: label,
    actualStatus: value,
    overallCplsDcpDownloadStatus: dcpDownloadStatus,
    overallCplsDcpTransferStatus: dcpTransferStatus,
    enableDcpTransferStatusComponent: enableDcpTransferStatusComponent
  };
};

var partnerWorkOrderStatusStates = {
  partnerWithoutAppliance: [getWorkOrderStatus(getStatusLabel('ready_to_process'), APPROVED, null, null, true), getWorkOrderStatus(getStatusLabel('in_process'), APPROVED, null, DcpTransferStatuses.STARTED, true), getWorkOrderStatus(getStatusLabel('shipment_pending'), APPROVED, null, DcpTransferStatuses.COMPLETED, true)],
  partnerWithAppliance: [getWorkOrderStatus(getStatusLabel('download_in_progress'), APPROVED, IN_PROGRESS, null, false), getWorkOrderStatus(getStatusLabel('ready_to_process'), APPROVED, COMPLETED, null, false)]
};

var isWorkOrderDuplicationInProgress = function isWorkOrderDuplicationInProgress(workOrderNo) {
  var duplicationStateInfo = get(workOrderNo);
  return !(isEmpty$1(duplicationStateInfo) || isEmpty$1(duplicationStateInfo.status));
};
/**
 * this is a Function that depends on paramters passed
 *
 * it will return WorkOrderStatus state
 *
 * which contains display status ,actual status and other overall statuses
 * @function getWorkOrderStatusState
 * @param appliances
 * @param {Workorder}
 * @param {overallWorkOrderStatus}
 * @param isWorkOrderDatePast:boolean
 * @returns {WorkOrderStatusState}
 */


var getWorkOrderStatusState = function getWorkOrderStatusState( // TODO: Update the appliances type once actual development of page is started
appliances, workOrder, overallWorkOrderCplsStatus, isWorkOrderDatePast) {
  var _workOrderStatusState;

  var workOrderStatusState = {};
  var workOrderNo = workOrder.workOrderNo,
      totalCopied = workOrder.totalCopied,
      totalShipped = workOrder.totalShipped,
      totalDrives = workOrder.totalDrives,
      totalDelivered = workOrder.totalDelivered;
  var dispatchedDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.DISPATCHED;
  });
  var deliveredDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.DELIVERED;
  });
  var cancelledDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.CANCELLED;
  });
  var pendingCancellationDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.PENDING_CANCELLATION;
  });
  var delivered_or_dispatched_drives = deliveredDrives.length + dispatchedDrives.length;

  if ([WorkOrderStatuses.CANCELLED, WorkOrderStatuses.REJECTED].includes(workOrder.status) || every(workOrder.shipments, {
    status: ShippingStatus.CANCELLED
  }) || every(workOrder.shipments, {
    status: ShippingStatus.REJECTED
  })) {
    workOrderStatusState.displayStatus = workOrderStatuses.cancelled;
    return workOrderStatusState;
  }

  if (!isEmpty$1(appliances) && overallWorkOrderCplsStatus.dcpDownloadStatus === DcpDownloadStatuses.FAILED) {
    workOrderStatusState.displayStatus = workOrderStatuses.download_failed;
    return workOrderStatusState;
  }

  if (pendingCancellationDrives.length > 0) {
    if (dispatchedDrives.length + cancelledDrives.length + pendingCancellationDrives.length === workOrder.shipments.length) {
      workOrderStatusState.displayStatus = workOrderStatuses.shipments_pending_cancellation;
      return workOrderStatusState;
    }

    if (!isWorkOrderDatePast && dispatchedDrives.length + cancelledDrives.length + pendingCancellationDrives.length < workOrder.shipments.length) {
      workOrderStatusState.displayStatus = [workOrderStatuses.update_shipping_details, workOrderStatuses.shipments_pending_cancellation].join(', ');
      return workOrderStatusState;
    }
  }

  if (isWorkOrderDatePast) {
    workOrderStatusState.displayStatus = workOrderStatuses.update_shipping_details;
    return workOrderStatusState;
  }

  if (totalDelivered !== null && totalDelivered !== void 0 ? totalDelivered : 0 > 0) {
    if (delivered_or_dispatched_drives + cancelledDrives.length === totalDrives) {
      workOrderStatusState.displayStatus = workOrderStatuses.shipment_completed;
    }
  } else if (totalShipped > 0) {
    workOrderStatusState.displayStatus = workOrderStatuses.shipment_pending;

    if (delivered_or_dispatched_drives + cancelledDrives.length === totalDrives) {
      workOrderStatusState.displayStatus = workOrderStatuses.shipment_completed;
    }
  } else if (totalCopied > 0 || isWorkOrderDuplicationInProgress(workOrderNo)) {
    workOrderStatusState = {
      displayStatus: workOrderStatuses.duplication_in_progress,
      actualStatus: workOrder.status,
      overallCplsDcpUploadStatus: DcpUploadStatuses.COMPLETED,
      overallCplsDcpDownloadStatus: DcpDownloadStatuses.COMPLETED,
      overallCplsDcpTransferStatus: null,
      enableDcpTransferStatusComponent: false
    };

    if (totalCopied === totalDrives) {
      workOrderStatusState.displayStatus = workOrderStatuses.shipment_pending;
    }
  } else {
    var partnerWithoutAppliance = partnerWorkOrderStatusStates.partnerWithoutAppliance,
        partnerWithAppliance = partnerWorkOrderStatusStates.partnerWithAppliance;
    var actualPartnerWithoutApplianceStatus = {
      actualStatus: workOrder.status,
      overallCplsDcpTransferStatus: overallWorkOrderCplsStatus.dcpTransferStatus
    };
    var actualPartnerWithApplianceStatus = {
      actualStatus: workOrder.status,
      overallCplsDcpTransferStatus: overallWorkOrderCplsStatus.dcpTransferStatus,
      overallCplsDcpDownloadStatus: overallWorkOrderCplsStatus.dcpDownloadStatus
    };

    if (isEmpty$1(appliances)) {
      var workOrderStatus = find(partnerWithoutAppliance, actualPartnerWithoutApplianceStatus);
      if (!isEmpty$1(workOrderStatus)) workOrderStatusState = workOrderStatus;
    } else {
      var _workOrderStatus = find(partnerWithAppliance, actualPartnerWithApplianceStatus);

      if (!isEmpty$1(_workOrderStatus)) workOrderStatusState = _workOrderStatus;
    }
  }

  return (_workOrderStatusState = workOrderStatusState) !== null && _workOrderStatusState !== void 0 ? _workOrderStatusState : defaultWorkOrderStatusState;
};

/**
 * This is a pure function acts based on the parameter passed (composition).
 *
 * Based on compositions available, the DCP download details are gathered and grouped based on the serial number.
 *
 * For each appliances, based on the DCP download status the count for each status are incremented.
 *
 * For those appliances whose count values are more than zero the dcpDownloadStatus value gets updated according to status available in enums.
 *
 * Finally thus based on the count, each of the appliances will have the values under below format.
 *
 * ```typescript
 *  const data = {
 *    [serialNumber]: {dcpDownloadStatus: value}
 *  }
 * ```
 *
 * @param { Array<Composition>}
 * @returns { dcpDownloadStatusByApplianceSerialNo }
 */

var getDcpDownloadStatusByApplianceSerialNo = function getDcpDownloadStatusByApplianceSerialNo(compositions) {
  var dcpDownloadDetailsAcrossCpls = [];
  var firstCplWithDcpDownloadsDetails = compositions.find(function (c) {
    return c.dcpDownloadsDetails.length > 0;
  });
  var serialNos = firstCplWithDcpDownloadsDetails ? map$1(firstCplWithDcpDownloadsDetails.dcpDownloadsDetails, 'serialNo') : [];
  var DcpDownloadStatuses$1 = DcpDownloadStatuses;
  var dcpDownloadStatusByApplianceSerialNo = {};
  compositions.forEach(function (composition) {
    if (isEmpty$1(composition.dcpDownloadsDetails)) {
      serialNos.forEach(function (serialNo) {
        dcpDownloadDetailsAcrossCpls.push({
          status: DcpDownloadStatuses$1.NOT_STARTED,
          serialNo: serialNo
        });
      });
    } else {
      composition.dcpDownloadsDetails.forEach(function (dcpDownloadDetails) {
        dcpDownloadDetailsAcrossCpls.push(dcpDownloadDetails);
      });
    }
  });
  var dcpDownloadNotStartedCount = 0;
  var dcpDownloadCompletedCount = 0;
  var dcpDownloadFailedCount = 0;
  var dcpDownloadPending = 0;
  var dcpDownloadError = 0;
  var dcpDownloadUnarchiving = 0;
  var dcpDownloadArchived = 0;
  var dcpDownloadStalled = 0;
  var groupedDcpDownloadDetailsByApplianceSerialNo = groupBy(dcpDownloadDetailsAcrossCpls, function (dcpDownloadDetails) {
    return dcpDownloadDetails.serialNo;
  });
  forEach$2(groupedDcpDownloadDetailsByApplianceSerialNo, function (dcpDownloadsDetails, serialNo) {
    dcpDownloadNotStartedCount = 0;
    dcpDownloadCompletedCount = 0;
    dcpDownloadFailedCount = 0;
    dcpDownloadPending = 0;
    dcpDownloadError = 0;
    dcpDownloadUnarchiving = 0;
    dcpDownloadArchived = 0;
    dcpDownloadStalled = 0;
    dcpDownloadsDetails.forEach(function (dcpDownloadDetails) {
      switch (dcpDownloadDetails && dcpDownloadDetails.status) {
        case DcpDownloadStatuses$1.NOT_STARTED:
          dcpDownloadNotStartedCount += 1;
          break;

        case DcpDownloadStatuses$1.QUEUED:
          break;

        case DcpDownloadStatuses$1.IN_PROGRESS:
          break;

        case DcpDownloadStatuses$1.COMPLETED:
          dcpDownloadCompletedCount += 1;
          break;

        case DcpDownloadStatuses$1.FAILED:
          dcpDownloadFailedCount += 1;
          break;

        case DcpDownloadStatuses$1.DOWNLOADED:
          dcpDownloadCompletedCount += 1;
          break;

        case DcpDownloadStatuses$1.DOWNLOADING:
          break;

        case DcpDownloadStatuses$1.EXPIRED:
          dcpDownloadFailedCount += 1;
          break;

        case DcpDownloadStatuses$1.SCHEDULED:
          dcpDownloadPending += 1;
          break;

        case DcpDownloadStatuses$1.ERROR:
          dcpDownloadError += 1;
          break;

        case DcpDownloadStatuses$1.UNARCHIVING:
          dcpDownloadUnarchiving += 1;
          break;

        case DcpDownloadStatuses$1.ARCHIVED:
          dcpDownloadArchived += 1;
          break;

        case DcpDownloadStatuses$1.STALLED:
          dcpDownloadStalled += 1;
          break;
      }
    });
    dcpDownloadStatusByApplianceSerialNo[serialNo] = {};
    var dcpDownloadsDetailsLen = dcpDownloadsDetails.length;

    if (dcpDownloadFailedCount > 0) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.FAILED;
    } else if (dcpDownloadNotStartedCount === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.NOT_STARTED;
    } else if (dcpDownloadCompletedCount === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.COMPLETED;
    } else if (dcpDownloadPending === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.PENDING;
    } else if (dcpDownloadError === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.ERROR;
    } else if (dcpDownloadUnarchiving === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.UNARCHIVING;
    } else if (dcpDownloadArchived === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.ARCHIVED;
    } else if (dcpDownloadStalled === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.STALLED;
    } else {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.IN_PROGRESS;
    }
  });
  return dcpDownloadStatusByApplianceSerialNo;
};
/**
 * This is a pure function that acts based on the parameter (compositions)
 *
 * We receive a array of compositions were we have an DCP upload status object
 *
 * Based on the status we will update the count of in_progress and completed data
 *
 * The status is purely related with DCP upload.
 *
 * Finally we receive the in progress count and completed count
 *
 * @external
 * @param {Array<Composition>}
 * @return {DcpUploadStatesCount}
 *
 * ```typescript
 * DcpUploadStatesCount = {
 *    dcpUploadInProgressCount: 0,
 *    dcpUploadCompletedCount: 0
 * }
 * ```
 */

var getDcpUploadStatesCount = function getDcpUploadStatesCount(compositions) {
  var dcpUploadInProgressCount = 0;
  var dcpUploadCompletedCount = 0;
  compositions.forEach(function (composition) {
    switch (composition.dcpUploadStatus) {
      case DcpUploadStatuses.IN_PROGRESS:
        dcpUploadInProgressCount += 1;
        break;

      case DcpUploadStatuses.COMPLETED:
        dcpUploadCompletedCount += 1;
        break;
    }
  });
  return {
    dcpUploadInProgressCount: dcpUploadInProgressCount,
    dcpUploadCompletedCount: dcpUploadCompletedCount
  };
};
/**
 * This is a pure function that solely depends on the parameters passed.
 *
 * This function updates the dcpUploadStatus as completed or in_progress based on the number of cpl and dcpUploadStatesCount.
 *
 * @external
 * @param {OverallWorkOrderCplsStatus} overallWorkOrderCplsStatus
 * @param {number} cplsLength
 * @param {DcpUploadStatesCount} dcpUploadStatesCount
 * @return {OverallWorkOrderCplsStatus}  {OverallWorkOrderCplsStatus}
 *
 *```typescript
 * const output = {
 *    dcpUploadStatus: 'in_progress', // Updates the status based on the count
 *    dcpDownloadStatus: 'downloading',
 *    dcpTransferStatus: 'completed';
 * }
 * ```
 */


var updateDcpUploadStatusInOverallWorkOrderCplsStatus = function updateDcpUploadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpUploadStatesCount) {
  var dcpUploadInProgressCount = dcpUploadStatesCount.dcpUploadInProgressCount,
      dcpUploadCompletedCount = dcpUploadStatesCount.dcpUploadCompletedCount;

  if (dcpUploadInProgressCount > 0) {
    overallWorkOrderCplsStatus.dcpUploadStatus = DcpUploadStatuses.IN_PROGRESS;
  } else if (dcpUploadCompletedCount === cplsLength) {
    overallWorkOrderCplsStatus.dcpUploadStatus = DcpUploadStatuses.COMPLETED;
  }

  return overallWorkOrderCplsStatus;
};
/**
 * This is a pure function that acts based on the composition parameter.
 *
 * Based on the dcpTransferStatus available in the composition the status count are updated
 *
 * The status is purely related with DCP upload.
 *
 * Finally we receive the DCP transfer started count and completed count
 *
 * @external
 * @param {Array<Composition>} compositions
 * @return {DcpTransferStatesCount} DcpTransferStatesCount
 *
 * ```typescript
 * const output = {
 *    cpTransferStartedCount: number,
 *    dcpTransferCompletedCount: number,
 * }
 * ```
 *
 */


var getDcpTransferStatesCount = function getDcpTransferStatesCount(compositions) {
  var dcpTransferStartedCount = 0;
  var dcpTransferCompletedCount = 0;
  compositions.forEach(function (composition) {
    switch (composition.dcpTransferStatus) {
      case DcpTransferStatuses.STARTED:
        dcpTransferStartedCount += 1;
        break;

      case DcpTransferStatuses.COMPLETED:
        dcpTransferCompletedCount += 1;
        break;
    }
  });
  return {
    dcpTransferStartedCount: dcpTransferStartedCount,
    dcpTransferCompletedCount: dcpTransferCompletedCount
  };
};
/**
 * This is the pure function that solely depends on the parameters passed.
 *
 * This function updates the dcpTransferStatus as completed or started based on the number of cpl and dcpTransferStatesCount
 *
 * @external
 * @param {OverallWorkOrderCplsStatus} overallWorkOrderCplsStatus
 * @param {number} cplsLength
 * @param {DcpTransferStatesCount} dcpTransferStatesCount
 * @return {OverallWorkOrderCplsStatus}  {OverallWorkOrderCplsStatus}
 *
 * ```typescript
 * const output = {
 *    dcpUploadStatus: 'in_progress',
 *    dcpDownloadStatus: 'downloading',
 *    dcpTransferStatus: 'completed',// Updates the status based on the count
 * }
 */


var updateDcpTransferStatusInOverallWorkOrderCplsStatus = function updateDcpTransferStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpTransferStatesCount) {
  var dcpTransferStartedCount = dcpTransferStatesCount.dcpTransferStartedCount,
      dcpTransferCompletedCount = dcpTransferStatesCount.dcpTransferCompletedCount;
  var DcpTransferStatuses$1 = DcpTransferStatuses;

  if (dcpTransferStartedCount > 0) {
    overallWorkOrderCplsStatus.dcpTransferStatus = DcpTransferStatuses$1.STARTED;
  } else if (dcpTransferCompletedCount > 0) {
    if (dcpTransferCompletedCount === cplsLength) {
      overallWorkOrderCplsStatus.dcpTransferStatus = DcpTransferStatuses$1.COMPLETED;
    } else {
      overallWorkOrderCplsStatus.dcpTransferStatus = DcpTransferStatuses$1.STARTED;
    }
  }

  return overallWorkOrderCplsStatus;
};
/**
 * This is a pure function acts based on the parameter
 *
 * It uses the previously computed @param {dcpDownloadStatusByApplianceSerialNo}
 *
 * For each appliances, based the DCP download details status the count for each status are incremented
 *
 * For those appliances whose values are more than zero the dcpDownloadStatus value gets updated according to status available in enums
 *
 * This is the pure function that solely depends on the parameters passed
 *
 * This function updates the dcpDownloadStatus as either one of the status based on the number of DcpDownloadStatusByApplianceSerialNo
 *
 * @external
 * @param {OverallWorkOrderCplsStatus} overallWorkOrderCplsStatus
 * @param {DcpDownloadStatusByApplianceSerialNo} dcpDownloadStatusByApplianceSerialNo
 * @return {OverallWorkOrderCplsStatus} OverallWorkOrderCplsStatus
 *
 * ```typescript
 * const output = {
 *    dcpUploadStatus: 'in_progress',
 *    dcpDownloadStatus: 'downloading', // Updates the status based on the count
 *    dcpTransferStatus: 'completed',
 * }
 * ```
 *
 */


var updateDcpDownloadStatusInOverallWorkOrderCplsStatus = function updateDcpDownloadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, dcpDownloadStatusByApplianceSerialNo) {
  var dcpDownloadNotStartedCount = 0;
  var dcpDownloadCompletedCount = 0;
  var dcpDownloadFailedCount = 0;
  var dcpDownloadPending = 0;
  var dcpDownloadError = 0;
  var DcpDownloadStatuses$1 = DcpDownloadStatuses;
  forEach$2(dcpDownloadStatusByApplianceSerialNo, function (item) {
    switch (item && item.dcpDownloadStatus) {
      case DcpDownloadStatuses$1.NOT_STARTED:
        dcpDownloadNotStartedCount += 1;
        break;

      case DcpDownloadStatuses$1.QUEUED:
        break;

      case DcpDownloadStatuses$1.IN_PROGRESS:
        break;

      case DcpDownloadStatuses$1.COMPLETED:
        dcpDownloadCompletedCount += 1;
        break;

      case DcpDownloadStatuses$1.DOWNLOADED:
        dcpDownloadCompletedCount += 1;
        break;

      case DcpDownloadStatuses$1.FAILED:
        dcpDownloadFailedCount += 1;
        break;

      case DcpDownloadStatuses$1.EXPIRED:
        dcpDownloadFailedCount += 1;
        break;

      case DcpDownloadStatuses$1.SCHEDULED:
        dcpDownloadPending += 1;
        break;

      case DcpDownloadStatuses$1.ERROR:
        dcpDownloadError += 1;
        break;
    }
  });
  var dcpDownloadStatusByApplianceSerialNoLen = keys(dcpDownloadStatusByApplianceSerialNo).length;

  if (dcpDownloadCompletedCount > 0) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.COMPLETED;
  } else if (dcpDownloadNotStartedCount === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.NOT_STARTED;
  } else if (dcpDownloadFailedCount === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.FAILED;
  } else if (dcpDownloadPending === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.PENDING;
  } else if (dcpDownloadError === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.ERROR;
  } else {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.IN_PROGRESS;
  }

  return overallWorkOrderCplsStatus;
};
/**
 * This the main function that returns the overall Download, Upload, Transfer Status based on the compositions parameter.
 *
 * This function uses the all above functions to compute the values,
 *
 * The function works totally based on the the DCP download and upload details that is available
 * under each compositions
 *
 * ```typescript
 *  const output = {
 *    dcpUploadStatus: 'in_progress',
 *    dcpDownloadStatus: 'downloading',
 *    dcpTransferStatus: 'completed';
 *  }
 * ```
 *
 * @external
 * @param {Array<Composition>} compositions
 * @return {OverallWorkOrderCplsStatus} OverallWorkOrderCplsStatus
 */


var getOverallWorkOrderCplsStatus = function getOverallWorkOrderCplsStatus(compositions) {
  var overallWorkOrderCplsStatus = {
    dcpUploadStatus: null,
    dcpDownloadStatus: null,
    dcpTransferStatus: null
  };
  var cplsLength = compositions.length;
  /**
   * A local scoped variable that holds count values
   * @returns {object} dcpUploadStatesCount
   *
   * ```typescript
   * const data = {
   *    dcpUploadInProgressCount: 0,
   *    dcpUploadCompletedCount: 0
   * }
   * ```
   */

  var dcpUploadStatesCount = getDcpUploadStatesCount(compositions);
  /**
   * A local scoped variable with count values
   * @param {object} overallWorkOrderCplsStatus the DCP upload, download, transfer status
   * @param {number} cplsLength number of compositions
   * @param {number} dcpUploadStatesCount is the local scoped variable with count
   * values as said above
   * @returns {null}
   */

  overallWorkOrderCplsStatus = updateDcpUploadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpUploadStatesCount);
  /**
   * A local scoped variable that collected the DCP download status based on the serial number
   */

  var dcpDownloadStatusByApplianceSerialNo = getDcpDownloadStatusByApplianceSerialNo(compositions);
  /**
   * A local scoped variable that updates the dcp download status
   */

  overallWorkOrderCplsStatus = updateDcpDownloadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, dcpDownloadStatusByApplianceSerialNo);
  /**
   * A local scoped variable that stores the dcp transfer count
   */

  var dcpTransferStatesCount = getDcpTransferStatesCount(compositions);
  /**
   * A local scoped variable that updates the dcp transfer status
   */

  overallWorkOrderCplsStatus = updateDcpTransferStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpTransferStatesCount);
  return overallWorkOrderCplsStatus;
};

var WorkOrderCplStatus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getDcpDownloadStatusByApplianceSerialNo: getDcpDownloadStatusByApplianceSerialNo,
  getOverallWorkOrderCplsStatus: getOverallWorkOrderCplsStatus
});

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DriveIcon = QubeIcons.DriveIcon,
    ApplianceIcon = QubeIcons.ApplianceIcon,
    InfoFilledIcon = QubeIcons.InfoFilledIcon,
    DownloadIcon = QubeIcons.DownloadIcon,
    AlertFilledIcon = QubeIcons.AlertFilledIcon;
    QubeIcons.ViewIcon;
    QubeIcons.ConfirmIcon; // Predefined set of work order status inferred from WorkOrderStatusState function

var infoStatuses = ['Assigned', 'Ready to process', 'In Process', 'Fulfilled', 'Download in progress', 'Copy in progress', 'Cancelled', 'Shipments pending cancellation'];
var failedActionMsgList = ['Download failed', 'Pending shipment', 'Delivery date has passed. Please update shipping details.', 'Delivery date has passed. Please update shipping details, Shipments pending cancellation'];

var WorkOrderCard = /*#__PURE__*/function (_Component) {
  _inherits$1(WorkOrderCard, _Component);

  var _super = _createSuper$j(WorkOrderCard);

  function WorkOrderCard() {
    var _this;

    _classCallCheck$1(this, WorkOrderCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      workOrderStatusState: null,
      viewCPLs: false
    });

    _defineProperty$1(_assertThisInitialized(_this), "setWorkOrderStatusState", function (workOrder) {
      var appliances = _this.getAppliances();

      var overallWorkOrderCplsStatus = getOverallWorkOrderCplsStatus(workOrder.compositions);
      var workOrderStatusState = getWorkOrderStatusState(appliances, workOrder, overallWorkOrderCplsStatus, _this.isPastDate(workOrder));

      _this.setState({
        workOrderStatusState: workOrderStatusState
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldShowCopyStatus", function () {
      var _this$props = _this.props,
          isAdminPortal = _this$props.isAdminPortal,
          showCopyStatus = _this$props.showCopyStatus;
      if (!showCopyStatus) return false;

      if (isAdminPortal) {
        var partner = _this.getPartnerByWorkOrderOrg();

        if (partner) {
          return partner.type === PartnerTypes.OFFLINE && partner.appliances.length > 0;
        } else {
          return false;
        }
      } else {
        return _this.props.shouldShowCopyStatus();
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "getPartnerByWorkOrderOrg", function () {
      var _this$props2 = _this.props,
          workOrder = _this$props2.workOrder,
          partners = _this$props2.partners;
      return partners.find(function (partner) {
        return partner.orgId === workOrder.org;
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "getProgressPercent", function (actual, total) {
      var value = parseInt(actual) / parseInt(total);
      return value * 100;
    });

    _defineProperty$1(_assertThisInitialized(_this), "getCancelledShipmentDrives", function (workOrder) {
      return workOrder.shipments.filter(function (shipment) {
        return shipment.status === ShippingStatus.CANCELLED;
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "getRejectedShipmentDrives", function (workOrder) {
      return workOrder.shipments.filter(function (shipment) {
        return shipment.status === ShippingStatus.REJECTED;
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "getWorkOrderStatus", function () {
      var _this$props$workOrder3;

      var workOrderStatusState = _this.state.workOrderStatusState;
      var workOrderStatus = workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus;

      if (!(workOrderStatusState !== null && workOrderStatusState !== void 0 && workOrderStatusState.displayStatus)) {
        var _this$props$workOrder;

        if ((_this$props$workOrder = _this.props.workOrder) !== null && _this$props$workOrder !== void 0 && _this$props$workOrder.status) {
          var _this$props$workOrder2;

          return /*#__PURE__*/React__default.createElement("span", {
            className: "work-order-status progress custom-status"
          }, (_this$props$workOrder2 = _this.props.workOrder) === null || _this$props$workOrder2 === void 0 ? void 0 : _this$props$workOrder2.status);
        }

        return null;
      }

      if (workOrderStatus === 'Completed') return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status completed"
      }, workOrderStatus);
      if (workOrderStatus === 'Cancelled') return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status cancelled"
      }, workOrderStatus);
      if (workOrderStatus === 'Assigned') return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status assigned"
      }, workOrderStatus);
      if (infoStatuses.includes(workOrderStatus)) return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status progress"
      }, workOrderStatus);
      return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status progress custom-status"
      }, (_this$props$workOrder3 = _this.props.workOrder) === null || _this$props$workOrder3 === void 0 ? void 0 : _this$props$workOrder3.status);
    });

    _defineProperty$1(_assertThisInitialized(_this), "handlePageFilters", function (type, data) {
      var partnerData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _this$props3 = _this.props,
          onFilterSelect = _this$props3.onFilterSelect,
          enableFilters = _this$props3.enableFilters;
      if (!enableFilters) return null;
      if (onFilterSelect) onFilterSelect(type, data, partnerData);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderIcon", function () {
      var _this$props$workOrder4 = _this.props.workOrder,
          shipments = _this$props$workOrder4.shipments,
          workOrderNo = _this$props$workOrder4.workOrderNo;
      var deliveryType = shipments[0].deliveryType;

      switch (deliveryType) {
        case WorkOrderDeliveryType.INTERNET:
          return /*#__PURE__*/React__default.createElement(ApplianceIcon, {
            "data-tip": true,
            "data-for": "".concat(workOrderNo, "-icon")
          });

        case WorkOrderDeliveryType.HARD_DRIVE:
        default:
          return /*#__PURE__*/React__default.createElement(DriveIcon, {
            "data-tip": true,
            "data-for": "".concat(workOrderNo, "-icon")
          });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderInfo", function () {
      var _this$props4 = _this.props,
          workOrder = _this$props4.workOrder,
          enableFilters = _this$props4.enableFilters;
      workOrder.shipments[0].deliveryType;
      _this.state.workOrderStatusState;

      var showCopyStatus = _this.shouldShowCopyStatus();

      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-top-info"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('work-order-number', {
          'no-filter': !enableFilters
        }),
        onClick: function onClick() {
          return _this.handlePageFilters(WorkOrderTagList.WORK_ORDER, workOrder.workOrderNo);
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Work Order:"), workOrder.workOrderNo), /*#__PURE__*/React__default.createElement("div", {
        className: "status-container"
      }, _this.getWorkOrderStatus()), showCopyStatus && workOrder.totalCopied > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "copy-status-container"
      }, i18n.t('copiedCount', {
        itemCount: workOrder.totalCopied
      }))), workOrder.orgName && workOrder.orgLocation && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-info"
      }, _this.renderWorkOrderCompanyInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-price-info"
      }, workOrder.bookingNo && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-booking-info"
      }, _this.renderWorkOrderBookingInfo()), workOrder.netAmount && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, workOrder.bookingNo && /*#__PURE__*/React__default.createElement("span", {
        className: "separator"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-price"
      }, "USD $", workOrder.netAmount))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderBookingInfo", function () {
      var _this$props5 = _this.props,
          workOrder = _this$props5.workOrder,
          enableFilters = _this$props5.enableFilters;
      var base_url = window.location.origin;
      var bookingRefLink = base_url + '/history/bookings/detail/' + workOrder.bookingNo;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('work-order-booking-number', {
          'no-filter': !enableFilters
        })
      }, /*#__PURE__*/React__default.createElement("span", null, "Booking:"), /*#__PURE__*/React__default.createElement("a", {
        className: "redirect-links",
        href: bookingRefLink,
        target: "_blank"
      }, workOrder.bookingNo));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderCompanyInfo", function () {
      var _this$props6 = _this.props,
          workOrder = _this$props6.workOrder,
          enableFilters = _this$props6.enableFilters;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-top-info"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('work-order-company-name', {
          'no-filter': !enableFilters
        }),
        onClick: function onClick() {
          return _this.handlePageFilters(WorkOrderTagList.PARTNER, workOrder.org, workOrder.orgName);
        }
      }, workOrder.orgName), /*#__PURE__*/React__default.createElement("span", {
        className: "separator"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-location"
      }, "".concat(workOrder.orgLocation.city, ", ").concat(workOrder.orgLocation.province, ", ").concat(workOrder.orgLocation.country, " "))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderDeliveryInfo", function () {
      var _this$props7 = _this.props,
          workOrder = _this$props7.workOrder;
          _this$props7.isAdminPortal;

      var cancelledShipmentDrives = _this.getCancelledShipmentDrives(workOrder);

      var rejectedShipmentDrives = _this.getRejectedShipmentDrives(workOrder);

      var deliveriesCount = workOrder.totalDelivered + workOrder.totalShipped;
      var minDeliveryOn = momentTZ.tz(moment(workOrder.deliverOn).add(1, 'seconds'), momentTZ.tz.guess()).format('DD MMM YYYY');
      var maxDeliveryOn = momentTZ.tz(moment(workOrder.maxDeliverOn).add(1, 'seconds'), momentTZ.tz.guess()).format('DD MMM YYYY');
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 delivery-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-shipping-status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix text-section"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col', {
          'col-6': cancelledShipmentDrives.length > 0 || rejectedShipmentDrives.length > 0,
          'col-4': cancelledShipmentDrives.length === 0 && rejectedShipmentDrives.length === 0
        })
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, deliveriesCount, "/", workOrder.totalDrives, "\xA0", i18n.t('deliveries')), cancelledShipmentDrives.length > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, ", \xA0", cancelledShipmentDrives.length, "\xA0", i18n.t('cancelled')), rejectedShipmentDrives.length > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, ", \xA0", rejectedShipmentDrives.length, "\xA0", i18n.t('rejected')), workOrder.totalShipped > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, ", \xA0", workOrder.totalShipped, "\xA0", i18n.t('shipped'))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col deliverOn', {
          'col-6': cancelledShipmentDrives.length > 0 || rejectedShipmentDrives.length > 0,
          'col-8': cancelledShipmentDrives.length === 0 && rejectedShipmentDrives.length === 0
        })
      }, workOrder.deliverOn && /*#__PURE__*/React__default.createElement("span", {
        className: "delivery-date"
      }, i18n.t('deliverBefore'), ":", /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, minDeliveryOn), workOrder.maxDeliverOn && minDeliveryOn !== maxDeliveryOn && /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, "".concat(i18n.t('to'), " ").toLowerCase(), maxDeliveryOn)))), /*#__PURE__*/React__default.createElement(ProgressBar, {
        percent: _this.getProgressPercent(deliveriesCount, workOrder.totalDrives),
        status: "success"
      })));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderViewAction", function () {
      var _this$props8 = _this.props,
          workOrderNo = _this$props8.workOrder.workOrderNo,
          onClickViewButton = _this$props8.onClickViewButton;
      return /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        onClick: function onClick() {
          return onClickViewButton(workOrderNo);
        },
        className: "view-button",
        buttonText: i18n.t('view')
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderActionMenuItems", function () {
      var _this$props9 = _this.props;
          _this$props9.showViewButton;
          var onTriggerDownload = _this$props9.onTriggerDownload,
          workOrderNo = _this$props9.workOrder.workOrderNo;
      return /*#__PURE__*/React__default.createElement(ActionMenu$1, {
        iconList: [{
          toolTipClass: 'actionMenuTooltip',
          toolTip: 'More Actions',
          iconName: 'MoreHorizontalIcon',
          dropdown: [{
            text: i18n.t('download'),
            onClick: function onClick() {
              return onTriggerDownload(workOrderNo);
            },
            hideMenuItem: false,
            icon: /*#__PURE__*/React__default.createElement(DownloadIcon, null)
          }]
        }]
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderCompositionHeader", function (isOtherComposition) {
      var className = isOtherComposition ? 'cpl-header other-compositions' : 'cpl-header';
      var headerText = isOtherComposition ? 'Other Compositions' : 'Compositions';
      return /*#__PURE__*/React__default.createElement("div", {
        className: className
      }, headerText);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDownloadAction", function () {
      var _this$props10 = _this.props,
          onTriggerDownload = _this$props10.onTriggerDownload,
          workOrderNo = _this$props10.workOrder.workOrderNo;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        "data-tip": true,
        "data-for": "".concat(workOrderNo, "-download"),
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        iconName: "DownloadIcon",
        onClick: onTriggerDownload(workOrderNo),
        className: "download-button"
      }), /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "".concat(workOrderNo, "-download"),
        place: "top",
        type: "dark",
        effect: "solid"
      }, "Download"));
    });

    _defineProperty$1(_assertThisInitialized(_this), "isPastDate", function (workOrder) {
      return _this.props.isPastDate(workOrder);
    });

    _defineProperty$1(_assertThisInitialized(_this), "getAppliances", function () {
      var _this$props11 = _this.props,
          isAdminPortal = _this$props11.isAdminPortal,
          _this$props11$account = _this$props11.account.user.appliances,
          appliances = _this$props11$account === void 0 ? [] : _this$props11$account;

      if (isAdminPortal) {
        var partner = _this.getPartnerByWorkOrderOrg();

        if (partner) return partner.appliances;
      }

      return appliances;
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderFirstComposition", function () {
      var _compositionToRender, _compositionToRender2;

      var _this$props12 = _this.props,
          enableFilters = _this$props12.enableFilters,
          isAdminPortal = _this$props12.isAdminPortal,
          workOrder = _this$props12.workOrder,
          dcpTransferStatuses = _this$props12.dcpTransferStatuses,
          updateDcpTransferStatusInServer = _this$props12.updateDcpTransferStatusInServer,
          account = _this$props12.account,
          onFilterSelect = _this$props12.onFilterSelect,
          onDcpDownloadsStatusClick = _this$props12.onDcpDownloadsStatusClick,
          changeDcpTransferStatus = _this$props12.changeDcpTransferStatus;
      var workOrderStatusState = _this.state.workOrderStatusState;
      var enableDcpTransferStatusComponent = workOrderStatusState && workOrderStatusState.enableDcpTransferStatusComponent;
      var firstComposition = workOrder.compositions[0];

      var _ref = firstComposition || {},
          movieId = _ref.movieId,
          movieName = _ref.movieName;

      var compositionToRender = firstComposition;

      if (movieId && movieName) {
        var matchingCompositions = workOrder.compositions.filter(function (comp) {
          return comp.movieId === movieId;
        });

        if (matchingCompositions.length > 0) {
          compositionToRender = matchingCompositions[0];
        }
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !compositionToRender.movieId && _this.renderCompositionHeader(false), /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-header"
      }, ((_compositionToRender = compositionToRender) === null || _compositionToRender === void 0 ? void 0 : _compositionToRender.movieName) && "".concat((_compositionToRender2 = compositionToRender) === null || _compositionToRender2 === void 0 ? void 0 : _compositionToRender2.movieName), compositionToRender.releaseDate && !isNaN(extractYear(compositionToRender.releaseDate)) && " (".concat(extractYear(compositionToRender.releaseDate), ")"), compositionToRender.language && ", ".concat(compositionToRender.language), /*#__PURE__*/React__default.createElement(Composition$1, {
        key: 0,
        enableFilters: enableFilters,
        account: account,
        workOrderNo: workOrder.workOrderNo,
        isAdminPortal: isAdminPortal,
        composition: compositionToRender,
        dcpTransferStatuses: dcpTransferStatuses,
        onChangeDcpTransferStatus: changeDcpTransferStatus,
        enableDcpTransferStatusComponent: enableDcpTransferStatusComponent,
        updateDcpTransferStatusInServer: updateDcpTransferStatusInServer,
        onFilterSelect: onFilterSelect,
        appliances: _this.getAppliances(),
        onDcpDownloadsStatusClick: onDcpDownloadsStatusClick
      })));
    });

    _defineProperty$1(_assertThisInitialized(_this), "CompositionView", function (composition, index) {
      var _this$props13 = _this.props,
          enableFilters = _this$props13.enableFilters,
          isAdminPortal = _this$props13.isAdminPortal,
          account = _this$props13.account,
          workOrder = _this$props13.workOrder,
          dcpTransferStatuses = _this$props13.dcpTransferStatuses,
          changeDcpTransferStatus = _this$props13.changeDcpTransferStatus,
          updateDcpTransferStatusInServer = _this$props13.updateDcpTransferStatusInServer,
          onFilterSelect = _this$props13.onFilterSelect,
          onDcpDownloadsStatusClick = _this$props13.onDcpDownloadsStatusClick;
      var workOrderStatusState = _this.state.workOrderStatusState;
      var enableDcpTransferStatusComponent = workOrderStatusState && workOrderStatusState.enableDcpTransferStatusComponent;
      return /*#__PURE__*/React__default.createElement(Composition$1, {
        key: index,
        enableFilters: enableFilters,
        account: account,
        workOrderNo: workOrder.workOrderNo,
        isAdminPortal: isAdminPortal,
        composition: composition,
        dcpTransferStatuses: dcpTransferStatuses,
        onChangeDcpTransferStatus: changeDcpTransferStatus,
        enableDcpTransferStatusComponent: enableDcpTransferStatusComponent,
        updateDcpTransferStatusInServer: updateDcpTransferStatusInServer,
        onFilterSelect: onFilterSelect,
        appliances: _this.getAppliances(),
        onDcpDownloadsStatusClick: onDcpDownloadsStatusClick
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderMoreCompositions", function () {
      var workOrder = _this.props.workOrder;
      var viewCPLs = _this.state.viewCPLs;
      var compositionsWithMovieName = [];
      var untitledCompositions = [];
      var displayedMovieNames = new Set();
      var firstComposition = null;
      viewCPLs && workOrder.compositions.slice(1).forEach(function (composition, index) {
        var movieName = composition.movieName,
            releaseDate = composition.releaseDate,
            language = composition.language,
            movieId = composition.movieId;
        var isMatching = workOrder.compositions[0].movieId === movieId && movieId !== undefined;

        if (isMatching) {
          compositionsWithMovieName.unshift(_this.CompositionView(composition, index));
        } else if (movieName && movieId) {
          if (!displayedMovieNames.has(movieId) && workOrder.compositions[0].movieId !== movieId) {
            displayedMovieNames.add(movieId);
            var matchingCompositions = workOrder.compositions.filter(function (comp) {
              return comp.movieId === movieId;
            });
            compositionsWithMovieName.push( /*#__PURE__*/React__default.createElement("div", {
              className: "cpl-header",
              key: index
            }, "".concat(movieName), releaseDate && !isNaN(extractYear(releaseDate)) && " (".concat(extractYear(releaseDate), ")"), language && ", ".concat(language), matchingCompositions.map(function (comp, idx) {
              return _this.CompositionView(comp, idx);
            })));
          }
        } else {
          untitledCompositions.push(_this.CompositionView(composition, index));
        }

        if (index === 0) {
          firstComposition = workOrder.compositions[0].movieId;
        }
      });
      return /*#__PURE__*/React__default.createElement("div", null, compositionsWithMovieName, untitledCompositions.length > 0 && firstComposition && _this.renderCompositionHeader(true), untitledCompositions);
    });

    _defineProperty$1(_assertThisInitialized(_this), "getAlertIconByStatus", function (status) {
      if (failedActionMsgList.includes(status)) return /*#__PURE__*/React__default.createElement(AlertFilledIcon, null); // By default return Info Icon

      return /*#__PURE__*/React__default.createElement(InfoFilledIcon, null);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderActionRequired", function () {
      var workOrderStatusState = _this.state.workOrderStatusState;
      var _this$props14 = _this.props;
          _this$props14.showViewButton;
          var workOrder = _this$props14.workOrder;
          _this$props14.showDownload;

      var isPastDate = _this.isPastDate(workOrder);

      if (!workOrderStatusState || !failedActionMsgList.includes(workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus)) return null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('wo-card-action-required')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1(lowerCase(workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus).split(' ').join('_'), {
          'past-work-order-status-text': isPastDate
        })
      }, (workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus) && _this.getAlertIconByStatus(workOrderStatusState.displayStatus), /*#__PURE__*/React__default.createElement("span", null, (workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus) && workOrderStatusState.displayStatus)));
    });

    return _this;
  }

  _createClass$1(WorkOrderCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var workOrder = this.props.workOrder;
      this.setWorkOrderStatusState(workOrder);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var workOrder = nextProps.workOrder;

      if (workOrder.overallWorkOrderStatusChangedInServer) {
        this.setWorkOrderStatusState(workOrder);
        this.props.setOverallWorkOrderStatusUpdatedInServer(workOrder.workOrderNo, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props15 = this.props,
          showViewButton = _this$props15.showViewButton,
          workOrder = _this$props15.workOrder,
          showDownload = _this$props15.showDownload;
      var _this$state = this.state;
          _this$state.workOrderStatusState;
          var viewCPLs = _this$state.viewCPLs;
      var isPastDate = this.isPastDate(workOrder);
      var _this$props$workOrder5 = this.props.workOrder,
          shipments = _this$props$workOrder5.shipments,
          workOrderNo = _this$props$workOrder5.workOrderNo;
      var deliveryType = shipments[0].deliveryType;
      return /*#__PURE__*/React__default.createElement("div", {
        id: workOrderNo,
        className: classNames$1('wo-card-container', {
          'past-order-card': isPastDate
        })
      }, this.renderActionRequired(), /*#__PURE__*/React__default.createElement("div", {
        className: "wo-card-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-icon"
      }, /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "".concat(workOrderNo, "-icon"),
        place: "top",
        type: "dark",
        effect: "solid"
      }, WorkOrderDeliveryLabel[deliveryType]), this.renderWorkOrderIcon()), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-info-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col-5 work-order-info"
      }, this.renderWorkOrderInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "col-5 work-order-delivery-info"
      }, this.renderWorkOrderDeliveryInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "col-2 action-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-view-action"
      }, showViewButton && this.renderViewAction()), /*#__PURE__*/React__default.createElement("div", {
        className: "action-item-list"
      }, showDownload && this.renderActionMenuItems())))), /*#__PURE__*/React__default.createElement("div", {
        className: "composition-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "composition-list"
      }, this.renderFirstComposition(), !viewCPLs && workOrder.compositions.length > 1 ? /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-more",
        onClick: function onClick() {
          return _this2.setState({
            viewCPLs: true
          });
        }
      }, "".concat(workOrder.compositions.length - 1, " More Compositions")) : null, this.renderMoreCompositions(), viewCPLs ? /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-more",
        onClick: function onClick() {
          return _this2.setState({
            viewCPLs: false
          });
        }
      }, "Less Compositions") : null))));
    }
  }]);

  return WorkOrderCard;
}(Component);
WorkOrderCard.defaultProps = {
  onFilterSelect: null,
  showDownload: true,
  showCopyStatus: false,
  showViewButton: false,
  enableFilters: true
};

var _excluded$1 = ["draggable", "draggableProps", "children"];
var SortIcon = Icons.SortIcon,
    SortAscendingIcon = Icons.SortAscendingIcon,
    SortDescendingIcon = Icons.SortDescendingIcon;

var TableComponent = function TableComponent(_ref) {
  var getTableProps = _ref.getTableProps,
      headerGroups = _ref.headerGroups,
      sortable = _ref.sortable,
      page = _ref.page,
      prepareRow = _ref.prepareRow,
      renderRowSubComponent = _ref.renderRowSubComponent,
      visibleColumns = _ref.visibleColumns,
      draggable = _ref.draggable,
      draggableProps = _ref.draggableProps;
  // Render the UI for your table
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tableWrapper"
  }, /*#__PURE__*/React__default.createElement("div", _extends$2({
    className: "table"
  }, getTableProps()), /*#__PURE__*/React__default.createElement("div", {
    className: "table-th-group"
  }, headerGroups.map(function (headerGroup, i) {
    return /*#__PURE__*/React__default.createElement("div", _extends$2({}, headerGroup.getHeaderGroupProps(), {
      key: "headerGroup".concat(i)
    }), headerGroup.headers.map(function (column, index) {
      return /*#__PURE__*/React__default.createElement("div", _extends$2({
        className: classNames$1('table-th', column.className)
      }, column.getHeaderProps(sortable && column.getSortByToggleProps()), {
        key: "hG".concat(i, "header").concat(index)
      }), /*#__PURE__*/React__default.createElement("span", null, column.render('Header')), sortable && column.canSort && /*#__PURE__*/React__default.createElement("span", null, column.isSortedDesc === undefined && /*#__PURE__*/React__default.createElement(SortIcon, {
        color: "#69788C"
      }), column.isSorted && column.isSortedDesc === true && /*#__PURE__*/React__default.createElement(SortDescendingIcon, null), column.isSorted && column.isSortedDesc === false && /*#__PURE__*/React__default.createElement(SortAscendingIcon, null)));
    }));
  })), /*#__PURE__*/React__default.createElement(TableBody, {
    draggable: draggable,
    draggableProps: draggableProps
  }, page.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: "page".concat(i)
    }, /*#__PURE__*/React__default.createElement("div", _extends$2({
      className: "table-body-row"
    }, row.getRowProps()), row.cells.map(function (cell, index) {
      return /*#__PURE__*/React__default.createElement("div", _extends$2({
        className: "table-cell"
      }, cell.getCellProps(), {
        key: "page".concat(i, "row").concat(index)
      }), cell.render('Cell'));
    })), row.isExpanded ? /*#__PURE__*/React__default.createElement("div", {
      className: "table-body-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      colSpan: visibleColumns.length
    }, renderRowSubComponent(row))) : null);
  }))));
};

function TableBody(_ref2) {
  var draggable = _ref2.draggable,
      draggableProps = _ref2.draggableProps,
      children = _ref2.children,
      rest = _objectWithoutProperties$2(_ref2, _excluded$1);

  if (draggable) {
    return /*#__PURE__*/React__default.createElement(ReactSortable, _extends$2({
      className: "table-tbody",
      animation: 150,
      forceFallback: true
    }, draggableProps), children);
  }

  return /*#__PURE__*/React__default.createElement("div", _extends$2({
    className: "table-tbody"
  }, rest), children);
}

var MarkerInfo = function MarkerInfo(_ref) {
  var markers = _ref.markers,
      compositionDuration = _ref.compositionDuration,
      getDurationFromEnd = _ref.getDurationFromEnd,
      compositionName = _ref.compositionName;

  var getCreditOffsets = function getCreditOffsets() {
    var markerDataStyle = 'qw-font-size-body qw-line-height-body qw-color-text-body';
    var creditOffset = [];

    if (markers.ffec) {
      creditOffset.push( /*#__PURE__*/React__default.createElement("p", {
        key: "ffec",
        className: markerDataStyle
      }, i18n.t('ffec'), " -", ' ', getDurationFromEnd(compositionDuration, markers.ffec), " (\u2212", getDuration(parseInt(markers.ffec, 10)), ")"));
    }

    if (markers.ffmc) {
      creditOffset.push( /*#__PURE__*/React__default.createElement("p", {
        key: "ffmc",
        className: markerDataStyle
      }, i18n.t('ffmc'), " -", ' ', getDurationFromEnd(compositionDuration, markers.ffmc), " (\u2212", getDuration(parseInt(markers.ffmc, 10)), ")"));
    }

    return creditOffset;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "marker-info"
  }, /*#__PURE__*/React__default.createElement(_Row, {
    className: "composition-name qw-mb-large qw-font-size-body qw-bold qw-line-height-body qw-color-text-body"
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 20,
    title: compositionName,
    className: "qw-truncate"
  }, compositionName), /*#__PURE__*/React__default.createElement(_Col, {
    span: 4,
    className: "qw-right-align"
  }, getDuration(compositionDuration))), /*#__PURE__*/React__default.createElement("p", {
    className: "marker-title qw-font-size-small qw-color-text-secondary-heading qw-line-height-small"
  }, "".concat(i18n.t('cplMarkers'), " / ").concat(i18n.t('creditsOffset'))), getCreditOffsets());
};

var CompositionAttributePopOver = function CompositionAttributePopOver(_ref) {
  var value = _ref.value,
      type = _ref.type,
      icon = _ref.icon;

  var getContent = function getContent() {
    var valueExists = _$1.isArray(value) && value.length > 1;
    var attributes = {
      language: 'Language',
      subtitleLanguage: 'Subtitle Language',
      mainCaption: 'Main Caption',
      ratings: 'Ratings',
      type: 'Type',
      dciStandard: 'DCI Standard',
      closedSubtitles: 'Closed Subtitles',
      frameRate: 'Frame Rate',
      audioFormats: 'Audio Formats',
      resolution: 'Resolution',
      closedCaptions: 'Closed Captions',
      stereoType: 'Stereo Type',
      aspectRatio: 'Aspect Ratio'
    };
    return /*#__PURE__*/React__default.createElement("div", {
      className: "qw-font-size-body qw-line-height-body"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: classNames$1('qw-color-text-heading', {
        'qw-mb-xx-small': valueExists
      })
    }, attributes[type]), valueExists ? value.map(function (val, idx) {
      return /*#__PURE__*/React__default.createElement("p", {
        key: idx,
        className: "attribute popover-attribute ".concat(type)
      }, val);
    }) : null);
  };

  return /*#__PURE__*/React__default.createElement(_Popover, {
    content: getContent(),
    placement: "bottom",
    overlayClassName: "cpl-popover"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "attribute qw-border qw-medium-rounded left qw-flex qw-items-center qw-justify-center qw-px-x-small qw-mr-xx-small ".concat(type, " ").concat(type === 'type' && value.toLowerCase())
  }, icon, _$1.isArray(value) && value.length > 1 ? "".concat(value[0], "...") : value));
};

var CompositionAttributes = function CompositionAttributes(_ref) {
  var composition = _ref.composition;

  var setOrderNumber = function setOrderNumber(attributes) {
    return attributes ? attributes.map(function (attribute) {
      return _$1.extend(attribute, {
        orderNumber: CPLAttributes[attribute.type]
      });
    }).filter(function (a) {
      return a.orderNumber;
    }) : [];
  };

  var renderAttributes = function renderAttributes() {
    var attributes = _$1.cloneDeep(composition.attributes);

    var attrs = [];

    _$1.orderBy(setOrderNumber(attributes), ['orderNumber']).map(function (attribute, idx) {
      var icon;
      var attrClass = 'qw-icon-x-small attr-icon qw-mr-xxx-small centered-icon';

      switch (attribute.type) {
        case 'language':
          {
            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "audio",
              size: "16",
              className: attrClass
            });
            break;
          }

        case 'subtitleLanguage':
          {
            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "subtitle",
              size: "16",
              className: attrClass
            });
            break;
          }

        case 'closedCaptions':
          {
            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "caption",
              size: "16",
              className: attrClass
            });
            break;
          }

        case 'ratings':
          {
            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "certifications",
              size: "16",
              className: attrClass
            });
            break;
          }

        default:
          {
            icon = null;
          }
      }

      if (!_$1.isEmpty(_$1.compact(attribute.value))) {
        attrs.push( /*#__PURE__*/React__default.createElement(CompositionAttributePopOver, {
          key: idx,
          type: attribute.type,
          value: attribute.value,
          icon: icon
        }));
      }
    });

    return attrs;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "qw-font-size-body qw-line-height-body"
  }, renderAttributes());
};

function naturalCompare(a, b) {
  var i,
      codeA,
      codeB = 1,
      posA = 0,
      posB = 0,
      alphabet = String.alphabet;

  function getCode(str, pos, code) {
    if (code) {
      for (i = pos; code = getCode(str, i), code < 76 && code > 65;) {
        ++i;
      }

      return +str.slice(pos - 1, i);
    }

    code = alphabet && alphabet.indexOf(str.charAt(pos));
    return code > -1 ? code + 76 : (code = str.charCodeAt(pos) || 0, code < 45 || code > 127) ? code : code < 46 ? 65 // -
    : code < 48 ? code - 1 : code < 58 ? code + 18 // 0-9
    : code < 65 ? code - 11 : code < 91 ? code + 11 // A-Z
    : code < 97 ? code - 37 : code < 123 ? code + 5 // a-z
    : code - 63;
  }

  if ((a += '') !== (b += '')) for (; codeB;) {
    codeA = getCode(a, posA++);
    codeB = getCode(b, posB++);

    if (codeA < 76 && codeB < 76 && codeA > 66 && codeB > 66) {
      codeA = getCode(a, posA, posA);
      codeB = getCode(b, posB, posA = i);
      posB = i;
    }

    if (codeA !== codeB) return codeA < codeB ? -1 : 1;
  }
  return 0;
}

var CompositionTheatreItem = function CompositionTheatreItem(_ref) {
  var showDCPInfo = _ref.showDCPInfo,
      showKDMInfo = _ref.showKDMInfo,
      theatre = _ref.theatre,
      index = _ref.index,
      cplInfo = _ref.cplInfo,
      getTheatreKdmStatus = _ref.getTheatreKdmStatus,
      renderDCPStatus = _ref.renderDCPStatus,
      showKdmValidity = _ref.showKdmValidity;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var showKDMInfoWrapper = function showKDMInfoWrapper(theatre, kdmGenerationCompleted) {
    setLoading(true);
    showKDMInfo(theatre, kdmGenerationCompleted).then(function () {
      setLoading(false);
    }).catch(function () {
      setLoading(false);
    });
  };

  var kdmStatus = {};
  var kdmIngestStatus = {};
  var kdmSummary = theatre.kdmSummary,
      timezone = theatre.timezone;

  var _ref2 = kdmSummary || {},
      validFrom = _ref2.validFrom,
      validTill = _ref2.validTill;

  var showValidity = showKdmValidity(kdmSummary);
  var isTheatreKdmBooking = cplInfo.isKdmBooking && kdmSummary;
  var kdmGenerationCompleted = isTheatreKdmBooking ? getTheatreKdmStatus(theatre, kdmStatus, kdmIngestStatus) : false;
  var theatreAddress = frameTheatreAddress(theatre);
  return /*#__PURE__*/React__default.createElement(_Row, {
    key: index,
    className: classNames$1('theatre-border qw-font-size-small qw-line-height-small qw-color-text-body qw-mb-x-small', {
      'qw-pointer-none': isLoading
    })
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 6,
    className: "qw-pl-x-large"
  }, theatre.name, theatreAddress && /*#__PURE__*/React__default.createElement("span", {
    className: "block qw-font-size-x-small qw-color-text-secondary-heading"
  }, theatreAddress), isTheatreKdmBooking && /*#__PURE__*/React__default.createElement("span", {
    className: "block qw-font-size-x-small qw-color-text-secondary-heading"
  }, i18n.t('screenCount', {
    count: theatre.screenCount
  }))), cplInfo.isDcpBooking && /*#__PURE__*/React__default.createElement(_Col, {
    span: 9,
    className: "qw-pl-x-small"
  }, renderDCPStatus(theatre), theatre.dcpIngestSummary && theatre.dcpIngestSummary.statuses && !_$1.isEmpty(theatre.dcpIngestSummary.statuses) && /*#__PURE__*/React__default.createElement("div", {
    className: "ingest_status_summary",
    onClick: function onClick() {
      return showDCPInfo(theatre);
    }
  }, renderIngestStatusSummary(theatre.dcpIngestSummary.statuses))), isTheatreKdmBooking && /*#__PURE__*/React__default.createElement(_Col, {
    span: 9,
    className: "kdm-summary qw-cursor-pointer qw-pl-x-small",
    onClick: function onClick() {
      return showKDMInfoWrapper(theatre, kdmGenerationCompleted);
    }
  }, isLoading && /*#__PURE__*/React__default.createElement("span", {
    className: "inline-block qw-align-middle qw-icon-x-small"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: "loading",
    size: "16",
    className: "qw-icon-x-small"
  })), renderKDMStatusSummary(kdmStatus, showValidity && {
    validFrom: validFrom,
    validTill: validTill,
    timezone: timezone,
    isMultiple: !validFrom && !validTill
  }, kdmIngestStatus)));
};

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var KDMTableContentItem = /*#__PURE__*/function (_Component) {
  _inherits$1(KDMTableContentItem, _Component);

  var _super = _createSuper$i(KDMTableContentItem);

  function KDMTableContentItem() {
    _classCallCheck$1(this, KDMTableContentItem);

    return _super.apply(this, arguments);
  }

  _createClass$1(KDMTableContentItem, [{
    key: "getKDMStatusDetails",
    value: function getKDMStatusDetails() {
      var theatre = this.props.theatre;
      var kdmScreens = theatre.screens && theatre.screens.filter(function (s) {
        return s.isKdmIssued;
      });
      var KDMStatus = theatre.kdms && theatre.kdms.map(function (kdm) {
        var id = kdm.id,
            validFrom = kdm.validFrom,
            validTill = kdm.validTill,
            _kdm$device = kdm.device,
            serial = _kdm$device.serial,
            manufacturer = _kdm$device.manufacturer,
            model = _kdm$device.model,
            screen = _kdm$device.screen,
            _kdm$status = kdm.status,
            type = _kdm$status.type,
            detail = _kdm$status.detail,
            subDetail = _kdm$status.subDetail,
            deliveryStatus = kdm.deliveryStatus;
        var statusType = type;
        var statusDetail = detail;
        var statusSubDetail = subDetail;
        var ingestStatus = '';

        if (type === KDMStatuses.emailed && !_$1.isEmpty(deliveryStatus) && !_$1.isEmpty(deliveryStatus.emails)) {
          statusDetail = deliveryStatus.emails.map(function (email) {
            return email.to;
          }).join(', ');
          statusSubDetail = '';
        }

        if (!_$1.isEmpty(deliveryStatus) && deliveryStatus.ingest && !_$1.isEmpty(deliveryStatus.ingest)) {
          ingestStatus = deliveryStatus.ingest.status;
        }

        return {
          model: model,
          serial: serial,
          manufacturer: manufacturer,
          kdmId: id,
          validFrom: validFrom,
          validTill: validTill,
          statusType: statusType,
          statusDetail: statusDetail,
          statusSubDetail: statusSubDetail,
          screenName: screen.name,
          screenId: screen.id,
          deliveryStatus: deliveryStatus,
          ingestStatus: ingestStatus
        };
      });
      kdmScreens && kdmScreens.forEach(function (s) {
        if (_$1.isEmpty(KDMStatus.find(function (d) {
          return d.screenId === s.id;
        }))) {
          KDMStatus.push({
            screenName: s.name,
            screenId: s.id,
            statusType: KDMStatuses.inprogress
          });
        }
      });
      return KDMStatus;
    }
  }, {
    key: "getStatusDetail",
    value: function getStatusDetail(statusType, statusDetail) {
      switch (statusType.toLowerCase()) {
        case KDMStatuses.emailed:
          return "to ".concat(statusDetail);

        case KDMStatuses.success:
          return null;

        default:
          return statusDetail;
      }
    }
  }, {
    key: "getDeviceInformation",
    value: function getDeviceInformation(deviceInfo) {
      var info = [];

      if (deviceInfo.manufacturer) {
        info.push(deviceInfo.manufacturer);
      }

      if (deviceInfo.model) {
        info.push(deviceInfo.model);
      }

      if (deviceInfo.serial) {
        info.push(deviceInfo.serial);
      }

      return info.join('::');
    }
  }, {
    key: "getDetail",
    value: function getDetail(KDMStatusDetails) {
      var _this = this;

      var timezone = this.props.theatre.timezone;
      var kdmStatusSummary = {
        emailed: 'Emailed',
        generated: 'Available',
        failed: 'Failed',
        inprogress: 'In Progress',
        action_required: 'Action Required',
        success: 'Available',
        unavailable: 'Unavailable',
        expired: 'Expired',
        expiring: 'Expiring'
      };
      return _$1.sortBy(KDMStatusDetails, ['screenName']).map(function (info, idx) {
        var subDetail = _this.getStatusDetail(info.statusType, info.statusDetail);

        return /*#__PURE__*/React__default.createElement(_Row, {
          key: idx,
          className: "kdm-table-content-detail qw-mt-x-small qw-pb-x-small qw-border-bottom"
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 8,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "screen-name qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.screenName ? info.screenName : 'Standby Server'), /*#__PURE__*/React__default.createElement("p", {
          className: "screen-info qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small"
        }, _this.getDeviceInformation(info))), /*#__PURE__*/React__default.createElement(_Col, {
          span: 7,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "kdm-details-status"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "kdm-summary__status ".concat(info.statusType.toLowerCase())
        }, kdmStatusSummary[info.statusType.toLowerCase()]), info.ingestStatus && /*#__PURE__*/React__default.createElement("p", {
          className: "kdm-summary__status ".concat(info.ingestStatus.toLowerCase())
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "status-meta__txt"
        }, "\u2022"), IngestStatusValues[info.ingestStatus.toLowerCase()])), /*#__PURE__*/React__default.createElement("p", {
          className: "status-detail qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small qw-truncate qw-pr-x-small",
          title: subDetail
        }, subDetail)), /*#__PURE__*/React__default.createElement(_Col, {
          span: 9,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "validity qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.validFrom && info.validTill ? "".concat(formatDateTime(momentTZ.tz(info.validFrom, timezone)), " to ").concat(formatDateTime(momentTZ.tz(info.validTill, timezone))) : null)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var KDMStatusDetails = this.getKDMStatusDetails();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-table-content"
      }, this.getDetail(KDMStatusDetails));
    }
  }]);

  return KDMTableContentItem;
}(Component);

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var KDMInfo = /*#__PURE__*/function (_Component) {
  _inherits$1(KDMInfo, _Component);

  var _super = _createSuper$h(KDMInfo);

  function KDMInfo(props) {
    var _this;

    _classCallCheck$1(this, KDMInfo);

    _this = _super.call(this, props);
    _this.state = {
      sendKDMEmail: '',
      sendKDMEmailError: '',
      sendEmail: false,
      sendKDMEmailSuccess: ''
    };
    return _this;
  }

  _createClass$1(KDMInfo, [{
    key: "getBasicInfo",
    value: function getBasicInfo() {
      return /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement("p", {
        className: "composition-name-label qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Composition Name"), /*#__PURE__*/React__default.createElement("p", {
        className: "composition-name qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal"
      }, this.props.composition.name));
    }
  }, {
    key: "getKDMTableHeader",
    value: function getKDMTableHeader() {
      return /*#__PURE__*/React__default.createElement(_Row, {
        className: "kdm-table-header qw-bold qw-mt-x-small qw-border-bottom qw-font-size-small qw-py-x-small qw-color-text-secondary-heading qw-font-weight-bold qw-line-height-small"
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "qw-px-x-small"
      }, "Screen"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 7,
        className: "qw-px-x-small"
      }, "Status"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 9,
        className: "qw-px-x-small"
      }, "Validity"));
    }
  }, {
    key: "getKDMTableContent",
    value: function getKDMTableContent() {
      var _this$props = this.props,
          composition = _this$props.composition,
          theatre = _this$props.theatre;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-table-content-wrapper",
        style: {
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React__default.createElement(KDMTableContentItem, {
        theatre: theatre,
        composition: composition
      }));
    }
  }, {
    key: "getTheatreInfo",
    value: function getTheatreInfo() {
      var theatre = this.props.theatre;
      var totalScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.length : 0;
      var kdmScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.filter(function (s) {
        return s.isKdmIssued;
      }).length : 0;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Theatre"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal"
      }, theatre.name), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small"
      }, frameTheatreAddress(theatre)), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small"
      }, "".concat(kdmScreenCount, "/").concat(totalScreenCount, " Screens")));
    }
  }, {
    key: "getKDMDeliveryEmail",
    value: function getKDMDeliveryEmail() {
      var kdmDeliveryMethods = this.props.theatre.kdmDeliveryMethods;
      var kdmDeliveryEmail = kdmDeliveryMethods && kdmDeliveryMethods.filter(function (method) {
        return method.type === 'Email';
      }).map(function (method) {
        return method.email;
      }).join(', ');
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "KDM Delivery Email"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal"
      }, _$1.isEmpty(kdmDeliveryEmail) ? 'None' : kdmDeliveryEmail));
    }
  }, {
    key: "validateSendEmail",
    value: function validateSendEmail() {
      var sendKDMEmail = this.state.sendKDMEmail;

      if (_$1.isEmpty(sendKDMEmail.replace(/ /g, ''))) {
        this.setState({
          sendKDMEmailError: 'Atleast one email is required'
        });
        return false;
      }

      var emails = sendKDMEmail.replace(/ /g, '').split(',');
      var invalidEmails = emails.filter(function (email) {
        return !validator.isEmail(email);
      });

      if (invalidEmails.length) {
        this.setState({
          sendKDMEmailError: 'Invalid Email'.concat(" - ", invalidEmails.join(', '), " ")
        });
        return false;
      }

      return true;
    }
  }, {
    key: "sendKDMEmail",
    value: function sendKDMEmail() {
      var _this2 = this;

      this.setState({
        sendKDMEmailError: '',
        sendKDMEmailSuccess: ''
      });

      if (this.validateSendEmail()) {
        this.setState({
          sendEmail: true
        });
        var payload = {};
        var _this$props2 = this.props,
            _this$props2$composit = _this$props2.composition,
            compositionName = _this$props2$composit.name,
            compositionId = _this$props2$composit.id,
            theatre = _this$props2.theatre;
        payload.facility_id = theatre.id;
        payload.composition_names = [compositionName];
        payload.composition_ids = [compositionId];
        payload.earliest_kdm_validity = _$1.minBy(theatre.kdms, 'validFrom').validFrom;
        payload.latest_kdm_validity = _$1.minBy(theatre.kdms, 'validTill').validTill;
        payload.kdms = {};
        payload.email_addresses = {
          to: this.state.sendKDMEmail.replace(/ /g, '').split(',')
        };
        this.props.sendKDMEmail([compositionId], [theatre.id], payload, function (status) {
          _this2.setState({
            sendEmail: false,
            sendKDMEmailError: !status ? 'Error in sending KDM Email' : '',
            sendKDMEmailSuccess: status ? "KDM Email's sent" : ''
          });
        });
      }
    }
  }, {
    key: "onChangeSendKDMEmail",
    value: function onChangeSendKDMEmail(e) {
      this.setState({
        sendKDMEmail: e.target.value,
        sendKDMEmailError: '',
        sendKDMEmailSuccess: ''
      });
    }
  }, {
    key: "hideKDMEmail",
    value: function hideKDMEmail(kdmGenerationCompleted, theatre, user) {
      return user.info.role_in_product.code === 'device manager' || !kdmGenerationCompleted || !theatre.kdms.find(function (kdm) {
        return [KDMStatuses.success, KDMStatuses.generated].includes(kdm.status.type.toLowerCase());
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          downloadKDMS = _this$props3.downloadKDMS,
          theatre = _this$props3.theatre;
      var _this$state = this.state,
          sendEmail = _this$state.sendEmail,
          sendKDMEmail = _this$state.sendKDMEmail,
          sendKDMEmailSuccess = _this$state.sendKDMEmailSuccess,
          sendKDMEmailError = _this$state.sendKDMEmailError;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-info"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-details-header"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-name-header-modal"
      }, this.getTheatreInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "composition-name-header-modal"
      }, this.getBasicInfo())), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-delivery-info-modal"
      }, this.getKDMDeliveryEmail()), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-option-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-overview-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-input-modal"
      }, /*#__PURE__*/React__default.createElement(_Input, {
        className: !_$1.isEmpty(sendKDMEmailError) ? 'qw-border-error' : '',
        value: sendKDMEmail,
        placeholder: "Enter Email Addresses",
        onChange: function onChange(e) {
          return _this3.onChangeSendKDMEmail(e);
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-status-modal"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small qw-color-text-red qw-mt-xx-small"
      }, sendKDMEmailError), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small qw-color-text-green qw-mt-xx-small"
      }, sendKDMEmailSuccess))), /*#__PURE__*/React__default.createElement("div", {
        className: "email-option-button-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-option"
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this3.sendKDMEmail();
        },
        className: "qw-cursor-pointer qw-flex qw-align-middle qw-justify-center"
      }, sendEmail ? /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "loader"
      }) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "email"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "email inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small"
      }, "Email")))))), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-option-view-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-option"
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this3.sendKDMEmail();
        },
        className: "qw-cursor-pointer qw-flex qw-align-middle qw-justify-center"
      }, sendEmail ? /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "loader"
      }) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "email"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "email inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small"
      }, "Email")))), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-download-option"
      }, /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return downloadKDMS(theatre.id);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "download"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "download-summary inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small"
      }, "Download"))))), /*#__PURE__*/React__default.createElement("div", null, this.getKDMTableHeader(), this.getKDMTableContent()));
    }
  }]);

  return KDMInfo;
}(Component);

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DCPTableContentItem = /*#__PURE__*/function (_Component) {
  _inherits$1(DCPTableContentItem, _Component);

  var _super = _createSuper$g(DCPTableContentItem);

  function DCPTableContentItem() {
    _classCallCheck$1(this, DCPTableContentItem);

    return _super.apply(this, arguments);
  }

  _createClass$1(DCPTableContentItem, [{
    key: "getDCPIngestStatus",
    value: function getDCPIngestStatus() {
      var theatre = this.props.theatre;
      var dcpAutoIngestStatus = theatre.dcpIngestDetails && theatre.dcpIngestDetails.map(function (dcpIngest) {
        var updatedAt = dcpIngest.updatedAt,
            _dcpIngest$device = dcpIngest.device,
            serial = _dcpIngest$device.serial,
            manufacturer = _dcpIngest$device.manufacturer,
            model = _dcpIngest$device.model,
            screen = _dcpIngest$device.screen,
            status = dcpIngest.status,
            completionPercentage = dcpIngest.completionPercentage;
        var ingestStatus = status;
        return {
          model: model,
          serial: serial,
          manufacturer: manufacturer,
          updatedAt: updatedAt,
          screenName: screen.name,
          screenId: screen.id,
          ingestStatus: ingestStatus,
          completionPercentage: completionPercentage
        };
      });
      return dcpAutoIngestStatus;
    }
  }, {
    key: "getDeviceInformation",
    value: function getDeviceInformation(deviceInfo) {
      var info = [];

      if (deviceInfo.manufacturer) {
        info.push(deviceInfo.manufacturer);
      }

      if (deviceInfo.model) {
        info.push(deviceInfo.model);
      }

      if (deviceInfo.serial) {
        info.push(deviceInfo.serial);
      }

      return info.join('::');
    }
  }, {
    key: "getDetail",
    value: function getDetail(dcpIngetStatus) {
      var _this = this;

      var timezone = this.props.theatre.timezone;
      return _$1.sortBy(dcpIngetStatus, ['screenName']).map(function (info, idx) {
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: idx,
          className: "dcp-table-content-detail qw-mt-x-small qw-pb-x-small qw-border-bottom"
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 8,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "screen-name qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.screenName ? info.screenName : 'Standby Server'), /*#__PURE__*/React__default.createElement("p", {
          className: "screen-info qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small"
        }, _this.getDeviceInformation(info))), /*#__PURE__*/React__default.createElement(_Col, {
          span: 7,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "dcp-details-status"
        }, info.ingestStatus && /*#__PURE__*/React__default.createElement("p", {
          className: "dcp-summary__status ".concat(info.ingestStatus.toLowerCase())
        }, IngestStatusValues[info.ingestStatus.toLowerCase()]))), /*#__PURE__*/React__default.createElement(_Col, {
          span: 9,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "validity qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.ingestStatus && info.ingestStatus.toLowerCase() === 'ingested' && info.updatedAt && "Ingested on ".concat(formatDateTime(momentTZ.tz(info.updatedAt, timezone))), info.ingestStatus && info.ingestStatus.toLowerCase() === 'ingestinprogress' && info.completionPercentage && "Ingesting... ".concat(Math.round(info.completionPercentage * 100) / 100, "%"), info.ingestStatus && !info.updatedAt && !info.completionPercentage && '-')));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var dcpIngetStatus = this.getDCPIngestStatus();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-table-content"
      }, this.getDetail(dcpIngetStatus));
    }
  }]);

  return DCPTableContentItem;
}(Component);

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DCPInfo = /*#__PURE__*/function (_Component) {
  _inherits$1(DCPInfo, _Component);

  var _super = _createSuper$f(DCPInfo);

  function DCPInfo() {
    _classCallCheck$1(this, DCPInfo);

    return _super.apply(this, arguments);
  }

  _createClass$1(DCPInfo, [{
    key: "getBasicInfo",
    value: function getBasicInfo() {
      var _this$props = this.props,
          name = _this$props.composition.name,
          theatre = _this$props.theatre;
      var _theatre$dcp$details$ = theatre.dcp.details.shippingDetails;
      _theatre$dcp$details$ = _theatre$dcp$details$ === void 0 ? {} : _theatre$dcp$details$;
      var trackingId = _theatre$dcp$details$.trackingId,
          trackingName = _theatre$dcp$details$.name;
      var totalScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.length : 0;
      var ingestScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.filter(function (s) {
        return s.isDcpAutoIngest;
      }).length : 0;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-info-details qw-mb-large"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-theatre-info-status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-name"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Theatre"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal"
      }, theatre.name), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-color-text-body qw-line-height-small qw-white-space-normal"
      }, frameTheatreAddress(theatre)), ingestScreenCount > 0 && /*#__PURE__*/React__default.createElement("p", {
        className: "dcp-ingest-meta"
      }, "Auto Inget in ".concat(ingestScreenCount, "/").concat(totalScreenCount, " Screens"))), /*#__PURE__*/React__default.createElement("div", {
        className: "tracking-info"
      }, trackingId && trackingName && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Tracking Info"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal"
      }, trackingName, " \u2022", trackingId)))), /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-info-composition-name qw-mb-large"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Composition Name"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal"
      }, name)));
    }
  }, {
    key: "renderShipmentStatuses",
    value: function renderShipmentStatuses(status) {
      var className = classNames$1('status-tag qw-mb-xxx-small', {
        'qw-warning': ShipmentStatuses.Pending === status,
        'qw-error': [ShipmentStatuses.AttemptFail, ShipmentStatuses.Exception].includes(status),
        'qw-success': ShipmentStatuses.Delivered === status,
        'qw-pending': [ShipmentStatuses.InfoReceived, ShipmentStatuses.InTransit, ShipmentStatuses.OutForDelivery].includes(status),
        'qw-waiting': ShipmentStatuses.Expired === status
      });
      return /*#__PURE__*/React__default.createElement(_Tag, {
        className: className
      }, ShipmentStatusValues[status.toLowerCase()]);
    }
  }, {
    key: "renderTimeline",
    value: function renderTimeline() {
      var _this = this;

      var _this$props$theatre$d = this.props.theatre.dcp.details.shippingDetails;
      _this$props$theatre$d = _this$props$theatre$d === void 0 ? {} : _this$props$theatre$d;
      var _this$props$theatre$d2 = _this$props$theatre$d.trackingInfo;
      _this$props$theatre$d2 = _this$props$theatre$d2 === void 0 ? {} : _this$props$theatre$d2;
      var _this$props$theatre$d3 = _this$props$theatre$d2.checkpoints,
          checkpoints = _this$props$theatre$d3 === void 0 ? [] : _this$props$theatre$d3;

      if (_$1.isEmpty(checkpoints)) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "qw-timeline"
      }, _$1.orderBy(checkpoints, ['checkpointTime'], ['desc']).map(function (checkpoint, idx) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: classNames$1('qw-timeline-item', {
            current: !idx
          })
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "qw-timeline-left qw-font-size-small qw-line-height-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "qw-color-text-heading qw-mb-xx-small"
        }, _this.convertCheckPointDate(checkpoint.checkpointTime, _this.props.theatre.timezone)), /*#__PURE__*/React__default.createElement("p", {
          className: "qw-color-text-secondary-body"
        }, _this.convertCheckPointTime(checkpoint.checkpointTime, _this.props.theatre.timezone))), /*#__PURE__*/React__default.createElement("div", {
          className: "qw-timeline-right"
        }, _this.renderShipmentStatuses(checkpoint.tag), checkpoint.message && /*#__PURE__*/React__default.createElement("p", {
          className: "qw-color-grey-1"
        }, checkpoint.message)));
      }));
    }
  }, {
    key: "convertCheckPointDate",
    value: function convertCheckPointDate(checkpointTime, timezone) {
      if (momentTZ(checkpointTime, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
        return momentTZ(checkpointTime).tz(timezone).format('DD MMM YYYY');
      }

      var date = checkpointTime.includes('T') ? checkpointTime.split('T')[0] : checkpointTime;
      return momentTZ(date).endOf('day').format('DD MMM YYYY');
    }
  }, {
    key: "convertCheckPointTime",
    value: function convertCheckPointTime(checkpointTime, timezone) {
      if (momentTZ(checkpointTime, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
        return momentTZ(checkpointTime).tz(timezone).format('hh:mmA');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          composition = _this$props2.composition,
          theatre = _this$props2.theatre;
      !_$1.isEmpty(theatre.screens) ? theatre.screens.filter(function (s) {
        return s.isDcpAutoIngest;
      }).length : 0;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-info qw-mt-x-small"
      }, this.getBasicInfo(), this.renderTimeline(), /*#__PURE__*/React__default.createElement("div", {
        className: "ingest-status-container"
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "ingest-table-header"
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "qw-px-x-small"
      }, "Screen"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 7,
        className: "qw-px-x-small"
      }, "Status"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 9,
        className: "qw-px-x-small"
      }, "Details")), /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-table-content-wrapper"
      }, /*#__PURE__*/React__default.createElement(DCPTableContentItem, {
        theatre: theatre,
        composition: composition
      }))));
    }
  }]);

  return DCPInfo;
}(Component);

var Composition = function Composition(props) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      loadingTheatreId = _useState2[0],
      setLoadingTheatreId = _useState2[1];

  var getDurationFromEnd = function getDurationFromEnd(compositionDuration, duration) {
    return getDuration(parseInt(compositionDuration, 10) - parseInt(duration, 10));
  };

  var showKdmValidity = function showKdmValidity(kdmSummary) {
    if (kdmSummary) {
      var statuses = Object.keys(kdmSummary.statuses);

      if (statuses.find(function (k) {
        return k.toLowerCase() === KDMStatuses.inprogress;
      })) {
        return statuses.length > 1;
      }

      return true;
    }

    return false;
  };

  var showViewCreditOffset = function showViewCreditOffset(composition) {
    var name = composition.name,
        markers = composition.markers,
        duration = composition.duration;
    props.showModal(i18n.t('creditOffset'), /*#__PURE__*/React__default.createElement(MarkerInfo, {
      compositionName: name,
      markers: markers,
      compositionDuration: duration,
      getDurationFromEnd: getDurationFromEnd
    }), '50%');
  };

  var showDCPInfo = function showDCPInfo(theatre) {
    var cpl = props.composition,
        loadTheatreDetails = props.loadTheatreDetails;
    setLoadingTheatreId(theatre.id);
    return loadTheatreDetails(theatre.id, cpl.id).then(function (data) {
      setLoadingTheatreId(null);
      var composition = props.composition,
          showModal = props.showModal;
      var updatedTheatre = data[0] && data[0].theatres.find(function (t) {
        return t.id === theatre.id;
      });
      showModal(i18n.t('dcpStatus'), /*#__PURE__*/React__default.createElement(DCPInfo, {
        composition: composition,
        theatre: updatedTheatre
      }), '70%');
    }).catch(function () {
      setLoadingTheatreId(null);
    });
  };

  var showKDMInfo = function showKDMInfo(theatre, kdmGenerationCompleted) {
    var cpl = props.composition,
        loadTheatreDetails = props.loadTheatreDetails;
    return loadTheatreDetails(theatre.id, cpl.id).then(function (data) {
      var composition = props.composition,
          sendKDMEmail = props.sendKDMEmail,
          showModal = props.showModal;
      var updatedTheatre = data[0] && data[0].theatres.find(function (t) {
        return t.id === theatre.id;
      });

      if (theatre.kdmSummary.statuses.hasOwnProperty(KDMStatuses.action_required)) {
        for (var i = 0; i < updatedTheatre.kdms.length; i++) {
          if (updatedTheatre.kdms[i].status.type == KDMStatuses.failed) {
            updatedTheatre.kdms[i].status.type = KDMStatuses.action_required;
          }
        }
      }

      showModal(i18n.t('kdmDetails'), /*#__PURE__*/React__default.createElement(KDMInfo, {
        composition: composition,
        theatre: updatedTheatre,
        kdmGenerationCompleted: kdmGenerationCompleted,
        downloadKDMS: downloadKDMS,
        sendKDMEmail: sendKDMEmail
      }), '70%');
    });
  };

  var getTheatreKdmStatus = function getTheatreKdmStatus(theatre, kdmStatus, kdmIngestStatus) {
    var kdmGenerationCompleted = true;
    var kdmIssuedScreenCount = 0;
    var kdmSummaryStatus = theatre.kdmSummary ? theatre.kdmSummary.statuses : [];
    var kdmIngestSummaryStatus = theatre.kdmSummary ? theatre.kdmSummary.ingest : {};
    [KDMStatuses.success, KDMStatuses.generated, KDMStatuses.emailed].forEach(function (key) {
      if (kdmSummaryStatus[key]) {
        kdmIssuedScreenCount += kdmSummaryStatus[key];
      }
    });
    Object.keys(kdmSummaryStatus).forEach(function (key) {
      var statusKey = key.toLowerCase();

      if (kdmStatus[statusKey]) {
        kdmStatus[statusKey] += kdmSummaryStatus[key];
      } else {
        kdmStatus[statusKey] = kdmSummaryStatus[key];
      }
    });

    if (kdmIngestSummaryStatus) {
      Object.keys(kdmIngestSummaryStatus).forEach(function (key) {
        var statusKey = key.toLowerCase();

        if (kdmIngestStatus[statusKey]) {
          kdmIngestStatus[statusKey] += kdmIngestSummaryStatus[key];
        } else {
          kdmIngestStatus[statusKey] = kdmIngestSummaryStatus[key];
        }
      });
    }

    if (kdmIssuedScreenCount && !!kdmStatus[KDMStatuses.inprogress]) {
      kdmGenerationCompleted = false;
    }

    return kdmGenerationCompleted;
  };

  var downloadKDMS = function downloadKDMS() {
    var composition = props.composition;
    props.downloadKDMs(composition.name, [composition.id], composition.theatres.map(function (t) {
      return t.id;
    }), downloadKdm);
  };

  var getDcpShipmentStatus = function getDcpShipmentStatus(dcpInfo) {
    var _dcpInfo$shippingDeta = dcpInfo.shippingDetails;
    _dcpInfo$shippingDeta = _dcpInfo$shippingDeta === void 0 ? {} : _dcpInfo$shippingDeta;
    var _dcpInfo$shippingDeta2 = _dcpInfo$shippingDeta.trackingInfo;
    _dcpInfo$shippingDeta2 = _dcpInfo$shippingDeta2 === void 0 ? {} : _dcpInfo$shippingDeta2;
    var status = _dcpInfo$shippingDeta2.status;

    switch (status) {
      case ShipmentStatuses.InfoReceived:
        return ShipmentStatuses.InTransit;

      case ShipmentStatuses.Pending:
        return DCPStatuses.dispatched;

      default:
        return status || DCPStatuses.dispatched;
    }
  };

  var getDcpStatus = function getDcpStatus(_ref) {
    var subDetail = _ref.subDetail,
        type = _ref.type;
    var status = subDetail || (type ? type.toLowerCase() : DCPStatuses.pending);

    switch (status) {
      case DCPStatuses.error:
      case DCPStatuses.expired:
        status = DCPStatuses.failed;
        break;

      case DCPStatuses.pending_cancellation:
        status = DCPStatuses.pending;
        break;

      case DCPStatuses.unarchiving:
        status = DCPStatuses.unarchiving;
        break;
    }

    return status;
  };

  var renderExpandToggle = function renderExpandToggle() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "qw-icon-medium left",
      onClick: props.toggleExpand
    }, props.expand ? /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "ChevronDown"
    }) : /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "ChevronRight"
    }));
  };

  var renderDCPStatus = function renderDCPStatus(theatre) {
    if (!theatre.dcp) return /*#__PURE__*/React__default.createElement("span", null, "\xA0");
    var _theatre$dcp = theatre.dcp,
        dcpStatus = _theatre$dcp.status,
        details = _theatre$dcp.details,
        deliveryType = _theatre$dcp.deliveryType;
    var status = getDcpStatus(dcpStatus);
    var statusText = {
      downloaded: 'Downloaded',
      pending: 'Pending',
      cancelled: 'Cancelled',
      dispatched: 'Shipped',
      pending_cancellation: 'Pending Cancellation',
      queued: 'Queued',
      failed: 'Failed',
      succeeded: 'Succeeded',
      executing: 'Downloading...',
      scheduled: 'Scheduled for Download',
      downloading: 'Downloading...',
      expired: 'Failed',
      intransit: 'In Transit',
      inforeceived: 'In Transit',
      outfordelivery: 'Out For Delivery',
      attemptfail: 'Delivery AttemptFail',
      delivered: 'Delivered',
      exception: 'Delivery Exception',
      unarchiving: 'Unarchiving',
      downloading_unarchiving: 'Downloading - Unarchiving',
      pending_fulfilment: 'Pending Fulfilment - Unarchiving',
      archived: 'Archived',
      downloading_archived: 'Downloading - Archived',
      pending_fulfilment_archived: 'Pending Fulfilment - Archived',
      stalled: 'Stalled',
      downloading_stalled: 'Downloading - Stalled',
      pending_fulfilment_stalled: 'Pending Fulfilment - Stalled'
    };

    if (status === DCPStatuses.dispatched) {
      status = getDcpShipmentStatus(details).toLowerCase();
    }

    var shippingInfo;
    var icon;
    var className = '';
    var onShowDCPInfo = null;
    var showStatus = '';
    var toolTip = null;
    var timeData = {};
    var toolTipId = "unarchival".concat(theatre.id).concat(Date.now());

    if (details) {
      switch (deliveryType) {
        case DCPDeliveryType.THEATRE_APPLIANCE:
          {
            var progress = details.progress,
                _status = details.status;

            if (_status === DCPStatuses.downloading) {
              shippingInfo = /*#__PURE__*/React__default.createElement("span", null, " ", parseInt(progress, 10), "%");
            }

            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "downloadProgress",
              size: "16",
              className: "inline"
            });
            break;
          }

        case DCPDeliveryType.PARTNERS:
          {
            var _ref2 = details || {},
                _ref2$shippingDetails = _ref2.shippingDetails;

            _ref2$shippingDetails = _ref2$shippingDetails === void 0 ? {} : _ref2$shippingDetails;
            var trackingId = _ref2$shippingDetails.trackingId,
                trackingName = _ref2$shippingDetails.name;

            if (trackingName && trackingId) {
              className = 'qw-cursor-pointer';

              onShowDCPInfo = function onShowDCPInfo() {
                return showDCPInfo(theatre);
              };

              shippingInfo = /*#__PURE__*/React__default.createElement("span", null, trackingName, " \u2022 ", trackingId);
            }

            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "drive",
              className: "inline"
            });
            break;
          }

        case DCPDeliveryType.ELECTRONIC:
          {
            var _ref3 = details || {},
                _ref3$shippingDetails = _ref3.shippingDetails;

            _ref3$shippingDetails = _ref3$shippingDetails === void 0 ? {} : _ref3$shippingDetails;
            var _trackingId = _ref3$shippingDetails.trackingId,
                _trackingName = _ref3$shippingDetails.name;

            if (_trackingName && _trackingId) {
              shippingInfo = /*#__PURE__*/React__default.createElement("span", null, _trackingName, " \u2022 ", _trackingId);
            }

            icon = /*#__PURE__*/React__default.createElement(AppIcon, {
              name: "satellite",
              className: "inline"
            });
            break;
          }

        default:
          shippingInfo = '';
      }
    }

    if (status === DCPStatuses.unarchiving) {
      switch (deliveryType) {
        case DCPDeliveryType.ELECTRONIC:
          status = DCPStatuses.downloading_unarchiving;
          break;

        case DCPDeliveryType.PARTNERS:
          status = DCPStatuses.pending_fulfilment;
          break;
      }

      showStatus = /*#__PURE__*/React__default.createElement("span", {
        "data-tip": true,
        "data-for": toolTipId,
        className: "qw-bold dcp-unarchiving qw-mb-small qw-align-middle"
      }, statusText[status]);

      if (details.unarchivalETAInMinutes) {
        timeData = formatMinutesToHours(details.unarchivalETAInMinutes);
      } else {
        timeData.hours = 12;
      }

      toolTip = /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: toolTipId,
        place: "top",
        type: "dark",
        effect: "solid"
      }, /*#__PURE__*/React__default.createElement("span", null, i18n.t('unarchivalMayTake'), timeData.hours ? i18n.t('hourCount', {
        count: timeData.hours
      }) : '', timeData.hours && timeData.minutes ? 'and' : '', timeData.minutes ? i18n.t('minuteCount', {
        count: timeData.minutes
      }) : '', !details.unarchivalETAInMinutes === 12 ? i18n.t('fromTimeOfBooking') : '', "."));
    } else if (status === DCPStatuses.archived) {
      switch (deliveryType) {
        case DCPDeliveryType.ELECTRONIC:
          status = DCPStatuses.downloading_archived;
          break;

        case DCPDeliveryType.PARTNERS:
          status = DCPStatuses.pending_fulfilment_archived;
          break;
      }

      showStatus = /*#__PURE__*/React__default.createElement("span", {
        className: "qw-bold dcp-archived qw-mb-small qw-align-middle"
      }, statusText[status]);
    } else if (status === DCPStatuses.stalled) {
      switch (deliveryType) {
        case DCPDeliveryType.ELECTRONIC:
          status = DCPStatuses.downloading_stalled;
          break;

        case DCPDeliveryType.PARTNERS:
          status = DCPStatuses.pending_fulfilment_stalled;
          break;
      }

      showStatus = /*#__PURE__*/React__default.createElement("span", {
        className: "qw-bold dcp-stalled qw-mb-small qw-align-middle"
      }, statusText[status]);
    } else {
      showStatus = /*#__PURE__*/React__default.createElement("span", {
        className: "qw-bold dcp-".concat(status.toLowerCase(), " qw-mb-small qw-align-middle")
      }, statusText[status]);
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: className,
      onClick: onShowDCPInfo
    }, icon, showStatus, toolTip, loadingTheatreId === theatre.id && /*#__PURE__*/React__default.createElement("span", {
      className: "inline-block"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "loading",
      size: "16"
    })), shippingInfo && /*#__PURE__*/React__default.createElement("span", {
      className: classNames$1('block', {
        'qw-pl-x-large': icon
      })
    }, shippingInfo));
  };

  var renderTheatreInfo = function renderTheatreInfo(cplInfo) {
    var composition = props.composition;
    return composition.theatres.sort(function (a, b) {
      return naturalCompare(a.name.toLowerCase(), b.name.toLowerCase());
    }).map(function (theatre, idx) {
      return /*#__PURE__*/React__default.createElement(CompositionTheatreItem, {
        theatre: theatre,
        key: idx,
        index: idx,
        cplInfo: cplInfo,
        getTheatreKdmStatus: getTheatreKdmStatus,
        renderDCPStatus: renderDCPStatus,
        showKDMInfo: showKDMInfo,
        showDCPInfo: showDCPInfo,
        showKdmValidity: showKdmValidity
      });
    });
  };

  var renderKdmOptions = function renderKdmOptions(_ref4) {
    _ref4.kdmStatus;
        _ref4.theatreCount;
        var kdmGenerationCompleted = _ref4.kdmGenerationCompleted,
        showKdmDownloadOption = _ref4.showKdmDownloadOption;
    if (!kdmGenerationCompleted || !showKdmDownloadOption) return;
    var theatre = props.composition.theatres[0];
    return /*#__PURE__*/React__default.createElement("span", {
      className: "inline-block"
    }, /*#__PURE__*/React__default.createElement(_Popover, {
      content: i18n.t('downloadKdms'),
      overlayClassName: "cpl-popover qw-font-size-body qw-line-height-body"
    }, /*#__PURE__*/React__default.createElement("span", {
      onClick: downloadKDMS,
      className: "qw-justify-center qw-cursor-pointer qw-px-xx-small"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "download",
      size: "20",
      className: "inline"
    }))), /*#__PURE__*/React__default.createElement(_Popover, {
      content: i18n.t('emailKDMS'),
      overlayClassName: "cpl-popover qw-font-size-body qw-line-height-body"
    }, /*#__PURE__*/React__default.createElement("span", {
      onClick: function onClick() {
        return showKDMInfo(theatre, kdmGenerationCompleted);
      },
      className: "qw-justify-center qw-cursor-pointer qw-px-xx-small"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "email",
      size: "20",
      className: "inline"
    }))));
  };

  var isAttributesAvailable = function isAttributesAvailable() {
    var _props$composition = props.composition;
    _props$composition = _props$composition === void 0 ? {} : _props$composition;
    var attributes = _props$composition.attributes;

    if (!attributes || _$1.isEmpty(attributes)) {
      return false;
    }

    var dataCount = 0;
    var displayAttrArray = Object.keys(CPLAttributes);
    Object.keys(attributes).forEach(function (attr) {
      if (attributes[attr].value && displayAttrArray.includes(attributes[attr].type)) {
        dataCount += 1;
      }
    });
    return dataCount > 0;
  };

  var composition = props.composition;
  var isMarkerAvailable = !_$1.isEmpty(composition.markers) && (composition.markers.ffec || composition.markers.ffmc);
  var cplInfo = getCplInfo(composition.theatres);
  var kdmInfo = cplInfo.isKdmBooking ? getKDMSummaryData(props) : {};
  return /*#__PURE__*/React__default.createElement(_Card, {
    className: "composition-card qw-m-small",
    bordered: false
  }, /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(_Col, {
    span: 22
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "name qw-color-text-body qw-font-size-body qw-bold qw-line-height-body qw-truncate",
    title: composition.name
  }, composition.name)), /*#__PURE__*/React__default.createElement(_Col, {
    span: 2
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "duration qw-right-align qw-color-text-body qw-font-size-body qw-bold qw-line-height-body"
  }, composition.duration ? getDuration(composition.duration) : null))), (isMarkerAvailable || isAttributesAvailable) && /*#__PURE__*/React__default.createElement(_Row, {
    className: "qw-mt-x-small"
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 20
  }, isAttributesAvailable ? /*#__PURE__*/React__default.createElement(CompositionAttributes, {
    composition: composition
  }) : /*#__PURE__*/React__default.createElement("span", null, "\xA0")), isMarkerAvailable && /*#__PURE__*/React__default.createElement(_Col, {
    span: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return showViewCreditOffset(composition);
    },
    className: "qw-color-text-link qw-right-align qw-cursor-pointer qw-font-size-small qw-line-height-small"
  }, i18n.t('creditsValue', {
    value: getDurationFromEnd(composition.duration, composition.markers.ffec || composition.markers.ffmc)
  })))), /*#__PURE__*/React__default.createElement(_Row, {
    className: "qw-mt-small qw-mb-xx-small qw-color-text-body qw-font-size-small qw-bold qw-line-height-medium"
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 6,
    className: "qw-cursor-pointer"
  }, renderExpandToggle(), /*#__PURE__*/React__default.createElement("span", {
    onClick: props.toggleExpand
  }, i18n.t('theatreCount', {
    count: cplInfo.theatreCount
  }))), cplInfo.isDcpBooking && /*#__PURE__*/React__default.createElement(_Col, {
    span: 9,
    className: "qw-pl-x-small qw-cursor-pointer",
    onClick: props.toggleExpand
  }, i18n.t('dcp')), cplInfo.isKdmBooking && /*#__PURE__*/React__default.createElement(_Col, {
    span: 9,
    className: "qw-pl-x-small"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "qw-mr-xx-small qw-cursor-pointer",
    onClick: props.toggleExpand
  }, i18n.t('kdm')), renderKdmOptions(kdmInfo))), props.expand && renderTheatreInfo(cplInfo), !props.expand && /*#__PURE__*/React__default.createElement(_Row, {
    className: "qw-font-size-small qw-line-height-small"
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 6,
    className: "qw-pl-large"
  }, "\xA0"), cplInfo.isDcpBooking && /*#__PURE__*/React__default.createElement(_Col, {
    span: 9,
    className: "qw-pl-x-small qw-cursor-pointer",
    onClick: props.toggleExpand
  }, renderDCPStatusSummary(cplInfo.dcpStatus, cplInfo.dcpIngestStatus)), cplInfo.isKdmBooking && /*#__PURE__*/React__default.createElement(_Col, {
    span: 9,
    className: "kdm-summary qw-color-text-body qw-pl-x-small qw-cursor-pointer",
    onClick: props.toggleExpand
  }, renderKDMStatusSummary(kdmInfo.kdmStatus, kdmInfo.kdmValidity, kdmInfo.kdmIngestStatus))));
};

var Movie = function Movie(props) {
  var getCompositions = function getCompositions() {
    var compositions = props.composition.compositions,
        cplIds = props.cplIds,
        showModal = props.showModal,
        sendKDMEmail = props.sendKDMEmail,
        downloadKDMs = props.downloadKDMs,
        loadTheatreDetails = props.loadTheatreDetails;
    return compositions.map(function (composition, idx) {
      return /*#__PURE__*/React__default.createElement(Composition, {
        key: idx,
        composition: composition,
        showModal: showModal,
        sendKDMEmail: sendKDMEmail,
        downloadKDMs: downloadKDMs,
        expand: cplIds.includes(composition.id),
        toggleExpand: function toggleExpand() {
          return props.toggleExpand(composition.id);
        },
        loadTheatreDetails: loadTheatreDetails
      });
    });
  };

  var _props$composition = props.composition,
      name = _props$composition.name,
      language = _props$composition.language,
      releaseYear = _props$composition.releaseYear;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "movie qw-m-small qw-pt-x-small qw-pb-xx-small"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "movie-name qw-font-size-body qw-line-height-body qw-color-text-body qw-bold qw-ml-small"
  }, name, " ", releaseYear ? /*#__PURE__*/React__default.createElement("span", null, "(", releaseYear, ")") : null, ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "movie-language qw-font-size-small qw-regular qw-color-text-body"
  }, language)), getCompositions());
};

var FilterTags = function FilterTags(_ref) {
  var theatres = _ref.compositionFilters.theatres,
      toggleTheatreFilter = _ref.toggleTheatreFilter;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "qw-m-small"
  }, theatres.map(function (theatre) {
    return /*#__PURE__*/React__default.createElement(_Tag, {
      key: theatre.id,
      closable: true,
      className: "composition-card qw-my-xx-small qw-mx-xx-small qw-p-small qw-border-none qw-not-rounded search-tag qw-font-size-small qw-font-size-small qw-line-height-small",
      onClose: function onClose() {
        return toggleTheatreFilter({
          id: theatre.id
        });
      }
    }, i18n.t('theatre'), ":\xA0", theatre.name, ",", ' ', /*#__PURE__*/React__default.createElement("span", {
      className: "location qw-font-size-x-small qw-font-weight-medium qw-color-text-secondary-heading qw-mt-xx-small"
    }, frameTheatreAddress(theatre)));
  }));
};

var CompositionList = function CompositionList(_ref) {
  var compositionFilters = _ref.compositionFilters,
      toggleTheatreFilter = _ref.toggleTheatreFilter,
      _ref$compositions = _ref.compositions,
      compositions = _ref$compositions.compositions,
      fetchInProgress = _ref$compositions.fetchInProgress,
      cplIds = _ref$compositions.cplIds,
      hasMore = _ref$compositions.hasMore,
      dataReceived = _ref$compositions.dataReceived,
      scrollHeight = _ref.scrollHeight,
      updateCplIds = _ref.updateCplIds,
      showModal = _ref.showModal,
      fetchCompositions = _ref.fetchCompositions,
      selectedTheatres = _ref.selectedTheatres,
      sendKDMEmail = _ref.sendKDMEmail,
      downloadKDMs = _ref.downloadKDMs,
      loadTheatreDetails = _ref.loadTheatreDetails;
  useEffect(function () {// props.fetchCompositions()
  }, []);
  useEffect(function () {
    fetchCompositions(true);
  }, [selectedTheatres]);

  var _toggleExpand = function toggleExpand(cplId) {
    var cplIdsCloned = _$1.cloneDeep(cplIds);

    if (cplIdsCloned.includes(cplId)) {
      cplIdsCloned = _$1.remove(cplIdsCloned, function (cId) {
        return cId !== cplId;
      });
    } else {
      cplIdsCloned.push(cplId);
    }

    updateCplIds(cplIdsCloned);
  };

  var getCompositions = function getCompositions() {
    if (!fetchInProgress && !compositions.length) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-center qw-font-size-large qw-line-height-large qw-py-medium"
      }, i18n.t('noCompositions')));
    }

    return compositions.map(function (composition, idx) {
      return composition.resourceType === 'composition' ? /*#__PURE__*/React__default.createElement(Composition, {
        key: idx,
        composition: composition,
        showModal: showModal,
        sendKDMEmail: sendKDMEmail,
        downloadKDMs: downloadKDMs,
        expand: cplIds.includes(composition.id),
        toggleExpand: function toggleExpand() {
          return _toggleExpand(composition.id);
        },
        loadTheatreDetails: loadTheatreDetails
      }) : /*#__PURE__*/React__default.createElement(Movie, {
        key: idx,
        composition: composition,
        showModal: showModal,
        sendKDMEmail: sendKDMEmail,
        downloadKDMs: downloadKDMs,
        cplIds: cplIds,
        toggleExpand: _toggleExpand,
        loadTheatreDetails: loadTheatreDetails
      });
    });
  };

  var renderLoading = function renderLoading() {
    var initialLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames$1('qw-flex qw-items-center qw-justify-center', {
        'full-height': initialLoad
      })
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "loading",
      size: "48"
    }));
  };

  return /*#__PURE__*/React__default.createElement(InfiniteScroll, {
    dataLength: compositions.length,
    next: function next() {
      return fetchCompositions();
    },
    hasMore: hasMore,
    loader: renderLoading(),
    height: scrollHeight || window.innerHeight - 50
  }, /*#__PURE__*/React__default.createElement(FilterTags, {
    compositionFilters: compositionFilters,
    toggleTheatreFilter: toggleTheatreFilter
  }), !dataReceived && renderLoading(true), getCompositions());
};

function PageHeaderWithTabs(_ref) {
  var data = _ref.data,
      isLoading = _ref.isLoading,
      tabs = _ref.tabs,
      onTabChange = _ref.onTabChange;
  var subHeadingText = data.subHeadingText,
      headingText = data.headingText,
      descriptionText = data.descriptionText,
      tagsInfo = data.tagsInfo;
  return /*#__PURE__*/React__default.createElement("header", {
    className: "detailed-header-tabs__header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "detailed-header-tabs__info"
  }, /*#__PURE__*/React__default.createElement(ReactPlaceholder, {
    showLoadingAnimation: true,
    color: "#adbbcc",
    type: "text",
    rows: 4,
    ready: !isLoading,
    style: {
      maxWidth: '15rem'
    }
  }, /*#__PURE__*/React__default.createElement("h1", null, headingText), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h2", null, subHeadingText), /*#__PURE__*/React__default.createElement("h3", null, descriptionText)), tagsInfo && /*#__PURE__*/React__default.createElement("div", {
    className: "tag_list"
  }, tagsInfo.map(function (tagObj) {
    var iconAt = 'prefixIcon';
    var IconComponent = Icons[tagObj.iconType]; // getting icon component based on icon type

    var iconComponent = IconComponent ?
    /*#__PURE__*/
    // creating icon component only if icon type is available
    React__default.createElement(IconComponent, {
      color: tagObj.iconColor
    }) : null;
    var tagProps = iconComponent // adding props if icon component is available
    ? _defineProperty$1({}, iconAt, iconComponent) : {};
    return /*#__PURE__*/React__default.createElement(Tag, tagProps, tagObj.tagText);
  })))), /*#__PURE__*/React__default.createElement("hr", null), /*#__PURE__*/React__default.createElement(Tabs, {
    tabs: tabs,
    onChange: onTabChange
  }));
}

PageHeaderWithTabs.defaultProps = {
  isLoading: false,
  tabs: [],
  onTabChange: function onTabChange() {}
};

var TheatreLayout = function TheatreLayout(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "theatre-selection-card"
  }, props.children);
};

function getSelectedScreensCount(theatres) {
  var selectedScreensCount = 0;

  if (!theatres) {
    return selectedScreensCount;
  }

  theatres.forEach(function (theatre) {
    selectedScreensCount += _$1.filter(theatre.screens, function (sc) {
      return sc.selected;
    }).length;
  });
  return selectedScreensCount;
}

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var tabMenu = [];

var TheatreSelection = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TheatreSelection, _React$Component);

  var _super = _createSuper$e(TheatreSelection);

  function TheatreSelection(props) {
    var _this;

    _classCallCheck$1(this, TheatreSelection);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "fetchingFunction", function (value) {
      _this.setState({
        listViewFetching: value
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "refetchLoading", function (value) {
      _this.setState({
        layoutLoading: value
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "createListModalOpen", function (value) {
      _this.setState({
        listError: null,
        createListModal: value
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "listRefetching", function (value) {
      _this.setState({
        refetchListView: value
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "updateAppComponent", function () {
      var selectedBookingList = _this.state.selectedBookingList;

      if (_this.props.selectedTheatresBooking) {
        _this.props.selectedTheatresBooking(selectedBookingList);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "addTheatreToBooking", function (list) {
      var tempList = _this.state.selectedBookingList;
      var theatreList = list[0];
      var itemIndex;

      if (_this.props.mode === 'exhibitor') {
        itemIndex = tempList.findIndex(function (item) {
          return item.uuid === theatreList.uuid;
        });
        theatreList.auditoriums && theatreList.auditoriums.map(function (item) {
          item.selected = true;
        });
      } else {
        itemIndex = tempList.findIndex(function (item) {
          return item.id === theatreList.id;
        });
        theatreList.screens && theatreList.screens.map(function (item) {
          item.selected = true;
        });
      }

      if (itemIndex > -1) {
        tempList.splice(itemIndex, 1);
      } else {
        tempList.push(theatreList);
      }

      _this.setState({
        selectedBookingList: tempList
      }, function () {
        return _this.updateAppComponent();
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "addTheatresToBookingByCsv", function (list) {
      var tempList = _this.state.selectedBookingList;
      var theatreList = list;
      var tempIndex;

      if (tempList.length) {
        theatreList.forEach(function (item) {
          tempList.forEach(function (theatre) {
            if (theatre.id === item.id) {
              tempIndex = _$1.findIndex(tempList, function (theatre) {
                return theatre.id == item.id;
              });
              tempList.splice(tempIndex, 1);
            }
          });
        });
        theatreList.forEach(function (theatre) {
          return tempList.push(theatre);
        });
      } else {
        theatreList.forEach(function (theatre) {
          return tempList.push(theatre);
        });
      }

      _this.setState({
        selectedBookingList: tempList
      });

      _this.updateAppComponent();
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleScreenBooking", function (selectionIndex, screenIndex, selected, theatre, screen) {
      var tempList = _this.state.selectedBookingList;

      var theatreIndex = _$1.findIndex(tempList, function (th) {
        return th.id == theatre.id;
      });

      if (!_$1.isEmpty(tempList) && theatreIndex >= 0 && tempList[theatreIndex]) {
        tempList[theatreIndex].screens[screenIndex].selected = !selected;
        var hasSelected;
        tempList[theatreIndex].screens.forEach(function (item) {
          if (item.selected) {
            hasSelected = true;
          }
        });

        if (hasSelected) {
          _this.setState({
            selectedBookingList: tempList
          }, function () {
            return _this.updateAppComponent();
          });
        } else {
          tempList.splice(theatreIndex, 1);

          _this.setState({
            selectedBookingList: tempList
          }, function () {
            return _this.updateAppComponent();
          });
        }
      } else {
        var _tempList = _this.state.selectedBookingList;
        var tempScreen = theatre;
        tempScreen && tempScreen.screens.map(function (item) {
          if (item.id == screen.id) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });

        _tempList.push(tempScreen);

        _this.setState({
          selectedBookingList: _tempList
        }, function () {
          return _this.updateAppComponent();
        });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleAddListToBooking", function (list) {
      var selectedBookingList = _this.state.selectedBookingList;
      var theatreList = list;

      if (selectedBookingList.length) {
        theatreList.forEach(function (item) {
          item.screens.forEach(function (item) {
            item.isInList && (item.selected = true);
          });
        });
        var contains = [];
        var addList = true;
        selectedBookingList.map(function (item) {
          theatreList.map(function (list) {
            if (item.id === list.id) {
              contains.push(list.id);
            }
          });
        });

        if (contains.length) {
          addList = false;
        }

        if (addList) {
          theatreList.map(function (item) {
            selectedBookingList.push(item);
          });

          _this.setState({
            selectedBookingList: selectedBookingList
          }, function () {
            return _this.updateAppComponent();
          });
        } else {
          theatreList.map(function (item, index) {
            selectedBookingList.map(function (list) {
              if (item.id === list.id) {
                var itemIndex = selectedBookingList.findIndex(function (item) {
                  return item.id === list.id;
                });

                if (itemIndex > -1) {
                  selectedBookingList.splice(itemIndex, 1);
                }
              }
            });
          });

          _this.setState({
            selectedBookingList: selectedBookingList
          }, function () {
            return _this.updateAppComponent();
          });
        }
      } else {
        theatreList.forEach(function (item) {
          item.screens.forEach(function (item) {
            item.isInList && (item.selected = true);
          });
        });
        theatreList.map(function (item) {
          selectedBookingList.push(item);
        });

        _this.setState({
          selectedBookingList: selectedBookingList
        }, function () {
          return _this.updateAppComponent();
        });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "createTheatreList", function (name) {
      var selectedBookingList = _this.state.selectedBookingList;
      var data = {};
      data.name = name;
      data.isPublic = false;
      data.theatres = selectedBookingList.map(function (theatre) {
        var obj = {};
        obj.id = theatre.id;
        var screens = theatre.screens.map(function (screen) {
          if (screen.selected) {
            return screen.id;
          }
        });
        screens = _$1.compact(screens);

        if (screens.length != theatre.screens.length) {
          obj.screens = screens;
        }

        return obj;
      });

      _this.setState({
        listPosting: true,
        listError: null
      }, function () {
        return _this.postCreateList(data);
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "postCreateList", function (data) {
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken;
      _this.state.currentTab;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };
      axios.post("".concat(hostUrl, "/v1/theatrelists"), data, config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.listRefetching(true);
          this.setState({
            createListModal: false,
            listPosting: false
          });
          SuccessMessage(i18n.t('theatresListCreated'));
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        this.setState({
          listError: i18n.t('theatreListNameAlreadyExists'),
          listPosting: false
        });
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty$1(_assertThisInitialized(_this), "deteteTheatreList", function (listId, closeModal) {
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken;
      _this.state.currentTab;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };

      _this.setState({
        listPosting: true,
        listError: null
      });

      axios.delete("".concat(hostUrl, "/v1/theatrelists/").concat(listId), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          SuccessMessage(i18n.t('theatresListDeleted'));
          closeModal();
          this.listRefetching(true);
          this.setState({
            listPosting: false,
            listError: null
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        var _error$data, _error$response, _error$response$data;

        this.setState({
          listPosting: false
        });
        closeModal();
        var errorMessage = (error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.message) || (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message);
        ErrorMessage(errorMessage);
      }.bind(_assertThisInitialized(_this)));
    });

    _this.state = {
      currentTab: 'theatres',
      showMobileView: false,
      selectedBookingList: _this.props.theatresInBooking ? _this.props.theatresInBooking : [],
      listViewFetching: false,
      refetchListView: false,
      listPosting: false,
      listError: null,
      createListModal: false,
      layoutLoading: false
    };
    _this.changeTab = _this.changeTab.bind(_assertThisInitialized(_this));
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    _this.fetchingFunction = _this.fetchingFunction.bind(_assertThisInitialized(_this));
    _this.deteteTheatreList = _this.deteteTheatreList.bind(_assertThisInitialized(_this));
    _this.clearTheatreList = _this.clearTheatreList.bind(_assertThisInitialized(_this));
    _this.constructTabMenu = _this.constructTabMenu.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(TheatreSelection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          mode = _this$props3.mode,
          account = _this$props3.account;
      var currentTab = this.state.currentTab;

      if (mode === 'non-exhibitor') {
        tabMenu = [{
          id: 'tab' + 1,
          name: i18n.t('theatres'),
          type: 'theatres',
          route: '/theatres'
        }, {
          id: 'tab' + 2,
          name: i18n.t('lists'),
          type: 'lists',
          route: '/theatres/list'
        }];
        this.constructTabMenu(account);
        var menu = tabMenu.find(function (menu) {
          return menu.route === history.location.pathname;
        });

        if (menu && menu.type !== currentTab) {
          this.setState({
            currentTab: menu.type
          });
          history.push(menu.route);
        }
      }

      window.addEventListener('resize', this.updateDimensions, true);
      this.updateDimensions();
    }
  }, {
    key: "constructTabMenu",
    value: function constructTabMenu(account) {
      var user = account.user;
      var showFestivalsTabAlways = this.props.showFestivalsTabAlways;
      var hasFestivalTabMenu = tabMenu.some(function (m) {
        return m.type === 'festivals';
      });

      if ((user.hasFestivals || showFestivalsTabAlways) && !hasFestivalTabMenu) {
        tabMenu.push({
          id: 'tab' + 3,
          name: i18n.t('filmFestivals'),
          type: 'festivals',
          route: '/theatres/festivals'
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.theatresInBooking !== this.props.theatresInBooking) {
        this.setState({
          selectedBookingList: this.props.theatresInBooking
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.actions) {
        this.props.actions.resetTheatres();
      }

      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      var mediaSizeValue = window.matchMedia('(max-width: 990px)');
      this.setState({
        showMobileView: mediaSizeValue.matches
      });
    }
  }, {
    key: "changeTab",
    value: function changeTab(item) {
      var _this$props4 = this.props,
          history = _this$props4.history,
          mode = _this$props4.mode;

      if (mode === 'non-exhibitor') {
        history.push(item.route);
      }

      this.setState({
        currentTab: item.type
      });
    }
  }, {
    key: "onSelectDropDown",
    value: function onSelectDropDown(item) {
      var currentTab = tabMenu.find(function (menu) {
        return menu.type === item;
      });

      if (currentTab) {
        var _this$props5 = this.props,
            history = _this$props5.history,
            mode = _this$props5.mode;

        if (mode === 'non-exhibitor') {
          history.push(currentTab.route);
        }

        this.setState({
          currentTab: currentTab.type
        });
      }
    }
  }, {
    key: "clearTheatreList",
    value: function clearTheatreList() {
      var _this2 = this;

      this.setState({
        selectedBookingList: []
      }, function () {
        return _this2.updateAppComponent();
      });
    }
  }, {
    key: "renderTabContent",
    value: function renderTabContent() {
      var _this$props6 = this.props,
          accessToken = _this$props6.accessToken,
          app = _this$props6.app,
          hostUrl = _this$props6.hostUrl,
          account = _this$props6.account,
          showAppBusy = _this$props6.showAppBusy,
          handleAppError = _this$props6.handleAppError,
          theatreUrl = _this$props6.theatreUrl,
          shouldShowUploadCSV = _this$props6.shouldShowUploadCSV,
          theatreSearchUrl = _this$props6.theatreSearchUrl,
          mode = _this$props6.mode,
          genericWireTapIcon = _this$props6.genericWireTapIcon;
      var _this$state = this.state,
          currentTab = _this$state.currentTab,
          selectedBookingList = _this$state.selectedBookingList,
          listViewFetching = _this$state.listViewFetching,
          refetchListView = _this$state.refetchListView,
          listPosting = _this$state.listPosting;
          _this$state.listError;

      if (currentTab === 'theatres') {
        return /*#__PURE__*/React__default.createElement(TheatresViewPage, {
          tabType: currentTab,
          hostUrl: hostUrl,
          theatreSearchUrl: theatreSearchUrl,
          accessToken: accessToken,
          theatresInBooking: selectedBookingList,
          addTheatreToBooking: this.addTheatreToBooking.bind(this),
          handleScreenBooking: this.handleScreenBooking.bind(this),
          addTheatre: function addTheatre() {
            return actions.pushPath('/theatres/add');
          },
          addTheatresToBooking: this.addTheatresToBookingByCsv,
          showAppBusy: showAppBusy,
          handleAppError: handleAppError,
          theatreUrl: theatreUrl,
          account: account,
          shouldShowUploadCSV: shouldShowUploadCSV,
          mode: mode,
          genericWireTapIcon: genericWireTapIcon,
          withScreenInfo: this.props.withScreenInfo
        });
      }

      if (this.state.currentTab === 'lists') {
        return /*#__PURE__*/React__default.createElement(ListsViewPage, {
          hostUrl: hostUrl,
          accessToken: accessToken,
          tabType: currentTab,
          theatresInBooking: selectedBookingList,
          addTheatreForBooking: this.handleAddListToBooking.bind(this),
          handleScreenBooking: this.handleScreenBooking.bind(this),
          fetchingFunction: this.fetchingFunction,
          listViewFetching: listViewFetching,
          refetchListView: refetchListView,
          deteteTheatreList: this.deteteTheatreList,
          listPosting: listPosting,
          appError: app && app.error,
          handleAppError: handleAppError,
          listRefetching: this.listRefetching
        });
      }

      if (this.state.currentTab === 'festivals') {
        return /*#__PURE__*/React__default.createElement(FestivalsView, {
          hostUrl: hostUrl,
          accessToken: accessToken,
          tabType: currentTab,
          theatresInBooking: selectedBookingList,
          addTheatreForBooking: this.handleAddListToBooking.bind(this),
          fetchingFunction: this.fetchingFunction,
          handleAppError: handleAppError,
          handleScreenBooking: this.handleScreenBooking.bind(this)
        });
      }
    }
  }, {
    key: "mobileSummaryButtonText",
    value: function mobileSummaryButtonText(selectedTheatres) {
      return selectedTheatres.length ? "".concat(selectedTheatres.length, " (").concat(getSelectedScreensCount(selectedTheatres), ")") : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props7 = this.props;
          _this$props7.actions;
          _this$props7.booking;
          _this$props7.theatreLists;
          var hostUrl = _this$props7.hostUrl,
          accessToken = _this$props7.accessToken,
          showTheatreSelectionView = _this$props7.showTheatreSelectionView,
          setShowTheatreSelectionView = _this$props7.setShowTheatreSelectionView,
          title = _this$props7.title,
          mode = _this$props7.mode,
          handleAppError = _this$props7.handleAppError,
          genericWireTapIcon = _this$props7.genericWireTapIcon;
      var _this$state2 = this.state,
          currentTab = _this$state2.currentTab;
          _this$state2.searchText;
          _this$state2.selectionView;
          var showMobileView = _this$state2.showMobileView,
          selectedBookingList = _this$state2.selectedBookingList,
          listViewFetching = _this$state2.listViewFetching,
          listPosting = _this$state2.listPosting,
          listError = _this$state2.listError,
          createListModal = _this$state2.createListModal,
          layoutLoading = _this$state2.layoutLoading;

      if (showMobileView) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-page-overview-layout"
        }, showTheatreSelectionView ? /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-page-selection-side"
        }, layoutLoading && /*#__PURE__*/React__default.createElement("div", {
          style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
          style: {
            fontSize: 32,
            color: '#084782'
          },
          spin: true
        })), /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-selection-card-overview"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-selection-card-tab-view-mobile"
        }, tabMenu.length ? /*#__PURE__*/React__default.createElement(DropDown, {
          placeholder: i18n.t('selectOption'),
          list: tabMenu,
          value: currentTab,
          width: "100px",
          onSelectDropDown: function onSelectDropDown(i) {
            return _this3.onSelectDropDown(i);
          }
        }) : /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-search-header title"
        }, /*#__PURE__*/React__default.createElement(HeaderText, {
          text: title
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-selection-card-tab-view-button"
        }, /*#__PURE__*/React__default.createElement(SelectButton, {
          clickEvent: function clickEvent() {
            return setShowTheatreSelectionView(!showTheatreSelectionView);
          },
          text: this.mobileSummaryButtonText(selectedBookingList),
          type: "theatre"
        }))), /*#__PURE__*/React__default.createElement("div", null, this.renderTabContent())))) : /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-page-selection-side"
        }, layoutLoading && /*#__PURE__*/React__default.createElement("div", {
          style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
          style: {
            fontSize: 32,
            color: '#084782'
          },
          spin: true
        })), /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement(SelectedTheatres, {
          hostUrl: hostUrl,
          handleAppError: handleAppError,
          accessToken: accessToken,
          theatres: selectedBookingList,
          addTheatreForBooking: this.addTheatreToBooking.bind(this),
          handleScreenBooking: this.handleScreenBooking.bind(this),
          listViewFetching: listViewFetching,
          createTheatreList: this.createTheatreList,
          listPosting: listPosting,
          listError: listError,
          createListModal: createListModal,
          clearTheatreList: this.clearTheatreList,
          onChangeView: function onChangeView() {
            return setShowTheatreSelectionView(!showTheatreSelectionView);
          },
          createListModalOpen: this.createListModalOpen.bind(this),
          refetchLoading: this.refetchLoading.bind(this),
          listRefetching: this.listRefetching,
          mode: mode,
          genericWireTapIcon: genericWireTapIcon,
          withScreenInfo: this.props.withScreenInfo
        }))));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-page-overview-layout"
      }, layoutLoading && /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-page-desktop-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-page-selection-side"
      }, /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selection-card-overview"
      }, tabMenu.length ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selection-card-tab-view"
      }, /*#__PURE__*/React__default.createElement(TabBar, {
        list: tabMenu,
        selectedTab: currentTab,
        onChange: this.changeTab.bind(this)
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-header title"
      }, /*#__PURE__*/React__default.createElement(HeaderText, {
        text: title
      })), /*#__PURE__*/React__default.createElement("div", null, this.renderTabContent())))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-page-selection-side"
      }, /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement(SelectedTheatres, {
        hostUrl: hostUrl,
        accessToken: accessToken,
        theatres: selectedBookingList,
        addTheatreForBooking: this.addTheatreToBooking.bind(this),
        handleScreenBooking: this.handleScreenBooking.bind(this),
        listViewFetching: listViewFetching,
        createTheatreList: this.createTheatreList,
        listPosting: listPosting,
        listError: listError,
        createListModal: createListModal,
        clearTheatreList: this.clearTheatreList,
        createListModalOpen: this.createListModalOpen.bind(this),
        refetchLoading: this.refetchLoading.bind(this),
        listRefetching: this.listRefetching,
        mode: mode,
        genericWireTapIcon: genericWireTapIcon,
        showSearch: this.props.showSelectedTheatresSearch,
        withScreenInfo: this.props.withScreenInfo
      })))));
    }
  }]);

  return TheatreSelection;
}(React__default.Component);
TheatreSelection.defaultProps = {
  title: i18n.t('searchAndSelectTheatres'),
  theatreSearchUrl: 'v1/theatres/search',
  mode: 'non-exhibitor',
  showSelectedTheatresSearch: true,
  withScreenInfo: true
};

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ManageTags = /*#__PURE__*/function (_Component) {
  _inherits$1(ManageTags, _Component);

  var _super = _createSuper$d(ManageTags);

  function ManageTags() {
    _classCallCheck$1(this, ManageTags);

    return _super.apply(this, arguments);
  }

  _createClass$1(ManageTags, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rows = _this$props.rows,
          canEdit = _this$props.canEdit,
          fetchingData = _this$props.fetchingData,
          tagDetailsSavingStatus = _this$props.tagDetailsSavingStatus,
          errorWhileSavingTags = _this$props.errorWhileSavingTags;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "manage-tags__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "manage-tags__header"
      }, /*#__PURE__*/React__default.createElement(SectionHeading, {
        content: i18n.t('compositionTags'),
        size: "large"
      }), canEdit && /*#__PURE__*/React__default.createElement(CreateTagModal, {
        tagDetailsSavingStatus: tagDetailsSavingStatus,
        errorWhileSavingTags: errorWhileSavingTags,
        saveTagDetails: this.props.saveTagDetails
      })), /*#__PURE__*/React__default.createElement(TagsTable, {
        rows: rows,
        canEdit: canEdit,
        fetchingData: fetchingData,
        tagDetailsSavingStatus: tagDetailsSavingStatus,
        errorWhileSavingTags: errorWhileSavingTags,
        saveTagDetails: this.props.saveTagDetails
      }));
    }
  }]);

  return ManageTags;
}(Component);

ManageTags.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: '',
  saveTagDetails: function saveTagDetails() {}
};

var utils = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
exports.joinClassNames = void 0;
exports.joinClassNames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    return classNames.filter(function (c) { return c; }).join(' ');
};
});

var TextRow_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;


var TextRow = function (_a) {
    var className = _a.className, maxHeight = _a.maxHeight, color = _a.color, _b = _a.lineSpacing, lineSpacing = _b === void 0 ? '0.7em' : _b, style = _a.style;
    var defaultStyles = {
        maxHeight: maxHeight,
        width: '100%',
        height: '1em',
        backgroundColor: color,
        marginTop: lineSpacing
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('text-row', className), style: __assign(__assign({}, defaultStyles), style) }));
};
exports["default"] = TextRow;
});

var RoundShape_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;


var RoundShape = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color;
    var defaultStyles = {
        backgroundColor: color,
        borderRadius: '500rem',
        width: '100%',
        height: '100%'
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('round-shape', className), style: __assign(__assign({}, defaultStyles), style) }));
};
exports["default"] = RoundShape;
});

var RectShape_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;


var RectShape = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color;
    var defaultStyle = {
        backgroundColor: color,
        width: '100%',
        height: '100%',
        marginRight: 10
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('rect-shape', className), style: __assign(__assign({}, defaultStyle), style) }));
};
exports["default"] = RectShape;
});

var TextBlock_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;



var defaultStyles = {
    width: '100%'
};
var defaultWidths = [97, 100, 94, 90, 98, 95, 98, 40];
var TextBlock = function (_a) {
    var rows = _a.rows, lineSpacing = _a.lineSpacing, color = _a.color, style = _a.style, className = _a.className, _b = _a.widths, widths = _b === void 0 ? defaultWidths : _b;
    var getRowStyle = function (i) {
        return {
            maxHeight: 100 / (rows * 2 - 1) + "%",
            width: widths[(i + widths.length) % widths.length] + "%"
        };
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('text-block', className), style: __assign(__assign({}, defaultStyles), style) }, Array.apply(null, Array(rows)).map(function (_, i) { return (React__default.createElement(TextRow_1["default"], { color: color, style: getRowStyle(i), lineSpacing: i !== 0 ? lineSpacing : 0, key: i })); })));
};
exports["default"] = TextBlock;
});

var MediaBlock_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;




var defaultStyles = {
    display: 'flex'
};
var MediaBlock = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color, rows = _a.rows;
    return (React__default.createElement("div", { className: utils.joinClassNames('media-block', className), style: __assign(__assign({}, defaultStyles), style) },
        React__default.createElement(RoundShape_1["default"], { color: color, style: { minHeight: 55, width: 55, minWidth: 55, marginRight: 10 } }),
        React__default.createElement(TextBlock_1["default"], { color: color, rows: rows })));
};
exports["default"] = MediaBlock;
});

var placeholders = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
exports.media = exports.text = exports.rect = exports.round = exports.textRow = exports.MediaBlock = exports.TextBlock = exports.RectShape = exports.RoundShape = exports.TextRow = void 0;

exports.TextRow = TextRow_1["default"];

exports.RoundShape = RoundShape_1["default"];

exports.RectShape = RectShape_1["default"];

exports.TextBlock = TextBlock_1["default"];

exports.MediaBlock = MediaBlock_1["default"];
exports.textRow = TextRow_1["default"];
exports.round = RoundShape_1["default"];
exports.rect = RectShape_1["default"];
exports.text = TextBlock_1["default"];
exports.media = MediaBlock_1["default"];
});

var WorkOrderCardLoader = function WorkOrderCardLoader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "panelLoader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '70%',
      height: 30
    }
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '20%',
      height: 30
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '60%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '20%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '10%',
      height: 20
    }
  })), /*#__PURE__*/React__default.createElement(placeholders.TextRow, {
    color: "#cfdce6",
    style: {
      width: '80%'
    }
  }));
};

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DcpDownloadsDetailsDialog = /*#__PURE__*/function (_Component) {
  _inherits$1(DcpDownloadsDetailsDialog, _Component);

  var _super = _createSuper$c(DcpDownloadsDetailsDialog);

  function DcpDownloadsDetailsDialog(props) {
    var _this;

    _classCallCheck$1(this, DcpDownloadsDetailsDialog);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleCancel", function () {
      if (_this.props.onCloseDownloadModal) _this.props.onCloseDownloadModal();
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDcpDownloadsDetails", function () {
      var dcpDownloadList = _this.state.dcpDownloadList;
      return (dcpDownloadList || []).map(function (dcpDownloadDetails) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "py1"
        }, _this.renderDcpDownloadStatus(dcpDownloadDetails));
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDcpDownloadStatus", function (dcpDownloadDetails) {
      var downloadDcpPercentage = 0;
      var messageColor = 'black';
      var downloadDcpStatusMessage = i18n.t('downloadYetToStart');

      if (dcpDownloadDetails) {
        switch (dcpDownloadDetails.status) {
          case DcpDownloadStatuses.QUEUED:
            downloadDcpStatusMessage = i18n.t('downloadQueued');
            break;

          case DcpDownloadStatuses.SCHEDULED:
            downloadDcpStatusMessage = i18n.t('downloadScheduled');
            break;

          case DcpDownloadStatuses.IN_PROGRESS:
            downloadDcpPercentage = dcpDownloadDetails.progress.toString();
            downloadDcpStatusMessage = i18n.t('downloadingPercentage', {
              percentage: downloadDcpPercentage.slice(0, downloadDcpPercentage.indexOf('.') + 3)
            });
            break;

          case DcpDownloadStatuses.DOWNLOADING:
            downloadDcpPercentage = dcpDownloadDetails.progress.toString();
            downloadDcpStatusMessage = i18n.t('downloadingPercentage', {
              percentage: downloadDcpPercentage.slice(0, downloadDcpPercentage.indexOf('.') + 3)
            });
            break;

          case DcpDownloadStatuses.COMPLETED:
            messageColor = 'green';
            downloadDcpStatusMessage = i18n.t('downloaded');
            break;

          case DcpDownloadStatuses.DOWNLOADED:
            messageColor = 'green';
            downloadDcpStatusMessage = i18n.t('downloaded');
            break;

          case DcpDownloadStatuses.FAILED:
            messageColor = 'red';
            downloadDcpStatusMessage = i18n.t('downloadFailed');
            break;

          case DcpDownloadStatuses.ERROR:
            messageColor = 'red';
            downloadDcpStatusMessage = i18n.t('errorFetchingDownloadStatus');
            break;

          case DcpDownloadStatuses.UNARCHIVING:
            messageColor = 'yellow';
            downloadDcpStatusMessage = i18n.t('downloadingUnarchiving');
            break;

          case DcpDownloadStatuses.ARCHIVED:
            messageColor = 'yellow';
            downloadDcpStatusMessage = i18n.t('downloadingArchived');
            break;

          case DcpDownloadStatuses.STALLED:
            messageColor = 'yellow';
            downloadDcpStatusMessage = i18n.t('downloadingStalled');
            break;
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-3"
      }, dcpDownloadDetails.serialNo), /*#__PURE__*/React__default.createElement("div", {
        className: "col col-9 ".concat(messageColor)
      }, downloadDcpStatusMessage));
    });

    _this.state = {
      visible: false,
      dcpDownloadList: []
    };
    return _this;
  }

  _createClass$1(DcpDownloadsDetailsDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        visible: this.props.visible,
        dcpDownloadList: this.props.dcpDownloadList
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.visible !== this.props.visible) {
        this.setState({
          visible: this.props.visible,
          dcpDownloadList: this.props.dcpDownloadList
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var visible = this.state.visible;
      var modalClassName = this.props.modalClassName;
      var dialogTitle = i18n.t('downloadDetails');
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: dialogTitle,
        wrapClassName: classNames$1('vertical-center-modal modal-large', modalClassName),
        visible: visible,
        onCancel: this.handleCancel,
        footer: null
      }, this.renderDcpDownloadsDetails());
    }
  }]);

  return DcpDownloadsDetailsDialog;
}(Component);

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WorkOrderPage = /*#__PURE__*/function (_Component) {
  _inherits$1(WorkOrderPage, _Component);

  var _super = _createSuper$b(WorkOrderPage);

  function WorkOrderPage() {
    var _this;

    _classCallCheck$1(this, WorkOrderPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      isDownloadModalOpen: false,
      dcpDownloadList: [],
      activeTab: _this.props.activeTab
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleTabChange", function (tabName) {
      _this.setState({
        activeTab: tabName
      });

      _this.props.onTabChange(tabName);
    });

    _defineProperty$1(_assertThisInitialized(_this), "onCloseDownloadModal", function () {
      _this.setState({
        isDownloadModalOpen: false
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "onDcpDownloadsStatusClick", function (dcpDownloadList) {
      _this.setState({
        dcpDownloadList: dcpDownloadList,
        isDownloadModalOpen: true
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldShowCopyStatus", function () {
      var _this$props$account$u = _this.props.account.user,
          appliances = _this$props$account$u.appliances,
          partner = _this$props$account$u.partner;
      return !_.isEmpty(appliances) && partner.type === PartnerTypes.OFFLINE;
    });

    _defineProperty$1(_assertThisInitialized(_this), "isPastDate", function (workOrder) {
      var currentDate = Date.now();
      var currentUnixTime = moment(currentDate).unix();
      var inputDate = moment.utc(workOrder.deliverOn).startOf('day');
      var inputDateUnixTime = moment(inputDate).endOf('day').unix();
      var itemsFilter = _this.props.itemsFilter;
      return itemsFilter === WorkOrderItemsFilterValues.CURRENT && currentUnixTime - inputDateUnixTime > 0;
    });

    _defineProperty$1(_assertThisInitialized(_this), "getWorkOrderTabs", function () {
      return [{
        id: WorkOrderTypes.CURRENT,
        title: 'Active'
      }, {
        id: WorkOrderTypes.PAST,
        title: 'Past'
      }];
    });

    _defineProperty$1(_assertThisInitialized(_this), "hasPastWorkOrders", function () {
      var workOrders = _this.props.workOrders;
      return workOrders.some(_this.isPastDate);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderList", function () {
      var _this$props = _this.props,
          onClickViewButton = _this$props.onClickViewButton,
          showViewButton = _this$props.showViewButton,
          showCopyStatus = _this$props.showCopyStatus,
          showDownload = _this$props.showDownload,
          enableFilters = _this$props.enableFilters,
          workOrders = _this$props.workOrders,
          partners = _this$props.partners,
          dcpTransferStatuses = _this$props.dcpTransferStatuses,
          updateDcpTransferStatusInServer = _this$props.updateDcpTransferStatusInServer,
          onView = _this$props.onView,
          account = _this$props.account,
          isAdminPortal = _this$props.isAdminPortal,
          offlinePartnersWithAppliance = _this$props.offlinePartnersWithAppliance,
          onFilterSelect = _this$props.onFilterSelect,
          onTriggerDownload = _this$props.onTriggerDownload,
          itemsFilter = _this$props.itemsFilter,
          changeDcpTransferStatus = _this$props.changeDcpTransferStatus,
          showDcpDownloadsStatusDetails = _this$props.showDcpDownloadsStatusDetails,
          setOverallWorkOrderStatusUpdatedInServer = _this$props.setOverallWorkOrderStatusUpdatedInServer;

      if (workOrders.length === 0) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "h4 center no-work-order"
        }, i18n.t('noItemTypeInWorkOrderFound', {
          type: _this.props.workOrderItemsType
        }));
      }

      return workOrders.map(function (workOrder, index) {
        return /*#__PURE__*/React__default.createElement(WorkOrderCard, {
          key: index,
          index: index,
          partners: partners,
          workOrder: workOrder,
          dcpTransferStatuses: dcpTransferStatuses,
          changeDcpTransferStatus: changeDcpTransferStatus,
          updateDcpTransferStatusInServer: updateDcpTransferStatusInServer,
          setOverallWorkOrderStatusUpdatedInServer: setOverallWorkOrderStatusUpdatedInServer,
          showViewButton: showViewButton,
          showDownload: showDownload,
          onClickViewButton: onClickViewButton,
          enableFilters: enableFilters,
          onView: onView,
          account: account,
          isAdminPortal: isAdminPortal,
          offlinePartnersWithAppliance: offlinePartnersWithAppliance,
          onFilterSelect: onFilterSelect,
          onTriggerDownload: onTriggerDownload,
          itemsFilter: itemsFilter,
          isPastDate: _this.isPastDate,
          shouldShowCopyStatus: _this.shouldShowCopyStatus,
          showCopyStatus: showCopyStatus,
          showDcpDownloadsStatusDetails: showDcpDownloadsStatusDetails,
          onDcpDownloadsStatusClick: _this.onDcpDownloadsStatusClick
        });
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderFilterTags", function () {
      var filterTags = [];
      var filterTagLabels = {
        booking: i18n.t('booking'),
        workorder: i18n.t('workorder'),
        partner: i18n.t('partner'),
        composition: i18n.t('composition')
      };

      var _loop = function _loop(key) {
        if (key === WorkOrderItemsFilterTagKeys.COMPOSITION) {
          _this.props.filterTags[key].map(function (value) {
            return filterTags.push({
              id: value,
              name: value,
              type: filterTagLabels[key],
              filterType: key,
              displayName: value
            });
          });
        } else {
          filterTags.push({
            id: _this.props.filterTags[key],
            name: _this.props.filterTags[key],
            type: filterTagLabels[key],
            filterType: key,
            displayName: _this.props.filterTags[key]
          });
        }
      };

      for (var key in _this.props.filterTags) {
        _loop(key);
      }

      return /*#__PURE__*/React__default.createElement(FilterChips$1, {
        showResultsCount: false,
        selected: filterTags,
        resultsCount: _this.props.workOrderCount,
        onFilterChange: function onFilterChange(updateFilters) {
          return _this.props.removeFilterTag(updateFilters);
        }
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderControls", function () {
      var _this$props2 = _this.props,
          pageSizeList = _this$props2.pageSizeList,
          pageSize = _this$props2.pageSize,
          onPageSizeChange = _this$props2.onPageSizeChange;
          _this$props2.hasMoreData;
      return [{
        id: 'pageSizeControl',
        component: function component() {
          return /*#__PURE__*/React__default.createElement(Selector$1, {
            onSelect: onPageSizeChange,
            selectedList: [pageSize],
            list: pageSizeList,
            showLabelInButton: false,
            label: 'Show',
            singleSelect: true,
            closeOnSelect: true,
            noSelectedIcon: false,
            defaultIsOpen: false,
            usePortal: false
          });
        }
      }];
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderTableControls", function () {
      var _this$props3 = _this.props,
          showSearchBar = _this$props3.showSearchBar,
          workOrders = _this$props3.workOrders;
          _this$props3.dataReceived;
          var workOrderCount = _this$props3.workOrderCount,
          pageSize = _this$props3.pageSize,
          currentPage = _this$props3.currentPage,
          pageNeighbors = _this$props3.pageNeighbors,
          searchInputProps = _this$props3.searchInputProps,
          onPageChange = _this$props3.onPageChange,
          filterTags = _this$props3.filterTags,
          onClearSearchText = _this$props3.onClearSearchText,
          simplePagination = _this$props3.simplePagination,
          hasMoreData = _this$props3.hasMoreData;

      var searchInputData = _objectSpread$2({}, searchInputProps);

      return /*#__PURE__*/React__default.createElement("div", {
        className: "tableControlsWrapper"
      }, /*#__PURE__*/React__default.createElement(TableControls$1, {
        searchBar: showSearchBar,
        pagination: workOrders.length > 0,
        showFilterButton: false,
        columnFilter: false,
        inputWithSelection: false,
        pageSize: pageSize,
        currentPage: currentPage,
        searchType: SEARCH_TAG_TYPES.INPUT_SEARCH,
        totalResults: parseInt(workOrderCount),
        searchInputProps: showSearchBar ? searchInputData : null,
        pageNeighbors: pageNeighbors,
        onRowSizeChange: onPageChange,
        simplePagination: simplePagination,
        hasMoreData: hasMoreData,
        onSearchClear: onClearSearchText,
        controls: _this.renderControls()
      }), !isEmpty(filterTags) && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-filter-chips"
      }, _this.renderFilterTags()));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderContainer", function () {
      var _this$props4 = _this.props;
          _this$props4.showSearchBar;
          var workOrders = _this$props4.workOrders,
          dataReceived = _this$props4.dataReceived,
          workOrderCount = _this$props4.workOrderCount,
          pageSize = _this$props4.pageSize,
          currentPage = _this$props4.currentPage,
          pageNeighbors = _this$props4.pageNeighbors;
          _this$props4.searchInputProps;
          var _onPageChange = _this$props4.onPageChange;
          _this$props4.filterTags;
          var simplePagination = _this$props4.simplePagination,
          hasMoreData = _this$props4.hasMoreData;
      if (!dataReceived) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-table-controls-loader"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '60%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '20%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        color: "#cfdce6",
        style: {
          width: '10%',
          height: 24
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-data-list"
      }, /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null), /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null), /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null), /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null)), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-footer"
      }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '70%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '20%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        color: "#cfdce6",
        style: {
          width: '10%',
          height: 24
        }
      })));
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _this.renderTableControls(), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-data-list"
      }, _this.renderWorkOrderList()), workOrders.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-footer"
      }, /*#__PURE__*/React__default.createElement(TablePagination$1, {
        pageSize: pageSize,
        currentPage: currentPage,
        totalRecords: parseInt(workOrderCount),
        pageNeighbors: pageNeighbors,
        simplePagination: simplePagination,
        hasMoreData: hasMoreData,
        onPageChange: function onPageChange(v) {
          return _onPageChange(currentPage, v);
        }
      })));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderViewSwitchComponent", function () {
      var activeTab = _this.state.activeTab;
      return /*#__PURE__*/React__default.createElement(ViewSwitch, {
        label: "View as",
        buttons: [{
          id: WorkOrderTypes.CURRENT,
          buttonText: 'Current',
          onClick: function onClick() {
            return activeTab !== WorkOrderTypes.CURRENT ? _this.handleTabChange(WorkOrderTypes.CURRENT) : null;
          },
          isActive: activeTab === WorkOrderTypes.CURRENT
        }, {
          id: WorkOrderTypes.PAST,
          buttonText: 'Past',
          onClick: function onClick() {
            return activeTab !== WorkOrderTypes.PAST ? _this.handleTabChange(WorkOrderTypes.PAST) : null;
          },
          isActive: activeTab === WorkOrderTypes.PAST
        }]
      });
    });

    return _this;
  }

  _createClass$1(WorkOrderPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.activeTab !== this.props.activeTab) {
        this.setState({
          activeTab: this.props.activeTab
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props;
          _this$props5.workOrders;
          var workOrderCount = _this$props5.workOrderCount,
          dataReceived = _this$props5.dataReceived,
          isAdminPortal = _this$props5.isAdminPortal,
          hasMoreData = _this$props5.hasMoreData;
      var _this$state = this.state,
          isDownloadModalOpen = _this$state.isDownloadModalOpen,
          dcpDownloadList = _this$state.dcpDownloadList;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-page"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-header"
      }, /*#__PURE__*/React__default.createElement(Header$2, {
        name: "Work Orders",
        isPartialLoading: !dataReceived,
        count: workOrderCount,
        renderRightSideComponent: function renderRightSideComponent() {
          return _this2.renderViewSwitchComponent();
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('work-order-body-container', {
          adminBodyContainer: isAdminPortal,
          noMoreData: !hasMoreData
        })
      }, this.renderWorkOrderContainer()), /*#__PURE__*/React__default.createElement(DcpDownloadsDetailsDialog, {
        visible: isDownloadModalOpen,
        onCloseDownloadModal: this.onCloseDownloadModal,
        dcpDownloadList: dcpDownloadList
      }));
    }
  }]);

  return WorkOrderPage;
}(Component);
WorkOrderPage.defaultProps = {
  showSearchBar: true,
  showViewButton: false,
  enableFilters: true,
  showCopyStatus: true,
  showDownload: true
};

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*#__PURE__*/(function (_React$Component) {
  _inherits$1(WorkOrderView, _React$Component);

  var _super = _createSuper$a(WorkOrderView);

  function WorkOrderView() {
    var _this;

    _classCallCheck$1(this, WorkOrderView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "handleClick", function (e) {
      if (e.key === WorkOrderTabs.DUPLICATION) {
        _this.props.history.push("/work-orders/".concat(_this.props.workOrder.workOrderNo));
      } else if (e.key === WorkOrderTabs.SHIPMENT) {
        _this.props.history.push("/work-orders/".concat(_this.props.workOrder.workOrderNo, "/shipment"));
      }
    });

    return _this;
  }

  _createClass$1(WorkOrderView, [{
    key: "goToDuplicationTab",
    value: function goToDuplicationTab() {
      this.props.history.push("/work-orders/".concat(this.props.workOrder.workOrderNo));
    }
  }, {
    key: "goToShipmentTab",
    value: function goToShipmentTab() {
      this.props.history.push("/work-orders/".concat(this.props.workOrder.workOrderNo, "/shipment"));
    }
  }, {
    key: "calculateWorkOrderContentSize",
    value: function calculateWorkOrderContentSize(compositions) {
      var uniqueAssets = [];
      compositions.forEach(function (cpl) {
        uniqueAssets = uniqBy(concat(uniqueAssets, cpl.assets), 'id');
      });
      return bytesToSize(sumBy(uniqueAssets, 'size'));
    }
  }, {
    key: "isCopyFeatureApplicable",
    value: function isCopyFeatureApplicable(workOrder) {
      var _this$props$user = this.props.user,
          appliances = _this$props$user.appliances,
          partner = _this$props$user.partner;
      var deliveryType = workOrder && workOrder.shipments && workOrder.shipments[0].deliveryType;
      return !isEmpty(appliances) && partner.type === PartnerTypes.OFFLINE && deliveryType && deliveryType === DeliveryTypes.HARD_DRIVE;
    }
  }, {
    key: "renderDriveCopyShipmentStatus",
    value: function renderDriveCopyShipmentStatus(workOrder, copyInProgress) {
      var isCopyFeatureApplicable = this.isCopyFeatureApplicable(workOrder);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "h4"
      }, isCopyFeatureApplicable && this.renderCopyStatusDetails(workOrder, copyInProgress), this.renderShipmentStatusDetails(workOrder));
    }
  }, {
    key: "renderCopyStatusDetails",
    value: function renderCopyStatusDetails(workOrder, copyInProgress) {
      var totalCopied = workOrder.totalCopied,
          totalDrives = workOrder.totalDrives;
      var cancelledDrives = 0;

      if (workOrder && workOrder.shipments) {
        cancelledDrives = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.CANCELLED;
        }).length;
      }

      var copyPending = totalDrives - totalCopied - cancelledDrives - copyInProgress;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "h5"
      }, i18n.t('copyStatus'), totalCopied > 0 && /*#__PURE__*/React__default.createElement("span", null, i18n.t('copiedCount', {
        itemCount: totalCopied
      })), copyInProgress > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1"
      }, totalCopied > 0 && /*#__PURE__*/React__default.createElement("span", null, "| "), i18n.t('inProgressCount', {
        itemCount: copyInProgress
      })), copyPending > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1"
      }, (totalCopied > 0 || copyInProgress > 0) && /*#__PURE__*/React__default.createElement("span", null, "| "), i18n.t('pendingCount', {
        itemCount: copyPending
      })));
    }
  }, {
    key: "renderShipmentStatusDetails",
    value: function renderShipmentStatusDetails(workOrder) {
      var totalShipped = 0;
      var shipmentPending = 0;
      var shipmentCancelled = 0;
      var pendingCancellation = 0;

      if (workOrder && workOrder.shipments) {
        totalShipped = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.DISPATCHED;
        }).length;
        shipmentPending = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.PENDING;
        }).length;
        shipmentCancelled = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.CANCELLED;
        }).length;
        pendingCancellation = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.PENDING_CANCELLATION;
        }).length;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "h5"
      }, i18n.t('shipmentStatus'), totalShipped > 0 && /*#__PURE__*/React__default.createElement("span", null, i18n.t('shipped', {
        shipped: totalShipped
      })), shipmentPending > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1"
      }, totalShipped > 0 && /*#__PURE__*/React__default.createElement("span", null, "| "), i18n.t('pendingCount', {
        itemCount: shipmentPending
      })), pendingCancellation > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1"
      }, (shipmentPending > 0 || totalShipped > 0) && /*#__PURE__*/React__default.createElement("span", null, "| "), i18n.t('pendingCancellationCount', {
        itemCount: pendingCancellation
      })), shipmentCancelled > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1"
      }, (shipmentPending > 0 || totalShipped > 0 || pendingCancellation > 0) && /*#__PURE__*/React__default.createElement("span", null, "| "), i18n.t('cancelledCount', {
        itemCount: shipmentCancelled
      })));
    }
  }, {
    key: "renderWorkOrderInfo",
    value: function renderWorkOrderInfo(workOrder, currentTab, copyInProgress) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix pt2 pb1"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-9"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "h3"
      }, i18n.t('workorder'), workOrder.workOrderNo, workOrder && workOrder.shipments && workOrder.shipments[0].deliveryMode === DeliveryMode.PARTNERS && /*#__PURE__*/React__default.createElement("span", {
        className: "h5 regular"
      }, ' ', i18n.t('drivesCount', {
        count: workOrder.totalDrives
      }))), this.renderDriveCopyShipmentStatus(workOrder, copyInProgress), this.renderWorkOrderContentSize(workOrder)));
    }
  }, {
    key: "renderTabs",
    value: function renderTabs(currentTab) {
      return /*#__PURE__*/React__default.createElement("div", {
        id: "work-order-tabs"
      }, /*#__PURE__*/React__default.createElement(_Menu, {
        onClick: this.handleClick,
        defaultSelectedKeys: ['duplication'],
        selectedKeys: [currentTab],
        mode: "horizontal"
      }, /*#__PURE__*/React__default.createElement(_Menu.Item, {
        key: WorkOrderTabs.DUPLICATION
      }, i18n.t('driveCopy')), /*#__PURE__*/React__default.createElement(_Menu.Item, {
        key: WorkOrderTabs.SHIPMENT
      }, i18n.t('shipping'))), /*#__PURE__*/React__default.createElement("hr", {
        className: "ui-divider"
      }));
    }
  }, {
    key: "renderWorkOrderHeader",
    value: function renderWorkOrderHeader(workOrder, currentTab) {
      var copyInProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var shouldShowCopyTab = this.isCopyFeatureApplicable(workOrder);
      return /*#__PURE__*/React__default.createElement("div", null, this.renderWorkOrderInfo(workOrder, currentTab, copyInProgress), shouldShowCopyTab ? this.renderTabs(currentTab) : /*#__PURE__*/React__default.createElement("div", null));
    }
  }, {
    key: "renderWorkOrderContentSize",
    value: function renderWorkOrderContentSize(workOrder) {
      if (isEmpty(workOrder.compositions)) {
        return;
      }

      var size = this.calculateWorkOrderContentSize(workOrder.compositions);

      if (size <= 0) {
        return;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "h5 mb2"
      }, "".concat(i18n.t('contentSize'), ": "), size);
    }
  }, {
    key: "getCopyinProgressDrives",
    value: function getCopyinProgressDrives(workOrder) {
      var copyInProgressDrives = [];
      var duplicationStateInfo = get(workOrder.workOrderNo);

      if (duplicationStateInfo) {
        Object.keys(duplicationStateInfo).forEach(function (key) {
          var duplicationState = duplicationStateInfo[key];

          if (duplicationState.status === DuplicationProgress.EXECUTING || duplicationState.status === DuplicationProgress.QUEUED) {
            copyInProgressDrives = concat(copyInProgressDrives, duplicationState.slots.filter(function (slot) {
              return slot.status === BayStatuses.INSERTED;
            }));
          }
        });
      }

      return copyInProgressDrives;
    }
  }]);

  return WorkOrderView;
})(React__default.Component);

var DuplicationLoader = function DuplicationLoader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "duplication-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col col-12 duplication-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col col-6 copy-container",
    style: {
      height: '60vh',
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: '100%'
    },
    color: "#cfdce6"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "col col-6 appliance-container",
    style: {
      height: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40,
      marginBottom: '16px'
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '80%',
      height: 40
    },
    color: "#cfdce6"
  }))));
};

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DOWNLOAD_PROGRESS_POLLING_INTERVAL = 10000;
var invalidDownloadStatusesForProgress = [DcpDownloadStatuses.NOT_STARTED, DcpDownloadStatuses.FAILED, DcpDownloadStatuses.EXPIRED, DcpDownloadStatuses.ERROR];
var validStatusesToShowDownload$1 = [DcpDownloadStatuses.NOT_STARTED, DcpDownloadStatuses.EXPIRED, DcpDownloadStatuses.ERROR, DcpDownloadStatuses.IN_PROGRESS, DcpDownloadStatuses.PENDING, DcpDownloadStatuses.FAILED, DcpDownloadStatuses.UNARCHIVING];
var validStatusesToDisableDownload = [DcpDownloadStatuses.ERROR, DcpDownloadStatuses.IN_PROGRESS, DcpDownloadStatuses.PENDING, DcpDownloadStatuses.UNARCHIVING];

var validStatusForPartialTasks$1 = _$1.concat(DuplicationProgressStatuses, DuplicationProgress.SUCCEEDED);

var WorkOrderDuplicationView = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WorkOrderDuplicationView, _React$Component);

  var _super = _createSuper$9(WorkOrderDuplicationView);

  function WorkOrderDuplicationView(props) {
    var _this;

    _classCallCheck$1(this, WorkOrderDuplicationView);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "updateDisabledAppliancesAndWorkOrderDetails", function (nextProps) {
      var appliance = _this.props.appliance;
      var updatedDisabledAppliances = _this.state.disabledAppliances;
      var waitingForStatus = _this.state.waitingForFirstStatus;

      var isCurrentWorkOrderDuplicatingInThisAppliance = _this.isCurrentWorkOrderDuplicatingInThisAppliance();

      var isAnyOtherWorkOrderDuplicatingInSameAppliance = _this.isAnyOtherWorkOrderDuplicatingInSameAppliance();

      if (!isCurrentWorkOrderDuplicatingInThisAppliance) {
        updatedDisabledAppliances = _$1.remove(updatedDisabledAppliances, nextProps.appliance.applianceId);
        waitingForStatus = _$1.remove(waitingForStatus, nextProps.appliance.applianceId);

        _this.setState({
          disabledAppliances: updatedDisabledAppliances,
          waitingForFirstStatus: waitingForStatus
        });
      }

      if (_this.state.waitingForFirstStatus.includes(appliance.applianceId) && _this.state.disabledAppliances.includes(nextProps.appliance.applianceId) && isCurrentWorkOrderDuplicatingInThisAppliance) {
        _this.setState({
          waitingForFirstStatus: _$1.remove(waitingForStatus, nextProps.appliance.applianceId)
        });
      }

      var newAppliance = nextProps.appliance;

      var nextTask = _this.getTaskFromDuplicationStatus(newAppliance);

      if (!isEmpty(nextTask) && !isEmpty(nextTask.duplicationStatus) && nextTask.duplicationStatus.status === DuplicationProgress.FAILED || isAnyOtherWorkOrderDuplicatingInSameAppliance) {
        updatedDisabledAppliances = _$1.remove(updatedDisabledAppliances, nextProps.appliance.applianceId);

        _this.setState({
          disabledAppliances: updatedDisabledAppliances
        });

        waitingForStatus = _$1.remove(waitingForStatus, nextProps.appliance.applianceId);

        _this.setState({
          waitingForFirstStatus: waitingForStatus
        });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleStartCopy", function (e) {
      var applianceId = _this.props.appliance.applianceId;

      _this.setDisabledAppliances(applianceId);

      if (!_this.handleStartCopyDebounced) {
        _this.handleStartCopyDebounced = _$1.debounce(function () {
          _this.props.actions.startDuplication(_this.props.workOrder.workOrderNo);
        }, 500, {
          leading: true,
          trailing: false
        }).bind(_assertThisInitialized(_this));
      }

      e.stopPropagation();

      _this.handleStartCopyDebounced();
    });

    _defineProperty$1(_assertThisInitialized(_this), "triggerDownload", function () {
      var _this$props = _this.props,
          workOrderId = _this$props.workOrderId,
          applianceId = _this$props.appliance.applianceId;

      _this.props.actions.startDownload(workOrderId, applianceId);
    });

    _defineProperty$1(_assertThisInitialized(_this), "startDownloadProgressPolling", function () {
      _this.fetchUpdatedWorkOrderStatusFromServer(true);

      _this.stopDownloadProgressPolling();

      _this.state.downloadProgressPolling = setInterval(function () {
        _this.fetchUpdatedWorkOrderStatusFromServer(false);
      }, DOWNLOAD_PROGRESS_POLLING_INTERVAL);
    });

    _defineProperty$1(_assertThisInitialized(_this), "stopDownloadProgressPolling", function () {
      clearInterval(_this.state.downloadProgressPolling);
      _this.state.downloadProgressPolling = null;
    });

    _defineProperty$1(_assertThisInitialized(_this), "fetchDuplicationStatusFromServer", function () {
      var showLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.props.actions.fetchDuplicationStatus(showLoading);
    });

    _defineProperty$1(_assertThisInitialized(_this), "doesApplianceHaveErrors", function (duplication) {
      return duplication && duplication.status === DuplicationProgress.FAILED || duplication && duplication.statusDetails && duplication.statusDetails.failedTargetDrives && duplication.statusDetails.failedTargetDrives.length > 0;
    });

    _defineProperty$1(_assertThisInitialized(_this), "isApplianceInEjectionState", function () {
      var appliance = _this.props.appliance;
      return _this.state.appliancesInEjectionState.includes(appliance.applianceId);
    });

    _defineProperty$1(_assertThisInitialized(_this), "switchAppliance", function (serialNo) {
      var appliance = _this.props.appliances.find(function (appliance) {
        return appliance.serialNo === serialNo;
      });

      _this.props.actions.updateActiveAppliance(appliance);
    });

    _defineProperty$1(_assertThisInitialized(_this), "isCurrentWorkOrderDuplicatingInThisAppliance", function () {
      var _this$props2 = _this.props,
          appliance = _this$props2.appliance,
          workOrder = _this$props2.workOrder;

      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      return !isEmpty(currentTask) && applianceWorkOrderNo === workOrder.workOrderNo && _this.isDuplicationInProgress(currentTask.duplicationStatus);
    });

    _defineProperty$1(_assertThisInitialized(_this), "isAnyOtherWorkOrderDuplicatingInSameAppliance", function () {
      var _this$props3 = _this.props,
          appliance = _this$props3.appliance,
          workOrder = _this$props3.workOrder;

      var applianceTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(applianceTask);

      return !isEmpty(applianceWorkOrderNo) && workOrder.workOrderNo !== applianceWorkOrderNo && applianceTask && _this.isDuplicationInProgress(applianceTask.duplicationStatus);
    });

    _defineProperty$1(_assertThisInitialized(_this), "getTaskFromDuplicationStatus", function (appliance) {
      var drives = [];
      appliance.drives && appliance.drives.forEach(function (drive) {
        if (!isEmpty(drive.duplicationStatus)) drives.push(drive);
      });

      var uniqStatuses = _$1.uniq(_$1.map(drives, 'duplicationStatus.status').filter(function (s) {
        return !isEmpty(s);
      }));

      if (uniqStatuses.length > 1) {
        return appliance.drives && appliance.drives.find(function (d) {
          return d && !isEmpty(d.duplicationStatus) && validStatusForPartialTasks$1.includes(d.duplicationStatus.status);
        });
      } else {
        return appliance.drives && appliance.drives.find(function (d) {
          return d && !isEmpty(d.duplicationStatus);
        }) || appliance.drives && appliance.drives[0] || {};
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "isDuplicationInProgress", function (duplication) {
      return !isEmpty(duplication) && (DuplicationProgressStatuses.includes(duplication.status) || duplication.status === DuplicationProgress.QUEUED);
    });

    _defineProperty$1(_assertThisInitialized(_this), "insertedDrives", function (appliance) {
      if (!appliance) {
        appliance = _this.props.appliance;
      }

      var insertedDrives = [];

      if (!isEmpty(appliance)) {
        var applianceBays = appliance && appliance.drives;

        if (!isEmpty(applianceBays)) {
          _$1.forEach(applianceBays, function (bay) {
            if (!isEmpty(bay.path)) insertedDrives.push(bay);
          });
        }
      }

      return insertedDrives;
    });

    _defineProperty$1(_assertThisInitialized(_this), "isAnyDownloadInProgressOrPending", function (workOrderAppliancesDownloadStatus) {
      var downloadInProgessOrPending = 0;

      _$1.forEach(workOrderAppliancesDownloadStatus, function (applianceDownloadStatus) {
        if (applianceDownloadStatus.dcpDownloadStatus === DcpDownloadStatuses.IN_PROGRESS || applianceDownloadStatus.dcpDownloadStatus === DcpDownloadStatuses.PENDING) {
          downloadInProgessOrPending++;
        }
      });

      return downloadInProgessOrPending > 0;
    });

    _defineProperty$1(_assertThisInitialized(_this), "fetchUpdatedWorkOrderStatusFromServer", function (showLoading) {
      var _this$props4 = _this.props,
          workOrderNo = _this$props4.workOrder.workOrderNo,
          workOrderId = _this$props4.workOrderId;
      workOrderNo = workOrderId === workOrderNo ? workOrderNo : workOrderId;
      workOrderNo && _this.props.actions.fetchWorkOrderFromServer && _this.props.actions.fetchWorkOrderFromServer(workOrderNo, showLoading);
    });

    _defineProperty$1(_assertThisInitialized(_this), "wereAllDrivesCopied", function () {
      var workOrder = _this.props.workOrder;
      return workOrder.totalCopied === workOrder.totalDrives;
    });

    _defineProperty$1(_assertThisInitialized(_this), "setDisabledAppliances", function (applianceId) {
      var disabledAppliances = _$1.uniq(_$1.concat(_this.state.disabledAppliances, [applianceId]));

      var waitingForFirstStatus = _$1.uniq(_$1.concat(_this.state.waitingForFirstStatus, [applianceId]));

      _this.setState({
        disabledAppliances: disabledAppliances,
        waitingForFirstStatus: waitingForFirstStatus
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldDisableDownloadButton", function () {
      var _this$props5 = _this.props,
          workOrder = _this$props5.workOrder,
          appliance = _this$props5.appliance;
      var workOrderApplianceCplDownloadStatus = {};

      if (workOrder.compositions) {
        workOrderApplianceCplDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions)[appliance.serialNo];
      }

      var workOrderApproved = false;

      if (!isEmpty(workOrder)) {
        workOrderApproved = workOrder && workOrder.status === WorkOrderStatuses.APPROVED;
      }

      return !workOrderApproved || isEmpty(appliance) || workOrderApplianceCplDownloadStatus && validStatusesToDisableDownload.includes(workOrderApplianceCplDownloadStatus.dcpDownloadStatus);
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldDisableCopyButton", function () {
      var _this$props6 = _this.props,
          workOrder = _this$props6.workOrder,
          appliance = _this$props6.appliance;
      var insertedDrives = [];
      var workOrderApproved = false;

      if (!isEmpty(workOrder)) {
        workOrderApproved = workOrder && workOrder.status === WorkOrderStatuses.APPROVED;
      }

      if (!isEmpty(appliance)) {
        var applianceBays = appliance && appliance.drives;

        if (!isEmpty(applianceBays)) {
          insertedDrives = _this.insertedDrives();
        }
      }

      return _this.state.disabledAppliances.includes(appliance.applianceId) || insertedDrives.length < 1 || !workOrderApproved || _this.isCurrentWorkOrderDuplicatingInThisAppliance() || _this.isAnyOtherWorkOrderDuplicatingInSameAppliance() || _this.state.waitingForFirstStatus.includes(appliance.applianceId);
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldShowDownloadStatus", function (applianceWorkOrderDownloadStatus) {
      var _this$props7 = _this.props,
          appliance = _this$props7.appliance,
          workOrder = _this$props7.workOrder;

      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      return !applianceWorkOrderDownloadStatus || validStatusesToShowDownload$1.includes(applianceWorkOrderDownloadStatus.dcpDownloadStatus) || applianceWorkOrderDownloadStatus.dcpDownloadStatus === DcpDownloadStatuses.FAILED && currentTask && applianceWorkOrderNo === workOrder.workOrderNo && currentTask.duplicationStatus.status === DuplicationProgress.FAILED || isEmpty(currentTask);
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldShowCopyStatus", function (applianceWorkOrderDownloadStatus) {
      var _this$props8 = _this.props,
          appliance = _this$props8.appliance,
          workOrder = _this$props8.workOrder;

      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      return applianceWorkOrderDownloadStatus && applianceWorkOrderDownloadStatus.dcpDownloadStatus === DcpDownloadStatuses.COMPLETED && applianceWorkOrderDownloadStatus.dcpDownloadStatus !== DcpDownloadStatuses.PENDING && applianceWorkOrderDownloadStatus.dcpDownloadStatus !== DcpDownloadStatuses.DOWNLOADING || applianceWorkOrderDownloadStatus.dcpDownloadStatus === DcpDownloadStatuses.FAILED && currentTask && applianceWorkOrderNo === workOrder.workOrderNo && (currentTask.duplicationStatus.status === DuplicationProgress.SUCCEEDED || DuplicationProgressStatuses.includes(currentTask.duplicationStatus.status)) && !isEmpty(currentTask);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderApplianceTabs", function () {
      var _this$props9 = _this.props,
          appliances = _this$props9.appliances,
          appliance = _this$props9.appliance,
          duplications = _this$props9.duplication.duplications;
      return appliances.map(function (a) {
        var applianceDuplication = duplications.find(function (duplication) {
          return a.applianceId === duplication.applianceId;
        });

        var doesApplianceHaveErrors = _this.doesApplianceHaveErrors(applianceDuplication);

        return /*#__PURE__*/React__default.createElement("div", {
          className: classNames$1('appliance-tab-style', {
            'active-tab-style': a.applianceId === appliance.applianceId,
            'tab-error': doesApplianceHaveErrors
          }),
          onClick: function onClick() {
            return _this.switchAppliance(a.serialNo);
          }
        }, /*#__PURE__*/React__default.createElement("div", null, a.serialNo));
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderApplianceRack", function () {
      var _this$props10 = _this.props,
          workOrder = _this$props10.workOrder;
          _this$props10.appliance;

      var isCurrentWorkOrderDuplicatingInThisAppliance = _this.isCurrentWorkOrderDuplicatingInThisAppliance();

      if (isEmpty(_this.props.user.appliances)) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "h4 center"
        }, i18n.t('noAppliancesFound'));
      } else {
        var _appliance = _this.props.appliance;
        return /*#__PURE__*/React__default.createElement(ApplianceRack, {
          appliance: _appliance,
          workOrder: workOrder,
          isCurrentWorkOrderDuplicatingInThisAppliance: isCurrentWorkOrderDuplicatingInThisAppliance
        });
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDuplicationStage", function () {
      var _this$props11 = _this.props,
          workOrder = _this$props11.workOrder,
          appliance = _this$props11.appliance;
      var message = i18n.t('copyPending');
      var className = 'h4 mt1 duplication-';

      var allDrivesCopied = _this.wereAllDrivesCopied();

      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      if (!(!isEmpty(currentTask) && _this.isDuplicationInProgress(currentTask.duplicationStatus)) && allDrivesCopied && !isEmpty(currentTask.duplicationStatus) && currentTask.duplicationStatus.status !== DuplicationProgress.FAILED) {
        message = i18n.t('copyCompleted');
      } else if (!isEmpty(currentTask) && applianceWorkOrderNo === workOrder.workOrderNo) {
        switch (currentTask.duplicationStatus.status) {
          case DuplicationProgress.QUEUED:
            message = i18n.t('copyQueued');
            break;

          case DuplicationProgress.PREPARING:
            message = i18n.t('preparingToCopy');
            break;

          case DuplicationProgress.FORMATTING:
            message = i18n.t('stageFormattingDrives');
            break;

          case DuplicationProgress.DUPLICATING:
            message = i18n.t('stageCopyingContentToDrives');
            break;

          case DuplicationProgress.VERIFYING:
            message = i18n.t('stageVerifying');
            break;

          case DuplicationProgress.FAILED:
            message = i18n.t('copyFailed');
            break;
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: className
      }, message);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderCopyStatus", function () {
      var _this$props12 = _this.props,
          appliance = _this$props12.appliance,
          workOrder = _this$props12.workOrder;
      var workOrderDuplicationProgress = 0;

      var insertedDrives = _this.insertedDrives();

      var task = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(task);

      if (applianceWorkOrderNo === workOrder.workOrderNo && !isEmpty(task) && !isEmpty(task.duplicationStatus) && (DuplicationProgressStatuses.includes(task.duplicationStatus.status) || task.duplicationStatus.status === DuplicationProgress.SUCCEEDED)) {
        if (_$1.isNumber(task.duplicationStatus.progress)) {
          workOrderDuplicationProgress = task.duplicationStatus.progress;
        }

        if (task.duplicationStatus.status === DuplicationProgress.SUCCEEDED) {
          workOrderDuplicationProgress = 100;
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix copy-status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-12"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "copy-info-text",
        style: {
          maxWidth: '100%'
        }
      }, _this.renderDuplicationStage(), /*#__PURE__*/React__default.createElement("div", {
        className: "h5"
      }, i18n.t('insertedDrivesCount', {
        itemCount: (insertedDrives || []).length
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "progress-bar-container center"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "progress-text h2"
      }, Math.floor(workOrderDuplicationProgress), "%"), /*#__PURE__*/React__default.createElement(ProgressBar, {
        type: "circle",
        percent: 100,
        strokeWidth: 6.25,
        strokeColor: "#cbcbcb"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1({
          hide: workOrderDuplicationProgress === 0
        }, 'progress-indicator')
      }, /*#__PURE__*/React__default.createElement(ProgressBar, {
        type: "circle",
        percent: workOrderDuplicationProgress,
        strokeWidth: 6.25,
        style: {
          transform: 'rotate(-90deg)'
        },
        strokeColor: "#084782"
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "action-items center"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonText: i18n.t('startCopying'),
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        disabled: _this.shouldDisableCopyButton(),
        onClick: _this.handleStartCopy
      })));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDownloadStatus", function () {
      var _this$props13 = _this.props,
          workOrder = _this$props13.workOrder,
          _this$props13$applian = _this$props13.appliance,
          applianceId = _this$props13$applian.applianceId,
          serialNo = _this$props13$applian.serialNo;
      var workOrderDownloadProgress = 0;
      var applianceWorkOrderDownloadStatus = {};

      if (!isEmpty(workOrder.compositions)) {
        getOverallWorkOrderCplsStatus(workOrder.compositions);
        applianceWorkOrderDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions)[serialNo];

        if (applianceWorkOrderDownloadStatus && !invalidDownloadStatusesForProgress.includes(applianceWorkOrderDownloadStatus.dcpDownloadStatus)) {
          workOrder.compositions.forEach(function (composition) {
            var applianceDownloadDetails = composition.dcpDownloadsDetails.find(function (downloadDetail) {
              return downloadDetail.applianceId === applianceId;
            });

            if (applianceDownloadDetails) {
              workOrderDownloadProgress += applianceDownloadDetails.progress;
            }
          });
        }

        workOrderDownloadProgress = workOrderDownloadProgress / workOrder.compositions.length;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix copy-status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-12"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "center copy-info-text",
        style: {
          maxWidth: '100%'
        }
      }, _this.renderDownloadStatusMessage()), /*#__PURE__*/React__default.createElement("div", {
        className: "progress-bar-container center"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "progress-text h2"
      }, Math.floor(workOrderDownloadProgress), "%"), /*#__PURE__*/React__default.createElement(ProgressBar, {
        type: "circle",
        percent: 100,
        strokeWidth: 6.25,
        strokeColor: "#cbcbcb"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1({
          hide: workOrderDownloadProgress === 0
        }, 'progress-indicator')
      }, /*#__PURE__*/React__default.createElement(ProgressBar, {
        type: "circle",
        percent: workOrderDownloadProgress,
        strokeWidth: 6.25,
        style: {
          transform: 'rotate(-90deg)'
        },
        strokeColor: "##084782"
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "action-items center"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonText: i18n.t('download'),
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        disabled: _this.shouldDisableDownloadButton(),
        onClick: _this.triggerDownload
      })));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDownloadCopyStatus", function () {
      var _this$props14 = _this.props,
          workOrder = _this$props14.workOrder,
          serialNo = _this$props14.appliance.serialNo;
      var applianceWorkOrderDownloadStatus = {};

      var isCurrentWorkOrderDuplicatingInThisAppliance = _this.isCurrentWorkOrderDuplicatingInThisAppliance();

      if (_$1.isEmpty(workOrder)) {
        return;
      }

      if (serialNo && workOrder.compositions) {
        applianceWorkOrderDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions)[serialNo];
      }

      if (_this.shouldShowCopyStatus(applianceWorkOrderDownloadStatus) || isCurrentWorkOrderDuplicatingInThisAppliance) {
        return _this.renderCopyStatus();
      } else if (_this.shouldShowDownloadStatus(applianceWorkOrderDownloadStatus) && !isCurrentWorkOrderDuplicatingInThisAppliance) {
        return _this.renderDownloadStatus();
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDownloadStatusMessage", function () {
      var _this$props15 = _this.props,
          workOrder = _this$props15.workOrder,
          serialNo = _this$props15.appliance.serialNo;
      var message = i18n.t('downloadNotStarted');
      var applianceWorkOrderDownloadStatus = {};
      var overallWorkOrderCplsStatus = {};

      if (workOrder.compositions) {
        overallWorkOrderCplsStatus = getOverallWorkOrderCplsStatus(workOrder.compositions);
        applianceWorkOrderDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions)[serialNo];
      }

      if (!isEmpty(applianceWorkOrderDownloadStatus)) {
        switch (applianceWorkOrderDownloadStatus.dcpDownloadStatus) {
          case DcpDownloadStatuses.QUEUED:
            {
              message = i18n.t('downloadQueued');
              break;
            }

          case DcpDownloadStatuses.PENDING:
            {
              message = i18n.t('downloadPending');
              break;
            }

          case DcpDownloadStatuses.NOT_STARTED:
            {
              message = i18n.t('downloadNotStarted');
              break;
            }

          case DcpDownloadStatuses.IN_PROGRESS:
            {
              if (overallWorkOrderCplsStatus.dcpUploadStatus === DcpUploadStatuses.IN_PROGRESS) {
                message = i18n.t('downloadPending');
              } else {
                message = "".concat(i18n.t('downloading'), "...");
              }

              break;
            }

          case DcpDownloadStatuses.COMPLETED:
            {
              message = i18n.t('downloadCompleted');
              break;
            }

          case DcpDownloadStatuses.FAILED:
            {
              message = i18n.t('downloadFailed');
              break;
            }

          case DcpDownloadStatuses.ERROR:
            {
              message = i18n.t('someErrorInGettingDownloadStatus');
              break;
            }

          case DcpDownloadStatuses.UNARCHIVING:
            {
              message = i18n.t('downloadingUnarchiving');
              break;
            }

          case DcpDownloadStatuses.ARCHIVED:
            {
              message = i18n.t('downloadingArchived');
              break;
            }

          case DcpDownloadStatuses.STALLED:
            {
              message = i18n.t('downloadingStalled');
              break;
            }

          default:
            message = '';
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "h4 mt1"
      }, message);
    });

    _defineProperty$1(_assertThisInitialized(_this), "getCopyInProgressDrivesInAllAppliances", function () {
      var _this$props16 = _this.props,
          appliances = _this$props16.appliances,
          workOrder = _this$props16.workOrder;
      var copyInProgressDrives = 0;

      if (!isEmpty(appliances)) {
        _$1.forEach(appliances, function (appliance) {
          var currentTask = _this.getTaskFromDuplicationStatus(appliance);

          var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

          var drives = appliance.drives && appliance.drives.filter(function (drive) {
            return !isEmpty(drive.duplicationStatus) && DuplicationProgressStatuses.includes(drive.duplicationStatus.status) && workOrder.workOrderNo === applianceWorkOrderNo;
          });
          copyInProgressDrives = copyInProgressDrives + drives && drives.length;
        });
      }

      return copyInProgressDrives;
    });

    _defineProperty$1(_assertThisInitialized(_this), "getCurrentTaskWorkOrderNo", function (bay) {
      var task = bay.duplicationStatus;
      return task && task.userData && task.userData.workOrderNo;
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleRedirection", function (appliance) {
      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      _this.props.onPageRedirect("".concat(applianceWorkOrderNo));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderRedirectionMessage", function () {
      var appliance = _this.props.appliance;

      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      return /*#__PURE__*/React__default.createElement("div", {
        className: "col col-10 mt2 mb2 pl2 center"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "h5"
      }, !isEmpty(applianceWorkOrderNo) ? /*#__PURE__*/React__default.createElement("div", null, i18n.t('applianceBusyInDuplicating'), /*#__PURE__*/React__default.createElement("span", {
        className: "blue cursor-pointer",
        onClick: function onClick() {
          return _this.handleRedirection(appliance);
        }
      }, applianceWorkOrderNo)) : /*#__PURE__*/React__default.createElement("div", null, "".concat(i18n.t('fetchingDetailsPleaseWait'), "..."))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "closeAlert", function () {
      _this.setState({
        showAlert: false
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderSizeAlert", function (workOrderCompositions) {
      if (isEmpty(workOrderCompositions)) {
        return;
      }

      var size = _this.calculateWorkOrderContentSize(workOrderCompositions);

      if (size >= 0 && size < 8) {
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            paddingBottom: '24px'
          }
        }, /*#__PURE__*/React__default.createElement(Alert, {
          title: i18n.t('contentIsLessThan8GBWarning'),
          bodyContent: i18n.t('contentIsLessThan8GBWarningContent'),
          closeAlert: _this.closeAlert,
          showIcon: true,
          showClose: true,
          showSubText: true,
          type: "warning"
        }));
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDuplicationView", function () {
      var _this$props17 = _this.props,
          workOrder = _this$props17.workOrder,
          serialNo = _this$props17.appliance.serialNo,
          appliances = _this$props17.appliances;
      var showAlert = _this.state.showAlert;
      var applianceWorkOrderDownloadStatus = {};
      if (isEmpty(workOrder)) return;

      if (serialNo && workOrder.compositions) {
        applianceWorkOrderDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions)[serialNo];
      }

      var shouldShowDownloadStatus = _this.shouldShowDownloadStatus(applianceWorkOrderDownloadStatus);

      var isAnyOtherWorkOrderDuplicatingInSameAppliance = _this.isAnyOtherWorkOrderDuplicatingInSameAppliance();

      if (!shouldShowDownloadStatus) {
        _this.getCopyInProgressDrivesInAllAppliances();
      }

      if (shouldShowDownloadStatus && _this.isCurrentWorkOrderDuplicatingInThisAppliance() || !(isAnyOtherWorkOrderDuplicatingInSameAppliance && !shouldShowDownloadStatus)) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: classNames$1('duplication-view', {
            'col col-10': appliances.length > 1,
            'col col-12': appliances.length < 1
          })
        }, showAlert ? _this.renderSizeAlert(workOrder.compositions) : null, /*#__PURE__*/React__default.createElement("div", {
          className: "col col-5 copy-container"
        }, _this.renderDownloadCopyStatus()), /*#__PURE__*/React__default.createElement("div", {
          className: "col col-7 appliance-container"
        }, _this.renderApplianceRack()));
      }

      if (isAnyOtherWorkOrderDuplicatingInSameAppliance && !shouldShowDownloadStatus) {
        return _this.renderRedirectionMessage();
      }
    });

    _this.state = {
      areSlotsInEjectedState: true,
      downloadProgressPolling: null,
      duplicationProgressPolling: null,
      disabledAppliances: [],
      appliancesInEjectionState: [],
      loadingWorkOrdersInProgress: false,
      currentlyDuplicatingWorkOrder: {},
      waitingForFirstStatus: [],
      showAlert: true
    };
    return _this;
  }

  _createClass$1(WorkOrderDuplicationView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props18 = this.props,
          user = _this$props18.user,
          appliances = _this$props18.appliances;

      if (!isEmpty(user.appliances) && this.props.actions) {
        this.props.actions.updateActiveAppliance(appliances[0]);
      }

      this.startDownloadProgressPolling();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var workOrder = nextProps.workOrder;
          nextProps.appliance;
      var isAnyDownloadInProgressOrPending = false;

      if (workOrder.compositions) {
        var workOrderAppliancesDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions);
        isAnyDownloadInProgressOrPending = this.isAnyDownloadInProgressOrPending(workOrderAppliancesDownloadStatus);
      }

      this.updateDisabledAppliancesAndWorkOrderDetails(nextProps);

      if (this.state.downloadProgressPolling && !isAnyDownloadInProgressOrPending) {
        this.stopDownloadProgressPolling();
      } else if (!this.state.downloadProgressPolling && isAnyDownloadInProgressOrPending) {
        this.startDownloadProgressPolling();
      }

      var newAppliance = nextProps.appliance;
      var nextTask = this.getTaskFromDuplicationStatus(newAppliance);

      if (this.isCurrentWorkOrderDuplicatingInThisAppliance() && nextTask.duplicationStatus.status === DuplicationProgress.SUCCEEDED) {
        this.fetchUpdatedWorkOrderStatusFromServer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopDownloadProgressPolling();
    }
  }, {
    key: "calculateWorkOrderContentSize",
    value: function calculateWorkOrderContentSize(compositions) {
      var uniqueAssets = [];
      compositions.forEach(function (cpl) {
        uniqueAssets = uniqBy(concat(uniqueAssets, cpl.assets), 'id');
      });
      return sumBy(uniqueAssets, 'size') / Math.pow(2, 30);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.workOrderLoading) return /*#__PURE__*/React__default.createElement(DuplicationLoader, null);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "duplication-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-12 duplication-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-2 appliance-tabs"
      }, this.props.appliances.length > 1 && this.renderApplianceTabs()), this.renderDuplicationView()));
    }
  }]);

  return WorkOrderDuplicationView;
}(React__default.Component);

var getCity = function getCity(address) {
  return address.city ? isString$1(address.city) ? address.city : address.city.name : ' ';
};

var getState = function getState(address) {
  return address.state ? isString$1(address.state) ? address.state : address.state.name : ' ';
};

var getCountry = function getCountry(address) {
  return address.country ? isString$1(address.country) ? address.country : address.country.name : ' ';
};

var ShipmentAddress = function ShipmentAddress(props) {
  var facilityDetails = props.facilityDetails;
      props.expanded;
      var shipment = props.shipment;
  var address = shipment.status === ShippingStatus.DISPATCHED ? shipment.shippingDetails.address ? shipment.shippingDetails.address : facilityDetails : facilityDetails;
  var city = getCity(address);
  var state = getState(address);
  var country = getCountry(address);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "shipment-address"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "facility-name"
  }, facilityDetails.name), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
    className: "text-ellipsis address-line-1",
    title: "".concat(address.street, " + ").concat(address.street, " + ").concat(address.displayLocation, " ")
  }, address.street, address.street ? ',' : '', address.displayLocation, address.displayLocation ? ',' : ' '), ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "text-ellipsis address-line-2"
  }, city), /*#__PURE__*/React__default.createElement("span", {
    className: "text-ellipsis address-line-3"
  }, state, " - ", address.postalCode, address.postalCode ? ',' : ' ', " ", country));
};

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectField = /*#__PURE__*/function (_React$Component) {
  _inherits$1(SelectField, _React$Component);

  var _super = _createSuper$8(SelectField);

  function SelectField(props) {
    _classCallCheck$1(this, SelectField);

    return _super.call(this, props);
  }

  _createClass$1(SelectField, [{
    key: "renderErrorText",
    value: function renderErrorText() {
      return !_$1.isEmpty(this.props.errorText) ? /*#__PURE__*/React__default.createElement("div", {
        className: "h6 red"
      }, this.props.errorText) : /*#__PURE__*/React__default.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(index$1, _extends$1({}, this.props, {
        theme: reactSelectTheme()
      })), this.renderErrorText());
    }
  }]);

  return SelectField;
}(React__default.Component);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectShippingInfo = /*#__PURE__*/function (_React$Component) {
  _inherits$1(SelectShippingInfo, _React$Component);

  var _super = _createSuper$7(SelectShippingInfo);

  function SelectShippingInfo(props) {
    var _this;

    _classCallCheck$1(this, SelectShippingInfo);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "handleStatusChange", function (selectedValue) {
      _this.props.onChange({
        status: selectedValue
      });
    });

    _this.handleShippingType = _this.handleShippingType.bind(_assertThisInitialized(_this));
    _this.handleReturnShippingType = _this.handleReturnShippingType.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass$1(SelectShippingInfo, [{
    key: "handleShippingType",
    value: function handleShippingType(shippingType) {
      this.handleChange(shippingType.label, 'type', 'shippingDetails');
    }
  }, {
    key: "handleReturnShippingType",
    value: function handleReturnShippingType(shippingType) {
      this.handleChange(shippingType.label, 'type', 'returnDetails');
    }
  }, {
    key: "handleChange",
    value: function handleChange(value, changedFieldName, shipmentMode) {
      var _cloneDeep = cloneDeep(this.props),
          shipment = _cloneDeep.shipment;

      if (!shipment[shipmentMode]) {
        shipment[shipmentMode] = {};
      }

      shipment[shipmentMode][changedFieldName] = value;
      this.props.onChange(_defineProperty$1({}, shipmentMode, shipment[shipmentMode]));
    } // getCountry = (address) => {
    //   return address.country
    //     ? isString(address.country)
    //       ? address.country
    //       : address.country.name
    //     : ' ';
    // };

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          shipment = _this$props.shipment,
          shippingTypes = _this$props.shippingTypes,
          isShipmentCancelled = _this$props.isShipmentCancelled,
          isShipmentPendingCancellation = _this$props.isShipmentPendingCancellation;
      var shippingDetails = shipment.shippingDetails,
          returnDetails = shipment.returnDetails;
      var address = formatAddress(shipment.theatre);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "shipment-info-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-section"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "heading"
      }, "Theatre"), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-name-shipment-details"
      }, shipment.theatre.name), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-address-shipment-details"
      }, address))), /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix shipment-section"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('semi-bold section-title', {
          hide: isShipmentCancelled || isShipmentPendingCancellation
        })
      }, i18n.t('delivery')), /*#__PURE__*/React__default.createElement("div", {
        className: "shipment-form"
      }, /*#__PURE__*/React__default.createElement("div", {
        title: i18n.t('selectCourierType'),
        className: classNames$1('col col-12 courier-selector', {
          hide: isShipmentCancelled || isShipmentPendingCancellation
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "courier-title"
      }, i18n.t('selectCourierType')), /*#__PURE__*/React__default.createElement(SelectField, {
        className: "delivery-select-container",
        classNamePrefix: "delivery-select",
        disabled: isShipmentCancelled || isShipmentPendingCancellation,
        isClearable: false,
        matchProp: "label",
        options: shippingTypes,
        value: shippingDetails && shippingDetails.type ? {
          label: shippingDetails.type,
          value: shippingDetails.type
        } : null,
        placeholder: i18n.t('selectCourierType'),
        onChange: this.handleShippingType,
        onFocus: this.handleFocus
      })), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-12 tracking-number-input', {
          hide: isShipmentCancelled || isShipmentPendingCancellation
        })
      }, /*#__PURE__*/React__default.createElement(TextInput$1, {
        disabled: isEmpty(shippingDetails) || !isEmpty(shippingDetails) && isEmpty(shippingDetails.type) || isShipmentCancelled || isShipmentPendingCancellation,
        withLabel: true,
        withRightIcon: false,
        ref: "trackingNoField",
        placeholder: i18n.t('enterTrackingNumber'),
        label: i18n.t('trackingNumber'),
        className: "textInput",
        value: shippingDetails && shippingDetails.reference,
        onChange: function onChange(event) {
          return _this2.handleChange(event.target.value, 'reference', 'shippingDetails');
        },
        onFocus: this.handleFocus,
        isOptional: false
      })), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('clearfix shipment-info', {
          hide: !isShipmentCancelled
        })
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, i18n.t('cancelled'))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('clearfix shipment-info', {
          hide: !isShipmentPendingCancellation
        })
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "red"
      }, i18n.t('pendingCancellation'))), /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 comment-section"
      }, /*#__PURE__*/React__default.createElement(TextInput$1, {
        disabled: isEmpty(shippingDetails) || !isEmpty(shippingDetails) && isEmpty(shippingDetails.type) && isEmpty(shippingDetails.reference) || isShipmentCancelled || isShipmentPendingCancellation,
        withLabel: true,
        withRightIcon: false,
        label: i18n.t('notes'),
        className: "textInput",
        placeholder: i18n.t('comments'),
        value: shippingDetails && shippingDetails.comments,
        title: shippingDetails && shippingDetails.comments,
        maxLength: 250,
        onChange: function onChange(event) {
          return _this2.handleChange(event.target.value, 'comments', 'shippingDetails');
        },
        onFocus: this.handleFocus
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix shipment-status-section"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('semi-bold section-title', {
          hide: isShipmentCancelled || isShipmentPendingCancellation
        })
      }, i18n.t('status')), /*#__PURE__*/React__default.createElement("div", {
        className: "status-section"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 mark-as-work-order-status"
      }, /*#__PURE__*/React__default.createElement(Radio, {
        label: 'Pending',
        selectedValue: shipment.status === ShippingStatus.PENDING,
        disabled: isEmpty(shippingDetails) || !isEmpty(shippingDetails) && isEmpty(shippingDetails.type) && isEmpty(shippingDetails.reference) || isShipmentCancelled || isShipmentPendingCancellation,
        onChange: function onChange() {
          return _this2.handleStatusChange(ShippingStatus.PENDING);
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 mark-as-work-order-status"
      }, /*#__PURE__*/React__default.createElement(Radio, {
        label: 'Shipped',
        selectedValue: shipment.status === ShippingStatus.DISPATCHED,
        disabled: isEmpty(shippingDetails) || !isEmpty(shippingDetails) && isEmpty(shippingDetails.type) && isEmpty(shippingDetails.reference) || isShipmentCancelled || isShipmentPendingCancellation,
        onChange: function onChange() {
          return _this2.handleStatusChange(ShippingStatus.DISPATCHED);
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 mark-as-work-order-status"
      }, /*#__PURE__*/React__default.createElement(Radio, {
        label: 'Delivered',
        selectedValue: shipment.status === ShippingStatus.DELIVERED,
        disabled: isEmpty(shippingDetails) || !isEmpty(shippingDetails) && isEmpty(shippingDetails.type) && isEmpty(shippingDetails.reference) || isShipmentCancelled || isShipmentPendingCancellation,
        onChange: function onChange() {
          return _this2.handleStatusChange(ShippingStatus.DELIVERED);
        }
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('clearfix return-section', {
          hide: isShipmentCancelled || isShipmentPendingCancellation
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "semi-bold section-title"
      }, i18n.t('return')), /*#__PURE__*/React__default.createElement("div", {
        className: "shipment-form"
      }, /*#__PURE__*/React__default.createElement("div", {
        title: i18n.t('selectCourierType'),
        className: "col col-12 courier-selector"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "courier-title"
      }, i18n.t('selectCourierType')), /*#__PURE__*/React__default.createElement(SelectField, {
        className: "return-select-container",
        classNamePrefix: "return-select",
        isClearable: false,
        matchProp: "label",
        options: shippingTypes,
        value: returnDetails && returnDetails.type ? {
          label: returnDetails.type,
          value: returnDetails.type
        } : null,
        errorText: shipment.returnTypeErrorText,
        placeholder: i18n.t('selectCourierType'),
        onChange: this.handleReturnShippingType,
        onFocus: this.handleFocus
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "col col-12 tracking-number-input"
      }, /*#__PURE__*/React__default.createElement(TextInput$1, {
        withLabel: true,
        withRightIcon: false,
        className: "textInput",
        label: i18n.t('trackingNumber'),
        placeholder: i18n.t('enterTrackingNumber'),
        value: returnDetails && returnDetails.reference,
        onChange: function onChange(event) {
          return _this2.handleChange(event.target.value, 'reference', 'returnDetails');
        },
        onFocus: this.handleFocus
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "comment-section"
      }, /*#__PURE__*/React__default.createElement(TextInput$1, {
        withLabel: true,
        withRightIcon: false,
        label: i18n.t('notes'),
        className: "textInput comment-input",
        placeholder: i18n.t('comments'),
        value: returnDetails && returnDetails.comments,
        title: returnDetails && returnDetails.comments,
        maxLength: 250,
        onChange: function onChange(event) {
          return _this2.handleChange(event.target.value, 'comments', 'returnDetails');
        },
        onFocus: this.handleFocus
      })))));
    }
  }]);

  return SelectShippingInfo;
}(React__default.Component);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

var DeliveryInstructions = /*#__PURE__*/function (_React$Component) {
  _inherits$1(DeliveryInstructions, _React$Component);

  var _super = _createSuper$6(DeliveryInstructions);

  function DeliveryInstructions(props) {
    var _this;

    _classCallCheck$1(this, DeliveryInstructions);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "frameDayMarkerStrings", function (days) {
      var dayMarkerString = [];

      var listOfDays = _this.getStartDayAndEndDayList(days);

      listOfDays.forEach(function (day) {
        if (day.startDay !== day.endDay) {
          dayMarkerString.push("".concat(day.startDay, " - ").concat(day.endDay));
        } else {
          dayMarkerString.push("".concat(day.startDay));
        }
      });
      return dayMarkerString.join(', ');
    });

    _defineProperty$1(_assertThisInitialized(_this), "convertTo12HourFormat", function (time) {
      return moment(time, 'hh:mm').format('h A');
    });

    _defineProperty$1(_assertThisInitialized(_this), "getConsolidatedDeliveryTimes", function () {
      var _this$props = _this.props,
          facilityDetails = _this$props.facilityDetails;
          _this$props.shipment;
      var availabilityTimes = facilityDetails.deliveryInstructions.times;
      var deliveryTimes = [];

      if (availabilityTimes) {
        Object.keys(availabilityTimes).forEach(function (day) {
          var currentDay = availabilityTimes[day];
          var deliveryDay = capitalize$1(day);

          if (isEmpty(deliveryTimes)) {
            deliveryTimes.push({
              from: currentDay.from,
              to: currentDay.to,
              days: [deliveryDay]
            });
          } else {
            var existingTimeIndex = deliveryTimes.findIndex(function (time) {
              return time.from === currentDay.from && time.to === currentDay.to;
            });

            if (existingTimeIndex > -1) {
              deliveryTimes[existingTimeIndex].days.push(capitalize$1(day));
            } else {
              deliveryTimes.push({
                from: currentDay.from,
                to: currentDay.to,
                days: [deliveryDay]
              });
            }
          }
        });
      }

      return deliveryTimes;
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDeliveryNotes", function () {
      var facilityDetails = _this.props.facilityDetails;
      var notes = facilityDetails.deliveryInstructions.notes;

      if (notes) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "mt1 overflow text-ellipsis"
        }, notes);
      }
    });

    return _this;
  }

  _createClass$1(DeliveryInstructions, [{
    key: "constructDeliveryTime",
    value: function constructDeliveryTime(from, to, startDay) {
      var endDay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, startDay, !endDay && ':'), endDay && /*#__PURE__*/React__default.createElement("span", null, "- ", endDay, ":"), /*#__PURE__*/React__default.createElement("span", null, "\xA0", this.convertTo12HourFormat(from)), /*#__PURE__*/React__default.createElement("span", null, "- ", this.convertTo12HourFormat(to)));
    }
  }, {
    key: "renderDeliveryTimes",
    value: function renderDeliveryTimes() {
      var _this2 = this;

      var _this$props2 = this.props,
          facilityDetails = _this$props2.facilityDetails;
          _this$props2.shipment;
      var availabilityTimes = facilityDetails.deliveryInstructions.times;
      var deliveryTimes = [];

      if (availabilityTimes) {
        Object.keys(availabilityTimes).forEach(function (day) {
          var deliveryDay = capitalize$1(day);
          deliveryTimes.push(_this2.constructDeliveryTime(availabilityTimes[day].from, availabilityTimes[day].to, deliveryDay));
        });
        return deliveryTimes;
      }
    }
  }, {
    key: "getStartDayAndEndDayList",
    value: function getStartDayAndEndDayList(days, standAloneDays) {
      var dayMarkers = [];
      var firstDay = days[0];
      days.forEach(function (day, index) {
        var prevDay = days[index - 1];
        var nextDay = days[index + 1];

        if (weekDays.indexOf(nextDay) - weekDays.indexOf(day) === 1 || weekDays.indexOf(day) - weekDays.indexOf(prevDay) === 1) {
          var dayMarker = {
            startDay: firstDay,
            endDay: day
          };
          var existingDayMarker = dayMarkers.find(function (d) {
            return d.startDay === firstDay;
          });

          if (existingDayMarker) {
            existingDayMarker.endDay = day;
          } else {
            dayMarkers.push(dayMarker);
          }
        }

        if (!nextDay && weekDays.indexOf(day) - weekDays.indexOf(prevDay) > 1) {
          var _dayMarker = {
            startDay: day,
            endDay: day
          };
          dayMarkers.push(_dayMarker);
        } else if (weekDays.indexOf(nextDay) - weekDays.indexOf(day) > 1) {
          firstDay = nextDay;
        }
      });
      return dayMarkers;
    }
  }, {
    key: "renderShipmentDeliveryNotes",
    value: function renderShipmentDeliveryNotes() {
      var deliveryNote = this.props.shipment.deliveryNote;

      if (deliveryNote) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "overflow text-ellipsis"
        }, deliveryNote);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          facilityDetails = _this$props3.facilityDetails,
          deliveryNote = _this$props3.shipment.deliveryNote;
      var deliveryInstructions = facilityDetails.deliveryInstructions;

      if (isEmpty(deliveryInstructions)) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "left-align"
        }, "-");
      }

      var notes = deliveryInstructions.notes,
          times = deliveryInstructions.times;

      if (isEmpty(notes) && isEmpty(times) && isEmpty(deliveryNote)) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "left-align"
        }, "-");
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "overflow text-ellipsis delivery-instructions"
      }, this.renderShipmentDeliveryNotes(), this.renderDeliveryTimes(), this.renderDeliveryNotes());
    }
  }]);

  return DeliveryInstructions;
}(React__default.Component);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var WorkOrderShipmentView = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WorkOrderShipmentView, _React$Component);

  var _super = _createSuper$5(WorkOrderShipmentView);

  function WorkOrderShipmentView() {
    var _this;

    _classCallCheck$1(this, WorkOrderShipmentView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      isPaneOpen: false,
      currentShipment: null
    });

    _defineProperty$1(_assertThisInitialized(_this), "getSlugByName", function (shippingTypes, type) {
      var shippingType = shippingTypes.find(function (s) {
        return s.name === type;
      });
      return shippingType && shippingType.aftership_slug;
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleChange", function (values) {
      var currentShipment = _this.state.currentShipment;
      var shippingTypes = _this.props.shippingTypes;
      currentShipment.shippingDetails = _objectSpread$1(_objectSpread$1({}, currentShipment.shippingDetails), values.shippingDetails);
      currentShipment.returnDetails = _objectSpread$1(_objectSpread$1({}, currentShipment.returnDetails), values.returnDetails);

      if (values.status) {
        currentShipment.status = values.status;
      }

      if (currentShipment.shippingDetails) {
        currentShipment.shippingDetails.slug = _this.getSlugByName(shippingTypes, currentShipment.shippingDetails.type);
      }

      if (currentShipment.returnDetails) {
        currentShipment.returnDetails.slug = _this.getSlugByName(shippingTypes, currentShipment.returnDetails.type);
      }

      _this.setState({
        currentShipment: currentShipment
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleSave", function () {
      var workOrder = _this.props.workOrder;
      var currentShipment = _this.state.currentShipment;
      currentShipment.shippingDetails.address = _this.getAddress(); // currentShipment.status = ShippingStatus.DISPATCHED;

      if (currentShipment.status === ShippingStatus.DISPATCHED) {
        currentShipment.dispatchedOn = moment().format('YYYY-MM-DD HH:mm:ss.SSSZ');
      }

      _this.props.saveShipments(workOrder.workOrderNo, [currentShipment]);

      _this.setState({
        currentShipment: currentShipment
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleShipmentUpload", function (files, rejected) {
      _this.props.uploadShipmentInformation(files[0], rejected);
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleSort", function (column) {
      var _column = _slicedToArray(column, 1),
          _column$ = _column[0],
          id = _column$.id,
          desc = _column$.desc;

      _this.props.sort(id, !desc);
    });

    _defineProperty$1(_assertThisInitialized(_this), "handlePanelClose", function () {
      if (_this.props.onClose) {
        _this.props.onClose(true);
      }

      _this.setState({
        isPaneOpen: false,
        currentShipment: null
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldDisableShipButton", function () {
      var currentShipment = _this.state.currentShipment;
      var hasShippingTypeError = _.isEmpty(currentShipment.shippingDetails) || _.isEmpty(currentShipment.shippingDetails.type) || currentShipment.shippingDetails.slug != null && _.isEmpty(currentShipment.shippingDetails.reference) || currentShipment.shippingTypeErrorText;
      return hasShippingTypeError || currentShipment.returnTypeErrorText;
    });

    _defineProperty$1(_assertThisInitialized(_this), "getAddress", function () {
      var currentShipment = _this.state.currentShipment;
      return {
        street: currentShipment.theatre.street,
        displayLocation: currentShipment.theatre.displayLocation,
        city: currentShipment.theatre.city,
        state: currentShipment.theatre.state,
        stateCode: currentShipment.theatre.stateCode,
        country: currentShipment.theatre.country,
        countryCode: currentShipment.theatre.countryCode,
        postalCode: currentShipment.theatre.postalCode,
        addressType: currentShipment.theatre.addressType
      };
    });

    _defineProperty$1(_assertThisInitialized(_this), "doesAtleastOneShipmentHaveInfoFilled", function () {
      var shipmentData = _this.props.shipmentData;
      return shipmentData.some(function (shipment) {
        return !isEmpty(shipment.shippingDetails) && !isEmpty(shipment.shippingDetails.reference);
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "doShipmentsHaveErrors", function () {
      var shipmentData = _this.props.shipmentData;
      return shipmentData.some(function (shipment) {
        return !isEmpty(shipment.shippingTypeErrorText) || !isEmpty(shipment.returnTypeErrorText);
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldEnableUpdateButton", function () {
      var _this$props = _this.props,
          workOrder = _this$props.workOrder;
          _this$props.shipments;
          var shouldUpdateButtonEnabled = true;

      if (workOrder.status !== WorkOrderStatuses.ASSIGNED && _this.doShipmentsHaveErrors()) {
        shouldUpdateButtonEnabled = false;
      }

      return shouldUpdateButtonEnabled;
    });

    _defineProperty$1(_assertThisInitialized(_this), "formatShippingTypes", function () {
      return _this.props.shippingTypes.map(function (type) {
        return {
          label: type.name,
          value: type.aftership_slug
        };
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "hasIdenticalStatuses", function (shipments, status) {
      return !shipments.some(function (shipment) {
        return shipment.status !== status;
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "bulkUpdateShipment", function (status) {
      var selectedShipments = _this.props.selectedShipments;
      var _this$props2 = _this.props,
          workOrder = _this$props2.workOrder,
          saveShipments = _this$props2.saveShipments;
      var updatedShipmentData = [];

      if (selectedShipments.length) {
        if (status === ShippingStatus.PENDING) {
          updatedShipmentData = selectedShipments.map(function (shipment) {
            var updatedShipment = cloneDeep(shipment);
            updatedShipment.status = ShippingStatus.PENDING;
            return updatedShipment;
          });
        } else if (status === ShippingStatus.DISPATCHED) {
          updatedShipmentData = selectedShipments.map(function (shipment) {
            var updatedShipment = cloneDeep(shipment);
            updatedShipment.status = ShippingStatus.DISPATCHED;
            updatedShipment.dispatchedOn = moment().format('YYYY-MM-DD HH:mm:ss.SSSZ');
            return updatedShipment;
          });
        } else if (status === ShippingStatus.DELIVERED) {
          updatedShipmentData = selectedShipments.map(function (shipment) {
            var updatedShipment = cloneDeep(shipment);
            updatedShipment.status = ShippingStatus.DELIVERED;
            return updatedShipment;
          });
        }

        saveShipments(workOrder.workOrderNo, updatedShipmentData);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "isSelectAllDisabled", function () {
      var shipmentData = _this.props.shipmentData;
      var disabled = true;
      shipmentData.forEach(function (shipment) {
        if (!_this.isShipmentCancelled(shipment) && !_this.isShipmentPendingCancellation(shipment) && !isEmpty(shipment.shippingDetails) && !isEmpty(shipment.shippingDetails.type) && !isEmpty(shipment.shippingDetails.reference)) {
          disabled = false;
          return disabled;
        }
      });
      return disabled;
    });

    _defineProperty$1(_assertThisInitialized(_this), "isAllShipmentSelected", function () {
      var _this$props3 = _this.props,
          shipmentData = _this$props3.shipmentData,
          selectedShipments = _this$props3.selectedShipments;
      var selectableShipments = 0;
      shipmentData.forEach(function (shipment) {
        if (!_this.isShipmentCancelled(shipment) && !_this.isShipmentPendingCancellation(shipment) && !isEmpty(shipment.shippingDetails) && !isEmpty(shipment.shippingDetails.type) && !isEmpty(shipment.shippingDetails.reference)) {
          selectableShipments = selectableShipments + 1;
        }
      });

      if (selectableShipments > 0 && selectableShipments === selectedShipments.length) {
        return true;
      } else {
        return false;
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "selectAllShipments", function () {
      var _this$props4 = _this.props,
          shipmentData = _this$props4.shipmentData,
          updateSelectedShipments = _this$props4.actions.updateSelectedShipments;
      var selectedShipments = [];

      if (!_this.isAllShipmentSelected()) {
        shipmentData.forEach(function (shipment) {
          if (!_this.isShipmentCancelled(shipment) && !_this.isShipmentPendingCancellation(shipment) && !isEmpty(shipment.shippingDetails) && !isEmpty(shipment.shippingDetails.type) && !isEmpty(shipment.shippingDetails.reference)) {
            selectedShipments.push(shipment);
          }
        });
      }

      updateSelectedShipments(selectedShipments);
    });

    _defineProperty$1(_assertThisInitialized(_this), "selectShipment", function (value) {
      var _this$props5 = _this.props,
          shipmentData = _this$props5.shipmentData,
          selectedShipments = _this$props5.selectedShipments,
          updateSelectedShipments = _this$props5.actions.updateSelectedShipments;

      var selectedShipmentsData = _.cloneDeep(selectedShipments); // let statusData = { status: '' };


      var index = shipmentData.findIndex(function (shipment) {
        return shipment.ordinal === value;
      });
      var selectedIndex = selectedShipments.findIndex(function (shipment) {
        return shipment.ordinal === value;
      });

      if (selectedIndex >= 0) {
        selectedShipmentsData.splice(selectedIndex, 1);
      } else {
        selectedShipmentsData.push(shipmentData[index]);
      }

      updateSelectedShipments(selectedShipmentsData);
    });

    _defineProperty$1(_assertThisInitialized(_this), "isShipmentCancelled", function (shipment) {
      return shipment.status === ShippingStatus.CANCELLED || shipment.status === ShippingStatus.REJECTED;
    });

    _defineProperty$1(_assertThisInitialized(_this), "isShipmentPendingCancellation", function (shipment) {
      return shipment.status === ShippingStatus.PENDING_CANCELLATION;
    });

    _defineProperty$1(_assertThisInitialized(_this), "onUpdateShipment", function (shipment) {
      _this.props.onClose(false);

      _this.setState({
        isPaneOpen: true,
        currentShipment: shipment
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderShipmentStatus", function (status) {
      var shipmentStatus = {
        pending: 'Pending',
        dispatched: 'Shipped',
        cancelled: 'Cancelled',
        pending_cancellation: 'Pending Cancellation',
        delivered: 'Delivered'
      };

      if (status === ShippingStatus.DISPATCHED) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StatusIcon, {
          color: STATUS_ICON_COLORS.GREEN,
          type: STATUS_ICON_TYPES.CIRCLE
        }), /*#__PURE__*/React__default.createElement("span", null, shipmentStatus[status]));
      } else if (status === ShippingStatus.DELIVERED) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StatusIcon, {
          color: STATUS_ICON_COLORS.GREEN,
          type: STATUS_ICON_TYPES.CIRCLE
        }), /*#__PURE__*/React__default.createElement("span", null, shipmentStatus[status]));
      } else if (status === ShippingStatus.PENDING) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StatusIcon, {
          color: STATUS_ICON_COLORS.YELLOW,
          type: STATUS_ICON_TYPES.CIRCLE
        }), /*#__PURE__*/React__default.createElement("span", null, shipmentStatus[status]));
      } else if (status === ShippingStatus.PENDING_CANCELLATION) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StatusIcon, {
          color: STATUS_ICON_COLORS.RED,
          type: STATUS_ICON_TYPES.CIRCLE
        }), /*#__PURE__*/React__default.createElement("span", null, shipmentStatus[status]));
      } else if (status === ShippingStatus.CANCELLED) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StatusIcon, {
          color: STATUS_ICON_COLORS.GREY,
          type: STATUS_ICON_TYPES.CIRCLE
        }), /*#__PURE__*/React__default.createElement("span", null, shipmentStatus[status]));
      } else if (status === ShippingStatus.REJECTED) {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StatusIcon, {
          color: STATUS_ICON_COLORS.GREY,
          type: STATUS_ICON_TYPES.CIRCLE
        }), /*#__PURE__*/React__default.createElement("span", null, i18n.t('rejected')));
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderActionButtons", function () {
      var _this$props6 = _this.props,
          onDownloadShipment = _this$props6.onDownloadShipment,
          selectedShipments = _this$props6.selectedShipments;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix action-buttons"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-12"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "right"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "mr1 col"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonText: i18n.t('downloadShipmentInformation'),
        onClick: function onClick() {
          return onDownloadShipment();
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "col dropzone-container mr1"
      }, /*#__PURE__*/React__default.createElement(Dropzone, {
        onDrop: function onDrop(accepted, rejected) {
          return _this.handleShipmentUpload(accepted, rejected);
        },
        accept: FILE_TYPE_XLSX
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps;
        return /*#__PURE__*/React__default.createElement("section", null, /*#__PURE__*/React__default.createElement("div", getRootProps(), /*#__PURE__*/React__default.createElement("input", getInputProps()), /*#__PURE__*/React__default.createElement(BaseButton$1, {
          buttonType: BUTTON_TYPE.PRIMARY,
          buttonText: i18n.t('uploadShipmentInformation')
        })));
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "mr1 col"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonText: i18n.t('markAsShipped'),
        onClick: function onClick() {
          return _this.bulkUpdateShipment(ShippingStatus.DISPATCHED);
        },
        disabled: !selectedShipments.length || _this.hasIdenticalStatuses(selectedShipments, ShippingStatus.DISPATCHED)
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "mr1 col"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonText: i18n.t('markAsPending'),
        onClick: function onClick() {
          return _this.bulkUpdateShipment(ShippingStatus.PENDING);
        },
        disabled: !selectedShipments.length || _this.hasIdenticalStatuses(selectedShipments, ShippingStatus.PENDING)
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "mr1 col"
      }, /*#__PURE__*/React__default.createElement(BaseButton$1, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonText: i18n.t('markAsDelivered'),
        onClick: function onClick() {
          return _this.bulkUpdateShipment(ShippingStatus.DELIVERED);
        },
        disabled: !selectedShipments.length || _this.hasIdenticalStatuses(selectedShipments, ShippingStatus.DELIVERED)
      })))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "columns", function () {
      var _this$props7 = _this.props;
          _this$props7.shipmentErrors;
          var selectedShipments = _this$props7.selectedShipments;
          _this$props7.shipmentData;
      return [{
        Header: /*#__PURE__*/React__default.createElement(Checkbox, {
          checked: _this.isAllShipmentSelected(),
          disabled: _this.isSelectAllDisabled(),
          onChange: function onChange() {
            return _this.selectAllShipments();
          }
        }),
        accessor: ShippingTabColumns.ORDINAL,
        sortable: false,
        resizable: false,
        width: 64,
        hideIfOnlyColumn: true,
        Cell: function Cell(_ref2) {
          var value = _ref2.value,
              original = _ref2.original;
          var shippingDetails = original.shippingDetails;
          return /*#__PURE__*/React__default.createElement(Checkbox, {
            checked: selectedShipments.find(function (shipment) {
              return shipment.ordinal === original.ordinal;
            }),
            disabled: isEmpty(shippingDetails) || !isEmpty(shippingDetails) && isEmpty(shippingDetails.type) && isEmpty(shippingDetails.reference) || _this.isShipmentCancelled(original) || _this.isShipmentPendingCancellation(original),
            onChange: function onChange() {
              return _this.selectShipment(value);
            }
          });
        }
      }, {
        Header: i18n.t('address'),
        accessor: ShippingTabColumns.ADDRESS,
        width: 250,
        Cell: function Cell(_ref3) {
          var original = _ref3.original;
          return /*#__PURE__*/React__default.createElement(ShipmentAddress, {
            shipment: original,
            facilityDetails: original.theatre
          });
        }
      }, {
        Header: i18n.t('deliveryInstructions'),
        accessor: ShippingTabColumns.DELIVERY_INSTRUCTIONS,
        Cell: function Cell(_ref4) {
          var original = _ref4.original;
          return /*#__PURE__*/React__default.createElement(DeliveryInstructions, {
            shipment: original,
            facilityDetails: original.theatre
          });
        }
      }, {
        Header: i18n.t('shipBy'),
        accessor: ShippingTabColumns.SHIP_BY,
        width: 200,
        Cell: function Cell(_ref5) {
          var original = _ref5.original;
          var shipBy = momentTZ.tz(original.dispatchDeadline, original.partnerTimezone);
          return /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-ship_by"
          }, shipBy.format('DD MMM, YYYY '), /*#__PURE__*/React__default.createElement("br", null), shipBy.format('hh:mm A'), " (", shipBy.format('z'), ")");
        }
      }, {
        Header: i18n.t('deliverBy'),
        accessor: ShippingTabColumns.DELIVER_BY,
        width: 200,
        Cell: function Cell(_ref6) {
          var original = _ref6.original;
          var deliverOn = momentTZ.tz(original.deliverOn, original.theatre.timezone);
          return /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-deliver_by"
          }, deliverOn.format('DD MMM, YYYY'), /*#__PURE__*/React__default.createElement("br", null), deliverOn.format('hh:mm A'), " (", deliverOn.format('z'), ")");
        }
      }, {
        Header: i18n.t('status'),
        accessor: ShippingTabColumns.STATUS,
        width: 200,
        Cell: function Cell(_ref7) {
          var value = _ref7.value;
          return /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-status"
          }, _this.renderShipmentStatus(value));
        }
      }, {
        Header: i18n.t('shippingInformation'),
        id: 'shipment_info',
        width: 200,
        sortable: false,
        Cell: function Cell(_ref8) {
          var original = _ref8.original;
          if (!original.shippingDetails && !original.returnDetails) return /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-info"
          }, " - ");
          return /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-info"
          }, original.shippingDetails && /*#__PURE__*/React__default.createElement("div", {
            className: "delivery-container"
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "delivery-title"
          }, i18n.t('delivery')), /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-delivery-info"
          }, original.shippingDetails.type && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, i18n.t('courierType'), ":"), original.shippingDetails.type), original.shippingDetails.reference && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, i18n.t('shipmentNo'), ":"), original.shippingDetails.reference), original.shippingDetails.comments && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, i18n.t('comments'), ":"), original.shippingDetails.comments))), original.returnDetails && /*#__PURE__*/React__default.createElement("div", {
            className: "return-container"
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "delivery-title"
          }, i18n.t('return')), /*#__PURE__*/React__default.createElement("div", {
            className: "shipment-return-info"
          }, original.returnDetails.type && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, i18n.t('courierType'), ":"), original.returnDetails.type), original.returnDetails.reference && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, i18n.t('shipmentNo'), ":"), original.returnDetails.reference), original.returnDetails.comments && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, i18n.t('comments'), ":"), original.returnDetails.comments))));
        }
      }, {
        id: 'icon',
        sortable: false,
        resizable: false,
        width: 64,
        hideIfOnlyColumn: true,
        Cell: function Cell(props) {
          return /*#__PURE__*/React__default.createElement(ActionMenu$1, {
            iconList: [{
              toolTip: i18n.t('updateDelivery'),
              onClick: function onClick() {
                return _this.onUpdateShipment(props.original);
              },
              iconName: 'EditIcon',
              buttonSize: 'small'
            }]
          });
        }
      }];
    });

    return _this;
  }

  _createClass$1(WorkOrderShipmentView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var shipmentData = this.props.shipmentData;

      if (shipmentData.length > 0) {
        this.setState({
          currentShipment: shipmentData[0]
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.closeRightPane !== this.props.closeRightPane && this.props.closeRightPane) {
        this.handlePanelClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props;
          _this$props8.workOrder;
          var shipmentErrors = _this$props8.shipmentErrors,
          shipmentsLoading = _this$props8.shipmentsLoading,
          sortColumn = _this$props8.sortColumn,
          sortByAsc = _this$props8.sortByAsc;
      var _this$state = this.state,
          isPaneOpen = _this$state.isPaneOpen,
          currentShipment = _this$state.currentShipment;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "shipment-page"
      }, !shipmentsLoading && this.renderActionButtons(), /*#__PURE__*/React__default.createElement("div", {
        className: "table-container"
      }, /*#__PURE__*/React__default.createElement(Table, {
        manual: true,
        striped: false,
        onSortedChange: this.handleSort,
        data: cloneDeep(this.props.shipmentData),
        columns: this.columns(),
        loading: shipmentsLoading,
        sorted: [{
          id: sortColumn,
          desc: !sortByAsc
        }],
        LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
          columns: this.columns()
        })
      })), isPaneOpen && /*#__PURE__*/React__default.createElement(RightPanel$1, {
        showFooter: true,
        header: i18n.t('updateDelivery'),
        isOpen: isPaneOpen,
        onClose: this.handlePanelClose,
        showFilterIcon: false,
        showClearAll: false,
        primaryButtonProps: [{
          buttonText: i18n.t('save'),
          disabled: !this.shouldEnableUpdateButton() || this.shouldDisableShipButton(),
          onClick: this.handleSave,
          className: 'ship-button'
        }, {
          buttonText: i18n.t('cancel'),
          onClick: this.handlePanelClose,
          className: 'cancel-button'
        }]
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "shipment-form-details"
      }, /*#__PURE__*/React__default.createElement(SelectShippingInfo, {
        shippingTypes: this.formatShippingTypes(),
        shipment: currentShipment,
        onChange: this.handleChange,
        isShipmentCancelled: this.isShipmentCancelled(currentShipment),
        isShipmentPendingCancellation: this.isShipmentPendingCancellation(currentShipment),
        error: shipmentErrors.find(function (error) {
          return error.id === currentShipment.id;
        })
      }))));
    }
  }]);

  return WorkOrderShipmentView;
}(React__default.Component);

var HeaderLoader = function HeaderLoader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "wo-order-view-loader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header",
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '80%',
      height: 30
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '60%',
      height: 20
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '20%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '20%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '20%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '20%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '10%',
      height: 20
    }
  })));
};

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var validStatusesToShowDownload = [DcpDownloadStatuses.NOT_STARTED, DcpDownloadStatuses.EXPIRED, DcpDownloadStatuses.ERROR, DcpDownloadStatuses.IN_PROGRESS, DcpDownloadStatuses.PENDING, DcpDownloadStatuses.FAILED, DcpDownloadStatuses.UNARCHIVING];
var validStatusForPartialTasks = concat(DuplicationProgressStatuses, DuplicationProgress.SUCCEEDED);

var Header = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Header, _React$Component);

  var _super = _createSuper$4(Header);

  function Header(props) {
    var _this;

    _classCallCheck$1(this, Header);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "isCopyFeatureApplicable", function (workOrder) {
      var _this$props$user = _this.props.user,
          appliances = _this$props$user.appliances,
          partner = _this$props$user.partner;
      var deliveryType = workOrder && workOrder.shipments && workOrder.shipments[0].deliveryType;
      return !_.isEmpty(appliances) && partner.type === PartnerTypes.OFFLINE && deliveryType && deliveryType === DeliveryTypes.HARD_DRIVE;
    });

    _defineProperty$1(_assertThisInitialized(_this), "getCopyInProgressDrivesInAllAppliances", function () {
      var _this$props = _this.props,
          appliances = _this$props.appliances,
          workOrder = _this$props.workOrder;
      var copyInProgressDrives = 0;

      if (!_.isEmpty(appliances)) {
        _.forEach(appliances, function (appliance) {
          var currentTask = _this.getTaskFromDuplicationStatus(appliance);

          var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

          var drives = appliance.drives && appliance.drives.filter(function (drive) {
            return !_.isEmpty(drive.duplicationStatus) && DuplicationProgressStatuses.includes(drive.duplicationStatus.status) && workOrder.workOrderNo === applianceWorkOrderNo;
          });
          copyInProgressDrives = copyInProgressDrives + drives && drives.length;
        });
      }

      return copyInProgressDrives;
    });

    _defineProperty$1(_assertThisInitialized(_this), "getTaskFromDuplicationStatus", function (appliance) {
      var drives = [];
      appliance.drives && appliance.drives.forEach(function (drive) {
        if (!isEmpty(drive.duplicationStatus)) drives.push(drive);
      });
      var uniqStatuses = uniq(map$2(drives, 'duplicationStatus.status').filter(function (s) {
        return !isEmpty(s);
      }));

      if (uniqStatuses.length > 1) {
        return appliance.drives && appliance.drives.find(function (d) {
          return d && !isEmpty(d.duplicationStatus) && validStatusForPartialTasks.includes(d.duplicationStatus.status);
        });
      } else {
        return appliance.drives && appliance.drives.find(function (d) {
          return d && !isEmpty(d.duplicationStatus);
        }) || appliance.drives && appliance.drives[0] || {};
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "getCurrentTaskWorkOrderNo", function (bay) {
      var task = bay.duplicationStatus;
      return task && task.userData && task.userData.workOrderNo;
    });

    _defineProperty$1(_assertThisInitialized(_this), "shouldShowDownloadStatus", function (applianceWorkOrderDownloadStatus) {
      var _this$props2 = _this.props,
          appliance = _this$props2.appliance,
          workOrder = _this$props2.workOrder;

      var currentTask = _this.getTaskFromDuplicationStatus(appliance);

      var applianceWorkOrderNo = _this.getCurrentTaskWorkOrderNo(currentTask);

      return !applianceWorkOrderDownloadStatus || validStatusesToShowDownload.includes(applianceWorkOrderDownloadStatus.dcpDownloadStatus) || applianceWorkOrderDownloadStatus.dcpDownloadStatus === DcpDownloadStatuses.FAILED && currentTask && applianceWorkOrderNo === workOrder.workOrderNo && currentTask.duplicationStatus.status === DuplicationProgress.FAILED || isEmpty(currentTask);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderShipmentStatusDetails", function () {
      var workOrder = _this.props.workOrder;
      var totalShipped = 0;
      var shipmentPending = 0;
      var shipmentCancelled = 0;
      var pendingCancellation = 0;
      var shipmentRejected = 0;

      if (workOrder && workOrder.shipments) {
        totalShipped = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.DISPATCHED;
        }).length;
        shipmentPending = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.PENDING;
        }).length;
        shipmentCancelled = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.CANCELLED;
        }).length;
        pendingCancellation = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.PENDING_CANCELLATION;
        }).length;
        shipmentRejected = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.REJECTED;
        }).length;
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (totalShipped || shipmentPending || pendingCancellation || shipmentCancelled || shipmentRejected) && /*#__PURE__*/React__default.createElement(ToolTip, {
        toolTip: i18n.t('shipmentStatus')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-item"
      }, /*#__PURE__*/React__default.createElement("div", null, totalShipped > 0 && /*#__PURE__*/React__default.createElement("span", null, i18n.t('shipped', {
        shipped: totalShipped
      })), shipmentPending > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, totalShipped > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "separator ml1 mr1"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("span", null, i18n.t('pendingCount', {
        itemCount: shipmentPending
      }))), pendingCancellation > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (shipmentPending > 0 || totalShipped > 0) && /*#__PURE__*/React__default.createElement("span", {
        className: "separator ml1 mr1"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("span", null, i18n.t('pendingCancellationCount', {
        itemCount: pendingCancellation
      }))), shipmentCancelled > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (shipmentPending > 0 || totalShipped > 0 || pendingCancellation > 0) && /*#__PURE__*/React__default.createElement("span", {
        className: "separator ml1 mr1"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("span", null, i18n.t('cancelledCount', {
        itemCount: shipmentCancelled
      }))), shipmentRejected > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (shipmentPending > 0 || totalShipped > 0 || pendingCancellation > 0 || shipmentCancelled > 0) && /*#__PURE__*/React__default.createElement("span", {
        className: "separator ml1 mr1"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("span", null, i18n.t('rejectedCount', {
        itemCount: shipmentRejected
      })))))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDriveCopyShipmentStatus", function () {
      var _this$props3 = _this.props,
          workOrder = _this$props3.workOrder,
          serialNo = _this$props3.appliance.serialNo;
      var totalCopied = workOrder.totalCopied,
          totalDrives = workOrder.totalDrives;
      var applianceWorkOrderDownloadStatus = {};
      var cancelledDrives = 0;

      if (serialNo && workOrder.compositions) {
        applianceWorkOrderDownloadStatus = getDcpDownloadStatusByApplianceSerialNo(workOrder.compositions)[serialNo];
      }

      if (workOrder && workOrder.shipments) {
        cancelledDrives = workOrder.shipments.filter(function (s) {
          return s.status === ShippingStatus.CANCELLED;
        }).length;
      }

      var shouldShowDownloadStatus = _this.shouldShowDownloadStatus(applianceWorkOrderDownloadStatus);

      var copyInProgressDrives = 0;

      if (!shouldShowDownloadStatus) {
        copyInProgressDrives = _this.getCopyInProgressDrivesInAllAppliances();
      }

      var isCopyFeatureApplicable = _this.isCopyFeatureApplicable(workOrder);

      if (!isCopyFeatureApplicable || totalCopied < 0 && copyInProgressDrives < 0 && copyPending < 0) return null;
      var copyPending = totalDrives - totalCopied - cancelledDrives - copyInProgressDrives;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (totalCopied || copyInProgressDrives || copyPending) && /*#__PURE__*/React__default.createElement(ToolTip, {
        toolTip: i18n.t('copyStatus')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-item"
      }, /*#__PURE__*/React__default.createElement("div", null, totalCopied > 0 && /*#__PURE__*/React__default.createElement("span", null, i18n.t('copiedCount', {
        itemCount: totalCopied
      })), copyInProgressDrives > 0 && /*#__PURE__*/React__default.createElement("span", null, totalCopied > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1 separator mr1"
      }, "\u2022"), i18n.t('inProgressCount', {
        itemCount: copyInProgressDrives
      })), copyPending > 0 && /*#__PURE__*/React__default.createElement("span", null, (totalCopied > 0 || copyInProgressDrives > 0) && /*#__PURE__*/React__default.createElement("span", {
        className: "ml1 mr1 separator"
      }, "\u2022"), i18n.t('pendingCount', {
        itemCount: copyPending
      }))))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderWorkOrderContentSize", function () {
      var workOrder = _this.props.workOrder;
      if (isEmpty(workOrder.compositions)) return;
      var assetList = [];
      workOrder.compositions.map(function (composition) {
        return composition.assets.map(function (asset) {
          return assetList.push(asset);
        });
      });
      var sizeList = assetList.filter(function (asset) {
        return asset.type !== 'assetmap' && asset.type !== 'pkl';
      }).map(function (asset) {
        return parseInt(asset.size);
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formatDataBytes(sum$1(sizeList)));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderCompositionsHeader", function (isOtherComposition) {
      var className = isOtherComposition ? 'cpl-title unmapped' : 'cpl-title';
      var headerText = isOtherComposition ? 'Other Compositions' : 'Compositions';
      return /*#__PURE__*/React__default.createElement("div", {
        className: className
      }, headerText);
    });

    _defineProperty$1(_assertThisInitialized(_this), "CompositionView", function (composition, index, sizeList) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-8 cpl-name')
      }, composition.cplName), /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-4 composition-size')
      }, formatDataBytes(sum$1(sizeList)))));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderMoreCPLs", function (workOrder) {
      var viewCPLs = _this.state.viewCPLs;
      var compositionsWithMovieName = [];
      var untitledCompositions = [];
      var displayedMovieNames = new Set();
      var firstComposition = null;

      if (viewCPLs) {
        workOrder.compositions.slice(1).forEach(function (composition, index) {
          var movieName = composition.movieName,
              releaseDate = composition.releaseDate,
              language = composition.language,
              movieId = composition.movieId;
          var isMatching = workOrder.compositions[0].movieId === movieId && movieId !== undefined;
          var sizeList = composition.assets.filter(function (asset) {
            return asset.type !== 'assetmap' && asset.type !== 'pkl';
          }).map(function (asset) {
            return parseInt(asset.size);
          });

          if (isMatching) {
            compositionsWithMovieName.unshift(_this.CompositionView(composition, index, sizeList));
          } else if (movieName && movieId) {
            if (!displayedMovieNames.has(movieId) && workOrder.compositions[0].movieId !== movieId) {
              displayedMovieNames.add(movieId);
              var matchingCompositions = workOrder.compositions.filter(function (comp) {
                return comp.movieId === movieId;
              });
              compositionsWithMovieName.push( /*#__PURE__*/React__default.createElement("div", {
                className: "cpl-title",
                key: index
              }, "".concat(movieName), releaseDate && !isNaN(extractYear(releaseDate)) && " (".concat(extractYear(releaseDate), ")"), language && ", ".concat(language)));
              matchingCompositions.forEach(function (comp, idx) {
                compositionsWithMovieName.push(_this.CompositionView(comp, idx, sizeList));
              });
            }
          } else {
            untitledCompositions.push(_this.CompositionView(composition, index, sizeList));
          }

          if (index === 0) {
            firstComposition = workOrder.compositions[0].movieId;
          }
        });
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, compositionsWithMovieName, firstComposition && untitledCompositions.length > 0 && _this.renderCompositionsHeader(true), untitledCompositions);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderCPLs", function () {
      var _compositionToRender, _compositionToRender2;

      var viewCPLs = _this.state.viewCPLs;
      var workOrder = _this.props.workOrder;
      var sizeList = workOrder.compositions[0].assets.filter(function (asset) {
        return asset.type !== 'assetmap' && asset.type !== 'pkl';
      }).map(function (asset) {
        return parseInt(asset.size);
      });
      var firstComposition = workOrder.compositions[0];

      var _ref = firstComposition || {},
          movieId = _ref.movieId,
          movieName = _ref.movieName;

      var compositionToRender = firstComposition;

      if (movieId && movieName) {
        var matchingCompositions = workOrder.compositions.filter(function (comp) {
          return comp.movieId === movieId;
        });

        if (matchingCompositions.length > 0) {
          compositionToRender = matchingCompositions[0];
        }
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "cplExpand"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames$1('col col-11 header-cpl'),
        key: workOrder.workOrderNo
      }, !compositionToRender.movieId && _this.renderCompositionsHeader(false), /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-title"
      }, ((_compositionToRender = compositionToRender) === null || _compositionToRender === void 0 ? void 0 : _compositionToRender.movieName) && "".concat((_compositionToRender2 = compositionToRender) === null || _compositionToRender2 === void 0 ? void 0 : _compositionToRender2.movieName), compositionToRender.releaseDate && !isNaN(extractYear(compositionToRender.releaseDate)) && " (".concat(extractYear(compositionToRender.releaseDate), ")"), compositionToRender.language && ", ".concat(compositionToRender.language)), _this.CompositionView(compositionToRender, 0, sizeList), !viewCPLs && workOrder.compositions.length > 1 ? /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-more",
        onClick: function onClick() {
          return _this.setState({
            viewCPLs: true
          });
        }
      }, "".concat(workOrder.compositions.length - 1, " More Compositions")) : null, _this.renderMoreCPLs(workOrder), viewCPLs ? /*#__PURE__*/React__default.createElement("div", {
        className: "cpl-more",
        onClick: function onClick() {
          return _this.setState({
            viewCPLs: false
          });
        }
      }, "Less Compositions") : null)));
    });

    _this.state = {
      viewCPLs: false
    };
    return _this;
  }

  _createClass$1(Header, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          workOrder = _this$props4.workOrder,
          loading = _this$props4.loading;
      var PARTNERS = DeliveryMode.PARTNERS;
      if (loading) return /*#__PURE__*/React__default.createElement(HeaderLoader, null);
      if (!workOrder) return null;
      var deliverMode = workOrder.shipments && (workOrder === null || workOrder === void 0 ? void 0 : workOrder.shipments[0].deliveryMode);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "header-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "title"
      }, i18n.t('workorder'), ":\xA0", workOrder.workOrderNo), /*#__PURE__*/React__default.createElement("div", {
        className: "addon-list"
      }, deliverMode === PARTNERS && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ToolTip, {
        toolTip: "No of Drives"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-item"
      }, i18n.t('totalDriveCount', {
        count: workOrder.totalDrives
      }))), /*#__PURE__*/React__default.createElement(ToolTip, {
        toolTip: "Content Size"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-item"
      }, this.renderWorkOrderContentSize()))), this.renderDriveCopyShipmentStatus(), this.renderShipmentStatusDetails()), this.renderCPLs());
    }
  }]);

  return Header;
}(React__default.Component);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WorkOrderView = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WorkOrderView, _React$Component);

  var _super = _createSuper$3(WorkOrderView);

  function WorkOrderView() {
    var _this;

    _classCallCheck$1(this, WorkOrderView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      pageLinks: [{
        name: 'Work Orders',
        path: '/work-orders'
      }]
    });

    _defineProperty$1(_assertThisInitialized(_this), "handlePageRedirect", function (url) {
      if (_this.props.onPageRedirect) {
        _this.props.onPageRedirect(url);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "getPageTabs", function () {
      return [{
        id: WorkOrderTabs.DUPLICATION,
        title: 'Duplication',
        goto: "/work-orders/".concat(_this.props.workOrder.workOrderNo),
        isHidden: !_this.props.isCopyFeatureApplicable()
      }, {
        id: WorkOrderTabs.DELIVERY,
        title: 'Delivery',
        goto: "/work-orders/".concat(_this.props.workOrder.workOrderNo, "/shipment")
      }];
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleTabChange", function (tab) {
      var tabUrl, activeTab;

      if (tab === WorkOrderTabs.DUPLICATION) {
        tabUrl = "/work-orders/".concat(_this.props.workOrder.workOrderNo);
        activeTab = WorkOrderTabs.DUPLICATION;
      }

      if (tab === WorkOrderTabs.DELIVERY) {
        tabUrl = "/work-orders/".concat(_this.props.workOrder.workOrderNo, "/shipment");
        activeTab = WorkOrderTabs.DELIVERY;
      }

      if (_this.props.onTabChange) {
        _this.props.onTabChange(tabUrl, activeTab);
      }
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderPageTabs", function () {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tabs-container"
      }, /*#__PURE__*/React__default.createElement(Tabs, {
        selectedTabId: _this.props.selectedTabId,
        tabs: _this.getPageTabs(),
        onChange: _this.handleTabChange,
        isLoader: _this.props.workOrderLoading
      }));
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDuplicationTab", function () {
      return /*#__PURE__*/React__default.createElement(WorkOrderDuplicationView, _this.props);
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderDeliveryTab", function () {
      return /*#__PURE__*/React__default.createElement(WorkOrderShipmentView, {
        workOrder: _this.props.workOrder,
        onClose: _this.props.onClose,
        shipmentErrors: _this.props.shipmentErrors,
        shipmentsLoading: _this.props.shipmentsLoading,
        sortColumn: _this.props.sortColumn,
        sortByAsc: _this.props.sortByAsc,
        shipmentData: _this.props.shipmentData,
        closeRightPane: _this.props.closeRightPane,
        shippingTypes: _this.props.shippingTypes,
        saveShipments: _this.props.actions.saveShipments,
        uploadShipmentInformation: _this.props.actions.uploadShipmentInformation,
        sort: _this.props.actions.sort,
        onDownloadShipment: _this.props.onDownloadShipment,
        actions: _this.props.actions,
        selectedShipments: _this.props.selectedShipments
      });
    });

    return _this;
  }

  _createClass$1(WorkOrderView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var workOrderId = this.props.workOrderId;
      var updatePageLink = this.state.pageLinks;
      updatePageLink.push({
        name: "Work Order: ".concat(workOrderId)
      });
      this.setState({
        pageLinks: updatePageLink
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pageLinks = this.state.pageLinks;

      if (prevProps.workOrderId !== this.props.workOrderId) {
        if (pageLinks.length > 1) {
          pageLinks[0].name = "Work Order: ".concat(this.props.workOrderId);
        }

        this.setState({
          pageLinks: pageLinks
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-view-container work-order-page"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-breadcrumb"
      }, /*#__PURE__*/React__default.createElement(BreadCrumb, {
        links: this.state.pageLinks,
        handleRedirect: this.handlePageRedirect,
        isLoading: this.props.workOrderLoading
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "header-content-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-view-header"
      }, /*#__PURE__*/React__default.createElement(Header, _extends$1({}, this.props, {
        loading: this.props.workOrderLoading
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-tabs"
      }, this.renderPageTabs())), /*#__PURE__*/React__default.createElement("div", {
        className: "tab-content-wrapper"
      }, this.props.selectedTabId === 'duplication' ? this.renderDuplicationTab() : this.renderDeliveryTab()));
    }
  }]);

  return WorkOrderView;
}(React__default.Component);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PageNotFound = /*#__PURE__*/function (_React$Component) {
  _inherits$2(PageNotFound, _React$Component);

  var _super = _createSuper$2(PageNotFound);

  function PageNotFound() {
    _classCallCheck$2(this, PageNotFound);

    return _super.apply(this, arguments);
  }

  _createClass$2(PageNotFound, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React__default.createElement("div", {
        className: "pagenotfound"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "pagenotfound__icon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "PageNotFound",
        filledColor: this.props.svgColor
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "pagenotfound__header"
      }, i18n.t('oops')), /*#__PURE__*/React__default.createElement("div", {
        className: "pagenotfound__subtext"
      }, i18n.t('thisPageDoesNotExist')), /*#__PURE__*/React__default.createElement(PrimaryButton, {
        btnName: 'Go Home',
        style: {
          marginTop: '20px'
        },
        callbackAction: function callbackAction() {
          _this.props.history.push(_this.props.homeRoute);
        }
      }));
    }
  }]);

  return PageNotFound;
}(React__default.Component);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MaintenancePage = /*#__PURE__*/function (_React$Component) {
  _inherits$2(MaintenancePage, _React$Component);

  var _super = _createSuper$1(MaintenancePage);

  function MaintenancePage() {
    _classCallCheck$2(this, MaintenancePage);

    return _super.apply(this, arguments);
  }

  _createClass$2(MaintenancePage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "maintenance"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "maintenance__icon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "Maintenance"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "maintenance__header"
      }, i18n.t('maintenance')), /*#__PURE__*/React__default.createElement("div", {
        className: "maintenance__subtext"
      }, i18n.t('maintenanceDescription')));
    }
  }]);

  return MaintenancePage;
}(React__default.Component);

var getUniqueTheatres = function getUniqueTheatres(compositions) {
  var uniqTheatres = [];
  compositions.forEach(function (cpl) {
    var dkdmList = cpl.dkdms || [];
    dkdmList.forEach(function (dkdm) {
      if (dkdm.theatre && dkdm.theatre.length > 0) uniqTheatres.push.apply(uniqTheatres, _toConsumableArray(dkdm.theatre));
      if (dkdm.theatres && dkdm.theatres.length > 0) uniqTheatres.push.apply(uniqTheatres, _toConsumableArray(dkdm.theatres));
    });
  });
  return uniqTheatres;
};

var getCompositionKdmStatus = function getCompositionKdmStatus(compositionData, options) {
  var compositionKdmStatus = {
    successfulScreenCount: 0,
    deliveredScreenCount: 0,
    queuedScreenCount: 0,
    failedScreenCount: 0,
    regeneratedCount: 0,
    pendingApprovalScreenCount: 0
  };
  if (!compositionData) return compositionKdmStatus;
  var cplList = isArray$3(compositionData) ? compositionData : [compositionData];
  var uniqTheatres = getUniqueTheatres(cplList) || [];
  uniqTheatres.forEach(function (theatre) {
    var screens = theatre.screens || [];
    screens.forEach(function (screen) {
      if (screen.status) {
        var regeneratedKdms = theatre.screens.filter(function (theatreScreen) {
          return theatreScreen.kdmRegenerated === true && (!options.skipVisitedCheck ? theatreScreen.visited === false : true) && theatreScreen.id === screen.id;
        });

        if (!isEmpty$1(regeneratedKdms)) {
          compositionKdmStatus.regeneratedCount += 1;
        }

        switch (screen.status.toLowerCase()) {
          case SUCCESS:
            if (options.deliverToTheatres && !isEmpty$1(screen.deliveryStatus)) {
              compositionKdmStatus.deliveredScreenCount += 1;
            } else {
              compositionKdmStatus.successfulScreenCount += 1;
            }

            break;

          case PENDING_APPROVAL:
            compositionKdmStatus.pendingApprovalScreenCount += 1;
            break;

          case QUEUED:
            compositionKdmStatus.queuedScreenCount += 1;
            break;

          case FAILED:
            compositionKdmStatus.failedScreenCount += 1;
            break;
        }
      }
    });
  });
  return compositionKdmStatus;
};

/**
 * Class with functions for Parsing Search Queries
 *
 * @class SearchQueryparser
 */
var SearchQueryParser = /*#__PURE__*/function () {
  /**
   * sets the variables in searchquery Parser
   *
   * @param searchQuery:string
   * @param filterTagEnum:string
   * @param processFilterPair :any
   * @param filterRegex :any
   */
  function SearchQueryParser(searchQuery, filterTagEnum, processFilterPair) {
    var filterRegex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /(\w+:(([a-zA-Z0-9_-]+)|".*?"))/g;

    _classCallCheck$2(this, SearchQueryParser);

    _defineProperty(this, "searchQuery", void 0);

    _defineProperty(this, "filterTagEnum", void 0);

    _defineProperty(this, "processFilterPair", void 0);

    _defineProperty(this, "filterRegex", void 0);

    _defineProperty(this, "key", void 0);

    _defineProperty(this, "value", void 0);

    this.searchQuery = searchQuery;
    this.filterTagEnum = filterTagEnum;
    this.processFilterPair = processFilterPair;
    this.filterRegex = filterRegex;
  }
  /**
   * Function to sanitize the Search Query by trimming and replacing punctuation marks
   *
   * @returns {string} returns the sanitized search query value
   */


  _createClass$2(SearchQueryParser, [{
    key: "sanitizeSearchQuery",
    value: function sanitizeSearchQuery() {
      return this.searchQuery.trim().replace(/((\s)+:)/g, ':').replace(/(:(\s)+)/g, ':');
    }
    /**
     * Based on the Search Query the filter tags are seperated and identified
     *
     * @param sanitizedSearchQuery
     * @returns {search:string,filter:object} - returns the filter tags and searchquery removing the filter tags from it
     */

  }, {
    key: "getFiltersFromSearchQuery",
    value: function getFiltersFromSearchQuery(sanitizedSearchQuery) {
      var filterTags = {};
      var filterPair = {
        key: null,
        value: null
      };
      var match = this.filterRegex.exec(sanitizedSearchQuery);

      while (match != null) {
        filterPair = this.getFilterPair(match);
        if (!filterPair) return false;
        var _filterPair = filterPair,
            key = _filterPair.key,
            value = _filterPair.value;
        filterTags = this.processFilterPair ? this.processFilterPair(filterPair, filterTags) : Object.assign(filterTags, _defineProperty({}, key, value));
        match = this.filterRegex.exec(sanitizedSearchQuery);
      }

      return {
        search: this.removeFilterFromSearchQuery(sanitizedSearchQuery),
        filter: filterTags
      };
    }
    /**
     * checks for the given filter if present sends true or false if there is a match
     *
     *
     * @param match
     * @returns {boolean}
     */

  }, {
    key: "getFilterPair",
    value: function getFilterPair(match) {
      var filterTagParts = match[0].split(':');
      return this.validateFilterKey(filterTagParts[0]) ? {
        key: filterTagParts[0],
        value: filterTagParts[1].replace(/"/g, '')
      } : false;
    }
    /**
     * gets the filter key as param and returs the validation
     * @param filterKey
     * @returns {boolean}
     */

  }, {
    key: "validateFilterKey",
    value: function validateFilterKey(filterKey) {
      var _this = this;

      return Object.keys(this.filterTagEnum).map(function (filterKey) {
        return _this.filterTagEnum[filterKey];
      }).includes(filterKey);
    }
    /**
     * Removes the filter from the search query
     *
     * @param searchQuery
     * @returns {string}
     */

  }, {
    key: "removeFilterFromSearchQuery",
    value: function removeFilterFromSearchQuery(searchQuery) {
      return searchQuery.replace(this.filterRegex, '').replace(/\s\s+/g, ' ').trim();
    }
    /**
     *  if the : is present returns the filters if not returns the string
     * @returns {object|string}
     */

  }, {
    key: "execute",
    value: function execute() {
      if (this.searchQuery.includes(':')) {
        return this.getFiltersFromSearchQuery(this.sanitizeSearchQuery());
      } else {
        return {
          search: this.searchQuery
        };
      }
    }
  }]);

  return SearchQueryParser;
}();

var FilterChips = function FilterChips(props) {
  return /*#__PURE__*/React__default.createElement(FilterChips$1, props);
};

var FilterSection = function FilterSection(props) {
  return /*#__PURE__*/React__default.createElement(FilterSection$1, props);
};

var MultiSelectInput = function MultiSelectInput(props) {
  return /*#__PURE__*/React__default.createElement(MultiSelectInput$1, props);
};

MultiSelectInput.defaultProps = {
  customSubTextName: function customSubTextName(item) {
    return FilterLabels[item.type];
  },
  customMenuName: function customMenuName(item) {
    return item.displayName;
  }
};

var TableControls = function TableControls(props) {
  return /*#__PURE__*/React__default.createElement(TableControls$1, props);
};

var RightPanel = function RightPanel(props) {
  return /*#__PURE__*/React__default.createElement(RightPanel$1, props);
};

var TextInput = function TextInput(props) {
  return /*#__PURE__*/React__default.createElement(TextInput$1, props);
};

var _excluded = ["placeholder", "filterType", "label", "componentType", "suggestionList", "selectedItems"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RightFilterPanel = /*#__PURE__*/function (_Component) {
  _inherits$2(RightFilterPanel, _Component);

  var _super = _createSuper(RightFilterPanel);

  function RightFilterPanel() {
    _classCallCheck$2(this, RightFilterPanel);

    return _super.apply(this, arguments);
  }

  _createClass$2(RightFilterPanel, [{
    key: "renderFilterSectionType",
    value: function renderFilterSectionType(componentType) {
      if (componentType === ComponentTypes.list) return FILTER_TAG_TYPES.LIST;else if (componentType === ComponentTypes.multiselect) return FILTER_TAG_TYPES.MULTI_SELECT_SEARCH;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          header = _this$props.header,
          isOpen = _this$props.isOpen,
          showFilterIcon = _this$props.showFilterIcon,
          showClearAll = _this$props.showClearAll,
          onClickClearAll = _this$props.onClickClearAll,
          onClose = _this$props.onClose,
          clearAllText = _this$props.clearAllText,
          showFooter = _this$props.showFooter,
          primaryButtonProps = _this$props.primaryButtonProps,
          secondaryButtonProps = _this$props.secondaryButtonProps,
          _this$props$actions = _this$props.actions,
          addItemToFilter = _this$props$actions.addItemToFilter,
          handleQueryChange = _this$props$actions.handleQueryChange;
          _this$props$actions.removeItemFromFilter;
          var resetFilterData = _this$props$actions.resetFilterData,
          clearSearchText = _this$props$actions.clearSearchText,
          handleListFilter = _this$props$actions.handleListFilter,
          filterList = _this$props.filterList;
      return /*#__PURE__*/React__default.createElement(RightPanel, {
        header: header,
        isOpen: isOpen,
        onClose: onClose,
        showFilterIcon: showFilterIcon,
        showClearAll: showClearAll,
        onClickClearAll: onClickClearAll,
        clearAllText: clearAllText,
        showFooter: showFooter,
        primaryButtonProps: primaryButtonProps,
        secondaryButtonProps: secondaryButtonProps
      }, filterList.map(function (filter) {
        var placeholder = filter.placeholder,
            filterType = filter.filterType,
            label = filter.label,
            componentType = filter.componentType,
            suggestionList = filter.suggestionList,
            selectedItems = filter.selectedItems,
            rest = _objectWithoutProperties$2(filter, _excluded);

        return /*#__PURE__*/React__default.createElement(FilterSection, _extends$2({
          resetOnSelect: true,
          tagInputProps: {
            placeholder: placeholder,
            value: ''
          },
          inputValueRenderer: function inputValueRenderer(item) {
            return item.name;
          },
          header: label,
          tagType: filterType,
          filterType: _this.renderFilterSectionType(componentType),
          tagList: suggestionList,
          suggestionList: suggestionList,
          selected: selectedItems,
          onFilterChange: function onFilterChange(item) {
            return handleListFilter(item, filterType);
          },
          onFilterClear: function onFilterClear() {
            return resetFilterData(filterType);
          },
          onItemSelect: function onItemSelect(item) {
            return addItemToFilter(item, filterType);
          },
          onQueryChange: function onQueryChange(text, event) {
            return handleQueryChange(text, filterType, event);
          },
          onSearchClear: function onSearchClear() {
            return clearSearchText(filterType);
          }
        }, rest));
      }));
    }
  }]);

  return RightFilterPanel;
}(Component);

var ReportCard = function ReportCard(_ref) {
  var icon = _ref.icon,
      reportName = _ref.reportName,
      ctaBtnText = _ref.ctaBtnText,
      actionHandler = _ref.actionHandler;
  var Icon = QubeIcons[icon];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "report-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "report-container__top-section"
  }, icon ? /*#__PURE__*/React__default.createElement("div", {
    className: "report-container__top-section__icon-container"
  }, /*#__PURE__*/React__default.createElement(Icon, null)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "report-container__top-section__device-report-name"
  }, reportName)), /*#__PURE__*/React__default.createElement("div", {
    className: "report-container__divider"
  }), /*#__PURE__*/React__default.createElement(BaseButton$1, {
    buttonText: ctaBtnText,
    buttonType: "primary",
    onClick: actionHandler
  }));
};

ReportCard.defaultProps = {
  ctaBtnText: 'Generate Report'
};

function ApplianceDetailsHeader(_ref) {
  var data = _ref.data,
      isLoading = _ref.isLoading,
      tabs = _ref.tabs,
      onTabChange = _ref.onTabChange;
  return /*#__PURE__*/React__default.createElement("header", {
    className: "appliance-details__header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "appliance-details__info"
  }, /*#__PURE__*/React__default.createElement(ReactPlaceholder, {
    showLoadingAnimation: true,
    color: "#adbbcc",
    type: "text",
    rows: 4,
    ready: !isLoading,
    style: {
      maxWidth: '15rem'
    }
  }, /*#__PURE__*/React__default.createElement("h1", null, data === null || data === void 0 ? void 0 : data.serialNumber), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h2", null, data === null || data === void 0 ? void 0 : data.theatreName), /*#__PURE__*/React__default.createElement("h3", null, data === null || data === void 0 ? void 0 : data.address)), /*#__PURE__*/React__default.createElement("div", {
    className: "tag_list"
  }, typeof (data === null || data === void 0 ? void 0 : data.active) === 'boolean' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, data.active ? /*#__PURE__*/React__default.createElement(Tag, {
    prefixIcon: /*#__PURE__*/React__default.createElement(Icons.CircleIcon, {
      color: "#0D7C2D"
    })
  }, "Online") : /*#__PURE__*/React__default.createElement(Tag, {
    prefixIcon: /*#__PURE__*/React__default.createElement(Icons.CircleIcon, {
      color: "#CF1322"
    })
  }, "Offline")), (data === null || data === void 0 ? void 0 : data.type) && /*#__PURE__*/React__default.createElement(Tag, null, data.type), (data === null || data === void 0 ? void 0 : data.storageSizeInGB) && /*#__PURE__*/React__default.createElement(Tag, {
    prefixIcon: /*#__PURE__*/React__default.createElement(Icons.ViewPieChartIcon, null)
  }, "".concat(data.storageSizeInGB, " GB"))))), /*#__PURE__*/React__default.createElement("hr", null), /*#__PURE__*/React__default.createElement(Tabs, {
    tabs: tabs,
    onChange: onTabChange
  }));
}

ApplianceDetailsHeader.defaultProps = {
  isLoading: false,
  tabs: [],
  onTabChange: function onTabChange() {}
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var filterType = {
  cpl: i18n.t('composition'),
  downloadStatuses: i18n.t('downloadStatus'),
  ingestStatuses: i18n.t('ingestStatus'),
  cplAvailability: i18n.t('cplAvailability')
};
var filterSuggestionList = {
  downloadStatuses: [{
    id: 'pending',
    displayName: 'Pending',
    type: 'downloadStatuses'
  }, // { id: 'scheduled', displayName: 'Scheduled', type: 'downloadStatuses' },
  {
    id: 'booked',
    displayName: 'Booked',
    type: 'downloadStatuses'
  }, {
    id: 'downloading',
    displayName: 'Downloading',
    type: 'downloadStatuses'
  }, {
    id: 'downloaded',
    displayName: 'Downloaded',
    type: 'downloadStatuses'
  }, {
    id: 'failed',
    displayName: 'Failed',
    type: 'downloadStatuses'
  }, {
    id: 'cancelled',
    displayName: 'Cancelled',
    type: 'downloadStatuses'
  }],
  ingestStatuses: [{
    id: 'pending',
    displayName: 'Pending',
    type: 'pending'
  }, {
    id: 'in_progress',
    displayName: 'In Progress',
    type: 'in_progress'
  }, {
    id: 'ingested',
    displayName: 'Ingested',
    type: 'ingested'
  }, {
    id: 'failed',
    displayName: 'Failed',
    type: 'failed'
  }, {
    id: 'expired',
    displayName: 'Expired',
    type: 'expired'
  }, {
    id: 'cancelled',
    displayName: 'Cancelled',
    type: 'cancelled'
  }, {
    id: 'unsupported',
    displayName: 'Unsupported',
    type: 'unsupported'
  }],
  cplAvailability: [{
    id: 'available',
    displayName: i18n.t('available'),
    type: 'cplAvailability'
  }, {
    id: 'not_available',
    displayName: i18n.t('notAvailable'),
    type: 'cplAvailability'
  }]
};
var ingestStatusClasses = [{
  id: 'pending',
  status: 'Pending',
  className: 'appliance-injested__pending'
}, {
  id: 'in_progress',
  status: 'In Progress',
  className: 'appliance-injested__inprogress'
}, {
  id: 'ingested',
  status: 'Ingested',
  className: 'appliance-injested__injested'
}, {
  id: 'failed',
  status: 'Failed',
  className: 'appliance-injested__failed'
}, {
  id: 'expired',
  status: 'Expired',
  className: 'appliance-injested__expired'
}, {
  id: 'cancelled',
  status: 'Cancelled',
  className: 'appliance-injested__cancelled'
}, {
  id: 'unsupported',
  status: 'Unsupported',
  className: 'appliance-injested__unsupported'
}];
function ApplianceContentTable(_ref) {
  var contents = _ref.contents,
      rowActions = _ref.rowActions,
      onTableConfigChange = _ref.onTableConfigChange,
      tableSearch = _ref.tableSearch;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showFilterPanel = _useState2[0],
      setShowFilterPanel = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      globalSearchQuery = _useState4[0],
      setGlobalSearchQuery = _useState4[1];

  var _useState5 = useState({
    cpl: {
      data: [],
      isLoading: false
    },
    global: {
      data: [],
      isLoading: false
    }
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      search = _useState6[0],
      setSearch = _useState6[1];

  var _useState7 = useState({
    cpl: [],
    downloadStatuses: [],
    ingestStatuses: [],
    cplAvailability: []
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      filterState = _useState8[0],
      setFilterState = _useState8[1];

  var isMounted = React__default.useRef(true);
  useEffect(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  var data = contents.data,
      isError = contents.isError,
      isFetching = contents.isFetching,
      totalResultCount = contents.totalResultCount;
  var defaultColumns = useMemo(function () {
    return [{
      Header: i18n.t('composition'),
      id: 'composition',
      accessor: 'composition',
      disableSortBy: true,
      width: 180,
      Cell: function Cell(_ref2) {
        var value = _ref2.value,
            original = _ref2.row.original;

        if (value) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "appliance-composition-details"
          }, value && /*#__PURE__*/React__default.createElement("div", {
            title: value
          }, value), original.movieName && /*#__PURE__*/React__default.createElement("div", {
            title: original.movieName
          }, original.movieName));
        }

        return '-';
      }
    }, {
      Header: i18n.t('dcpSize'),
      id: 'dcp_size',
      accessor: 'dcpSizeInGB',
      width: 90,
      Cell: function Cell(_ref3) {
        var value = _ref3.value;
        return value ? "".concat(value, " GB") : '-';
      }
    }, {
      Header: i18n.t('cplAvailability'),
      id: 'cpl_availability',
      accessor: 'isAvailable',
      disableSortBy: true,
      Cell: function Cell(_ref4) {
        var value = _ref4.value;
        return /*#__PURE__*/React__default.createElement("div", {
          className: "appliance-composition-status"
        }, value ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icons.StatusIcon, {
          color: "#0D7C2D"
        }), i18n.t('available')) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icons.StatusOutlineIcon, {
          color: "#69788C"
        }), i18n.t('notAvailable')));
      }
    }, {
      Header: i18n.t('downloadStatus'),
      id: 'download_status',
      accessor: 'downloadStatus',
      disableSortBy: true,
      Cell: function Cell(_ref5) {
        var value = _ref5.value;
        if (!value) return '-';
        return /*#__PURE__*/React__default.createElement("div", {
          className: "appliance-composition-status"
        }, (value === 'pending' || value === 'booked') && /*#__PURE__*/React__default.createElement(Icons.ClockIcon, {
          color: "#F0A203"
        }), value === 'failed' && /*#__PURE__*/React__default.createElement(Icons.AlertFilledIcon, {
          color: "#CF1322"
        }), value === 'downloading' && /*#__PURE__*/React__default.createElement(Icons.DownloadIcon, {
          color: "#1D81E3"
        }), value === 'cancelled' && /*#__PURE__*/React__default.createElement(Icons.CancelRoundedIcon, {
          color: "#69788C"
        }), value === 'scheduled' && /*#__PURE__*/React__default.createElement(Icons.ConfirmCircleIcon, {
          color: "#F0A203"
        }), value === 'downloaded' && /*#__PURE__*/React__default.createElement(Icons.ConfirmCircleFilledIcon, {
          color: "#0D7C2D"
        }), value[0].toUpperCase() + value.slice(1));
      }
    }, {
      Header: i18n.t('ingestStatus'),
      id: 'ingest_status',
      accessor: 'ingestStatus',
      width: 80,
      disableSortBy: true,
      Cell: function Cell(_ref6) {
        _ref6.value;
            var original = _ref6.row.original;
        var ingestStatusSummary = original.ingestStatusSummary;

        if (!ingestStatusSummary || Object.keys(ingestStatusSummary).length === 0) {
          return '-';
        }

        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ingestStatusClasses.map(function (_ref7) {
          var id = _ref7.id,
              status = _ref7.status,
              className = _ref7.className;
          var count = ingestStatusSummary[id];
          if (!count) return null;
          return /*#__PURE__*/React__default.createElement("div", {
            className: className
          }, "".concat(count, " ").concat(status));
        }));
      }
    }, {
      Header: i18n.t('createdOn'),
      id: 'created_on',
      accessor: 'createdOn',
      Cell: function Cell(_ref8) {
        var value = _ref8.value;
        return value ? /*#__PURE__*/React__default.createElement(DateTimeView, {
          value: value
        }) : '-';
      }
    }, {
      Header: i18n.t('downloadedOn'),
      id: 'downloaded_on',
      accessor: 'downloadedOn',
      Cell: function Cell(_ref9) {
        var value = _ref9.value;
        return value ? /*#__PURE__*/React__default.createElement(DateTimeView, {
          value: value
        }) : '-';
      }
    }, {
      Header: i18n.t('ingestedOn'),
      id: 'ingested_on',
      accessor: 'ingestedOn',
      Cell: function Cell(_ref10) {
        var value = _ref10.value;
        return value ? /*#__PURE__*/React__default.createElement(DateTimeView, {
          value: value
        }) : '-';
      }
    }, {
      Header: i18n.t('lastUpdatedOn'),
      id: 'last_updated_on',
      accessor: 'lastUpdatedOn',
      Cell: function Cell(_ref11) {
        var value = _ref11.value;
        return value ? /*#__PURE__*/React__default.createElement(DateTimeView, {
          value: value
        }) : '-';
      }
    }, {
      Header: '',
      id: 'options',
      width: 48,
      minWidth: 48,
      maxWidth: 48,
      Cell: function Cell(_ref12) {
        var original = _ref12.row.original;
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, typeof rowActions === 'function' && /*#__PURE__*/React__default.createElement(ActionMenu$1, {
          popOverProps: {
            popoverClassName: 'appliance-dropdown'
          },
          iconList: [{
            iconName: 'MoreHorizontalIcon',
            className: 'appliance-dropdown__icon',
            toolTipClass: 'appliance-dropdown__tooltip',
            dropdown: rowActions(original)
          }]
        }));
      }
    }];
  }, [rowActions]);
  var initialState = useMemo(function () {
    return {
      pageIndex: 0,
      pageSize: 10,
      hiddenColumns: typeof rowActions !== 'function' ? ['options'] : []
    };
  }, []);
  var tableData = useMemo(function () {
    return isFetching ? Array(15).fill({}) : data;
  }, [isFetching, data]);
  var tableColumns = useMemo(function () {
    if (isFetching) {
      return defaultColumns.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          Cell: /*#__PURE__*/React__default.createElement(ReactPlaceholder, {
            color: "#adbbcc",
            type: "textRow",
            showLoadingAnimation: true,
            style: {
              borderRadius: '0.5rem'
            }
          })
        });
      });
    }

    return defaultColumns;
  }, [isFetching]);

  var _useTable = useTable({
    columns: tableColumns,
    data: tableData,
    defaultColumn: {
      width: 120,
      minWidth: 100,
      maxWidth: 400
    },
    initialState: initialState,
    manualSortBy: true,
    manualPagination: true,
    pageCount: -1,
    stateReducer: function stateReducer(newState, action) {
      if (action.type === 'toggleSortBy') {
        var _newState$sortBy$, _newState$sortBy$2;

        var columnToSort = (_newState$sortBy$ = newState.sortBy[0]) === null || _newState$sortBy$ === void 0 ? void 0 : _newState$sortBy$.id;
        var sortDirection = (_newState$sortBy$2 = newState.sortBy[0]) === null || _newState$sortBy$2 === void 0 ? void 0 : _newState$sortBy$2.desc;

        if (typeof sortDirection === 'boolean') {
          sortDirection = sortDirection ? 'desc' : 'asc';
        }

        onTableConfigChange === null || onTableConfigChange === void 0 ? void 0 : onTableConfigChange({
          columnToSort: columnToSort,
          sortDirection: sortDirection
        });
      }

      return newState;
    }
  }, useFlexLayout, useSortBy, usePagination),
      getTableProps = _useTable.getTableProps,
      headerGroups = _useTable.headerGroups,
      visibleColumns = _useTable.visibleColumns,
      page = _useTable.page,
      prepareRow = _useTable.prepareRow,
      setPageSize = _useTable.setPageSize,
      gotoPage = _useTable.gotoPage,
      _useTable$state = _useTable.state,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize;

  var tableControls = useMemo(function () {
    return [{
      id: 'pageSizeControl',
      component: function component() {
        return /*#__PURE__*/React__default.createElement(Selector$1, {
          singleSelect: true,
          closeOnSelect: true,
          label: "Show",
          placeHolder: "-",
          showLabelInButton: false,
          noSelectedIcon: false,
          defaultIsOpen: false,
          usePortal: false,
          list: [10, 50, 100],
          selectedList: [pageSize],
          onSelect: function onSelect(_ref13) {
            var _ref14 = _slicedToArray(_ref13, 1),
                size = _ref14[0];

            setPageSize(size);
            onTableConfigChange === null || onTableConfigChange === void 0 ? void 0 : onTableConfigChange({
              offset: 0,
              pageSize: size
            });
          }
        });
      }
    }];
  }, [pageSize]);

  var handleTableFilter = function handleTableFilter(operation, payload) {
    var _newFilter$cpl$0$id, _newFilter$cpl$;

    var newFilter = filterState;

    switch (operation) {
      case 'list':
        {
          var item = payload.item,
              type = payload.type;

          if (type === 'cpl') {
            var _filterState$cpl$;

            newFilter = _objectSpread(_objectSpread({}, filterState), {}, {
              cpl: item.id === ((_filterState$cpl$ = filterState.cpl[0]) === null || _filterState$cpl$ === void 0 ? void 0 : _filterState$cpl$.id) ? [] : [item]
            });
            break;
          }

          newFilter = _objectSpread(_objectSpread({}, filterState), {}, _defineProperty$1({}, type, filterState[type].some(function (i) {
            return i.id === item.id;
          }) ? filterState[type].filter(function (i) {
            return i.id !== item.id;
          }) : [].concat(_toConsumableArray$1(filterState[type]), [item])));
          break;
        }

      case 'filterChips':
        newFilter = Object.keys(filterType).reduce(function (acc, key) {
          acc[key] = payload.filter(function (item) {
            return item.type === filterType[key];
          });
          return acc;
        }, {});
        break;

      case 'reset':
        if (payload) newFilter = _objectSpread(_objectSpread({}, filterState), {}, _defineProperty$1({}, payload, []));else {
          newFilter = Object.keys(filterState).reduce(function (acc, key) {
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty$1({}, key, []));
          }, {});
        }
        break;
    }

    setFilterState(newFilter);
    gotoPage(0);
    onTableConfigChange === null || onTableConfigChange === void 0 ? void 0 : onTableConfigChange({
      filters: {
        cpl: (_newFilter$cpl$0$id = (_newFilter$cpl$ = newFilter.cpl[0]) === null || _newFilter$cpl$ === void 0 ? void 0 : _newFilter$cpl$.id) !== null && _newFilter$cpl$0$id !== void 0 ? _newFilter$cpl$0$id : '',
        downloadStatuses: newFilter.downloadStatuses.map(function (i) {
          return i.id;
        }),
        ingestStatuses: newFilter.ingestStatuses.map(function (i) {
          return i.id;
        }),
        cplAvailability: newFilter.cplAvailability.map(function (i) {
          return i.id;
        })
      },
      offset: 0
    });
  };

  var handleSearch = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(query, type) {
      var filter, _yield$tableSearch, result;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              filter = type || 'global';
              _context.prev = 1;
              setSearch(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, _defineProperty$1({}, filter, {
                  data: [],
                  isLoading: true
                }));
              });
              _context.next = 5;
              return tableSearch(query, 'cpl');

            case 5:
              _context.t1 = _yield$tableSearch = _context.sent;
              _context.t0 = _context.t1 !== null;

              if (!_context.t0) {
                _context.next = 9;
                break;
              }

              _context.t0 = _yield$tableSearch !== void 0;

            case 9:
              if (!_context.t0) {
                _context.next = 13;
                break;
              }

              _context.t2 = _yield$tableSearch;
              _context.next = 14;
              break;

            case 13:
              _context.t2 = [];

            case 14:
              result = _context.t2;

              if (isMounted.current) {
                setSearch(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, _defineProperty$1({}, filter, {
                    data: result,
                    isLoading: false
                  }));
                });
              }

              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t3 = _context["catch"](1);

              if (isMounted.current && !axios.isCancel(_context.t3)) {
                setSearch(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, _defineProperty$1({}, filter, {
                    data: [],
                    isLoading: false
                  }));
                });
              }

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 18]]);
    }));

    return function handleSearch(_x, _x2) {
      return _ref15.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default.createElement("div", {
    className: "appliance-table"
  }, /*#__PURE__*/React__default.createElement(TableControls$1, {
    pagination: true,
    searchBar: true,
    showRowSize: true,
    inputWithSelection: true,
    filterPresent: true,
    pageSize: pageSize,
    currentPage: pageIndex + 1,
    controls: tableControls,
    totalResults: totalResultCount,
    onRowSizeChange: function onRowSizeChange(_, pageNumber) {
      gotoPage(pageNumber - 1);
      onTableConfigChange === null || onTableConfigChange === void 0 ? void 0 : onTableConfigChange({
        offset: (pageNumber - 1) * pageSize,
        pageSize: pageSize
      });
    },
    handleFilterToggle: function handleFilterToggle() {
      return setShowFilterPanel(true);
    },
    searchType: "multiSelectSearch",
    onSearchClear: function onSearchClear() {
      return setGlobalSearchQuery('');
    },
    multiSelectProps: {
      tagInputProps: {
        placeholder: i18n.t('searchByComposition')
      },
      resetOnSelect: true,
      showSubText: true,
      loading: search.global.isLoading,
      suggestionList: search.global.data,
      noResultsText: i18n.t('noResultsFound'),
      selectedItems: filterState.cpl,
      query: globalSearchQuery,
      onQueryChange: function onQueryChange(query) {
        setGlobalSearchQuery(query);
        handleSearch(query);
      },
      onMenuItemSelect: function onMenuItemSelect(item) {
        handleTableFilter('list', {
          item: item,
          type: item.type
        });
      },
      onRemove: function onRemove(item) {
        handleTableFilter('list', {
          item: item,
          type: item.type
        });
      },
      customMenuName: function customMenuName(val) {
        return val.displayName;
      },
      customSubTextName: function customSubTextName(val) {
        var _filterType$val$type;

        return (_filterType$val$type = filterType[val.type]) !== null && _filterType$val$type !== void 0 ? _filterType$val$type : val.type;
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FilterChips$1, {
    showResultsCount: true,
    resultsCount: totalResultCount,
    selected: Object.keys(filterState).reduce(function (acc, key) {
      var selectedFilters = acc.concat(filterState[key].map(function (item) {
        var _filterType$key;

        return _objectSpread(_objectSpread({}, item), {}, {
          type: (_filterType$key = filterType[key]) !== null && _filterType$key !== void 0 ? _filterType$key : key
        });
      }));
      return selectedFilters;
    }, []),
    onFilterChange: function onFilterChange(updatedFilter) {
      handleTableFilter('filterChips', updatedFilter);
    }
  }), /*#__PURE__*/React__default.createElement(TableComponent, {
    sortable: true,
    getTableProps: getTableProps,
    headerGroups: headerGroups,
    page: page,
    prepareRow: prepareRow,
    visibleColumns: visibleColumns
  }), isError && !isFetching && /*#__PURE__*/React__default.createElement("div", {
    className: "appliance-table__error"
  }, i18n.t('somethingWentWrong')), !isError && !isFetching && (data === null || data === void 0 ? void 0 : data.length) === 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "appliance-table__error"
  }, i18n.t('noRecordsfound'))), /*#__PURE__*/React__default.createElement(RightFilterPanel, {
    header: "Filter",
    isOpen: showFilterPanel,
    showFilterIcon: true,
    showClearAll: Object.values(filterState).some(function (arr) {
      return arr.length > 0;
    }),
    onClickClearAll: function onClickClearAll() {
      return handleTableFilter('reset');
    },
    onClose: function onClose() {
      return setShowFilterPanel(false);
    },
    actions: {
      handleListFilter: function handleListFilter(item, type) {
        handleTableFilter('list', {
          item: item,
          type: type
        });
      },
      addItemToFilter: function addItemToFilter(item, type) {
        handleTableFilter('list', {
          item: item,
          type: type
        });
      },
      removeItemFromFilter: function removeItemFromFilter(item, type) {
        handleTableFilter('list', {
          item: item,
          type: type
        });
      },
      resetFilterData: function resetFilterData(type) {
        return handleTableFilter('reset', type);
      },
      handleQueryChange: function handleQueryChange(value, type) {
        return handleSearch(value, type);
      }
    },
    filterList: [{
      key: 'cpl',
      filterType: 'cpl',
      componentType: ComponentTypes.multiselect,
      label: i18n.t('composition'),
      noResultsText: i18n.t('noResultsFound'),
      placeholder: i18n.t('filterByComposition'),
      showSubText: true,
      loading: search.cpl.isLoading,
      suggestionList: search.cpl.data,
      selectedItems: filterState.cpl,
      customMenuName: function customMenuName(val) {
        return val.displayName;
      },
      customSubTextName: function customSubTextName(val) {
        var _filterType$val$type2;

        return (_filterType$val$type2 = filterType[val.type]) !== null && _filterType$val$type2 !== void 0 ? _filterType$val$type2 : val.type;
      }
    }, {
      filterType: 'downloadStatuses',
      key: 'downloadStatuses',
      componentType: ComponentTypes.list,
      label: "DCP ".concat(i18n.t('downloadStatus')),
      suggestionList: filterSuggestionList.downloadStatuses,
      selectedItems: filterState.downloadStatuses
    }, {
      filterType: 'ingestStatuses',
      key: 'ingestStatuses',
      componentType: ComponentTypes.list,
      label: "DCP ".concat(i18n.t('ingestStatus')),
      suggestionList: filterSuggestionList.ingestStatuses,
      selectedItems: filterState.ingestStatuses
    }, {
      filterType: 'cplAvailability',
      key: 'cplAvailability',
      componentType: ComponentTypes.list,
      label: i18n.t('cplAvailability'),
      suggestionList: filterSuggestionList.cplAvailability,
      selectedItems: filterState.cplAvailability
    }]
  }));
}
ApplianceContentTable.defaultProps = {
  contents: propTypes.shape({
    data: [],
    isError: false,
    isFetching: false,
    totalResultCount: 0
  }),
  rowActions: null
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ApplianceDetailsHeader: ApplianceDetailsHeader,
  ApplianceContentTable: ApplianceContentTable
});

export { ActionMenu, AppIcon, index as ApplianceDetails, ApplianceRack, ApplianceTable, AutoSuggest, BaseButton, CPLRightPanelContent, CSVUpload, CheckboxFilter, ClearTag, CommonModal, CompositionCard, CompositionCardList, CompositionCardTags, CompositionInfoModal, CompositionList, CreateTagModal, CursorPagination, DCPInfo, DateTimeInput, DateTimeView, DefaultCheckbox, DefaultDatePicker, DefaultRangePicker, DefaultTable, DefaultTabs, DefaultTag, DeleteButton, DeleteModal, DeliveryStatus, Description, DropDown as Dropdown, EditTagModal, EmptyHandler, ErrorMessage, FestivalsView, FilterChips, FilterPanel, FilterSection, FilterTag, FilterTags$1 as FilterTags, GroupsDetailTheatreTable, GroupsTable, Header$1 as Header, HeaderText, HeaderWithTabs, HelpText, IconButton, InputBox, InputLabel, KDMInfo, Label, ListCard, ListsViewPage, MaintenancePage, ManageTags, MapTagsDropdown, MultiEmailInput, MultiSelectInput, MultiSelectTagInput, PageDefaultHeader, PageHeaderWithTabs, PageHeading, PageNotFound, PopConfirm, PrimaryButton, ProgressBar, QubeIcons, ReportCard, RightFilterPanel, RightPanel, SaveTagModal, ScreensList, SearchButton, SearchFilter, SearchMenu, SearchBox as Searchbox, SecondaryButton, SectionHeading, SelectButton, SelectText, SelectableCompositionCard, SelectedHeader, SelectedTheatres, Selector, Status, StatusHeader, SuccessMessage, TabBar, TabItem, TableControls, TablePagination, TableComponent as TableTemplate, TagsDropdownMenu, TagsTable, TextArea, TextInput, TextLinks, TextWithIconLinks, TheatreAddress, TheatreCard, TheatreDefaultCard, TheatreDefaultInfo, TheatreDefaultMeta, TheatreLayout, TheatreName, TheatrePrice, TheatreSelectModal, TheatreSelection, TheatresViewPage, Title, UsersTable, WarnHeading, WorkOrderCard, WorkOrderCplStatus, WorkOrderView, WorkOrderPage as WorkOrders, bandwidthCalculator, enums, getCompositionKdmStatus, getCplInfo, getKDMSummaryData, i18n as i18nConfig, renderDCPStatusSummary, renderIngestStatusSummary, renderKDMStatusSummary, SearchQueryParser as searchQueryParser, getWorkOrderStatusState as workOrderStatusState };
//# sourceMappingURL=index.esm.js.map
